/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 209);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(216);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(245);


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = formatCurrency;
/* harmony export (immutable) */ __webpack_exports__["B"] = stripCurrencyFormat;
/* harmony export (immutable) */ __webpack_exports__["k"] = formatDate;
/* harmony export (immutable) */ __webpack_exports__["m"] = formatNumber;
/* harmony export (immutable) */ __webpack_exports__["n"] = formatNumberStringForExcel;
/* harmony export (immutable) */ __webpack_exports__["C"] = toTitleCase;
/* harmony export (immutable) */ __webpack_exports__["l"] = formatDateForInput;
/* harmony export (immutable) */ __webpack_exports__["u"] = getStartDate;
/* harmony export (immutable) */ __webpack_exports__["b"] = concatenateAddressLabel;
/* harmony export (immutable) */ __webpack_exports__["c"] = concatenateGeosuggestLabel;
/* harmony export (immutable) */ __webpack_exports__["t"] = getOrgDisplayName;
/* harmony export (immutable) */ __webpack_exports__["q"] = getIndividualDisplayName;
/* harmony export (immutable) */ __webpack_exports__["i"] = formatBankInfoDisplay;
/* harmony export (immutable) */ __webpack_exports__["y"] = isVowel;
/* harmony export (immutable) */ __webpack_exports__["x"] = isValidEmail;
/* harmony export (immutable) */ __webpack_exports__["E"] = validateFieldLength;
/* harmony export (immutable) */ __webpack_exports__["g"] = exportCSVFile;
/* harmony export (immutable) */ __webpack_exports__["d"] = convertToCSV;
/* harmony export (immutable) */ __webpack_exports__["f"] = downloadCSV;
/* harmony export (immutable) */ __webpack_exports__["w"] = isEmptyObj;
/* harmony export (immutable) */ __webpack_exports__["h"] = flattenObj;
/* harmony export (immutable) */ __webpack_exports__["a"] = arrayToObjMap;
/* harmony export (immutable) */ __webpack_exports__["e"] = deepEquals;
/* harmony export (immutable) */ __webpack_exports__["v"] = includesObj;
/* harmony export (immutable) */ __webpack_exports__["A"] = replaceValuesInObject;
/* harmony export (immutable) */ __webpack_exports__["z"] = locationIsIsraeli;
/* harmony export (immutable) */ __webpack_exports__["r"] = getLocationDepartment;
/* harmony export (immutable) */ __webpack_exports__["D"] = validateAddressLocation;
/* harmony export (immutable) */ __webpack_exports__["o"] = formatReferenceOptions;
/* harmony export (immutable) */ __webpack_exports__["s"] = getObjectKeyByValue;
/* harmony export (immutable) */ __webpack_exports__["p"] = getApplicationPayee;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json2csv__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json2csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_json2csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(11);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function formatCurrency(num,isIsraeli,noCurrencySign){var alwaysPositive=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;if(!num){return num===0?(noCurrencySign?'':isIsraeli?'₪':'$')+'0.00':'';}num=parseFloat(num).toFixed(2);var parts=num.toString().split(".");var dollarAmount=alwaysPositive?Math.abs(parts[0]):parts[0];return(noCurrencySign?'':isIsraeli?'₪':'$')+dollarAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g,",")+(parts[1]?"."+parts[1]:"");}function stripCurrencyFormat(formattedNum){return formattedNum?parseInt(formattedNum.toString().replace(/[^0-9\.]/g,'')):'';}function formatDate(dateString){return dateString?new Date(dateString).toLocaleDateString():'';}function formatNumber(numString){return numString?numString.toString().replace(/\B(?=(\d{3})+(?!\d))/g,","):0;}function formatNumberStringForExcel(numString){return numString?'="'+numString+'"':null;}function toTitleCase(str){return str?str.replace(/\w\S*/g,function(txt){return txt.charAt(0).toUpperCase()+txt.substr(1);}):str;}function formatDateForInput(dateString){var date='';if(dateString){date=dateString;if(dateString.toString().length>10){var d=new Date(new Date(dateString)),month=''+(d.getMonth()+1),day=''+d.getDate(),year=d.getFullYear();if(month.length<2)month='0'+month;if(day.length<2)day='0'+day;return[year,month,day].join('-');}}return date;}function getStartDate(){var date=new Date();if(date.getDate()===1)return new Date(date.getFullYear(),date.getMonth()-1,1);return new Date(date.getFullYear(),date.getMonth(),1);}function concatenateAddressLabel(address,isIsraeli){if(!address)return'';if(isIsraeli){var streetNumDisplay=void 0;if(address.streetNumber&&address.apartment)streetNumDisplay=address.streetNumber+'/'+address.apartment;else{if(address.streetNumber)streetNumDisplay=address.streetNumber;else if(address.apartment)streetNumDisplay='-/'+address.apartment;}return''+(address.street?address.street+' ':'')+(streetNumDisplay?streetNumDisplay+', ':'')+' '+(address.city?address.city+', ':'')+(address.state?address.state+' ':'')+(address.zip?address.zip+', ':'')+(address.country?''+address.country:'');}return''+(address.streetNumber?address.streetNumber+' ':'')+(address.street?address.street+', ':'')+(address.unitType?address.unitType+' ':'')+(address.apartment?address.apartment+', ':'')+(address.city?address.city+', ':'')+(address.state?address.state+' ':'')+(address.zip?address.zip+', ':'')+(address.country?''+address.country:'');}function concatenateGeosuggestLabel(address,isIsraeli){if(!address)return'';return isIsraeli?''+(address.street?address.street+' ':'')+(address.streetNumber?address.streetNumber+', ':'')+(address.city?address.city+', ':'')+(address.state?address.state+' ':'')+(address.zip?address.zip+', ':'')+(address.country?''+address.country:''):''+(address.streetNumber?address.streetNumber+' ':'')+(address.street?address.street+', ':'')+(address.city?address.city+', ':'')+(address.state?address.state+' ':'')+(address.zip?address.zip+', ':'')+(address.country?''+address.country:'');}function getOrgDisplayName(titleKey,orgName,isIsraeli){var titles=isIsraeli?__WEBPACK_IMPORTED_MODULE_1__systemVariables__["m" /* Settings */].recipientSettings.israelInstitutionTitles:__WEBPACK_IMPORTED_MODULE_1__systemVariables__["m" /* Settings */].recipientSettings.usInstitutionTitles;var title=(titles[titles.map(function(t){return t.key;}).indexOf(titleKey)]||{}).value;return''+(title?title+' ':'')+orgName;}function getIndividualDisplayName(titleKey,firstName,lastName,isIsraeli){var titles=isIsraeli?__WEBPACK_IMPORTED_MODULE_1__systemVariables__["m" /* Settings */].recipientSettings.israelPersonTitles:__WEBPACK_IMPORTED_MODULE_1__systemVariables__["m" /* Settings */].recipientSettings.usPersonTitles;var title=(titles[titles.map(function(t){return t.key;}).indexOf(titleKey)]||{}).value;return''+(title?title+' ':'')+firstName+' '+lastName;}function formatBankInfoDisplay(bankNum,branchNum,accountNum,accountHolder){return bankNum||branchNum||accountNum||accountHolder?(bankNum||'--')+'/'+(branchNum||'---')+'/'+(accountNum||'---------')+(accountHolder?' held by '+accountHolder:''):'';}function isVowel(char){return char?['a','e','i','o','u'].indexOf(char.toLowerCase())!==-1:false;}function isValidEmail(email){return email?/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email):true;}function validateFieldLength(length,value){return value?value.toString().trim().length>=length:true;}function exportCSVFile(headers,data,fileTitle){var csv=convertToCSV(headers,data);var fileName=fileTitle?fileTitle+'.xls':'export.xls';//download
downloadCSV(csv,fileName);}function convertToCSV(headers,data){var flattenedData=data.map(function(data){for(var key in data){if(data[key]instanceof Array){data[key]=data[key].join(", ");}}return data;});return __WEBPACK_IMPORTED_MODULE_0_json2csv___default()({data:flattenedData,fields:headers,withBOM:true});}function downloadCSV(csv,fileName){var blob=new Blob([csv],{type:'text/xls;charset=utf-8;'});if(navigator.msSaveBlob){// IE 10+
navigator.msSaveBlob(blob,fileName);}else{var link=document.createElement("a");if(link.download!==undefined){// feature detection
// Browsers that support HTML5 download attribute
var url=URL.createObjectURL(blob);link.setAttribute("href",url);link.setAttribute("download",fileName);link.style.visibility='hidden';document.body.appendChild(link);link.click();document.body.removeChild(link);}}}function isEmptyObj(o){return Object.keys(o).every(function(x){return o[x]===''||o[x]===null;// or just "return o[x];" for falsy values
});}function flattenObj(ob){return Object.keys(ob).reduce(function(toReturn,k){if(Object.prototype.toString.call(ob[k])==='[object Date]'){toReturn[k]=ob[k].toString();}else if(_typeof(ob[k])==='object'&&ob[k]){if(Object.keys(ob[k]).length===0&&ob[k].constructor===Object){toReturn[k]='';}else{var flatObject=flattenObj(ob[k]);Object.keys(flatObject).forEach(function(k2){toReturn[k+'.'+k2]=flatObject[k2];});}}else{toReturn[k]=ob[k];}return toReturn;},{});}function arrayToObjMap(array,keys){var objMap={};if(array&&array.length)array.forEach(function(val){return objMap[val.key]=!keys?val.value:val.key;});return objMap;};function deepEquals(a,b){var sort=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;if(a&&b){if(a instanceof Array&&b instanceof Array)return sort?arraysEqual(a.sort(),b.sort()):arraysEqual(a,b);if(a instanceof Object&&b instanceof Object)return objectsEqual(a,b);}return a===b;}function arraysEqual(a,b){if(a.length!==b.length)return false;for(var i=0;i<a.length;i++){if(!deepEquals(a[i],b[i]))return false;}return true;}function objectsEqual(a,b){var aKeys=Object.getOwnPropertyNames(a);var bKeys=Object.getOwnPropertyNames(b);if(aKeys.length!==bKeys.length)return false;aKeys.sort();bKeys.sort();for(var i=0;i<aKeys.length;i++){if(aKeys[i]!==bKeys[i])// keys must be strings
return false;}return deepEquals(aKeys.map(function(k){return a[k];}),aKeys.map(function(k){return b[k];}));}function includesObj(obj,array){for(var i=0;i<array.length;i++){if(deepEquals(array[i],obj))return true;}return false;}function replaceValuesInObject(obj,toReplace,replacementValue){Object.keys(obj).forEach(function(key){if(toReplace(obj[key])){obj[key]=replacementValue;}else if(obj[key]){if(obj[key]instanceof Array){obj[key].forEach(function(rec){return replaceValuesInObject(rec,toReplace,replacementValue);});}else if(obj[key]instanceof Object){replaceValuesInObject(obj[key],toReplace,replacementValue);}}});}function locationIsIsraeli(locations,locationId){if(!locations||!locationId)return false;var location=locations[locations.map(function(loc){return loc.groupId.toString();}).indexOf(locationId.toString())];return location?location.department===__WEBPACK_IMPORTED_MODULE_1__systemVariables__["g" /* Departments */].IL:false;}function getLocationDepartment(locations,locationId){if(!locations||!locationId)return false;var location=locations[locations.map(function(loc){return loc.groupId.toString();}).indexOf(locationId.toString())];return location?location.department:'';}function validateAddressLocation(locations,locationId,address){if(!locations||!locationId||!address)return;var city=address.city,state=address.state,country=address.country;if(!city||!country)return true;else{var location=locations[locations.map(function(loc){return loc.groupId.toString();}).indexOf(locationId.toString())];if(!location)return true;if(address.country==="United States"){return includesObj({city:city,state:state,country:country},[].concat(_toConsumableArray(location.members.map(function(m){return{city:m.city,state:m.state,country:m.country};}))));}else if(address.country==='ישראל'&&location.department===__WEBPACK_IMPORTED_MODULE_1__systemVariables__["g" /* Departments */].IL&&location.members.length===1&&!location.members[0].city){return true;}else{return includesObj({city:city,country:country},[].concat(_toConsumableArray(location.members.map(function(m){return{city:m.city,country:m.country};}))));}}}function formatReferenceOptions(references){return references?references.map(function(ref){return{key:ref.referenceId,value:ref.displayName,displayValue:formatReferenceDisplay(ref)};}):[];}function formatReferenceDisplay(reference){if(!reference)return;var refProperties=[reference.displayName,reference.addressDisplay||reference.phoneNumber||reference.secondPhoneNumber||reference.email].filter(function(p){return p;});if(reference.displayName.search(/[\u0590-\u05FF]/)>=0)refProperties.reverse();//reverse order for Hebrew references
return refProperties.join(' - ');}function getObjectKeyByValue(obj,value){return obj?Object.keys(obj).find(function(i){return obj[i]===value;}):null;}function getApplicationPayee(paymentInfo,recipient){if(!paymentInfo)return{};switch(paymentInfo.payTo){case __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* PayeeTypes */].Recipient:return recipient||{};case __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* PayeeTypes */].ThirdParty:return paymentInfo.thirdParty||{};case __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* PayeeTypes */].TrustedPayee:return recipient.trustedPayee||{};default:return{};}}

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoadingSpinner=function(_React$Component){_inherits(LoadingSpinner,_React$Component);function LoadingSpinner(){_classCallCheck(this,LoadingSpinner);return _possibleConstructorReturn(this,(LoadingSpinner.__proto__||Object.getPrototypeOf(LoadingSpinner)).apply(this,arguments));}_createClass(LoadingSpinner,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"spinner-container"+(this.props.alignRight?"-right":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:"spinner",width:(this.props.height||12)+"px",height:(this.props.height||12)+"px",viewBox:"0 0 66 66",xmlns:"http://www.w3.org/2000/svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{className:"circle",fill:"none",strokeWidth:"6",strokeLinecap:"round",cx:"33",cy:"33",r:"30"})));}}]);return LoadingSpinner;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (LoadingSpinner);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LoadingSettings */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return Settings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Departments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PermissionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApplicationStatuses; });
/* unused harmony export RecipientStatuses */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RecipientTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CampaignListStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CampaignCategoryTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CampaignStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CampaignListTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return OrgEmploymentTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PreviousEmploymentTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CurrencyTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ManualPaymentTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_store__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
__WEBPACK_IMPORTED_MODULE_0__redux_store__["a" /* default */].subscribe(listener);function hasSetting(setting){return setting&&setting.length;}function listener(){var state=__WEBPACK_IMPORTED_MODULE_0__redux_store__["a" /* default */].getState();if(state.settings.updateTimestamp!==settingsUpdateTimestamp){var _state$settings$syste=state.settings.systemSettings,loadingSettings=_state$settings$syste.loading,settings=_state$settings$syste.data;settingsUpdateTimestamp=state.settings.updateTimestamp;LoadingSettings=loadingSettings;Settings=settings;if(!loadingSettings){if(hasSetting(settings.otherSettings.departments))Departments=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* arrayToObjMap */])(settings.otherSettings.departments);if(hasSetting(settings.otherSettings.permissionTypes))PermissionTypes=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* arrayToObjMap */])(settings.otherSettings.permissionTypes,true);if(hasSetting(settings.otherSettings.applicationStatuses))ApplicationStatuses=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* arrayToObjMap */])(settings.otherSettings.applicationStatuses);if(hasSetting(settings.otherSettings.recipientStatuses))RecipientStatuses=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* arrayToObjMap */])(settings.otherSettings.recipientStatuses);if(hasSetting(settings.otherSettings.recipientTypes))RecipientTypes=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* arrayToObjMap */])(settings.otherSettings.recipientTypes);if(hasSetting(settings.otherSettings.campaignListStatuses))CampaignListStatuses=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* arrayToObjMap */])(settings.otherSettings.campaignListStatuses);if(hasSetting(settings.otherSettings.campaignCategorie))CampaignCategoryTypes=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* arrayToObjMap */])(settings.otherSettings.campaignCategories);if(hasSetting(settings.otherSettings.campaignStatuses))CampaignStatuses=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* arrayToObjMap */])(settings.otherSettings.campaignStatuses);if(hasSetting(settings.otherSettings.campaignListTypes))CampaignListTypes=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* arrayToObjMap */])(settings.otherSettings.campaignListTypes);if(hasSetting(settings.otherSettings.orgEmploymentTypes))OrgEmploymentTypes=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* arrayToObjMap */])(settings.otherSettings.orgEmploymentTypes,true);if(hasSetting(settings.otherSettings.previousEmploymentTypes))PreviousEmploymentTypes=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* arrayToObjMap */])(settings.otherSettings.previousEmploymentTypes,true);if(hasSetting(settings.otherSettings.currencyTypes))CurrencyTypes=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* arrayToObjMap */])(settings.otherSettings.currencyTypes);}}}var settingsUpdateTimestamp=null;var LoadingSettings=false;var Settings={};var Departments={US:'US',IL:'IL'};var PermissionTypes={ApplicationsView:'ApplicationsView',ApplicationsManage:'ApplicationsManage',ApplicationsApproveFull:'ApplicationsApproveFull',ApplicationsApproveLimited:'ApplicationsApproveLimited',ApplicationsPrivate:'ApplicationsPrivate',RecipientAccntsView:'RecipientAccntsView',RecipientAccntsManage:'RecipientAccntsManage',CampaignAndListsView:'CampaignAndListsView',CampaignAndListsManage:'CampaignAndListsManage',PaymentsACH:'PaymentsACH',PaymentsPrint:'PaymentsPrint',PaymentsWire:'PaymentsWire',PaymentsVoid:'PaymentsVoid',AccountingView:'AccountingView',AccountingManage:'AccountingManage',Reporting:'Reporting',UsersAndSettingsManage:'UsersAndSettingsManage',IndividualsManage:'IndividualsManage',InstitutionsManage:'InstitutionsManage',AllFundsAccess:'AllFundsAccess',LimitedFundsAccess:"LimitedFundsAccess"};var ApplicationStatuses={New:'New',InReview:'In Review',Incomplete:'Incomplete',Approved:'Approved',Paid:'Paid',Rejected:'Rejected'};var RecipientStatuses={New:'New',HasBeenApproved:'Has Been Approved',HasBeenRejected:'Has Been Rejected'};var RecipientTypes={Organization:'Organization',Individual:'Individual'};var CampaignListStatuses={Added:'Added',Approved:'Approved',Sent:'Sent',Submitted:'Submitted'};var CampaignCategoryTypes={Yearly:'Yearly',Monthly:'Monthly'};var CampaignStatuses={Open:'Open',Closed:'Closed'};var CampaignListTypes={Internal:'Internal',External:'External'};var OrgEmploymentTypes={Rebbi:'Rebbi',Other:'Other',NA:'NA'};var PreviousEmploymentTypes={Kollel:'Kollel',Rebbi:'Rebbi',Other:'Other',NA:'NA'};var CurrencyTypes={Dollar:'$',Shekel:'₪'};var ManualPaymentTypes={BlankCheck:'BlankCheck',ManualCheck:'ManualCheck',ManualWire:'ManualWire'};

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FadeOutErrorMessage=function(_React$Component){_inherits(FadeOutErrorMessage,_React$Component);function FadeOutErrorMessage(props){_classCallCheck(this,FadeOutErrorMessage);var _this=_possibleConstructorReturn(this,(FadeOutErrorMessage.__proto__||Object.getPrototypeOf(FadeOutErrorMessage)).call(this,props));_this.mounted=false;_this.state={initialized:false,show:false};return _this;}_createClass(FadeOutErrorMessage,[{key:'componentDidMount',value:function componentDidMount(){this.mounted=true;}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.mounted=false;}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this2=this;if(!this.state.initialized&&nextProps.show){this.setState({initialized:true});}if(nextProps.show!==this.state.show){this.setState({show:nextProps.show});if(nextProps.show){if(this.props.timeOut){setTimeout(function(){if(_this2.mounted){_this2.setState({show:false});}},this.props.timeOut);}}}}},{key:'render',value:function render(){var message=this.props.message&&this.props.message.indexOf('\n')>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.message.split('\n').slice(0,1).map(function(text,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{key:index},text);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.message.split('\n').slice(1).map(function(text,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{key:index},text);}))):this.props.message||"Something went wrong.  Please try again.";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'error-label fade-error-label '+(this.state.show?"fade-in":"fade-out")},this.state.initialized?message:"");}}]);return FadeOutErrorMessage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (FadeOutErrorMessage);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NavigationComponent=function(_React$Component){_inherits(NavigationComponent,_React$Component);function NavigationComponent(props){_classCallCheck(this,NavigationComponent);var _this=_possibleConstructorReturn(this,(NavigationComponent.__proto__||Object.getPrototypeOf(NavigationComponent)).call(this,props));_this.state={showModals:{}};_this.pushRoute=_this.pushRoute.bind(_this);_this.pushRouteWithProps=_this.pushRouteWithProps.bind(_this);_this.toggleModals=_this.toggleModals.bind(_this);_this.toggleModal=_this.toggleModal.bind(_this);return _this;}_createClass(NavigationComponent,[{key:'pushRoute',value:function pushRoute(route,passProps){this.context.router.history.push(route);}},{key:'pushRouteWithProps',value:function pushRouteWithProps(route,passProps){this.context.router.history.push(route,passProps);}},{key:'toggleModals',value:function toggleModals(modals){var _this2=this;var updatedModals={};modals.forEach(function(modal){return updatedModals[modal]=!_this2.state.showModals[modal];});this.setState({showModals:Object.assign({},this.state.showModals,updatedModals)});}},{key:'toggleModal',value:function toggleModal(modal){this.setState({showModals:Object.assign({},this.state.showModals,_defineProperty({},modal,!this.state.showModals[modal]))});}}]);return NavigationComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);NavigationComponent.contextTypes={router:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (NavigationComponent);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(225)();
}


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transition_group__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Modal=function(_React$Component){_inherits(Modal,_React$Component);function Modal(){_classCallCheck(this,Modal);return _possibleConstructorReturn(this,(Modal.__proto__||Object.getPrototypeOf(Modal)).apply(this,arguments));}_createClass(Modal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_transition_group__["CSSTransitionGroup"],{transitionName:'example',transitionEnterTimeout:500,transitionLeaveTimeout:300},this.props.modalShowing&&this.props.children);}}]);return Modal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_TAGS", function() { return START_GET_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_TAGS", function() { return GET_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_SYSTEM_SETTINGS", function() { return START_GET_SYSTEM_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_SYSTEM_SETTINGS", function() { return GET_SYSTEM_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_PARTIAL_SYSTEM_SETTINGS", function() { return START_GET_PARTIAL_SYSTEM_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_PARTIAL_SYSTEM_SETTINGS", function() { return GET_PARTIAL_SYSTEM_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_PRINTERS", function() { return START_GET_PRINTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_PRINTERS", function() { return GET_PRINTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_PRINT_CHECKS", function() { return START_PRINT_CHECKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PRINT_CHECKS_COMPLETED", function() { return PRINT_CHECKS_COMPLETED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_CONFIRM_CHECKS_PRINTED", function() { return START_CONFIRM_CHECKS_PRINTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONFIRM_CHECKS_PRINTED", function() { return CONFIRM_CHECKS_PRINTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_LOGIN", function() { return START_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_VERIFY_LOGIN", function() { return START_VERIFY_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERIFY_LOGIN", function() { return VERIFY_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_LOGOUT", function() { return START_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT_SUCCESS", function() { return LOGOUT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_RECOVER_PASSWORD", function() { return START_RECOVER_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RECOVER_PASSWORD", function() { return RECOVER_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_RESET_PASSWORD", function() { return START_RESET_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_PASSWORD", function() { return RESET_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_APPROVERS", function() { return START_GET_APPROVERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_APPROVERS", function() { return GET_APPROVERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_USERS_TABLE", function() { return UPDATE_USERS_TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_USERS_TABLE_RECORDS", function() { return START_GET_USERS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_USERS_TABLE_RECORDS", function() { return GET_USERS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_USERS_TABLE_RECORD", function() { return UPDATE_USERS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_USER_DETAILS", function() { return START_GET_USER_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_USER_DETAILS", function() { return GET_USER_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_USER_PERMISSIONS", function() { return START_GET_USER_PERMISSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_USER_PERMISSIONS", function() { return GET_USER_PERMISSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_USER_DETAILS_AND_PERMISSIONS", function() { return CLEAR_USER_DETAILS_AND_PERMISSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_USER", function() { return START_UPDATE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_USER", function() { return UPDATE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_USER_DETAIL", function() { return START_UPDATE_USER_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_USER_DETAIL", function() { return UPDATE_USER_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_CREATE_USER", function() { return START_CREATE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CREATE_USER", function() { return CREATE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_PERMISSIONS_FOR_ROLE", function() { return START_GET_PERMISSIONS_FOR_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_PERMISSIONS_FOR_ROLE", function() { return GET_PERMISSIONS_FOR_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_USER_PROFILE", function() { return START_GET_USER_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_USER_PROFILE", function() { return GET_USER_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_USER_PROFILE", function() { return UPDATE_USER_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_RECIPIENT_SUGGESTIONS", function() { return START_GET_RECIPIENT_SUGGESTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_RECIPIENT_SUGGESTIONS", function() { return GET_RECIPIENT_SUGGESTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_RECIPIENT_SUGGESTIONS", function() { return CLEAR_RECIPIENT_SUGGESTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_APPLICATION_STATUS_COUNTS", function() { return START_GET_APPLICATION_STATUS_COUNTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_APPLICATION_STATUS_COUNTS", function() { return GET_APPLICATION_STATUS_COUNTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_APPLICATIONS_TO_RECIPIENT_IDS_MAPPING", function() { return START_GET_APPLICATIONS_TO_RECIPIENT_IDS_MAPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_APPLICATIONS_TO_RECIPIENT_IDS_MAPPING", function() { return GET_APPLICATIONS_TO_RECIPIENT_IDS_MAPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_APPLICATIONS_FILTERS", function() { return UPDATE_APPLICATIONS_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_APPLICATIONS_FILTERS", function() { return RESET_APPLICATIONS_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_APPLICATIONS_TABLE", function() { return UPDATE_APPLICATIONS_TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_APPLICATIONS_TABLE_RECORDS", function() { return CLEAR_APPLICATIONS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_APPLICATIONS_TABLE_RECORDS", function() { return START_GET_APPLICATIONS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_APPLICATIONS_TABLE_RECORDS", function() { return GET_APPLICATIONS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_APPLICATIONS_TABLE_RECORD", function() { return START_UPDATE_APPLICATIONS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_APPLICATIONS_TABLE_RECORD", function() { return UPDATE_APPLICATIONS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_REMOVE_APPLICATIONS_TABLE_RECORD", function() { return START_REMOVE_APPLICATIONS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE_APPLICATIONS_TABLE_RECORD", function() { return REMOVE_APPLICATIONS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOGGLE_SELECT_APPLICATIONS_TABLE_RECORD", function() { return TOGGLE_SELECT_APPLICATIONS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_APPLICATIONS_TABLE_SELECTION", function() { return CLEAR_APPLICATIONS_TABLE_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_APPLICATIONS_STATUS", function() { return START_UPDATE_APPLICATIONS_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_APPLICATIONS_STATUS_COMPLETED", function() { return UPDATE_APPLICATIONS_STATUS_COMPLETED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_VOID_APPLICATION_PAYMENT", function() { return START_VOID_APPLICATION_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VOID_APPLICATION_PAYMENT_COMPLETED", function() { return VOID_APPLICATION_PAYMENT_COMPLETED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_SEND_ACH_APPLICATIONS", function() { return START_SEND_ACH_APPLICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEND_ACH_APPLICATIONS_COMPLETED", function() { return SEND_ACH_APPLICATIONS_COMPLETED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SELECTED_COUNTS", function() { return UPDATE_SELECTED_COUNTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOGGLE_APPLICATIONS_SIDEBAR_FILTERS", function() { return TOGGLE_APPLICATIONS_SIDEBAR_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_APPLICATIONS_SIDEBAR_FILTERS", function() { return UPDATE_APPLICATIONS_SIDEBAR_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_APPLICATIONS_SIDEBAR_FILTERS", function() { return RESET_APPLICATIONS_SIDEBAR_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_APPLICATIONS_APPLIED_FILTERS", function() { return SET_APPLICATIONS_APPLIED_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_APPLICATIONS_SAVED_SEARCHES", function() { return START_GET_APPLICATIONS_SAVED_SEARCHES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_APPLICATIONS_SAVED_SEARCHES", function() { return GET_APPLICATIONS_SAVED_SEARCHES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_APPLICATIONS_SAVED_SEARCH", function() { return START_GET_APPLICATIONS_SAVED_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_APPLICATIONS_SAVED_SEARCH", function() { return GET_APPLICATIONS_SAVED_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_CREATE_APPLICATIONS_SAVED_SEARCH", function() { return START_CREATE_APPLICATIONS_SAVED_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CREATE_APPLICATIONS_SAVED_SEARCH", function() { return CREATE_APPLICATIONS_SAVED_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_DELETE_APPLICATIONS_SAVED_SEARCH", function() { return START_DELETE_APPLICATIONS_SAVED_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE_APPLICATIONS_SAVED_SEARCH", function() { return DELETE_APPLICATIONS_SAVED_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_CREATE_APPLICATION", function() { return START_CREATE_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CREATE_APPLICATION", function() { return CREATE_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_ORGANIZATIONS", function() { return START_GET_ORGANIZATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_ORGANIZATIONS", function() { return GET_ORGANIZATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_RECIPIENTS_FILTERS", function() { return UPDATE_RECIPIENTS_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_RECIPIENTS_FILTERS", function() { return RESET_RECIPIENTS_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_RECIPIENTS_TABLE", function() { return UPDATE_RECIPIENTS_TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_RECIPIENTS_TABLE_RECORDS", function() { return START_GET_RECIPIENTS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_RECIPIENTS_TABLE_RECORDS", function() { return GET_RECIPIENTS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_RECIPIENTS_FOR_EXPORT", function() { return GET_RECIPIENTS_FOR_EXPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_PLEDGES_REPORT", function() { return START_GET_PLEDGES_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_PLEDGES_REPORT", function() { return GET_PLEDGES_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_REMOVE_RECIPIENTS_TABLE_RECORD", function() { return START_REMOVE_RECIPIENTS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE_RECIPIENTS_TABLE_RECORD", function() { return REMOVE_RECIPIENTS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOGGLE_SELECT_RECIPIENTS_TABLE_RECORD", function() { return TOGGLE_SELECT_RECIPIENTS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_RECIPIENTS_TABLE_SELECTION", function() { return CLEAR_RECIPIENTS_TABLE_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOGGLE_RECIPIENTS_SIDEBAR_FILTERS", function() { return TOGGLE_RECIPIENTS_SIDEBAR_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_RECIPIENTS_SIDEBAR_FILTERS", function() { return UPDATE_RECIPIENTS_SIDEBAR_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_RECIPIENTS_SIDEBAR_FILTERS", function() { return RESET_RECIPIENTS_SIDEBAR_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_RECIPIENTS_APPLIED_FILTERS", function() { return SET_RECIPIENTS_APPLIED_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_RECIPIENTS_SAVED_SEARCHES", function() { return START_GET_RECIPIENTS_SAVED_SEARCHES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_RECIPIENTS_SAVED_SEARCHES", function() { return GET_RECIPIENTS_SAVED_SEARCHES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_RECIPIENTS_SAVED_SEARCH", function() { return START_GET_RECIPIENTS_SAVED_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_RECIPIENTS_SAVED_SEARCH", function() { return GET_RECIPIENTS_SAVED_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_CREATE_RECIPIENTS_SAVED_SEARCH", function() { return START_CREATE_RECIPIENTS_SAVED_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CREATE_RECIPIENTS_SAVED_SEARCH", function() { return CREATE_RECIPIENTS_SAVED_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_DELETE_RECIPIENTS_SAVED_SEARCH", function() { return START_DELETE_RECIPIENTS_SAVED_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE_RECIPIENTS_SAVED_SEARCH", function() { return DELETE_RECIPIENTS_SAVED_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_CREATE_RECIPIENT", function() { return START_CREATE_RECIPIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CREATE_RECIPIENT", function() { return CREATE_RECIPIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_RECIPIENT_DETAILS", function() { return START_GET_RECIPIENT_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_RECIPIENT_DETAILS", function() { return GET_RECIPIENT_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_RECIPIENT_APPLICATION_HISTORY", function() { return START_GET_RECIPIENT_APPLICATION_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_RECIPIENT_APPLICATION_HISTORY", function() { return GET_RECIPIENT_APPLICATION_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_RECIPIENT_APPLICATIONS_FOR_EXPORT", function() { return GET_RECIPIENT_APPLICATIONS_FOR_EXPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_RECIPIENT_DETAILS", function() { return START_UPDATE_RECIPIENT_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_RECIPIENT_DETAILS", function() { return UPDATE_RECIPIENT_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_ADD_RECIPIENT_NOTE", function() { return START_ADD_RECIPIENT_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_RECIPIENT_NOTE", function() { return ADD_RECIPIENT_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_RECIPIENT_NOTE", function() { return START_UPDATE_RECIPIENT_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_RECIPIENT_NOTE", function() { return UPDATE_RECIPIENT_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_DELETE_RECIPIENT_NOTE", function() { return START_DELETE_RECIPIENT_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE_RECIPIENT_NOTE", function() { return DELETE_RECIPIENT_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_APPLICATION_DETAILS", function() { return START_GET_APPLICATION_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_APPLICATION_DETAILS", function() { return GET_APPLICATION_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_APPLICATION_DETAILS", function() { return UPDATE_APPLICATION_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_ADD_APPLICATION_NOTE", function() { return START_ADD_APPLICATION_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_APPLICATION_NOTE", function() { return ADD_APPLICATION_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_APPLICATION_NOTE", function() { return START_UPDATE_APPLICATION_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_APPLICATION_NOTE", function() { return UPDATE_APPLICATION_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_DELETE_APPLICATION_NOTE", function() { return START_DELETE_APPLICATION_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE_APPLICATION_NOTE", function() { return DELETE_APPLICATION_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_APPLICATION_ATTACHMENTS", function() { return START_UPDATE_APPLICATION_ATTACHMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_APPLICATION_ATTACHMENTS", function() { return UPDATE_APPLICATION_ATTACHMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_APPLICATION_RECEIPTS", function() { return START_UPDATE_APPLICATION_RECEIPTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_APPLICATION_RECEIPTS", function() { return UPDATE_APPLICATION_RECEIPTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_APPLICATION", function() { return START_UPDATE_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_APPLICATION", function() { return UPDATE_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_REFERENCES", function() { return START_GET_REFERENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_REFERENCES", function() { return GET_REFERENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_REFERENCES_SEARCH", function() { return UPDATE_REFERENCES_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_CREATE_REFERENCE", function() { return START_CREATE_REFERENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CREATE_REFERENCE", function() { return CREATE_REFERENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_REFERENCE", function() { return START_UPDATE_REFERENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_REFERENCE", function() { return UPDATE_REFERENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_REFERENCES_TABLE", function() { return UPDATE_REFERENCES_TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_REFERENCES_TABLE_RECORDS", function() { return START_GET_REFERENCES_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_REFERENCES_TABLE_RECORDS", function() { return GET_REFERENCES_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_REMOVE_REFERENCES_TABLE_RECORD", function() { return START_REMOVE_REFERENCES_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE_REFERENCES_TABLE_RECORD", function() { return REMOVE_REFERENCES_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_FIND_DUPLICATE_RECIPIENTS", function() { return START_FIND_DUPLICATE_RECIPIENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FIND_DUPLICATE_RECIPIENTS_COMPLETE", function() { return FIND_DUPLICATE_RECIPIENTS_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_DUPLICATE_RECIPIENTS_TABLE", function() { return UPDATE_DUPLICATE_RECIPIENTS_TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_DUPLICATE_RECIPIENTS_TABLE_RECORDS", function() { return START_GET_DUPLICATE_RECIPIENTS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_DUPLICATE_RECIPIENTS_TABLE_RECORDS", function() { return GET_DUPLICATE_RECIPIENTS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_DUPLICATE_RECIPIENTS_DETAILS", function() { return START_GET_DUPLICATE_RECIPIENTS_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_DUPLICATE_RECIPIENTS_DETAILS", function() { return GET_DUPLICATE_RECIPIENTS_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_RESOLVE_DUPLICATE_RECIPIENTS", function() { return START_RESOLVE_DUPLICATE_RECIPIENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESOLVE_DUPLICATE_RECIPIENTS", function() { return RESOLVE_DUPLICATE_RECIPIENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_CAMPAIGNS", function() { return START_GET_CAMPAIGNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_CAMPAIGNS", function() { return GET_CAMPAIGNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CAMPAIGNS_FILTERS", function() { return UPDATE_CAMPAIGNS_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_CREATE_CAMPAIGN", function() { return START_CREATE_CAMPAIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CREATE_CAMPAIGN", function() { return CREATE_CAMPAIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE_CAMPAIGN", function() { return DELETE_CAMPAIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CAMPAIGNS_TABLE", function() { return UPDATE_CAMPAIGNS_TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_CAMPAIGNS_TABLE_RECORDS", function() { return START_GET_CAMPAIGNS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_CAMPAIGNS_TABLE_RECORDS", function() { return GET_CAMPAIGNS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_CAMPAIGN_DETAILS", function() { return START_GET_CAMPAIGN_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_CAMPAIGN_DETAILS", function() { return GET_CAMPAIGN_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_CAMPAIGN_DETAILS", function() { return CLEAR_CAMPAIGN_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_CAMPAIGN_DETAILS", function() { return START_UPDATE_CAMPAIGN_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CAMPAIGN_DETAILS", function() { return UPDATE_CAMPAIGN_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_CAMPAIGN_ALL_LISTS", function() { return START_GET_CAMPAIGN_ALL_LISTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_CAMPAIGN_ALL_LISTS", function() { return GET_CAMPAIGN_ALL_LISTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_CAMPAIGN_ALL_INDIVIDUALS", function() { return START_GET_CAMPAIGN_ALL_INDIVIDUALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_CAMPAIGN_ALL_INDIVIDUALS", function() { return GET_CAMPAIGN_ALL_INDIVIDUALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE", function() { return UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS", function() { return START_GET_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS", function() { return GET_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD", function() { return START_UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD", function() { return UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_REMOVE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD", function() { return START_REMOVE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD", function() { return REMOVE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS", function() { return CLEAR_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_ALL_CAMPAIGN_LISTS", function() { return START_GET_ALL_CAMPAIGN_LISTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_ALL_CAMPAIGN_LISTS", function() { return GET_ALL_CAMPAIGN_LISTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_ADD_CAMPAIGN_DETAILS_LIST", function() { return START_ADD_CAMPAIGN_DETAILS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_CAMPAIGN_DETAILS_LIST", function() { return ADD_CAMPAIGN_DETAILS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_APPROVE_CAMPAIGN_DETAILS_LIST", function() { return START_APPROVE_CAMPAIGN_DETAILS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APPROVE_CAMPAIGN_DETAILS_LIST", function() { return APPROVE_CAMPAIGN_DETAILS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_RESEND_CAMPAIGN_DETAILS_LIST", function() { return START_RESEND_CAMPAIGN_DETAILS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESEND_CAMPAIGN_DETAILS_LIST", function() { return RESEND_CAMPAIGN_DETAILS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_CAMPAIGN_LIST_EXTERNAL_UPDATES", function() { return START_GET_CAMPAIGN_LIST_EXTERNAL_UPDATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_CAMPAIGN_LIST_EXTERNAL_UPDATES", function() { return GET_CAMPAIGN_LIST_EXTERNAL_UPDATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_VERIFY_CAMPAIGN_LIST_EXTERNAL_UPDATES", function() { return START_VERIFY_CAMPAIGN_LIST_EXTERNAL_UPDATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERIFY_CAMPAIGN_LIST_EXTERNAL_UPDATES", function() { return VERIFY_CAMPAIGN_LIST_EXTERNAL_UPDATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE", function() { return UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS", function() { return START_GET_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS", function() { return GET_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD", function() { return START_UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD", function() { return UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_REMOVE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD", function() { return START_REMOVE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD", function() { return REMOVE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOGGLE_SELECT_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD", function() { return TOGGLE_SELECT_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_SELECTION", function() { return CLEAR_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS", function() { return CLEAR_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_ADD_CAMPAIGN_DETAILS_INDIVIDUAL", function() { return START_ADD_CAMPAIGN_DETAILS_INDIVIDUAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_CAMPAIGN_DETAILS_INDIVIDUAL", function() { return ADD_CAMPAIGN_DETAILS_INDIVIDUAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CAMPAIGN_LISTS_FILTERS", function() { return UPDATE_CAMPAIGN_LISTS_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_CREATE_CAMPAIGN_LIST", function() { return START_CREATE_CAMPAIGN_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CREATE_CAMPAIGN_LIST", function() { return CREATE_CAMPAIGN_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CAMPAIGN_LISTS_SEARCH", function() { return UPDATE_CAMPAIGN_LISTS_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_CAMPAIGN_LISTS", function() { return START_GET_CAMPAIGN_LISTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_CAMPAIGN_LISTS", function() { return GET_CAMPAIGN_LISTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CAMPAIGN_LISTS_TABLE", function() { return UPDATE_CAMPAIGN_LISTS_TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_CAMPAIGN_LISTS_TABLE_RECORDS", function() { return START_GET_CAMPAIGN_LISTS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_CAMPAIGN_LISTS_TABLE_RECORDS", function() { return GET_CAMPAIGN_LISTS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_CAMPAIGN_LIST_DETAILS", function() { return START_GET_CAMPAIGN_LIST_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_CAMPAIGN_LIST_DETAILS", function() { return GET_CAMPAIGN_LIST_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_CAMPAIGN_LIST_DETAILS", function() { return CLEAR_CAMPAIGN_LIST_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_CAMPAIGN_LIST_DETAILS", function() { return START_UPDATE_CAMPAIGN_LIST_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CAMPAIGN_LIST_DETAILS", function() { return UPDATE_CAMPAIGN_LIST_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_ADD_CAMPAIGN_LIST_PARTICIPANT", function() { return START_ADD_CAMPAIGN_LIST_PARTICIPANT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_CAMPAIGN_LIST_PARTICIPANT", function() { return ADD_CAMPAIGN_LIST_PARTICIPANT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_CAMPAIGN_LIST_ALL_PARTICIPANTS", function() { return START_GET_CAMPAIGN_LIST_ALL_PARTICIPANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_CAMPAIGN_LIST_ALL_PARTICIPANTS", function() { return GET_CAMPAIGN_LIST_ALL_PARTICIPANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CAMPAIGN_LIST_PARTICIPANTS_TABLE", function() { return UPDATE_CAMPAIGN_LIST_PARTICIPANTS_TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS", function() { return START_GET_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS", function() { return GET_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_REMOVE_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORD", function() { return START_REMOVE_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVE_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORD", function() { return REMOVE_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS", function() { return CLEAR_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_CAMPAIGN_LIST_PENDING_PARTICIPANTS", function() { return START_GET_CAMPAIGN_LIST_PENDING_PARTICIPANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_CAMPAIGN_LIST_PENDING_PARTICIPANTS", function() { return GET_CAMPAIGN_LIST_PENDING_PARTICIPANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE", function() { return UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS", function() { return START_GET_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS", function() { return GET_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORD", function() { return START_UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORD", function() { return UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS", function() { return CLEAR_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CAMPAIGN_LISTS_APPLICATIONS_STATUS", function() { return UPDATE_CAMPAIGN_LISTS_APPLICATIONS_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_CAMPAIGN_LISTS_APPLICATIONS_STATUS", function() { return CLEAR_CAMPAIGN_LISTS_APPLICATIONS_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_RECEIVING_PARTICIPANTS_INFINITELIST_CONFIGS", function() { return UPDATE_RECEIVING_PARTICIPANTS_INFINITELIST_CONFIGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS", function() { return START_GET_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS", function() { return GET_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS", function() { return CLEAR_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_EXTERNAL_CAMPAIGN_LIST_DETAILS", function() { return START_GET_EXTERNAL_CAMPAIGN_LIST_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_EXTERNAL_CAMPAIGN_LIST_DETAILS", function() { return GET_EXTERNAL_CAMPAIGN_LIST_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_EXTERNAL_CAMPAIGN_LIST_RECIPIENTS", function() { return START_GET_EXTERNAL_CAMPAIGN_LIST_RECIPIENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_EXTERNAL_CAMPAIGN_LIST_RECIPIENTS", function() { return GET_EXTERNAL_CAMPAIGN_LIST_RECIPIENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_CONFIGS", function() { return UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_CONFIGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_RECORDS", function() { return START_GET_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_RECORDS", function() { return GET_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_DATA", function() { return UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS", function() { return START_UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS", function() { return UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_SELECT_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS", function() { return START_SELECT_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SELECT_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS", function() { return SELECT_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_EXPORT_EXTERNAL_CAMPAIGN_LIST", function() { return START_EXPORT_EXTERNAL_CAMPAIGN_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXPORT_EXTERNAL_CAMPAIGN_LIST", function() { return EXPORT_EXTERNAL_CAMPAIGN_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_SUBMIT_EXTERNAL_CAMPAIGN_LIST", function() { return START_SUBMIT_EXTERNAL_CAMPAIGN_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBMIT_EXTERNAL_CAMPAIGN_LIST", function() { return SUBMIT_EXTERNAL_CAMPAIGN_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_ADD_TAG", function() { return START_ADD_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_TAG", function() { return ADD_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_TAG", function() { return START_UPDATE_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_TAG", function() { return UPDATE_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_DELETE_TAG", function() { return START_DELETE_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE_TAG", function() { return DELETE_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_SETTING", function() { return START_UPDATE_SETTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SETTING", function() { return UPDATE_SETTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_ADD_SIGNATURE", function() { return START_ADD_SIGNATURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_SIGNATURE", function() { return ADD_SIGNATURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_FUNDS", function() { return START_GET_FUNDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_FUNDS", function() { return GET_FUNDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_FUNDS_VERBOSE", function() { return START_GET_FUNDS_VERBOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_FUNDS_VERBOSE", function() { return GET_FUNDS_VERBOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_CREATE_FUND", function() { return START_CREATE_FUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CREATE_FUND", function() { return CREATE_FUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_FUND_DETAILS", function() { return START_GET_FUND_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_FUND_DETAILS", function() { return GET_FUND_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_FUND", function() { return START_UPDATE_FUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_FUND", function() { return UPDATE_FUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_ACCOUNTING_FILTERS", function() { return UPDATE_ACCOUNTING_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_ACCOUNTING_TRANSACTIONS_TABLE", function() { return UPDATE_ACCOUNTING_TRANSACTIONS_TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS", function() { return START_GET_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS", function() { return GET_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS", function() { return CLEAR_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_ACCOUNTING_OUTSIDE_TRANSACTION_FILTERS", function() { return UPDATE_ACCOUNTING_OUTSIDE_TRANSACTION_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE", function() { return UPDATE_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE_RECORDS", function() { return START_GET_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE_RECORDS", function() { return GET_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE_RECORDS", function() { return CLEAR_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_CREATE_OUTSIDE_TRANSACTION", function() { return START_CREATE_OUTSIDE_TRANSACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CREATE_OUTSIDE_TRANSACTION", function() { return CREATE_OUTSIDE_TRANSACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_TRANSACTION", function() { return START_UPDATE_TRANSACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_TRANSACTION", function() { return UPDATE_TRANSACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_VOIDING_TRANSACTION", function() { return START_VOIDING_TRANSACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VOID_TRANSACTIONS", function() { return VOID_TRANSACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_BANK_RECONCILIATIONS", function() { return START_GET_BANK_RECONCILIATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_BANK_RECONCILIATIONS", function() { return GET_BANK_RECONCILIATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_DELETE_RECONCILIATION_REPORT", function() { return START_DELETE_RECONCILIATION_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE_RECONCILIATION_REPORT", function() { return DELETE_RECONCILIATION_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_RECONCILIATION_REPORTS_FILTERS", function() { return UPDATE_RECONCILIATION_REPORTS_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_RECONCILIATION_PAYMENTS_INFINITELIST_CONFIGS", function() { return UPDATE_RECONCILIATION_PAYMENTS_INFINITELIST_CONFIGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS", function() { return START_GET_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS", function() { return GET_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOGGLE_SELECT_RECONCILIATION_PAYMENTS_INFINITELIST_RECORD", function() { return TOGGLE_SELECT_RECONCILIATION_PAYMENTS_INFINITELIST_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_RECONCILIATION_PAYMENTS_INFINITELIST_SELECTION", function() { return CLEAR_RECONCILIATION_PAYMENTS_INFINITELIST_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS", function() { return CLEAR_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_RECONCILIATION_CREDITS_INFINITELIST_CONFIGS", function() { return UPDATE_RECONCILIATION_CREDITS_INFINITELIST_CONFIGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_RECONCILIATION_CREDITS_INFINITELIST_RECORDS", function() { return START_GET_RECONCILIATION_CREDITS_INFINITELIST_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_RECONCILIATION_CREDITS_INFINITELIST_RECORDS", function() { return GET_RECONCILIATION_CREDITS_INFINITELIST_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOGGLE_SELECT_RECONCILIATION_CREDITS_INFINITELIST_RECORD", function() { return TOGGLE_SELECT_RECONCILIATION_CREDITS_INFINITELIST_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_RECONCILIATION_CREDITS_INFINITELIST_SELECTION", function() { return CLEAR_RECONCILIATION_CREDITS_INFINITELIST_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_RECONCILIATION_CREDITS_INFINITELIST_RECORDS", function() { return CLEAR_RECONCILIATION_CREDITS_INFINITELIST_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_RECONCILIATION_ADJUSTMENTS", function() { return UPDATE_RECONCILIATION_ADJUSTMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_RECONCILIATION_BALANCE", function() { return UPDATE_RECONCILIATION_BALANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_RECONCILIATION_REPORT", function() { return START_GET_RECONCILIATION_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_RECONCILIATION_REPORT", function() { return GET_RECONCILIATION_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_CREATE_RECONCILIATION_REPORT", function() { return START_CREATE_RECONCILIATION_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CREATE_RECONCILIATION_REPORT", function() { return CREATE_RECONCILIATION_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_CREATE_AND_COMPLETE_RECONCILIATION_REPORT", function() { return START_CREATE_AND_COMPLETE_RECONCILIATION_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CREATE_AND_COMPLETE_RECONCILIATION_REPORT", function() { return CREATE_AND_COMPLETE_RECONCILIATION_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_UPDATE_RECONCILIATION_REPORT", function() { return START_UPDATE_RECONCILIATION_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_RECONCILIATION_REPORT", function() { return UPDATE_RECONCILIATION_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_COMPLETE_RECONCILIATION_REPORT", function() { return START_COMPLETE_RECONCILIATION_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPLETE_RECONCILIATION_REPORT", function() { return COMPLETE_RECONCILIATION_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_GET_BLANK_CHECKS", function() { return START_GET_BLANK_CHECKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GET_BLANK_CHECKS", function() { return GET_BLANK_CHECKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_BLANK_CHECKS", function() { return CLEAR_BLANK_CHECKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_GEOSUGGEST_SETTINGS", function() { return UPDATE_GEOSUGGEST_SETTINGS; });
//Settings/Utils:
var START_GET_TAGS='START_GET_TAGS';var GET_TAGS='GET_TAGS';var START_GET_SYSTEM_SETTINGS='START_GET_SYSTEM_SETTINGS';var GET_SYSTEM_SETTINGS='GET_SYSTEM_SETTINGS';var START_GET_PARTIAL_SYSTEM_SETTINGS='START_GET_PARTIAL_SYSTEM_SETTINGS';var GET_PARTIAL_SYSTEM_SETTINGS='GET_PARTIAL_SYSTEM_SETTINGS';var START_GET_PRINTERS='START_GET_PRINTERS';var GET_PRINTERS='GET_PRINTERS';//Check Printing:
var START_PRINT_CHECKS='START_PRINT_CHECKS';var PRINT_CHECKS_COMPLETED='PRINT_CHECKS_COMPLETED';var START_CONFIRM_CHECKS_PRINTED='START_CONFIRM_CHECKS_PRINTED';var CONFIRM_CHECKS_PRINTED='CONFIRM_CHECKS_PRINTED';//Authentication: 
var START_LOGIN='START_LOGIN';var LOGIN='LOGIN';var START_VERIFY_LOGIN='START_VERIFY_LOGIN';var VERIFY_LOGIN='VERIFY_LOGIN';var START_LOGOUT='START_LOGOUT';var LOGOUT='LOGOUT';var LOGOUT_SUCCESS='LOGOUT_SUCCESS';var START_RECOVER_PASSWORD='START_RECOVER_PASSWORD';var RECOVER_PASSWORD='RECOVER_PASSWORD';var START_RESET_PASSWORD='START_RESET_PASSWORD';var RESET_PASSWORD='RESET_PASSWORD';//Users:
var START_GET_APPROVERS='START_GET_APPROVERS';var GET_APPROVERS='GET_APPROVERS';var UPDATE_USERS_TABLE='UPDATE_USERS_TABLE';var START_GET_USERS_TABLE_RECORDS='START_GET_USERS_TABLE_RECORDS';var GET_USERS_TABLE_RECORDS='GET_USERS_TABLE_RECORDS';var UPDATE_USERS_TABLE_RECORD='UPDATE_USERS_TABLE_RECORD';var START_GET_USER_DETAILS='START_GET_USER_DETAILS';var GET_USER_DETAILS='GET_USER_DETAILS';var START_GET_USER_PERMISSIONS='START_GET_USER_PERMISSIONS';var GET_USER_PERMISSIONS='GET_USER_PERMISSIONS';var CLEAR_USER_DETAILS_AND_PERMISSIONS='CLEAR_USER_DETAILS_AND_PERMISSIONS';var START_UPDATE_USER='START_UPDATE_USER';var UPDATE_USER='UPDATE_USER';var START_UPDATE_USER_DETAIL='START_UPDATE_USER_DETAIL';var UPDATE_USER_DETAIL='UPDATE_USER_DETAIL';var START_CREATE_USER='START_CREATE_USER';var CREATE_USER='CREATE_USER';var START_GET_PERMISSIONS_FOR_ROLE='START_GET_PERMISSIONS_FOR_ROLE';var GET_PERMISSIONS_FOR_ROLE='GET_PERMISSIONS_FOR_ROLE';//User Profile:
var START_GET_USER_PROFILE='START_GET_USER_PROFILE';var GET_USER_PROFILE='GET_USER_PROFILE';var UPDATE_USER_PROFILE='UPDATE_USER_PROFILE';//Suggestions:
var START_GET_RECIPIENT_SUGGESTIONS='START_GET_RECIPIENT_SUGGESTIONS';var GET_RECIPIENT_SUGGESTIONS='GET_RECIPIENT_SUGGESTIONS';var CLEAR_RECIPIENT_SUGGESTIONS='CLEAR_RECIPIENT_SUGGESTIONS';//Applications
var START_GET_APPLICATION_STATUS_COUNTS='START_GET_APPLICATION_STATUS_COUNTS';var GET_APPLICATION_STATUS_COUNTS='GET_APPLICATION_STATUS_COUNTS';var START_GET_APPLICATIONS_TO_RECIPIENT_IDS_MAPPING='START_GET_APPLICATION_TO_RECIPIENT_ID_MAPPING';var GET_APPLICATIONS_TO_RECIPIENT_IDS_MAPPING='GET_APPLICATION_TO_RECIPIENT_ID_MAPPING';var UPDATE_APPLICATIONS_FILTERS='UPDATE_APPLICATIONS_FILTERS';var RESET_APPLICATIONS_FILTERS='RESET_APPLICATIONS_FILTERS';var UPDATE_APPLICATIONS_TABLE='UPDATE_APPLICATIONS_TABLE';var CLEAR_APPLICATIONS_TABLE_RECORDS='CLEAR_APPLICATIONS_TABLE_RECORDS';var START_GET_APPLICATIONS_TABLE_RECORDS='START_GET_APPLICATIONS_TABLE_RECORDS';var GET_APPLICATIONS_TABLE_RECORDS='GET_APPLICATIONS_TABLE_RECORDS';var START_UPDATE_APPLICATIONS_TABLE_RECORD='START_UPDATE_APPLICATIONS_TABLE_RECORD';var UPDATE_APPLICATIONS_TABLE_RECORD='UPDATE_APPLICATIONS_TABLE_RECORD';var START_REMOVE_APPLICATIONS_TABLE_RECORD='START_REMOVE_APPLICATIONS_TABLE_RECORD';var REMOVE_APPLICATIONS_TABLE_RECORD='REMOVE_APPLICATIONS_TABLE_RECORD';var TOGGLE_SELECT_APPLICATIONS_TABLE_RECORD='TOGGLE_SELECT_APPLICATIONS_TABLE_RECORD';var CLEAR_APPLICATIONS_TABLE_SELECTION='CLEAR_APPLICATIONS_TABLE_SELECTION';var START_UPDATE_APPLICATIONS_STATUS='START_UPDATE_APPLICATIONS_STATUS';var UPDATE_APPLICATIONS_STATUS_COMPLETED='UPDATE_APPLICATIONS_STATUS_COMPLETED';var START_VOID_APPLICATION_PAYMENT='START_VOID_APPLICATION_PAYMENT';var VOID_APPLICATION_PAYMENT_COMPLETED='VOID_APPLICATION_PAYMENT_COMPLETED';var START_SEND_ACH_APPLICATIONS='START_SEND_ACH_APPLICATIONS';var SEND_ACH_APPLICATIONS_COMPLETED='SEND_ACH_APPLICATIONS_COMPLETED';var UPDATE_SELECTED_COUNTS='UPDATE_SELECTED_COUNTS';var TOGGLE_APPLICATIONS_SIDEBAR_FILTERS='TOGGLE_APPLICATIONS_SIDEBAR_FILTERS';var UPDATE_APPLICATIONS_SIDEBAR_FILTERS='UPDATE_APPLICATIONS_SIDEBAR_FILTERS';var RESET_APPLICATIONS_SIDEBAR_FILTERS='RESET_APPLICATIONS_SIDEBAR_FILTERS';var SET_APPLICATIONS_APPLIED_FILTERS='SET_APPLICATIONS_APPLIED_FILTERS';var START_GET_APPLICATIONS_SAVED_SEARCHES='START_GET_APPLICATIONS_SAVED_SEARCHES';var GET_APPLICATIONS_SAVED_SEARCHES='GET_APPLICATIONS_SAVED_SEARCHES';var START_GET_APPLICATIONS_SAVED_SEARCH='START_GET_APPLICATIONS_SAVED_SEARCH';var GET_APPLICATIONS_SAVED_SEARCH='GET_APPLICATIONS_SAVED_SEARCH';var START_CREATE_APPLICATIONS_SAVED_SEARCH='START_CREATE_APPLICATIONS_SAVED_SEARCH';var CREATE_APPLICATIONS_SAVED_SEARCH='CREATE_APPLICATIONS_SAVED_SEARCH';var START_DELETE_APPLICATIONS_SAVED_SEARCH='START_DELETE_APPLICATIONS_SAVED_SEARCH';var DELETE_APPLICATIONS_SAVED_SEARCH='DELETE_APPLICATIONS_SAVED_SEARCH';//Create Application:
var START_CREATE_APPLICATION='START_CREATE_APPLICATION';var CREATE_APPLICATION='CREATE_APPLICATION';//Recipients:
var START_GET_ORGANIZATIONS='START_GET_ORGANIZATIONS';var GET_ORGANIZATIONS='GET_ORGANIZATIONS';var UPDATE_RECIPIENTS_FILTERS='UPDATE_RECIPIENTS_FILTERS';var RESET_RECIPIENTS_FILTERS='RESET_RECIPIENTS_FILTERS';var UPDATE_RECIPIENTS_TABLE='UPDATE_RECIPIENTS_TABLE';var START_GET_RECIPIENTS_TABLE_RECORDS='START_GET_RECIPIENTS_TABLE_RECORDS';var GET_RECIPIENTS_TABLE_RECORDS='GET_RECIPIENTS_TABLE_RECORDS';var GET_RECIPIENTS_FOR_EXPORT='GET_RECIPIENTS_FOR_EXPORT';var START_GET_PLEDGES_REPORT='START_GET_PLEDGES_REPORT';var GET_PLEDGES_REPORT='GET_PLEDGES_REPORT';var START_REMOVE_RECIPIENTS_TABLE_RECORD='START_REMOVE_RECIPIENTS_TABLE_RECORD';var REMOVE_RECIPIENTS_TABLE_RECORD='REMOVE_RECIPIENTS_TABLE_RECORD';var TOGGLE_SELECT_RECIPIENTS_TABLE_RECORD='TOGGLE_SELECT_RECIPIENTS_TABLE_RECORD';var CLEAR_RECIPIENTS_TABLE_SELECTION='CLEAR_RECIPIENTS_TABLE_SELECTION';var TOGGLE_RECIPIENTS_SIDEBAR_FILTERS='TOGGLE_RECIPIENTS_SIDEBAR_FILTERS';var UPDATE_RECIPIENTS_SIDEBAR_FILTERS='UPDATE_RECIPIENTS_SIDEBAR_FILTERS';var RESET_RECIPIENTS_SIDEBAR_FILTERS='RESET_RECIPIENTS_SIDEBAR_FILTERS';var SET_RECIPIENTS_APPLIED_FILTERS='SET_RECIPIENTS_APPLIED_FILTERS';var START_GET_RECIPIENTS_SAVED_SEARCHES='START_GET_RECIPIENTS_SAVED_SEARCHES';var GET_RECIPIENTS_SAVED_SEARCHES='GET_RECIPIENTS_SAVED_SEARCHES';var START_GET_RECIPIENTS_SAVED_SEARCH='START_GET_RECIPIENTS_SAVED_SEARCH';var GET_RECIPIENTS_SAVED_SEARCH='GET_RECIPIENTS_SAVED_SEARCH';var START_CREATE_RECIPIENTS_SAVED_SEARCH='START_CREATE_RECIPIENTS_SAVED_SEARCH';var CREATE_RECIPIENTS_SAVED_SEARCH='CREATE_RECIPIENTS_SAVED_SEARCH';var START_DELETE_RECIPIENTS_SAVED_SEARCH='START_DELETE_RECIPIENTS_SAVED_SEARCH';var DELETE_RECIPIENTS_SAVED_SEARCH='DELETE_RECIPIENTS_SAVED_SEARCH';var START_CREATE_RECIPIENT='START_CREATE_RECIPIENT';var CREATE_RECIPIENT='CREATE_RECIPIENT';//Recipient Account Details:
var START_GET_RECIPIENT_DETAILS='START_GET_RECIPIENT_DETAILS';var GET_RECIPIENT_DETAILS='GET_RECIPIENT_DETAILS';var START_GET_RECIPIENT_APPLICATION_HISTORY='START_GET_RECIPIENT_APPLICATION_HISTORY';var GET_RECIPIENT_APPLICATION_HISTORY='GET_RECIPIENT_APPLICATION_HISTORY';var GET_RECIPIENT_APPLICATIONS_FOR_EXPORT='GET_RECIPIENT_APPLICATIONS_FOR_EXPORT';var START_UPDATE_RECIPIENT_DETAILS='START_UPDATE_RECIPIENT_DETAILS';var UPDATE_RECIPIENT_DETAILS='UPDATE_RECIPIENT_DETAILS';var START_ADD_RECIPIENT_NOTE='START_ADD_RECIPIENT_NOTE';var ADD_RECIPIENT_NOTE='ADD_RECIPIENT_NOTE';var START_UPDATE_RECIPIENT_NOTE='START_UPDATE_RECIPIENT_NOTE';var UPDATE_RECIPIENT_NOTE='UPDATE_RECIPIENT_NOTE';var START_DELETE_RECIPIENT_NOTE='START_DELETE_RECIPIENT_NOTE';var DELETE_RECIPIENT_NOTE='DELETE_RECIPIENT_NOTE';//Application Details:
var START_GET_APPLICATION_DETAILS='START_GET_APPLICATION_DETAILS';var GET_APPLICATION_DETAILS='GET_APPLICATION_DETAILS';var UPDATE_APPLICATION_DETAILS='UPDATE_APPLICATION_DETAILS';var START_ADD_APPLICATION_NOTE='START_ADD_APPLICATION_NOTE';var ADD_APPLICATION_NOTE='ADD_APPLICATION_NOTE';var START_UPDATE_APPLICATION_NOTE='START_UPDATE_APPLICATION_NOTE';var UPDATE_APPLICATION_NOTE='UPDATE_APPLICATION_NOTE';var START_DELETE_APPLICATION_NOTE='START_DELETE_APPLICATION_NOTE';var DELETE_APPLICATION_NOTE='DELETE_APPLICATION_NOTE';var START_UPDATE_APPLICATION_ATTACHMENTS='START_UPDATE_APPLICATION_ATTACHMENTS';var UPDATE_APPLICATION_ATTACHMENTS='UPDATE_APPLICATION_ATTACHMENTS';var START_UPDATE_APPLICATION_RECEIPTS='START_UPDATE_APPLICATION_RECEIPTS';var UPDATE_APPLICATION_RECEIPTS='UPDATE_APPLICATION_RECEIPTS';var START_UPDATE_APPLICATION='START_UPDATE_APPLICATION';var UPDATE_APPLICATION='UPDATE_APPLICATION';//References:
var START_GET_REFERENCES='START_GET_REFERENCES';var GET_REFERENCES='GET_REFERENCES';var UPDATE_REFERENCES_SEARCH='UPDATE_REFERENCES_SEARCH';var START_CREATE_REFERENCE='START_CREATE_REFERENCE';var CREATE_REFERENCE='CREATE_REFERENCE';var START_UPDATE_REFERENCE='START_UPDATE_REFERENCE';var UPDATE_REFERENCE='UPDATE_REFERENCE';var UPDATE_REFERENCES_TABLE='UPDATE_REFERENCES_TABLE';var START_GET_REFERENCES_TABLE_RECORDS='START_GET_REFERENCES_TABLE_RECORDS';var GET_REFERENCES_TABLE_RECORDS='GET_REFERENCES_TABLE_RECORDS';var START_REMOVE_REFERENCES_TABLE_RECORD='START_REMOVE_REFERENCES_TABLE_RECORD';var REMOVE_REFERENCES_TABLE_RECORD='REMOVE_REFERENCES_TABLE_RECORD';//Duplicate Recipients:
var START_FIND_DUPLICATE_RECIPIENTS='START_FIND_DUPLICATE_RECIPIENTS';var FIND_DUPLICATE_RECIPIENTS_COMPLETE='FIND_DUPLICATE_RECIPIENTS_COMPLETE';var UPDATE_DUPLICATE_RECIPIENTS_TABLE='UPDATE_DUPLICATE_RECIPIENTS_TABLE';var START_GET_DUPLICATE_RECIPIENTS_TABLE_RECORDS='START_GET_DUPLICATE_RECIPIENTS_TABLE_RECORDS';var GET_DUPLICATE_RECIPIENTS_TABLE_RECORDS='GET_DUPLICATE_RECIPIENTS_TABLE_RECORDS';var START_GET_DUPLICATE_RECIPIENTS_DETAILS='START_GET_DUPLICATE_RECIPIENTS_DETAILS';var GET_DUPLICATE_RECIPIENTS_DETAILS='GET_DUPLICATE_RECIPIENTS_DETAILS';var START_RESOLVE_DUPLICATE_RECIPIENTS='START_RESOLVE_DUPLICATE_RECIPIENTS';var RESOLVE_DUPLICATE_RECIPIENTS='RESOLVE_DUPLICATE_RECIPIENTS';//Campaigns:
var START_GET_CAMPAIGNS='START_GET_CAMPAIGNS';var GET_CAMPAIGNS='GET_CAMPAIGNS';var UPDATE_CAMPAIGNS_FILTERS='UPDATE_CAMPAIGNS_FILTERS';var START_CREATE_CAMPAIGN='START_CREATE_CAMPAIGN';var CREATE_CAMPAIGN='CREATE_CAMPAIGN';var DELETE_CAMPAIGN='DELETE_CAMPAIGN';var UPDATE_CAMPAIGNS_TABLE='UPDATE_CAMPAIGNS_TABLE';var START_GET_CAMPAIGNS_TABLE_RECORDS='START_GET_CAMPAIGNS_TABLE_RECORDS';var GET_CAMPAIGNS_TABLE_RECORDS='GET_CAMPAIGNS_TABLE_RECORDS';//Campaign Details:
var START_GET_CAMPAIGN_DETAILS='START_GET_CAMPAIGN_DETAILS';var GET_CAMPAIGN_DETAILS='GET_CAMPAIGN_DETAILS';var CLEAR_CAMPAIGN_DETAILS='CLEAR_CAMPAIGN_DETAILS';var START_UPDATE_CAMPAIGN_DETAILS='START_UPDATE_CAMPAIGN_DETAILS';var UPDATE_CAMPAIGN_DETAILS='UPDATE_CAMPAIGN_DETAILS';var START_GET_CAMPAIGN_ALL_LISTS='START_GET_CAMPAIGN_ALL_LISTS';var GET_CAMPAIGN_ALL_LISTS='GET_CAMPAIGN_ALL_LISTS';var START_GET_CAMPAIGN_ALL_INDIVIDUALS='START_GET_CAMPAIGN_ALL_INDIVIDUALS';var GET_CAMPAIGN_ALL_INDIVIDUALS='GET_CAMPAIGN_ALL_INDIVIDUALS';var UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE='UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE';var START_GET_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS='START_GET_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS';var GET_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS='GET_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS';var START_UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD='START_UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD';var UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD='UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD';var START_REMOVE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD='START_REMOVE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD';var REMOVE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD='REMOVE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD';var CLEAR_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS='CLEAR_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS';var START_GET_ALL_CAMPAIGN_LISTS='START_GET_ALL_CAMPAIGN_LISTS';var GET_ALL_CAMPAIGN_LISTS='GET_ALL_CAMPAIGN_LISTS';var START_ADD_CAMPAIGN_DETAILS_LIST='START_ADD_CAMPAIGN_DETAILS_LIST';var ADD_CAMPAIGN_DETAILS_LIST='ADD_CAMPAIGN_DETAILS_LIST';var START_APPROVE_CAMPAIGN_DETAILS_LIST='START_APPROVE_CAMPAIGN_DETAILS_LIST';var APPROVE_CAMPAIGN_DETAILS_LIST='APPROVE_CAMPAIGN_DETAILS_LIST';var START_RESEND_CAMPAIGN_DETAILS_LIST='START_RESEND_CAMPAIGN_DETAILS_LIST';var RESEND_CAMPAIGN_DETAILS_LIST='RESEND_CAMPAIGN_DETAILS_LIST';var START_GET_CAMPAIGN_LIST_EXTERNAL_UPDATES='START_GET_CAMPAIGN_LIST_EXTERNAL_UPDATES';var GET_CAMPAIGN_LIST_EXTERNAL_UPDATES='GET_CAMPAIGN_LIST_EXTERNAL_UPDATES';var START_VERIFY_CAMPAIGN_LIST_EXTERNAL_UPDATES='START_VERIFY_CAMPAIGN_LIST_EXTERNAL_UPDATES';var VERIFY_CAMPAIGN_LIST_EXTERNAL_UPDATES='VERIFY_CAMPAIGN_LIST_EXTERNAL_UPDATES';var UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE='UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE';var START_GET_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS='START_GET_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS';var GET_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS='GET_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS';var START_UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD='START_UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD';var UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD='UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD';var START_REMOVE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD='START_REMOVE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD';var REMOVE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD='REMOVE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD';var TOGGLE_SELECT_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD='TOGGLE_SELECT_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD';var CLEAR_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_SELECTION='CLEAR_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_SELECTION';var CLEAR_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS='CLEAR_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS';var START_ADD_CAMPAIGN_DETAILS_INDIVIDUAL='START_ADD_CAMPAIGN_DETAILS_INDIVIDUAL';var ADD_CAMPAIGN_DETAILS_INDIVIDUAL='ADD_CAMPAIGN_DETAILS_INDIVIDUAL';//Campaign Lists:
var UPDATE_CAMPAIGN_LISTS_FILTERS='UPDATE_CAMPAIGN_LISTS_FILTERS';var START_CREATE_CAMPAIGN_LIST='START_CREATE_CAMPAIGN_LIST';var CREATE_CAMPAIGN_LIST='CREATE_CAMPAIGN_LIST';var UPDATE_CAMPAIGN_LISTS_SEARCH='UPDATE_CAMPAIGN_LISTS_SEARCH';var START_GET_CAMPAIGN_LISTS='START_GET_CAMPAIGN_LISTS';var GET_CAMPAIGN_LISTS='GET_CAMPAIGN_LISTS';var UPDATE_CAMPAIGN_LISTS_TABLE='UPDATE_CAMPAIGN_LISTS_TABLE';var START_GET_CAMPAIGN_LISTS_TABLE_RECORDS='START_CREATE_CAMPAIGN_LIST_TABLE_RECORDS';var GET_CAMPAIGN_LISTS_TABLE_RECORDS='GET_CAMPAIGN_LISTS_TABLE_RECORDS';//Campaign List Details:
var START_GET_CAMPAIGN_LIST_DETAILS='START_GET_CAMPAIGN_LIST_DETAILS';var GET_CAMPAIGN_LIST_DETAILS='GET_CAMPAIGN_LIST_DETAILS';var CLEAR_CAMPAIGN_LIST_DETAILS='CLEAR_CAMPAIGN_LIST_DETAILS';var START_UPDATE_CAMPAIGN_LIST_DETAILS='START_UPDATE_CAMPAIGN_LIST_DETAILS';var UPDATE_CAMPAIGN_LIST_DETAILS='UPDATE_CAMPAIGN_LIST_DETAILS';var START_ADD_CAMPAIGN_LIST_PARTICIPANT='START_ADD_CAMPAIGN_LIST_PARTICIPANT';var ADD_CAMPAIGN_LIST_PARTICIPANT='ADD_CAMPAIGN_LIST_PARTICIPANT';var START_GET_CAMPAIGN_LIST_ALL_PARTICIPANTS='START_GET_CAMPAIGN_LIST_ALL_PARTICIPANTS';var GET_CAMPAIGN_LIST_ALL_PARTICIPANTS='GET_CAMPAIGN_LIST_ALL_PARTICIPANTS';var UPDATE_CAMPAIGN_LIST_PARTICIPANTS_TABLE='UPDATE_CAMPAIGN_LIST_PARTICIPANTS_TABLE';var START_GET_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS='START_GET_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS';var GET_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS='GET_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS';var START_REMOVE_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORD='START_REMOVE_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORD';var REMOVE_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORD='REMOVE_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORD';var CLEAR_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS='CLEAR_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS';var START_GET_CAMPAIGN_LIST_PENDING_PARTICIPANTS='START_GET_CAMPAIGN_LIST_PENDING_PARTICIPANTS';var GET_CAMPAIGN_LIST_PENDING_PARTICIPANTS='GET_CAMPAIGN_LIST_PENDING_PARTICIPANTS';//Campaign List Applications:
var UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE='UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE';var START_GET_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS='START_GET_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS';var GET_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS='GET_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS';var START_UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORD='START_UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORD';var UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORD='UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORD';var CLEAR_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS='CLEAR_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS';var UPDATE_CAMPAIGN_LISTS_APPLICATIONS_STATUS='UPDATE_CAMPAIGN_LIST_APPLICATIONS_STATUS';var CLEAR_CAMPAIGN_LISTS_APPLICATIONS_STATUS='CLEAR_CAMPAIGN_LIST_APPLICATIONS_STATUS';//Receiving Participants (verify)
var UPDATE_RECEIVING_PARTICIPANTS_INFINITELIST_CONFIGS='UPDATE_RECEIVING_PARTICIPANTS_CONFIGS';var START_GET_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS='START_GET_RECEIVING_PARTICIPANTS_RECORDS';var GET_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS='GET_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS';var CLEAR_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS='CLEAR_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS';//EXTERNAL CAMPAIGN LISTS
var START_GET_EXTERNAL_CAMPAIGN_LIST_DETAILS='START_GET_EXTERNAL_CAMPAIGN_LIST_DETAILS';var GET_EXTERNAL_CAMPAIGN_LIST_DETAILS='GET_EXTERNAL_CAMPAIGN_LIST_DETAILS';var START_GET_EXTERNAL_CAMPAIGN_LIST_RECIPIENTS='START_GET_EXTERNAL_CAMPAIGN_LIST_RECIPIENTS';var GET_EXTERNAL_CAMPAIGN_LIST_RECIPIENTS='GET_EXTERNAL_CAMPAIGN_LIST_RECIPIENTS';var UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_CONFIGS='UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_CONFIGS';var START_GET_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_RECORDS='START_GET_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_RECORDS';var GET_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_RECORDS='GET_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_RECORDS';var UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_DATA='UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_DATA';var START_UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS='START_UDPATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS';var UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS='UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS';var START_SELECT_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS='START_SELECT_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS';var SELECT_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS='SELECT_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS';var START_EXPORT_EXTERNAL_CAMPAIGN_LIST='START_EXPORT_EXTERNAL_CAMPAIGN_LIST';var EXPORT_EXTERNAL_CAMPAIGN_LIST='EXPORT_EXTERNAL_CAMPAIGN_LIST';var START_SUBMIT_EXTERNAL_CAMPAIGN_LIST='START_SUBMIT_EXTERNAL_CAMPAIGN_LIST';var SUBMIT_EXTERNAL_CAMPAIGN_LIST='SUBMIT_EXTERNAL_CAMPAIGN_LIST';//SYSTEM SETTINGS (editing)
var START_ADD_TAG='START_ADD_TAG';var ADD_TAG='ADD_TAG';var START_UPDATE_TAG='START_UPDATE_TAG';var UPDATE_TAG='UPDATE_TAG';var START_DELETE_TAG="START_DELETE_TAG";var DELETE_TAG="DELETE_TAG";var START_UPDATE_SETTING="START_UPDATE_SETTING";var UPDATE_SETTING="UPDATE_SETTING";var START_ADD_SIGNATURE='START_ADD_SIGNATURE';var ADD_SIGNATURE='ADD_SIGNATURE';//FUNDS - ACCOUNTING
var START_GET_FUNDS='START_GET_FUNDS';var GET_FUNDS='GET_FUNDS';var START_GET_FUNDS_VERBOSE='START_GET_FUNDS_VERBOSE';var GET_FUNDS_VERBOSE='GET_FUNDS_VERBOSE';var START_CREATE_FUND='START_CREATE_FUND';var CREATE_FUND='CREATE_FUND';var START_GET_FUND_DETAILS='START_GET_FUND_DETAILS';var GET_FUND_DETAILS='GET_FUND_DETAILS';var START_UPDATE_FUND='START_UPDATE_FUND';var UPDATE_FUND='UPDATE_FUND';var UPDATE_ACCOUNTING_FILTERS='UPDATE_ACCOUNTING_FILTERS';var UPDATE_ACCOUNTING_TRANSACTIONS_TABLE='UPDATE_ACCOUNTING_TRANSACTIONS_TABLE';var START_GET_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS='START_GET_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS';var GET_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS='GET_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS';var CLEAR_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS='CLEAR_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS';var UPDATE_ACCOUNTING_OUTSIDE_TRANSACTION_FILTERS='UPDATE_ACCOUNTING_OUTSIDE_TRANSACTION_FILTERS';var UPDATE_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE='UPDATE_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE';var START_GET_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE_RECORDS='START_GET_ACCOUNTING__OUTSIDE_TRANSACTIONS_TABLE_RECORDS';var GET_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE_RECORDS='GET_ACCOUNTING_TRANSACTIONS_OUTSIDE_TABLE_RECORDS';var CLEAR_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE_RECORDS='CLEAR_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE_RECORDS';var START_CREATE_OUTSIDE_TRANSACTION='START_CREATE_OUTSIDE_TRANSACTION';var CREATE_OUTSIDE_TRANSACTION='CREATE_OUTSIDE_TRANSACTION';var START_UPDATE_TRANSACTION='START_UPDATE_TRANSACTION';var UPDATE_TRANSACTION='UPDATE_TRANSACTION';var START_VOIDING_TRANSACTION='START_VOIDING_TRANSACTION';var VOID_TRANSACTIONS='VOID_TRANSACTIONS';var START_GET_BANK_RECONCILIATIONS='START_GET_BANK_RECONCILIATIONS';var GET_BANK_RECONCILIATIONS='GET_BANK_RECONCILIATIONS';var START_DELETE_RECONCILIATION_REPORT='START_DELETE_RECONCILIATION_REPORT';var DELETE_RECONCILIATION_REPORT='DELETE_RECONCILIATION_REPORT';var UPDATE_RECONCILIATION_REPORTS_FILTERS='UPDATE_RECONCILIATION_REPORTS_FILTERS';var UPDATE_RECONCILIATION_PAYMENTS_INFINITELIST_CONFIGS='UPDATE_RECONCILIATION_PAYMENTS_INFINITELIST_CONFIGS';var START_GET_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS='START_GET_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS';var GET_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS='GET_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS';var TOGGLE_SELECT_RECONCILIATION_PAYMENTS_INFINITELIST_RECORD='TOGGLE_SELECT_RECONCILIATION_PAYMENTS_INFINITELIST_RECORD';var CLEAR_RECONCILIATION_PAYMENTS_INFINITELIST_SELECTION='CLEAR_RECONCILIATION_PAYMENTS_INFINITELIST_SELECTION';var CLEAR_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS='CLEAR_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS';var UPDATE_RECONCILIATION_CREDITS_INFINITELIST_CONFIGS='UPDATE_RECONCILIATION_CREDITS_INFINITELIST_CONFIGS';var START_GET_RECONCILIATION_CREDITS_INFINITELIST_RECORDS='START_GET_RECONCILIATION_CREDITS_INFINITELIST_RECORDS';var GET_RECONCILIATION_CREDITS_INFINITELIST_RECORDS='GET_RECONCILIATION_CREDITS_INFINITELIST_RECORDS';var TOGGLE_SELECT_RECONCILIATION_CREDITS_INFINITELIST_RECORD='TOGGLE_SELECT_RECONCILIATION_CREDITS_INFINITELIST_RECORD';var CLEAR_RECONCILIATION_CREDITS_INFINITELIST_SELECTION='CLEAR_RECONCILIATION_CREDITS_INFINITELIST_SELECTION';var CLEAR_RECONCILIATION_CREDITS_INFINITELIST_RECORDS='CLEAR_RECONCILIATION_CREDITS_INFINITELIST_RECORDS';var UPDATE_RECONCILIATION_ADJUSTMENTS='UPDATE_RECONCILIATION_ADJUSTMENTS';var UPDATE_RECONCILIATION_BALANCE='UPDATE_RECONCILIATION_BALANCE';var START_GET_RECONCILIATION_REPORT='START_GET_RECONCILIATION_REPORT';var GET_RECONCILIATION_REPORT='GET_RECONCILIATION_REPORT';var START_CREATE_RECONCILIATION_REPORT='START_CREATE_RECONCILIATION_REPORT';var CREATE_RECONCILIATION_REPORT='CREATE_RECONCILIATION_REPORT';var START_CREATE_AND_COMPLETE_RECONCILIATION_REPORT='START_CREATE_AND_COMPLETE_RECONCILIATION_REPORT';var CREATE_AND_COMPLETE_RECONCILIATION_REPORT='CREATE_AND_COMPLETE_RECONCILIATION_REPORT';var START_UPDATE_RECONCILIATION_REPORT='START_UPDATE_RECONCILIATION_REPORT';var UPDATE_RECONCILIATION_REPORT='UPDATE_RECONCILIATION_REPORT';var START_COMPLETE_RECONCILIATION_REPORT='START_COMPLETE_RECONCILIATION_REPORT';var COMPLETE_RECONCILIATION_REPORT='COMPLETE_RECONCILIATION_REPORT';var START_GET_BLANK_CHECKS='START_GET_BLANK_CHECKS';var GET_BLANK_CHECKS='GET_BLANK_CHECKS';var CLEAR_BLANK_CHECKS='CLEAR_BLANK_CHECKS';//LANGUAGE SETTINGS
var UPDATE_GEOSUGGEST_SETTINGS='UPDATE_GEOSUGGEST_SETTINGS';

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ValidatedInput=function(_React$Component){_inherits(ValidatedInput,_React$Component);function ValidatedInput(props){_classCallCheck(this,ValidatedInput);var _this=_possibleConstructorReturn(this,(ValidatedInput.__proto__||Object.getPrototypeOf(ValidatedInput)).call(this,props));_this.state={requiredError:!_this.hasValue(_this.props.value),validationError:_this.props.validate?!_this.props.validate(_this.props.value):false};_this.onChange=_this.onChange.bind(_this);_this.checkRequire=_this.checkRequire.bind(_this);_this.validate=_this.validate.bind(_this);return _this;}_createClass(ValidatedInput,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.value!==this.props.value){this.checkRequire(nextProps.value);if(!nextProps.value||this.state.validationError){this.validate(nextProps.value);}}}},{key:'onChange',value:function onChange(event){if(this.props.onChange)this.props.onChange(event.target.name,event.target.value);}},{key:'checkRequire',value:function checkRequire(value){if(this.props.required){this.setState({requiredError:!this.hasValue(value)});}}},{key:'hasValue',value:function hasValue(value){var hasVal=value;if((value==='0'||value===0)&&!this.props.zeroAsValue){hasVal=false;}else if(value instanceof Array){hasVal=value.length;}else if(value instanceof Object){hasVal=Object.keys(value).length;}return!!hasVal;}},{key:'validate',value:function validate(value){if(this.props.validated&&this.props.validate){this.setState({validationError:!this.props.validate(value)});}}},{key:'render',value:function render(){var _this2=this;var requiredErr=this.props.required&&this.props.showRequiredError&&this.state.requiredError;var validationErr=this.props.showValidationError&&this.state.validationError;var input=__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.input,{name:this.props.name,value:this.props.value,className:(this.props.input.props.className||"")+' '+(validationErr||requiredErr?" error-input":""),onChange:this.onChange,onBlur:function onBlur(e){return _this2.validate(e.target.value);},onKeyDown:function onKeyDown(e){if(e.key==='Enter')_this2.validate(e.target.value);if(_this2.props.onKeyDown)_this2.props.onKeyDown(e);if(_this2.props.input.props.onKeyDown)_this2.props.input.props.onKeyDown(e);}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.label&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label '+(validationErr||requiredErr?"error-label":"")},this.props.label),input,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__FadeOutErrorMessage__["a" /* default */],{show:validationErr,message:this.props.errorMessage||'Invalid entry'}));}}]);return ValidatedInput;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ValidatedInput);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PhoneNumberFormats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PhoneNumberTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return TableViews; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return TableNames; });
/* unused harmony export TagTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return TagNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SettingNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PartialSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IncompleteTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LanguageTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return TransactionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MonthNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PayeeTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SourceTypes; });
var PhoneNumberFormats={american:{format:'(###) ###-####',length:10},israeliHouse:{format:'(##) ###-####',length:9},israeliCell:{format:'(###) ###-####',length:10}};var PhoneNumberTypes={American:"US",Israeli:"IL",Other:"Other"};var TableViews={Standard:'standard',Detailed:'detailed'};var TableNames={Applications:'APPLICATIONS',Recipients:'RECIPIENTS',References:'REFERENCES',DuplicateRecipients:'DUPLICATE_RECIPIENTS',Campaigns:'CAMPAIGNS',CampaignLists:'CAMPAIGN_LISTS',CampaignListParticipants:'CAMPAIGN_LIST_PARTICIPANTS',CampaignListApplications:'CAMPAIGN_LIST_APPLICATIONS',CampaignDetailsLists:'CAMPAIGN_DETAILS_LISTS',CampaignDetailsIndividuals:'CAMPAIGN_DETAILS_INDIVIDUALS',ExternalCampaignListParticipants:'EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS',Users:'USERS',AccountingTransactions:'ACCOUNTING_TRANSACTIONS',AccountingOutsideTransactions:'ACCOUNTING_OUTSIDE_TRANSACTIONS',ReconciliationPayments:'RECONCILIATION_PAYMENTS',ReconciliationCredits:'RECONCILIATION_CREDITS',ReceivingParticipants:'RECEIVING_PARTICIPANTS'};var TagTypes={Campaigns:'Campaigns',Funds:'Funds',Approvers:'Approvers',Organizations:'Organizations'};var TagNames={IndividualTags:'individualTags',OrganizationTags:'organizationTags',IndividualApplicationReasons:'individualApplicationReasons',OrganizationApplicationReasons:'organizationApplicationReasons',Banks:'banks',CardTypes:'cardTypes',CampaignCategories:'campaignCategories',CampaignIndivCategories:'campaignIndivCategories',LocationGroups:'campaignLocationGroups',WithdrawalTypes:'withdrawalTypes',DepositSources:'depositSources',USPersonTitles:'usPersonTitles',IsraelPersonTitles:'israelPersonTitles',USInstitutionTitles:'usInstitutionTitles',IsraelInstitutionTitles:'israelInstitutionTitles'};var SettingNames={CurrencyConversionRate:'currencyConversionRate',FromEmailAddress:'fromEmailAddress',ReturnAddress:'returnAddress',DefaultUSFund:'defaultUSFund',DefaultILFund:'defaultIsraelFund',Signatures:'signatures',AuthorizeCloudPrint:'cloudPrint'};var PartialSettings={AllSettings:'allSettings',PaymentSettings:'paymentSettings',RecipientSettings:'recipientSettings',ApplicationSettings:'applicationSettings',CampaignSettings:'campaignSettings',FundSettings:'fundSettings',PrintSettings:'printSettings',OtherSettings:'otherSettings'};var IncompleteTypes={Recipient:'Recipient',Application:'Application'};var LanguageTypes={Hebrew:'iw',English:''};var TransactionTypes={Withdrawal:'Withdrawal',Deposit:'Deposit'};var MonthNames=["January","February","March","April","May","June","July","August","September","October","November","December"];var PayeeTypes={Recipient:'Recipient',ThirdParty:'ThirdParty',TrustedPayee:'TrustedPayee'};var SourceTypes={New:'new',Reference:'reference'};

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(249);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(133);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LoadingSpinner__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Select=function(_React$Component){_inherits(Select,_React$Component);function Select(props){_classCallCheck(this,Select);var _this=_possibleConstructorReturn(this,(Select.__proto__||Object.getPrototypeOf(Select)).call(this,props));_this.clear=_this.clear.bind(_this);return _this;}_createClass(Select,[{key:'clear',value:function clear(){this.props.onChange({target:{name:this.props.name,value:''}});}},{key:'getValue',value:function getValue(){var allowZero=this.props.allowZero;if(allowZero&&this.props.value===0)return"0";return this.props.value||'';}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{tabIndex:this.props.tabIndex||'',className:this.props.className,name:this.props.name,value:this.getValue(),onChange:this.props.onChange,disabled:this.props.disabled},(this.props.placeholder||this.props.options&&this.props.options.length>0)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{hidden:true,defaultValue:true},this.props.placeholder||"Select"),this.props.options&&this.props.options.map(function(option){return option.optionGroup?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('optgroup',{key:option.label,label:option.label}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:option.key,value:option.key,title:option.details},option.value);})),this.props.clearable&&!!this.props.value&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-ios-close-outline clear-select input',onClick:this.clear}),this.props.loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__LoadingSpinner__["a" /* default */],{height:'12'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-ios-arrow-down'}));}}]);return Select;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(224);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(228);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(117);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(230);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(232);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(235);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(236);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(119);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(240);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(241);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(242);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(243);
/* unused harmony reexport withRouter */



























/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return postRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return putRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return patchRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var ResponseStatusCodes={Unauthorized:401,Forbidden:403};var BASE_URL='/api';function CheckAuthenticationAndAuthorizationErrors(responseStatus,requestUrl){if(responseStatus===ResponseStatusCodes.Unauthorized&&window.location.pathname!=="/login"&&requestUrl!=="/account/myprofile"){window.location.replace("/login");}else if(responseStatus===Response.Forbidden){__WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__["toastr"].error("You do not have permission to perform this action.");}}function getRequestHeaders(headers){return Object.assign({RequestVerificationToken:localStorage.getItem('RequestVerificationToken'),'Content-Type':'application/json'},headers);}var getRequest=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(requestUrl){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var dataType=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var options=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};var result,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:result={success:true,data:dataType,loading:false};_context.prev=1;_context.next=4;return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(''+BASE_URL+requestUrl,Object.assign({params:params,paramsSerializer:function paramsSerializer(params){return __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.stringify(params,{arrayFormat:'repeat'});}},options));case 4:response=_context.sent;result.status=response.status;if(response.status===204){result.success=false;result.noData=true;}else{result.data=response.data!==null&&response.data!==undefined?response.data:dataType;}_context.next=13;break;case 9:_context.prev=9;_context.t0=_context['catch'](1);result.success=false;if(_context.t0.response){if(_context.t0.response.data&&_context.t0.response.data.message)result.message=_context.t0.response.data.message;CheckAuthenticationAndAuthorizationErrors(_context.t0.response.status,requestUrl);}case 13:return _context.abrupt('return',result);case 14:case'end':return _context.stop();}}},_callee,this,[[1,9]]);}));return function getRequest(_x4){return _ref.apply(this,arguments);};}();var postRequest=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(requestUrl){var body=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var headers=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var dataType=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};var result,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:result={success:true,data:dataType,loading:false};_context2.prev=1;_context2.next=4;return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(''+BASE_URL+requestUrl,body,{headers:getRequestHeaders(headers)});case 4:response=_context2.sent;result.data=response.data;_context2.next=12;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](1);result.success=false;if(_context2.t0.response){if(_context2.t0.response.data&&_context2.t0.response.data.message){result.message=_context2.t0.response.data.message;result.data=_context2.t0.response.data.data||{};}CheckAuthenticationAndAuthorizationErrors(_context2.t0.response.status,requestUrl);}case 12:return _context2.abrupt('return',result);case 13:case'end':return _context2.stop();}}},_callee2,this,[[1,8]]);}));return function postRequest(_x8){return _ref2.apply(this,arguments);};}();var putRequest=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(requestUrl){var body=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var headers=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var dataType=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};var result,requestHeaders,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:result={success:true,data:dataType,loading:false};_context3.prev=1;// For FormData, don't set Content-Type header - let axios set it with boundary
requestHeaders=body instanceof FormData?Object.assign({},getRequestHeaders({}),headers):getRequestHeaders(headers);// Remove Content-Type if it's FormData so axios can set it with boundary
if(body instanceof FormData&&requestHeaders['Content-Type']){delete requestHeaders['Content-Type'];}_context3.next=6;return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(''+BASE_URL+requestUrl,body,{headers:requestHeaders});case 6:response=_context3.sent;result.data=response.data;_context3.next=14;break;case 10:_context3.prev=10;_context3.t0=_context3['catch'](1);result.success=false;if(_context3.t0.response){if(_context3.t0.response.data&&_context3.t0.response.data.message){result.message=_context3.t0.response.data.message;result.data=_context3.t0.response.data.data||{};}CheckAuthenticationAndAuthorizationErrors(_context3.t0.response.status,requestUrl);}case 14:return _context3.abrupt('return',result);case 15:case'end':return _context3.stop();}}},_callee3,this,[[1,10]]);}));return function putRequest(_x12){return _ref3.apply(this,arguments);};}();var patchRequest=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(requestUrl,update){var headers=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var dataType=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};var result,patchDoc,key,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:result={success:true,data:dataType,loading:false};_context4.prev=1;patchDoc=[];for(key in update){patchDoc.push({op:'replace',path:key,value:update[key]});}_context4.next=6;return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(''+BASE_URL+requestUrl,patchDoc,{headers:getRequestHeaders()});case 6:response=_context4.sent;result.data=response.data;_context4.next=14;break;case 10:_context4.prev=10;_context4.t0=_context4['catch'](1);result.success=false;if(_context4.t0.response){if(_context4.t0.response.data&&_context4.t0.response.data.message)result.message=_context4.t0.response.data.message;CheckAuthenticationAndAuthorizationErrors(_context4.t0.response.status,requestUrl);}case 14:return _context4.abrupt('return',result);case 15:case'end':return _context4.stop();}}},_callee4,this,[[1,10]]);}));return function patchRequest(_x15,_x16){return _ref4.apply(this,arguments);};}();var deleteRequest=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(requestUrl){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var dataType=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var result,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:result={success:true,loading:false,data:dataType};_context5.prev=1;_context5.next=4;return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(''+BASE_URL+requestUrl,{params:params,paramsSerializer:function paramsSerializer(params){return __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.stringify(params,{arrayFormat:'repeat'});},headers:getRequestHeaders()});case 4:response=_context5.sent;result.data=response.data!==null&&response.data!==undefined?response.data:dataType;_context5.next=12;break;case 8:_context5.prev=8;_context5.t0=_context5['catch'](1);result.success=false;if(_context5.t0.response){if(_context5.t0.response.data&&_context5.t0.response.data.message)result.message=_context5.t0.response.data.message;CheckAuthenticationAndAuthorizationErrors(_context5.t0.response.status,requestUrl);}case 12:return _context5.abrupt('return',result);case 13:case'end':return _context5.stop();}}},_callee5,this,[[1,8]]);}));return function deleteRequest(_x19){return _ref5.apply(this,arguments);};}();

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toastr = exports.reducer = exports.actions = undefined;

var _ReduxToastr = __webpack_require__(290);

var _ReduxToastr2 = _interopRequireDefault(_ReduxToastr);

var _actions = __webpack_require__(142);

var ReduxToastrActions = _interopRequireWildcard(_actions);

var _reducer = __webpack_require__(143);

var _reducer2 = _interopRequireDefault(_reducer);

var _toastrEmitter = __webpack_require__(144);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ReduxToastr2.default;
var actions = exports.actions = ReduxToastrActions;
var reducer = exports.reducer = _reducer2.default;
var toastr = exports.toastr = _toastrEmitter.toastrEmitter;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_number_format__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_number_format__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CurrencyFormatInput=function(_React$Component){_inherits(CurrencyFormatInput,_React$Component);function CurrencyFormatInput(){_classCallCheck(this,CurrencyFormatInput);return _possibleConstructorReturn(this,(CurrencyFormatInput.__proto__||Object.getPrototypeOf(CurrencyFormatInput)).apply(this,arguments));}_createClass(CurrencyFormatInput,[{key:"rejectValue",value:function rejectValue(values){var floatValue=values.floatValue,value=values.value;var _props=this.props,allowZero=_props.allowZero,max=_props.max,min=_props.min;if(value&&floatValue){if(max||min){return(!max||floatValue<=max)&&(!min||floatValue>=min);}}else if(floatValue===0&&(!allowZero||min>0)){return false;}return true;}},{key:"onChange",value:function onChange(e){var event=Object.assign({},e);event.target.value=event.target.value.replace(/[^0-9\.-]/g,"");this.props.onChange(event);}},{key:"render",value:function render(){var _props2=this.props,allowNegative=_props2.allowNegative,allowZero=_props2.allowZero,isIsraeli=_props2.isIsraeli,onChange=_props2.onChange,max=_props2.max,min=_props2.min,passProps=_objectWithoutProperties(_props2,["allowNegative","allowZero","isIsraeli","onChange","max","min"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dollar-input"},isIsraeli?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons shekel-icon"},"\u20AA"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons"},"attach_money"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_number_format___default.a,Object.assign({},passProps,{allowNegative:allowNegative||false,decimalScale:2,isAllowed:this.rejectValue.bind(this),onChange:this.onChange.bind(this),thousandSeparator:true})));}}]);return CurrencyFormatInput;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CurrencyFormatInput);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RadioGroup=function(_React$Component){_inherits(RadioGroup,_React$Component);function RadioGroup(props){_classCallCheck(this,RadioGroup);var _this=_possibleConstructorReturn(this,(RadioGroup.__proto__||Object.getPrototypeOf(RadioGroup)).call(this,props));_this.onChange=_this.onChange.bind(_this);return _this;}_createClass(RadioGroup,[{key:"onChange",value:function onChange(key){this.props.onChange(this.props.name,key);}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,!!this.props.title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"input-label"},this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"radio-container"},this.props.options.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:item.key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"radio",id:_this2.props.name+"-"+item.key,name:_this2.props.name,onChange:_this2.onChange.bind(_this2,item.key),checked:_this2.props.value===item.key,disabled:item.disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:_this2.props.name+"-"+item.key,className:(_this2.props.error||item.error?"error-label":"")+" "+(item.disabled?"disabled":"")},item.value,item.tag));})));}}]);return RadioGroup;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (RadioGroup);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConfirmationModal=function(_React$Component){_inherits(ConfirmationModal,_React$Component);function ConfirmationModal(props){_classCallCheck(this,ConfirmationModal);var _this=_possibleConstructorReturn(this,(ConfirmationModal.__proto__||Object.getPrototypeOf(ConfirmationModal)).call(this,props));_this.state={error:false};return _this;}_createClass(ConfirmationModal,[{key:'confirm',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var result,success;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.confirm();case 2:result=_context.sent;// Prefer the value returned by confirm() so the outcome doesn't depend on
// a parent setState having flushed to props by the time the await resolves.
// Fall back to props.success for callers that don't return a value.
success=result===undefined?this.props.success:result;if(success){if(this.props.closeOnConfirm!==false){this.props.close();}}else{this.setState({error:true});}case 5:case'end':return _context.stop();}}},_callee,this);}));function confirm(){return _ref.apply(this,arguments);}return confirm;}()},{key:'close',value:function close(){this.setState({error:false});this.props.close();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container',key:'warningModal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal confirmation-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons middle',style:{color:"#145214",marginRight:"8px"}},'check_circle_outline'),this.props.title||"Confirmation"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'bold-text'},this.props.message))),this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:'true'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'warning-modal-btns modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.close.bind(this)},'No'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent2',onClick:this.confirm.bind(this)},'Yes'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error,message:this.props.errorMessage})))));}}]);return ConfirmationModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ConfirmationModal);

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaginatedTable=function(_React$Component){_inherits(PaginatedTable,_React$Component);function PaginatedTable(){_classCallCheck(this,PaginatedTable);return _possibleConstructorReturn(this,(PaginatedTable.__proto__||Object.getPrototypeOf(PaginatedTable)).apply(this,arguments));}_createClass(PaginatedTable,[{key:'componentWillMount',value:function componentWillMount(){if(!this.props.noReload){var _props;var tableSettings=this.props.records.length?[this.props.page,this.props.resultsView,this.props.sort]:[];(_props=this.props).loadData.apply(_props,tableSettings);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!nextProps.success&&this.props.success){__WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error("Something went wrong",'We couldn\'t retrieve '+(this.props.name||"records")+'.  Please try again');}}},{key:'sortTable',value:function sortTable(column){var sort={by:column.id,direction:this.props.sort.by!==column.id?column.defaultDirection?column.defaultDirection:"Ascending":this.props.sort.direction==="Ascending"?"Descending":"Ascending"};this.props.sortData({sort:sort});this.props.loadData(1,this.props.resultsView,sort);}},{key:'changeResultsView',value:function changeResultsView(event){var pageUpdate=event.target.value<12?1:Math.floor(this.props.resultsView*this.props.page/event.target.value)||1;this.props.changeDataView({resultsView:event.target.value});this.props.loadData(pageUpdate,event.target.value,this.props.sort);}},{key:'paginate',value:function paginate(page){if(!this.props.loading){this.props.loadData(page,this.props.resultsView,this.props.sort);window.scrollTo({"behavior":"smooth","left":0,"top":0});}}},{key:'getHeader',value:function getHeader(){var _this2=this;return this.props.columns.filter(function(column){return!column.hidden;}).map(function(column){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:column.id,className:column.className||''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'relative'},column.component||__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sort flex-center '+(_this2.props.sort&&_this2.props.sort.by===column.id?"active":"")},column.icon?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons large-text'},column.icon):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'sort-arrows-label'},column.title),column.sortable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sort-arrows relative',onClick:_this2.sortTable.bind(_this2,column)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-android-arrow-dropup '+(_this2.props.sort.direction!=='Ascending'?"inactive":"")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-android-arrow-dropdown '+(_this2.props.sort.direction!=='Descending'?"inactive":"")})))));});}},{key:'getRows',value:function getRows(){var _this3=this;return this.props.records.map(function(item){return _this3.props.renderRow(item);});}},{key:'getPaginationFooter',value:function getPaginationFooter(){var _this4=this;var numberOfPages=Math.ceil((this.props.totalCount||0)/this.props.resultsView);if(numberOfPages<2){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pagination'});}var pagesArray=Array(numberOfPages).fill().map(function(_,i){return i+1;});if(this.props.page>6&&numberOfPages>10){var startPg=this.props.page-6;if(numberOfPages-startPg<10)startPg=numberOfPages-10;pagesArray=pagesArray.slice(startPg,pagesArray.length);}if(pagesArray.length>10)pagesArray=pagesArray.slice(0,10);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pagination '+(this.props.loading?"disabled":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'prev',className:this.props.page>1?"fade-in":"fade-out",onClick:this.paginate.bind(this,this.props.page-1)},'Prev'),pagesArray.map(function(pg){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:pg,className:_this4.props.page.toString()===pg.toString()?"active":"",onClick:_this4.paginate.bind(_this4,pg)},pg);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'next',className:this.props.page<pagesArray[pagesArray.length-1]?"fade-in":"fade-out",onClick:this.paginate.bind(this,this.props.page+1)},'Next'));}},{key:'getResultsView',value:function getResultsView(){return this.props.totalCount>12&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.props.resultsView,onChange:this.changeResultsView.bind(this)},Array(4).fill().map(function(_,i){return++i*12;}).map(function(resultSize){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:resultSize,value:resultSize},'Show ',resultSize,' Results');}),'}',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:90},'Show 90 Results'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:250},'Show 250 Results'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:this.props.totalCount||0},'Show All Results')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'arrow_drop_down'));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},!this.props.loading&&!this.props.records.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'empty-state'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'not_interested'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'No ',this.props.name?Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["C" /* toTitleCase */])(this.props.name):'Records',' Found')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-container'},this.props.loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row table-loader-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-view__loader loader-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-6'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-7'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-8'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-9'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-10'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-11'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'table-header table-row'},this.getHeader())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.getRows()))),this.props.records.length>0&&!(this.props.hasOwnProperty('showFooter')&&!this.props.showFooter)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-footer'},this.getPaginationFooter(),this.getResultsView())));}}]);return PaginatedTable;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PaginatedTable);

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HoverTableRow=function(_React$Component){_inherits(HoverTableRow,_React$Component);function HoverTableRow(){_classCallCheck(this,HoverTableRow);return _possibleConstructorReturn(this,(HoverTableRow.__proto__||Object.getPrototypeOf(HoverTableRow)).apply(this,arguments));}_createClass(HoverTableRow,[{key:'setHover',value:function setHover(event){var row=event.target.closest("tr");if(!row)return;// event originated in a portal (e.g. hover card), not inside the row
var showHover=typeof event.target.className==='string'&&event.target.className.indexOf("input")<0;if(showHover&&row.className.indexOf("hover")<0){row.classList.add(this.props.disabled?"disabled-hover":"hover");}else if(!showHover){row.classList.remove("hover");}}},{key:'removeHover',value:function removeHover(event){var row=event.target.closest("tr");if(!row)return;row.classList.remove(this.props.disabled?"disabled-hover":"hover");}},{key:'onClick',value:function onClick(event){if(this.props.onClick&&event.target.className.indexOf("input")<0){this.props.onClick();}}},{key:'onDoubleClick',value:function onDoubleClick(event){if(this.props.onDoubleClick&&event.target.className.indexOf("input")<0){this.props.onDoubleClick();}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',Object.assign({className:'table-row'},this.props,{onClick:this.onClick.bind(this),onDoubleClick:this.onDoubleClick.bind(this),onMouseOver:this.setHover.bind(this),onMouseLeave:this.removeHover.bind(this)}),this.props.children);}}]);return HoverTableRow;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (HoverTableRow);

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(137);
var isBuffer = __webpack_require__(272);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _utils = __webpack_require__(443);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var propTypes = {
  thousandSeparator: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.oneOf([true])]),
  decimalSeparator: _propTypes.default.string,
  thousandsGroupStyle: _propTypes.default.oneOf(['thousand', 'lakh', 'wan']),
  decimalScale: _propTypes.default.number,
  fixedDecimalScale: _propTypes.default.bool,
  displayType: _propTypes.default.oneOf(['input', 'text']),
  prefix: _propTypes.default.string,
  suffix: _propTypes.default.string,
  format: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  removeFormatting: _propTypes.default.func,
  mask: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  isNumericString: _propTypes.default.bool,
  customInput: _propTypes.default.func,
  allowNegative: _propTypes.default.bool,
  allowEmptyFormatting: _propTypes.default.bool,
  onValueChange: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  onMouseUp: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  type: _propTypes.default.oneOf(['text', 'tel', 'password']),
  isAllowed: _propTypes.default.func,
  renderText: _propTypes.default.func,
  getInputRef: _propTypes.default.func
};
var defaultProps = {
  displayType: 'input',
  decimalSeparator: '.',
  thousandsGroupStyle: 'thousand',
  fixedDecimalScale: false,
  prefix: '',
  suffix: '',
  allowNegative: true,
  allowEmptyFormatting: false,
  isNumericString: false,
  type: 'text',
  onValueChange: _utils.noop,
  onChange: _utils.noop,
  onKeyDown: _utils.noop,
  onMouseUp: _utils.noop,
  onFocus: _utils.noop,
  onBlur: _utils.noop,
  isAllowed: _utils.returnTrue,
  getInputRef: _utils.noop
};

var NumberFormat =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NumberFormat, _React$Component);

  function NumberFormat(props) {
    var _this;

    _classCallCheck(this, NumberFormat);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NumberFormat).call(this, props));
    var defaultValue = props.defaultValue; //validate props

    _this.validateProps();

    var formattedValue = _this.formatValueProp(defaultValue);

    _this.state = {
      value: formattedValue,
      numAsString: _this.removeFormatting(formattedValue)
    };
    _this.selectionBeforeInput = {
      selectionStart: 0,
      selectionEnd: 0
    };
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onMouseUp = _this.onMouseUp.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(NumberFormat, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.updateValueIfRequired(prevProps);
    }
  }, {
    key: "updateValueIfRequired",
    value: function updateValueIfRequired(prevProps) {
      var props = this.props,
          state = this.state,
          focusedElm = this.focusedElm;
      var stateValue = state.value,
          _state$numAsString = state.numAsString,
          lastNumStr = _state$numAsString === void 0 ? '' : _state$numAsString;

      if (prevProps !== props) {
        //validate props
        this.validateProps();
        var lastValueWithNewFormat = this.formatNumString(lastNumStr);
        var formattedValue = props.value === undefined ? lastValueWithNewFormat : this.formatValueProp();
        var numAsString = this.removeFormatting(formattedValue);
        var floatValue = parseFloat(numAsString);
        var lastFloatValue = parseFloat(lastNumStr);

        if ( //while typing set state only when float value changes
        (!isNaN(floatValue) || !isNaN(lastFloatValue)) && floatValue !== lastFloatValue || //can also set state when float value is same and the format props changes
        lastValueWithNewFormat !== stateValue || //set state always when not in focus and formatted value is changed
        focusedElm === null && formattedValue !== stateValue) {
          this.updateValue({
            formattedValue: formattedValue,
            numAsString: numAsString,
            input: focusedElm
          });
        }
      }
    }
    /** Misc methods **/

  }, {
    key: "getFloatString",
    value: function getFloatString() {
      var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var decimalScale = this.props.decimalScale;

      var _this$getSeparators = this.getSeparators(),
          decimalSeparator = _this$getSeparators.decimalSeparator;

      var numRegex = this.getNumberRegex(true); //remove negation for regex check

      var hasNegation = num[0] === '-';
      if (hasNegation) num = num.replace('-', ''); //if decimal scale is zero remove decimal and number after decimalSeparator

      if (decimalSeparator && decimalScale === 0) {
        num = num.split(decimalSeparator)[0];
      }

      num = (num.match(numRegex) || []).join('').replace(decimalSeparator, '.'); //remove extra decimals

      var firstDecimalIndex = num.indexOf('.');

      if (firstDecimalIndex !== -1) {
        num = "".concat(num.substring(0, firstDecimalIndex), ".").concat(num.substring(firstDecimalIndex + 1, num.length).replace(new RegExp((0, _utils.escapeRegExp)(decimalSeparator), 'g'), ''));
      } //add negation back


      if (hasNegation) num = '-' + num;
      return num;
    } //returned regex assumes decimalSeparator is as per prop

  }, {
    key: "getNumberRegex",
    value: function getNumberRegex(g, ignoreDecimalSeparator) {
      var _this$props = this.props,
          format = _this$props.format,
          decimalScale = _this$props.decimalScale;

      var _this$getSeparators2 = this.getSeparators(),
          decimalSeparator = _this$getSeparators2.decimalSeparator;

      return new RegExp('\\d' + (decimalSeparator && decimalScale !== 0 && !ignoreDecimalSeparator && !format ? '|' + (0, _utils.escapeRegExp)(decimalSeparator) : ''), g ? 'g' : undefined);
    }
  }, {
    key: "getSeparators",
    value: function getSeparators() {
      var decimalSeparator = this.props.decimalSeparator;
      var thousandSeparator = this.props.thousandSeparator;

      if (thousandSeparator === true) {
        thousandSeparator = ',';
      }

      return {
        decimalSeparator: decimalSeparator,
        thousandSeparator: thousandSeparator
      };
    }
  }, {
    key: "getMaskAtIndex",
    value: function getMaskAtIndex(index) {
      var _this$props$mask = this.props.mask,
          mask = _this$props$mask === void 0 ? ' ' : _this$props$mask;

      if (typeof mask === 'string') {
        return mask;
      }

      return mask[index] || ' ';
    }
  }, {
    key: "getValueObject",
    value: function getValueObject(formattedValue, numAsString) {
      var floatValue = parseFloat(numAsString);
      return {
        formattedValue: formattedValue,
        value: numAsString,
        floatValue: isNaN(floatValue) ? undefined : floatValue
      };
    }
  }, {
    key: "validateProps",
    value: function validateProps() {
      var mask = this.props.mask; //validate decimalSeparator and thousandSeparator

      var _this$getSeparators3 = this.getSeparators(),
          decimalSeparator = _this$getSeparators3.decimalSeparator,
          thousandSeparator = _this$getSeparators3.thousandSeparator;

      if (decimalSeparator === thousandSeparator) {
        throw new Error("\n          Decimal separator can't be same as thousand separator.\n          thousandSeparator: ".concat(thousandSeparator, " (thousandSeparator = {true} is same as thousandSeparator = \",\")\n          decimalSeparator: ").concat(decimalSeparator, " (default value for decimalSeparator is .)\n       "));
      } //validate mask


      if (mask) {
        var maskAsStr = mask === 'string' ? mask : mask.toString();

        if (maskAsStr.match(/\d/g)) {
          throw new Error("\n          Mask ".concat(mask, " should not contain numeric character;\n        "));
        }
      }
    }
    /** Misc methods end **/

    /** caret specific methods **/

  }, {
    key: "setPatchedCaretPosition",
    value: function setPatchedCaretPosition(el, caretPos, currentValue) {
      /* setting caret position within timeout of 0ms is required for mobile chrome,
      otherwise browser resets the caret position after we set it
      We are also setting it without timeout so that in normal browser we don't see the flickering */
      (0, _utils.setCaretPosition)(el, caretPos);
      setTimeout(function () {
        if (el.value === currentValue) (0, _utils.setCaretPosition)(el, caretPos);
      }, 0);
    }
    /* This keeps the caret within typing area so people can't type in between prefix or suffix */

  }, {
    key: "correctCaretPosition",
    value: function correctCaretPosition(value, caretPos, direction) {
      var _this$props2 = this.props,
          prefix = _this$props2.prefix,
          suffix = _this$props2.suffix,
          format = _this$props2.format; //if value is empty return 0

      if (value === '') return 0; //caret position should be between 0 and value length

      caretPos = (0, _utils.clamp)(caretPos, 0, value.length); //in case of format as number limit between prefix and suffix

      if (!format) {
        var hasNegation = value[0] === '-';
        return (0, _utils.clamp)(caretPos, prefix.length + (hasNegation ? 1 : 0), value.length - suffix.length);
      } //in case if custom format method don't do anything


      if (typeof format === 'function') return caretPos;
      /* in case format is string find the closest # position from the caret position */
      //in case the caretPos have input value on it don't do anything

      if (format[caretPos] === '#' && (0, _utils.charIsNumber)(value[caretPos])) return caretPos; //if caretPos is just after input value don't do anything

      if (format[caretPos - 1] === '#' && (0, _utils.charIsNumber)(value[caretPos - 1])) return caretPos; //find the nearest caret position

      var firstHashPosition = format.indexOf('#');
      var lastHashPosition = format.lastIndexOf('#'); //limit the cursor between the first # position and the last # position

      caretPos = (0, _utils.clamp)(caretPos, firstHashPosition, lastHashPosition + 1);
      var nextPos = format.substring(caretPos, format.length).indexOf('#');
      var caretLeftBound = caretPos;
      var caretRightBound = caretPos + (nextPos === -1 ? 0 : nextPos); //get the position where the last number is present

      while (caretLeftBound > firstHashPosition && (format[caretLeftBound] !== '#' || !(0, _utils.charIsNumber)(value[caretLeftBound]))) {
        caretLeftBound -= 1;
      }

      var goToLeft = !(0, _utils.charIsNumber)(value[caretRightBound]) || direction === 'left' && caretPos !== firstHashPosition || caretPos - caretLeftBound < caretRightBound - caretPos;

      if (goToLeft) {
        //check if number should be taken after the bound or after it
        //if number preceding a valid number keep it after
        return (0, _utils.charIsNumber)(value[caretLeftBound]) ? caretLeftBound + 1 : caretLeftBound;
      }

      return caretRightBound;
    }
  }, {
    key: "getCaretPosition",
    value: function getCaretPosition(inputValue, formattedValue, caretPos) {
      var format = this.props.format;
      var stateValue = this.state.value;
      var numRegex = this.getNumberRegex(true);
      var inputNumber = (inputValue.match(numRegex) || []).join('');
      var formattedNumber = (formattedValue.match(numRegex) || []).join('');
      var j, i;
      j = 0;

      for (i = 0; i < caretPos; i++) {
        var currentInputChar = inputValue[i] || '';
        var currentFormatChar = formattedValue[j] || ''; //no need to increase new cursor position if formatted value does not have those characters
        //case inputValue = 1a23 and formattedValue =  123

        if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) continue; //When we are striping out leading zeros maintain the new cursor position
        //Case inputValue = 00023 and formattedValue = 23;

        if (currentInputChar === '0' && currentFormatChar.match(numRegex) && currentFormatChar !== '0' && inputNumber.length !== formattedNumber.length) continue; //we are not using currentFormatChar because j can change here

        while (currentInputChar !== formattedValue[j] && j < formattedValue.length) {
          j++;
        }

        j++;
      }

      if (typeof format === 'string' && !stateValue) {
        //set it to the maximum value so it goes after the last number
        j = formattedValue.length;
      } //correct caret position if its outside of editable area


      j = this.correctCaretPosition(formattedValue, j);
      return j;
    }
    /** caret specific methods ends **/

    /** methods to remove formattting **/

  }, {
    key: "removePrefixAndSuffix",
    value: function removePrefixAndSuffix(val) {
      var _this$props3 = this.props,
          format = _this$props3.format,
          prefix = _this$props3.prefix,
          suffix = _this$props3.suffix; //remove prefix and suffix

      if (!format && val) {
        var isNegative = val[0] === '-'; //remove negation sign

        if (isNegative) val = val.substring(1, val.length); //remove prefix

        val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val; //remove suffix

        var suffixLastIndex = val.lastIndexOf(suffix);
        val = suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length ? val.substring(0, suffixLastIndex) : val; //add negation sign back

        if (isNegative) val = '-' + val;
      }

      return val;
    }
  }, {
    key: "removePatternFormatting",
    value: function removePatternFormatting(val) {
      var format = this.props.format;
      var formatArray = format.split('#').filter(function (str) {
        return str !== '';
      });
      var start = 0;
      var numStr = '';

      for (var i = 0, ln = formatArray.length; i <= ln; i++) {
        var part = formatArray[i] || ''; //if i is the last fragment take the index of end of the value
        //For case like +1 (911) 911 91 91 having pattern +1 (###) ### ## ##

        var index = i === ln ? val.length : val.indexOf(part, start);
        /* in any case if we don't find the pattern part in the value assume the val as numeric string
        This will be also in case if user has started typing, in any other case it will not be -1
        unless wrong prop value is provided */

        if (index === -1) {
          numStr = val;
          break;
        } else {
          numStr += val.substring(start, index);
          start = index + part.length;
        }
      }

      return (numStr.match(/\d/g) || []).join('');
    }
  }, {
    key: "removeFormatting",
    value: function removeFormatting(val) {
      var _this$props4 = this.props,
          format = _this$props4.format,
          removeFormatting = _this$props4.removeFormatting;
      if (!val) return val;

      if (!format) {
        val = this.removePrefixAndSuffix(val);
        val = this.getFloatString(val);
      } else if (typeof format === 'string') {
        val = this.removePatternFormatting(val);
      } else if (typeof removeFormatting === 'function') {
        //condition need to be handled if format method is provide,
        val = removeFormatting(val);
      } else {
        val = (val.match(/\d/g) || []).join('');
      }

      return val;
    }
    /** methods to remove formattting end **/

    /*** format specific methods start ***/

    /**
     * Format when # based string is provided
     * @param  {string} numStr Numeric String
     * @return {string}        formatted Value
     */

  }, {
    key: "formatWithPattern",
    value: function formatWithPattern(numStr) {
      var format = this.props.format;
      var hashCount = 0;
      var formattedNumberAry = format.split('');

      for (var i = 0, ln = format.length; i < ln; i++) {
        if (format[i] === '#') {
          formattedNumberAry[i] = numStr[hashCount] || this.getMaskAtIndex(hashCount);
          hashCount += 1;
        }
      }

      return formattedNumberAry.join('');
    }
    /**
     * @param  {string} numStr Numeric string/floatString] It always have decimalSeparator as .
     * @return {string} formatted Value
     */

  }, {
    key: "formatAsNumber",
    value: function formatAsNumber(numStr) {
      var _this$props5 = this.props,
          decimalScale = _this$props5.decimalScale,
          fixedDecimalScale = _this$props5.fixedDecimalScale,
          prefix = _this$props5.prefix,
          suffix = _this$props5.suffix,
          allowNegative = _this$props5.allowNegative,
          thousandsGroupStyle = _this$props5.thousandsGroupStyle;

      var _this$getSeparators4 = this.getSeparators(),
          thousandSeparator = _this$getSeparators4.thousandSeparator,
          decimalSeparator = _this$getSeparators4.decimalSeparator;

      var hasDecimalSeparator = numStr.indexOf('.') !== -1 || decimalScale && fixedDecimalScale;

      var _splitDecimal = (0, _utils.splitDecimal)(numStr, allowNegative),
          beforeDecimal = _splitDecimal.beforeDecimal,
          afterDecimal = _splitDecimal.afterDecimal,
          addNegation = _splitDecimal.addNegation; // eslint-disable-line prefer-const
      //apply decimal precision if its defined


      if (decimalScale !== undefined) afterDecimal = (0, _utils.limitToScale)(afterDecimal, decimalScale, fixedDecimalScale);

      if (thousandSeparator) {
        var thousandsGroupRegex = (0, _utils.getThousandsGroupRegex)(thousandsGroupStyle);
        beforeDecimal = beforeDecimal.replace(thousandsGroupRegex, '$1' + thousandSeparator);
      } //add prefix and suffix


      if (prefix) beforeDecimal = prefix + beforeDecimal;
      if (suffix) afterDecimal = afterDecimal + suffix; //restore negation sign

      if (addNegation) beforeDecimal = '-' + beforeDecimal;
      numStr = beforeDecimal + (hasDecimalSeparator && decimalSeparator || '') + afterDecimal;
      return numStr;
    }
  }, {
    key: "formatNumString",
    value: function formatNumString() {
      var numStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var _this$props6 = this.props,
          format = _this$props6.format,
          allowEmptyFormatting = _this$props6.allowEmptyFormatting;
      var formattedValue = numStr;

      if (numStr === '' && !allowEmptyFormatting) {
        formattedValue = '';
      } else if (numStr === '-' && !format) {
        formattedValue = '-';
      } else if (typeof format === 'string') {
        formattedValue = this.formatWithPattern(formattedValue);
      } else if (typeof format === 'function') {
        formattedValue = format(formattedValue);
      } else {
        formattedValue = this.formatAsNumber(formattedValue);
      }

      return formattedValue;
    }
  }, {
    key: "formatValueProp",
    value: function formatValueProp(defaultValue) {
      var _this$props7 = this.props,
          format = _this$props7.format,
          decimalScale = _this$props7.decimalScale,
          fixedDecimalScale = _this$props7.fixedDecimalScale,
          allowEmptyFormatting = _this$props7.allowEmptyFormatting;
      var _this$props8 = this.props,
          _this$props8$value = _this$props8.value,
          value = _this$props8$value === void 0 ? defaultValue : _this$props8$value,
          isNumericString = _this$props8.isNumericString;
      var isNonNumericFalsy = !value && value !== 0;

      if (isNonNumericFalsy && allowEmptyFormatting) {
        value = '';
      } // if value is not defined return empty string


      if (isNonNumericFalsy && !allowEmptyFormatting) return '';

      if (typeof value === 'number') {
        value = value.toString();
        isNumericString = true;
      } //change infinity value to empty string


      if (value === 'Infinity' && isNumericString) {
        value = '';
      } //round the number based on decimalScale
      //format only if non formatted value is provided


      if (isNumericString && !format && typeof decimalScale === 'number') {
        value = (0, _utils.roundToPrecision)(value, decimalScale, fixedDecimalScale);
      }

      var formattedValue = isNumericString ? this.formatNumString(value) : this.formatInput(value);
      return formattedValue;
    }
  }, {
    key: "formatNegation",
    value: function formatNegation() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var allowNegative = this.props.allowNegative;
      var negationRegex = new RegExp('(-)');
      var doubleNegationRegex = new RegExp('(-)(.)*(-)'); // Check number has '-' value

      var hasNegation = negationRegex.test(value); // Check number has 2 or more '-' values

      var removeNegation = doubleNegationRegex.test(value); //remove negation

      value = value.replace(/-/g, '');

      if (hasNegation && !removeNegation && allowNegative) {
        value = '-' + value;
      }

      return value;
    }
  }, {
    key: "formatInput",
    value: function formatInput() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var format = this.props.format; //format negation only if we are formatting as number

      if (!format) {
        value = this.removePrefixAndSuffix(value);
        value = this.formatNegation(value);
      } //remove formatting from number


      value = this.removeFormatting(value);
      return this.formatNumString(value);
    }
    /*** format specific methods end ***/

  }, {
    key: "isCharacterAFormat",
    value: function isCharacterAFormat(caretPos, value) {
      var _this$props9 = this.props,
          format = _this$props9.format,
          prefix = _this$props9.prefix,
          suffix = _this$props9.suffix,
          decimalScale = _this$props9.decimalScale,
          fixedDecimalScale = _this$props9.fixedDecimalScale;

      var _this$getSeparators5 = this.getSeparators(),
          decimalSeparator = _this$getSeparators5.decimalSeparator; //check within format pattern


      if (typeof format === 'string' && format[caretPos] !== '#') return true; //check in number format

      if (!format && (caretPos < prefix.length || caretPos >= value.length - suffix.length || decimalScale && fixedDecimalScale && value[caretPos] === decimalSeparator)) {
        return true;
      }

      return false;
    }
  }, {
    key: "checkIfFormatGotDeleted",
    value: function checkIfFormatGotDeleted(start, end, value) {
      for (var i = start; i < end; i++) {
        if (this.isCharacterAFormat(i, value)) return true;
      }

      return false;
    }
    /**
     * This will check if any formatting got removed by the delete or backspace and reset the value
     * It will also work as fallback if android chome keyDown handler does not work
     **/

  }, {
    key: "correctInputValue",
    value: function correctInputValue(caretPos, lastValue, value) {
      var _this$props10 = this.props,
          format = _this$props10.format,
          allowNegative = _this$props10.allowNegative,
          prefix = _this$props10.prefix,
          suffix = _this$props10.suffix;

      var _this$getSeparators6 = this.getSeparators(),
          decimalSeparator = _this$getSeparators6.decimalSeparator;

      var lastNumStr = this.state.numAsString || '';
      var _this$selectionBefore = this.selectionBeforeInput,
          selectionStart = _this$selectionBefore.selectionStart,
          selectionEnd = _this$selectionBefore.selectionEnd;

      var _findChangedIndex = (0, _utils.findChangedIndex)(lastValue, value),
          start = _findChangedIndex.start,
          end = _findChangedIndex.end;
      /** Check if only . is added in the numeric format and replace it with decimal separator */


      if (!format && decimalSeparator !== '.' && start === end && value[selectionStart] === '.') {
        return value.substr(0, selectionStart) + decimalSeparator + value.substr(selectionStart + 1, value.length);
      }
      /* don't do anyhting if something got added,
       or if value is empty string (when whole input is cleared)
       or whole input is replace with a number
      */


      var leftBound = !!format ? 0 : prefix.length;
      var rightBound = lastValue.length - (!!format ? 0 : suffix.length);

      if (value.length > lastValue.length || !value.length || start === end || selectionStart === 0 && selectionEnd === lastValue.length || selectionStart === leftBound && selectionEnd === rightBound) {
        return value;
      } //if format got deleted reset the value to last value


      if (this.checkIfFormatGotDeleted(start, end, lastValue)) {
        value = lastValue;
      } //for numbers check if beforeDecimal got deleted and there is nothing after decimal,
      //clear all numbers in such case while keeping the - sign


      if (!format) {
        var numericString = this.removeFormatting(value);

        var _splitDecimal2 = (0, _utils.splitDecimal)(numericString, allowNegative),
            beforeDecimal = _splitDecimal2.beforeDecimal,
            afterDecimal = _splitDecimal2.afterDecimal,
            addNegation = _splitDecimal2.addNegation; // eslint-disable-line prefer-const
        //clear only if something got deleted


        var isBeforeDecimalPoint = caretPos < value.indexOf(decimalSeparator) + 1;

        if (numericString.length < lastNumStr.length && isBeforeDecimalPoint && beforeDecimal === '' && !parseFloat(afterDecimal)) {
          return addNegation ? '-' : '';
        }
      }

      return value;
    }
    /** Update value and caret position */

  }, {
    key: "updateValue",
    value: function updateValue(params) {
      var _this2 = this;

      var onUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils.noop;
      var formattedValue = params.formattedValue,
          input = params.input;
      var numAsString = params.numAsString,
          caretPos = params.caretPos;
      var onValueChange = this.props.onValueChange;
      var lastValue = this.state.value; //set caret position, and value imperatively when element is provided

      if (input) {
        //calculate caret position if not defined
        if (!caretPos) {
          var inputValue = params.inputValue || input.value;
          var currentCaretPosition = (0, _utils.getCurrentCaretPosition)(input); //get the caret position

          caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition);
        } //set the value imperatively, this is required for IE fix


        input.value = formattedValue; //set caret position

        this.setPatchedCaretPosition(input, caretPos, formattedValue);
      } //calculate numeric string if not passed


      if (numAsString === undefined) {
        numAsString = this.removeFormatting(formattedValue);
      } //update state if value is changed


      if (formattedValue !== lastValue) {
        this.setState({
          value: formattedValue,
          numAsString: numAsString
        }, function () {
          onValueChange(_this2.getValueObject(formattedValue, numAsString));
          onUpdate();
        });
      } else {
        onUpdate();
      }
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      e.persist();
      var el = e.target;
      var inputValue = el.value;
      var state = this.state,
          props = this.props;
      var isAllowed = props.isAllowed;
      var lastValue = state.value || '';
      var currentCaretPosition = (0, _utils.getCurrentCaretPosition)(el);
      inputValue = this.correctInputValue(currentCaretPosition, lastValue, inputValue);
      var formattedValue = this.formatInput(inputValue) || '';
      var numAsString = this.removeFormatting(formattedValue);
      var valueObj = this.getValueObject(formattedValue, numAsString);

      if (!isAllowed(valueObj)) {
        formattedValue = lastValue;
      }

      this.updateValue({
        formattedValue: formattedValue,
        numAsString: numAsString,
        inputValue: inputValue,
        input: el
      }, function () {
        props.onChange(e);
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      var props = this.props,
          state = this.state;
      var format = props.format,
          onBlur = props.onBlur;
      var numAsString = state.numAsString;
      var lastValue = state.value;
      this.focusedElm = null;

      if (!format) {
        numAsString = (0, _utils.fixLeadingZero)(numAsString);
        var formattedValue = this.formatNumString(numAsString); //change the state

        if (formattedValue !== lastValue) {
          // the event needs to be persisted because its properties can be accessed in an asynchronous way
          e.persist();
          this.updateValue({
            formattedValue: formattedValue,
            numAsString: numAsString
          }, function () {
            onBlur(e);
          });
          return;
        }
      }

      onBlur(e);
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      var el = e.target;
      var key = e.key;
      var selectionStart = el.selectionStart,
          selectionEnd = el.selectionEnd,
          _el$value = el.value,
          value = _el$value === void 0 ? '' : _el$value;
      var expectedCaretPosition;
      var _this$props11 = this.props,
          decimalScale = _this$props11.decimalScale,
          fixedDecimalScale = _this$props11.fixedDecimalScale,
          prefix = _this$props11.prefix,
          suffix = _this$props11.suffix,
          format = _this$props11.format,
          onKeyDown = _this$props11.onKeyDown,
          onValueChange = _this$props11.onValueChange;
      var ignoreDecimalSeparator = decimalScale !== undefined && fixedDecimalScale;
      var numRegex = this.getNumberRegex(false, ignoreDecimalSeparator);
      var negativeRegex = new RegExp('-');
      var isPatternFormat = typeof format === 'string';
      this.selectionBeforeInput = {
        selectionStart: selectionStart,
        selectionEnd: selectionEnd //Handle backspace and delete against non numerical/decimal characters or arrow keys

      };

      if (key === 'ArrowLeft' || key === 'Backspace') {
        expectedCaretPosition = selectionStart - 1;
      } else if (key === 'ArrowRight') {
        expectedCaretPosition = selectionStart + 1;
      } else if (key === 'Delete') {
        expectedCaretPosition = selectionStart;
      } //if expectedCaretPosition is not set it means we don't want to Handle keyDown
      //also if multiple characters are selected don't handle


      if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
        onKeyDown(e);
        return;
      }

      var newCaretPosition = expectedCaretPosition;
      var leftBound = isPatternFormat ? format.indexOf('#') : prefix.length;
      var rightBound = isPatternFormat ? format.lastIndexOf('#') + 1 : value.length - suffix.length;

      if (key === 'ArrowLeft' || key === 'ArrowRight') {
        var direction = key === 'ArrowLeft' ? 'left' : 'right';
        newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
      } else if (key === 'Delete' && !numRegex.test(value[expectedCaretPosition]) && !negativeRegex.test(value[expectedCaretPosition])) {
        while (!numRegex.test(value[newCaretPosition]) && newCaretPosition < rightBound) {
          newCaretPosition++;
        }
      } else if (key === 'Backspace' && !numRegex.test(value[expectedCaretPosition])) {
        /* NOTE: This is special case when backspace is pressed on a
        negative value while the cursor position is after prefix. We can't handle it on onChange because
        we will not have any information of keyPress
        */
        if (selectionStart <= leftBound + 1 && value[0] === '-' && typeof format === 'undefined') {
          var newValue = value.substring(1); //persist event before performing async task

          e.persist();
          this.updateValue({
            formattedValue: newValue,
            caretPos: newCaretPosition,
            input: el
          });
        } else if (!negativeRegex.test(value[expectedCaretPosition])) {
          while (!numRegex.test(value[newCaretPosition - 1]) && newCaretPosition > leftBound) {
            newCaretPosition--;
          }

          newCaretPosition = this.correctCaretPosition(value, newCaretPosition, 'left');
        }
      }

      if (newCaretPosition !== expectedCaretPosition || expectedCaretPosition < leftBound || expectedCaretPosition > rightBound) {
        e.preventDefault();
        this.setPatchedCaretPosition(el, newCaretPosition, value);
      }
      /* NOTE: this is just required for unit test as we need to get the newCaretPosition,
              Remove this when you find different solution */


      if (e.isUnitTestRun) {
        this.setPatchedCaretPosition(el, newCaretPosition, value);
      }

      this.props.onKeyDown(e);
    }
    /** required to handle the caret position when click anywhere within the input **/

  }, {
    key: "onMouseUp",
    value: function onMouseUp(e) {
      var el = e.target;
      /**
       * NOTE: we have to give default value for value as in case when custom input is provided
       * value can come as undefined when nothing is provided on value prop.
      */

      var selectionStart = el.selectionStart,
          selectionEnd = el.selectionEnd,
          _el$value2 = el.value,
          value = _el$value2 === void 0 ? '' : _el$value2;

      if (selectionStart === selectionEnd) {
        var caretPosition = this.correctCaretPosition(value, selectionStart);

        if (caretPosition !== selectionStart) {
          this.setPatchedCaretPosition(el, caretPosition, value);
        }
      }

      this.props.onMouseUp(e);
    }
  }, {
    key: "onFocus",
    value: function onFocus(e) {
      var _this3 = this;

      // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
      // (onFocus event target selectionStart is always 0 before setTimeout)
      e.persist();
      this.focusedElm = e.target;
      setTimeout(function () {
        var el = e.target;
        var selectionStart = el.selectionStart,
            selectionEnd = el.selectionEnd,
            _el$value3 = el.value,
            value = _el$value3 === void 0 ? '' : _el$value3;

        var caretPosition = _this3.correctCaretPosition(value, selectionStart); //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)


        if (caretPosition !== selectionStart && !(selectionStart === 0 && selectionEnd === value.length)) {
          _this3.setPatchedCaretPosition(el, caretPosition, value);
        }

        _this3.props.onFocus(e);
      }, 0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props12 = this.props,
          type = _this$props12.type,
          displayType = _this$props12.displayType,
          customInput = _this$props12.customInput,
          renderText = _this$props12.renderText,
          getInputRef = _this$props12.getInputRef;
      var value = this.state.value;
      var otherProps = (0, _utils.omit)(this.props, propTypes);

      var inputProps = _extends({}, otherProps, {
        type: type,
        value: value,
        onChange: this.onChange,
        onKeyDown: this.onKeyDown,
        onMouseUp: this.onMouseUp,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      });

      if (displayType === 'text') {
        return renderText ? renderText(value) || null : _react.default.createElement("span", _extends({}, otherProps, {
          ref: getInputRef
        }), value);
      } else if (customInput) {
        var CustomInput = customInput;
        return _react.default.createElement(CustomInput, inputProps);
      }

      return _react.default.createElement("input", _extends({}, inputProps, {
        ref: getInputRef
      }));
    }
  }]);

  return NumberFormat;
}(_react.default.Component);

NumberFormat.propTypes = propTypes;
NumberFormat.defaultProps = defaultProps;
var _default = NumberFormat;
exports.default = _default;
module.exports = exports.default;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Toggle=function(_React$Component){_inherits(Toggle,_React$Component);function Toggle(props){_classCallCheck(this,Toggle);var _this=_possibleConstructorReturn(this,(Toggle.__proto__||Object.getPrototypeOf(Toggle)).call(this,props));_this.onChange=_this.onChange.bind(_this);return _this;}_createClass(Toggle,[{key:"onChange",value:function onChange(e){this.props.onChange(this.props.name,e.target.checked);}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"toggle-container inline-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",name:this.props.name,checked:this.props.value,id:"toggle-"+this.props.id,onChange:this.onChange,disabled:this.props.disabled,className:"cbx hidden input"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"toggle-"+this.props.id,className:"toggle input "+(this.props.disabled?'disabled':'')}));}}]);return Toggle;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Toggle);

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getPrinters"] = getPrinters;
/* harmony export (immutable) */ __webpack_exports__["getSystemSettings"] = getSystemSettings;
/* harmony export (immutable) */ __webpack_exports__["getPartialSystemSettings"] = getPartialSystemSettings;
/* harmony export (immutable) */ __webpack_exports__["getTags"] = getTags;
/* harmony export (immutable) */ __webpack_exports__["deleteTag"] = deleteTag;
/* harmony export (immutable) */ __webpack_exports__["addTag"] = addTag;
/* harmony export (immutable) */ __webpack_exports__["updateTag"] = updateTag;
/* harmony export (immutable) */ __webpack_exports__["updateSetting"] = updateSetting;
/* harmony export (immutable) */ __webpack_exports__["updateReturnAddress"] = updateReturnAddress;
/* harmony export (immutable) */ __webpack_exports__["updateDefaultFund"] = updateDefaultFund;
/* harmony export (immutable) */ __webpack_exports__["updateLocationGroup"] = updateLocationGroup;
/* harmony export (immutable) */ __webpack_exports__["saveSignature"] = saveSignature;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CampaignsActions__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CampaignListsActions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RecipientAccountsActions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UsersActions__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FundsActions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ReferencesActions__ = __webpack_require__(99);
var fetchUtilsWithRetry=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(url,params,dataType){var response,i;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.prev=0;_context5.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])(url,params,dataType);case 3:response=_context5.sent;i=0;case 5:if(!(i<4&&!response.success)){_context5.next=12;break;}_context5.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])(url,params,dataType);case 8:response=_context5.sent;i++;_context5.next=5;break;case 12:return _context5.abrupt('return',{loading:false,success:response.success,data:response.data});case 15:_context5.prev=15;_context5.t0=_context5['catch'](0);return _context5.abrupt('return',{loading:false,success:false,data:dataType});case 18:case'end':return _context5.stop();}}},_callee5,this,[[0,15]]);}));return function fetchUtilsWithRetry(_x5,_x6,_x7){return _ref5.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function getPrinters(){var _this=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_PRINTERS"]});_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])("/settings/printers",null,[]);case 3:response=_context.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_PRINTERS"],response:response});return _context.abrupt('return',response);case 6:case'end':return _context.stop();}}},_callee,_this);}));return function(_x){return _ref.apply(this,arguments);};}();}function getSystemSettings(){var _this2=this;return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_SYSTEM_SETTINGS"]});_context2.next=3;return fetchUtilsWithRetry("/settings",{AllSettings:true});case 3:response=_context2.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_SYSTEM_SETTINGS"],response:response});case 5:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref2.apply(this,arguments);};}();}function getPartialSystemSettings(setting){var _this3=this;return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_PARTIAL_SYSTEM_SETTINGS"],setting:setting});_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/settings?'+setting+'=true');case 3:response=_context3.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_PARTIAL_SYSTEM_SETTINGS"],setting:setting,response:response});case 5:case'end':return _context3.stop();}}},_callee3,_this3);}));return function(_x3){return _ref3.apply(this,arguments);};}();}function getTags(){var _this4=this;return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Promise.all([dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__CampaignsActions__["getCampaigns"])()),dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__CampaignListsActions__["getAllCampaignLists"])()),dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__UsersActions__["getApprovers"])()),dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__RecipientAccountsActions__["getOrganizations"])()),dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__FundsActions__["getFunds"])()),dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__ReferencesActions__["getAllReferences"])())]);case 2:case'end':return _context4.stop();}}},_callee4,_this4);}));return function(_x4){return _ref4.apply(this,arguments);};}();}function deleteTag(tagName,tagId){var _this5=this;return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_DELETE_TAG"],tagName:tagName,tagId:tagId});_context6.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["a" /* deleteRequest */])('/settings/'+tagName+'/'+tagId);case 3:response=_context6.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["DELETE_TAG"],response:response,tagName:tagName,tagId:tagId});case 5:case'end':return _context6.stop();}}},_callee6,_this5);}));return function(_x8){return _ref6.apply(this,arguments);};}();}function addTag(tagName,tagValue){var _this6=this;return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatch){var value,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_ADD_TAG"],tagName:tagName});value=typeof tagValue==="string"?{tagValue:tagValue}:tagValue;_context7.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/settings/'+tagName,value,null);case 4:response=_context7.sent;if(response.success){if(typeof tagValue==="string"){response.data={key:response.data,value:tagValue};}else{if(tagName===__WEBPACK_IMPORTED_MODULE_3__lib_constants__["l" /* TagNames */].CampaignCategories)response.data=Object.assign({},tagValue,{campaignCategoryId:response.data});if(tagName===__WEBPACK_IMPORTED_MODULE_3__lib_constants__["l" /* TagNames */].LocationGroups)response.data=Object.assign({},tagValue,{groupId:response.data});}}dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["ADD_TAG"],tagName:tagName,response:response});case 7:case'end':return _context7.stop();}}},_callee7,_this6);}));return function(_x9){return _ref7.apply(this,arguments);};}();}function updateTag(tagName,tag){var _this7=this;return function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_TAG"],tagName:tagName});_context8.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["e" /* putRequest */])('/settings/'+tagName+'/'+tag.key,{tagValue:tag.value},null);case 3:response=_context8.sent;if(response.success){response.data=tag;}dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_TAG"],tagName:tagName,response:response});case 6:case'end':return _context8.stop();}}},_callee8,_this7);}));return function(_x10){return _ref8.apply(this,arguments);};}();}function updateSetting(settingName,settingId,newSettingValue){var _this8=this;return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_SETTING"],settingName:settingName});_context9.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["e" /* putRequest */])('/settings/'+settingId,{newSettingValue:newSettingValue});case 3:response=_context9.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_SETTING"],response:response,settingName:settingName,value:newSettingValue});case 5:case'end':return _context9.stop();}}},_callee9,_this8);}));return function(_x11){return _ref9.apply(this,arguments);};}();}function updateReturnAddress(address){var _this9=this;return function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_SETTING"],settingName:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["h" /* SettingNames */].ReturnAddress});_context10.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["e" /* putRequest */])('/settings/returnaddress',address);case 3:response=_context10.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_SETTING"],response:response,settingName:__WEBPACK_IMPORTED_MODULE_3__lib_constants__["h" /* SettingNames */].ReturnAddress,value:address});case 5:case'end':return _context10.stop();}}},_callee10,_this9);}));return function(_x12){return _ref10.apply(this,arguments);};}();}function updateDefaultFund(settingName,fundId){var _this10=this;return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_SETTING"],settingName:settingName});_context11.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["c" /* patchRequest */])('/funds/'+fundId,{isDefault:true});case 3:response=_context11.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_SETTING"],response:response,settingName:settingName,value:fundId});case 5:case'end':return _context11.stop();}}},_callee11,_this10);}));return function(_x13){return _ref11.apply(this,arguments);};}();}function updateLocationGroup(groupId,group){var _this11=this;return function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(dispatch){var settingName,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:settingName=__WEBPACK_IMPORTED_MODULE_3__lib_constants__["l" /* TagNames */].LocationGroups;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_SETTING"],settingName:settingName});_context12.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["e" /* putRequest */])('/settings/campaignLocationGroups/'+groupId,group);case 4:response=_context12.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_SETTING"],response:response,settingName:settingName,value:group});case 6:case'end':return _context12.stop();}}},_callee12,_this11);}));return function(_x14){return _ref12.apply(this,arguments);};}();}function saveSignature(signature){var _this12=this;return function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(dispatch){var settingName,formData,prop,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:settingName=__WEBPACK_IMPORTED_MODULE_3__lib_constants__["h" /* SettingNames */].Signatures;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_SETTING"],settingName:settingName});formData=new FormData();for(prop in signature){formData.append(prop,signature[prop]);}_context13.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/settings/signatures',formData,{'Content-Type':'multipart/form-data'},{});case 6:response=_context13.sent;if(response.success)signature.fileId=1;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_SETTING"],response:response,settingName:settingName,value:signature});case 9:case'end':return _context13.stop();}}},_callee13,_this12);}));return function(_x15){return _ref13.apply(this,arguments);};}();}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(148);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var throttle = __webpack_require__(164);
var debounce = __webpack_require__(431);

module.exports = {
	throttle: throttle,
	debounce: debounce
};


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Modal__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WarningModal=function(_React$Component){_inherits(WarningModal,_React$Component);function WarningModal(){_classCallCheck(this,WarningModal);return _possibleConstructorReturn(this,(WarningModal.__proto__||Object.getPrototypeOf(WarningModal)).apply(this,arguments));}_createClass(WarningModal,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal warning-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons middle'},'warning'),'Warning'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'medium-text'},this.props.message&&this.props.message.indexOf('\n')>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.message.split('\n').slice(0,1).map(function(text,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{key:index},text);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scrollable-recipients-container'},this.props.message.split('\n').slice(1).map(function(text,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{key:index},text);}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.message,'  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bold-text'},this.props.confirmationMessage||"Do you still want to continue?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'warning-modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-accent',onClick:function onClick(){if(_this2.props.cancel)_this2.props.cancel();_this2.props.close();}},this.props.cancelText||"Cancel"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-accent2',onClick:function onClick(){_this2.props.continue();_this2.props.close();}},this.props.continueText||"Continue")))));}}]);return WarningModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (WarningModal);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getFunds"] = getFunds;
/* harmony export (immutable) */ __webpack_exports__["getFundsVerbose"] = getFundsVerbose;
/* harmony export (immutable) */ __webpack_exports__["createFund"] = createFund;
/* harmony export (immutable) */ __webpack_exports__["getFundDetails"] = getFundDetails;
/* harmony export (immutable) */ __webpack_exports__["updateFundDetails"] = updateFundDetails;
/* harmony export (immutable) */ __webpack_exports__["clearFundDetails"] = clearFundDetails;
/* harmony export (immutable) */ __webpack_exports__["getTransactions"] = getTransactions;
/* harmony export (immutable) */ __webpack_exports__["updateTransactionsFilters"] = updateTransactionsFilters;
/* harmony export (immutable) */ __webpack_exports__["updateTransactionsTable"] = updateTransactionsTable;
/* harmony export (immutable) */ __webpack_exports__["getOutsideTransactions"] = getOutsideTransactions;
/* harmony export (immutable) */ __webpack_exports__["updateOutsideTransactionsTable"] = updateOutsideTransactionsTable;
/* harmony export (immutable) */ __webpack_exports__["updateOutsideTransactionsFilters"] = updateOutsideTransactionsFilters;
/* harmony export (immutable) */ __webpack_exports__["createOutsideTransaction"] = createOutsideTransaction;
/* harmony export (immutable) */ __webpack_exports__["updateTransactionDetails"] = updateTransactionDetails;
/* harmony export (immutable) */ __webpack_exports__["voidTransactions"] = voidTransactions;
/* harmony export (immutable) */ __webpack_exports__["getReconciliationReports"] = getReconciliationReports;
/* harmony export (immutable) */ __webpack_exports__["updateReconciliationReportsFilters"] = updateReconciliationReportsFilters;
/* harmony export (immutable) */ __webpack_exports__["getReconciliationReport"] = getReconciliationReport;
/* harmony export (immutable) */ __webpack_exports__["createReconciliationReport"] = createReconciliationReport;
/* harmony export (immutable) */ __webpack_exports__["createAndCompleteReconciliationReport"] = createAndCompleteReconciliationReport;
/* harmony export (immutable) */ __webpack_exports__["updateReconciliationReport"] = updateReconciliationReport;
/* harmony export (immutable) */ __webpack_exports__["completeReconciliationReport"] = completeReconciliationReport;
/* harmony export (immutable) */ __webpack_exports__["deleteReconciliationReport"] = deleteReconciliationReport;
/* harmony export (immutable) */ __webpack_exports__["calculateReconciliationBalance"] = calculateReconciliationBalance;
/* harmony export (immutable) */ __webpack_exports__["clearReconciliationDetails"] = clearReconciliationDetails;
/* harmony export (immutable) */ __webpack_exports__["getReconciliationPayments"] = getReconciliationPayments;
/* harmony export (immutable) */ __webpack_exports__["toggleSelectReconciliationPayments"] = toggleSelectReconciliationPayments;
/* harmony export (immutable) */ __webpack_exports__["getReconciliationCredits"] = getReconciliationCredits;
/* harmony export (immutable) */ __webpack_exports__["toggleSelectReconciliationCredits"] = toggleSelectReconciliationCredits;
/* harmony export (immutable) */ __webpack_exports__["updateReconciliationAdjustments"] = updateReconciliationAdjustments;
/* harmony export (immutable) */ __webpack_exports__["getBlankChecks"] = getBlankChecks;
/* harmony export (immutable) */ __webpack_exports__["clearManualChecks"] = clearManualChecks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bignumber_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bignumber_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bignumber_js__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function getFunds(){var _this=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_FUNDS"]});_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/funds',null,[]);case 3:response=_context.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_FUNDS"],response:response});case 5:case'end':return _context.stop();}}},_callee,_this);}));return function(_x){return _ref.apply(this,arguments);};}();}function getFundsVerbose(){var _this2=this;return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_FUNDS_VERBOSE"]});_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/funds?verbose=true',null,[]);case 3:response=_context2.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_FUNDS_VERBOSE"],response:response});case 5:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref2.apply(this,arguments);};}();}function createFund(fund){var _this3=this;return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_CREATE_FUND"]});_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/funds',fund);case 3:response=_context3.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CREATE_FUND"],response:response});if(response.success){dispatch(getFunds());dispatch(getFundsVerbose());}case 6:case'end':return _context3.stop();}}},_callee3,_this3);}));return function(_x3){return _ref3.apply(this,arguments);};}();}function getFundDetails(fundId){var _this4=this;return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_FUND_DETAILS"]});_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/funds/'+fundId);case 3:response=_context4.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_FUND_DETAILS"],response:response});case 5:case'end':return _context4.stop();}}},_callee4,_this4);}));return function(_x4){return _ref4.apply(this,arguments);};}();}function updateFundDetails(fundId,fund){var _this5=this;return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch){var response,updatedFund;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_FUND"]});_context5.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["e" /* putRequest */])('/funds/'+fundId,fund,{});case 3:response=_context5.sent;if(!response.success){_context5.next=10;break;}dispatch(getFunds());_context5.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/funds/'+fundId);case 8:updatedFund=_context5.sent;if(updatedFund.success)response.data=updatedFund.data;case 10:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_FUND"],response:response});case 11:case'end':return _context5.stop();}}},_callee5,_this5);}));return function(_x5){return _ref5.apply(this,arguments);};}();}function getUpdatedFundDetails(fundId){var _this6=this;return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/funds/'+fundId);case 2:response=_context6.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_FUND_DETAILS"],response:response});case 4:case'end':return _context6.stop();}}},_callee6,_this6);}));return function(_x6){return _ref6.apply(this,arguments);};}();}function clearFundDetails(){var _this7=this;return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatch){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:dispatch(clearReconciliationDetails());dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS"]});dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE_RECORDS"]});case 3:case'end':return _context7.stop();}}},_callee7,_this7);}));return function(_x7){return _ref7.apply(this,arguments);};}();}//all transactions:
function getTransactions(fundId){var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var _this8=this;var results=arguments.length>2&&arguments[2]!==undefined?arguments[2]:12;var sort=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{by:'date',direction:'Descending'};return function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatch,getState){var settings,requestId,tableSettings,filterSettings,params,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:settings={page:page,results:results,sort:sort};dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_ACCOUNTING_TRANSACTIONS_TABLE"],settings:settings});requestId=++getState().accountingTransactionsTable.currentRequestId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS"],requestId:requestId});tableSettings=getState().accountingTransactionsTable;filterSettings=getState().fundDetails.transactionsFilters;params={page:tableSettings.page,sortBy:tableSettings.sort.by,sortDirection:tableSettings.sort.direction,results:tableSettings.resultsView,startDate:filterSettings.startDate,endDate:filterSettings.endDate,search:filterSettings.search,searchWithoutDate:!filterSettings.startDate&&!filterSettings.endDate};_context8.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/funds/'+fundId+'/transactions',params);case 9:response=_context8.sent;dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS"]},{response:response,requestId:requestId}));case 11:case'end':return _context8.stop();}}},_callee8,_this8);}));return function(_x11,_x12){return _ref8.apply(this,arguments);};}();}function updateTransactionsFilters(fundId,update,getTrans,sort,results){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_ACCOUNTING_FILTERS"],update:update});if(getTrans)dispatch(getTransactions(fundId,1,results,sort));};}function updateTransactionsTable(settings){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_ACCOUNTING_TRANSACTIONS_TABLE"],settings:settings});};}//outside transactions:
function getOutsideTransactions(fundId){var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var _this9=this;var results=arguments.length>2&&arguments[2]!==undefined?arguments[2]:12;var sort=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{by:'amount',direction:'Descending'};return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatch,getState){var settings,requestId,tableSettings,filterSettings,params,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:settings={page:page,results:results,sort:sort};dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE"],settings:settings});requestId=++getState().accountingOutsideTransactionsTable.currentRequestId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE_RECORDS"],requestId:requestId});tableSettings=getState().accountingOutsideTransactionsTable;filterSettings=getState().fundDetails.outsideTransactionsFilters;params={page:tableSettings.page,sortBy:tableSettings.sort.by,sortDirection:tableSettings.sort.direction,results:tableSettings.resultsView,startDate:filterSettings.startDate,endDate:filterSettings.endDate,search:filterSettings.search,searchWithoutDate:!filterSettings.startDate&&!filterSettings.endDate,sources:'manual'};_context9.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/funds/'+fundId+'/transactions',params);case 9:response=_context9.sent;dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE_RECORDS"]},{response:response,requestId:requestId}));case 11:case'end':return _context9.stop();}}},_callee9,_this9);}));return function(_x16,_x17){return _ref9.apply(this,arguments);};}();}function updateOutsideTransactionsTable(settings){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE"],settings:settings});};}function updateOutsideTransactionsFilters(fundId,update,getTrans,sort,results){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_ACCOUNTING_OUTSIDE_TRANSACTION_FILTERS"],update:update});if(getTrans)dispatch(getOutsideTransactions(fundId,1,results,sort));};}function createOutsideTransaction(fundId,transaction){var _this10=this;return function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_CREATE_OUTSIDE_TRANSACTION"]});_context10.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/funds/'+fundId+'/transactions',transaction);case 3:response=_context10.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CREATE_OUTSIDE_TRANSACTION"],response:response});if(response.success)dispatch(getUpdatedFundDetails(fundId));case 6:case'end':return _context10.stop();}}},_callee10,_this10);}));return function(_x18){return _ref10.apply(this,arguments);};}();}function updateTransactionDetails(fundId,transactionId,transaction){var _this11=this;return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_TRANSACTION"]});_context11.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["c" /* patchRequest */])('/funds/'+fundId+'/'+transactionId,transaction);case 3:response=_context11.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_TRANSACTION"],response:response});if(response.success)dispatch(getUpdatedFundDetails(fundId));case 6:case'end':return _context11.stop();}}},_callee11,_this11);}));return function(_x19){return _ref11.apply(this,arguments);};}();}function voidTransactions(fundId,transactionIds){var _this12=this;return function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_VOIDING_TRANSACTION"]});_context12.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/funds/'+fundId+'/voidTransactions',transactionIds);case 3:response=_context12.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["VOID_TRANSACTIONS"],response:response});if(response.success){dispatch(getUpdatedFundDetails(fundId));dispatch(getOutsideTransactions(fundId));}case 6:case'end':return _context12.stop();}}},_callee12,_this12);}));return function(_x20){return _ref12.apply(this,arguments);};}();}//reconciliation reports:
function getReconciliationReports(fundId){var _this13=this;return function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(dispatch,getState){var year,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_BANK_RECONCILIATIONS"]});year=getState().reconciliationReports.filters.year;_context13.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/funds/'+fundId+'/reconciliationReports',{year:year});case 4:response=_context13.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_BANK_RECONCILIATIONS"],response:response});if(!year&&response.success&&response.data.years){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_RECONCILIATION_REPORTS_FILTERS"],filter:{year:response.data.years[0]}});}case 7:case'end':return _context13.stop();}}},_callee13,_this13);}));return function(_x21,_x22){return _ref13.apply(this,arguments);};}();}function updateReconciliationReportsFilters(filter,fundId){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_RECONCILIATION_REPORTS_FILTERS"],filter:filter});dispatch(getReconciliationReports(fundId));};}function getReconciliationReport(fundId,reportId){var _this14=this;return function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(dispatch,getState){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_RECONCILIATION_REPORT"]});_context14.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/funds/'+fundId+'/reconciliationReports/'+reportId,{report:false});case 3:response=_context14.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_RECONCILIATION_REPORT"],response:response});case 5:case'end':return _context14.stop();}}},_callee14,_this14);}));return function(_x23,_x24){return _ref14.apply(this,arguments);};}();}function createReconciliationReport(fundId,report,closeOnSave){var _this15=this;return function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_CREATE_RECONCILIATION_REPORT"]});_context15.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/funds/'+fundId+'/reconciliationReports',report);case 3:response=_context15.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CREATE_RECONCILIATION_REPORT"],response:response});if(response.success&&!!closeOnSave){dispatch(clearReconciliationDetails());dispatch(getReconciliationReports(fundId));}case 6:case'end':return _context15.stop();}}},_callee15,_this15);}));return function(_x25){return _ref15.apply(this,arguments);};}();}function createAndCompleteReconciliationReport(fundId,report){var _this16=this;return function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_CREATE_AND_COMPLETE_RECONCILIATION_REPORT"]});_context16.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/funds/'+fundId+'/reconciliationReports',report);case 3:response=_context16.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CREATE_AND_COMPLETE_RECONCILIATION_REPORT"],response:response});if(response.success){dispatch(clearReconciliationDetails());dispatch(getReconciliationReports(fundId));}case 6:case'end':return _context16.stop();}}},_callee16,_this16);}));return function(_x26){return _ref16.apply(this,arguments);};}();}function updateReconciliationReport(fundId,reportId,transactions,adjustments,report,closeOnSave){var _this17=this;return function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_RECONCILIATION_REPORT"]});_context17.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/funds/'+fundId+'/reconciliationReports/'+reportId+'/save',{transactions:transactions,adjustments:adjustments,reportName:report.reportName,toDate:report.dateTo,statementBalance:report.statementBalance});case 3:response=_context17.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_RECONCILIATION_REPORT"],response:response});if(response.success&&!!closeOnSave){dispatch(clearReconciliationDetails());dispatch(getReconciliationReports(fundId));}case 6:case'end':return _context17.stop();}}},_callee17,_this17);}));return function(_x27){return _ref17.apply(this,arguments);};}();}function completeReconciliationReport(fundId,reportId,transactions,adjustments,report){var _this18=this;return function(){var _ref18=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_COMPLETE_RECONCILIATION_REPORT"]});_context18.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/funds/'+fundId+'/reconciliationReports/'+reportId+'/reconcile',{transactions:transactions,adjustments:adjustments,reportName:report.reportName,toDate:report.dateTo,statementBalance:report.statementBalance});case 3:response=_context18.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["COMPLETE_RECONCILIATION_REPORT"],response:response});if(response.success){dispatch(clearReconciliationDetails());dispatch(getReconciliationReports(fundId));}case 6:case'end':return _context18.stop();}}},_callee18,_this18);}));return function(_x28){return _ref18.apply(this,arguments);};}();}function deleteReconciliationReport(fundId,reportId){var _this19=this;return function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_DELETE_RECONCILIATION_REPORT"]});_context19.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["a" /* deleteRequest */])('/funds/'+fundId+'/reconciliationReports/'+reportId);case 3:response=_context19.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["DELETE_RECONCILIATION_REPORT"],response:response});if(response.success){dispatch(clearReconciliationDetails());dispatch(getReconciliationReports(fundId));}case 6:case'end':return _context19.stop();}}},_callee19,_this19);}));return function(_x29){return _ref19.apply(this,arguments);};}();}function calculateReconciliationBalance(){return function(dispatch,getState){var selectedCredits=getState().reconciliationCreditsTable.selected;var selectedPayments=getState().reconciliationPaymentsTable.selected;var adjustmentCredits=getState().reconciliationReports.reconciliationAdjustments.filter(function(adj){return adj.transactionType===__WEBPACK_IMPORTED_MODULE_3__lib_constants__["m" /* TransactionTypes */].Deposit;});var adjustmentPayments=getState().reconciliationReports.reconciliationAdjustments.filter(function(adj){return adj.transactionType===__WEBPACK_IMPORTED_MODULE_3__lib_constants__["m" /* TransactionTypes */].Withdrawal;});var currentReconciliationBalance=getState().reconciliationReports.reconciliationReports.data.currentReconciliationBalance;var credits=[].concat(_toConsumableArray(selectedCredits),_toConsumableArray(adjustmentCredits)).reduce(function(total,trans){return total.plus(trans.amount);},new __WEBPACK_IMPORTED_MODULE_4_bignumber_js__["BigNumber"](0));var payments=[].concat(_toConsumableArray(selectedPayments),_toConsumableArray(adjustmentPayments)).reduce(function(total,trans){return total.plus(trans.amount);},new __WEBPACK_IMPORTED_MODULE_4_bignumber_js__["BigNumber"](0));var balance=new __WEBPACK_IMPORTED_MODULE_4_bignumber_js__["BigNumber"](currentReconciliationBalance).plus(credits).minus(payments);dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_RECONCILIATION_BALANCE"],value:balance.toNumber()});};}function clearReconciliationDetails(){return function(dispatch,getState){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_RECONCILIATION_PAYMENTS_INFINITELIST_SELECTION"]});dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_RECONCILIATION_CREDITS_INFINITELIST_SELECTION"]});dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS"]});dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_RECONCILIATION_CREDITS_INFINITELIST_RECORDS"]});dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_RECONCILIATION_BALANCE"],value:getState().reconciliationReports.reconciliationReports.data.currentReconciliationBalance});dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_RECONCILIATION_ADJUSTMENTS"],value:[]});};}function getReconciliationPayments(fundId,startDate,endDate){var reset=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var page=arguments.length>4&&arguments[4]!==undefined?arguments[4]:1;var _this20=this;var results=arguments.length>5&&arguments[5]!==undefined?arguments[5]:24;var sort=arguments.length>6&&arguments[6]!==undefined?arguments[6]:{by:'date',direction:'Ascending'};return function(){var _ref20=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20(dispatch,getState){var configs,requestId,tableSettings,params,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:configs={page:page,results:results,sort:sort};dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_RECONCILIATION_PAYMENTS_INFINITELIST_CONFIGS"],configs:configs});requestId=++getState().reconciliationPaymentsTable.currentRequestId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS"],requestId:requestId,reset:reset||page===1});tableSettings=getState().reconciliationPaymentsTable;params={page:page,results:results,sortBy:tableSettings.sort.by,sortDirection:tableSettings.sort.direction,startDate:startDate,endDate:endDate,statuses:'outstanding',types:'withdrawal',reconcile:true};_context20.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/funds/'+fundId+'/transactions',params);case 8:response=_context20.sent;dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS"]},{response:response,requestId:requestId}));case 10:case'end':return _context20.stop();}}},_callee20,_this20);}));return function(_x34,_x35){return _ref20.apply(this,arguments);};}();}function toggleSelectReconciliationPayments(transaction){return function(dispatch){dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["TOGGLE_SELECT_RECONCILIATION_PAYMENTS_INFINITELIST_RECORD"]},{record:transaction,recordIdKey:'transactionId'}));dispatch(calculateReconciliationBalance());};}function getReconciliationCredits(fundId,startDate,endDate){var reset=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var page=arguments.length>4&&arguments[4]!==undefined?arguments[4]:1;var _this21=this;var results=arguments.length>5&&arguments[5]!==undefined?arguments[5]:12;var sort=arguments.length>6&&arguments[6]!==undefined?arguments[6]:{by:'date',direction:'Ascending'};return function(){var _ref21=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee21(dispatch,getState){var configs,requestId,tableSettings,params,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21){while(1){switch(_context21.prev=_context21.next){case 0:configs={page:page,results:results,sort:sort};dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_RECONCILIATION_CREDITS_INFINITELIST_CONFIGS"],configs:configs});requestId=++getState().reconciliationCreditsTable.currentRequestId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_RECONCILIATION_CREDITS_INFINITELIST_RECORDS"],requestId:requestId,reset:reset||page===1});tableSettings=getState().reconciliationCreditsTable;params={page:page,results:results,sortBy:tableSettings.sort.by,sortDirection:tableSettings.sort.direction,startDate:startDate,endDate:endDate,statuses:'outstanding',types:'deposit',reconcile:true};_context21.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/funds/'+fundId+'/transactions',params);case 8:response=_context21.sent;dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_RECONCILIATION_CREDITS_INFINITELIST_RECORDS"]},{response:response,requestId:requestId}));case 10:case'end':return _context21.stop();}}},_callee21,_this21);}));return function(_x40,_x41){return _ref21.apply(this,arguments);};}();}function toggleSelectReconciliationCredits(transaction){return function(dispatch){dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["TOGGLE_SELECT_RECONCILIATION_CREDITS_INFINITELIST_RECORD"]},{record:transaction,recordIdKey:'transactionId'}));dispatch(calculateReconciliationBalance());};}function updateReconciliationAdjustments(adjustments){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_RECONCILIATION_ADJUSTMENTS"],value:adjustments||[]});dispatch(calculateReconciliationBalance());};}function getBlankChecks(fundId){var _this22=this;return function(){var _ref22=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee22(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22){while(1){switch(_context22.prev=_context22.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_BLANK_CHECKS"]});_context22.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/funds/'+fundId+'/blankChecks');case 3:response=_context22.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_BLANK_CHECKS"],response:response});case 5:case'end':return _context22.stop();}}},_callee22,_this22);}));return function(_x42){return _ref22.apply(this,arguments);};}();}function clearManualChecks(){var _this23=this;return function(){var _ref23=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee23(dispatch){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23){while(1){switch(_context23.prev=_context23.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_BLANK_CHECKS"]});case 1:case'end':return _context23.stop();}}},_callee23,_this23);}));return function(_x43){return _ref23.apply(this,arguments);};}();}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(217);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["login"] = login;
/* harmony export (immutable) */ __webpack_exports__["verifyLogin"] = verifyLogin;
/* harmony export (immutable) */ __webpack_exports__["logout"] = logout;
/* harmony export (immutable) */ __webpack_exports__["recoverPassword"] = recoverPassword;
/* harmony export (immutable) */ __webpack_exports__["resetPassword"] = resetPassword;
/* harmony export (immutable) */ __webpack_exports__["externalLogin"] = externalLogin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_recipientSummaryCache__ = __webpack_require__(42);
var getVerificationToken=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])("/xsrfToken");case 2:return _context.abrupt('return',_context.sent);case 3:case'end':return _context.stop();}}},_callee,this);}));return function getVerificationToken(){return _ref.apply(this,arguments);};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function login(username,password){var _this=this;return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){var response,verification,_login,lastVerification;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_LOGIN"]});response={loading:false,success:false,data:{}};_context2.next=4;return getVerificationToken();case 4:verification=_context2.sent;response.success=verification.success;if(!verification.success){_context2.next=20;break;}_context2.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/account/login',{username:username,password:password},_defineProperty({},verification.data.tokenName,verification.data.token));case 9:_login=_context2.sent;response.success=_login.success;response.message=!_login.success?_login.message||"Sorry, something went wrong.  Please try again.":"";response.data=_login.data||{};if(_login.success)Object(__WEBPACK_IMPORTED_MODULE_3__lib_recipientSummaryCache__["a" /* clearRecipientSummaryCache */])();if(!(_login.success&&!_login.data.verify)){_context2.next=20;break;}_context2.next=17;return getVerificationToken();case 17:lastVerification=_context2.sent;response.success=lastVerification.success;if(response.success){localStorage.setItem("RequestVerificationToken",lastVerification.data.token);}case 20:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["LOGIN"],response:response});case 21:case'end':return _context2.stop();}}},_callee2,_this);}));return function(_x){return _ref2.apply(this,arguments);};}();}function verifyLogin(verificationCode,remember){var _this2=this;return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var response,verification,_verifyLogin,lastVerification;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_VERIFY_LOGIN"]});response={loading:false,success:false};_context3.next=4;return getVerificationToken();case 4:verification=_context3.sent;response.success=verification.success;if(!verification.success){_context3.next=19;break;}_context3.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/account/verify?verificationCode='+verificationCode+'&remember='+remember,null,_defineProperty({},verification.data.tokenName,verification.data.token));case 9:_verifyLogin=_context3.sent;response.success=_verifyLogin.success;response.message=!_verifyLogin.success?_verifyLogin.message||"Sorry, something went wrong.  Please try again.":"";if(!_verifyLogin.success){_context3.next=19;break;}Object(__WEBPACK_IMPORTED_MODULE_3__lib_recipientSummaryCache__["a" /* clearRecipientSummaryCache */])();_context3.next=16;return getVerificationToken();case 16:lastVerification=_context3.sent;response.success=lastVerification.success;if(response.success){localStorage.setItem("RequestVerificationToken",lastVerification.data.token);}case 19:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["VERIFY_LOGIN"],response:response});case 20:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}();}function logout(){var _this3=this;return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_LOGOUT"]});_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])("/account/logout");case 3:response=_context4.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["LOGOUT"],response:response});if(response.success){Object(__WEBPACK_IMPORTED_MODULE_3__lib_recipientSummaryCache__["a" /* clearRecipientSummaryCache */])();localStorage.removeItem("RequestVerificationToken");localStorage.removeItem("IdleTimer");dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["LOGOUT_SUCCESS"]});}case 6:case'end':return _context4.stop();}}},_callee4,_this3);}));return function(_x3){return _ref4.apply(this,arguments);};}();}function recoverPassword(email){var _this4=this;return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch){var response,verification,recover;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_RECOVER_PASSWORD"]});response={loading:false,success:false};_context5.next=4;return getVerificationToken();case 4:verification=_context5.sent;response.success=verification.success;if(!verification.success){_context5.next=11;break;}_context5.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/account/forgotPassword',{url:window.location.origin+'/reset-password',email:email},_defineProperty({},verification.data.tokenName,verification.data.token));case 9:recover=_context5.sent;response.success=recover.success;case 11:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["RECOVER_PASSWORD"],response:response});case 12:case'end':return _context5.stop();}}},_callee5,_this4);}));return function(_x4){return _ref5.apply(this,arguments);};}();}function resetPassword(token,newPassword){var _this5=this;return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch){var response,verification,reset;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_RESET_PASSWORD"]});response={loading:false,success:false};_context6.next=4;return getVerificationToken();case 4:verification=_context6.sent;response.success=verification.success;if(!verification.success){_context6.next=12;break;}_context6.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/account/resetPassword',{url:window.location.origin+'/recover-password',token:token,newPassword:newPassword},_defineProperty({},verification.data.tokenName,verification.data.token));case 9:reset=_context6.sent;response.success=reset.success;response.expired=!reset.success?(reset.message&&reset.message.toLowerCase().indexOf('expired'))===0:false;case 12:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["RESET_PASSWORD"],response:response});case 13:case'end':return _context6.stop();}}},_callee6,_this5);}));return function(_x5){return _ref6.apply(this,arguments);};}();}function externalLogin(token){var _this6=this;return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatch){var response,verification,_login2,lastVerification;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_LOGIN"]});response={loading:false,success:false};_context7.next=4;return getVerificationToken();case 4:verification=_context7.sent;response.success=verification.success;if(!verification.success){_context7.next=18;break;}_context7.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/account/externalLogin?token='+token,null,_defineProperty({},verification.data.tokenName,verification.data.token));case 9:_login2=_context7.sent;response.success=_login2.success;if(!_login2.success){_context7.next=18;break;}Object(__WEBPACK_IMPORTED_MODULE_3__lib_recipientSummaryCache__["a" /* clearRecipientSummaryCache */])();_context7.next=15;return getVerificationToken();case 15:lastVerification=_context7.sent;response.success=lastVerification.success;if(response.success){localStorage.setItem("RequestVerificationToken",lastVerification.data.token);}case 18:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["LOGIN"],response:response});case 19:case'end':return _context7.stop();}}},_callee7,_this6);}));return function(_x6){return _ref7.apply(this,arguments);};}();}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(288);
var objectAssign = __webpack_require__(49);
var decodeComponent = __webpack_require__(289);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18), __webpack_require__(52)(module)))

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getOrganizations"] = getOrganizations;
/* harmony export (immutable) */ __webpack_exports__["searchRecipients"] = searchRecipients;
/* harmony export (immutable) */ __webpack_exports__["filterRecipients"] = filterRecipients;
/* harmony export (immutable) */ __webpack_exports__["updateTable"] = updateTable;
/* harmony export (immutable) */ __webpack_exports__["toggleSelectRecipient"] = toggleSelectRecipient;
/* harmony export (immutable) */ __webpack_exports__["clearRecipientsSelection"] = clearRecipientsSelection;
/* harmony export (immutable) */ __webpack_exports__["getRecipientAccounts"] = getRecipientAccounts;
/* harmony export (immutable) */ __webpack_exports__["deleteRecipientAccount"] = deleteRecipientAccount;
/* harmony export (immutable) */ __webpack_exports__["getRecipientAccountDetails"] = getRecipientAccountDetails;
/* harmony export (immutable) */ __webpack_exports__["getRecipientApplicationsForExport"] = getRecipientApplicationsForExport;
/* harmony export (immutable) */ __webpack_exports__["getUpdatedRecipientAccountDetails"] = getUpdatedRecipientAccountDetails;
/* harmony export (immutable) */ __webpack_exports__["getRecipientApplicationHistory"] = getRecipientApplicationHistory;
/* harmony export (immutable) */ __webpack_exports__["updateRecipientDetails"] = updateRecipientDetails;
/* harmony export (immutable) */ __webpack_exports__["addRecipientNote"] = addRecipientNote;
/* harmony export (immutable) */ __webpack_exports__["updateRecipientNote"] = updateRecipientNote;
/* harmony export (immutable) */ __webpack_exports__["deleteRecipientNote"] = deleteRecipientNote;
/* harmony export (immutable) */ __webpack_exports__["createRecipient"] = createRecipient;
/* harmony export (immutable) */ __webpack_exports__["getRecipientsForExport"] = getRecipientsForExport;
/* harmony export (immutable) */ __webpack_exports__["getPledgesReport"] = getPledgesReport;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_recipientSummaryCache__ = __webpack_require__(42);
var getNote=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(recipientId,noteId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/recipients/'+recipientId+'/notes/'+noteId);case 2:return _context10.abrupt('return',_context10.sent);case 3:case'end':return _context10.stop();}}},_callee10,this);}));return function getNote(_x21,_x22){return _ref10.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function getOrganizations(){var _this=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_ORGANIZATIONS"]});_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])("/recipients",{recipientTypes:[__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["l" /* RecipientTypes */].Organization]});case 3:response=_context.sent;response.data=response.data.records?response.data.records.map(function(recipient){return{key:recipient.applicantId,value:recipient.lastOrOrgName,tags:recipient.tags,address:recipient.address};}):[];dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_ORGANIZATIONS"],response:response});case 6:case'end':return _context.stop();}}},_callee,_this);}));return function(_x){return _ref.apply(this,arguments);};}();}function searchRecipients(search){var _this2=this;var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var results=arguments.length>2&&arguments[2]!==undefined?arguments[2]:12;return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState){var filterSettings,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:filterSettings=getState().recipientAccounts.filters;filterSettings.elasticSearchText=search;if(!(search.length>0)){_context2.next=9;break;}_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/search/applicants',{text:search,page:page,results:results});case 5:response=_context2.sent;filterSettings.recipients=response.data||{};_context2.next=10;break;case 9:filterSettings.recipients={};case 10:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_RECIPIENTS_FILTERS"],update:filterSettings});case 11:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x4,_x5){return _ref2.apply(this,arguments);};}();}function filterRecipients(){var update=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var search=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";var results=arguments.length>2&&arguments[2]!==undefined?arguments[2]:12;var sort=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{by:'lastOrOrgName',direction:'Ascending'};return function(dispatch){dispatch({type:update?__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_RECIPIENTS_FILTERS"]:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["RESET_RECIPIENTS_FILTERS"],update:update});if(!update){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_RECIPIENTS_TABLE_SELECTION"]});}dispatch(getRecipientAccounts(search,1,results,sort));};}function updateTable(settings){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_RECIPIENTS_TABLE"],settings:settings});};}function toggleSelectRecipient(recipient){return function(dispatch){dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["TOGGLE_SELECT_RECIPIENTS_TABLE_RECORD"]},{record:recipient,recordIdKey:'applicantId'}));};}function clearRecipientsSelection(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_RECIPIENTS_TABLE_SELECTION"]});};}function getRecipientAccounts(){var search=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var _this3=this;var results=arguments.length>2&&arguments[2]!==undefined?arguments[2]:12;var sort=arguments[3];return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch,getState){var filterSettings,settings,tableSettings,requestId,params,filterProperty,filterVal,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:filterSettings=getState().recipientAccounts.filters;filterSettings.elasticSearchText=search;if(search.length>0&&!sort){sort={by:'recipientIds',direction:'Ascending'};}settings={page:page,results:results,sort:sort||{by:'name',direction:'Ascending'}};dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_RECIPIENTS_TABLE"],settings:settings});tableSettings=getState().recipientsTable;requestId=++getState().recipientsTable.currentRequestId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_RECIPIENTS_TABLE_RECORDS"],requestId:requestId});params={page:tableSettings.page,sortBy:tableSettings.sort.by,sortDirection:tableSettings.sort.direction,results:tableSettings.resultsView};for(filterProperty in filterSettings){filterVal=filterSettings[filterProperty];params[filterProperty]=filterVal;}_context3.next=12;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/recipients',params);case 12:response=_context3.sent;dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_RECIPIENTS_TABLE_RECORDS"]},{response:response,requestId:requestId}));case 14:case'end':return _context3.stop();}}},_callee3,_this3);}));return function(_x13,_x14){return _ref3.apply(this,arguments);};}();}function deleteRecipientAccount(recipientId){var _this4=this;return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_REMOVE_RECIPIENTS_TABLE_RECORD"]});_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["a" /* deleteRequest */])('/recipients/'+recipientId);case 3:response=_context4.sent;response.recordIdKey='applicantId';response.recordId=recipientId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["REMOVE_RECIPIENTS_TABLE_RECORD"],response:response});case 7:case'end':return _context4.stop();}}},_callee4,_this4);}));return function(_x15){return _ref4.apply(this,arguments);};}();}function getRecipientAccountDetails(applicantId,preserveDetails){var _this5=this;return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_RECIPIENT_DETAILS"],preserveDetails:preserveDetails});_context5.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/recipients/'+applicantId);case 3:response=_context5.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_RECIPIENT_DETAILS"],response:response});case 5:case'end':return _context5.stop();}}},_callee5,_this5);}));return function(_x16){return _ref5.apply(this,arguments);};}();}function getRecipientApplicationsForExport(fields,recipientId,startDate,endDate){var _this6=this;return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch){var params,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:params={fields:fields,startDate:startDate,endDate:endDate};_context6.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/recipients/'+recipientId+'/applications/report',params);case 3:response=_context6.sent;dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_RECIPIENT_APPLICATIONS_FOR_EXPORT"]},{response:response}));case 5:case'end':return _context6.stop();}}},_callee6,_this6);}));return function(_x17){return _ref6.apply(this,arguments);};}();}function getUpdatedRecipientAccountDetails(applicantId){var _this7=this;return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/recipients/'+applicantId);case 2:response=_context7.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_RECIPIENT_DETAILS"],response:response});case 4:case'end':return _context7.stop();}}},_callee7,_this7);}));return function(_x18){return _ref7.apply(this,arguments);};}();}function getRecipientApplicationHistory(applicantId){var _this8=this;return function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_RECIPIENT_APPLICATION_HISTORY"]});_context8.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/recipients/'+applicantId+'/applications',null,[]);case 3:response=_context8.sent;response.data=response.data instanceof Array?response.data.map(function(app){return Object.assign({},app,{applicantId:applicantId});}):[];dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_RECIPIENT_APPLICATION_HISTORY"],response:response});case 6:case'end':return _context8.stop();}}},_callee8,_this8);}));return function(_x19){return _ref8.apply(this,arguments);};}();}function updateRecipientDetails(recipientId,recipient){var _this9=this;return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_RECIPIENT_DETAILS"]});_context9.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["e" /* putRequest */])('/recipients/'+recipientId,recipient,{});case 3:response=_context9.sent;if(response.success)Object(__WEBPACK_IMPORTED_MODULE_4__lib_recipientSummaryCache__["a" /* clearRecipientSummaryCache */])(recipientId);dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_RECIPIENT_DETAILS"],response:response});case 6:case'end':return _context9.stop();}}},_callee9,_this9);}));return function(_x20){return _ref9.apply(this,arguments);};}();}function addRecipientNote(recipientId,noteText){var _this10=this;return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(dispatch){var response,note;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_ADD_RECIPIENT_NOTE"]});_context11.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/recipients/'+recipientId+'/notes',{noteText:noteText});case 3:response=_context11.sent;if(response.success)Object(__WEBPACK_IMPORTED_MODULE_4__lib_recipientSummaryCache__["a" /* clearRecipientSummaryCache */])(recipientId);if(!response.success){_context11.next=10;break;}_context11.next=8;return getNote(recipientId,response.data);case 8:note=_context11.sent;response.data=note.data;case 10:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["ADD_RECIPIENT_NOTE"],response:response});case 11:case'end':return _context11.stop();}}},_callee11,_this10);}));return function(_x23){return _ref11.apply(this,arguments);};}();}function updateRecipientNote(recipientId,noteId,noteText){var _this11=this;return function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(dispatch){var response,note;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_RECIPIENT_NOTE"]});_context12.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["e" /* putRequest */])('/recipients/'+recipientId+'/notes/'+noteId,{noteText:noteText});case 3:response=_context12.sent;if(response.success)Object(__WEBPACK_IMPORTED_MODULE_4__lib_recipientSummaryCache__["a" /* clearRecipientSummaryCache */])(recipientId);_context12.next=7;return getNote(recipientId,noteId);case 7:note=_context12.sent;response.data=note.data;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_RECIPIENT_NOTE"],response:response});case 10:case'end':return _context12.stop();}}},_callee12,_this11);}));return function(_x24){return _ref12.apply(this,arguments);};}();}function deleteRecipientNote(recipientId,noteId){var _this12=this;return function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_DELETE_RECIPIENT_NOTE"]});_context13.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["a" /* deleteRequest */])('/recipients/'+recipientId+'/notes/'+noteId);case 3:response=_context13.sent;if(response.success)Object(__WEBPACK_IMPORTED_MODULE_4__lib_recipientSummaryCache__["a" /* clearRecipientSummaryCache */])(recipientId);dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["DELETE_RECIPIENT_NOTE"]},{response:response,noteId:noteId}));case 6:case'end':return _context13.stop();}}},_callee13,_this12);}));return function(_x25){return _ref13.apply(this,arguments);};}();}function createRecipient(recipient){var _this13=this;var recipientObj={applicantType:recipient.applicantType,isIsraeli:recipient.isIsraeli,personTitleId:recipient.personTitleId,firstName:recipient.firstName,lastName:recipient.lastName,reportName:recipient.reportName,organization:recipient.organization,address:recipient.address,previousAddress:recipient.previousAddress,phoneNumber:recipient.phoneNumber,phoneType:recipient.phoneType,secondPhoneNumber:recipient.secondPhoneNumber,secondPhoneType:recipient.secondPhoneType,email:recipient.email,teudatZahut:recipient.teudatZehut,bankRoutingNumber:recipient.bankRoutingNumber,bankBranchNumber:recipient.bankBranchNumber,bankAccountNumber:recipient.bankAccountNumber,bankAccountHolder:recipient.bankAccountHolder,tags:recipient.tags,note:recipient.note,trustedPayeeId:recipient.trustedPayeeId,references:recipient.references,solicitors:recipient.solicitors,roshYeshivas:recipient.roshYeshivas,applicantPledges:recipient.applicantPledges};return function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_CREATE_RECIPIENT"]});_context14.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/recipients',recipientObj,{});case 3:response=_context14.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CREATE_RECIPIENT"],response:response});case 5:case'end':return _context14.stop();}}},_callee14,_this13);}));return function(_x26){return _ref14.apply(this,arguments);};}();}function getRecipientsForExport(fields,groupBy){var _this14=this;return function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(dispatch,getState){var filterSettings,params,filterProperty,filterVal,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:filterSettings=getState().recipientAccounts.filters;params={fields:fields,groupBy:groupBy};for(filterProperty in filterSettings){filterVal=filterSettings[filterProperty];params[filterProperty]=filterVal;}_context15.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/recipients/report',params);case 5:response=_context15.sent;dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_RECIPIENTS_FOR_EXPORT"]},{response:response}));case 7:case'end':return _context15.stop();}}},_callee15,_this14);}));return function(_x27,_x28){return _ref15.apply(this,arguments);};}();}function getPledgesReport(){var _this15=this;var fundIds=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var includeClosedPledges=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_PLEDGES_REPORT"]});_context16.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/recipients/report/pledge',{fundIds:fundIds,includeClosedPledges:includeClosedPledges});case 3:response=_context16.sent;if(response.success&&typeof response.data==='string'){try{response.data=JSON.parse(response.data);}catch(error){}}dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_PLEDGES_REPORT"],response:response});return _context16.abrupt('return',response);case 7:case'end':return _context16.stop();}}},_callee16,_this15);}));return function(_x31){return _ref16.apply(this,arguments);};}();}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.toastrWarn = toastrWarn;
exports.createReducer = createReducer;
exports.isBrowser = isBrowser;
exports.keyCode = keyCode;
exports.mapToToastrMessage = mapToToastrMessage;
exports.guid = guid;
exports.onCSSTransitionEnd = onCSSTransitionEnd;
exports.preventDuplication = preventDuplication;
exports.updateConfig = updateConfig;
exports._bind = _bind;

var _config = __webpack_require__(87);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function whichAnimationEvent() {
  var t = void 0;
  var el = document.createElement('fakeelement');

  var transitions = {
    animation: 'animationend',
    oanimation: 'oanimationend',
    MSAnimation: 'MSAnimationEnd',
    webkitAnimation: 'webkitAnimationEnd'
  };

  for (t in transitions) {
    if (el.style[t] !== undefined) {
      return transitions[t];
    }
  }
}

function isString(obj) {
  if (typeof obj == 'string') {
    return true;
  }
  return false;
}

function toastrWarn(message) {
  if (true) {
    return null;
  }
  console.warn('[react-redux-toastr] ' + message);
}

function createReducer(initialState, fnMap) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var _ref = arguments[1];
    var type = _ref.type,
        payload = _ref.payload;

    var handle = fnMap[type];
    return handle ? handle(state, payload) : state;
  };
}

function isBrowser() {
  if (typeof window !== 'undefined') {
    return true;
  }
  return false;
}

function keyCode(e) {
  return e.which ? e.which : e.keyCode;
}

function mapToToastrMessage(type, array) {
  var obj = {};
  obj.type = type;
  obj.position = _config2.default.position;

  obj.options = array.filter(function (item) {
    return (typeof item === 'undefined' ? 'undefined' : _typeof(item)) == 'object';
  })[0] || {};

  if (obj.options.hasOwnProperty('position')) {
    obj.position = obj.options.position;
  }

  if (!obj.options.hasOwnProperty('removeOnHover')) {
    obj.options.removeOnHover = true;
    if (type === 'message') {
      obj.options.removeOnHover = false;
    }
  }

  if (!obj.options.hasOwnProperty('showCloseButton')) {
    obj.options.showCloseButton = true;
  }

  if (type === 'message' && !obj.options.hasOwnProperty('timeOut')) {
    obj.options.timeOut = 0;
  }

  if (isString(array[0]) && isString(array[1])) {
    obj.title = array[0];
    obj.message = array[1];
  } else if (isString(array[0]) && !isString(array[1])) {
    obj.title = array[0];
  } else {
    obj.message = array[0];
  }

  return obj;
}

function guid() {
  var r = function r() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  };
  return r() + r() + r() + '-' + r() + '_' + r() + '-' + r() + '_' + r() + r() + r();
}

function onCSSTransitionEnd(node, callback) {
  // if css animation is failed - dispatch event manually
  var animationEnd = whichAnimationEvent();
  var timeoutId = setTimeout(function () {
    var e = new Event(animationEnd);
    toastrWarn('The toastr box was closed automatically, please check \'transitionOut\' prop value');
    node.dispatchEvent(e);
  }, _config2.default.maxAnimationDelay);

  var runOnce = function runOnce(e) {
    clearTimeout(timeoutId);
    // stopPropagation is not working in IE11 and Edge, the transitionend from the Button.js is waiting
    // on the confirm animation to end first and not the Button.js
    e.stopPropagation();
    node.removeEventListener(animationEnd, runOnce);
    callback && callback(e);
  };
  node.addEventListener(animationEnd, runOnce);
}

function preventDuplication(currentData, newObjec) {
  var hasDuplication = false;
  currentData.forEach(function (item) {
    // If the toastr options implicitly specify not to prevent duplicates then skip
    if (item.options.preventDuplicates === false) return;
    // Because the toastr has a unic id we will check by the title and message.
    if (item.title === newObjec.title && item.message === newObjec.message && item.type === newObjec.type) {
      hasDuplication = true;
    }
  });
  return hasDuplication;
}

function updateConfig(obj) {
  Object.keys(_config2.default).forEach(function (key) {
    if (obj.hasOwnProperty(key)) {
      _config2.default[key] = obj[key];
    }
  });
}

function _bind(strinOrAray, scope) {
  var array = strinOrAray;
  if (!Array.isArray(strinOrAray)) {
    array = strinOrAray.split(' ');
  }
  return array.map(function (item) {
    return scope[item] = scope[item].bind(scope);
  });
}

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getCachedRecipientSummary;
/* harmony export (immutable) */ __webpack_exports__["c"] = setCachedRecipientSummary;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearRecipientSummaryCache;
var summaryCache=new Map();var SUMMARY_CACHE_TTL_MS=60*1000;function getCachedRecipientSummary(recipientId){var cached=summaryCache.get(recipientId);if(!cached)return null;if(cached.expiresAt<=Date.now()){summaryCache.delete(recipientId);return null;}return cached.summary;}function setCachedRecipientSummary(recipientId,summary){summaryCache.set(recipientId,{summary:summary,expiresAt:Date.now()+SUMMARY_CACHE_TTL_MS});}function clearRecipientSummaryCache(recipientId){if(recipientId){summaryCache.delete(recipientId);}else{summaryCache.clear();}}

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(350),
    getValue = __webpack_require__(353);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getAllCampaignLists"] = getAllCampaignLists;
/* harmony export (immutable) */ __webpack_exports__["updateCampaignListsSearch"] = updateCampaignListsSearch;
/* harmony export (immutable) */ __webpack_exports__["updateTable"] = updateTable;
/* harmony export (immutable) */ __webpack_exports__["getCampaignLists"] = getCampaignLists;
/* harmony export (immutable) */ __webpack_exports__["createCampaignList"] = createCampaignList;
/* harmony export (immutable) */ __webpack_exports__["getCampaignListDetails"] = getCampaignListDetails;
/* harmony export (immutable) */ __webpack_exports__["clearCampaignListDetails"] = clearCampaignListDetails;
/* harmony export (immutable) */ __webpack_exports__["updateCampaignList"] = updateCampaignList;
/* harmony export (immutable) */ __webpack_exports__["getCampaignListAllParticipants"] = getCampaignListAllParticipants;
/* harmony export (immutable) */ __webpack_exports__["updateParticipantsTable"] = updateParticipantsTable;
/* harmony export (immutable) */ __webpack_exports__["getCampaignListParticipants"] = getCampaignListParticipants;
/* harmony export (immutable) */ __webpack_exports__["removeCampaignListParticipant"] = removeCampaignListParticipant;
/* harmony export (immutable) */ __webpack_exports__["addCampaignListParticipants"] = addCampaignListParticipants;
/* harmony export (immutable) */ __webpack_exports__["getCampaignListPendingParticipants"] = getCampaignListPendingParticipants;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__ = __webpack_require__(16);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function getAllCampaignLists(){var _this=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_CAMPAIGN_LISTS"]});_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaignLists');case 3:response=_context.sent;response.data=response.data.records?response.data.records.map(function(list){return Object.assign({key:list.campaignListId,value:list.name},list);}):[];dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_CAMPAIGN_LISTS"],response:response});case 6:case'end':return _context.stop();}}},_callee,_this);}));return function(_x){return _ref.apply(this,arguments);};}();}function updateCampaignListsSearch(keyword){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGN_LISTS_SEARCH"],keyword:keyword});};}function updateTable(settings){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGN_LISTS_TABLE"],settings:settings});};}function getCampaignLists(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var _this2=this;var results=arguments.length>1&&arguments[1]!==undefined?arguments[1]:12;var sort=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{by:'name',direction:'Ascending'};return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState){var settings,requestId,tableSettings,keyword,params,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:settings={page:page,results:results,sort:sort};dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGN_LISTS_TABLE"],settings:settings});requestId=++getState().campaignListsTable.currentRequestId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_CAMPAIGN_LISTS_TABLE_RECORDS"],requestId:requestId});tableSettings=getState().campaignListsTable;keyword=getState().campaignLists.keyword;params={page:tableSettings.page,sortBy:tableSettings.sort.by,sortDirection:tableSettings.sort.direction,results:tableSettings.resultsView,keyword:keyword};_context2.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaignLists',params);case 9:response=_context2.sent;dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_CAMPAIGN_LISTS_TABLE_RECORDS"]},{response:response,requestId:requestId}));case 11:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x5,_x6){return _ref2.apply(this,arguments);};}();}function createCampaignList(campaignList){var _this3=this;return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_CREATE_CAMPAIGN_LIST"]});_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])("/campaignLists",campaignList);case 3:response=_context3.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CREATE_CAMPAIGN_LIST"],response:response});if(response.success){dispatch(getAllCampaignLists());}case 6:case'end':return _context3.stop();}}},_callee3,_this3);}));return function(_x7){return _ref3.apply(this,arguments);};}();}function getCampaignListDetails(campaignListId){var _this4=this;return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_CAMPAIGN_LIST_DETAILS"]});_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaignLists/'+campaignListId);case 3:response=_context4.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_CAMPAIGN_LIST_DETAILS"],response:response});case 5:case'end':return _context4.stop();}}},_callee4,_this4);}));return function(_x8){return _ref4.apply(this,arguments);};}();}function clearCampaignListDetails(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_CAMPAIGN_LIST_DETAILS"]});dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS"]});};}function updateCampaignList(campaignList){var _this5=this;return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch){var allowDuplicates,campaignListId,managerName,managerEmail,fundId,locationId,campaignListType,response,updatedCampaignList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_CAMPAIGN_LIST_DETAILS"]});allowDuplicates=campaignList.allowDuplicates,campaignListId=campaignList.campaignListId,managerName=campaignList.managerName,managerEmail=campaignList.managerEmail,fundId=campaignList.fundId,locationId=campaignList.locationId,campaignListType=campaignList.campaignListType;_context5.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["e" /* putRequest */])('/campaignLists/'+campaignListId,{allowDuplicates:allowDuplicates,managerName:managerName,managerEmail:managerEmail,fundId:fundId,locationId:locationId,campaignListType:campaignListType});case 4:response=_context5.sent;if(!response.success){_context5.next=10;break;}_context5.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaignLists/'+campaignListId);case 8:updatedCampaignList=_context5.sent;response.data=updatedCampaignList.data;case 10:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGN_LIST_DETAILS"],response:response});if(response.success){dispatch(getAllCampaignLists());}case 12:case'end':return _context5.stop();}}},_callee5,_this5);}));return function(_x9){return _ref5.apply(this,arguments);};}();}function getCampaignListAllParticipants(campaignListId){var _this6=this;return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_CAMPAIGN_LIST_ALL_PARTICIPANTS"]});_context6.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaignLists/'+campaignListId+'/participants');case 3:response=_context6.sent;response.data=response.data?response.data.records||[]:[];dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_CAMPAIGN_LIST_ALL_PARTICIPANTS"],response:response});case 6:case'end':return _context6.stop();}}},_callee6,_this6);}));return function(_x10){return _ref6.apply(this,arguments);};}();}function updateParticipantsTable(settings){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGN_LIST_PARTICIPANTS_TABLE"],settings:settings});};}function getCampaignListParticipants(campaignListId){var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var _this7=this;var results=arguments.length>2&&arguments[2]!==undefined?arguments[2]:12;var sort=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{by:'name',direction:'Ascending'};return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatch,getState){var settings,requestId,tableSettings,params,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:settings={page:page,results:results,sort:sort};dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGN_LIST_PARTICIPANTS_TABLE"],settings:settings});requestId=++getState().campaignListParticipantsTable.currentRequestId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS"],requestId:requestId});tableSettings=getState().campaignListParticipantsTable;params={page:tableSettings.page,sortBy:tableSettings.sort.by,sortDirection:tableSettings.sort.direction,results:tableSettings.resultsView};_context7.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaignLists/'+campaignListId+'/participants',params);case 8:response=_context7.sent;dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS"]},{response:response,requestId:requestId}));case 10:case'end':return _context7.stop();}}},_callee7,_this7);}));return function(_x14,_x15){return _ref7.apply(this,arguments);};}();}function removeCampaignListParticipant(campaignListId,participantId,bypassError,removeFromActiveCampaign){var _this8=this;return function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_REMOVE_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORD"],recordId:campaignListId});_context8.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["a" /* deleteRequest */])('/campaignLists/'+campaignListId+'/participants/'+participantId,{bypassError:bypassError,removeFromActiveCampaign:removeFromActiveCampaign});case 3:response=_context8.sent;response.recordIdKey="applicantId";response.recordId=participantId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["REMOVE_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORD"],response:response});case 7:case'end':return _context8.stop();}}},_callee8,_this8);}));return function(_x16){return _ref8.apply(this,arguments);};}();}function addCampaignListParticipants(campaignListId,recipientIds,bypassError,addToActiveCampaign,getUpdatedListDetails){var _this9=this;return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatch){var response,updatedCampaignList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_ADD_CAMPAIGN_LIST_PARTICIPANT"]});_context9.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/campaignLists/'+campaignListId+'/participants?bypassError='+bypassError,{recipientIds:recipientIds,addToActiveCampaign:addToActiveCampaign});case 3:response=_context9.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["ADD_CAMPAIGN_LIST_PARTICIPANT"],response:response});if(!(getUpdatedListDetails&&response.success)){_context9.next=11;break;}_context9.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaignLists/'+campaignListId);case 8:updatedCampaignList=_context9.sent;response.data=updatedCampaignList.data;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGN_LIST_DETAILS"],response:response});case 11:case'end':return _context9.stop();}}},_callee9,_this9);}));return function(_x17){return _ref9.apply(this,arguments);};}();}function getCampaignListPendingParticipants(campaignListId){var _this10=this;return function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_CAMPAIGN_LIST_PENDING_PARTICIPANTS"]});_context10.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaignLists/'+campaignListId+'/pendingParticipants');case 3:response=_context10.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_CAMPAIGN_LIST_PENDING_PARTICIPANTS"],response:response});case 5:case'end':return _context10.stop();}}},_callee10,_this10);}));return function(_x18){return _ref10.apply(this,arguments);};}();}

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getRecipientSuggestions"] = getRecipientSuggestions;
/* harmony export (immutable) */ __webpack_exports__["clearRecipientSuggestions"] = clearRecipientSuggestions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__ = __webpack_require__(16);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function getRecipientSuggestions(name){var _this=this;var otherInput=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var blackList=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var addressInfo,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_RECIPIENT_SUGGESTIONS"]});addressInfo=otherInput.address?{streetNumber:otherInput.address.streetNumber,street:otherInput.address.street,city:otherInput.address.city,state:otherInput.address.state}:{};delete otherInput.address;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/recipients/suggestions',Object.assign({name:name},otherInput,addressInfo),[]);case 5:response=_context.sent;if(blackList.length){response.data=response.data.filter(function(rec){return blackList.indexOf(rec.applicantId)<0;});}dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_RECIPIENT_SUGGESTIONS"],response:response});case 8:case'end':return _context.stop();}}},_callee,_this);}));return function(_x3){return _ref.apply(this,arguments);};}();}function clearRecipientSuggestions(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_RECIPIENT_SUGGESTIONS"]});};}

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_autosuggest__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_autosuggest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_autosuggest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LoadingSpinner__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AutocompleteInput=function(_React$Component){_inherits(AutocompleteInput,_React$Component);function AutocompleteInput(props){_classCallCheck(this,AutocompleteInput);var _this=_possibleConstructorReturn(this,(AutocompleteInput.__proto__||Object.getPrototypeOf(AutocompleteInput)).call(this,props));var value=_this.props.value&&!_this.props.multi?(_this.props.options[_this.props.options.map(function(o){return o.key;}).indexOf(_this.props.value)]||{}).value||_this.props.overridable&&_this.props.value||'':'';_this.state={value:value,searchValue:'',suggestions:[]};return _this;}//In order to allow this input to get cleared out by external change... would need some more development.  Implement only if becomes necessary.
// componentWillReceiveProps(nextProps) {
//     if(!nextProps.multi && this.state.value && !nextProps.value) {
//         this.setState({ value: '' });
//     }
// }
_createClass(AutocompleteInput,[{key:'onChange',value:function onChange(event,_ref){var _this2=this;var newValue=_ref.newValue;if(this.props.overridable){//non-multi, allow override to custom input.
this.setState({value:newValue},function(){return _this2.props.update(_this2.props.name,newValue);});}else{this.setState({value:'',searchValue:newValue});if((!newValue||this.state.value)&&!this.props.multi){this.props.update(this.props.name,'');}}}},{key:'onSuggest',value:function onSuggest(suggestion){var _this3=this;this.setState({suggestions:this.props.options.filter(function(o){return o.value.toLowerCase().indexOf(suggestion.value.toLowerCase())>=0&&(_this3.props.multi?_this3.props.selection.indexOf(o.key)<0:true);}).sort(function(o1,o2){return o1.value.toLowerCase().indexOf(suggestion.value.toLowerCase())-o2.value.toLowerCase().indexOf(suggestion.value.toLowerCase());})});}},{key:'onSelectSuggestion',value:function onSelectSuggestion(event,_ref2){var suggestion=_ref2.suggestion;this.setState({value:this.props.multi?'':suggestion.value,searchValue:''});this.props.update(this.props.name,this.props.multi?[].concat(_toConsumableArray(this.props.selection),[suggestion.key]):suggestion.key);}},{key:'clearSuggestions',value:function clearSuggestions(){this.setState({suggestions:[]});}},{key:'render',value:function render(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'search-input '+this.props.className},!this.props.overridable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'search'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_autosuggest___default.a,{suggestions:this.state.suggestions,onSuggestionsFetchRequested:this.onSuggest.bind(this),onSuggestionsClearRequested:this.clearSuggestions.bind(this),getSuggestionValue:function getSuggestionValue(s){return s.value;},onSuggestionSelected:this.onSelectSuggestion.bind(this),renderSuggestion:function renderSuggestion(s){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:s.key},s.displayValue||s.value);},shouldRenderSuggestions:function shouldRenderSuggestions(val){return _this4.props.showList?true:val&&val.trim().length;},focusInputOnSuggestionClick:!this.props.showList,inputProps:{tabIndex:this.props.tabIndex||'',disabled:this.props.disabled,placeholder:this.props.placeholder,className:this.props.className,value:this.state.searchValue||this.state.value,onChange:this.onChange.bind(this)}}),this.props.loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__LoadingSpinner__["a" /* default */],{height:'12'}),!this.state.value&&this.state.searchValue&&!this.state.suggestions.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'error-label'},'No suggestions')));}}]);return AutocompleteInput;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AutocompleteInput);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_number_format__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_number_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var israeliTwoDigitCodes=['02','03','04','08','09'];var ValidatedPhoneInput=function(_React$Component){_inherits(ValidatedPhoneInput,_React$Component);function ValidatedPhoneInput(props){_classCallCheck(this,ValidatedPhoneInput);var _this=_possibleConstructorReturn(this,(ValidatedPhoneInput.__proto__||Object.getPrototypeOf(ValidatedPhoneInput)).call(this,props));_this.getPhoneFormat=function(phoneNumber,phoneType){switch(phoneType){case __WEBPACK_IMPORTED_MODULE_2__lib_constants__["g" /* PhoneNumberTypes */].American:return __WEBPACK_IMPORTED_MODULE_2__lib_constants__["f" /* PhoneNumberFormats */].american.format;case __WEBPACK_IMPORTED_MODULE_2__lib_constants__["g" /* PhoneNumberTypes */].Israeli:var number=phoneNumber.replace(/\D/g,'');if(number&&israeliTwoDigitCodes.indexOf(number.substring(0,2))<0){return __WEBPACK_IMPORTED_MODULE_2__lib_constants__["f" /* PhoneNumberFormats */].israeliCell.format;}else{return __WEBPACK_IMPORTED_MODULE_2__lib_constants__["f" /* PhoneNumberFormats */].israeliHouse.format;}default:return"";}};_this.update=function(name,val){var _this$setState;var format=_this.state.format;var value=val;switch(name){case"phoneType":format=_this.getPhoneFormat(_this.state.phoneNumber,value);break;case"phoneNumber":if(_this.state.phoneType===__WEBPACK_IMPORTED_MODULE_2__lib_constants__["g" /* PhoneNumberTypes */].Israeli&&value.value.length>=2){format=_this.getPhoneFormat(value.value,_this.state.phoneType);}value=value.formattedValue;break;default:break;}_this.setState((_this$setState={},_defineProperty(_this$setState,name,value),_defineProperty(_this$setState,'format',format),_this$setState),function(){if(name==="phoneType"||_this.props.error){_this.validatePhoneNumber(_this.state.phoneNumber);}_this.props.onChange(name==="phoneNumber"?_this.props.phoneNumberName:_this.props.phoneTypeName,value);});};_this.checkRequire=function(value){if(_this.props.required){_this.setState({requiredError:!value});}};_this.validatePhoneNumber=function(val){if(!val)return;var phoneNumber=val.replace(/\D/g,'');switch(_this.state.phoneType){case __WEBPACK_IMPORTED_MODULE_2__lib_constants__["g" /* PhoneNumberTypes */].American:_this.validateAndSetError(phoneNumber,__WEBPACK_IMPORTED_MODULE_2__lib_constants__["f" /* PhoneNumberFormats */].american.length);return;case __WEBPACK_IMPORTED_MODULE_2__lib_constants__["g" /* PhoneNumberTypes */].Israeli:if(_this.state.format===__WEBPACK_IMPORTED_MODULE_2__lib_constants__["f" /* PhoneNumberFormats */].israeliHouse.format){_this.validateAndSetError(phoneNumber,__WEBPACK_IMPORTED_MODULE_2__lib_constants__["f" /* PhoneNumberFormats */].israeliHouse.length);}else if(_this.state.format===__WEBPACK_IMPORTED_MODULE_2__lib_constants__["f" /* PhoneNumberFormats */].israeliCell.format){_this.validateAndSetError(phoneNumber,__WEBPACK_IMPORTED_MODULE_2__lib_constants__["f" /* PhoneNumberFormats */].israeliCell.length);}return;case __WEBPACK_IMPORTED_MODULE_2__lib_constants__["g" /* PhoneNumberTypes */].Other:_this.validateAndSetError(phoneNumber,7);return;default:return;}};_this.validateAndSetError=function(val,length){if(!_this.props.updateError)return;if(val.length<length){_this.props.updateError(_this.props.errorName,true);}else{_this.props.updateError(_this.props.errorName,false);}};_this.onBlur=function(){if(_this.state.phoneNumber!==''){_this.validatePhoneNumber(_this.state.phoneNumber);}else if(_this.props.updateError){_this.props.updateError(_this.props.errorName,false);}};_this.state={phoneNumber:props.phoneNumber,phoneType:props.phoneType,format:_this.getPhoneFormat(props.phoneNumber,props.phoneType),requiredError:!props.phoneNumber};return _this;}_createClass(ValidatedPhoneInput,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.phoneNumber!==this.state.phoneNumber){this.setState({phoneNumber:nextProps.phoneNumber});this.checkRequire(nextProps.phoneNumber);}if(nextProps.phoneType!==this.state.phoneType){this.setState({phoneType:nextProps.phoneType,format:this.getPhoneFormat(nextProps.phoneNumber,nextProps.phoneType)});}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,error=_props.error,label=_props.label,span1=_props.span1,span2=_props.span2,showRequiredError=_props.showRequiredError,tabIndex=_props.tabIndex;var _state=this.state,format=_state.format,phoneNumber=_state.phoneNumber,phoneType=_state.phoneType,requiredError=_state.requiredError;var requiredErr=showRequiredError&&requiredError;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'phone-select flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Phone Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'phoneType',value:phoneType,onChange:function onChange(e){return _this2.update(e.target.name,e.target.value);}},Object.keys(__WEBPACK_IMPORTED_MODULE_2__lib_constants__["g" /* PhoneNumberTypes */]).map(function(key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:key,value:__WEBPACK_IMPORTED_MODULE_2__lib_constants__["g" /* PhoneNumberTypes */][key]},key);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-ios-arrow-down'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'phone-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:error||requiredErr?"input-label error-label":"input-label"},label||'Phone',' ',span1,' ',span2),phoneType!=="Other"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_number_format___default.a,{tabIndex:tabIndex||'',mask:'_',placeholder:format,format:format,className:error||requiredErr?"error-input":"",name:'phoneNumber',value:phoneNumber,onFocus:this.onFocus,onBlur:this.onBlur,onValueChange:function onValueChange(values){return _this2.update("phoneNumber",values);},onKeyDown:function onKeyDown(e){if(e.key==='Enter'&&_this2.props.onSubmit)_this2.props.onSubmit();}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_number_format___default.a,{tabIndex:tabIndex||'',format:'####################',name:'phoneNumber',value:phoneNumber,className:error||requiredErr?"error-input":"",onValueChange:function onValueChange(values){return _this2.update("phoneNumber",values);},onFocus:this.onFocus,onBlur:this.onBlur}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_FadeOutErrorMessage__["a" /* default */],{show:error,message:'Please enter a valid phone number.'}))));}}]);return ValidatedPhoneInput;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ValidatedPhoneInput);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(38);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(474);

var _lodash2 = _interopRequireDefault(_lodash);

var _defaults = __webpack_require__(475);

var _defaults2 = _interopRequireDefault(_defaults);

var _propTypes = __webpack_require__(476);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _filterInputAttributes = __webpack_require__(175);

var _filterInputAttributes2 = _interopRequireDefault(_filterInputAttributes);

var _input = __webpack_require__(477);

var _input2 = _interopRequireDefault(_input);

var _suggestList = __webpack_require__(478);

var _suggestList2 = _interopRequireDefault(_suggestList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */

// Escapes special characters in user input for regex
function escapeRegExp(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

/**
 * Entry point for the Geosuggest component
 */

var Geosuggest = function (_React$Component) {
  _inherits(Geosuggest, _React$Component);

  /**
   * The constructor. Sets the initial state.
   * @param  {Object} props The properties object.
   */
  function Geosuggest(props) {
    _classCallCheck(this, Geosuggest);

    var _this = _possibleConstructorReturn(this, (Geosuggest.__proto__ || Object.getPrototypeOf(Geosuggest)).call(this, props));

    _this.onInputChange = function (userInput) {
      if (!userInput) {
        _this.props.onSuggestSelect();
      }
      _this.setState({ userInput: userInput }, _this.onAfterInputChange);
    };

    _this.onAfterInputChange = function () {
      _this.showSuggests();
      _this.props.onChange(_this.state.userInput);
    };

    _this.onInputFocus = function () {
      _this.props.onFocus();
      _this.showSuggests();
    };

    _this.onInputBlur = function () {
      if (!_this.state.ignoreBlur) {
        _this.hideSuggests();
      }
    };

    _this.onNext = function () {
      return _this.activateSuggest('next');
    };

    _this.onPrev = function () {
      return _this.activateSuggest('prev');
    };

    _this.onSelect = function () {
      return _this.selectSuggest(_this.state.activeSuggest);
    };

    _this.onSuggestMouseDown = function () {
      return _this.setState({ ignoreBlur: true });
    };

    _this.onSuggestMouseOut = function () {
      return _this.setState({ ignoreBlur: false });
    };

    _this.onSuggestNoResults = function () {
      _this.props.onSuggestNoResults(_this.state.userInput);
    };

    _this.hideSuggests = function () {
      _this.props.onBlur(_this.state.userInput);
      _this.timer = setTimeout(function () {
        _this.setState({
          isSuggestsHidden: true,
          activeSuggest: null
        });
      }, 100);
    };

    _this.selectSuggest = function (suggest) {
      if (!suggest) {
        suggest = {
          label: _this.state.userInput
        };
      }

      _this.setState({
        isSuggestsHidden: true,
        userInput: _typeof(suggest.label) !== 'object' ? suggest.label : suggest.description
      });

      if (suggest.location) {
        _this.setState({ ignoreBlur: false });
        _this.props.onSuggestSelect(suggest);
        return;
      }

      _this.geocodeSuggest(suggest);
    };

    _this.state = {
      isSuggestsHidden: true,
      isLoading: false,
      userInput: props.initialValue,
      activeSuggest: null,
      suggests: []
    };

    _this.onInputChange = _this.onInputChange.bind(_this);
    _this.onAfterInputChange = _this.onAfterInputChange.bind(_this);

    if (props.queryDelay) {
      _this.onAfterInputChange = (0, _lodash2.default)(_this.onAfterInputChange, props.queryDelay);
    }
    return _this;
  }

  /**
   * Change inputValue if prop changes
   * @param {Object} props The new props
   */


  _createClass(Geosuggest, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (this.props.initialValue !== props.initialValue) {
        this.setState({ userInput: props.initialValue });
      }
    }

    /**
     * Called on the client side after component is mounted.
     * Google api sdk object will be obtained and cached as a instance property.
     * Necessary objects of google api will also be determined and saved.
     */

  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window === 'undefined') {
        return;
      }

      var googleMaps = this.props.googleMaps || window.google && // eslint-disable-line no-extra-parens
      window.google.maps || this.googleMaps;

      /* istanbul ignore next */
      if (!googleMaps) {
        if (console) {
          console.error( // eslint-disable-line no-console
          'Google map api was not found in the page.');
        }
        return;
      }
      this.googleMaps = googleMaps;

      this.autocompleteService = new googleMaps.places.AutocompleteService();
      this.geocoder = new googleMaps.Geocoder();
    }

    /**
     * When the component will unmount
     */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }

    /**
     * When the input changed
     * @param {String} userInput The input value of the user
     */


    /**
     * On After the input got changed
     */


    /**
     * When the input gets focused
     */


    /**
     * When the input gets blurred
     */

  }, {
    key: 'focus',


    /**
     * Focus the input
     */
    value: function focus() {
      this.input.focus();
    }

    /**
     * Blur the input
     */

  }, {
    key: 'blur',
    value: function blur() {
      this.input.blur();
    }

    /**
     * Update the value of the user input
     * @param {String} userInput the new value of the user input
     */

  }, {
    key: 'update',
    value: function update(userInput) {
      this.setState({ userInput: userInput });
      this.props.onChange(userInput);
    }

    /*
     * Clear the input and close the suggestion pane
     */

  }, {
    key: 'clear',
    value: function clear() {
      this.setState({ userInput: '' }, this.hideSuggests);
    }

    /**
     * Search for new suggests
     */

  }, {
    key: 'searchSuggests',
    value: function searchSuggests() {
      var _this2 = this;

      if (!this.state.userInput) {
        this.updateSuggests();
        return;
      }

      var options = {
        input: this.state.userInput
      },
          inputLength = this.state.userInput.length,
          isShorterThanMinLength = inputLength < this.props.minLength;

      if (isShorterThanMinLength) {
        return;
      }

      ['location', 'radius', 'bounds', 'types'].forEach(function (option) {
        if (_this2.props[option]) {
          options[option] = _this2.props[option];
        }
      });

      if (this.props.country) {
        options.componentRestrictions = {
          country: this.props.country
        };
      }

      this.setState({ isLoading: true }, function () {
        _this2.autocompleteService.getPlacePredictions(options, function (suggestsGoogle) {
          _this2.setState({ isLoading: false });
          _this2.updateSuggests(suggestsGoogle || [], // can be null
          function () {
            if (_this2.props.autoActivateFirstSuggest && !_this2.state.activeSuggest) {
              _this2.activateSuggest('next');
            }
          });
        });
      });
    }

    /**
     * Update the suggests
     * @param {Array} suggestsGoogle The new google suggests
     * @param {Function} callback Called once the state has been updated
     */

  }, {
    key: 'updateSuggests',
    value: function updateSuggests() {
      var _this3 = this;

      var suggestsGoogle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var callback = arguments[1];

      var suggests = [],
          userInput = this.state.userInput,
          regex = new RegExp(escapeRegExp(userInput), 'gim'),
          skipSuggest = this.props.skipSuggest,
          maxFixtures = this.props.maxFixtures,
          fixturesSearched = 0,
          activeSuggest = null;

      this.props.fixtures.forEach(function (suggest) {
        if (fixturesSearched >= maxFixtures) {
          return;
        }

        if (!skipSuggest(suggest) && suggest.label.match(regex)) {
          fixturesSearched++;

          suggest.placeId = suggest.label;
          suggest.isFixture = true;
          suggest.matchedSubstrings = {
            offset: suggest.label.indexOf(userInput),
            length: userInput.length
          };
          suggests.push(suggest);
        }
      });

      suggestsGoogle.forEach(function (suggest) {
        if (!skipSuggest(suggest)) {
          suggests.push({
            description: suggest.description,
            label: _this3.props.getSuggestLabel(suggest),
            placeId: suggest.place_id,
            isFixture: false,
            matchedSubstrings: suggest.matched_substrings[0]
          });
        }
      });

      activeSuggest = this.updateActiveSuggest(suggests);

      this.props.onUpdateSuggests(suggests, activeSuggest);
      this.setState({ suggests: suggests, activeSuggest: activeSuggest }, callback);
    }

    /**
     * Return the new activeSuggest object after suggests have been updated
     * @param {Array} suggests The new list of suggests
     * @return {Object} The new activeSuggest
     **/

  }, {
    key: 'updateActiveSuggest',
    value: function updateActiveSuggest() {
      var suggests = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var activeSuggest = this.state.activeSuggest;

      if (activeSuggest) {
        var newSuggest = suggests.filter(function (listedSuggest) {
          return activeSuggest.placeId === listedSuggest.placeId && activeSuggest.isFixture === listedSuggest.isFixture;
        })[0];

        activeSuggest = newSuggest || null;
      }

      return activeSuggest;
    }

    /**
     * Show the suggestions
     */

  }, {
    key: 'showSuggests',
    value: function showSuggests() {
      this.searchSuggests();
      this.setState({ isSuggestsHidden: false });
    }

    /**
     * Hide the suggestions
     */

  }, {
    key: 'activateSuggest',


    /**
     * Activate a new suggest
     * @param {String} direction The direction in which to activate new suggest
     */
    value: function activateSuggest(direction) {
      // eslint-disable-line complexity
      if (this.state.isSuggestsHidden) {
        this.showSuggests();
        return;
      }

      var suggestsCount = this.state.suggests.length - 1,
          next = direction === 'next';
      var newActiveSuggest = null,
          newIndex = 0,
          i = 0;

      for (i; i <= suggestsCount; i++) {
        if (this.state.suggests[i] === this.state.activeSuggest) {
          newIndex = next ? i + 1 : i - 1;
        }
      }

      if (!this.state.activeSuggest) {
        newIndex = next ? 0 : suggestsCount;
      }

      if (newIndex >= 0 && newIndex <= suggestsCount) {
        newActiveSuggest = this.state.suggests[newIndex];
      }

      this.props.onActivateSuggest(newActiveSuggest);

      this.setState({ activeSuggest: newActiveSuggest });
    }

    /**
     * When an item got selected
     * @param {GeosuggestItem} suggest The selected suggest item
     */

  }, {
    key: 'geocodeSuggest',


    /**
     * Geocode a suggest
     * @param  {Object} suggest The suggest
     */
    value: function geocodeSuggest(suggest) {
      var _this4 = this;

      var options = null;
      if (suggest.placeId && !suggest.isFixture) {
        options = {
          placeId: suggest.placeId
        };
      } else {
        options = {
          address: suggest.label,
          location: this.props.location,
          bounds: this.props.bounds,
          componentRestrictions: this.props.country ? { country: this.props.country } : null
        };
      }
      this.geocoder.geocode(options, function (results, status) {
        if (status === _this4.googleMaps.GeocoderStatus.OK) {
          var gmaps = results[0],
              location = gmaps.geometry.location;

          suggest.gmaps = gmaps;
          suggest.location = {
            lat: location.lat(),
            lng: location.lng()
          };
        }
        _this4.props.onSuggestSelect(suggest);
      });
    }

    /**
     * Render the view
     * @return {Function} The React element to render
     */

  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var attributes = (0, _filterInputAttributes2.default)(this.props),
          classes = (0, _classnames2.default)('geosuggest', this.props.className, { 'geosuggest--loading': this.state.isLoading }),
          shouldRenderLabel = this.props.label && attributes.id,
          input = _react2.default.createElement(_input2.default, _extends({ className: this.props.inputClassName,
        ref: function ref(i) {
          return _this5.input = i;
        },
        value: this.state.userInput,
        ignoreEnter: !this.state.isSuggestsHidden,
        ignoreTab: this.props.ignoreTab,
        style: this.props.style.input,
        onChange: this.onInputChange,
        onFocus: this.onInputFocus,
        onBlur: this.onInputBlur,
        onKeyDown: this.props.onKeyDown,
        onKeyPress: this.props.onKeyPress,
        onNext: this.onNext,
        onPrev: this.onPrev,
        onSelect: this.onSelect,
        onEscape: this.hideSuggests }, attributes)),
          suggestionsList = _react2.default.createElement(_suggestList2.default, { isHidden: this.state.isSuggestsHidden,
        style: this.props.style.suggests,
        suggestItemStyle: this.props.style.suggestItem,
        userInput: this.state.userInput,
        isHighlightMatch: this.props.highlightMatch,
        suggestsClassName: this.props.suggestsClassName,
        suggestItemClassName: this.props.suggestItemClassName,
        suggests: this.state.suggests,
        hiddenClassName: this.props.suggestsHiddenClassName,
        suggestItemActiveClassName: this.props.suggestItemActiveClassName,
        activeSuggest: this.state.activeSuggest,
        onSuggestNoResults: this.onSuggestNoResults,
        onSuggestMouseDown: this.onSuggestMouseDown,
        onSuggestMouseOut: this.onSuggestMouseOut,
        onSuggestSelect: this.selectSuggest,
        renderSuggestItem: this.props.renderSuggestItem,
        minLength: this.props.minLength });

      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(
          'div',
          { className: 'geosuggest__input-wrapper' },
          shouldRenderLabel && _react2.default.createElement(
            'label',
            { className: 'geosuggest__label',
              htmlFor: attributes.id },
            this.props.label
          ),
          input
        ),
        _react2.default.createElement(
          'div',
          { className: 'geosuggest__suggests-wrapper' },
          suggestionsList
        )
      );
    }
  }]);

  return Geosuggest;
}(_react2.default.Component);

/**
 * Types for the properties
 * @type {Object}
 */


Geosuggest.propTypes = _propTypes2.default;

/**
 * Default values for the properties
 * @type {Object}
 */
Geosuggest.defaultProps = _defaults2.default;

exports.default = Geosuggest;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(68),
    getRawTag = __webpack_require__(342),
    objectToString = __webpack_require__(343);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 54 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getStatusCounts"] = getStatusCounts;
/* harmony export (immutable) */ __webpack_exports__["filterApplications"] = filterApplications;
/* harmony export (immutable) */ __webpack_exports__["searchApplicants"] = searchApplicants;
/* harmony export (immutable) */ __webpack_exports__["updateTable"] = updateTable;
/* harmony export (immutable) */ __webpack_exports__["toggleSelectApplication"] = toggleSelectApplication;
/* harmony export (immutable) */ __webpack_exports__["clearApplicationsSelection"] = clearApplicationsSelection;
/* harmony export (immutable) */ __webpack_exports__["getApplications"] = getApplications;
/* harmony export (immutable) */ __webpack_exports__["getApplicationsToRecipientIdsMapping"] = getApplicationsToRecipientIdsMapping;
/* harmony export (immutable) */ __webpack_exports__["deleteApplication"] = deleteApplication;
/* harmony export (immutable) */ __webpack_exports__["getApplicationDetails"] = getApplicationDetails;
/* harmony export (immutable) */ __webpack_exports__["updateApplication"] = updateApplication;
/* harmony export (immutable) */ __webpack_exports__["updateApplicationsStatus"] = updateApplicationsStatus;
/* harmony export (immutable) */ __webpack_exports__["revertApplicationStatus"] = revertApplicationStatus;
/* harmony export (immutable) */ __webpack_exports__["wireApplications"] = wireApplications;
/* harmony export (immutable) */ __webpack_exports__["sendACHApplications"] = sendACHApplications;
/* harmony export (immutable) */ __webpack_exports__["voidApplicationPayment"] = voidApplicationPayment;
/* harmony export (immutable) */ __webpack_exports__["addApplicationNote"] = addApplicationNote;
/* harmony export (immutable) */ __webpack_exports__["updateApplicationNote"] = updateApplicationNote;
/* harmony export (immutable) */ __webpack_exports__["deleteApplicationNote"] = deleteApplicationNote;
/* harmony export (immutable) */ __webpack_exports__["updateApplicationAttachments"] = updateApplicationAttachments;
/* harmony export (immutable) */ __webpack_exports__["deleteApplicationReceipt"] = deleteApplicationReceipt;
/* harmony export (immutable) */ __webpack_exports__["updateApplicationReceipts"] = updateApplicationReceipts;
/* harmony export (immutable) */ __webpack_exports__["updateApplicationDetails"] = updateApplicationDetails;
/* harmony export (immutable) */ __webpack_exports__["updateSelectedCounts"] = updateSelectedCounts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RecipientAccountsActions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_recipientSummaryCache__ = __webpack_require__(42);
var getNote=function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(applicationId,noteId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/applications/'+applicationId+'/notes/'+noteId);case 2:return _context13.abrupt('return',_context13.sent);case 3:case'end':return _context13.stop();}}},_callee13,this);}));return function getNote(_x25,_x26){return _ref13.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function getStatusCounts(){var _this=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState){var requestId,filterSettings,params,filterProperty,filterVal,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:requestId=++getState().applications.statusCounts.currentRequestId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_APPLICATION_STATUS_COUNTS"],requestId:requestId});filterSettings=getState().applications.filters;params={paidDaysBack:filterSettings.days.Paid,rejectedDaysBack:filterSettings.days.Rejected};_context.t0=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(filterSettings);case 5:if((_context.t1=_context.t0()).done){_context.next=15;break;}filterProperty=_context.t1.value;if(!(filterProperty!=="status"&&filterProperty!=="days")){_context.next=13;break;}filterVal=filterSettings[filterProperty];if(filterProperty==="recipients"){filterVal=filterSettings.recipients.map(function(rec){return rec.applicantId;});}// Only include hasReceipt if it's explicitly true or false, not null
if(!(filterProperty==="hasReceipt"&&filterVal===null)){_context.next=12;break;}return _context.abrupt('continue',5);case 12:params[filterProperty]=filterVal;case 13:_context.next=5;break;case 15:_context.next=17;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/applications/statusCounts',params);case 17:response=_context.sent;dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_APPLICATION_STATUS_COUNTS"]},{response:response,requestId:requestId}));case 19:case'end':return _context.stop();}}},_callee,_this);}));return function(_x,_x2){return _ref.apply(this,arguments);};}();}function filterApplications(getCounts){var update=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var search=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"";var results=arguments.length>3&&arguments[3]!==undefined?arguments[3]:12;var sort=arguments.length>4&&arguments[4]!==undefined?arguments[4]:{by:'applicationDate',direction:'Descending'};return function(dispatch){if(update&&update.hasOwnProperty("status")){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_APPLICATIONS_TABLE_RECORDS"]});}dispatch({type:update?__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_APPLICATIONS_FILTERS"]:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["RESET_APPLICATIONS_FILTERS"],update:update});dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_APPLICATIONS_TABLE_SELECTION"]});dispatch(getApplications(search,1,results,sort));if(getCounts)dispatch(getStatusCounts());};}function searchApplicants(search){var _this2=this;var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var results=arguments.length>2&&arguments[2]!==undefined?arguments[2]:12;return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState){var filterSettings,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:filterSettings=getState().applications.filters;filterSettings.elasticSearchText=search;if(!(search.length>0)){_context2.next=9;break;}_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/search/applicants',{text:search,page:page,results:results});case 5:response=_context2.sent;filterSettings=Object.assign({},filterSettings,{recipients:response.data&&response.data.results?response.data.results:[],status:null,days:Object.assign({},filterSettings.days,{Recent:""})});_context2.next=10;break;case 9:filterSettings.recipients=[];case 10:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_APPLICATIONS_FILTERS"],update:filterSettings});dispatch(getApplications(page,results));case 12:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x9,_x10){return _ref2.apply(this,arguments);};}();}function updateTable(settings){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_APPLICATIONS_TABLE"],settings:settings});};}function toggleSelectApplication(application){return function(dispatch){dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["TOGGLE_SELECT_APPLICATIONS_TABLE_RECORD"]},{record:application,recordIdKey:'applicationId'}));};}function clearApplicationsSelection(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_APPLICATIONS_TABLE_SELECTION"]});};}function getApplications(){var search=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var _this3=this;var results=arguments.length>2&&arguments[2]!==undefined?arguments[2]:12;var sort=arguments[3];return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch,getState){var filterSettings,settings,tableSettings,requestId,params,filterProperty,filterVal,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:filterSettings=getState().applications.filters;filterSettings.elasticSearchText=search;settings={page:page,results:results,sort:sort||{by:'applicationDate',direction:'Descending'}};dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_APPLICATIONS_TABLE"],settings:settings});tableSettings=getState().applicationsTable;requestId=++getState().applicationsTable.currentRequestId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_APPLICATIONS_TABLE_RECORDS"],requestId:requestId});params={page:tableSettings.page,sortBy:tableSettings.sort.by,sortDirection:tableSettings.sort.direction,results:tableSettings.resultsView};for(filterProperty in filterSettings){filterVal=filterSettings[filterProperty];if(filterProperty==="view"){params.detailed=filterVal===__WEBPACK_IMPORTED_MODULE_6__lib_constants__["k" /* TableViews */].Detailed;}else if(filterProperty==="hasReceipt"){// Only include hasReceipt if it's explicitly true or false, not null
if(filterVal!==null){params[filterProperty]=filterVal;}}else{if(filterProperty==="days"){filterVal=filterSettings.days[filterSettings.status?filterSettings.status:'Recent']||'';}else if(filterProperty==="recipients"){filterVal=filterSettings.recipients.map(function(rec){return rec.applicantId;});}params[filterProperty]=filterVal;}}_context3.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/applications',params);case 11:response=_context3.sent;dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_APPLICATIONS_TABLE_RECORDS"]},{response:response,requestId:requestId}));case 13:case'end':return _context3.stop();}}},_callee3,_this3);}));return function(_x14,_x15){return _ref3.apply(this,arguments);};}();}function getApplicationsToRecipientIdsMapping(campaignId,campaignListId){var _this4=this;return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch,getState){var tableSettings,filterSettings,params,filterProperty,filterVal,response,mapping,_response,_mapping;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_APPLICATIONS_TO_RECIPIENT_IDS_MAPPING"]});tableSettings={};if(campaignId&&campaignListId){tableSettings={sort:{by:'lastOrOrgName',direction:'Ascending'}};}else{tableSettings=campaignId?getState().campaignDetailsIndividualsTable:campaignListId?getState().campaignListParticipantsTable:getState().applicationsTable;}filterSettings=campaignId?!campaignListId?{campaignIndividuals:true,campaigns:[campaignId]}:{campaigns:[campaignId],campaignLists:[campaignListId],applicationStatuses:[getState().campaignListApplications.applicationStatus]}:campaignListId?{campaignListIndividuals:true,campaignLists:[campaignListId]}:getState().applications.filters;params={page:tableSettings.page,sortBy:tableSettings.sort.by,sortDirection:tableSettings.sort.direction};if(campaignListId){params.verbose=false;}_context4.t0=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(filterSettings);case 7:if((_context4.t1=_context4.t0()).done){_context4.next=16;break;}filterProperty=_context4.t1.value;filterVal=filterSettings[filterProperty];if(filterProperty==="days"){filterVal=filterSettings.days[filterSettings.status?filterSettings.status:'Recent']||'';}else if(filterProperty==="recipients"){filterVal=filterSettings.recipients.map(function(rec){return rec.applicantId;});}// Only include hasReceipt if it's explicitly true or false, not null
if(!(filterProperty==="hasReceipt"&&filterVal===null)){_context4.next=13;break;}return _context4.abrupt('continue',7);case 13:params[filterProperty]=filterVal;_context4.next=7;break;case 16:if(!(campaignListId&&!campaignId)){_context4.next=26;break;}_context4.next=19;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaignLists/'+campaignListId+'/participants',params,[]);case 19:response=_context4.sent;mapping={};if(response.data)response.data.forEach(function(ids){return mapping[ids.applicantId]=null;});response.data={mapping:mapping,orderedApplications:response.data.map(function(ids){return ids.applicantId;})};dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_APPLICATIONS_TO_RECIPIENT_IDS_MAPPING"],response:response});_context4.next=33;break;case 26:_context4.next=28;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/applications/recipients',params,[]);case 28:_response=_context4.sent;_mapping={};if(_response.data)_response.data.forEach(function(ids){return _mapping[ids.applicationId]=ids.recipientId;});_response.data={mapping:_mapping,orderedApplications:_response.data.map(function(ids){return ids.applicationId;})};dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_APPLICATIONS_TO_RECIPIENT_IDS_MAPPING"],response:_response});case 33:case'end':return _context4.stop();}}},_callee4,_this4);}));return function(_x16,_x17){return _ref4.apply(this,arguments);};}();}function deleteApplication(applicationId){var _this5=this;return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_REMOVE_APPLICATIONS_TABLE_RECORD"]});_context5.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["a" /* deleteRequest */])('/applications/'+applicationId);case 3:response=_context5.sent;if(response.success)Object(__WEBPACK_IMPORTED_MODULE_7__lib_recipientSummaryCache__["a" /* clearRecipientSummaryCache */])();response.recordIdKey='applicationId';response.recordId=applicationId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["REMOVE_APPLICATIONS_TABLE_RECORD"],response:response});return _context5.abrupt('return',response);case 9:case'end':return _context5.stop();}}},_callee5,_this5);}));return function(_x18){return _ref5.apply(this,arguments);};}();}function getApplicationDetails(applicationId,updateHistory,recipientId){var _this6=this;return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_APPLICATION_DETAILS"]});if(!recipientId){_context6.next=7;break;}_context6.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/applications/'+applicationId,{recipientId:recipientId});case 4:_context6.t0=_context6.sent;_context6.next=10;break;case 7:_context6.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/applications/'+applicationId);case 9:_context6.t0=_context6.sent;case 10:response=_context6.t0;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_APPLICATION_DETAILS"],response:response});if(response.success&&updateHistory){//this is being used for when a user edits an application (not wire/void/print) and have saved a manual check so the total needs to be updated.
//or when a user edits an application and chooses a new source or recipient reference/trusted payee as payee, so isUsedAsPayee needs to be updated for reicpient references.
if(recipientId)dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__RecipientAccountsActions__["getUpdatedRecipientAccountDetails"])(recipientId));dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_APPLICATION_DETAILS"]},{applicationId:applicationId,update:{status:response.data.status,amount:response.data.amount,lastModified:response.data.history?response.data.history[0].date:Date.now(),reason:response.data.reason?response.data.reason.reason:'',currency:response.data.currency}}));}case 13:case'end':return _context6.stop();}}},_callee6,_this6);}));return function(_x19){return _ref6.apply(this,arguments);};}();}function updateApplication(application,update){var _this7=this;return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_APPLICATIONS_TABLE_RECORD"],recordId:application.applicationId});_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["c" /* patchRequest */])('/applications/'+application.applicationId,update);case 3:response=_context7.sent;if(response.success)Object(__WEBPACK_IMPORTED_MODULE_7__lib_recipientSummaryCache__["a" /* clearRecipientSummaryCache */])(application.recipient&&application.recipient.recipientId);response.recordIdKey='applicationId';response.recordId=application.applicationId;response.update=Object.assign({},update,{lastModified:Date.now()});//Note - This code can be optimized.  Data may be out of sync with server being that we are artificially updating lastModified property to avoid additional server request.  
dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_APPLICATIONS_TABLE_RECORD"],response:response});return _context7.abrupt('return',response);case 10:case'end':return _context7.stop();}}},_callee7,_this7);}));return function(_x20){return _ref7.apply(this,arguments);};}();}function updateApplicationsStatus(action,applications){var _this8=this;return function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_APPLICATIONS_STATUS"]});_context8.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/applications/'+action,applications);case 3:response=_context8.sent;if(response.success)Object(__WEBPACK_IMPORTED_MODULE_7__lib_recipientSummaryCache__["a" /* clearRecipientSummaryCache */])();dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_APPLICATIONS_STATUS_COMPLETED"],response:response});case 6:case'end':return _context8.stop();}}},_callee8,_this8);}));return function(_x21){return _ref8.apply(this,arguments);};}();}function revertApplicationStatus(applicationId){var _this9=this;return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_APPLICATIONS_STATUS"]});_context9.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/applications/revertStatus',applicationId);case 3:response=_context9.sent;if(response.success)Object(__WEBPACK_IMPORTED_MODULE_7__lib_recipientSummaryCache__["a" /* clearRecipientSummaryCache */])();dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_APPLICATIONS_STATUS_COMPLETED"],response:response});case 6:case'end':return _context9.stop();}}},_callee9,_this9);}));return function(_x22){return _ref9.apply(this,arguments);};}();}function wireApplications(applicationIds){var _this10=this;return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/applications/wire',applicationIds,[]);case 2:response=_context10.sent;if(response.success)Object(__WEBPACK_IMPORTED_MODULE_7__lib_recipientSummaryCache__["a" /* clearRecipientSummaryCache */])();return _context10.abrupt('return',response);case 5:case'end':return _context10.stop();}}},_callee10,_this10);}));}function sendACHApplications(applicationIds){var _this11=this;return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_SEND_ACH_APPLICATIONS"]});_context11.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/ach/send',applicationIds);case 3:response=_context11.sent;if(response.success)Object(__WEBPACK_IMPORTED_MODULE_7__lib_recipientSummaryCache__["a" /* clearRecipientSummaryCache */])();dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["SEND_ACH_APPLICATIONS_COMPLETED"],response:response});return _context11.abrupt('return',response);case 7:case'end':return _context11.stop();}}},_callee11,_this11);}));return function(_x23){return _ref11.apply(this,arguments);};}();}function voidApplicationPayment(applicationIds){var _this12=this;return function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_VOID_APPLICATION_PAYMENT"]});_context12.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/applications/void',applicationIds);case 3:response=_context12.sent;if(response.success)Object(__WEBPACK_IMPORTED_MODULE_7__lib_recipientSummaryCache__["a" /* clearRecipientSummaryCache */])();dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["VOID_APPLICATION_PAYMENT_COMPLETED"],response:response});case 6:case'end':return _context12.stop();}}},_callee12,_this12);}));return function(_x24){return _ref12.apply(this,arguments);};}();}function addApplicationNote(applicationId,noteText){var _this13=this;return function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(dispatch){var response,note;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_ADD_APPLICATION_NOTE"]});_context14.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/applications/'+applicationId+'/notes',{noteText:noteText});case 3:response=_context14.sent;if(response.success)Object(__WEBPACK_IMPORTED_MODULE_7__lib_recipientSummaryCache__["a" /* clearRecipientSummaryCache */])();if(!response.success){_context14.next=10;break;}_context14.next=8;return getNote(applicationId,response.data);case 8:note=_context14.sent;response.data=note.data;case 10:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["ADD_APPLICATION_NOTE"],response:response});case 11:case'end':return _context14.stop();}}},_callee14,_this13);}));return function(_x27){return _ref14.apply(this,arguments);};}();}function updateApplicationNote(applicationId,noteId,noteText){var _this14=this;return function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(dispatch){var response,note;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_APPLICATION_NOTE"]});_context15.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["e" /* putRequest */])('/applications/'+applicationId+'/notes/'+noteId,{noteText:noteText});case 3:response=_context15.sent;if(response.success)Object(__WEBPACK_IMPORTED_MODULE_7__lib_recipientSummaryCache__["a" /* clearRecipientSummaryCache */])();_context15.next=7;return getNote(applicationId,noteId);case 7:note=_context15.sent;response.data=note.data;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_APPLICATION_NOTE"],response:response});case 10:case'end':return _context15.stop();}}},_callee15,_this14);}));return function(_x28){return _ref15.apply(this,arguments);};}();}function deleteApplicationNote(applicationId,noteId){var _this15=this;return function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_DELETE_APPLICATION_NOTE"]});_context16.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["a" /* deleteRequest */])('/applications/'+applicationId+'/notes/'+noteId);case 3:response=_context16.sent;if(response.success)Object(__WEBPACK_IMPORTED_MODULE_7__lib_recipientSummaryCache__["a" /* clearRecipientSummaryCache */])();dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["DELETE_APPLICATION_NOTE"]},{response:response,noteId:noteId}));case 6:case'end':return _context16.stop();}}},_callee16,_this15);}));return function(_x29){return _ref16.apply(this,arguments);};}();}function updateApplicationAttachments(applicationId,attachments){var _this16=this;return function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(dispatch){var formData,response,updatedAttachments;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_APPLICATION_ATTACHMENTS"]});formData=new FormData();attachments.newAttachments.map(function(attachment){return formData.append('newAttachments',attachment);});attachments.deletedAttachments.map(function(attachment){return formData.append('deletedAttachments',attachment);});_context17.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["e" /* putRequest */])('/applications/'+applicationId+'/attachments',formData,{'Content-Type':'multipart/form-data'},{});case 6:response=_context17.sent;_context17.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/applications/'+applicationId+'/attachments');case 9:updatedAttachments=_context17.sent;response.updatedAttachments=updatedAttachments;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_APPLICATION_ATTACHMENTS"],response:response});case 12:case'end':return _context17.stop();}}},_callee17,_this16);}));return function(_x30){return _ref17.apply(this,arguments);};}();}function deleteApplicationReceipt(applicationId,receiptId){var _this17=this;return function(){var _ref18=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(dispatch){var response,updatedReceipts;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_APPLICATION_RECEIPTS"]});_context18.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["a" /* deleteRequest */])('/applications/'+applicationId+'/receipts/'+receiptId);case 3:response=_context18.sent;if(!response.success){_context18.next=9;break;}_context18.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/applications/'+applicationId+'/receipts');case 7:updatedReceipts=_context18.sent;response.updatedReceipts=updatedReceipts;case 9:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_APPLICATION_RECEIPTS"],response:response});case 10:case'end':return _context18.stop();}}},_callee18,_this17);}));return function(_x31){return _ref18.apply(this,arguments);};}();}function updateApplicationReceipts(applicationId,receipts){var _this18=this;return function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(dispatch){var formData,response,updatedReceipts;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_APPLICATION_RECEIPTS"]});formData=new FormData();// Append receipts
if(receipts.newReceipts&&Array.isArray(receipts.newReceipts)){receipts.newReceipts.forEach(function(receipt){formData.append('receipts',receipt);});}_context19.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["e" /* putRequest */])('/applications/'+applicationId+'/receipts',formData,{},{});case 5:response=_context19.sent;if(!response.success){_context19.next=11;break;}_context19.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/applications/'+applicationId+'/receipts');case 9:updatedReceipts=_context19.sent;response.updatedReceipts=updatedReceipts;case 11:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_APPLICATION_RECEIPTS"],response:response});case 12:case'end':return _context19.stop();}}},_callee19,_this18);}));return function(_x32){return _ref19.apply(this,arguments);};}();}function updateApplicationDetails(applicationId,application){var _this19=this;var bypass=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return function(){var _ref20=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20(dispatch){var formData,flatObj,prop,url,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_APPLICATION"]});formData=new FormData();flatObj=Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils__["h" /* flattenObj */])(application);for(prop in flatObj){formData.append(prop,flatObj[prop]!==null?flatObj[prop]:'');}application.newAttachments.map(function(attachment){return formData.append('newAttachments',attachment);});application.deletedAttachments.map(function(attachment){return formData.append('deletedAttachments',attachment);});url=bypass===true?'/applications/'+applicationId+'?bypassError='+bypass:'/applications/'+applicationId;_context20.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["e" /* putRequest */])(url,formData,{'Content-Type':'multipart/form-data'},{});case 9:response=_context20.sent;if(response.success)Object(__WEBPACK_IMPORTED_MODULE_7__lib_recipientSummaryCache__["a" /* clearRecipientSummaryCache */])();dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_APPLICATION"],response:response});case 12:case'end':return _context20.stop();}}},_callee20,_this19);}));return function(_x34){return _ref20.apply(this,arguments);};}();}function updateSelectedCounts(selectedApplications,userProfile,funds){return function(dispatch){var counts=calculateActionCounts(selectedApplications,userProfile,funds);dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_SELECTED_COUNTS"],counts:counts});};}function calculateActionCounts(selectedApplications,userProfile,funds){var isUSUser=userProfile.departments&&userProfile.departments.indexOf(__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["g" /* Departments */].US)>=0;var isIsraelUser=userProfile.departments&&userProfile.departments.indexOf(__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["g" /* Departments */].IL)>=0;var checkCount=0;var achCount=0;var wireCount=0;selectedApplications.forEach(function(app){var hasEligibleRecipient=app.recipient&&app.recipient.hasAchAccount===true&&app.recipient.applicantType===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["l" /* RecipientTypes */].Organization;if(app.currency===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["f" /* CurrencyTypes */].Dollar&&isUSUser){if(hasEligibleRecipient&&app.payTo==="Recipient"&&app.fundAllowsACH===true){achCount++;checkCount++;}else{checkCount++;}}else if(app.currency===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["f" /* CurrencyTypes */].Shekel&&isIsraelUser){wireCount++;}});return{check:checkCount,ach:achCount,wire:wireCount};}

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_geosuggest__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_geosuggest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_geosuggest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddressModal__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GeoSuggestWrapper__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ManualAddress__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddressAutocomplete=function(_NavigationComponent){_inherits(AddressAutocomplete,_NavigationComponent);function AddressAutocomplete(props){_classCallCheck(this,AddressAutocomplete);var _this=_possibleConstructorReturn(this,(AddressAutocomplete.__proto__||Object.getPrototypeOf(AddressAutocomplete)).call(this,props));_this.noSuggestionsError='noSuggestionsError';_this.invalidAddressError='invalidAddressError';_this.invalidAddressCity='invalidAddressCity';_this.skipSuggestion=function(suggestion){var isIsrael=_this.props.isIsraeli;var terms=suggestion.terms||[];var lastTerm=terms.length>0?terms[terms.length-1].value:'';var allowedTypes=['geocode','street_address','premise','route','subpremise','locality'];var hasAllowedType=suggestion.types.some(function(type){return allowedTypes.includes(type);});if(!hasAllowedType)return true;if(isIsrael&&lastTerm!=='ישראל')return true;if(!isIsrael&&lastTerm==='Israel')return true;return false;};_this.state={noSuggestionsError:false,invalidAddressError:false,invalidAddressCity:false,showModals:{addressNotFound:false},addressLabel:!_this.props.address?'':_this.props.address.isManual?Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["b" /* concatenateAddressLabel */])(_this.props.address):Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["c" /* concatenateGeosuggestLabel */])(_this.props.address)};_this.clearAllErrors=_this.clearAllErrors.bind(_this);_this.updateSuggestions=_this.updateSuggestions.bind(_this);_this.noSuggestions=_this.noSuggestions.bind(_this);_this.onSuggestSelect=_this.onSuggestSelect.bind(_this);_this.updateErrors=_this.updateErrors.bind(_this);return _this;}_createClass(AddressAutocomplete,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.state.addressLabel&&Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["e" /* deepEquals */])(nextProps.address,{}))this.setState({addressLabel:''});}},{key:'clearAllErrors',value:function clearAllErrors(){if(this.state.noSuggestionsError)this.updateErrors(this.noSuggestionsError,false);else if(this.state.invalidAddressError){this.updateErrors(this.invalidAddressError,false);}else if(this.state.invalidAddressCity)this.updateErrors(this.invalidAddressCity,false);}},{key:'updateSuggestions',value:function updateSuggestions(suggestions){if(suggestions.length&&this.state.addressLabel)this.clearAllErrors();}},{key:'noSuggestions',value:function noSuggestions(){if(this._geoSuggest.props.value!==''){this.updateErrors(this.noSuggestionsError,true);}}},{key:'onBlur',value:function onBlur(){if((Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["e" /* deepEquals */])(this.props.address,{})||Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["e" /* deepEquals */])({streetNumber:this.props.address.streetNumber,street:this.props.address.street,city:this.props.address.city,state:this.props.address.state,zip:this.props.address.zip,country:this.props.address.country},{streetNumber:'',street:'',city:'',state:'',zip:'',country:''}))&&this.state.addressLabel&&!this.state.noSuggestionsError&&!this.state.invalidAddressCity){this.updateErrors(this.invalidAddressError,true);}else if(this.state.invalidAddressError){this.updateErrors(this.invalidAddressError,false);}}},{key:'saveManualAddress',value:function saveManualAddress(address){this.toggleModal('addressNotFound');this.setState({addressLabel:Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["b" /* concatenateAddressLabel */])(Object.assign({},address,{unitType:address.unitType?this.props.unitTypes.filter(function(type){return type.key===address.unitType;}).length?this.props.unitTypes.filter(function(type){return type.key===address.unitType;})[0].value:'':''||''}),this.props.isIsraeli)});var validCity=true;if(this.props.validateAddress)validCity=this.props.validateAddress(address);if(!validCity){this.updateErrors(this.invalidAddressCity,true);}else if(this.state.invalidAddressCity)this.updateErrors(this.invalidAddressCity,false);this.props.updateAddress(Object.assign({},address,{isManual:true}));}},{key:'clearManualAddress',value:function clearManualAddress(){this.setState({addressLabel:''});this.clearAllErrors();this.props.updateAddress(Object.assign({},this.props.address,{streetNumber:'',street:'',unitType:'',apartment:'',city:'',state:'',zip:'',country:'',isManual:false}));}},{key:'clearAndShowAddressModal',value:function clearAndShowAddressModal(){var _this2=this;this.props.updateAddress(Object.assign({},this.props.address,{streetNumber:'',street:'',unitType:'',apartment:'',city:'',state:'',zip:'',country:''}));this.setState({addressLabel:'',noSuggestionsError:false,invalidAddressError:false,invalidAddressCity:false},function(){_this2.props.updateError(false);_this2.toggleModal('addressNotFound');});}},{key:'updateAddressLabel',value:function updateAddressLabel(e){this.props.updateAddress(Object.assign({},this.props.address,{streetNumber:'',street:'',city:'',state:'',zip:'',country:''}));this.setState({addressLabel:e});if(!e)this.clearAllErrors();}},{key:'onSuggestSelect',value:function onSuggestSelect(suggestion){if(suggestion&&suggestion.gmaps&&suggestion.gmaps.address_components){var address_components=suggestion.gmaps.address_components;var address=Object.assign({},this.props.address);address.streetNumber=address_components.find(function(obj){return obj.types.includes('street_number');})?address_components.find(function(obj){return obj.types.includes('street_number');}).long_name:'';address.street=address_components.find(function(obj){return obj.types.includes('route');})?address_components.find(function(obj){return obj.types.includes('route');}).long_name:'';address.city=address_components.find(function(obj){return obj.types.includes('locality');})?address_components.find(function(obj){return obj.types.includes('locality');}).long_name:''||address_components.find(function(obj){return obj.types.includes('sublocality');})?address_components.find(function(obj){return obj.types.includes('sublocality');}).long_name:'';address.state=address_components.find(function(obj){return obj.types.includes('administrative_area_level_1');})?address_components.find(function(obj){return obj.types.includes('administrative_area_level_1');}).long_name:'';address.country=address_components.find(function(obj){return obj.types.includes('country');})?address_components.find(function(obj){return obj.types.includes('country');}).long_name:'';address.zip=address_components.find(function(obj){return obj.types.includes('postal_code');})?address_components.find(function(obj){return obj.types.includes('postal_code');}).long_name:'';var validCity=true;if(this.props.validateAddress)validCity=this.props.validateAddress(address);if(!validCity||!address.streetNumber||!address.street||!address.country){if(validCity){this.updateErrors(this.invalidAddressError,true);}else{this.updateErrors(this.invalidAddressCity,true);}this.setState({addressLabel:Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["c" /* concatenateGeosuggestLabel */])(address,this.props.isIsraeli)});this.props.updateAddress(Object.assign({},this.props.address,{streetNumber:'',street:'',city:'',state:'',zip:'',country:''}));this._geoSuggest.blur();return;}else if(this.state.invalidAddressError)this.updateErrors(this.invalidAddressError,false);else if(this.state.invalidAddressCity)this.updateErrors(this.invalidAddressCity,false);this.setState({addressLabel:suggestion.label?Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["c" /* concatenateGeosuggestLabel */])(address,this.props.isIsraeli):''});this.props.updateAddress(Object.assign({},this.props.address,address));this._geoSuggest.blur();}}},{key:'updateAddressComponent',value:function updateAddressComponent(e){this.props.updateAddress(Object.assign({},this.props.address,_defineProperty({},e.target.name,e.target.value)));}},{key:'updateErrors',value:function updateErrors(errorName,value){var _this3=this;if(errorName===this.invalidAddressError&&!this.state.noSuggestionsError||errorName===this.invalidAddressCity&&!this.state.noSuggestionsError||errorName===this.noSuggestionsError){this.setState(_defineProperty({},errorName,value),function(){if(_this3.state.invalidAddressError||_this3.state.noSuggestionsError||_this3.state.invalidAddressCity)_this3.props.updateError(true);else _this3.props.updateError(false);});}}},{key:'render',value:function render(){var _this4=this;var requiredErr=this.props.showRequiredError&&this.props.required&&(!this.props.address.streetNumber||!this.props.address.street||!this.props.address.city||!this.props.address.country);var validationErr=this.state.noSuggestionsError||this.state.invalidAddressError||this.state.invalidAddressCity;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__GeoSuggestWrapper__["a" /* default */],{isIsraeli:this.props.isIsraeli},!this.props.hide&&(//for cases when need to render GeosuggestWrapper in order to update script, but don't want to show input
this.props.address.isManual?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ManualAddress__["a" /* default */],{clearAddress:this.clearManualAddress.bind(this),editAddress:this.toggleModal.bind(this,'addressNotFound'),manualLabel:this.state.addressLabel,addAddressLabel:this.props.addAddressLabel,showError:this.props.showRequiredError&&this.props.required,invalidAddressCity:this.state.invalidAddressCity,incomplete:!this.props.address.streetNumber||!this.props.address.street||!this.props.address.city||!this.props.address.country}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address-autocomplete'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label '+(validationErr||requiredErr?'error-label':'')},this.props.title||'Address',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link-text small-text',onClick:this.clearAndShowAddressModal.bind(this)},'Address Not Found?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_geosuggest___default.a,{inputClassName:validationErr||requiredErr?'error-input':'',tabIndex:this.props.tabIndex||'',ignoreTab:true,placeholder:'Enter Address',queryDelay:250,autoComplete:'on',ref:function ref(el){return _this4._geoSuggest=el;},value:this.state.addressLabel,initialValue:this.state.addressLabel,onChange:this.updateAddressLabel.bind(this),onUpdateSuggests:this.updateSuggestions,onBlur:this.onBlur.bind(this),skipSuggest:this.skipSuggestion,onFocus:this.clearAllErrors,onSuggestSelect:this.onSuggestSelect,types:['geocode','establishment'],onSuggestNoResults:this.noSuggestions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__util_FadeOutErrorMessage__["a" /* default */],{show:this.state.noSuggestionsError,message:'No suggestions, use address not found.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__util_FadeOutErrorMessage__["a" /* default */],{show:this.state.invalidAddressError,message:'Invalid Address'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__util_FadeOutErrorMessage__["a" /* default */],{show:this.state.invalidAddressCity,message:'Invalid address, city must be included in the associated location group.'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Unit Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__util_Select__["a" /* default */],{clearable:true,tabIndex:this.props.tabIndex?this.props.tabIndex+5:'',options:this.props.unitTypes,name:'unitType',value:this.props.address.unitType||'',onChange:this.updateAddressComponent.bind(this)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Unit #'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.address.apartment||'',tabIndex:this.props.tabIndex?this.props.tabIndex+10:'',onChange:this.updateAddressComponent.bind(this),name:'apartment'})),this.props.addAddressLabel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},this.props.addAddressLabel))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AddressModal__["a" /* default */],{modalShowing:this.state.showModals.addressNotFound,address:this.props.address,closeModal:this.toggleModal.bind(this,'addressNotFound'),onChange:this.onChange,saveAddress:this.saveManualAddress.bind(this),unitTypes:this.props.unitTypes,streetNames:this.props.streetNames}));}}]);return AddressAutocomplete;}(__WEBPACK_IMPORTED_MODULE_7__util_NavigationComponent__["a" /* default */]);function mapStateToProps(state,ownProps){return{unitTypes:state.settings.systemSettings.data.otherSettings.unitTypes,streetNames:state.settings.systemSettings.data.otherSettings.streetNames};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,null)(AddressAutocomplete));//props:
//address (obj), updateAddress (func), udpateError (func), unitTypes (array), required (bool), showRequiredError (bool)
//optional props: validateAddress (func), hideNotFound (bool)

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_UtilsActions__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_constants__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GeoSuggestWrapper=function(_React$Component){_inherits(GeoSuggestWrapper,_React$Component);function GeoSuggestWrapper(props){_classCallCheck(this,GeoSuggestWrapper);var _this=_possibleConstructorReturn(this,(GeoSuggestWrapper.__proto__||Object.getPrototypeOf(GeoSuggestWrapper)).call(this,props));_this.updateLanguage=_this.updateLanguage.bind(_this);return _this;}_createClass(GeoSuggestWrapper,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.isIsraeli!==this.props.isIsraeli&&(nextProps.isIsraeli&&this.props.languageSettings.language!=='iw'||!nextProps.isIsraeli&&this.props.languageSettings.language==='iw')){this.updateLanguage(nextProps.isIsraeli?__WEBPACK_IMPORTED_MODULE_5__lib_constants__["b" /* LanguageTypes */].Hebrew:__WEBPACK_IMPORTED_MODULE_5__lib_constants__["b" /* LanguageTypes */].English);}}},{key:'updateLanguage',value:function updateLanguage(lang){window.google=undefined;this.props.actions.updateGeosuggestLanguageSettings({language:lang,loading:true});}},{key:'componentWillMount',value:function componentWillMount(){//need this bec cwrp isn't called on the initial "render" the first time props are passed through, 
// and that doesn't work for the edit application/recipient details.
if(this.props.isIsraeli&&this.props.languageSettings.language!==__WEBPACK_IMPORTED_MODULE_5__lib_constants__["b" /* LanguageTypes */].Hebrew||!this.props.isIsraeli&&this.props.languageSettings.language!==__WEBPACK_IMPORTED_MODULE_5__lib_constants__["b" /* LanguageTypes */].English){this.updateLanguage(this.props.isIsraeli?__WEBPACK_IMPORTED_MODULE_5__lib_constants__["b" /* LanguageTypes */].Hebrew:__WEBPACK_IMPORTED_MODULE_5__lib_constants__["b" /* LanguageTypes */].English);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-width'},window.google&&!this.props.languageSettings.loading?this.props.children:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__util_LoadingSpinner__["a" /* default */],{height:'12'}));}}]);return GeoSuggestWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);function mapStateToProps(state){return{languageSettings:state.utils.geosuggestLanguageSettings};}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({updateGeosuggestLanguageSettings:__WEBPACK_IMPORTED_MODULE_3__redux_actions_UtilsActions__["a" /* updateGeosuggestLanguageSettings */]},dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(GeoSuggestWrapper));

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_constants__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IncompleteApplicationWarning=function(_React$Component){_inherits(IncompleteApplicationWarning,_React$Component);function IncompleteApplicationWarning(props){_classCallCheck(this,IncompleteApplicationWarning);var _this=_possibleConstructorReturn(this,(IncompleteApplicationWarning.__proto__||Object.getPrototypeOf(IncompleteApplicationWarning)).call(this,props));_this.renderMissingFields=_this.renderMissingFields.bind(_this);return _this;}_createClass(IncompleteApplicationWarning,[{key:'renderMissingFields',value:function renderMissingFields(title,values){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'bold-text'},'Missing ',title,' '),values.map(function(field,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{key:index},' ',field);}));}},{key:'render',value:function render(){var _props=this.props,allowIncomplete=_props.allowIncomplete,fields=_props.fields,viewOnly=_props.viewOnly;var types=[];if(fields.recipientInfo&&fields.recipientInfo.length||fields.incompleteApplicationDueToRecipient)types.push(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["a" /* IncompleteTypes */].Recipient);if(fields.applicationInfo&&fields.applicationInfo.length||fields.paymentInfo&&fields.paymentInfo.length)types.push(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["a" /* IncompleteTypes */].Application);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accent-box-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accent-box application-warning'},!viewOnly&&(allowIncomplete?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'application-warning-header flex-center flex-justify'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'application-warning-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-android-warning'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,types.join(" and "),' ',types.length>1?"are":"is",' incomplete',types.indexOf(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["a" /* IncompleteTypes */].Application)<0&&fields.incompleteApplicationDueToRecipient?", and this application is therefore considered incomplete as well.  ":".  ",'Would you like to save anyways and come back later?'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-center application-warning-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-android-warning'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,types.join(" and "),' cannot be updated without the following required fields.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'accent-box-warnings'},fields.recipientInfo&&fields.recipientInfo.length>0&&(viewOnly&&fields.incompleteApplicationDueToRecipient?"This application is incomplete due to incomplete recipient information.":this.renderMissingFields('Recipient Info',fields.recipientInfo)),fields.paymentInfo&&fields.paymentInfo.length>0&&this.renderMissingFields('Payment Info',fields.paymentInfo),fields.applicationInfo&&fields.applicationInfo.length>0&&this.renderMissingFields('Application Info',fields.applicationInfo))));}}]);return IncompleteApplicationWarning;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (IncompleteApplicationWarning);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(51);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getApprovers"] = getApprovers;
/* harmony export (immutable) */ __webpack_exports__["updateTable"] = updateTable;
/* harmony export (immutable) */ __webpack_exports__["getUsers"] = getUsers;
/* harmony export (immutable) */ __webpack_exports__["getUserDetails"] = getUserDetails;
/* harmony export (immutable) */ __webpack_exports__["getUserPermissions"] = getUserPermissions;
/* harmony export (immutable) */ __webpack_exports__["getPermissionsForRole"] = getPermissionsForRole;
/* harmony export (immutable) */ __webpack_exports__["clearUserDetailsAndPermissions"] = clearUserDetailsAndPermissions;
/* harmony export (immutable) */ __webpack_exports__["createUser"] = createUser;
/* harmony export (immutable) */ __webpack_exports__["updateUser"] = updateUser;
/* harmony export (immutable) */ __webpack_exports__["updateUserDetail"] = updateUserDetail;
/* harmony export (immutable) */ __webpack_exports__["updateCurrentUserDefaultPrinter"] = updateCurrentUserDefaultPrinter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserProfileActions__ = __webpack_require__(89);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function getApprovers(){var _this=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_APPROVERS"]});_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])("/users/filtered",{permissions:[__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsApproveFull,__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsApproveLimited],active:true});case 3:response=_context.sent;response.data=response.data.records?response.data.records.map(function(user){return{key:user.userId,value:user.name,departments:user.departments};}):[];dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_APPROVERS"],response:response});case 6:case'end':return _context.stop();}}},_callee,_this);}));return function(_x){return _ref.apply(this,arguments);};}();}function updateTable(settings){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_USERS_TABLE"],settings:settings});};}function getUsers(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var _this2=this;var results=arguments.length>1&&arguments[1]!==undefined?arguments[1]:12;var sort=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{by:'name',direction:'Ascending'};return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState){var settings,requestId,tableSettings,params,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:settings={page:page,results:results,sort:sort};dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_USERS_TABLE"],settings:settings});requestId=++getState().usersTable.currentRequestId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_USERS_TABLE_RECORDS"],requestId:requestId});tableSettings=getState().usersTable;params={verbose:true,page:tableSettings.page,sortBy:tableSettings.sort.by,sortDirection:tableSettings.sort.direction,results:tableSettings.resultsView};_context2.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/users',params);case 8:response=_context2.sent;dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_USERS_TABLE_RECORDS"]},{response:response,requestId:requestId}));case 10:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x5,_x6){return _ref2.apply(this,arguments);};}();}function getUserDetails(userId){var _this3=this;return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_USER_DETAILS"]});_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/users/'+userId);case 3:response=_context3.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_USER_DETAILS"],response:response});case 5:case'end':return _context3.stop();}}},_callee3,_this3);}));return function(_x7){return _ref3.apply(this,arguments);};}();}function getUserPermissions(userId){var _this4=this;var myPermissions=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_USER_PERMISSIONS"],myPermissions:myPermissions});_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/users/'+userId+'/permissions',null,[]);case 3:response=_context4.sent;dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_USER_PERMISSIONS"]},{response:response,myPermissions:myPermissions}));case 5:case'end':return _context4.stop();}}},_callee4,_this4);}));return function(_x9){return _ref4.apply(this,arguments);};}();}function getPermissionsForRole(roleId){var _this5=this;return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_PERMISSIONS_FOR_ROLE"]});_context5.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/settings/permissions/'+roleId,null,[]);case 3:response=_context5.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_PERMISSIONS_FOR_ROLE"],response:response});case 5:case'end':return _context5.stop();}}},_callee5,_this5);}));return function(_x10){return _ref5.apply(this,arguments);};}();}function clearUserDetailsAndPermissions(){return function(dispatch){return dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_USER_DETAILS_AND_PERMISSIONS"]});};}function createUser(user){var _this6=this;return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_CREATE_USER"]});_context6.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/users',{setPasswordUrl:window.location.origin+'/set-password',user:user});case 3:response=_context6.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CREATE_USER"],response:response});if(response.success)dispatch(getApprovers());case 6:case'end':return _context6.stop();}}},_callee6,_this6);}));return function(_x11){return _ref6.apply(this,arguments);};}();}function updateUser(userId,user,replacementApproverId){var _this7=this;return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatch,getState){var userObj,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_USER"]});userObj={user:user};if(replacementApproverId)userObj.replacementApproverId=replacementApproverId;_context7.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["e" /* putRequest */])('/users/'+userId,userObj);case 5:response=_context7.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_USER"],response:response});if(response.success){dispatch(getApprovers());if(userId===getState().userProfile.profile.data.userId)dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__UserProfileActions__["getUserProfileAndPermissions"])(1));}case 8:case'end':return _context7.stop();}}},_callee7,_this7);}));return function(_x12,_x13){return _ref7.apply(this,arguments);};}();}function updateUserDetail(userId,update,replacementApproverId){var _this8=this;return function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatch,getState){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_USER_DETAIL"]});_context8.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["c" /* patchRequest */])('/users/'+userId+(replacementApproverId?'?replacementApproverId='+replacementApproverId:''),update);case 3:response=_context8.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_USER_DETAIL"],response:response});response.recordIdKey='userId';response.recordId=userId;response.update=update;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_USERS_TABLE_RECORD"],response:response});if(response.success){dispatch(getApprovers());if(userId===getState().userProfile.profile.data.userId)dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_USER_PROFILE"],update:update});//no need to reload profile for single property update, can just update the property
}case 10:case'end':return _context8.stop();}}},_callee8,_this8);}));return function(_x14,_x15){return _ref8.apply(this,arguments);};}();}function updateCurrentUserDefaultPrinter(defaultPrinterId){var _this9=this;return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["e" /* putRequest */])('/users/me/default-printer',{defaultPrinterId:defaultPrinterId});case 2:response=_context9.sent;if(response.success){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_USER_PROFILE"],update:{defaultPrinterId:response.data.defaultPrinterId}});}return _context9.abrupt('return',response);case 5:case'end':return _context9.stop();}}},_callee9,_this9);}));return function(_x16){return _ref9.apply(this,arguments);};}();}

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateGeosuggestLanguageSettings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(9);
function updateGeosuggestLanguageSettings(setting){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_GEOSUGGEST_SETTINGS"],setting:setting});};}

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SplitPageContainer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function SplitPageContainer(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("header",{className:"split-page-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/images/logo.png",alt:"logo",className:"logo"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page split-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"left-column"},props.children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gradient"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,props.subtitle)))));}

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getCampaigns"] = getCampaigns;
/* harmony export (immutable) */ __webpack_exports__["updateFilters"] = updateFilters;
/* harmony export (immutable) */ __webpack_exports__["updateTable"] = updateTable;
/* harmony export (immutable) */ __webpack_exports__["getCampaignRecords"] = getCampaignRecords;
/* harmony export (immutable) */ __webpack_exports__["createCampaign"] = createCampaign;
/* harmony export (immutable) */ __webpack_exports__["getCampaignDetails"] = getCampaignDetails;
/* harmony export (immutable) */ __webpack_exports__["clearCampaignDetails"] = clearCampaignDetails;
/* harmony export (immutable) */ __webpack_exports__["updateCampaign"] = updateCampaign;
/* harmony export (immutable) */ __webpack_exports__["getCampaignAllLists"] = getCampaignAllLists;
/* harmony export (immutable) */ __webpack_exports__["getCampaignAllIndividuals"] = getCampaignAllIndividuals;
/* harmony export (immutable) */ __webpack_exports__["updateIndividualsTable"] = updateIndividualsTable;
/* harmony export (immutable) */ __webpack_exports__["getIndividuals"] = getIndividuals;
/* harmony export (immutable) */ __webpack_exports__["addIndividual"] = addIndividual;
/* harmony export (immutable) */ __webpack_exports__["updateIndividual"] = updateIndividual;
/* harmony export (immutable) */ __webpack_exports__["removeIndividual"] = removeIndividual;
/* harmony export (immutable) */ __webpack_exports__["deleteCampaign"] = deleteCampaign;
/* harmony export (immutable) */ __webpack_exports__["toggleSelectIndividual"] = toggleSelectIndividual;
/* harmony export (immutable) */ __webpack_exports__["updateListsTable"] = updateListsTable;
/* harmony export (immutable) */ __webpack_exports__["getLists"] = getLists;
/* harmony export (immutable) */ __webpack_exports__["addList"] = addList;
/* harmony export (immutable) */ __webpack_exports__["updateList"] = updateList;
/* harmony export (immutable) */ __webpack_exports__["removeList"] = removeList;
/* harmony export (immutable) */ __webpack_exports__["getCampaignListExternalUpdates"] = getCampaignListExternalUpdates;
/* harmony export (immutable) */ __webpack_exports__["getReceivingParticipants"] = getReceivingParticipants;
/* harmony export (immutable) */ __webpack_exports__["clearReceivingParticipants"] = clearReceivingParticipants;
/* harmony export (immutable) */ __webpack_exports__["verifyCampaignListExternalUpdates"] = verifyCampaignListExternalUpdates;
/* harmony export (immutable) */ __webpack_exports__["approveCampaignList"] = approveCampaignList;
/* harmony export (immutable) */ __webpack_exports__["resendExternalCampaignListMessage"] = resendExternalCampaignListMessage;
/* harmony export (immutable) */ __webpack_exports__["updateCampaignListApplicationsTable"] = updateCampaignListApplicationsTable;
/* harmony export (immutable) */ __webpack_exports__["clearCampaignListApplications"] = clearCampaignListApplications;
/* harmony export (immutable) */ __webpack_exports__["getCampaignListApplications"] = getCampaignListApplications;
/* harmony export (immutable) */ __webpack_exports__["updateCampaignListApplicationsStatus"] = updateCampaignListApplicationsStatus;
/* harmony export (immutable) */ __webpack_exports__["updateCampaignListApplication"] = updateCampaignListApplication;
/* harmony export (immutable) */ __webpack_exports__["updateApplicationStatus"] = updateApplicationStatus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SettingsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_orderBy__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_orderBy__);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function getCampaigns(){var _this=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_CAMPAIGNS"]});_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])("/campaigns");case 3:response=_context.sent;response.data=response.data.records?response.data.records.map(function(campaign){return{key:campaign.campaignId,value:campaign.name};}):[];dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_CAMPAIGNS"],response:response});case 6:case'end':return _context.stop();}}},_callee,_this);}));return function(_x){return _ref.apply(this,arguments);};}();}function updateFilters(update){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGNS_FILTERS"],update:update});};}function updateTable(settings){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGNS_TABLE"],settings:settings});};}function getCampaignRecords(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var _this2=this;var results=arguments.length>1&&arguments[1]!==undefined?arguments[1]:12;var sort=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{by:'status',direction:'Descending'};return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState){var settings,requestId,tableSettings,filterSettings,params,filterProperty,filterVal,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:settings={page:page,results:results,sort:sort};dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGNS_TABLE"],settings:settings});requestId=++getState().campaignsTable.currentRequestId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_CAMPAIGNS_TABLE_RECORDS"],requestId:requestId});tableSettings=getState().campaignsTable;filterSettings=getState().campaigns.filters;params={verbose:true,page:tableSettings.page,sortBy:tableSettings.sort.by,sortDirection:tableSettings.sort.direction,results:tableSettings.resultsView};for(filterProperty in filterSettings){filterVal=filterSettings[filterProperty];params[filterProperty]=filterVal;}_context2.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaigns',params);case 10:response=_context2.sent;dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_CAMPAIGNS_TABLE_RECORDS"]},{response:response,requestId:requestId}));case 12:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x5,_x6){return _ref2.apply(this,arguments);};}();}function createCampaign(campaign){var _this3=this;return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_CREATE_CAMPAIGN"]});_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])("/campaigns",campaign);case 3:response=_context3.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CREATE_CAMPAIGN"],response:response});if(response.success){dispatch(getCampaigns());dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__SettingsActions__["getPartialSystemSettings"])(__WEBPACK_IMPORTED_MODULE_5__lib_constants__["d" /* PartialSettings */].CampaignSettings));}case 6:case'end':return _context3.stop();}}},_callee3,_this3);}));return function(_x7){return _ref3.apply(this,arguments);};}();}function getCampaignDetails(campaignId){var _this4=this;var verbose=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_CAMPAIGN_DETAILS"]});_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaigns/'+campaignId,{verbose:verbose});case 3:response=_context4.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_CAMPAIGN_DETAILS"],response:response});case 5:case'end':return _context4.stop();}}},_callee4,_this4);}));return function(_x9){return _ref4.apply(this,arguments);};}();}function clearCampaignDetails(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_CAMPAIGN_DETAILS"]});dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS"]});dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS"]});dispatch(updateIndividualsTable({search:''}));dispatch(updateListsTable({statusFilter:''}));};}function updateCampaign(campaign){var _this5=this;return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch){var campaignId,endDate,approverId,maxAmount,response,updatedCampaign;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_CAMPAIGN_DETAILS"]});campaignId=campaign.campaignId,endDate=campaign.endDate,approverId=campaign.approverId,maxAmount=campaign.maxAmount;_context5.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["e" /* putRequest */])('/campaigns/'+campaignId,{endDate:endDate,maxAmount:maxAmount,approverId:approverId});case 4:response=_context5.sent;if(!response.success){_context5.next=10;break;}_context5.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaigns/'+campaignId);case 8:updatedCampaign=_context5.sent;response.data=updatedCampaign.data;case 10:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGN_DETAILS"],response:response});case 11:case'end':return _context5.stop();}}},_callee5,_this5);}));return function(_x10){return _ref5.apply(this,arguments);};}();}function getCampaignAllLists(campaignId){var _this6=this;return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_CAMPAIGN_ALL_LISTS"]});_context6.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaigns/'+campaignId+'/lists');case 3:response=_context6.sent;response.data=response.data?response.data.records||[]:[];dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_CAMPAIGN_ALL_LISTS"],response:response});case 6:case'end':return _context6.stop();}}},_callee6,_this6);}));return function(_x11){return _ref6.apply(this,arguments);};}();}function getCampaignAllIndividuals(campaignId){var _this7=this;return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_CAMPAIGN_ALL_INDIVIDUALS"]});_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaigns/'+campaignId+'/individuals');case 3:response=_context7.sent;response.data=response.data?response.data.records||[]:[];dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_CAMPAIGN_ALL_INDIVIDUALS"],response:response});case 6:case'end':return _context7.stop();}}},_callee7,_this7);}));return function(_x12){return _ref7.apply(this,arguments);};}();}function getUpdatedCampaignDetails(campaignId){var _this8=this;return function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaigns/'+campaignId);case 2:response=_context8.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_CAMPAIGN_DETAILS"],response:response});case 4:case'end':return _context8.stop();}}},_callee8,_this8);}));return function(_x13){return _ref8.apply(this,arguments);};}();}//INDIVIDUALS:
function updateIndividualsTable(settings){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE"],settings:settings});};}function getIndividuals(campaignId){var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var _this9=this;var results=arguments.length>2&&arguments[2]!==undefined?arguments[2]:12;var sort=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{by:'name',direction:'Ascending'};return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatch,getState){var settings,requestId,tableSettings,params,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:if(getState().campaignDetailsIndividualsTable.selected.length)dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_SELECTION"]});settings={page:page,results:results,sort:sort};dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE"],settings:settings});requestId=++getState().campaignDetailsIndividualsTable.currentRequestId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS"],requestId:requestId});tableSettings=getState().campaignDetailsIndividualsTable;params={page:tableSettings.page,sortBy:tableSettings.sort.by,sortDirection:tableSettings.sort.direction,results:tableSettings.resultsView,search:tableSettings.search};_context9.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaigns/'+campaignId+'/individuals',params);case 9:response=_context9.sent;dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS"]},{response:response,requestId:requestId}));case 11:case'end':return _context9.stop();}}},_callee9,_this9);}));return function(_x17,_x18){return _ref9.apply(this,arguments);};}();}function addIndividual(campaignId,recipientId,bypassError,campaignApplication){var _this10=this;return function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(dispatch){var formData,flatObj,prop,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_ADD_CAMPAIGN_DETAILS_INDIVIDUAL"]});formData=new FormData();flatObj=Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils__["h" /* flattenObj */])(Object.assign({recipientId:recipientId},campaignApplication));for(prop in flatObj){formData.append(prop,flatObj[prop]!==null?flatObj[prop]:'');}campaignApplication.attachments.map(function(attachment){return formData.append('attachments',attachment);});_context10.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/campaigns/'+campaignId+'/individuals?bypassError='+bypassError,formData);case 7:response=_context10.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["ADD_CAMPAIGN_DETAILS_INDIVIDUAL"],response:response});if(response.success)dispatch(getUpdatedCampaignDetails(campaignId));case 10:case'end':return _context10.stop();}}},_callee10,_this10);}));return function(_x19){return _ref10.apply(this,arguments);};}();}function updateIndividual(campaignId,recipientId,applicationId,update){var _this11=this;return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(dispatch,getState){var patchUpdate,response,tableSettings;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD"],recordId:recipientId});patchUpdate={};if(update.amount)patchUpdate.amount=update.amount;if(update.individualCategoryId)patchUpdate.individualCategoryId=update.individualCategoryId;if(update.fundId)patchUpdate['paymentInfo/fundId']=update.fundId;_context11.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["c" /* patchRequest */])('/applications/'+applicationId,patchUpdate);case 7:response=_context11.sent;response.recordIdKey="recipientId";response.recordId=recipientId;response.update=update;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD"],response:response});if(response.success){dispatch(getUpdatedCampaignDetails(campaignId));//TODO: re-requesting records, for now.  Will add request to get single indiv on campaign /campaigns/{id}/individuals/{id}.
tableSettings=getState().campaignDetailsIndividualsTable;dispatch(getIndividuals(campaignId,tableSettings.page,tableSettings.resultsView,tableSettings.sort));}case 13:case'end':return _context11.stop();}}},_callee11,_this11);}));return function(_x20,_x21){return _ref11.apply(this,arguments);};}();}function removeIndividual(campaignId,recipientId){var _this12=this;return function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_REMOVE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD"],recordId:recipientId});_context12.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["a" /* deleteRequest */])('/campaigns/'+campaignId+'/individuals/'+recipientId);case 3:response=_context12.sent;response.recordIdKey="recipientId";response.recordId=recipientId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["REMOVE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD"],response:response});if(response.success)dispatch(getUpdatedCampaignDetails(campaignId));case 8:case'end':return _context12.stop();}}},_callee12,_this12);}));return function(_x22){return _ref12.apply(this,arguments);};}();}function deleteCampaign(campaignId){var _this13=this;return function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(dispatch){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["DELETE_CAMPAIGN"],result:{loading:true}});_context13.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["a" /* deleteRequest */])('/campaigns/'+campaignId);case 3:result=_context13.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["DELETE_CAMPAIGN"],result:result});case 5:case'end':return _context13.stop();}}},_callee13,_this13);}));return function(_x23){return _ref13.apply(this,arguments);};}();}function toggleSelectIndividual(recipient){return function(dispatch){dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["TOGGLE_SELECT_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD"]},{record:recipient,recordIdKey:'recipientId'}));};}//LISTS:
function updateListsTable(settings){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE"],settings:settings});};}function getLists(campaignId){var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var _this14=this;var results=arguments.length>2&&arguments[2]!==undefined?arguments[2]:12;var sort=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{by:'name',direction:'Ascending'};return function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(dispatch,getState){var settings,requestId,tableSettings,params,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:settings={page:page,results:results,sort:sort};dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE"],settings:settings});requestId=++getState().campaignDetailsListsTable.currentRequestId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS"],requestId:requestId});tableSettings=getState().campaignDetailsListsTable;params={page:tableSettings.page,sortBy:tableSettings.sort.by,sortDirection:tableSettings.sort.direction,results:tableSettings.resultsView,status:tableSettings.statusFilter,keyword:tableSettings.keyword};_context14.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaigns/'+campaignId+'/lists',params);case 8:response=_context14.sent;dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS"]},{response:response,requestId:requestId}));case 10:case'end':return _context14.stop();}}},_callee14,_this14);}));return function(_x27,_x28){return _ref14.apply(this,arguments);};}();}function addList(campaignId,listId,emailMessage,defaultAmount,bypassError){var _this15=this;return function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_ADD_CAMPAIGN_DETAILS_LIST"]});_context15.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/campaigns/'+campaignId+'/lists?bypassError='+bypassError,{listId:listId,emailMessage:emailMessage,defaultAmount:defaultAmount,url:window.location.origin+'/external-lists/'+listId});case 3:response=_context15.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["ADD_CAMPAIGN_DETAILS_LIST"],response:response});if(response.success)dispatch(getUpdatedCampaignDetails(campaignId));case 6:case'end':return _context15.stop();}}},_callee15,_this15);}));return function(_x29){return _ref15.apply(this,arguments);};}();}function updateList(campaignId,campaignListId,update){var _this16=this;return function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(dispatch,getState){var response,tableSettings;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD"],recordId:campaignListId});_context16.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["c" /* patchRequest */])('/campaigns/'+campaignId+'/lists/'+campaignListId,update);case 3:response=_context16.sent;response.recordIdKey="campaignListId";response.recordId=campaignListId;response.update=update;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD"],response:response});if(response.success){dispatch(getUpdatedCampaignDetails(campaignId));//TODO: re-requesting records, for now.  Will add request to get single list on campaign /campaigns/{id}/lists/{id}.
tableSettings=getState().campaignDetailsListsTable;dispatch(getLists(campaignId,tableSettings.page,tableSettings.resultsView,tableSettings.sort));}case 9:case'end':return _context16.stop();}}},_callee16,_this16);}));return function(_x30,_x31){return _ref16.apply(this,arguments);};}();}function removeList(campaignId,campaignListId){var _this17=this;return function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_REMOVE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD"],recordId:campaignListId});_context17.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["a" /* deleteRequest */])('/campaigns/'+campaignId+'/lists/'+campaignListId);case 3:response=_context17.sent;response.recordIdKey="campaignListId";response.recordId=campaignListId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["REMOVE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD"],response:response});if(response.success)dispatch(getUpdatedCampaignDetails(campaignId));case 8:case'end':return _context17.stop();}}},_callee17,_this17);}));return function(_x32){return _ref17.apply(this,arguments);};}();}function getCampaignListExternalUpdates(campaignListId){var _this18=this;return function(){var _ref18=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(dispatch){var response,updatedParticipants,removedParticipants,addedParticipants;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_CAMPAIGN_LIST_EXTERNAL_UPDATES"]});response={loading:false,success:true,data:{}};_context18.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaignlists/'+campaignListId+'/updatedParticipants',null,[]);case 4:updatedParticipants=_context18.sent;_context18.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaignlists/'+campaignListId+'/removedParticipants',null,[]);case 7:removedParticipants=_context18.sent;_context18.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaignlists/'+campaignListId+'/addedParticipants',null,[]);case 10:addedParticipants=_context18.sent;response.success=updatedParticipants.success&&removedParticipants.success&&addedParticipants.success;response.data={updatedParticipants:updatedParticipants.data,removedParticipants:removedParticipants.data,addedParticipants:addedParticipants.data};dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_CAMPAIGN_LIST_EXTERNAL_UPDATES"],response:response});case 14:case'end':return _context18.stop();}}},_callee18,_this18);}));return function(_x33){return _ref18.apply(this,arguments);};}();}function getReceivingParticipants(campaignListId,newParticipants){var reset=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var page=arguments.length>3&&arguments[3]!==undefined?arguments[3]:1;var _this19=this;var results=arguments.length>4&&arguments[4]!==undefined?arguments[4]:12;var sort=arguments.length>5&&arguments[5]!==undefined?arguments[5]:{by:'name',direction:'Ascending'};return function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(dispatch,getState){var configs,requestId,tableSettings,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:configs={page:page,results:results,sort:sort};dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_RECEIVING_PARTICIPANTS_INFINITELIST_CONFIGS"],configs:configs});requestId=++getState().receivingParticipantsTable.currentRequestId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS"],requestId:requestId,reset:reset});tableSettings=getState().receivingParticipantsTable;//need to get all records from db and do sorting on client side bec. replacing suggested name and position
_context19.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaignlists/'+campaignListId+'/receivingParticipants');case 7:response=_context19.sent;response.data.records=response.data.records.map(function(participant){var id=participant.externalListMemberId.toString();var selectedSuggestion=newParticipants.filter(function(p){return p.key.toString()===id&&p.value;})[0];var name=selectedSuggestion?selectedSuggestion.name:participant.name;var lastName=selectedSuggestion?selectedSuggestion.lastName:participant.lastName;var orgEmployment=participant&&participant.orgEmployment!=""?participant.orgEmployment:selectedSuggestion?selectedSuggestion.orgEmployment:'';participant.name=name;participant.lastName=lastName;participant.orgEmployment=orgEmployment;return participant;});response.data.records=__WEBPACK_IMPORTED_MODULE_7_lodash_orderBy___default()(response.data.records,tableSettings.sort.by==='position'?'orgEmployment':tableSettings.sort.by==='name'?'lastName':tableSettings.sort.by,tableSettings.sort.direction==='Descending'?'desc':'asc');response.data.records=response.data.records.slice((page-1)*results,page*results);dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS"]},{response:response,requestId:requestId}));case 12:case'end':return _context19.stop();}}},_callee19,_this19);}));return function(_x38,_x39){return _ref19.apply(this,arguments);};}();}function clearReceivingParticipants(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS"]});};}function verifyCampaignListExternalUpdates(campaignId,campaignListId,newParticipants,rejectedParticipants,defaultAmount,bypassError){var _this20=this;return function(){var _ref20=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_VERIFY_CAMPAIGN_LIST_EXTERNAL_UPDATES"]});_context20.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/campaignLists/'+campaignListId+'/pendingChanges/verify?bypassError='+bypassError,{newParticipants:newParticipants,rejectedParticipants:rejectedParticipants,campaignId:campaignId,defaultAmount:defaultAmount});case 3:response=_context20.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["VERIFY_CAMPAIGN_LIST_EXTERNAL_UPDATES"],response:response});case 5:case'end':return _context20.stop();}}},_callee20,_this20);}));return function(_x40){return _ref20.apply(this,arguments);};}();}function approveCampaignList(campaignId,campaignListId){var _this21=this;return function(){var _ref21=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee21(dispatch){var response,updatedCampaignList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21){while(1){switch(_context21.prev=_context21.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_APPROVE_CAMPAIGN_DETAILS_LIST"]});_context21.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/campaigns/'+campaignId+'/lists/'+campaignListId+'/approve');case 3:response=_context21.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["APPROVE_CAMPAIGN_DETAILS_LIST"],response:response});if(response.success){updatedCampaignList={success:response.success,recordIdKey:"campaignListId",recordId:campaignListId,update:{status:__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["c" /* CampaignListStatuses */].Approved}};dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD"]},{response:updatedCampaignList}));}case 6:case'end':return _context21.stop();}}},_callee21,_this21);}));return function(_x41){return _ref21.apply(this,arguments);};}();}function resendExternalCampaignListMessage(campaignId,campaignListId){var _this22=this;return function(){var _ref22=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee22(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22){while(1){switch(_context22.prev=_context22.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_RESEND_CAMPAIGN_DETAILS_LIST"]});_context22.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/campaigns/'+campaignId+'/lists/'+campaignListId+'/resendMessage',{url:window.location.origin+'/external-lists/'+campaignListId});case 3:response=_context22.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["RESEND_CAMPAIGN_DETAILS_LIST"],response:response});case 5:case'end':return _context22.stop();}}},_callee22,_this22);}));return function(_x42){return _ref22.apply(this,arguments);};}();}function updateCampaignListApplicationsTable(settings){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE"],settings:settings});};}function clearCampaignListApplications(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_CAMPAIGN_LIST_DETAILS"]});dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_CAMPAIGN_DETAILS"]});dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS"]});dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CLEAR_CAMPAIGN_LISTS_APPLICATIONS_STATUS"]});};}function getCampaignListApplications(campaignId,campaignListId){var page=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;var _this23=this;var results=arguments.length>3&&arguments[3]!==undefined?arguments[3]:12;var sort=arguments.length>4&&arguments[4]!==undefined?arguments[4]:{by:'lastName',direction:'Ascending'};return function(){var _ref23=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee23(dispatch,getState){var settings,requestId,tableSettings,applicationStatus,params,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23){while(1){switch(_context23.prev=_context23.next){case 0:settings={page:page,results:results,sort:sort};dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE"],settings:settings});requestId=++getState().campaignListApplicationsTable.currentRequestId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS"],requestId:requestId});tableSettings=getState().campaignListApplicationsTable;applicationStatus=getState().campaignListApplications.applicationStatus;params={page:tableSettings.page,sortBy:tableSettings.sort.by,sortDirection:tableSettings.sort.direction,results:tableSettings.resultsView,applicationStatus:applicationStatus};_context23.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaigns/'+campaignId+'/lists/'+campaignListId+'/applications',params);case 9:response=_context23.sent;dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS"]},{response:response,requestId:requestId}));case 11:case'end':return _context23.stop();}}},_callee23,_this23);}));return function(_x46,_x47){return _ref23.apply(this,arguments);};}();}function updateCampaignListApplicationsStatus(applicationStatus){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGN_LISTS_APPLICATIONS_STATUS"],applicationStatus:applicationStatus});};}function updateCampaignListApplication(application,update){var _this24=this;return function(){var _ref24=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee24(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24){while(1){switch(_context24.prev=_context24.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORD"],recordId:application.applicationId});_context24.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["c" /* patchRequest */])('/applications/'+application.applicationId,update);case 3:response=_context24.sent;response.recordIdKey='applicationId';response.recordId=application.applicationId;response.update=Object.assign({},update);dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORD"],response:response});case 8:case'end':return _context24.stop();}}},_callee24,_this24);}));return function(_x48){return _ref24.apply(this,arguments);};}();}function updateApplicationStatus(action,applications){var _this25=this;var applicationId=applications[0].applicationId;return function(){var _ref25=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee25(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25){while(1){switch(_context25.prev=_context25.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORD"],recordId:applicationId});_context25.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/applications/'+action,applications);case 3:response=_context25.sent;response.recordIdKey='applicationId';response.recordId=applicationId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORD"],response:response});case 7:case'end':return _context25.stop();}}},_callee25,_this25);}));return function(_x49){return _ref25.apply(this,arguments);};}();}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53),
    isObjectLike = __webpack_require__(54);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(31);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(43);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(358),
    listCacheDelete = __webpack_require__(359),
    listCacheGet = __webpack_require__(360),
    listCacheHas = __webpack_require__(361),
    listCacheSet = __webpack_require__(362);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(151);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(364);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(67);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["printChecks"] = printChecks;
/* harmony export (immutable) */ __webpack_exports__["confirmChecksPrinted"] = confirmChecksPrinted;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_recipientSummaryCache__ = __webpack_require__(42);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function printChecks(printJobType,printerId,printDetails){var _this=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_PRINT_CHECKS"],printerId:printerId});_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/printJobs',Object.assign({printerId:printerId,printJobType:printJobType},printDetails),[]);case 3:response=_context.sent;if(response.success&&printJobType==='applications')Object(__WEBPACK_IMPORTED_MODULE_3__lib_recipientSummaryCache__["a" /* clearRecipientSummaryCache */])();if(printJobType==='reprints')delete response.data;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["PRINT_CHECKS_COMPLETED"],response:response});case 7:case'end':return _context.stop();}}},_callee,_this);}));return function(_x){return _ref.apply(this,arguments);};}();}function confirmChecksPrinted(printJobIds,isCancel){var _this2=this;return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_CONFIRM_CHECKS_PRINTED"]});_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["a" /* deleteRequest */])('/printjobs',{printJobIds:printJobIds,isCancel:isCancel});case 3:response=_context2.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CONFIRM_CHECKS_PRINTED"],response:response});case 5:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref2.apply(this,arguments);};}();}

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_systemVariables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ApplicationStatusTag=function(_React$Component){_inherits(ApplicationStatusTag,_React$Component);function ApplicationStatusTag(){_classCallCheck(this,ApplicationStatusTag);return _possibleConstructorReturn(this,(ApplicationStatusTag.__proto__||Object.getPrototypeOf(ApplicationStatusTag)).apply(this,arguments));}_createClass(ApplicationStatusTag,[{key:'render',value:function render(){switch(this.props.status){case __WEBPACK_IMPORTED_MODULE_1__lib_systemVariables__["a" /* ApplicationStatuses */].Paid:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag blue'},__WEBPACK_IMPORTED_MODULE_1__lib_systemVariables__["a" /* ApplicationStatuses */].Paid);case __WEBPACK_IMPORTED_MODULE_1__lib_systemVariables__["a" /* ApplicationStatuses */].Rejected:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag red'},__WEBPACK_IMPORTED_MODULE_1__lib_systemVariables__["a" /* ApplicationStatuses */].Rejected);case __WEBPACK_IMPORTED_MODULE_1__lib_systemVariables__["a" /* ApplicationStatuses */].Incomplete:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag gray'},__WEBPACK_IMPORTED_MODULE_1__lib_systemVariables__["a" /* ApplicationStatuses */].Incomplete);case __WEBPACK_IMPORTED_MODULE_1__lib_systemVariables__["a" /* ApplicationStatuses */].Approved:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag green'},__WEBPACK_IMPORTED_MODULE_1__lib_systemVariables__["a" /* ApplicationStatuses */].Approved);case __WEBPACK_IMPORTED_MODULE_1__lib_systemVariables__["a" /* ApplicationStatuses */].InReview:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag purple'},__WEBPACK_IMPORTED_MODULE_1__lib_systemVariables__["a" /* ApplicationStatuses */].InReview);case __WEBPACK_IMPORTED_MODULE_1__lib_systemVariables__["a" /* ApplicationStatuses */].New:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag yellow'},__WEBPACK_IMPORTED_MODULE_1__lib_systemVariables__["a" /* ApplicationStatuses */].New);default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);}}}]);return ApplicationStatusTag;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ApplicationStatusTag);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AutocompleteInput__ = __webpack_require__(46);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AutocompleteMultiInput=function(_React$Component){_inherits(AutocompleteMultiInput,_React$Component);function AutocompleteMultiInput(){_classCallCheck(this,AutocompleteMultiInput);return _possibleConstructorReturn(this,(AutocompleteMultiInput.__proto__||Object.getPrototypeOf(AutocompleteMultiInput)).apply(this,arguments));}_createClass(AutocompleteMultiInput,[{key:'onRemoveSelection',value:function onRemoveSelection(selection){this.props.update(this.props.name,this.props.selection.filter(function(s){return s!==selection;}));}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__AutocompleteInput__["a" /* default */],Object.assign({multi:true},this.props)),this.props.selection.map(function(selectionKey){var selection=_this2.props.options[_this2.props.options.map(function(o){return o.key;}).indexOf(selectionKey)];return selection?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:selectionKey,className:'chip name-chip'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,selection.displayvalue||selection.value),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons delete-chip',onClick:_this2.onRemoveSelection.bind(_this2,selectionKey)},'close')):null;}));}}]);return AutocompleteMultiInput;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AutocompleteMultiInput);

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dropzone__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UploadAttachments=function(_React$Component){_inherits(UploadAttachments,_React$Component);function UploadAttachments(props){_classCallCheck(this,UploadAttachments);var _this=_possibleConstructorReturn(this,(UploadAttachments.__proto__||Object.getPrototypeOf(UploadAttachments)).call(this,props));_this.mounted=false;_this.state={duplicates:0,rejectedFiles:0};_this.onFileDrop=_this.onFileDrop.bind(_this);_this.removeFile=_this.removeFile.bind(_this);_this.dropRejected=_this.dropRejected.bind(_this);return _this;}_createClass(UploadAttachments,[{key:'onFileDrop',value:function onFileDrop(acceptedFiles){var _this2=this;//to avoid memory leaks
var files=[].concat(_toConsumableArray(this.props.files));var duplicates=0;acceptedFiles.forEach(function(newFile){if(files.filter(function(f){return f.name===newFile.name&&f.lastModified===newFile.lastModified&&f.size===newFile.size;}).length>0){duplicates++;}else{files.push(newFile);}if(duplicates){_this2.setState({duplicates:duplicates},function(){setTimeout(function(){if(_this2.refs.dropzone){_this2.setState({duplicates:0});}},5000);});}window.URL.revokeObjectURL(newFile.preview);});this.props.onChange(this.props.name,files);}},{key:'dropRejected',value:function dropRejected(rejectedFiles){var _this3=this;this.setState({rejectedFiles:rejectedFiles.length},function(){setTimeout(function(){if(_this3.refs.dropzone){_this3.setState({rejectedFiles:0});}},5000);});}},{key:'removeFile',value:function removeFile(file){var files=[].concat(_toConsumableArray(this.props.files));var index=files.indexOf(file);if(index>-1)files.splice(index,1);this.props.onChange(this.props.name,files);}},{key:'render',value:function render(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'upload-box-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half column-half-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Uploads'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_dropzone__["a" /* default */],{ref:'dropzone',className:'upload-box',accept:'application/pdf,text/html,image/png,image/jpeg,image/tiff,image/gif,image/bmp,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.docx',onDropRejected:this.dropRejected,disablePreview:true,onDropAccepted:this.onFileDrop,multiple:true,maxSize:20000000},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'accent-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-ios-cloud-upload-outline'}),'Drop files here or ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' click to ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'accent-text2 block'},'Upload Attachment'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_FadeOutErrorMessage__["a" /* default */],{message:'Can not upload duplicate file(s)',show:this.state.duplicates}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_FadeOutErrorMessage__["a" /* default */],{message:'Incompatible file format or size.',show:this.state.rejectedFiles}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half'},this.props.files&&this.props.files.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Files to be Uploaded'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.props.files.map(function(f){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:f.name},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-document icon-left middle'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'small-text'},f.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-ios-close-outline trash-hover icon-right middle',onClick:_this4.removeFile.bind(_this4,f)}));})))));}}]);return UploadAttachments;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (UploadAttachments);

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LoadingSpinner__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InfiniteScrollList=function(_React$Component){_inherits(InfiniteScrollList,_React$Component);function InfiniteScrollList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InfiniteScrollList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InfiniteScrollList.__proto__||Object.getPrototypeOf(InfiniteScrollList)).call.apply(_ref,[this].concat(args))),_this),_this.state={hasMore:true,prevScrollPosition:0,showScrollToTop:false},_this.getListHeader=function(){var _this$props=_this.props,columns=_this$props.columns,sort=_this$props.sort;return columns.filter(function(column){return!column.hidden;}).map(function(column){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:column.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sort flex-center '+(sort&&sort.by===column.id?"active":"")},column.component||__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'sort-arrows-label'},column.title),column.sortable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sort-arrows relative '+(sort&&sort.by===column.id?"active":""),onClick:function onClick(){return _this.sortList(column);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-android-arrow-dropup '+(sort.direction!=='Ascending'?"inactive":"")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-android-arrow-dropdown '+(sort.direction!=='Descending'?"inactive":"")})))));});},_this.getListRecords=function(){var _this$props2=_this.props,records=_this$props2.records,renderRecord=_this$props2.renderRecord;return records.map(function(rec){return renderRecord(rec);});},_this.sortList=function(column){var sort=_this.props.sort;var updatedSort={by:column.id,direction:sort.by!==column.id?column.defaultDirection?column.defaultDirection:"Ascending":sort.direction==="Ascending"?"Descending":"Ascending"};_this.props.getRecords(1,updatedSort,true);},_this.onScroll=function(event){var _this$props3=_this.props,hasMore=_this$props3.hasMore,loading=_this$props3.loading,page=_this$props3.page,sort=_this$props3.sort;var showScrollToTop=_this.state.showScrollToTop;var isHorizontalScroll=event.target.scrollTop===_this.state.prevScrollPosition;var distanceFromBottom=event.target.scrollHeight-event.target.clientHeight-event.target.scrollTop;if(!loading&&hasMore&&!isHorizontalScroll&&distanceFromBottom<=250){//TODO: adjust as needed!
_this.props.getRecords(page+1,sort);_this.setState({prevScrollPosition:event.target.scrollTop});}var hasScroll=event.target.scrollTop>event.target.clientHeight+250;if(hasScroll&&!showScrollToTop){_this.setState({showScrollToTop:true});}else if(!hasScroll&&showScrollToTop){_this.setState({showScrollToTop:false});}},_this.scrollToTop=function(){if(_this.refs.infiniteList)_this.refs.infiniteList.scrollTo({"behavior":"smooth","left":0,"top":0});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InfiniteScrollList,[{key:'componentWillMount',value:function componentWillMount(){this.props.getRecords();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!nextProps.success&&this.props.success){__WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error("Something went wrong",'We couldn\'t retrieve '+(this.props.name||"records")+'.  Please try again');}}},{key:'render',value:function render(){var _props=this.props,hideScrollToTopButton=_props.hideScrollToTopButton,loading=_props.loading,name=_props.name,records=_props.records;var showScrollToTop=this.state.showScrollToTop;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container infinite-scroll-list',ref:'infiniteList',onScroll:this.onScroll},!loading&&!records.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'empty-state'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'not_interested'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'No ',Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["C" /* toTitleCase */])(name)||'Records',' Found')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-container'},loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row table-loader-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-view__loader loader-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-6'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-7'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-8'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-9'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-10'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-row__cell lrc-11'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'table-header table-row'},this.getListHeader())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.getListRecords())),loading&&records.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__LoadingSpinner__["a" /* default */],{height:'20'}),showScrollToTop&&!hideScrollToTopButton&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-top btn-primary',onClick:this.scrollToTop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'arrow_upward')))));}}]);return InfiniteScrollList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (InfiniteScrollList);

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(114);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(115);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(20);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(59);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(60);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(259);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(26);
var normalizeHeaderName = __webpack_require__(274);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(138);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(138);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var toastr = {
  maxAnimationDelay: 6000,
  newestOnTop: true,
  position: 'top-right',
  preventDuplicates: true
};

exports.default = toastr;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADD_TOASTR = exports.ADD_TOASTR = '@ReduxToastr/toastr/ADD';
var REMOVE_TOASTR = exports.REMOVE_TOASTR = '@ReduxToastr/toastr/REMOVE';
var CLEAN_TOASTR = exports.CLEAN_TOASTR = '@ReduxToastr/toastr/CLEAN';
var SHOW_CONFIRM = exports.SHOW_CONFIRM = '@ReduxToastr/confirm/SHOW';
var HIDE_CONFIRM = exports.HIDE_CONFIRM = '@ReduxToastr/confirm/HIDE';
var REMOVE_BY_TYPE = exports.REMOVE_BY_TYPE = '@ReduxToastr/toastr/REMOVE_BY_TYPE';
// before add a new transition - check its presence in src/styles/animations.scss
var TRANSITIONS = exports.TRANSITIONS = {
  in: ['bounceIn', 'bounceInDown', 'fadeIn'],
  out: ['bounceOut', 'bounceOutUp', 'fadeOut']
};

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getUserProfileAndPermissions"] = getUserProfileAndPermissions;
/* harmony export (immutable) */ __webpack_exports__["getUserProfile"] = getUserProfile;
/* harmony export (immutable) */ __webpack_exports__["updateAiSummaryPreference"] = updateAiSummaryPreference;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UsersActions__ = __webpack_require__(63);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function getUserProfileAndPermissions(){var _this=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return dispatch(getUserProfile());case 2:if(!getState().userProfile.profile.success){_context.next=5;break;}_context.next=5;return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__UsersActions__["getUserPermissions"])(getState().userProfile.profile.data.userId,true));case 5:case'end':return _context.stop();}}},_callee,_this);}));return function(_x,_x2){return _ref.apply(this,arguments);};}();}function getUserProfile(){var _this2=this;return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_USER_PROFILE"]});_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/account/myprofile');case 3:response=_context2.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_USER_PROFILE"],response:response});case 5:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x3){return _ref2.apply(this,arguments);};}();}function updateAiSummaryPreference(showAiSummaries){var _this3=this;return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["e" /* putRequest */])('/account/ai-summary-preference',{showAiSummaries:showAiSummaries});case 2:response=_context3.sent;if(response.success){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_USER_PROFILE"],update:{showAiSummaries:showAiSummaries}});}return _context3.abrupt('return',response);case 5:case'end':return _context3.stop();}}},_callee3,_this3);}));return function(_x4){return _ref3.apply(this,arguments);};}();}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(147),
    toKey = __webpack_require__(73);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(28),
    isSymbol = __webpack_require__(67);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(347),
    mapCacheDelete = __webpack_require__(363),
    mapCacheGet = __webpack_require__(365),
    mapCacheHas = __webpack_require__(366),
    mapCacheSet = __webpack_require__(367);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(43),
    root = __webpack_require__(31);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(395),
    baseKeys = __webpack_require__(401),
    isArrayLike = __webpack_require__(97);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 96 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(149),
    isLength = __webpack_require__(96);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;;(function (globalObject) {
    'use strict';

/*
 *      bignumber.js v6.0.0
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2018 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */


    var BigNumber,
        isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i,

        mathceil = Math.ceil,
        mathfloor = Math.floor,

        bignumberError = '[BigNumber Error] ',
        tooManyDigits = bignumberError + 'Number primitive has more than 15 significant digits: ',

        BASE = 1e14,
        LOG_BASE = 14,
        MAX_SAFE_INTEGER = 0x1fffffffffffff,         // 2^53 - 1
        // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
        POWS_TEN = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13],
        SQRT_BASE = 1e7,

        // EDITABLE
        // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
        // the arguments to toExponential, toFixed, toFormat, and toPrecision.
        MAX = 1E9;                                   // 0 to MAX_INT32


    /*
     * Create and return a BigNumber constructor.
     */
    function clone(configObject) {
        var div, convertBase, parseNumeric,
            P = BigNumber.prototype,
            ONE = new BigNumber(1),


            //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------


            // The default values below must be integers within the inclusive ranges stated.
            // The values can also be changed at run-time using BigNumber.set.

            // The maximum number of decimal places for operations involving division.
            DECIMAL_PLACES = 20,                     // 0 to MAX

            // The rounding mode used when rounding to the above decimal places, and when using
            // toExponential, toFixed, toFormat and toPrecision, and round (default value).
            // UP         0 Away from zero.
            // DOWN       1 Towards zero.
            // CEIL       2 Towards +Infinity.
            // FLOOR      3 Towards -Infinity.
            // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
            // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
            // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
            // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
            // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
            ROUNDING_MODE = 4,                       // 0 to 8

            // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]

            // The exponent value at and beneath which toString returns exponential notation.
            // Number type: -7
            TO_EXP_NEG = -7,                         // 0 to -MAX

            // The exponent value at and above which toString returns exponential notation.
            // Number type: 21
            TO_EXP_POS = 21,                         // 0 to MAX

            // RANGE : [MIN_EXP, MAX_EXP]

            // The minimum exponent value, beneath which underflow to zero occurs.
            // Number type: -324  (5e-324)
            MIN_EXP = -1e7,                          // -1 to -MAX

            // The maximum exponent value, above which overflow to Infinity occurs.
            // Number type:  308  (1.7976931348623157e+308)
            // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
            MAX_EXP = 1e7,                           // 1 to MAX

            // Whether to use cryptographically-secure random number generation, if available.
            CRYPTO = false,                          // true or false

            // The modulo mode used when calculating the modulus: a mod n.
            // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
            // The remainder (r) is calculated as: r = a - n * q.
            //
            // UP        0 The remainder is positive if the dividend is negative, else is negative.
            // DOWN      1 The remainder has the same sign as the dividend.
            //             This modulo mode is commonly known as 'truncated division' and is
            //             equivalent to (a % n) in JavaScript.
            // FLOOR     3 The remainder has the same sign as the divisor (Python %).
            // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
            // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
            //             The remainder is always positive.
            //
            // The truncated division, floored division, Euclidian division and IEEE 754 remainder
            // modes are commonly used for the modulus operation.
            // Although the other rounding modes can also be used, they may not give useful results.
            MODULO_MODE = 1,                         // 0 to 9

            // The maximum number of significant digits of the result of the exponentiatedBy operation.
            // If POW_PRECISION is 0, there will be unlimited significant digits.
            POW_PRECISION = 0,                    // 0 to MAX

            // The format specification used by the BigNumber.prototype.toFormat method.
            FORMAT = {
                decimalSeparator: '.',
                groupSeparator: ',',
                groupSize: 3,
                secondaryGroupSize: 0,
                fractionGroupSeparator: '\xA0',      // non-breaking space
                fractionGroupSize: 0
            },

            // The alphabet used for base conversion.
            // It must be at least 2 characters long, with no '.' or repeated character.
            // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
            ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz';


        //------------------------------------------------------------------------------------------


        // CONSTRUCTOR


        /*
         * The BigNumber constructor and exported function.
         * Create and return a new instance of a BigNumber object.
         *
         * n {number|string|BigNumber} A numeric value.
         * [b] {number} The base of n. Integer, 2 to ALPHABET.length inclusive.
         */
        function BigNumber( n, b ) {
            var alphabet, c, e, i, isNum, len, str,
                x = this;

            // Enable constructor usage without new.
            if ( !( x instanceof BigNumber ) ) {

                // Don't throw on constructor call without new (#81).
                // '[BigNumber Error] Constructor call without new: {n}'
                //throw Error( bignumberError + ' Constructor call without new: ' + n );
                return new BigNumber( n, b );
            }

            if ( b == null ) {

                // Duplicate.
                if ( n instanceof BigNumber ) {
                    x.s = n.s;
                    x.e = n.e;
                    x.c = ( n = n.c ) ? n.slice() : n;
                    return;
                }

                isNum = typeof n == 'number';

                if ( isNum && n * 0 == 0 ) {

                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / n < 0 ? ( n = -n, -1 ) : 1;

                    // Faster path for integers.
                    if ( n === ~~n ) {
                        for ( e = 0, i = n; i >= 10; i /= 10, e++ );
                        x.e = e;
                        x.c = [n];
                        return;
                    }

                    str = n + '';
                } else {
                    if ( !isNumeric.test( str = n + '' ) ) return parseNumeric( x, str, isNum );
                    x.s = str.charCodeAt(0) == 45 ? ( str = str.slice(1), -1 ) : 1;
                }

            } else {

                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck( b, 2, ALPHABET.length, 'Base' );
                str = n + '';

                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if ( b == 10 ) {
                    x = new BigNumber( n instanceof BigNumber ? n : str );
                    return round( x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE );
                }

                isNum = typeof n == 'number';

                if (isNum) {

                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if ( n * 0 != 0 ) return parseNumeric( x, str, isNum, b );

                    x.s = 1 / n < 0 ? ( str = str.slice(1), -1 ) : 1;

                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if ( str.replace( /^0\.0*|\./, '' ).length > 15 ) {
                        throw Error
                          ( tooManyDigits + n );
                    }

                    // Prevent later check for length on converted number.
                    isNum = false;
                } else {
                    x.s = str.charCodeAt(0) === 45 ? ( str = str.slice(1), -1 ) : 1;

                    // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    if ( b > 10 && b < 37 ) str = str.toLowerCase();
                }

                alphabet = ALPHABET.slice( 0, b );
                e = i = 0;

                // Check that str is a valid base b number.
                // Don't use RegExp so alphabet can contain special characters.
                for ( len = str.length; i < len; i++ ) {
                    if ( alphabet.indexOf( c = str.charAt(i) ) < 0 ) {
                        if ( c == '.' ) {

                            // If '.' is not the first character and it has not be found before.
                            if ( i > e ) {
                                e = len;
                                continue;
                            }
                        }

                        return parseNumeric( x, n + '', isNum, b );
                    }
                }

                str = convertBase( str, b, 10, x.s );
            }

            // Decimal point?
            if ( ( e = str.indexOf('.') ) > -1 ) str = str.replace( '.', '' );

            // Exponential form?
            if ( ( i = str.search( /e/i ) ) > 0 ) {

                // Determine exponent.
                if ( e < 0 ) e = i;
                e += +str.slice( i + 1 );
                str = str.substring( 0, i );
            } else if ( e < 0 ) {

                // Integer.
                e = str.length;
            }

            // Determine leading zeros.
            for ( i = 0; str.charCodeAt(i) === 48; i++ );

            // Determine trailing zeros.
            for ( len = str.length; str.charCodeAt(--len) === 48; );
            str = str.slice( i, len + 1 );

            if (str) {
                len = str.length;

                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if ( isNum && len > 15 && ( n > MAX_SAFE_INTEGER || n !== mathfloor(n) ) ) {
                    throw Error
                      ( tooManyDigits + ( x.s * n ) );
                }

                e = e - i - 1;

                 // Overflow?
                if ( e > MAX_EXP ) {

                    // Infinity.
                    x.c = x.e = null;

                // Underflow?
                } else if ( e < MIN_EXP ) {

                    // Zero.
                    x.c = [ x.e = 0 ];
                } else {
                    x.e = e;
                    x.c = [];

                    // Transform base

                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = ( e + 1 ) % LOG_BASE;
                    if ( e < 0 ) i += LOG_BASE;

                    if ( i < len ) {
                        if (i) x.c.push( +str.slice( 0, i ) );

                        for ( len -= LOG_BASE; i < len; ) {
                            x.c.push( +str.slice( i, i += LOG_BASE ) );
                        }

                        str = str.slice(i);
                        i = LOG_BASE - str.length;
                    } else {
                        i -= len;
                    }

                    for ( ; i--; str += '0' );
                    x.c.push( +str );
                }
            } else {

                // Zero.
                x.c = [ x.e = 0 ];
            }
        }


        // CONSTRUCTOR PROPERTIES


        BigNumber.clone = clone;

        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;


        /*
         * Configure infrequently-changing library-wide settings.
         *
         * Accept an object with the following optional properties (if the value of a property is
         * a number, it must be an integer within the inclusive range stated):
         *
         *   DECIMAL_PLACES   {number}           0 to MAX
         *   ROUNDING_MODE    {number}           0 to 8
         *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
         *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
         *   CRYPTO           {boolean}          true or false
         *   MODULO_MODE      {number}           0 to 9
         *   POW_PRECISION       {number}           0 to MAX
         *   ALPHABET         {string}           A string of two or more unique characters, and not
         *                                       containing '.'. The empty string, null or undefined
         *                                       resets the alphabet to its default value.
         *   FORMAT           {object}           An object with some of the following properties:
         *      decimalSeparator       {string}
         *      groupSeparator         {string}
         *      groupSize              {number}
         *      secondaryGroupSize     {number}
         *      fractionGroupSeparator {string}
         *      fractionGroupSize      {number}
         *
         * (The values assigned to the above FORMAT object properties are not checked for validity.)
         *
         * E.g.
         * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
         *
         * Ignore properties/parameters set to null or undefined, except for ALPHABET.
         *
         * Return an object with the properties current values.
         */
        BigNumber.config = BigNumber.set = function (obj) {
            var p, v;

            if ( obj != null ) {

                if ( typeof obj == 'object' ) {

                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if ( obj.hasOwnProperty( p = 'DECIMAL_PLACES' ) ) {
                        v = obj[p];
                        intCheck( v, 0, MAX, p );
                        DECIMAL_PLACES = v;
                    }

                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if ( obj.hasOwnProperty( p = 'ROUNDING_MODE' ) ) {
                        v = obj[p];
                        intCheck( v, 0, 8, p );
                        ROUNDING_MODE = v;
                    }

                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if ( obj.hasOwnProperty( p = 'EXPONENTIAL_AT' ) ) {
                        v = obj[p];
                        if ( isArray(v) ) {
                            intCheck( v[0], -MAX, 0, p );
                            intCheck( v[1], 0, MAX, p );
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck( v, -MAX, MAX, p );
                            TO_EXP_NEG = -( TO_EXP_POS = v < 0 ? -v : v );
                        }
                    }

                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if ( obj.hasOwnProperty( p = 'RANGE' ) ) {
                        v = obj[p];
                        if ( isArray(v) ) {
                            intCheck( v[0], -MAX, -1, p );
                            intCheck( v[1], 1, MAX, p );
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck( v, -MAX, MAX, p );
                            if (v) {
                                MIN_EXP = -( MAX_EXP = v < 0 ? -v : v );
                            } else {
                                throw Error
                                  ( bignumberError + p + ' cannot be zero: ' + v );
                            }
                        }
                    }

                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if ( obj.hasOwnProperty( p = 'CRYPTO' ) ) {
                        v = obj[p];
                        if ( v === !!v ) {
                            if (v) {
                                if ( typeof crypto != 'undefined' && crypto &&
                                  (crypto.getRandomValues || crypto.randomBytes) ) {
                                    CRYPTO = v;
                                } else {
                                    CRYPTO = !v;
                                    throw Error
                                      ( bignumberError + 'crypto unavailable' );
                                }
                            } else {
                                CRYPTO = v;
                            }
                        } else {
                            throw Error
                              ( bignumberError + p + ' not true or false: ' + v );
                        }
                    }

                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if ( obj.hasOwnProperty( p = 'MODULO_MODE' ) ) {
                        v = obj[p];
                        intCheck( v, 0, 9, p );
                        MODULO_MODE = v;
                    }

                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if ( obj.hasOwnProperty( p = 'POW_PRECISION' ) ) {
                        v = obj[p];
                        intCheck( v, 0, MAX, p );
                        POW_PRECISION = v;
                    }

                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if ( obj.hasOwnProperty( p = 'FORMAT' ) ) {
                        v = obj[p];
                        if ( typeof v == 'object' ) FORMAT = v;
                        else throw Error
                          ( bignumberError + p + ' not an object: ' + v );
                    }

                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if ( obj.hasOwnProperty( p = 'ALPHABET' ) ) {
                        v = obj[p];

                        // Disallow if only one character, or contains '.' or a repeated character.
                        if ( typeof v == 'string' && !/^.$|\.|(.).*\1/.test(v) ) {
                            ALPHABET = v;
                        } else {
                            throw Error
                              ( bignumberError + p + ' invalid: ' + v );
                        }
                    }

                } else {

                    // '[BigNumber Error] Object expected: {v}'
                    throw Error
                      ( bignumberError + 'Object expected: ' + obj );
                }
            }

            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [ TO_EXP_NEG, TO_EXP_POS ],
                RANGE: [ MIN_EXP, MAX_EXP ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };


        /*
         * Return true if v is a BigNumber instance, otherwise return false.
         *
         * v {any}
         */
        BigNumber.isBigNumber = function (v) {
            return v instanceof BigNumber || v && v._isBigNumber === true || false;
        };


        /*
         * Return a new BigNumber whose value is the maximum of the arguments.
         *
         * arguments {number|string|BigNumber}
         */
        BigNumber.maximum = BigNumber.max = function () {
            return maxOrMin( arguments, P.lt );
        };


        /*
         * Return a new BigNumber whose value is the minimum of the arguments.
         *
         * arguments {number|string|BigNumber}
         */
        BigNumber.minimum = BigNumber.min = function () {
            return maxOrMin( arguments, P.gt );
        };


        /*
         * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
         * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
         * zeros are produced).
         *
         * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
         *
         * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
         * '[BigNumber Error] crypto unavailable'
         */
        BigNumber.random = (function () {
            var pow2_53 = 0x20000000000000;

            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = (Math.random() * pow2_53) & 0x1fffff
              ? function () { return mathfloor( Math.random() * pow2_53 ); }
              : function () { return ((Math.random() * 0x40000000 | 0) * 0x800000) +
                  (Math.random() * 0x800000 | 0); };

            return function (dp) {
                var a, b, e, k, v,
                    i = 0,
                    c = [],
                    rand = new BigNumber(ONE);

                if ( dp == null ) dp = DECIMAL_PLACES;
                else intCheck( dp, 0, MAX );

                k = mathceil( dp / LOG_BASE );

                if (CRYPTO) {

                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {

                        a = crypto.getRandomValues( new Uint32Array( k *= 2 ) );

                        for ( ; i < k; ) {

                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);

                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if ( v >= 9e15 ) {
                                b = crypto.getRandomValues( new Uint32Array(2) );
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {

                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push( v % 1e14 );
                                i += 2;
                            }
                        }
                        i = k / 2;

                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {

                        // buffer
                        a = crypto.randomBytes( k *= 7 );

                        for ( ; i < k; ) {

                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = ( ( a[i] & 31 ) * 0x1000000000000 ) + ( a[i + 1] * 0x10000000000 ) +
                                  ( a[i + 2] * 0x100000000 ) + ( a[i + 3] * 0x1000000 ) +
                                  ( a[i + 4] << 16 ) + ( a[i + 5] << 8 ) + a[i + 6];

                            if ( v >= 9e15 ) {
                                crypto.randomBytes(7).copy( a, i );
                            } else {

                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push( v % 1e14 );
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error
                          ( bignumberError + 'crypto unavailable' );
                    }
                }

                // Use Math.random.
                if (!CRYPTO) {

                    for ( ; i < k; ) {
                        v = random53bitInt();
                        if ( v < 9e15 ) c[i++] = v % 1e14;
                    }
                }

                k = c[--i];
                dp %= LOG_BASE;

                // Convert trailing digits to zeros according to dp.
                if ( k && dp ) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor( k / v ) * v;
                }

                // Remove trailing elements which are zero.
                for ( ; c[i] === 0; c.pop(), i-- );

                // Zero?
                if ( i < 0 ) {
                    c = [ e = 0 ];
                } else {

                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for ( e = -1 ; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);

                    // Count the digits of the first element of c to determine leading zeros, and...
                    for ( i = 1, v = c[0]; v >= 10; v /= 10, i++);

                    // adjust the exponent accordingly.
                    if ( i < LOG_BASE ) e -= LOG_BASE - i;
                }

                rand.e = e;
                rand.c = c;
                return rand;
            };
        })();


        // PRIVATE FUNCTIONS


        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = ( function () {
            var decimal = '0123456789';

            /*
             * Convert string of baseIn to an array of numbers of baseOut.
             * Eg. toBaseOut('255', 10, 16) returns [15, 15].
             * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
             */
            function toBaseOut( str, baseIn, baseOut, alphabet ) {
                var j,
                    arr = [0],
                    arrL,
                    i = 0,
                    len = str.length;

                for ( ; i < len; ) {
                    for ( arrL = arr.length; arrL--; arr[arrL] *= baseIn );

                    arr[0] += alphabet.indexOf( str.charAt( i++ ) );

                    for ( j = 0; j < arr.length; j++ ) {

                        if ( arr[j] > baseOut - 1 ) {
                            if ( arr[j + 1] == null ) arr[j + 1] = 0;
                            arr[j + 1] += arr[j] / baseOut | 0;
                            arr[j] %= baseOut;
                        }
                    }
                }

                return arr.reverse();
            }

            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function ( str, baseIn, baseOut, sign, callerIsToString ) {
                var alphabet, d, e, k, r, x, xc, y,
                    i = str.indexOf( '.' ),
                    dp = DECIMAL_PLACES,
                    rm = ROUNDING_MODE;

                // Non-integer.
                if ( i >= 0 ) {
                    k = POW_PRECISION;

                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace( '.', '' );
                    y = new BigNumber(baseIn);
                    x = y.pow( str.length - i );
                    POW_PRECISION = k;

                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.

                    y.c = toBaseOut( toFixedPoint( coeffToString( x.c ), x.e, '0' ),
                      10, baseOut, decimal );
                    y.e = y.c.length;
                }

                // Convert the number as integer.

                xc = toBaseOut( str, baseIn, baseOut, callerIsToString
                  ? ( alphabet = ALPHABET, decimal )
                  : ( alphabet = decimal, ALPHABET ) );


                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;

                // Remove trailing zeros.
                for ( ; xc[--k] == 0; xc.pop() );

                // Zero?
                if ( !xc[0] ) return alphabet.charAt(0);

                // Does str represent an integer? If so, no need for the division.
                if ( i < 0 ) {
                    --e;
                } else {
                    x.c = xc;
                    x.e = e;

                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div( x, y, dp, rm, baseOut );
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }

                // xc now represents str converted to baseOut.

                // THe index of the rounding digit.
                d = e + dp + 1;

                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];

                // Look at the rounding digits and mode to determine whether to round up.

                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;

                r = rm < 4 ? ( i != null || r ) && ( rm == 0 || rm == ( x.s < 0 ? 3 : 2 ) )
                           : i > k || i == k &&( rm == 4 || r || rm == 6 && xc[d - 1] & 1 ||
                             rm == ( x.s < 0 ? 8 : 7 ) );

                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if ( d < 1 || !xc[0] ) {

                    // 1^-dp or 0
                    str = r ? toFixedPoint( alphabet.charAt(1), -dp, alphabet.charAt(0) )
                            : alphabet.charAt(0);
                } else {

                    // Truncate xc to the required number of decimal places.
                    xc.length = d;

                    // Round up?
                    if (r) {

                        // Rounding up may mean the previous digit has to be rounded up and so on.
                        for ( --baseOut; ++xc[--d] > baseOut; ) {
                            xc[d] = 0;

                            if ( !d ) {
                                ++e;
                                xc = [1].concat(xc);
                            }
                        }
                    }

                    // Determine trailing zeros.
                    for ( k = xc.length; !xc[--k]; );

                    // E.g. [4, 11, 15] becomes 4bf.
                    for ( i = 0, str = ''; i <= k; str += alphabet.charAt( xc[i++] ) );

                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint( str, e, alphabet.charAt(0) );
                }

                // The caller will add the sign.
                return str;
            };
        })();


        // Perform division in the specified base. Called by div and convertBase.
        div = (function () {

            // Assume non-zero x and k.
            function multiply( x, k, base ) {
                var m, temp, xlo, xhi,
                    carry = 0,
                    i = x.length,
                    klo = k % SQRT_BASE,
                    khi = k / SQRT_BASE | 0;

                for ( x = x.slice(); i--; ) {
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + ( ( m % SQRT_BASE ) * SQRT_BASE ) + carry;
                    carry = ( temp / base | 0 ) + ( m / SQRT_BASE | 0 ) + khi * xhi;
                    x[i] = temp % base;
                }

                if (carry) x = [carry].concat(x);

                return x;
            }

            function compare( a, b, aL, bL ) {
                var i, cmp;

                if ( aL != bL ) {
                    cmp = aL > bL ? 1 : -1;
                } else {

                    for ( i = cmp = 0; i < aL; i++ ) {

                        if ( a[i] != b[i] ) {
                            cmp = a[i] > b[i] ? 1 : -1;
                            break;
                        }
                    }
                }
                return cmp;
            }

            function subtract( a, b, aL, base ) {
                var i = 0;

                // Subtract b from a.
                for ( ; aL--; ) {
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }

                // Remove leading zeros.
                for ( ; !a[0] && a.length > 1; a.splice(0, 1) );
            }

            // x: dividend, y: divisor.
            return function ( x, y, dp, rm, base ) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0,
                    yL, yz,
                    s = x.s == y.s ? 1 : -1,
                    xc = x.c,
                    yc = y.c;

                // Either NaN, Infinity or 0?
                if ( !xc || !xc[0] || !yc || !yc[0] ) {

                    return new BigNumber(

                      // Return NaN if either NaN, or both Infinity or 0.
                      !x.s || !y.s || ( xc ? yc && xc[0] == yc[0] : !yc ) ? NaN :

                        // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                        xc && xc[0] == 0 || !yc ? s * 0 : s / 0
                    );
                }

                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;

                if ( !base ) {
                    base = BASE;
                    e = bitFloor( x.e / LOG_BASE ) - bitFloor( y.e / LOG_BASE );
                    s = s / LOG_BASE | 0;
                }

                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for ( i = 0; yc[i] == ( xc[i] || 0 ); i++ );

                if ( yc[i] > ( xc[i] || 0 ) ) e--;

                if ( s < 0 ) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;

                    // Normalise xc and yc so highest order digit of yc is >= base / 2.

                    n = mathfloor( base / ( yc[0] + 1 ) );

                    // Not necessary, but to handle odd bases where yc[0] == ( base / 2 ) - 1.
                    // if ( n > 1 || n++ == 1 && yc[0] < base / 2 ) {
                    if ( n > 1 ) {
                        yc = multiply( yc, n, base );
                        xc = multiply( xc, n, base );
                        yL = yc.length;
                        xL = xc.length;
                    }

                    xi = yL;
                    rem = xc.slice( 0, yL );
                    remL = rem.length;

                    // Add zeros to make remainder as long as divisor.
                    for ( ; remL < yL; rem[remL++] = 0 );
                    yz = yc.slice();
                    yz = [0].concat(yz);
                    yc0 = yc[0];
                    if ( yc[1] >= base / 2 ) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if ( base == 3 && yc0 == 1 ) yc0 = 1 + 1e-15;

                    do {
                        n = 0;

                        // Compare divisor and remainder.
                        cmp = compare( yc, rem, yL, remL );

                        // If divisor < remainder.
                        if ( cmp < 0 ) {

                            // Calculate trial digit, n.

                            rem0 = rem[0];
                            if ( yL != remL ) rem0 = rem0 * base + ( rem[1] || 0 );

                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor( rem0 / yc0 );

                            //  Algorithm:
                            //  1. product = divisor * trial digit (n)
                            //  2. if product > remainder: product -= divisor, n--
                            //  3. remainder -= product
                            //  4. if product was < remainder at 2:
                            //    5. compare new remainder and divisor
                            //    6. If remainder > divisor: remainder -= divisor, n++

                            if ( n > 1 ) {

                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;

                                // product = divisor * trial digit.
                                prod = multiply( yc, n, base );
                                prodL = prod.length;
                                remL = rem.length;

                                // Compare product and remainder.
                                // If product > remainder.
                                // Trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while ( compare( prod, rem, prodL, remL ) == 1 ) {
                                    n--;

                                    // Subtract divisor from product.
                                    subtract( prod, yL < prodL ? yz : yc, prodL, base );
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {

                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if ( n == 0 ) {

                                    // divisor < remainder, so n must be at least 1.
                                    cmp = n = 1;
                                }

                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }

                            if ( prodL < remL ) prod = [0].concat(prod);

                            // Subtract product from remainder.
                            subtract( rem, prod, remL, base );
                            remL = rem.length;

                             // If product was < remainder.
                            if ( cmp == -1 ) {

                                // Compare divisor and new remainder.
                                // If divisor < new remainder, subtract divisor from remainder.
                                // Trial digit n too low.
                                // n is 1 too low about 5% of the time, and very rarely 2 too low.
                                while ( compare( yc, rem, yL, remL ) < 1 ) {
                                    n++;

                                    // Subtract divisor from remainder.
                                    subtract( rem, yL < remL ? yz : yc, remL, base );
                                    remL = rem.length;
                                }
                            }
                        } else if ( cmp === 0 ) {
                            n++;
                            rem = [0];
                        } // else cmp === 1 and n will be 0

                        // Add the next digit, n, to the result array.
                        qc[i++] = n;

                        // Update the remainder.
                        if ( rem[0] ) {
                            rem[remL++] = xc[xi] || 0;
                        } else {
                            rem = [ xc[xi] ];
                            remL = 1;
                        }
                    } while ( ( xi++ < xL || rem[0] != null ) && s-- );

                    more = rem[0] != null;

                    // Leading zero?
                    if ( !qc[0] ) qc.splice(0, 1);
                }

                if ( base == BASE ) {

                    // To calculate q.e, first get the number of digits of qc[0].
                    for ( i = 1, s = qc[0]; s >= 10; s /= 10, i++ );

                    round( q, dp + ( q.e = i + e * LOG_BASE - 1 ) + 1, rm, more );

                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }

                return q;
            };
        })();


        /*
         * Return a string representing the value of BigNumber n in fixed-point or exponential
         * notation rounded to the specified decimal places or significant digits.
         *
         * n: a BigNumber.
         * i: the index of the last digit required (i.e. the digit that may be rounded up).
         * rm: the rounding mode.
         * id: 1 (toExponential) or 2 (toPrecision).
         */
        function format( n, i, rm, id ) {
            var c0, e, ne, len, str;

            if ( rm == null ) rm = ROUNDING_MODE;
            else intCheck( rm, 0, 8 );

            if ( !n.c ) return n.toString();

            c0 = n.c[0];
            ne = n.e;

            if ( i == null ) {
                str = coeffToString( n.c );
                str = id == 1 || id == 2 && ne <= TO_EXP_NEG
                  ? toExponential( str, ne )
                  : toFixedPoint( str, ne, '0' );
            } else {
                n = round( new BigNumber(n), i, rm );

                // n.e may have changed if the value was rounded up.
                e = n.e;

                str = coeffToString( n.c );
                len = str.length;

                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.

                // Exponential notation.
                if ( id == 1 || id == 2 && ( i <= e || e <= TO_EXP_NEG ) ) {

                    // Append zeros?
                    for ( ; len < i; str += '0', len++ );
                    str = toExponential( str, e );

                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint( str, e, '0' );

                    // Append zeros?
                    if ( e + 1 > len ) {
                        if ( --i > 0 ) for ( str += '.'; i--; str += '0' );
                    } else {
                        i += e - len;
                        if ( i > 0 ) {
                            if ( e + 1 == len ) str += '.';
                            for ( ; i--; str += '0' );
                        }
                    }
                }
            }

            return n.s < 0 && c0 ? '-' + str : str;
        }


        // Handle BigNumber.max and BigNumber.min.
        function maxOrMin( args, method ) {
            var m, n,
                i = 0;

            if ( isArray( args[0] ) ) args = args[0];
            m = new BigNumber( args[0] );

            for ( ; ++i < args.length; ) {
                n = new BigNumber( args[i] );

                // If any number is NaN, return NaN.
                if ( !n.s ) {
                    m = n;
                    break;
                } else if ( method.call( m, n ) ) {
                    m = n;
                }
            }

            return m;
        }


        /*
         * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
         * Called by minus, plus and times.
         */
        function normalise( n, c, e ) {
            var i = 1,
                j = c.length;

             // Remove trailing zeros.
            for ( ; !c[--j]; c.pop() );

            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for ( j = c[0]; j >= 10; j /= 10, i++ );

            // Overflow?
            if ( ( e = i + e * LOG_BASE - 1 ) > MAX_EXP ) {

                // Infinity.
                n.c = n.e = null;

            // Underflow?
            } else if ( e < MIN_EXP ) {

                // Zero.
                n.c = [ n.e = 0 ];
            } else {
                n.e = e;
                n.c = c;
            }

            return n;
        }


        // Handle values that fail the validity test in BigNumber.
        parseNumeric = (function () {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i,
                dotAfter = /^([^.]+)\.$/,
                dotBefore = /^\.([^.]+)$/,
                isInfinityOrNaN = /^-?(Infinity|NaN)$/,
                whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;

            return function ( x, str, isNum, b ) {
                var base,
                    s = isNum ? str : str.replace( whitespaceOrPlus, '' );

                // No exception on ±Infinity or NaN.
                if ( isInfinityOrNaN.test(s) ) {
                    x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                    x.c = x.e = null;
                } else {
                    if ( !isNum ) {

                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace( basePrefix, function ( m, p1, p2 ) {
                            base = ( p2 = p2.toLowerCase() ) == 'x' ? 16 : p2 == 'b' ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });

                        if (b) {
                            base = b;

                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace( dotAfter, '$1' ).replace( dotBefore, '0.$1' );
                        }

                        if ( str != s ) return new BigNumber( s, base );
                    }

                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    throw Error
                      ( bignumberError + 'Not a' + ( b ? ' base ' + b : '' ) + ' number: ' + str );
                }
            }
        })();


        /*
         * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
         * If r is truthy, it is known that there are more digits after the rounding digit.
         */
        function round( x, sd, rm, r ) {
            var d, i, j, k, n, ni, rd,
                xc = x.c,
                pows10 = POWS_TEN;

            // if x is not Infinity or NaN...
            if (xc) {

                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {

                    // Get the number of digits of the first element of xc.
                    for ( d = 1, k = xc[0]; k >= 10; k /= 10, d++ );
                    i = sd - d;

                    // If the rounding digit is in the first element of xc...
                    if ( i < 0 ) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ ni = 0 ];

                        // Get the rounding digit at index j of n.
                        rd = n / pows10[ d - j - 1 ] % 10 | 0;
                    } else {
                        ni = mathceil( ( i + 1 ) / LOG_BASE );

                        if ( ni >= xc.length ) {

                            if (r) {

                                // Needed by sqrt.
                                for ( ; xc.length <= ni; xc.push(0) );
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else {
                                break out;
                            }
                        } else {
                            n = k = xc[ni];

                            // Get the number of digits of n.
                            for ( d = 1; k >= 10; k /= 10, d++ );

                            // Get the index of rd within n.
                            i %= LOG_BASE;

                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;

                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : n / pows10[ d - j - 1 ] % 10 | 0;
                        }
                    }

                    r = r || sd < 0 ||

                    // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[ d - j - 1 ]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                      xc[ni + 1] != null || ( j < 0 ? n : n % pows10[ d - j - 1 ] );

                    r = rm < 4
                      ? ( rd || r ) && ( rm == 0 || rm == ( x.s < 0 ? 3 : 2 ) )
                      : rd > 5 || rd == 5 && ( rm == 4 || r || rm == 6 &&

                        // Check whether the digit to the left of the rounding digit is odd.
                        ( ( i > 0 ? j > 0 ? n / pows10[ d - j ] : 0 : xc[ni - 1] ) % 10 ) & 1 ||
                          rm == ( x.s < 0 ? 8 : 7 ) );

                    if ( sd < 1 || !xc[0] ) {
                        xc.length = 0;

                        if (r) {

                            // Convert sd to decimal places.
                            sd -= x.e + 1;

                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[ ( LOG_BASE - sd % LOG_BASE ) % LOG_BASE ];
                            x.e = -sd || 0;
                        } else {

                            // Zero.
                            xc[0] = x.e = 0;
                        }

                        return x;
                    }

                    // Remove excess digits.
                    if ( i == 0 ) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[ LOG_BASE - i ];

                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor( n / pows10[ d - j ] % pows10[j] ) * k : 0;
                    }

                    // Round up?
                    if (r) {

                        for ( ; ; ) {

                            // If the digit to be rounded up is in the first element of xc...
                            if ( ni == 0 ) {

                                // i will be the length of xc[0] before k is added.
                                for ( i = 1, j = xc[0]; j >= 10; j /= 10, i++ );
                                j = xc[0] += k;
                                for ( k = 1; j >= 10; j /= 10, k++ );

                                // if i != k the length has increased.
                                if ( i != k ) {
                                    x.e++;
                                    if ( xc[0] == BASE ) xc[0] = 1;
                                }

                                break;
                            } else {
                                xc[ni] += k;
                                if ( xc[ni] != BASE ) break;
                                xc[ni--] = 0;
                                k = 1;
                            }
                        }
                    }

                    // Remove trailing zeros.
                    for ( i = xc.length; xc[--i] === 0; xc.pop() );
                }

                // Overflow? Infinity.
                if ( x.e > MAX_EXP ) {
                    x.c = x.e = null;

                // Underflow? Zero.
                } else if ( x.e < MIN_EXP ) {
                    x.c = [ x.e = 0 ];
                }
            }

            return x;
        }


        // PROTOTYPE/INSTANCE METHODS


        /*
         * Return a new BigNumber whose value is the absolute value of this BigNumber.
         */
        P.absoluteValue = P.abs = function () {
            var x = new BigNumber(this);
            if ( x.s < 0 ) x.s = 1;
            return x;
        };


        /*
         * Return
         *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
         *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
         *   0 if they have the same value,
         *   or null if the value of either is NaN.
         */
        P.comparedTo = function ( y, b ) {
            return compare( this, new BigNumber( y, b ) );
        };


        /*
         * If dp is undefined or null or true or false, return the number of decimal places of the
         * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
         *
         * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
         * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
         * ROUNDING_MODE if rm is omitted.
         *
         * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
         *
         * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
         */
        P.decimalPlaces = P.dp = function ( dp, rm ) {
            var c, n, v,
                x = this;

            if ( dp != null ) {
                intCheck( dp, 0, MAX );
                if ( rm == null ) rm = ROUNDING_MODE;
                else intCheck( rm, 0, 8 );

                return round( new BigNumber(x), dp + x.e + 1, rm );
            }

            if ( !( c = x.c ) ) return null;
            n = ( ( v = c.length - 1 ) - bitFloor( this.e / LOG_BASE ) ) * LOG_BASE;

            // Subtract the number of trailing zeros of the last number.
            if ( v = c[v] ) for ( ; v % 10 == 0; v /= 10, n-- );
            if ( n < 0 ) n = 0;

            return n;
        };


        /*
         *  n / 0 = I
         *  n / N = N
         *  n / I = 0
         *  0 / n = 0
         *  0 / 0 = N
         *  0 / N = N
         *  0 / I = 0
         *  N / n = N
         *  N / 0 = N
         *  N / N = N
         *  N / I = N
         *  I / n = I
         *  I / 0 = I
         *  I / N = N
         *  I / I = N
         *
         * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
         * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
         */
        P.dividedBy = P.div = function ( y, b ) {
            return div( this, new BigNumber( y, b ), DECIMAL_PLACES, ROUNDING_MODE );
        };


        /*
         * Return a new BigNumber whose value is the integer part of dividing the value of this
         * BigNumber by the value of BigNumber(y, b).
         */
        P.dividedToIntegerBy = P.idiv = function ( y, b ) {
            return div( this, new BigNumber( y, b ), 0, 1 );
        };


        /*
         * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
         * otherwise return false.
         */
        P.isEqualTo = P.eq = function ( y, b ) {
            return compare( this, new BigNumber( y, b ) ) === 0;
        };


        /*
         * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
         * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
         *
         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
         *
         * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
         */
        P.integerValue = function (rm) {
            var n = new BigNumber(this);
            if ( rm == null ) rm = ROUNDING_MODE;
            else intCheck( rm, 0, 8 );
            return round( n, n.e + 1, rm );
        };


        /*
         * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
         * otherwise return false.
         */
        P.isGreaterThan = P.gt = function ( y, b ) {
            return compare( this, new BigNumber( y, b ) ) > 0;
        };


        /*
         * Return true if the value of this BigNumber is greater than or equal to the value of
         * BigNumber(y, b), otherwise return false.
         */
        P.isGreaterThanOrEqualTo = P.gte = function ( y, b ) {
            return ( b = compare( this, new BigNumber( y, b ) ) ) === 1 || b === 0;

        };


        /*
         * Return true if the value of this BigNumber is a finite number, otherwise return false.
         */
        P.isFinite = function () {
            return !!this.c;
        };


        /*
         * Return true if the value of this BigNumber is an integer, otherwise return false.
         */
        P.isInteger = function () {
            return !!this.c && bitFloor( this.e / LOG_BASE ) > this.c.length - 2;
        };


        /*
         * Return true if the value of this BigNumber is NaN, otherwise return false.
         */
        P.isNaN = function () {
            return !this.s;
        };


        /*
         * Return true if the value of this BigNumber is negative, otherwise return false.
         */
        P.isNegative = function () {
            return this.s < 0;
        };


        /*
         * Return true if the value of this BigNumber is positive, otherwise return false.
         */
        P.isPositive = function () {
            return this.s > 0;
        };


        /*
         * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
         */
        P.isZero = function () {
            return !!this.c && this.c[0] == 0;
        };


        /*
         * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
         * otherwise return false.
         */
        P.isLessThan = P.lt = function ( y, b ) {
            return compare( this, new BigNumber( y, b ) ) < 0;
        };


        /*
         * Return true if the value of this BigNumber is less than or equal to the value of
         * BigNumber(y, b), otherwise return false.
         */
        P.isLessThanOrEqualTo = P.lte = function ( y, b ) {
            return ( b = compare( this, new BigNumber( y, b ) ) ) === -1 || b === 0;
        };


        /*
         *  n - 0 = n
         *  n - N = N
         *  n - I = -I
         *  0 - n = -n
         *  0 - 0 = 0
         *  0 - N = N
         *  0 - I = -I
         *  N - n = N
         *  N - 0 = N
         *  N - N = N
         *  N - I = N
         *  I - n = I
         *  I - 0 = I
         *  I - N = N
         *  I - I = N
         *
         * Return a new BigNumber whose value is the value of this BigNumber minus the value of
         * BigNumber(y, b).
         */
        P.minus = function ( y, b ) {
            var i, j, t, xLTy,
                x = this,
                a = x.s;

            y = new BigNumber( y, b );
            b = y.s;

            // Either NaN?
            if ( !a || !b ) return new BigNumber(NaN);

            // Signs differ?
            if ( a != b ) {
                y.s = -b;
                return x.plus(y);
            }

            var xe = x.e / LOG_BASE,
                ye = y.e / LOG_BASE,
                xc = x.c,
                yc = y.c;

            if ( !xe || !ye ) {

                // Either Infinity?
                if ( !xc || !yc ) return xc ? ( y.s = -b, y ) : new BigNumber( yc ? x : NaN );

                // Either zero?
                if ( !xc[0] || !yc[0] ) {

                    // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                    return yc[0] ? ( y.s = -b, y ) : new BigNumber( xc[0] ? x :

                      // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                      ROUNDING_MODE == 3 ? -0 : 0 );
                }
            }

            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();

            // Determine which is the bigger number.
            if ( a = xe - ye ) {

                if ( xLTy = a < 0 ) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }

                t.reverse();

                // Prepend zeros to equalise exponents.
                for ( b = a; b--; t.push(0) );
                t.reverse();
            } else {

                // Exponents equal. Check digit by digit.
                j = ( xLTy = ( a = xc.length ) < ( b = yc.length ) ) ? a : b;

                for ( a = b = 0; b < j; b++ ) {

                    if ( xc[b] != yc[b] ) {
                        xLTy = xc[b] < yc[b];
                        break;
                    }
                }
            }

            // x < y? Point xc to the array of the bigger number.
            if (xLTy) t = xc, xc = yc, yc = t, y.s = -y.s;

            b = ( j = yc.length ) - ( i = xc.length );

            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if ( b > 0 ) for ( ; b--; xc[i++] = 0 );
            b = BASE - 1;

            // Subtract yc from xc.
            for ( ; j > a; ) {

                if ( xc[--j] < yc[j] ) {
                    for ( i = j; i && !xc[--i]; xc[i] = b );
                    --xc[i];
                    xc[j] += BASE;
                }

                xc[j] -= yc[j];
            }

            // Remove leading zeros and adjust exponent accordingly.
            for ( ; xc[0] == 0; xc.splice(0, 1), --ye );

            // Zero?
            if ( !xc[0] ) {

                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [ y.e = 0 ];
                return y;
            }

            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise( y, xc, ye );
        };


        /*
         *   n % 0 =  N
         *   n % N =  N
         *   n % I =  n
         *   0 % n =  0
         *  -0 % n = -0
         *   0 % 0 =  N
         *   0 % N =  N
         *   0 % I =  0
         *   N % n =  N
         *   N % 0 =  N
         *   N % N =  N
         *   N % I =  N
         *   I % n =  N
         *   I % 0 =  N
         *   I % N =  N
         *   I % I =  N
         *
         * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
         * BigNumber(y, b). The result depends on the value of MODULO_MODE.
         */
        P.modulo = P.mod = function ( y, b ) {
            var q, s,
                x = this;

            y = new BigNumber( y, b );

            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if ( !x.c || !y.s || y.c && !y.c[0] ) {
                return new BigNumber(NaN);

            // Return x if y is Infinity or x is zero.
            } else if ( !y.c || x.c && !x.c[0] ) {
                return new BigNumber(x);
            }

            if ( MODULO_MODE == 9 ) {

                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div( x, y, 0, 3 );
                y.s = s;
                q.s *= s;
            } else {
                q = div( x, y, 0, MODULO_MODE );
            }

            return x.minus( q.times(y) );
        };


        /*
         *  n * 0 = 0
         *  n * N = N
         *  n * I = I
         *  0 * n = 0
         *  0 * 0 = 0
         *  0 * N = N
         *  0 * I = N
         *  N * n = N
         *  N * 0 = N
         *  N * N = N
         *  N * I = N
         *  I * n = I
         *  I * 0 = N
         *  I * N = N
         *  I * I = I
         *
         * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
         * of BigNumber(y, b).
         */
        P.multipliedBy = P.times = function ( y, b ) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc,
                base, sqrtBase,
                x = this,
                xc = x.c,
                yc = ( y = new BigNumber( y, b ) ).c;

            // Either NaN, ±Infinity or ±0?
            if ( !xc || !yc || !xc[0] || !yc[0] ) {

                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if ( !x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc ) {
                    y.c = y.e = y.s = null;
                } else {
                    y.s *= x.s;

                    // Return ±Infinity if either is ±Infinity.
                    if ( !xc || !yc ) {
                        y.c = y.e = null;

                    // Return ±0 if either is ±0.
                    } else {
                        y.c = [0];
                        y.e = 0;
                    }
                }

                return y;
            }

            e = bitFloor( x.e / LOG_BASE ) + bitFloor( y.e / LOG_BASE );
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;

            // Ensure xc points to longer array and xcL to its length.
            if ( xcL < ycL ) zc = xc, xc = yc, yc = zc, i = xcL, xcL = ycL, ycL = i;

            // Initialise the result array with zeros.
            for ( i = xcL + ycL, zc = []; i--; zc.push(0) );

            base = BASE;
            sqrtBase = SQRT_BASE;

            for ( i = ycL; --i >= 0; ) {
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;

                for ( k = xcL, j = i + k; j > i; ) {
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + ( ( m % sqrtBase ) * sqrtBase ) + zc[j] + c;
                    c = ( xlo / base | 0 ) + ( m / sqrtBase | 0 ) + yhi * xhi;
                    zc[j--] = xlo % base;
                }

                zc[j] = c;
            }

            if (c) {
                ++e;
            } else {
                zc.splice(0, 1);
            }

            return normalise( y, zc, e );
        };


        /*
         * Return a new BigNumber whose value is the value of this BigNumber negated,
         * i.e. multiplied by -1.
         */
        P.negated = function () {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };


        /*
         *  n + 0 = n
         *  n + N = N
         *  n + I = I
         *  0 + n = n
         *  0 + 0 = 0
         *  0 + N = N
         *  0 + I = I
         *  N + n = N
         *  N + 0 = N
         *  N + N = N
         *  N + I = N
         *  I + n = I
         *  I + 0 = I
         *  I + N = N
         *  I + I = I
         *
         * Return a new BigNumber whose value is the value of this BigNumber plus the value of
         * BigNumber(y, b).
         */
        P.plus = function ( y, b ) {
            var t,
                x = this,
                a = x.s;

            y = new BigNumber( y, b );
            b = y.s;

            // Either NaN?
            if ( !a || !b ) return new BigNumber(NaN);

            // Signs differ?
             if ( a != b ) {
                y.s = -b;
                return x.minus(y);
            }

            var xe = x.e / LOG_BASE,
                ye = y.e / LOG_BASE,
                xc = x.c,
                yc = y.c;

            if ( !xe || !ye ) {

                // Return ±Infinity if either ±Infinity.
                if ( !xc || !yc ) return new BigNumber( a / 0 );

                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if ( !xc[0] || !yc[0] ) return yc[0] ? y : new BigNumber( xc[0] ? x : a * 0 );
            }

            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();

            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if ( a = xe - ye ) {
                if ( a > 0 ) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }

                t.reverse();
                for ( ; a--; t.push(0) );
                t.reverse();
            }

            a = xc.length;
            b = yc.length;

            // Point xc to the longer array, and b to the shorter length.
            if ( a - b < 0 ) t = yc, yc = xc, xc = t, b = a;

            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for ( a = 0; b; ) {
                a = ( xc[--b] = xc[b] + yc[b] + a ) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }

            if (a) {
                xc = [a].concat(xc);
                ++ye;
            }

            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise( y, xc, ye );
        };


        /*
         * If sd is undefined or null or true or false, return the number of significant digits of
         * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
         * If sd is true include integer-part trailing zeros in the count.
         *
         * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
         * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
         * ROUNDING_MODE if rm is omitted.
         *
         * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
         *                     boolean: whether to count integer-part trailing zeros: true or false.
         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
         *
         * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
         */
        P.precision = P.sd = function ( sd, rm ) {
            var c, n, v,
                x = this;

            if ( sd != null && sd !== !!sd ) {
                intCheck( sd, 1, MAX );
                if ( rm == null ) rm = ROUNDING_MODE;
                else intCheck( rm, 0, 8 );

                return round( new BigNumber(x), sd, rm );
            }

            if ( !( c = x.c ) ) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;

            if ( v = c[v] ) {

                // Subtract the number of trailing zeros of the last element.
                for ( ; v % 10 == 0; v /= 10, n-- );

                // Add the number of digits of the first element.
                for ( v = c[0]; v >= 10; v /= 10, n++ );
            }

            if ( sd && x.e + 1 > n ) n = x.e + 1;

            return n;
        };


        /*
         * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
         * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
         *
         * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
         *
         * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
         */
        P.shiftedBy = function (k) {
            intCheck( k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER );
            return this.times( '1e' + k );
        };


        /*
         *  sqrt(-n) =  N
         *  sqrt( N) =  N
         *  sqrt(-I) =  N
         *  sqrt( I) =  I
         *  sqrt( 0) =  0
         *  sqrt(-0) = -0
         *
         * Return a new BigNumber whose value is the square root of the value of this BigNumber,
         * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
         */
        P.squareRoot = P.sqrt = function () {
            var m, n, r, rep, t,
                x = this,
                c = x.c,
                s = x.s,
                e = x.e,
                dp = DECIMAL_PLACES + 4,
                half = new BigNumber('0.5');

            // Negative/NaN/Infinity/zero?
            if ( s !== 1 || !c || !c[0] ) {
                return new BigNumber( !s || s < 0 && ( !c || c[0] ) ? NaN : c ? x : 1 / 0 );
            }

            // Initial estimate.
            s = Math.sqrt( +x );

            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if ( s == 0 || s == 1 / 0 ) {
                n = coeffToString(c);
                if ( ( n.length + e ) % 2 == 0 ) n += '0';
                s = Math.sqrt(n);
                e = bitFloor( ( e + 1 ) / 2 ) - ( e < 0 || e % 2 );

                if ( s == 1 / 0 ) {
                    n = '1e' + e;
                } else {
                    n = s.toExponential();
                    n = n.slice( 0, n.indexOf('e') + 1 ) + e;
                }

                r = new BigNumber(n);
            } else {
                r = new BigNumber( s + '' );
            }

            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if ( r.c[0] ) {
                e = r.e;
                s = e + dp;
                if ( s < 3 ) s = 0;

                // Newton-Raphson iteration.
                for ( ; ; ) {
                    t = r;
                    r = half.times( t.plus( div( x, t, dp, 1 ) ) );

                    if ( coeffToString( t.c   ).slice( 0, s ) === ( n =
                         coeffToString( r.c ) ).slice( 0, s ) ) {

                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if ( r.e < e ) --s;
                        n = n.slice( s - 3, s + 1 );

                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if ( n == '9999' || !rep && n == '4999' ) {

                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if ( !rep ) {
                                round( t, t.e + DECIMAL_PLACES + 2, 0 );

                                if ( t.times(t).eq(x) ) {
                                    r = t;
                                    break;
                                }
                            }

                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {

                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if ( !+n || !+n.slice(1) && n.charAt(0) == '5' ) {

                                // Truncate to the first rounding digit.
                                round( r, r.e + DECIMAL_PLACES + 2, 1 );
                                m = !r.times(r).eq(x);
                            }

                            break;
                        }
                    }
                }
            }

            return round( r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m );
        };


        /*
         * Return a string representing the value of this BigNumber in exponential notation and
         * rounded using ROUNDING_MODE to dp fixed decimal places.
         *
         * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
         *
         * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
         */
        P.toExponential = function ( dp, rm ) {
            if ( dp != null ) {
                intCheck( dp, 0, MAX );
                dp++;
            }
            return format( this, dp, rm, 1 );
        };


        /*
         * Return a string representing the value of this BigNumber in fixed-point notation rounding
         * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
         *
         * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
         * but e.g. (-0.00001).toFixed(0) is '-0'.
         *
         * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
         *
         * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
         */
        P.toFixed = function ( dp, rm ) {
            if ( dp != null ) {
                intCheck( dp, 0, MAX );
                dp = dp + this.e + 1;
            }
            return format( this, dp, rm );
        };


        /*
         * Return a string representing the value of this BigNumber in fixed-point notation rounded
         * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
         * of the FORMAT object (see BigNumber.set).
         *
         * FORMAT = {
         *      decimalSeparator : '.',
         *      groupSeparator : ',',
         *      groupSize : 3,
         *      secondaryGroupSize : 0,
         *      fractionGroupSeparator : '\xA0',    // non-breaking space
         *      fractionGroupSize : 0
         * };
         *
         * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
         *
         * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
         */
        P.toFormat = function ( dp, rm ) {
            var str = this.toFixed( dp, rm );

            if ( this.c ) {
                var i,
                    arr = str.split('.'),
                    g1 = +FORMAT.groupSize,
                    g2 = +FORMAT.secondaryGroupSize,
                    groupSeparator = FORMAT.groupSeparator,
                    intPart = arr[0],
                    fractionPart = arr[1],
                    isNeg = this.s < 0,
                    intDigits = isNeg ? intPart.slice(1) : intPart,
                    len = intDigits.length;

                if (g2) i = g1, g1 = g2, g2 = i, len -= i;

                if ( g1 > 0 && len > 0 ) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr( 0, i );

                    for ( ; i < len; i += g1 ) {
                        intPart += groupSeparator + intDigits.substr( i, g1 );
                    }

                    if ( g2 > 0 ) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = '-' + intPart;
                }

                str = fractionPart
                  ? intPart + FORMAT.decimalSeparator + ( ( g2 = +FORMAT.fractionGroupSize )
                    ? fractionPart.replace( new RegExp( '\\d{' + g2 + '}\\B', 'g' ),
                      '$&' + FORMAT.fractionGroupSeparator )
                    : fractionPart )
                  : intPart;
            }

            return str;
        };


        /*
         * Return a string array representing the value of this BigNumber as a simple fraction with
         * an integer numerator and an integer denominator. The denominator will be a positive
         * non-zero value less than or equal to the specified maximum denominator. If a maximum
         * denominator is not specified, the denominator will be the lowest value necessary to
         * represent the number exactly.
         *
         * [md] {number|string|BigNumber} Integer >= 1 and < Infinity. The maximum denominator.
         *
         * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
         */
        P.toFraction = function (md) {
            var arr, d, d0, d1, d2, e, exp, n, n0, n1, q, s,
                x = this,
                xc = x.c;

            if ( md != null ) {
                n = new BigNumber(md);

                if ( !n.isInteger() || n.lt(ONE) ) {
                    throw Error
                      ( bignumberError + 'Argument ' +
                        ( n.isInteger() ? 'out of range: ' : 'not an integer: ' ) + md );
                }
            }

            if ( !xc ) return x.toString();

            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);

            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[ ( exp = e % LOG_BASE ) < 0 ? LOG_BASE + exp : exp ];
            md = !md || n.comparedTo(d) > 0 ? ( e > 0 ? d : n1 ) : n;

            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);

            // n0 = d1 = 0
            n0.c[0] = 0;

            for ( ; ; )  {
                q = div( n, d, 0, 1 );
                d2 = d0.plus( q.times(d1) );
                if ( d2.comparedTo(md) == 1 ) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus( q.times( d2 = n1 ) );
                n0 = d2;
                d = n.minus( q.times( d2 = d ) );
                n = d2;
            }

            d2 = div( md.minus(d0), d1, 0, 1 );
            n0 = n0.plus( d2.times(n1) );
            d0 = d0.plus( d2.times(d1) );
            n0.s = n1.s = x.s;
            e *= 2;

            // Determine which fraction is closer to x, n0/d0 or n1/d1
            arr = div( n1, d1, e, ROUNDING_MODE ).minus(x).abs().comparedTo(
                  div( n0, d0, e, ROUNDING_MODE ).minus(x).abs() ) < 1
                    ? [ n1.toString(), d1.toString() ]
                    : [ n0.toString(), d0.toString() ];

            MAX_EXP = exp;
            return arr;
        };


        /*
         * Return the value of this BigNumber converted to a number primitive.
         */
        P.toNumber = function () {
            return +this;
        };


        /*
         * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
         *
         * If m is present, return the result modulo m.
         * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
         * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
         *
         * The modular power operation works efficiently when x, n, and m are positive integers,
         * otherwise it is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
         *
         * n {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
         * [m] {number|string|BigNumber} The modulus.
         *
         * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {n}'
         *
         * Performs 54 loop iterations for n of 9007199254740991.
         */
        P.exponentiatedBy = P.pow = function ( n, m ) {
            var i, k, y, z,
                x = this;

            intCheck( n, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER );
            if ( m != null ) m = new BigNumber(m);

            if (m) {
                if ( n > 1 && x.gt(ONE) && x.isInteger() && m.gt(ONE) && m.isInteger() ) {
                    x = x.mod(m);
                } else {
                    z = m;

                    // Nullify m so only a single mod operation is performed at the end.
                    m = null;
                }
            } else if (POW_PRECISION) {

                // Truncating each coefficient array to a length of k after each multiplication
                // equates to truncating significant digits to POW_PRECISION + [28, 41],
                // i.e. there will be a minimum of 28 guard digits retained.
                //k = mathceil( POW_PRECISION / LOG_BASE + 1.5 );   // gives [9, 21] guard digits.
                k = mathceil( POW_PRECISION / LOG_BASE + 2 );
            }

            y = new BigNumber(ONE);

            for ( i = mathfloor( n < 0 ? -n : n ); ; ) {
                if ( i % 2 ) {
                    y = y.times(x);
                    if ( !y.c ) break;
                    if (k) {
                        if ( y.c.length > k ) y.c.length = k;
                    } else if (m) {
                        y = y.mod(m);
                    }
                }

                i = mathfloor( i / 2 );
                if ( !i ) break;
                x = x.times(x);
                if (k) {
                    if ( x.c && x.c.length > k ) x.c.length = k;
                } else if (m) {
                    x = x.mod(m);
                }
            }

            if (m) return y;
            if ( n < 0 ) y = ONE.div(y);

            return z ? y.mod(z) : k ? round( y, POW_PRECISION, ROUNDING_MODE ) : y;
        };


        /*
         * Return a string representing the value of this BigNumber rounded to sd significant digits
         * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
         * necessary to represent the integer part of the value in fixed-point notation, then use
         * exponential notation.
         *
         * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
         * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
         *
         * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
         */
        P.toPrecision = function ( sd, rm ) {
            if ( sd != null ) intCheck( sd, 1, MAX );
            return format( this, sd, rm, 2 );
        };


        /*
         * Return a string representing the value of this BigNumber in base b, or base 10 if b is
         * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
         * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
         * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
         * TO_EXP_NEG, return exponential notation.
         *
         * [b] {number} Integer, 2 to ALPHABET.length inclusive.
         *
         * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
         */
        P.toString = function (b) {
            var str,
                n = this,
                s = n.s,
                e = n.e;

            // Infinity or NaN?
            if ( e === null ) {

                if (s) {
                    str = 'Infinity';
                    if ( s < 0 ) str = '-' + str;
                } else {
                    str = 'NaN';
                }
            } else {
                str = coeffToString( n.c );

                if ( b == null ) {
                    str = e <= TO_EXP_NEG || e >= TO_EXP_POS
                      ? toExponential( str, e )
                      : toFixedPoint( str, e, '0' );
                } else {
                    intCheck( b, 2, ALPHABET.length, 'Base' );
                    str = convertBase( toFixedPoint( str, e, '0' ), 10, b, s, true );
                }

                if ( s < 0 && n.c[0] ) str = '-' + str;
            }

            return str;
        };


        /*
         * Return as toString, but do not accept a base argument, and include the minus sign for
         * negative zero.
         */
        P.valueOf = P.toJSON = function () {
            var str,
                n = this,
                e = n.e;

            if ( e === null ) return n.toString();

            str = coeffToString( n.c );

            str = e <= TO_EXP_NEG || e >= TO_EXP_POS
                ? toExponential( str, e )
                : toFixedPoint( str, e, '0' );

            return n.s < 0 ? '-' + str : str;
        };


        P._isBigNumber = true;

        if ( configObject != null ) BigNumber.set(configObject);

        return BigNumber;
    }


    // PRIVATE HELPER FUNCTIONS


    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }


    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z,
            i = 1,
            j = a.length,
            r = a[0] + '';

        for ( ; i < j; ) {
            s = a[i++] + '';
            z = LOG_BASE - s.length;
            for ( ; z--; s = '0' + s );
            r += s;
        }

        // Determine trailing zeros.
        for ( j = r.length; r.charCodeAt(--j) === 48; );
        return r.slice( 0, j + 1 || 1 );
    }


    // Compare the value of BigNumbers x and y.
    function compare( x, y ) {
        var a, b,
            xc = x.c,
            yc = y.c,
            i = x.s,
            j = y.s,
            k = x.e,
            l = y.e;

        // Either NaN?
        if ( !i || !j ) return null;

        a = xc && !xc[0];
        b = yc && !yc[0];

        // Either zero?
        if ( a || b ) return a ? b ? 0 : -j : i;

        // Signs differ?
        if ( i != j ) return i;

        a = i < 0;
        b = k == l;

        // Either Infinity?
        if ( !xc || !yc ) return b ? 0 : !xc ^ a ? 1 : -1;

        // Compare exponents.
        if ( !b ) return k > l ^ a ? 1 : -1;

        j = ( k = xc.length ) < ( l = yc.length ) ? k : l;

        // Compare digit by digit.
        for ( i = 0; i < j; i++ ) if ( xc[i] != yc[i] ) return xc[i] > yc[i] ^ a ? 1 : -1;

        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }


    /*
     * Check that n is a primitive number, an integer, and in range, otherwise throw.
     */
    function intCheck( n, min, max, name ) {
        if ( n < min || n > max || n !== ( n < 0 ? mathceil(n) : mathfloor(n) ) ) {
            throw Error
              ( bignumberError + ( name || 'Argument' ) + ( typeof n == 'number'
                  ? n < min || n > max ? ' out of range: ' : ' not an integer: '
                  : ' not a primitive number: ' ) + n );
        }
    }


    function isArray(obj) {
        return Object.prototype.toString.call(obj) == '[object Array]';
    }


    function toExponential( str, e ) {
        return ( str.length > 1 ? str.charAt(0) + '.' + str.slice(1) : str ) +
          ( e < 0 ? 'e' : 'e+' ) + e;
    }


    function toFixedPoint( str, e, z ) {
        var len, zs;

        // Negative exponent?
        if ( e < 0 ) {

            // Prepend zeros.
            for ( zs = z + '.'; ++e; zs += z );
            str = zs + str;

        // Positive exponent
        } else {
            len = str.length;

            // Append zeros.
            if ( ++e > len ) {
                for ( zs = z, e -= len; --e; zs += z );
                str += zs;
            } else if ( e < len ) {
                str = str.slice( 0, e ) + '.' + str.slice(e);
            }
        }

        return str;
    }


    // EXPORT


    BigNumber = clone();
    BigNumber['default'] = BigNumber.BigNumber = BigNumber;


    // AMD.
    if ( true ) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return BigNumber; }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    // Node.js and other environments that support module.exports.
    } else if ( typeof module != 'undefined' && module.exports ) {
        module.exports = BigNumber;

    // Browser.
    } else {
        if ( !globalObject ) {
            globalObject = typeof self != 'undefined' ? self : Function('return this')();
        }

        globalObject.BigNumber = BigNumber;
    }
})(this);


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getAllReferences"] = getAllReferences;
/* harmony export (immutable) */ __webpack_exports__["updateReferencesSearch"] = updateReferencesSearch;
/* harmony export (immutable) */ __webpack_exports__["updateTable"] = updateTable;
/* harmony export (immutable) */ __webpack_exports__["getReferences"] = getReferences;
/* harmony export (immutable) */ __webpack_exports__["deleteReference"] = deleteReference;
/* harmony export (immutable) */ __webpack_exports__["updateReference"] = updateReference;
/* harmony export (immutable) */ __webpack_exports__["createReference"] = createReference;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__ = __webpack_require__(16);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function getAllReferences(){var _this=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_REFERENCES"]});_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])("/references",null,[]);case 3:response=_context.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_REFERENCES"],response:response});case 5:case'end':return _context.stop();}}},_callee,_this);}));return function(_x){return _ref.apply(this,arguments);};}();}function updateReferencesSearch(keyword){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_REFERENCES_SEARCH"],keyword:keyword});};}function updateTable(settings){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_REFERENCES_TABLE"],settings:settings});};}function getReferences(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var _this2=this;var results=arguments.length>1&&arguments[1]!==undefined?arguments[1]:12;var sort=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{by:'name',direction:'Ascending'};return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState){var settings,requestId,tableSettings,keyword,params,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:settings={page:page,results:results,sort:sort};dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_REFERENCES_TABLE"],settings:settings});requestId=++getState().referencesTable.currentRequestId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_REFERENCES_TABLE_RECORDS"],requestId:requestId});tableSettings=getState().referencesTable;keyword=getState().references.keyword;params={page:tableSettings.page,sortBy:tableSettings.sort.by,sortDirection:tableSettings.sort.direction,results:tableSettings.resultsView,keyword:keyword};_context2.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/references',params);case 9:response=_context2.sent;dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_REFERENCES_TABLE_RECORDS"]},{response:response,requestId:requestId}));case 11:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x5,_x6){return _ref2.apply(this,arguments);};}();}function deleteReference(referenceId){var _this3=this;return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_REMOVE_REFERENCES_TABLE_RECORD"]});_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["a" /* deleteRequest */])('/references/'+referenceId);case 3:response=_context3.sent;response.recordIdKey='referenceId';response.recordId=referenceId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["REMOVE_REFERENCES_TABLE_RECORD"],response:response});if(response.success)dispatch(getAllReferences());case 8:case'end':return _context3.stop();}}},_callee3,_this3);}));return function(_x7){return _ref3.apply(this,arguments);};}();}function updateReference(referenceId,reference){var _this4=this;return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_REFERENCE"]});_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["e" /* putRequest */])('/references/'+referenceId,reference);case 3:response=_context4.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_REFERENCE"],response:response});if(response.success)dispatch(getAllReferences());case 6:case'end':return _context4.stop();}}},_callee4,_this4);}));return function(_x8){return _ref4.apply(this,arguments);};}();}function createReference(reference){var _this5=this;return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_CREATE_REFERENCE"]});_context5.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/references',reference);case 3:response=_context5.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CREATE_REFERENCE"],response:response});if(response.success)dispatch(getAllReferences());case 6:case'end':return _context5.stop();}}},_callee5,_this5);}));return function(_x9){return _ref5.apply(this,arguments);};}();}

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["toggleSidebar"] = toggleSidebar;
/* harmony export (immutable) */ __webpack_exports__["updateFilters"] = updateFilters;
/* harmony export (immutable) */ __webpack_exports__["resetFilters"] = resetFilters;
/* harmony export (immutable) */ __webpack_exports__["setAppliedFilters"] = setAppliedFilters;
/* harmony export (immutable) */ __webpack_exports__["getSavedSearches"] = getSavedSearches;
/* harmony export (immutable) */ __webpack_exports__["getSavedSearch"] = getSavedSearch;
/* harmony export (immutable) */ __webpack_exports__["createSavedSearch"] = createSavedSearch;
/* harmony export (immutable) */ __webpack_exports__["deleteSavedSearch"] = deleteSavedSearch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__ = __webpack_require__(16);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function toggleSidebar(filterType){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__['TOGGLE_'+filterType+'_SIDEBAR_FILTERS']});};}function updateFilters(filterType,update){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__['UPDATE_'+filterType+'_SIDEBAR_FILTERS'],update:update});};}function resetFilters(filterType,applyFilters){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__['RESET_'+filterType+'_SIDEBAR_FILTERS'],applyFilters:applyFilters});};}function setAppliedFilters(filterType,filters){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__['SET_'+filterType+'_APPLIED_FILTERS'],filters:filters});};}function getSavedSearches(filterType){var _this=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__['START_GET_'+filterType+'_SAVED_SEARCHES']});_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/savedSearches',{type:filterType},[]);case 3:response=_context.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__['GET_'+filterType+'_SAVED_SEARCHES'],response:response});case 5:case'end':return _context.stop();}}},_callee,_this);}));return function(_x){return _ref.apply(this,arguments);};}();}function getSavedSearch(filterType,searchId){var _this2=this;return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__['START_GET_'+filterType+'_SAVED_SEARCH']});_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/savedSearches/'+searchId);case 3:response=_context2.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__['GET_'+filterType+'_SAVED_SEARCH'],response:response});case 5:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref2.apply(this,arguments);};}();}function createSavedSearch(filterType,title,search){var _this3=this;return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__['START_CREATE_'+filterType+'_SAVED_SEARCH']});_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])("/savedSearches",{name:title,type:filterType,fields:search});case 3:response=_context3.sent;response.data={key:response.data,value:title};dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__['CREATE_'+filterType+'_SAVED_SEARCH'],response:response});case 6:case'end':return _context3.stop();}}},_callee3,_this3);}));return function(_x3){return _ref3.apply(this,arguments);};}();}function deleteSavedSearch(filterType,savedSearchId){var _this4=this;return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__['START_DELETE_'+filterType+'_SAVED_SEARCH'],savedSearchId:savedSearchId});_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["a" /* deleteRequest */])('/savedSearches/'+savedSearchId);case 3:response=_context4.sent;response.savedSearchId=savedSearchId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__['DELETE_'+filterType+'_SAVED_SEARCH'],response:response});case 6:case'end':return _context4.stop();}}},_callee4,_this4);}));return function(_x4){return _ref4.apply(this,arguments);};}();}

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getQueryParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = setQueryParams;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__history__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(2);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function getQueryParams(){return __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.parse(__WEBPACK_IMPORTED_MODULE_0__history__["a" /* default */].location.search);}function setQueryParams(params){if(params){var searchParams=Object.assign({},params);Object.keys(searchParams).forEach(function(prop){if(!searchParams[prop])searchParams[prop]=[];else if(_typeof(searchParams[prop])==='object')searchParams[prop]=Object(__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* flattenObj */])(searchParams[prop]);});var search=__WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(Object.assign({},getQueryParams(),searchParams));__WEBPACK_IMPORTED_MODULE_0__history__["a" /* default */].replace({search:search});}else{__WEBPACK_IMPORTED_MODULE_0__history__["a" /* default */].replace({search:''});}}

/***/ }),
/* 102 */
/***/ (function(module, exports) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ExportButton=function(_React$Component){_inherits(ExportButton,_React$Component);function ExportButton(props){_classCallCheck(this,ExportButton);var _this=_possibleConstructorReturn(this,(ExportButton.__proto__||Object.getPrototypeOf(ExportButton)).call(this,props));_this.state={exporting:false,error:false,errorMessage:''};return _this;}_createClass(ExportButton,[{key:'exportData',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var response,headers;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({exporting:true,error:false});_context.prev=1;_context.next=4;return this.props.getDataForExport();case 4:response=_context.sent;if(response.success){_context.next=7;break;}throw Error(response.message);case 7:if(!response.data.length){this.setState({exporting:false,error:true,errorMessage:'No results for export'});}else{headers=this.props.exportHeaders||this.props.getDynamicExportHeaders(response.data);Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["g" /* exportCSVFile */])(headers,response.data,this.props.fileName+'-'+new Date().toLocaleDateString().replace(/\//g,"-"));this.setState({exporting:false});if(this.props.onGetDataSuccess){this.props.onGetDataSuccess();}}_context.next=13;break;case 10:_context.prev=10;_context.t0=_context['catch'](1);this.setState({exporting:false,error:true,errorMessage:_context.t0.message});case 13:case'end':return _context.stop();}}},_callee,this,[[1,10]]);}));function exportData(){return _ref.apply(this,arguments);}return exportData;}()//added this.props.exporting & this.props.error to allow management of export via redux store 
//bec long exports may extend over mounting and unmounting of component and loses component state
//use redux storage going forward
},{key:'render',value:function render(){var buttonText=this.state.exporting||this.props.exporting?this.props.busyText||"Exporting...":this.props.text||"Export";var isSelectionBtn=this.props.buttonClassName&&this.props.buttonClassName.includes('selection-action-btn');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:('btn btn-flat btn-small '+(this.props.buttonClassName||'')).trim(),onClick:this.exportData.bind(this),disabled:this.props.disabled||this.state.exporting,title:this.props.title},this.props.count!==undefined&&!(this.state.exporting||this.props.exporting)?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'selection-action-btn__content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/export-icon'+(this.props.disabled||this.state.exporting?"-disabled":"")+'.png',className:'selection-action-btn__icon',alt:'export-icon'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'selection-action-btn__label'},buttonText)),isSelectionBtn&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'selection-action-btn__badge'},this.props.count),!isSelectionBtn&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'(',this.props.count,')')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/export-icon'+(this.props.disabled||this.state.exporting?"-disabled":"")+'.png',className:'icon-left',alt:'export-icon'}),buttonText)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error||this.props.error,message:this.state.errorMessage,timeOut:5000}));}}]);return ExportButton;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ExportButton);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_SettingsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_UsersActions__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PrintModal=function(_React$Component){_inherits(PrintModal,_React$Component);function PrintModal(props){_classCallCheck(this,PrintModal);var _this=_possibleConstructorReturn(this,(PrintModal.__proto__||Object.getPrototypeOf(PrintModal)).call(this,props));_this.state={selectedPrinterId:'',showPrinterSelect:false,setDefaultPrinter:false,initializing:true,submitting:false,printError:false,defaultPrinterError:false};_this.close=_this.close.bind(_this);_this.continue=_this.continue.bind(_this);return _this;}_createClass(PrintModal,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var printers;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.actions.getPrinters();case 2:printers=_context.sent;this.initializePrinterSelection(printers&&printers.data);case 4:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'findPrinter',value:function findPrinter(printerId){var printers=arguments.length>1&&arguments[1]!==undefined?arguments[1]:this.props.printers.data;if(printerId===null||printerId===undefined||printerId==='')return null;var normalizedPrinterId=String(printerId).trim();return(printers||[]).find(function(printer){return String(printer.printerId).trim()===normalizedPrinterId;})||null;}},{key:'initializePrinterSelection',value:function initializePrinterSelection(printers){var defaultPrinter=this.findPrinter(this.props.userProfile.defaultPrinterId,printers||this.props.printers.data);this.setState({selectedPrinterId:defaultPrinter?defaultPrinter.printerId:'',showPrinterSelect:!defaultPrinter,setDefaultPrinter:false,initializing:false});}},{key:'close',value:function close(){if(this.state.submitting||this.props.printing.loading)return;this.props.close();}},{key:'continue',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var selectedPrinter,defaultPrinterError,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!this.state.submitting){_context2.next=2;break;}return _context2.abrupt('return');case 2:selectedPrinter=this.findPrinter(this.state.selectedPrinterId);if(!(this.props.printers.loading||!selectedPrinter)){_context2.next=5;break;}return _context2.abrupt('return');case 5:this.setState({submitting:true,printError:false,defaultPrinterError:false});defaultPrinterError=false;if(!(this.state.setDefaultPrinter&&String(this.props.userProfile.defaultPrinterId)!==String(selectedPrinter.printerId))){_context2.next=13;break;}_context2.next=10;return this.props.actions.updateCurrentUserDefaultPrinter(selectedPrinter.printerId);case 10:response=_context2.sent;defaultPrinterError=!response||!response.success;if(defaultPrinterError)this.setState({defaultPrinterError:true});case 13:_context2.next=15;return this.props.print(selectedPrinter.printerId);case 15:if(this.props.printing.success){if(defaultPrinterError){__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error('Default printer was not saved','The checks were sent to print, but your printer preference could not be saved.');}this.props.close();this.props.onPrintSuccess();}else{this.setState({submitting:false,printError:true});}case 16:case'end':return _context2.stop();}}},_callee2,this);}));function _continue(){return _ref2.apply(this,arguments);}return _continue;}()},{key:'chooseDifferentPrinter',value:function chooseDifferentPrinter(){this.setState({selectedPrinterId:'',showPrinterSelect:true,setDefaultPrinter:false,printError:false,defaultPrinterError:false});}},{key:'selectPrinter',value:function selectPrinter(event){this.setState({selectedPrinterId:event.target.value,printError:false,defaultPrinterError:false});}},{key:'render',value:function render(){var _this2=this;var selectedPrinter=this.findPrinter(this.state.selectedPrinterId);var showPrinterSelect=this.state.showPrinterSelect||!selectedPrinter;var printersLoading=this.state.initializing||this.props.printers.loading;var submitting=this.state.submitting||this.props.printing.loading;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_Modal__["a" /* default */],{modalShowing:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal large-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},'Print ',Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["m" /* formatNumber */])(this.props.count),' Check',this.props.count===1?"":"s"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty'+(submitting?' disabled':''),onClick:this.close})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'print-modal-box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'print-modal-pic'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/Print.png',alt:'print'})),printersLoading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20'}):!showPrinterSelect?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,selectedPrinter.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'print-modal-btn',onClick:this.chooseDifferentPrinter.bind(this)},'Choose a different printer')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-select'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('select',{disabled:!this.props.printers.data.length,value:this.state.selectedPrinterId,onChange:this.selectPrinter.bind(this)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:'',hidden:true},'Select Printer'),this.props.printers.data.map(function(printer){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:printer.printerId,value:printer.printerId},'[',printer.computerName,'] ',printer.name);})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'arrow_drop_down')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'default',className:'custom-check',checked:this.state.setDefaultPrinter,onChange:function onChange(){return _this2.setState({setDefaultPrinter:!_this2.state.setDefaultPrinter});}}),selectedPrinter&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'default',className:'secondary-text'},'Always use this printer')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:!this.props.printers.success,message:'Could not retrieve printers.  '+(this.props.printers.message||"Please try again.")}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-btns text-right'},submitting?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.close},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',onClick:this.continue,disabled:printersLoading||!selectedPrinter||submitting},'Continue'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.defaultPrinterError,message:'The printer could not be saved as your default. You can still print with it.'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.printError,message:'Something went wrong and the print job could not be completed.  Please try again.'}))))));}}]);return PrintModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);function mapStateToProps(state,ownProps){return{printers:state.settings.printers,printing:state.checkPrinting.printing,userProfile:state.userProfile.profile.data};}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({getPrinters:__WEBPACK_IMPORTED_MODULE_5__redux_actions_SettingsActions__["getPrinters"],updateCurrentUserDefaultPrinter:__WEBPACK_IMPORTED_MODULE_6__redux_actions_UsersActions__["updateCurrentUserDefaultPrinter"]},dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(PrintModal));

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_throttle_debounce__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_throttle_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_throttle_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_autosuggest__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_autosuggest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_autosuggest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AutoSuggestInput=function(_React$Component){_inherits(AutoSuggestInput,_React$Component);function AutoSuggestInput(props){_classCallCheck(this,AutoSuggestInput);var _this=_possibleConstructorReturn(this,(AutoSuggestInput.__proto__||Object.getPrototypeOf(AutoSuggestInput)).call(this,props));_this.state={value:'',searchValue:'',noSuggestions:false,suggestions:[]};_this.onSuggest=Object(__WEBPACK_IMPORTED_MODULE_2_throttle_debounce__["debounce"])(500,_this.onSuggest);return _this;}_createClass(AutoSuggestInput,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this2=this;if(nextProps.suggestions){this.setState({suggestions:nextProps.multi?nextProps.suggestions.filter(function(suggestion){return nextProps.selection.map(function(sel){return sel[_this2.props.suggestionKey];}).indexOf(suggestion[_this2.props.suggestionKey])<0;}):nextProps.suggestions});}}},{key:'onChange',value:function onChange(event,_ref){var newValue=_ref.newValue,method=_ref.method;this.setState({value:'',searchValue:method==="type"?newValue:this.state.searchValue});if(!this.props.multi){this.props.update(this.props.name,'');}}},{key:'onSuggest',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(input){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(input.value.length>2)){_context.next=4;break;}_context.next=3;return this.props.getSuggestions(input.value);case 3:this.setState({noSuggestions:!this.state.suggestions.length});case 4:case'end':return _context.stop();}}},_callee,this);}));function onSuggest(_x){return _ref2.apply(this,arguments);}return onSuggest;}()},{key:'onSelectSuggestion',value:function onSelectSuggestion(event,_ref3){var suggestion=_ref3.suggestion;if(suggestion.incomplete&&!this.props.allowIncomplete)return;this.setState({searchValue:suggestion[this.props.suggestionValue]});this.props.update(this.props.name,this.props.multi?[].concat(_toConsumableArray(this.props.selection),[suggestion]):suggestion);}},{key:'clearSuggestions',value:function clearSuggestions(){this.setState({noSuggestions:false});if(this.props.multi&&this.state.searchValue){this.setState({searchValue:''});}this.props.clearSuggestions();}},{key:'getSuggestionAction',value:function getSuggestionAction(suggestion){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:function onClick(e){return e.stopPropagation();}},this.props.suggestionAction(suggestion));}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.props.title&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},this.props.title),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'search-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'search'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_autosuggest___default.a,{suggestions:this.state.suggestions,onSuggestionsFetchRequested:this.onSuggest.bind(this),onSuggestionsClearRequested:this.clearSuggestions.bind(this),getSuggestionValue:function getSuggestionValue(s){return s[_this3.props.suggestionValue];},onSuggestionSelected:this.onSelectSuggestion.bind(this),renderSuggestion:function renderSuggestion(s){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:s.incomplete&&!_this3.props.allowIncomplete?"disabled-hover":''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'bold-text inline-block'},s.name),s.incomplete&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'tag incomplete'},'Incomplete'),!!_this3.props.suggestionAction&&_this3.getSuggestionAction(s)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,s.address),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,s.phoneNumber.join(", ")));},inputProps:{className:this.props.className,disabled:this.props.disabled,onChange:this.onChange.bind(this),value:this.state.searchValue}}),this.props.loadingSuggestions&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__LoadingSpinner__["a" /* default */],{height:'12'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FadeOutErrorMessage__["a" /* default */],{show:!this.props.loadingSuggestions&&this.state.searchValue&&this.state.noSuggestions,message:'No Suggestions'})));}}]);return AutoSuggestInput;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AutoSuggestInput);

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(453)["default"];

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = compareObjects;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function compareObjects(objA, objB) {
  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (objA === objB) {
    return false;
  }

  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (aKeys.length !== bKeys.length) {
    return true;
  }

  var keysMap = {};
  var i, len;

  for (i = 0, len = keys.length; i < len; i++) {
    keysMap[keys[i]] = true;
  }

  for (i = 0, len = aKeys.length; i < len; i++) {
    var key = aKeys[i];
    var aValue = objA[key];
    var bValue = objB[key];

    if (aValue === bValue) {
      continue;
    }

    if (!keysMap[key] || aValue === null || bValue === null || _typeof(aValue) !== 'object' || _typeof(bValue) !== 'object') {
      return true;
    }

    var aValueKeys = Object.keys(aValue);
    var bValueKeys = Object.keys(bValue);

    if (aValueKeys.length !== bValueKeys.length) {
      return true;
    }

    for (var n = 0, length = aValueKeys.length; n < length; n++) {
      var aValueKey = aValueKeys[n];

      if (aValue[aValueKey] !== bValue[aValueKey]) {
        return true;
      }
    }
  }

  return false;
}

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(118);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(120);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(121);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(82);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(59);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(124);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(125);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__matchPath__ = __webpack_require__(60);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withRouter__ = __webpack_require__(126);
/* unused harmony reexport withRouter */



















/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_RadioGroup__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_Toggle__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_number_format__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_number_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_util_ValidatedPhoneInput__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_shared_AddressAutocomplete__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_constants__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReferenceModal=function(_NavigationComponent){_inherits(ReferenceModal,_NavigationComponent);function ReferenceModal(props){var _this2=this;_classCallCheck(this,ReferenceModal);var _this=_possibleConstructorReturn(this,(ReferenceModal.__proto__||Object.getPrototypeOf(ReferenceModal)).call(this,props));_this.initialState={editReferenceId:null,preEditReference:null,referenceType:__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Individual,reference:{isIsraeli:false,institutionTitleId:null,personTitleId:null,firstName:"",lastName:"",orgName:"",position:"",address:{},phoneNumber:"",phoneType:__WEBPACK_IMPORTED_MODULE_15__lib_constants__["g" /* PhoneNumberTypes */].American,secondPhoneNumber:"",secondPhoneType:__WEBPACK_IMPORTED_MODULE_15__lib_constants__["g" /* PhoneNumberTypes */].American,email:"",isPayee:false,bankRoutingNumber:"",bankBranchNumber:"",bankAccountNumber:"",bankAccountHolder:""},showSecondPhone:false,error:false,dataErrors:[],submitAttempted:false};_this.onUpdateReferenceType=function(name,value){var _this$state=_this.state,reference=_this$state.reference,editReferenceId=_this$state.editReferenceId,preEditReference=_this$state.preEditReference;var initialReference=editReferenceId?preEditReference:_this.initialState.reference;if(value===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Individual){var _this$setState;_this.setState((_this$setState={},_defineProperty(_this$setState,name,value),_defineProperty(_this$setState,"reference",Object.assign({},reference,{institutionTitleId:null,orgName:"",firstName:initialReference.firstName,lastName:initialReference.lastName})),_this$setState));}else if(value===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Organization){var _this$setState2;_this.setState((_this$setState2={},_defineProperty(_this$setState2,name,value),_defineProperty(_this$setState2,"reference",Object.assign({},reference,{personTitleId:null,firstName:"",lastName:"",orgName:initialReference.orgName})),_this$setState2));}};_this.onUpdateReferenceIsIsraeli=function(name,value){_this.setState({reference:Object.assign({},_this.state.reference,{institutionTitleId:null,personTitleId:null,address:{}},!value?{bankRoutingNumber:"",bankBranchNumber:"",bankAccountNumber:"",bankAccountHolder:""}:{},_defineProperty({},name,value))});};_this.onChange=function(name,value){if(name==="firstName"||name==="lastName"||name==="orgName")value=Object(__WEBPACK_IMPORTED_MODULE_13__lib_utils__["C" /* toTitleCase */])(value);_this.setState({reference:Object.assign({},_this.state.reference,_defineProperty({},name,value))});};_this.onChangeEvt=function(event){_this.onChange(event.target.name,event.target.value);};_this.onSubmit=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var reference;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({error:false,submitAttempted:true});reference=_this.state.reference;if(!(_this.state.dataErrors.length||!(_this.state.referenceType===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Individual?reference.lastName:reference.orgName)||reference.isPayee&&(reference.isIsraeli?!reference.bankRoutingNumber||!reference.bankBranchNumber||!reference.bankAccountNumber:!reference.address))){_context.next=4;break;}return _context.abrupt("return");case 4:_context.next=6;return _this.props.submitReference(reference);case 6:if(_this.props.success){_this.onClose();}else{_this.setState({error:true});}case 7:case"end":return _context.stop();}}},_callee,_this2);}));_this.onClose=function(){_this.setState(_this.initialState,_this.props.close);};_this.validateFieldLength=function(name,length,value){var isValid=Object(__WEBPACK_IMPORTED_MODULE_13__lib_utils__["E" /* validateFieldLength */])(length,value);_this.setDataError(name,!isValid);return isValid;};_this.validateEmail=function(value){var isValid=Object(__WEBPACK_IMPORTED_MODULE_13__lib_utils__["x" /* isValidEmail */])(value);_this.setDataError("email",!isValid);return isValid;};_this.setDataError=function(errorName,error){var dataErrors=[].concat(_toConsumableArray(_this.state.dataErrors));if(error)dataErrors.push(errorName);else dataErrors=dataErrors.filter(function(e){return e!==errorName;});_this.setState({dataErrors:dataErrors});};_this.state=_this.initialState;return _this;}_createClass(ReferenceModal,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(!this.props.show&&nextProps.show&&nextProps.reference){var reference={isIsraeli:nextProps.reference.isIsraeli,institutionTitleId:nextProps.reference.institutionTitleId,personTitleId:nextProps.reference.personTitleId,firstName:nextProps.reference.firstName||"",lastName:nextProps.reference.lastName||"",orgName:nextProps.reference.orgName||"",position:nextProps.reference.position||"",address:nextProps.reference.address||{},phoneNumber:nextProps.reference.phoneNumber||"",phoneType:nextProps.reference.phoneType||(nextProps.reference.isIsraeli?__WEBPACK_IMPORTED_MODULE_15__lib_constants__["g" /* PhoneNumberTypes */].Israeli:__WEBPACK_IMPORTED_MODULE_15__lib_constants__["g" /* PhoneNumberTypes */].American),secondPhoneNumber:nextProps.reference.secondPhoneNumber||"",secondPhoneType:nextProps.reference.secondPhoneType||(nextProps.reference.isIsraeli?__WEBPACK_IMPORTED_MODULE_15__lib_constants__["g" /* PhoneNumberTypes */].Israeli:__WEBPACK_IMPORTED_MODULE_15__lib_constants__["g" /* PhoneNumberTypes */].American),email:nextProps.reference.email||"",isPayee:false,bankRoutingNumber:nextProps.reference.bankRoutingNumber||"",bankBranchNumber:nextProps.reference.bankBranchNumber||"",bankAccountNumber:nextProps.reference.bankAccountNumber||"",bankAccountHolder:nextProps.reference.bankAccountHolder||""};this.setState({editReferenceId:nextProps.reference.referenceId,preEditReference:reference,referenceType:reference.orgName?__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Organization:__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Individual,reference:reference,showSecondPhone:reference.secondPhoneNumber});}}},{key:"render",value:function render(){var _this3=this;var _state=this.state,reference=_state.reference,editReferenceId=_state.editReferenceId,preEditReference=_state.preEditReference,referenceType=_state.referenceType,showSecondPhone=_state.showSecondPhone,submitAttempted=_state.submitAttempted,dataErrors=_state.dataErrors,error=_state.error;var _props=this.props,loading=_props.loading,usPersonTitles=_props.usPersonTitles,israelPersonTitles=_props.israelPersonTitles,usInstitutionTitles=_props.usInstitutionTitles,israelInstitutionTitles=_props.israelInstitutionTitles,recipientTypes=_props.recipientTypes;var initialReference=editReferenceId?preEditReference:this.initialState.reference;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal reference-modal large-modal"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-header"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",{className:"page-header"},editReferenceId?"Edit":"New"," Reference"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon ion-ios-close-empty",onClick:this.onClose.bind(this)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_RadioGroup__["a" /* default */],{options:recipientTypes,title:"Reference Type",name:"referenceType",value:referenceType,onChange:this.onUpdateReferenceType})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"input-label"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"flex-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_Toggle__["a" /* default */],{id:"isIsraeli",name:"isIsraeli",value:reference.isIsraeli,disabled:reference.isPayee,onChange:this.onUpdateReferenceIsIsraeli}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"small-text middle"},"Israeli"))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-section"},referenceType===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Individual?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-third"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"input-label"},"Title"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_Select__["a" /* default */],{clearable:true,name:"personTitleId",value:reference.personTitleId,options:reference.isIsraeli?israelPersonTitles:usPersonTitles,onChange:this.onChangeEvt})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-third"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text"}),label:"First Name",name:"firstName",value:reference.firstName,onChange:this.onChange,required:reference.isPayee,showRequiredError:submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-third"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text"}),label:"Last Name",name:"lastName",value:reference.lastName,onChange:this.onChange,required:true,showRequiredError:submitAttempted}))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"input-label"},"Institution Title"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_Select__["a" /* default */],{clearable:true,name:"institutionTitleId",value:reference.institutionTitleId,options:reference.isIsraeli?israelInstitutionTitles:usInstitutionTitles,onChange:this.onChangeEvt})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text"}),label:"Name",name:"orgName",value:reference.orgName,onChange:this.onChange,required:true,showRequiredError:submitAttempted})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"input-label"},"Position"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",name:"position",value:reference.position,onChange:this.onChangeEvt})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_shared_AddressAutocomplete__["a" /* default */],{title:!reference.isIsraeli?"Address *Required if using the contact as payee":"",isIsraeli:reference.isIsraeli,required:!reference.isIsraeli&&reference.isPayee,showRequiredError:true,address:reference.address,updateAddress:this.onChange.bind(this,"address"),updateError:function updateError(){return _this3.setDataError("address");}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_util_ValidatedPhoneInput__["a" /* default */],{tabIndex:250,span1:!showSecondPhone&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{onClick:function onClick(){return _this3.setState({showSecondPhone:true});},className:"link-text small-text"},"Add Phone "),phoneNumber:reference.phoneNumber,phoneType:reference.phoneType||(reference.isIsraeli?__WEBPACK_IMPORTED_MODULE_15__lib_constants__["g" /* PhoneNumberTypes */].Israeli:__WEBPACK_IMPORTED_MODULE_15__lib_constants__["g" /* PhoneNumberTypes */].American),phoneNumberName:"phoneNumber",phoneTypeName:"phoneType",onChange:this.onChange,error:dataErrors.indexOf("phoneNumber")>=0,updateError:this.setDataError,errorName:"phoneNumber"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},showSecondPhone?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_util_ValidatedPhoneInput__["a" /* default */],{label:"Second Phone",phoneNumber:reference.secondPhoneNumber,phoneType:reference.secondPhoneType||(reference.isIsraeli?__WEBPACK_IMPORTED_MODULE_15__lib_constants__["g" /* PhoneNumberTypes */].Israeli:__WEBPACK_IMPORTED_MODULE_15__lib_constants__["g" /* PhoneNumberTypes */].American),phoneNumberName:"secondPhoneNumber",phoneTypeName:"secondPhoneType",onChange:this.onChange,error:dataErrors.indexOf("secondPhoneNumber")>=0,updateError:this.setDataError,errorName:"secondPhoneNumber"}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text"}),label:"Email",name:"email",value:reference.email,onChange:this.onChange,validated:true,showValidationError:true,validate:this.validateEmail,errorMessage:"Invalid Email Address"})))),showSecondPhone&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text"}),label:"Email",name:"email",value:reference.email,onChange:this.onChange,validated:true,showValidationError:true,validate:this.validateEmail,errorMessage:"Invalid Email Address"})))),reference.isIsraeli&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row",style:{paddingTop:"20px",marginBottom:"16px",borderTop:"2px solid #E0E5F2"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"small-text"},"If using the reference as payee:")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_number_format___default.a,{placeholder:"##",format:"##",onValueChange:function onValueChange(values){return _this3.onChange("bankRoutingNumber",values.value);}}),label:"Bank Number",name:"bankRoutingNumber",value:reference.bankRoutingNumber,required:reference.isPayee,showRequiredError:submitAttempted,errorMessage:"Invalid Bank Number",validated:true,showValidationError:true,validate:function validate(val){return _this3.validateFieldLength("bankRoutingNumber",2,val);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_number_format___default.a,{placeholder:"###",format:"###",onValueChange:function onValueChange(values){return _this3.onChange("bankBranchNumber",values.value);}}),label:"Branch Number",name:"bankBranchNumber",value:reference.bankBranchNumber,required:reference.isPayee,showRequiredError:submitAttempted,errorMessage:"Invalid Branch Number",validated:true,showValidationError:true,validate:function validate(val){return _this3.validateFieldLength("bankBranchNumber",2,val);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_number_format___default.a,{placeholder:"###############",format:"###############",onValueChange:function onValueChange(values){return _this3.onChange("bankAccountNumber",values.value);}}),label:"Account Number",name:"bankAccountNumber",value:reference.bankAccountNumber,required:reference.isPayee,showRequiredError:submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"input-label"},"Account Holder"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",name:"bankAccountHolder",value:reference.bankAccountHolder,onChange:function onChange(e){return _this3.onChange(e.target.name,e.target.value);}})))),loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_util_LoadingSpinner__["a" /* default */],{height:"20",alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-btns text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-accent",onClick:this.onClose.bind(this)},"Cancel"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-primary",disabled:Object(__WEBPACK_IMPORTED_MODULE_13__lib_utils__["e" /* deepEquals */])(reference,initialReference)||dataErrors.length,onClick:this.onSubmit},"Submit"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:error})))));}}]);return ReferenceModal;}(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ReferenceModal);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_RadioGroup__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_PlaceholderDateInput__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_CurrencyFormatInput__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_AutocompleteSelect__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ThirdPartyPayeeModal__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaymentInfo=function(_NavigationComponent){_inherits(PaymentInfo,_NavigationComponent);function PaymentInfo(props){_classCallCheck(this,PaymentInfo);var _this=_possibleConstructorReturn(this,(PaymentInfo.__proto__||Object.getPrototypeOf(PaymentInfo)).call(this,props));_this.updateIsManualPayment=function(event){var _event$target=event.target,name=_event$target.name,checked=_event$target.checked;_this.setState({isManualPayment:checked});var paymentInfo=_this.props.paymentInfo;if(checked){paymentInfo.manualPayment={blankCheckId:null,manualPaymentType:__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["h" /* ManualPaymentTypes */].BlankCheck,manualPaymentNumber:null,manualPaymentDate:null,manualPaymentAmount:null};if(_this.props.payeeIsIsraeli){paymentInfo=Object.assign({},paymentInfo,{fundId:_this.props.defaultUSFund||'',thirdParty:Object.assign({},_this.props.paymentInfo.thirdParty,{bankNumber:'',branchNumber:'',accountNumber:'',accountHolder:''})});_this.props.updateApplication('paymentInfo',paymentInfo);if(_this.props.defaultUSFund)_this.props.getBlankChecks(_this.props.defaultUSFund);}else{paymentInfo=Object.assign({},paymentInfo,{thirdParty:Object.assign({},paymentInfo.thirdParty,{useRecipientAddress:false,careOf:''})});_this.props.updateApplication('paymentInfo',paymentInfo);_this.props.onChange('showCareOf',false);if(_this.props.paymentInfo.fundId)_this.props.getBlankChecks(_this.props.paymentInfo.fundId);}}else{paymentInfo.manualPayment={blankCheckId:null,manualPaymentType:null,manualPaymentNumber:null,manualPaymentDate:null,manualPaymentAmount:null};if(_this.props.payeeIsIsraeli){paymentInfo.fundId=_this.props.defaultIsraeliFund;}_this.props.updateApplication('paymentInfo',paymentInfo);_this.props.onChange('manualCheckLabel','');}};_this.updateManualPaymentInfo=function(name,value){var manualPaymentInfo=_this.props.paymentInfo.manualPayment;if(name==='blankCheckId'){var _manualPaymentInfo;var blankCheck=_this.props.blankChecks.data.find(function(c){return c.blankCheckId===value;});_this.setState({blankCheck:blankCheck});blankCheck?manualPaymentInfo=Object.assign({},manualPaymentInfo,{blankCheckId:blankCheck.blankCheckId,manualPaymentNumber:blankCheck.checkNumber,manualPaymentDate:blankCheck.checkDate,manualPaymentAmount:blankCheck.checkAmount}):manualPaymentInfo=(_manualPaymentInfo={},_defineProperty(_manualPaymentInfo,name,value),_defineProperty(_manualPaymentInfo,'manualPaymentType',__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["h" /* ManualPaymentTypes */].BlankCheck),_defineProperty(_manualPaymentInfo,'manualPaymentNumber',null),_defineProperty(_manualPaymentInfo,'manualPaymentDate',null),_defineProperty(_manualPaymentInfo,'manualPaymentAmount',null),_manualPaymentInfo);}else{if(name==="manualPaymentType"){if(value!==__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["h" /* ManualPaymentTypes */].BlankCheck&&manualPaymentInfo.blankCheckId){_this.setState({blankCheck:null});manualPaymentInfo=Object.assign({},manualPaymentInfo,{blankCheckId:null,manualPaymentNumber:null,manualPaymentAmount:null});_this.props.onChange('manualCheckLabel','');}else if(value===__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["h" /* ManualPaymentTypes */].BlankCheck){manualPaymentInfo=Object.assign({},manualPaymentInfo,{manualPaymentNumber:null,manualPaymentDate:null,manualPaymentAmount:null});}}manualPaymentInfo[name]=value;}_this.props.updatePaymentInfo('manualPayment',Object.assign({},manualPaymentInfo));};_this.updatePayableTo=function(name,value){var _Object$assign;var isIsraeli=value===__WEBPACK_IMPORTED_MODULE_10__lib_constants__["e" /* PayeeTypes */].TrustedPayee?_this.props.trustedPayee.isIsraeli:_this.props.initialThirdParty.isIsraeli;//will be equivalent to recipient.isIsraeli
var fundId=isIsraeli===_this.props.payeeIsIsraeli//don't update fundId if isIsraeli was not changed
?_this.props.paymentInfo.fundId:isIsraeli?_this.props.defaultIsraeliFund:_this.props.defaultUSFund;_this.props.updateApplication('paymentInfo',Object.assign({},_this.props.paymentInfo,(_Object$assign={},_defineProperty(_Object$assign,name,value),_defineProperty(_Object$assign,'fundId',fundId),_defineProperty(_Object$assign,'thirdParty',_this.props.initialThirdParty),_Object$assign)));};_this.updateThirdParty=function(thirdParty){var fundId=_this.state.isManualPayment||thirdParty.isIsraeli===_this.props.payeeIsIsraeli?//don't update fundId if manual check or if isIsraeli was not changed
_this.props.paymentInfo.fundId:thirdParty.isIsraeli?_this.props.defaultIsraeliFund:_this.props.defaultUSFund;_this.props.updateApplication('paymentInfo',Object.assign({},_this.props.paymentInfo,{fundId:fundId,thirdParty:Object.assign({},thirdParty,!_this.state.isManualPayment&&thirdParty.isIsraeli?{useRecipientAddress:false,careOf:''}:{})}));if(_this.props.showCareOf&&!_this.state.isManualPayment&&thirdParty.isIsraeli)_this.props.onChange('showCareOf',false);//if !manualCheck and switched to israeli, clear out showCareOf if checked
};_this.updateThirdPartyInfo=function(name,value){var info=Object.assign({},_this.props.paymentInfo.thirdParty,_defineProperty({},name,value));if(name==="referenceId"){var reference=_this.props.recipientReferences[_this.props.recipientReferences.map(function(ref){return ref.referenceId.toString();}).indexOf(value.toString())]||{};info.isIsraeli=reference.isIsraeli;info.firstName=reference.firstName||null;info.lastName=reference.lastName||null;info.orgName=reference.orgName||null;info.address=reference.address||null;info.bankNumber=reference.bankRoutingNumber||null;info.branchNumber=reference.bankBranchNumber||null;info.accountNumber=reference.bankAccountNumber||null;info.accountHolder=reference.bankAccountHolder||null;}_this.updateThirdParty(info);};_this.updateThirdPartyPayeeType=function(name,value){_this.props.onChange(name,value);_this.updateThirdParty(_this.props.initialThirdParty);};_this.toggleCareOf=function(name,value){_this.props.onChange(name,value);if(!value&&_this.props.paymentInfo.thirdParty.careOf)_this.updateThirdPartyInfo('careOf','');};_this.state={isManualPayment:!_this.props.paymentInfo.manualPayment||!_this.props.paymentInfo.manualPayment.manualPaymentType?false:true,blankCheck:null,showModals:{thirdPartyPayeeModal:false}};return _this;}_createClass(PaymentInfo,[{key:'render',value:function render(){var _this2=this;var _state=this.state,showModals=_state.showModals,isManualPayment=_state.isManualPayment,blankCheck=_state.blankCheck;var _props=this.props,applicationId=_props.applicationId,funds=_props.funds,campaignApplication=_props.campaignApplication,payeeIsIsraeli=_props.payeeIsIsraeli,paymentInfo=_props.paymentInfo,initialThirdParty=_props.initialThirdParty,thirdPartyPayeeType=_props.thirdPartyPayeeType,trustedPayee=_props.trustedPayee,recipientReferences=_props.recipientReferences,recipientAddress=_props.recipientAddress,recipientTypes=_props.recipientTypes,blankChecks=_props.blankChecks,manualCheckLabel=_props.manualCheckLabel,showCareOf=_props.showCareOf,submitAttempted=_props.submitAttempted;var thirdParty=paymentInfo.thirdParty;var thirdPartyPaymentDescription=void 0;var missingThirdPartyPayeeInfo=void 0;var payToThirdParty=paymentInfo.payTo===__WEBPACK_IMPORTED_MODULE_10__lib_constants__["e" /* PayeeTypes */].ThirdParty;if(payToThirdParty){var thirdPartyPayee={name:thirdParty.orgName||(thirdParty.firstName+' '+thirdParty.lastName).trim(),address:thirdParty.useRecipientAddress?recipientAddress:Object(__WEBPACK_IMPORTED_MODULE_9__lib_utils__["b" /* concatenateAddressLabel */])(thirdParty.address),bankInfo:Object(__WEBPACK_IMPORTED_MODULE_9__lib_utils__["i" /* formatBankInfoDisplay */])(thirdParty.bankNumber,thirdParty.branchNumber,thirdParty.accountNumber,thirdParty.accountHolder)};if(thirdPartyPayee.name&&(payeeIsIsraeli?thirdPartyPayee.bankInfo:thirdPartyPayee.address)){if(isManualPayment){thirdPartyPaymentDescription='Manual check will be made out to '+thirdPartyPayee.name+'.';}else{thirdPartyPaymentDescription=payeeIsIsraeli?'Payment will be wired to '+thirdPartyPayee.name+' at bank account '+thirdPartyPayee.bankInfo+'.':'Payment will be sent to '+thirdPartyPayee.name+(thirdParty.careOf?' C/O '+thirdParty.careOf:'')+' at '+thirdPartyPayee.address+'.';}}if(!paymentInfo.useRecipientAddress&&!isManualPayment&&(payeeIsIsraeli?!thirdPartyPayee.bankInfo:!thirdPartyPayee.address)){missingThirdPartyPayeeInfo=payeeIsIsraeli?"Bank Account Info":"Address";}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payment-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payment-info-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'section-header'},'Payment Info'),this.props.manageAccounting&&(applicationId||!campaignApplication)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'custom-check',type:'checkbox',id:'manualCheck',name:'isManualPayment',checked:isManualPayment||false,onChange:this.updateIsManualPayment}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'manualCheck'},'Manual Payment')),isManualPayment&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__["a" /* default */],{name:'manualPaymentType',value:paymentInfo.manualPayment.manualPaymentType,options:this.props.manualPaymentTypes,onChange:function onChange(e){return _this2.updateManualPaymentInfo(e.target.name,e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_RadioGroup__["a" /* default */],{options:[].concat(_toConsumableArray(trustedPayee?[{key:__WEBPACK_IMPORTED_MODULE_10__lib_constants__["e" /* PayeeTypes */].TrustedPayee,value:"Trusted Payee"}]:[]),[{key:__WEBPACK_IMPORTED_MODULE_10__lib_constants__["e" /* PayeeTypes */].Recipient,value:"Recipient"},{key:__WEBPACK_IMPORTED_MODULE_10__lib_constants__["e" /* PayeeTypes */].ThirdParty,value:"Third Party"}]),title:isManualPayment?"Paid To":"Payable To",name:'payTo',value:paymentInfo.payTo,onChange:this.updatePayableTo})),paymentInfo.payTo===__WEBPACK_IMPORTED_MODULE_10__lib_constants__["e" /* PayeeTypes */].ThirdParty&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'third-party-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Third Party Info'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_RadioGroup__["a" /* default */],{options:[{key:__WEBPACK_IMPORTED_MODULE_10__lib_constants__["i" /* SourceTypes */].Reference,value:'Choose reference as payee',error:submitAttempted&&thirdPartyPayeeType===__WEBPACK_IMPORTED_MODULE_10__lib_constants__["i" /* SourceTypes */].Reference&&!thirdParty.referenceId,disabled:!recipientReferences.length},{key:__WEBPACK_IMPORTED_MODULE_10__lib_constants__["i" /* SourceTypes */].New,value:'Enter new payee',error:submitAttempted&&thirdPartyPayeeType===__WEBPACK_IMPORTED_MODULE_10__lib_constants__["i" /* SourceTypes */].New&&!(thirdParty.orgName||thirdParty.lastName),tag:!(thirdParty.orgName||thirdParty.lastName)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link-text '+(thirdPartyPayeeType!==__WEBPACK_IMPORTED_MODULE_10__lib_constants__["i" /* SourceTypes */].New?"disabled":"")+' '+(thirdPartyPayeeType===__WEBPACK_IMPORTED_MODULE_10__lib_constants__["i" /* SourceTypes */].New&&submitAttempted?"error":""),onClick:thirdPartyPayeeType===__WEBPACK_IMPORTED_MODULE_10__lib_constants__["i" /* SourceTypes */].New?function(){return _this2.toggleModal("thirdPartyPayeeModal");}:null},'Add')}],name:'thirdPartyPayeeType',value:thirdPartyPayeeType,onChange:this.updateThirdPartyPayeeType}),thirdPartyPayeeType===__WEBPACK_IMPORTED_MODULE_10__lib_constants__["i" /* SourceTypes */].Reference?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__["a" /* default */],{tabIndex:650,options:recipientReferences.map(function(ref){return{key:ref.referenceId,value:ref.displayName};})}),name:'referenceId',value:thirdParty.referenceId,onChange:this.updateThirdPartyInfo,required:true,showRequiredError:submitAttempted})):(thirdParty.orgName||thirdParty.lastName)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payee-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small-text bold-text accent-text'},'Payee Info: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link-text',onClick:function onClick(){return _this2.toggleModal("thirdPartyPayeeModal");}},'Edit')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'accent-text'},'Name:'),' ',thirdParty.orgName||thirdParty.firstName+' '+thirdParty.lastName),thirdParty.isIsraeli?thirdParty.accountNumber&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'accent-text'},'Bank Info:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_9__lib_utils__["i" /* formatBankInfoDisplay */])(thirdParty.bankNumber,thirdParty.branchNumber,thirdParty.accountNumber,thirdParty.accountHolder))):thirdParty.address.street&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'accent-text'},'Address:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_9__lib_utils__["b" /* concatenateAddressLabel */])(thirdParty.address))),submitAttempted&&missingThirdPartyPayeeInfo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'error-label'},'Third party '+missingThirdPartyPayeeInfo+' is required.')),!payeeIsIsraeli&&!isManualPayment&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payee-info-check'},recipientAddress&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'custom-check',type:'checkbox',id:'use-recipient-address-checkbox',checked:thirdParty.useRecipientAddress,onChange:function onChange(e){return _this2.updateThirdPartyInfo('useRecipientAddress',e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'use-recipient-address-checkbox',className:'secondary-text'},'Use Recipient\'s Address')),(thirdParty.useRecipientAddress||thirdParty.referenceId||thirdParty.address.street)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'custom-check',type:'checkbox',id:'careof-checkbox',checked:showCareOf,onChange:function onChange(e){return _this2.toggleCareOf("showCareOf",e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'careof-checkbox',className:'secondary-text'},'Add Care of')),showCareOf&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Care Of',tabIndex:660,name:'careOf',value:thirdParty.careOf,onChange:function onChange(e){return _this2.updateThirdPartyInfo('careOf',e.target.value);}}))),thirdPartyPaymentDescription&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'accent-text xs-text'},thirdPartyPaymentDescription)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payment-info-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__["a" /* default */],{options:funds,tabIndex:690}),label:'Fund',name:'fundId',value:paymentInfo.fundId,onChange:this.props.updatePaymentInfo,required:true,showRequiredError:submitAttempted}),isManualPayment&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,paymentInfo.manualPayment.manualPaymentType===__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["h" /* ManualPaymentTypes */].BlankCheck?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_AutocompleteSelect__["a" /* default */],{label:manualCheckLabel,updateLabel:function updateLabel(val){return _this2.props.onChange('manualCheckLabel',val);},tabIndex:700,disabledPlaceholder:'No Checks Found',multi:false,placeholder:'Manual Check',disabled:!paymentInfo.fundId,update:this.updateManualPaymentInfo,options:blankChecks.data.length?blankChecks.data.map(function(check){return{key:check.blankCheckId,value:check.checkNumber};}):[],propertyName:'blankCheckId',loading:blankChecks.loading}),value:paymentInfo.manualPayment.blankCheckId,required:true,showRequiredError:submitAttempted}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:(paymentInfo.manualPayment.manualPaymentType===__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["h" /* ManualPaymentTypes */].ManualWire?"Wire":"Check")+' Number',type:'text',tabIndex:700}),name:'manualPaymentNumber',value:paymentInfo.manualPayment.manualPaymentNumber||'',onChange:this.updateManualPaymentInfo,required:true,showRequiredError:submitAttempted}),(paymentInfo.manualPayment.blankCheckId&&paymentInfo.manualPayment.manualPaymentType===__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["h" /* ManualPaymentTypes */].BlankCheck||paymentInfo.manualPayment.manualPaymentType===__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["h" /* ManualPaymentTypes */].ManualCheck||paymentInfo.manualPayment.manualPaymentType===__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["h" /* ManualPaymentTypes */].ManualWire)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_PlaceholderDateInput__["a" /* default */],{disabled:blankCheck&&blankCheck.checkDate,placeholder:(paymentInfo.manualPayment.manualPaymentType===__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["h" /* ManualPaymentTypes */].ManualWire?"Wire":"Check")+' Date',tabIndex:710}),name:'manualPaymentDate',value:Object(__WEBPACK_IMPORTED_MODULE_9__lib_utils__["l" /* formatDateForInput */])(paymentInfo.manualPayment.manualPaymentDate),onChange:this.updateManualPaymentInfo,required:true,showRequiredError:submitAttempted}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_CurrencyFormatInput__["a" /* default */],{disabled:blankCheck&&blankCheck.checkAmount,placeholder:(paymentInfo.manualPayment.manualPaymentType===__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["h" /* ManualPaymentTypes */].ManualWire?"Wire":"Check")+' Amount',isIsraeli:false,tabIndex:720}),onChange:this.updateManualPaymentInfo,name:'manualPaymentAmount',value:paymentInfo.manualPayment.manualPaymentAmount||'',required:true,showRequiredError:submitAttempted})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'check-memo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Check Memo (Optional)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:'checkMemo',value:paymentInfo.checkMemo,tabIndex:730,onChange:function onChange(e){return _this2.props.updatePaymentInfo(e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Report Memo (Optional)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:'reportMemo',value:paymentInfo.reportMemo,tabIndex:740,onChange:function onChange(e){return _this2.props.updatePaymentInfo(e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ThirdPartyPayeeModal__["a" /* default */],{show:showModals.thirdPartyPayeeModal,close:function close(){return _this2.toggleModal("thirdPartyPayeeModal");},payee:thirdParty,recipientIsIsraeli:initialThirdParty.isIsraeli,isManualPayment:isManualPayment,useRecipientAddress:paymentInfo.thirdParty.useRecipientAddress,recipientTypes:recipientTypes,submitPayee:this.updateThirdParty,submitAttempted:submitAttempted}));}}]);return PaymentInfo;}(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (PaymentInfo);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SettingsMenu=function(_React$Component){_inherits(SettingsMenu,_React$Component);function SettingsMenu(){_classCallCheck(this,SettingsMenu);return _possibleConstructorReturn(this,(SettingsMenu.__proto__||Object.getPrototypeOf(SettingsMenu)).apply(this,arguments));}_createClass(SettingsMenu,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'page-header settings-header'},'Settings'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'settings-options'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* NavLink */],{activeclassname:'active',to:'/settings/user'},'User Settings')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* NavLink */],{activeclassname:'active',to:'/settings/system'},'System Settings')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* NavLink */],{activeclassname:'active',to:'/settings/printing'},'Print Checks'))));}}]);return SettingsMenu;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SettingsMenu);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var stringify = __webpack_require__(208);

var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function isObject(what) {
  return typeof what === 'object' && what !== null;
}

// Yanked from https://git.io/vS8DV re-used under CC0
// with some tiny modifications
function isError(value) {
  switch ({}.toString.call(value)) {
    case '[object Error]':
      return true;
    case '[object Exception]':
      return true;
    case '[object DOMException]':
      return true;
    default:
      return value instanceof Error;
  }
}

function isErrorEvent(value) {
  return supportsErrorEvent() && {}.toString.call(value) === '[object ErrorEvent]';
}

function isUndefined(what) {
  return what === void 0;
}

function isFunction(what) {
  return typeof what === 'function';
}

function isPlainObject(what) {
  return Object.prototype.toString.call(what) === '[object Object]';
}

function isString(what) {
  return Object.prototype.toString.call(what) === '[object String]';
}

function isArray(what) {
  return Object.prototype.toString.call(what) === '[object Array]';
}

function isEmptyObject(what) {
  if (!isPlainObject(what)) return false;

  for (var _ in what) {
    if (what.hasOwnProperty(_)) {
      return false;
    }
  }
  return true;
}

function supportsErrorEvent() {
  try {
    new ErrorEvent(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsFetch() {
  if (!('fetch' in _window)) return false;

  try {
    new Headers(); // eslint-disable-line no-new
    new Request(''); // eslint-disable-line no-new
    new Response(); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

// Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
// https://caniuse.com/#feat=referrer-policy
// It doesn't. And it throw exception instead of ignoring this parameter...
// REF: https://github.com/getsentry/raven-js/issues/1233
function supportsReferrerPolicy() {
  if (!supportsFetch()) return false;

  try {
    // eslint-disable-next-line no-new
    new Request('pickleRick', {
      referrerPolicy: 'origin'
    });
    return true;
  } catch (e) {
    return false;
  }
}

function supportsPromiseRejectionEvent() {
  return typeof PromiseRejectionEvent === 'function';
}

function wrappedCallback(callback) {
  function dataCallback(data, original) {
    var normalizedData = callback(data) || data;
    if (original) {
      return original(normalizedData) || normalizedData;
    }
    return normalizedData;
  }

  return dataCallback;
}

function each(obj, callback) {
  var i, j;

  if (isUndefined(obj.length)) {
    for (i in obj) {
      if (hasKey(obj, i)) {
        callback.call(null, i, obj[i]);
      }
    }
  } else {
    j = obj.length;
    if (j) {
      for (i = 0; i < j; i++) {
        callback.call(null, i, obj[i]);
      }
    }
  }
}

function objectMerge(obj1, obj2) {
  if (!obj2) {
    return obj1;
  }
  each(obj2, function(key, value) {
    obj1[key] = value;
  });
  return obj1;
}

/**
 * This function is only used for react-native.
 * react-native freezes object that have already been sent over the
 * js bridge. We need this function in order to check if the object is frozen.
 * So it's ok that objectFrozen returns false if Object.isFrozen is not
 * supported because it's not relevant for other "platforms". See related issue:
 * https://github.com/getsentry/react-native-sentry/issues/57
 */
function objectFrozen(obj) {
  if (!Object.isFrozen) {
    return false;
  }
  return Object.isFrozen(obj);
}

function truncate(str, max) {
  if (typeof max !== 'number') {
    throw new Error('2nd argument to `truncate` function should be a number');
  }
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : str.substr(0, max) + '\u2026';
}

/**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function hasKey(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}

function joinRegExp(patterns) {
  // Combine an array of regular expressions and strings into one large regexp
  // Be mad.
  var sources = [],
    i = 0,
    len = patterns.length,
    pattern;

  for (; i < len; i++) {
    pattern = patterns[i];
    if (isString(pattern)) {
      // If it's a string, we need to escape it
      // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
      sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
    } else if (pattern && pattern.source) {
      // If it's a regexp already, we want to extract the source
      sources.push(pattern.source);
    }
    // Intentionally skip other cases
  }
  return new RegExp(sources.join('|'), 'i');
}

function urlencode(o) {
  var pairs = [];
  each(o, function(key, value) {
    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
  });
  return pairs.join('&');
}

// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
// intentionally using regex and not <a/> href parsing trick because React Native and other
// environments where DOM might not be available
function parseUrl(url) {
  if (typeof url !== 'string') return {};
  var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  // coerce to undefined values to empty string so we don't get 'undefined'
  var query = match[6] || '';
  var fragment = match[8] || '';
  return {
    protocol: match[2],
    host: match[4],
    path: match[5],
    relative: match[5] + query + fragment // everything minus origin
  };
}
function uuid4() {
  var crypto = _window.crypto || _window.msCrypto;

  if (!isUndefined(crypto) && crypto.getRandomValues) {
    // Use window.crypto API if available
    // eslint-disable-next-line no-undef
    var arr = new Uint16Array(8);
    crypto.getRandomValues(arr);

    // set 4 in byte 7
    arr[3] = (arr[3] & 0xfff) | 0x4000;
    // set 2 most significant bits of byte 9 to '10'
    arr[4] = (arr[4] & 0x3fff) | 0x8000;

    var pad = function(num) {
      var v = num.toString(16);
      while (v.length < 4) {
        v = '0' + v;
      }
      return v;
    };

    return (
      pad(arr[0]) +
      pad(arr[1]) +
      pad(arr[2]) +
      pad(arr[3]) +
      pad(arr[4]) +
      pad(arr[5]) +
      pad(arr[6]) +
      pad(arr[7])
    );
  } else {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @param elem
 * @returns {string}
 */
function htmlTreeAsString(elem) {
  /* eslint no-extra-parens:0*/
  var MAX_TRAVERSE_HEIGHT = 5,
    MAX_OUTPUT_LEN = 80,
    out = [],
    height = 0,
    len = 0,
    separator = ' > ',
    sepLength = separator.length,
    nextStr;

  while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
    nextStr = htmlElementAsString(elem);
    // bail out if
    // - nextStr is the 'html' element
    // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
    //   (ignore this limit if we are on the first iteration)
    if (
      nextStr === 'html' ||
      (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)
    ) {
      break;
    }

    out.push(nextStr);

    len += nextStr.length;
    elem = elem.parentNode;
  }

  return out.reverse().join(separator);
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @param HTMLElement
 * @returns {string}
 */
function htmlElementAsString(elem) {
  var out = [],
    className,
    classes,
    key,
    attr,
    i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());
  if (elem.id) {
    out.push('#' + elem.id);
  }

  className = elem.className;
  if (className && isString(className)) {
    classes = className.split(/\s+/);
    for (i = 0; i < classes.length; i++) {
      out.push('.' + classes[i]);
    }
  }
  var attrWhitelist = ['type', 'name', 'title', 'alt'];
  for (i = 0; i < attrWhitelist.length; i++) {
    key = attrWhitelist[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push('[' + key + '="' + attr + '"]');
    }
  }
  return out.join('');
}

/**
 * Returns true if either a OR b is truthy, but not both
 */
function isOnlyOneTruthy(a, b) {
  return !!(!!a ^ !!b);
}

/**
 * Returns true if both parameters are undefined
 */
function isBothUndefined(a, b) {
  return isUndefined(a) && isUndefined(b);
}

/**
 * Returns true if the two input exception interfaces have the same content
 */
function isSameException(ex1, ex2) {
  if (isOnlyOneTruthy(ex1, ex2)) return false;

  ex1 = ex1.values[0];
  ex2 = ex2.values[0];

  if (ex1.type !== ex2.type || ex1.value !== ex2.value) return false;

  // in case both stacktraces are undefined, we can't decide so default to false
  if (isBothUndefined(ex1.stacktrace, ex2.stacktrace)) return false;

  return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
}

/**
 * Returns true if the two input stack trace interfaces have the same content
 */
function isSameStacktrace(stack1, stack2) {
  if (isOnlyOneTruthy(stack1, stack2)) return false;

  var frames1 = stack1.frames;
  var frames2 = stack2.frames;

  // Exit early if frame count differs
  if (frames1.length !== frames2.length) return false;

  // Iterate through every frame; bail out if anything differs
  var a, b;
  for (var i = 0; i < frames1.length; i++) {
    a = frames1[i];
    b = frames2[i];
    if (
      a.filename !== b.filename ||
      a.lineno !== b.lineno ||
      a.colno !== b.colno ||
      a['function'] !== b['function']
    )
      return false;
  }
  return true;
}

/**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */
function fill(obj, name, replacement, track) {
  if (obj == null) return;
  var orig = obj[name];
  obj[name] = replacement(orig);
  obj[name].__raven__ = true;
  obj[name].__orig__ = orig;
  if (track) {
    track.push([obj, name, orig]);
  }
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns {string}
 */
function safeJoin(input, delimiter) {
  if (!isArray(input)) return '';

  var output = [];

  for (var i = 0; i < input.length; i++) {
    try {
      output.push(String(input[i]));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

// Default Node.js REPL depth
var MAX_SERIALIZE_EXCEPTION_DEPTH = 3;
// 50kB, as 100kB is max payload size, so half sounds reasonable
var MAX_SERIALIZE_EXCEPTION_SIZE = 50 * 1024;
var MAX_SERIALIZE_KEYS_LENGTH = 40;

function utf8Length(value) {
  return ~-encodeURI(value).split(/%..|./).length;
}

function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}

function serializeValue(value) {
  if (typeof value === 'string') {
    var maxLength = 40;
    return truncate(value, maxLength);
  } else if (
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    typeof value === 'undefined'
  ) {
    return value;
  }

  var type = Object.prototype.toString.call(value);

  // Node.js REPL notation
  if (type === '[object Object]') return '[Object]';
  if (type === '[object Array]') return '[Array]';
  if (type === '[object Function]')
    return value.name ? '[Function: ' + value.name + ']' : '[Function]';

  return value;
}

function serializeObject(value, depth) {
  if (depth === 0) return serializeValue(value);

  if (isPlainObject(value)) {
    return Object.keys(value).reduce(function(acc, key) {
      acc[key] = serializeObject(value[key], depth - 1);
      return acc;
    }, {});
  } else if (Array.isArray(value)) {
    return value.map(function(val) {
      return serializeObject(val, depth - 1);
    });
  }

  return serializeValue(value);
}

function serializeException(ex, depth, maxSize) {
  if (!isPlainObject(ex)) return ex;

  depth = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_DEPTH : depth;
  maxSize = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_SIZE : maxSize;

  var serialized = serializeObject(ex, depth);

  if (jsonSize(stringify(serialized)) > maxSize) {
    return serializeException(ex, depth - 1);
  }

  return serialized;
}

function serializeKeysForMessage(keys, maxLength) {
  if (typeof keys === 'number' || typeof keys === 'string') return keys.toString();
  if (!Array.isArray(keys)) return '';

  keys = keys.filter(function(key) {
    return typeof key === 'string';
  });
  if (keys.length === 0) return '[object has no keys]';

  maxLength = typeof maxLength !== 'number' ? MAX_SERIALIZE_KEYS_LENGTH : maxLength;
  if (keys[0].length >= maxLength) return keys[0];

  for (var usedKeys = keys.length; usedKeys > 0; usedKeys--) {
    var serialized = keys.slice(0, usedKeys).join(', ');
    if (serialized.length > maxLength) continue;
    if (usedKeys === keys.length) return serialized;
    return serialized + '\u2026';
  }

  return '';
}

function sanitize(input, sanitizeKeys) {
  if (!isArray(sanitizeKeys) || (isArray(sanitizeKeys) && sanitizeKeys.length === 0))
    return input;

  var sanitizeRegExp = joinRegExp(sanitizeKeys);
  var sanitizeMask = '********';
  var safeInput;

  try {
    safeInput = JSON.parse(stringify(input));
  } catch (o_O) {
    return input;
  }

  function sanitizeWorker(workerInput) {
    if (isArray(workerInput)) {
      return workerInput.map(function(val) {
        return sanitizeWorker(val);
      });
    }

    if (isPlainObject(workerInput)) {
      return Object.keys(workerInput).reduce(function(acc, k) {
        if (sanitizeRegExp.test(k)) {
          acc[k] = sanitizeMask;
        } else {
          acc[k] = sanitizeWorker(workerInput[k]);
        }
        return acc;
      }, {});
    }

    return workerInput;
  }

  return sanitizeWorker(safeInput);
}

module.exports = {
  isObject: isObject,
  isError: isError,
  isErrorEvent: isErrorEvent,
  isUndefined: isUndefined,
  isFunction: isFunction,
  isPlainObject: isPlainObject,
  isString: isString,
  isArray: isArray,
  isEmptyObject: isEmptyObject,
  supportsErrorEvent: supportsErrorEvent,
  supportsFetch: supportsFetch,
  supportsReferrerPolicy: supportsReferrerPolicy,
  supportsPromiseRejectionEvent: supportsPromiseRejectionEvent,
  wrappedCallback: wrappedCallback,
  each: each,
  objectMerge: objectMerge,
  truncate: truncate,
  objectFrozen: objectFrozen,
  hasKey: hasKey,
  joinRegExp: joinRegExp,
  urlencode: urlencode,
  uuid4: uuid4,
  htmlTreeAsString: htmlTreeAsString,
  htmlElementAsString: htmlElementAsString,
  isSameException: isSameException,
  isSameStacktrace: isSameStacktrace,
  parseUrl: parseUrl,
  fill: fill,
  safeJoin: safeJoin,
  serializeException: serializeException,
  serializeKeysForMessage: serializeKeysForMessage,
  sanitize: sanitize
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(212);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(59);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(82);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(122);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(237);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(238);
/* unused harmony reexport createHashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(239);
/* unused harmony reexport createMemoryHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(61);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(51);
/* unused harmony reexport parsePath */
/* unused harmony reexport createPath */










/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(59);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(60);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(82);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history__ = __webpack_require__(122);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_history__["a" /* createBrowserHistory */])());

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(129);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(253);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(136);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(84);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);
var settle = __webpack_require__(275);
var buildURL = __webpack_require__(277);
var parseHeaders = __webpack_require__(278);
var isURLSameOrigin = __webpack_require__(279);
var createError = __webpack_require__(139);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(280);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(276);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeByType = exports.hideConfirm = exports.showConfirm = exports.remove = exports.clean = undefined;
exports.add = add;

var _constants = __webpack_require__(88);

var _utils = __webpack_require__(41);

var _reducer = __webpack_require__(143);

var _config = __webpack_require__(87);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function add(toastr) {
  if (_config2.default.preventDuplicates && (0, _utils.preventDuplication)(_reducer.toastrsCache, toastr)) {
    return {
      type: _constants.ADD_TOASTR,
      payload: {
        ignoreToastr: true
      }
    };
  }
  return {
    type: _constants.ADD_TOASTR,
    payload: toastr
  };
}

var clean = exports.clean = function clean() {
  return { type: _constants.CLEAN_TOASTR };
};

var remove = exports.remove = function remove(payload) {
  return {
    type: _constants.REMOVE_TOASTR,
    payload: payload
  };
};

var showConfirm = exports.showConfirm = function showConfirm(payload) {
  return {
    type: _constants.SHOW_CONFIRM,
    payload: payload
  };
};

var hideConfirm = exports.hideConfirm = function hideConfirm() {
  return { type: _constants.HIDE_CONFIRM };
};

var removeByType = exports.removeByType = function removeByType(payload) {
  return {
    type: _constants.REMOVE_BY_TYPE,
    payload: payload
  };
};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toastrsCache = undefined;

var _createReducer;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(41);

var _config = __webpack_require__(87);

var _config2 = _interopRequireDefault(_config);

var _constants = __webpack_require__(88);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// We will cache data so we can check for duplicated before fire the add action.
var toastrsCache = exports.toastrsCache = [];

var initialState = {
  toastrs: [],
  confirm: null
};

exports.default = (0, _utils.createReducer)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _constants.ADD_TOASTR, function (state, toastr) {
  if (toastr.ignoreToastr) {
    return state;
  }

  var newToastr = _extends({
    id: (0, _utils.guid)(),
    position: _config2.default.position
  }, toastr);

  var newState = {};
  if (!_config2.default.newestOnTop) {
    newState = _extends({}, state, {
      toastrs: [].concat(_toConsumableArray(state.toastrs), [newToastr])
    });
  } else {
    newState = _extends({}, state, {
      toastrs: [newToastr].concat(_toConsumableArray(state.toastrs))
    });
  }
  exports.toastrsCache = toastrsCache = newState.toastrs;
  return newState;
}), _defineProperty(_createReducer, _constants.REMOVE_TOASTR, function (state, id) {
  var newState = _extends({}, state, {
    toastrs: state.toastrs.filter(function (toastr) {
      return toastr.id !== id;
    })
  });

  exports.toastrsCache = toastrsCache = newState.toastrs;
  return newState;
}), _defineProperty(_createReducer, _constants.REMOVE_BY_TYPE, function (state, type) {
  var newState = _extends({}, state, {
    toastrs: state.toastrs.filter(function (toastr) {
      return toastr.type !== type;
    })
  });

  exports.toastrsCache = toastrsCache = newState.toastrs;
  return newState;
}), _defineProperty(_createReducer, _constants.CLEAN_TOASTR, function (state) {
  exports.toastrsCache = toastrsCache = [];
  return _extends({}, state, {
    toastrs: []
  });
}), _defineProperty(_createReducer, _constants.SHOW_CONFIRM, function (state, _ref) {
  var id = _ref.id,
      message = _ref.message,
      options = _ref.options;

  return _extends({}, state, {
    confirm: {
      id: id || (0, _utils.guid)(),
      show: true,
      message: message,
      options: options || {}
    }
  });
}), _defineProperty(_createReducer, _constants.HIDE_CONFIRM, function (state) {
  return _extends({}, state, {
    confirm: null
  });
}), _createReducer));

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toastrEmitter = exports.EE = undefined;

var _utils = __webpack_require__(41);

var _eventemitter = __webpack_require__(297);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emitter = new _eventemitter2.default();

var addToToastr = function addToToastr(type, array) {
  return emitter.emit('add/toastr', (0, _utils.mapToToastrMessage)(type, array));
};

var actions = {};
['light', 'message', 'info', 'success', 'warning', 'error'].forEach(function (item) {
  actions[item] = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return addToToastr(item, args);
  };
});

actions.clean = function () {
  return emitter.emit('clean/toastr');
};

/**
 * @params: can be a ID or a object that with a property type: 'success'
 * and by passing this we will remove all toastr with that type.
 */
actions.removeByType = function (type) {
  return emitter.emit('removeByType/toastr', type);
};

actions.confirm = function () {
  emitter.emit('toastr/confirm', {
    message: arguments.length <= 0 ? undefined : arguments[0],
    options: (arguments.length <= 1 ? undefined : arguments[1]) || {}
  });
};

var EE = exports.EE = emitter;
var toastrEmitter = exports.toastrEmitter = actions;

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_thunk__);
var composeEnhancers=window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__||__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */];/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(__WEBPACK_IMPORTED_MODULE_1__reducers__["a" /* default */],composeEnhancers(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_2_redux_thunk___default.a))));

/***/ }),
/* 146 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(28),
    isKey = __webpack_require__(91),
    stringToPath = __webpack_require__(344),
    toString = __webpack_require__(368);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53),
    isObject = __webpack_require__(93);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 150 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 151 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(70),
    stackClear = __webpack_require__(373),
    stackDelete = __webpack_require__(374),
    stackGet = __webpack_require__(375),
    stackHas = __webpack_require__(376),
    stackSet = __webpack_require__(377);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(378),
    isObjectLike = __webpack_require__(54);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(379),
    arraySome = __webpack_require__(382),
    cacheHas = __webpack_require__(383);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(397),
    isObjectLike = __webpack_require__(54);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(31),
    stubFalse = __webpack_require__(398);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)(module)))

/***/ }),
/* 157 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(399),
    baseUnary = __webpack_require__(159),
    nodeUtil = __webpack_require__(400);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 159 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(93);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 161 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 162 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IdleTimer=function(_React$Component){_inherits(IdleTimer,_React$Component);function IdleTimer(props){_classCallCheck(this,IdleTimer);var _this=_possibleConstructorReturn(this,(IdleTimer.__proto__||Object.getPrototypeOf(IdleTimer)).call(this,props));_this.events=['mousemove','keydown','wheel','DOMMouseScroll','mouseWheel','mousedown','touchstart','touchmove','MSPointerDown','MSPointerMove'];_this.defaultExpirationMS=5400000;_this.preExpirationTimeoutMS=120000;_this.timer=null;_this.state={active:false,expiresOn:''};_this.handleOnActive=_this.handleOnActive.bind(_this);_this.handleStorageEvent=_this.handleStorageEvent.bind(_this);return _this;}//90 MIN
//2 MIN - TO REQ REFRESH 2 MIN BEFORE TOKEN EXPIRATION
_createClass(IdleTimer,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;window.addEventListener('storage',this.handleStorageEvent,false);this.events.forEach(function(e){return document.addEventListener(e,_this2.handleOnActive);});}},{key:'componentDidMount',value:function componentDidMount(){this.syncTimer(JSON.parse(localStorage.getItem('IdleTimer')));}},{key:'componentWillUnmount',value:function componentWillUnmount(){var _this3=this;clearTimeout(this.timer);window.removeEventListener('storage',this.handleStorageEvent,false);this.events.forEach(function(e){return document.removeEventListener(e,_this3.handleOnActive);});}},{key:'handleStorageEvent',value:function handleStorageEvent(e){if(e.key&&e.key==='IdleTimer'){if(e.oldValue===e.newValue){return;}if(!e.newValue){//when any browser tab logs out
this.props.logout(true,true);//true for navigation only
}else{this.syncTimer(JSON.parse(e.newValue));}}}},{key:'syncTimer',value:function syncTimer(idleTimer){var timerExpiration=idleTimer?new Date(idleTimer.expiresOn)-this.preExpirationTimeoutMS:null;if(idleTimer&&timerExpiration>Date.now()){//timer has not yet expired
//sync timer and timer state
if(idleTimer.expiresOn!==this.state.expiresOn){clearTimeout(this.timer);var remainingTime=timerExpiration-Date.now()+30000;//ADDING 30 SECONDS TO TIMEOUT WHEN SYNC TO ANOTHER TAB TO AVOID HAVING REQUEST MADE BY BOTH TABS ON IDENTICAL TIMEOUT
this.timer=setTimeout(this.onTimeout.bind(this),remainingTime);}this.setState(Object.assign({},idleTimer));}else{this.reset();}}},{key:'reset',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var refresh,timeout;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:clearTimeout(this.timer);this.setState({active:false,expiresOn:''});_context.next=4;return this.getRefreshToken();case 4:refresh=_context.sent;if(refresh.success){timeout=refresh.expiresIn-this.preExpirationTimeoutMS;this.timer=setTimeout(this.onTimeout.bind(this),timeout);this.setLocalStorageIdleTimer({active:false,expiresOn:refresh.expiresOn});}case 6:case'end':return _context.stop();}}},_callee,this);}));function reset(){return _ref.apply(this,arguments);}return reset;}()},{key:'setLocalStorageIdleTimer',value:function setLocalStorageIdleTimer(idleTimer){//Window 'storage' event is not invoked on the browser tab that the local storage event is raised by, t/f setting state here
localStorage.setItem('IdleTimer',JSON.stringify(idleTimer));this.setState(Object.assign({},idleTimer));}},{key:'handleOnActive',value:function handleOnActive(){if(!this.state.active){var idleTimer=JSON.parse(localStorage.getItem('IdleTimer'));if(idleTimer){this.setLocalStorageIdleTimer(Object.assign({},idleTimer,{active:true}));}}}},{key:'onTimeout',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(this.state.active||this.props.alwaysRefresh){this.reset();}else{this.props.logout(true);//IdleTimer removed from localStorage in LOGOUT ACTION
}case 1:case'end':return _context2.stop();}}},_callee2,this);}));function onTimeout(){return _ref2.apply(this,arguments);}return onTimeout;}()},{key:'getRefreshToken',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var res,verification,refresh,lastVerification;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:res={success:true,timeout:this.defaultExpirationMS};_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])("/xsrfToken");case 3:verification=_context3.sent;if(!verification.success){_context3.next=21;break;}_context3.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])(this.props.refreshUrl||"/account/refreshToken",null,_defineProperty({},verification.data.tokenName,verification.data.token));case 7:refresh=_context3.sent;if(!refresh.success){_context3.next=17;break;}res.expiresIn=refresh.data.expiresIn?refresh.data.expiresIn*1000:this.defaultExpirationMS;//converting S to MS (OR default)
res.expiresOn=new Date(refresh.data.expiresOn).toLocaleString();_context3.next=13;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])("/xsrfToken");case 13:lastVerification=_context3.sent;if(lastVerification.success){localStorage.setItem("RequestVerificationToken",lastVerification.data.token);}_context3.next=19;break;case 17:res.success=false;this.props.logout(true);case 19:_context3.next=23;break;case 21:res.success=false;this.props.logout(true);case 23:return _context3.abrupt('return',res);case 24:case'end':return _context3.stop();}}},_callee3,this);}));function getRefreshToken(){return _ref3.apply(this,arguments);}return getRefreshToken;}()},{key:'render',value:function render(){return this.props.children;}}]);return IdleTimer;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (IdleTimer);

/***/ }),
/* 164 */
/***/ (function(module, exports) {

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}   noTrailing     Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset)
 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {Boolean}   debounceMode   If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @return {Function}  A new, throttled, function.
 */
module.exports = function ( delay, noTrailing, callback, debounceMode ) {

	// After wrapper has stopped being called, this timeout ensures that
	// `callback` is executed at the proper times in `throttle` and `end`
	// debounce modes.
	var timeoutID;

	// Keep track of the last time `callback` was executed.
	var lastExec = 0;

	// `noTrailing` defaults to falsy.
	if ( typeof noTrailing !== 'boolean' ) {
		debounceMode = callback;
		callback = noTrailing;
		noTrailing = undefined;
	}

	// The `wrapper` function encapsulates all of the throttling / debouncing
	// functionality and when executed will limit the rate at which `callback`
	// is executed.
	function wrapper () {

		var self = this;
		var elapsed = Number(new Date()) - lastExec;
		var args = arguments;

		// Execute `callback` and update the `lastExec` timestamp.
		function exec () {
			lastExec = Number(new Date());
			callback.apply(self, args);
		}

		// If `debounceMode` is true (at begin) this is used to clear the flag
		// to allow future `callback` executions.
		function clear () {
			timeoutID = undefined;
		}

		if ( debounceMode && !timeoutID ) {
			// Since `wrapper` is being called for the first time and
			// `debounceMode` is true (at begin), execute `callback`.
			exec();
		}

		// Clear any existing timeout.
		if ( timeoutID ) {
			clearTimeout(timeoutID);
		}

		if ( debounceMode === undefined && elapsed > delay ) {
			// In throttle mode, if `delay` time has been exceeded, execute
			// `callback`.
			exec();

		} else if ( noTrailing !== true ) {
			// In trailing throttle mode, since `delay` time has not been
			// exceeded, schedule `callback` to execute `delay` ms after most
			// recent execution.
			//
			// If `debounceMode` is true (at begin), schedule `clear` to execute
			// after `delay` ms.
			//
			// If `debounceMode` is false (at end), schedule `callback` to
			// execute after `delay` ms.
			timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
		}

	}

	// Return the wrapper function.
	return wrapper;

};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(435);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(20);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(436);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(102);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(438));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_CurrencyFormatInput__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_systemVariables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={updatedAmount:null,updateAttempted:false,updateError:false};var UpdateApplicationAmtInput=function(_React$Component){_inherits(UpdateApplicationAmtInput,_React$Component);function UpdateApplicationAmtInput(props){_classCallCheck(this,UpdateApplicationAmtInput);var _this=_possibleConstructorReturn(this,(UpdateApplicationAmtInput.__proto__||Object.getPrototypeOf(UpdateApplicationAmtInput)).call(this,props));_this.state=initialState;return _this;}_createClass(UpdateApplicationAmtInput,[{key:'updateAmount',value:function updateAmount(name,value){this.setState({updatedAmount:parseFloat(value||0)!==parseFloat(this.props.maxAmount||0)?value:null});}},{key:'saveUpdate',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({updateAttempted:true,updateError:false});if(!(this.state.updatedAmount>this.props.maxAmount)){_context.next=3;break;}return _context.abrupt('return');case 3:_context.next=5;return this.props.update(this.props.application,{amount:this.state.updatedAmount});case 5:if(this.props.updateError){this.setState({updateError:true});}else{this.setState({updatedAmount:null});}case 6:case'end':return _context.stop();}}},_callee,this);}));function saveUpdate(){return _ref.apply(this,arguments);}return saveUpdate;}()},{key:'cancelUpdate',value:function cancelUpdate(){this.setState(initialState);}},{key:'render',value:function render(){var _this2=this;var _props$application=this.props.application,amount=_props$application.amount,currency=_props$application.currency;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dollar-input-container dollar-input-container--inline-actions'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__util_CurrencyFormatInput__["a" /* default */],{className:'input',isIsraeli:currency===__WEBPACK_IMPORTED_MODULE_7__lib_systemVariables__["f" /* CurrencyTypes */].Shekel}),value:this.state.updatedAmount!==null?this.state.updatedAmount:amount||'',onChange:this.updateAmount.bind(this),onKeyDown:function onKeyDown(e){if(e.key==='Enter'&&_this2.state.updatedAmount!==null)_this2.saveUpdate();},validated:true,showValidationError:this.state.updateAttempted,validate:function validate(val){return!val||Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["B" /* stripCurrencyFormat */])(val)<=_this2.props.maxAmount;},errorMessage:'Application amount cannot exceed '+Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["j" /* formatCurrency */])(this.props.maxAmount,currency===__WEBPACK_IMPORTED_MODULE_7__lib_systemVariables__["f" /* CurrencyTypes */].Shekel)+'.'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dollar-input-edit'},this.props.updating?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_LoadingSpinner__["a" /* default */],{height:'12'}):this.state.updatedAmount!==null&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons input',onClick:this.saveUpdate.bind(this)},'check'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons input',onClick:this.cancelUpdate.bind(this)},'close'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__util_FadeOutErrorMessage__["a" /* default */],{show:this.state.updateError}));}}]);return UpdateApplicationAmtInput;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (UpdateApplicationAmtInput);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RecipientSummaryCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_apiUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_recipientSummaryCache__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_shared_AiIcon__ = __webpack_require__(172);
/* unused harmony reexport clearRecipientSummaryCache */
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GAP=8;var RecipientSummaryCard=function(_React$Component){_inherits(RecipientSummaryCard,_React$Component);function RecipientSummaryCard(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,RecipientSummaryCard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RecipientSummaryCard.__proto__||Object.getPrototypeOf(RecipientSummaryCard)).call.apply(_ref,[this].concat(args))),_this),_this.state={show:false,position:null,summary:null,loading:false,error:false,aiLoading:false},_this.requestId=0,_this.triggerRef=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef(),_this.cardRef=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef(),_this.addWindowListeners=function(){document.addEventListener('mousedown',_this.onDocumentPointerDown);document.addEventListener('touchstart',_this.onDocumentPointerDown);window.addEventListener('scroll',_this.close,true);window.addEventListener('resize',_this.close);window.addEventListener('keydown',_this.onKeyDown);},_this.removeWindowListeners=function(){document.removeEventListener('mousedown',_this.onDocumentPointerDown);document.removeEventListener('touchstart',_this.onDocumentPointerDown);window.removeEventListener('scroll',_this.close,true);window.removeEventListener('resize',_this.close);window.removeEventListener('keydown',_this.onKeyDown);},_this.onKeyDown=function(e){if(e.key==='Escape')_this.close();},_this.onDocumentPointerDown=function(e){if(_this.triggerRef.current&&_this.triggerRef.current.contains(e.target)||_this.cardRef.current&&_this.cardRef.current.contains(e.target)){return;}_this.close();},_this.onTriggerClick=function(e){e.preventDefault();e.stopPropagation();if(_this.state.show){_this.close();return;}_this.open();},_this.stopEvent=function(e){e.stopPropagation();},_this.getPosition=function(){if(!_this.triggerRef.current||!_this.cardRef.current)return null;var triggerRect=_this.triggerRef.current.getBoundingClientRect();var cardRect=_this.cardRef.current.getBoundingClientRect();var flipUp=triggerRect.bottom+GAP+cardRect.height>window.innerHeight;var position={left:Math.max(GAP,Math.min(triggerRect.left,window.innerWidth-cardRect.width-GAP))};if(flipUp){position.bottom=window.innerHeight-triggerRect.top+GAP;}else{position.top=triggerRect.bottom+GAP;}return position;},_this.updatePosition=function(){var position=_this.getPosition();if(!position)return;_this.setState({position:position});},_this.open=function(){_this.setState({show:true,position:null});if(_this.props.onOpenChange)_this.props.onOpenChange(true);_this.addWindowListeners();_this.loadSummary();},_this.close=function(){_this.requestId++;_this.removeWindowListeners();_this.setState({show:false,loading:false,aiLoading:false});if(_this.props.onOpenChange)_this.props.onOpenChange(false);},_this.loadSummary=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var recipientId,cached,requestId,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:recipientId=_this.props.recipientId;cached=Object(__WEBPACK_IMPORTED_MODULE_6__lib_recipientSummaryCache__["b" /* getCachedRecipientSummary */])(recipientId);if(!cached){_context.next=6;break;}_this.setState({summary:cached,error:false});if(cached.aiSummaryPending&&!cached.aiSummary){_this.generateAiSummary();}return _context.abrupt('return');case 6:_this.setState({loading:true,error:false,summary:null});requestId=++_this.requestId;_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_4__lib_apiUtils__["b" /* getRequest */])('/applications/recipients/'+recipientId+'/summary');case 10:result=_context.sent;if(!(requestId!==_this.requestId)){_context.next=13;break;}return _context.abrupt('return');case 13:if(result.success){_context.next=16;break;}_this.setState({loading:false,error:true});return _context.abrupt('return');case 16:Object(__WEBPACK_IMPORTED_MODULE_6__lib_recipientSummaryCache__["c" /* setCachedRecipientSummary */])(recipientId,result.data);_this.setState({summary:result.data,loading:false});if(result.data.aiSummaryPending&&!result.data.aiSummary){_this.generateAiSummary();}case 19:case'end':return _context.stop();}}},_callee,_this2);})),_this.generateAiSummary=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var recipientId,requestId,result,updated;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:recipientId=_this.props.recipientId;_this.setState({aiLoading:true});requestId=_this.requestId;_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_4__lib_apiUtils__["d" /* postRequest */])('/applications/recipients/'+recipientId+'/summary/generate');case 5:result=_context2.sent;if(!(requestId!==_this.requestId||!_this.props.showAiSummaries)){_context2.next=8;break;}return _context2.abrupt('return');case 8:updated=Object.assign({},_this.state.summary||Object(__WEBPACK_IMPORTED_MODULE_6__lib_recipientSummaryCache__["b" /* getCachedRecipientSummary */])(recipientId)||{},{aiSummary:result.success?result.data.aiSummary:null,aiSummaryGeneratedDate:result.success?result.data.generatedDate:null,aiSummaryPending:!result.success});Object(__WEBPACK_IMPORTED_MODULE_6__lib_recipientSummaryCache__["c" /* setCachedRecipientSummary */])(recipientId,updated);_this.setState({summary:updated,aiLoading:false});case 11:case'end':return _context2.stop();}}},_callee2,_this2);})),_this.getHistoryDuration=function(firstApplicationDate,lastApplicationDate){var first=new Date(firstApplicationDate);var last=new Date(lastApplicationDate);var months=(last.getUTCFullYear()-first.getUTCFullYear())*12+last.getUTCMonth()-first.getUTCMonth();months=Math.max(0,months);var years=Math.floor(months/12);var remainingMonths=months%12;var parts=[];if(years>0)parts.push(years+' '+(years===1?'year':'years'));if(remainingMonths>0)parts.push(remainingMonths+' '+(remainingMonths===1?'month':'months'));return parts.length>0?parts.join(', '):'Less than a month';},_this.formatSummaryDate=function(date){return new Date(date).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric',timeZone:'UTC'});},_this.formatSummaryCurrency=function(amount,isIsraeli){return Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["j" /* formatCurrency */])(Math.round(Number(amount)),isIsraeli).replace(/\.00$/,'');},_this.renderStats=function(stats){var isIsraeli=stats.isIsraeli;if(stats.totalApplications===1){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipient-summary-stats recipient-summary-first-application'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'stat full-width'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'stat-label'},'First Application'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'stat-note'},'No prior application history')),stats.totalPaid>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'stat full-width'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'stat-label'},'Total Paid'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'stat-value'},_this.formatSummaryCurrency(stats.totalPaid,isIsraeli))));}var historyDuration=_this.getHistoryDuration(stats.firstApplicationDate,stats.lastApplicationDate);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipient-summary-history'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'history-overview'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,stats.totalApplications,' applications'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,' ','\xB7',' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,_this.formatSummaryCurrency(stats.totalPaid,isIsraeli),' paid')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'history-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'history-heading'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,'History'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'\xB7'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,historyDuration)),stats.latestPaidApplicationDate&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,'Last Paid'),' ','\u2014',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,_this.formatSummaryDate(stats.latestPaidApplicationDate)),stats.latestPaidApplicationReason&&' \xB7 '+stats.latestPaidApplicationReason,stats.latestPaidApplicationAmount!=null&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,' ','\xB7',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,_this.formatSummaryCurrency(stats.latestPaidApplicationAmount,isIsraeli))))));},_this.renderShimmer=function(lines){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{'aria-busy':'true'},Array.from({length:lines}).map(function(_,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:i,className:'shimmer-line',style:i===lines-1?{width:'60%'}:null});}));},_this.renderCardBody=function(){var _this$state=_this.state,summary=_this$state.summary,loading=_this$state.loading,error=_this$state.error,aiLoading=_this$state.aiLoading;if(error){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'recipient-summary-error'},'Unable to load summary');}if(loading||!summary){return _this.renderShimmer(3);}if(!summary.stats||summary.stats.totalApplications===0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'recipient-summary-error'},'No applications visible to you');}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,_this.renderStats(summary.stats),(aiLoading||summary.aiSummary)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipient-summary-ai'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'stat-label'},'AI Summary'),aiLoading?_this.renderShimmer(2):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,summary.aiSummary)));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RecipientSummaryCard,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.showAiSummaries&&!this.props.showAiSummaries){if(this.state.show){this.close();return;}if(this.state.aiLoading)this.setState({aiLoading:false});}var cardContentChanged=!prevState.show||prevState.loading!==this.state.loading||prevState.error!==this.state.error||prevState.summary!==this.state.summary||prevState.aiLoading!==this.state.aiLoading||prevProps.title!==this.props.title;if(this.state.show&&cardContentChanged)this.updatePosition();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.requestId++;this.removeWindowListeners();}// The card renders in a portal, but React still bubbles its events to the
// table row's hover/click handlers - block them at the card boundary.
},{key:'render',value:function render(){var _props=this.props,recipientId=_props.recipientId,disabled=_props.disabled,title=_props.title,children=_props.children;var _state=this.state,show=_state.show,position=_state.position;if(!this.props.showAiSummaries||disabled||!recipientId){return children||null;}var cardId='recipient-summary-'+recipientId;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'recipient-summary-trigger'},children,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button',ref:this.triggerRef,className:'recipient-summary-button','aria-controls':cardId,'aria-expanded':show,'aria-label':'Show recipient summary',title:'Show recipient summary',onClick:this.onTriggerClick,onMouseDown:this.stopEvent},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_shared_AiIcon__["a" /* default */],{className:'recipient-summary-button-icon'})),show&&__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.createPortal(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:cardId,ref:this.cardRef,className:'recipient-summary-card',style:position,role:'dialog','aria-label':title||'AI summary',onMouseOver:this.stopEvent,onMouseOut:this.stopEvent,onClick:this.stopEvent,onDoubleClick:this.stopEvent,onMouseDown:this.stopEvent},title&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'card-header'},title),this.renderCardBody()),document.body));}}]);return RecipientSummaryCard;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);function mapStateToProps(state){return{showAiSummaries:state.userProfile.profile.data.showAiSummaries!==false};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps)(RecipientSummaryCard));

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var AiIcon=function AiIcon(_ref){var className=_ref.className,_ref$size=_ref.size,size=_ref$size===undefined?20:_ref$size;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{className:className,viewBox:"0 0 24 24",width:size,height:size,"aria-hidden":"true"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M11 3l1.6 4.4L17 9l-4.4 1.6L11 15l-1.6-4.4L5 9l4.4-1.6z",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M18.5 13l.55 1.85 1.85.55-1.85.55-.55 1.85-.55-1.85-1.85-.55 1.85-.55z",fill:"currentColor"}));};/* harmony default export */ __webpack_exports__["a"] = (AiIcon);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_SuggestionsActions__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_SidebarFilterActions__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_hotkeys__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_hotkeys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_hotkeys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_CustomDropdown__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SaveSearchModal__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_AutoSuggestMultiInput__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_AutocompleteMultiInput__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_FreeTextEntry__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_MultiSelectToggleView__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_DateRangePicker__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_ValidatedPhoneInput__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util_LoadingSpinner__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SidebarFilter=function(_NavigationComponent){_inherits(SidebarFilter,_NavigationComponent);function SidebarFilter(props){_classCallCheck(this,SidebarFilter);var _this=_possibleConstructorReturn(this,(SidebarFilter.__proto__||Object.getPrototypeOf(SidebarFilter)).call(this,props));_this.state={showModals:{saveSearchModal:false}};_this.update=_this.update.bind(_this);return _this;}_createClass(SidebarFilter,[{key:'componentWillMount',value:function componentWillMount(){this.props.actions.getSavedSearches(this.props.type);}},{key:'update',value:function update(propertyName,value){this.props.actions.updateFilters(this.props.type,_defineProperty({},propertyName,value));}},{key:'search',value:function search(){if(!Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["e" /* deepEquals */])(this.props.filters,this.props.appliedFilters)){this.props.actions.setAppliedFilters(this.props.type,this.props.filters);this.props.search(this.props.filters);}}},{key:'saveSearch',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(title){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.actions.createSavedSearch(this.props.type,title,this.props.filters);case 2:if(this.props.newSearch.success){__WEBPACK_IMPORTED_MODULE_9_react_redux_toastr__["toastr"].success(title+' search has been saved.',{timeOut:2000,progressBar:false});}case 3:case'end':return _context.stop();}}},_callee,this);}));function saveSearch(_x){return _ref.apply(this,arguments);}return saveSearch;}()},{key:'deleteSearch',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(searchId,title){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return this.props.actions.deleteSavedSearch(this.props.type,searchId);case 2:if(!this.props.savedSearchList.deleting.hasOwnProperty(searchId)){__WEBPACK_IMPORTED_MODULE_9_react_redux_toastr__["toastr"].success(title+' search has been deleted.',{timeOut:2000,progressBar:false});}else{__WEBPACK_IMPORTED_MODULE_9_react_redux_toastr__["toastr"].error("Something went wrong",'This action could not be completed.  Please try again.');}case 3:case'end':return _context2.stop();}}},_callee2,this);}));function deleteSearch(_x2,_x3){return _ref2.apply(this,arguments);}return deleteSearch;}()},{key:'render',value:function render(){var _this2=this;var noFilters=!this.props.filters.keyword&&!this.props.filters.reportName&&!this.props.filters.teudatZahut&&!this.props.filters.bankAccount&&!this.props.filters.firstName&&!this.props.filters.lastName&&!this.props.filters.streetNames.length&&!this.props.filters.cities.length&&!this.props.filters.phoneNumber&&!this.props.filters.categories.length&&!this.props.filters.nationalities.length&&!this.props.filters.recipientTypes.length&&!this.props.filters.recipientStatuses.length&&!this.props.filters.organizations.length&&!this.props.filters.taxId&&!this.props.filters.references.length&&!this.props.filters.hasAchAccount&&(this.props.type===__WEBPACK_IMPORTED_MODULE_8__lib_constants__["j" /* TableNames */].Recipients?!this.props.filters.recipientSearch&&!this.props.filters.hasPledges&&!this.props.filters.incomplete&&!this.props.filters.campaignLists.length:!this.props.filters.recipients.length&&!this.props.filters.reportMemo&&!this.props.filters.checkNumber&&!this.props.filters.applicationStatuses.length&&!this.props.filters.applicationReasons.length&&!this.props.filters.approvers.length&&!this.props.filters.sources.length&&!this.props.filters.funds.length&&!this.props.filters.campaigns.length&&!this.props.filters.campaignIndividualCategories.length&&!this.props.filters.campaignLists.length&&(!this.props.filters.startDate||!this.props.filters.endDate)&&this.props.filters.hasReceipt===null);var canSearch=!Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["e" /* deepEquals */])(this.props.filters,this.props.appliedFilters);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('aside',{className:'sidebar '+(this.props.visible?"sidebar-show":"sidebar-hidden")},this.props.loading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__util_LoadingSpinner__["a" /* default */],{height:'32'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'sidebar-header relative'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text uppercase-text accent-text'},' ',this.props.type,' FILTER'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'link-text xs-text '+(noFilters?"disabled":""),onClick:function onClick(){if(!noFilters)_this2.props.actions.resetFilters(_this2.props.type);}},'Clear All'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-arrow-left-c sidebar-slide-in',onClick:function onClick(){return _this2.props.actions.toggleSidebar(_this2.props.type);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_hotkeys__["HotKeys"],{keyMap:{search:'enter'},handlers:{search:function search(){if(_this2.props.visible)_this2.search();}}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'sidebar-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__util_CustomDropdown__["a" /* default */],{placeholder:'Saved Searches',options:this.props.savedSearchList.data,onSelect:function onSelect(searchId){return _this2.props.actions.getSavedSearch(_this2.props.type,searchId);},selection:this.props.savedSearch.data.value,actionIcon:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-android-delete action'}),action:this.deleteSearch.bind(this),loading:this.props.savedSearch.loading}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',placeholder:'Keyword',value:this.props.filters.keyword||'',onChange:function onChange(e){return _this2.update("keyword",e.target.value);}}),this.props.type===__WEBPACK_IMPORTED_MODULE_8__lib_constants__["j" /* TableNames */].Applications?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__util_AutoSuggestMultiInput__["a" /* default */],{title:'Name',suggestions:this.props.recipientSuggestions.data,suggestionKey:'applicantId',suggestionValue:'name',allowIncomplete:true,getSuggestions:this.props.actions.getRecipientSuggestions,clearSuggestions:this.props.actions.clearRecipientSuggestions,loadingSuggestions:this.props.recipientSuggestions.loading,name:'recipients',selection:this.props.filters.recipients,update:this.update}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__util_FreeTextEntry__["a" /* default */],{title:'Recipient Search',value:this.props.filters.recipientSearch,propertyName:'recipientSearch',update:this.update}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__util_FreeTextEntry__["a" /* default */],{title:'First Name',value:this.props.filters.firstName,propertyName:'firstName',update:this.update})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__util_FreeTextEntry__["a" /* default */],{title:'Last Name',value:this.props.filters.lastName,propertyName:'lastName',update:this.update}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__util_FreeTextEntry__["a" /* default */],{title:'Report Name',value:this.props.filters.reportName,propertyName:'reportName',update:this.update}),this.props.type===__WEBPACK_IMPORTED_MODULE_8__lib_constants__["j" /* TableNames */].Applications&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__util_FreeTextEntry__["a" /* default */],{title:'Report Memo',value:this.props.filters.reportMemo,propertyName:'reportMemo',update:this.update}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__util_FreeTextEntry__["a" /* default */],{title:'Teudat Zehut',value:this.props.filters.teudatZahut,propertyName:'teudatZahut',update:this.update}),this.props.type===__WEBPACK_IMPORTED_MODULE_8__lib_constants__["j" /* TableNames */].Recipients&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__util_FreeTextEntry__["a" /* default */],{title:'Bank Account',value:this.props.filters.bankAccount,propertyName:'bankAccount',update:this.update}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'street-num column-third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__util_FreeTextEntry__["a" /* default */],{title:'Num',value:this.props.filters.streetNum,propertyName:'streetNum',update:this.update})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'street-name'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__util_AutocompleteMultiInput__["a" /* default */],{title:'Street Name',name:'streetNames',options:this.props.systemSettings.otherSettings.streetNames.map(function(s){return{key:s,value:s};}),selection:this.props.filters.streetNames,update:this.update}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__util_AutocompleteMultiInput__["a" /* default */],{title:'City',name:'cities',options:this.props.systemSettings.otherSettings.cities.map(function(c){return{key:c,value:c};}),selection:this.props.filters.cities,update:this.update}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__util_ValidatedPhoneInput__["a" /* default */],{phoneNumber:this.props.filters.phoneNumber||'',phoneType:this.state.phoneType||__WEBPACK_IMPORTED_MODULE_8__lib_constants__["g" /* PhoneNumberTypes */].American,phoneNumberName:'phoneNumber',phoneTypeName:'phoneType',onChange:function onChange(name,value){return name==="phoneNumber"?_this2.update(name,value):_this2.setState(_defineProperty({},name,value));}}),this.props.userPermissions.institutions&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__util_AutocompleteMultiInput__["a" /* default */],{title:'Organization',name:'organizations',options:this.props.tags.organizations,selection:this.props.filters.organizations,update:this.update}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__util_FreeTextEntry__["a" /* default */],{title:'Tax ID',value:this.props.filters.taxId,propertyName:'taxId',update:this.update})),this.props.type===__WEBPACK_IMPORTED_MODULE_8__lib_constants__["j" /* TableNames */].Applications&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__util_FreeTextEntry__["a" /* default */],{title:'Check',value:this.props.filters.checkNumber,propertyName:'checkNumber',update:this.update}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'hasAchAccount',name:'hasAchAccount',className:'custom-check',checked:this.props.filters.hasAchAccount||false,onChange:function onChange(e){return _this2.update('hasAchAccount',!_this2.props.filters.hasAchAccount);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'hasAchAccount'},'Has ACH Account'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null))),this.props.type===__WEBPACK_IMPORTED_MODULE_8__lib_constants__["j" /* TableNames */].Recipients&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'pledge-checkbox',name:'pledge-checkbox',className:'custom-check',checked:this.props.filters.hasPledges||false,onChange:function onChange(e){return _this2.update('hasPledges',!_this2.props.filters.hasPledges);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'pledge-checkbox',className:'secondary-text'},'Show Pledges Only'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'incomplete-checkbox',name:'incomplete-checkbox',className:'custom-check',checked:this.props.filters.incomplete||false,onChange:function onChange(e){return _this2.update('incomplete',!_this2.props.filters.incomplete);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'incomplete-checkbox',className:'secondary-text'},'Show Incomplete Only'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__util_MultiSelectToggleView__["a" /* default */],{title:'Category',propertyName:'categories',options:[].concat(_toConsumableArray(this.props.systemSettings.recipientSettings.individualTags),_toConsumableArray(this.props.systemSettings.recipientSettings.organizationTags)),selection:this.props.filters.categories,update:this.update}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__util_MultiSelectToggleView__["a" /* default */],{title:'Nationality',propertyName:'nationalities',options:this.props.systemSettings.otherSettings.nationalities.map(function(n){return{key:n,value:n};}),selection:this.props.filters.nationalities,update:this.update}),this.props.userPermissions.individuals&&this.props.userPermissions.institutions&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__util_MultiSelectToggleView__["a" /* default */],{title:'Recipient Type',propertyName:'recipientTypes',options:this.props.systemSettings.otherSettings.recipientTypes,selection:this.props.filters.recipientTypes,update:this.update}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__util_MultiSelectToggleView__["a" /* default */],{title:'Recipient Status',propertyName:'recipientStatuses',options:this.props.systemSettings.otherSettings.recipientStatuses,selection:this.props.filters.recipientStatuses,update:this.update}),this.props.type===__WEBPACK_IMPORTED_MODULE_8__lib_constants__["j" /* TableNames */].Applications&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__util_MultiSelectToggleView__["a" /* default */],{title:'Application Status',propertyName:'applicationStatuses',options:this.props.systemSettings.otherSettings.applicationStatuses,selection:this.props.filters.applicationStatuses,update:this.update}),this.props.userPermissions.individuals&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__util_MultiSelectToggleView__["a" /* default */],{title:'Individual Application Reason',propertyName:'applicationReasons',options:this.props.systemSettings.applicationSettings.individualApplicationReasons,selection:this.props.filters.applicationReasons,update:this.update}),this.props.userPermissions.institutions&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__util_MultiSelectToggleView__["a" /* default */],{title:'Organization Application Reason',propertyName:'applicationReasons',options:this.props.systemSettings.applicationSettings.organizationApplicationReasons,selection:this.props.filters.applicationReasons,update:this.update}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__util_AutocompleteMultiInput__["a" /* default */],{title:'Approver',name:'approvers',options:this.props.tags.approvers,selection:this.props.filters.approvers,update:this.update}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__util_AutocompleteMultiInput__["a" /* default */],{title:'Fund',name:'funds',options:this.props.tags.funds,selection:this.props.filters.funds,update:this.update}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__util_AutocompleteMultiInput__["a" /* default */],{title:'Campaign',name:'campaigns',options:this.props.tags.campaigns,selection:this.props.filters.campaigns,update:this.update}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__util_AutocompleteMultiInput__["a" /* default */],{title:'Campaign Individual Category',name:'campaignIndividualCategories',options:this.props.systemSettings.campaignSettings.campaignIndivCategories,selection:this.props.filters.campaignIndividualCategories,update:this.update}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__util_AutocompleteMultiInput__["a" /* default */],{title:'Campaign List',name:'campaignLists',options:this.props.tags.campaignLists,selection:this.props.filters.campaignLists,update:this.update}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__util_AutocompleteMultiInput__["a" /* default */],{title:'Source',name:'sources',options:Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["o" /* formatReferenceOptions */])(this.props.tags.references),selection:this.props.filters.sources,update:this.update})),this.props.type===__WEBPACK_IMPORTED_MODULE_8__lib_constants__["j" /* TableNames */].Recipients&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__util_AutocompleteMultiInput__["a" /* default */],{title:'Campaign List',name:'campaignLists',options:this.props.tags.campaignLists,selection:this.props.filters.campaignLists,update:this.update}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__util_AutocompleteMultiInput__["a" /* default */],{title:'Reference / Solicitor / Rosh Yeshiva',name:'references',options:Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["o" /* formatReferenceOptions */])(this.props.tags.references),selection:this.props.filters.references,update:this.update}),this.props.type===__WEBPACK_IMPORTED_MODULE_8__lib_constants__["j" /* TableNames */].Applications&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__util_DateRangePicker__["a" /* default */],{startDate:this.props.filters.startDate,endDate:this.props.filters.endDate,update:this.update}),this.props.type===__WEBPACK_IMPORTED_MODULE_8__lib_constants__["j" /* TableNames */].Applications&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'filter-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Receipt'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'filter-chips'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'filter-chip '+(this.props.filters.hasReceipt===true?'filter-chip-selected':''),onClick:function onClick(){return _this2.update('hasReceipt',_this2.props.filters.hasReceipt===true?null:true);}},'Yes'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'filter-chip '+(this.props.filters.hasReceipt===false?'filter-chip-selected':''),onClick:function onClick(){return _this2.update('hasReceipt',_this2.props.filters.hasReceipt===false?null:false);}},'No')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'sidebar-footer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent btn-fullWidth',onClick:this.toggleModal.bind(this,"saveSearchModal"),disabled:noFilters||this.props.savedSearch.data.key},'Save'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent2 btn-fullWidth',onClick:this.search.bind(this),disabled:!canSearch},'Search')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__SaveSearchModal__["a" /* default */],{modalShowing:this.state.showModals.saveSearchModal,close:this.toggleModal.bind(this,"saveSearchModal"),save:this.saveSearch.bind(this),saving:this.props.newSearch.loading,success:this.props.newSearch.success,savedSearchTitles:this.props.savedSearchList.data.map(function(search){return search.value;})}));}}]);return SidebarFilter;}(__WEBPACK_IMPORTED_MODULE_11__util_NavigationComponent__["a" /* default */]);function mapStateToProps(state,ownProps){var filterProps=ownProps.type===__WEBPACK_IMPORTED_MODULE_8__lib_constants__["j" /* TableNames */].Applications?state.applicationsSidebarFilters:state.recipientsSidebarFilters;return{loading:state.settings.systemSettings.loading,tags:{campaigns:state.campaigns.campaigns.data,campaignLists:state.campaignLists.allCampaignLists.data,organizations:state.recipientAccounts.organizations.data,approvers:state.users.approvers.data,funds:state.funds.fundsByDept.all,references:state.references.references.data},systemSettings:state.settings.systemSettings.data,visible:filterProps.showSidebar,filters:filterProps.filters,appliedFilters:filterProps.appliedFilters,savedSearchList:filterProps.savedSearchList,savedSearch:filterProps.savedSearch,newSearch:filterProps.newSearch,recipientSuggestions:state.suggestions.recipientSuggestions,userPermissions:{individuals:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_7__lib_systemVariables__["j" /* PermissionTypes */].IndividualsManage)>=0,institutions:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_7__lib_systemVariables__["j" /* PermissionTypes */].InstitutionsManage)>=0}};}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(Object.assign({},__WEBPACK_IMPORTED_MODULE_4__redux_actions_SuggestionsActions__,__WEBPACK_IMPORTED_MODULE_5__redux_actions_SidebarFilterActions__),dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(SidebarFilter));

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_AutocompleteMultiInput__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedPhoneInput__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_number_format__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_number_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_RadioGroup__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_util_Toggle__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_shared_AddressAutocomplete__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SuggestionsTable__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__applicationsCommon_RecipientReferencesTable__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__applicationsCommon_ApplicantPledgesTable__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_throttle_debounce__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_throttle_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_throttle_debounce__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateRecipient=function(_React$Component){_inherits(CreateRecipient,_React$Component);function CreateRecipient(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,CreateRecipient);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CreateRecipient.__proto__||Object.getPrototypeOf(CreateRecipient)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(name,value){_this.setState(_defineProperty({},name,value));},_this.suggestionSelected=function(suggestion){if(_this.props.onSelectRecipientSuggestion){//For usage with Create-Application
_this.props.onSelectRecipientSuggestion(suggestion.applicantId);}else{_this.props.onChange('recipient',Object.assign({},_this.props.recipient,{isIsraeli:suggestion.isIsraeli,id:suggestion.applicantId,displayName:suggestion.name,addressDisplay:suggestion.address,phoneNumber:suggestion.phoneNumber.length?suggestion.phoneNumber[0]:'',secondPhoneNumber:suggestion.phoneNumber.length>1?suggestion.phoneNumber[1]:'',address:suggestion.address,incomplete:suggestion.incomplete}));}_this.props.suggestions.clearSuggestions();},_this.validateEmail=function(name,value){var isValid=Object(__WEBPACK_IMPORTED_MODULE_13__lib_utils__["x" /* isValidEmail */])(value);_this.props.updateDataErrors(name,!isValid);return isValid;},_this.validateLength=function(name,length,value){var isValid=Object(__WEBPACK_IMPORTED_MODULE_13__lib_utils__["E" /* validateFieldLength */])(length,value);_this.props.updateDataErrors(name,!isValid);return isValid;},_this.updateApplicantType=function(name,value){if(value===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Organization){_this.props.onChange('recipient',Object.assign({},_this.props.recipient,_defineProperty({personTitleId:null,firstName:'',lastName:'',tags:[]},name,value)));}else if(value===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Individual){_this.props.onChange('recipient',Object.assign({},_this.props.recipient,_defineProperty({teudatZehut:'',organization:{institutionTitleId:null,name:'',registered:true,taxId:''},tags:[]},name,value)));}_this.props.suggestions.clearSuggestions();},_this.updateIsIsraeli=function(name,value){if(value){_this.props.onChange('recipient',Object.assign({},_this.props.recipient,_defineProperty({personTitleId:null,address:{},previousAddress:{},organization:Object.assign({},_this.props.recipient.organization,{institutionTitleId:null})},name,value)));}else{_this.props.onChange('recipient',Object.assign({},_this.props.recipient,_defineProperty({personTitleId:null,teudatZehut:'',bankRoutingNumber:'',bankBranchNumber:'',bankAccountNumber:'',bankAccountHolder:'',achRoutingNumber:'',achAccountNumber:'',achAccountType:'',address:{},previousAddress:{},organization:Object.assign({},_this.props.recipient.organization,{institutionTitleId:null})},name,value)));}//update suggestions
if((_this.props.recipient.applicantType===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Individual?_this.props.recipient.firstName&&_this.props.recipient.lastName:_this.props.recipient.organization.name)&&_this.props.suggestions.getSuggestions){_this.props.suggestions.getSuggestions(_this.props.recipient.applicantType===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Individual?_this.props.recipient.firstName+' '+_this.props.recipient.lastName:_this.props.recipient.organization.name,{address:_this.props.recipient.address,phoneNumber:_this.props.recipient.phoneNumber,email:_this.props.recipient.email,applicantType:_this.props.recipient.applicantType,departments:value?__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].IL:__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].US});}else{_this.props.suggestions.clearSuggestions();}},_this.updateRecipient=function(name,value){if(name==="firstName"||name==="lastName"||name==="reportName")value=Object(__WEBPACK_IMPORTED_MODULE_13__lib_utils__["C" /* toTitleCase */])(value);var recipient=Object.assign({},_this.props.recipient,_defineProperty({},name,value));_this.props.onChange('recipient',recipient);var recipientInfo={address:_this.props.recipient.address,phoneNumber:_this.props.recipient.phoneNumber,email:_this.props.recipient.email,applicantType:_this.props.recipient.applicantType};var recipName=recipient.applicantType===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Individual?recipient.firstName+' '+recipient.lastName:recipient.organization.name;var hasName=recipient.applicantType===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Individual?recipient.firstName&&recipient.lastName:recipient.organization.name;switch(name){case"firstName":if(value&&_this.props.recipient.lastName)_this.getRecipientSuggestions(value+' '+_this.props.recipient.lastName,recipientInfo);else _this.props.suggestions.clearSuggestions();return;case"lastName":if(value&&_this.props.recipient.firstName)_this.getRecipientSuggestions(_this.props.recipient.firstName+' '+value,recipientInfo);else _this.props.suggestions.clearSuggestions();return;case"email":if(hasName)_this.getRecipientSuggestions(recipName,Object.assign({},recipientInfo,_defineProperty({},name,value)));return;case"phoneNumber":if(hasName)_this.getRecipientSuggestions(recipName,Object.assign({},recipientInfo,_defineProperty({},name,value)));return;case"address":if(hasName)_this.getRecipientSuggestions(recipName,Object.assign({},recipientInfo,_defineProperty({},name,value)));return;default:return;}},_this.updateOrganization=function(name,val){if(name==="name")val=Object(__WEBPACK_IMPORTED_MODULE_13__lib_utils__["C" /* toTitleCase */])(val);_this.props.onChange('recipient',Object.assign({},_this.props.recipient,{organization:Object.assign({},_this.props.recipient.organization,_defineProperty({},name,val))}));if(name==='name'&&val)_this.getRecipientSuggestions(val,{address:_this.props.recipient.address,phoneNumber:_this.props.recipient.phoneNumber,email:_this.props.recipient.email,applicantType:__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Organization});else if(name==='name'&&!val)_this.props.suggestions.clearSuggestions();},_this.updateNotRegistered=function(e){var recipient=Object.assign({},_this.props.recipient);recipient.organization[e.target.name]=!e.target.checked;if(e.target.checked)recipient.organization.taxId='';_this.props.onChange('recipient',recipient);},_this.getRecipientSuggestions=Object(__WEBPACK_IMPORTED_MODULE_16_throttle_debounce__["debounce"])(500,function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(name,otherInfo){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!_this.props.suggestions.getSuggestions){_context.next=3;break;}_context.next=3;return _this.props.suggestions.getSuggestions(name,Object.assign({},otherInfo,{departments:_this.props.recipient.isIsraeli?[__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].IL]:[__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].US]}));case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x,_x2){return _ref2.apply(this,arguments);};}()),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CreateRecipient,[{key:'render',value:function render(){var _this3=this;var _props=this.props,recipient=_props.recipient,campaignTagId=_props.campaignTagId,allowIncomplete=_props.allowIncomplete,hideRecipientTitle=_props.hideRecipientTitle,showPrevAddress=_props.showPrevAddress,showSecondPhone=_props.showSecondPhone,showEmail=_props.showEmail,setTrustedPayee=_props.setTrustedPayee,dataErrors=_props.dataErrors,submitAttempted=_props.submitAttempted,suggestions=_props.suggestions,tags=_props.tags,departments=_props.departments,isManualPayment=_props.isManualPayment;var _ref3=recipient.bankAccounts.filter(function(acct){return acct.active;})[0]||{},bankRoutingNumber=_ref3.bankRoutingNumber,bankBranchNumber=_ref3.bankBranchNumber,bankAccountNumber=_ref3.bankAccountNumber,bankAccountHolder=_ref3.bankAccountHolder,achRoutingNumber=_ref3.achRoutingNumber,achAccountNumber=_ref3.achAccountNumber,achAccountType=_ref3.achAccountType;var inactiveBankAccounts=recipient.bankAccounts.filter(function(acct){return!acct.active;});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipient-info'},!hideRecipientTitle&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',{className:'section-header'},'Recipient Info'),!!recipient.id&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'recipient-name'},recipient.displayName,recipient.incomplete&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'tag incomplete'},'Incomplete')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipient-details'},recipient.reportName&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text'},'Report Name: '),recipient.reportName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center'},recipient.phoneNumber&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:{marginRight:"8px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-telephone-outline accent-text2'}),recipient.phoneNumber),recipient.secondPhoneNumber&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-telephone-outline accent-text2'}),recipient.secondPhoneNumber)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center'},recipient.addressDisplay&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-home-outline accent-text2'}),recipient.addressDisplay),recipient.trustedPayee&&recipient.trustedPayee.referenceId&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons ion-ios-person-outline accent-text2'}),'Trusted Payee: ',recipient.trustedPayee.displayName)),recipient.bankAccounts.length>0&&recipient.isIsraeli&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Account Information:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'application-details-account-info flex-center'},bankRoutingNumber&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons icon-wallet accent-text2'}),'Bank Routing #: ',bankRoutingNumber),bankBranchNumber&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons icon-pie-chart accent-text2'}),'Branch #: ',bankBranchNumber),bankAccountNumber&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons icon-calculator accent-text2'}),'Account #: ',bankAccountNumber),bankAccountHolder&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons accent-text2'},'person_outline'),'Account Holder: ',bankAccountHolder),inactiveBankAccounts.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'link-text small-text',onClick:function onClick(){return _this3.setState({showInactiveBankAccounts:true});}},'See Inactive Accounts'))),recipient.bankAccounts.length>0&&!recipient.isIsraeli&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'ACH Account Information:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'application-details-account-info flex-center'},achRoutingNumber&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons icon-wallet accent-text2'}),'ACH Routing #: ',achRoutingNumber),achAccountNumber&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons icon-pie-chart accent-text2'}),'ACH Account #: ',achAccountNumber),achAccountType&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons accent-text2'},'person_outline'),'Account Type: ',achAccountType),inactiveBankAccounts.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'link-text small-text',onClick:function onClick(){return _this3.setState({showInactiveBankAccounts:true});}},'See Inactive Accounts'))),recipient.solicitors.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'mt-16'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Solicitors:'),recipient.solicitors.map(function(reference){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:reference.referenceId,className:'application-details-personal-info flex-center'},reference.displayName&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons ion-ios-person-outline accent-text2'}),reference.displayName),reference.relationship&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons ion-ios-information-outline accent-text2'}),reference.relationship),(reference.phoneNumber||reference.secondPhoneNumber)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons ion-ios-telephone-outline accent-text2'}),[reference.phoneNumber,reference.secondPhoneNumber].filter(function(p){return p;}).join(' | ')),reference.email&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons ion-ios-email-outline accent-text2'}),reference.email),reference.addressDisplay&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons ion-ios-location-outline accent-text2'}),reference.addressDisplay));})))),!recipient.id&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,tags.recipientTypes.length>1&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_RadioGroup__["a" /* default */],{options:tags.recipientTypes,title:'Recipient Type',name:'applicantType',value:recipient.applicantType,onChange:this.updateApplicantType}),recipient.applicantType===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Individual&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-select'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Title'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Select__["a" /* default */],{tabIndex:100,clearable:true,options:recipient.isIsraeli?tags.israelPersonTitles:tags.usPersonTitles,label:'Title',name:'personTitleId',value:recipient.personTitleId||'',onChange:function onChange(e){return _this3.updateRecipient(e.target.name,e.target.value);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',tabIndex:110}),label:'First Name',name:'firstName',value:recipient.firstName,onChange:this.updateRecipient,required:!isManualPayment&&recipient.applicantType==="Individual",showRequiredError:submitAttempted}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',tabIndex:120}),label:'Last Name',name:'lastName',value:recipient.lastName,onChange:this.updateRecipient,required:recipient.applicantType===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Individual,showRequiredError:submitAttempted}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Report Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',value:recipient.reportName,tabIndex:130,onChange:function onChange(e){return _this3.updateRecipient('reportName',e.target.value);}})),departments.indexOf(__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].US)>=0&&departments.indexOf(__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].IL)>=0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_Toggle__["a" /* default */],{name:'isIsraeli',value:recipient.isIsraeli,onChange:this.updateIsIsraeli}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'small-text middle'},'Israeli'))),recipient.applicantType===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Organization&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-select'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Institution Title'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Select__["a" /* default */],{tabIndex:100,clearable:true,options:recipient.isIsraeli?tags.israelInstitutionTitles:tags.usInstitutionTitles,label:'Institution Title',name:'institutionTitleId',value:recipient.organization.institutionTitleId||'',onChange:function onChange(e){return _this3.updateOrganization(e.target.name,e.target.value);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',tabIndex:100}),label:'Name',name:'name',value:recipient.organization.name,onChange:this.updateOrganization,required:recipient.applicantType===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Organization,showRequiredError:submitAttempted}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Report Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',value:recipient.reportName,tabIndex:130,onChange:function onChange(e){return _this3.updateRecipient('reportName',e.target.value);}})),departments.indexOf(__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].US)>=0&&departments.indexOf(__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].IL)>=0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_Toggle__["a" /* default */],{name:'isIsraeli',value:recipient.isIsraeli,onChange:this.updateIsIsraeli}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'small-text middle'},'Israeli'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',tabIndex:130}),label:'Email',name:'email',value:recipient.email,onChange:this.updateRecipient,required:false,showRequiredError:false,validated:true,showValidationError:true,validate:this.validateEmail.bind(this,'email'),errorMessage:'Invalid Email Address'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_number_format___default.a,{placeholder:'#########',format:'#########',onValueChange:function onValueChange(values){return _this3.updateOrganization('taxId',values.value);},disabled:!recipient.organization.registered,tabIndex:140}),label:'Tax ID',name:'taxId',value:recipient.organization.taxId,errorMessage:'Invalid Tax ID',validated:true,showValidationError:true,validate:this.validateLength.bind(this,'taxId',9),required:!isManualPayment,showRequiredError:submitAttempted&&recipient.applicantType===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Organization&&recipient.organization.registered}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'check',className:'custom-check',name:'registered',checked:!recipient.organization.registered,onChange:this.updateNotRegistered}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'check'},'Not Registered'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row wrap-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_shared_AddressAutocomplete__["a" /* default */],{tabIndex:150,validateAddress:this.props.hasOwnProperty('validateAddress')?this.props.validateAddress:undefined,isIsraeli:recipient.isIsraeli,showRequiredError:submitAttempted,required:!isManualPayment,address:recipient.address,updateAddress:this.updateRecipient.bind(this,'address'),updateError:this.props.updateDataErrors.bind(this,'recipientAddress'),addAddressLabel:!showPrevAddress?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:function onClick(){return _this3.props.onChange('showPrevAddress',true);},className:'link-text small-text'},'Add Previous Address'):null})),showPrevAddress&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row wrap-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_shared_AddressAutocomplete__["a" /* default */],{tabIndex:190,title:'Previous Address',isIsraeli:recipient.isIsraeli,showRequiredError:submitAttempted,required:false,address:recipient.previousAddress,updateAddress:this.updateRecipient.bind(this,'previousAddress'),updateError:this.props.updateDataErrors.bind(this,'recipientPreviousAddress')})),recipient.isIsraeli&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_number_format___default.a,{placeholder:'##',format:'##',onValueChange:function onValueChange(values){return _this3.updateRecipient('bankRoutingNumber',values.value);},tabIndex:220}),label:'Bank Number',name:'bankRoutingNumber',value:recipient.bankRoutingNumber,required:!isManualPayment&&recipient.isIsraeli&&!recipient.trustedPayee,showRequiredError:submitAttempted,errorMessage:'Invalid Bank Number',validated:true,showValidationError:true,validate:this.validateLength.bind(this,'bankRoutingNumber',2)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_number_format___default.a,{placeholder:'###',format:'###',onValueChange:function onValueChange(values){return _this3.updateRecipient('bankBranchNumber',values.value);},tabIndex:230}),label:'Branch Number',name:'bankBranchNumber',value:recipient.bankBranchNumber,required:!isManualPayment&&recipient.isIsraeli&&!recipient.trustedPayee,showRequiredError:submitAttempted,errorMessage:'Invalid Branch Number',validated:true,showValidationError:true,validate:this.validateLength.bind(this,'bankBranchNumber',3)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_number_format___default.a,{placeholder:'###############',format:'###############',onValueChange:function onValueChange(values){return _this3.updateRecipient('bankAccountNumber',values.value);},tabIndex:240}),label:'Account Number',name:'bankAccountNumber',value:recipient.bankAccountNumber,required:!isManualPayment&&recipient.isIsraeli&&!recipient.trustedPayee,showRequiredError:submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Account Holder'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',name:'bankAccountHolder',value:recipient.bankAccountHolder||'',onChange:function onChange(e){return _this3.updateRecipient(e.target.name,e.target.value);}}))),!recipient.isIsraeli&&recipient.applicantType===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Organization&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_number_format___default.a,{placeholder:'#########',format:'#########',onValueChange:function onValueChange(values){return _this3.updateRecipient('achRoutingNumber',values.value);},tabIndex:220}),label:'ACH Routing Number',name:'achRoutingNumber',value:recipient.achRoutingNumber,showRequiredError:submitAttempted,errorMessage:'Invalid ACH Routing Number',validated:true,showValidationError:true,validate:this.validateLength.bind(this,'achRoutingNumber',9)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_number_format___default.a,{placeholder:'##################',format:'##################',onValueChange:function onValueChange(values){return _this3.updateRecipient('achAccountNumber',values.value);},tabIndex:230}),label:'ACH Account Number',name:'achAccountNumber',value:recipient.achAccountNumber,showRequiredError:submitAttempted,errorMessage:'Invalid ACH Account Number',validated:true,showValidationError:true,validate:this.validateLength.bind(this,'achAccountNumber',17)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Account Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Select__["a" /* default */],{tabIndex:430,options:[{key:'checking',value:'checking'},{key:'savings',value:'savings'}]}),label:'',name:'achAccountType',value:recipient.achAccountType||'',onChange:function onChange(e){return _this3.updateRecipient(e.target.name,e.target.value);}}))),suggestions.suggestions.length>0&&(recipient.applicantType===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Individual?recipient.firstName&&recipient.lastName:recipient.organization.name)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SuggestionsTable__["a" /* default */],{suggestions:suggestions.suggestions,suggestionSelected:this.suggestionSelected,allowIncomplete:allowIncomplete}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row wrap-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third modal-column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedPhoneInput__["a" /* default */],{tabIndex:250,span1:!showSecondPhone&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:function onClick(){return _this3.props.onChange('showSecondPhone',true);},className:'link-text small-text'},'Add Phone'),span2:!showEmail&&recipient.applicantType===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Individual&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:function onClick(){return _this3.props.onChange('showEmail',true);},className:'link-text small-text'},'Add Email'),phoneNumber:recipient.phoneNumber,phoneType:recipient.phoneType||(recipient.isIsraeli?__WEBPACK_IMPORTED_MODULE_15__lib_constants__["g" /* PhoneNumberTypes */].Israeli:__WEBPACK_IMPORTED_MODULE_15__lib_constants__["g" /* PhoneNumberTypes */].American),phoneNumberName:'phoneNumber',phoneTypeName:'phoneType',onChange:this.updateRecipient,error:dataErrors.phoneNumber,updateError:this.props.updateDataErrors,errorName:'phoneNumber'})),showSecondPhone&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedPhoneInput__["a" /* default */],{tabIndex:260,label:'Second Phone',phoneNumber:recipient.secondPhoneNumber,phoneType:recipient.secondPhoneType||(recipient.isIsraeli?__WEBPACK_IMPORTED_MODULE_15__lib_constants__["g" /* PhoneNumberTypes */].Israeli:__WEBPACK_IMPORTED_MODULE_15__lib_constants__["g" /* PhoneNumberTypes */].American),phoneNumberName:'secondPhoneNumber',phoneTypeName:'secondPhoneType',onChange:this.updateRecipient,error:dataErrors.secondPhoneNumber,updateError:this.props.updateDataErrors,errorName:'secondPhoneNumber'})),showEmail&&recipient.applicantType===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Individual&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',tabIndex:270}),label:'Email',name:'email',value:recipient.email,onChange:this.updateRecipient,required:false,showRequiredError:false,validated:true,showValidationError:true,validate:this.validateEmail.bind(this,'email'),errorMessage:'Invalid Email Address'}),recipient.isIsraeli&&recipient.applicantType===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Individual&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_number_format___default.a,{placeholder:'#########',format:'#########',tabIndex:280,onValueChange:function onValueChange(values){return _this3.updateRecipient('teudatZehut',values.value);}}),label:'Teudat Zehut',name:'teudatZehut',value:recipient.teudatZehut,required:!isManualPayment&&recipient.isIsraeli,showRequiredError:submitAttempted}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row categories-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_AutocompleteMultiInput__["a" /* default */],{tabIndex:290,showList:true,options:recipient.applicantType===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Individual?tags.categories.individualTags:campaignTagId?tags.categories.organizationTags.filter(function(tag){return tag.key.toString()!==campaignTagId;}):tags.categories.organizationTags,selection:recipient.tags,update:this.updateRecipient}),label:'Categories',name:'tags',value:recipient.tags.length,required:!isManualPayment,showRequiredError:submitAttempted}),campaignTagId&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chip reverse-chip'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,this.props.tags.categories.organizationTags[tags.categories.organizationTags.map(function(t){return t.key.toString();}).indexOf(campaignTagId)].value))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Note'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{value:recipient.note,tabIndex:300,onChange:function onChange(e){return _this3.updateRecipient('note',e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row references-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__applicationsCommon_RecipientReferencesTable__["a" /* default */],{tabIndex:310,references:recipient.references,solicitors:recipient.solicitors,roshYeshivas:recipient.roshYeshivas,trustedPayee:recipient.trustedPayee,updateRecipient:this.updateRecipient,updateRecipientProps:function updateRecipientProps(props){return _this3.props.onChange('recipient',Object.assign({},_this3.props.recipient,props));},setTrustedPayee:setTrustedPayee,toggleSetTrustedPayee:this.props.onChange,submitAttempted:submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row references-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__applicationsCommon_ApplicantPledgesTable__["a" /* default */],{tabIndex:315,applicantPledges:recipient.applicantPledges,updateRecipient:this.updateRecipient,updateRecipientProps:function updateRecipientProps(props){return _this3.props.onChange('recipient',Object.assign({},_this3.props.recipient,props));},submitAttempted:submitAttempted}))));}}]);return CreateRecipient;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CreateRecipient);

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (props) {
  var attributes = {};

  allowedAttributes.forEach(function (allowedAttribute) {
    if (props[allowedAttribute]) {
      attributes[allowedAttribute] = props[allowedAttribute];
    }
  });

  return attributes;
};

/**
 * Attributes allowed on input elements
 */
var allowedAttributes = ['autoCapitalize', 'autoComplete', 'autoCorrect', 'autoFocus', 'disabled', 'form', 'formAction', 'formEncType', 'formMethod', 'formNoValidate', 'formTarget', 'height', 'id', 'inputMode', 'maxLength', 'name', 'onClick', 'onContextMenu', 'onCopy', 'onCut', 'onDoubleClick', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', 'onPaste', 'pattern', 'placeholder', 'readOnly', 'required', 'size', 'spellCheck', 'tabIndex', 'title', 'aria-atomic', 'aria-busy', 'aria-controls', 'aria-current', 'aria-describedby', 'aria-details', 'aria-disabled', 'aria-dropeffect', 'aria-errormessage', 'aria-flowto', 'aria-grabbed', 'aria-haspopup', 'aria-hidden', 'aria-invalid', 'aria-keyshortcuts', 'aria-label', 'aria-labelledby', 'aria-live', 'aria-owns', 'aria-relevant', 'aria-roledescription', 'aria-activedescendant', 'aria-autocomplete', 'aria-multiline', 'aria-placeholder', 'aria-readonly', 'aria-required'];

/**
 * Filter the properties for only allowed input properties
 * @param  {Object} props The properties to filter
 * @return {Object} The filtered, allowed properties
 */

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule shallowCompare
 */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/**
 * Does a shallow comparison for props and state.
 * See ReactComponentWithPureRenderMixin
 * See also https://facebook.github.io/react/docs/shallow-compare.html
 */
function shallowCompare(instance, nextProps, nextState) {
  return (
    !shallowEqual(instance.props, nextProps) ||
    !shallowEqual(instance.state, nextState)
  );
}

module.exports = shallowCompare;


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddReferenceModal__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Toggle__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReferencesTable=function ReferencesTable(_ref){var references=_ref.references,removeReference=_ref.removeReference,type=_ref.type;return references&&references.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details-card-rows'},references.map(function(reference){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex',key:reference.referenceId},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex'},reference.displayName&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons ion-ios-person-outline accent-text2'}),reference.displayName),reference.relationship&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons ion-ios-information-outline accent-text2'}),reference.relationship),(reference.phoneNumber||reference.secondPhoneNumber)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons ion-ios-telephone-outline accent-text2'}),[reference.phoneNumber,reference.secondPhoneNumber].filter(function(p){return p;}).join(' | ')),reference.email&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons ion-ios-email-outline accent-text2'}),reference.email),reference.addressDisplay&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons ion-ios-location-outline accent-text2'}),reference.addressDisplay)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex'},!reference.isUsedAsPayee&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:function onClick(){return removeReference(reference.referenceId,type);},className:'link-text'},'Remove')));})):null;};var RecipientReferencesTable=function(_NavigationComponent){_inherits(RecipientReferencesTable,_NavigationComponent);function RecipientReferencesTable(props){var _this2=this;_classCallCheck(this,RecipientReferencesTable);var _this=_possibleConstructorReturn(this,(RecipientReferencesTable.__proto__||Object.getPrototypeOf(RecipientReferencesTable)).call(this,props));_this.ReferenceTypes={Reference:{type:"Reference",prop:"references"},Solicitor:{type:"Solicitor",prop:"solicitors"},RoshYeshiva:{type:"Rosh Yeshiva",prop:"roshYeshivas"}};_this.addReference=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(reference){var referencesProp,references;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:referencesProp=_this.state.newReferenceType.prop;references=[].concat(_toConsumableArray(_this.props[referencesProp]),[reference]);_this.props.updateRecipient(referencesProp,references);case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();_this.removeReference=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(referenceId,referenceType){var referencesProp,recipientUpdate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:referencesProp=referenceType.prop;recipientUpdate=_defineProperty({},referencesProp,_this.props[referencesProp].filter(function(r){return r.referenceId!==referenceId;}));if(referenceType===_this.ReferenceTypes.Reference){if(_this.props.trustedPayee&&_this.props.trustedPayee.referenceId===referenceId)recipientUpdate.trustedPayee=null;if(_this.props.setTrustedPayee&&!recipientUpdate.references.filter(function(ref){return ref.isPayable;}).length)_this.props.toggleSetTrustedPayee("setTrustedPayee",false);}_this.props.updateRecipientProps(recipientUpdate);case 4:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2,_x3){return _ref3.apply(this,arguments);};}();_this.toggleSetTrustedPayee=function(name,value){_this.props.toggleSetTrustedPayee(name,value);if(!value)_this.selectTrustedPayee('trustedPayee',null);};_this.selectTrustedPayee=function(name,value){var trustedPayee=!value?null:_this.props.references[_this.props.references.map(function(ref){return ref.referenceId.toString();}).indexOf(value.toString())]||null;_this.props.updateRecipient(name,trustedPayee);};_this.state={newReferenceType:_this.ReferenceTypes.Reference,showModals:{addReferenceModal:false}};return _this;}_createClass(RecipientReferencesTable,[{key:'render',value:function render(){var _this3=this;var _props=this.props,className=_props.className,references=_props.references,solicitors=_props.solicitors,roshYeshivas=_props.roshYeshivas,trustedPayee=_props.trustedPayee,setTrustedPayee=_props.setTrustedPayee,submitAttempted=_props.submitAttempted;var _state=this.state,newReferenceType=_state.newReferenceType,showModals=_state.showModals;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:className},'References',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'link-text',onClick:function onClick(){_this3.setState({newReferenceType:_this3.ReferenceTypes.Reference},function(){return _this3.toggleModal("addReferenceModal");});}},'Add New')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ReferencesTable,{references:references,removeReference:this.removeReference,type:this.ReferenceTypes.Reference}),references&&references.filter(function(ref){return ref.isPayable;}).length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center trusted-payee'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Toggle__["a" /* default */],{id:'setTrustedPayee',disabled:trustedPayee?trustedPayee.isUsedAsPayee:false,name:'setTrustedPayee',value:setTrustedPayee,onChange:this.toggleSetTrustedPayee}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'small-text middle'},'Set Trusted Payee'),setTrustedPayee&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Select__["a" /* default */],{tabIndex:this.props.tabIndex,disabled:trustedPayee?trustedPayee.isUsedAsPayee:false,options:references.filter(function(ref){return ref.isPayable;}).map(function(ref){return{key:ref.referenceId,value:ref.displayName};})}),name:'trustedPayee',value:trustedPayee?trustedPayee.referenceId:null,onChange:this.selectTrustedPayee,required:setTrustedPayee,showRequiredError:submitAttempted}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:"32px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:className},'Solicitors',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'link-text',onClick:function onClick(){_this3.setState({newReferenceType:_this3.ReferenceTypes.Solicitor},function(){return _this3.toggleModal("addReferenceModal");});}},'Add New')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ReferencesTable,{references:solicitors,removeReference:this.removeReference,type:this.ReferenceTypes.Solicitor})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:"32px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:className},'Rosh Yeshivas',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'link-text',onClick:function onClick(){_this3.setState({newReferenceType:_this3.ReferenceTypes.RoshYeshiva},function(){return _this3.toggleModal("addReferenceModal");});}},'Add New')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ReferencesTable,{references:roshYeshivas,removeReference:this.removeReference,type:this.ReferenceTypes.RoshYeshiva})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AddReferenceModal__["a" /* default */],{show:showModals.addReferenceModal,close:function close(){return _this3.toggleModal("addReferenceModal");},referenceType:newReferenceType.type,filterReferences:function filterReferences(ref){return[newReferenceType.prop].map(function(r){return r.referenceId;}).indexOf(ref.referenceId)<0;},addReference:this.addReference}));}}]);return RecipientReferencesTable;}(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (RecipientReferencesTable);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PledgeRowDisplay__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PledgeRowEdit__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PledgeTableHeader__ = __webpack_require__(489);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Constants
var NO_PLEDGE_DISPLAY="-";var INITIAL_FORM_STATE={pledgeUpdate:{pledgeDate:"",pledgeAmount:"",payOutSchedule:""},editPledgeIndex:null,newPledge:false,submitAttempted:false};var ApplicantPledgesTable=function(_NavigationComponent){_inherits(ApplicantPledgesTable,_NavigationComponent);function ApplicantPledgesTable(props){_classCallCheck(this,ApplicantPledgesTable);var _this=_possibleConstructorReturn(this,(ApplicantPledgesTable.__proto__||Object.getPrototypeOf(ApplicantPledgesTable)).call(this,props));_this.displayLocalDate=function(dateString){if(!dateString)return"";if(/^\d{4}-\d{2}-\d{2}$/.test(dateString)){var _dateString$split$map=dateString.split("-").map(Number),_dateString$split$map2=_slicedToArray(_dateString$split$map,3),year=_dateString$split$map2[0],month=_dateString$split$map2[1],day=_dateString$split$map2[2];return new Date(year,month-1,day).toLocaleDateString();}return Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils__["k" /* formatDate */])(dateString);};_this.toNumber=function(value){return value===""||value===null||value===undefined?0:Number(value)||0;};_this.resetForm=function(){return _this.setState(INITIAL_FORM_STATE);};_this.startEditPledge=function(index,pledge){_this.setState({editPledgeIndex:index,pledgeUpdate:{pledgeDate:pledge.pledgeDate||"",pledgeAmount:pledge.pledgeAmount||"",payOutSchedule:pledge.payOutSchedule||""},submitAttempted:false});};_this.addNewPledge=function(){_this.setState({newPledge:true,pledgeUpdate:Object.assign({},INITIAL_FORM_STATE.pledgeUpdate),submitAttempted:false});};_this.updateFormField=function(fieldName,fieldValue){_this.setState({pledgeUpdate:Object.assign({},_this.state.pledgeUpdate,_defineProperty({},fieldName,fieldValue))});};_this.disableSubmit=function(){var pledgeUpdate=_this.state.pledgeUpdate;return!pledgeUpdate.pledgeDate||!pledgeUpdate.pledgeAmount;};_this.submitPledge=function(){var isNewPledge=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;_this.setState({submitAttempted:true});if(_this.disableSubmit())return;var pledges=[].concat(_toConsumableArray(_this.props.applicantPledges));if(isNewPledge){pledges.push(Object.assign({},_this.state.pledgeUpdate,{amountPaid:0}));}else{var existing=pledges[_this.state.editPledgeIndex];pledges[_this.state.editPledgeIndex]=Object.assign({},existing,_this.state.pledgeUpdate,{amountPaid:existing.amountPaid||0});}_this.props.updateRecipient("applicantPledges",pledges);_this.resetForm();};_this.state=Object.assign({showModals:{}},INITIAL_FORM_STATE);return _this;}_createClass(ApplicantPledgesTable,[{key:"render",value:function render(){var _this2=this;var _props=this.props,className=_props.className,_props$applicantPledg=_props.applicantPledges,applicantPledges=_props$applicantPledg===undefined?[]:_props$applicantPledg;var _state=this.state,pledgeUpdate=_state.pledgeUpdate,newPledge=_state.newPledge,editPledgeIndex=_state.editPledgeIndex;var addingOrEditing=newPledge||editPledgeIndex!==null;var disableSubmit=this.disableSubmit();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"full-width bank-accounts-edit pledges-edit",style:{marginTop:"18px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:className},"Pledges "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"link-text "+(addingOrEditing?"disabled":""),style:{marginLeft:"8px",padding:0,position:"relative",zIndex:10},onClick:!addingOrEditing?this.addNewPledge:null},"Add New"),(applicantPledges.length>0||newPledge)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"pledges-table-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table pledges-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("colgroup",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("col",{className:"pledges-col-id"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("col",{className:"pledges-col-date"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("col",{className:"pledges-col-amount"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("col",{className:"pledges-col-amount-paid"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("col",{className:"pledges-col-outstanding"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("col",{className:"pledges-col-schedule"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("col",{className:"pledges-col-actions"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__PledgeTableHeader__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,applicantPledges.map(function(ap,index){var outstandingAmount=(ap.pledgeAmount||0)-(ap.amountPaid||0);if(editPledgeIndex===index){var editingOutstanding=_this2.toNumber(pledgeUpdate.pledgeAmount)-_this2.toNumber(ap.amountPaid);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PledgeRowEdit__["a" /* default */],{key:ap.applicantPledgeId||index,pledgeId:ap.applicantPledgeId?"#"+ap.applicantPledgeId:NO_PLEDGE_DISPLAY,pledgeDate:pledgeUpdate.pledgeDate,pledgeAmount:pledgeUpdate.pledgeAmount,payOutSchedule:pledgeUpdate.payOutSchedule,amountPaid:ap.amountPaid||0,outstandingAmount:editingOutstanding,onFieldChange:_this2.updateFormField,onSubmit:function onSubmit(){return _this2.submitPledge(false);},onCancel:_this2.resetForm,disableSubmit:disableSubmit,showValidationErrors:_this2.state.submitAttempted});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PledgeRowDisplay__["a" /* default */],{key:ap.applicantPledgeId||index,pledgeId:ap.applicantPledgeId?"#"+ap.applicantPledgeId:NO_PLEDGE_DISPLAY,pledgeDate:_this2.displayLocalDate(ap.pledgeDate),pledgeAmount:ap.pledgeAmount,amountPaid:ap.amountPaid||0,outstandingAmount:outstandingAmount,payOutSchedule:ap.payOutSchedule,onEdit:function onEdit(){return _this2.startEditPledge(index,ap);},disableEdit:addingOrEditing});}),newPledge&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PledgeRowEdit__["a" /* default */],{key:"new-pledge",pledgeId:NO_PLEDGE_DISPLAY,pledgeDate:pledgeUpdate.pledgeDate,pledgeAmount:pledgeUpdate.pledgeAmount,payOutSchedule:pledgeUpdate.payOutSchedule,amountPaid:0,outstandingAmount:this.toNumber(pledgeUpdate.pledgeAmount),onFieldChange:this.updateFormField,onSubmit:function onSubmit(){return _this2.submitPledge(true);},onCancel:this.resetForm,disableSubmit:disableSubmit,showValidationErrors:this.state.submitAttempted}))))));}}]);return ApplicantPledgesTable;}(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ApplicantPledgesTable);ApplicantPledgesTable.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,applicantPledges:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({applicantPledgeId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,pledgeDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,pledgeAmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),amountPaid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),payOutSchedule:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string})),updateRecipient:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};ApplicantPledgesTable.defaultProps={className:"",applicantPledges:[]};

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils__ = __webpack_require__(2);
var CurrencyCell=function CurrencyCell(_ref){var value=_ref.value,_ref$align=_ref.align,align=_ref$align===undefined?"text-right":_ref$align;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:align},Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["j" /* formatCurrency */])(value));};CurrencyCell.propTypes={value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,align:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};CurrencyCell.defaultProps={align:"text-right"};/* harmony default export */ __webpack_exports__["a"] = (CurrencyCell);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles__ = __webpack_require__(494);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint prefer-template: 0 */






var Dropzone = function (_React$Component) {
  _inherits(Dropzone, _React$Component);

  function Dropzone(props, context) {
    _classCallCheck(this, Dropzone);

    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));

    _this.renderChildren = function (children, isDragActive, isDragAccept, isDragReject) {
      if (typeof children === 'function') {
        return children(_extends({}, _this.state, {
          isDragActive: isDragActive,
          isDragAccept: isDragAccept,
          isDragReject: isDragReject
        }));
      }
      return children;
    };

    _this.composeHandlers = _this.composeHandlers.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
    _this.onDragEnter = _this.onDragEnter.bind(_this);
    _this.onDragLeave = _this.onDragLeave.bind(_this);
    _this.onDragOver = _this.onDragOver.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.onDrop = _this.onDrop.bind(_this);
    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
    _this.onInputElementClick = _this.onInputElementClick.bind(_this);

    _this.setRef = _this.setRef.bind(_this);
    _this.setRefs = _this.setRefs.bind(_this);

    _this.isFileDialogActive = false;

    _this.state = {
      draggedFiles: [],
      acceptedFiles: [],
      rejectedFiles: []
    };
    return _this;
  }

  _createClass(Dropzone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      this.dragTargets = [];

      if (preventDropOnDocument) {
        document.addEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["e" /* onDocumentDragOver */], false);
        document.addEventListener('drop', this.onDocumentDrop, false);
      }
      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
      // Tried implementing addEventListener, but didn't work out
      document.body.onfocus = this.onFileDialogCancel;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      if (preventDropOnDocument) {
        document.removeEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["e" /* onDocumentDragOver */]);
        document.removeEventListener('drop', this.onDocumentDrop);
      }
      if (this.fileInputEl != null) {
        this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
      }
      // Can be replaced with removeEventListener, if addEventListener works
      if (document != null) {
        document.body.onfocus = null;
      }
    }
  }, {
    key: 'composeHandlers',
    value: function composeHandlers(handler) {
      if (this.props.disabled) {
        return null;
      }

      return handler;
    }
  }, {
    key: 'onDocumentDrop',
    value: function onDocumentDrop(evt) {
      if (this.node && this.node.contains(evt.target)) {
        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
      }
      evt.preventDefault();
      this.dragTargets = [];
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(evt) {
      if (this.props.onDragStart) {
        this.props.onDragStart.call(this, evt);
      }
    }
  }, {
    key: 'onDragEnter',
    value: function onDragEnter(evt) {
      evt.preventDefault();

      // Count the dropzone and any children that are entered.
      if (this.dragTargets.indexOf(evt.target) === -1) {
        this.dragTargets.push(evt.target);
      }

      this.setState({
        isDragActive: true, // Do not rely on files for the drag state. It doesn't work in Safari.
        draggedFiles: Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getDataTransferItems */])(evt)
      });

      if (this.props.onDragEnter) {
        this.props.onDragEnter.call(this, evt);
      }
    }
  }, {
    key: 'onDragOver',
    value: function onDragOver(evt) {
      // eslint-disable-line class-methods-use-this
      evt.preventDefault();
      evt.stopPropagation();
      try {
        evt.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign
      } catch (err) {
        // continue regardless of error
      }

      if (this.props.onDragOver) {
        this.props.onDragOver.call(this, evt);
      }
      return false;
    }
  }, {
    key: 'onDragLeave',
    value: function onDragLeave(evt) {
      var _this2 = this;

      evt.preventDefault();

      // Only deactivate once the dropzone and all children have been left.
      this.dragTargets = this.dragTargets.filter(function (el) {
        return el !== evt.target && _this2.node.contains(el);
      });
      if (this.dragTargets.length > 0) {
        return;
      }

      // Clear dragging files state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      if (this.props.onDragLeave) {
        this.props.onDragLeave.call(this, evt);
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(evt) {
      var _this3 = this;

      var _props = this.props,
          onDrop = _props.onDrop,
          onDropAccepted = _props.onDropAccepted,
          onDropRejected = _props.onDropRejected,
          multiple = _props.multiple,
          disablePreview = _props.disablePreview,
          accept = _props.accept;

      var fileList = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getDataTransferItems */])(evt);
      var acceptedFiles = [];
      var rejectedFiles = [];

      // Stop default browser behavior
      evt.preventDefault();

      // Reset the counter along with the drag on a drop.
      this.dragTargets = [];
      this.isFileDialogActive = false;

      fileList.forEach(function (file) {
        if (!disablePreview) {
          try {
            file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
          } catch (err) {
            if (false) {
              console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
            }
          }
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* fileAccepted */])(file, accept) && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* fileMatchSize */])(file, _this3.props.maxSize, _this3.props.minSize)) {
          acceptedFiles.push(file);
        } else {
          rejectedFiles.push(file);
        }
      });

      if (!multiple) {
        // if not in multi mode add any extra accepted files to rejected.
        // This will allow end users to easily ignore a multi file drop in "single" mode.
        rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
      }

      if (onDrop) {
        onDrop.call(this, acceptedFiles, rejectedFiles, evt);
      }

      if (rejectedFiles.length > 0 && onDropRejected) {
        onDropRejected.call(this, rejectedFiles, evt);
      }

      if (acceptedFiles.length > 0 && onDropAccepted) {
        onDropAccepted.call(this, acceptedFiles, evt);
      }

      // Clear files value
      this.draggedFiles = null;

      // Reset drag state
      this.setState({
        isDragActive: false,
        draggedFiles: [],
        acceptedFiles: acceptedFiles,
        rejectedFiles: rejectedFiles
      });
    }
  }, {
    key: 'onClick',
    value: function onClick(evt) {
      var _props2 = this.props,
          onClick = _props2.onClick,
          disableClick = _props2.disableClick;

      if (!disableClick) {
        evt.stopPropagation();

        if (onClick) {
          onClick.call(this, evt);
        }

        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
        // this is so react can handle state changes in the onClick prop above above
        // see: https://github.com/react-dropzone/react-dropzone/issues/450
        setTimeout(this.open.bind(this), 0);
      }
    }
  }, {
    key: 'onInputElementClick',
    value: function onInputElementClick(evt) {
      evt.stopPropagation();
      if (this.props.inputProps && this.props.inputProps.onClick) {
        this.props.inputProps.onClick();
      }
    }
  }, {
    key: 'onFileDialogCancel',
    value: function onFileDialogCancel() {
      // timeout will not recognize context of this method
      var onFileDialogCancel = this.props.onFileDialogCancel;
      var fileInputEl = this.fileInputEl;
      var isFileDialogActive = this.isFileDialogActive;
      // execute the timeout only if the onFileDialogCancel is defined and FileDialog
      // is opened in the browser

      if (onFileDialogCancel && isFileDialogActive) {
        setTimeout(function () {
          // Returns an object as FileList
          var FileList = fileInputEl.files;
          if (!FileList.length) {
            isFileDialogActive = false;
            onFileDialogCancel();
          }
        }, 300);
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(ref) {
      this.node = ref;
    }
  }, {
    key: 'setRefs',
    value: function setRefs(ref) {
      this.fileInputEl = ref;
    }
    /**
     * Open system file upload dialog.
     *
     * @public
     */

  }, {
    key: 'open',
    value: function open() {
      this.isFileDialogActive = true;
      this.fileInputEl.value = null;
      this.fileInputEl.click();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          accept = _props3.accept,
          acceptClassName = _props3.acceptClassName,
          activeClassName = _props3.activeClassName,
          children = _props3.children,
          disabled = _props3.disabled,
          disabledClassName = _props3.disabledClassName,
          inputProps = _props3.inputProps,
          multiple = _props3.multiple,
          name = _props3.name,
          rejectClassName = _props3.rejectClassName,
          rest = _objectWithoutProperties(_props3, ['accept', 'acceptClassName', 'activeClassName', 'children', 'disabled', 'disabledClassName', 'inputProps', 'multiple', 'name', 'rejectClassName']);

      var acceptStyle = rest.acceptStyle,
          activeStyle = rest.activeStyle,
          className = rest.className,
          disabledStyle = rest.disabledStyle,
          rejectStyle = rest.rejectStyle,
          style = rest.style,
          props = _objectWithoutProperties(rest, ['acceptStyle', 'activeStyle', 'className', 'disabledStyle', 'rejectStyle', 'style']);

      var _state = this.state,
          isDragActive = _state.isDragActive,
          draggedFiles = _state.draggedFiles;

      var filesCount = draggedFiles.length;
      var isMultipleAllowed = multiple || filesCount <= 1;
      var isDragAccept = filesCount > 0 && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* allFilesAccepted */])(draggedFiles, this.props.accept);
      var isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);
      className = className || '';
      var noStyles = !className && !style && !activeStyle && !acceptStyle && !rejectStyle && !disabledStyle;

      if (isDragActive && activeClassName) {
        className += ' ' + activeClassName;
      }
      if (isDragAccept && acceptClassName) {
        className += ' ' + acceptClassName;
      }
      if (isDragReject && rejectClassName) {
        className += ' ' + rejectClassName;
      }
      if (disabled && disabledClassName) {
        className += ' ' + disabledClassName;
      }

      if (noStyles) {
        style = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].default;
        activeStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        acceptStyle = style.active;
        rejectStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].rejected;
        disabledStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].disabled;
      }

      var appliedStyle = _extends({}, style);
      if (activeStyle && isDragActive) {
        appliedStyle = _extends({}, style, activeStyle);
      }
      if (acceptStyle && isDragAccept) {
        appliedStyle = _extends({}, appliedStyle, acceptStyle);
      }
      if (rejectStyle && isDragReject) {
        appliedStyle = _extends({}, appliedStyle, rejectStyle);
      }
      if (disabledStyle && disabled) {
        appliedStyle = _extends({}, style, disabledStyle);
      }

      var inputAttributes = {
        accept: accept,
        disabled: disabled,
        type: 'file',
        style: { display: 'none' },
        multiple: __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* supportMultiple */] && multiple,
        ref: this.setRefs,
        onChange: this.onDrop,
        autoComplete: 'off'
      };

      if (name && name.length) {
        inputAttributes.name = name;
      }

      // Remove custom properties before passing them to the wrapper div element
      var customProps = ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'activeClassName', 'acceptClassName', 'rejectClassName', 'disabledClassName', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize'];
      var divProps = _extends({}, props);
      customProps.forEach(function (prop) {
        return delete divProps[prop];
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: className,
          style: appliedStyle
        }, divProps /* expand user provided props first so event handlers are never overridden */, {
          onClick: this.composeHandlers(this.onClick),
          onDragStart: this.composeHandlers(this.onDragStart),
          onDragEnter: this.composeHandlers(this.onDragEnter),
          onDragOver: this.composeHandlers(this.onDragOver),
          onDragLeave: this.composeHandlers(this.onDragLeave),
          onDrop: this.composeHandlers(this.onDrop),
          ref: this.setRef,
          'aria-disabled': disabled
        }),
        this.renderChildren(children, isDragActive, isDragAccept, isDragReject),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
      );
    }
  }]);

  return Dropzone;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Dropzone);

Dropzone.propTypes = {
  /**
   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Contents of the dropzone
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),

  /**
   * Disallow clicking on the dropzone container to open file dialog
   */
  disableClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
  * Enable/disable the dropzone entirely
  */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable preview generation
   */
  disablePreview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Pass additional attributes to the `<input type="file"/>` tag
   */
  inputProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Allow dropping multiple files
   */
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * `name` attribute for the input tag
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Maximum file size
   */
  maxSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Minimum file size
   */
  minSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * className
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className for active state
   */
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className for accepted state
   */
  acceptClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className for rejected state
   */
  rejectClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className for disabled state
   */
  disabledClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * CSS styles to apply
   */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drag is active
   */
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be accepted
   */
  acceptStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be rejected
   */
  rejectStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when dropzone is disabled
   */
  disabledStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * onClick callback
   * @param {Event} event
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDrop callback
   */
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropAccepted callback
   */
  onDropAccepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropRejected callback
   */
  onDropRejected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragStart callback
   */
  onDragStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragEnter callback
   */
  onDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragOver callback
   */
  onDragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragLeave callback
   */
  onDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Provide a callback on clicking the cancel button of the file dialog
   */
  onFileDialogCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Dropzone.defaultProps = {
  preventDropOnDocument: true,
  disabled: false,
  disablePreview: false,
  disableClick: false,
  multiple: true,
  maxSize: Infinity,
  minSize: 0
};

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CheckExistsWarningModal=function(_React$Component){_inherits(CheckExistsWarningModal,_React$Component);function CheckExistsWarningModal(){_classCallCheck(this,CheckExistsWarningModal);return _possibleConstructorReturn(this,(CheckExistsWarningModal.__proto__||Object.getPrototypeOf(CheckExistsWarningModal)).apply(this,arguments));}_createClass(CheckExistsWarningModal,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal warning-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons middle'},'warning'),'Warning'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'medium-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.message),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bold-text'},'Are you sure you want to proceed?')),this.props.transactions.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-16'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bold-text'},'Assigned Applications'),' click on link'+(this.props.transactions.length>1?'s':'')+' below to view:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-8'},this.props.transactions.map(function(t){var url='/recipient-accounts/'+t.recipientId+'?applicationId='+t.applicationId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{target:"_blank",to:url,className:'link-text small-text'},url));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'warning-modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-accent',onClick:function onClick(){if(_this2.props.cancel)_this2.props.cancel();_this2.props.close();}},this.props.cancelText||"Cancel"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-accent2',onClick:function onClick(){_this2.props.continue();_this2.props.close();}},this.props.continueText||"Continue")))));}}]);return CheckExistsWarningModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CheckExistsWarningModal);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MarkInquiry=function(_React$Component){_inherits(MarkInquiry,_React$Component);function MarkInquiry(){_classCallCheck(this,MarkInquiry);return _possibleConstructorReturn(this,(MarkInquiry.__proto__||Object.getPrototypeOf(MarkInquiry)).apply(this,arguments));}_createClass(MarkInquiry,[{key:"updateInquire",value:function updateInquire(event){this.props.updateApplication(event.target.name,event.target.checked);}},{key:"render",value:function render(){var _this2=this;var _props=this.props,inquire=_props.inquire,inquireNote=_props.inquireNote;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"medium-text"},"Mark For Inquiry"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"info-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column-third"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"custom-check-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",id:"inquire",name:"inquire",className:"custom-check",checked:inquire,onChange:this.updateInquire.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"inquire"},"Mark this application for inquiry"))),inquire&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column-two-thirds"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",placeholder:"Enter inquiry note",value:inquireNote,onChange:function onChange(e){return _this2.props.updateApplication('inquireNote',e.target.value);}}))));}}]);return MarkInquiry;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (MarkInquiry);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["findDuplicateRecipients"] = findDuplicateRecipients;
/* harmony export (immutable) */ __webpack_exports__["updateTable"] = updateTable;
/* harmony export (immutable) */ __webpack_exports__["getDuplicateRecipients"] = getDuplicateRecipients;
/* harmony export (immutable) */ __webpack_exports__["getDuplicateRecipientsDetails"] = getDuplicateRecipientsDetails;
/* harmony export (immutable) */ __webpack_exports__["resolveDuplicateRecipients"] = resolveDuplicateRecipients;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__ = __webpack_require__(16);
//MOCK API CALLS:
var mockFindDuplicates=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return sleep(4000);case 2:return _context5.abrupt('return',{success:true,loading:false});case 3:case'end':return _context5.stop();}}},_callee5,this);}));return function mockFindDuplicates(){return _ref5.apply(this,arguments);};}();var mockGetDuplicates=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){var duplicates;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return sleep(1500);case 2:duplicates=[[{applicantId:123,name:"Chaim Moshe Stern",address:"346 Reta Way Suite 132",phone:"185-548-0987"},{applicantId:567,name:"Moshe Stern",address:"346 Reta Way Suite 132",phone:"185-548-0987"},{applicantId:456,name:"Moshe Stern",address:"346 Reta Way Suite 132",phone:"185-548-0987"}],[{applicantId:432,name:"Henry Bloch",address:"346 Reta Way Suite 132",phone:"185-548-0987"},{applicantId:987,name:"Henry Block",address:"346 Reta Way Suite 132",phone:"185-548-0987"},{applicantId:111,name:"Moshe Stern",address:"346 Reta Way Suite 132",phone:"185-548-0987"}],[{applicantId:123,name:"Chaim Moshe Stern",address:"346 Reta Way Suite 132",phone:"185-548-0987"},{applicantId:5687,name:"Moshe Stern",address:"346 Reta Way Suite 132",phone:"185-548-0987"}],[{applicantId:432,name:"Henry Bloch",address:"346 Reta Way Suite 132",phone:"185-548-0987"},{applicantId:9187,name:"Henry Block",address:"346 Reta Way Suite 132",phone:"185-548-0987"}],[{applicantId:1223,name:"Chaim Moshe Stern",address:"346 Reta Way Suite 132",phone:"185-548-0987"},{applicantId:852,name:"Moshe Stern",address:"346 Reta Way Suite 132",phone:"185-548-0987"},{applicantId:258,name:"Moshe Stern",address:"346 Reta Way Suite 132",phone:"185-548-0987"},{applicantId:147,name:"Moshe Stern",address:"346 Reta Way Suite 132",phone:"185-548-0987"},{applicantId:741,name:"Moshe Stern",address:"346 Reta Way Suite 132",phone:"185-548-0987"}],[{applicantId:4732,name:"Henry Bloch",address:"346 Reta Way Suite 132",phone:"185-548-0987"},{applicantId:9987,name:"Henry Block",address:"346 Reta Way Suite 132",phone:"185-548-0987"}],[{applicantId:1293,name:"Chaim Moshe Stern",address:"346 Reta Way Suite 132",phone:"185-548-0987"},{applicantId:5967,name:"Moshe Stern",address:"346 Reta Way Suite 132",phone:"185-548-0987"}],[{applicantId:4632,name:"Henry Bloch",address:"346 Reta Way Suite 132",phone:"185-548-0987"},{applicantId:9837,name:"Henry Block",address:"346 Reta Way Suite 132",phone:"185-548-0987"}],[{applicantId:22123,name:"Chaim Moshe Stern",address:"346 Reta Way Suite 132",phone:"185-548-0987"},{applicantId:22567,name:"Moshe Stern",address:"346 Reta Way Suite 132",phone:"185-548-0987"}],[{applicantId:43222,name:"Henry Bloch",address:"346 Reta Way Suite 132",phone:"185-548-0987"},{applicantId:98722,name:"Henry Block",address:"346 Reta Way Suite 132",phone:"185-548-0987"}]];return _context6.abrupt('return',{loading:false,success:true,data:{totalCount:duplicates.length,records:duplicates}});case 4:case'end':return _context6.stop();}}},_callee6,this);}));return function mockGetDuplicates(){return _ref6.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function findDuplicateRecipients(){var _this=this;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_FIND_DUPLICATE_RECIPIENTS"]});_context.next=3;return mockFindDuplicates();case 3:response=_context.sent;//TODO: temp mock
dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["FIND_DUPLICATE_RECIPIENTS_COMPLETE"],response:response});case 5:case'end':return _context.stop();}}},_callee,_this);}));return function(_x){return _ref.apply(this,arguments);};}();}function updateTable(settings){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_DUPLICATE_RECIPIENTS_TABLE"],settings:settings});};}function getDuplicateRecipients(){var _this2=this;var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var results=arguments.length>1&&arguments[1]!==undefined?arguments[1]:12;//no sort for now: sort = { by: 'name', direction: 'Ascending' }) {
return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState){var settings,requestId,tableSettings,params,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:settings={page:page,results:results};dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_DUPLICATE_RECIPIENTS_TABLE"],settings:settings});requestId=++getState().duplicateRecipientsTable.currentRequestId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_DUPLICATE_RECIPIENTS_TABLE_RECORDS"],requestId:requestId});tableSettings=getState().duplicateRecipientsTable;params={page:tableSettings.page,sortBy:tableSettings.sort.by,sortDirection:tableSettings.sort.direction,results:tableSettings.resultsView};// const response = await getRequest('/recipients/duplicates', params);
//TODO: temp mock
_context2.next=8;return mockGetDuplicates(params);case 8:response=_context2.sent;dispatch(Object.assign({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_DUPLICATE_RECIPIENTS_TABLE_RECORDS"]},{response:response,requestId:requestId}));case 10:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x4,_x5){return _ref2.apply(this,arguments);};}();}function getDuplicateRecipientsDetails(recipientOneId,recipientTwoId){var _this3=this;return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch){var recipients,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_DUPLICATE_RECIPIENTS_DETAILS"]});_context3.next=3;return Promise.all([Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/recipients/'+recipientOneId),Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/recipients/'+recipientTwoId)]);case 3:recipients=_context3.sent;response={loading:false,success:recipients.every(function(recipient){return recipient.success;}),//check that firefox 1.5+ is good.  for .every support
data:recipients.map(function(recipient){return recipient.data;})};dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_DUPLICATE_RECIPIENTS_DETAILS"],response:response});case 6:case'end':return _context3.stop();}}},_callee3,_this3);}));return function(_x6){return _ref3.apply(this,arguments);};}();}function resolveDuplicateRecipients(deleteRecipientId,keepRecipientId){var _this4=this;return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_RESOLVE_DUPLICATE_RECIPIENTS"]});_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["a" /* deleteRequest */])('/recipients/'+deleteRecipientId,{duplicateId:keepRecipientId});case 3:response=_context4.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["RESOLVE_DUPLICATE_RECIPIENTS"],response:response});case 5:case'end':return _context4.stop();}}},_callee4,_this4);}));return function(_x7){return _ref4.apply(this,arguments);};}();}function sleep(ms){return new Promise(function(resolve){return setTimeout(resolve,ms);});}

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MergeDuplicatesModal=function(_React$Component){_inherits(MergeDuplicatesModal,_React$Component);function MergeDuplicatesModal(props){var _this2=this;_classCallCheck(this,MergeDuplicatesModal);var _this=_possibleConstructorReturn(this,(MergeDuplicatesModal.__proto__||Object.getPrototypeOf(MergeDuplicatesModal)).call(this,props));_this.toggleSelectRecipient=function(applicantId){_this.setState({keepRecipientId:_this.state.keepRecipientId===applicantId?null:applicantId});};_this.mergeRecipients=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var keepRecipientId,deleteRecipientId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:keepRecipientId=_this.state.keepRecipientId;deleteRecipientId=_this.props.duplicatesDetails.data.map(function(d){return d.applicantId;}).filter(function(id){return id!==keepRecipientId;})[0];_context.next=4;return _this.props.mergeDuplicates(deleteRecipientId,keepRecipientId);case 4:if(_this.props.mergingDuplicates.success){if(_this.props.onMergeDuplicates)_this.props.onMergeDuplicates();_this.onClose();}case 5:case'end':return _context.stop();}}},_callee,_this2);}));_this.onClose=function(){_this.setState({keepRecipientId:null});_this.props.close();};_this.state={keepRecipientId:null};return _this;}_createClass(MergeDuplicatesModal,[{key:'render',value:function render(){var _this3=this;var _props=this.props,duplicatesDetails=_props.duplicatesDetails,mergingDuplicates=_props.mergingDuplicates,show=_props.show;var recipients=duplicatesDetails.data;var keepRecipientId=this.state.keepRecipientId;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal merge-modal large-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},'Merge Duplicates'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.onClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-subheader'},recipients.map(function(r){return r.displayName;}).join(" & ")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'split-cards flex-justify',style:{marginTop:"16px"}},duplicatesDetails.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'full-width'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'30'})):recipients.map(function(recipient,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:recipient.applicantId,className:'card card-'+(index%2===0?"left":"right")+' merge-card column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'card-header'},recipient.displayName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card-person-info'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons ion-ios-telephone-outline'}),[recipient.phoneNumber,recipient.secondPhoneNumber].filter(function(p){return p;}).join(' | ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons ion-ios-home-outline'}),recipient.addressDisplay),recipient.campaignList&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons ion-ios-briefcase-outline'}),recipient.campaignList)),recipient.tags.map(function(tag){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:tag.key,className:'chip name-chip'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,tag.value));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),recipient.references.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'References:'),recipient.references.map(function(reference){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:reference.referenceId,className:'application-details-personal-info'},reference.displayName&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons ion-ios-person-outline accent-text2'}),reference.displayName),reference.relationship&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons ion-ios-information-outline accent-text2'}),reference.relationship),(reference.phoneNumber||reference.secondPhoneNumber)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons ion-ios-telephone-outline accent-text2'}),[reference.phoneNumber,reference.secondPhoneNumber].filter(function(p){return p;}).join(' | ')),reference.email&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons ion-ios-email-outline accent-text2'}),reference.email),reference.addressDisplay&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons ion-ios-location-outline accent-text2'}),reference.addressDisplay));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:recipient.applicantId,className:'custom-check-container name-check-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'select-keep-'+recipient.applicantId,className:'custom-check input',checked:keepRecipientId===recipient.applicantId,onChange:function onChange(){return _this3.toggleSelectRecipient(recipient.applicantId);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'select-keep-'+recipient.applicantId,className:'secondary-text input'},'Use this Recipient')));}))),mergingDuplicates.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.onClose},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',disabled:!keepRecipientId,onClick:this.mergeRecipients},'Merge'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:!mergingDuplicates.success,message:mergingDuplicates.message})))));}}]);return MergeDuplicatesModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (MergeDuplicatesModal);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NoteModal=function(_React$Component){_inherits(NoteModal,_React$Component);function NoteModal(props){_classCallCheck(this,NoteModal);var _this=_possibleConstructorReturn(this,(NoteModal.__proto__||Object.getPrototypeOf(NoteModal)).call(this,props));_this.state={text:'',error:false};return _this;}_createClass(NoteModal,[{key:'onChange',value:function onChange(event){this.setState(_defineProperty({},event.target.name,event.target.value));}},{key:'onClose',value:function onClose(){this.props.close();this.setState({text:'',error:false});}},{key:'onSave',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.save(this.state.text);case 2:if(this.props.success){this.onClose();}else{this.setState({error:true});}case 3:case'end':return _context.stop();}}},_callee,this);}));function onSave(){return _ref.apply(this,arguments);}return onSave;}()},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal warning-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},this.props.note.noteId?"Edit":"New",' Note'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.onClose.bind(this)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{value:this.state.text?this.state.text:this.props.note.text,name:'text',onChange:this.onChange.bind(this)}),this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.onClose.bind(this)},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',disabled:!this.state.text||this.state.text===this.props.note.text,onClick:this.onSave.bind(this)},'Save'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error})))));}}]);return NoteModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (NoteModal);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_CurrencyFormatInput__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState=function initialState(props){return{showDropdown:false,showApprove:false,showReject:false,showReview:false,showMarkForInquiry:false,amount:props.amount||'',approvalNote:'',rejectReason:'',reviewDate:'',inquire:props.inquire,inquireNote:props.inquireNote||'',updateAttempted:false,updateError:false};};var ApplicationActionsDropdown=function(_React$Component){_inherits(ApplicationActionsDropdown,_React$Component);function ApplicationActionsDropdown(props){_classCallCheck(this,ApplicationActionsDropdown);var _this=_possibleConstructorReturn(this,(ApplicationActionsDropdown.__proto__||Object.getPrototypeOf(ApplicationActionsDropdown)).call(this,props));_this.state=initialState(props);_this.setWrapperRef=_this.setWrapperRef.bind(_this);_this.handleClickOutside=_this.handleClickOutside.bind(_this);return _this;}_createClass(ApplicationActionsDropdown,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.amount){this.setState({amount:this.props.amount});}}},{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('mousedown',this.handleClickOutside);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('mousedown',this.handleClickOutside);}},{key:'toggleDropdown',value:function toggleDropdown(dropdownPart){if(this.props.locked)return;this.setState(Object.assign({},initialState(this.props),_defineProperty({showDropdown:true},dropdownPart,!this.state[dropdownPart])));}},{key:'onChange',value:function onChange(name,value){this.setState(_defineProperty({},name,value));}},{key:'updateStatus',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(action,applications){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!this.props.locked){_context.next=2;break;}return _context.abrupt('return');case 2:this.setState({updateAttempted:true,updateError:false});if(!(action==="approve"&&this.state.amount>this.props.maxAmount)){_context.next=5;break;}return _context.abrupt('return');case 5:_context.next=7;return this.props.updateApplicationStatus(action,applications);case 7:if(!this.props.update.success)this.setState({updateError:true});case 8:case'end':return _context.stop();}}},_callee,this);}));function updateStatus(_x,_x2){return _ref.apply(this,arguments);}return updateStatus;}()},{key:'setWrapperRef',value:function setWrapperRef(node){this.wrapperRef=node;}},{key:'handleClickOutside',value:function handleClickOutside(event){if(this.wrapperRef&&!this.wrapperRef.contains(event.target)&&this.state.showDropdown){this.setState(Object.assign({},initialState(this.props)));}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-dropdown',ref:this.setWrapperRef},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-flat-status-'+(this.props.status?this.props.status.replace(' ','').toLowerCase():''),disabled:this.props.disabled,'aria-disabled':this.props.locked,onClick:this.toggleDropdown.bind(this,'showDropdown')},this.props.status,' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'"icon icon-right ion-android-arrow-drop'+(this.state.showDropdown?"up":"down")})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{hidden:!this.state.showDropdown,className:'custom-dropdown-box'},(this.props.status===__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["a" /* ApplicationStatuses */].InReview||this.props.status===__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["a" /* ApplicationStatuses */].New)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-dropdown-option'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-justify',onClick:this.toggleDropdown.bind(this,'showApprove')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},'Approve'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-arrow-'+(this.state.showApprove?"up":"down")})),this.state.showApprove&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-dropdown-extension flex-wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_CurrencyFormatInput__["a" /* default */],{className:'input',placeholder:'Amount',isIsraeli:this.props.currency===__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["f" /* CurrencyTypes */].Shekel}),name:'amount',value:this.state.amount,onChange:this.onChange.bind(this),onKeyDown:function onKeyDown(e){if(e.key==='Enter'&&_this2.state.amount)_this2.updateStatus('approve',[{applicationId:_this2.props.applicationId,amount:_this2.state.amount,currency:Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["s" /* getObjectKeyByValue */])(__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["f" /* CurrencyTypes */],_this2.props.currency),approvalNote:_this2.state.approvalNote}]);},validated:true,showValidationError:this.state.updateAttempted,validate:function validate(val){return _this2.props.maxAmount?_this2.state.amount<=_this2.props.maxAmount:true;},errorMessage:'Amount cannot exceed '+Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["j" /* formatCurrency */])(this.props.maxAmount,this.props.currency===__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["f" /* CurrencyTypes */].Shekel)+'.'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',placeholder:'Approval Note',name:'approvalNote',value:this.state.approvalNote,onChange:function onChange(e){return _this2.onChange(e.target.name,e.target.value);},onKeyDown:function onKeyDown(e){if(e.key==='Enter'&&_this2.state.amount)_this2.updateStatus('approve',[{applicationId:_this2.props.applicationId,amount:_this2.state.amount,currency:Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["s" /* getObjectKeyByValue */])(__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["f" /* CurrencyTypes */],_this2.props.currency),approvalNote:_this2.state.approvalNote}]);}}),this.props.update.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'16'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-flat-primary btn-flat-primary-background',disabled:!this.state.amount,onClick:this.updateStatus.bind(this,'approve',[{applicationId:this.props.applicationId,amount:this.state.amount,currency:Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["s" /* getObjectKeyByValue */])(__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["f" /* CurrencyTypes */],this.props.currency),approvalNote:this.state.approvalNote}])},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons icon-left'},'save'),'Save'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.updateError}))),(this.props.status===__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["a" /* ApplicationStatuses */].InReview||this.props.status===__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["a" /* ApplicationStatuses */].New)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-dropdown-option'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-justify',onClick:this.toggleDropdown.bind(this,'showReject')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},'Reject'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-arrow-'+(this.state.showReject?"up":"down")})),this.state.showReject&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-dropdown-extension'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',placeholder:'Reason',name:'rejectReason',value:this.state.rejectReason,onChange:function onChange(e){return _this2.onChange(e.target.name,e.target.value);},onKeyDown:function onKeyDown(e){if(e.key==='Enter')_this2.updateStatus.bind(_this2,'reject',[{applicationId:_this2.props.applicationId,rejectReason:_this2.state.rejectReason}]);}}),this.props.update.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'16'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-flat-primary btn-flat-primary-background',onClick:this.updateStatus.bind(this,'reject',[{applicationId:this.props.applicationId,rejectReason:this.state.rejectReason}])},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons icon-left'},'save'),'Save'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.updateError}))),this.props.status===__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["a" /* ApplicationStatuses */].New&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-dropdown-option'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-justify',onClick:this.toggleDropdown.bind(this,'showReview')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},'Review'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-arrow-'+(this.state.showReview?"up":"down")})),this.state.showReview&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-dropdown-extension'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'date',name:'reviewDate',value:this.state.reviewDate,max:'9999-12-31',onChange:function onChange(e){return _this2.onChange(e.target.name,e.target.value);},min:Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["l" /* formatDateForInput */])(new Date().setDate(new Date().getDate()+1))}),this.props.update.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'16'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-flat-primary btn-flat-primary-background',disabled:!this.state.reviewDate||new Date(this.state.reviewDate)<=Date.now(),onClick:this.updateStatus.bind(this,'review',[{applicationId:this.props.applicationId,reviewDate:this.state.reviewDate}])},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons icon-left'},'save'),'Save'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.updateError}))),(this.props.userId===this.props.approverId||this.props.admin)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-dropdown-option'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-justify',onClick:this.toggleDropdown.bind(this,'showMarkForInquiry')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},this.props.inquire?'Edit Inquiry':'Mark For Inquiry'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-arrow-'+(this.state.showMarkForInquiry?"up":"down")})),this.state.showMarkForInquiry&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-dropdown-extension flex-wrap'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'inquire',name:'inquire',className:'custom-check',checked:this.state.inquire,onChange:function onChange(e){return _this2.onChange(e.target.name,e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'inquire'},'Mark this application for inquiry')),this.state.inquire&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',placeholder:'Note',name:'inquireNote',value:this.state.inquireNote,onChange:function onChange(e){return _this2.onChange(e.target.name,e.target.value);},onKeyDown:function onKeyDown(e){if(e.key==='Enter')_this2.updateStatus.bind(_this2,'markForInquiry',[{applicationId:_this2.props.applicationId,inquire:_this2.state.inquire,inquireNote:_this2.state.inquireNote}]);}}),this.props.update.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'16'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-flat-primary btn-flat-primary-background',onClick:this.updateStatus.bind(this,'markForInquiry',[{applicationId:this.props.applicationId,inquire:this.state.inquire,inquireNote:this.state.inquireNote}])},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons icon-left'},'save'),'Save'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.updateError})))));}}]);return ApplicationActionsDropdown;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ApplicationActionsDropdown);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MarkInquiryWarning=function(_React$Component){_inherits(MarkInquiryWarning,_React$Component);function MarkInquiryWarning(){_classCallCheck(this,MarkInquiryWarning);return _possibleConstructorReturn(this,(MarkInquiryWarning.__proto__||Object.getPrototypeOf(MarkInquiryWarning)).apply(this,arguments));}_createClass(MarkInquiryWarning,[{key:'render',value:function render(){var inquireNote=this.props.inquireNote;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error-label error-label-margin-bottom'},'This application was marked for inquiry',inquireNote?' | '+inquireNote:'');}}]);return MarkInquiryWarning;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (MarkInquiryWarning);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignStatusTag=function(_React$Component){_inherits(CampaignStatusTag,_React$Component);function CampaignStatusTag(){_classCallCheck(this,CampaignStatusTag);return _possibleConstructorReturn(this,(CampaignStatusTag.__proto__||Object.getPrototypeOf(CampaignStatusTag)).apply(this,arguments));}_createClass(CampaignStatusTag,[{key:'render',value:function render(){return this.props.status?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-flat-'+this.props.status.toLowerCase()},this.props.status):null;}}]);return CampaignStatusTag;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CampaignStatusTag);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getExternalCampaignListDetails"] = getExternalCampaignListDetails;
/* harmony export (immutable) */ __webpack_exports__["getExternalCampaignListRecipients"] = getExternalCampaignListRecipients;
/* harmony export (immutable) */ __webpack_exports__["updateListConfigs"] = updateListConfigs;
/* harmony export (immutable) */ __webpack_exports__["getExternalCampaignListParticipants"] = getExternalCampaignListParticipants;
/* harmony export (immutable) */ __webpack_exports__["exportExternalCampaignList"] = exportExternalCampaignList;
/* harmony export (immutable) */ __webpack_exports__["submitExternalCampaignList"] = submitExternalCampaignList;
/* harmony export (immutable) */ __webpack_exports__["addExternalCampaignListParticipant"] = addExternalCampaignListParticipant;
/* harmony export (immutable) */ __webpack_exports__["updateExternalCampaignListParticipant"] = updateExternalCampaignListParticipant;
/* harmony export (immutable) */ __webpack_exports__["removeExternalCampaignListParticipant"] = removeExternalCampaignListParticipant;
/* harmony export (immutable) */ __webpack_exports__["restoreExternalCampaignListParticipant"] = restoreExternalCampaignListParticipant;
/* harmony export (immutable) */ __webpack_exports__["toggleExternalCampaignListParticipantsReceiving"] = toggleExternalCampaignListParticipantsReceiving;
/* harmony export (immutable) */ __webpack_exports__["onUpdateList"] = onUpdateList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__ = __webpack_require__(16);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var listType="EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST";var listName="externalCampaignListParticipantsList";function getExternalCampaignListDetails(campaignListId){var _this=this;var dispatchLoading=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(dispatchLoading)dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_EXTERNAL_CAMPAIGN_LIST_DETAILS"]});_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaignLists/'+campaignListId);case 3:response=_context.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_EXTERNAL_CAMPAIGN_LIST_DETAILS"],response:response});case 5:case'end':return _context.stop();}}},_callee,_this);}));return function(_x2){return _ref.apply(this,arguments);};}();}function getExternalCampaignListRecipients(campaignListId){var _this2=this;return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_GET_EXTERNAL_CAMPAIGN_LIST_RECIPIENTS"]});_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaignLists/'+campaignListId+'/externalRecipients',null,[]);case 3:response=_context2.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["GET_EXTERNAL_CAMPAIGN_LIST_RECIPIENTS"],response:response});case 5:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x3){return _ref2.apply(this,arguments);};}();}function updateListConfigs(configs){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__['UPDATE_'+listType+'_CONFIGS'],configs:configs});};}function getExternalCampaignListParticipants(campaignListId){var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'new';var keyword=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"";var reset=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var _this3=this;var page=arguments.length>4&&arguments[4]!==undefined?arguments[4]:1;var sort=arguments.length>5&&arguments[5]!==undefined?arguments[5]:{by:'name',direction:'Ascending'};return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch,getState){var requestId,listSettings,params,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch(updateListConfigs({filters:{keyword:keyword,type:type},page:page,sort:sort}));//sending in with each request, but storing in redux to allow other actions to access
requestId=++getState()[listName].currentRequestId;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__['START_GET_'+listType+'_RECORDS'],requestId:requestId,reset:reset});listSettings=getState()[listName];params={keyword:listSettings.filters.keyword,page:listSettings.page,results:listSettings.results,sortBy:listSettings.sort.by,sortDirection:listSettings.sort.direction,type:listSettings.filters.type};_context3.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaignLists/'+campaignListId+'/externalParticipants',params);case 7:response=_context3.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__['GET_'+listType+'_RECORDS'],response:response,requestId:requestId});case 9:case'end':return _context3.stop();}}},_callee3,_this3);}));return function(_x9,_x10){return _ref3.apply(this,arguments);};}();}function exportExternalCampaignList(campaignListId){var _this4=this;return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_EXPORT_EXTERNAL_CAMPAIGN_LIST"]});_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaignLists/'+campaignListId+'/externalParticipants',{report:true},[]);case 3:response=_context4.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["EXPORT_EXTERNAL_CAMPAIGN_LIST"],response:response});case 5:case'end':return _context4.stop();}}},_callee4,_this4);}));return function(_x11){return _ref4.apply(this,arguments);};}();}function submitExternalCampaignList(campaignListId){var _this5=this;return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_SUBMIT_EXTERNAL_CAMPAIGN_LIST"]});_context5.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/campaignLists/'+campaignListId+'/submitExternalChanges');case 3:response=_context5.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["SUBMIT_EXTERNAL_CAMPAIGN_LIST"],response:response});case 5:case'end':return _context5.stop();}}},_callee5,_this5);}));return function(_x12){return _ref5.apply(this,arguments);};}();}function addExternalCampaignListParticipant(campaignListId,participant){var _this6=this;return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS"]});_context6.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/campaignLists/'+campaignListId+'/externalParticipants',participant);case 3:response=_context6.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS"],response:response});if(response.success){dispatch(onUpdateList(campaignListId));dispatch(getExternalCampaignListParticipants(campaignListId,'new',"",true));}case 6:case'end':return _context6.stop();}}},_callee6,_this6);}));return function(_x13){return _ref6.apply(this,arguments);};}();}function updateExternalCampaignListParticipant(campaignListId,participant){var _this7=this;return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatch,getState){var response,participants,participantIndex;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS"]});_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/campaignLists/'+campaignListId+'/externalParticipants/'+participant.externalListMemberId+'/update',participant);case 3:response=_context7.sent;if(!response.success){_context7.next=10;break;}participants=[].concat(_toConsumableArray(getState()[listName].data.records));participantIndex=participants.map(function(p){return p.externalListMemberId;}).indexOf(participant.externalListMemberId);participants[participantIndex]=response.data;_context7.next=10;return dispatch(onUpdateList(campaignListId,participants));case 10:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS"],response:response});case 11:case'end':return _context7.stop();}}},_callee7,_this7);}));return function(_x14,_x15){return _ref7.apply(this,arguments);};}();}function removeExternalCampaignListParticipant(campaignListId,participantExternalListMemberId){var _this8=this;return function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatch,getState){var response,participants,participantIndex;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS"]});_context8.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/campaignLists/'+campaignListId+'/externalParticipants/'+participantExternalListMemberId+'/remove');case 3:response=_context8.sent;if(!response.success){_context8.next=11;break;}participants=[].concat(_toConsumableArray(getState()[listName].data.records));participantIndex=participants.map(function(p){return p.externalListMemberId;}).indexOf(participantExternalListMemberId);participants[participantIndex].isRemoved=true;participants[participantIndex].isReceiving=false;_context8.next=11;return dispatch(onUpdateList(campaignListId,participants));case 11:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS"],response:response});case 12:case'end':return _context8.stop();}}},_callee8,_this8);}));return function(_x16,_x17){return _ref8.apply(this,arguments);};}();}function restoreExternalCampaignListParticipant(campaignListId,participantExternalListMemberId){var _this9=this;return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatch,getState){var response,participants,participantIndex;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS"]});_context9.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/campaignLists/'+campaignListId+'/externalParticipants/'+participantExternalListMemberId+'/restore');case 3:response=_context9.sent;if(!response.success){_context9.next=10;break;}participants=[].concat(_toConsumableArray(getState()[listName].data.records));participantIndex=participants.map(function(p){return p.externalListMemberId;}).indexOf(participantExternalListMemberId);participants[participantIndex].isRemoved=false;_context9.next=10;return dispatch(onUpdateList(campaignListId,participants));case 10:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS"],response:response});case 11:case'end':return _context9.stop();}}},_callee9,_this9);}));return function(_x18,_x19){return _ref9.apply(this,arguments);};}();}function toggleExternalCampaignListParticipantsReceiving(campaignListId,isReceiving,isNotReceiving,toggleAll,type,keyword){var _this10=this;return function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(dispatch,getState){var toggleDetails,response,participants;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_SELECT_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS"]});toggleDetails={isReceiving:isReceiving,isNotReceiving:isNotReceiving};if(toggleAll){toggleDetails.keyword=keyword;toggleDetails.type=type;if(toggleAll==="all")toggleDetails.allReceiving=true;else if(toggleAll==="none")toggleDetails.noneReceiving=true;}_context10.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["d" /* postRequest */])('/campaignLists/'+campaignListId+'/externalParticipants/receiving',toggleDetails);case 5:response=_context10.sent;if(!response.success){_context10.next=11;break;}participants=[].concat(_toConsumableArray(getState()[listName].data.records));//update records in current list
if(toggleDetails.allReceiving){participants.forEach(function(participant){return participant.isReceiving=true;});}else if(toggleDetails.noneReceiving){participants.forEach(function(participant){return participant.isReceiving=false;});}else{isReceiving.forEach(function(participantId){var participantIndex=participants.map(function(p){return p.externalListMemberId;}).indexOf(participantId);if(participants[participantIndex])participants[participantIndex].isReceiving=true;});isNotReceiving.forEach(function(participantId){var participantIndex=participants.map(function(p){return p.externalListMemberId;}).indexOf(participantId);if(participants[participantIndex])participants[participantIndex].isReceiving=false;});}_context10.next=11;return dispatch(onUpdateList(campaignListId,participants,false));case 11:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["SELECT_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS"],response:response});case 12:case'end':return _context10.stop();}}},_callee10,_this10);}));return function(_x20,_x21){return _ref10.apply(this,arguments);};}();}function onUpdateList(campaignListId,records){var _this11=this;var getTotalCount=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(dispatch,getState){var listSettings,params,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:dispatch(getExternalCampaignListDetails(campaignListId,false));if(!records){_context11.next=8;break;}listSettings=getState()[listName];params={noRecords:true,noTotalCount:!getTotalCount,keyword:listSettings.filters.keyword,page:listSettings.page,results:listSettings.results,sortBy:listSettings.sort.by,sortDirection:listSettings.sort.direction,type:listSettings.filters.type};_context11.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2__lib_apiUtils__["b" /* getRequest */])('/campaignLists/'+campaignListId+'/externalParticipants',params);case 6:response=_context11.sent;dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__['UPDATE_'+listType+'_DATA'],data:{allSelected:response.data.allSelected,totalCount:getTotalCount?response.data.totalCount:listSettings.data.totalCount,records:records//getting records with manual updates bec not requesting all pages that may contain updates..
}});case 8:case'end':return _context11.stop();}}},_callee11,_this11);}));return function(_x23,_x24){return _ref11.apply(this,arguments);};}();}

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_RadioGroup__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__campaignsCommon_CreateCampaignRecipientModal__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={campaignList:{listType:'internal',managerName:'',managerEmail:'',locationId:'',categoryId:'',organizationId:'',fundId:'',batch:false,allowDuplicates:false},categoryIsOrg:false,categoryOrgName:"",invalidData:false,error:false,submitAttempted:false,showModals:{createRecipientModal:false}};var CreateCampaignListModal=function(_NavigationComponent){_inherits(CreateCampaignListModal,_NavigationComponent);function CreateCampaignListModal(props){_classCallCheck(this,CreateCampaignListModal);var _this=_possibleConstructorReturn(this,(CreateCampaignListModal.__proto__||Object.getPrototypeOf(CreateCampaignListModal)).call(this,props));_this.state=initialState;_this.onChange=_this.onChange.bind(_this);return _this;}_createClass(CreateCampaignListModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.locationId&&nextProps.locationId!==this.state.campaignList.locationId){this.onChange("locationId",nextProps.locationId);}}},{key:'onChange',value:function onChange(name,value){var _this2=this;var prevVal=this.state.campaignList[value];if(name==="managerName")value=Object(__WEBPACK_IMPORTED_MODULE_10__lib_utils__["C" /* toTitleCase */])(value);this.setState({campaignList:Object.assign({},this.state.campaignList,_defineProperty({},name,value))},function(){if(name==="categoryId"){var categoryIsOrg=false;var categoryOrgName="";if(value){var orgCategoryIds=_this2.props.organizationCategories.map(function(category){return category.key.toString();});categoryIsOrg=orgCategoryIds.indexOf(value.toString())>=0;categoryOrgName=categoryIsOrg?_this2.props.organizationCategories[orgCategoryIds.indexOf(value.toString())].value:"";}_this2.setState({categoryIsOrg:categoryIsOrg,categoryOrgName:categoryOrgName,campaignList:Object.assign({},_this2.state.campaignList,{organizationId:''})});}else if(name==="listType"){_this2.setState({campaignList:Object.assign({},_this2.state.campaignList,{managerName:'',managerEmail:''}),invalidData:false,submitAttempted:false});}else if(name==="locationId"){if(_this2.state.campaignList.organizationId){var org=_this2.props.organizations[_this2.props.organizations.map(function(o){return o.key.toString();}).indexOf(_this2.state.campaignList.organizationId.toString())];if(org&&!Object(__WEBPACK_IMPORTED_MODULE_10__lib_utils__["D" /* validateAddressLocation */])(_this2.props.locations,value,org.address)){_this2.setState({campaignList:Object.assign({},_this2.state.campaignList,{organizationId:''})});}}if(_this2.state.campaignList.fundId&&Object(__WEBPACK_IMPORTED_MODULE_10__lib_utils__["z" /* locationIsIsraeli */])(_this2.props.locations,value)!==Object(__WEBPACK_IMPORTED_MODULE_10__lib_utils__["z" /* locationIsIsraeli */])(_this2.props.locations,prevVal)){_this2.setState({campaignList:Object.assign({},_this2.state.campaignList,{fundId:''})});}}});}},{key:'onSubmit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var campaignList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({error:false,submitAttempted:true});campaignList=this.state.campaignList;if(!(this.state.invalidData||!campaignList.listType||!campaignList.locationId||!campaignList.categoryId||!campaignList.fundId||campaignList.listType==="external"&&(!campaignList.managerName||!campaignList.managerEmail)||this.state.categoryIsOrg&&!campaignList.organizationId)){_context.next=4;break;}return _context.abrupt('return');case 4:_context.next=6;return this.props.createCampaignList(this.state.campaignList);case 6:if(this.props.success){this.onClose();if(this.props.onSuccess)this.props.onSuccess();}else{this.setState({error:true});}case 7:case'end':return _context.stop();}}},_callee,this);}));function onSubmit(){return _ref.apply(this,arguments);}return onSubmit;}()},{key:'onClose',value:function onClose(){this.props.close();this.setState(initialState);}},{key:'validateEmail',value:function validateEmail(email){var isValid=Object(__WEBPACK_IMPORTED_MODULE_10__lib_utils__["x" /* isValidEmail */])(email);this.setState({invalidData:!isValid});return isValid;}},{key:'render',value:function render(){var _this3=this;var campaignList=this.state.campaignList;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},!this.state.showModals.createRecipientModal&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal large-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},'Create Campaign List'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.onClose.bind(this)})),this.props.isAdmin&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'allow-duplicates',className:'custom-check',name:'allowDuplicates',onChange:function onChange(event){return _this3.onChange(event.target.name,event.target.checked);},checked:campaignList.allowDuplicates}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'allow-duplicates',className:'secondary-text'},'Allow Duplicates'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_RadioGroup__["a" /* default */],{title:'Management',name:'listType',value:campaignList.listType,options:[{key:'internal',value:'Internal'},{key:'external',value:'External'}],onChange:this.onChange})),campaignList.listType==="external"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'empty-label',style:{marginBottom:"6px"}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'batch-list',className:'custom-check',name:'batch',onChange:function onChange(event){return _this3.onChange(event.target.name,event.target.checked);},checked:campaignList.batch}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'batch-list',className:'secondary-text'},'Batch')))))),campaignList.listType==="external"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',placeholder:'Name'}),label:'External Contact',name:'managerName',value:campaignList.managerName,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',placeholder:'Email'}),label:'  ',name:'managerEmail',value:campaignList.managerEmail,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted,validated:true,showValidationError:true,validate:this.validateEmail.bind(this),errorMessage:'Invalid Email Address'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Select__["a" /* default */],{disabled:this.props.locationId,options:this.props.locations.map(function(locationGroup){return{key:locationGroup.groupId,value:locationGroup.groupName,details:locationGroup.members.map(function(member){return member.city+', '+member.state;}).join('\n')};})}),label:'Location',name:'locationId',value:campaignList.locationId,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Select__["a" /* default */],{options:[].concat(_toConsumableArray(this.props.organizationCategories.length?[{optionGroup:true,label:"Organization"}].concat(_toConsumableArray(this.props.organizationCategories),[{optionGroup:true,label:"Individual"}]):[]),_toConsumableArray(this.props.individualCategories))}),label:'Category',name:'categoryId',value:campaignList.categoryId,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Select__["a" /* default */],{disabled:!campaignList.locationId,options:Object(__WEBPACK_IMPORTED_MODULE_10__lib_utils__["z" /* locationIsIsraeli */])(this.props.locations,campaignList.locationId)?this.props.ILFunds:this.props.USFunds}),label:'Fund',name:'fundId',value:campaignList.fundId,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half organization-column'},this.state.categoryIsOrg&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Select__["a" /* default */],{disabled:!campaignList.locationId,options:this.props.organizations.filter(function(org){return org.tags.indexOf(_this3.state.categoryOrgName)>=0;}).filter(function(org){return Object(__WEBPACK_IMPORTED_MODULE_10__lib_utils__["D" /* validateAddressLocation */])(_this3.props.locations,campaignList.locationId,org.address);})}),label:'Please select '+(Object(__WEBPACK_IMPORTED_MODULE_10__lib_utils__["y" /* isVowel */])(this.state.categoryOrgName[0])?"an":"a")+' '+this.state.categoryOrgName,name:'organizationId',value:campaignList.organizationId,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.categoryIsOrg&&campaignList.locationId&&campaignList.categoryId&&!this.props.organizations.filter(function(org){return org.tags.indexOf(_this3.state.categoryOrgName)>=0;}).filter(function(org){return Object(__WEBPACK_IMPORTED_MODULE_10__lib_utils__["D" /* validateAddressLocation */])(_this3.props.locations,campaignList.locationId,org.address);}).length,message:'There are no organizations matching the selected location and category.'})))),this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-btns add-campaign-list-modal-btns'},this.state.categoryIsOrg&&campaignList.locationId&&campaignList.categoryId&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent2',onClick:this.toggleModal.bind(this,"createRecipientModal")},'Create Organization'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-right full-width'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.onClose.bind(this)},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',onClick:this.onSubmit.bind(this),disabled:this.state.invalidData},'Submit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error,message:this.props.message}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__campaignsCommon_CreateCampaignRecipientModal__["a" /* default */],{show:this.state.showModals.createRecipientModal,close:this.toggleModal.bind(this,"createRecipientModal"),locationId:campaignList.locationId,campaignTagId:campaignList.categoryId,onContinue:function onContinue(org){return _this3.onChange('organizationId',org.applicantId);},recipientType:__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["l" /* RecipientTypes */].Organization}));}}]);return CreateCampaignListModal;}(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (CreateCampaignListModal);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_SuggestionsActions__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_RecipientAccountsActions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_SettingsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__applicationsComponents_newApplication_CreateRecipient__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateCampaignRecipientModal=function(_React$Component){_inherits(CreateCampaignRecipientModal,_React$Component);function CreateCampaignRecipientModal(props){_classCallCheck(this,CreateCampaignRecipientModal);var _this=_possibleConstructorReturn(this,(CreateCampaignRecipientModal.__proto__||Object.getPrototypeOf(CreateCampaignRecipientModal)).call(this,props));_this.initialState={modals:{address:false,warning:false},submitAttempted:false,error:false,dataErrors:{email:false,phoneNumber:false,secondPhoneNumber:false},showEmail:false,showSecondPhone:false,showPrevAddress:false,setTrustedPayee:false,noSuggestions:false,recipient:{id:0,fullName:'',applicantType:_this.props.recipientType||__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["l" /* RecipientTypes */].Individual,isIsraeli:Object(__WEBPACK_IMPORTED_MODULE_12__lib_utils__["z" /* locationIsIsraeli */])(_this.props.utils.locationGroups,_this.props.locationId),personTitleId:null,firstName:'',lastName:'',reportName:'',organization:{institutionTitleId:null,name:'',registered:true,taxId:''},address:{},previousAddress:{},teudatZehut:'',phoneNumber:'',secondPhoneNumber:'',email:'',bankRoutingNumber:'',bankBranchNumber:'',bankAccountNumber:'',bankAccountHolder:'',bankAccounts:[],tags:_this.props.campaignTagId?[_this.props.campaignTagId]:[],note:'',references:[],solicitors:[],roshYeshivas:[],trustedPayee:''}};_this.state=_this.initialState;_this.onChange=_this.onChange.bind(_this);_this.updateDataErrors=_this.updateDataErrors.bind(_this);_this.getMissingFields=_this.getMissingFields.bind(_this);return _this;}_createClass(CreateCampaignRecipientModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.locationId!==this.props.locationId){var isIsraeli=Object(__WEBPACK_IMPORTED_MODULE_12__lib_utils__["z" /* locationIsIsraeli */])(this.props.utils.locationGroups,nextProps.locationId);this.initialState=Object.assign({},this.initialState,{recipient:Object.assign({},this.initialState.recipient,{isIsraeli:isIsraeli})});this.setState({recipient:Object.assign({},this.state.recipient,{isIsraeli:isIsraeli})});}else if(nextProps.campaignTagId!==this.props.campaignTagId){this.initialState=Object.assign({},this.initialState,{recipient:Object.assign({},this.initialState.recipient,{tags:nextProps.campaignTagId?[nextProps.campaignTagId]:[]})});this.setState({recipient:Object.assign({},this.state.recipient,{tags:nextProps.campaignTagId?[nextProps.campaignTagId]:[]})});}}},{key:'updateDataErrors',value:function updateDataErrors(name,val){this.setState({dataErrors:Object.assign({},this.state.dataErrors,_defineProperty({},name,val))});}},{key:'onChange',value:function onChange(name,value){this.setState(_defineProperty({},name,value));}},{key:'close',value:function close(){this.props.close();this.setState(this.initialState);if(this.props.recipientSuggestions.data.length)this.props.actions.clearRecipientSuggestions();}},{key:'getMissingFields',value:function getMissingFields(){if(!this.state.recipient.id){if(this.state.recipient.isIsraeli){if(this.state.recipient.applicantType===__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["l" /* RecipientTypes */].Individual&&!this.state.recipient.teudatZehut)return true;if(!this.state.recipient.trustedPayee&&(!this.state.recipient.bankRoutingNumber||!this.state.recipient.bankBranchNumber||!this.state.recipient.bankAccountNumber))return true;}if(this.state.recipient.applicantType===__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["l" /* RecipientTypes */].Individual){if(!this.state.recipient.firstName||!this.state.recipient.lastName)return true;}else{if(!this.state.recipient.organization.name)return true;if(this.state.recipient.organization.registered&&!this.state.recipient.organization.taxId)return true;}if(!this.state.recipient.tags.length)return true;if(!this.state.recipient.address.streetNumber||!this.state.recipient.address.street||!this.state.recipient.address.city||!this.state.recipient.address.country)return true;if(this.state.setTrustedPayee&&!this.state.recipient.trustedPayee)return true;}return false;}},{key:'saveOrContinue',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var missingFields,recipient;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(this.state.error)this.setState({error:false});if(!this.state.recipient.id){_context.next=5;break;}this.props.onContinue(this.state.recipient);this.close();return _context.abrupt('return');case 5:missingFields=this.getMissingFields();if(missingFields){_context.next=21;break;}recipient=Object.assign({},this.state.recipient,{references:this.state.recipient.references.map(function(ref){return{referenceId:ref.referenceId,relationship:ref.relationship};}),solicitors:this.state.recipient.solicitors.map(function(ref){return{referenceId:ref.referenceId,relationship:ref.relationship};}),roshYeshivas:this.state.recipient.roshYeshivas.map(function(ref){return{referenceId:ref.referenceId,relationship:ref.relationship};}),trustedPayeeId:this.state.recipient.trustedPayee?this.state.recipient.trustedPayee.referenceId:null,bankAccounts:this.state.recipient.bankAccounts});_context.next=10;return this.props.actions.createRecipient(recipient);case 10:if(!this.props.createRecipient.success){_context.next=18;break;}if(!this.state.recipient.id&&this.state.recipient.address.country&&this.props.utils.nationalities.indexOf(this.state.recipient.address.country)<0){this.props.actions.getSystemSettings();}else if(!this.state.recipient.id&&this.state.recipient.applicantType===__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["l" /* RecipientTypes */].Organization)this.props.actions.getOrganizations();_context.next=14;return this.props.actions.getRecipientAccountDetails(this.props.createRecipient.data);case 14:this.props.onContinue(this.props.recipientDetails.data);this.close();_context.next=19;break;case 18:this.setState({error:true});case 19:_context.next=22;break;case 21:if(!this.state.submitAttempted)this.setState({submitAttempted:true});case 22:case'end':return _context.stop();}}},_callee,this);}));function saveOrContinue(){return _ref.apply(this,arguments);}return saveOrContinue;}()},{key:'render',value:function render(){var _this2=this;var utils=this.props.utils;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal create-recipient-modal xl-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},'Create Recipient'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.close.bind(this)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__applicationsComponents_newApplication_CreateRecipient__["a" /* default */],{tags:{usPersonTitles:utils.usPersonTitles,israelPersonTitles:utils.usPersonTitles,usInstitutionTitles:utils.usInstitutionTitles,israelInstitutionTitles:utils.israelInstitutionTitles,recipientTypes:this.props.recipientType?utils.recipientTypes.filter(function(type){return type.value===_this2.props.recipientType;}):utils.recipientTypes,categories:{individualTags:utils.individualTags,organizationTags:utils.organizationTags}},campaignTagId:this.props.hasOwnProperty('campaignTagId')?this.props.campaignTagId:null,hideRecipientTitle:true,departments:[Object(__WEBPACK_IMPORTED_MODULE_12__lib_utils__["r" /* getLocationDepartment */])(this.props.utils.locationGroups,this.props.locationId)],submitAttempted:this.state.submitAttempted,recipient:this.state.recipient,dataErrors:this.state.dataErrors,updateDataErrors:this.updateDataErrors,clearIsraeliApplicationInfo:function clearIsraeliApplicationInfo(){},toggleModal:this.toggleModal,onChange:this.onChange,suggestions:{suggestions:this.props.recipientSuggestions.data,getSuggestions:this.props.hasOwnProperty('getRecipientSuggestions')?this.props.getRecipientSuggestions:undefined,clearSuggestions:this.props.actions.clearRecipientSuggestions},validateAddress:this.props.locationId?__WEBPACK_IMPORTED_MODULE_12__lib_utils__["D" /* validateAddressLocation */].bind(this,this.props.utils.locationGroups,this.props.locationId):null,showSecondPhone:this.state.showSecondPhone,showEmail:this.state.showEmail,showPrevAddress:this.state.showPrevAddress,setTrustedPayee:this.state.setTrustedPayee,allowIncomplete:false}),this.props.createRecipient.loading||this.props.recipientDetails.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'application-create-btns modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.close.bind(this)},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',disabled:Object.keys(this.state.dataErrors).some(function(k){return _this2.state.dataErrors[k];}),onClick:this.saveOrContinue.bind(this)},this.state.recipient.id?'Continue':'Save'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error,message:this.props.createRecipient.message||'Something went wrong and the recipient could not be created. Please try again.'})))));}}]);return CreateCampaignRecipientModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);function mapStateToProps(state){return Object.assign({recipientDetails:state.recipientAccountDetails.recipientDetails,createRecipient:state.recipientAccounts.createRecipient,utils:{usPersonTitles:state.settings.systemSettings.data.recipientSettings.usPersonTitles,israelPersonTitles:state.settings.systemSettings.data.recipientSettings.israelPersonTitles,usInstitutionTitles:state.settings.systemSettings.data.recipientSettings.usInstitutionTitles,israelInstitutionTitles:state.settings.systemSettings.data.recipientSettings.israelInstitutionTitles,recipientTypes:state.settings.systemSettings.data.otherSettings.recipientTypes,individualTags:state.settings.systemSettings.data.recipientSettings.individualTags,organizationTags:state.settings.systemSettings.data.recipientSettings.organizationTags,nationalities:state.settings.systemSettings.data.otherSettings.nationalities,locationGroups:state.settings.systemSettings.data.campaignSettings.locationGroups}},state.suggestions);}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(Object.assign({},__WEBPACK_IMPORTED_MODULE_4__redux_actions_SuggestionsActions__,{createRecipient:__WEBPACK_IMPORTED_MODULE_5__redux_actions_RecipientAccountsActions__["createRecipient"],getRecipientAccountDetails:__WEBPACK_IMPORTED_MODULE_5__redux_actions_RecipientAccountsActions__["getRecipientAccountDetails"],getSystemSettings:__WEBPACK_IMPORTED_MODULE_6__redux_actions_SettingsActions__["getSystemSettings"],getOrganizations:__WEBPACK_IMPORTED_MODULE_5__redux_actions_RecipientAccountsActions__["getOrganizations"]}),dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CreateCampaignRecipientModal));

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_AutoSuggestInput__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__campaignsCommon_CreateCampaignRecipientModal__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_shared_WarningModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CampaignRecipientApplication__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commonComponents_shared_ApplicationStatusTag__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_apiUtils__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={recipient:{},newRecipient:{},application:{},recipientHistory:[],wizzardStep:1,loadingRecipientDetails:false,dataErrors:[],submitAttempted:false,checkCampaignRules:true,error:false,showModals:{createRecipientModal:false,campaign60DayRuleAlertModal:false,campaignAddToActiveRuleAlertModal:false}};var AddCampaignRecipientModal=function(_NavigationComponent){_inherits(AddCampaignRecipientModal,_NavigationComponent);function AddCampaignRecipientModal(props){var _this2=this;_classCallCheck(this,AddCampaignRecipientModal);var _this=_possibleConstructorReturn(this,(AddCampaignRecipientModal.__proto__||Object.getPrototypeOf(AddCampaignRecipientModal)).call(this,props));_this.applicationIsIncomplete=function(application){if(!application.paymentInfo.fundId)return true;var thirdParty=application.paymentInfo.thirdParty;if(_this.state.dataErrors.length||application.paymentInfo.payTo===__WEBPACK_IMPORTED_MODULE_14__lib_constants__["e" /* PayeeTypes */].ThirdParty&&!thirdParty.referenceId&&(!thirdParty.orgName&&(!thirdParty.firstName||!thirdParty.lastName)||(thirdParty.isIsraeli?!thirdParty.bankNumber||!thirdParty.branchNumber||!thirdParty.accountNumber:!thirdParty.address.streetNumber||!thirdParty.address.street||!thirdParty.address.city||!thirdParty.address.country)))return true;};_this.onClose=function(){_this.props.close();_this.setState(initialState);};_this.onChange=function(name,value){_this.setState(_defineProperty({},name,value));};_this.onSelectRecipient=function(name,value){if(value&&_this.props.campaign){_this.setState({loadingRecipientDetails:true,error:false},_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var recipientRes,_this$setState2,recipient,recipientHistory,historyRes,_this$setState3;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_16__lib_apiUtils__["b" /* getRequest */])('/recipients/'+value.applicantId);case 2:recipientRes=_context.sent;if(!recipientRes.success){_context.next=14;break;}recipient=recipientRes.data;recipientHistory=[];if(!_this.props.campaign){_context.next=11;break;}_context.next=9;return Object(__WEBPACK_IMPORTED_MODULE_16__lib_apiUtils__["b" /* getRequest */])('/recipients/'+value.applicantId+'/applications');case 9:historyRes=_context.sent;if(historyRes.success)recipientHistory=historyRes.data;case 11:_this.setState((_this$setState2={},_defineProperty(_this$setState2,name,{applicantId:recipient.applicantId,name:recipient.displayName,isIsraeli:recipient.isIsraeli,address:recipient.address,references:recipient.references,trustedPayee:recipient.trustedPayee}),_defineProperty(_this$setState2,'recipientHistory',recipientHistory),_defineProperty(_this$setState2,'loadingRecipientDetails',false),_this$setState2));_context.next=15;break;case 14:_this.setState((_this$setState3={},_defineProperty(_this$setState3,name,value),_defineProperty(_this$setState3,'recipientHistory',[]),_defineProperty(_this$setState3,'loadingRecipientDetails',false),_defineProperty(_this$setState3,'error',true),_this$setState3));case 15:case'end':return _context.stop();}}},_callee,_this2);})));}else{var _this$setState4;_this.setState((_this$setState4={},_defineProperty(_this$setState4,name,value),_defineProperty(_this$setState4,'recipientHistory',[]),_this$setState4));}};_this.state=initialState;return _this;}_createClass(AddCampaignRecipientModal,[{key:'onSubmit',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(addToActiveCampaign){var _state,recipient,newRecipient,application;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:this.setState({error:false,submitAttempted:true});_state=this.state,recipient=_state.recipient,newRecipient=_state.newRecipient,application=_state.application;if(!(!Object.keys(recipient).length&&!Object.keys(newRecipient).length||this.props.campaign&&this.applicationIsIncomplete(application))){_context2.next=4;break;}return _context2.abrupt('return');case 4:_context2.next=6;return this.props.addRecipient(!this.state.checkCampaignRules,newRecipient.applicantId||recipient.applicantId,this.props.campaign?application:this.state.checkCampaignRules===false?addToActiveCampaign:false);case 6:if(this.props.success){this.onClose();}else{if(this.state.checkCampaignRules&&this.props.message&&(this.props.message.indexOf("60 days")>=0||this.props.message.indexOf("active campaigns")>=0)){this.toggleModal(this.props.message.indexOf("active campaigns")>=0?'campaignAddToActiveRuleAlertModal':'campaign60DayRuleAlertModal');}else{this.setState({error:true});}}case 7:case'end':return _context2.stop();}}},_callee2,this);}));function onSubmit(_x){return _ref2.apply(this,arguments);}return onSubmit;}()},{key:'render',value:function render(){var _this3=this;var _state2=this.state,recipient=_state2.recipient,newRecipient=_state2.newRecipient,recipientHistory=_state2.recipientHistory,dataErrors=_state2.dataErrors,error=_state2.error,loadingRecipientDetails=_state2.loadingRecipientDetails,showModals=_state2.showModals,submitAttempted=_state2.submitAttempted,wizzardStep=_state2.wizzardStep;var _props=this.props,campaign=_props.campaign,campaignList=_props.campaignList,campaignIndivCategories=_props.campaignIndivCategories,defaultIsraelFund=_props.defaultIsraelFund,defaultUSFund=_props.defaultUSFund,funds=_props.funds,loading=_props.loading,message=_props.message,recipientTypes=_props.recipientTypes,references=_props.references,show=_props.show;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:show},!showModals.createRecipientModal&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal add-participant-modal large-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},campaign?campaign.name:campaignList.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},'Add Recipient')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.onClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},wizzardStep===1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row flex-center'},newRecipient.applicantId?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Recipient'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,newRecipient.name)):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'search-input-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_AutoSuggestInput__["a" /* default */],{allowIncomplete:false,suggestions:this.props.recipientSuggestions.data,suggestionKey:'applicantId',suggestionValue:'name',getSuggestions:this.props.getRecipientSuggestions,clearSuggestions:this.props.clearRecipientSuggestions,loadingSuggestions:this.props.recipientSuggestions.loading,update:this.onSelectRecipient,suggestionAction:function suggestionAction(suggestion){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{className:'btn btn-primary input',target:"_blank",to:'/recipient-accounts/'+suggestion.applicantId},'View');}}),label:'Select Recipient',name:'recipient',value:recipient,required:true,showRequiredError:submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,newRecipient.applicantId?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:function onClick(){return _this3.setState({newRecipient:{}});}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-outline accent-text hover'})):loadingRecipientDetails?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:"-28px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'15',alignRight:true})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent2',onClick:function onClick(){_this3.setState({recipient:initialState.recipient,recipientHistory:initialState.recipientHistory},function(){return _this3.toggleModal("createRecipientModal");});}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-plus-empty icon-left'}),'Create'))),recipientHistory.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:"24px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:{fontWeight:"bold",marginBottom:"16px"}},'Application History'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'applications-list'},recipientHistory.map(function(application){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:application.applicationId,className:'application'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},application.reason||application.campaign),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},application.campaignIndividualCategory?application.campaignIndividualCategory:''),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},Object(__WEBPACK_IMPORTED_MODULE_15__lib_utils__["j" /* formatCurrency */])(application.amount,application.currency===__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["f" /* CurrencyTypes */].Shekel)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text accent-text'},Object(__WEBPACK_IMPORTED_MODULE_15__lib_utils__["k" /* formatDate */])(application.date)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_shared_ApplicationStatusTag__["a" /* default */],{status:application.status}));})))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CampaignRecipientApplication__["a" /* default */],{campaign:campaign,recipient:newRecipient.applicantId?newRecipient:recipient,references:references,recipientTypes:recipientTypes,campaignIndivCategories:campaignIndivCategories,israelFunds:funds.IL,usFunds:funds.US,defaultUSFund:defaultUSFund,defaultIsraelFund:defaultIsraelFund,submitAttempted:submitAttempted,dataErrors:dataErrors,onChange:this.onChange})),loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.onClose},'Cancel'),campaign&&wizzardStep===1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',disabled:!Object.keys(this.state.recipient).length&&!Object.keys(this.state.newRecipient).length,onClick:function onClick(){return _this3.setState({wizzardStep:2});}},'Continue'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',disabled:dataErrors.length,onClick:function onClick(){return _this3.onSubmit(false);}},'Submit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:error,message:message}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__campaignsCommon_CreateCampaignRecipientModal__["a" /* default */],{show:showModals.createRecipientModal,close:function close(){return _this3.toggleModal("createRecipientModal");},locationId:campaign?campaign.locationId:!campaignList.organizationName?campaignList.locationId:null,getRecipientSuggestions:this.props.getRecipientSuggestions,onContinue:function onContinue(recipient){return _this3.setState({newRecipient:{applicantId:recipient.id||recipient.applicantId,name:recipient.fullName||recipient.displayName,isIsraeli:recipient.isIsraeli,address:recipient.address,references:recipient.references,trustedPayee:recipient.trustedPayee}});},recipientType:campaignList&&(campaignList.campaignListType===__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["d" /* CampaignListTypes */].External||campaignList.organizationName)?__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["l" /* RecipientTypes */].Individual:this.props.recipientType}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_shared_WarningModal__["a" /* default */],{show:showModals.campaign60DayRuleAlertModal,close:function close(){return _this3.toggleModal("campaign60DayRuleAlertModal");},message:message,'continue':function _continue(){_this3.setState({checkCampaignRules:false},function(){return _this3.onSubmit(false);});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_shared_WarningModal__["a" /* default */],{show:showModals.campaignAddToActiveRuleAlertModal,close:function close(){return _this3.toggleModal("campaignAddToActiveRuleAlertModal");},message:message,confirmationMessage:"Do you want to add this participant to these campaign(s)?",cancelText:"No",continueText:"Yes",cancel:function cancel(){_this3.setState({checkCampaignRules:false},function(){return _this3.onSubmit(false);});},'continue':function _continue(){_this3.setState({checkCampaignRules:false},function(){return _this3.onSubmit(true);});}}));}}]);return AddCampaignRecipientModal;}(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (AddCampaignRecipientModal);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_CampaignListsActions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EditCampaignListModal__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={showModals:{editCampaignListModal:false}};var CampaignListInfo=function(_NavigationComponent){_inherits(CampaignListInfo,_NavigationComponent);function CampaignListInfo(props){_classCallCheck(this,CampaignListInfo);var _this=_possibleConstructorReturn(this,(CampaignListInfo.__proto__||Object.getPrototypeOf(CampaignListInfo)).call(this,props));_this.state=initialState;return _this;}_createClass(CampaignListInfo,[{key:'render',value:function render(){var campaignList=this.props.campaignList;var locationGroup=campaignList.locationId?this.props.locationGroups[this.props.locationGroups.map(function(loc){return loc.groupId.toString();}).indexOf(campaignList.locationId.toString())]:null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'page-header'},campaignList.name,campaignList.batch&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons ml-16 large-text'},'filter_none'),this.props.userPermissions.manage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn btn-primary btn-small icon-right',onClick:this.toggleModal.bind(this,"editCampaignListModal")},'Edit')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex campaign-header-icons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-home icon-left accent-text2'}),campaignList.fundName),locationGroup&&locationGroup.members.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-location-pin icon-left accent-text2'}),locationGroup.members.map(function(loc){return loc.city;}).join(', ')||locationGroup.members[0].country,' '),campaignList.allowDuplicates&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-check icon-left accent-text2'}),'Duplicates Enabled'),campaignList.managerName&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-user icon-left accent-text2'}),'Manager: ',campaignList.managerName),campaignList.managerEmail&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-envelope icon-left accent-text2'}),campaignList.managerEmail),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-pencil icon-left accent-text2'}),'Created by ',campaignList.createdBy,' on ',Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["k" /* formatDate */])(campaignList.createdOn)),campaignList.updatedOn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-refresh icon-left accent-text2'}),'Updated by ',campaignList.updatedBy,' on ',Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["k" /* formatDate */])(campaignList.updatedOn)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__EditCampaignListModal__["a" /* default */],Object.assign({show:this.state.showModals.editCampaignListModal,close:this.toggleModal.bind(this,"editCampaignListModal")},this.props.updateCampaignList,{isAdmin:this.props.userPermissions.admin,campaignList:campaignList,locations:this.props.locationGroups,ILFunds:this.props.funds.IL||[],USFunds:this.props.funds.US||[],updateCampaignList:this.props.actions.updateCampaignList})));}}]);return CampaignListInfo;}(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_NavigationComponent__["a" /* default */]);function mapStateToProps(state,ownProps){return Object.assign({},state.campaignListDetails,{locationGroups:state.settings.systemSettings.data.campaignSettings.locationGroups.filter(function(lg){return state.userProfile.profile.data.departments.indexOf(lg.department)>=0;}),funds:state.funds.fundsByDept,userPermissions:{admin:state.userProfile.profile.data.roleId===1,manage:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["j" /* PermissionTypes */].CampaignAndListsManage)>=0}});}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({updateCampaignList:__WEBPACK_IMPORTED_MODULE_3__redux_actions_CampaignListsActions__["updateCampaignList"]},dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CampaignListInfo));

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_RadioGroup__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Toggle__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BankAddress__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__settingComponents_systemSettings_paymentSettings_ReturnAddress__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StartingAmountInput__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commonComponents_util_CurrencyFormatInput__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_number_format__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_number_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_apiUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__FundReturnAddress__ = __webpack_require__(572);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FundModal=function(_React$Component){_inherits(FundModal,_React$Component);function FundModal(props){_classCallCheck(this,FundModal);var _this=_possibleConstructorReturn(this,(FundModal.__proto__||Object.getPrototypeOf(FundModal)).call(this,props));var fund=_this.props.fund;_this.initialState={fund:{fundName:fund&&fund.name?fund.name:'',active:fund&&typeof fund.active==='boolean'?fund.active:true,bankId:fund&&fund.bankId?fund.bankId:'',bankRoutingNumber:fund&&fund.bankRoutingNumber?fund.bankRoutingNumber:'',bankAddress:fund&&fund.bankAddress?fund.bankAddress:{},returnAddress:fund&&fund.returnAddress?fund.returnAddress:{},checkMemo:fund&&fund.checkMemo?fund.checkMemo:'',reportMemo:fund&&fund.reportMemo?fund.reportMemo:'',includeCampaignListOnCheck:fund&&fund.includeCampaignListOnCheck?fund.includeCampaignListOnCheck:false,allowACH:fund&&fund.allowACH?fund.allowACH:false,banquestSourceKey:fund&&fund.banquestSourceKey?fund.banquestSourceKey:'',banquestPin:fund&&fund.banquestPin?fund.banquestPin:'',accountNumber:fund&&fund.accountNumber?fund.accountNumber:'',startingAmount:fund?fund.startingAmount:'',startingDate:fund&&fund.startingDate?fund.startingDate:'',startingCheckNumber:fund&&fund.checkNumber?fund.checkNumber:'',department:fund&&fund.department?fund.department:__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].US,limitedApprovalMax:fund&&fund.limitedApprovalMax?fund.limitedApprovalMax:'',autoSignedCheckLimit:fund&&fund.autoSignedCheckLimit?fund.autoSignedCheckLimit:'',checkCuttingMax:fund&&fund.checkCuttingMax?fund.checkCuttingMax:'',wiringMax:fund&&fund.wiringMax?fund.wiringMax:'',frac1:'',frac2:''},editMode:!!(fund&&fund.fundId),submitAttempted:false,error:false,dataErrors:{}};_this.state=Object.assign({},_this.initialState,{showDecryptedSourceKey:false,showDecryptedPin:false,decryptedSourceKey:'',decryptedPin:'',loadingCredentials:false,originalSourceKey:fund&&fund.banquestSourceKey?fund.banquestSourceKey:'',originalPin:fund&&fund.banquestPin?fund.banquestPin:''});_this.onChange=_this.onChange.bind(_this);_this.toggleSourceKeyVisibility=_this.toggleSourceKeyVisibility.bind(_this);_this.togglePinVisibility=_this.togglePinVisibility.bind(_this);return _this;}_createClass(FundModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!Object(__WEBPACK_IMPORTED_MODULE_16__lib_utils__["e" /* deepEquals */])(nextProps.fund,this.props.fund)&&nextProps.fund.fundId){var fund=nextProps.fund;var fracNums=fund.fractionalNumber.split('-');this.initialState=Object.assign({},this.state,{fund:{fundName:nextProps.fund.name||'',active:typeof fund.active==='boolean'?fund.active:true,bankId:fund.bankId||'',bankRoutingNumber:fund.bankRoutingNumber||'',bankAddress:fund.bankAddress?fund.bankAddress:{},returnAddress:fund.returnAddress?fund.returnAddress:{},checkMemo:fund.checkMemo||'',reportMemo:fund.reportMemo||'',includeCampaignListOnCheck:fund.includeCampaignListOnCheck||false,allowACH:fund.allowACH||false,banquestSourceKey:fund.banquestSourceKey||'',banquestPin:fund.banquestPin||'',accountNumber:fund.accountNumber||'',startingAmount:fund.startingAmount||0,startingDate:fund.startingDate||'',startingCheckNumber:fund.checkNumber.toString()||'',department:fund.department||__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].US,limitedApprovalMax:fund.limitedApprovalMax||'',autoSignedCheckLimit:fund.autoSignedCheckLimit||'',checkCuttingMax:fund.checkCuttingMax||'',wiringMax:fund.wiringMax||'',frac1:fracNums[0],frac2:fracNums[1]},editMode:true});this.setState(Object.assign({},this.initialState,{originalSourceKey:fund.banquestSourceKey||'',originalPin:fund.banquestPin||''}));}}},{key:'onChange',value:function onChange(name,value){if(name==="department"&&value===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].IL){var _Object$assign;this.setState({fund:Object.assign({},this.state.fund,(_Object$assign={},_defineProperty(_Object$assign,name,value),_defineProperty(_Object$assign,'checkMemo',''),_defineProperty(_Object$assign,'startingCheckNumber',''),_Object$assign))});return;}if(name==="banquestSourceKey"||name==="banquestPin"){var newFund=Object.assign({},this.state.fund,_defineProperty({},name,value));if(!newFund.banquestSourceKey||!newFund.banquestPin){newFund.allowACH=false;}this.setState({fund:newFund});return;}this.setState({fund:Object.assign({},this.state.fund,_defineProperty({},name,value))});}},{key:'validateLength',value:function validateLength(name,length,value){var isValid=Object(__WEBPACK_IMPORTED_MODULE_16__lib_utils__["E" /* validateFieldLength */])(length,value);this.setState({dataErrors:Object.assign({},this.state.dataErrors,_defineProperty({},name,!isValid))});return isValid;}},{key:'onClose',value:function onClose(){this.props.close();this.setState(Object.assign({},this.initialState,{showDecryptedSourceKey:false,showDecryptedPin:false,decryptedSourceKey:'',decryptedPin:'',loadingCredentials:false,originalSourceKey:this.props.fund&&this.props.fund.banquestSourceKey?this.props.fund.banquestSourceKey:'',originalPin:this.props.fund&&this.props.fund.banquestPin?this.props.fund.banquestPin:''}));}},{key:'onSubmit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var fund;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({error:false,submitAttempted:true});fund=Object.assign({},this.state.fund);// Sync decrypted values back to the fund when visible
if(this.state.showDecryptedSourceKey){fund.banquestSourceKey=this.state.decryptedSourceKey||'';}if(this.state.showDecryptedPin){fund.banquestPin=this.state.decryptedPin||'';}if(!(!fund.fundName||!fund.bankId||!fund.frac1||!fund.frac2||!fund.bankRoutingNumber||!fund.bankAddress.streetNumber||!fund.bankAddress.street||!fund.bankAddress.city||!fund.bankAddress.country||!fund.accountNumber||!fund.startingAmount&&!fund.startingAmount===0||!fund.startingDate||fund.department===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].US&&!fund.startingCheckNumber||fund.department===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].US&&!fund.limitedApprovalMax&&this.props.userPermissions.admin||fund.department===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].US&&!fund.checkCuttingMax&&this.props.userPermissions.admin||fund.department===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].US&&!fund.autoSignedCheckLimit&&this.props.userPermissions.admin||fund.department===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].IL&&!fund.wiringMax)){_context.next=6;break;}return _context.abrupt('return');case 6:fund.fractionalNumber=fund.frac1+'-'+fund.frac2;delete fund.frac1;delete fund.frac2;if(this.state.editMode){fund.checkNumber=fund.startingCheckNumber;delete fund.startingCheckNumber;delete fund.startingAmount;delete fund.startingDate;delete fund.department;// For existing funds, only send credentials when visible (decrypted) to avoid re-encrypting masked values
if(!this.state.showDecryptedSourceKey){delete fund.banquestSourceKey;}if(!this.state.showDecryptedPin){delete fund.banquestPin;}}// No special handling for clears; rely on backend behavior
_context.next=12;return this.props.createFund(fund);case 12:if(this.props.success){this.onClose();}else{this.setState({error:true});}case 13:case'end':return _context.stop();}}},_callee,this);}));function onSubmit(){return _ref.apply(this,arguments);}return onSubmit;}()},{key:'fetchDecryptedCredentials',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!(!this.props.fund||!this.props.fund.fundId)){_context2.next=2;break;}return _context2.abrupt('return');case 2:this.setState({loadingCredentials:true});_context2.prev=3;_context2.next=6;return Object(__WEBPACK_IMPORTED_MODULE_15__lib_apiUtils__["b" /* getRequest */])('/funds/'+this.props.fund.fundId+'/credentials');case 6:result=_context2.sent;if(result.success){this.setState({decryptedSourceKey:result.data.sourceKey||'',decryptedPin:result.data.pin||'',loadingCredentials:false});}else{console.error('Failed to fetch decrypted credentials:',result.message);this.setState({loadingCredentials:false});}_context2.next=14;break;case 10:_context2.prev=10;_context2.t0=_context2['catch'](3);console.error('Error fetching decrypted credentials:',_context2.t0);this.setState({loadingCredentials:false});case 14:case'end':return _context2.stop();}}},_callee2,this,[[3,10]]);}));function fetchDecryptedCredentials(){return _ref2.apply(this,arguments);}return fetchDecryptedCredentials;}()},{key:'isSourceKeyModified',value:function isSourceKeyModified(){return this.state.fund.banquestSourceKey!==this.state.originalSourceKey;}},{key:'isPinModified',value:function isPinModified(){return this.state.fund.banquestPin!==this.state.originalPin;}},{key:'toggleSourceKeyVisibility',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var newVisibility,hasExistingCred;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:newVisibility=!this.state.showDecryptedSourceKey;// Hiding: sync decrypted value back into fund state
if(!(!newVisibility&&this.state.showDecryptedSourceKey)){_context3.next=4;break;}this.setState({showDecryptedSourceKey:newVisibility,fund:Object.assign({},this.state.fund,{banquestSourceKey:this.state.decryptedSourceKey})});return _context3.abrupt('return');case 4:if(!newVisibility){_context3.next=12;break;}hasExistingCred=!!(this.state.originalSourceKey||this.state.fund.banquestSourceKey);// If we have an existing credential but no decrypted value yet, fetch it
if(!(hasExistingCred&&!this.state.decryptedSourceKey&&this.props.fund&&this.props.fund.fundId)){_context3.next=9;break;}_context3.next=9;return this.fetchDecryptedCredentials();case 9:if(hasExistingCred){_context3.next=12;break;}this.setState({showDecryptedSourceKey:true,decryptedSourceKey:this.state.fund.banquestSourceKey||''});return _context3.abrupt('return');case 12:this.setState({showDecryptedSourceKey:newVisibility});case 13:case'end':return _context3.stop();}}},_callee3,this);}));function toggleSourceKeyVisibility(){return _ref3.apply(this,arguments);}return toggleSourceKeyVisibility;}()},{key:'togglePinVisibility',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var newVisibility,hasExistingCred;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:newVisibility=!this.state.showDecryptedPin;// Hiding: sync decrypted value back into fund state
if(!(!newVisibility&&this.state.showDecryptedPin)){_context4.next=4;break;}this.setState({showDecryptedPin:newVisibility,fund:Object.assign({},this.state.fund,{banquestPin:this.state.decryptedPin})});return _context4.abrupt('return');case 4:if(!newVisibility){_context4.next=12;break;}hasExistingCred=!!(this.state.originalPin||this.state.fund.banquestPin);if(!(hasExistingCred&&!this.state.decryptedPin&&this.props.fund&&this.props.fund.fundId)){_context4.next=9;break;}_context4.next=9;return this.fetchDecryptedCredentials();case 9:if(hasExistingCred){_context4.next=12;break;}this.setState({showDecryptedPin:true,decryptedPin:this.state.fund.banquestPin||''});return _context4.abrupt('return');case 12:this.setState({showDecryptedPin:newVisibility});case 13:case'end':return _context4.stop();}}},_callee4,this);}));function togglePinVisibility(){return _ref4.apply(this,arguments);}return togglePinVisibility;}()},{key:'render',value:function render(){var _this2=this;var _state=this.state,fund=_state.fund,submitAttempted=_state.submitAttempted;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal new-fund-modal large-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header',style:{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},this.state.editMode?'Edit':'New',' Fund'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center',gap:'8px',marginTop:'4px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label',style:{marginBottom:0}},'Active'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Toggle__["a" /* default */],{id:this.state.editMode?this.props.fund.fundId:'new-fund',name:'active',value:fund.active,onChange:this.onChange}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.onClose.bind(this)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'Fund Name',name:'fundName',value:fund.fundName,onChange:this.onChange,required:true,showRequiredError:submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-quarter'},this.state.editMode?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Starting Date'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',value:Object(__WEBPACK_IMPORTED_MODULE_16__lib_utils__["k" /* formatDate */])(fund.startingDate),disabled:true})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'date',max:'9999-12-31'}),label:'Starting Date',name:'startingDate',value:fund.startingDate,onChange:this.onChange,required:true,showRequiredError:submitAttempted}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-quarter'},this.state.editMode?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Starting Amount'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',value:Object(__WEBPACK_IMPORTED_MODULE_16__lib_utils__["j" /* formatCurrency */])(fund.startingAmount,fund.department===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].IL),disabled:true})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__StartingAmountInput__["a" /* default */],{isIsraeli:fund.department===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].IL}),name:'startingAmount',value:fund.startingAmount,onChange:this.onChange,label:'Starting Amount',required:true,showRequiredError:submitAttempted&&fund.startingAmount!=='0'&&!fund.startingAmount}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row fund-section-divider-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label',style:{fontWeight:'bold',fontSize:'14px'}},'Bank Info'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Select__["a" /* default */],{options:this.props.utils.banks}),label:'Bank',name:'bankId',value:fund.bankId,onChange:this.onChange,required:true,showRequiredError:submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label '+(submitAttempted&&(!fund.frac1||!fund.frac2)?"error-label":"")},'Bank Fractional No.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center flex-justify bank-fractional-no'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_number_format___default.a,{placeholder:'##',format:'##',onValueChange:function onValueChange(vals){return _this2.onChange('frac1',vals.value);}}),value:fund.frac1,required:true,showRequiredError:submitAttempted}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'-'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_number_format___default.a,{placeholder:'####',format:'####',onValueChange:function onValueChange(vals){return _this2.onChange('frac2',vals.value);}}),value:fund.frac2,required:true,showRequiredError:submitAttempted})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_number_format___default.a,{placeholder:'#########',format:'#########',onValueChange:function onValueChange(values){return _this2.onChange('bankRoutingNumber',values.value);}}),label:'Bank Routing Number',name:'bankRoutingNumber',value:fund.bankRoutingNumber,errorMessage:'Invalid Bank Routing Number',validated:true,showValidationError:true,validate:this.validateLength.bind(this,'routingNumber',9),required:true,showRequiredError:submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_number_format___default.a,{placeholder:'#########',format:'#########',onValueChange:function onValueChange(values){return _this2.onChange('accountNumber',values.value);}}),label:'Account No.',name:'accountNumber',value:fund.accountNumber,errorMessage:'Invalid Account Number',validated:true,showValidationError:true,validate:this.validateLength.bind(this,'accountNumber',9),required:true,showRequiredError:submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third'},this.state.editMode?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Department'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',value:fund.department,disabled:true})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_RadioGroup__["a" /* default */],{onChange:this.onChange,options:this.props.utils.departments,title:'Department',name:'department',value:fund.department}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__BankAddress__["a" /* default */],{address:fund.bankAddress,updateAddress:this.onChange.bind(this,'bankAddress'),showRequiredError:submitAttempted,addressLabel:Object(__WEBPACK_IMPORTED_MODULE_16__lib_utils__["c" /* concatenateGeosuggestLabel */])(fund.bankAddress,fund.department===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].IL)}),fund.department===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].US&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row fund-section-divider-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label',style:{fontWeight:'bold',fontSize:'14px'}},'Check Settings'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__FundReturnAddress__["a" /* default */],{address:fund.returnAddress,unitTypes:this.props.utils&&this.props.utils.unitTypes?this.props.utils.unitTypes:[],updateAddress:this.onChange.bind(this,'returnAddress'),showRequiredError:submitAttempted,addressLabel:Object(__WEBPACK_IMPORTED_MODULE_16__lib_utils__["c" /* concatenateGeosuggestLabel */])(fund.returnAddress,fund.department===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].IL)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_number_format___default.a,{placeholder:'######',format:'##########',onValueChange:function onValueChange(values){return _this2.onChange('startingCheckNumber',values.value);}}),label:this.state.editMode?"Check No.":"Starting Check No.",name:'startingCheckNumber',value:fund.startingCheckNumber,errorMessage:'Invalid Check Number',validated:true,showValidationError:true,validate:this.validateLength.bind(this,'startingCheckNumber',6),required:true,showRequiredError:submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Check Memo'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',name:'checkMemo',value:fund.checkMemo,onChange:function onChange(e){return _this2.onChange(e.target.name,e.target.value);}})))),fund.department===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].US&&this.props.userPermissions.admin&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_util_CurrencyFormatInput__["a" /* default */],{isIsraeli:fund.department===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].IL}),label:'Auto Signed Check Limit',name:'autoSignedCheckLimit',onChange:this.onChange,required:true,showRequiredError:submitAttempted,value:fund.autoSignedCheckLimit})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_util_CurrencyFormatInput__["a" /* default */],{isIsraeli:fund.department===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].IL}),label:'Max Check Amount',name:'checkCuttingMax',onChange:this.onChange,required:true,showRequiredError:submitAttempted,value:fund.checkCuttingMax})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_util_CurrencyFormatInput__["a" /* default */],{isIsraeli:fund.department===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].IL}),label:'Limited Approval Max',name:'limitedApprovalMax',onChange:this.onChange,required:true,showRequiredError:submitAttempted,value:fund.limitedApprovalMax}))),fund.department===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].IL&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_util_CurrencyFormatInput__["a" /* default */],{isIsraeli:fund.department===__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].IL}),label:'Wiring Max',name:'wiringMax',onChange:this.onChange,required:true,showRequiredError:submitAttempted,value:fund.wiringMax}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'includeCampaignList',className:'custom-check',name:'includeCampaignListOnCheck',onChange:function onChange(event){return _this2.onChange(event.target.name,event.target.checked);},checked:fund.includeCampaignListOnCheck}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'includeCampaignList',className:'input-label'},'Include campaign list on Check Memo')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row fund-section-divider-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label',style:{fontWeight:'bold',fontSize:'14px'}},'ACH Settings'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Banquest Source Key'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'input-with-button'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:this.state.showDecryptedSourceKey?"text":"password",name:'banquestSourceKey',value:this.state.showDecryptedSourceKey?this.state.decryptedSourceKey:fund.banquestSourceKey,onChange:function onChange(e){if(_this2.state.showDecryptedSourceKey){_this2.setState({decryptedSourceKey:e.target.value});_this2.onChange(e.target.name,e.target.value);}else if(!_this2.state.editMode){// Allow masked entry for new funds
_this2.onChange(e.target.name,e.target.value);}},readOnly:this.state.editMode?!this.state.showDecryptedSourceKey:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button',className:'eye-button',onClick:this.toggleSourceKeyVisibility,disabled:this.state.loadingCredentials,title:this.state.showDecryptedSourceKey?"Hide decrypted value":"Show decrypted value"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon '+(this.state.showDecryptedSourceKey?'ion-ios-eye':'ion-ios-eye-outline')})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Banquest PIN'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'input-with-button'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:this.state.showDecryptedPin?"text":"password",name:'banquestPin',value:this.state.showDecryptedPin?this.state.decryptedPin:fund.banquestPin,onChange:function onChange(e){if(_this2.state.showDecryptedPin){_this2.setState({decryptedPin:e.target.value});_this2.onChange(e.target.name,e.target.value);}else if(!_this2.state.editMode){// Allow masked entry for new funds
_this2.onChange(e.target.name,e.target.value);}},readOnly:this.state.editMode?!this.state.showDecryptedPin:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button',className:'eye-button',onClick:this.togglePinVisibility,disabled:this.state.loadingCredentials,title:this.state.showDecryptedPin?"Hide decrypted value":"Show decrypted value"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon '+(this.state.showDecryptedPin?'ion-ios-eye':'ion-ios-eye-outline')}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'allowACH',className:'custom-check',name:'allowACH',onChange:function onChange(event){return _this2.onChange(event.target.name,event.target.checked);},checked:fund.allowACH,disabled:!fund.banquestSourceKey||!fund.banquestPin}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'allowACH',className:'input-label '+(!fund.banquestSourceKey||!fund.banquestPin?'disabled':'')},'Allow ACH'))),this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.onClose.bind(this)},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',disabled:Object.keys(this.state.dataErrors).some(function(k){return _this2.state.dataErrors[k];})||Object(__WEBPACK_IMPORTED_MODULE_16__lib_utils__["e" /* deepEquals */])(this.initialState.fund,this.state.fund),onClick:this.onSubmit.bind(this)},this.state.editMode?'Update':'Submit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error})))));}}]);return FundModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (FundModal);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_geosuggest__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_geosuggest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_geosuggest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_GeoSuggestWrapper__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReturnAddress=function(_React$Component){_inherits(ReturnAddress,_React$Component);function ReturnAddress(props){_classCallCheck(this,ReturnAddress);var _this=_possibleConstructorReturn(this,(ReturnAddress.__proto__||Object.getPrototypeOf(ReturnAddress)).call(this,props));_this.noSuggestionsError='noSuggestionsError';_this.invalidAddressError='invalidAddressError';var initialAddress={streetNumber:_this.props.address.streetNumber||'',street:_this.props.address.street||'',apartment:_this.props.address.apartment||'',unitType:_this.props.address.unitType||'',city:_this.props.address.city||'',state:_this.props.address.state||'',zip:_this.props.address.zip||'',country:_this.props.address.country||''};_this.state={initialAddress:initialAddress,address:initialAddress,noSuggestionsError:false,invalidAddressError:false,addressLabel:_this.props.addressLabel||'',error:false};_this.clearNoSuggestions=_this.clearNoSuggestions.bind(_this);_this.updateSuggestions=_this.updateSuggestions.bind(_this);_this.noSuggestions=_this.noSuggestions.bind(_this);_this.onSuggestSelect=_this.onSuggestSelect.bind(_this);_this.updateErrors=_this.updateErrors.bind(_this);return _this;}_createClass(ReturnAddress,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var address=Object.assign({},nextProps.address);delete address.isManual;if(!Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["e" /* deepEquals */])(address,this.state.initialAddress)&&!Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["e" /* deepEquals */])(nextProps.address,{})){this.setState({address:address,initialAddress:address,addressLabel:nextProps.addressLabel});}}},{key:'clearNoSuggestions',value:function clearNoSuggestions(){if(this.state.noSuggestionsError)this.updateErrors(this.noSuggestionsError,false);if(this.state.invalidAddressError){this.updateErrors(this.invalidAddressError,false);}}},{key:'updateSuggestions',value:function updateSuggestions(suggestions){if(suggestions.length&&this.state.addressLabel)this.clearNoSuggestions();}},{key:'noSuggestions',value:function noSuggestions(){if(this._geoSuggest.props.value!==''){this.updateErrors(this.noSuggestionsError,true);}}},{key:'onBlur',value:function onBlur(){if((Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["e" /* deepEquals */])(this.state.address,{})||Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["e" /* deepEquals */])({streetNumber:this.state.address.streetNumber,street:this.state.address.street,city:this.state.address.city,state:this.state.address.state,zip:this.state.address.zip,country:this.state.address.country},{streetNumber:'',street:'',city:'',state:'',zip:'',country:''}))&&this.state.addressLabel&&!this.state.noSuggestionsError){this.updateErrors(this.invalidAddressError,true);}else if(this.state.invalidAddressError){this.updateErrors(this.invalidAddressError,false);}}},{key:'updateAddressLabel',value:function updateAddressLabel(e){this.setState({addressLabel:e,address:Object.assign({},this.state.address,{streetNumber:'',street:'',city:'',state:'',zip:'',country:''})});if(!e)this.clearNoSuggestions();}},{key:'onSuggestSelect',value:function onSuggestSelect(suggestion){if(suggestion&&suggestion.gmaps&&suggestion.gmaps.address_components){var address_components=suggestion.gmaps.address_components;var address=Object.assign({},this.state.address);address.streetNumber=address_components.find(function(obj){return obj.types.includes('street_number');})?address_components.find(function(obj){return obj.types.includes('street_number');}).long_name:'';address.street=address_components.find(function(obj){return obj.types.includes('route');})?address_components.find(function(obj){return obj.types.includes('route');}).long_name:'';address.city=address_components.find(function(obj){return obj.types.includes('locality');})?address_components.find(function(obj){return obj.types.includes('locality');}).long_name:''||address_components.find(function(obj){return obj.types.includes('sublocality');})?address_components.find(function(obj){return obj.types.includes('sublocality');}).long_name:'';address.state=address_components.find(function(obj){return obj.types.includes('administrative_area_level_1');})?address_components.find(function(obj){return obj.types.includes('administrative_area_level_1');}).long_name:'';address.country=address_components.find(function(obj){return obj.types.includes('country');})?address_components.find(function(obj){return obj.types.includes('country');}).long_name:'';address.zip=address_components.find(function(obj){return obj.types.includes('postal_code');})?address_components.find(function(obj){return obj.types.includes('postal_code');}).long_name:'';if(!address.streetNumber||!address.street){this.updateErrors(this.invalidAddressError,true);//set address to empty object and return
this.setState({addressLabel:Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["c" /* concatenateGeosuggestLabel */])(address,false),address:Object.assign({},this.state.address,{streetNumber:'',street:'',city:'',state:'',zip:'',country:''})});this._geoSuggest.blur();return;}else if(this.state.invalidAddressError){this.updateErrors(this.invalidAddressError,false);}this.setState({address:address,addressLabel:Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["c" /* concatenateGeosuggestLabel */])(address)});this._geoSuggest.blur();}}},{key:'updateAddressComponent',value:function updateAddressComponent(e){this.setState({address:Object.assign({},this.state.address,_defineProperty({},e.target.name,e.target.value))});}},{key:'updateErrors',value:function updateErrors(errorName,value){if(errorName===this.invalidAddressError&&!this.state.noSuggestionsError||errorName===this.noSuggestionsError){this.setState(_defineProperty({},errorName,value));}}},{key:'apply',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({error:false});_context.next=3;return this.props.update(Object.assign({},this.state.address,{isManual:false}));case 3:if(!this.props.success){this.setState({error:true});}case 4:case'end':return _context.stop();}}},_callee,this);}));function apply(){return _ref.apply(this,arguments);}return apply;}()},{key:'cancel',value:function cancel(){var address=Object.assign({},this.props.address);delete address.isManual;this.setState({initialAddress:address,address:address,error:false,addressLabel:Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["c" /* concatenateGeosuggestLabel */])(address,false)});}},{key:'render',value:function render(){var _this2=this;var validationErr=this.state.noSuggestionsError||this.state.invalidAddressError;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_GeoSuggestWrapper__["a" /* default */],{isIsraeli:false},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'address-autocomplete'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label '+(validationErr?"error-label":"")},'Return Address'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_geosuggest___default.a,{inputClassName:validationErr?"error-input":"",placeholder:'Enter Address',queryDelay:0,autoComplete:'on',ref:function ref(el){return _this2._geoSuggest=el;},value:this.state.addressLabel,onUpdateSuggests:this.updateSuggestions,onChange:this.updateAddressLabel.bind(this),onBlur:this.onBlur.bind(this),initialValue:this.state.addressLabel,onFocus:this.clearNoSuggestions,onSuggestSelect:this.onSuggestSelect,types:['address'],onSuggestNoResults:this.noSuggestions}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.noSuggestionsError,message:'No suggestions, use address not found.'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.invalidAddressError,message:'Invalid Address'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label input-label-small'},'Unit Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__["a" /* default */],{clearable:true,options:this.props.unitTypes,name:'unitType',value:this.state.address.unitType?this.state.address.unitType:'',onChange:this.updateAddressComponent.bind(this)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label input-label-small'},'Unit #'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',value:this.state.address.apartment||'',onChange:this.updateAddressComponent.bind(this),name:'apartment'})),!Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["e" /* deepEquals */])(this.state.initialAddress,this.state.address)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'settings-btns'},this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_LoadingSpinner__["a" /* default */],{height:20,loading:this.props.loading}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-small btn-primary icon-left',disabled:validationErr,onClick:this.apply.bind(this)},'Apply'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-small btn-accent',onClick:this.cancel.bind(this)},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error})))));}}]);return ReturnAddress;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ReturnAddress);

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mapDispatchToProps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_FundsActions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_SettingsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TransactionTypeModal__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_util_CurrencyFormatInput__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commonComponents_util_RadioGroup__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={error:false,transaction:{transactionType:__WEBPACK_IMPORTED_MODULE_15__lib_constants__["m" /* TransactionTypes */].Deposit,amount:"",description:"",date:"",withdrawalTypeId:null,depositSourceId:null,outsideTransactionOtherSource:""},transactionTypeForUpdate:null,submitAttempted:false,useTransactionOtherSource:false};var OutsideTransactionModal=function(_NavigationComponent){_inherits(OutsideTransactionModal,_NavigationComponent);function OutsideTransactionModal(props){var _this2=this;_classCallCheck(this,OutsideTransactionModal);var _this=_possibleConstructorReturn(this,(OutsideTransactionModal.__proto__||Object.getPrototypeOf(OutsideTransactionModal)).call(this,props));_this.save=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var transaction,transactionId,withdrawalTypeId,transFields;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({submitAttempted:true,error:false});transaction=_this.state.transaction;if(!(!transaction.amount||!transaction.description||!transaction.date||!transaction.withdrawalTypeId&&!transaction.depositSourceId&&!transaction.outsideTransactionOtherSource)){_context.next=4;break;}return _context.abrupt("return");case 4:if(!_this.props.transactionForUpdate){_context.next=10;break;}transactionId=transaction.transactionId,withdrawalTypeId=transaction.withdrawalTypeId,transFields=_objectWithoutProperties(transaction,["transactionId","withdrawalTypeId"]);_context.next=8;return _this.props.actions.updateTransactionDetails(_this.props.fundId,transactionId,Object.assign({},transFields,{withdrawalSourceId:withdrawalTypeId//Note - rename withdrawalTypeId to withdrawalSourceId for patch doc naming purposes
}));case 8:_context.next=12;break;case 10:_context.next=12;return _this.props.actions.createOutsideTransaction(_this.props.fundId,transaction);case 12:if(!_this.props.success){_this.setState({error:true});}else{if(_this.props.onSuccess)_this.props.onSuccess(transaction.transactionType);_this.close();}case 13:case"end":return _context.stop();}}},_callee,_this2);}));_this.saveTransactionType=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(value){var tagName,isUpdate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:tagName=_this.state.transaction.transactionType===__WEBPACK_IMPORTED_MODULE_15__lib_constants__["m" /* TransactionTypes */].Deposit?__WEBPACK_IMPORTED_MODULE_15__lib_constants__["l" /* TagNames */].DepositSources:__WEBPACK_IMPORTED_MODULE_15__lib_constants__["l" /* TagNames */].WithdrawalTypes;isUpdate=_this.state.transactionTypeForUpdate;if(!isUpdate){_context2.next=7;break;}_context2.next=5;return _this.props.actions.updateTag(tagName,value);case 5:_context2.next=9;break;case 7:_context2.next=9;return _this.props.actions.addTag(tagName,value);case 9:if(_this.props.systemSettings[tagName][isUpdate?"update":"add"].success){if(isUpdate){_this.props.onUpdateTransactionType();}else{if(tagName===__WEBPACK_IMPORTED_MODULE_15__lib_constants__["l" /* TagNames */].DepositSources){_this.setState({transaction:Object.assign({},_this.state.transaction,{depositSourceId:_this.props.systemSettings[__WEBPACK_IMPORTED_MODULE_15__lib_constants__["l" /* TagNames */].DepositSources].add.data?_this.props.systemSettings[__WEBPACK_IMPORTED_MODULE_15__lib_constants__["l" /* TagNames */].DepositSources].add.data.key:null})});}else{_this.setState({transaction:Object.assign({},_this.state.transaction,{withdrawalTypeId:_this.props.systemSettings[__WEBPACK_IMPORTED_MODULE_15__lib_constants__["l" /* TagNames */].WithdrawalTypes].add.data?_this.props.systemSettings[__WEBPACK_IMPORTED_MODULE_15__lib_constants__["l" /* TagNames */].WithdrawalTypes].add.data.key:null})});}}}case 10:case"end":return _context2.stop();}}},_callee2,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();_this.close=function(){_this.setState(initialState,_this.props.close);};_this.onChange=function(name,value){_this.setState({transaction:Object.assign({},_this.state.transaction,_defineProperty({},name,value))});};_this.onChangeTransactionSourceId=function(name,value){var _Object$assign2;var useTransactionOtherSource=value==="useTransactionOtherSource";_this.setState({transaction:Object.assign({},_this.state.transaction,(_Object$assign2={},_defineProperty(_Object$assign2,name,useTransactionOtherSource?null:value),_defineProperty(_Object$assign2,"outsideTransactionOtherSource",""),_Object$assign2)),useTransactionOtherSource:useTransactionOtherSource});};_this.updateTransactionType=function(name,value){var _Object$assign3;_this.setState({transaction:Object.assign({},_this.state.transaction,(_Object$assign3={},_defineProperty(_Object$assign3,name,value),_defineProperty(_Object$assign3,"withdrawalTypeId",null),_defineProperty(_Object$assign3,"depositSourceId",null),_defineProperty(_Object$assign3,"outsideTransactionOtherSource",""),_Object$assign3)),useTransactionOtherSource:false});};_this.state=Object.assign({showModals:{transactionTypeModal:false}},initialState);return _this;}_createClass(OutsideTransactionModal,[{key:"componentWillUpdate",value:function componentWillUpdate(nextProps){if(nextProps.show&&!this.props.show&&nextProps.transactionForUpdate){var _nextProps$transactio=nextProps.transactionForUpdate,amount=_nextProps$transactio.amount,date=_nextProps$transactio.date,depositSourceId=_nextProps$transactio.depositSourceId,description=_nextProps$transactio.description,outsideTransactionOtherSource=_nextProps$transactio.outsideTransactionOtherSource,transactionId=_nextProps$transactio.transactionId,type=_nextProps$transactio.type,withdrawalTypeId=_nextProps$transactio.withdrawalTypeId;this.setState({transaction:{transactionId:transactionId,transactionType:type||"",amount:amount||"",description:description||"",date:Object(__WEBPACK_IMPORTED_MODULE_16__lib_utils__["l" /* formatDateForInput */])(date)||"",withdrawalTypeId:withdrawalTypeId||null,depositSourceId:depositSourceId||null,outsideTransactionOtherSource:outsideTransactionOtherSource||""},useTransactionOtherSource:!!outsideTransactionOtherSource});}}},{key:"render",value:function render(){var _this3=this;var _state=this.state,transaction=_state.transaction,submitAttempted=_state.submitAttempted,useTransactionOtherSource=_state.useTransactionOtherSource;var transactionForUpdate=this.props.transactionForUpdate;var transactionIsReconciled=!!(transactionForUpdate&&transactionForUpdate.reconciliationId);var descriptionItems=["deposit by avi schron","deposit for shmaya","deposit from ofman","dividends paid from bank","donation income chaya cohen","donation income rubin schron","federal tax on dividends withheld","payroll","transfer from RS charity acct","wire to BMA Special- Israel","wire transfer"];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal new-transaction-modal large-modal"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-header"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",{className:"page-header"},transaction.transactionId?"Edit":"New"," Outside Transaction"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon ion-ios-close-empty",onClick:this.close})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_util_RadioGroup__["a" /* default */],{name:"transactionType",title:"Transaction Type",value:transaction.transactionType,options:[{key:__WEBPACK_IMPORTED_MODULE_15__lib_constants__["m" /* TransactionTypes */].Deposit,value:__WEBPACK_IMPORTED_MODULE_15__lib_constants__["m" /* TransactionTypes */].Deposit},{key:__WEBPACK_IMPORTED_MODULE_15__lib_constants__["m" /* TransactionTypes */].Withdrawal,value:__WEBPACK_IMPORTED_MODULE_15__lib_constants__["m" /* TransactionTypes */].Withdrawal}],onChange:this.updateTransactionType})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_util_CurrencyFormatInput__["a" /* default */],{disabled:transactionIsReconciled,isIsraeli:this.props.isIsraeli}),name:"amount",value:transaction.amount,onChange:this.onChange,required:true,showRequiredError:submitAttempted,label:"Amount "+(transactionIsReconciled?"*":"")})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",list:"description",name:"description"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("datalist",{id:"description"},descriptionItems.map(function(item,key){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option",{key:key,value:item});}))),label:"Description",name:"description",value:transaction.description,onChange:this.onChange,required:true,showRequiredError:submitAttempted})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{disabled:transactionIsReconciled,type:"date"}),value:transaction.date,name:"date",label:"Date "+(transactionIsReconciled?"*":""),onChange:this.onChange,required:true,showRequiredError:submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"link-text xs-text right lowercase-text",onClick:this.toggleModal.bind(this,"transactionTypeModal")},"Add New"),!!(transaction.depositSourceId||transaction.withdrawalTypeId)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon-pencil link-text right mr-8",onClick:function onClick(){return _this3.setState({transactionTypeForUpdate:transaction.depositSourceId?_this3.props.utils.depositSources.find(function(source){return source.key.toString()===transaction.depositSourceId.toString();}):transaction.withdrawalTypeId?_this3.props.utils.withdrawalTypes.find(function(source){return source.key.toString()===transaction.withdrawalTypeId.toString();}):null},_this3.toggleModal.bind(_this3,"transactionTypeModal"));},style:{borderBottom:"none"}}),transaction.transactionType===__WEBPACK_IMPORTED_MODULE_15__lib_constants__["m" /* TransactionTypes */].Deposit?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_util_Select__["a" /* default */],{options:[].concat(_toConsumableArray(this.props.utils.depositSources),[{key:"useTransactionOtherSource",value:"Other"}])}),label:"Deposit Source",name:"depositSourceId",value:useTransactionOtherSource?"useTransactionOtherSource":transaction.depositSourceId,onChange:this.onChangeTransactionSourceId,required:true,showRequiredError:submitAttempted}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_util_Select__["a" /* default */],{options:[].concat(_toConsumableArray(this.props.utils.withdrawalTypes),[{key:"useTransactionOtherSource",value:"Other"}])}),label:"Withdrawal Type",name:"withdrawalTypeId",value:useTransactionOtherSource?"useTransactionOtherSource":transaction.withdrawalTypeId,onChange:this.onChangeTransactionSourceId,required:true,showRequiredError:submitAttempted})))),useTransactionOtherSource&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text"}),label:"Other "+(transaction.transactionType===__WEBPACK_IMPORTED_MODULE_15__lib_constants__["m" /* TransactionTypes */].Deposit?"Deposit Source":"Withdrawal Type"),name:"outsideTransactionOtherSource",value:transaction.outsideTransactionOtherSource,onChange:this.onChange,required:true,showRequiredError:submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"}))),transactionIsReconciled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"accent-text xs-text"},"*This transaction is already marked as cleared. Please unclear it in order to edit the amount or date fields."),this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_util_LoadingSpinner__["a" /* default */],{height:20,alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-btns text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-accent",onClick:this.close},"Cancel"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-primary",onClick:this.save},"Save"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error,timeOut:5000})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TransactionTypeModal__["a" /* default */],{close:function close(){_this3.toggleModal("transactionTypeModal");if(_this3.state.transactionTypeForUpdate){_this3.setState({transactionTypeForUpdate:null});}},save:this.saveTransactionType,show:this.state.showModals.transactionTypeModal,title:transaction.transactionType===__WEBPACK_IMPORTED_MODULE_15__lib_constants__["m" /* TransactionTypes */].Deposit?"Deposit Source":"Withdrawal Type",transactionType:this.state.transactionTypeForUpdate,success:this.props.systemSettings[transaction.transactionType===__WEBPACK_IMPORTED_MODULE_15__lib_constants__["m" /* TransactionTypes */].Deposit?__WEBPACK_IMPORTED_MODULE_15__lib_constants__["l" /* TagNames */].DepositSources:__WEBPACK_IMPORTED_MODULE_15__lib_constants__["l" /* TagNames */].WithdrawalTypes][this.state.transactionTypeForUpdate?"update":"add"].success,loading:this.props.systemSettings[transaction.transactionType===__WEBPACK_IMPORTED_MODULE_15__lib_constants__["m" /* TransactionTypes */].Deposit?__WEBPACK_IMPORTED_MODULE_15__lib_constants__["l" /* TagNames */].DepositSources:__WEBPACK_IMPORTED_MODULE_15__lib_constants__["l" /* TagNames */].WithdrawalTypes][this.state.transactionTypeForUpdate?"update":"add"].loading,data:this.props.systemSettings[transaction.transactionType===__WEBPACK_IMPORTED_MODULE_15__lib_constants__["m" /* TransactionTypes */].Deposit?__WEBPACK_IMPORTED_MODULE_15__lib_constants__["l" /* TagNames */].DepositSources:__WEBPACK_IMPORTED_MODULE_15__lib_constants__["l" /* TagNames */].WithdrawalTypes][this.state.transactionTypeForUpdate?"update":"add"].data}));}}]);return OutsideTransactionModal;}(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_NavigationComponent__["a" /* default */]);function mapStateToProps(state,thisProps){return Object.assign({},state.fundDetails[thisProps.transactionForUpdate?"updateTransaction":"newOutsideTransaction"],{utils:{depositSources:state.settings.systemSettings.data.fundSettings.depositSources,withdrawalTypes:state.settings.systemSettings.data.fundSettings.withdrawalTypes},systemSettings:state.systemSettings});}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({createOutsideTransaction:__WEBPACK_IMPORTED_MODULE_4__redux_actions_FundsActions__["createOutsideTransaction"],updateTransactionDetails:__WEBPACK_IMPORTED_MODULE_4__redux_actions_FundsActions__["updateTransactionDetails"],addTag:__WEBPACK_IMPORTED_MODULE_5__redux_actions_SettingsActions__["addTag"],updateTag:__WEBPACK_IMPORTED_MODULE_5__redux_actions_SettingsActions__["updateTag"]},dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(OutsideTransactionModal));

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_CurrencyFormatInput__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_RadioGroup__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_clonedeep__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_clonedeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_clonedeep__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={adjustment:{amount:"",description:"",transactionType:__WEBPACK_IMPORTED_MODULE_6__lib_constants__["m" /* TransactionTypes */].Deposit},submitAttempted:false};var ReconciliationAdjustmentModal=function(_React$Component){_inherits(ReconciliationAdjustmentModal,_React$Component);function ReconciliationAdjustmentModal(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,ReconciliationAdjustmentModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ReconciliationAdjustmentModal.__proto__||Object.getPrototypeOf(ReconciliationAdjustmentModal)).call.apply(_ref,[this].concat(args))),_this),_this.state=__WEBPACK_IMPORTED_MODULE_7_lodash_clonedeep___default()(initialState),_this.save=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var adjustment;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({submitAttempted:true});adjustment=_this.state.adjustment;if(!(!adjustment.amount||!adjustment.transactionType)){_context.next=4;break;}return _context.abrupt("return");case 4:_this.props.submit(adjustment);_this.close();case 6:case"end":return _context.stop();}}},_callee,_this2);})),_this.close=function(){_this.setState(initialState,_this.props.close);},_this.onChange=function(name,value){_this.setState({adjustment:Object.assign({},_this.state.adjustment,_defineProperty({},name,value))});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ReconciliationAdjustmentModal,[{key:"componentWillUpdate",value:function componentWillUpdate(nextProps){if(nextProps.show&&!this.props.show&&nextProps.adjustment){var _nextProps$adjustment=nextProps.adjustment,amount=_nextProps$adjustment.amount,description=_nextProps$adjustment.description,transactionType=_nextProps$adjustment.transactionType;this.setState({adjustment:{amount:amount,description:description||"",transactionType:transactionType},submitAttempted:false});}}},{key:"render",value:function render(){var _this3=this;var _props=this.props,adjustmentEdit=_props.adjustment,isIsraeli=_props.isIsraeli,show=_props.show;var _state=this.state,adjustment=_state.adjustment,submitAttempted=_state.submitAttempted;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Modal__["a" /* default */],{modalShowing:show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal new-transaction-modal large-modal"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"bordered-modal-header"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",{className:"page-header"},adjustmentEdit?"Edit":"New"," Reconciliation Adjustment"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon ion-ios-close-empty",onClick:this.close})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_RadioGroup__["a" /* default */],{name:"transactionType",title:"Transaction Type",value:adjustment.transactionType,options:[{key:__WEBPACK_IMPORTED_MODULE_6__lib_constants__["m" /* TransactionTypes */].Deposit,value:__WEBPACK_IMPORTED_MODULE_6__lib_constants__["m" /* TransactionTypes */].Deposit},{key:__WEBPACK_IMPORTED_MODULE_6__lib_constants__["m" /* TransactionTypes */].Withdrawal,value:__WEBPACK_IMPORTED_MODULE_6__lib_constants__["m" /* TransactionTypes */].Withdrawal}],onChange:this.onChange})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_CurrencyFormatInput__["a" /* default */],{isIsraeli:isIsraeli}),name:"amount",value:adjustment.amount,onChange:this.onChange,required:true,showRequiredError:submitAttempted,label:"Amount"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"input-label"},"Description"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{name:"description",onChange:function onChange(e){return _this3.onChange(e.target.name,e.target.value);},type:"text",value:adjustment.description})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-btns text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-accent",onClick:this.close},"Cancel"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-primary",onClick:this.save},"Save")))));}}]);return ReconciliationAdjustmentModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ReconciliationAdjustmentModal);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Modal__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TransactionNoteModal=function(_React$Component){_inherits(TransactionNoteModal,_React$Component);function TransactionNoteModal(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,TransactionNoteModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TransactionNoteModal.__proto__||Object.getPrototypeOf(TransactionNoteModal)).call.apply(_ref,[this].concat(args))),_this),_this.state={error:false,text:""},_this.onChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.onClose=function(){_this.props.close();_this.setState({error:false,text:""});},_this.onSave=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this$props,save,saveAsync;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$props=_this.props,save=_this$props.save,saveAsync=_this$props.saveAsync;if(!saveAsync){_context.next=8;break;}_this.setState({error:false});_context.next=5;return saveAsync(_this.state.text);case 5:if(_this.props.success){_this.onClose();}else{_this.setState({error:true});}_context.next=10;break;case 8:save(_this.state.text);_this.onClose();case 10:case"end":return _context.stop();}}},_callee,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TransactionNoteModal,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.text!==this.props.text){this.setState({text:nextProps.text||""});}}},{key:"render",value:function render(){var _props=this.props,loading=_props.loading,initialText=_props.text;var _state=this.state,error=_state.error,text=_state.text;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal warning-modal"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-header"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",{className:"page-header"},initialText?"Edit":"New"," Reconciliation Note"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon ion-ios-close-empty",onClick:this.onClose.bind(this)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("textarea",{value:text,name:"text",onChange:this.onChange}),loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_LoadingSpinner__["a" /* default */],{height:"20",alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-btns text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-accent",onClick:this.onClose},"Cancel"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-primary",disabled:!text&&!initialText||text===initialText,onClick:this.onSave},"Save"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:error})))));}}]);return TransactionNoteModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (TransactionNoteModal);

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={approverId:'',submitAttempted:false};var ApproverReplacementModal=function(_React$Component){_inherits(ApproverReplacementModal,_React$Component);function ApproverReplacementModal(props){_classCallCheck(this,ApproverReplacementModal);var _this=_possibleConstructorReturn(this,(ApproverReplacementModal.__proto__||Object.getPrototypeOf(ApproverReplacementModal)).call(this,props));_this.state=initialState;return _this;}_createClass(ApproverReplacementModal,[{key:'onChange',value:function onChange(name,value){this.setState(_defineProperty({},name,value));}},{key:'onContinue',value:function onContinue(){this.setState({submitAttempted:true});if(!this.state.approverId)return;this.onClose(this.state.approverId);}},{key:'onClose',value:function onClose(approverId){this.setState(initialState);this.props.close(approverId);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal warning-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons middle'},'warning'),'Warning'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'medium-text'},this.props.user.name,' has approval permissions.  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bold-text'},'Please select a replacement approver before continuing.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__["a" /* default */],{options:this.props.approvers.filter(function(approver){return approver.key!==_this2.props.user.userId;})}),name:'approverId',value:this.state.approverId,onChange:this.onChange.bind(this),required:true,showRequiredError:this.state.submitAttempted}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'warning-modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-accent',onClick:function onClick(){return _this2.onClose();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-accent2',onClick:this.onContinue.bind(this)},'Continue')))));}}]);return ApproverReplacementModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ApproverReplacementModal);

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(35));

var _reactLifecyclesCompat = __webpack_require__(201);

var _PropTypes = __webpack_require__(202);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(201);

var _ChildMapping = __webpack_require__(609);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TagInput=function(_React$Component){_inherits(TagInput,_React$Component);function TagInput(props){var _this2=this;_classCallCheck(this,TagInput);var _this=_possibleConstructorReturn(this,(TagInput.__proto__||Object.getPrototypeOf(TagInput)).call(this,props));_this.clearErrorMessages=function(){var _this$state=_this.state,addingError=_this$state.addingError,deletingError=_this$state.deletingError,duplicateError=_this$state.duplicateError,errorMessage=_this$state.errorMessage,updatingError=_this$state.updatingError;if(addingError||deletingError||duplicateError||errorMessage||updatingError){_this.setState({addingError:false,deletingError:false,duplicateError:false,errorMessage:"",updatingError:false});}};_this.onUpdateTagClick=function(tag){if(_this.props.allowUpdate){_this.setState({tagForUpdate:tag,updatingError:false},function(){if(_this.editTagInput){_this.editTagInput.focus();}});}};_this.updateTag=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var tagForUpdate,tagPriorToUpdate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:tagForUpdate=_this.state.tagForUpdate;if(tagForUpdate){_context.next=3;break;}return _context.abrupt("return");case 3:tagPriorToUpdate=_this.props.values.find(function(t){return t.key===_this.state.tagForUpdate.key;});if(!(tagPriorToUpdate&&tagForUpdate.value===tagPriorToUpdate.value)){_context.next=6;break;}return _context.abrupt("return");case 6:_this.clearErrorMessages();if(!(_this.props.values.map(function(v){return v.value.toLowerCase();}).indexOf(tagForUpdate.value.toLowerCase())>-1)){_context.next=10;break;}_this.setState({duplicateError:true});return _context.abrupt("return");case 10:_context.next=12;return _this.props.update(tagForUpdate);case 12:if(_this.props.updating.success){_this.setState({tagForUpdate:null});}else{_this.setState({updatingError:true});}case 13:case"end":return _context.stop();}}},_callee,_this2);}));_this.state={addingError:false,deletingError:false,duplicateError:false,errorMessage:"",updatingError:false,newValue:"",tagForUpdate:null};return _this;}_createClass(TagInput,[{key:"onChange",value:function onChange(e){this.setState(_defineProperty({},e.target.name,e.target.value));if(this.state.duplicateError&&this.props.values.map(function(v){return v.value;}).indexOf(e.target.value)<=-1)this.setState({duplicateError:false});}},{key:"cancel",value:function cancel(){this.setState({newValue:"",duplicateError:false,addingError:false});}},{key:"save",value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(this.state.newValue){_context2.next=2;break;}return _context2.abrupt("return");case 2:this.clearErrorMessages();if(!(this.props.values.map(function(v){return v.value.toLowerCase();}).indexOf(this.state.newValue.toLowerCase())>-1)){_context2.next=6;break;}this.setState({duplicateError:true,addingError:false,deletingError:false,errorMessage:""});return _context2.abrupt("return");case 6:_context2.next=8;return this.props.add(this.state.newValue);case 8:if(this.props.adding.success){this.setState({newValue:""});}else{this.setState({addingError:true,duplicateError:false,deletingError:false,errorMessage:""});}case 9:case"end":return _context2.stop();}}},_callee2,this);}));function save(){return _ref2.apply(this,arguments);}return save;}()},{key:"remove",value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:this.clearErrorMessages();_context3.next=3;return this.props.delete(id);case 3:if(this.props.deleting[id]&&!this.props.deleting[id].success){if(this.props.deleting[id]&&this.props.deleting[id].message)this.setState({errorMessage:this.props.deleting[id].message});else this.setState({deletingError:true});}case 4:case"end":return _context3.stop();}}},_callee3,this);}));function remove(_x){return _ref3.apply(this,arguments);}return remove;}()},{key:"render",value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"input-label"},this.props.title),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"chip-container"},this.props.values.sort(function(a,b){return _this3.props.sort?a.value.toLowerCase().localeCompare(b.value.toLowerCase()):0;}).map(function(tag,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"chip",key:index,onDoubleClick:function onDoubleClick(){return _this3.onUpdateTagClick(tag);}},_this3.state.tagForUpdate&&_this3.state.tagForUpdate.key===tag.key?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{onBlur:function onBlur(){return _this3.setState({tagForUpdate:null});},onChange:function onChange(event){_this3.setState({tagForUpdate:Object.assign({},_this3.state.tagForUpdate,{value:event.target.value})});},onKeyDown:function onKeyDown(event){if(event.key==="Enter"){_this3.updateTag();}},ref:function ref(el){return _this3.editTagInput=el;},value:_this3.state.tagForUpdate.value}),_this3.props.updating.loading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_LoadingSpinner__["a" /* default */],{loading:true})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,tag.value),_this3.props.deleting[tag.key]&&_this3.props.deleting[tag.key].loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_LoadingSpinner__["a" /* default */],{loading:_this3.props.deleting[tag.key]&&_this3.props.deleting[tag.key].success}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"material-icons delete-chip",onClick:_this3.remove.bind(_this3,tag.key)},"close")));}),this.state.tagForUpdate?this.state.tagForUpdate.value!==(this.props.values.find(function(t){return t.key===_this3.state.tagForUpdate.key;})||{}).value&&!this.props.updating.loading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"xs-text accent-text"},"Press enter to save changes"):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",placeholder:"Add New",value:this.state.newValue,name:"newValue",onChange:this.onChange.bind(this),onKeyDown:function onKeyDown(e){if(e.key==="Enter")_this3.save();}}),this.props.adding.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_LoadingSpinner__["a" /* default */],{loading:this.props.adding.loading}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"tag-actions"},this.state.newValue&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{onClick:this.save.bind(this)},"Add"),this.state.newValue&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"accent-text",onClick:this.cancel.bind(this)},"Cancel"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.duplicateError,message:"Could not add duplicate "+this.props.name,timeOut:3000}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.addingError,message:"Could not add "+this.props.name,timeOut:3000}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.deletingError,timeOut:3000,message:"Could not delete "+this.props.name}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.updatingError,message:"Could not update "+this.props.name,timeOut:3000}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.errorMessage,timeOut:3000,message:this.state.errorMessage}));}}]);return TagInput;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (TagInput);

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(626);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _deepEqual = __webpack_require__(629);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _HelmetUtils = __webpack_require__(632);

var _HelmetConstants = __webpack_require__(206);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _deepEqual2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
            * @param {Object} bodyAttributes: {"className": "root"}
            * @param {String} defaultTitle: "Default Title"
            * @param {Boolean} defer: true
            * @param {Boolean} encodeSpecialCharacters: true
            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
            * @param {String} title: "Title"
            * @param {Object} titleAttributes: {"itemprop": "name"}
            * @param {String} titleTemplate: "MySite.com - %s"
            */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 206 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Enforces a single instance of the Raven client, and the
 * main entry point for Raven. If you are a consumer of the
 * Raven library, you SHOULD load this file (vs raven.js).
 **/

var RavenConstructor = __webpack_require__(640);

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _Raven = _window.Raven;

var Raven = new RavenConstructor();

/*
 * Allow multiple versions of Raven to be installed.
 * Strip Raven from the global context and returns the instance.
 *
 * @return {Raven}
 */
Raven.noConflict = function() {
  _window.Raven = _Raven;
  return Raven;
};

Raven.afterLoad();

module.exports = Raven;

/**
 * DISCLAIMER:
 *
 * Expose `Client` constructor for cases where user want to track multiple "sub-applications" in one larger app.
 * It's not meant to be used by a wide audience, so pleaaase make sure that you know what you're doing before using it.
 * Accidentally calling `install` multiple times, may result in an unexpected behavior that's very hard to debug.
 *
 * It's called `Client' to be in-line with Raven Node implementation.
 *
 * HOWTO:
 *
 * import Raven from 'raven-js';
 *
 * const someAppReporter = new Raven.Client();
 * const someOtherAppReporter = new Raven.Client();
 *
 * someAppReporter.config('__DSN__', {
 *   ...config goes here
 * });
 *
 * someOtherAppReporter.config('__OTHER_DSN__', {
 *   ...config goes here
 * });
 *
 * someAppReporter.captureMessage(...);
 * someAppReporter.captureException(...);
 * someAppReporter.captureBreadcrumb(...);
 *
 * someOtherAppReporter.captureMessage(...);
 * someOtherAppReporter.captureException(...);
 * someOtherAppReporter.captureBreadcrumb(...);
 *
 * It should "just work".
 */
module.exports.Client = RavenConstructor;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 208 */
/***/ (function(module, exports) {

/*
 json-stringify-safe
 Like JSON.stringify, but doesn't throw on circular references.

 Originally forked from https://github.com/isaacs/json-stringify-safe
 version 5.0.1 on 3/8/2017 and modified to handle Errors serialization
 and IE8 compatibility. Tests for this are in test/vendor.

 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
*/

exports = module.exports = stringify;
exports.getSerialize = serializer;

function indexOf(haystack, needle) {
  for (var i = 0; i < haystack.length; ++i) {
    if (haystack[i] === needle) return i;
  }
  return -1;
}

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}

// https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
function stringifyError(value) {
  var err = {
    // These properties are implemented as magical getters and don't show up in for in
    stack: value.stack,
    message: value.message,
    name: value.name
  };

  for (var i in value) {
    if (Object.prototype.hasOwnProperty.call(value, i)) {
      err[i] = value[i];
    }
  }

  return err;
}

function serializer(replacer, cycleReplacer) {
  var stack = [];
  var keys = [];

  if (cycleReplacer == null) {
    cycleReplacer = function(key, value) {
      if (stack[0] === value) {
        return '[Circular ~]';
      }
      return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']';
    };
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = indexOf(stack, this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);

      if (~indexOf(stack, value)) {
        value = cycleReplacer.call(this, key, value);
      }
    } else {
      stack.push(value);
    }

    return replacer == null
      ? value instanceof Error ? stringifyError(value) : value
      : replacer.call(this, key, value);
  };
}


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(210);
module.exports = __webpack_require__(215);


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(211).enable();
  window.Promise = __webpack_require__(213);
}

// fetch() polyfill for making API calls.
__webpack_require__(214);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(49);


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(113);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(113);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 214 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_reset_css__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_styles_css__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_toast_css__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_toast_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_toast_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__registerServiceWorker__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_store__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raven_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_loadPolyfills__ = __webpack_require__(646);
//configure sentry if not in production
if(true){__WEBPACK_IMPORTED_MODULE_10_raven_js___default.a.config('https://140870c8654346f58963383942f1cc83@sentry.io/1197093').install();}Object(__WEBPACK_IMPORTED_MODULE_11__lib_loadPolyfills__["a" /* default */])();__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_redux__["Provider"],{store:__WEBPACK_IMPORTED_MODULE_7__redux_store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_redux_toastr___default.a,{timeOut:6000,position:'top-right',transitionIn:'fadeIn',transitionOut:'fadeOut',progressBar:true}))),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_6__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(49),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(49),r=__webpack_require__(218);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(219);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__history__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layoutComponents_AuthRoute__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layoutComponents_404__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_authenticationComponents_LoginPage__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_authenticationComponents_VerifyLoginPage__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_authenticationComponents_PasswordResetPage__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_authenticationComponents_PasswordRecoveryPage__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_layoutComponents_Layout__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_layoutComponents_ExternalUserContainer__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_commonComponents_util_ErrorBoundary__ = __webpack_require__(639);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_commonComponents_util_ErrorBoundary__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Router */],{history:__WEBPACK_IMPORTED_MODULE_2__history__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_layoutComponents_AuthRoute__["a" /* default */],{exact:true,path:'/404',component:__WEBPACK_IMPORTED_MODULE_4__components_layoutComponents_404__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_layoutComponents_AuthRoute__["a" /* default */],{exact:true,path:'/login',component:__WEBPACK_IMPORTED_MODULE_5__components_authenticationComponents_LoginPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_layoutComponents_AuthRoute__["a" /* default */],{exact:true,path:'/verify-login',component:__WEBPACK_IMPORTED_MODULE_6__components_authenticationComponents_VerifyLoginPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_layoutComponents_AuthRoute__["a" /* default */],{exact:true,path:'/recover-password',component:__WEBPACK_IMPORTED_MODULE_8__components_authenticationComponents_PasswordRecoveryPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_layoutComponents_AuthRoute__["a" /* default */],{exact:true,path:'/reset-password',component:__WEBPACK_IMPORTED_MODULE_7__components_authenticationComponents_PasswordResetPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_layoutComponents_AuthRoute__["a" /* default */],{exact:true,path:'/set-password',component:__WEBPACK_IMPORTED_MODULE_7__components_authenticationComponents_PasswordResetPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/external-lists/:id',component:__WEBPACK_IMPORTED_MODULE_10__components_layoutComponents_ExternalUserContainer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_layoutComponents_AuthRoute__["a" /* default */],{path:'/',component:__WEBPACK_IMPORTED_MODULE_9__components_layoutComponents_Layout__["a" /* default */]}))));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(81);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(226);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(20);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(79);

var _PathUtils = __webpack_require__(50);

var _createTransitionManager = __webpack_require__(80);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(116);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(81);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(20);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(25);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(79);

var _PathUtils = __webpack_require__(50);

var _createTransitionManager = __webpack_require__(80);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(116);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(118);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(20);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(50);

var _LocationUtils = __webpack_require__(79);

var _createTransitionManager = __webpack_require__(80);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(117);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(234)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = prefix || defaultDelimiter
    var pattern = capture || group
    var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '')

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : restrictBacktrack(delimiter, prevText))
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

function restrictBacktrack(delimiter, prevText) {
  if (!prevText || prevText.indexOf(delimiter) > -1) {
    return '[^' + escapeString(delimiter) + ']+?'
  }

  return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?'
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(120);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(121);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(123);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(123);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHashHistory);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(83);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createMemoryHistory);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(124);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(125);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(60);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(126);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_AuthenticationActions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_UserProfileActions__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions_UtilsActions__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_constants__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AuthRoute=function(_React$Component){_inherits(AuthRoute,_React$Component);function AuthRoute(props){_classCallCheck(this,AuthRoute);var _this=_possibleConstructorReturn(this,(AuthRoute.__proto__||Object.getPrototypeOf(AuthRoute)).call(this,props));_this.state={ready:false};return _this;}_createClass(AuthRoute,[{key:'componentWillMount',value:function componentWillMount(){this.requestUserInfo();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var authRoute=this.isAuthRoute(nextProps.path);if(authRoute!==this.isAuthRoute(this.props.path)){this.setState({ready:false},this.requestUserInfo);}}},{key:'isAuthRoute',value:function isAuthRoute(route){return route==="/login"||route==="/verify-login"||route==="/recover-password"||route.indexOf("/reset-password")===0||route.indexOf("/set-password")===0;}},{key:'requestUserInfo',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.actions.getUserProfileAndPermissions();case 2:// Maybe only update if only belong to 1 department, cuz default is US and then won't mess up if on a specific page????
if(this.props.userProfile.departments&&this.props.userProfile.departments.length===1){if(this.props.userProfile.departments.indexOf(__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["g" /* Departments */].IL)>-1&&this.props.languageSettings.language!==__WEBPACK_IMPORTED_MODULE_9__lib_constants__["b" /* LanguageTypes */].Hebrew){window.google=undefined;this.props.actions.updateGeosuggestLanguageSettings({language:__WEBPACK_IMPORTED_MODULE_9__lib_constants__["b" /* LanguageTypes */].Hebrew,loading:true});}else if(this.props.userProfile.departments.indexOf(__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["g" /* Departments */].US)>-1&&this.props.languageSettings.language!==__WEBPACK_IMPORTED_MODULE_9__lib_constants__["b" /* LanguageTypes */].English){window.google=undefined;this.props.actions.updateGeosuggestLanguageSettings({language:__WEBPACK_IMPORTED_MODULE_9__lib_constants__["b" /* LanguageTypes */].English,loading:true});}}this.setState({ready:true});case 4:case'end':return _context.stop();}}},_callee,this);}));function requestUserInfo(){return _ref.apply(this,arguments);}return requestUserInfo;}()},{key:'render',value:function render(){var _this2=this;var _props=this.props,Component=_props.component,rest=_objectWithoutProperties(_props,['component']);var redirect=false,redirectPath="/";if(this.state.ready){var authRoute=this.isAuthRoute(this.props.location.pathname);redirect=authRoute?!!this.props.userProfile.userId:!this.props.userProfile.userId;redirectPath=authRoute?"/":"/login";}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],Object.assign({},rest,{render:function render(props){return _this2.state.ready?redirect?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{to:{pathname:redirectPath,state:Object.assign({},props.location.state,{from:props.location.pathname+props.location.search})}}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component,props):null;}}));}}]);return AuthRoute;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);function mapStateToProps(state,ownProps){return{userProfile:state.userProfile.profile.data,languageSettings:state.utils.geosuggestLanguageSettings};}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(Object.assign({},__WEBPACK_IMPORTED_MODULE_5__redux_actions_AuthenticationActions__,{getUserProfileAndPermissions:__WEBPACK_IMPORTED_MODULE_6__redux_actions_UserProfileActions__["getUserProfileAndPermissions"],updateGeosuggestLanguageSettings:__WEBPACK_IMPORTED_MODULE_7__redux_actions_UtilsActions__["a" /* updateGeosuggestLanguageSettings */]}),dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(AuthRoute));

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(246);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 246 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(84);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(268);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(135);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(256);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(254);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(18)))

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(132);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(258);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(261);


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(262);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18), __webpack_require__(52)(module)))

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(133);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(134);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(135);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(136);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(269);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(84);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(271);

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);
var bind = __webpack_require__(137);
var Axios = __webpack_require__(273);
var defaults = __webpack_require__(86);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(141);
axios.CancelToken = __webpack_require__(286);
axios.isCancel = __webpack_require__(140);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(287);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 272 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(86);
var utils = __webpack_require__(26);
var InterceptorManager = __webpack_require__(281);
var dispatchRequest = __webpack_require__(282);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(139);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);
var transformData = __webpack_require__(283);
var isCancel = __webpack_require__(140);
var defaults = __webpack_require__(86);
var isAbsoluteURL = __webpack_require__(284);
var combineURLs = __webpack_require__(285);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(141);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher) || [];

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReduxToastr = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(12);

var _classnames = __webpack_require__(38);

var _classnames2 = _interopRequireDefault(_classnames);

var _ToastrBox = __webpack_require__(291);

var _ToastrBox2 = _interopRequireDefault(_ToastrBox);

var _ToastrConfirm = __webpack_require__(295);

var _ToastrConfirm2 = _interopRequireDefault(_ToastrConfirm);

var _actions = __webpack_require__(142);

var actions = _interopRequireWildcard(_actions);

var _toastrEmitter = __webpack_require__(144);

var _utils = __webpack_require__(41);

var _constants = __webpack_require__(88);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var ReduxToastr = exports.ReduxToastr = function (_React$Component) {
  _inherits(ReduxToastr, _React$Component);

  function ReduxToastr(props) {
    _classCallCheck(this, ReduxToastr);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.toastrFired = {};
    _this.toastrPositions = ['top-left', 'top-right', 'top-center', 'bottom-left', 'bottom-right', 'bottom-center'];

    (0, _utils.updateConfig)(props);
    return _this;
  }

  ReduxToastr.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        add = _props.add,
        showConfirm = _props.showConfirm,
        clean = _props.clean,
        removeByType = _props.removeByType;

    _toastrEmitter.EE.on('toastr/confirm', showConfirm);
    _toastrEmitter.EE.on('add/toastr', add);
    _toastrEmitter.EE.on('clean/toastr', clean);
    _toastrEmitter.EE.on('removeByType/toastr', removeByType);
  };

  ReduxToastr.prototype.componentWillUnmount = function componentWillUnmount() {
    _toastrEmitter.EE.removeListener('toastr/confirm');
    _toastrEmitter.EE.removeListener('add/toastr');
    _toastrEmitter.EE.removeListener('clean/toastr');
    _toastrEmitter.EE.removeListener('removeByType/toastr');
    this.toastrFired = {};
  };

  ReduxToastr.prototype._addToMemory = function _addToMemory(id) {
    this.toastrFired[id] = true;
  };

  ReduxToastr.prototype._renderToastrForPosition = function _renderToastrForPosition(position) {
    var _this2 = this;

    var toastrs = this.props.toastr.toastrs;


    if (toastrs) {
      return toastrs.filter(function (item) {
        return item.position === position;
      }).map(function (item) {
        var mergedItem = _extends({}, item, {
          options: _extends({
            progressBar: _this2.props.progressBar,
            transitionIn: _this2.props.transitionIn,
            transitionOut: _this2.props.transitionOut
          }, item.options)
        });

        return _react2.default.createElement(
          'span',
          { key: item.id },
          _react2.default.createElement(_ToastrBox2.default, _extends({
            inMemory: _this2.toastrFired,
            addToMemory: function addToMemory() {
              return _this2._addToMemory(item.id);
            },
            item: mergedItem
          }, _this2.props)),
          item.options && item.options.attention && _react2.default.createElement('div', { onClick: function onClick() {
              return _this2.props.remove(item.id);
            }, className: 'toastr-attention' })
        );
      });
    }
  };

  ReduxToastr.prototype._renderToastrs = function _renderToastrs() {
    var _this3 = this;

    var toastr = this.props.toastr;

    var width = toastr.toastrs && toastr.toastrs[0] && toastr.toastrs[0].options && toastr.toastrs[0].options.width;
    var style = width ? { width: width } : {};
    return _react2.default.createElement(
      'span',
      null,
      this.toastrPositions.map(function (position) {
        return _react2.default.createElement(
          'div',
          { key: position, className: position, style: style },
          _this3._renderToastrForPosition(position)
        );
      })
    );
  };

  ReduxToastr.prototype.render = function render() {
    var _props2 = this.props,
        className = _props2.className,
        toastr = _props2.toastr;

    return _react2.default.createElement(
      'span',
      { className: (0, _classnames2.default)('redux-toastr', className), 'aria-live': 'assertive' },
      toastr.confirm && _react2.default.createElement(_ToastrConfirm2.default, _extends({
        confirm: toastr.confirm
      }, this.props)),
      this._renderToastrs()
    );
  };

  return ReduxToastr;
}(_react2.default.Component);

ReduxToastr.displayName = 'ReduxToastr';
ReduxToastr.propTypes = {
  toastr: _propTypes2.default.object,
  position: _propTypes2.default.string,
  newestOnTop: _propTypes2.default.bool,
  timeOut: _propTypes2.default.number,
  confirmOptions: _propTypes2.default.object,
  progressBar: _propTypes2.default.bool,
  transitionIn: _propTypes2.default.oneOf(_constants.TRANSITIONS.in),
  transitionOut: _propTypes2.default.oneOf(_constants.TRANSITIONS.out),
  preventDuplicates: _propTypes2.default.bool
};
ReduxToastr.defaultProps = {
  position: 'top-right',
  newestOnTop: true,
  timeOut: 5000,
  progressBar: false,
  transitionIn: _constants.TRANSITIONS.in[0],
  transitionOut: _constants.TRANSITIONS.out[0],
  preventDuplicates: false,
  confirmOptions: {
    okText: 'ok',
    cancelText: 'cancel'
  }
};
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    toastr: state.toastr ? state.toastr : state.get('toastr')
  };
}, actions)(ReduxToastr);

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(38);

var _classnames2 = _interopRequireDefault(_classnames);

var _ProgressBar = __webpack_require__(292);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _Icon = __webpack_require__(293);

var _Icon2 = _interopRequireDefault(_Icon);

var _utils = __webpack_require__(41);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); } //  eslint-disable-line no-unused-vars


var ToastrBox = function (_React$Component) {
  _inherits(ToastrBox, _React$Component);

  function ToastrBox(props) {
    _classCallCheck(this, ToastrBox);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    var _props$item$options = props.item.options,
        transitionIn = _props$item$options.transitionIn,
        transitionOut = _props$item$options.transitionOut;


    _this.isHiding = false;
    _this.shouldClose = false;
    _this.intervalId = null;
    _this.ignoreIsHiding = false;

    _this.transitionIn = transitionIn || _this.props.transitionIn;
    _this.transitionOut = transitionOut || _this.props.transitionOut;

    _this.state = { progressBar: null };

    (0, _utils._bind)(['renderSubComponent', 'renderIcon', 'renderToastr', 'renderCloseButton', 'renderMessage', '_onAnimationComplete', '_removeToastr', '_setTransition', '_clearTransition', '_setIntervalId', '_setIsHiding', '_setShouldClose'], _this);
    return _this;
  }

  ToastrBox.prototype.componentDidMount = function componentDidMount() {
    var item = this.props.item;

    if (this.props.inMemory[item.id]) return;

    var timeOut = this._getItemTimeOut();

    if (timeOut) {
      this._setIntervalId(setTimeout(this._removeToastr, timeOut));
    }

    if (timeOut && item.options.progressBar) {
      this.setState({ progressBar: { duration: this._getItemTimeOut() } });
    }

    this._setTransition();
    (0, _utils.onCSSTransitionEnd)(this.toastrBoxElement, this._onAnimationComplete);
    this.props.addToMemory(item.id);
  };

  ToastrBox.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.intervalId) {
      clearTimeout(this.intervalId);
    }
  };

  ToastrBox.prototype.handleClick = function handleClick() {
    var onCloseButtonClick = this.props.item.options.onCloseButtonClick;

    this.ignoreIsHiding = true;

    if (onCloseButtonClick) {
      onCloseButtonClick();
    }

    this._setShouldClose(true);
    this._removeToastr();
  };

  ToastrBox.prototype.mouseEnter = function mouseEnter() {
    clearTimeout(this.intervalId);

    this._setIntervalId(null);
    this._setIsHiding(false);

    var progressBar = this.props.item.options.progressBar;

    var timeOut = this._getItemTimeOut();

    if (timeOut && progressBar) {
      this.setState({ progressBar: null });
    }
  };

  ToastrBox.prototype.mouseLeave = function mouseLeave() {
    var removeOnHover = this.props.item.options.removeOnHover;


    if (!this.isHiding && (removeOnHover || this.shouldClose)) {
      var interval = removeOnHover === true ? 1000 : removeOnHover;
      this._setIntervalId(setTimeout(this._removeToastr, interval));

      var progressBar = this.props.item.options.progressBar;

      var timeOut = this._getItemTimeOut();

      if (timeOut && progressBar) {
        this.setState({ progressBar: { duration: interval } });
      }
    }
  };

  ToastrBox.prototype.renderSubComponent = function renderSubComponent() {
    var _this2 = this;

    var _props$item = this.props.item,
        id = _props$item.id,
        options = _props$item.options;


    var removeCurrentToastrFunc = function removeCurrentToastrFunc() {
      return _this2.props.remove(id);
    };

    if ((0, _react.isValidElement)(options.component)) {
      return _react2.default.cloneElement(options.component, {
        remove: removeCurrentToastrFunc
      });
    }

    return _react2.default.createElement(options.component, { remove: removeCurrentToastrFunc });
  };

  ToastrBox.prototype.renderIcon = function renderIcon() {
    var _props$item2 = this.props.item,
        type = _props$item2.type,
        options = _props$item2.options;


    if ((0, _react.isValidElement)(options.icon)) {
      return _react2.default.cloneElement(options.icon);
    }

    var iconName = type === 'light' ? options.icon : type;
    return _react2.default.createElement(_Icon2.default, { name: iconName });
  };

  ToastrBox.prototype.renderCloseButton = function renderCloseButton() {
    return _react2.default.createElement(
      'button',
      {
        type: 'button',
        className: 'close-toastr',
        onClick: this.handleClick.bind(this)
      },
      '\u2715'
    );
  };

  ToastrBox.prototype.renderToastr = function renderToastr() {
    var _props$item3 = this.props.item,
        type = _props$item3.type,
        options = _props$item3.options,
        message = _props$item3.message,
        title = _props$item3.title;


    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: 'rrt-left-container' },
        _react2.default.createElement(
          'div',
          { className: 'rrt-holder' },
          this.renderIcon()
        )
      ),
      options.status && type === 'light' && _react2.default.createElement('div', { className: (0, _classnames2.default)('toastr-status', options.status) }),
      _react2.default.createElement(
        'div',
        { className: 'rrt-middle-container' },
        title && _react2.default.createElement(
          'div',
          { className: 'rrt-title' },
          title
        ),
        message && _react2.default.createElement(
          'div',
          { className: 'rrt-text' },
          message
        ),
        options.component && this.renderSubComponent()
      ),
      _react2.default.createElement(
        'div',
        { className: 'rrt-right-container' },
        options.showCloseButton && this.renderCloseButton()
      ),
      this.state.progressBar ? _react2.default.createElement(_ProgressBar2.default, this.state.progressBar) : null
    );
  };

  ToastrBox.prototype.renderMessage = function renderMessage() {
    var _props$item4 = this.props.item,
        title = _props$item4.title,
        message = _props$item4.message,
        options = _props$item4.options;


    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: 'rrt-title' },
        title,
        this.renderCloseButton()
      ),
      _react2.default.createElement(
        'div',
        { className: 'rrt-text' },
        message,
        options.component && this.renderSubComponent()
      )
    );
  };

  ToastrBox.prototype.toastr = function toastr() {
    if (this.props.item.type === 'message') {
      return this.renderMessage();
    }

    return this.renderToastr();
  };

  ToastrBox.prototype._getItemTimeOut = function _getItemTimeOut() {
    var item = this.props.item;
    var timeOut = item.options.timeOut;

    if (typeof timeOut === 'undefined') {
      timeOut = this.props.timeOut;
    }

    return timeOut;
  };

  ToastrBox.prototype._onAnimationComplete = function _onAnimationComplete() {
    var _props = this.props,
        remove = _props.remove,
        item = _props.item;
    var options = item.options,
        id = item.id;


    if (this.isHiding || this.ignoreIsHiding) {
      this._setIsHiding(false);
      this.ignoreIsHiding = false;
      remove(id);
      if (options.onHideComplete) {
        options.onHideComplete();
      }
    } else if (!this.isHiding && options.onShowComplete) {
      options.onShowComplete();
    }
  };

  ToastrBox.prototype._removeToastr = function _removeToastr() {
    if (!this.isHiding) {
      this._setIsHiding(true);
      this._setTransition(true);
      (0, _utils.onCSSTransitionEnd)(this.toastrBoxElement, this._onAnimationComplete);
    }
  };

  ToastrBox.prototype._setTransition = function _setTransition(hide) {
    var _this3 = this;

    var animationType = hide ? this.transitionOut : this.transitionIn;

    var onEndListener = function onEndListener(e) {
      if (e && e.target == _this3.toastrBoxElement) {
        _this3.toastrBoxElement.classList.remove(animationType);
      }
    };

    (0, _utils.onCSSTransitionEnd)(this.toastrBoxElement, onEndListener);
    this.toastrBoxElement.classList.add(animationType);
  };

  ToastrBox.prototype._clearTransition = function _clearTransition() {
    this.toastrBoxElement.classList.remove(this.transitionIn, this.transitionOut);
  };

  ToastrBox.prototype._setIntervalId = function _setIntervalId(intervalId) {
    this.intervalId = intervalId;
  };

  ToastrBox.prototype._setIsHiding = function _setIsHiding(val) {
    this.isHiding = val;
  };

  ToastrBox.prototype._setShouldClose = function _setShouldClose(val) {
    this.shouldClose = val;
  };

  ToastrBox.prototype.render = function render() {
    var _this4 = this;

    var _props$item5 = this.props.item,
        options = _props$item5.options,
        type = _props$item5.type;


    return _react2.default.createElement(
      'div',
      {
        ref: function ref(_ref) {
          return _this4.toastrBoxElement = _ref;
        },
        className: (0, _classnames2.default)('toastr', 'animated', 'rrt-' + type, options.className),
        onMouseEnter: this.mouseEnter.bind(this),
        onMouseLeave: this.mouseLeave.bind(this)
      },
      this.toastr()
    );
  };

  return ToastrBox;
}(_react2.default.Component);

ToastrBox.displayName = 'ToastrBox';
ToastrBox.propTypes = {
  item: _propTypes2.default.shape({
    options: _propTypes2.default.shape({
      transitionIn: _propTypes2.default.string,
      transitionOut: _propTypes2.default.string
    })
  })
};
exports.default = ToastrBox;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var ProgressBar = function (_React$Component) {
  _inherits(ProgressBar, _React$Component);

  function ProgressBar(props) {
    _classCallCheck(this, ProgressBar);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = { percent: 100 };
    _this.intervalId = null;
    return _this;
  }

  ProgressBar.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var distance = 100 / (this.props.duration / 10);
    this.intervalId = setInterval(function () {
      var percent = _this2.state.percent - distance;

      _this2.setState({ percent: percent > 0 ? percent : 0 });
    }, 10);
  };

  ProgressBar.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.state.percent <= 0 && this.intervalId) {
      clearTimeout(this.intervalId);
    }
  };

  ProgressBar.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.intervalId) {
      clearTimeout(this.intervalId);
    }
  };

  ProgressBar.prototype.render = function render() {
    var percent = this.state.percent;


    return _react2.default.createElement(
      'div',
      { className: 'rrt-progress-container' },
      _react2.default.createElement('div', { className: 'rrt-progressbar', style: { width: percent + '%' } })
    );
  };

  return ProgressBar;
}(_react2.default.Component);

ProgressBar.displayName = 'ProgressBar';
ProgressBar.propTypes = {
  duration: _propTypes2.default.number.isRequired
};
exports.default = ProgressBar;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(38);

var _classnames2 = _interopRequireDefault(_classnames);

var _icons = __webpack_require__(294);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Icon = function (_React$Component) {
  _inherits(Icon, _React$Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Icon.prototype.render = function render() {
    var size = this.props.size;

    var styles = {
      width: size,
      height: size
    };

    return _react2.default.createElement(
      'svg',
      {
        className: (0, _classnames2.default)(this.props.className, 'toastr-icon'),
        xmlns: 'http://www.w3.org/2000/svg',
        preserveAspectRatio: 'xMidYMid meet',
        viewBox: '0 0 ' + this.props.size + ' ' + this.props.size,
        style: styles
      },
      (0, _icons2.default)(this.props.name)
    );
  };

  return Icon;
}(_react2.default.Component);

Icon.displayName = 'ReduxToastrIcon';
Icon.defaultProps = {
  size: 32
};
exports.default = Icon;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (name) {
  switch (name) {
    case 'success':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { d: 'M27 4l-15 15-7-7-5 5 12 12 20-20z' })
      );
    case 'info':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { d: 'M14 9.5c0-0.825 0.675-1.5 1.5-1.5h1c0.825 0 1.5 0.675 1.5 1.5v1c0 0.825-0.675 1.5-1.5 1.5h-1c-0.825 0-1.5-0.675-1.5-1.5v-1z' }),
        _react2.default.createElement('path', { d: 'M20 24h-8v-2h2v-6h-2v-2h6v8h2z' }),
        _react2.default.createElement('path', { d: 'M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 29c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13z' })
      );
    case 'warning':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { d: 'M16 2.899l13.409 26.726h-26.819l13.409-26.726zM16 0c-0.69 0-1.379 0.465-1.903 1.395l-13.659 27.222c-1.046 1.86-0.156 3.383 1.978 3.383h27.166c2.134 0 3.025-1.522 1.978-3.383h0l-13.659-27.222c-0.523-0.93-1.213-1.395-1.903-1.395v0z' }),
        _react2.default.createElement('path', { d: 'M18 26c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z' }),
        _react2.default.createElement('path', { d: 'M16 22c-1.105 0-2-0.895-2-2v-6c0-1.105 0.895-2 2-2s2 0.895 2 2v6c0 1.105-0.895 2-2 2z' })
      );
    case 'error':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { d: 'M12,0C5.373,0,0,5.373,0,12s5.373,12,12,12s12-5.373,12-12S18.627,0,12,0z M12,19.66 c-0.938,0-1.58-0.723-1.58-1.66c0-0.964,0.669-1.66,1.58-1.66c0.963,0,1.58,0.696,1.58,1.66C13.58,18.938,12.963,19.66,12,19.66z M12.622,13.321c-0.239,0.815-0.992,0.829-1.243,0c-0.289-0.956-1.316-4.585-1.316-6.942c0-3.11,3.891-3.125,3.891,0 C13.953,8.75,12.871,12.473,12.622,13.321z' })
      );
    default:
      return null;
  }
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(41);

var _Button = __webpack_require__(296);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var ENTER = 13;
var ESC = 27;

var ToastrConfirm = function (_React$Component) {
  _inherits(ToastrConfirm, _React$Component);

  function ToastrConfirm(props) {
    _classCallCheck(this, ToastrConfirm);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    var _this$props = _this.props,
        confirmOptions = _this$props.confirmOptions,
        confirm = _this$props.confirm;
    var _confirm$options = confirm.options,
        okText = _confirm$options.okText,
        cancelText = _confirm$options.cancelText,
        transitionIn = _confirm$options.transitionIn,
        transitionOut = _confirm$options.transitionOut,
        disableCancel = _confirm$options.disableCancel;


    _this.okText = okText || confirmOptions.okText;
    _this.cancelText = cancelText || confirmOptions.cancelText;
    _this.transitionIn = transitionIn || confirmOptions.transitionIn || props.transitionIn;
    _this.transitionOut = transitionOut || confirmOptions.transitionOut || props.transitionOut;
    _this.disableCancel = disableCancel || confirmOptions.disableCancel;
    (0, _utils._bind)('setTransition removeConfirm handleOnKeyUp handleOnKeyDown', _this);
    _this.isKeyDown = false;
    return _this;
  }

  ToastrConfirm.prototype.componentDidMount = function componentDidMount() {
    this.isHiding = false;
    this.hasClicked = false;
    this.confirmHolderElement.focus();

    if (this.props.confirm.show) {
      this.setTransition(true);
    }
  };

  ToastrConfirm.prototype.handleOnKeyDown = function handleOnKeyDown(e) {
    if ((0, _utils.keyCode)(e) == ENTER) {
      e.preventDefault();
    }
    this.isKeyDown = true;
  };

  ToastrConfirm.prototype.handleButtonClick = function handleButtonClick(callback) {
    var _this2 = this;

    if (this.hasClicked) return;
    this.hasClicked = true;

    var onAnimationEnd = function onAnimationEnd() {
      _this2.removeConfirm();
      if (callback) {
        callback();
      }
    };

    this.setTransition();
    (0, _utils.onCSSTransitionEnd)(this.confirmElement, onAnimationEnd);
  };

  ToastrConfirm.prototype.handleConfirmClick = function handleConfirmClick() {
    var callback = this.props.confirm.options ? this.props.confirm.options.onOk : null;
    this.handleButtonClick(callback);
  };

  ToastrConfirm.prototype.handleCancelClick = function handleCancelClick() {
    var callback = this.props.confirm.options ? this.props.confirm.options.onCancel : null;
    this.handleButtonClick(callback);
  };

  ToastrConfirm.prototype.setTransition = function setTransition(add) {
    if (add) {
      this.isHiding = false;
      this.confirmElement.classList.add(this.transitionIn);
      if ((0, _utils.isBrowser)()) return document.querySelector('body').classList.add('toastr-confirm-active');
    }

    this.isHiding = true;
    this.confirmElement.classList.remove(this.transitionIn);
    this.confirmElement.classList.add(this.transitionOut);
  };

  ToastrConfirm.prototype.removeConfirm = function removeConfirm() {
    this.isHiding = false;
    this.props.hideConfirm();
    if ((0, _utils.isBrowser)()) return document.querySelector('body').classList.remove('toastr-confirm-active');
  };

  ToastrConfirm.prototype.handleOnKeyUp = function handleOnKeyUp(e) {
    var code = (0, _utils.keyCode)(e);
    if (code == ESC && !this.disableCancel) {
      this.handleCancelClick();
    } else if (code == ESC && this.disableCancel) {
      this.handleConfirmClick();
    } else if (code == ENTER && this.isKeyDown) {
      this.isKeyDown = false;
      this.handleConfirmClick();
    }
  };

  ToastrConfirm.prototype.containsOkButton = function containsOkButton(buttons) {
    return buttons && buttons.filter(function (button) {
      return button.ok === true;
    }).length > 0;
  };

  ToastrConfirm.prototype.containsCancelButton = function containsCancelButton(buttons) {
    return buttons && buttons.filter(function (button) {
      return button.cancel === true;
    }).length > 0;
  };

  ToastrConfirm.prototype.getCustomButtonHandler = function getCustomButtonHandler(config) {
    var _this3 = this;

    if (config.ok === true) {
      return this.handleConfirmClick.bind(this);
    }
    if (config.cancel === true) {
      return this.handleCancelClick.bind(this);
    }
    return function () {
      return _this3.handleButtonClick(config.handler);
    };
  };

  ToastrConfirm.prototype.getCustomButtonText = function getCustomButtonText(config) {
    if (config.ok === true) {
      return this.okText;
    }
    if (config.cancel === true) {
      return this.cancelText;
    }
    return config.text;
  };

  ToastrConfirm.prototype.getCustomButtonClassName = function getCustomButtonClassName(config) {
    if (config.ok === true) {
      return 'rrt-ok-btn';
    }
    if (config.cancel === true) {
      return 'rrt-cancel-btn';
    }
    return config.className;
  };

  ToastrConfirm.prototype.render = function render() {
    var _this4 = this;

    var _props$confirm = this.props.confirm,
        options = _props$confirm.options,
        message = _props$confirm.message;


    return _react2.default.createElement(
      'div',
      {
        className: 'rrt-confirm-holder',
        tabIndex: '-1',
        ref: function ref(_ref2) {
          return _this4.confirmHolderElement = _ref2;
        },
        onKeyDown: this.handleOnKeyDown,
        onKeyUp: this.handleOnKeyUp,
        role: 'alert'
      },
      _react2.default.createElement(
        'div',
        { className: 'rrt-confirm animated', ref: function ref(_ref) {
            return _this4.confirmElement = _ref;
          } },
        message && _react2.default.createElement(
          'div',
          { className: 'rrt-message' },
          message
        ),
        options.component && _react2.default.createElement(options.component, null),
        _react2.default.createElement(
          'div',
          { className: 'rrt-buttons-holder' },
          !this.containsOkButton(options.buttons) && _react2.default.createElement(
            _Button2.default,
            { className: 'rrt-ok-btn', onClick: function onClick() {
                return _this4.handleConfirmClick();
              } },
            this.okText
          ),
          !this.disableCancel && !this.containsCancelButton(options.buttons) && _react2.default.createElement(
            _Button2.default,
            { className: 'rrt-cancel-btn', onClick: this.handleCancelClick.bind(this) },
            this.cancelText
          ),
          options.buttons && options.buttons.map(function (button, index) {
            if (button.cancel === true && _this4.disableCancel) {
              return null;
            }

            var handler = _this4.getCustomButtonHandler(button);
            var text = _this4.getCustomButtonText(button);
            var className = _this4.getCustomButtonClassName(button);

            return _react2.default.createElement(
              _Button2.default,
              { className: className, onClick: handler, key: index },
              text
            );
          })
        )
      ),
      _react2.default.createElement('div', { className: 'shadow' })
    );
  };

  return ToastrConfirm;
}(_react2.default.Component);

ToastrConfirm.displayName = 'ToastrConfirm';
ToastrConfirm.propTypes = {
  confirm: _propTypes2.default.shape({
    options: _propTypes2.default.shape({
      transitionIn: _propTypes2.default.string,
      transitionOut: _propTypes2.default.string
    })
  })
};
exports.default = ToastrConfirm;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(props) {
  return _react2.default.createElement(
    'button',
    { type: 'button', onClick: function onClick() {
        return props.onClick();
      }, className: 'rrt-button ' + props.className },
    props.children
  );
};

Button.displayName = 'ReduxConfirmButton';

exports.default = Button;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AuthenticationReducer__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SettingsReducer__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SystemSettingsReducer__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SuggestionsReducer__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ApplicationsReducer__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CheckPrintingReducer__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CreateApplicationReducer__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RecipientAccountsReducer__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RecipientAccountDetailsReducer__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ReferencesReducer__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DuplicateRecipientsReducer__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SidebarFiltersReducer__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CampaignsReducer__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__CampaignDetailsReducer__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CampaignListsReducer__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__CampaignListDetailsReducer__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CampaignListApplicationsReducer__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ExternalCampaignListReducer__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__FundsReducer__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__FundDetailsReducer__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ReconciliationReportsReducer__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__TableReducer__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__InfiniteListReducer__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__UserProfileReducer__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__UsersReducer__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__UtilsReducer__ = __webpack_require__(332);
var appReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({authentication:__WEBPACK_IMPORTED_MODULE_3__AuthenticationReducer__["a" /* default */],settings:__WEBPACK_IMPORTED_MODULE_4__SettingsReducer__["a" /* default */],systemSettings:__WEBPACK_IMPORTED_MODULE_5__SystemSettingsReducer__["a" /* default */],suggestions:__WEBPACK_IMPORTED_MODULE_6__SuggestionsReducer__["a" /* default */],applications:__WEBPACK_IMPORTED_MODULE_7__ApplicationsReducer__["a" /* default */],checkPrinting:__WEBPACK_IMPORTED_MODULE_8__CheckPrintingReducer__["a" /* default */],recipientAccounts:__WEBPACK_IMPORTED_MODULE_10__RecipientAccountsReducer__["a" /* default */],recipientAccountDetails:__WEBPACK_IMPORTED_MODULE_11__RecipientAccountDetailsReducer__["a" /* default */],references:__WEBPACK_IMPORTED_MODULE_12__ReferencesReducer__["a" /* default */],duplicateRecipients:__WEBPACK_IMPORTED_MODULE_13__DuplicateRecipientsReducer__["a" /* default */],createApplication:__WEBPACK_IMPORTED_MODULE_9__CreateApplicationReducer__["a" /* default */],applicationsSidebarFilters:Object(__WEBPACK_IMPORTED_MODULE_14__SidebarFiltersReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["j" /* TableNames */].Applications),recipientsSidebarFilters:Object(__WEBPACK_IMPORTED_MODULE_14__SidebarFiltersReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["j" /* TableNames */].Recipients),campaigns:__WEBPACK_IMPORTED_MODULE_15__CampaignsReducer__["a" /* default */],campaignDetails:__WEBPACK_IMPORTED_MODULE_16__CampaignDetailsReducer__["a" /* default */],campaignLists:__WEBPACK_IMPORTED_MODULE_17__CampaignListsReducer__["a" /* default */],campaignListDetails:__WEBPACK_IMPORTED_MODULE_18__CampaignListDetailsReducer__["a" /* default */],campaignListApplications:__WEBPACK_IMPORTED_MODULE_19__CampaignListApplicationsReducer__["a" /* default */],externalCampaignList:__WEBPACK_IMPORTED_MODULE_20__ExternalCampaignListReducer__["a" /* default */],funds:__WEBPACK_IMPORTED_MODULE_21__FundsReducer__["a" /* default */],fundDetails:__WEBPACK_IMPORTED_MODULE_22__FundDetailsReducer__["a" /* default */],reconciliationReports:__WEBPACK_IMPORTED_MODULE_23__ReconciliationReportsReducer__["a" /* default */],userProfile:__WEBPACK_IMPORTED_MODULE_26__UserProfileReducer__["a" /* default */],users:__WEBPACK_IMPORTED_MODULE_27__UsersReducer__["a" /* default */],toastr:__WEBPACK_IMPORTED_MODULE_28_react_redux_toastr__["reducer"],utils:__WEBPACK_IMPORTED_MODULE_29__UtilsReducer__["a" /* default */],applicationsTable:Object(__WEBPACK_IMPORTED_MODULE_24__TableReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["j" /* TableNames */].Applications),recipientsTable:Object(__WEBPACK_IMPORTED_MODULE_24__TableReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["j" /* TableNames */].Recipients),referencesTable:Object(__WEBPACK_IMPORTED_MODULE_24__TableReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["j" /* TableNames */].References),duplicateRecipientsTable:Object(__WEBPACK_IMPORTED_MODULE_24__TableReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["j" /* TableNames */].DuplicateRecipients),campaignsTable:Object(__WEBPACK_IMPORTED_MODULE_24__TableReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["j" /* TableNames */].Campaigns),campaignListsTable:Object(__WEBPACK_IMPORTED_MODULE_24__TableReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["j" /* TableNames */].CampaignLists),campaignListParticipantsTable:Object(__WEBPACK_IMPORTED_MODULE_24__TableReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["j" /* TableNames */].CampaignListParticipants),campaignListApplicationsTable:Object(__WEBPACK_IMPORTED_MODULE_24__TableReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["j" /* TableNames */].CampaignListApplications),campaignDetailsListsTable:Object(__WEBPACK_IMPORTED_MODULE_24__TableReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["j" /* TableNames */].CampaignDetailsLists),campaignDetailsIndividualsTable:Object(__WEBPACK_IMPORTED_MODULE_24__TableReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["j" /* TableNames */].CampaignDetailsIndividuals),accountingTransactionsTable:Object(__WEBPACK_IMPORTED_MODULE_24__TableReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["j" /* TableNames */].AccountingTransactions),accountingOutsideTransactionsTable:Object(__WEBPACK_IMPORTED_MODULE_24__TableReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["j" /* TableNames */].AccountingOutsideTransactions),usersTable:Object(__WEBPACK_IMPORTED_MODULE_24__TableReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["j" /* TableNames */].Users),externalCampaignListParticipantsList:Object(__WEBPACK_IMPORTED_MODULE_25__InfiniteListReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["j" /* TableNames */].ExternalCampaignListParticipants),reconciliationPaymentsTable:Object(__WEBPACK_IMPORTED_MODULE_25__InfiniteListReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["j" /* TableNames */].ReconciliationPayments),reconciliationCreditsTable:Object(__WEBPACK_IMPORTED_MODULE_25__InfiniteListReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["j" /* TableNames */].ReconciliationCredits),receivingParticipantsTable:Object(__WEBPACK_IMPORTED_MODULE_25__InfiniteListReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__lib_constants__["j" /* TableNames */].ReceivingParticipants)});var rootReducer=function rootReducer(state,action){if(action.type===__WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["LOGOUT_SUCCESS"]){state=undefined;}return appReducer(state,action);};/* harmony default export */ __webpack_exports__["a"] = (rootReducer);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
var initialState={login:{success:true,loading:false,message:'',data:{}},verifyLogin:{success:true,loading:false,message:''},logout:{success:true,loading:false},recoverPassword:{success:true,loading:false},resetPassword:{success:true,loading:false,expired:false}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_LOGIN"]:return Object.assign({},state,{login:Object.assign({},initialState.login,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["LOGIN"]:return Object.assign({},state,{login:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_VERIFY_LOGIN"]:return Object.assign({},state,{verifyLogin:Object.assign({},initialState.verifyLogin,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["VERIFY_LOGIN"]:return Object.assign({},state,{verifyLogin:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_LOGOUT"]:return Object.assign({},state,{logout:Object.assign({},initialState.logout,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["LOGOUT"]:return Object.assign({},state,{logout:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_RECOVER_PASSWORD"]:return Object.assign({},state,{recoverPassword:Object.assign({},initialState.recoverPassword,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["RECOVER_PASSWORD"]:return Object.assign({},state,{recoverPassword:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_RESET_PASSWORD"]:return Object.assign({},state,{resetPassword:Object.assign({},initialState.resetPassword,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["RESET_PASSWORD"]:return Object.assign({},state,{resetPassword:action.response});default:return state;}});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_constants__ = __webpack_require__(11);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={updateTimestamp:null,systemSettings:{fetched:false,loading:false,success:true,data:{applicationSettings:{individualApplicationReasons:[],organizationApplicationReasons:[]},campaignSettings:{categories:[],campaignIndivCategories:[],fromEmailAddress:[],locationGroups:[],years:[],months:[]},fundSettings:{banks:[],defaultIsraelFund:null,defaultUSFund:null,depositSources:[],withdrawalTypes:[]},otherSettings:{applicationStatuses:[],campaignCategories:[],campaignListStatuses:[],streetNames:[],cities:[],currencyTypes:[],departments:[],nationalities:[],orgEmploymentTypes:[],permissionTypes:[],previousEmploymentTypes:[],recipientStatuses:[],recipientTypes:[],roles:[],unitTypes:[]},paymentSettings:{returnAddress:{},signatures:[],currencyConversionRate:{}},printSettings:{cardTypes:[],cloudPrintIsAuthorized:false,cloudPrintUserName:""},recipientSettings:{individualTags:[],organizationTags:[],usPersonTitles:[],israelPersonTitles:[],usInstitutionTitles:[],israelInstitutionTitles:[]}},reloading:{allSettings:{loading:false,success:true},paymentSettings:{loading:false,success:true},recipientSettings:{loading:false,success:true},applicationSettings:{loading:false,success:true},campaignSettings:{loading:false,success:true},fundSettings:{loading:false,success:true},printSettings:{loading:false,success:true},otherSettings:{loading:false,success:true}}},printers:{fetched:false,loading:false,success:true,message:"",data:[]}};function getSystemSettingsStateAfterAddition(state,settingCategoryName,settingName,updatedSetting){return Object.assign({},state,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,_defineProperty({},settingCategoryName,Object.assign({},state.systemSettings.data[settingCategoryName],_defineProperty({},settingName,[].concat(_toConsumableArray(state.systemSettings.data[settingCategoryName][settingName]),[updatedSetting])))))})});}function getSystemSettingsStateAfterUpdate(state,settingCategoryName,settingName,updatedSetting){var updatedSettings=[].concat(_toConsumableArray(state.systemSettings.data[settingCategoryName][settingName]));var updatedSettingIndex=updatedSettings.map(function(settingTag){return settingTag.key;}).indexOf(updatedSetting.key);if(updatedSettingIndex>=0){updatedSettings[updatedSettingIndex]=updatedSetting;}return Object.assign({},state,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,_defineProperty({},settingCategoryName,Object.assign({},state.systemSettings.data[settingCategoryName],_defineProperty({},settingName,updatedSettings))))})});}/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var updatedState=Object.assign({},state,{updateTimestamp:Date.now()});switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_SYSTEM_SETTINGS"]:return Object.assign({},state,{systemSettings:Object.assign({},state.systemSettings,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_SYSTEM_SETTINGS"]:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,action.response,{data:Object.assign({},state.systemSettings.data,action.response.data),fetched:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_PARTIAL_SYSTEM_SETTINGS"]:return Object.assign({},state,{systemSettings:Object.assign({},state.systemSettings,{reloading:Object.assign({},state.systemSettings.reloading,_defineProperty({},action.setting,Object.assign({},state.systemSettings.reloading[action.setting],{loading:true})))})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_PARTIAL_SYSTEM_SETTINGS"]:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{reloading:Object.assign({},state.systemSettings.reloading,_defineProperty({},action.setting,{loading:false,success:action.response.success})),data:action.response.success?Object.assign({},state.systemSettings.data,_defineProperty({},action.setting,action.response.data[action.setting])):Object.assign({},state.systemSettings.data)})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_PRINTERS"]:return Object.assign({},state,{printers:Object.assign({},initialState.printers,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_PRINTERS"]:return Object.assign({},state,{printers:Object.assign({},state.printers,action.response,{fetched:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["ADD_TAG"]:if(!action.response.success)return state;switch(action.tagName){case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].IndividualTags:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{recipientSettings:Object.assign({},state.systemSettings.data.recipientSettings,{individualTags:[].concat(_toConsumableArray(state.systemSettings.data.recipientSettings.individualTags),[action.response.data])})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].OrganizationTags:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{recipientSettings:Object.assign({},state.systemSettings.data.recipientSettings,{organizationTags:[].concat(_toConsumableArray(state.systemSettings.data.recipientSettings.organizationTags),[action.response.data])})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].IndividualApplicationReasons:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{applicationSettings:Object.assign({},state.systemSettings.data.applicationSettings,{individualApplicationReasons:[].concat(_toConsumableArray(state.systemSettings.data.applicationSettings.individualApplicationReasons),[action.response.data])})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].OrganizationApplicationReasons:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{applicationSettings:Object.assign({},state.systemSettings.data.applicationSettings,{organizationApplicationReasons:[].concat(_toConsumableArray(state.systemSettings.data.applicationSettings.organizationApplicationReasons),[action.response.data])})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].USPersonTitles:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{recipientSettings:Object.assign({},state.systemSettings.data.recipientSettings,{usPersonTitles:[].concat(_toConsumableArray(state.systemSettings.data.recipientSettings.usPersonTitles),[action.response.data])})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].IsraelPersonTitles:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{recipientSettings:Object.assign({},state.systemSettings.data.recipientSettings,{israelPersonTitles:[].concat(_toConsumableArray(state.systemSettings.data.recipientSettings.israelPersonTitles),[action.response.data])})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].USInstitutionTitles:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{recipientSettings:Object.assign({},state.systemSettings.data.recipientSettings,{usInstitutionTitles:[].concat(_toConsumableArray(state.systemSettings.data.recipientSettings.usInstitutionTitles),[action.response.data])})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].IsraelInstitutionTitles:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{recipientSettings:Object.assign({},state.systemSettings.data.recipientSettings,{israelInstitutionTitles:[].concat(_toConsumableArray(state.systemSettings.data.recipientSettings.israelInstitutionTitles),[action.response.data])})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].Banks:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{fundSettings:Object.assign({},state.systemSettings.data.fundSettings,{banks:[].concat(_toConsumableArray(state.systemSettings.data.fundSettings.banks),[action.response.data])})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].CardTypes:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{printSettings:Object.assign({},state.systemSettings.data.printSettings,{cardTypes:[].concat(_toConsumableArray(state.systemSettings.data.printSettings.cardTypes),[action.response.data])})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].CampaignCategories:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{campaignSettings:Object.assign({},state.systemSettings.data.campaignSettings,{categories:[].concat(_toConsumableArray(state.systemSettings.data.campaignSettings.categories),[action.response.data])})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].CampaignIndivCategories:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{campaignSettings:Object.assign({},state.systemSettings.data.campaignSettings,{campaignIndivCategories:[].concat(_toConsumableArray(state.systemSettings.data.campaignSettings.campaignIndivCategories),[action.response.data])})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].LocationGroups:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{campaignSettings:Object.assign({},state.systemSettings.data.campaignSettings,{locationGroups:[].concat(_toConsumableArray(state.systemSettings.data.campaignSettings.locationGroups),[action.response.data])})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].WithdrawalTypes:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{fundSettings:Object.assign({},state.systemSettings.data.fundSettings,{withdrawalTypes:[].concat(_toConsumableArray(state.systemSettings.data.fundSettings.withdrawalTypes),[action.response.data])})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].DepositSources:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{fundSettings:Object.assign({},state.systemSettings.data.fundSettings,{depositSources:[].concat(_toConsumableArray(state.systemSettings.data.fundSettings.depositSources),[action.response.data])})})})});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_TAG"]:if(!action.response.success)return state;switch(action.tagName){case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].WithdrawalTypes:return getSystemSettingsStateAfterUpdate(updatedState,"fundSettings","withdrawalTypes",action.response.data);case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].DepositSources:return getSystemSettingsStateAfterUpdate(updatedState,"fundSettings","depositSources",action.response.data);case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].USPersonTitles:return getSystemSettingsStateAfterUpdate(updatedState,"recipientSettings","usPersonTitles",action.response.data);case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].IsraelPersonTitles:return getSystemSettingsStateAfterUpdate(updatedState,"recipientSettings","israelPersonTitles",action.response.data);case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].USInstitutionTitles:return getSystemSettingsStateAfterUpdate(updatedState,"recipientSettings","usInstitutionTitles",action.response.data);case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].IsraelInstitutionTitles:return getSystemSettingsStateAfterUpdate(updatedState,"recipientSettings","israelInstitutionTitles",action.response.data);default:return state;}case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["DELETE_TAG"]:if(!action.response.success)return state;var index=void 0,tags=[];switch(action.tagName){case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].IndividualTags:tags=[].concat(_toConsumableArray(state.systemSettings.data.recipientSettings.individualTags));index=tags.map(function(tag){return tag.key;}).indexOf(action.tagId);if(index>-1)tags.splice(index,1);return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{recipientSettings:Object.assign({},state.systemSettings.data.recipientSettings,{individualTags:tags})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].OrganizationTags:tags=[].concat(_toConsumableArray(state.systemSettings.data.recipientSettings.organizationTags));index=tags.map(function(tag){return tag.key;}).indexOf(action.tagId);if(index>-1)tags.splice(index,1);return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{recipientSettings:Object.assign({},state.systemSettings.data.recipientSettings,{organizationTags:tags})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].IndividualApplicationReasons:tags=[].concat(_toConsumableArray(state.systemSettings.data.applicationSettings.individualApplicationReasons));index=tags.map(function(tag){return tag.key;}).indexOf(action.tagId);if(index>-1)tags.splice(index,1);return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{applicationSettings:Object.assign({},state.systemSettings.data.applicationSettings,{individualApplicationReasons:tags})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].OrganizationApplicationReasons:tags=[].concat(_toConsumableArray(state.systemSettings.data.applicationSettings.organizationApplicationReasons));index=tags.map(function(tag){return tag.key;}).indexOf(action.tagId);if(index>-1)tags.splice(index,1);return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{applicationSettings:Object.assign({},state.systemSettings.data.applicationSettings,{organizationApplicationReasons:tags})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].USPersonTitles:tags=[].concat(_toConsumableArray(state.systemSettings.data.recipientSettings.usPersonTitles));index=tags.map(function(tag){return tag.key;}).indexOf(action.tagId);if(index>-1)tags.splice(index,1);return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{recipientSettings:Object.assign({},state.systemSettings.data.recipientSettings,{usPersonTitles:tags})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].IsraelPersonTitles:tags=[].concat(_toConsumableArray(state.systemSettings.data.recipientSettings.israelPersonTitles));index=tags.map(function(tag){return tag.key;}).indexOf(action.tagId);if(index>-1)tags.splice(index,1);return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{recipientSettings:Object.assign({},state.systemSettings.data.recipientSettings,{israelPersonTitles:tags})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].USInstitutionTitles:tags=[].concat(_toConsumableArray(state.systemSettings.data.recipientSettings.usInstitutionTitles));index=tags.map(function(tag){return tag.key;}).indexOf(action.tagId);if(index>-1)tags.splice(index,1);return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{recipientSettings:Object.assign({},state.systemSettings.data.recipientSettings,{usInstitutionTitles:tags})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].IsraelInstitutionTitles:tags=[].concat(_toConsumableArray(state.systemSettings.data.recipientSettings.israelInstitutionTitles));index=tags.map(function(tag){return tag.key;}).indexOf(action.tagId);if(index>-1)tags.splice(index,1);return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{recipientSettings:Object.assign({},state.systemSettings.data.recipientSettings,{israelInstitutionTitles:tags})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].Banks:tags=[].concat(_toConsumableArray(state.systemSettings.data.fundSettings.banks));index=tags.map(function(tag){return tag.key;}).indexOf(action.tagId);if(index>-1)tags.splice(index,1);return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{fundSettings:Object.assign({},state.systemSettings.data.fundSettings,{banks:tags})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].CardTypes:tags=[].concat(_toConsumableArray(state.systemSettings.data.printSettings.cardTypes));index=tags.map(function(tag){return tag.key;}).indexOf(action.tagId);if(index>-1)tags.splice(index,1);return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{printSettings:Object.assign({},state.systemSettings.data.printSettings,{cardTypes:tags})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].CampaignCategories:tags=[].concat(_toConsumableArray(state.systemSettings.data.campaignSettings.categories));index=tags.map(function(cat){return cat.campaignCategoryId;}).indexOf(action.tagId);if(index>-1)tags.splice(index,1);return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{campaignSettings:Object.assign({},state.systemSettings.data.campaignSettings,{categories:tags})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].CampaignIndivCategories:tags=[].concat(_toConsumableArray(state.systemSettings.data.campaignSettings.campaignIndivCategories));console.log(tags);index=tags.map(function(tag){return tag.key;}).indexOf(action.tagId);if(index>-1)tags.splice(index,1);return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{campaignSettings:Object.assign({},state.systemSettings.data.campaignSettings,{campaignIndivCategories:tags})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].LocationGroups:tags=[].concat(_toConsumableArray(state.systemSettings.data.campaignSettings.locationGroups));index=tags.map(function(loc){return loc.groupId;}).indexOf(action.tagId);if(index>-1)tags.splice(index,1);return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{campaignSettings:Object.assign({},state.systemSettings.data.campaignSettings,{locationGroups:tags})})})});default:return state;}case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_SETTING"]:if(!action.response.success)return state;switch(action.settingName){case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["h" /* SettingNames */].CurrencyConversionRate:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{paymentSettings:Object.assign({},state.systemSettings.data.paymentSettings,{currencyConversionRate:Object.assign({},state.systemSettings.data.paymentSettings.currencyConversionRate,{value:action.value})})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["h" /* SettingNames */].FromEmailAddress:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{campaignSettings:Object.assign({},state.systemSettings.data.campaignSettings,{fromEmailAddress:Object.assign({},state.systemSettings.data.campaignSettings.fromEmailAddress,{value:action.value})})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["h" /* SettingNames */].ReturnAddress:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{paymentSettings:Object.assign({},state.systemSettings.data.paymentSettings,{returnAddress:action.value})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["h" /* SettingNames */].DefaultUSFund:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{fundSettings:Object.assign({},state.systemSettings.data.fundSettings,{defaultUSFund:action.value})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["h" /* SettingNames */].DefaultILFund:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{fundSettings:Object.assign({},state.systemSettings.data.fundSettings,{defaultIsraelFund:action.value})})})});case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["h" /* SettingNames */].Signatures:return updatedState;case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].LocationGroups:return updatedState;case __WEBPACK_IMPORTED_MODULE_1__lib_constants__["h" /* SettingNames */].AuthorizeCloudPrint:return Object.assign({},updatedState,{systemSettings:Object.assign({},state.systemSettings,{data:Object.assign({},state.systemSettings.data,{printSettings:Object.assign({},state.systemSettings.data.printSettings,{cloudPrintIsAuthorized:true,cloudPrintUserName:action.response.data})})})});default:return state;}default:return state;}});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_constants__ = __webpack_require__(11);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={currencyConversionRate:{loading:false,success:true},fromEmailAddress:{loading:false,success:true},signatures:{loading:false,success:true},returnAddress:{loading:false,success:true},individualTags:{add:{loading:false,success:true},delete:{}},organizationTags:{add:{loading:false,success:true},delete:{}},individualApplicationReasons:{add:{loading:false,success:true},delete:{}},organizationApplicationReasons:{add:{loading:false,success:true},delete:{}},usPersonTitles:{add:{loading:false,success:true},delete:{},update:{loading:false,success:true}},israelPersonTitles:{add:{loading:false,success:true},delete:{},update:{loading:false,success:true}},usInstitutionTitles:{add:{loading:false,success:true},delete:{},update:{loading:false,success:true}},israelInstitutionTitles:{add:{loading:false,success:true},delete:{},update:{loading:false,success:true}},campaignCategories:{add:{loading:false,success:true},delete:{}},campaignIndivCategories:{add:{loading:false,success:true},delete:{}},campaignLocationGroups:{add:{loading:false,success:true},update:{loading:false,success:true},delete:{}},defaultUSFund:{loading:false,success:true},defaultIsraelFund:{loading:false,success:true},depositSources:{add:{loading:false,success:true},update:{loading:false,success:true}},withdrawalTypes:{add:{loading:false,success:true},update:{loading:false,success:true}},banks:{add:{loading:false,success:true},delete:{}},cloudPrintUserName:{loading:false,success:true},cloudPrintAuthorized:{loading:false,success:true},cloudPrint:{loading:false,success:true},cardTypes:{add:{loading:false,success:true},delete:{}}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var tagName=action.tagName,settingName=action.settingName,response=action.response;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_ADD_TAG"]:return Object.assign({},state,_defineProperty({},tagName,Object.assign({},state[tagName],{add:Object.assign({},initialState[tagName].add,{loading:true})})));case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["ADD_TAG"]:if(tagName===__WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].WithdrawalTypes||tagName===__WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].DepositSources)return Object.assign({},state,_defineProperty({},tagName,Object.assign({},state[tagName],{add:response.success?{loading:response.loading,success:response.success,data:response.data}:{loading:response.loading,success:response.success}})));return Object.assign({},state,_defineProperty({},tagName,Object.assign({},state[tagName],{add:{loading:response.loading,success:response.success}})));case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_UPDATE_TAG"]:return Object.assign({},state,_defineProperty({},tagName,Object.assign({},state[tagName],{update:Object.assign({},initialState[tagName].update,{loading:true})})));case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_TAG"]:return Object.assign({},state,_defineProperty({},tagName,Object.assign({},state[tagName],{update:{loading:response.loading,success:response.success}})));case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_DELETE_TAG"]:return Object.assign({},state,_defineProperty({},tagName,Object.assign({},state[tagName],{delete:Object.assign({},state[tagName].delete,_defineProperty({},action.tagId,{loading:true}))})));case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["DELETE_TAG"]:var deleteObj=Object.assign({},state[tagName].delete);response.success?delete deleteObj[action.tagId]:deleteObj[action.tagId]={loading:false,success:false,message:response.message};return Object.assign({},state,_defineProperty({},tagName,Object.assign({},state[tagName],{delete:deleteObj})));case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_UPDATE_SETTING"]:// Hack for location groups- only tags with editing...
if(settingName===__WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].LocationGroups)return Object.assign({},state,_defineProperty({},settingName,Object.assign({},state[settingName],{update:Object.assign({},initialState[settingName].update,{loading:true})})));return Object.assign({},state,_defineProperty({},settingName,Object.assign({},initialState[settingName],{loading:true})));case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_SETTING"]:if(settingName===__WEBPACK_IMPORTED_MODULE_1__lib_constants__["l" /* TagNames */].LocationGroups)return Object.assign({},state,_defineProperty({},settingName,Object.assign({},state[settingName],{update:Object.assign({},response)})));return Object.assign({},state,_defineProperty({},settingName,Object.assign({},response)));default:return state;}});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
var initialState={recipientSuggestions:{loading:false,success:true,data:[]}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_RECIPIENT_SUGGESTIONS"]:return Object.assign({},state,{recipientSuggestions:Object.assign({},state.recipientSuggestions,{loading:true,success:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_RECIPIENT_SUGGESTIONS"]:return Object.assign({},state,{recipientSuggestions:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["CLEAR_RECIPIENT_SUGGESTIONS"]:return Object.assign({},state,{recipientSuggestions:initialState.recipientSuggestions});default:return state;}});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_constants__ = __webpack_require__(11);
var initialState={filters:{view:__WEBPACK_IMPORTED_MODULE_1__lib_constants__["k" /* TableViews */].Standard,status:'',days:{Recent:30,Paid:30,Rejected:30},inquireOnly:false,keyword:'',recipients:[],firstName:'',lastName:'',reportName:'',reportMemo:'',teudatZahut:'',phoneNumber:'',checkNumber:'',categories:[],nationalities:[],recipientTypes:[],recipientStatuses:[],applicationStatuses:[],applicationReasons:[],approvers:[],funds:[],references:[],sources:[],campaigns:[],campaignIndividualCategories:[],campaignLists:[],organizations:[],taxId:'',streetNames:[],cities:[],startDate:'',endDate:'',elasticSearchText:'',bankAccount:'',hasPledges:false,hasAchAccount:false,hasReceipt:null},statusCounts:{loading:false,success:true,data:{new:'',inReview:'',incomplete:'',approved:'',paid:'',rejected:''},currentRequestId:0},selectedCounts:{ach:'',check:'',wire:''},applicationsToRecipientIdsMapping:{loading:false,success:true,data:{mapping:{},orderedApplications:[]}},voidingPayment:{loading:false,success:true},sendingACH:{loading:false,success:true},updating:{loading:false,success:true}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_APPLICATIONS_FILTERS"]:return Object.assign({},state,{filters:Object.assign({},state.filters,action.update)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["RESET_APPLICATIONS_FILTERS"]:return Object.assign({},state,{filters:initialState.filters});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_APPLICATION_STATUS_COUNTS"]:return Object.assign({},state,{statusCounts:Object.assign({},state.statusCounts,{loading:true,currentRequestId:action.requestId})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_APPLICATION_STATUS_COUNTS"]:return action.requestId!==state.statusCounts.currentRequestId?state:Object.assign({},state,{statusCounts:Object.assign({},state.statusCounts,action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_APPLICATIONS_TABLE_RECORDS"]:return Object.assign({},state,{applicationsToRecipientIdsMapping:initialState.applicationsToRecipientIdsMapping});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_APPLICATIONS_TO_RECIPIENT_IDS_MAPPING"]:return Object.assign({},state,{applicationsToRecipientIdsMapping:Object.assign({},state.applicationsToRecipientIdsMapping,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_APPLICATIONS_TO_RECIPIENT_IDS_MAPPING"]:return Object.assign({},state,{applicationsToRecipientIdsMapping:Object.assign({},state.applicationsToRecipientIdsMapping,action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_UPDATE_APPLICATIONS_STATUS"]:return Object.assign({},state,{updating:Object.assign({},state.updating,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_APPLICATIONS_STATUS_COMPLETED"]:return Object.assign({},state,{updating:Object.assign({},state.updating,action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_VOID_APPLICATION_PAYMENT"]:return Object.assign({},state,{voidingPayment:Object.assign({},state.voidingPayment,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["VOID_APPLICATION_PAYMENT_COMPLETED"]:return Object.assign({},state,{voidingPayment:Object.assign({},state.voidingPayment,action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_SEND_ACH_APPLICATIONS"]:return Object.assign({},state,{sendingACH:Object.assign({},state.sendingACH,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["SEND_ACH_APPLICATIONS_COMPLETED"]:return Object.assign({},state,{sendingACH:Object.assign({},state.sendingACH,action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_SELECTED_COUNTS"]:return Object.assign({},state,{selectedCounts:action.counts});default:return state;}});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
var initialState={printing:{loading:false,success:true,printerId:'',data:[]},confirmPrinting:{loading:false,success:true}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_PRINT_CHECKS"]:return Object.assign({},state,{printing:Object.assign({},state.printing,{loading:true,printerId:action.printerId})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["PRINT_CHECKS_COMPLETED"]:return Object.assign({},state,{printing:Object.assign({},state.printing,action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_CONFIRM_CHECKS_PRINTED"]:return Object.assign({},state,{confirmPrinting:Object.assign({},state.confirmPrinting,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["CONFIRM_CHECKS_PRINTED"]:return Object.assign({},state,{confirmPrinting:Object.assign({},state.confirmPrinting,action.response)});default:return state;}});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
var initialState={createApplication:{loading:false,success:true,message:'',id:0,data:{}}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_CREATE_APPLICATION"]:return Object.assign({},state,{createApplication:Object.assign({},state.createApplication,{loading:true,id:0})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["CREATE_APPLICATION"]:return Object.assign({},state,{createApplication:{loading:false,success:action.response.success,message:action.response.message,id:action.response.id,data:action.response.data}});default:return state;}});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = recipientAccountsReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
var initialState={organizations:{loading:false,success:true,data:[]},filters:{keyword:'',recipientSearch:'',firstName:'',lastName:'',reportName:'',teudatZahut:'',phoneNumber:'',categories:[],nationalities:[],recipientTypes:[],recipientStatuses:[],references:[],organizations:[],taxId:'',streetNames:[],cities:[],hasPledges:false,incomplete:false,campaignLists:[],bankAccount:''},createRecipient:{loading:false,success:false,data:''},export:{loading:false,success:false,data:''}};function recipientAccountsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_ORGANIZATIONS"]:return Object.assign({},state,{organizations:Object.assign({},state.organizations,{success:true,loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_ORGANIZATIONS"]:return Object.assign({},state,{organizations:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_RECIPIENTS_FILTERS"]:return Object.assign({},state,{filters:Object.assign({},state.filters,action.update)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["RESET_RECIPIENTS_FILTERS"]:return Object.assign({},state,{filters:initialState.filters});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_CREATE_RECIPIENT"]:return Object.assign({},state,{createRecipient:Object.assign({},initialState.createRecipient,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["CREATE_RECIPIENT"]:return Object.assign({},state,{createRecipient:Object.assign({},action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_RECIPIENTS_FOR_EXPORT"]:return Object.assign({},state,{export:Object.assign({},action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_PLEDGES_REPORT"]:return Object.assign({},state,{pledgeReport:Object.assign({},state.pledgeReport,{loading:true,success:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_PLEDGES_REPORT"]:return Object.assign({},state,{pledgeReport:Object.assign({},action.response)});default:return state;}}

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = recipientAccountDetailsReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={recipientDetails:{loading:false,success:true,data:{}},applicationHistory:{loading:false,success:true,data:[]},applicationDetails:{loading:false,success:true,data:{}},updateApplicationDetails:{loading:false,success:true,message:'',data:{}},updateRecipientDetails:{loading:false,success:true},applicationNotesUpdate:{loading:false,success:true},recipientNotesUpdate:{loading:false,success:true},applicationAttachmentsUpdate:{loading:false,success:true,message:''},applicationReceiptsUpdate:{loading:false,success:true,message:''},export:{loading:false,success:false,data:''}};function recipientAccountDetailsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_RECIPIENT_DETAILS"]:return Object.assign({},state,{recipientDetails:Object.assign({},action.preserveDetails?state.recipientDetails:initialState.recipientDetails,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_RECIPIENT_DETAILS"]:return Object.assign({},state,{recipientDetails:Object.assign({},state.recipientDetails,action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_RECIPIENT_APPLICATION_HISTORY"]:return Object.assign({},state,{applicationHistory:Object.assign({},initialState.applicationHistory,{loading:true}),applicationDetails:initialState.applicationDetails});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_RECIPIENT_APPLICATION_HISTORY"]:return Object.assign({},state,{applicationHistory:Object.assign({},state.applicationHistory,action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_APPLICATION_DETAILS"]:return Object.assign({},state,{applicationDetails:Object.assign({},initialState.applicationDetails,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_APPLICATION_DETAILS"]:return Object.assign({},state,{applicationDetails:Object.assign({},state.applicationDetails,action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_RECIPIENT_APPLICATIONS_FOR_EXPORT"]:return Object.assign({},state,{export:Object.assign({},action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_APPLICATION_DETAILS"]:var applicationHistory=[].concat(_toConsumableArray(state.applicationHistory.data));var appIndex=applicationHistory.map(function(app){return app.applicationId;}).indexOf(action.applicationId);applicationHistory[appIndex]=Object.assign({},state.applicationHistory.data[appIndex],action.update,{lastModified:Date.now()});return Object.assign({},state,{applicationHistory:Object.assign({},state.applicationHistory,{data:applicationHistory})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_ADD_APPLICATION_NOTE"]:case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_UPDATE_APPLICATION_NOTE"]:case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_DELETE_APPLICATION_NOTE"]:return Object.assign({},state,{applicationNotesUpdate:Object.assign({},state.applicationNotesUpdate,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["ADD_APPLICATION_NOTE"]:return Object.assign({},state,{applicationDetails:action.response.success?Object.assign({},state.applicationDetails,{data:Object.assign({},state.applicationDetails.data,{notes:[].concat(_toConsumableArray(state.applicationDetails.data.notes),[action.response.data])})}):state.applicationDetails,applicationNotesUpdate:{success:action.response.success,loading:false}});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_APPLICATION_NOTE"]:var updatedApplicationNotes=[].concat(_toConsumableArray(state.applicationDetails.data.notes));updatedApplicationNotes[updatedApplicationNotes.map(function(note){return note.noteId;}).indexOf(action.response.data.noteId)]=action.response.data;return Object.assign({},state,{applicationDetails:action.response.success?Object.assign({},state.applicationDetails,{data:Object.assign({},state.applicationDetails.data,{notes:updatedApplicationNotes})}):state.applicationDetails,applicationNotesUpdate:{success:action.response.success,loading:false}});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["DELETE_APPLICATION_NOTE"]:return Object.assign({},state,{applicationDetails:action.response.success?Object.assign({},state.applicationDetails,{data:Object.assign({},state.applicationDetails.data,{notes:state.applicationDetails.data.notes.filter(function(note){return note.noteId!==action.noteId;})})}):state.applicationDetails,applicationNotesUpdate:{success:action.response.success,loading:false}});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_ADD_RECIPIENT_NOTE"]:case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_UPDATE_RECIPIENT_NOTE"]:case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_DELETE_RECIPIENT_NOTE"]:return Object.assign({},state,{recipientNotesUpdate:Object.assign({},state.recipientNotesUpdate,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["ADD_RECIPIENT_NOTE"]:return Object.assign({},state,{recipientDetails:action.response.success?Object.assign({},state.recipientDetails,{data:Object.assign({},state.recipientDetails.data,{notes:[].concat(_toConsumableArray(state.recipientDetails.data.notes),[action.response.data])})}):state.recipientDetails,recipientNotesUpdate:{success:action.response.success,loading:false}});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_RECIPIENT_NOTE"]:var updateRecipientNotes=[].concat(_toConsumableArray(state.recipientDetails.data.notes));updateRecipientNotes[updateRecipientNotes.map(function(note){return note.noteId;}).indexOf(action.response.data.noteId)]=action.response.data;return Object.assign({},state,{recipientDetails:action.response.success?Object.assign({},state.recipientDetails,{data:Object.assign({},state.recipientDetails.data,{notes:updateRecipientNotes})}):state.recipientDetails,recipientNotesUpdate:{success:action.response.success,loading:false}});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["DELETE_RECIPIENT_NOTE"]:return Object.assign({},state,{recipientDetails:action.response.success?Object.assign({},state.recipientDetails,{data:Object.assign({},state.recipientDetails.data,{notes:state.recipientDetails.data.notes.filter(function(note){return note.noteId!==action.noteId;})})}):state.recipientDetails,recipientNotesUpdate:{success:action.response.success,loading:false}});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_UPDATE_APPLICATION_ATTACHMENTS"]:return Object.assign({},state,{applicationAttachmentsUpdate:Object.assign({},state.applicationAttachmentsUpdate,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_APPLICATION_ATTACHMENTS"]:return Object.assign({},state,{applicationDetails:action.response.success&&action.response.updatedAttachments.success?Object.assign({},state.applicationDetails,{data:Object.assign({},state.applicationDetails.data,{attachments:action.response.updatedAttachments.data})}):state.applicationDetails,applicationAttachmentsUpdate:{loading:false,success:action.response.success,message:action.response.message}});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_UPDATE_APPLICATION_RECEIPTS"]:return Object.assign({},state,{applicationReceiptsUpdate:Object.assign({},state.applicationReceiptsUpdate,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_APPLICATION_RECEIPTS"]:return Object.assign({},state,{applicationDetails:action.response.success&&action.response.updatedReceipts.success?Object.assign({},state.applicationDetails,{data:Object.assign({},state.applicationDetails.data,{receipts:action.response.updatedReceipts.data})}):state.applicationDetails,applicationReceiptsUpdate:{loading:false,success:action.response.success,message:action.response.message}});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_UPDATE_APPLICATION"]:return Object.assign({},state,{updateApplicationDetails:Object.assign({},initialState.updateApplicationDetails,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_APPLICATION"]:return Object.assign({},state,{updateApplicationDetails:Object.assign({},state.updateApplicationDetails,action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_UPDATE_RECIPIENT_DETAILS"]:return Object.assign({},state,{updateRecipientDetails:Object.assign({},initialState.updateRecipientDetails,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_RECIPIENT_DETAILS"]:return Object.assign({},state,{updateRecipientDetails:Object.assign({},state.updateRecipientDetails,action.response)});default:return state;}}

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = referencesReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
var initialState={references:{loading:false,success:true,data:[]},keyword:'',createReference:{loading:false,success:false,data:{}},updateReference:{loading:false,success:false,data:{}}};function referencesReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_REFERENCES"]:return Object.assign({},state,{references:Object.assign({},initialState.references,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_REFERENCES"]:return Object.assign({},state,{references:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_REFERENCES_SEARCH"]:return Object.assign({},state,{keyword:action.keyword});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_CREATE_REFERENCE"]:return Object.assign({},state,{createReference:Object.assign({},initialState.createReference,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["CREATE_REFERENCE"]:return Object.assign({},state,{createReference:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_UPDATE_REFERENCE"]:return Object.assign({},state,{updateReference:Object.assign({},initialState.updateReference,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_REFERENCE"]:return Object.assign({},state,{updateReference:action.response});default:return state;}}

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = duplicateRecipientsReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
var initialState={findingDuplicates:{loading:false,success:true},duplicatesDetails:{loading:false,success:true,data:[]},resolvingDuplicates:{loading:false,success:true}};function duplicateRecipientsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_FIND_DUPLICATE_RECIPIENTS"]:return Object.assign({},state,{findingDuplicates:{loading:true,success:true}});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["FIND_DUPLICATE_RECIPIENTS_COMPLETE"]:return Object.assign({},state,{findingDuplicates:Object.assign({},action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_DUPLICATE_RECIPIENTS_DETAILS"]:return Object.assign({},state,{duplicatesDetails:Object.assign({},initialState.duplicatesDetails,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_DUPLICATE_RECIPIENTS_DETAILS"]:return Object.assign({},state,{duplicatesDetails:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_RESOLVE_DUPLICATE_RECIPIENTS"]:return Object.assign({},state,{resolvingDuplicates:{loading:true,success:true}});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["RESOLVE_DUPLICATE_RECIPIENTS"]:return Object.assign({},state,{resolvingDuplicates:Object.assign({},action.response)});default:return state;}}

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={showSidebar:true,savedSearchList:{loading:false,success:true,data:[],deleting:{}},savedSearch:{loading:false,success:true,data:{}},newSearch:{loading:false,success:true},filters:{keyword:'',recipientSearch:'',recipients:[],reportName:'',reportMemo:'',firstName:'',lastName:'',teudatZahut:'',phoneNumber:'',checkNumber:'',categories:[],nationalities:[],recipientTypes:[],recipientStatuses:[],applicationStatuses:[],applicationReasons:[],approvers:[],references:[],sources:[],funds:[],campaigns:[],campaignIndividualCategories:[],campaignLists:[],organizations:[],taxId:'',streetNum:'',streetNames:[],cities:[],startDate:'',endDate:'',bankAccount:'',hasPledges:false,incomplete:false,hasAchAccount:false,hasReceipt:null},appliedFilters:{keyword:'',reportName:'',reportMemo:'',firstName:'',lastName:'',teudatZahut:'',phoneNumber:'',checkNumber:'',categories:[],nationalities:[],recipientTypes:[],recipientStatuses:[],applicationStatuses:[],applicationReasons:[],approvers:[],references:[],sources:[],funds:[],campaigns:[],campaignIndividualCategories:[],campaignLists:[],organizations:[],taxId:'',streetNum:'',streetNames:[],cities:[],startDate:'',endDate:'',bankAccount:'',hasPledges:false,incomplete:false,hasAchAccount:false,hasReceipt:null}};/* harmony default export */ __webpack_exports__["a"] = (function(filterType){return function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['TOGGLE_'+filterType+'_SIDEBAR_FILTERS']:return Object.assign({},state,{showSidebar:!state.showSidebar});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['UPDATE_'+filterType+'_SIDEBAR_FILTERS']:return Object.assign({},state,{filters:Object.assign({},state.filters,action.update),savedSearch:initialState.savedSearch});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['RESET_'+filterType+'_SIDEBAR_FILTERS']:return Object.assign({},state,{filters:initialState.filters,appliedFilters:action.applyFilters?initialState.filters:state.appliedFilters,savedSearch:initialState.savedSearch});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['SET_'+filterType+'_APPLIED_FILTERS']:return Object.assign({},state,{appliedFilters:action.filters});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['START_GET_'+filterType+'_SAVED_SEARCHES']:return Object.assign({},state,{savedSearchList:Object.assign({},initialState.savedSearchList,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['GET_'+filterType+'_SAVED_SEARCHES']:return Object.assign({},state,{savedSearchList:Object.assign({},initialState.savedSearchList,action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['START_GET_'+filterType+'_SAVED_SEARCH']:return Object.assign({},state,{savedSearch:Object.assign({},state.savedSearch,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['GET_'+filterType+'_SAVED_SEARCH']:var _action$response$data=action.response.data,savedSearchId=_action$response$data.savedSearchId,name=_action$response$data.name,fields=_action$response$data.fields;return Object.assign({},state,{savedSearch:Object.assign({},action.response,{data:{key:savedSearchId,value:name}}),filters:Object.assign({},state.filter,fields)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['START_CREATE_'+filterType+'_SAVED_SEARCH']:return Object.assign({},state,{newSearch:Object.assign({},state.newSearch,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['CREATE_'+filterType+'_SAVED_SEARCH']:return Object.assign({},state,{savedSearchList:action.response.success?Object.assign({},state.savedSearchList,{data:[].concat(_toConsumableArray(state.savedSearchList.data),[action.response.data])}):state.savedSearchList,savedSearch:action.response.success?Object.assign({},state.savedSearch,{data:action.response.data}):state.savedSearch,newSearch:{loading:false,success:action.response.success}});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['START_DELETE_'+filterType+'_SAVED_SEARCH']:return Object.assign({},state,{savedSearchList:Object.assign({},state.savedSearchList,{deleting:Object.assign({},state.savedSearchList.deleting,_defineProperty({},action.savedSearchId,true))})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['DELETE_'+filterType+'_SAVED_SEARCH']:var deletingSearches=Object.assign({},state.savedSearchList.deleting);action.response.success?delete deletingSearches[action.response.savedSearchId]:deletingSearches[action.response.savedSearchId]=false;return Object.assign({},state,{savedSearch:action.response.success?initialState.savedSearch:state.savedSearch,savedSearchList:Object.assign({},state.savedSearchList,{data:action.response.success?state.savedSearchList.data.filter(function(s){return s.key!==action.response.savedSearchId;}):state.savedSearchList.data,deleting:deletingSearches})});default:return state;}};});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
var initialState={campaigns:{loading:false,success:true,data:[]},filters:{categoryId:'',locationId:'',year:''},newCampaign:{loading:false,success:true,message:'',campaignId:''},campaignDelete:{loading:false,success:true,message:''}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_CAMPAIGNS"]:return Object.assign({},state,{campaigns:Object.assign({},state.campaigns,{success:true,loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_CAMPAIGNS"]:return Object.assign({},state,{campaigns:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_CAMPAIGNS_FILTERS"]:return Object.assign({},state,{filters:Object.assign({},state.filters,action.update)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_CAMPAIGNS_TABLE"]:return Object.assign({},state,{campaignsTable:Object.assign({},state.campaignsTable,action.settings)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_CREATE_CAMPAIGN"]:return Object.assign({},state,{newCampaign:Object.assign({},initialState.newCampaign,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["CREATE_CAMPAIGN"]:return Object.assign({},state,{newCampaign:{loading:action.response.loading,success:action.response.success,message:action.response.message,campaignId:action.response.data}});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["DELETE_CAMPAIGN"]:return Object.assign({},state,{campaignDelete:Object.assign({},action.result)});default:return state;}});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
var initialState={details:{loading:false,success:true,data:{}},updateCampaignDetails:{loading:false,success:true,message:''},lists:{newList:{loading:false,success:true,message:''},allLists:{loading:false,success:true,data:[]},approve:{loading:false,success:true,message:''},resendMessage:{loading:false,success:true},externalUpdates:{loading:false,success:true,data:{}},verifyUpdates:{loading:false,success:true}},individuals:{newIndividual:{loading:false,success:true,message:''},allIndividuals:{loading:false,success:true,data:[]}}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_CAMPAIGN_DETAILS"]:return Object.assign({},state,{details:Object.assign({},initialState.details,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_CAMPAIGN_DETAILS"]:return Object.assign({},state,{details:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["CLEAR_CAMPAIGN_DETAILS"]:return Object.assign({},state,{details:initialState.details});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_UPDATE_CAMPAIGN_DETAILS"]:return Object.assign({},state,{updateCampaignDetails:Object.assign({},initialState.updateCampaignDetails,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_CAMPAIGN_DETAILS"]:return Object.assign({},state,{updateCampaignDetails:{loading:false,success:action.response.success,message:action.response.message},details:Object.assign({},state.details,{data:action.response.success?action.response.data:state.details.data})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_ADD_CAMPAIGN_DETAILS_INDIVIDUAL"]:return Object.assign({},state,{individuals:Object.assign({},state.individuals,{newIndividual:Object.assign({},initialState.newIndividual,{loading:true})})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["ADD_CAMPAIGN_DETAILS_INDIVIDUAL"]:return Object.assign({},state,{individuals:Object.assign({},state.individuals,{newIndividual:{success:action.response.success,loading:action.response.loading,message:action.response.message}})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_CAMPAIGN_ALL_LISTS"]:return Object.assign({},state,{lists:Object.assign({},state.lists,{allLists:Object.assign({},initialState.lists.allLists,{loading:true})})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_CAMPAIGN_ALL_LISTS"]:return Object.assign({},state,{lists:Object.assign({},state.lists,{allLists:action.response})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_CAMPAIGN_ALL_INDIVIDUALS"]:return Object.assign({},state,{individuals:Object.assign({},state.individuals,{allIndividuals:Object.assign({},initialState.individuals.allIndividuals,{loading:true})})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_CAMPAIGN_ALL_INDIVIDUALS"]:return Object.assign({},state,{individuals:Object.assign({},state.individuals,{allIndividuals:action.response})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_ADD_CAMPAIGN_DETAILS_LIST"]:return Object.assign({},state,{lists:Object.assign({},state.lists,{newList:Object.assign({},initialState.newList,{loading:true})})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["ADD_CAMPAIGN_DETAILS_LIST"]:return Object.assign({},state,{lists:Object.assign({},state.lists,{newList:{success:action.response.success,loading:action.response.loading,message:action.response.message}})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_APPROVE_CAMPAIGN_DETAILS_LIST"]:return Object.assign({},state,{lists:Object.assign({},state.lists,{approve:Object.assign({},initialState.approve,{loading:true})})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["APPROVE_CAMPAIGN_DETAILS_LIST"]:return Object.assign({},state,{lists:Object.assign({},state.lists,{approve:action.response})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_RESEND_CAMPAIGN_DETAILS_LIST"]:return Object.assign({},state,{lists:Object.assign({},state.lists,{resendMessage:Object.assign({},initialState.resendMessage,{loading:true})})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["RESEND_CAMPAIGN_DETAILS_LIST"]:return Object.assign({},state,{lists:Object.assign({},state.lists,{resendMessage:action.response})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_CAMPAIGN_LIST_EXTERNAL_UPDATES"]:return Object.assign({},state,{lists:Object.assign({},state.lists,{externalUpdates:Object.assign({},initialState.externalUpdates,{loading:true})})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_CAMPAIGN_LIST_EXTERNAL_UPDATES"]:return Object.assign({},state,{lists:Object.assign({},state.lists,{externalUpdates:action.response})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_VERIFY_CAMPAIGN_LIST_EXTERNAL_UPDATES"]:return Object.assign({},state,{lists:Object.assign({},state.lists,{verifyUpdates:Object.assign({},initialState.verifyUpdates,{loading:true})})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["VERIFY_CAMPAIGN_LIST_EXTERNAL_UPDATES"]:return Object.assign({},state,{lists:Object.assign({},state.lists,{verifyUpdates:action.response})});default:return state;}});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
var initialState={keyword:'',newCampaignList:{loading:false,success:true,message:'',campaignListId:''},allCampaignLists:{loading:false,success:true,data:[]}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_CAMPAIGN_LISTS_FILTERS"]:return Object.assign({},state,{filters:Object.assign({},state.filters,action.update)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_CREATE_CAMPAIGN_LIST"]:return Object.assign({},state,{newCampaignList:Object.assign({},state.newCampaignList,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["CREATE_CAMPAIGN_LIST"]:return Object.assign({},state,{newCampaignList:{loading:action.response.loading,success:action.response.success,message:action.response.message,campaignListId:action.response.data}});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_CAMPAIGN_LISTS_SEARCH"]:return Object.assign({},state,{keyword:action.keyword});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_CAMPAIGN_LISTS"]:return Object.assign({},state,{allCampaignLists:Object.assign({},state.allCampaignLists,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_CAMPAIGN_LISTS"]:return Object.assign({},state,{allCampaignLists:action.response});default:return state;}});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
var initialState={details:{loading:false,success:true,data:{}},updateCampaignList:{loading:false,success:true},allParticipants:{loading:false,success:true,data:[]},newParticipant:{loading:false,success:true,message:''},pendingParticipants:{loading:false,success:true,data:[]}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_CAMPAIGN_LIST_DETAILS"]:return Object.assign({},state,{details:Object.assign({},initialState.details,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_CAMPAIGN_LIST_DETAILS"]:return Object.assign({},state,{details:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["CLEAR_CAMPAIGN_LIST_DETAILS"]:return Object.assign({},state,{details:initialState.details});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_UPDATE_CAMPAIGN_LIST_DETAILS"]:return Object.assign({},state,{updateCampaignList:Object.assign({},initialState.updateCampaignList,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_CAMPAIGN_LIST_DETAILS"]:return Object.assign({},state,{updateCampaignList:{loading:false,success:action.response.success},details:Object.assign({},state.details,{data:action.response.success?action.response.data:state.details.data})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_CAMPAIGN_LIST_ALL_PARTICIPANTS"]:return Object.assign({},state,{allParticipants:Object.assign({},initialState.allParticipants,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_CAMPAIGN_LIST_ALL_PARTICIPANTS"]:return Object.assign({},state,{allParticipants:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_ADD_CAMPAIGN_LIST_PARTICIPANT"]:return Object.assign({},state,{newParticipant:Object.assign({},initialState.newParticipant,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["ADD_CAMPAIGN_LIST_PARTICIPANT"]:return Object.assign({},state,{newParticipant:{success:action.response.success,loading:action.response.loading,message:action.response.message}});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_CAMPAIGN_LIST_PENDING_PARTICIPANTS"]:return Object.assign({},state,{pendingParticipants:Object.assign({},initialState.pendingParticipants,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_CAMPAIGN_LIST_PENDING_PARTICIPANTS"]:return Object.assign({},state,{pendingParticipants:action.response});default:return state;}});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
var initialState={applicationStatus:''};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_CAMPAIGN_LISTS_APPLICATIONS_STATUS"]:return Object.assign({},state,{applicationStatus:action.applicationStatus});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["CLEAR_CAMPAIGN_LISTS_APPLICATIONS_STATUS"]:return Object.assign({},state,{applicationStatus:initialState.applicationStatus});default:return state;}});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
var initialState={listDetails:{loading:false,success:true,data:{}},listRecipients:{loading:false,success:true,data:[]},listExport:{loading:false,success:true,data:[]},listUpdate:{loading:false,success:true},listSelection:{loading:false,success:true},listSubmission:{loading:false,success:true}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_EXTERNAL_CAMPAIGN_LIST_DETAILS"]:return Object.assign({},state,{listDetails:Object.assign({},initialState.listDetails,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_EXTERNAL_CAMPAIGN_LIST_DETAILS"]:return Object.assign({},state,{listDetails:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_EXTERNAL_CAMPAIGN_LIST_RECIPIENTS"]:return Object.assign({},state,{listRecipients:Object.assign({},initialState.listRecipients,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_EXTERNAL_CAMPAIGN_LIST_RECIPIENTS"]:return Object.assign({},state,{listRecipients:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_EXPORT_EXTERNAL_CAMPAIGN_LIST"]:return Object.assign({},state,{listExport:Object.assign({},initialState.listExport,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["EXPORT_EXTERNAL_CAMPAIGN_LIST"]:return Object.assign({},state,{listExport:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS"]:return Object.assign({},state,{listUpdate:{loading:true,success:true}});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS"]:return Object.assign({},state,{listUpdate:{success:action.response.success,loading:action.response.loading,message:action.response.message}});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_SELECT_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS"]:return Object.assign({},state,{listSelection:{loading:true,success:true}});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["SELECT_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS"]:return Object.assign({},state,{listSelection:{success:action.response.success,loading:action.response.loading,message:action.response.message}});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_SUBMIT_EXTERNAL_CAMPAIGN_LIST"]:return Object.assign({},state,{listSubmission:{loading:true,success:true}});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["SUBMIT_EXTERNAL_CAMPAIGN_LIST"]:return Object.assign({},state,{listSubmission:{success:action.response.success,loading:action.response.loading,message:action.response.message}});default:return state;}});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
var isActiveFund=function isActiveFund(fund){return fund.active!==false;};var toFundOption=function toFundOption(fund){return{key:fund.fundId,value:fund.name};};var buildFundsByDeptState=function buildFundsByDeptState(funds){var activeFunds=funds.filter(isActiveFund);return{loading:false,success:true,all:funds.map(toFundOption),allWithLimits:funds.map(function(f){return{key:f.fundId,value:f};}),activeAll:activeFunds.map(toFundOption),activeAllWithLimits:activeFunds.map(function(f){return{key:f.fundId,value:f};}),US:funds.filter(function(fund){return fund.department==="US";}).map(toFundOption),IL:funds.filter(function(fund){return fund.department==="IL";}).map(toFundOption),activeUS:activeFunds.filter(function(fund){return fund.department==="US";}).map(toFundOption),activeIL:activeFunds.filter(function(fund){return fund.department==="IL";}).map(toFundOption)};};var initialState={funds:{loading:false,success:true,data:[]},fundsByDept:{loading:false,success:true,all:[],allWithLimits:[],activeAll:[],activeAllWithLimits:[],US:[],IL:[],activeUS:[],activeIL:[]},newFund:{loading:false,success:true}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_FUNDS"]:return Object.assign({},state,{fundsByDept:Object.assign({},initialState.fundsByDept,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_FUNDS"]:return Object.assign({},state,{fundsByDept:action.response.success?buildFundsByDeptState(action.response.data):Object.assign({},initialState.fundsByDept,{loading:false,success:false})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_FUNDS_VERBOSE"]:return Object.assign({},state,{funds:Object.assign({},initialState.funds,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_FUNDS_VERBOSE"]:return Object.assign({},state,{funds:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_CREATE_FUND"]:return Object.assign({},state,{newFund:Object.assign({},initialState.newFund,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["CREATE_FUND"]:return Object.assign({},state,{newFund:Object.assign({},action.response)});default:return state;}});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = recipientAccountDetailsReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils__ = __webpack_require__(2);
var initialState={fundDetails:{loading:false,success:true,data:{}},updateFund:{loading:false,success:true},transactionsFilters:{startDate:Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["l" /* formatDateForInput */])(Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["u" /* getStartDate */])()),endDate:Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["l" /* formatDateForInput */])(new Date()),search:''},outsideTransactionsFilters:{startDate:Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["l" /* formatDateForInput */])(Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["u" /* getStartDate */])()),endDate:Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["l" /* formatDateForInput */])(new Date()),search:''},newOutsideTransaction:{loading:false,success:true},updateTransaction:{loading:false,success:true},blankChecks:{loading:false,success:true,data:[]},voidTransactions:{loading:false,success:true}};function recipientAccountDetailsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_FUND_DETAILS"]:return Object.assign({},state,{fundDetails:Object.assign({},initialState.fundDetails,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_FUND_DETAILS"]:return Object.assign({},state,{fundDetails:Object.assign({},state.fundDetails,action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_UPDATE_FUND"]:return Object.assign({},state,{updateFund:Object.assign({},initialState.update,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_FUND"]:return Object.assign({},state,{updateFund:Object.assign({},state.updateFund,action.response),fundDetails:Object.assign({},state.fundDetails,{data:action.response.success?action.response.data:state.fundDetails.data})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_ACCOUNTING_FILTERS"]:return Object.assign({},state,{transactionsFilters:Object.assign({},state.transactionsFilters,action.update)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_ACCOUNTING_OUTSIDE_TRANSACTION_FILTERS"]:return Object.assign({},state,{outsideTransactionsFilters:Object.assign({},state.outsideTransactionsFilters,action.update)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_CREATE_OUTSIDE_TRANSACTION"]:return Object.assign({},state,{newOutsideTransaction:Object.assign({},initialState.newOutsideTransaction,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["CREATE_OUTSIDE_TRANSACTION"]:return Object.assign({},state,{newOutsideTransaction:Object.assign({},action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_UPDATE_TRANSACTION"]:return Object.assign({},state,{updateTransaction:Object.assign({},initialState.updateTransaction,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_TRANSACTION"]:return Object.assign({},state,{updateTransaction:Object.assign({},action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_VOIDING_TRANSACTION"]:return Object.assign({},state,{voidTransactions:Object.assign({},initialState.voidTransactions,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["VOID_TRANSACTIONS"]:return Object.assign({},state,{voidTransactions:Object.assign({},action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_BLANK_CHECKS"]:return Object.assign({},state,{blankChecks:Object.assign({},initialState.blankChecks,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_BLANK_CHECKS"]:return Object.assign({},state,{blankChecks:Object.assign({},initialState.blankChecks,action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["CLEAR_BLANK_CHECKS"]:return Object.assign({},state,{blankChecks:initialState.blankChecks});default:return state;}}

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Module dependencies.
 */
var os = __webpack_require__(320);
var lodashGet = __webpack_require__(321);
var lodashFlatten = __webpack_require__(322);
var lodashUniq = __webpack_require__(323);
var lodashSet = __webpack_require__(324);
var lodashCloneDeep = __webpack_require__(39);
var flatten = __webpack_require__(325);

/**
 * @name Json2CsvParams
 * @typedef {Object}
 * @property {Array} data - array of JSON objects
 * @property {Array} [fields] - see documentation for details
 * @property {String[]} [fieldNames] - names for fields at the same indexes. Must be same length as fields array
 *                                   (Optional. Maintained for backwards compatibility. Use fields config object for more features)
 * @property {String} [del=","] - delimiter of columns
 * @property {String} [defaultValue="<empty>"] - default value to use when missing data
 * @property {String} [quotes='"'] - quotes around cell values and column names
 * @property {String} [doubleQuotes='""'] - the value to replace double quotes in strings
 * @property {Boolean} [hasCSVColumnTitle=true] - determines whether or not CSV file will contain a title column
 * @property {String} [eol=''] - it gets added to each row of data
 * @property {String} [newLine] - overrides the default OS line ending (\n on Unix \r\n on Windows)
 * @property {Boolean} [flatten=false] - flattens nested JSON using flat (https://www.npmjs.com/package/flat)
 * @property {String[]} [unwindPath] - similar to MongoDB's $unwind, Deconstructs an array field from the input JSON to output a row for each element
 * @property {Boolean} [excelStrings] - converts string data into normalized Excel style data
 * @property {Boolean} [includeEmptyRows=false] - includes empty rows
 * @property {Boolean} [withBOM=false] - includes BOM character at the beginning of the csv
 */

/**
 * Main function that converts json to csv.
 *
 * @param {Json2CsvParams} params Function parameters containing data, fields,
 * delimiter (default is ','), hasCSVColumnTitle (default is true)
 * and default value (default is '')
 * @param {Function} [callback] Callback function
 *   if error, returning error in call back.
 *   if csv is created successfully, returning csv output to callback.
 */
module.exports = function (params, callback) {
  var hasCallback = typeof callback === 'function';
  var err;

  try {
    checkParams(params);
  } catch (err) {
    if (hasCallback) {
      return process.nextTick(function () {
        callback(err);
      });
    } else {
      throw err;
    }
  }

  var titles = createColumnTitles(params);
  var csv = createColumnContent(params, titles);

  if (hasCallback) {
    return process.nextTick(function () {
      callback(null, csv);
    });
  } else {
    return csv;
  }
};


/**
 * Check passing params.
 *
 * Note that this modifies params.
 *
 * @param {Json2CsvParams} params Function parameters containing data, fields,
 * delimiter, default value, mark quotes and hasCSVColumnTitle
 */
function checkParams(params) {
  params.data = params.data || [];

  // if data is an Object, not in array [{}], then just create 1 item array.
  // So from now all data in array of object format.
  if (!Array.isArray(params.data)) {
    params.data = [params.data];
  }

  if (params.flatten) {
    params.data = params.data.map(flatten);
  }

  // Set params.fields default to first data element's keys
  if (!params.fields && (params.data.length === 0 || typeof params.data[0] !== 'object')) {
    throw new Error('params should include "fields" and/or non-empty "data" array of objects');
  }

  if (!params.fields) {
    var dataFields = params.data.map(function (item) {
      return Object.keys(item);
    });

    dataFields = lodashFlatten(dataFields);
    params.fields = lodashUniq(dataFields);
  }


  //#check fieldNames
  if (params.fieldNames && params.fieldNames.length !== params.fields.length) {
    throw new Error('fieldNames and fields should be of the same length, if fieldNames is provided.');
  }

  // Get fieldNames from fields
  params.fieldNames = params.fields.map(function (field, i) {
    if (params.fieldNames && typeof field === 'string') {
      return params.fieldNames[i];
    }
    return (typeof field === 'string') ? field : (field.label || field.value);
  });

  //#check delimiter
  params.del = params.del || ',';

  //#check end of line character
  params.eol = params.eol || '';

  //#check quotation mark
  params.quotes = typeof params.quotes === 'string' ? params.quotes : '"';

  //#check double quotes
  params.doubleQuotes = typeof params.doubleQuotes === 'string' ? params.doubleQuotes : Array(3).join(params.quotes);

  //#check default value
  params.defaultValue = params.defaultValue;

  //#check hasCSVColumnTitle, if it is not explicitly set to false then true.
  params.hasCSVColumnTitle = params.hasCSVColumnTitle !== false;

  //#check include empty rows, defaults to false
  params.includeEmptyRows = params.includeEmptyRows || false;

  //#check with BOM, defaults to false
  params.withBOM = params.withBOM || false;

  //#check unwindPath, defaults to empty array
  params.unwindPath = params.unwindPath || [];

  // if unwindPath is not in array [{}], then just create 1 item array.
  if (!Array.isArray(params.unwindPath)) {
    params.unwindPath = [params.unwindPath];
  }
}

/**
 * Create the title row with all the provided fields as column headings
 *
 * @param {Json2CsvParams} params Function parameters containing data, fields and delimiter
 * @returns {String} titles as a string
 */
function createColumnTitles(params) {
  var str = '';

  //if CSV has column title, then create it
  if (params.hasCSVColumnTitle) {
    params.fieldNames.forEach(function (element) {
      if (str !== '') {
        str += params.del;
      }
      str += JSON.stringify(element).replace(/\"/g, params.quotes);
    });
  }

  return str;
}

/**
 * Replace the quotation marks of the field element if needed (can be a not string-like item)
 *
 * @param {string} stringifiedElement The field element after JSON.stringify()
 * @param {string} quotes The params.quotes value. At this point we know that is not equal to double (")
 */
function replaceQuotationMarks(stringifiedElement, quotes) {
  var lastCharIndex = stringifiedElement.length - 1;

  //check if it's an string-like element
  if (stringifiedElement[0] === '"' && stringifiedElement[lastCharIndex] === '"') {
    //split the stringified field element because Strings are immutable
    var splitElement = stringifiedElement.split('');

    //replace the quotation marks
    splitElement[0] = quotes;
    splitElement[lastCharIndex] = quotes;

    //join again
    stringifiedElement = splitElement.join('');
  }

  return stringifiedElement;
}

/**
 * Create the content column by column and row by row below the title
 *
 * @param {Object} params Function parameters containing data, fields and delimiter
 * @param {String} str Title row as a string
 * @returns {String} csv string
 */
function createColumnContent(params, str) {
  createDataRows(params.data, params.unwindPath).forEach(function (dataElement) {
    //if null do nothing, if empty object without includeEmptyRows do nothing
    if (dataElement && (Object.getOwnPropertyNames(dataElement).length > 0 || params.includeEmptyRows)) {
      var line = '';
      var eol = params.newLine || os.EOL || '\n';

      params.fields.forEach(function (fieldElement) {
        var val;
        var defaultValue = params.defaultValue;
        var stringify = true;
        if (typeof fieldElement === 'object' && 'default' in fieldElement) {
          defaultValue = fieldElement.default;
        }

        if (fieldElement && (typeof fieldElement === 'string' || typeof fieldElement.value === 'string')) {
          var path = (typeof fieldElement === 'string') ? fieldElement : fieldElement.value;
          val = lodashGet(dataElement, path, defaultValue);
        } else if (fieldElement && typeof fieldElement.value === 'function') {
          var field = {
            label: fieldElement.label,
            default: fieldElement.default
          };
          val = fieldElement.value(dataElement, field, params.data);
          if (fieldElement.stringify !== undefined) {
            stringify = fieldElement.stringify;
          }
        }

        if (val === null || val === undefined){
          val = defaultValue;
        }

        if (val !== undefined) {
          if (params.preserveNewLinesInValues && typeof val === 'string') {
            val = val
              .replace(/\n/g, '\u2028')
              .replace(/\r/g, '\u2029');
          }

          var stringifiedElement = val;
          if (stringify) {
            stringifiedElement = JSON.stringify(val);
          }

          if (params.preserveNewLinesInValues && typeof val === 'string') {
            stringifiedElement = stringifiedElement
              .replace(/\u2028/g, '\n')
              .replace(/\u2029/g, '\r');
          }

          if (typeof val === 'object') {
            // In some cases (e.g. val is a Date), stringifiedElement is already a quoted string.
            // Strip the leading and trailing quotes if so, so we don't end up double-quoting it
            stringifiedElement = replaceQuotationMarks(stringifiedElement, '');

            // If val is a normal object, we want to escape its JSON so any commas etc
            // don't get interpreted as field separators
            stringifiedElement = JSON.stringify(stringifiedElement);
          }

          if (params.quotes !== '"') {
            stringifiedElement = replaceQuotationMarks(stringifiedElement, params.quotes);
          }

          //JSON.stringify('\\') results in a string with two backslash
          //characters in it. I.e. '\\\\'.
          stringifiedElement = stringifiedElement.replace(/\\\\/g, '\\');

          if (params.excelStrings && typeof val === 'string') {
            stringifiedElement = '"="' + stringifiedElement + '""';
          }

          //Replace single quotes with double quotes.  Single quotes are preceeded by
          //a backslash,  and it's not at the end of the stringifiedElement.
          stringifiedElement = stringifiedElement.replace(/(\\")(?=.)/g, params.doubleQuotes);

          line += stringifiedElement;
        }

        line += params.del;
      });

      //remove last delimeter by its length
      line = line.substring(0, line.length - params.del.length);

      //Remove the final excess backslashes from the stringified value.
      line = line.replace(/\\\\/g,'\\');

      //If header exists, add it, otherwise, print only content
      if (str !== '') {
        str += eol + line + params.eol;
      } else {
        str = line + params.eol;
      }
    }
  });
  // Add BOM character if required
  if (params.withBOM) {
    str = '\ufeff' + str;
  }

  return str;
}

/**
 * Performs the unwind recursively in specified sequence
 *
 * @param {Array} originalData The params.data value. Original array of JSON objects
 * @param {String[]} unwindPaths The params.unwindPath value. Unwind strings to be used to deconstruct array
 * @returns {Array} Array of objects containing all rows after unwind of chosen paths
 */
function createDataRows(originalData, unwindPaths) {
  var dataRows = [];
  if (unwindPaths.length) {
    originalData.forEach(function(dataElement) {
      var dataRow = [dataElement];

      unwindPaths.forEach(function(unwindPath) {
        dataRow = unwindRows(dataRow, unwindPath);
      });

      Array.prototype.push.apply(dataRows, dataRow);
    });
  } else {
    dataRows = originalData;
  }

  return dataRows;
}

/**
 * Performs the unwind logic if necessary to convert single JSON document into multiple rows
 *
 * @param {Array} inputRows Array contaning single or multiple rows to unwind
 * @param {String} unwindPath Single path to do unwind
 * @returns {Array} Array of rows processed
 */
function unwindRows(inputRows, unwindPath) {
  var outputRows = [];
  inputRows.forEach(function(dataEl) {
    var unwindArray = lodashGet(dataEl, unwindPath);
    var isArr = Array.isArray(unwindArray);

    if (isArr && unwindArray.length) {
      unwindArray.forEach(function(unwindEl) {
        var dataCopy = lodashCloneDeep(dataEl);
        lodashSet(dataCopy, unwindPath, unwindEl);
        outputRows.push(dataCopy);
      });
    } else if (isArr && !unwindArray.length) {
      var dataCopy = lodashCloneDeep(dataEl);
      lodashSet(dataCopy, unwindPath, undefined);
      outputRows.push(dataCopy);
    } else {
      outputRows.push(dataEl);
    }
  });
  return outputRows;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 320 */
/***/ (function(module, exports) {

exports.endianness = function () { return 'LE' };

exports.hostname = function () {
    if (typeof location !== 'undefined') {
        return location.hostname
    }
    else return '';
};

exports.loadavg = function () { return [] };

exports.uptime = function () { return 0 };

exports.freemem = function () {
    return Number.MAX_VALUE;
};

exports.totalmem = function () {
    return Number.MAX_VALUE;
};

exports.cpus = function () { return [] };

exports.type = function () { return 'Browser' };

exports.release = function () {
    if (typeof navigator !== 'undefined') {
        return navigator.appVersion;
    }
    return '';
};

exports.networkInterfaces
= exports.getNetworkInterfaces
= function () { return {} };

exports.arch = function () { return 'javascript' };

exports.platform = function () { return 'browser' };

exports.tmpdir = exports.tmpDir = function () {
    return '/tmp';
};

exports.EOL = '\n';

exports.homedir = function () {
	return '/'
};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array ? array.length : 0;
  return length ? baseFlatten(array, 1) : [];
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = flatten;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    Set = getNative(root, 'Set'),
    nativeCreate = getNative(Object, 'create');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each
 * element is kept.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length)
    ? baseUniq(array)
    : [];
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = uniq;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = isKey(path, object) ? [path] : castPath(path);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var isBuffer = __webpack_require__(326)

module.exports = flatten
flatten.flatten = flatten
flatten.unflatten = unflatten

function flatten (target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var maxDepth = opts.maxDepth
  var output = {}

  function step (object, prev, currentDepth) {
    currentDepth = currentDepth || 1
    Object.keys(object).forEach(function (key) {
      var value = object[key]
      var isarray = opts.safe && Array.isArray(value)
      var type = Object.prototype.toString.call(value)
      var isbuffer = isBuffer(value)
      var isobject = (
        type === '[object Object]' ||
        type === '[object Array]'
      )

      var newKey = prev
        ? prev + delimiter + key
        : key

      if (!isarray && !isbuffer && isobject && Object.keys(value).length &&
        (!opts.maxDepth || currentDepth < maxDepth)) {
        return step(value, newKey, currentDepth + 1)
      }

      output[newKey] = value
    })
  }

  step(target)

  return output
}

function unflatten (target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var overwrite = opts.overwrite || false
  var result = {}

  var isbuffer = isBuffer(target)
  if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
    return target
  }

  // safely ensure that the key is
  // an integer.
  function getkey (key) {
    var parsedKey = Number(key)

    return (
      isNaN(parsedKey) ||
      key.indexOf('.') !== -1 ||
      opts.object
    ) ? key
      : parsedKey
  }

  var sortedKeys = Object.keys(target).sort(function (keyA, keyB) {
    return keyA.length - keyB.length
  })

  sortedKeys.forEach(function (key) {
    var split = key.split(delimiter)
    var key1 = getkey(split.shift())
    var key2 = getkey(split[0])
    var recipient = result

    while (key2 !== undefined) {
      if (key1 === '__proto__') {
        return
      }
      var type = Object.prototype.toString.call(recipient[key1])
      var isobject = (
        type === '[object Object]' ||
        type === '[object Array]'
      )

      // do not write over falsey, non-undefined values if overwrite is false
      if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
        return
      }

      if ((overwrite && !isobject) || (!overwrite && recipient[key1] == null)) {
        recipient[key1] = (
          typeof key2 === 'number' &&
          !opts.object ? [] : {}
        )
      }

      recipient = recipient[key1]
      if (split.length > 0) {
        key1 = getkey(split.shift())
        key2 = getkey(split[0])
      }
    }

    // unflatten again for 'messy objects'
    recipient[key1] = unflatten(target[key], opts)
  })

  return result
}


/***/ }),
/* 326 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reconciliationReportsReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
var initialState={reconciliationReports:{loading:false,success:true,data:{reports:[],lastReconciliation:null,currentReconciliationBalance:0,years:[],reconciliationInProgressReportId:null}},reconciliationReportDetails:{loading:false,success:true,newReconciliationReportId:null,data:{}},newReconciliationReport:{loading:false,success:true,newReconciliationReportId:null},inProgressReconciliationReport:{loading:false,success:true},deleteReconciliationReport:{loading:false,success:true},reconciliationAdjustments:[],reconciliationBalance:0,filters:{year:''}};function reconciliationReportsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_BANK_RECONCILIATIONS"]:return Object.assign({},state,{reconciliationReports:Object.assign({},initialState.reconciliationReports,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_BANK_RECONCILIATIONS"]:return Object.assign({},state,{reconciliationReports:Object.assign({},state.reconciliationReports,action.response),reconciliationBalance:action.response.success?action.response.data.currentReconciliationBalance:0});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_RECONCILIATION_REPORTS_FILTERS"]:return Object.assign({},state,{filters:Object.assign({},state.filters,action.filter)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_RECONCILIATION_ADJUSTMENTS"]:return Object.assign({},state,{reconciliationAdjustments:action.value});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_RECONCILIATION_BALANCE"]:return Object.assign({},state,{reconciliationBalance:action.value});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_RECONCILIATION_REPORT"]:return Object.assign({},state,{reconciliationReportDetails:Object.assign({},initialState.reconciliationReportDetails,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_RECONCILIATION_REPORT"]:return Object.assign({},state,{reconciliationReportDetails:Object.assign({},action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_CREATE_RECONCILIATION_REPORT"]:return Object.assign({},state,{newReconciliationReport:Object.assign({},initialState.newReconciliationReport,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["CREATE_RECONCILIATION_REPORT"]:return Object.assign({},state,{newReconciliationReport:Object.assign({},action.response,{newReconciliationReportId:action.response.data})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_UPDATE_RECONCILIATION_REPORT"]:case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_COMPLETE_RECONCILIATION_REPORT"]:case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_CREATE_AND_COMPLETE_RECONCILIATION_REPORT"]:return Object.assign({},state,{inProgressReconciliationReport:Object.assign({},initialState.inProgressReconciliationReport,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_RECONCILIATION_REPORT"]:return Object.assign({},state,{inProgressReconciliationReport:Object.assign({},action.response)});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["COMPLETE_RECONCILIATION_REPORT"]:case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["CREATE_AND_COMPLETE_RECONCILIATION_REPORT"]:return Object.assign({},state,{reconciliationReports:initialState.reconciliationReports,newReconciliationReport:initialState.newReconciliationReport});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_DELETE_RECONCILIATION_REPORT"]:return Object.assign({},state,{deleteReconciliationReport:Object.assign({},initialState.deleteReconciliationReport,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["DELETE_RECONCILIATION_REPORT"]:return Object.assign({},state,{deleteReconciliationReport:Object.assign({},action.response),newReconciliationReport:initialState.newReconciliationReport});default:return state;}}

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={page:1,resultsView:12,sort:{by:'',direction:''},loading:false,success:true,data:{totalCount:0,records:[]},currentRequestId:0,selected:[],updating:{},removing:{loading:false,success:true,message:''}};/* harmony default export */ __webpack_exports__["a"] = (function(tableType){return function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['UPDATE_'+tableType+'_TABLE']:return Object.assign({},state,action.settings);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['CLEAR_'+tableType+'_TABLE_RECORDS']:return Object.assign({},state,{data:initialState.data});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['START_GET_'+tableType+'_TABLE_RECORDS']:return Object.assign({},state,{loading:true,success:true,currentRequestId:action.requestId});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['GET_'+tableType+'_TABLE_RECORDS']:return action.requestId!==state.currentRequestId?state:Object.assign({},state,Object.assign({},action.response,{data:Object.assign({},initialState.data,action.response.data)},Object.keys(state.updating).length?{updating:Object.keys(state.updating).filter(function(key){return state.updating[key];}).reduce(function(obj,key){obj[key]=state.updating[key];return obj;},{})}:{}));case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['START_UPDATE_'+tableType+'_TABLE_RECORD']:return Object.assign({},state,{updating:Object.assign({},state.updating,_defineProperty({},action.recordId,true))});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['UPDATE_'+tableType+'_TABLE_RECORD']:var updatingRecords=Object.assign({},state.updating);action.response.success?delete updatingRecords[action.response.recordId]:updatingRecords[action.response.recordId]=action.response.message||false;var records=[].concat(_toConsumableArray(state.data.records));if(action.response.success){var index=records.map(function(rec){return rec[action.response.recordIdKey];}).indexOf(action.response.recordId);if(index>=0){records[index]=Object.assign({},records[index],action.response.update);}}return Object.assign({},state,{data:Object.assign({},state.data,{records:records}),updating:updatingRecords});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['TOGGLE_SELECT_'+tableType+'_TABLE_RECORD']:var selectedRecordId=action.record[action.recordIdKey];var selected=state.selected.map(function(rec){return rec[action.recordIdKey];}).indexOf(selectedRecordId)<0?[].concat(_toConsumableArray(state.selected),[action.record]):state.selected.filter(function(rec){return rec[action.recordIdKey]!==selectedRecordId;});return Object.assign({},state,{selected:selected});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['CLEAR_'+tableType+'_TABLE_SELECTION']:return Object.assign({},state,{selected:[]});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['START_REMOVE_'+tableType+'_TABLE_RECORD']:return Object.assign({},state,{removing:Object.assign({},initialState.removing,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__['REMOVE_'+tableType+'_TABLE_RECORD']:var data=action.response.success?{totalCount:--state.data.totalCount,records:state.data.records.filter(function(rec){return rec[action.response.recordIdKey]!==action.response.recordId;})}:state.data;var remainingSelection=state.selected.filter(function(rec){return rec[action.response.recordIdKey]!==action.response.recordId;});return Object.assign({},state,{data:data,selected:remainingSelection,removing:{success:action.response.success,message:action.response.message,loading:false}});default:return state;}};});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={currentRequestId:0,data:{totalCount:0,records:[]},filters:{},hasMore:true,loading:false,page:1,results:24,selected:[],sort:{by:"",direction:""},success:true};/* harmony default export */ __webpack_exports__["a"] = (function(listType){return function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_"+listType+"_INFINITELIST_CONFIGS"]:return Object.assign({},state,action.configs);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["CLEAR_"+listType+"_INFINITELIST_RECORDS"]:return Object.assign({},state,{data:initialState.data});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_"+listType+"_INFINITELIST_RECORDS"]:return Object.assign({},state,Object.assign({currentRequestId:action.requestId,hasMore:true,loading:true,success:true},action.reset?{data:initialState.data}:[]));case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_"+listType+"_INFINITELIST_RECORDS"]:return action.requestId!==state.currentRequestId?state:Object.assign({},state,Object.assign({},action.response,{data:Object.assign({},action.response.data,{records:[].concat(_toConsumableArray(state.data.records),_toConsumableArray(action.response.data.records||[]))}),hasMore:action.response.data.records&&action.response.data.records.length===state.results}));case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_"+listType+"_INFINITELIST_DATA"]:return Object.assign({},state,{data:action.data});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["TOGGLE_SELECT_"+listType+"_INFINITELIST_RECORD"]:var selectedRecordId=action.record[action.recordIdKey];var selected=state.selected.map(function(rec){return rec[action.recordIdKey];}).indexOf(selectedRecordId)<0?[].concat(_toConsumableArray(state.selected),[action.record]):state.selected.filter(function(rec){return rec[action.recordIdKey]!==selectedRecordId;});return Object.assign({},state,{selected:selected});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["CLEAR_"+listType+"_INFINITELIST_SELECTION"]:return Object.assign({},state,{selected:[]});default:return state;}};});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
var initialState={profile:{success:true,loading:false,data:{}},permissions:{success:true,loading:false,data:[]}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_USER_PROFILE"]:return Object.assign({},state,{profile:Object.assign({},state.profile,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_USER_PROFILE"]:return Object.assign({},state,{profile:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_USER_PERMISSIONS"]:return action.myPermissions?Object.assign({},state,{permissions:Object.assign({},state.permissions,{loading:true})}):state;case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_USER_PERMISSIONS"]:return action.myPermissions?Object.assign({},state,{permissions:action.response}):state;case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_USER_PROFILE"]:return Object.assign({},state,{profile:Object.assign({},state.profile,{data:Object.assign({},state.profile.data,action.update)})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["LOGOUT"]:return Object.assign({},action.response.success?initialState:state);default:return state;}});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = usersReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
var initialState={approvers:{loading:false,success:true,data:[]},userDetails:{loading:false,success:true,data:{}},userPermissions:{loading:false,success:true,data:[]},updateUser:{loading:false,success:true,message:''},updateUserDetail:{loading:false,success:true},createUser:{loading:false,success:true,message:''},permissionsForRole:{loading:false,success:true,data:[]}};function usersReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_APPROVERS"]:return Object.assign({},state,{approvers:Object.assign({},state.approvers,{success:true,loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_APPROVERS"]:return Object.assign({},state,{approvers:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_USER_DETAILS"]:return Object.assign({},state,{userDetails:Object.assign({},initialState.userDetails,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_USER_DETAILS"]:return Object.assign({},state,{userDetails:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_USER_PERMISSIONS"]:return!action.myPermissions?Object.assign({},state,{userPermissions:Object.assign({},initialState.userPermissions,{loading:true})}):state;case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_USER_PERMISSIONS"]:return!action.myPermissions?Object.assign({},state,{userPermissions:action.response}):state;case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["CLEAR_USER_DETAILS_AND_PERMISSIONS"]:return Object.assign({},state,{userDetails:initialState.userDetails,userPermissions:initialState.userPermissions,permissionsForRole:initialState.permissionsForRole});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_UPDATE_USER"]:return Object.assign({},state,{updateUser:Object.assign({},initialState.updateUser,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_USER"]:return Object.assign({},state,{updateUser:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_UPDATE_USER_DETAIL"]:return Object.assign({},state,{updateUserDetail:Object.assign({},initialState.updateUserDetail,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_USER_DETAIL"]:return Object.assign({},state,{updateUserDetail:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_CREATE_USER"]:return Object.assign({},state,{createUser:Object.assign({},initialState.createUser,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["CREATE_USER"]:return Object.assign({},state,{createUser:action.response});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["START_GET_PERMISSIONS_FOR_ROLE"]:return Object.assign({},state,{permissionsForRole:Object.assign({},initialState.permissionsForRole,{loading:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["GET_PERMISSIONS_FOR_ROLE"]:return Object.assign({},state,{permissionsForRole:action.response});default:return state;}}

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
var initialState={geosuggestLanguageSettings:{loading:false,success:true,language:''}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["UPDATE_GEOSUGGEST_SETTINGS"]:return Object.assign({},state,{geosuggestLanguageSettings:Object.assign({},state.geosuggestLanguageSettings,action.setting)});default:return state;}});

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PageNotFound=function(_React$Component){_inherits(PageNotFound,_React$Component);function PageNotFound(){_classCallCheck(this,PageNotFound);return _possibleConstructorReturn(this,(PageNotFound.__proto__||Object.getPrototypeOf(PageNotFound)).apply(this,arguments));}_createClass(PageNotFound,[{key:'constructer',value:function constructer(){}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'background-404'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'text-404 relative'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h1',{className:'left'},'4'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'coin'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'front'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'front_b'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'back'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{className:'back_b'})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('h1',{className:'right'},'4')),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',{className:'sorry'},'Sorry, the page you are looking for cannot be found.'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{to:'/applications',className:'home-link'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('i',{className:'material-icons'},'arrow_back'),'Take me home')));}}]);return PageNotFound;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PageNotFound);

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_AuthenticationActions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_shared_SplitPageContainer__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoginPage=function(_React$Component){_inherits(LoginPage,_React$Component);function LoginPage(props){_classCallCheck(this,LoginPage);var _this=_possibleConstructorReturn(this,(LoginPage.__proto__||Object.getPrototypeOf(LoginPage)).call(this,props));_this.state={username:"",password:""};_this.onChange=_this.onChange.bind(_this);_this.login=_this.login.bind(_this);return _this;}_createClass(LoginPage,[{key:'onChange',value:function onChange(event){this.setState(_defineProperty({},event.target.name,event.target.value));}},{key:'login',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(!this.state.username||!this.state.password)){_context.next=2;break;}return _context.abrupt('return');case 2:_context.next=4;return this.props.actions.login(this.state.username,this.state.password);case 4:if(this.props.success){if(this.props.data.verify){this.props.location.state&&this.props.location.state.from?this.props.history.replace("/verify-login",{from:this.props.location.state.from}):this.props.history.push("/verify-login");}else{this.props.location.state&&this.props.location.state.from?this.props.history.replace(this.props.location.state.from):this.props.history.push("/applications");}}else{this.setState({password:""});}case 5:case'end':return _context.stop();}}},_callee,this);}));function login(){return _ref.apply(this,arguments);}return login;}()},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__commonComponents_shared_SplitPageContainer__["a" /* default */],{title:'SFTF',subtitle:'Log in to access your account'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',null,this.props.location.state&&this.props.location.state.resetPasswordRedirect&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('span',{className:'success-label success-label-margin-bottom'},'Your password has been reset.  Please log in below.'),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('label',{className:'input-label'},'Email'),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('input',{type:'text',name:'username',value:this.state.username,onChange:this.onChange,onKeyDown:function onKeyDown(e){if(e.key==='Enter')_this2.login();}})),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('label',{className:'input-label'},'Password'),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('input',{type:'password',name:'password',value:this.state.password,onChange:this.onChange,onKeyDown:function onKeyDown(e){if(e.key==='Enter')_this2.login();}})),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:'left-column-footer relative'},this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'32'}):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('button',{className:'btn btn-primary btn-wide',onClick:this.login,disabled:!this.state.username||!this.state.password},'Login'),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:!this.props.success,message:this.props.message}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{className:'link-text',to:'/recover-password'},'Forgot your password? '))));}}]);return LoginPage;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);function mapStateToProps(state){return Object.assign({},state.authentication.login);}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_5__redux_actions_AuthenticationActions__,dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(LoginPage));

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_AuthenticationActions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_SplitPageContainer__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VerifyLoginPage=function(_React$Component){_inherits(VerifyLoginPage,_React$Component);function VerifyLoginPage(props){_classCallCheck(this,VerifyLoginPage);var _this=_possibleConstructorReturn(this,(VerifyLoginPage.__proto__||Object.getPrototypeOf(VerifyLoginPage)).call(this,props));_this.state={verificationCode:"",rememberDevice:false};_this.onChange=_this.onChange.bind(_this);_this.verify=_this.verify.bind(_this);return _this;}_createClass(VerifyLoginPage,[{key:'onChange',value:function onChange(event){this.setState(_defineProperty({},event.target.name,event.target.type==="checkbox"?event.target.checked:event.target.value));}},{key:'verify',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(this.state.verificationCode){_context.next=2;break;}return _context.abrupt('return');case 2:_context.next=4;return this.props.actions.verifyLogin(this.state.verificationCode,this.state.rememberDevice);case 4:if(this.props.success){this.props.location.state&&this.props.location.state.from?this.props.history.replace(this.props.location.state.from):this.props.history.push("/applications");}else{this.setState({verificationCode:""});}case 5:case'end':return _context.stop();}}},_callee,this);}));function verify(){return _ref.apply(this,arguments);}return verify;}()},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_SplitPageContainer__["a" /* default */],{title:'Login Verify',subtitle:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('span',null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('i',{className:'material-icons middle'},'smartphone'),' A text message with your code has been sent to ',this.props.phoneLast2Digits?'(***)-***-**'+this.props.phoneLast2Digits:'your phone','.')},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('label',{className:'input-label'},'Enter Verification Code'),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('input',{type:'text',name:'verificationCode',value:this.state.verificationCode,onChange:this.onChange,onKeyDown:function onKeyDown(e){if(e.key==='Enter')_this2.verify();}})),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('input',{type:'checkbox',id:'remember',className:'custom-check',name:'rememberDevice',checked:this.state.rememberDevice,onChange:this.onChange}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('label',{htmlFor:'remember',className:'secondary-text'},'Remember this computer for 30 days')),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:'left-column-footer relative'},this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'32'}):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('button',{className:'btn btn-primary btn-wide',onClick:this.verify,disabled:!this.state.verificationCode},'Verify'),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:!this.props.success,message:this.props.message}))));}}]);return VerifyLoginPage;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);function mapStateToProps(state){return Object.assign({},state.authentication.verifyLogin,{phoneLast2Digits:state.authentication.login.data.phoneLast2Digits});}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_4__redux_actions_AuthenticationActions__,dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(VerifyLoginPage));

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_AuthenticationActions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_SplitPageContainer__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_query_string__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_query_string__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PasswordResetPage=function(_React$Component){_inherits(PasswordResetPage,_React$Component);function PasswordResetPage(props){_classCallCheck(this,PasswordResetPage);var _this=_possibleConstructorReturn(this,(PasswordResetPage.__proto__||Object.getPrototypeOf(PasswordResetPage)).call(this,props));_this.state={password:'',passwordConfirm:'',validPassword:false,token:__WEBPACK_IMPORTED_MODULE_9_query_string___default.a.parse(_this.props.location.search).token};_this.onChange=_this.onChange.bind(_this);_this.resetPassword=_this.resetPassword.bind(_this);return _this;}_createClass(PasswordResetPage,[{key:'onChange',value:function onChange(name,value){this.setState(_defineProperty({},name,value));}},{key:'validatePassword',value:function validatePassword(password){var validPassword=!password||/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/.test(password);this.setState({validPassword:validPassword});return validPassword;}},{key:'resetPassword',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.actions.resetPassword(this.state.token,this.state.password);case 2:if(this.props.success){this.props.history.push('/login',{resetPasswordRedirect:true});}else{this.setState({password:'',passwordConfirm:'',validPassword:false});if(this.props.expired)this.props.history.push('/recover-password',{expiredResetTokenRedirect:true});}case 3:case'end':return _context.stop();}}},_callee,this);}));function resetPassword(){return _ref.apply(this,arguments);}return resetPassword;}()},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_SplitPageContainer__["a" /* default */],{title:this.props.location.pathname==="/reset-password"?"Password Reset":"Set Password",subtitle:'Please enter '+(this.props.location.pathname==="/reset-password"?"your new":"a")+' password.'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('input',{type:'password'}),label:'Password',name:'password',value:this.state.password,onChange:this.onChange,validated:true,showValidationError:true,validate:this.validatePassword.bind(this),errorMessage:'Password must be at least 8 characters long, and must contain an uppercase and lowercase letter and a digit.'}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('input',{type:'password',disabled:!this.state.password||!this.state.validPassword,onKeyDown:function onKeyDown(e){if(e.key==='Enter'&&_this2.state.password===_this2.state.passwordConfirm)_this2.resetPassword();}}),label:'Confirm Password',name:'passwordConfirm',value:this.state.passwordConfirm,onChange:this.onChange,validated:true,showValidationError:true,validate:function validate(val){return!val||_this2.state.password===val;},errorMessage:'Passwords do not match.'}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:'left-column-footer relative'},this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'32'}):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('button',{className:'btn btn-primary btn-wide',onClick:this.resetPassword,disabled:!this.state.passwordConfirm||this.state.password!==this.state.passwordConfirm},'Submit'),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:!this.props.success&&!this.props.expired}))));}}]);return PasswordResetPage;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);function mapStateToProps(state){return Object.assign({},state.authentication.resetPassword);}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_4__redux_actions_AuthenticationActions__,dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(PasswordResetPage));

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_AuthenticationActions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_shared_SplitPageContainer__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PasswordRecoverPage=function(_React$Component){_inherits(PasswordRecoverPage,_React$Component);function PasswordRecoverPage(props){_classCallCheck(this,PasswordRecoverPage);var _this=_possibleConstructorReturn(this,(PasswordRecoverPage.__proto__||Object.getPrototypeOf(PasswordRecoverPage)).call(this,props));_this.state={email:'',validEmail:false,submitted:false};_this.onChange=_this.onChange.bind(_this);_this.submitEmail=_this.submitEmail.bind(_this);return _this;}_createClass(PasswordRecoverPage,[{key:'onChange',value:function onChange(name,value){this.setState(_defineProperty({},name,value));}},{key:'validateEmail',value:function validateEmail(email){var validEmail=Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["x" /* isValidEmail */])(email);this.setState({validEmail:validEmail});return validEmail;}},{key:'submitEmail',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.actions.recoverPassword(this.state.email);case 2:if(this.props.success)this.setState({submitted:true});case 3:case'end':return _context.stop();}}},_callee,this);}));function submitEmail(){return _ref.apply(this,arguments);}return submitEmail;}()},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__commonComponents_shared_SplitPageContainer__["a" /* default */],{title:'Password Recovery',subtitle:'Enter your email address and we will send you a link to reset your password.'},this.state.submitted?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:'password-recovery'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('p',null,'Sent!'),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('p',null,'An email has been sent to ',this.state.email,', check your inbox for instructions on how to reset your password.')):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',null,this.props.location.state&&this.props.location.state.expiredResetTokenRedirect&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('span',{className:'error-label error-label-margin-bottom'},'Your reset password link has expired.  Please enter your email to receive a new link to reset your password.'),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('input',{type:'text',onKeyDown:function onKeyDown(e){if(e.key==='Enter'&&_this2.state.email)if(_this2.validateEmail(_this2.state.email))_this2.submitEmail();}}),label:'Enter Email Address',name:'email',value:this.state.email,onChange:this.onChange,validated:true,showValidationError:this.state.email,validate:this.validateEmail.bind(this),errorMessage:'Invalid Email Address'}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:'left-column-footer relative'},this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'32'}):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('button',{className:'btn btn-primary btn-wide',onClick:this.submitEmail,disabled:!this.state.email||!this.state.validEmail},'Reset'),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:!this.props.success}))));}}]);return PasswordRecoverPage;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);function mapStateToProps(state){return Object.assign({},state.authentication.recoverPassword);}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_4__redux_actions_AuthenticationActions__,dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(PasswordRecoverPage));

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_SettingsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_AuthenticationActions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions_UserProfileActions__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_actions_UtilsActions__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__IdleTimer__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Header__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ProtectedPage__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applicationsComponents_applications_ApplicationsPage__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__applicationsComponents_newApplication_CreateApplicationPage__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__printingComponents_PrintingPage__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__recipientAccountsComponents_recipientAccounts_RecipientAccountsPage__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__recipientAccountsComponents_recipientAccountDetails_RecipientAccountDetailsPage__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__recipientAccountsComponents_references_ReferencesPage__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__recipientAccountsComponents_manageDuplicates_DuplicateRecipientsPage__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__campaignComponents_campaigns_CampaignsPage__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__campaignComponents_campaignDetails_CampaignDetailsPage__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__campaignComponents_campaignLists_CampaignListsPage__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__campaignComponents_campaignListDetails_CampaignListDetailsPage__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__campaignComponents_campaignListDetails_CampaignListApplicationsPage__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__accountingComponents_funds_FundsPage__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__accountingComponents_fundDetails_FundDetailsPage__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__settingComponents_userSettings_UserSettingsPage__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__settingComponents_systemSettings_SystemSettingsPage__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__settingComponents_checkPrinting_CheckPrintingPage__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_react_helmet__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_react_helmet__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Layout=function(_React$Component){_inherits(Layout,_React$Component);function Layout(props){_classCallCheck(this,Layout);var _this=_possibleConstructorReturn(this,(Layout.__proto__||Object.getPrototypeOf(Layout)).call(this,props));_this.state={ready:false};return _this;}_createClass(Layout,[{key:'componentWillMount',value:function componentWillMount(){this.startupRequests();}},{key:'logout',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(redirect,navOnly){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(navOnly){_context.next=3;break;}_context.next=3;return this.props.actions.logout();case 3:if(navOnly||this.props.logout.success){this.props.history.push("/login",redirect?{from:this.props.location.pathname+this.props.location.search}:{});}case 4:case'end':return _context.stop();}}},_callee,this);}));function logout(_x,_x2){return _ref.apply(this,arguments);}return logout;}()},{key:'startupRequests',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Promise.all([this.props.actions.getSystemSettings(),this.props.actions.getTags()]);case 2:if(this.props.settings.systemSettings.success){this.setState({ready:true});}else{__WEBPACK_IMPORTED_MODULE_9_react_redux_toastr__["toastr"].error("Something went wrong","We were unable to properly retrieve system settings.  Please try refreshing the page.");}case 3:case'end':return _context2.stop();}}},_callee2,this);}));function startupRequests(){return _ref2.apply(this,arguments);}return startupRequests;}()},{key:'handleScriptInject',value:function handleScriptInject(_ref3){var scriptTags=_ref3.scriptTags;if(scriptTags){if(window.google)window.google=undefined;this.props.actions.updateGeosuggestLanguageSettings({loading:true});var scriptTag=scriptTags[0];scriptTag.onload=this.handleOnLoad.bind(this);}}},{key:'handleOnLoad',value:function handleOnLoad(script){this.props.actions.updateGeosuggestLanguageSettings({loading:false});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__IdleTimer__["a" /* default */],{logout:this.logout.bind(this),refreshUrl:'/account/refreshToken'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32_react_helmet__["Helmet"],{defer:false,onChangeClientState:function onChangeClientState(newState,addedTags){return _this2.handleScriptInject(addedTags);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('script',{async:false,type:'text/javascript',src:'https://maps.googleapis.com/maps/api/js?key='+"AIzaSyA5hyj_ZDrtl3AM67YAc9LiGCgqhvB_6i0"+'&libraries=places'+(this.props.utils.geosuggestLanguageSettings.language?'&language='+this.props.utils.geosuggestLanguageSettings.language:'')})),this.props.location.pathname!=='/print'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Header__["a" /* default */],{userProfile:this.props.userProfile,userPermissions:this.props.userPermissions,loggingOut:this.props.logout.loading,logout:this.logout.bind(this),updateAiSummaryPreference:this.props.actions.updateAiSummaryPreference}),!this.state.ready?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'35'})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:'/applications',render:function render(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProtectedPage__["a" /* default */],{permitted:_this2.props.userPermissions.viewApplications},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__applicationsComponents_applications_ApplicationsPage__["a" /* default */],props));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:'/applications/create-application/:recipientId?',render:function render(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProtectedPage__["a" /* default */],{permitted:_this2.props.userPermissions.manageApplications},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__applicationsComponents_newApplication_CreateApplicationPage__["a" /* default */],props));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:'/print',render:function render(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProtectedPage__["a" /* default */],{permitted:_this2.props.userPermissions.printPayments},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__printingComponents_PrintingPage__["a" /* default */],props));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:'/recipient-accounts',render:function render(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProtectedPage__["a" /* default */],{permitted:_this2.props.userPermissions.viewRecipients},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__recipientAccountsComponents_recipientAccounts_RecipientAccountsPage__["a" /* default */],props));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:'/recipient-accounts/references',render:function render(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProtectedPage__["a" /* default */],{permitted:_this2.props.userPermissions.viewRecipients},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__recipientAccountsComponents_references_ReferencesPage__["a" /* default */],props));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:'/recipient-accounts/:id',render:function render(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProtectedPage__["a" /* default */],{permitted:_this2.props.userPermissions.viewApplications||_this2.props.userPermissions.viewRecipients},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__recipientAccountsComponents_recipientAccountDetails_RecipientAccountDetailsPage__["a" /* default */],props));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:'/campaigns',render:function render(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProtectedPage__["a" /* default */],{permitted:_this2.props.userPermissions.viewCampaigns},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__campaignComponents_campaigns_CampaignsPage__["a" /* default */],props));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:'/campaigns/lists',render:function render(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProtectedPage__["a" /* default */],{permitted:_this2.props.userPermissions.viewCampaignLists},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__campaignComponents_campaignLists_CampaignListsPage__["a" /* default */],props));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:'/campaigns/:id',render:function render(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProtectedPage__["a" /* default */],{permitted:_this2.props.userPermissions.viewCampaigns},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__campaignComponents_campaignDetails_CampaignDetailsPage__["a" /* default */],props));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:'/campaigns/:campaignId/lists/:listId/applications',render:function render(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProtectedPage__["a" /* default */],{permitted:_this2.props.userPermissions.viewCampaignLists},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__campaignComponents_campaignListDetails_CampaignListApplicationsPage__["a" /* default */],props));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:'/campaigns/lists/:id',render:function render(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProtectedPage__["a" /* default */],{permitted:_this2.props.userPermissions.viewCampaignLists},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__campaignComponents_campaignListDetails_CampaignListDetailsPage__["a" /* default */],props));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:'/accounting',render:function render(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProtectedPage__["a" /* default */],{permitted:_this2.props.userPermissions.viewAccounting},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__accountingComponents_funds_FundsPage__["a" /* default */],props));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:'/accounting/:id',render:function render(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProtectedPage__["a" /* default */],{permitted:_this2.props.userPermissions.viewAccounting},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__accountingComponents_fundDetails_FundDetailsPage__["a" /* default */],props));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:'/settings/user',render:function render(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProtectedPage__["a" /* default */],{permitted:_this2.props.userPermissions.admin},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__settingComponents_userSettings_UserSettingsPage__["a" /* default */],props));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:'/settings/system',render:function render(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProtectedPage__["a" /* default */],{permitted:_this2.props.userPermissions.admin},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__settingComponents_systemSettings_SystemSettingsPage__["a" /* default */],props));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:'/settings/printing',render:function render(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ProtectedPage__["a" /* default */],{permitted:_this2.props.userPermissions.admin},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__settingComponents_checkPrinting_CheckPrintingPage__["a" /* default */],props));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{path:'/settings',to:'/settings/user'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{exact:true,path:'/',to:'/applications'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{path:'*',to:'/404'})));}}]);return Layout;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);function mapStateToProps(state,ownProps){return{settings:state.settings,logout:state.authentication.logout,userProfile:state.userProfile.profile.data,userPermissions:{viewApplications:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_31__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsView)>=0,manageApplications:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_31__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsManage)>=0,printPayments:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_31__lib_systemVariables__["j" /* PermissionTypes */].PaymentsPrint)>=0,viewRecipients:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_31__lib_systemVariables__["j" /* PermissionTypes */].RecipientAccntsView)>=0,manageRecipients:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_31__lib_systemVariables__["j" /* PermissionTypes */].RecipientAccntsManage)>=0,viewCampaigns:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_31__lib_systemVariables__["j" /* PermissionTypes */].CampaignAndListsView)>=0,viewCampaignLists:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_31__lib_systemVariables__["j" /* PermissionTypes */].CampaignAndListsView)>=0&&state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_31__lib_systemVariables__["j" /* PermissionTypes */].IndividualsManage)>=0,viewAccounting:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_31__lib_systemVariables__["j" /* PermissionTypes */].AccountingView)>=0,admin:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_31__lib_systemVariables__["j" /* PermissionTypes */].UsersAndSettingsManage)>=0},utils:state.utils};}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(Object.assign({},__WEBPACK_IMPORTED_MODULE_5__redux_actions_SettingsActions__,__WEBPACK_IMPORTED_MODULE_6__redux_actions_AuthenticationActions__,__WEBPACK_IMPORTED_MODULE_7__redux_actions_UserProfileActions__,{updateGeosuggestLanguageSettings:__WEBPACK_IMPORTED_MODULE_8__redux_actions_UtilsActions__["a" /* updateGeosuggestLanguageSettings */]}),dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Layout));

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var baseOrderBy = __webpack_require__(341),
    isArray = __webpack_require__(28);

/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */
function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }
  if (!isArray(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }
  orders = guard ? undefined : orders;
  if (!isArray(orders)) {
    orders = orders == null ? [] : [orders];
  }
  return baseOrderBy(collection, iteratees, orders);
}

module.exports = orderBy;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(146),
    baseGet = __webpack_require__(90),
    baseIteratee = __webpack_require__(370),
    baseMap = __webpack_require__(419),
    baseSortBy = __webpack_require__(425),
    baseUnary = __webpack_require__(159),
    compareMultiple = __webpack_require__(426),
    identity = __webpack_require__(162),
    isArray = __webpack_require__(28);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(68);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 343 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(345);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(346);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(92);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(348),
    ListCache = __webpack_require__(70),
    Map = __webpack_require__(94);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(349),
    hashDelete = __webpack_require__(354),
    hashGet = __webpack_require__(355),
    hashHas = __webpack_require__(356),
    hashSet = __webpack_require__(357);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(69);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(149),
    isMasked = __webpack_require__(351),
    isObject = __webpack_require__(93),
    toSource = __webpack_require__(150);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(352);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(31);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 353 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 354 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(69);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(69);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(69);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 358 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(71);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(71);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(71);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(71);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(72);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 364 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(72);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(72);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(72);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(369);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(68),
    arrayMap = __webpack_require__(146),
    isArray = __webpack_require__(28),
    isSymbol = __webpack_require__(67);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(371),
    baseMatchesProperty = __webpack_require__(411),
    identity = __webpack_require__(162),
    isArray = __webpack_require__(28),
    property = __webpack_require__(416);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(372),
    getMatchData = __webpack_require__(410),
    matchesStrictComparable = __webpack_require__(161);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(152),
    baseIsEqual = __webpack_require__(153);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(70);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 374 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 375 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 376 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(70),
    Map = __webpack_require__(94),
    MapCache = __webpack_require__(92);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(152),
    equalArrays = __webpack_require__(154),
    equalByTag = __webpack_require__(384),
    equalObjects = __webpack_require__(388),
    getTag = __webpack_require__(405),
    isArray = __webpack_require__(28),
    isBuffer = __webpack_require__(156),
    isTypedArray = __webpack_require__(158);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(92),
    setCacheAdd = __webpack_require__(380),
    setCacheHas = __webpack_require__(381);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 380 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 381 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 382 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 383 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(68),
    Uint8Array = __webpack_require__(385),
    eq = __webpack_require__(151),
    equalArrays = __webpack_require__(154),
    mapToArray = __webpack_require__(386),
    setToArray = __webpack_require__(387);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(31);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 386 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 387 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(389);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(390),
    getSymbols = __webpack_require__(392),
    keys = __webpack_require__(95);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(391),
    isArray = __webpack_require__(28);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 391 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(393),
    stubArray = __webpack_require__(394);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 393 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 394 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(396),
    isArguments = __webpack_require__(155),
    isArray = __webpack_require__(28),
    isBuffer = __webpack_require__(156),
    isIndex = __webpack_require__(157),
    isTypedArray = __webpack_require__(158);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 396 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53),
    isObjectLike = __webpack_require__(54);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 398 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53),
    isLength = __webpack_require__(96),
    isObjectLike = __webpack_require__(54);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(148);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)(module)))

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(402),
    nativeKeys = __webpack_require__(403);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 402 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(404);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 404 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(406),
    Map = __webpack_require__(94),
    Promise = __webpack_require__(407),
    Set = __webpack_require__(408),
    WeakMap = __webpack_require__(409),
    baseGetTag = __webpack_require__(53),
    toSource = __webpack_require__(150);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(43),
    root = __webpack_require__(31);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(43),
    root = __webpack_require__(31);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(43),
    root = __webpack_require__(31);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(43),
    root = __webpack_require__(31);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(160),
    keys = __webpack_require__(95);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(153),
    get = __webpack_require__(412),
    hasIn = __webpack_require__(413),
    isKey = __webpack_require__(91),
    isStrictComparable = __webpack_require__(160),
    matchesStrictComparable = __webpack_require__(161),
    toKey = __webpack_require__(73);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(90);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(414),
    hasPath = __webpack_require__(415);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 414 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(147),
    isArguments = __webpack_require__(155),
    isArray = __webpack_require__(28),
    isIndex = __webpack_require__(157),
    isLength = __webpack_require__(96),
    toKey = __webpack_require__(73);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(417),
    basePropertyDeep = __webpack_require__(418),
    isKey = __webpack_require__(91),
    toKey = __webpack_require__(73);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 417 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(90);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(420),
    isArrayLike = __webpack_require__(97);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(421),
    createBaseEach = __webpack_require__(424);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(422),
    keys = __webpack_require__(95);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(423);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 423 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(97);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 425 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(427);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(67);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header=function(_NavigationComponent){_inherits(Header,_NavigationComponent);function Header(props){var _this2=this;_classCallCheck(this,Header);var _this=_possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).call(this,props));_this.updateAiSummaryPreference=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var showAiSummaries,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:showAiSummaries=event.target.checked;_this.setState({savingAiSummaryPreference:true});_context.next=4;return _this.props.updateAiSummaryPreference(showAiSummaries);case 4:response=_context.sent;if(!response.success){__WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__["toastr"].error('Something went wrong','We were unable to save your AI summary preference.');}_this.setState({savingAiSummaryPreference:false});case 7:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.state={showMobileMenu:false,showAccountDropdown:false,savingAiSummaryPreference:false};_this.accountDropdownRef=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();_this.handleDocumentClick=_this.handleDocumentClick.bind(_this);return _this;}_createClass(Header,[{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('mousedown',this.handleDocumentClick,true);document.addEventListener('touchstart',this.handleDocumentClick,true);document.addEventListener('click',this.handleDocumentClick,true);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('mousedown',this.handleDocumentClick,true);document.removeEventListener('touchstart',this.handleDocumentClick,true);document.removeEventListener('click',this.handleDocumentClick,true);}},{key:'handleDocumentClick',value:function handleDocumentClick(event){if(this.state.showAccountDropdown&&this.accountDropdownRef.current&&!this.accountDropdownRef.current.contains(event.target)){this.setState({showAccountDropdown:false});}}},{key:'render',value:function render(){var _this3=this;var firstName=this.props.userProfile&&this.props.userProfile.firstName?this.props.userProfile.firstName:'';var lastName=this.props.userProfile&&this.props.userProfile.lastName?this.props.userProfile.lastName:'';var fullName=(firstName+' '+lastName).trim()||'User';var email=this.props.userProfile&&(this.props.userProfile.email||this.props.userProfile.userName||this.props.userProfile.username)?this.props.userProfile.email||this.props.userProfile.userName||this.props.userProfile.username:'';var firstInitial=firstName?firstName.charAt(0).toUpperCase():'U';var lastInitial=lastName?lastName.charAt(0).toUpperCase():'';var userInitials=''+firstInitial+lastInitial;var showAiSummaries=!this.props.userProfile||this.props.userProfile.showAiSummaries!==false;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'header-left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/logo-white.png',alt:'logo'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'header-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'nav'},this.props.userPermissions.viewApplications&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],{to:'/applications',activeClassName:'active'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-layers'}),'Applications')),this.props.userPermissions.viewRecipients&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],{to:'/recipient-accounts',activeClassName:'active'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-people'}),'Recipients')),this.props.userPermissions.viewCampaigns&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],{to:'/campaigns',activeClassName:'active'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-volume-2'}),'Campaigns')),this.props.userPermissions.viewAccounting&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],{to:'/accounting',activeClassName:'active'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-calculator'}),'Accounting')),this.props.userPermissions.admin&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],{to:'/settings',activeClassName:'active'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-settings'}),'Admin')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'header-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'account-dropdown-container',ref:this.accountDropdownRef},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'button',className:'account-avatar-trigger',onClick:function onClick(){return _this3.setState({showAccountDropdown:!_this3.state.showAccountDropdown});}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'account-avatar-initial'},userInitials)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dropdown-box '+(this.state.showAccountDropdown?'active':'')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dropdown-user-info'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'dropdown-user-icon'},userInitials),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dropdown-user-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'dropdown-user-name'},fullName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'dropdown-user-email'},email))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dropdown-ai-summary-setting'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'toggle-ai-summaries',className:'dropdown-ai-summary-label'},'AI summaries'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dropdown-ai-summary-control'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'dropdown-ai-summary-state'},showAiSummaries?'On':'Off'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'toggle-ai-summaries',className:'cbx account-ai-summary-checkbox input',checked:showAiSummaries,disabled:this.state.savingAiSummaryPreference,onChange:this.updateAiSummaryPreference}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'toggle-ai-summaries',className:'toggle input '+(this.state.savingAiSummaryPreference?'disabled':'')}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{onClick:function onClick(){_this3.setState({showAccountDropdown:false});_this3.props.logout();},disabled:this.props.loggingOut},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'exit_to_app'),'Sign out'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'mobile-menu-icon',onClick:function onClick(){return _this3.setState({showMobileMenu:true});}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons open-menu'},'menu')))),this.state.showAccountDropdown&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'account-dropdown-backdrop',onClick:function onClick(){return _this3.setState({showAccountDropdown:false});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'mobile-menu '+(!this.state.showMobileMenu?'closed-menu':'')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'mobile-menu-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'mobile-menu-header-text',onClick:function onClick(){return _this3.setState({showMobileMenu:false});}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons close-menu',onClick:function onClick(){return _this3.setState({showMobileMenu:false});}},'close'),'Close')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',null,this.props.userPermissions.viewApplications&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],{to:'/applications',activeClassName:'active'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-layers'}),'Applications')),this.props.userPermissions.viewRecipients&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],{to:'/recipient-accounts',activeClassName:'active'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-people'}),'Recipients')),this.props.userPermissions.viewCampaigns&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],{to:'/campaigns',activeClassName:'active'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-volume-2'}),'Campaigns')),this.props.userPermissions.viewAccounting&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],{to:'/accounting',activeClassName:'active'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-calculator'}),'Accounting')),this.props.userPermissions.admin&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],{to:'/settings',activeClassName:'active'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-settings'}),'Admin Settings')))));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProtectedPage=function(_React$Component){_inherits(ProtectedPage,_React$Component);function ProtectedPage(){_classCallCheck(this,ProtectedPage);return _possibleConstructorReturn(this,(ProtectedPage.__proto__||Object.getPrototypeOf(ProtectedPage)).apply(this,arguments));}_createClass(ProtectedPage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:this.props.className||""},this.props.permitted?this.props.children:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"no-results"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon ion-eye-disabled"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"You don't have permission to view this page."))));}}]);return ProtectedPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ProtectedPage);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_ApplicationsActions__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_CheckPrintingActions__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_SidebarFilterActions__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_urlUtils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_apiUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_throttle_debounce__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_throttle_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_throttle_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ApplicationsPageActionsView__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ApplicationsTable__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commonComponents_shared_SidebarFilter__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ApplicationsListControls__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ApplicationsReportModal__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__achComponents_ACHResultsPage__ = __webpack_require__(469);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ApplicationsPage=function(_React$Component){_inherits(ApplicationsPage,_React$Component);function ApplicationsPage(props){_classCallCheck(this,ApplicationsPage);var _this=_possibleConstructorReturn(this,(ApplicationsPage.__proto__||Object.getPrototypeOf(ApplicationsPage)).call(this,props));_initialiseProps.call(_this);_this.state={search:'',reportModal:false,showACHResults:false,achResults:[]};_this.filterApplications=_this.filterApplications.bind(_this);return _this;}_createClass(ApplicationsPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;if(Object(__WEBPACK_IMPORTED_MODULE_9__lib_urlUtils__["a" /* getQueryParams */])().applyFilters){var tableView=Object(__WEBPACK_IMPORTED_MODULE_9__lib_urlUtils__["a" /* getQueryParams */])().view;if(tableView){this.toggleView(tableView,true);}else{this.setState({search:this.props.filters.elasticSearchText||''},function(){_this2.props.actions.getApplications(_this2.state.search,_this2.props.applicationsTable.page,_this2.props.applicationsTable.resultsView,_this2.props.applicationsTable.sort);});}}else{//manually rest and reload data, only if not popped off stack
this.props.actions.resetFilters(__WEBPACK_IMPORTED_MODULE_8__lib_constants__["j" /* TableNames */].Applications,true);//reset and apply filters
this.props.actions.filterApplications(true);//reset table and reload applications and counts
}this.props.actions.getStatusCounts();}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.props.applicationsTable.selected.length){this.props.actions.clearApplicationsSelection();}}},{key:'filterApplications',value:function filterApplications(updatedFilters,updateCounts,resetSort){var tableSort=this.props.applicationsTable.sort;if(updatedFilters.lastName){tableSort={by:"lastNameDiff",direction:"Ascending"};}else if(updatedFilters.firstName){tableSort={by:"firstNameDiff",direction:"Ascending"};}else if(updatedFilters.status===null&&(this.props.applicationsTable.sort.by==="lastNameDiff"||this.props.applicationsTable.sort.by==="firstNameDiff")){tableSort=undefined;}this.props.actions.filterApplications(updateCounts,updatedFilters,this.state.search,this.props.applicationsTable.resultsView,resetSort?undefined:tableSort);if(updatedFilters&&!Object(__WEBPACK_IMPORTED_MODULE_9__lib_urlUtils__["a" /* getQueryParams */])().applyFilters){Object(__WEBPACK_IMPORTED_MODULE_9__lib_urlUtils__["b" /* setQueryParams */])({applyFilters:true});}}},{key:'render',value:function render(){var _this3=this;if(this.state.showACHResults){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__achComponents_ACHResultsPage__["a" /* default */],{achResults:this.state.achResults,onClose:this.closeACHResults});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page page-with-sidebar applications '+(!this.props.sidebarVisible?"page-with-sidebar-hidden":"")},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__commonComponents_shared_SidebarFilter__["a" /* default */],{type:__WEBPACK_IMPORTED_MODULE_8__lib_constants__["j" /* TableNames */].Applications,search:this.searchApplications}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'subheader relative'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-justify flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-one'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons sidebar-slide-out',onClick:function onClick(){return _this3.props.actions.toggleSidebar(__WEBPACK_IMPORTED_MODULE_8__lib_constants__["j" /* TableNames */].Applications);}},'filter_list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'page-header'},'Applications')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-one'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'elastic-search'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'search-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'search'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',name:'search',placeholder:'Search (Max Results: 100)',value:this.state.search||'',onChange:function onChange(e){return _this3.search(e);}})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ApplicationsPageActionsView__["a" /* default */],{canCreate:this.props.userPermissions.manage,userPermissions:this.props.userPermissions,userProfile:this.props.userProfile,filters:this.props.filters,sort:this.props.applicationsTable.sort,selected:this.props.applicationsTable.selected,selectedCounts:this.props.selectedCounts,funds:this.props.funds,inquireOnly:this.props.filters.inquireOnly,noData:!this.props.applicationsTable.data.records||!this.props.applicationsTable.data.records.length,printing:this.props.checkPrinting,approving:this.props.updating,sendingACH:this.props.sendingACH,onACHResultsReady:this.handleACHResultsReady,actions:{toggleInquireOnly:function toggleInquireOnly(){return _this3.filterApplications({inquireOnly:!_this3.props.filters.inquireOnly},true);},approveApplications:function approveApplications(applications){return _this3.props.actions.updateApplicationsStatus('approve',applications);},printChecks:this.props.actions.printChecks,wireApplications:this.props.actions.wireApplications,sendACHApplications:this.props.actions.sendACHApplications,updateSelectedCounts:this.props.actions.updateSelectedCounts,onActionCompleted:function onActionCompleted(){var keepSelect=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];_this3.filterApplications({},true);keepSelect.forEach(function(app){return _this3.props.actions.toggleSelectApplication(app);});},toggleView:this.toggleView}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ApplicationsListControls__["a" /* default */],{status:this.props.filters.status,days:this.props.filters.days,statusCounts:this.props.statusCounts.data,inquireOnly:this.props.filters.inquireOnly,toggleInquireOnly:function toggleInquireOnly(){return _this3.filterApplications({inquireOnly:!_this3.props.filters.inquireOnly},true);},update:function update(propertyName,value){return _this3.filterApplications(_defineProperty({},propertyName,value),propertyName==="days");},filters:this.props.filters,toggleView:this.toggleView,canExport:this.props.userPermissions.report,exportDisabled:!this.props.applicationsTable.data.records||!this.props.applicationsTable.data.records.length,onExport:this.toggleReportModal}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ApplicationsReportModal__["a" /* default */],{getDataForExport:this.getApplicationsForExport,show:this.state.reportModal,close:this.toggleReportModal})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ApplicationsTable__["a" /* default */],Object.assign({},this.props.applicationsTable,{view:this.props.filters.view,isUSUser:this.props.userProfile.departments&&this.props.userProfile.departments.indexOf(__WEBPACK_IMPORTED_MODULE_7__lib_systemVariables__["g" /* Departments */].US)>=0,userPermissions:this.props.userPermissions,funds:this.props.funds,status:this.props.filters.status,updateTable:this.props.actions.updateTable,getApplications:this.getApplications,selectApplication:this.props.actions.toggleSelectApplication,updateApplication:this.props.actions.updateApplication,deleteApplication:this.props.actions.deleteApplication}))));}}]);return ApplicationsPage;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this4=this;this.search=function(e){_this4.setState({search:e.target.value});if(!Object(__WEBPACK_IMPORTED_MODULE_9__lib_urlUtils__["a" /* getQueryParams */])().applyFilters){Object(__WEBPACK_IMPORTED_MODULE_9__lib_urlUtils__["b" /* setQueryParams */])({applyFilters:true});}_this4.searchDebounce();};this.searchDebounce=Object(__WEBPACK_IMPORTED_MODULE_11_throttle_debounce__["debounce"])(400,function(){_this4.props.actions.filterApplications(true,Object.assign({},_this4.props.filters,{days:Object.assign({},_this4.props.filters.days,{Recent:""})}),_this4.state.search,_this4.props.applicationsTable.resultsView,_this4.state.search.length>0?{by:'ApplicationIds',direction:'Ascending'}:undefined);});this.getApplications=function(){var _props$actions;for(var _len=arguments.length,props=Array(_len),_key=0;_key<_len;_key++){props[_key]=arguments[_key];}(_props$actions=_this4.props.actions).getApplications.apply(_props$actions,[_this4.state.search].concat(props));if(props&&!Object(__WEBPACK_IMPORTED_MODULE_9__lib_urlUtils__["a" /* getQueryParams */])().applyFilters){Object(__WEBPACK_IMPORTED_MODULE_9__lib_urlUtils__["b" /* setQueryParams */])({applyFilters:true});}};this.searchApplications=function(updatedFilters){_this4.filterApplications(Object.assign({},updatedFilters,{status:null,days:Object.assign({},_this4.props.filters.days,{Recent:""})//reset table status to All & All time.
}),true);};this.toggleView=function(view){if(view!==_this4.props.filters.view){var sortBy=_this4.props.applicationsTable.sort.by;var resetSort=view===__WEBPACK_IMPORTED_MODULE_8__lib_constants__["k" /* TableViews */].Standard?sortBy==="address"||sortBy==="teudatZahut"||sortBy==="totalPaid"||sortBy==="source"||sortBy==="note"||sortBy==="references":sortBy==="fund";_this4.filterApplications({view:view},false,resetSort);Object(__WEBPACK_IMPORTED_MODULE_9__lib_urlUtils__["b" /* setQueryParams */])({view:view===__WEBPACK_IMPORTED_MODULE_8__lib_constants__["k" /* TableViews */].Standard?null:view});}};this.handleACHResultsReady=function(achResults){_this4.setState({showACHResults:true,achResults:achResults});};this.closeACHResults=function(){_this4.setState({showACHResults:false,achResults:[]});_this4.props.actions.clearApplicationsSelection();_this4.filterApplications({},true);};this.toggleReportModal=function(){_this4.setState(function(prevState){return{reportModal:!prevState.reportModal};});};this.getApplicationsForExport=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(params){var filterSettings,filterProperty,filterVal;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:filterSettings=_this4.props.filters;for(filterProperty in filterSettings){if(filterProperty!=="days"&&filterProperty!=="status"){filterVal=filterSettings[filterProperty];if(filterProperty==="recipients"){filterVal=filterSettings.recipients.map(function(rec){return rec.applicantId;});}params[filterProperty]=filterVal;}}_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_10__lib_apiUtils__["b" /* getRequest */])("/applications/report",params,null,{responseType:'blob'});case 4:return _context.abrupt('return',_context.sent);case 5:case'end':return _context.stop();}}},_callee,_this4);}));return function(_x2){return _ref.apply(this,arguments);};}();};function mapStateToProps(state,ownProps){return Object.assign({},state.applications,{applicationsTable:state.applicationsTable,sidebarVisible:state.applicationsSidebarFilters.showSidebar,checkPrinting:state.checkPrinting.printing,selectedCounts:state.applications.selectedCounts,userProfile:state.userProfile.profile.data,userPermissions:{manage:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_7__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsManage)>=0,approveFull:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_7__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsApproveFull)>=0,approveLimited:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_7__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsApproveLimited)>=0,wire:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_7__lib_systemVariables__["j" /* PermissionTypes */].PaymentsWire)>=0,print:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_7__lib_systemVariables__["j" /* PermissionTypes */].PaymentsPrint)>=0,report:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_7__lib_systemVariables__["j" /* PermissionTypes */].Reporting)>=0},funds:state.funds.fundsByDept.allWithLimits});}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(Object.assign({},__WEBPACK_IMPORTED_MODULE_4__redux_actions_ApplicationsActions__,{printChecks:__WEBPACK_IMPORTED_MODULE_5__redux_actions_CheckPrintingActions__["printChecks"],toggleSidebar:__WEBPACK_IMPORTED_MODULE_6__redux_actions_SidebarFilterActions__["toggleSidebar"],resetFilters:__WEBPACK_IMPORTED_MODULE_6__redux_actions_SidebarFilterActions__["resetFilters"]}),dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(ApplicationsPage));

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-undefined */

var throttle = __webpack_require__(164);

/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {Number}   delay         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}  atBegin       Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @return {Function} A new, debounced function.
 */
module.exports = function ( delay, atBegin, callback ) {
	return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
};


/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_shared_ConfirmationModal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_shared_ExportButton__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__printingComponents_PrintModal__ = __webpack_require__(104);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ApplicationsPageActionsView=function(_NavigationComponent){_inherits(ApplicationsPageActionsView,_NavigationComponent);function ApplicationsPageActionsView(props){_classCallCheck(this,ApplicationsPageActionsView);var _this=_possibleConstructorReturn(this,(ApplicationsPageActionsView.__proto__||Object.getPrototypeOf(ApplicationsPageActionsView)).call(this,props));_this.state={showModals:{printApplicationsModal:false,approveSelectedModal:false,sendACHModal:false}};return _this;}_createClass(ApplicationsPageActionsView,[{key:"componentDidMount",value:function componentDidMount(){// Calculate initial counts
if(this.props.actions.updateSelectedCounts&&this.props.selected.length>0){this.props.actions.updateSelectedCounts(this.props.selected,this.props.userProfile,this.props.funds);}}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){// Update counts when selected applications change
if(prevProps.selected!==this.props.selected&&this.props.actions.updateSelectedCounts){this.props.actions.updateSelectedCounts(this.props.selected,this.props.userProfile,this.props.funds);}}},{key:"getWireApplicationForExport",value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(applicationIds){var applications;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.actions.wireApplications(applicationIds);case 2:applications=_context.sent;if(applications.data.length){applications.data=applications.data.map(function(d){return Object.assign({},d,{teudatZahut:Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils__["n" /* formatNumberStringForExcel */])(d.teudatZahut)});});}return _context.abrupt("return",applications);case 5:case"end":return _context.stop();}}},_callee,this);}));function getWireApplicationForExport(_x){return _ref.apply(this,arguments);}return getWireApplicationForExport;}()},{key:"getSelectionAction",value:function getSelectionAction(){var isUSUser=this.props.userProfile.departments&&this.props.userProfile.departments.indexOf(__WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__["g" /* Departments */].US)>=0;var isIsraelUser=this.props.userProfile.departments&&this.props.userProfile.departments.indexOf(__WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__["g" /* Departments */].IL)>=0;var checkCount=this.props.selectedCounts?this.props.selectedCounts.check:0;var achCount=this.props.selectedCounts?this.props.selectedCounts.ach:0;var wireCount=this.props.selectedCounts?this.props.selectedCounts.wire:0;var action=void 0;if(this.props.filters.status===__WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__["a" /* ApplicationStatuses */].New){action=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-flat btn-small approve",disabled:this.props.approving.loading,onClick:this.toggleModal.bind(this,"approveSelectedModal")},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon ion-ios-checkmark approved-text icon-left large-text middle"}),this.props.approving.loading?"Approving Selected...":"Approve Selected");}else if(this.props.filters.status===__WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__["a" /* ApplicationStatuses */].Approved){action=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"approved-btns",style:{display:'flex',flexWrap:'wrap',gap:'8px',alignItems:'flex-start',justifyContent:'flex-start'}},isUSUser&&checkCount>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-flat btn-small selection-action-btn selection-action-btn--with-badge",disabled:this.props.printing.loading,onClick:this.toggleModal.bind(this,"printApplicationsModal")},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"selection-action-btn__content"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"material-icons selection-action-btn__icon selection-action-btn__icon--print","aria-hidden":"true"},"print"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"selection-action-btn__label"},"Print")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"selection-action-btn__badge"},checkCount)),isUSUser&&achCount>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-flat btn-small selection-action-btn selection-action-btn--with-badge",disabled:this.props.sendingACH.loading,onClick:this.toggleModal.bind(this,"sendACHModal"),title:"ACH is enabled for organizations that have bank account info. Fund must be ACH-enabled and third-party payments are not allowed."},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"selection-action-btn__content"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"material-icons selection-action-btn__icon middle","aria-hidden":"true"},"swap_horiz"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"selection-action-btn__label"},"Send ACH")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"selection-action-btn__badge"},achCount)),isIsraelUser&&wireCount>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_shared_ExportButton__["a" /* default */],{text:"Wire",count:wireCount,buttonClassName:"selection-action-btn selection-action-btn--with-badge",disabled:this.props.noData,exportHeaders:[{label:"First Name",value:"firstName",default:""},{label:"Last Name",value:"lastName",default:""},{label:"Teudat",value:"teudatZahut",default:""},{label:"Wire Info",value:"wireInfo",default:""},{label:"Address",value:"address",default:""},{label:"City",value:"city",default:""},{label:"Amount",value:"amount",default:""},{label:"Pay To",value:"payTo",default:""},{label:"Currency Symbol",value:"currencySymbol",default:""}],fileName:"Approved-wires",getDataForExport:this.getWireApplicationForExport.bind(this,this.props.selected.filter(function(app){return app.currency===__WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__["f" /* CurrencyTypes */].Shekel;}).map(function(app){return app.applicationId;}),true),onGetDataSuccess:this.props.actions.onActionCompleted.bind(this,this.props.selected.filter(function(app){return app.currency!==__WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__["f" /* CurrencyTypes */].Shekel;}))}));}return action&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"flex-center"},action);}},{key:"approveApplications",value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return this.props.actions.approveApplications(this.props.selected.map(function(app){return{applicationId:app.applicationId,amount:app.amount,currency:Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils__["s" /* getObjectKeyByValue */])(__WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__["f" /* CurrencyTypes */],app.currency)};}));case 2:if(this.props.approving.success){__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].success(this.props.selected.length+" "+(this.props.selected.length>1?"Applications have":"Application has")+" been approved.");this.props.actions.onActionCompleted();}case 3:case"end":return _context2.stop();}}},_callee2,this);}));function approveApplications(){return _ref2.apply(this,arguments);}return approveApplications;}()},{key:"printApplications",value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(printerId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return this.props.actions.printChecks("applications",printerId,{applicationIds:this.props.selected.filter(function(app){return app.currency===__WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__["f" /* CurrencyTypes */].Dollar;}).map(function(app){return app.applicationId;})});case 2:if(this.props.printing.success){this.props.actions.onActionCompleted(this.props.selected.filter(function(app){return app.currency!==__WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__["f" /* CurrencyTypes */].Dollar;}));}case 3:case"end":return _context3.stop();}}},_callee3,this);}));function printApplications(_x2){return _ref3.apply(this,arguments);}return printApplications;}()},{key:"getQualifyingAchApplications",value:function getQualifyingAchApplications(){return this.props.selected.filter(function(app){return app.currency===__WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__["f" /* CurrencyTypes */].Dollar&&app.recipient&&app.recipient.hasAchAccount&&app.recipient.applicantType===__WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__["l" /* RecipientTypes */].Organization&&app.payTo==="Recipient"&&app.fundAllowsACH===true;});}},{key:"sendACHToSelected",value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var selectedAchApplications,applicationIds,response,achResults;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:selectedAchApplications=this.getQualifyingAchApplications();if(!(selectedAchApplications.length===0)){_context4.next=4;break;}__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].warning("No ACH Applications","None of the selected applications qualify for ACH transfer.");return _context4.abrupt("return");case 4:applicationIds=selectedAchApplications.map(function(app){return app.applicationId;});_context4.prev=5;_context4.next=8;return this.props.actions.sendACHApplications(applicationIds);case 8:response=_context4.sent;if(response.success){_context4.next=11;break;}throw new Error(response.message||"ACH transfer failed");case 11:achResults=selectedAchApplications.map(function(app){var apiResult=response.data?response.data.find(function(result){return result.transactionId===app.applicationId;}):null;return{applicationId:app.applicationId,orgName:app.recipient.lastOrOrgName,amount:app.amount,success:apiResult?apiResult.isSuccess:false,errorMessage:apiResult?apiResult.message:'No response received from server'};});// Pass results to parent component
if(this.props.onACHResultsReady){this.props.onACHResultsReady(achResults);}return _context4.abrupt("return",true);case 16:_context4.prev=16;_context4.t0=_context4["catch"](5);__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].error("ACH Transfer Failed",_context4.t0.message||"ACH transfer could not be initiated. Please try again.");return _context4.abrupt("return",false);case 20:case"end":return _context4.stop();}}},_callee4,this,[[5,16]]);}));function sendACHToSelected(){return _ref4.apply(this,arguments);}return sendACHToSelected;}()},{key:"toggleModal",value:function toggleModal(modalName){this.setState({showModals:Object.assign({},this.state.showModals,_defineProperty({},modalName,!this.state.showModals[modalName]))});}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"flex-one"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"btn-group-top flex-right subheader-btns"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"action-buttons"},this.props.selected.length>0&&this.getSelectionAction(),this.props.canCreate&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{className:"btn btn-primary btn-small action-btn",to:"/applications/create-application"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"material-icons icon-left action-btn-icon"},"add"),"Create"))),this.state.showModals.printApplicationsModal&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__printingComponents_PrintModal__["a" /* default */],{close:this.toggleModal.bind(this,"printApplicationsModal"),onPrintSuccess:this.pushRoute.bind(this,"/print"),count:this.props.selected.length,print:this.printApplications.bind(this)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_shared_ConfirmationModal__["a" /* default */],{show:this.state.showModals.approveSelectedModal,title:"Approve Applications",message:"Are you sure you want to approve "+this.props.selected.length+" selected application"+(this.props.selected.length!==1?"s":"")+"?",close:this.toggleModal.bind(this,"approveSelectedModal"),confirm:this.approveApplications.bind(this),loading:this.props.approving.loading,success:this.props.approving.success,errorMessage:this.props.approving.message||"This action could not be completed. Please try again."}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_shared_ConfirmationModal__["a" /* default */],{show:this.state.showModals.sendACHModal,title:"Send ACH",message:"Are you sure you want to send ACH to the "+this.getQualifyingAchApplications().length+" selected recipient"+(this.getQualifyingAchApplications().length!==1?"s":"")+"?",close:this.toggleModal.bind(this,"sendACHModal"),confirm:this.sendACHToSelected.bind(this),loading:this.props.sendingACH.loading,success:this.props.sendingACH.success,errorMessage:this.props.sendingACH.message||"ACH transfer could not be initiated. Please try again."}));}}]);return ApplicationsPageActionsView;}(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ApplicationsPageActionsView);

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransitionGroup = __webpack_require__(434);

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _TransitionGroup = __webpack_require__(165);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  TransitionGroup: _TransitionGroup2.default,
  CSSTransitionGroup: _CSSTransitionGroup2.default
};

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(165);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(437);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(169);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 435 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(166);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(167);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(439);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(440);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(35);

var _PropTypes = __webpack_require__(169);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(102);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(168));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */


var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(102);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(168));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_PaginatedTable__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ApplicationsTableRow__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_ConfirmationModal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_constants__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ApplicationsTable=function(_NavigationComponent){_inherits(ApplicationsTable,_NavigationComponent);function ApplicationsTable(props){var _this2=this;_classCallCheck(this,ApplicationsTable);var _this=_possibleConstructorReturn(this,(ApplicationsTable.__proto__||Object.getPrototypeOf(ApplicationsTable)).call(this,props));_this.initialState={selectedRecord:{},showModals:{confirmationModal:false}};_this.updateApplication=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(application,update){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.updateApplication(application,update);case 2:response=_context.sent;return _context.abrupt('return',response);case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x,_x2){return _ref.apply(this,arguments);};}();_this.deleteApplication=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var selectedRecord,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:selectedRecord=_this.state.selectedRecord;_context2.next=3;return _this.props.deleteApplication(selectedRecord.applicationId);case 3:response=_context2.sent;return _context2.abrupt('return',response);case 5:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.state=_this.initialState;_this.getTableRow=_this.getTableRow.bind(_this);return _this;}_createClass(ApplicationsTable,[{key:'getTableRow',value:function getTableRow(application){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ApplicationsTableRow__["a" /* default */],{key:application.applicationId,view:this.props.view,status:this.props.status,application:application,isUSUser:this.props.isUSUser,permissions:this.props.userPermissions,fund:this.props.funds.find(function(f){return f.key===application.fundId;})?this.props.funds.find(function(f){return f.key===application.fundId;}).value:null,selectApplication:this.props.selectApplication,selected:this.props.selected.map(function(app){return app.applicationId;}).indexOf(application.applicationId)>=0,update:this.updateApplication,updating:this.props.updating[application.applicationId]===true,updateError:this.props.updating.hasOwnProperty(application.applicationId)&&this.props.updating[application.applicationId]!==true,'delete':function _delete(){_this3.setState({selectedRecord:application},_this3.toggleModal.bind(_this3,"confirmationModal"));}});}},{key:'render',value:function render(){var _this4=this;var _props=this.props,view=_props.view,status=_props.status,permissions=_props.userPermissions;var canApprove=permissions.approveFull||permissions.approveLimited;var canManage=permissions.manage;var canPrintOrWire=this.props.isUSUser?permissions.print:permissions.wire;var columns=[{id:'firstName',title:'First Name',sortable:true},{id:'lastOrOrgName',title:'Last / Org Name',sortable:true}].concat(_toConsumableArray(view===__WEBPACK_IMPORTED_MODULE_7__lib_constants__["k" /* TableViews */].Detailed?[{id:'address',title:'Address',sortable:true},{id:'teudatZahut',title:'Teudat Zehut',sortable:true},{id:'totalPaid',title:'Total Paid',sortable:true,className:'text-right'}]:[]),[{id:'applicationDate',title:'Created / Review Date',sortable:true,defaultDirection:'Descending'},{id:'details',title:'Details',sortable:true},{id:'status',title:'Status',sortable:true},{id:'amount',title:'Amount',sortable:true,className:'text-right'}],_toConsumableArray(view===__WEBPACK_IMPORTED_MODULE_7__lib_constants__["k" /* TableViews */].Detailed?[{id:'source',title:'Source',sortable:true},{id:'note',title:'Note',sortable:true},{id:'references',title:'References',sortable:true}]:[{id:'fund',title:'Fund',sortable:true}]),[{id:'private',title:'',sortable:false,icon:"lock_outline"},{id:'ach',title:'ACH',sortable:false,icon:"account_balance"}]);if(canManage){if(!status||status===__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["a" /* ApplicationStatuses */].New||status===__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["a" /* ApplicationStatuses */].Incomplete){columns.push({id:'delete',title:'',sortable:false,icon:"delete_outline"});}if(status===__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["a" /* ApplicationStatuses */].New&&canApprove||status===__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["a" /* ApplicationStatuses */].Approved&&canPrintOrWire){var selectableApps=this.props.data.records.filter(function(app){var fundEntry=_this4.props.funds.find(function(f){return f.key===app.fundId;});var fund=fundEntry?fundEntry.value:null;var cantSelect=(status===__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["a" /* ApplicationStatuses */].New||status===__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["a" /* ApplicationStatuses */].Approved)&&!app.amount||!fund||status===__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["a" /* ApplicationStatuses */].Approved&&app.currency===__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["f" /* CurrencyTypes */].Dollar&&!_this4.props.userPermissions.approveFull&&app.amount>fund.limitedApprovalMax||status===__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["a" /* ApplicationStatuses */].Approved&&app.amount>(app.currency===__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["f" /* CurrencyTypes */].Shekel?fund.wiringMax:fund.checkCuttingMax);return!cantSelect;});var selectedApps=this.props.selected.filter(function(app){return selectableApps.map(function(a){return a.applicationId;}).indexOf(app.applicationId)>=0;});var checked=selectableApps.length&&selectedApps.length===selectableApps.length;columns.unshift({id:'select',title:'',sortable:false,component:!this.props.loading&&this.props.data.records.length&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-check-container '+(!selectableApps.length?"disabled":"")},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'applications-select-all',className:'custom-check',checked:checked,disabled:!selectableApps.length,onChange:function onChange(){return(!checked?selectableApps.filter(function(app){return selectedApps.map(function(a){return a.applicationId;}).indexOf(app.applicationId)<0;}):selectableApps).forEach(function(app){return _this4.props.selectApplication(app);});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'applications-select-all',className:'secondary-text',title:'Select All'}))});}}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_PaginatedTable__["a" /* default */],{name:'applications',page:this.props.page,totalCount:this.props.data.totalCount,resultsView:this.props.resultsView,sort:this.props.sort,loading:this.props.loading,success:this.props.success,renderRow:this.getTableRow,columns:columns,records:this.props.data.records||[],sortData:this.props.updateTable,changeDataView:this.props.updateTable,loadData:this.props.getApplications,noReload:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_ConfirmationModal__["a" /* default */],{show:this.state.showModals.confirmationModal,message:this.state.selectedRecord.applicationId?'Are you sure you want to permanently delete this '+this.state.selectedRecord.status.toLowerCase()+' application?':'',close:function close(){_this4.setState({selectedRecord:_this4.initialState.selectedRecord});_this4.toggleModal("confirmationModal");},confirm:this.deleteApplication,loading:this.props.removing.loading,success:this.props.removing.success,errorMessage:this.props.removing.message}));}}]);return ApplicationsTable;}(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ApplicationsTable);

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_HoverTableRow__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_shared_ApplicationStatusTag__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_shared_UpdateApplicationAmtInput__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RecipientSummaryCard__ = __webpack_require__(171);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ApplicationsTableRow=function(_NavigationComponent){_inherits(ApplicationsTableRow,_NavigationComponent);function ApplicationsTableRow(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ApplicationsTableRow);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ApplicationsTableRow.__proto__||Object.getPrototypeOf(ApplicationsTableRow)).call.apply(_ref,[this].concat(args))),_this),_this.state={summaryOpen:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ApplicationsTableRow,[{key:'render',// getCombinedNotes = (applicationNote, recipientNote) => {
//     if (!applicationNote && !recipientNote) return;
//     const limit = 50;
//     if (applicationNote && recipientNote) {
//         let applicationNoteTrimmed = applicationNote;
//         let recipientNoteTrimmed = recipientNote;
//         if ((applicationNote.length + recipientNote.length) > limit) {
//             if (applicationNote.length > (limit / 2) && recipientNote.length > (limit / 2)) {
//                 applicationNoteTrimmed = applicationNote.substring(0, (limit / 2));
//                 recipientNoteTrimmed = recipientNote.substring(0, (limit / 2));
//             } else if (recipientNote.length > (limit / 2)) {
//                 recipientNoteTrimmed = recipientNote.substring(0, (limit - applicationNote));
//             } else if (applicationNote.length > (limit / 2)) {
//                 applicationNoteTrimmed = applicationNote.substring(0, (limit - recipientNote));
//             }
//         }
//         return `Application Notes: ${applicationNoteTrimmed} | Recipient Notes: ${recipientNoteTrimmed}`
//     }
//     return applicationNote
//         ? `Application Notes: ${applicationNote.substring(0, limit)}`
//         : `Recipient Notes: ${recipientNote.substring(0, limit)}`;
// // }
// getNoteDisplay = note => {
//     const limit = 50;
//     return (note && note.length > limit) ? note.substring(0, limit) + "..." : note;
// }
value:function render(){var _this2=this;var _props$application=this.props.application,applicationId=_props$application.applicationId,status=_props$application.status,_props$application$re=_props$application.recipient,recipient=_props$application$re===undefined?{}:_props$application$re,sourceName=_props$application.sourceName,applicationDate=_props$application.applicationDate,amount=_props$application.amount,fundName=_props$application.fundName,_props$application$ca=_props$application.campaign,campaign=_props$application$ca===undefined?{}:_props$application$ca,reason=_props$application.reason,hasAttachments=_props$application.hasAttachments,hasReceipt=_props$application.hasReceipt,isBlocked=_props$application.isBlocked,isPrivate=_props$application.isPrivate,inquire=_props$application.inquire,currency=_props$application.currency,note=_props$application.note,printedUnconfirmed=_props$application.printedUnconfirmed,canBeDeleted=_props$application.canBeDeleted;var _props=this.props,tableStatus=_props.status,permissions=_props.permissions,view=_props.view;var canApprove=permissions.approveFull||permissions.approveLimited;var canManage=permissions.manage;var canPrintOrWire=this.props.isUSUser?permissions.print:permissions.wire;var fund=this.props.fund;var disabledTooltip='';if(isBlocked){disabledTooltip='You do not have access to this application';}else if((status===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].New||status===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].Approved)&&!amount)disabledTooltip='Application amount required';else if((status===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].New||status===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].Approved)&&!fund)disabledTooltip='Fund data unavailable';else if(status===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].New&&currency===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["f" /* CurrencyTypes */].Dollar&&!permissions.approveFull&&amount>fund.limitedApprovalMax)disabledTooltip='Application amount exceeds your approval max';else if(status===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].Approved&&amount>(currency===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["f" /* CurrencyTypes */].Shekel?fund.wiringMax:fund.checkCuttingMax))disabledTooltip='Application amount exceeds '+(currency===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["f" /* CurrencyTypes */].Shekel?'wiring':'check cutting')+' max';else if(status===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].Approved&&printedUnconfirmed){disabledTooltip='Application requires printing confirmation';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_HoverTableRow__["a" /* default */],{className:'table-row '+(view===__WEBPACK_IMPORTED_MODULE_4__lib_constants__["k" /* TableViews */].Detailed?'application-row-detailed':'')+' '+(this.state.summaryOpen?'recipient-summary-open':''),onClick:this.pushRouteWithProps.bind(this,'/recipient-accounts/'+recipient.recipientId+'?applicationId='+applicationId,{prevPage:(tableStatus?__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */][tableStatus]+' ':'')+'Applications',applicationId:applicationId})},(tableStatus===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].New&&canApprove||tableStatus===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].Approved&&canPrintOrWire)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-check-container name-check-container '+(disabledTooltip?"disabled":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'name-'+applicationId,className:'custom-check input',checked:this.props.selected,onChange:function onChange(){return _this2.props.selectApplication(_this2.props.application);},disabled:disabledTooltip}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name-'+applicationId,className:'secondary-text input',title:disabledTooltip}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,recipient.firstName&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},recipient.firstName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Name',className:'application-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'application-name-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'bold-text application-name-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{to:'/recipient-accounts/'+recipient.recipientId+'?applicationId='+applicationId},recipient.lastOrOrgName)),inquire&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag inquire'},'Inquire'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__RecipientSummaryCard__["a" /* default */],{recipientId:recipient.recipientId,disabled:isBlocked,onOpenChange:function onOpenChange(summaryOpen){return _this2.setState({summaryOpen:summaryOpen});},title:(''+(recipient.firstName?recipient.firstName+' ':'')+(recipient.lastOrOrgName||'')).trim()}))),view===__WEBPACK_IMPORTED_MODULE_4__lib_constants__["k" /* TableViews */].Detailed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,recipient.addressDisplay&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-location-pin icon-left accent-text2'}),recipient.addressDisplay)),view===__WEBPACK_IMPORTED_MODULE_4__lib_constants__["k" /* TableViews */].Detailed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,recipient.teudatZahut&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-doc icon-left accent-text2'}),recipient.teudatZahut)),view===__WEBPACK_IMPORTED_MODULE_4__lib_constants__["k" /* TableViews */].Detailed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},recipient.totalPaid&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-wallet icon-left accent-text2'}),recipient.totalPaid)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Application Date'},Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["k" /* formatDate */])(applicationDate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Details'},campaign.name?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'accent-text2'},campaign.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,campaign.campaignListName)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,reason),hasAttachments&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons debt-attach accent-text middle'},'attach_file'),hasReceipt&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-doc accent-text middle',style:{marginLeft:'4px'},title:'Has Receipt'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Status'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_shared_ApplicationStatusTag__["a" /* default */],{status:status})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Amount',className:'text-right'},tableStatus===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].New&&canApprove&&canManage&&!isBlocked?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_shared_UpdateApplicationAmtInput__["a" /* default */],{application:this.props.application,updateError:this.props.updateError,update:this.props.update,maxAmount:this.props.application.maxApprovalAmount}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["j" /* formatCurrency */])(amount,currency===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["f" /* CurrencyTypes */].Shekel))),view===__WEBPACK_IMPORTED_MODULE_4__lib_constants__["k" /* TableViews */].Detailed?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Source'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,sourceName)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Fund'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,fundName)),view===__WEBPACK_IMPORTED_MODULE_4__lib_constants__["k" /* TableViews */].Detailed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Note'},note),view===__WEBPACK_IMPORTED_MODULE_4__lib_constants__["k" /* TableViews */].Detailed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'References'},recipient.references?''+recipient.references.substring(0,50)+(recipient.references.length>50?'...':''):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'IsPrivate'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex'},isPrivate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'private-icon mr-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons accent-text'},'lock_outline'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tooltip private-tooltip'},'Private')),isBlocked&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'private-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons accent-text'},'visibility_off_outline'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tooltip private-tooltip'},'Private')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'IsAchEnabled'},recipient.hasAchAccount&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons accent-text'},'check_circle'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tooltip private-tooltip'},'ACH Enabled'))),canManage&&!isBlocked&&(!tableStatus||tableStatus===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].New||tableStatus===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].Incomplete)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Delete'},canBeDeleted&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-trash trash-hover input',onClick:this.props.delete})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null));}}]);return ApplicationsTableRow;}(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ApplicationsTableRow);

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = noop;
exports.returnTrue = returnTrue;
exports.charIsNumber = charIsNumber;
exports.escapeRegExp = escapeRegExp;
exports.getThousandsGroupRegex = getThousandsGroupRegex;
exports.splitDecimal = splitDecimal;
exports.fixLeadingZero = fixLeadingZero;
exports.limitToScale = limitToScale;
exports.roundToPrecision = roundToPrecision;
exports.omit = omit;
exports.setCaretPosition = setCaretPosition;
exports.findChangedIndex = findChangedIndex;
exports.clamp = clamp;
exports.getCurrentCaretPosition = getCurrentCaretPosition;

// basic noop function
function noop() {}

function returnTrue() {
  return true;
}

function charIsNumber(char) {
  return !!(char || '').match(/\d/);
}

function escapeRegExp(str) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}

function getThousandsGroupRegex(thousandsGroupStyle) {
  switch (thousandsGroupStyle) {
    case 'lakh':
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;

    case 'wan':
      return /(\d)(?=(\d{4})+(?!\d))/g;

    case 'thousand':
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
} //spilt a float number into different parts beforeDecimal, afterDecimal, and negation


function splitDecimal(numStr) {
  var allowNegative = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var hasNagation = numStr[0] === '-';
  var addNegation = hasNagation && allowNegative;
  numStr = numStr.replace('-', '');
  var parts = numStr.split('.');
  var beforeDecimal = parts[0];
  var afterDecimal = parts[1] || '';
  return {
    beforeDecimal: beforeDecimal,
    afterDecimal: afterDecimal,
    hasNagation: hasNagation,
    addNegation: addNegation
  };
}

function fixLeadingZero(numStr) {
  if (!numStr) return numStr;
  var isNegative = numStr[0] === '-';
  if (isNegative) numStr = numStr.substring(1, numStr.length);
  var parts = numStr.split('.');
  var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
  var afterDecimal = parts[1] || '';
  return "".concat(isNegative ? '-' : '').concat(beforeDecimal).concat(afterDecimal ? ".".concat(afterDecimal) : '');
}
/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */


function limitToScale(numStr, scale, fixedDecimalScale) {
  var str = '';
  var filler = fixedDecimalScale ? '0' : '';

  for (var i = 0; i <= scale - 1; i++) {
    str += numStr[i] || filler;
  }

  return str;
}
/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */


function roundToPrecision(numStr, scale, fixedDecimalScale) {
  //if number is empty don't do anything return empty string
  if (['', '-'].indexOf(numStr) !== -1) return numStr;
  var shoudHaveDecimalSeparator = numStr.indexOf('.') !== -1 && scale;

  var _splitDecimal = splitDecimal(numStr),
      beforeDecimal = _splitDecimal.beforeDecimal,
      afterDecimal = _splitDecimal.afterDecimal,
      hasNagation = _splitDecimal.hasNagation;

  var roundedDecimalParts = parseFloat("0.".concat(afterDecimal || '0')).toFixed(scale).split('.');
  var intPart = beforeDecimal.split('').reverse().reduce(function (roundedStr, current, idx) {
    if (roundedStr.length > idx) {
      return (Number(roundedStr[0]) + Number(current)).toString() + roundedStr.substring(1, roundedStr.length);
    }

    return current + roundedStr;
  }, roundedDecimalParts[0]);
  var decimalPart = limitToScale(roundedDecimalParts[1] || '', Math.min(scale, afterDecimal.length), fixedDecimalScale);
  var negation = hasNagation ? '-' : '';
  var decimalSeparator = shoudHaveDecimalSeparator ? '.' : '';
  return "".concat(negation).concat(intPart).concat(decimalSeparator).concat(decimalPart);
}

function omit(obj, keyMaps) {
  var filteredObj = {};
  Object.keys(obj).forEach(function (key) {
    if (!keyMaps[key]) filteredObj[key] = obj[key];
  });
  return filteredObj;
}
/** set the caret positon in an input field **/


function setCaretPosition(el, caretPos) {
  el.value = el.value; // ^ this is used to not only get "focus", but
  // to make sure we don't have it everything -selected-
  // (it causes an issue in chrome, and having it doesn't hurt any other browser)

  if (el !== null) {
    if (el.createTextRange) {
      var range = el.createTextRange();
      range.move('character', caretPos);
      range.select();
      return true;
    } // (el.selectionStart === 0 added for Firefox bug)


    if (el.selectionStart || el.selectionStart === 0) {
      el.focus();
      el.setSelectionRange(caretPos, caretPos);
      return true;
    } // fail city, fortunately this never happens (as far as I've tested) :)


    el.focus();
    return false;
  }
}
/**
  Given previous value and newValue it returns the index
  start - end to which values have changed.
  This function makes assumption about only consecutive
  characters are changed which is correct assumption for caret input.
*/


function findChangedIndex(prevValue, newValue) {
  var i = 0,
      j = 0;
  var prevLength = prevValue.length;
  var newLength = newValue.length;

  while (prevValue[i] === newValue[i] && i < prevLength) {
    i++;
  } //check what has been changed from last


  while (prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] && newLength - j > i && prevLength - j > i) {
    j++;
  }

  return {
    start: i,
    end: prevLength - j
  };
}
/*
  Returns a number whose value is limited to the given range
*/


function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max);
}

function getCurrentCaretPosition(el) {
  /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/
  return Math.max(el.selectionStart, el.selectionEnd);
}

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(445);
} else {
  module.exports = require('./es/index.js');
}


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HotKeys", function() { return HotKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withHotKeys", function() { return withHotKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FocusTrap", function() { return FocusTrap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HotKeyMapMixin", function() { return HotKeyMapMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isequal__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isboolean__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isboolean___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isboolean__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isobject__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isobject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isobject__);
/**
 * ISC License
 *
 * Copyright (c) 2018, Aleck Greenham
 *
 * Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */

var classCallCheck=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},createClass=function(){function e(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,o,n){return o&&e(t.prototype,o),n&&e(t,n),t}}(),_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var n in o)Object.prototype.hasOwnProperty.call(o,n)&&(e[n]=o[n])}return e},inherits=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)},objectWithoutProperties=function(e,t){var o={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(o[n]=e[n]);return o},possibleConstructorReturn=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t},FocusTrap=function(e){function t(){return classCallCheck(this,t),possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return inherits(t,__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),createClass(t,[{key:"render",value:function(){var e=this.props,t=e.component,o=e.children,n=objectWithoutProperties(e,["component","children"]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(t,_extends({tabIndex:"-1"},n),o)}}]),t}();function sequencesFromKeyMap(e,t){var o=e[t];return o?Array.isArray(o)?o:[o]:[t]}function hasChanged(e,t){return!__WEBPACK_IMPORTED_MODULE_2_lodash_isequal___default()(e,t)}FocusTrap.propTypes={onFocus:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,onBlur:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,component:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),children:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node},FocusTrap.defaultProps={component:"div"};var HotKeys=function(e){function t(e,o){classCallCheck(this,t);var n=possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e,o));return n.onFocus=n.onFocus.bind(n),n.onBlur=n.onBlur.bind(n),n}return inherits(t,__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),createClass(t,[{key:"getChildContext",value:function(){return{hotKeyParent:this,hotKeyMap:this.__hotKeyMap__}}},{key:"componentWillMount",value:function(){this.updateMap()}},{key:"updateMap",value:function(){var e=this.buildMap();return!__WEBPACK_IMPORTED_MODULE_2_lodash_isequal___default()(e,this.__hotKeyMap__)&&(this.__hotKeyMap__=e,!0)}},{key:"buildMap",value:function(){var e=this.context.hotKeyMap||{},t=this.props.keyMap||{};return _extends({},e,t)}},{key:"getMap",value:function(){return this.__hotKeyMap__}},{key:"componentDidMount",value:function(){var e=__webpack_require__(449);this.__mousetrap__=new e(this.props.attach||__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(this)),this.updateHotKeys(!0)}},{key:"componentDidUpdate",value:function(e){this.updateHotKeys(!1,e)}},{key:"componentWillUnmount",value:function(){this.context.hotKeyParent&&this.context.hotKeyParent.childHandledSequence(null),this.__mousetrap__&&this.__mousetrap__.reset()}},{key:"updateHotKeys",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},o=this.props.handlers,n=void 0===o?{}:o,r=t.handlers,s=void 0===r?n:r,a=this.updateMap();(e||a||hasChanged(n,s))&&(this.context.hotKeyParent&&this.context.hotKeyParent.childHandledSequence(null),this.syncHandlersToMousetrap())}},{key:"syncHandlersToMousetrap",value:function(){var e=this,t=this.props.handlers,o=void 0===t?{}:t,n=this.getMap(),r=[],s=this.__mousetrap__;Object.keys(o).forEach(function(t){var s=o[t];sequencesFromKeyMap(n,t).forEach(function(t){var o=void 0;__WEBPACK_IMPORTED_MODULE_5_lodash_isobject___default()(t)&&(o=t.action,t=t.sequence),r.push({callback:function(t,o){if((__WEBPACK_IMPORTED_MODULE_4_lodash_isboolean___default()(e.props.focused)?e.props.focused:e.__isFocused__)&&o!==e.__lastChildSequence__)return e.context.hotKeyParent&&e.context.hotKeyParent.childHandledSequence(o),s(t,o)},action:o,sequence:t})})}),s.reset(),r.forEach(function(e){var t=e.sequence,o=e.callback,n=e.action;return s.bind(t,o,n)})}},{key:"childHandledSequence",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;this.__lastChildSequence__=e,this.context.hotKeyParent&&this.context.hotKeyParent.childHandledSequence(e)}},{key:"render",value:function(){var e=this.props,t=(e.keyMap,e.handlers,e.focused,e.attach,e.children),o=objectWithoutProperties(e,["keyMap","handlers","focused","attach","children"]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(FocusTrap,_extends({},o,{onFocus:this.onFocus,onBlur:this.onBlur}),t)}},{key:"onFocus",value:function(){var e;(this.__isFocused__=!0,this.props.onFocus)&&(e=this.props).onFocus.apply(e,arguments)}},{key:"onBlur",value:function(){var e;(this.__isFocused__=!1,this.props.onBlur)&&(e=this.props).onBlur.apply(e,arguments);this.context.hotKeyParent&&this.context.hotKeyParent.childHandledSequence(null)}}]),t}();HotKeys.propTypes={keyMap:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,handlers:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,focused:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,attach:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,children:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,onFocus:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,onBlur:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func},HotKeys.childContextTypes={hotKeyParent:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,hotKeyMap:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object},HotKeys.contextTypes={hotKeyParent:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,hotKeyMap:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object};var withHotKeys=function(e){return function(t){return function(o){function n(e){classCallCheck(this,n);var t=possibleConstructorReturn(this,(n.__proto__||Object.getPrototypeOf(n)).call(this,e));return t._setRef=t._setRef.bind(t),t.state={handlers:{}},t}return inherits(n,__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]),createClass(n,[{key:"componentDidMount",value:function(){this.setState({handlers:this._ref.hotKeyHandlers})}},{key:"_setRef",value:function(e){this._ref=e}},{key:"render",value:function(){var o=this.state.handlers;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(HotKeys,{component:"document-fragment",keyMap:e,handlers:o},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(t,_extends({ref:this._setRef},this.props)))}}]),n}()}};function HotKeyMapMixin(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return{contextTypes:{hotKeyMap:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object},childContextTypes:{hotKeyMap:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object},getChildContext:function(){return{hotKeyMap:this.__hotKeyMap__}},componentWillMount:function(){this.updateMap()},updateMap:function(){var e=this.buildMap();return!__WEBPACK_IMPORTED_MODULE_2_lodash_isequal___default()(e,this.__hotKeyMap__)&&(this.__hotKeyMap__=e,!0)},buildMap:function(){var t=this.context.hotKeyMap||{},o=this.props.keyMap||{};return _extends({},t,e,o)},getMap:function(){return this.__hotKeyMap__}}}


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18), __webpack_require__(52)(module)))

/***/ }),
/* 447 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && objectToString.call(value) == boolTag);
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isBoolean;


/***/ }),
/* 448 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*global define:false */
/**
 * Copyright 2012-2017 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.6.2
 * @url craig.is/killing/mice
 */
(function(window, document, undefined) {

    // Check if mousetrap is used inside browser, if not, return
    if (!window) {
        return;
    }

    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */
    var _MAP = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'ins',
        46: 'del',
        91: 'meta',
        93: 'meta',
        224: 'meta'
    };

    /**
     * mapping for special characters so they can support
     *
     * this dictionary is only used incase you want to bind a
     * keyup or keydown event to one of these keys
     *
     * @type {Object}
     */
    var _KEYCODE_MAP = {
        106: '*',
        107: '+',
        109: '-',
        110: '.',
        111 : '/',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };

    /**
     * this is a mapping of keys that require shift on a US keypad
     * back to the non shift equivelents
     *
     * this is so you can use keyup events with these keys
     *
     * note that this will only work reliably on US keyboards
     *
     * @type {Object}
     */
    var _SHIFT_MAP = {
        '~': '`',
        '!': '1',
        '@': '2',
        '#': '3',
        '$': '4',
        '%': '5',
        '^': '6',
        '&': '7',
        '*': '8',
        '(': '9',
        ')': '0',
        '_': '-',
        '+': '=',
        ':': ';',
        '\"': '\'',
        '<': ',',
        '>': '.',
        '?': '/',
        '|': '\\'
    };

    /**
     * this is a list of special strings you can use to map
     * to modifier keys when you specify your keyboard shortcuts
     *
     * @type {Object}
     */
    var _SPECIAL_ALIASES = {
        'option': 'alt',
        'command': 'meta',
        'return': 'enter',
        'escape': 'esc',
        'plus': '+',
        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };

    /**
     * variable to store the flipped version of _MAP from above
     * needed to check if we should use keypress or not when no action
     * is specified
     *
     * @type {Object|undefined}
     */
    var _REVERSE_MAP;

    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */
    for (var i = 1; i < 20; ++i) {
        _MAP[111 + i] = 'f' + i;
    }

    /**
     * loop through to map numbers on the numeric keypad
     */
    for (i = 0; i <= 9; ++i) {

        // This needs to use a string cause otherwise since 0 is falsey
        // mousetrap will never fire for numpad 0 pressed as part of a keydown
        // event.
        //
        // @see https://github.com/ccampbell/mousetrap/pull/258
        _MAP[i + 96] = i.toString();
    }

    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */
    function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }

        object.attachEvent('on' + type, callback);
    }

    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */
    function _characterFromEvent(e) {

        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);

            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) {
                character = character.toLowerCase();
            }

            return character;
        }

        // for non keypress events the special maps are needed
        if (_MAP[e.which]) {
            return _MAP[e.which];
        }

        if (_KEYCODE_MAP[e.which]) {
            return _KEYCODE_MAP[e.which];
        }

        // if it is not in the special map

        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }

    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */
    function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }

    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */
    function _eventModifiers(e) {
        var modifiers = [];

        if (e.shiftKey) {
            modifiers.push('shift');
        }

        if (e.altKey) {
            modifiers.push('alt');
        }

        if (e.ctrlKey) {
            modifiers.push('ctrl');
        }

        if (e.metaKey) {
            modifiers.push('meta');
        }

        return modifiers;
    }

    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */
    function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }

        e.returnValue = false;
    }

    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */
    function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }

        e.cancelBubble = true;
    }

    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */
    function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }

    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */
    function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for (var key in _MAP) {

                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) {
                    continue;
                }

                if (_MAP.hasOwnProperty(key)) {
                    _REVERSE_MAP[_MAP[key]] = key;
                }
            }
        }
        return _REVERSE_MAP;
    }

    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */
    function _pickBestAction(key, modifiers, action) {

        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) {
            action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        }

        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) {
            action = 'keydown';
        }

        return action;
    }

    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */
    function _keysFromString(combination) {
        if (combination === '+') {
            return ['+'];
        }

        combination = combination.replace(/\+{2}/g, '+plus');
        return combination.split('+');
    }

    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */
    function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i;
        var modifiers = [];

        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);

        for (i = 0; i < keys.length; ++i) {
            key = keys[i];

            // normalize key names
            if (_SPECIAL_ALIASES[key]) {
                key = _SPECIAL_ALIASES[key];
            }

            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }

            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) {
                modifiers.push(key);
            }
        }

        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);

        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }

    function _belongsTo(element, ancestor) {
        if (element === null || element === document) {
            return false;
        }

        if (element === ancestor) {
            return true;
        }

        return _belongsTo(element.parentNode, ancestor);
    }

    function Mousetrap(targetElement) {
        var self = this;

        targetElement = targetElement || document;

        if (!(self instanceof Mousetrap)) {
            return new Mousetrap(targetElement);
        }

        /**
         * element to attach key events to
         *
         * @type {Element}
         */
        self.target = targetElement;

        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */
        self._callbacks = {};

        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */
        self._directMap = {};

        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */
        var _sequenceLevels = {};

        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */
        var _resetTimer;

        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */
        var _ignoreNextKeyup = false;

        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */
        var _ignoreNextKeypress = false;

        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */
        var _nextExpectedAction = false;

        /**
         * resets all sequence counters except for the ones passed in
         *
         * @param {Object} doNotReset
         * @returns void
         */
        function _resetSequences(doNotReset) {
            doNotReset = doNotReset || {};

            var activeSequences = false,
                key;

            for (key in _sequenceLevels) {
                if (doNotReset[key]) {
                    activeSequences = true;
                    continue;
                }
                _sequenceLevels[key] = 0;
            }

            if (!activeSequences) {
                _nextExpectedAction = false;
            }
        }

        /**
         * finds all callbacks that match based on the keycode, modifiers,
         * and action
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event|Object} e
         * @param {string=} sequenceName - name of the sequence we are looking for
         * @param {string=} combination
         * @param {number=} level
         * @returns {Array}
         */
        function _getMatches(character, modifiers, e, sequenceName, combination, level) {
            var i;
            var callback;
            var matches = [];
            var action = e.type;

            // if there are no events related to this keycode
            if (!self._callbacks[character]) {
                return [];
            }

            // if a modifier key is coming up on its own we should allow it
            if (action == 'keyup' && _isModifier(character)) {
                modifiers = [character];
            }

            // loop through all callbacks for the key that was pressed
            // and see if any of them match
            for (i = 0; i < self._callbacks[character].length; ++i) {
                callback = self._callbacks[character][i];

                // if a sequence name is not specified, but this is a sequence at
                // the wrong level then move onto the next match
                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
                    continue;
                }

                // if the action we are looking for doesn't match the action we got
                // then we should keep going
                if (action != callback.action) {
                    continue;
                }

                // if this is a keypress event and the meta key and control key
                // are not pressed that means that we need to only look at the
                // character, otherwise check the modifiers as well
                //
                // chrome will not fire a keypress if meta or control is down
                // safari will fire a keypress if meta or meta+shift is down
                // firefox will fire a keypress if meta or control is down
                if ((action == 'keypress' && !e.metaKey && !e.ctrlKey) || _modifiersMatch(modifiers, callback.modifiers)) {

                    // when you bind a combination or sequence a second time it
                    // should overwrite the first one.  if a sequenceName or
                    // combination is specified in this call it does just that
                    //
                    // @todo make deleting its own method?
                    var deleteCombo = !sequenceName && callback.combo == combination;
                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                    if (deleteCombo || deleteSequence) {
                        self._callbacks[character].splice(i, 1);
                    }

                    matches.push(callback);
                }
            }

            return matches;
        }

        /**
         * actually calls the callback function
         *
         * if your callback function returns false this will use the jquery
         * convention - prevent default and stop propogation on the event
         *
         * @param {Function} callback
         * @param {Event} e
         * @returns void
         */
        function _fireCallback(callback, e, combo, sequence) {

            // if this event should not happen stop here
            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
                return;
            }

            if (callback(e, combo) === false) {
                _preventDefault(e);
                _stopPropagation(e);
            }
        }

        /**
         * handles a character key event
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event} e
         * @returns void
         */
        self._handleKey = function(character, modifiers, e) {
            var callbacks = _getMatches(character, modifiers, e);
            var i;
            var doNotReset = {};
            var maxLevel = 0;
            var processedSequenceCallback = false;

            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
            for (i = 0; i < callbacks.length; ++i) {
                if (callbacks[i].seq) {
                    maxLevel = Math.max(maxLevel, callbacks[i].level);
                }
            }

            // loop through matching callbacks for this key event
            for (i = 0; i < callbacks.length; ++i) {

                // fire for all sequence callbacks
                // this is because if for example you have multiple sequences
                // bound such as "g i" and "g t" they both need to fire the
                // callback for matching g cause otherwise you can only ever
                // match the first one
                if (callbacks[i].seq) {

                    // only fire callbacks for the maxLevel to prevent
                    // subsequences from also firing
                    //
                    // for example 'a option b' should not cause 'option b' to fire
                    // even though 'option b' is part of the other sequence
                    //
                    // any sequences that do not match here will be discarded
                    // below by the _resetSequences call
                    if (callbacks[i].level != maxLevel) {
                        continue;
                    }

                    processedSequenceCallback = true;

                    // keep a list of which sequences were matches for later
                    doNotReset[callbacks[i].seq] = 1;
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                    continue;
                }

                // if there were no sequence matches but we are still here
                // that means this is a regular match so we should fire that
                if (!processedSequenceCallback) {
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
                }
            }

            // if the key you pressed matches the type of sequence without
            // being a modifier (ie "keyup" or "keypress") then we should
            // reset all sequences that were not matched by this event
            //
            // this is so, for example, if you have the sequence "h a t" and you
            // type "h e a r t" it does not match.  in this case the "e" will
            // cause the sequence to reset
            //
            // modifier keys are ignored because you can have a sequence
            // that contains modifiers such as "enter ctrl+space" and in most
            // cases the modifier key will be pressed before the next key
            //
            // also if you have a sequence such as "ctrl+b a" then pressing the
            // "b" key will trigger a "keypress" and a "keydown"
            //
            // the "keydown" is expected when there is a modifier, but the
            // "keypress" ends up matching the _nextExpectedAction since it occurs
            // after and that causes the sequence to reset
            //
            // we ignore keypresses in a sequence that directly follow a keydown
            // for the same character
            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
                _resetSequences(doNotReset);
            }

            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
        };

        /**
         * handles a keydown event
         *
         * @param {Event} e
         * @returns void
         */
        function _handleKeyEvent(e) {

            // normalize e.which for key events
            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
            if (typeof e.which !== 'number') {
                e.which = e.keyCode;
            }

            var character = _characterFromEvent(e);

            // no character found then stop
            if (!character) {
                return;
            }

            // need to use === for the character check because the character can be 0
            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
                _ignoreNextKeyup = false;
                return;
            }

            self.handleKey(character, _eventModifiers(e), e);
        }

        /**
         * called to set a 1 second timeout on the specified sequence
         *
         * this is so after each key press in the sequence you have 1 second
         * to press the next key before you have to start over
         *
         * @returns void
         */
        function _resetSequenceTimer() {
            clearTimeout(_resetTimer);
            _resetTimer = setTimeout(_resetSequences, 1000);
        }

        /**
         * binds a key sequence to an event
         *
         * @param {string} combo - combo specified in bind call
         * @param {Array} keys
         * @param {Function} callback
         * @param {string=} action
         * @returns void
         */
        function _bindSequence(combo, keys, callback, action) {

            // start off by adding a sequence level record for this combination
            // and setting the level to 0
            _sequenceLevels[combo] = 0;

            /**
             * callback to increase the sequence level for this sequence and reset
             * all other sequences that were active
             *
             * @param {string} nextAction
             * @returns {Function}
             */
            function _increaseSequence(nextAction) {
                return function() {
                    _nextExpectedAction = nextAction;
                    ++_sequenceLevels[combo];
                    _resetSequenceTimer();
                };
            }

            /**
             * wraps the specified callback inside of another function in order
             * to reset all sequence counters as soon as this sequence is done
             *
             * @param {Event} e
             * @returns void
             */
            function _callbackAndReset(e) {
                _fireCallback(callback, e, combo);

                // we should ignore the next key up if the action is key down
                // or keypress.  this is so if you finish a sequence and
                // release the key the final key will not trigger a keyup
                if (action !== 'keyup') {
                    _ignoreNextKeyup = _characterFromEvent(e);
                }

                // weird race condition if a sequence ends with the key
                // another sequence begins with
                setTimeout(_resetSequences, 10);
            }

            // loop through keys one at a time and bind the appropriate callback
            // function.  for any key leading up to the final one it should
            // increase the sequence. after the final, it should reset all sequences
            //
            // if an action is specified in the original bind call then that will
            // be used throughout.  otherwise we will pass the action that the
            // next key in the sequence should match.  this allows a sequence
            // to mix and match keypress and keydown events depending on which
            // ones are better suited to the key provided
            for (var i = 0; i < keys.length; ++i) {
                var isFinal = i + 1 === keys.length;
                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
                _bindSingle(keys[i], wrappedCallback, action, combo, i);
            }
        }

        /**
         * binds a single keyboard combination
         *
         * @param {string} combination
         * @param {Function} callback
         * @param {string=} action
         * @param {string=} sequenceName - name of sequence if part of sequence
         * @param {number=} level - what part of the sequence the command is
         * @returns void
         */
        function _bindSingle(combination, callback, action, sequenceName, level) {

            // store a direct mapped reference for use with Mousetrap.trigger
            self._directMap[combination + ':' + action] = callback;

            // make sure multiple spaces in a row become a single space
            combination = combination.replace(/\s+/g, ' ');

            var sequence = combination.split(' ');
            var info;

            // if this pattern is a sequence of keys then run through this method
            // to reprocess each pattern one key at a time
            if (sequence.length > 1) {
                _bindSequence(combination, sequence, callback, action);
                return;
            }

            info = _getKeyInfo(combination, action);

            // make sure to initialize array if this is the first time
            // a callback is added for this key
            self._callbacks[info.key] = self._callbacks[info.key] || [];

            // remove an existing match if there is one
            _getMatches(info.key, info.modifiers, {type: info.action}, sequenceName, combination, level);

            // add this call back to the array
            // if it is a sequence put it at the beginning
            // if not put it at the end
            //
            // this is important because the way these are processed expects
            // the sequence ones to come first
            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
                callback: callback,
                modifiers: info.modifiers,
                action: info.action,
                seq: sequenceName,
                level: level,
                combo: combination
            });
        }

        /**
         * binds multiple combinations to the same callback
         *
         * @param {Array} combinations
         * @param {Function} callback
         * @param {string|undefined} action
         * @returns void
         */
        self._bindMultiple = function(combinations, callback, action) {
            for (var i = 0; i < combinations.length; ++i) {
                _bindSingle(combinations[i], callback, action);
            }
        };

        // start!
        _addEvent(targetElement, 'keypress', _handleKeyEvent);
        _addEvent(targetElement, 'keydown', _handleKeyEvent);
        _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }

    /**
     * binds an event to mousetrap
     *
     * can be a single key, a combination of keys separated with +,
     * an array of keys, or a sequence of keys separated by spaces
     *
     * be sure to list the modifier keys first to make sure that the
     * correct key ends up getting bound (the last key in the pattern)
     *
     * @param {string|Array} keys
     * @param {Function} callback
     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
     * @returns void
     */
    Mousetrap.prototype.bind = function(keys, callback, action) {
        var self = this;
        keys = keys instanceof Array ? keys : [keys];
        self._bindMultiple.call(self, keys, callback, action);
        return self;
    };

    /**
     * unbinds an event to mousetrap
     *
     * the unbinding sets the callback function of the specified key combo
     * to an empty function and deletes the corresponding key in the
     * _directMap dict.
     *
     * TODO: actually remove this from the _callbacks dictionary instead
     * of binding an empty function
     *
     * the keycombo+action has to be exactly the same as
     * it was defined in the bind method
     *
     * @param {string|Array} keys
     * @param {string} action
     * @returns void
     */
    Mousetrap.prototype.unbind = function(keys, action) {
        var self = this;
        return self.bind.call(self, keys, function() {}, action);
    };

    /**
     * triggers an event that has already been bound
     *
     * @param {string} keys
     * @param {string=} action
     * @returns void
     */
    Mousetrap.prototype.trigger = function(keys, action) {
        var self = this;
        if (self._directMap[keys + ':' + action]) {
            self._directMap[keys + ':' + action]({}, keys);
        }
        return self;
    };

    /**
     * resets the library back to its initial state.  this is useful
     * if you want to clear out the current keyboard shortcuts and bind
     * new ones - for example if you switch to another page
     *
     * @returns void
     */
    Mousetrap.prototype.reset = function() {
        var self = this;
        self._callbacks = {};
        self._directMap = {};
        return self;
    };

    /**
     * should we stop this event before firing off callbacks
     *
     * @param {Event} e
     * @param {Element} element
     * @return {boolean}
     */
    Mousetrap.prototype.stopCallback = function(e, element) {
        var self = this;

        // if the element has the class "mousetrap" then no need to stop
        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
            return false;
        }

        if (_belongsTo(element, self.target)) {
            return false;
        }

        // stop for input, select, and textarea
        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };

    /**
     * exposes _handleKey publicly so it can be overwritten by extensions
     */
    Mousetrap.prototype.handleKey = function() {
        var self = this;
        return self._handleKey.apply(self, arguments);
    };

    /**
     * allow custom key mappings
     */
    Mousetrap.addKeycodes = function(object) {
        for (var key in object) {
            if (object.hasOwnProperty(key)) {
                _MAP[key] = object[key];
            }
        }
        _REVERSE_MAP = null;
    };

    /**
     * Init the global mousetrap functions
     *
     * This method is needed to allow the global mousetrap functions to work
     * now that mousetrap is a constructor function.
     */
    Mousetrap.init = function() {
        var documentMousetrap = Mousetrap(document);
        for (var method in documentMousetrap) {
            if (method.charAt(0) !== '_') {
                Mousetrap[method] = (function(method) {
                    return function() {
                        return documentMousetrap[method].apply(documentMousetrap, arguments);
                    };
                } (method));
            }
        }
    };

    Mousetrap.init();

    // expose mousetrap to the global object
    window.Mousetrap = Mousetrap;

    // expose as a common js module
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = Mousetrap;
    }

    // expose mousetrap as an AMD module
    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
            return Mousetrap;
        }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
}) (typeof window !== 'undefined' ? window : null, typeof  window !== 'undefined' ? document : null);


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CustomDropdown=function(_React$Component){_inherits(CustomDropdown,_React$Component);function CustomDropdown(props){_classCallCheck(this,CustomDropdown);var _this=_possibleConstructorReturn(this,(CustomDropdown.__proto__||Object.getPrototypeOf(CustomDropdown)).call(this,props));_this.state={showDropdown:false};return _this;}_createClass(CustomDropdown,[{key:"toggleDropdown",value:function toggleDropdown(){this.setState({showDropdown:!this.state.showDropdown});}},{key:"selectOption",value:function selectOption(key,value,event){if(event.target.className.includes("action")){this.props.action(key,value);}else{this.props.onSelect(key);this.toggleDropdown();}}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"custom-dropdown"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"btn btn-flat",disabled:this.props.loadingSearch,onClick:this.toggleDropdown.bind(this)},this.props.loading?"Loading...":this.props.selection||this.props.placeholder,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"\"icon icon-right ion-android-arrow-drop"+(this.state.showDropdown?"up":"down")})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{hidden:!this.state.showDropdown,className:"custom-dropdown-box"},this.props.options&&this.props.options.length?this.props.options.map(function(option){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:option.key,className:"custom-dropdown-option",onClick:_this2.selectOption.bind(_this2,option.key,option.value)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"flex-justify"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"medium-text"},option.value),_this2.props.actionIcon));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"No Searches")));}}]);return CustomDropdown;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CustomDropdown);

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_ValidatedInput__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SaveSearchModal=function(_React$Component){_inherits(SaveSearchModal,_React$Component);function SaveSearchModal(props){_classCallCheck(this,SaveSearchModal);var _this=_possibleConstructorReturn(this,(SaveSearchModal.__proto__||Object.getPrototypeOf(SaveSearchModal)).call(this,props));_this.state={error:false,title:'',validTitle:false};_this.onChange=_this.onChange.bind(_this);_this.onSave=_this.onSave.bind(_this);_this.onClose=_this.onClose.bind(_this);return _this;}_createClass(SaveSearchModal,[{key:'onChange',value:function onChange(name,value){this.setState(_defineProperty({},name,value));}},{key:'validateTitle',value:function validateTitle(title){var validTitle=this.props.savedSearchTitles.indexOf(title.trim())<0;this.setState({validTitle:validTitle});return validTitle;}},{key:'onSave',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({error:false});_context.next=3;return this.props.save(this.state.title);case 3:this.props.success?this.onClose():this.setState({error:true});case 4:case'end':return _context.stop();}}},_callee,this);}));function onSave(){return _ref.apply(this,arguments);}return onSave;}()},{key:'onClose',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:this.props.close();this.setState({error:false,title:'',validTitle:false});case 2:case'end':return _context2.stop();}}},_callee2,this);}));function onClose(){return _ref2.apply(this,arguments);}return onClose;}()},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_Modal__["a" /* default */],{modalShowing:this.props.modalShowing},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container',key:'warningModal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal save-search-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},'Save this search'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.onClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onKeyDown:function onKeyDown(e){if(e.key==='Enter'&&_this2.state.title&&_this2.state.validTitle)_this2.onSave();}}),label:'Enter a title for this search',name:'title',value:this.state.title,onChange:this.onChange,validated:true,showValidationError:true,validate:this.validateTitle.bind(this),errorMessage:'An existing saved search has been found by this title.  Please enter a unique search title.'}),this.props.saving?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_LoadingSpinner__["a" /* default */],{height:'32',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'warning-modal-btns text-right relative'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.onClose},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',onClick:this.onSave,disabled:!this.state.title||!this.state.validTitle},'Save'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error})))));}}]);return SaveSearchModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SaveSearchModal);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AutoSuggestInput__ = __webpack_require__(105);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AutoSuggestMultiInput=function(_React$Component){_inherits(AutoSuggestMultiInput,_React$Component);function AutoSuggestMultiInput(){_classCallCheck(this,AutoSuggestMultiInput);return _possibleConstructorReturn(this,(AutoSuggestMultiInput.__proto__||Object.getPrototypeOf(AutoSuggestMultiInput)).apply(this,arguments));}_createClass(AutoSuggestMultiInput,[{key:'onRemoveSelection',value:function onRemoveSelection(selection){var _this2=this;this.props.update(this.props.name,this.props.selection.filter(function(s){return s[_this2.props.suggestionKey]!==selection[_this2.props.suggestionKey];}));}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__AutoSuggestInput__["a" /* default */],Object.assign({multi:true},this.props)),this.props.selection.map(function(selectionItem){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:selectionItem[_this3.props.suggestionKey],className:'chip name-chip'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,selectionItem[_this3.props.suggestionValue]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons delete-chip',onClick:_this3.onRemoveSelection.bind(_this3,selectionItem)},'close'));}));}}]);return AutoSuggestMultiInput;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AutoSuggestMultiInput);

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _arrays = _interopRequireDefault(__webpack_require__(454));

var _Autowhatever = _interopRequireDefault(__webpack_require__(455));

var _theme = __webpack_require__(462);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alwaysTrue = function alwaysTrue() {
  return true;
};

var defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
  return value.trim().length > 0;
};

var defaultRenderSuggestionsContainer = function defaultRenderSuggestionsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", containerProps, children);
};

var REASON_SUGGESTIONS_REVEALED = 'suggestions-revealed';
var REASON_SUGGESTIONS_UPDATED = 'suggestions-updated';
var REASON_SUGGESTION_SELECTED = 'suggestion-selected';
var REASON_INPUT_FOCUSED = 'input-focused';
var REASON_INPUT_CHANGED = 'input-changed';
var REASON_INPUT_BLURRED = 'input-blurred';
var REASON_ESCAPE_PRESSED = 'escape-pressed';

var Autosuggest = /*#__PURE__*/function (_Component) {
  _inherits(Autosuggest, _Component);

  var _super = _createSuper(Autosuggest);

  function Autosuggest(_ref2) {
    var _this;

    var _alwaysRenderSuggestions = _ref2.alwaysRenderSuggestions;

    _classCallCheck(this, Autosuggest);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "onDocumentMouseDown", function (event) {
      _this.justClickedOnSuggestionsContainer = false;
      var node = event.detail && event.detail.target || // This is for testing only. Please show me a better way to emulate this.
      event.target;

      while (node !== null && node !== document) {
        if (node.getAttribute && node.getAttribute('data-suggestion-index') !== null) {
          // Suggestion was clicked
          return;
        }

        if (node === _this.suggestionsContainer) {
          // Something else inside suggestions container was clicked
          _this.justClickedOnSuggestionsContainer = true;
          return;
        }

        node = node.parentNode;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "storeAutowhateverRef", function (autowhatever) {
      if (autowhatever !== null) {
        _this.autowhatever = autowhatever;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionMouseEnter", function (event, _ref3) {
      var sectionIndex = _ref3.sectionIndex,
          itemIndex = _ref3.itemIndex;

      _this.updateHighlightedSuggestion(sectionIndex, itemIndex);

      if (event.target === _this.pressedSuggestion) {
        _this.justSelectedSuggestion = true;
      }

      _this.justMouseEntered = true;
      setTimeout(function () {
        _this.justMouseEntered = false;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "highlightFirstSuggestion", function () {
      _this.updateHighlightedSuggestion(_this.props.multiSection ? 0 : null, 0);
    });

    _defineProperty(_assertThisInitialized(_this), "onDocumentMouseUp", function () {
      if (_this.pressedSuggestion && !_this.justSelectedSuggestion) {
        _this.input.focus();
      }

      _this.pressedSuggestion = null;
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionMouseDown", function (event) {
      // Checking if this.justSelectedSuggestion is already true to not duplicate touch events in chrome
      // See: https://github.com/facebook/react/issues/9809#issuecomment-413978405
      if (!_this.justSelectedSuggestion) {
        _this.justSelectedSuggestion = true;
        _this.pressedSuggestion = event.target;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionsClearRequested", function () {
      var onSuggestionsClearRequested = _this.props.onSuggestionsClearRequested;
      onSuggestionsClearRequested && onSuggestionsClearRequested();
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionSelected", function (event, data) {
      var _this$props = _this.props,
          alwaysRenderSuggestions = _this$props.alwaysRenderSuggestions,
          onSuggestionSelected = _this$props.onSuggestionSelected,
          onSuggestionsFetchRequested = _this$props.onSuggestionsFetchRequested;
      onSuggestionSelected && onSuggestionSelected(event, data);

      var keepSuggestionsOnSelect = _this.props.shouldKeepSuggestionsOnSelect(data.suggestion);

      if (alwaysRenderSuggestions || keepSuggestionsOnSelect) {
        onSuggestionsFetchRequested({
          value: data.suggestionValue,
          reason: REASON_SUGGESTION_SELECTED
        });
      } else {
        _this.onSuggestionsClearRequested();
      }

      _this.resetHighlightedSuggestion();
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionClick", function (event) {
      var _this$props2 = _this.props,
          alwaysRenderSuggestions = _this$props2.alwaysRenderSuggestions,
          focusInputOnSuggestionClick = _this$props2.focusInputOnSuggestionClick;

      var _this$getSuggestionIn = _this.getSuggestionIndices(_this.findSuggestionElement(event.target)),
          sectionIndex = _this$getSuggestionIn.sectionIndex,
          suggestionIndex = _this$getSuggestionIn.suggestionIndex;

      var clickedSuggestion = _this.getSuggestion(sectionIndex, suggestionIndex);

      var clickedSuggestionValue = _this.props.getSuggestionValue(clickedSuggestion);

      _this.maybeCallOnChange(event, clickedSuggestionValue, 'click');

      _this.onSuggestionSelected(event, {
        suggestion: clickedSuggestion,
        suggestionValue: clickedSuggestionValue,
        suggestionIndex: suggestionIndex,
        sectionIndex: sectionIndex,
        method: 'click'
      });

      var keepSuggestionsOnSelect = _this.props.shouldKeepSuggestionsOnSelect(clickedSuggestion);

      if (!(alwaysRenderSuggestions || keepSuggestionsOnSelect)) {
        _this.closeSuggestions();
      }

      if (focusInputOnSuggestionClick === true) {
        _this.input.focus();
      } else {
        _this.onBlur();
      }

      setTimeout(function () {
        _this.justSelectedSuggestion = false;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
      var _this$props3 = _this.props,
          inputProps = _this$props3.inputProps,
          shouldRenderSuggestions = _this$props3.shouldRenderSuggestions;
      var value = inputProps.value,
          onBlur = inputProps.onBlur;

      var highlightedSuggestion = _this.getHighlightedSuggestion();

      var shouldRender = shouldRenderSuggestions(value, REASON_INPUT_BLURRED);

      _this.setState({
        isFocused: false,
        highlightedSectionIndex: null,
        highlightedSuggestionIndex: null,
        highlightedSuggestion: null,
        valueBeforeUpDown: null,
        isCollapsed: !shouldRender
      });

      onBlur && onBlur(_this.blurEvent, {
        highlightedSuggestion: highlightedSuggestion
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionMouseLeave", function (event) {
      _this.resetHighlightedSuggestion(false); // shouldResetValueBeforeUpDown


      if (_this.justSelectedSuggestion && event.target === _this.pressedSuggestion) {
        _this.justSelectedSuggestion = false;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionTouchStart", function () {
      _this.justSelectedSuggestion = true; // todo: event.preventDefault when https://github.com/facebook/react/issues/2043
      // todo: gets released so onSuggestionMouseDown won't fire in chrome
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionTouchMove", function () {
      _this.justSelectedSuggestion = false;
      _this.pressedSuggestion = null;

      _this.input.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "itemProps", function (_ref4) {
      var sectionIndex = _ref4.sectionIndex,
          itemIndex = _ref4.itemIndex;
      return {
        'data-section-index': sectionIndex,
        'data-suggestion-index': itemIndex,
        onMouseEnter: _this.onSuggestionMouseEnter,
        onMouseLeave: _this.onSuggestionMouseLeave,
        onMouseDown: _this.onSuggestionMouseDown,
        onTouchStart: _this.onSuggestionTouchStart,
        onTouchMove: _this.onSuggestionTouchMove,
        onClick: _this.onSuggestionClick
      };
    });

    _defineProperty(_assertThisInitialized(_this), "renderSuggestionsContainer", function (_ref5) {
      var containerProps = _ref5.containerProps,
          children = _ref5.children;
      var renderSuggestionsContainer = _this.props.renderSuggestionsContainer;
      return renderSuggestionsContainer({
        containerProps: containerProps,
        children: children,
        query: _this.getQuery()
      });
    });

    _this.state = {
      isFocused: false,
      isCollapsed: !_alwaysRenderSuggestions,
      highlightedSectionIndex: null,
      highlightedSuggestionIndex: null,
      highlightedSuggestion: null,
      valueBeforeUpDown: null
    };
    _this.justPressedUpDown = false;
    _this.justMouseEntered = false;
    _this.pressedSuggestion = null;
    return _this;
  }

  _createClass(Autosuggest, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.onDocumentMouseDown);
      document.addEventListener('mouseup', this.onDocumentMouseUp);
      this.input = this.autowhatever.input;
      this.suggestionsContainer = this.autowhatever.itemsContainer;
    } // eslint-disable-next-line camelcase, react/sort-comp

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // When highlightFirstSuggestion becomes deactivated, if the first suggestion was
      // set, we should reset the suggestion back to the unselected default state.
      var shouldResetHighlighting = this.state.highlightedSuggestionIndex === 0 && this.props.highlightFirstSuggestion && !nextProps.highlightFirstSuggestion;

      if ((0, _arrays["default"])(nextProps.suggestions, this.props.suggestions)) {
        if (nextProps.highlightFirstSuggestion && nextProps.suggestions.length > 0 && this.justPressedUpDown === false && this.justMouseEntered === false) {
          this.highlightFirstSuggestion();
        } else if (shouldResetHighlighting) {
          this.resetHighlightedSuggestion();
        }
      } else {
        if (this.willRenderSuggestions(nextProps, REASON_SUGGESTIONS_UPDATED)) {
          if (this.state.isCollapsed && !this.justSelectedSuggestion) {
            this.revealSuggestions();
          }

          if (shouldResetHighlighting) {
            this.resetHighlightedSuggestion();
          }
        } else {
          this.resetHighlightedSuggestion();
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props4 = this.props,
          suggestions = _this$props4.suggestions,
          onSuggestionHighlighted = _this$props4.onSuggestionHighlighted,
          highlightFirstSuggestion = _this$props4.highlightFirstSuggestion;

      if (!(0, _arrays["default"])(suggestions, prevProps.suggestions) && suggestions.length > 0 && highlightFirstSuggestion) {
        this.highlightFirstSuggestion();
        return;
      }

      if (onSuggestionHighlighted) {
        var highlightedSuggestion = this.getHighlightedSuggestion();
        var prevHighlightedSuggestion = prevState.highlightedSuggestion;

        if (highlightedSuggestion != prevHighlightedSuggestion) {
          onSuggestionHighlighted({
            suggestion: highlightedSuggestion
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.onDocumentMouseDown);
      document.removeEventListener('mouseup', this.onDocumentMouseUp);
    }
  }, {
    key: "updateHighlightedSuggestion",
    value: function updateHighlightedSuggestion(sectionIndex, suggestionIndex, prevValue) {
      var _this2 = this;

      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;

        if (suggestionIndex === null) {
          valueBeforeUpDown = null;
        } else if (valueBeforeUpDown === null && typeof prevValue !== 'undefined') {
          valueBeforeUpDown = prevValue;
        }

        return {
          highlightedSectionIndex: sectionIndex,
          highlightedSuggestionIndex: suggestionIndex,
          highlightedSuggestion: suggestionIndex === null ? null : _this2.getSuggestion(sectionIndex, suggestionIndex),
          valueBeforeUpDown: valueBeforeUpDown
        };
      });
    }
  }, {
    key: "resetHighlightedSuggestion",
    value: function resetHighlightedSuggestion() {
      var shouldResetValueBeforeUpDown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;
        return {
          highlightedSectionIndex: null,
          highlightedSuggestionIndex: null,
          highlightedSuggestion: null,
          valueBeforeUpDown: shouldResetValueBeforeUpDown ? null : valueBeforeUpDown
        };
      });
    }
  }, {
    key: "revealSuggestions",
    value: function revealSuggestions() {
      this.setState({
        isCollapsed: false
      });
    }
  }, {
    key: "closeSuggestions",
    value: function closeSuggestions() {
      this.setState({
        highlightedSectionIndex: null,
        highlightedSuggestionIndex: null,
        highlightedSuggestion: null,
        valueBeforeUpDown: null,
        isCollapsed: true
      });
    }
  }, {
    key: "getSuggestion",
    value: function getSuggestion(sectionIndex, suggestionIndex) {
      var _this$props5 = this.props,
          suggestions = _this$props5.suggestions,
          multiSection = _this$props5.multiSection,
          getSectionSuggestions = _this$props5.getSectionSuggestions;

      if (multiSection) {
        return getSectionSuggestions(suggestions[sectionIndex])[suggestionIndex];
      }

      return suggestions[suggestionIndex];
    }
  }, {
    key: "getHighlightedSuggestion",
    value: function getHighlightedSuggestion() {
      var _this$state = this.state,
          highlightedSectionIndex = _this$state.highlightedSectionIndex,
          highlightedSuggestionIndex = _this$state.highlightedSuggestionIndex;

      if (highlightedSuggestionIndex === null) {
        return null;
      }

      return this.getSuggestion(highlightedSectionIndex, highlightedSuggestionIndex);
    }
  }, {
    key: "getSuggestionValueByIndex",
    value: function getSuggestionValueByIndex(sectionIndex, suggestionIndex) {
      var getSuggestionValue = this.props.getSuggestionValue;
      return getSuggestionValue(this.getSuggestion(sectionIndex, suggestionIndex));
    }
  }, {
    key: "getSuggestionIndices",
    value: function getSuggestionIndices(suggestionElement) {
      var sectionIndex = suggestionElement.getAttribute('data-section-index');
      var suggestionIndex = suggestionElement.getAttribute('data-suggestion-index');
      return {
        sectionIndex: typeof sectionIndex === 'string' ? parseInt(sectionIndex, 10) : null,
        suggestionIndex: parseInt(suggestionIndex, 10)
      };
    }
  }, {
    key: "findSuggestionElement",
    value: function findSuggestionElement(startNode) {
      var node = startNode;

      do {
        if (node.getAttribute && node.getAttribute('data-suggestion-index') !== null) {
          return node;
        }

        node = node.parentNode;
      } while (node !== null);

      console.error('Clicked element:', startNode); // eslint-disable-line no-console

      throw new Error("Couldn't find suggestion element");
    }
  }, {
    key: "maybeCallOnChange",
    value: function maybeCallOnChange(event, newValue, method) {
      var _this$props$inputProp = this.props.inputProps,
          value = _this$props$inputProp.value,
          onChange = _this$props$inputProp.onChange;

      if (newValue !== value) {
        onChange(event, {
          newValue: newValue,
          method: method
        });
      }
    }
  }, {
    key: "willRenderSuggestions",
    value: function willRenderSuggestions(props, reason) {
      var suggestions = props.suggestions,
          inputProps = props.inputProps,
          shouldRenderSuggestions = props.shouldRenderSuggestions;
      var value = inputProps.value;
      return suggestions.length > 0 && shouldRenderSuggestions(value, reason);
    }
  }, {
    key: "getQuery",
    value: function getQuery() {
      var inputProps = this.props.inputProps;
      var value = inputProps.value;
      var valueBeforeUpDown = this.state.valueBeforeUpDown;
      return (valueBeforeUpDown === null ? value : valueBeforeUpDown).trim();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props6 = this.props,
          suggestions = _this$props6.suggestions,
          renderInputComponent = _this$props6.renderInputComponent,
          onSuggestionsFetchRequested = _this$props6.onSuggestionsFetchRequested,
          renderSuggestion = _this$props6.renderSuggestion,
          inputProps = _this$props6.inputProps,
          multiSection = _this$props6.multiSection,
          renderSectionTitle = _this$props6.renderSectionTitle,
          id = _this$props6.id,
          getSectionSuggestions = _this$props6.getSectionSuggestions,
          theme = _this$props6.theme,
          getSuggestionValue = _this$props6.getSuggestionValue,
          alwaysRenderSuggestions = _this$props6.alwaysRenderSuggestions,
          highlightFirstSuggestion = _this$props6.highlightFirstSuggestion,
          containerProps = _this$props6.containerProps;
      var _this$state2 = this.state,
          isFocused = _this$state2.isFocused,
          isCollapsed = _this$state2.isCollapsed,
          highlightedSectionIndex = _this$state2.highlightedSectionIndex,
          highlightedSuggestionIndex = _this$state2.highlightedSuggestionIndex,
          valueBeforeUpDown = _this$state2.valueBeforeUpDown;
      var shouldRenderSuggestions = alwaysRenderSuggestions ? alwaysTrue : this.props.shouldRenderSuggestions;
      var value = inputProps.value,
          _onFocus = inputProps.onFocus,
          _onKeyDown = inputProps.onKeyDown;
      var willRenderSuggestions = this.willRenderSuggestions(this.props, 'render');
      var isOpen = alwaysRenderSuggestions || isFocused && !isCollapsed && willRenderSuggestions;
      var items = isOpen ? suggestions : [];

      var autowhateverInputProps = _objectSpread({}, inputProps, {
        onFocus: function onFocus(event) {
          if (!_this3.justSelectedSuggestion && !_this3.justClickedOnSuggestionsContainer) {
            var shouldRender = shouldRenderSuggestions(value, REASON_INPUT_FOCUSED);

            _this3.setState({
              isFocused: true,
              isCollapsed: !shouldRender
            });

            _onFocus && _onFocus(event);

            if (shouldRender) {
              onSuggestionsFetchRequested({
                value: value,
                reason: REASON_INPUT_FOCUSED
              });
            }
          }
        },
        onBlur: function onBlur(event) {
          if (_this3.justClickedOnSuggestionsContainer) {
            _this3.input.focus();

            return;
          }

          _this3.blurEvent = event;

          if (!_this3.justSelectedSuggestion) {
            _this3.onBlur();

            _this3.onSuggestionsClearRequested();
          }
        },
        onChange: function onChange(event) {
          var value = event.target.value;
          var shouldRender = shouldRenderSuggestions(value, REASON_INPUT_CHANGED);

          _this3.maybeCallOnChange(event, value, 'type');

          if (_this3.suggestionsContainer) {
            _this3.suggestionsContainer.scrollTop = 0;
          }

          _this3.setState(_objectSpread({}, highlightFirstSuggestion ? {} : {
            highlightedSectionIndex: null,
            highlightedSuggestionIndex: null,
            highlightedSuggestion: null
          }, {
            valueBeforeUpDown: null,
            isCollapsed: !shouldRender
          }));

          if (shouldRender) {
            onSuggestionsFetchRequested({
              value: value,
              reason: REASON_INPUT_CHANGED
            });
          } else {
            _this3.onSuggestionsClearRequested();
          }
        },
        onKeyDown: function onKeyDown(event, data) {
          var keyCode = event.keyCode;

          switch (keyCode) {
            case 40: // ArrowDown

            case 38:
              // ArrowUp
              if (isCollapsed) {
                if (shouldRenderSuggestions(value, REASON_SUGGESTIONS_REVEALED)) {
                  onSuggestionsFetchRequested({
                    value: value,
                    reason: REASON_SUGGESTIONS_REVEALED
                  });

                  _this3.revealSuggestions();

                  event.preventDefault(); // We act on the key.
                }
              } else if (suggestions.length > 0) {
                var newHighlightedSectionIndex = data.newHighlightedSectionIndex,
                    newHighlightedItemIndex = data.newHighlightedItemIndex;
                var newValue;

                if (newHighlightedItemIndex === null) {
                  // valueBeforeUpDown can be null if, for example, user
                  // hovers on the first suggestion and then pressed Up.
                  // If that happens, use the original input value.
                  newValue = valueBeforeUpDown === null ? value : valueBeforeUpDown;
                } else {
                  newValue = _this3.getSuggestionValueByIndex(newHighlightedSectionIndex, newHighlightedItemIndex);
                }

                _this3.updateHighlightedSuggestion(newHighlightedSectionIndex, newHighlightedItemIndex, value);

                _this3.maybeCallOnChange(event, newValue, keyCode === 40 ? 'down' : 'up');

                event.preventDefault(); // We act on the key.
              }

              _this3.justPressedUpDown = true;
              setTimeout(function () {
                _this3.justPressedUpDown = false;
              });
              break;
            // Enter

            case 13:
              {
                // See #388
                if (event.keyCode === 229) {
                  break;
                }

                var highlightedSuggestion = _this3.getHighlightedSuggestion();

                if (isOpen && !alwaysRenderSuggestions) {
                  _this3.closeSuggestions();
                }

                if (highlightedSuggestion != null) {
                  event.preventDefault();

                  var _newValue = getSuggestionValue(highlightedSuggestion);

                  _this3.maybeCallOnChange(event, _newValue, 'enter');

                  _this3.onSuggestionSelected(event, {
                    suggestion: highlightedSuggestion,
                    suggestionValue: _newValue,
                    suggestionIndex: highlightedSuggestionIndex,
                    sectionIndex: highlightedSectionIndex,
                    method: 'enter'
                  });

                  _this3.justSelectedSuggestion = true;
                  setTimeout(function () {
                    _this3.justSelectedSuggestion = false;
                  });
                }

                break;
              }
            // Escape

            case 27:
              {
                if (isOpen) {
                  // If input.type === 'search', the browser clears the input
                  // when Escape is pressed. We want to disable this default
                  // behaviour so that, when suggestions are shown, we just hide
                  // them, without clearing the input.
                  event.preventDefault();
                }

                var willCloseSuggestions = isOpen && !alwaysRenderSuggestions;

                if (valueBeforeUpDown === null) {
                  // Didn't interact with Up/Down
                  if (!willCloseSuggestions) {
                    var _newValue2 = '';

                    _this3.maybeCallOnChange(event, _newValue2, 'escape');

                    if (shouldRenderSuggestions(_newValue2, REASON_ESCAPE_PRESSED)) {
                      onSuggestionsFetchRequested({
                        value: _newValue2,
                        reason: REASON_ESCAPE_PRESSED
                      });
                    } else {
                      _this3.onSuggestionsClearRequested();
                    }
                  }
                } else {
                  // Interacted with Up/Down
                  _this3.maybeCallOnChange(event, valueBeforeUpDown, 'escape');
                }

                if (willCloseSuggestions) {
                  _this3.onSuggestionsClearRequested();

                  _this3.closeSuggestions();
                } else {
                  _this3.resetHighlightedSuggestion();
                }

                break;
              }
          }

          _onKeyDown && _onKeyDown(event);
        }
      });

      var renderSuggestionData = {
        query: this.getQuery()
      };
      return /*#__PURE__*/_react["default"].createElement(_Autowhatever["default"], {
        multiSection: multiSection,
        items: items,
        renderInputComponent: renderInputComponent,
        renderItemsContainer: this.renderSuggestionsContainer,
        renderItem: renderSuggestion,
        renderItemData: renderSuggestionData,
        renderSectionTitle: renderSectionTitle,
        getSectionItems: getSectionSuggestions,
        highlightedSectionIndex: highlightedSectionIndex,
        highlightedItemIndex: highlightedSuggestionIndex,
        containerProps: containerProps,
        inputProps: autowhateverInputProps,
        itemProps: this.itemProps,
        theme: (0, _theme.mapToAutowhateverTheme)(theme),
        id: id,
        ref: this.storeAutowhateverRef
      });
    }
  }]);

  return Autosuggest;
}(_react.Component);

exports["default"] = Autosuggest;

_defineProperty(Autosuggest, "propTypes", {
  suggestions: _propTypes["default"].array.isRequired,
  onSuggestionsFetchRequested: function onSuggestionsFetchRequested(props, propName) {
    var onSuggestionsFetchRequested = props[propName];

    if (typeof onSuggestionsFetchRequested !== 'function') {
      throw new Error("'onSuggestionsFetchRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsFetchRequestedProp");
    }
  },
  onSuggestionsClearRequested: function onSuggestionsClearRequested(props, propName) {
    var onSuggestionsClearRequested = props[propName];

    if (props.alwaysRenderSuggestions === false && typeof onSuggestionsClearRequested !== 'function') {
      throw new Error("'onSuggestionsClearRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsClearRequestedProp");
    }
  },
  shouldKeepSuggestionsOnSelect: _propTypes["default"].func,
  onSuggestionSelected: _propTypes["default"].func,
  onSuggestionHighlighted: _propTypes["default"].func,
  renderInputComponent: _propTypes["default"].func,
  renderSuggestionsContainer: _propTypes["default"].func,
  getSuggestionValue: _propTypes["default"].func.isRequired,
  renderSuggestion: _propTypes["default"].func.isRequired,
  inputProps: function inputProps(props, propName) {
    var inputProps = props[propName];

    if (!inputProps) {
      throw new Error("'inputProps' must be passed.");
    }

    if (!Object.prototype.hasOwnProperty.call(inputProps, 'value')) {
      throw new Error("'inputProps' must have 'value'.");
    }

    if (!Object.prototype.hasOwnProperty.call(inputProps, 'onChange')) {
      throw new Error("'inputProps' must have 'onChange'.");
    }
  },
  shouldRenderSuggestions: _propTypes["default"].func,
  alwaysRenderSuggestions: _propTypes["default"].bool,
  multiSection: _propTypes["default"].bool,
  renderSectionTitle: function renderSectionTitle(props, propName) {
    var renderSectionTitle = props[propName];

    if (props.multiSection === true && typeof renderSectionTitle !== 'function') {
      throw new Error("'renderSectionTitle' must be implemented. See: https://github.com/moroshko/react-autosuggest#renderSectionTitleProp");
    }
  },
  getSectionSuggestions: function getSectionSuggestions(props, propName) {
    var getSectionSuggestions = props[propName];

    if (props.multiSection === true && typeof getSectionSuggestions !== 'function') {
      throw new Error("'getSectionSuggestions' must be implemented. See: https://github.com/moroshko/react-autosuggest#getSectionSuggestionsProp");
    }
  },
  focusInputOnSuggestionClick: _propTypes["default"].bool,
  highlightFirstSuggestion: _propTypes["default"].bool,
  theme: _propTypes["default"].object,
  id: _propTypes["default"].string,
  containerProps: _propTypes["default"].object // Arbitrary container props

});

_defineProperty(Autosuggest, "defaultProps", {
  renderSuggestionsContainer: defaultRenderSuggestionsContainer,
  shouldRenderSuggestions: defaultShouldRenderSuggestions,
  alwaysRenderSuggestions: false,
  multiSection: false,
  shouldKeepSuggestionsOnSelect: function shouldKeepSuggestionsOnSelect() {
    return false;
  },
  focusInputOnSuggestionClick: true,
  highlightFirstSuggestion: false,
  theme: _theme.defaultTheme,
  id: '1',
  containerProps: {}
});

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function shallowEqualArrays(arrA, arrB) {
  if (arrA === arrB) {
    return true;
  }

  if (!arrA || !arrB) {
    return false;
  }

  var len = arrA.length;

  if (arrB.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqualArrays;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _sectionIterator = _interopRequireDefault(__webpack_require__(456));

var _reactThemeable = _interopRequireDefault(__webpack_require__(457));

var _SectionTitle = _interopRequireDefault(__webpack_require__(459));

var _ItemList = _interopRequireDefault(__webpack_require__(460));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var emptyObject = {};

var defaultRenderInputComponent = function defaultRenderInputComponent(props) {
  return /*#__PURE__*/_react["default"].createElement("input", props);
};

var defaultRenderItemsContainer = function defaultRenderItemsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", containerProps, children);
};

var defaultTheme = {
  container: 'react-autowhatever__container',
  containerOpen: 'react-autowhatever__container--open',
  input: 'react-autowhatever__input',
  inputOpen: 'react-autowhatever__input--open',
  inputFocused: 'react-autowhatever__input--focused',
  itemsContainer: 'react-autowhatever__items-container',
  itemsContainerOpen: 'react-autowhatever__items-container--open',
  itemsList: 'react-autowhatever__items-list',
  item: 'react-autowhatever__item',
  itemFirst: 'react-autowhatever__item--first',
  itemHighlighted: 'react-autowhatever__item--highlighted',
  sectionContainer: 'react-autowhatever__section-container',
  sectionContainerFirst: 'react-autowhatever__section-container--first',
  sectionTitle: 'react-autowhatever__section-title'
};

var Autowhatever = /*#__PURE__*/function (_Component) {
  _inherits(Autowhatever, _Component);

  var _super = _createSuper(Autowhatever);

  function Autowhatever(props) {
    var _this;

    _classCallCheck(this, Autowhatever);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "storeInputReference", function (input) {
      if (input !== null) {
        _this.input = input;
      }

      var userRef = _this.props.inputProps.ref;

      if (userRef) {
        if (typeof userRef === 'function') {
          userRef(input);
        } else if (_typeof(userRef) === 'object' && Object.prototype.hasOwnProperty.call(userRef, 'current')) {
          userRef.current = input;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "storeItemsContainerReference", function (itemsContainer) {
      if (itemsContainer !== null) {
        _this.itemsContainer = itemsContainer;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onHighlightedItemChange", function (highlightedItem) {
      _this.highlightedItem = highlightedItem;
    });

    _defineProperty(_assertThisInitialized(_this), "getItemId", function (sectionIndex, itemIndex) {
      if (itemIndex === null) {
        return null;
      }

      var id = _this.props.id;
      var section = sectionIndex === null ? '' : "section-".concat(sectionIndex);
      return "react-autowhatever-".concat(id, "-").concat(section, "-item-").concat(itemIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "onFocus", function (event) {
      var inputProps = _this.props.inputProps;

      _this.setState({
        isInputFocused: true
      });

      inputProps.onFocus && inputProps.onFocus(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function (event) {
      var inputProps = _this.props.inputProps;

      _this.setState({
        isInputFocused: false
      });

      inputProps.onBlur && inputProps.onBlur(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      var _this$props = _this.props,
          inputProps = _this$props.inputProps,
          highlightedSectionIndex = _this$props.highlightedSectionIndex,
          highlightedItemIndex = _this$props.highlightedItemIndex;
      var keyCode = event.keyCode;

      switch (keyCode) {
        case 40: // ArrowDown

        case 38:
          {
            // ArrowUp
            var nextPrev = keyCode === 40 ? 'next' : 'prev';

            var _this$sectionIterator = _this.sectionIterator[nextPrev]([highlightedSectionIndex, highlightedItemIndex]),
                _this$sectionIterator2 = _slicedToArray(_this$sectionIterator, 2),
                newHighlightedSectionIndex = _this$sectionIterator2[0],
                newHighlightedItemIndex = _this$sectionIterator2[1];

            inputProps.onKeyDown(event, {
              newHighlightedSectionIndex: newHighlightedSectionIndex,
              newHighlightedItemIndex: newHighlightedItemIndex
            });
            break;
          }

        default:
          inputProps.onKeyDown(event, {
            highlightedSectionIndex: highlightedSectionIndex,
            highlightedItemIndex: highlightedItemIndex
          });
      }
    });

    _this.highlightedItem = null;
    _this.state = {
      isInputFocused: false
    };

    _this.setSectionsItems(props);

    _this.setSectionIterator(props);

    _this.setTheme(props);

    return _this;
  }

  _createClass(Autowhatever, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.ensureHighlightedItemIsVisible();
    } // eslint-disable-next-line camelcase, react/sort-comp

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.items !== this.props.items) {
        this.setSectionsItems(nextProps);
      }

      if (nextProps.items !== this.props.items || nextProps.multiSection !== this.props.multiSection) {
        this.setSectionIterator(nextProps);
      }

      if (nextProps.theme !== this.props.theme) {
        this.setTheme(nextProps);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.ensureHighlightedItemIsVisible();
    }
  }, {
    key: "setSectionsItems",
    value: function setSectionsItems(props) {
      if (props.multiSection) {
        this.sectionsItems = props.items.map(function (section) {
          return props.getSectionItems(section);
        });
        this.sectionsLengths = this.sectionsItems.map(function (items) {
          return items.length;
        });
        this.allSectionsAreEmpty = this.sectionsLengths.every(function (itemsCount) {
          return itemsCount === 0;
        });
      }
    }
  }, {
    key: "setSectionIterator",
    value: function setSectionIterator(props) {
      this.sectionIterator = (0, _sectionIterator["default"])({
        multiSection: props.multiSection,
        data: props.multiSection ? this.sectionsLengths : props.items.length
      });
    }
  }, {
    key: "setTheme",
    value: function setTheme(props) {
      this.theme = (0, _reactThemeable["default"])(props.theme);
    }
  }, {
    key: "renderSections",
    value: function renderSections() {
      var _this2 = this;

      if (this.allSectionsAreEmpty) {
        return null;
      }

      var theme = this.theme;
      var _this$props2 = this.props,
          id = _this$props2.id,
          items = _this$props2.items,
          renderItem = _this$props2.renderItem,
          renderItemData = _this$props2.renderItemData,
          renderSectionTitle = _this$props2.renderSectionTitle,
          highlightedSectionIndex = _this$props2.highlightedSectionIndex,
          highlightedItemIndex = _this$props2.highlightedItemIndex,
          itemProps = _this$props2.itemProps;
      return items.map(function (section, sectionIndex) {
        var keyPrefix = "react-autowhatever-".concat(id, "-");
        var sectionKeyPrefix = "".concat(keyPrefix, "section-").concat(sectionIndex, "-");
        var isFirstSection = sectionIndex === 0; // `key` is provided by theme()

        /* eslint-disable react/jsx-key */

        return /*#__PURE__*/_react["default"].createElement("div", theme("".concat(sectionKeyPrefix, "container"), 'sectionContainer', isFirstSection && 'sectionContainerFirst'), /*#__PURE__*/_react["default"].createElement(_SectionTitle["default"], {
          section: section,
          renderSectionTitle: renderSectionTitle,
          theme: theme,
          sectionKeyPrefix: sectionKeyPrefix
        }), /*#__PURE__*/_react["default"].createElement(_ItemList["default"], {
          items: _this2.sectionsItems[sectionIndex],
          itemProps: itemProps,
          renderItem: renderItem,
          renderItemData: renderItemData,
          sectionIndex: sectionIndex,
          highlightedItemIndex: highlightedSectionIndex === sectionIndex ? highlightedItemIndex : null,
          onHighlightedItemChange: _this2.onHighlightedItemChange,
          getItemId: _this2.getItemId,
          theme: theme,
          keyPrefix: keyPrefix,
          ref: _this2.storeItemsListReference
        }));
        /* eslint-enable react/jsx-key */
      });
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var items = this.props.items;

      if (items.length === 0) {
        return null;
      }

      var theme = this.theme;
      var _this$props3 = this.props,
          id = _this$props3.id,
          renderItem = _this$props3.renderItem,
          renderItemData = _this$props3.renderItemData,
          highlightedSectionIndex = _this$props3.highlightedSectionIndex,
          highlightedItemIndex = _this$props3.highlightedItemIndex,
          itemProps = _this$props3.itemProps;
      return /*#__PURE__*/_react["default"].createElement(_ItemList["default"], {
        items: items,
        itemProps: itemProps,
        renderItem: renderItem,
        renderItemData: renderItemData,
        highlightedItemIndex: highlightedSectionIndex === null ? highlightedItemIndex : null,
        onHighlightedItemChange: this.onHighlightedItemChange,
        getItemId: this.getItemId,
        theme: theme,
        keyPrefix: "react-autowhatever-".concat(id, "-")
      });
    }
  }, {
    key: "ensureHighlightedItemIsVisible",
    value: function ensureHighlightedItemIsVisible() {
      var highlightedItem = this.highlightedItem;

      if (!highlightedItem) {
        return;
      }

      var itemsContainer = this.itemsContainer;
      var itemOffsetRelativeToContainer = highlightedItem.offsetParent === itemsContainer ? highlightedItem.offsetTop : highlightedItem.offsetTop - itemsContainer.offsetTop;
      var scrollTop = itemsContainer.scrollTop; // Top of the visible area

      if (itemOffsetRelativeToContainer < scrollTop) {
        // Item is off the top of the visible area
        scrollTop = itemOffsetRelativeToContainer;
      } else if (itemOffsetRelativeToContainer + highlightedItem.offsetHeight > scrollTop + itemsContainer.offsetHeight) {
        // Item is off the bottom of the visible area
        scrollTop = itemOffsetRelativeToContainer + highlightedItem.offsetHeight - itemsContainer.offsetHeight;
      }

      if (scrollTop !== itemsContainer.scrollTop) {
        itemsContainer.scrollTop = scrollTop;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var theme = this.theme;
      var _this$props4 = this.props,
          id = _this$props4.id,
          multiSection = _this$props4.multiSection,
          renderInputComponent = _this$props4.renderInputComponent,
          renderItemsContainer = _this$props4.renderItemsContainer,
          highlightedSectionIndex = _this$props4.highlightedSectionIndex,
          highlightedItemIndex = _this$props4.highlightedItemIndex;
      var isInputFocused = this.state.isInputFocused;
      var renderedItems = multiSection ? this.renderSections() : this.renderItems();
      var isOpen = renderedItems !== null;
      var ariaActivedescendant = this.getItemId(highlightedSectionIndex, highlightedItemIndex);
      var itemsContainerId = "react-autowhatever-".concat(id);

      var containerProps = _objectSpread({
        role: 'combobox',
        'aria-haspopup': 'listbox',
        'aria-owns': itemsContainerId,
        'aria-expanded': isOpen
      }, theme("react-autowhatever-".concat(id, "-container"), 'container', isOpen && 'containerOpen'), {}, this.props.containerProps);

      var inputComponent = renderInputComponent(_objectSpread({
        type: 'text',
        value: '',
        autoComplete: 'off',
        'aria-autocomplete': 'list',
        'aria-controls': itemsContainerId,
        'aria-activedescendant': ariaActivedescendant
      }, theme("react-autowhatever-".concat(id, "-input"), 'input', isOpen && 'inputOpen', isInputFocused && 'inputFocused'), {}, this.props.inputProps, {
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.props.inputProps.onKeyDown && this.onKeyDown,
        ref: this.storeInputReference
      }));
      var itemsContainer = renderItemsContainer({
        containerProps: _objectSpread({
          id: itemsContainerId,
          role: 'listbox'
        }, theme("react-autowhatever-".concat(id, "-items-container"), 'itemsContainer', isOpen && 'itemsContainerOpen'), {
          ref: this.storeItemsContainerReference
        }),
        children: renderedItems
      });
      return /*#__PURE__*/_react["default"].createElement("div", containerProps, inputComponent, itemsContainer);
    }
  }]);

  return Autowhatever;
}(_react.Component);

exports["default"] = Autowhatever;

_defineProperty(Autowhatever, "propTypes", {
  id: _propTypes["default"].string,
  // Used in aria-* attributes. If multiple Autowhatever's are rendered on a page, they must have unique ids.
  multiSection: _propTypes["default"].bool,
  // Indicates whether a multi section layout should be rendered.
  renderInputComponent: _propTypes["default"].func,
  // When specified, it is used to render the input element.
  renderItemsContainer: _propTypes["default"].func,
  // Renders the items container.
  items: _propTypes["default"].array.isRequired,
  // Array of items or sections to render.
  renderItem: _propTypes["default"].func,
  // This function renders a single item.
  renderItemData: _propTypes["default"].object,
  // Arbitrary data that will be passed to renderItem()
  renderSectionTitle: _propTypes["default"].func,
  // This function gets a section and renders its title.
  getSectionItems: _propTypes["default"].func,
  // This function gets a section and returns its items, which will be passed into `renderItem` for rendering.
  containerProps: _propTypes["default"].object,
  // Arbitrary container props
  inputProps: _propTypes["default"].object,
  // Arbitrary input props
  itemProps: _propTypes["default"].oneOfType([// Arbitrary item props
  _propTypes["default"].object, _propTypes["default"].func]),
  highlightedSectionIndex: _propTypes["default"].number,
  // Section index of the highlighted item
  highlightedItemIndex: _propTypes["default"].number,
  // Highlighted item index (within a section)
  theme: _propTypes["default"].oneOfType([// Styles. See: https://github.com/markdalgleish/react-themeable
  _propTypes["default"].object, _propTypes["default"].array])
});

_defineProperty(Autowhatever, "defaultProps", {
  id: '1',
  multiSection: false,
  renderInputComponent: defaultRenderInputComponent,
  renderItemsContainer: defaultRenderItemsContainer,
  renderItem: function renderItem() {
    throw new Error('`renderItem` must be provided');
  },
  renderItemData: emptyObject,
  renderSectionTitle: function renderSectionTitle() {
    throw new Error('`renderSectionTitle` must be provided');
  },
  getSectionItems: function getSectionItems() {
    throw new Error('`getSectionItems` must be provided');
  },
  containerProps: emptyObject,
  inputProps: emptyObject,
  itemProps: emptyObject,
  highlightedSectionIndex: null,
  highlightedItemIndex: null,
  theme: defaultTheme
});

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

module.exports = function (_ref) {
  var data = _ref.data;
  var multiSection = _ref.multiSection;

  function nextNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = 0;
    } else {
      sectionIndex++;
    }

    while (sectionIndex < data.length && data[sectionIndex] === 0) {
      sectionIndex++;
    }

    return sectionIndex === data.length ? null : sectionIndex;
  }

  function prevNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = data.length - 1;
    } else {
      sectionIndex--;
    }

    while (sectionIndex >= 0 && data[sectionIndex] === 0) {
      sectionIndex--;
    }

    return sectionIndex === -1 ? null : sectionIndex;
  }

  function next(position) {
    var _position = _slicedToArray(position, 2);

    var sectionIndex = _position[0];
    var itemIndex = _position[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === data[sectionIndex] - 1) {
        sectionIndex = nextNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, 0];
      }

      return [sectionIndex, itemIndex + 1];
    }

    if (data === 0 || itemIndex === data - 1) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, 0];
    }

    return [null, itemIndex + 1];
  }

  function prev(position) {
    var _position2 = _slicedToArray(position, 2);

    var sectionIndex = _position2[0];
    var itemIndex = _position2[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === 0) {
        sectionIndex = prevNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, data[sectionIndex] - 1];
      }

      return [sectionIndex, itemIndex - 1];
    }

    if (data === 0 || itemIndex === 0) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, data - 1];
    }

    return [null, itemIndex - 1];
  }

  function isLast(position) {
    return next(position)[1] === null;
  }

  return {
    next: next,
    prev: prev,
    isLast: isLast
  };
};


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

var _objectAssign = __webpack_require__(458);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var truthy = function truthy(x) {
  return x;
};

exports['default'] = function (input) {
  var _ref = Array.isArray(input) && input.length === 2 ? input : [input, null];

  var _ref2 = _slicedToArray(_ref, 2);

  var theme = _ref2[0];
  var classNameDecorator = _ref2[1];

  return function (key) {
    for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      names[_key - 1] = arguments[_key];
    }

    var styles = names.map(function (name) {
      return theme[name];
    }).filter(truthy);

    return typeof styles[0] === 'string' || typeof classNameDecorator === 'function' ? { key: key, className: classNameDecorator ? classNameDecorator.apply(undefined, _toConsumableArray(styles)) : styles.join(' ') } : { key: key, style: _objectAssign2['default'].apply(undefined, [{}].concat(_toConsumableArray(styles))) };
  };
};

module.exports = exports['default'];

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function ToObject(val) {
	if (val == null) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function ownEnumerableKeys(obj) {
	var keys = Object.getOwnPropertyNames(obj);

	if (Object.getOwnPropertySymbols) {
		keys = keys.concat(Object.getOwnPropertySymbols(obj));
	}

	return keys.filter(function (key) {
		return propIsEnumerable.call(obj, key);
	});
}

module.exports = Object.assign || function (target, source) {
	var from;
	var keys;
	var to = ToObject(target);

	for (var s = 1; s < arguments.length; s++) {
		from = arguments[s];
		keys = ownEnumerableKeys(Object(from));

		for (var i = 0; i < keys.length; i++) {
			to[keys[i]] = from[keys[i]];
		}
	}

	return to;
};


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _compareObjects = _interopRequireDefault(__webpack_require__(107));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SectionTitle = /*#__PURE__*/function (_Component) {
  _inherits(SectionTitle, _Component);

  var _super = _createSuper(SectionTitle);

  function SectionTitle() {
    _classCallCheck(this, SectionTitle);

    return _super.apply(this, arguments);
  }

  _createClass(SectionTitle, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects["default"])(nextProps, this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          section = _this$props.section,
          renderSectionTitle = _this$props.renderSectionTitle,
          theme = _this$props.theme,
          sectionKeyPrefix = _this$props.sectionKeyPrefix;
      var sectionTitle = renderSectionTitle(section);

      if (!sectionTitle) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", theme("".concat(sectionKeyPrefix, "title"), 'sectionTitle'), sectionTitle);
    }
  }]);

  return SectionTitle;
}(_react.Component);

exports["default"] = SectionTitle;

_defineProperty(SectionTitle, "propTypes", {
  section: _propTypes["default"].any.isRequired,
  renderSectionTitle: _propTypes["default"].func.isRequired,
  theme: _propTypes["default"].func.isRequired,
  sectionKeyPrefix: _propTypes["default"].string.isRequired
});

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _Item = _interopRequireDefault(__webpack_require__(461));

var _compareObjects = _interopRequireDefault(__webpack_require__(107));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ItemsList = /*#__PURE__*/function (_Component) {
  _inherits(ItemsList, _Component);

  var _super = _createSuper(ItemsList);

  function ItemsList() {
    var _this;

    _classCallCheck(this, ItemsList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "storeHighlightedItemReference", function (highlightedItem) {
      _this.props.onHighlightedItemChange(highlightedItem === null ? null : highlightedItem.item);
    });

    return _this;
  }

  _createClass(ItemsList, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects["default"])(nextProps, this.props, ['itemProps']);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          items = _this$props.items,
          itemProps = _this$props.itemProps,
          renderItem = _this$props.renderItem,
          renderItemData = _this$props.renderItemData,
          sectionIndex = _this$props.sectionIndex,
          highlightedItemIndex = _this$props.highlightedItemIndex,
          getItemId = _this$props.getItemId,
          theme = _this$props.theme,
          keyPrefix = _this$props.keyPrefix;
      var sectionPrefix = sectionIndex === null ? keyPrefix : "".concat(keyPrefix, "section-").concat(sectionIndex, "-");
      var isItemPropsFunction = typeof itemProps === 'function';
      return /*#__PURE__*/_react["default"].createElement("ul", _extends({
        role: "listbox"
      }, theme("".concat(sectionPrefix, "items-list"), 'itemsList')), items.map(function (item, itemIndex) {
        var isFirst = itemIndex === 0;
        var isHighlighted = itemIndex === highlightedItemIndex;
        var itemKey = "".concat(sectionPrefix, "item-").concat(itemIndex);
        var itemPropsObj = isItemPropsFunction ? itemProps({
          sectionIndex: sectionIndex,
          itemIndex: itemIndex
        }) : itemProps;

        var allItemProps = _objectSpread({
          id: getItemId(sectionIndex, itemIndex),
          'aria-selected': isHighlighted
        }, theme(itemKey, 'item', isFirst && 'itemFirst', isHighlighted && 'itemHighlighted'), {}, itemPropsObj);

        if (isHighlighted) {
          allItemProps.ref = _this2.storeHighlightedItemReference;
        } // `key` is provided by theme()

        /* eslint-disable react/jsx-key */


        return /*#__PURE__*/_react["default"].createElement(_Item["default"], _extends({}, allItemProps, {
          sectionIndex: sectionIndex,
          isHighlighted: isHighlighted,
          itemIndex: itemIndex,
          item: item,
          renderItem: renderItem,
          renderItemData: renderItemData
        }));
        /* eslint-enable react/jsx-key */
      }));
    }
  }]);

  return ItemsList;
}(_react.Component);

exports["default"] = ItemsList;

_defineProperty(ItemsList, "propTypes", {
  items: _propTypes["default"].array.isRequired,
  itemProps: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),
  renderItem: _propTypes["default"].func.isRequired,
  renderItemData: _propTypes["default"].object.isRequired,
  sectionIndex: _propTypes["default"].number,
  highlightedItemIndex: _propTypes["default"].number,
  onHighlightedItemChange: _propTypes["default"].func.isRequired,
  getItemId: _propTypes["default"].func.isRequired,
  theme: _propTypes["default"].func.isRequired,
  keyPrefix: _propTypes["default"].string.isRequired
});

_defineProperty(ItemsList, "defaultProps", {
  sectionIndex: null
});

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _compareObjects = _interopRequireDefault(__webpack_require__(107));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Item = /*#__PURE__*/function (_Component) {
  _inherits(Item, _Component);

  var _super = _createSuper(Item);

  function Item() {
    var _this;

    _classCallCheck(this, Item);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "storeItemReference", function (item) {
      if (item !== null) {
        _this.item = item;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (event) {
      var _this$props = _this.props,
          sectionIndex = _this$props.sectionIndex,
          itemIndex = _this$props.itemIndex;

      _this.props.onMouseEnter(event, {
        sectionIndex: sectionIndex,
        itemIndex: itemIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function (event) {
      var _this$props2 = _this.props,
          sectionIndex = _this$props2.sectionIndex,
          itemIndex = _this$props2.itemIndex;

      _this.props.onMouseLeave(event, {
        sectionIndex: sectionIndex,
        itemIndex: itemIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (event) {
      var _this$props3 = _this.props,
          sectionIndex = _this$props3.sectionIndex,
          itemIndex = _this$props3.itemIndex;

      _this.props.onMouseDown(event, {
        sectionIndex: sectionIndex,
        itemIndex: itemIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      var _this$props4 = _this.props,
          sectionIndex = _this$props4.sectionIndex,
          itemIndex = _this$props4.itemIndex;

      _this.props.onClick(event, {
        sectionIndex: sectionIndex,
        itemIndex: itemIndex
      });
    });

    return _this;
  }

  _createClass(Item, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects["default"])(nextProps, this.props, ['renderItemData']);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          isHighlighted = _this$props5.isHighlighted,
          item = _this$props5.item,
          renderItem = _this$props5.renderItem,
          renderItemData = _this$props5.renderItemData,
          restProps = _objectWithoutProperties(_this$props5, ["isHighlighted", "item", "renderItem", "renderItemData"]);

      delete restProps.sectionIndex;
      delete restProps.itemIndex;

      if (typeof restProps.onMouseEnter === 'function') {
        restProps.onMouseEnter = this.onMouseEnter;
      }

      if (typeof restProps.onMouseLeave === 'function') {
        restProps.onMouseLeave = this.onMouseLeave;
      }

      if (typeof restProps.onMouseDown === 'function') {
        restProps.onMouseDown = this.onMouseDown;
      }

      if (typeof restProps.onClick === 'function') {
        restProps.onClick = this.onClick;
      }

      return /*#__PURE__*/_react["default"].createElement("li", _extends({
        role: "option"
      }, restProps, {
        ref: this.storeItemReference
      }), renderItem(item, _objectSpread({
        isHighlighted: isHighlighted
      }, renderItemData)));
    }
  }]);

  return Item;
}(_react.Component);

exports["default"] = Item;

_defineProperty(Item, "propTypes", {
  sectionIndex: _propTypes["default"].number,
  isHighlighted: _propTypes["default"].bool.isRequired,
  itemIndex: _propTypes["default"].number.isRequired,
  item: _propTypes["default"].any.isRequired,
  renderItem: _propTypes["default"].func.isRequired,
  renderItemData: _propTypes["default"].object.isRequired,
  onMouseEnter: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onClick: _propTypes["default"].func
});

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapToAutowhateverTheme = exports.defaultTheme = void 0;
var defaultTheme = {
  container: 'react-autosuggest__container',
  containerOpen: 'react-autosuggest__container--open',
  input: 'react-autosuggest__input',
  inputOpen: 'react-autosuggest__input--open',
  inputFocused: 'react-autosuggest__input--focused',
  suggestionsContainer: 'react-autosuggest__suggestions-container',
  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
  suggestionsList: 'react-autosuggest__suggestions-list',
  suggestion: 'react-autosuggest__suggestion',
  suggestionFirst: 'react-autosuggest__suggestion--first',
  suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
  sectionContainer: 'react-autosuggest__section-container',
  sectionContainerFirst: 'react-autosuggest__section-container--first',
  sectionTitle: 'react-autosuggest__section-title'
};
exports.defaultTheme = defaultTheme;

var mapToAutowhateverTheme = function mapToAutowhateverTheme(theme) {
  var result = {};

  for (var key in theme) {
    switch (key) {
      case 'suggestionsContainer':
        result['itemsContainer'] = theme[key];
        break;

      case 'suggestionsContainerOpen':
        result['itemsContainerOpen'] = theme[key];
        break;

      case 'suggestion':
        result['item'] = theme[key];
        break;

      case 'suggestionFirst':
        result['itemFirst'] = theme[key];
        break;

      case 'suggestionHighlighted':
        result['itemHighlighted'] = theme[key];
        break;

      case 'suggestionsList':
        result['itemsList'] = theme[key];
        break;

      default:
        result[key] = theme[key];
    }
  }

  return result;
};

exports.mapToAutowhateverTheme = mapToAutowhateverTheme;

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FreeTextEntry=function(_React$Component){_inherits(FreeTextEntry,_React$Component);function FreeTextEntry(){_classCallCheck(this,FreeTextEntry);return _possibleConstructorReturn(this,(FreeTextEntry.__proto__||Object.getPrototypeOf(FreeTextEntry)).apply(this,arguments));}_createClass(FreeTextEntry,[{key:"onChange",value:function onChange(event){this.props.update(this.props.propertyName,event.target.value);}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"input-label"},this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",value:this.props.value||'',onChange:this.onChange.bind(this)}));}}]);return FreeTextEntry;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (FreeTextEntry);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MultiSelectToggleView=function(_React$Component){_inherits(MultiSelectToggleView,_React$Component);function MultiSelectToggleView(props){_classCallCheck(this,MultiSelectToggleView);var _this=_possibleConstructorReturn(this,(MultiSelectToggleView.__proto__||Object.getPrototypeOf(MultiSelectToggleView)).call(this,props));_this.state={visible:_this.props.selection.length>0};return _this;}_createClass(MultiSelectToggleView,[{key:"toggleVisibility",value:function toggleVisibility(){this.setState({visible:!this.state.visible});}},{key:"onSelection",value:function onSelection(value,event){var selection=value.key;var selected=event.target.checked?[].concat(_toConsumableArray(this.props.selection),[selection]):this.props.selection.filter(function(s){return s!==selection;});this.props.update(this.props.propertyName,selected);}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:this.state.visible?"custom-add custom-add-open":"custom-add"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"custom-add-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",onClick:this.toggleVisibility.bind(this)},this.state.visible?"remove":"add")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"custom-add-body"},this.props.options.map(function(option){var checkboxId=_this2.props.propertyName+"-"+option.key;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:checkboxId,className:"custom-check-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",id:checkboxId,className:"custom-check",checked:_this2.props.selection.indexOf(option.key)>=0,onChange:_this2.onSelection.bind(_this2,option)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:checkboxId,className:"secondary-text"},option.value));})));}}]);return MultiSelectToggleView;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (MultiSelectToggleView);

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DateRangePicker=function(_React$Component){_inherits(DateRangePicker,_React$Component);function DateRangePicker(){_classCallCheck(this,DateRangePicker);return _possibleConstructorReturn(this,(DateRangePicker.__proto__||Object.getPrototypeOf(DateRangePicker)).apply(this,arguments));}_createClass(DateRangePicker,[{key:'onChange',value:function onChange(event){this.props.update(event.target.name,event.target.value);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Between Dates'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date-inputs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',name:'startDate',value:Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["l" /* formatDateForInput */])(this.props.startDate),max:this.props.endDate,onChange:this.onChange.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',name:'endDate',value:Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["l" /* formatDateForInput */])(this.props.endDate),min:this.props.startDate,onChange:this.onChange.bind(this)})));}}]);return DateRangePicker;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (DateRangePicker);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Toggle__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_GridIcon__ = __webpack_require__(467);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ApplicationsListControls=function(_React$Component){_inherits(ApplicationsListControls,_React$Component);function ApplicationsListControls(){_classCallCheck(this,ApplicationsListControls);return _possibleConstructorReturn(this,(ApplicationsListControls.__proto__||Object.getPrototypeOf(ApplicationsListControls)).apply(this,arguments));}_createClass(ApplicationsListControls,[{key:'updateStatus',value:function updateStatus(status){if(status!==this.props.status){this.props.update("status",status);}}},{key:'updateDays',value:function updateDays(status,event){var days=Object.assign({},this.props.days,_defineProperty({},status,event.target.value));this.props.update("days",days);}},{key:'render',value:function render(){var _this2=this;var isAllStatuses=!this.props.status;var hasStatusDateFilter=this.props.status==="Paid"||this.props.status==="Rejected";var activeDateFilterKey=isAllStatuses?"Recent":hasStatusDateFilter?this.props.status:null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container',style:{paddingTop:"20px",paddingBottom:"20px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'application-options'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'application-option status-option-all '+(isAllStatuses?"active":""),onClick:this.updateStatus.bind(this,null)},'All'),Object.keys(__WEBPACK_IMPORTED_MODULE_1__lib_systemVariables__["a" /* ApplicationStatuses */]).map(function(statusKey){var status=__WEBPACK_IMPORTED_MODULE_1__lib_systemVariables__["a" /* ApplicationStatuses */][statusKey];var count=Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["m" /* formatNumber */])(_this2.props.statusCounts[statusKey.charAt(0).toLowerCase()+statusKey.slice(1)]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{key:statusKey,className:'application-option status-option-'+statusKey.toLowerCase()+' '+(_this2.props.status===statusKey?"active":""),onClick:_this2.updateStatus.bind(_this2,statusKey)},status,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'status-option-count'},count));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'application-options-inquire-only'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Toggle__["a" /* default */],{id:'inquire-only',name:'inquireOnly',value:this.props.inquireOnly,onChange:function onChange(){return _this2.props.toggleInquireOnly();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'toggle-label'},'Show Inquire Only')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'application-options-date-filter '+(!activeDateFilterKey?"date-filter-disabled":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{disabled:!activeDateFilterKey,value:activeDateFilterKey?this.props.days[activeDateFilterKey]:"30",onChange:activeDateFilterKey?this.updateDays.bind(this,activeDateFilterKey):undefined},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'30'},'Last 30 days'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'60'},'Last 60 days'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'90'},'Last 90 days'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'All time')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'arrow_drop_down'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'application-details-toggle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-switch'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-flat btn-small view-toggle-button '+(this.props.filters.view===__WEBPACK_IMPORTED_MODULE_4__lib_constants__["k" /* TableViews */].Standard?"active":"inactive"),style:{width:'44px'},title:'Standard view','aria-label':'Standard view',onClick:function onClick(){return _this2.props.toggleView(__WEBPACK_IMPORTED_MODULE_4__lib_constants__["k" /* TableViews */].Standard);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_GridIcon__["a" /* default */],{rows:2,columns:2,gap:2})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-flat btn-small view-toggle-button '+(this.props.filters.view===__WEBPACK_IMPORTED_MODULE_4__lib_constants__["k" /* TableViews */].Detailed?"active":"inactive"),style:{width:'44px'},title:'Detailed view','aria-label':'Detailed view',onClick:function onClick(){return _this2.props.toggleView(__WEBPACK_IMPORTED_MODULE_4__lib_constants__["k" /* TableViews */].Detailed);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_GridIcon__["a" /* default */],{rows:3,columns:3})))),this.props.canExport&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-flat btn-small action-btn-export',onClick:this.props.onExport,disabled:this.props.exportDisabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/export-icon'+(this.props.exportDisabled?"-disabled":"")+'.png',className:'icon-left',alt:'export-icon'}),'Export')));}}]);return ApplicationsListControls;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ApplicationsListControls);

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var GridIcon=function GridIcon(_ref){var rows=_ref.rows,columns=_ref.columns,_ref$size=_ref.size,size=_ref$size===undefined?14:_ref$size,_ref$gap=_ref.gap,gap=_ref$gap===undefined?1:_ref$gap,_ref$radius=_ref.radius,radius=_ref$radius===undefined?0.5:_ref$radius;var cellWidth=(size-gap*(columns-1))/columns;var cellHeight=(size-gap*(rows-1))/rows;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{width:size,height:size,viewBox:"0 0 "+size+" "+size,fill:"currentColor","aria-hidden":"true"},Array.from({length:rows*columns}).map(function(_,index){var row=Math.floor(index/columns);var column=index%columns;var x=column*(cellWidth+gap);var y=row*(cellHeight+gap);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{key:row+"-"+column,x:x,y:y,width:cellWidth,height:cellHeight,rx:radius});}));};/* harmony default export */ __webpack_exports__["a"] = (GridIcon);

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function getReportFields(){return[{label:"Title",value:"Title",default:""},{label:"Last Name/Org Name",value:"LastOrOrgName",default:""},{label:"First Name",value:"FirstName",default:""},{label:"Report Name",value:"ReportName",default:""},{label:"Address",value:"Address",default:""},{label:"Unit #",value:"UnitNumber",default:""},{label:"City",value:"City",default:""},{label:"State",value:"State",default:""},{label:"Zip",value:"Zip",default:""},{label:"Country",value:"Country",default:""},{label:"Phone Number(s)",value:"PhoneNumbers",default:""},{label:"Reference(s)",value:"References",default:""},{label:"Solicitor(s)",value:"Solicitors",default:""},{label:"Rosh Yeshiva(s)",value:"RoshYeshivas",default:""},{label:"Status",value:"Status",default:""},{label:"Amount",value:"Amount",default:""},{label:"Currency",value:"Currency",default:""},{label:"Fund",value:"Fund",default:""},{label:"Reason",value:"Reason",default:""},{label:"Check Date",value:"CheckOrWireDate",default:""},{label:"Check #",value:"CheckOrWireNumber",default:""},{label:"Campaign",value:"Campaign",default:""},{label:"Campaign List",value:"CampaignList",default:""},{label:"Campaign List Contact",value:"CampaignListContact",default:""},{label:"Campaign Indiv Category",value:"CampaignIndivCat",default:""},{label:"Created Date",value:"CreatedDate",default:""},{label:"Review Date",value:"ReviewByDate",default:""},{label:"Teudat Zehut",value:"TeudatZahut",default:""},{label:"Source",value:"Source",default:""},{label:"Approver",value:"Approver",default:""},{label:"Notes",value:"Notes",default:""},{label:"Check Memo",value:"CheckMemo",default:""},{label:"Report Memo",value:"ReportMemo",default:""}];}var initialState={fields:[],groupBy:"",sortBy:"",sortDirection:"",error:false,noData:false,downloading:false,submitAttempted:false};var modalCloseAnimationMs=300;var sortDirectionOptions=[{key:"Ascending",value:"Ascending"},{key:"Descending",value:"Descending"}];var ApplicationsReportModal=function(_React$Component){_inherits(ApplicationsReportModal,_React$Component);function ApplicationsReportModal(props){_classCallCheck(this,ApplicationsReportModal);var _this=_possibleConstructorReturn(this,(ApplicationsReportModal.__proto__||Object.getPrototypeOf(ApplicationsReportModal)).call(this,props));_this.onChange=function(name,value){_this.setState(_defineProperty({},name,value));};_this.onChangeSortBy=function(name,value){_this.onChange(name,value);if(value===""){_this.setState({sortDirection:""});}else if(_this.state.sortDirection===""){_this.setState({sortDirection:sortDirectionOptions[0].value});}};_this.onToggleReportFields=function(event){var fieldName=event.target.name;var checked=event.target.checked;var fields=[].concat(_toConsumableArray(_this.state.fields));if(checked){fields.push(fieldName);}else{fields=fields.filter(function(f){return f!==fieldName;});if(_this.state.groupBy===fieldName){_this.setState({groupBy:""});}if(_this.state.sortBy===fieldName){_this.setState({sortBy:""});}}_this.setState({fields:fields});};_this.state=initialState;return _this;}_createClass(ApplicationsReportModal,[{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){if(!prevProps.show&&this.props.show){clearTimeout(this.closeTimeout);}}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearTimeout(this.closeTimeout);}},{key:"close",value:function close(){var _this2=this;this.props.close();clearTimeout(this.closeTimeout);this.closeTimeout=setTimeout(function(){_this2.setState(initialState);},modalCloseAnimationMs);}},{key:"exportData",value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _state,fields,groupBy,sortBy,sortDirection,now,dateStamp,fileName,params,response,blob,url,link;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({error:false,noData:false,submitAttempted:true});_state=this.state,fields=_state.fields,groupBy=_state.groupBy,sortBy=_state.sortBy,sortDirection=_state.sortDirection;if(fields.length){_context.next=4;break;}return _context.abrupt("return");case 4:_context.prev=4;now=new Date();dateStamp=[now.getFullYear(),String(now.getMonth()+1).padStart(2,'0'),String(now.getDate()).padStart(2,'0')].join('')+'_'+[String(now.getHours()).padStart(2,'0'),String(now.getMinutes()).padStart(2,'0'),String(now.getSeconds()).padStart(2,'0')].join('');fileName="Applications_Report_"+dateStamp+".xlsx";params={fields:fields,groupBy:groupBy,sortBy:sortBy,sortDirection:sortDirection};this.setState({downloading:true});_context.next=12;return this.props.getDataForExport(params);case 12:response=_context.sent;if(response.success){_context.next=15;break;}throw Error(response.noData?"noData":"error");case 15:blob=response.data instanceof Blob?response.data:new Blob([response.data],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});url=URL.createObjectURL(blob);link=document.createElement('a');link.href=url;link.download=fileName;document.body.appendChild(link);link.click();document.body.removeChild(link);setTimeout(function(){return URL.revokeObjectURL(url);},1000);__WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__["toastr"].success("Your report is ready");this.setState({downloading:false},this.close);_context.next=31;break;case 28:_context.prev=28;_context.t0=_context["catch"](4);this.setState(_defineProperty({downloading:false},_context.t0.message||"error",true));case 31:case"end":return _context.stop();}}},_callee,this,[[4,28]]);}));function exportData(){return _ref.apply(this,arguments);}return exportData;}()},{key:"render",value:function render(){var _this3=this;var _state2=this.state,error=_state2.error,fields=_state2.fields,groupBy=_state2.groupBy,sortBy=_state2.sortBy,sortDirection=_state2.sortDirection,downloading=_state2.downloading,noData=_state2.noData,submitAttempted=_state2.submitAttempted;var show=this.props.show;var reportFields=getReportFields();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Modal__["a" /* default */],{modalShowing:show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal new-fund-modal large-modal"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"bordered-modal-header"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",{className:"modal-page-header"},"Applications Report"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon ion-ios-close-empty "+(downloading?"disabled":""),onClick:downloading?null:this.close.bind(this)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"mb-16"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"flex"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"input-label "+(submitAttempted&&!fields.length?"error-label":"")},"Report Fields"),submitAttempted&&!fields.length&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"xs-text error-text ml-8"},"* Please select report fields")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row report-fields-grid"},reportFields.map(function(field){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-check-container",key:field.value},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",id:"report-field-"+field.value,className:"custom-check",name:field.value,onChange:_this3.onToggleReportFields,checked:fields.indexOf(field.value)>=0,disabled:downloading}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{htmlFor:"report-field-"+field.value,className:"secondary-text"},field.label));}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half column-half-left"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"input-label"},"Remove Duplicates Of"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Select__["a" /* default */],{clearable:!downloading,options:reportFields.filter(function(field){return fields.indexOf(field.value)>=0;}).map(function(field){return{key:field.value,value:field.label};}),value:groupBy,name:"groupBy",disabled:downloading,onChange:function onChange(e){return _this3.onChange(e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half column-half-left"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"input-label"},"Sort By"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Select__["a" /* default */],{clearable:!downloading,options:reportFields.filter(function(field){return fields.indexOf(field.value)>=0;}).map(function(field){return{key:field.value,value:field.label};}),value:sortBy,name:"sortBy",disabled:downloading,onChange:function onChange(e){return _this3.onChangeSortBy(e.target.name,e.target.value);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half column-half-left"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"input-label"},"Sort Direction"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Select__["a" /* default */],{options:sortDirectionOptions,disabled:downloading||sortBy==="",value:sortDirection,name:"sortDirection",onChange:function onChange(e){return _this3.onChange(e.target.name,e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-btns text-right"},downloading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"small-text info-text mb-8"},"Generating report... This may take a minute."),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-accent",onClick:this.close.bind(this),disabled:downloading},"Cancel"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-primary",onClick:this.exportData.bind(this),disabled:downloading},downloading?"Generating Report":"Download Report"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:error}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:noData,message:"No data was found.",timeOut:5000})))));}}]);return ApplicationsReportModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ApplicationsReportModal);

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_ApplicationsActions__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ACHResultsTable__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_components_ach_results_css__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_components_ach_results_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_components_ach_results_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ACHResultsPage=function(_NavigationComponent){_inherits(ACHResultsPage,_NavigationComponent);function ACHResultsPage(props){_classCallCheck(this,ACHResultsPage);return _possibleConstructorReturn(this,(ACHResultsPage.__proto__||Object.getPrototypeOf(ACHResultsPage)).call(this,props));}_createClass(ACHResultsPage,[{key:'render',value:function render(){var achResults=this.props.achResults;var successfulTransfers=achResults.filter(function(transfer){return transfer.success;});var transfersFailed=achResults.filter(function(transfer){return!transfer.success;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'secondary-page ach-results-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'secondary-page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container flex-justify flex-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-one flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-flat btn-small back-btn',onClick:this.props.onClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-ios-arrow-back icon-left'}),'Back to Applications')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-one',style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-header'},'ACH Results',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'printing-tag'},achResults.length))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-one flex-right'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container secondary-page-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ACHResultsTable__["a" /* default */],{achTransfers:achResults})),achResults.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'secretary-page-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-justify container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},'Total ',achResults.length,' Transfer',achResults.length>1?"s":"",'(',successfulTransfers.length,' successful, ',transfersFailed.length,' failed)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-accent2',onClick:this.props.onClose},'OK - Back to Applications'))));}}]);return ACHResultsPage;}(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_NavigationComponent__["a" /* default */]);function mapStateToProps(state,ownProps){return{};}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({getApplications:__WEBPACK_IMPORTED_MODULE_3__redux_actions_ApplicationsActions__["getApplications"]},dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(ACHResultsPage));

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ACHResultsTable=function(_React$Component){_inherits(ACHResultsTable,_React$Component);function ACHResultsTable(props){_classCallCheck(this,ACHResultsTable);var _this=_possibleConstructorReturn(this,(ACHResultsTable.__proto__||Object.getPrototypeOf(ACHResultsTable)).call(this,props));_this.state={sortAsc:true};return _this;}_createClass(ACHResultsTable,[{key:"sortTable",value:function sortTable(){this.setState({sortAsc:!this.state.sortAsc});}},{key:"render",value:function render(){var _this2=this;var _props$achTransfers=this.props.achTransfers,achTransfers=_props$achTransfers===undefined?[]:_props$achTransfers;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"table-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"table-header table-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"sort active"},"Application ID",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"sort-arrows relative",onClick:this.sortTable.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon ion-android-arrow-dropup"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon ion-android-arrow-dropdown"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Organization Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Amount"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Status"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Error Message"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,achTransfers&&achTransfers.slice().sort(function(a,b){var aId=Number(a.applicationId)||0;var bId=Number(b.applicationId)||0;return _this2.state.sortAsc?aId-bId:bId-aId;}).map(function(transfer){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:transfer.applicationId,className:"table-row "+(transfer.success?'success':'error')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"data-label":"Application ID"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"bold-text"},"#",transfer.applicationId)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"data-label":"Organization Name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,transfer.orgName||'N/A'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"data-label":"Amount"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"bold-text"},"$",transfer.amount.toLocaleString())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"data-label":"Status"},transfer.success?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon-check approved-text icon-left middle"}),"Success"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon-close error-text icon-left middle"}),"Failed")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"data-label":"Error Message"},transfer.success?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"secondary-text"},"-"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"error-text"},transfer.errorMessage||'Unknown error occurred')));}))),(!achTransfers||!achTransfers.length)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"no-results"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon ion-card"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"No ACH Transfer Records")));}}]);return ACHResultsTable;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ACHResultsTable);

/***/ }),
/* 471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions_CreateApplicationActions__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_actions_SuggestionsActions__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_actions_FundsActions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_actions_SettingsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__redux_actions_RecipientAccountsActions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CreateRecipient__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CreateApplication__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PrintInfo__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PaymentInfo__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CheckExistsWarningModal__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__commonComponents_shared_IncompleteApplicationWarning__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CreateCancelButtons__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__commonComponents_shared_WarningModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__applicationsCommon_MarkInquiry__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateApplicationPage=function(_NavigationComponent){_inherits(CreateApplicationPage,_NavigationComponent);function CreateApplicationPage(props){var _this2=this;_classCallCheck(this,CreateApplicationPage);var _this=_possibleConstructorReturn(this,(CreateApplicationPage.__proto__||Object.getPrototypeOf(CreateApplicationPage)).call(this,props));_this.setRecipientDetails=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(recipientId){var initialRecipient,recipientDetails,prevRecipient;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.actions.getRecipientAccountDetails(recipientId);case 2:if(!_this.props.recipientDetails.success){__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].error('Something went wrong','We were unable to retrieve recipient information. Please try again.');}else{initialRecipient=_this.state.initialRecipient;recipientDetails=_this.props.recipientDetails.data;prevRecipient=_this.state.recipient;_this.setState({recipient:Object.assign({},initialRecipient,{id:recipientDetails.applicantId,applicantType:recipientDetails.applicantType,isIsraeli:recipientDetails.isIsraeli,displayName:recipientDetails.displayName,reportName:recipientDetails.reportName,addressDisplay:recipientDetails.addressDisplay,address:recipientDetails.address,phoneNumber:recipientDetails.phoneNumber,secondPhoneNumber:recipientDetails.secondPhoneNumber,incomplete:recipientDetails.incomplete,references:recipientDetails.references,solicitors:recipientDetails.solicitors,roshYeshivas:recipientDetails.roshYeshivas,trustedPayee:recipientDetails.trustedPayee,bankAccounts:recipientDetails.bankAccounts,applicantPledges:recipientDetails.applicantPledges})},function(){return _this.onUpdateRecipient(_this.state.recipient,prevRecipient);});}case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.onChange=function(name,value){if(name==="recipient"){_this.updateRecipient(value);}else{_this.setState(_defineProperty({},name,value));}};_this.updateRecipient=function(recipient){var prevRecipient=_this.state.recipient;_this.setState({recipient:recipient},_this.onUpdateRecipient(recipient,prevRecipient));};_this.onUpdateRecipient=function(recipient,prevRecipient){var applicationUpdate=Object.assign({},_this.state.application);if(recipient.isIsraeli!==prevRecipient.isIsraeli){applicationUpdate=_this.onUpdateRecipientIsIsraeli(applicationUpdate,recipient.isIsraeli);}if(recipient.type!==prevRecipient.type){applicationUpdate=_this.onUpdateRecipientType(applicationUpdate);}if(!recipient.address.street&&prevRecipient.address.street){applicationUpdate=_this.onClearRecipientAddress(applicationUpdate);}if(recipient.trustedPayee?recipient.trustedPayee.referenceId:null!=prevRecipient.trustedPayee?prevRecipient.trustedPayee.referenceId:null){applicationUpdate=_this.onUpdateRecipientTrustedPayee(applicationUpdate,recipient.trustedPayee);}if(recipient.references.length<prevRecipient.references.length){var removedReferenceIds=prevRecipient.references.map(function(r){return r.referenceId.toString();}).filter(function(refId){return recipient.references.map(function(r){return r.referenceId.toString();}).indexOf(refId.toString)<0;});applicationUpdate=_this.onRemoveRecipientReferences(applicationUpdate,removedReferenceIds,recipient.references.length);}_this.setState({application:applicationUpdate});};_this.updateApplication=function(name,val){var application=Object.assign({},_this.state.application,_defineProperty({},name,val));_this.setState({application:application});};_this.updatePaymentInfo=function(name,val){var application=_this.state.application;if(name==='fundId'&&application.paymentInfo.manualPayment.manualPaymentType){var _Object$assign2;_this.props.actions.getBlankChecks(val);_this.setState({manualCheckLabel:'',application:Object.assign({},application,{paymentInfo:Object.assign({},application.paymentInfo,(_Object$assign2={},_defineProperty(_Object$assign2,name,val),_defineProperty(_Object$assign2,'manualPayment',Object.assign({},application.paymentInfo.manualPayment,{blankCheckId:''})),_Object$assign2))})});}else{_this.setState({application:Object.assign({},application,{paymentInfo:Object.assign({},application.paymentInfo,_defineProperty({},name,val))})});}};_this.updateDataErrors=function(name,val){_this.setState({dataErrors:Object.assign({},_this.state.dataErrors,_defineProperty({},name,val))});};_this.save=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var bypass=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var recipient,application;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(_this.state.error||_this.state.manualCheckError||_this.state.teudatZehutError){_this.setState({error:false,manualCheckError:false,teudatZehutError:false});//hide errors while submit
}if(!(_this.state.submitAttempted||!_this.getIncompleteFields())){_context2.next=10;break;}recipient=Object.assign({},_this.state.recipient,{references:_this.state.recipient.references.map(function(ref){return{referenceId:ref.referenceId,relationship:ref.relationship};}),solicitors:_this.state.recipient.solicitors.map(function(ref){return{referenceId:ref.referenceId,relationship:ref.relationship};}),roshYeshivas:_this.state.recipient.roshYeshivas.map(function(ref){return{referenceId:ref.referenceId,relationship:ref.relationship};}),trustedPayeeId:_this.state.recipient.trustedPayee?_this.state.recipient.trustedPayee.referenceId:null});application=_this.state.application;if(!application.paymentInfo.manualPayment||!application.paymentInfo.manualPayment.manualPaymentType){application.paymentInfo.manualPayment=null;}_context2.next=7;return _this.props.actions.createApplication(recipient,application,bypass);case 7:if(_this.props.createApplication.success){if(!_this.state.recipient.id){//created a new recipient
if(_this.state.recipient.applicantType===__WEBPACK_IMPORTED_MODULE_24__lib_systemVariables__["l" /* RecipientTypes */].Organization){_this.props.actions.getOrganizations();//get updated organization tags
}if(_this.state.recipient.address.country&&_this.props.utils.nationalities.indexOf(_this.state.recipient.address.country)<0||_this.state.recipient.address.city&&_this.props.utils.cities.indexOf(_this.state.recipient.address.city)<0){_this.props.actions.getSystemSettings();//get updated nationalities/cities
}}_this.setState({navigationOnSubmission:true},function(){return _this.pushRoute('/applications?applyFilters=true');});}else{if(_this.props.createApplication.id&&!_this.state.recipient.id){//recipient was created, create application failed
_this.setState({recipient:Object.assign({},_this.state.recipient,{id:_this.props.createApplication.id,displayName:_this.state.recipient.organization&&_this.state.recipient.organization.name?Object(__WEBPACK_IMPORTED_MODULE_25__lib_utils__["t" /* getOrgDisplayName */])(_this.state.recipient.organization.institutionTitleId,_this.state.recipient.organization.name,_this.state.recipient.isIsraeli):Object(__WEBPACK_IMPORTED_MODULE_25__lib_utils__["q" /* getIndividualDisplayName */])(_this.state.recipient.personTitleId,_this.state.recipient.firstName,_this.state.recipient.lastName,_this.state.recipient.isIsraeli),addressDisplay:Object(__WEBPACK_IMPORTED_MODULE_25__lib_utils__["b" /* concatenateAddressLabel */])(_this.state.recipient.address)})});}if(_this.props.createApplication.message){if(_this.props.createApplication.message.toLowerCase().indexOf("60 days")>=0){_this.toggleModal("warning");}else if(_this.props.createApplication.message.toLowerCase().indexOf('check number assigned')>=0){_this.toggleModal("checkExistsWarningModal");}else if(_this.props.createApplication.message.toLowerCase().indexOf("available")>=0){_this.setState({manualCheckError:true,manualCheckLabel:'',application:Object.assign({},_this.state.application,{paymentInfo:Object.assign({},_this.state.application.paymentInfo,{manualPayment:{blankCheckId:null,manualPaymentType:null,manualPaymentNumber:null,manualPaymentDate:null,manualPaymentAmount:null}})})});}else if(_this.props.createApplication.message.toLowerCase().indexOf('teudat')>=0){_this.setState({teudatZehutError:true});}}else{_this.setState({error:true});}}_context2.next=11;break;case 10:if(!_this.state.submitAttempted)_this.setState({submitAttempted:true});case 11:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.getRequiredFields=function(){var _this$state=_this.state,recipient=_this$state.recipient,application=_this$state.application;var requiredFields=[];if(application.paymentInfo.manualPayment&&application.paymentInfo.manualPayment.manualPaymentType&&!recipient.id){if(recipient.applicantType===__WEBPACK_IMPORTED_MODULE_24__lib_systemVariables__["l" /* RecipientTypes */].Individual){if(!recipient.lastName)requiredFields.push('Last Name');}else{if(!recipient.organization.name)requiredFields.push('Organization Name');}}else{if(!application.approverId)requiredFields.push("Approver");if(!application.paymentInfo.fundId)requiredFields.push("Fund");if(_this.state.setTrustedPayee&&!recipient.trustedPayee)requiredFields.push("Trusted Payee");if(!recipient.id){if(recipient.applicantType===__WEBPACK_IMPORTED_MODULE_24__lib_systemVariables__["l" /* RecipientTypes */].Individual&&!recipient.firstName&&!recipient.lastName&&!recipient.phoneNumber&&!recipient.secondPhoneNumber&&Object(__WEBPACK_IMPORTED_MODULE_25__lib_utils__["w" /* isEmptyObj */])(recipient.address))requiredFields.push("one or more of the following: First Name, Last Name, Phone number, Address");else if(recipient.applicantType===__WEBPACK_IMPORTED_MODULE_24__lib_systemVariables__["l" /* RecipientTypes */].Organization&&!recipient.organization.name&&!recipient.phoneNumber&&!recipient.secondPhoneNumber&&Object(__WEBPACK_IMPORTED_MODULE_25__lib_utils__["w" /* isEmptyObj */])(recipient.address))requiredFields.push("one or more of the following: Organization name, Phone number, Address");}}return requiredFields;};_this.getIncompleteFields=function(){var incompleteFields={recipientInfo:[],applicationInfo:[],paymentInfo:[]};var _this$state2=_this.state,application=_this$state2.application,recipient=_this$state2.recipient;//if manual payment only require manual payment fields and last name
if(application.paymentInfo.manualPayment&&application.paymentInfo.manualPayment.manualPaymentType){if(!application.paymentInfo.manualPayment.manualPaymentAmount||!application.paymentInfo.manualPayment.manualPaymentDate||!application.paymentInfo.manualPayment.manualPaymentNumber){incompleteFields.paymentInfo.push('Incomplete Manual Payment Information');}if(!recipient.id){if(recipient.applicantType===__WEBPACK_IMPORTED_MODULE_24__lib_systemVariables__["l" /* RecipientTypes */].Individual){if(!recipient.lastName)incompleteFields.recipientInfo.push('Last Name');}else{if(!recipient.organization.name)incompleteFields.recipientInfo.push('Name');}}}else{//recipient info
if(!recipient.id){if(recipient.isIsraeli){if(recipient.applicantType===__WEBPACK_IMPORTED_MODULE_24__lib_systemVariables__["l" /* RecipientTypes */].Individual){if(!recipient.teudatZehut)incompleteFields.recipientInfo.push('Teudat Zehut');}if(!recipient.trustedPayee){if(!recipient.bankRoutingNumber)incompleteFields.recipientInfo.push('Bank Number');if(!recipient.bankBranchNumber)incompleteFields.recipientInfo.push('Branch Number');if(!recipient.bankAccountNumber)incompleteFields.recipientInfo.push('Account Number');}}if(recipient.applicantType===__WEBPACK_IMPORTED_MODULE_24__lib_systemVariables__["l" /* RecipientTypes */].Individual){if(!recipient.firstName)incompleteFields.recipientInfo.push('First Name');if(!recipient.lastName)incompleteFields.recipientInfo.push('Last Name');}else{if(!recipient.organization.name)incompleteFields.recipientInfo.push('Name');if(recipient.organization.registered&&!recipient.organization.taxId)incompleteFields.recipientInfo.push('Tax ID');}if(!recipient.tags.length)incompleteFields.recipientInfo.push('Categories');if(!recipient.address.streetNumber||!recipient.address.street||!recipient.address.city||!recipient.address.country)incompleteFields.recipientInfo.push('Address is Incomplete');}// application info:
if(!application.reasonId)incompleteFields.applicationInfo.push('Reason');if(!application.approverId)incompleteFields.applicationInfo.push('Approver');//paymentInfo:
if(!application.paymentInfo.fundId)incompleteFields.paymentInfo.push('Fund');var thirdParty=application.paymentInfo.thirdParty;if(application.paymentInfo.payTo===__WEBPACK_IMPORTED_MODULE_23__lib_constants__["e" /* PayeeTypes */].ThirdParty){if(_this.state.thirdPartyPayeeType===__WEBPACK_IMPORTED_MODULE_23__lib_constants__["i" /* SourceTypes */].Reference){if(!thirdParty.referenceId)incompleteFields.paymentInfo.push('Third Party Payee');}else{if(!thirdParty.orgName&&(!thirdParty.firstName||!thirdParty.lastName))incompleteFields.paymentInfo.push('Third Party Payee Name');if(thirdParty.isIsraeli&&(!thirdParty.bankNumber||!thirdParty.branchNumber||!thirdParty.accountNumber))incompleteFields.paymentInfo.push('Third Party Payee Bank Information');else if(!thirdParty.isIsraeli&&!thirdParty.useRecipientAddress&&(!thirdParty.address.streetNumber||!thirdParty.address.street||!thirdParty.address.city||!thirdParty.address.country))incompleteFields.paymentInfo.push('Third Party Payee Address');}}}if(!incompleteFields.applicationInfo.length&&!incompleteFields.paymentInfo.length&&incompleteFields.recipientInfo.length){//only recipient is incomplete
var missingOnlyRecipientPaymentInfo=incompleteFields.recipientInfo.every(function(field){return field==='Bank Number'||field==='Branch Number'||field==='Account Number';});//missing only pymt info
var notUsingRecipientPaymentInfo=application.paymentInfo.payTo!==__WEBPACK_IMPORTED_MODULE_23__lib_constants__["e" /* PayeeTypes */].Recipient||application.paymentInfo.manualPayment&&application.paymentInfo.manualPayment.manualPaymentType;//AND not pay to recipient, or manual check pymt (so don't need recipient pymt info)
incompleteFields.incompleteApplicationDueToRecipient=!missingOnlyRecipientPaymentInfo||!notUsingRecipientPaymentInfo;}return incompleteFields.recipientInfo.length||incompleteFields.applicationInfo.length||incompleteFields.paymentInfo.length?incompleteFields:null;};var isIsraeli=_this.props.userProfile.departments.length===1&&_this.props.userProfile.departments.indexOf(__WEBPACK_IMPORTED_MODULE_24__lib_systemVariables__["g" /* Departments */].IL)>-1;_this.state={showModals:{warning:false,checkExistsWarningModal:false},navigationOnSubmission:false,submitAttempted:false,error:false,teudatZehutError:false,manualCheckError:false,manualCheckLabel:'',dataErrors:{email:false,phoneNumber:false,secondPhoneNumber:false},showEmail:false,showSecondPhone:false,showPrevAddress:false,showCareOf:false,setTrustedPayee:false,applicationSourceType:__WEBPACK_IMPORTED_MODULE_23__lib_constants__["i" /* SourceTypes */].New,thirdPartyPayeeType:__WEBPACK_IMPORTED_MODULE_23__lib_constants__["i" /* SourceTypes */].New,noSuggestions:false,recipient:{id:0,applicantType:!props.permissions.individuals?__WEBPACK_IMPORTED_MODULE_24__lib_systemVariables__["l" /* RecipientTypes */].Organization:__WEBPACK_IMPORTED_MODULE_24__lib_systemVariables__["l" /* RecipientTypes */].Individual,isIsraeli:isIsraeli,displayName:'',addressDisplay:'',title:'',firstName:'',lastName:'',reportName:'',organization:{institutionTitleId:null,name:'',registered:true,taxId:''},address:{},previousAddress:{},teudatZehut:'',phoneNumber:'',phoneType:__WEBPACK_IMPORTED_MODULE_23__lib_constants__["g" /* PhoneNumberTypes */].American,secondPhoneNumber:'',secondPhoneType:__WEBPACK_IMPORTED_MODULE_23__lib_constants__["g" /* PhoneNumberTypes */].American,email:'',bankRoutingNumber:'',bankBranchNumber:'',bankAccountNumber:'',bankAccountHolder:'',achRoutingNumber:'',achAccountNumber:'',achAccountType:'',bankAccounts:[],tags:[],note:'',references:[],solicitors:[],roshYeshivas:[],applicantPledges:[],trustedPayee:null},application:{attachments:[],paymentInfo:{manualPayment:{blankCheckId:null,manualPaymentType:null,manualPaymentNumber:null,manualPaymentDate:null,manualPaymentAmount:null},fundId:(isIsraeli?_this.props.utils.defaultIsraelFund:_this.props.utils.defaultUSFund)||'',payTo:__WEBPACK_IMPORTED_MODULE_23__lib_constants__["e" /* PayeeTypes */].Recipient,thirdParty:{referenceId:'',useRecipientAddress:false,isIsraeli:isIsraeli,firstName:'',lastName:'',orgName:'',address:{},bankNumber:'',branchNumber:'',accountNumber:'',accountHolder:'',careOf:''},checkMemo:'',reportMemo:''},isPrivate:false,reasonId:'',reasonDate:'',weddingHall:'',weddingSide:'',requestAmount:'',approverId:_this.props.userProfile.defaultApproverId||'',individualCategoryId:'',sourceId:'',note:'',cardTypeId:'',printInstructions:'',inquire:false,inquireNote:'',applicantPledgeId:''}};_this.state.initialApplication=_this.state.application;_this.state.initialRecipient=_this.state.recipient;return _this;}_createClass(CreateApplicationPage,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.match.params.recipientId)this.setRecipientDetails(this.props.match.params.recipientId);}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.props.recipientSuggestions.data.length)this.props.actions.clearRecipientSuggestions();}},{key:'onUpdateRecipientIsIsraeli',value:function onUpdateRecipientIsIsraeli(application,isIsraeli){var hasThirdParty=application.paymentInfo.payTo===__WEBPACK_IMPORTED_MODULE_23__lib_constants__["e" /* PayeeTypes */].ThirdParty&&(application.paymentInfo.thirdParty.referenceId||application.paymentInfo.thirdParty.orgName||application.paymentInfo.thirdParty.lastName);var fundId=application.paymentInfo.fundId;if((!application.paymentInfo.manualPayment||!application.paymentInfo.manualPayment.manualPaymentType)&&application.paymentInfo.payTo!==__WEBPACK_IMPORTED_MODULE_23__lib_constants__["e" /* PayeeTypes */].TrustedPayee&&!hasThirdParty){fundId=isIsraeli?this.props.utils.defaultIsraelFund:this.props.utils.defaultUSFund;//don't reset fundId if manual check, pay to trusted payee, or has third party
}application=isIsraeli?Object.assign({},application,{printInstructions:'',cardTypeId:'',paymentInfo:Object.assign({},application.paymentInfo,{checkMemo:'',reportMemo:'',fundId:fundId})}):Object.assign({},application,{paymentInfo:Object.assign({},application.paymentInfo,{fundId:fundId})});if(!hasThirdParty)//if no third party, default third party isIsraeli to recipient isIsraeli
application.paymentInfo.thirdParty=Object.assign({},application.paymentInfo.thirdParty,{isIsraeli:isIsraeli});return application;}},{key:'onUpdateRecipientType',value:function onUpdateRecipientType(application){return Object.assign({},application,{reasonId:null});}},{key:'onClearRecipientAddress',value:function onClearRecipientAddress(application){if(application.paymentInfo.thirdParty.useRecipientAddress){this.onChange('showCareOf',false);application.paymentInfo.thirdParty=Object.assign({},application.paymentInfo.thirdParty,{useRecipientAddress:false,careOf:''});}return application;}},{key:'onUpdateRecipientTrustedPayee',value:function onUpdateRecipientTrustedPayee(application,trustedPayee){var _state=this.state,recipient=_state.recipient,initialApplication=_state.initialApplication;var hasThirdParty=application.paymentInfo.payTo===__WEBPACK_IMPORTED_MODULE_23__lib_constants__["e" /* PayeeTypes */].ThirdParty&&(application.paymentInfo.thirdParty.referenceId||application.paymentInfo.thirdParty.orgName||application.paymentInfo.thirdParty.lastName);if(!trustedPayee&&application.paymentInfo.payTo===__WEBPACK_IMPORTED_MODULE_23__lib_constants__["e" /* PayeeTypes */].TrustedPayee){//cleared out trusted payee, and payTo is set to trustedPayee
application.paymentInfo=Object.assign({},application.paymentInfo,{payTo:__WEBPACK_IMPORTED_MODULE_23__lib_constants__["e" /* PayeeTypes */].Recipient},recipient.isIsraeli!==(recipient.trustedPayee||{}).isIsraeli?{fundId:recipient.isIsraeli?this.props.utils.defaultIsraelFund:this.props.utils.defaultUSFund}:{});}else if(trustedPayee&&!hasThirdParty){//set trusted payee, and no third party info filled in
var prevPayee=Object(__WEBPACK_IMPORTED_MODULE_25__lib_utils__["p" /* getApplicationPayee */])(application.paymentInfo,recipient);application.paymentInfo=Object.assign({},application.paymentInfo,{payTo:__WEBPACK_IMPORTED_MODULE_23__lib_constants__["e" /* PayeeTypes */].TrustedPayee,thirdParty:Object.assign({},initialApplication.paymentInfo.thirdParty,{isIsraeli:recipient.isIsraeli})},trustedPayee.isIsraeli!==prevPayee.isIsraeli?{fundId:trustedPayee.isIsraeli?this.props.utils.defaultIsraelFund:this.props.utils.defaultUSFund}:{});}return application;}},{key:'onRemoveRecipientReferences',value:function onRemoveRecipientReferences(application,removedReferenceIds,referencesCount){var _state2=this.state,recipient=_state2.recipient,initialApplication=_state2.initialApplication,applicationSourceType=_state2.applicationSourceType,thirdPartyPayeeType=_state2.thirdPartyPayeeType;if(applicationSourceType===__WEBPACK_IMPORTED_MODULE_23__lib_constants__["i" /* SourceTypes */].Reference){if(!referencesCount)this.onChange('applicationSourceType',__WEBPACK_IMPORTED_MODULE_23__lib_constants__["i" /* SourceTypes */].New);if(removedReferenceIds.indexOf(application.sourceId.toString())>=0)application.sourceId=null;}if(application.paymentInfo.payTo===__WEBPACK_IMPORTED_MODULE_23__lib_constants__["e" /* PayeeTypes */].ThirdParty&&thirdPartyPayeeType===__WEBPACK_IMPORTED_MODULE_23__lib_constants__["i" /* SourceTypes */].Reference){if(!referencesCount)this.onChange('thirdPartyPayeeType',__WEBPACK_IMPORTED_MODULE_23__lib_constants__["i" /* SourceTypes */].New);if(removedReferenceIds.indexOf(application.paymentInfo.thirdParty.referenceId.toString())>=0){application.paymentInfo=Object.assign({},application.paymentInfo,recipient.isIsraeli!==application.paymentInfo.thirdParty.isIsraeli//reset fund to default for recipient nationality if isIsraeli of prev reference does not match recipient
?{fundId:recipient.isIsraeli?this.props.utils.defaultIsraelFund:this.props.utils.defaultUSFund}:{},{thirdParty:Object.assign({},initialApplication.paymentInfo.thirdParty,{isIsraeli:recipient.isIsraeli})});this.onChange('showCareOf',false);}}return application;}},{key:'render',value:function render(){var _this3=this;var _state3=this.state,application=_state3.application,recipient=_state3.recipient,dataErrors=_state3.dataErrors,submitAttempted=_state3.submitAttempted,initialApplication=_state3.initialApplication,initialRecipient=_state3.initialRecipient,applicationSourceType=_state3.applicationSourceType,thirdPartyPayeeType=_state3.thirdPartyPayeeType,showCareOf=_state3.showCareOf;var _props=this.props,tags=_props.tags,utils=_props.utils;var payee=Object(__WEBPACK_IMPORTED_MODULE_25__lib_utils__["p" /* getApplicationPayee */])(application.paymentInfo,recipient);var formIsDirty=!Object(__WEBPACK_IMPORTED_MODULE_25__lib_utils__["e" /* deepEquals */])(application,initialApplication)||!Object(__WEBPACK_IMPORTED_MODULE_25__lib_utils__["e" /* deepEquals */])(recipient,initialRecipient);var isApprover=this.props.permissions.applications.approve;var isAdmin=this.props.permissions.admin;var requiredFields=this.getRequiredFields();var requiredFieldsMessage=formIsDirty&&requiredFields.length?'Please complete the following required field'+(requiredFields.length>1?"s":"")+': '+requiredFields.join(', ')+'.':'';var incompleteFields=this.getIncompleteFields(this.state.recipient);var errorMessage=this.state.manualCheckError?'The selected manual check number is not available.  Please select a different check number.':this.state.recipient.id?'Something went wrong and the application could not be created.  Please try again.':this.state.teudatZehutError?'The specified teudat zehut is already in use.  Please enter a unique teudat zehut.':'Something went wrong and the recipient and application could not be created.  Please try again.';return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'application-create'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* Prompt */],{when:!this.state.navigationOnSubmission&&formIsDirty,message:'All unsaved changes will be lost if you leave this page.  Are you sure you want to proceed?'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'subheader'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container application-create-subheader'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'page-header'},'Create Application'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'back-link'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-android-arrow-back middle medium-text'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:'/applications',className:'link-text small-text'},'Back to Applications')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container application-create-content'},this.props.recipientDetails.loading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'spinner-background'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'32'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'application-create-top'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__CreateRecipient__["a" /* default */],{tags:{usPersonTitles:utils.usPersonTitles,israelPersonTitles:utils.israelPersonTitles,usInstitutionTitles:utils.usInstitutionTitles,israelInstitutionTitles:utils.israelInstitutionTitles,recipientTypes:!this.props.permissions.individuals?utils.recipientTypes.filter(function(type){return type.value===__WEBPACK_IMPORTED_MODULE_24__lib_systemVariables__["l" /* RecipientTypes */].Individual;}):!this.props.permissions.institutions?utils.recipientTypes.filter(function(type){return type.value===__WEBPACK_IMPORTED_MODULE_24__lib_systemVariables__["l" /* RecipientTypes */].Organization;}):utils.recipientTypes,categories:{individualTags:utils.individualTags,organizationTags:utils.organizationTags}},departments:this.props.userProfile.departments,submitAttempted:submitAttempted,recipient:recipient,isManualPayment:application.paymentInfo.manualPayment&&application.paymentInfo.manualPayment.manualPaymentType,dataErrors:dataErrors,updateDataErrors:this.updateDataErrors,toggleModal:this.toggleModal,onChange:this.onChange,onSelectRecipientSuggestion:this.setRecipientDetails,suggestions:{suggestions:this.props.recipientSuggestions.data,getSuggestions:this.props.actions.getRecipientSuggestions,clearSuggestions:this.props.actions.clearRecipientSuggestions},showSecondPhone:this.state.showSecondPhone,showEmail:this.state.showEmail,showPrevAddress:this.state.showPrevAddress,setTrustedPayee:this.state.setTrustedPayee,allowIncomplete:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__PaymentInfo__["a" /* default */],{submitAttempted:submitAttempted,paymentInfo:application.paymentInfo,manageAccounting:this.props.permissions.accounting.manage,payeeIsIsraeli:payee.isIsraeli,initialThirdParty:Object.assign({},initialApplication.paymentInfo.thirdParty,{isIsraeli:recipient.isIsraeli}),trustedPayee:recipient.trustedPayee,onChange:this.onChange,updateApplication:this.updateApplication,updatePaymentInfo:this.updatePaymentInfo,funds:payee.isIsraeli&&(!application.paymentInfo.manualPayment||!application.paymentInfo.manualPayment.manualPaymentType)?tags.israelFunds:tags.usFunds,defaultUSFund:utils.defaultUSFund,defaultIsraeliFund:utils.defaultIsraelFund,blankChecks:this.props.blankChecks,getBlankChecks:this.props.actions.getBlankChecks,manualCheckLabel:this.state.manualCheckLabel,manualPaymentTypes:utils.manualPaymentTypes,thirdPartyPayeeType:thirdPartyPayeeType,showCareOf:showCareOf,recipientReferences:recipient.references.filter(function(ref){return ref.isPayable;}),recipientAddress:!recipient.isIsraeli&&!dataErrors.recipientAddress&&recipient.address.street?Object(__WEBPACK_IMPORTED_MODULE_25__lib_utils__["b" /* concatenateAddressLabel */])(recipient.address):'',recipientTypes:utils.recipientTypes})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__CreateApplication__["a" /* default */],{permissions:this.props.permissions.applications,tags:{applicationReasons:recipient.applicantType===__WEBPACK_IMPORTED_MODULE_24__lib_systemVariables__["l" /* RecipientTypes */].Organization?utils.organizationApplicationReasons:utils.individualApplicationReasons,approvers:tags.approvers,references:tags.references,campaignIndivCategories:utils.campaignIndivCategories},payeeIsIsraeli:payee.isIsraeli,submitAttempted:submitAttempted,updateApplication:this.updateApplication,application:application,applicationSourceType:applicationSourceType,toggleSourceType:function toggleSourceType(name,value){_this3.onChange(name,value);_this3.updateApplication("sourceId",'');},recipientReferences:recipient.references,recipientPledges:recipient.applicantPledges,isManualPayment:application.paymentInfo.manualPayment&&application.paymentInfo.manualPayment.manualPaymentType,toggleModal:this.toggleModal}),!payee.isIsraeli&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PrintInfo__["a" /* default */],{cardTypes:utils.cardTypes,selectedCardType:application.cardTypeId,updateApplication:this.updateApplication,printInstructions:application.printInstructions}),(isApprover||isAdmin)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__applicationsCommon_MarkInquiry__["a" /* default */],{inquire:application.inquire,inquireNote:application.inquireNote,updateApplication:this.updateApplication}),submitAttempted&&incompleteFields&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__commonComponents_shared_IncompleteApplicationWarning__["a" /* default */],{fields:incompleteFields,allowIncomplete:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__CreateCancelButtons__["a" /* default */],{save:this.save,disabled:Object.keys(this.state.dataErrors).some(function(k){return _this3.state.dataErrors[k];}).length>0||requiredFields.length>0,disabledMessage:requiredFields.length>0?requiredFieldsMessage:'',loading:this.props.createApplication.loading,show:this.state.error||this.state.manualCheckError||this.state.teudatZehutError,message:errorMessage,cancel:function cancel(){return _this3.setState({navigationOnSubmission:true},function(){return _this3.pushRoute('/applications');});}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__commonComponents_shared_WarningModal__["a" /* default */],{show:this.state.showModals.warning,message:'This recipient has received a check in the past 60 days.',close:function close(){return _this3.toggleModal("warning");},'continue':function _continue(){return _this3.save(true);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__CheckExistsWarningModal__["a" /* default */],{transactions:this.props.createApplication.data,message:this.props.createApplication.message,show:this.state.showModals.checkExistsWarningModal,close:function close(){return _this3.toggleModal("checkExistsWarningModal");},'continue':function _continue(){return _this3.save(true);}}));}}]);return CreateApplicationPage;}(__WEBPACK_IMPORTED_MODULE_12__commonComponents_util_NavigationComponent__["a" /* default */]);function mapStateToProps(state){return Object.assign({recipientDetails:state.recipientAccountDetails.recipientDetails,createApplication:state.createApplication.createApplication,blankChecks:state.fundDetails.blankChecks,userProfile:{departments:state.userProfile.profile.data?state.userProfile.profile.data.departments:[],defaultApproverId:state.userProfile.profile.data.defaultApproverId||''},permissions:{applications:{manage:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_24__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsManage)>=0,private:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_24__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsPrivate)>=0,approve:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_24__lib_systemVariables__["j" /* PermissionTypes */].ApproveFullApplications)>=0||state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_24__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsApproveLimited)>=0},accounting:{manage:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_24__lib_systemVariables__["j" /* PermissionTypes */].AccountingManage)>=0},individuals:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_24__lib_systemVariables__["j" /* PermissionTypes */].IndividualsManage)>=0,institutions:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_24__lib_systemVariables__["j" /* PermissionTypes */].InstitutionsManage)>=0,admin:state.userProfile.profile.data.roleId===1},utils:{defaultUSFund:state.settings.systemSettings.data.fundSettings.defaultUSFund||'',defaultIsraelFund:state.settings.systemSettings.data.fundSettings.defaultIsraelFund||'',recipientTypes:state.settings.systemSettings.data.otherSettings.recipientTypes,individualTags:state.settings.systemSettings.data.recipientSettings.individualTags,organizationTags:state.settings.systemSettings.data.recipientSettings.organizationTags,nationalities:state.settings.systemSettings.data.otherSettings.nationalities,cities:state.settings.systemSettings.data.otherSettings.cities,cardTypes:state.settings.systemSettings.data.printSettings.cardTypes,individualApplicationReasons:state.settings.systemSettings.data.applicationSettings.individualApplicationReasons,organizationApplicationReasons:state.settings.systemSettings.data.applicationSettings.organizationApplicationReasons,usPersonTitles:state.settings.systemSettings.data.recipientSettings.usPersonTitles,israelPersonTitles:state.settings.systemSettings.data.recipientSettings.israelPersonTitles,usInstitutionTitles:state.settings.systemSettings.data.recipientSettings.usInstitutionTitles,israelInstitutionTitles:state.settings.systemSettings.data.recipientSettings.israelInstitutionTitles,campaignIndivCategories:state.settings.systemSettings.data.campaignSettings.campaignIndivCategories,manualPaymentTypes:state.settings.systemSettings.data.otherSettings.manualPaymentTypes},tags:{campaigns:state.campaigns.campaigns.data,organizations:state.recipientAccounts.organizations.data,approvers:state.users.approvers.data,references:state.references.references.data,israelFunds:state.funds.fundsByDept.activeIL,usFunds:state.funds.fundsByDept.activeUS}},state.suggestions);}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(Object.assign({},__WEBPACK_IMPORTED_MODULE_7__redux_actions_CreateApplicationActions__,__WEBPACK_IMPORTED_MODULE_8__redux_actions_SuggestionsActions__,{getRecipientAccountDetails:__WEBPACK_IMPORTED_MODULE_11__redux_actions_RecipientAccountsActions__["getRecipientAccountDetails"],getTags:__WEBPACK_IMPORTED_MODULE_10__redux_actions_SettingsActions__["getTags"],getSystemSettings:__WEBPACK_IMPORTED_MODULE_10__redux_actions_SettingsActions__["getSystemSettings"],getOrganizations:__WEBPACK_IMPORTED_MODULE_11__redux_actions_RecipientAccountsActions__["getOrganizations"],getBlankChecks:__WEBPACK_IMPORTED_MODULE_9__redux_actions_FundsActions__["getBlankChecks"]}),dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CreateApplicationPage));

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["createApplication"] = createApplication;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_apiUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RecipientAccountsActions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_recipientSummaryCache__ = __webpack_require__(42);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function createApplication(recipient,application){var _this=this;var bypass=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var recipientObj={applicantType:recipient.applicantType,isIsraeli:recipient.isIsraeli,personTitleId:recipient.personTitleId,firstName:recipient.firstName,lastName:recipient.lastName,reportName:recipient.reportName,organization:recipient.organization,address:recipient.address,previousAddress:recipient.previousAddress,phoneNumber:recipient.phoneNumber,phoneType:recipient.phoneType,secondPhoneNumber:recipient.secondPhoneNumber,secondPhoneType:recipient.secondPhoneType,email:recipient.email,teudatZahut:recipient.teudatZehut,bankRoutingNumber:recipient.bankRoutingNumber,bankBranchNumber:recipient.bankBranchNumber,bankAccountNumber:recipient.bankAccountNumber,bankAccountHolder:recipient.bankAccountHolder,tags:recipient.tags,note:recipient.note,trustedPayeeId:recipient.trustedPayeeId,references:recipient.references,solicitors:recipient.solicitors,roshYeshivas:recipient.roshYeshivas,applicantPledges:recipient.applicantPledges};if(recipient.id)recipientObj.id=recipient.id;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var recipResponse,formData,flatObj,prop,url,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["START_CREATE_APPLICATION"]});recipResponse=void 0;if(recipient.id){_context.next=14;break;}_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_3__lib_apiUtils__["d" /* postRequest */])('/recipients',recipientObj,{});case 5:recipResponse=_context.sent;if(recipResponse.success){_context.next=11;break;}dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CREATE_APPLICATION"],response:recipResponse});return _context.abrupt('return');case 11:application.recipientId=recipResponse.data;case 12:_context.next=15;break;case 14:application.recipientId=recipient.id;case 15:formData=new FormData();flatObj=Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["h" /* flattenObj */])(application);for(prop in flatObj){formData.append(prop,flatObj[prop]!==null?flatObj[prop]:'');}application.attachments.map(function(attachment){return formData.append('attachments',attachment);});url=bypass===true?'/applications?bypassError='+bypass:'/applications';_context.next=22;return Object(__WEBPACK_IMPORTED_MODULE_3__lib_apiUtils__["d" /* postRequest */])(url,formData,{'Content-Type':'multipart/form-data'},{});case 22:response=_context.sent;if(response.success)Object(__WEBPACK_IMPORTED_MODULE_6__lib_recipientSummaryCache__["a" /* clearRecipientSummaryCache */])(application.recipientId);dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["CREATE_APPLICATION"],response:Object.assign({},response,{id:application.recipientId})});if(response.success&&recipient.applicantType===__WEBPACK_IMPORTED_MODULE_5__lib_systemVariables__["l" /* RecipientTypes */].Organization)dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__RecipientAccountsActions__["getOrganizations"])());case 26:case'end':return _context.stop();}}},_callee,_this);}));return function(_x2){return _ref.apply(this,arguments);};}();}

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* istanbul ignore next */
/**
 * Default values
 */
exports.default = {
  fixtures: [],
  maxFixtures: 10,
  initialValue: '',
  placeholder: 'Search places',
  disabled: false,
  className: '',
  inputClassName: '',
  location: null,
  radius: null,
  bounds: null,
  country: null,
  types: null,
  queryDelay: 250,
  googleMaps: null,
  highlightMatch: true,
  onActivateSuggest: function onActivateSuggest() {},
  onSuggestSelect: function onSuggestSelect() {},
  onSuggestNoResults: function onSuggestNoResults() {},
  onUpdateSuggests: function onUpdateSuggests() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  skipSuggest: function skipSuggest() {},
  getSuggestLabel: function getSuggestLabel(suggest) {
    return suggest.description;
  },
  renderSuggestItem: null,
  autoActivateFirstSuggest: false,
  style: {
    'input': {},
    'suggests': {},
    'suggestItem': {}
  },
  ignoreTab: false,
  minLength: 1
};

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Prop Types
 */
exports.default = {
  fixtures: _propTypes2.default.array,
  maxFixtures: _propTypes2.default.number,
  initialValue: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  inputClassName: _propTypes2.default.string,
  suggestsClassName: _propTypes2.default.string,
  suggestsHiddenClassName: _propTypes2.default.string,
  suggestItemClassName: _propTypes2.default.string,
  suggestItemActiveClassName: _propTypes2.default.string,
  location: _propTypes2.default.object,
  radius: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  bounds: _propTypes2.default.object,
  country: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
  types: _propTypes2.default.array,
  queryDelay: _propTypes2.default.number,
  googleMaps: _propTypes2.default.object,
  highlightMatch: _propTypes2.default.bool,
  onSuggestSelect: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onKeyPress: _propTypes2.default.func,
  onUpdateSuggests: _propTypes2.default.func,
  skipSuggest: _propTypes2.default.func,
  getSuggestLabel: _propTypes2.default.func,
  renderSuggestItem: _propTypes2.default.func,
  autoActivateFirstSuggest: _propTypes2.default.bool,
  style: _propTypes2.default.shape({
    input: _propTypes2.default.object,
    suggests: _propTypes2.default.object,
    suggestItem: _propTypes2.default.object
  }),
  ignoreTab: _propTypes2.default.bool,
  label: _propTypes2.default.string,
  autoComplete: _propTypes2.default.string,
  minLength: _propTypes2.default.number
};

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactAddonsShallowCompare = __webpack_require__(176);

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _classnames = __webpack_require__(38);

var _classnames2 = _interopRequireDefault(_classnames);

var _filterInputAttributes = __webpack_require__(175);

var _filterInputAttributes2 = _interopRequireDefault(_filterInputAttributes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line no-unused-vars


/**
 * The input field
 * @param {Object} props The component's props
 * @return {JSX} The icon component.
 */
var Input = function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Input);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function () {
      _this.props.onChange(_this.input.value);
    }, _this.onFocus = function () {
      _this.props.onFocus();
    }, _this.onBlur = function () {
      _this.props.onBlur();
    }, _this.onKeyPress = function (event) {
      _this.props.onKeyPress(event);
    }, _this.onInputKeyDown = function (event) {
      // eslint-disable-line complexity
      // Call props.onKeyDown if defined
      // Gives the developer a little bit more control if needed
      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event);
      }

      switch (event.which) {
        case 40:
          // DOWN
          if (!event.shiftKey) {
            event.preventDefault();
            _this.props.onNext();
          }
          break;
        case 38:
          // UP
          if (!event.shiftKey) {
            event.preventDefault();
            _this.props.onPrev();
          }
          break;
        case 13:
          // ENTER
          if (_this.props.ignoreEnter) {
            event.preventDefault();
          }

          _this.props.onSelect();
          break;
        case 9:
          // TAB
          if (!_this.props.ignoreTab) {
            _this.props.onSelect();
          }
          break;
        case 27:
          // ESC
          _this.props.onEscape();
          break;
        /* istanbul ignore next */
        default:
          break;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Input, [{
    key: 'shouldComponentUpdate',

    /**
     * Whether or not the component should update
     * @param {Object} nextProps The new properties
     * @param {Object} nextState The new state
     * @return {Boolean} Update or not?
     */
    value: function shouldComponentUpdate(nextProps, nextState) {
      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
    }

    /**
     * When the input got changed
     */


    /**
     * When the input got focused
     */


    /**
     * When the input loses focus
     */


    /**
     * When a key gets pressed in the input
     * @param  {Event} event The keypress event
     */


    /**
     * When a key gets pressed in the input
     * @param  {Event} event The keydown event
     */

  }, {
    key: 'focus',


    /**
     * Focus the input
     */
    value: function focus() {
      this.input.focus();
    }

    /**
     * Blur the input
     */

  }, {
    key: 'blur',
    value: function blur() {
      this.input.blur();
    }

    /**
     * Render the view
     * @return {Function} The React element to render
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var attributes = (0, _filterInputAttributes2.default)(this.props),
          classes = (0, _classnames2.default)('geosuggest__input', this.props.className);

      return _react2.default.createElement('input', _extends({ className: classes,
        ref: function ref(i) {
          return _this2.input = i;
        },
        type: 'text'
      }, attributes, {
        value: this.props.value,
        style: this.props.style,
        onKeyDown: this.onInputKeyDown,
        onChange: this.onChange,
        onKeyPress: this.onKeyPress,
        onFocus: this.onFocus,
        onBlur: this.onBlur }));
    }
  }]);

  return Input;
}(_react2.default.Component);

/**
 * Default values for the properties
 * @type {Object}
 */


Input.defaultProps = {
  className: '',
  value: '',
  ignoreTab: false,
  onKeyDown: function onKeyDown() {},
  onKeyPress: function onKeyPress() {},
  autoComplete: 'off'
};

exports.default = Input;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactAddonsShallowCompare = __webpack_require__(176);

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _classnames2 = __webpack_require__(38);

var _classnames3 = _interopRequireDefault(_classnames2);

var _suggestItem = __webpack_require__(479);

var _suggestItem2 = _interopRequireDefault(_suggestItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line no-unused-vars


/**
 * The list with suggestions. Either from an API or provided as fixture
 * @param {Object} props The component's props
 * @return {JSX} The icon component.
 */
var SuggestList = function (_React$Component) {
  _inherits(SuggestList, _React$Component);

  function SuggestList() {
    _classCallCheck(this, SuggestList);

    return _possibleConstructorReturn(this, (SuggestList.__proto__ || Object.getPrototypeOf(SuggestList)).apply(this, arguments));
  }

  _createClass(SuggestList, [{
    key: 'shouldComponentUpdate',

    /**
     * Whether or not the component should update
     * @param {Object} nextProps The new properties
     * @param {Object} nextState The new state
     * @return {Boolean} Update or not?
     */
    value: function shouldComponentUpdate(nextProps, nextState) {
      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
    }

    /**
     * Whether or not it is hidden
     * @return {Boolean} Hidden or not?
     */

  }, {
    key: 'isHidden',
    value: function isHidden() {
      return this.props.isHidden || this.props.suggests.length === 0;
    }

    /**
     * There are new properties available for the list
     * @param {Object} nextProps The new properties
     */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.suggests !== this.props.suggests) {
        if (nextProps.suggests.length === 0) {
          this.props.onSuggestNoResults();
        }
      }
    }

    /**
     * Render the view
     * @return {Function} The React element to render
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var classes = (0, _classnames3.default)('geosuggest__suggests', this.props.suggestsClassName, { 'geosuggest__suggests--hidden': this.isHidden() }, _defineProperty({}, this.props.hiddenClassName, this.props.hiddenClassName ? this.isHidden() : null));

      return _react2.default.createElement(
        'ul',
        { className: classes, style: this.props.style },
        this.props.suggests.map(function (suggest) {
          var isActive = _this2.props.activeSuggest && suggest.placeId === _this2.props.activeSuggest.placeId,
              key = suggest.key || suggest.placeId;

          return _react2.default.createElement(_suggestItem2.default, { key: key,
            className: suggest.className,
            userInput: _this2.props.userInput,
            isHighlightMatch: _this2.props.isHighlightMatch,
            suggest: suggest,
            style: _this2.props.suggestItemStyle,
            suggestItemClassName: _this2.props.suggestItemClassName,
            isActive: isActive,
            activeClassname: _this2.props.suggestItemActiveClassName,
            onMouseDown: _this2.props.onSuggestMouseDown,
            onMouseOut: _this2.props.onSuggestMouseOut,
            onSelect: _this2.props.onSuggestSelect,
            renderSuggestItem: _this2.props.renderSuggestItem });
        })
      );
    }
  }]);

  return SuggestList;
}(_react2.default.Component);

/**
 * Default values for the properties
 * @type {Object}
 */


exports.default = SuggestList;
SuggestList.defaultProps = {
  isHidden: true,
  suggests: []
};

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(38);

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A single Geosuggest item in the list
 * @param {Object} props The component's props
 * @return {JSX} The icon component.
 */
var SuggestItem = function (_React$Component) {
  _inherits(SuggestItem, _React$Component);

  function SuggestItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SuggestItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SuggestItem.__proto__ || Object.getPrototypeOf(SuggestItem)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (event) {
      event.preventDefault();
      _this.props.onSelect(_this.props.suggest);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SuggestItem, [{
    key: 'makeBold',

    /**
     * Makes a text bold
     * @param {String} element The element to wrap
     * @param {String} key The key to set on the element
     * @return {JSX} Bolder text
     */
    value: function makeBold(element, key) {
      return _react2.default.createElement(
        'b',
        { className: 'geosuggest__item__matched-text', key: key },
        element
      );
    }

    /**
     * Replace matched text with the same bold
     * @param {Object} userInput Value from input
     * @param {Object} suggest Data from google
     * @return {String} Formatted string with highlighted matched text
     */

  }, {
    key: 'formatMatchedText',
    value: function formatMatchedText(userInput, suggest) {
      if (!userInput || !suggest.matchedSubstrings) {
        return suggest.label;
      }

      var start = suggest.matchedSubstrings.offset,
          length = suggest.matchedSubstrings.length,
          end = start + length,
          boldPart = this.makeBold(suggest.label.substring(start, end), suggest.label);

      var pre = '',
          post = '';

      if (start > 0) {
        pre = suggest.label.slice(0, start);
      }
      if (end < suggest.label.length) {
        post = suggest.label.slice(end);
      }

      return _react2.default.createElement(
        'span',
        null,
        pre,
        boldPart,
        post
      );
    }

    /**
     * Checking if item just became active and scrolling if needed.
     * @param {Object} nextProps The new properties
     */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isActive && !this.props.isActive) {
        this.scrollIfNeeded();
      }
    }

    /**
     * Scrolling current item to the center of the list if item needs scrolling.
     * Item is scrolled to the center of the list.
     */

  }, {
    key: 'scrollIfNeeded',
    value: function scrollIfNeeded() {
      var el = this.ref,
          parent = el.parentElement,
          overTop = el.offsetTop - parent.offsetTop < parent.scrollTop,
          overBottom = el.offsetTop - parent.offsetTop + el.clientHeight > parent.scrollTop + parent.clientHeight;

      if (overTop || overBottom) {
        parent.scrollTop = el.offsetTop - parent.offsetTop - parent.clientHeight / 2 + el.clientHeight / 2;
      }
    }

    /**
     * When the suggest item got clicked
     * @param {Event} event The click event
     */

  }, {
    key: 'render',


    /**
     * Render the view
     * @return {Function} The React element to render
     */
    value: function render() {
      var _this2 = this;

      var suggest = this.props.suggest,
          classes = (0, _classnames3.default)('geosuggest__item', this.props.className, this.props.suggestItemClassName, { 'geosuggest__item--active': this.props.isActive }, _defineProperty({}, this.props.activeClassname, this.props.activeClassname ? this.props.isActive : null));

      var content = suggest.label;

      if (this.props.renderSuggestItem) {
        content = this.props.renderSuggestItem(suggest);
      } else if (this.props.isHighlightMatch) {
        content = this.formatMatchedText(this.props.userInput, suggest);
      }

      return _react2.default.createElement(
        'li',
        { className: classes,
          ref: function ref(li) {
            return _this2.ref = li;
          },
          style: this.props.style,
          onMouseDown: this.props.onMouseDown,
          onMouseOut: this.props.onMouseOut,
          onClick: this.onClick },
        content
      );
    }
  }]);

  return SuggestItem;
}(_react2.default.Component);

/**
 * Default values for the properties
 * @type {Object}
 */


exports.default = SuggestItem;
SuggestItem.defaultProps = {
  isActive: false,
  className: '',
  suggest: {}
};

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_AutocompleteInput__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ManualAddressComponent__ = __webpack_require__(481);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddressModal=function(_React$Component){_inherits(AddressModal,_React$Component);function AddressModal(props){_classCallCheck(this,AddressModal);var _this=_possibleConstructorReturn(this,(AddressModal.__proto__||Object.getPrototypeOf(AddressModal)).call(this,props));_this.update=function(name){return function(value){_this.setState({address:Object.assign({},_this.state.address,_defineProperty({},name,value))});};};_this.onChange=_this.onChange.bind(_this);_this.cancelClick=_this.cancelClick.bind(_this);_this.saveClick=_this.saveClick.bind(_this);_this.validate=_this.validate.bind(_this);_this.update=_this.update.bind(_this);_this.state={error:false,address:{streetNumber:'',street:'',apartment:'',unitType:'',city:'',state:'',zip:'',country:''}};return _this;}_createClass(AddressModal,[{key:'validateZip',value:function validateZip(value){var isValid=Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["E" /* validateFieldLength */])(5,value);this.setState({error:!isValid});return isValid;}},{key:'updateZip',value:function updateZip(values){this.setState({address:Object.assign({},this.state.address,{zip:values.value})});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["e" /* deepEquals */])(this.state.address,nextProps.address)){this.setState({address:{streetNumber:nextProps.address.streetNumber||'',street:nextProps.address.street||'',apartment:nextProps.address.apartment||'',unitType:nextProps.address.unitType||'',city:nextProps.address.city||'',state:nextProps.address.state||'',zip:nextProps.address.zip||'',country:nextProps.address.country||''}});}}},{key:'validate',value:function validate(){var address=_objectWithoutProperties(this.props.address,[]);delete address.isManual;if(this.state.error)return true;var allValuesEmpty=!this.state.address.streetNumber&&!this.state.address.street&&!this.state.address.apartment&&!this.state.address.state&&!this.state.address.city&&!this.state.address.zip&&!this.state.address.country&&!this.state.address.unitType;if(this.props.address.streetNumber||this.props.address.street||this.props.address.apartment||this.props.address.city||this.props.address.state||this.props.address.zip||this.props.address.country)return Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["e" /* deepEquals */])(address,this.state.address)||allValuesEmpty;else return allValuesEmpty;}},{key:'cancelClick',value:function cancelClick(){this.setState({address:{streetNumber:'',street:'',apartment:'',unitType:'',city:'',state:'',zip:'',country:''}});this.props.closeModal();}},{key:'saveClick',value:function saveClick(){this.props.saveAddress(this.state.address);}},{key:'onChange',value:function onChange(e){this.setState({address:Object.assign({},this.state.address,_defineProperty({},e.target.name,e.target.value))});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__util_Modal__["a" /* default */],{modalShowing:this.props.modalShowing},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal large-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-header'},'Address Not Found'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.cancelClick})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'streetNumber',className:'input-label'},'Street Number ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'*')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.state.address.streetNumber,name:'streetNumber',onChange:this.onChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__util_AutocompleteInput__["a" /* default */],{overridable:true,placeholder:'Search street names',title:'Street *',name:'street',value:this.state.address.street,options:this.props.streetNames.map(function(s){return{key:s,value:s};}),update:function update(name,val){return _this2.setState({address:Object.assign({},_this2.state.address,_defineProperty({},name,val))});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Unit Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__util_Select__["a" /* default */],{clearable:true,options:this.props.unitTypes,name:'unitType',value:this.state.address.unitType,onChange:this.onChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'apartment',className:'input-label'},'Apartment Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'apartment',onChange:this.onChange,value:this.state.address.apartment}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ManualAddressComponent__["a" /* default */],{label:'City',type:'city',required:true,value:this.state.address.city,onChange:this.update('city')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ManualAddressComponent__["a" /* default */],{label:'State',type:'state',value:this.state.address.state,onChange:this.update('state')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'#####',maxLength:7}),onChange:function onChange(name,val){return _this2.setState({address:Object.assign({},_this2.state.address,_defineProperty({},name,val))});},label:'Zip',name:'zip',value:this.state.address.zip,errorMessage:'Invalid Zip',validated:true,showValidationError:true,validate:this.validateZip.bind(this)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ManualAddressComponent__["a" /* default */],{label:'Country',type:'country',required:true,value:this.state.address.country,onChange:this.update('country')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.cancelClick},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',disabled:this.validate(),onClick:this.saveClick},this.props.address.streetNumber||this.props.address.street||this.props.address.apartment||this.props.address.city||this.props.address.state||this.props.address.zip||this.props.address.country?'Save Changes':'Save')))));}}]);return AddressModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AddressModal);

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_geosuggest__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_geosuggest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_geosuggest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManualAddressComponent=function(_React$Component){_inherits(ManualAddressComponent,_React$Component);function ManualAddressComponent(props){_classCallCheck(this,ManualAddressComponent);var _this=_possibleConstructorReturn(this,(ManualAddressComponent.__proto__||Object.getPrototypeOf(ManualAddressComponent)).call(this,props));_this.updateLabel=function(val){if(_this.state.label!==val){_this.setState({label:val},function(){return _this.props.onChange('');});}if(!val)_this.setState({noSuggestionsError:false,invalidAddress:false});};_this.getSuggestLabel=function(suggest){return suggest.description;};_this.skipSuggest=function(suggest){var types=suggest.types||[];if(_this.props.type==='country'&&!types.includes('country'))return true;if(_this.props.type==='state'&&!types.some(function(t){return['administrative_area_level_1','political','locality','geocode'].includes(t);})){return true;}if(_this.props.type==='city'&&!types.some(function(t){return['locality','sublocality','neighborhood','political'].includes(t);})){return true;}};_this.state={label:_this.props.value||'',noSuggestionsError:false,invalidAddress:false};return _this;}_createClass(ManualAddressComponent,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.value!==this.props.value&&!nextProps.value&&this.state.label===this.props.value){this.setState({label:nextProps.value});}}},{key:'clearNoSuggestions',value:function clearNoSuggestions(){if(this.state.noSuggestionsError)this.setState({noSuggestionsError:false});}},{key:'updateSuggestions',value:function updateSuggestions(suggestions){if(this.state.invalidAddress)this.setState({invalidAddress:false});if(suggestions.length&&this.state.label)this.clearNoSuggestions();}},{key:'noSuggestions',value:function noSuggestions(){if(this._geoSuggest.input.props.value){this.setState({noSuggestionsError:true});}}},{key:'onSuggestSelect',value:function onSuggestSelect(suggestion){this.setState({invalidAddress:false});if(suggestion&&suggestion.gmaps&&suggestion.gmaps.address_components){var address_components=suggestion.gmaps.address_components;var value=void 0;if(this.props.type==='country'){value=address_components.find(function(obj){return obj.types.includes('country');})?address_components.find(function(obj){return obj.types.includes('country');}).long_name:'';}else if(this.props.type==='state'){value=address_components.find(function(obj){return obj.types.includes('administrative_area_level_1');})?address_components.find(function(obj){return obj.types.includes('administrative_area_level_1');}).long_name:'';}else if(this.props.type==='city'){value=address_components.find(function(obj){return obj.types.includes('locality');})?address_components.find(function(obj){return obj.types.includes('locality');}).long_name:''||address_components.find(function(obj){return obj.types.includes('sublocality');})?address_components.find(function(obj){return obj.types.includes('sublocality');}).long_name:'';}this.setState({label:value});this.props.onChange(value);if(this._geoSuggest.input.props.value!==value)this._geoSuggest.update(value);}}},{key:'onBlur',value:function onBlur(){if(!this.props.value&&this.state.label)this.setState({label:''});if(this.state.noSuggestionsError||this.state.invalidAddress)this.setState({noSuggestionsError:false,invalidAddress:false});}},{key:'render',value:function render(){var _this2=this;var requiredErr=this.props.showRequiredError&&this.props.required&&!this.props.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},this.props.label,' ',this.props.required?'*':''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_geosuggest___default.a,{inputClassName:requiredErr||this.state.invalidAddress?'error-input':'',queryDelay:250,autoComplete:'on',ignoreTab:true,ref:function ref(el){return _this2._geoSuggest=el;},onBlur:this.onBlur.bind(this),onChange:this.updateLabel,getSuggestLabel:this.getSuggestLabel,onUpdateSuggests:this.updateSuggestions.bind(this),value:this.state.label,initialValue:this.state.label,types:this.props.type==='country'?['(regions)']:this.props.type==='state'?['(regions)']:this.props.type==='city'?['(regions)']:[],skipSuggest:this.skipSuggest,onFocus:this.clearNoSuggestions.bind(this),onSuggestSelect:this.onSuggestSelect.bind(this),onSuggestNoResults:this.noSuggestions.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FadeOutErrorMessage__["a" /* default */],{show:this.state.noSuggestionsError,message:'No Suggestions'}));}}]);return ManualAddressComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);//onChange, value, type (city, country, state)
/* harmony default export */ __webpack_exports__["a"] = (ManualAddressComponent);

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManualAddress=function(_React$Component){_inherits(ManualAddress,_React$Component);function ManualAddress(){_classCallCheck(this,ManualAddress);return _possibleConstructorReturn(this,(ManualAddress.__proto__||Object.getPrototypeOf(ManualAddress)).apply(this,arguments));}_createClass(ManualAddress,[{key:"render",value:function render(){var _props=this.props,incomplete=_props.incomplete,showError=_props.showError,editAddress=_props.editAddress,clearAddress=_props.clearAddress,manualLabel=_props.manualLabel,addAddressLabel=_props.addAddressLabel,invalidAddressCity=_props.invalidAddressCity;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"relative saved-address-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"input-label "+(incomplete&&showError||invalidAddressCity?"error-label":"")},"Saved Address",!!addAddressLabel&&addAddressLabel,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"link-text small-text",onClick:editAddress},"Edit"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"link-text small-text",onClick:clearAddress},"Clear")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"saved-address"},manualLabel),incomplete&&showError&&!invalidAddressCity&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"error-label"},"Incomplete manual address. Missing street number, street, city, or country."),invalidAddressCity&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"error-label"},"Invalid address, city must be included in campaign's location group."));}}]);return ManualAddress;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);//clearAddress, editAddress, manual Label, incomplete, showError
/* harmony default export */ __webpack_exports__["a"] = (ManualAddress);

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_HoverTableRow__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SuggestionsTable=function(_React$Component){_inherits(SuggestionsTable,_React$Component);function SuggestionsTable(props){_classCallCheck(this,SuggestionsTable);var _this=_possibleConstructorReturn(this,(SuggestionsTable.__proto__||Object.getPrototypeOf(SuggestionsTable)).call(this,props));_this.onClick=function(suggestion){if(!suggestion.incomplete||_this.props.allowIncomplete)_this.props.suggestionSelected(suggestion);};_this.state={tableVisible:false};return _this;}_createClass(SuggestionsTable,[{key:'toggleTableView',value:function toggleTableView(){this.setState({tableVisible:!this.state.tableVisible});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-two-thirds'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'suggestions-select-container accent-box-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'suggestion-select accent-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-android-warning'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'inline-block'},'We found ',this.props.suggestions.length,' ',this.props.suggestions.length===1?'suggestion':'suggestions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{onClick:this.toggleTableView.bind(this),className:this.state.tableVisible?"icon ion-ios-arrow-up":"icon ion-ios-arrow-down"})),this.state.tableVisible&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'suggestion-select-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.props.suggestions.map(function(s){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_HoverTableRow__["a" /* default */],{key:s.applicantId,onClick:function onClick(){return _this2.onClick(s);},disabled:s.incomplete&&!_this2.props.allowIncomplete},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'bold-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'block'},s.name),s.incomplete&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag incomplete'},'Incomplete')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,s.address),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:"128px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'suggestions-phone-number'},s.phoneNumber.join(" | "))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{className:'btn btn-primary input',target:"_blank",to:'/recipient-accounts/'+s.applicantId},'View')));}))))));}}]);return SuggestionsTable;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SuggestionsTable);

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_ReferencesActions__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_util_AutocompleteInput__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__recipientAccountsComponents_references_ReferenceModal__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddReferenceModal=function(_NavigationComponent){_inherits(AddReferenceModal,_NavigationComponent);function AddReferenceModal(props){var _this2=this;_classCallCheck(this,AddReferenceModal);var _this=_possibleConstructorReturn(this,(AddReferenceModal.__proto__||Object.getPrototypeOf(AddReferenceModal)).call(this,props));_this.initialState={referenceId:null,relationship:'',submitAttempted:false,showModals:{newReferenceModal:false}};_this.onChange=function(name,value){_this.setState(_defineProperty({},name,value));};_this.onClose=function(){_this.props.close();_this.setState(_this.initialState);};_this.onSubmit=function(){_this.setState({submitAttempted:true});var _this$state=_this.state,referenceId=_this$state.referenceId,relationship=_this$state.relationship;if(referenceId){var reference=_this.props.references.data[_this.props.references.data.map(function(ref){return ref.referenceId;}).indexOf(referenceId)];_this.props.addReference(Object.assign({},reference,{relationship:relationship}));_this.onClose();}};_this.createReference=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(reference){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.actions.createReference(reference);case 2:if(!_this.props.createReference.success){_context.next=6;break;}_context.next=5;return _this.props.actions.getAllReferences();case 5:_this.setState({referenceId:_this.props.createReference.data});case 6:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.state=_this.initialState;return _this;}_createClass(AddReferenceModal,[{key:'render',value:function render(){var _state=this.state,referenceId=_state.referenceId,relationship=_state.relationship,submitAttempted=_state.submitAttempted;var _props=this.props,references=_props.references,filterReferences=_props.filterReferences,referenceType=_props.referenceType;return!this.state.showModals.newReferenceModal?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal large-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},'Add ',referenceType),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.onClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row full-width-modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_AutocompleteInput__["a" /* default */],{placeholder:'Search references',loading:references.loading,options:Object(__WEBPACK_IMPORTED_MODULE_10__lib_utils__["o" /* formatReferenceOptions */])(references.data.filter(filterReferences)),update:this.onChange}),label:referenceType,name:'referenceId',value:referenceId,required:true,showRequiredError:submitAttempted}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginLeft:"16px",width:"auto"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent2',onClick:this.toggleModal.bind(this,"newReferenceModal")},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-plus-empty icon-left'}),'Create'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row full-width-modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'Relationship To Recipient',name:'relationship',value:relationship,onChange:this.onChange,required:true,showRequiredError:submitAttempted}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.onClose},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',onClick:this.onSubmit,disabled:!referenceId},'Add'))))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__recipientAccountsComponents_references_ReferenceModal__["a" /* default */],Object.assign({show:this.state.showModals.newReferenceModal,close:this.toggleModal.bind(this,"newReferenceModal")},this.props.createReference,{loading:this.props.createReference.loading||this.props.references.loading,submitReference:this.createReference,usPersonTitles:this.props.usPersonTitles,israelPersonTitles:this.props.israelPersonTitles,usInstitutionTitles:this.props.usInstitutionTitles,israelInstitutionTitles:this.props.israelInstitutionTitles,recipientTypes:this.props.recipientTypes}));}}]);return AddReferenceModal;}(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_NavigationComponent__["a" /* default */]);function mapStateToProps(state){return{references:state.references.references,createReference:state.references.createReference,usPersonTitles:state.settings.systemSettings.data.recipientSettings.usPersonTitles,israelPersonTitles:state.settings.systemSettings.data.recipientSettings.israelPersonTitles,usInstitutionTitles:state.settings.systemSettings.data.recipientSettings.usInstitutionTitles,israelInstitutionTitles:state.settings.systemSettings.data.recipientSettings.israelInstitutionTitles,recipientTypes:state.settings.systemSettings.data.otherSettings.recipientTypes};}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_4__redux_actions_ReferencesActions__,dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(AddReferenceModal));

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cells_CurrencyCell__ = __webpack_require__(179);
var PledgeRowDisplay=function PledgeRowDisplay(_ref){var pledgeId=_ref.pledgeId,pledgeDate=_ref.pledgeDate,pledgeAmount=_ref.pledgeAmount,amountPaid=_ref.amountPaid,outstandingAmount=_ref.outstandingAmount,payOutSchedule=_ref.payOutSchedule,onEdit=_ref.onEdit,disableEdit=_ref.disableEdit;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-right"},pledgeId),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-right"},pledgeDate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__cells_CurrencyCell__["a" /* default */],{value:pledgeAmount}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__cells_CurrencyCell__["a" /* default */],{value:amountPaid||0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__cells_CurrencyCell__["a" /* default */],{value:outstandingAmount}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-left"},payOutSchedule||"-"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon-pencil primary-hover input "+(disableEdit?"disabled":""),onClick:!disableEdit?onEdit:null,role:"button",tabIndex:"0",onKeyDown:function onKeyDown(e){if((e.key==="Enter"||e.key===" ")&&!disableEdit)onEdit();},"aria-label":"Edit pledge"})));};PledgeRowDisplay.propTypes={pledgeId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,pledgeDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,pledgeAmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,amountPaid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,outstandingAmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,payOutSchedule:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,disableEdit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};PledgeRowDisplay.defaultProps={payOutSchedule:"",disableEdit:false};/* harmony default export */ __webpack_exports__["a"] = (PledgeRowDisplay);

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cells_CurrencyCell__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cells_InputCell__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cells_ActionCell__ = __webpack_require__(488);
var PledgeRowEdit=function PledgeRowEdit(_ref){var pledgeId=_ref.pledgeId,amountPaid=_ref.amountPaid,outstandingAmount=_ref.outstandingAmount,pledgeDate=_ref.pledgeDate,pledgeAmount=_ref.pledgeAmount,payOutSchedule=_ref.payOutSchedule,onFieldChange=_ref.onFieldChange,onSubmit=_ref.onSubmit,onCancel=_ref.onCancel,disableSubmit=_ref.disableSubmit,showValidationErrors=_ref.showValidationErrors;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-right"},pledgeId),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__cells_InputCell__["a" /* default */],{type:"date",name:"pledgeDate",value:Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["l" /* formatDateForInput */])(pledgeDate)||"",onChange:onFieldChange,required:true,showError:showValidationErrors}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__cells_InputCell__["a" /* default */],{type:"currency",name:"pledgeAmount",value:pledgeAmount||"",onChange:onFieldChange,required:true,showError:showValidationErrors}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__cells_CurrencyCell__["a" /* default */],{value:amountPaid||0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__cells_CurrencyCell__["a" /* default */],{value:outstandingAmount}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__cells_InputCell__["a" /* default */],{type:"text",name:"payOutSchedule",value:payOutSchedule||"",onChange:onFieldChange,required:false,showError:showValidationErrors}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__cells_ActionCell__["a" /* default */],{onSubmit:onSubmit,onCancel:onCancel,disabled:disableSubmit}));};PledgeRowEdit.propTypes={pledgeId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,amountPaid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,outstandingAmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,pledgeDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,pledgeAmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]).isRequired,payOutSchedule:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onFieldChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,disableSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,showValidationErrors:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};PledgeRowEdit.defaultProps={showValidationErrors:false};/* harmony default export */ __webpack_exports__["a"] = (PledgeRowEdit);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_CurrencyFormatInput__ = __webpack_require__(19);
var InputCell=function InputCell(_ref){var _ref$type=_ref.type,type=_ref$type===undefined?"text":_ref$type,name=_ref.name,value=_ref.value,onChange=_ref.onChange,_ref$required=_ref.required,required=_ref$required===undefined?false:_ref$required,_ref$showError=_ref.showError,showError=_ref$showError===undefined?false:_ref$showError,_ref$maxDate=_ref.maxDate,maxDate=_ref$maxDate===undefined?"9999-12-31":_ref$maxDate;var isCurrency=type==="currency";var isDate=type==="date";var className=isDate||isCurrency?"text-right":"text-left";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:className},isCurrency?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_CurrencyFormatInput__["a" /* default */],null),label:"",name:name,value:value,onChange:onChange,required:required,showRequiredError:showError})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:isDate?"date":"text",max:isDate?maxDate:undefined}),label:"",name:name,value:value,onChange:onChange,required:required,showRequiredError:showError}));};InputCell.propTypes={type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["text","date","currency"]),name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]).isRequired,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,required:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,showError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,maxDate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};InputCell.defaultProps={type:"text",required:false,showError:false,maxDate:"9999-12-31"};/* harmony default export */ __webpack_exports__["a"] = (InputCell);

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var ActionCell=function ActionCell(_ref){var onSubmit=_ref.onSubmit,onCancel=_ref.onCancel,disabled=_ref.disabled,_ref$submitLabel=_ref.submitLabel,submitLabel=_ref$submitLabel===undefined?"Submit":_ref$submitLabel,_ref$cancelLabel=_ref.cancelLabel,cancelLabel=_ref$cancelLabel===undefined?"Cancel":_ref$cancelLabel;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"link-text small-text "+(disabled?"disabled":""),onClick:onSubmit,disabled:disabled,"aria-label":submitLabel},submitLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"link-text small-text",onClick:onCancel,style:{marginLeft:"16px"},"aria-label":cancelLabel},cancelLabel));};ActionCell.propTypes={onSubmit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,submitLabel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,cancelLabel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};ActionCell.defaultProps={disabled:false,submitLabel:"Submit",cancelLabel:"Cancel"};/* harmony default export */ __webpack_exports__["a"] = (ActionCell);

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pledgeTableConfig__ = __webpack_require__(490);
var PledgeTableHeader=function PledgeTableHeader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"table-header table-row"},__WEBPACK_IMPORTED_MODULE_1__pledgeTableConfig__["a" /* PLEDGE_COLUMNS */].map(function(col){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{key:col.key,className:col.align},col.label);})));};/* harmony default export */ __webpack_exports__["a"] = (PledgeTableHeader);

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PLEDGE_COLUMNS; });
var PLEDGE_COLUMNS=[{key:"pledgeId",label:"Pledge #",align:"text-right"},{key:"pledgeDate",label:"Date",align:"text-right"},{key:"pledgeAmount",label:"Amount",align:"text-right"},{key:"amountPaid",label:"Amount Paid",align:"text-right"},{key:"outstandingAmount",label:"Outstanding Amount",align:"text-right"},{key:"payOutSchedule",label:"Payout Schedule",align:"text-left"},{key:"actions",label:"",align:"text-center"}];

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_shared_UploadAttachments__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_CurrencyFormatInput__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_RadioGroup__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_AutocompleteInput__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateApplication=function(_React$Component){_inherits(CreateApplication,_React$Component);function CreateApplication(){_classCallCheck(this,CreateApplication);return _possibleConstructorReturn(this,(CreateApplication.__proto__||Object.getPrototypeOf(CreateApplication)).apply(this,arguments));}_createClass(CreateApplication,[{key:'isWedding',value:function isWedding(reasonId,applicationReasons){var s="wedding";for(var index=0;index<applicationReasons.length;index++){var element=applicationReasons[index];if(element.key==reasonId){var containsWedding=element.value.toLowerCase().includes(s);if(containsWedding)return true;}}return false;}},{key:'render',value:function render(){var _this2=this;var _props=this.props,application=_props.application,submitAttempted=_props.submitAttempted,tags=_props.tags,applicationSourceType=_props.applicationSourceType,recipientReferences=_props.recipientReferences,isManualPayment=_props.isManualPayment,recipientPledges=_props.recipientPledges;var applicantPledgeOptions=recipientPledges.map(function(x){return{key:x.applicantPledgeId,value:Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["k" /* formatDate */])(x.pledgeDate)+" - "+Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["j" /* formatCurrency */])(x.pledgeAmount)};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'section-header'},'Application Info'),!!this.props.permissions.private&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'private-application'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'private',className:'custom-check',value:application.isPrivate,name:'isPrivate',onChange:function onChange(e){return _this2.props.updateApplication(e.target.name,e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'private'},'Private Application ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'accent-text xs-text icon-right'},'This application will only be viewed by you.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__["a" /* default */],{clearable:true,tabIndex:410,options:tags.applicationReasons}),label:'Reason',name:'reasonId',value:application.reasonId,onChange:this.props.updateApplication,required:!isManualPayment,showRequiredError:submitAttempted})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Request Amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_CurrencyFormatInput__["a" /* default */],{name:'requestAmount',value:application.requestAmount,tabIndex:420,onChange:function onChange(e){return _this2.props.updateApplication(e.target.name,e.target.value);},isIsraeli:this.props.payeeIsIsraeli})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__["a" /* default */],{tabIndex:430,options:tags.approvers}),label:'Approver',name:'approverId',value:application.approverId,onChange:this.props.updateApplication,required:true,showRequiredError:submitAttempted}))),this.isWedding(this.props.application.reasonId,tags.applicationReasons)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info-row flex-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',max:'9999-12-31'}),label:'Wedding Date',name:'reasonDate',value:application.reasonDate,tabIndex:432,onChange:this.props.updateApplication,required:false,showRequiredError:this.submitAttempted})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text'}),label:'Wedding Hall',name:'weddingHall',value:application.weddingHall,onChange:this.props.updateApplication})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__["a" /* default */],{tabIndex:430,options:[{key:'Boy',value:'Boy'},{key:'Girl',value:'Girl'}]}),label:'Side',name:'weddingSide',value:application.weddingSide,onChange:this.props.updateApplication}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info-row flex-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_RadioGroup__["a" /* default */],{title:'Source',options:[{key:'new',value:'Enter New'},{key:'reference',value:'Choose Reference',disabled:!recipientReferences.length}],name:'applicationSourceType',value:applicationSourceType,onChange:this.props.toggleSourceType}),applicationSourceType==="reference"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__["a" /* default */],{tabIndex:440,options:recipientReferences.map(function(ref){return{key:ref.referenceId,value:ref.displayName};}),name:'sourceId',value:application.sourceId,onChange:function onChange(e){return _this2.props.updateApplication(e.target.name,e.target.value);}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_AutocompleteInput__["a" /* default */],{tabIndex:440,showList:true,placeholder:'Search references',name:'sourceId',value:application.sourceId,options:Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["o" /* formatReferenceOptions */])(tags.references.filter(function(r){return recipientReferences.map(function(ref){return ref.referenceId;}).indexOf(r.referenceId)<0;})),update:this.props.updateApplication})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info-row flex-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Campaign Individual Category'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__["a" /* default */],{tabIndex:450,clearable:true,options:tags.campaignIndivCategories.filter(function(c){return c.active!==false;}),name:'individualCategoryId',value:application.individualCategoryId,onChange:function onChange(e){return _this2.props.updateApplication(e.target.name,e.target.value);}}))),recipientPledges.length>=1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-third'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Pledge'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__["a" /* default */],{tabIndex:455,clearable:true,options:applicantPledgeOptions,name:'applicantPledgeId',value:application.applicantPledgeId,onChange:function onChange(e){return _this2.props.updateApplication(e.target.name,e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-third'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Note'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{value:application.note,tabIndex:460,onChange:function onChange(e){return _this2.props.updateApplication('note',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_shared_UploadAttachments__["a" /* default */],{files:application.attachments,name:'attachments',onChange:this.props.updateApplication})));}}]);return CreateApplication;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CreateApplication);

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportMultiple; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getDataTransferItems;
/* harmony export (immutable) */ __webpack_exports__["b"] = fileAccepted;
/* harmony export (immutable) */ __webpack_exports__["c"] = fileMatchSize;
/* harmony export (immutable) */ __webpack_exports__["a"] = allFilesAccepted;
/* harmony export (immutable) */ __webpack_exports__["e"] = onDocumentDragOver;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_attr_accept__);


var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;

function getDataTransferItems(event) {
  var dataTransferItemsList = [];
  if (event.dataTransfer) {
    var dt = event.dataTransfer;
    if (dt.files && dt.files.length) {
      dataTransferItemsList = dt.files;
    } else if (dt.items && dt.items.length) {
      // During the drag even the dataTransfer.files is null
      // but Chrome implements some drag store, which is accesible via dataTransfer.items
      dataTransferItemsList = dt.items;
    }
  } else if (event.target && event.target.files) {
    dataTransferItemsList = event.target.files;
  }
  // Convert from DataTransferItemsList to the native Array
  return Array.prototype.slice.call(dataTransferItemsList);
}

// Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted
function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || __WEBPACK_IMPORTED_MODULE_0_attr_accept___default()(file, accept);
}

function fileMatchSize(file, maxSize, minSize) {
  return file.size <= maxSize && file.size >= minSize;
}

function allFilesAccepted(files, accept) {
  return files.every(function (file) {
    return fileAccepted(file, accept);
  });
}

// allow the entire document to be a drag target
function onDocumentDragOver(evt) {
  evt.preventDefault();
}

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={exports:{},id:e,loaded:!1};return t[e].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}var r={};return n.m=t,n.c=r,n.p="",n(0)}([function(t,n,r){"use strict";n.__esModule=!0,r(8),r(9),n["default"]=function(t,n){if(t&&n){var r=function(){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return{v:r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}}();if("object"==typeof r)return r.v}return!0},t.exports=n["default"]},function(t,n){var r=t.exports={version:"1.2.2"};"number"==typeof __e&&(__e=r)},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n,r){var e=r(2),o=r(1),i=r(4),u=r(19),c="prototype",f=function(t,n){return function(){return t.apply(n,arguments)}},s=function(t,n,r){var a,p,l,y,d=t&s.G,h=t&s.P,v=d?e:t&s.S?e[n]||(e[n]={}):(e[n]||{})[c],x=d?o:o[n]||(o[n]={});d&&(r=n);for(a in r)p=!(t&s.F)&&v&&a in v,l=(p?v:r)[a],y=t&s.B&&p?f(l,e):h&&"function"==typeof l?f(Function.call,l):l,v&&!p&&u(v,a,l),x[a]!=l&&i(x,a,y),h&&((x[c]||(x[c]={}))[a]=l)};e.core=o,s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,t.exports=s},function(t,n,r){var e=r(5),o=r(18);t.exports=r(22)?function(t,n,r){return e.setDesc(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=Object;t.exports={create:r.create,getProto:r.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:r.getOwnPropertyDescriptor,setDesc:r.defineProperty,setDescs:r.defineProperties,getKeys:r.keys,getNames:r.getOwnPropertyNames,getSymbols:r.getOwnPropertySymbols,each:[].forEach}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(20)("wks"),o=r(2).Symbol;t.exports=function(t){return e[t]||(e[t]=o&&o[t]||(o||r(6))("Symbol."+t))}},function(t,n,r){r(26),t.exports=r(1).Array.some},function(t,n,r){r(25),t.exports=r(1).String.endsWith},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(10);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(e){try{return n[r(7)("match")]=!1,!"/./"[t](n)}catch(o){}}return!0}},function(t,n){t.exports=function(t){try{return!!t()}catch(n){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,r){var e=r(16),o=r(11),i=r(7)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(2),o=r(4),i=r(6)("src"),u="toString",c=Function[u],f=(""+c).split(u);r(1).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,u){"function"==typeof r&&(o(r,i,t[n]?""+t[n]:f.join(String(n))),"name"in r||(r.name=n)),t===e?t[n]=r:(u||delete t[n],o(t,n,r))})(Function.prototype,u,function(){return"function"==typeof this&&this[i]||c.call(this)})},function(t,n,r){var e=r(2),o="__core-js_shared__",i=e[o]||(e[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,n,r){var e=r(17),o=r(13);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){t.exports=!r(15)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(23),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";var e=r(3),o=r(24),i=r(21),u="endsWith",c=""[u];e(e.P+e.F*r(14)(u),"String",{endsWith:function(t){var n=i(this,t,u),r=arguments,e=r.length>1?r[1]:void 0,f=o(n.length),s=void 0===e?f:Math.min(o(e),f),a=String(t);return c?c.call(n,a,s):n.slice(s-a.length,s)===a}})},function(t,n,r){var e=r(5),o=r(3),i=r(1).Array||Array,u={},c=function(t,n){e.each.call(t.split(","),function(t){void 0==n&&t in i?u[t]=i[t]:t in[]&&(u[t]=r(12)(Function.call,[][t],n))})};c("pop,reverse,shift,keys,values,entries",1),c("indexOf,every,some,forEach,map,filter,find,findIndex,includes",3),c("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"),o(o.S,"Array",u)}]);

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  rejected: {
    borderStyle: 'solid',
    borderColor: '#c66',
    backgroundColor: '#eee'
  },
  disabled: {
    opacity: 0.5
  },
  active: {
    borderStyle: 'solid',
    borderColor: '#6c6',
    backgroundColor: '#eee'
  },
  default: {
    width: 200,
    height: 200,
    borderWidth: 2,
    borderColor: '#666',
    borderStyle: 'dashed',
    borderRadius: 5
  }
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_Select__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PrintInfo=function(_React$Component){_inherits(PrintInfo,_React$Component);function PrintInfo(){_classCallCheck(this,PrintInfo);return _possibleConstructorReturn(this,(PrintInfo.__proto__||Object.getPrototypeOf(PrintInfo)).apply(this,arguments));}_createClass(PrintInfo,[{key:'onChange',value:function onChange(e){this.props.updateApplication(e.target.name,e.target.value);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'medium-text'},'Print Instructions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-third'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Card Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_Select__["a" /* default */],{clearable:true,options:this.props.cardTypes,value:this.props.selectedCardType,tabIndex:500,name:'cardTypeId',title:'Card Type',onChange:this.onChange.bind(this)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-two-thirds'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'empty-label'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',tabIndex:510,placeholder:'Enter any other instructions',value:this.props.printInstructions,onChange:function onChange(e){return _this2.props.updateApplication('printInstructions',e.target.value);}}))));}}]);return PrintInfo;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PrintInfo);

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PlaceholderDateInput=function(_React$Component){_inherits(PlaceholderDateInput,_React$Component);function PlaceholderDateInput(props){_classCallCheck(this,PlaceholderDateInput);var _this=_possibleConstructorReturn(this,(PlaceholderDateInput.__proto__||Object.getPrototypeOf(PlaceholderDateInput)).call(this,props));_this.state={focused:false};return _this;}_createClass(PlaceholderDateInput,[{key:"onBlur",value:function onBlur(){if(this.state.focused&&!this.props.value)this.setState({focused:false});}},{key:"onFocus",value:function onFocus(){var _this2=this;this.setState({focused:true},function(){_this2.textInput.focus();});}},{key:"render",value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,!this.state.focused&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",Object.assign({type:"text",placeholder:this.props.placeholder},this.props,{onFocus:this.onFocus.bind(this)})),this.state.focused&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",Object.assign({type:"date",max:"9999-12-31",name:this.props.name,value:this.props.value,onChange:this.props.onChange},this.props,{onBlur:this.onBlur.bind(this),ref:function ref(input){_this3.textInput=input;}})));}}]);return PlaceholderDateInput;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);//props: name, value, placeholder, onChange
/* harmony default export */ __webpack_exports__["a"] = (PlaceholderDateInput);

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_autosuggest__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_autosuggest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_autosuggest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LoadingSpinner__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AutocompleteSelect=function(_React$Component){_inherits(AutocompleteSelect,_React$Component);function AutocompleteSelect(props){_classCallCheck(this,AutocompleteSelect);var _this=_possibleConstructorReturn(this,(AutocompleteSelect.__proto__||Object.getPrototypeOf(AutocompleteSelect)).call(this,props));_this.state={suggestions:[]};return _this;}_createClass(AutocompleteSelect,[{key:'onChange',value:function onChange(event,_ref){var newValue=_ref.newValue;this.props.updateLabel(newValue);if(newValue&&this.props.value||!newValue){this.props.update(this.props.propertyName,'');}}},{key:'onSuggest',value:function onSuggest(suggestion){this.setState({suggestions:this.props.options.filter(function(o){return o.value.toLowerCase().indexOf(suggestion.value.toLowerCase())>=0;})});}},{key:'onSelectSuggestion',value:function onSelectSuggestion(event,_ref2){var suggestion=_ref2.suggestion;this.props.updateLabel(suggestion.value);this.props.update(this.props.propertyName,suggestion.key);}},{key:'clearSuggestions',value:function clearSuggestions(){this.setState({suggestions:[]});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'search-input '+this.props.className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'search'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_autosuggest___default.a,{suggestions:this.state.suggestions,onSuggestionsFetchRequested:this.onSuggest.bind(this),onSuggestionsClearRequested:this.clearSuggestions.bind(this),getSuggestionValue:function getSuggestionValue(s){return s.value;},onSuggestionSelected:this.onSelectSuggestion.bind(this),renderSuggestion:function renderSuggestion(s){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:s.key},s.value);},inputProps:{tabIndex:this.props.tabindex||'',disabled:this.props.disabled||!this.props.loading&&!this.props.options.length,placeholder:!this.props.loading&&!this.props.options.length?this.props.disabledPlaceholder:this.props.placeholder,className:this.props.className,value:this.props.label,onChange:this.onChange.bind(this)}}),this.props.loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__LoadingSpinner__["a" /* default */],{height:'12'}),!this.props.value&&this.props.label&&!this.state.suggestions.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'error-label'},'No suggestions')));}}]);return AutocompleteSelect;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AutocompleteSelect);

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_RadioGroup__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Toggle__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_number_format__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_number_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_shared_AddressAutocomplete__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ThirdPartyPayeeModal=function(_React$Component){_inherits(ThirdPartyPayeeModal,_React$Component);function ThirdPartyPayeeModal(props){var _this2=this;_classCallCheck(this,ThirdPartyPayeeModal);var _this=_possibleConstructorReturn(this,(ThirdPartyPayeeModal.__proto__||Object.getPrototypeOf(ThirdPartyPayeeModal)).call(this,props));_this.initialState={payee:{isIsraeli:false,firstName:'',lastName:'',orgName:'',address:{},bankNumber:'',branchNumber:'',accountNumber:'',accountHolder:''},payeeType:__WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__["l" /* RecipientTypes */].Individual,initialPayee:{},dataErrors:[],submitAttempted:false};_this.onUpdatePayeeType=function(name,value){var _this$state=_this.state,payee=_this$state.payee,initialPayee=_this$state.initialPayee;if(value===__WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__["l" /* RecipientTypes */].Individual){var _this$setState;_this.setState((_this$setState={},_defineProperty(_this$setState,name,value),_defineProperty(_this$setState,'payee',Object.assign({},payee,{orgName:'',firstName:initialPayee.firstName,lastName:initialPayee.lastName})),_this$setState));}else if(value===__WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__["l" /* RecipientTypes */].Organization){var _this$setState2;_this.setState((_this$setState2={},_defineProperty(_this$setState2,name,value),_defineProperty(_this$setState2,'payee',Object.assign({},payee,{firstName:'',lastName:'',orgName:initialPayee.orgName})),_this$setState2));}};_this.onChange=function(name,value){if(name==="isIsraeli"){var _Object$assign;_this.setState({payee:Object.assign({},_this.state.payee,(_Object$assign={},_defineProperty(_Object$assign,name,value),_defineProperty(_Object$assign,'address',{}),_defineProperty(_Object$assign,'bankNumber',''),_defineProperty(_Object$assign,'branchNumber',''),_defineProperty(_Object$assign,'accountNumber',''),_defineProperty(_Object$assign,'accountHolder',''),_Object$assign))});}else{if(name==="firstName"||name==="lastName"||name==="orgName")value=Object(__WEBPACK_IMPORTED_MODULE_8__lib_utils__["C" /* toTitleCase */])(value);_this.setState({payee:Object.assign({},_this.state.payee,_defineProperty({},name,value))});}};_this.onChangeEvt=function(event){_this.onChange(event.target.name,event.target.value);};_this.onSubmit=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var payee;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({submitAttempted:true});payee=_this.state.payee;if(!(_this.state.dataErrors.length||!(_this.state.payeeType===__WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__["l" /* RecipientTypes */].Organization?payee.orgName:payee.firstName&&payee.lastName)//names always required
)){_context.next=4;break;}return _context.abrupt('return');case 4:_context.next=6;return _this.props.submitPayee(payee);case 6:_this.onClose();case 7:case'end':return _context.stop();}}},_callee,_this2);}));_this.onClose=function(){_this.setState({recipientIsIsraeli:_this.props.recipientIsIsraeli//this property will cause autosuggest input to remount with isIsraeli set to that of the recipient, in order to reload google places script to appropriate value for recipient
},function(){_this.props.close();_this.setState(_this.initialState);});};_this.validateFieldLength=function(name,length,value){var isValid=Object(__WEBPACK_IMPORTED_MODULE_8__lib_utils__["E" /* validateFieldLength */])(length,value);_this.setDataError(name,!isValid);return isValid;};_this.setDataError=function(errorName,error){var dataErrors=[].concat(_toConsumableArray(_this.state.dataErrors));if(error)dataErrors.push(errorName);else dataErrors=dataErrors.filter(function(e){return e!==errorName;});_this.setState({dataErrors:dataErrors});};_this.state=_this.initialState;return _this;}_createClass(ThirdPartyPayeeModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.show&&!this.props.show){var payee=Object.assign({},this.state.payee,nextProps.payee);this.setState({payee:payee,initialPayee:payee,payeeType:payee.orgName?__WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__["l" /* RecipientTypes */].Organization:__WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__["l" /* RecipientTypes */].Individual,recipientIsIsraeli:undefined});}}},{key:'render',value:function render(){var _this3=this;var _state=this.state,payee=_state.payee,initialPayee=_state.initialPayee,payeeType=_state.payeeType,recipientIsIsraeli=_state.recipientIsIsraeli,dataErrors=_state.dataErrors,submitAttempted=_state.submitAttempted;var _props=this.props,isManualPayment=_props.isManualPayment,recipientTypes=_props.recipientTypes,useRecipientAddress=_props.useRecipientAddress,show=_props.show,applicationSubmitAttempted=_props.submitAttempted;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal new-transaction-modal large-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},'New Third Party Payee'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.onClose.bind(this)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_RadioGroup__["a" /* default */],{options:recipientTypes,title:'Third Party Type',name:'payeeType',value:payeeType,onChange:this.onUpdatePayeeType})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Toggle__["a" /* default */],{id:'thirdPartyIsraeli',name:'isIsraeli',value:payee.isIsraeli,onChange:this.onChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'small-text middle'},'Israeli'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},payeeType===__WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__["l" /* RecipientTypes */].Individual?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'First Name',name:'firstName',value:payee.firstName,onChange:this.onChange,required:true,showRequiredError:submitAttempted||applicationSubmitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'Last Name',name:'lastName',value:payee.lastName,onChange:this.onChange,required:true,showRequiredError:submitAttempted||applicationSubmitAttempted}))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'Name',name:'orgName',value:payee.orgName,onChange:this.onChange,required:true,showRequiredError:submitAttempted||applicationSubmitAttempted})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_shared_AddressAutocomplete__["a" /* default */],{hide:payee.isIsraeli//showing address autocomplete if recipient is Israeli to ensure re-load of script when close modal for appropriate val for recipient 
,isIsraeli:recipientIsIsraeli!==undefined?recipientIsIsraeli:false,required:!isManualPayment&&!useRecipientAddress//not required if manual check or using recipient address
,showRequiredError:applicationSubmitAttempted&&!recipientIsIsraeli//not if recipientIsIsraeli - to avoid flashing required style in this case
,address:payee.address,updateAddress:this.onChange.bind(this,'address'),updateError:function updateError(){return _this3.setDataError('address');}})),payee.isIsraeli&&!isManualPayment&&//not allowing bank info if manual check
__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_number_format___default.a,{placeholder:'##',format:'##',onValueChange:function onValueChange(values){return _this3.onChange('bankNumber',values.value);}}),label:'Bank Number',name:'bankNumber',value:payee.bankNumber,required:true,showRequiredError:applicationSubmitAttempted,errorMessage:'Invalid Bank Number',validated:true,showValidationError:true,validate:function validate(val){return _this3.validateFieldLength('bankNumber',2,val);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_number_format___default.a,{placeholder:'###',format:'###',onValueChange:function onValueChange(values){return _this3.onChange('branchNumber',values.value);}}),label:'Branch Number',name:'branchNumber',value:payee.branchNumber,required:true,showRequiredError:applicationSubmitAttempted,errorMessage:'Invalid Branch Number',validated:true,showValidationError:true,validate:function validate(val){return _this3.validateFieldLength('branchNumber',2,val);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_number_format___default.a,{placeholder:'###############',format:'###############',onValueChange:function onValueChange(values){return _this3.onChange('accountNumber',values.value);}}),label:'Account Number',name:'accountNumber',value:payee.accountNumber,required:true,showRequiredError:applicationSubmitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Account Holder'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',name:'accountHolder',value:payee.accountHolder,onChange:function onChange(e){return _this3.onChange(e.target.name,e.target.value);}}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.onClose.bind(this)},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',disabled:Object(__WEBPACK_IMPORTED_MODULE_8__lib_utils__["e" /* deepEquals */])(payee,initialPayee)||dataErrors.length,onClick:this.onSubmit},'Submit')))));}}]);return ThirdPartyPayeeModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ThirdPartyPayeeModal);

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateCancelButtons=function(_React$Component){_inherits(CreateCancelButtons,_React$Component);function CreateCancelButtons(){_classCallCheck(this,CreateCancelButtons);return _possibleConstructorReturn(this,(CreateCancelButtons.__proto__||Object.getPrototypeOf(CreateCancelButtons)).apply(this,arguments));}_createClass(CreateCancelButtons,[{key:'render',value:function render(){return this.props.loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'application-create-btns text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.props.cancel},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',disabled:this.props.disabled,onClick:this.props.save},'Save'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.props.show,message:this.props.message}),this.props.disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'info-label'},this.props.disabledMessage));}}]);return CreateCancelButtons;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);//disabled, cancel, save, loading
/* harmony default export */ __webpack_exports__["a"] = (CreateCancelButtons);

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_CheckPrintingActions__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_ApplicationsActions__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PrintingTable__ = __webpack_require__(501);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PrintingPage=function(_NavigationComponent){_inherits(PrintingPage,_NavigationComponent);function PrintingPage(props){_classCallCheck(this,PrintingPage);var _this=_possibleConstructorReturn(this,(PrintingPage.__proto__||Object.getPrototypeOf(PrintingPage)).call(this,props));var checks=_this.props.printing.data;_this.state={checkPrints:checks,printsCancelled:[],printsConfirmed:[],reprintRangeFrom:checks.length?checks[0].checkNumber:'',reprintRangeTo:checks.length?checks[checks.length-1].checkNumber:'',showReprintDropdown:false};return _this;}_createClass(PrintingPage,[{key:'onChange',value:function onChange(event){this.setState(_defineProperty({},event.target.name,event.target.value));}},{key:'markPrintsCancelled',value:function markPrintsCancelled(checkNumbers){this.setState({printsCancelled:checkNumbers});}},{key:'markPrintsConfirmed',value:function markPrintsConfirmed(checkNumbers){this.setState({printsConfirmed:checkNumbers});}},{key:'reprint',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(printJobIds){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({showReprintDropdown:false});if(!printJobIds.length){_context.next=7;break;}__WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__["toastr"].info('Printing in progress',printJobIds.length+' check'+(printJobIds.length>1?"s":"")+' printing.',{timeOut:0});_context.next=5;return this.props.actions.printChecks('reprints',this.props.printing.printerId,{printJobIds:printJobIds});case 5:__WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__["toastr"].removeByType('info');if(this.props.printing.success){__WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__["toastr"].success('Printing completed.');}else{__WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__["toastr"].error("Something went wrong","The print job could not be completed.  Please try again.");}case 7:case'end':return _context.stop();}}},_callee,this);}));function reprint(_x){return _ref.apply(this,arguments);}return reprint;}()},{key:'confirmPrinting',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _state,checkPrints,printsCancelled,printsConfirmed,success,updatedCheckPrints,updatedPrintsCancelled,updatedPrintsConfirmed,confirmedPrintJobIds,cancelledPrintJobIds;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_state=this.state,checkPrints=_state.checkPrints,printsCancelled=_state.printsCancelled,printsConfirmed=_state.printsConfirmed;if(checkPrints.length){_context2.next=3;break;}return _context2.abrupt('return');case 3:success=true;updatedCheckPrints=[].concat(_toConsumableArray(checkPrints)),updatedPrintsCancelled=[],updatedPrintsConfirmed=[];if(!printsConfirmed.length){_context2.next=10;break;}confirmedPrintJobIds=checkPrints.filter(function(ck){return printsConfirmed.indexOf(ck.checkNumber)>=0;}).map(function(ck){return ck.printJobId;});_context2.next=9;return this.props.actions.confirmChecksPrinted(confirmedPrintJobIds);case 9:if(!this.props.confirming.success){success=false;}else{updatedCheckPrints=updatedCheckPrints.filter(function(ck){return confirmedPrintJobIds.indexOf(ck.printJobId)<0;});updatedPrintsConfirmed=[];}case 10:if(!printsCancelled.length){_context2.next=15;break;}cancelledPrintJobIds=checkPrints.filter(function(ck){return printsCancelled.indexOf(ck.checkNumber)>=0;}).map(function(ck){return ck.printJobId;});_context2.next=14;return this.props.actions.confirmChecksPrinted(cancelledPrintJobIds,true);case 14:if(!this.props.confirming.success){success=false;}else{updatedCheckPrints=updatedCheckPrints.filter(function(ck){return cancelledPrintJobIds.indexOf(ck.printJobId)<0;});updatedPrintsCancelled=[];}case 15:this.setState({checkPrints:updatedCheckPrints,printsCancelled:updatedPrintsCancelled,printsConfirmed:updatedPrintsConfirmed});if(success){if(checkPrints[0].applicationId){//application checks printing
if(printsConfirmed.length){__WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__["toastr"].success('Printing completed - '+(printsConfirmed.length>1?"Applications have":"Application has")+' been marked paid.');}this.props.actions.getApplications(1,this.props.applicationsTable.resultsView,this.props.applicationsTable.sort);this.pushRoute('/applications');}else{//blank checks printing
if(printsConfirmed.length){__WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__["toastr"].success('Printing completed.');}this.pushRoute('/settings/printing');}}else{__WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__["toastr"].error('Something went wrong','This action could not be completed.  Please try again.');}case 17:case'end':return _context2.stop();}}},_callee2,this);}));function confirmPrinting(){return _ref2.apply(this,arguments);}return confirmPrinting;}()},{key:'render',value:function render(){var _state2=this.state,checkPrints=_state2.checkPrints,printsCancelled=_state2.printsCancelled,printsConfirmed=_state2.printsConfirmed;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'secondary-page'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Prompt */],{when:printsCancelled.length+printsConfirmed.length!==checkPrints.length,message:'Are you sure you\'d like to leave this page before confirming printing?  You will not be able to confirm printing at a later point.'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'secondary-page-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container flex-justify flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-one flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},'Printing ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'printing-tag'},checkPrints.length))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'relative'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'thead-background'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container secondary-page-content printing-page-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__PrintingTable__["a" /* default */],{checkPrints:checkPrints,printsCancelled:printsCancelled,printsConfirmed:printsConfirmed,markPrintsCancelled:this.markPrintsCancelled.bind(this),markPrintsConfirmed:this.markPrintsConfirmed.bind(this),reprint:this.reprint.bind(this)})),checkPrints.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'secretary-page-footer'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-justify container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},'Total ',checkPrints.length,' Item',checkPrints.length>1?"s":""),printsCancelled.length+printsConfirmed.length===checkPrints.length&&(this.props.confirming.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent2',onClick:this.confirmPrinting.bind(this)},'Finish')))));}}]);return PrintingPage;}(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_NavigationComponent__["a" /* default */]);function mapStateToProps(state,ownProps){return{printing:state.checkPrinting.printing,confirming:state.checkPrinting.confirmPrinting,applicationsTable:state.applicationsTable};}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(Object.assign({},__WEBPACK_IMPORTED_MODULE_5__redux_actions_CheckPrintingActions__,{getApplications:__WEBPACK_IMPORTED_MODULE_6__redux_actions_ApplicationsActions__["getApplications"]}),dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(PrintingPage));

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PrintingActions__ = __webpack_require__(502);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PrintingTable=function(_React$Component){_inherits(PrintingTable,_React$Component);function PrintingTable(props){_classCallCheck(this,PrintingTable);var _this=_possibleConstructorReturn(this,(PrintingTable.__proto__||Object.getPrototypeOf(PrintingTable)).call(this,props));_this.state={reverseSort:false};return _this;}_createClass(PrintingTable,[{key:'sortTable',value:function sortTable(){this.setState({reverseSort:!this.state.reverseSort});}},{key:'toggleConfirmPrint',value:function toggleConfirmPrint(checkNumber,event){var checked=event.target.checked;var _props=this.props,printsCancelled=_props.printsCancelled,printsConfirmed=_props.printsConfirmed;this.props.markPrintsConfirmed(checked?[].concat(_toConsumableArray(printsConfirmed),[checkNumber]):printsConfirmed.filter(function(ck){return ck!==checkNumber;}));if(checked&&printsCancelled.indexOf(checkNumber)>=0){this.props.markPrintsCancelled(printsCancelled.filter(function(ck){return ck!==checkNumber;}));}}},{key:'toggleCancelPrint',value:function toggleCancelPrint(checkNumber,event){var checked=event.target.checked;var _props2=this.props,printsCancelled=_props2.printsCancelled,printsConfirmed=_props2.printsConfirmed;this.props.markPrintsCancelled(checked?[].concat(_toConsumableArray(printsCancelled),[checkNumber]):printsCancelled.filter(function(ck){return ck!==checkNumber;}));if(checked&&printsConfirmed.indexOf(checkNumber)>=0){this.props.markPrintsConfirmed(printsConfirmed.filter(function(ck){return ck!==checkNumber;}));}}},{key:'reprint',value:function reprint(check){if(this.props.printedOk.indexOf(check.checkNumber)<0){this.props.reprint([check.printJobId]);}}},{key:'render',value:function render(){var _this2=this;var _props3=this.props,checkPrints=_props3.checkPrints,printsCancelled=_props3.printsCancelled,printsConfirmed=_props3.printsConfirmed;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'table-header table-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'sort active'},'Number',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sort-arrows relative',onClick:this.sortTable.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-android-arrow-dropup'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-android-arrow-dropdown'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Reprint'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Printed Okay'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Cancel Printing'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,checkPrints.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PrintingActions__["a" /* default */],this.props),(this.state.reverseSort?checkPrints.reverse():checkPrints).map(function(check){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:check.checkNumber,className:'table-row deleted'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Number'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'bold-text'},'Check #',check.checkNumber)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Details'},check.applicationId>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-'+(check.card?"check approved":"close error")+'-text icon-left middle'}),'Card ',check.printInstructions&&'- '+check.printInstructions,check.signatureNeeded&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'accent-text3 icon-right'},'Signature Needed'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Reprint'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-printer accent-text primary-hover '+(printsCancelled.indexOf(check.checkNumber)>=0||printsConfirmed.indexOf(check.checkNumber)>=0?"disabled":""),onClick:_this2.reprint.bind(_this2,check)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Confirm Print'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'printed-'+check.checkNumber,className:'custom-check',checked:printsConfirmed.indexOf(check.checkNumber)>=0,onChange:_this2.toggleConfirmPrint.bind(_this2,check.checkNumber)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'printed-'+check.checkNumber,className:'secondary-text'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Cancel Print'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'cancel-print-'+check.checkNumber,className:'custom-check',checked:printsCancelled.indexOf(check.checkNumber)>=0,onChange:_this2.toggleCancelPrint.bind(_this2,check.checkNumber)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'cancel-print-'+check.checkNumber,className:'secondary-text'}))));}))),!checkPrints.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no-results'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-printer'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'No Print Records')));}}]);return PrintingTable;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PrintingTable);

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PrintingActions=function(_React$Component){_inherits(PrintingActions,_React$Component);function PrintingActions(props){_classCallCheck(this,PrintingActions);var _this=_possibleConstructorReturn(this,(PrintingActions.__proto__||Object.getPrototypeOf(PrintingActions)).call(this,props));var checkPrints=props.checkPrints;_this.state={reprintRangeFrom:checkPrints.length?checkPrints[0].checkNumber:'',reprintRangeTo:checkPrints.length?checkPrints[checkPrints.length-1].checkNumber:'',showReprintDropdown:false};return _this;}_createClass(PrintingActions,[{key:'onChange',value:function onChange(event){this.setState(_defineProperty({},event.target.name,event.target.value));}},{key:'onBlurPrintRange',value:function onBlurPrintRange(min,max,e){if(e.target.value<min)this.setState(_defineProperty({},e.target.name,min));else if(e.target.value>max)this.setState(_defineProperty({},e.target.name,max));}},{key:'render',value:function render(){var _this2=this;var checks=this.props.checkPrints;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'no-background-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'flex-center reprint-column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-dropdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-flat reprint-btn',onClick:function onClick(){return _this2.setState({showReprintDropdown:!_this2.state.showReprintDropdown});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'medium-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-printer icon-left'}),'Reprint'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'"icon icon-right ion-android-arrow-drop'+(this.state.showReprintDropdown?"up":"down")})),this.state.showReprintDropdown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-dropdown-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-dropdown-option'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-justify'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'medium-text'},'All')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-dropdown-extension'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-flat btn-flat-primary btn-xs btn-fullWidth btn-flat-primary-background',onClick:this.props.reprint.bind(this,checks.map(function(ck){return ck.printJobId;}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon-printer icon-left'}),'Print'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-dropdown-option'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-justify'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'medium-text'},'Range')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-dropdown-extension'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'reprintRangeFrom',value:this.state.reprintRangeFrom,onChange:this.onChange.bind(this),onBlur:this.onBlurPrintRange.bind(this,checks[0].checkNumber,this.state.reprintRangeTo)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'reprintRangeTo',value:this.state.reprintRangeTo,onChange:this.onChange.bind(this),onBlur:this.onBlurPrintRange.bind(this,this.state.reprintRangeFrom,checks[checks.length-1].checkNumber)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-flat btn-flat-primary btn-xs btn-flat-primary-background',disabled:!this.state.reprintRangeFrom||!this.state.reprintRangeTo||this.state.reprintRangeFrom>this.state.reprintRangeTo||this.state.reprintRangeFrom<checks[0].checkNumber||this.state.reprintRangeTo>checks[checks.length-1].checkNumber,onClick:this.props.reprint.bind(this,checks.filter(function(ck){return ck.checkNumber>=_this2.state.reprintRangeFrom&&ck.checkNumber<=_this2.state.reprintRangeTo;}).map(function(ck){return ck.printJobId;}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon icon-printer icon-left'}),'Print')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'printed-all',className:'custom-check',checked:this.props.printsConfirmed.length===checks.length,onChange:function onChange(e){_this2.props.markPrintsConfirmed(e.target.checked?checks.map(function(ck){return ck.checkNumber;}):[]);if(e.target.checked){_this2.props.markPrintsCancelled([]);}}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'printed-all',className:'secondary-text'},'Select All'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'cancel-print-all',className:'custom-check',checked:this.props.printsCancelled.length===checks.length,onChange:function onChange(e){_this2.props.markPrintsCancelled(e.target.checked?checks.map(function(ck){return ck.checkNumber;}):[]);if(e.target.checked){_this2.props.markPrintsConfirmed([]);}}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'cancel-print-all',className:'secondary-text'},'Select All'))));}}]);return PrintingActions;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PrintingActions);

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_RecipientAccountsActions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_DuplicateRecipientsActions__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions_SidebarFilterActions__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_urlUtils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_throttle_debounce__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_throttle_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_throttle_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__commonComponents_shared_SidebarFilter__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__RecipientAccountsTable__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__manageDuplicates_MergeDuplicatesModal__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__RecipientReportModal__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__PledgeReportModal__ = __webpack_require__(507);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RecipientAccountsPage=function(_NavigationComponent){_inherits(RecipientAccountsPage,_NavigationComponent);function RecipientAccountsPage(props){_classCallCheck(this,RecipientAccountsPage);var _this=_possibleConstructorReturn(this,(RecipientAccountsPage.__proto__||Object.getPrototypeOf(RecipientAccountsPage)).call(this,props));_initialiseProps.call(_this);_this.state={showModals:{search:'',mergeDuplicatesModal:false,reportModal:false,pledgeReportModal:false}};_this.filterRecipients=_this.filterRecipients.bind(_this);return _this;}_createClass(RecipientAccountsPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;if(Object(__WEBPACK_IMPORTED_MODULE_10__lib_urlUtils__["a" /* getQueryParams */])().applyFilters){this.setState({search:this.props.filters.elasticSearchText||''},function(){_this2.props.actions.getRecipientAccounts(_this2.state.search,_this2.props.recipientsTable.page,_this2.props.recipientsTable.resultsView,_this2.props.recipientsTable.sort);});}else{//manually reset and reload data, only if not popped from stack
this.props.actions.resetFilters(__WEBPACK_IMPORTED_MODULE_9__lib_constants__["j" /* TableNames */].Recipients,true);//reset and apply filters
this.props.actions.filterRecipients();//reset table and reload recipients
}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.props.recipientsTable.selected.length){this.props.actions.clearRecipientsSelection();}}},{key:'getSortBy',value:function getSortBy(updatedFilters){var tableSort=this.props.recipientsTable.sort;if(updatedFilters.recipientSearch){tableSort={by:"recipientSearchScore",direction:"Descending"};}else if(updatedFilters.lastName){tableSort={by:"lastNameDiff",direction:"Ascending"};}else if(updatedFilters.firstName){tableSort={by:"firstNameDiff",direction:"Ascending"};}else if(this.props.recipientsTable.sort.by==="recipientSearchScore"||this.props.recipientsTable.sort.by==="lastNameDiff"||this.props.recipientsTable.sort.by==="firstNameDiff"){tableSort=undefined;}return tableSort;}},{key:'filterRecipients',value:function filterRecipients(updatedFilters){var tableSort=this.getSortBy(updatedFilters);this.props.actions.filterRecipients(updatedFilters,this.state.search,this.props.recipientsTable.resultsView,tableSort);if(updatedFilters&&!Object(__WEBPACK_IMPORTED_MODULE_10__lib_urlUtils__["a" /* getQueryParams */])().applyFilters){Object(__WEBPACK_IMPORTED_MODULE_10__lib_urlUtils__["b" /* setQueryParams */])({applyFilters:true});}}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:'page page-with-sidebar applications '+(!this.props.sidebarVisible?"page-with-sidebar-hidden":"")},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__commonComponents_shared_SidebarFilter__["a" /* default */],{type:__WEBPACK_IMPORTED_MODULE_9__lib_constants__["j" /* TableNames */].Recipients,search:this.filterRecipients}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:'subheader recipients-subheader'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:'flex-justify flex-center'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:'flex-one'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('i',{className:'material-icons sidebar-slide-out',onClick:function onClick(){return _this3.props.actions.toggleSidebar(__WEBPACK_IMPORTED_MODULE_9__lib_constants__["j" /* TableNames */].Recipients);}},'filter_list'),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('h2',{className:'page-header'},'Recipients')),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:'flex-one'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:'elastic-search'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:'search-input'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('i',{className:'material-icons'},'search'),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('input',{type:'text',name:'search',placeholder:'Search (Max Results: 100)',value:this.state.search||'',onChange:function onChange(e){return _this3.search(e);}})))),this.props.userPermissions.manage&&this.props.recipientsTable.selected.length>0&&this.getDuplicatesHeader(),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:'flex-one'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:'text-right subheader-btns'},this.props.userPermissions.report&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:'subheader-btns'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('button',{className:'btn btn-flat btn-small',onClick:function onClick(){return _this3.toggleModal("reportModal");},disabled:!this.props.recipientsTable.data.records.length},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('img',{src:'/images/export-icon.png',className:'icon-left',alt:'export-icon'}),'Export'),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('button',{className:'btn btn-flat btn-small',onClick:function onClick(){return _this3.toggleModal("pledgeReportModal");},disabled:!this.props.recipientsTable.data.records.length},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('img',{src:'/images/export-icon.png',className:'icon-left',alt:'export-icon'}),'Pledge Report')),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:'/recipient-accounts/references',className:'btn btn-primary btn-small'},'Manage References'))))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__RecipientAccountsTable__["a" /* default */],Object.assign({},this.props.recipientsTable,{updateTable:this.props.actions.updateTable,getRecipients:this.getRecipientAccounts,deleteRecipient:this.props.actions.deleteRecipientAccount,canDelete:this.props.userPermissions.manage,canViewApplications:this.props.userPermissions.viewApplications,selectRecipient:this.props.actions.toggleSelectRecipient})),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__manageDuplicates_MergeDuplicatesModal__["a" /* default */],{show:this.state.showModals.mergeDuplicatesModal,close:function close(){return _this3.toggleModal("mergeDuplicatesModal");},duplicatesDetails:this.props.duplicateRecipients.duplicatesDetails,mergeDuplicates:this.props.actions.resolveDuplicateRecipients,onMergeDuplicates:function onMergeDuplicates(){return _this3.props.actions.getRecipientAccounts(_this3.state.search,_this3.props.recipientsTable.page,_this3.props.recipientsTable.resultsView,_this3.props.recipientsTable.sort);},mergingDuplicates:this.props.duplicateRecipients.resolvingDuplicates}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__RecipientReportModal__["a" /* default */],{getDataForExport:this.getRecipientsForExport.bind(this),'export':this.props.export,show:this.state.showModals.reportModal,close:function close(){return _this3.toggleModal("reportModal");}}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__PledgeReportModal__["a" /* default */],{show:this.state.showModals.pledgeReportModal,close:function close(){return _this3.toggleModal("pledgeReportModal");},onDownload:this.downloadPledgeReport}));}}]);return RecipientAccountsPage;}(__WEBPACK_IMPORTED_MODULE_13__commonComponents_util_NavigationComponent__["a" /* default */]);var _initialiseProps=function _initialiseProps(){var _this4=this;this.getRecipientAccounts=function(){var _props$actions;for(var _len=arguments.length,props=Array(_len),_key=0;_key<_len;_key++){props[_key]=arguments[_key];}(_props$actions=_this4.props.actions).getRecipientAccounts.apply(_props$actions,[_this4.state.search].concat(props));if(props&&!Object(__WEBPACK_IMPORTED_MODULE_10__lib_urlUtils__["a" /* getQueryParams */])().applyFilters){Object(__WEBPACK_IMPORTED_MODULE_10__lib_urlUtils__["b" /* setQueryParams */])({applyFilters:true});}};this.getRecipientsForExport=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(props){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this4.props.actions.getRecipientsForExport(props.fields,props.groupBy);case 2:case'end':return _context.stop();}}},_callee,_this4);}));return function(_x){return _ref.apply(this,arguments);};}();this.downloadPledgeReport=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(params){var response,data,values,records,exportHeaders,dateNow,reportName;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this4.props.actions.getPledgesReport(params.fundIds,params.includeClosed);case 2:response=_context2.sent;if(!(!response||!response.success)){_context2.next=5;break;}throw new Error('error');case 5:data=response.data||{};values=data.values||data.Values||data;records=Array.isArray(values)?values:[];if(records.length){_context2.next=10;break;}throw new Error('noData');case 10:exportHeaders=Object.keys(records[0]).map(function(key){return{label:key,value:key,default:''};});dateNow=''+new Date().toLocaleDateString().replace(/\//g,"_");reportName='pledges_'+dateNow;Object(__WEBPACK_IMPORTED_MODULE_11__lib_utils__["g" /* exportCSVFile */])(exportHeaders,records,reportName);case 14:case'end':return _context2.stop();}}},_callee2,_this4);}));return function(_x2){return _ref2.apply(this,arguments);};}();this.search=function(e){_this4.setState({search:e.target.value});if(!Object(__WEBPACK_IMPORTED_MODULE_10__lib_urlUtils__["a" /* getQueryParams */])().applyFilters){Object(__WEBPACK_IMPORTED_MODULE_10__lib_urlUtils__["b" /* setQueryParams */])({applyFilters:true});}_this4.searchDebounce();};this.searchDebounce=Object(__WEBPACK_IMPORTED_MODULE_12_throttle_debounce__["debounce"])(400,function(){_this4.props.actions.getRecipientAccounts(_this4.state.search,_this4.props.recipientsTable.page,_this4.props.recipientsTable.resultsView);});this.getDuplicatesHeader=function(){var _props=_this4.props,duplicateRecipients=_props.duplicateRecipients,recipientsTable=_props.recipientsTable;var selection=recipientsTable.selected;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{className:'text-right subheader-btns flex-center duplicates-container'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('p',null,'Duplicate Recipients:',__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('span',null,selection[0].name,'  ',__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('i',{className:'material-icons',onClick:function onClick(){return _this4.props.actions.toggleSelectRecipient(selection[0]);}},'close')),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('span',null,"  &  "),selection[1]?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('span',null,selection[1].name,'  ',__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('i',{className:'material-icons',onClick:function onClick(){return _this4.props.actions.toggleSelectRecipient(selection[1]);}},'close')):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('span',{className:'accent-text'},'None Selected')),duplicateRecipients.resolvingDuplicates.loading?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'12'}):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('button',{className:'btn btn-accent btn-small',disabled:selection.length!==2,onClick:_this4.mergeDuplicates},'Merge'),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:!duplicateRecipients.resolvingDuplicates.success,message:duplicateRecipients.resolvingDuplicates.message}));};this.mergeDuplicates=function(){var duplicates=_this4.props.recipientsTable.selected;_this4.props.actions.getDuplicateRecipientsDetails(duplicates[0].applicantId,duplicates[1].applicantId);//open modal and clear out table selection
_this4.toggleModal("mergeDuplicatesModal");duplicates.forEach(function(recipient){return _this4.props.actions.toggleSelectRecipient(recipient);});};};function mapStateToProps(state){return Object.assign({},state.recipientAccounts,{recipientsTable:state.recipientsTable,sidebarVisible:state.recipientsSidebarFilters.showSidebar,duplicateRecipients:state.duplicateRecipients,userPermissions:{manage:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["j" /* PermissionTypes */].RecipientAccntsManage)>=0,report:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["j" /* PermissionTypes */].Reporting)>=0,viewApplications:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsView)>=0}});}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(Object.assign({},__WEBPACK_IMPORTED_MODULE_5__redux_actions_RecipientAccountsActions__,{getDuplicateRecipientsDetails:__WEBPACK_IMPORTED_MODULE_6__redux_actions_DuplicateRecipientsActions__["getDuplicateRecipientsDetails"],resolveDuplicateRecipients:__WEBPACK_IMPORTED_MODULE_6__redux_actions_DuplicateRecipientsActions__["resolveDuplicateRecipients"],toggleSidebar:__WEBPACK_IMPORTED_MODULE_7__redux_actions_SidebarFilterActions__["toggleSidebar"],resetFilters:__WEBPACK_IMPORTED_MODULE_7__redux_actions_SidebarFilterActions__["resetFilters"]}),dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(RecipientAccountsPage));

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_PaginatedTable__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RecipientAccountsTableRow__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_shared_ConfirmationModal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RecipientAccountsTable=function(_NavigationComponent){_inherits(RecipientAccountsTable,_NavigationComponent);function RecipientAccountsTable(props){_classCallCheck(this,RecipientAccountsTable);var _this=_possibleConstructorReturn(this,(RecipientAccountsTable.__proto__||Object.getPrototypeOf(RecipientAccountsTable)).call(this,props));_this.initialState={selectedRecord:{},showModals:{confirmationModal:false}};_this.state=_this.initialState;_this.getTableRow=_this.getTableRow.bind(_this);return _this;}_createClass(RecipientAccountsTable,[{key:'getTableRow',value:function getTableRow(recipient){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RecipientAccountsTableRow__["a" /* default */],{key:recipient.applicantId,recipient:recipient,selectRecipient:this.props.selectRecipient,selected:this.props.selected.map(function(rec){return rec.applicantId;}).indexOf(recipient.applicantId)>=0,canSelect:this.props.selected.length<2,canDelete:this.props.canDelete,canViewApplications:this.props.canViewApplications,includeTeudatZahut:this.props.data.records.some(function(d){return!!d.teudatZahut;}),'delete':function _delete(){_this2.setState({selectedRecord:recipient},_this2.toggleModal.bind(_this2,"confirmationModal"));}});}},{key:'render',value:function render(){var _this3=this;var includeTeudatZahut=this.props.data.records.some(function(d){return!!d.teudatZahut;});var columns=[{title:'',sortable:false,id:'select'},{title:'First Name',sortable:true,id:'firstName'},{title:'Last / Org Name',sortable:true,id:'lastOrOrgName'},{title:'Address',sortable:true,id:'address'},{title:'Teudat Zahut',sortable:true,id:'teudatZahut',hidden:!includeTeudatZahut},{title:'Category',sortable:true,id:'tag'},{title:'Last Application',sortable:true,id:'lastApplication',defaultDirection:'Descending'},{title:'Total',sortable:true,id:'total',className:'text-right'}];if(this.props.canDelete)columns.push({title:'',sortable:false,id:'delete'});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_PaginatedTable__["a" /* default */],{name:'recipients',page:this.props.page,totalCount:this.props.data.totalCount,resultsView:this.props.resultsView,sort:this.props.sort,loading:this.props.loading,success:this.props.success,renderRow:this.getTableRow,columns:columns,records:this.props.data.records||[],sortData:this.props.updateTable,changeDataView:this.props.updateTable,loadData:this.props.getRecipients,noReload:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_shared_ConfirmationModal__["a" /* default */],{show:this.state.showModals.confirmationModal,message:this.state.selectedRecord.applicantId?'Are you sure you want to permanently delete the account of '+(this.state.selectedRecord.name||'this recipient')+'?':'',close:function close(){_this3.setState({selectedRecord:_this3.initialState.selectedRecord});_this3.toggleModal("confirmationModal");},confirm:function confirm(){return _this3.props.deleteRecipient(_this3.state.selectedRecord.applicantId);},loading:this.props.removing.loading,success:this.props.removing.success,errorMessage:this.props.removing.message}));}}]);return RecipientAccountsTable;}(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (RecipientAccountsTable);

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_HoverTableRow__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_shared_ApplicationStatusTag__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__applicationsComponents_applications_RecipientSummaryCard__ = __webpack_require__(171);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RecipientAccountsTableRow=function(_NavigationComponent){_inherits(RecipientAccountsTableRow,_NavigationComponent);function RecipientAccountsTableRow(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RecipientAccountsTableRow);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RecipientAccountsTableRow.__proto__||Object.getPrototypeOf(RecipientAccountsTableRow)).call.apply(_ref,[this].concat(args))),_this),_this.state={summaryOpen:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RecipientAccountsTableRow,[{key:'render',value:function render(){var _this2=this;var _props$recipient=this.props.recipient,applicantId=_props$recipient.applicantId,lastApplication=_props$recipient.lastApplication,firstName=_props$recipient.firstName,lastOrOrgName=_props$recipient.lastOrOrgName,addressDisplay=_props$recipient.addressDisplay,tags=_props$recipient.tags,applicantType=_props$recipient.applicantType,total=_props$recipient.total,canBeDeleted=_props$recipient.canBeDeleted,incomplete=_props$recipient.incomplete,reportName=_props$recipient.reportName,teudatZahut=_props$recipient.teudatZahut;var tooltipText=reportName&&reportName!==lastOrOrgName?lastOrOrgName+' - Report name: '+reportName:lastOrOrgName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_HoverTableRow__["a" /* default */],{className:'table-row '+(this.state.summaryOpen?'recipient-summary-open':''),onClick:this.pushRouteWithProps.bind(this,'/recipient-accounts/'+applicantId,{prevPage:'Recipients'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-check-container name-check-container '+(!this.props.selected&&!this.props.canSelect?"disabled":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'select-'+applicantId,className:'custom-check input',checked:this.props.selected,onChange:function onChange(){return _this2.props.selectRecipient(_this2.props.recipient);},disabled:!this.props.selected&&!this.props.canSelect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'select-'+applicantId,className:'secondary-text input'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'FirstName'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,firstName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Name',className:'recipient-name-col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recipient-name-layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bold-text recipient-name-content'},applicantType===__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["l" /* RecipientTypes */].Organization?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons accent-text3 middle recipient-name-icon '+(incomplete?'disabled':'')},'business'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons accent-text2 middle recipient-name-icon '+(incomplete?'disabled':'')},'person'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{className:'recipient-name-link',to:'/recipient-accounts/'+applicantId,title:tooltipText||undefined},lastOrOrgName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recipient-name-actions'},incomplete&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag incomplete'},'Incomplete'),this.props.canViewApplications&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__applicationsComponents_applications_RecipientSummaryCard__["a" /* default */],{recipientId:applicantId,onOpenChange:function onOpenChange(summaryOpen){return _this2.setState({summaryOpen:summaryOpen});},title:(''+(firstName?firstName+' ':'')+(lastOrOrgName||'')).trim()})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Address'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,addressDisplay)),this.props.includeTeudatZahut&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'TeudatZahut'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,teudatZahut)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Category'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,tags.join(' | '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Last Application'},lastApplication.applicationId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex recipient-last-application-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_shared_ApplicationStatusTag__["a" /* default */],{status:lastApplication.status})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["j" /* formatCurrency */])(lastApplication.amount,lastApplication.currency===__WEBPACK_IMPORTED_MODULE_6__lib_systemVariables__["f" /* CurrencyTypes */].Shekel)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'accent-text recipient-last-application-date'},Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["k" /* formatDate */])(lastApplication.date)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Total',className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,total)),this.props.canDelete&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Delete'},canBeDeleted&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-trash trash-hover input',onClick:this.props.delete})));}}]);return RecipientAccountsTableRow;}(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (RecipientAccountsTableRow);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function getReportFields(){return[{label:"Title",value:"Title",default:""},{label:"Last Name/Org Name",value:"LastOrOrgName",default:""},{label:"First Name",value:"FirstName",default:""},{label:"Report Name",value:"ReportName",default:""},{label:"Phone Number(s)",value:"PhoneNumbers",default:""},{label:"Email Address",value:"EmailAddress",default:""},{label:"Address",value:"Address",default:""},{label:"City",value:"City",default:""},{label:"State",value:"State",default:""},{label:"Zip",value:"Zip",default:""},{label:"Country",value:"Country",default:""},{label:"Categories",value:"Categories",default:""},{label:"Reference(s)",value:"References",default:""},{label:"Solicitor(s)",value:"Solicitors",default:""},{label:"Rosh Yeshiva(s)",value:"RoshYeshivas",default:""},{label:"Campaign List(s)",value:"CampaignLists",default:""},{label:"Notes",value:"Notes",default:""},{label:"Total",value:"Total",default:""}];}var initialState={fields:[],groupBy:"",error:false,noData:false,downloading:false,submitAttempted:false};var ReportModal=function(_React$Component){_inherits(ReportModal,_React$Component);function ReportModal(props){_classCallCheck(this,ReportModal);var _this=_possibleConstructorReturn(this,(ReportModal.__proto__||Object.getPrototypeOf(ReportModal)).call(this,props));_this.onChange=function(name,value){_this.setState(_defineProperty({},name,value));};_this.onToggleReportFields=function(event){var fieldName=event.target.name;var checked=event.target.checked;var fields=[].concat(_toConsumableArray(_this.state.fields));if(checked){fields.push(fieldName);}else{fields=fields.filter(function(f){return f!==fieldName;});if(_this.state.groupBy===fieldName){_this.setState({groupBy:""});}}_this.setState({fields:fields});};_this.state=initialState;return _this;}_createClass(ReportModal,[{key:"close",value:function close(){this.setState(initialState);this.props.close();}},{key:"exportData",value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _state,fields,groupBy,dateNow,reportFields,params,exportHeaders,reportName,response,records;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({error:false,noData:false,submitAttempted:true});_state=this.state,fields=_state.fields,groupBy=_state.groupBy;if(fields.length){_context.next=4;break;}return _context.abrupt("return");case 4:this.setState({downloading:true});_context.prev=5;dateNow=""+new Date().toLocaleDateString().replace(/\//g,"_");reportFields=getReportFields();params={fields:fields,groupBy:groupBy};exportHeaders=reportFields.filter(function(field){return fields.indexOf(field.value)>=0;});reportName="recipients_"+dateNow;_context.next=13;return this.props.getDataForExport(params);case 13:response=this.props.export;if(response.success){_context.next=16;break;}throw Error("error");case 16:records=response.data.values;if(records.length){_context.next=19;break;}throw Error("noData");case 19:exportHeaders=exportHeaders.map(function(_ref2){var getValue=_ref2.getValue,header=_objectWithoutProperties(_ref2,["getValue"]);return Object.assign({},header,{value:getValue||header.value});});Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["g" /* exportCSVFile */])(exportHeaders,records,reportName);this.setState({downloading:false},this.close);_context.next=27;break;case 24:_context.prev=24;_context.t0=_context["catch"](5);this.setState(_defineProperty({downloading:false},_context.t0.message||"error",true));case 27:case"end":return _context.stop();}}},_callee,this,[[5,24]]);}));function exportData(){return _ref.apply(this,arguments);}return exportData;}()},{key:"render",value:function render(){var _this2=this;var _state2=this.state,error=_state2.error,fields=_state2.fields,groupBy=_state2.groupBy,downloading=_state2.downloading,noData=_state2.noData,submitAttempted=_state2.submitAttempted;var show=this.props.show;var reportFields=getReportFields();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal new-fund-modal large-modal"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"bordered-modal-header"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",{className:"modal-page-header"},"Recipients Report"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon ion-ios-close-empty",onClick:this.close.bind(this)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"mb-16"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"flex"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"input-label "+(submitAttempted&&!fields.length?"error-label":"")},"Report Fields"),submitAttempted&&!fields.length&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"xs-text error-text ml-8"},"* Please select report fields")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row report-fields-grid"},reportFields.map(function(field){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-check-container",key:field.value},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",id:"report-field-"+field.value,className:"custom-check",name:field.value,onChange:_this2.onToggleReportFields,checked:fields.indexOf(field.value)>=0}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{htmlFor:"report-field-"+field.value,className:"secondary-text"},field.label));}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half column-half-left"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"input-label"},"Remove Duplicates Of"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__["a" /* default */],{clearable:true,options:reportFields.filter(function(field){return fields.indexOf(field.value)>=0;}).map(function(field){return{key:field.value,value:field.label};}),value:groupBy,name:"groupBy",onChange:function onChange(e){return _this2.onChange(e.target.name,e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-btns text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-accent",onClick:this.close.bind(this)},"Cancel"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-primary",onClick:this.exportData.bind(this),disabled:downloading},downloading?"Downloading Report":"Download Report"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:error}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:noData,message:"No data was found.",timeOut:5000})))));}}]);return ReportModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ReportModal);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_AutocompleteMultiInput__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions_FundsActions__ = __webpack_require__(34);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PledgeReportModal=function(_React$Component){_inherits(PledgeReportModal,_React$Component);function PledgeReportModal(props){var _this2=this;_classCallCheck(this,PledgeReportModal);var _this=_possibleConstructorReturn(this,(PledgeReportModal.__proto__||Object.getPrototypeOf(PledgeReportModal)).call(this,props));_this.close=function(){_this.setState({selectedFunds:[],includeClosed:false,submitAttempted:false,downloading:false});_this.props.close();};_this.onToggleIncludeClosed=function(e){_this.setState({includeClosed:e.target.checked});};_this.onUpdateFunds=function(name,selections){_this.setState({selectedFunds:selections||[]});};_this.onDownload=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var selectedFunds,params,isNoData,errorMessage;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:selectedFunds=_this.state.selectedFunds;_this.setState({submitAttempted:true});_context.prev=2;_this.setState({downloading:true});params={fundIds:selectedFunds,includeClosed:_this.state.includeClosed};// Delegate to parent handler (to be wired to API)
_context.next=7;return Promise.resolve(_this.props.onDownload&&_this.props.onDownload(params));case 7:_this.setState({downloading:false},_this.close);_context.next=16;break;case 10:_context.prev=10;_context.t0=_context["catch"](2);isNoData=_context.t0&&_context.t0.message==="noData";errorMessage=isNoData?"No data found for the selected criteria.":"Something went wrong. Please try again.";__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error("Report download failed",errorMessage);_this.setState({downloading:false},_this.close);case 16:case"end":return _context.stop();}}},_callee,_this2,[[2,10]]);}));_this.state={selectedFunds:[],includeClosed:false,submitAttempted:false,downloading:false};return _this;}_createClass(PledgeReportModal,[{key:"componentDidMount",value:function componentDidMount(){if(!this.props.fundsLoaded&&!this.props.fundsLoading){this.props.actions.getFunds();}}},{key:"render",value:function render(){var _props=this.props,show=_props.show,fundsOptions=_props.fundsOptions;var _state=this.state,selectedFunds=_state.selectedFunds,includeClosed=_state.includeClosed,downloading=_state.downloading;var options=(fundsOptions||[]).map(function(f){return{key:f.key,value:f.value};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Modal__["a" /* default */],{modalShowing:show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal new-fund-modal large-modal pledge-report-modal"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"bordered-modal-header"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",{className:"modal-page-header"},"Pledge Report"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon ion-ios-close-empty",onClick:this.close})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row modal-row-full-width"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"flex"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"input-label"},"Funds")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_AutocompleteMultiInput__["a" /* default */],{name:"fundIds",options:options,selection:selectedFunds,placeholder:"Select funds",disabled:!options.length,update:this.onUpdateFunds}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row modal-row-full-width pledge-report-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-check-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",id:"include-closed-pledges",className:"custom-check",name:"includeClosed",checked:includeClosed,onChange:this.onToggleIncludeClosed}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{htmlFor:"include-closed-pledges",className:"secondary-text"},"Include Closed Pledges"))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-btns text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-accent",onClick:this.close},"Cancel"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-primary",onClick:this.onDownload,disabled:downloading},downloading?"Downloading Report":"Download Report")))));}}]);return PledgeReportModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);function mapStateToProps(state){return{fundsOptions:state.funds.fundsByDept.all,fundsLoaded:(state.funds.fundsByDept.all||[]).length>0,fundsLoading:state.funds.fundsByDept.loading};}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({getFunds:__WEBPACK_IMPORTED_MODULE_7__redux_actions_FundsActions__["getFunds"]},dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(PledgeReportModal));

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_RecipientAccountsActions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_ApplicationsActions__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions_CheckPrintingActions__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_actions_SettingsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_actions_FundsActions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_query_string__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RecipientAccountNavigationHeader__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__RecipientAccountDetails__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RecipientAccountCampaignsTable__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__RecipientAccountApplications__ = __webpack_require__(517);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RecipientAccountDetailsPage=function(_React$Component){_inherits(RecipientAccountDetailsPage,_React$Component);function RecipientAccountDetailsPage(props){_classCallCheck(this,RecipientAccountDetailsPage);var _this=_possibleConstructorReturn(this,(RecipientAccountDetailsPage.__proto__||Object.getPrototypeOf(RecipientAccountDetailsPage)).call(this,props));_initialiseProps.call(_this);_this.state={currentRecipientId:_this.props.match.params.id,currentApplicationId:parseInt(__WEBPACK_IMPORTED_MODULE_11_query_string___default.a.parse(props.history.location.search).applicationId)||null,prevPage:props.location.state?props.location.state.prevPage:'',recipientEditMode:false,applicationEditMode:false};return _this;}_createClass(RecipientAccountDetailsPage,[{key:'componentWillMount',value:function componentWillMount(){this.getAccountDetails(this.state.currentRecipientId,this.state.currentApplicationId);}},{key:'getAccountDetails',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(recipientId,applicationId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.getRecipientDetails(recipientId);this.getRecipientApplicationHistory(recipientId,applicationId);if(this.state.currentRecipientId!==recipientId){this.props.history.replace({pathname:'/recipient-accounts/'+recipientId});this.setState({currentRecipientId:recipientId});}if(applicationId&&this.state.currentApplicationId!==applicationId){this.props.history.replace({search:'?applicationId='+applicationId});this.setState({currentApplicationId:applicationId});}case 4:case'end':return _context.stop();}}},_callee,this);}));function getAccountDetails(_x,_x2){return _ref.apply(this,arguments);}return getAccountDetails;}()},{key:'getRecipientDetails',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(recipientId,reload){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return this.props.actions.getRecipientAccountDetails(recipientId,reload);case 2:if(!this.props.recipientDetails.success){__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error('Something went wrong','We were unable to retrieve recipient details. Please try again');}case 3:case'end':return _context2.stop();}}},_callee2,this);}));function getRecipientDetails(_x3,_x4){return _ref2.apply(this,arguments);}return getRecipientDetails;}()},{key:'getRecipientApplicationHistory',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(recipientId,applicationId){var appHistory;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return this.props.actions.getRecipientApplicationHistory(recipientId);case 2:if(this.props.applicationHistory.success){appHistory=this.props.applicationHistory.data;this.selectApplication(applicationId||(appHistory.length?appHistory[0].applicationId:null),recipientId);}else{__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error('Something went wrong','We were unable to retrieve the application history for this recipient.  Please try again.');}case 3:case'end':return _context3.stop();}}},_callee3,this);}));function getRecipientApplicationHistory(_x5,_x6){return _ref3.apply(this,arguments);}return getRecipientApplicationHistory;}()},{key:'selectApplication',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(applicationId,recipientId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(!applicationId){_context4.next=5;break;}_context4.next=3;return this.getApplicationDetails(applicationId,false,recipientId);case 3:_context4.next=7;break;case 5:this.props.history.replace({search:''});this.setState({currentApplicationId:null});case 7:case'end':return _context4.stop();}}},_callee4,this);}));function selectApplication(_x7,_x8){return _ref4.apply(this,arguments);}return selectApplication;}()},{key:'getApplicationDetails',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(applicationId,updateHistory,recipientId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(!applicationId){_context5.next=5;break;}if(applicationId&&this.state.currentApplicationId!==applicationId){this.props.history.replace({search:'?applicationId='+applicationId});this.setState({currentApplicationId:applicationId});}_context5.next=4;return this.props.actions.getApplicationDetails(applicationId,updateHistory,recipientId);case 4:if(!this.props.applicationDetails.success)__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error('Something went wrong','We were unable to retrieve application details.  Please try again.');case 5:case'end':return _context5.stop();}}},_callee5,this);}));function getApplicationDetails(_x9,_x10,_x11){return _ref5.apply(this,arguments);}return getApplicationDetails;}()},{key:'render',value:function render(){var _this2=this;var recipientDetails=this.props.recipientDetails.data;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__RecipientAccountNavigationHeader__["a" /* default */],{history:this.props.history,prevPage:this.state.prevPage,campaignId:this.props.location.state?this.props.location.state.campaignId:null,campaignListId:this.props.location.state?this.props.location.state.campaignListId:null,applicationId:this.props.location.state?this.props.location.state.applicationId:null,recipientId:this.state.currentRecipientId,getApplicationsToRecipientIdsMapping:this.props.actions.getApplicationsToRecipientIdsMapping,applicationsToRecipientIdsMapping:this.props.applications.applicationsToRecipientIdsMapping,getAccountDetails:this.getAccountDetails.bind(this)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},this.props.permissions.recipients.view&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__RecipientAccountDetails__["a" /* default */],{editMode:this.state.recipientEditMode,toggleEditMode:function toggleEditMode(){return _this2.toggleEditMode("recipientEditMode");},disableEditMode:this.state.applicationEditMode||this.props.applicationHistory.loading||!this.props.applicationHistory.success,recipientDetails:this.props.recipientDetails,applicationHistory:this.props.applicationHistory.data,updateRecipient:this.props.actions.updateRecipientDetails,updateRecipientDetails:this.props.updateRecipientDetails,getRecipientDetails:this.getRecipientDetails.bind(this),getApplicationHistory:this.getRecipientApplicationHistory.bind(this,this.state.currentRecipientId,this.state.currentApplicationId),addNote:this.props.actions.addRecipientNote,updateNote:this.props.actions.updateRecipientNote,deleteNote:this.props.actions.deleteRecipientNote,updatingNote:this.props.recipientNotesUpdate,userId:this.props.userId,permissions:this.props.permissions.recipients,isAdmin:this.props.permissions.admin,isApprover:this.props.permissions.approver,tags:{usPersonTitles:this.props.systemSettings.recipientSettings.usPersonTitles,israelPersonTitles:this.props.systemSettings.recipientSettings.israelPersonTitles,usInstitutionTitles:this.props.systemSettings.recipientSettings.usInstitutionTitles,israelInstitutionTitles:this.props.systemSettings.recipientSettings.israelInstitutionTitles,recipientTypes:this.props.systemSettings.otherSettings.recipientTypes,categories:{individualTags:this.props.systemSettings.recipientSettings.individualTags,organizationTags:this.props.systemSettings.recipientSettings.organizationTags},nationalities:this.props.systemSettings.otherSettings.nationalities,cities:this.props.systemSettings.otherSettings.cities,orgEmploymentTypes:this.props.systemSettings.otherSettings.orgEmploymentTypes},getSystemSettings:this.props.actions.getSystemSettings}),this.props.permissions.campaigns.view&&recipientDetails.applicantType==='Organization'&&(recipientDetails.campaignListId||recipientDetails.campaigns&&recipientDetails.campaigns.length>0)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__RecipientAccountCampaignsTable__["a" /* default */],{campaigns:recipientDetails.campaigns,campaignListId:recipientDetails.campaignListId}),this.props.permissions.applications.view&&recipientDetails.applicantId&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__RecipientAccountApplications__["a" /* default */],{editMode:this.state.applicationEditMode,toggleEditMode:function toggleEditMode(){return _this2.toggleEditMode("applicationEditMode");},disableEditMode:this.state.recipientEditMode,recipientDetails:recipientDetails,applicationHistory:this.props.applicationHistory,currentApplicationId:this.state.currentApplicationId,currentApplicationDetails:this.props.applicationDetails,selectApplication:this.selectApplication.bind(this),getApplicationDetails:this.getApplicationDetails.bind(this),updateApplicationStatus:this.props.actions.updateApplicationsStatus,revertApplicationStatus:this.props.actions.revertApplicationStatus,applicationStatusUpdate:this.props.applications.updating,printCheck:this.props.actions.printChecks,printing:this.props.checkPrinting.printing,confirmPrinting:this.props.actions.confirmChecksPrinted,confirmingPrinting:this.props.checkPrinting.confirmPrinting,wireApplication:this.props.actions.wireApplications,sendACH:this.props.actions.sendACHApplications,sendingACH:this.props.applications.sendingACH,voidPayment:this.props.actions.voidApplicationPayment,voidingPayment:this.props.applications.voidingPayment,addNote:this.props.actions.addApplicationNote,updateNote:this.props.actions.updateApplicationNote,deleteNote:this.props.actions.deleteApplicationNote,updatingNote:this.props.applicationNotesUpdate,updateAttachments:this.props.actions.updateApplicationAttachments,updatingAttachments:this.props.applicationAttachmentsUpdate,updateReceipts:this.props.actions.updateApplicationReceipts,deleteReceipt:this.props.actions.deleteApplicationReceipt,updatingReceipts:this.props.applicationReceiptsUpdate,userId:this.props.userId,permissions:this.props.permissions,funds:this.props.funds,getBlankChecks:this.props.actions.getBlankChecks,blankChecks:this.props.blankChecks,manualPaymentTypes:this.props.systemSettings.otherSettings.manualPaymentTypes,updateApplication:this.props.actions.updateApplicationDetails,updateApplicationDetails:this.props.updateApplicationDetails,getApplicationHistory:this.getRecipientApplicationHistory.bind(this,this.state.currentRecipientId,this.state.currentApplicationId),getRecipientApplicationsForExport:this.getRecipientApplicationsForExport.bind(this),'export':this.props.export,tags:{applicationReasons:recipientDetails.applicantType===__WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__["l" /* RecipientTypes */].Organization?this.props.systemSettings.applicationSettings.organizationApplicationReasons:this.props.systemSettings.applicationSettings.individualApplicationReasons,approvers:this.props.tags.approvers,cardTypes:this.props.systemSettings.printSettings.cardTypes,references:this.props.tags.references,recipientTypes:this.props.systemSettings.otherSettings.recipientTypes,usFunds:this.props.tags.funds.US,israeliFunds:this.props.tags.funds.IL,defaultUSFund:this.props.tags.defaultUSFund,defaultIsraelFund:this.props.tags.defaultIsraelFund,campaignIndivCategories:this.props.systemSettings.campaignSettings.campaignIndivCategories}})));}}]);return RecipientAccountDetailsPage;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this3=this;this.getRecipientApplicationsForExport=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(props){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return _this3.props.actions.getRecipientApplicationsForExport(props.fields,props.recipientId,props.startDate,props.endDate);case 2:case'end':return _context6.stop();}}},_callee6,_this3);}));return function(_x12){return _ref6.apply(this,arguments);};}();this.toggleEditMode=function(editMode){return _this3.setState(_defineProperty({},editMode,!_this3.state[editMode]));};};function mapStateToProps(state,ownProps){return Object.assign({},state.recipientAccountDetails,{applications:state.applications,checkPrinting:state.checkPrinting,userId:state.userProfile.profile.data.userId,permissions:{recipients:{view:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__["j" /* PermissionTypes */].RecipientAccntsView)>=0,manage:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__["j" /* PermissionTypes */].RecipientAccntsManage)>=0},campaigns:{view:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__["j" /* PermissionTypes */].CampaignAndListsView)>=0},applications:{view:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsView)>=0,manage:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsManage)>=0,approveFull:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsApproveFull)>=0,approveLimited:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsApproveLimited)>=0,wire:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__["j" /* PermissionTypes */].PaymentsWire)>=0,print:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__["j" /* PermissionTypes */].PaymentsPrint)>=0,void:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__["j" /* PermissionTypes */].PaymentsVoid)>=0,private:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsPrivate)>=0},accounting:{manage:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__["j" /* PermissionTypes */].AccountingManage)>=0},admin:state.userProfile.profile.data.roleId===1,approver:state.userProfile.profile.data.roleId===3},blankChecks:state.fundDetails.blankChecks,systemSettings:state.settings.systemSettings.data,tags:{campaigns:state.campaigns.campaigns.data,organizations:state.recipientAccounts.organizations.data,approvers:state.users.approvers.data,references:state.references.references.data,funds:state.funds.fundsByDept,defaultUSFund:state.settings.systemSettings.data.fundSettings.defaultUSFund,defaultIsraelFund:state.settings.systemSettings.data.fundSettings.defaultIsraelFund},userProfile:state.userProfile,funds:state.funds.fundsByDept.allWithLimits});}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(Object.assign({},__WEBPACK_IMPORTED_MODULE_5__redux_actions_RecipientAccountsActions__,__WEBPACK_IMPORTED_MODULE_6__redux_actions_ApplicationsActions__,__WEBPACK_IMPORTED_MODULE_7__redux_actions_CheckPrintingActions__,{getBlankChecks:__WEBPACK_IMPORTED_MODULE_9__redux_actions_FundsActions__["getBlankChecks"],getSystemSettings:__WEBPACK_IMPORTED_MODULE_8__redux_actions_SettingsActions__["getSystemSettings"]}),dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(RecipientAccountDetailsPage));

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RecipientAccountNavigationHeader=function(_React$Component){_inherits(RecipientAccountNavigationHeader,_React$Component);function RecipientAccountNavigationHeader(props){_classCallCheck(this,RecipientAccountNavigationHeader);var _this=_possibleConstructorReturn(this,(RecipientAccountNavigationHeader.__proto__||Object.getPrototypeOf(RecipientAccountNavigationHeader)).call(this,props));_this.getCurrentNavIndex=function(){var currentApplicationId=_this.props.applicationId;if(!currentApplicationId){return _this.props.applicationsToRecipientIdsMapping.data.orderedApplications.indexOf(parseInt(_this.props.recipientId));}return _this.props.applicationsToRecipientIdsMapping.data.orderedApplications.indexOf(currentApplicationId);};_this.state={currentIndex:_this.getCurrentNavIndex()};return _this;}_createClass(RecipientAccountNavigationHeader,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;window.onbeforeunload=function(){if(_this2.props.prevPage&&_this2.props.prevPage.indexOf("Applications")>0&&_this2.props.prevPage.indexOf("Campaign List")<0){//because redux store with application table configuration will be cleared out, reset prevPage to Applications so navigation component is hidden
_this2.props.history.replace({state:Object.assign({},_this2.props.history.location.state,{prevPage:"Applications"})});}};}},{key:'componentWillMount',value:function componentWillMount(){if(this.props.prevPage&&(this.props.prevPage.indexOf("Applications")>=0||this.props.prevPage.indexOf("Campaign")>=0||this.props.prevPage.indexOf("Campaign List")>=0)){this.getApplicationsNavigationMapping();}}},{key:'getApplicationsNavigationMapping',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.getApplicationsToRecipientIdsMapping(this.props.campaignId,this.props.campaignListId);case 2:if(this.props.applicationsToRecipientIdsMapping.success){this.setState({currentIndex:this.getCurrentNavIndex()});}case 3:case'end':return _context.stop();}}},_callee,this);}));function getApplicationsNavigationMapping(){return _ref.apply(this,arguments);}return getApplicationsNavigationMapping;}()},{key:'navigate',value:function navigate(next){var newIndex=next?this.state.currentIndex+1:this.state.currentIndex-1;if(this.props.prevPage.indexOf("Campaign List")>=0&&this.props.prevPage.indexOf("Applications")<0){var recipientId=this.props.applicationsToRecipientIdsMapping.data.orderedApplications[newIndex];if(recipientId){this.props.getAccountDetails(recipientId);this.setState({currentIndex:newIndex});}}else{var applicationId=this.props.applicationsToRecipientIdsMapping.data.orderedApplications[newIndex];var _recipientId=this.props.applicationsToRecipientIdsMapping.data.mapping[applicationId];if(_recipientId){this.props.getAccountDetails(_recipientId,applicationId);this.setState({currentIndex:newIndex});}}}},{key:'render',value:function render(){var _this3=this;var totalApplications=this.props.applicationsToRecipientIdsMapping.data.orderedApplications.length;var currentIndex=this.state.currentIndex;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'subheader application-details-subheader'},this.props.prevPage&&!this.props.applicationsToRecipientIdsMapping.loading&&this.props.applicationsToRecipientIdsMapping.success&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container flex-justify'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,totalApplications>0&&currentIndex>=0&&(this.props.prevPage.indexOf("Applications")>=0||this.props.prevPage.indexOf("Campaign")>=0||this.props.prevPage.indexOf("Campaign List")>=0)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center previous-next-arrows'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'previous',onClick:this.navigate.bind(this,false)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-arrow-back accent-text2 '+(currentIndex<=0?'disabled':'')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'link-text '+(currentIndex===0?'disabled':'')},'Previous')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'accent-text medium-text'},Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["m" /* formatNumber */])(currentIndex+1),' of ',Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["m" /* formatNumber */])(totalApplications),' ',this.props.prevPage,this.props.prevPage.indexOf("Applications")>=0?"":this.props.prevPage.indexOf("Campaign List")>=0?" Participants":" Individual Recipients"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'next',onClick:this.navigate.bind(this,true)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'link-text '+(currentIndex===totalApplications-1?'disabled':'')},'Next'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-arrow-forward accent-text2 '+(currentIndex<0||currentIndex===totalApplications-1?'disabled':'')})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'back-link'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-android-arrow-back middle medium-text'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:function onClick(){return _this3.props.history.goBack();},className:'link-text small-text'},'Back to ',this.props.prevPage))));}}]);return RecipientAccountNavigationHeader;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (RecipientAccountNavigationHeader);

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RecipientDetailsCard__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RecipientDetailsEditCard__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_constants__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RecipientAccountDetails=function(_React$Component){_inherits(RecipientAccountDetails,_React$Component);function RecipientAccountDetails(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RecipientAccountDetails);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RecipientAccountDetails.__proto__||Object.getPrototypeOf(RecipientAccountDetails)).call.apply(_ref,[this].concat(args))),_this),_this.getInitialFormattedRecipient=function(recipient){return{applicantType:recipient.applicantType,isIsraeli:recipient.isIsraeli,personTitleId:recipient.personTitleId,firstName:recipient.firstName||'',lastName:recipient.lastName||'',reportName:recipient.reportName||'',organization:{institutionTitleId:recipient.applicantType===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["l" /* RecipientTypes */].Organization&&recipient.organization?recipient.organization.institutionTitleId:null,name:recipient.applicantType===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["l" /* RecipientTypes */].Organization&&recipient.organization?recipient.organization.name:'',registered:recipient.applicantType===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["l" /* RecipientTypes */].Organization&&recipient.organization?recipient.organization.registered:false,taxId:recipient.applicantType===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["l" /* RecipientTypes */].Organization&&recipient.organization?recipient.organization.taxId||'':''},address:recipient.address||{},previousAddress:recipient.previousAddress||{},phoneNumber:recipient.phoneNumber||'',phoneType:recipient.phoneType||(recipient.isIsraeli?__WEBPACK_IMPORTED_MODULE_4__lib_constants__["g" /* PhoneNumberTypes */].Israeli:__WEBPACK_IMPORTED_MODULE_4__lib_constants__["g" /* PhoneNumberTypes */].American),secondPhoneNumber:recipient.secondPhoneNumber||'',secondPhoneType:recipient.secondPhoneType||(recipient.isIsraeli?__WEBPACK_IMPORTED_MODULE_4__lib_constants__["g" /* PhoneNumberTypes */].Israeli:__WEBPACK_IMPORTED_MODULE_4__lib_constants__["g" /* PhoneNumberTypes */].American),email:recipient.email||'',bankAccounts:recipient.bankAccounts,teudatZahut:recipient.teudatZahut||'',tags:recipient.tags?recipient.tags.map(function(t){return t.key;}):[],references:recipient.references,solicitors:recipient.solicitors,roshYeshivas:recipient.roshYeshivas,trustedPayee:recipient.trustedPayee,applicantPledges:recipient.applicantPledges,orgEmploymentType:recipient.orgEmploymentType||'',orgEmploymentPosition:recipient.orgEmploymentPosition||'',orgEmploymentGrade:recipient.orgEmploymentGrade!==0?recipient.orgEmploymentGrade||'':"0",orgEmploymentSeder:recipient.orgEmploymentSeder||''};},_this.getIncompleteFields=function(recipientDetails,setTrustedPayee){var recipient=recipientDetails||_this.getInitialFormattedRecipient(_this.props.recipientDetails.data);var requiredFields={recipientInfo:[]};if(recipient.applicantType===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["l" /* RecipientTypes */].Individual){if(!recipient.firstName)requiredFields.recipientInfo.push('First Name');if(!recipient.lastName)requiredFields.recipientInfo.push('Last Name');}else{if(!recipient.organization.name)requiredFields.recipientInfo.push('Name');if(recipient.organization.registered&&!recipient.organization.taxId)requiredFields.recipientInfo.push('Tax ID');}if(recipient.isIsraeli){if(recipient.applicantType===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["l" /* RecipientTypes */].Individual&&!recipient.teudatZahut)requiredFields.recipientInfo.push('Teudat Zehut');if(!recipient.trustedPayee){var activeBankAcct=recipient.bankAccounts.filter(function(acct){return acct.active;})[0];if(!activeBankAcct){requiredFields.recipientInfo.push('Active Bank Account');}else{if(!activeBankAcct.bankRoutingNumber)requiredFields.recipientInfo.push('Active Bank Account - Bank Number');if(!activeBankAcct.bankBranchNumber)requiredFields.recipientInfo.push('Active Bank Account - Branch Number');if(!activeBankAcct.bankAccountNumber)requiredFields.recipientInfo.push('Active Bank Account - Account Number');}}}if(!recipient.tags.length)requiredFields.recipientInfo.push('Categories');if(setTrustedPayee&&!recipient.trustedPayee)requiredFields.recipientInfo.push('Trusted Payee');if(!recipient.address.streetNumber||!recipient.address.street||!recipient.address.city||!recipient.address.country)requiredFields.recipientInfo.push('Address is Incomplete');return requiredFields.recipientInfo.length?requiredFields:null;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RecipientAccountDetails,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.editMode?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__RecipientDetailsEditCard__["a" /* default */],{recipient:this.props.recipientDetails.data,tags:this.props.tags,toggleEditMode:this.props.toggleEditMode,getRecipientAccountDetails:this.props.getRecipientDetails,updateRecipient:this.props.updateRecipient,updateRecipientDetails:this.props.updateRecipientDetails,applicationHistory:this.props.applicationHistory,getApplicationHistory:this.props.getApplicationHistory,getSystemSettings:this.props.getSystemSettings,getInitialFormattedRecipient:this.getInitialFormattedRecipient,getIncompleteFields:this.getIncompleteFields}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RecipientDetailsCard__["a" /* default */],{recipient:this.props.recipientDetails.data,applicationHistory:this.props.applicationHistory,userId:this.props.userId,permissions:this.props.permissions,isAdmin:this.props.isAdmin,isApprover:this.props.isApprover,loading:this.props.recipientDetails.loading,toggleEditMode:this.props.toggleEditMode,disableEditMode:this.props.disableEditMode,addNote:this.props.addNote,updateNote:this.props.updateNote,deleteNote:this.props.deleteNote,updatingNote:this.props.updatingNote,getIncompleteFields:this.getIncompleteFields}));}}]);return RecipientAccountDetails;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (RecipientAccountDetails);

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NoteModal__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RecipientSummaryPanel__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_ConfirmationModal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_shared_IncompleteApplicationWarning__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_apiUtils__ = __webpack_require__(16);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RecipientDetailsCard=function(_NavigationComponent){_inherits(RecipientDetailsCard,_NavigationComponent);function RecipientDetailsCard(props){_classCallCheck(this,RecipientDetailsCard);var _this=_possibleConstructorReturn(this,(RecipientDetailsCard.__proto__||Object.getPrototypeOf(RecipientDetailsCard)).call(this,props));_this.displayLocalDate=function(dateString){if(!dateString)return'';if(/^\d{4}-\d{2}-\d{2}$/.test(dateString)){var _dateString$split$map=dateString.split('-').map(Number),_dateString$split$map2=_slicedToArray(_dateString$split$map,3),year=_dateString$split$map2[0],month=_dateString$split$map2[1],day=_dateString$split$map2[2];return new Date(year,month-1,day).toLocaleDateString();}return Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["k" /* formatDate */])(dateString);};_this.state={showInactiveBankAccounts:false,showModals:{deleteNoteConfirmationModal:false,recipientNoteModal:false},note:{},downloading:false};return _this;}// Helper to display date as local if yyyy-mm-dd
_createClass(RecipientDetailsCard,[{key:'render',value:function render(){var _this2=this;var _props$recipient=this.props.recipient,applicantId=_props$recipient.applicantId,displayName=_props$recipient.displayName,incomplete=_props$recipient.incomplete,taxIdNumber=_props$recipient.taxIdNumber,teudatZahut=_props$recipient.teudatZahut,reportName=_props$recipient.reportName,addressDisplay=_props$recipient.addressDisplay,previousAddressDisplay=_props$recipient.previousAddressDisplay,email=_props$recipient.email,phoneNumber=_props$recipient.phoneNumber,secondPhoneNumber=_props$recipient.secondPhoneNumber,campaignList=_props$recipient.campaignList,_props$recipient$tags=_props$recipient.tags,tags=_props$recipient$tags===undefined?[]:_props$recipient$tags,orgEmployment=_props$recipient.orgEmployment,_props$recipient$bank=_props$recipient.bankAccounts,bankAccounts=_props$recipient$bank===undefined?[]:_props$recipient$bank,_props$recipient$note=_props$recipient.notes,notes=_props$recipient$note===undefined?[]:_props$recipient$note,_props$recipient$refe=_props$recipient.references,references=_props$recipient$refe===undefined?[]:_props$recipient$refe,_props$recipient$soli=_props$recipient.solicitors,solicitors=_props$recipient$soli===undefined?[]:_props$recipient$soli,_props$recipient$rosh=_props$recipient.roshYeshivas,roshYeshivas=_props$recipient$rosh===undefined?[]:_props$recipient$rosh,_props$recipient$trus=_props$recipient.trustedPayee,trustedPayee=_props$recipient$trus===undefined?{}:_props$recipient$trus,_props$recipient$appl=_props$recipient.applicantPledges,applicantPledges=_props$recipient$appl===undefined?[]:_props$recipient$appl;var _ref=bankAccounts.filter(function(acct){return acct.active;})[0]||{},bankRoutingNumber=_ref.bankRoutingNumber,bankBranchNumber=_ref.bankBranchNumber,bankAccountNumber=_ref.bankAccountNumber,bankAccountHolder=_ref.bankAccountHolder,achRoutingNumber=_ref.achRoutingNumber,achAccountNumber=_ref.achAccountNumber,achAccountType=_ref.achAccountType;var inactiveBankAccounts=bankAccounts.filter(function(acct){return!acct.active;});var _props=this.props,disableEditMode=_props.disableEditMode,toggleEditMode=_props.toggleEditMode;var incompleteFields=applicantId&&incomplete?this.props.getIncompleteFields():null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card application-details-info'},this.props.loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-justify'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'recipient-name'},displayName,incomplete&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tag incomplete'},'Incomplete')),taxIdNumber&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'accent-text small-text tax-id'},'Tax ID: ',taxIdNumber),teudatZahut&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'accent-text small-text tax-id'},' Teudat Zehut: ',teudatZahut)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recipient-btns-right flex-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary primary',disabled:this.state.downloading,title:'Pdf Export',onClick:function onClick(){_this2.setState({downloading:true});Object(__WEBPACK_IMPORTED_MODULE_8__lib_apiUtils__["b" /* getRequest */])(('/recipients/'+applicantId+'/applications/report/pdf?\n                                    fields=DisplayName&\n                                    fields=Amount&\n                                    fields=CreationDate&\n                                    fields=Reason&\n                                    fields=Email&\n                                    fields=DisplayAddress&\n                                    fields=PhoneNumber&\n                                    fields=ReportName&\n                                    fields=Status&\n                                    fields=References&\n                                    fields=TotalPaid&\n                                    fields=Currency&\n                                    fields=Fund&\n                                    fields=CheckOrWireDate&\n                                    fields=CheckOrWireNumber&\n                                    fields=ReportMemo&\n                                    fields=ApplicantPledges\n                                    ').replace(/ +/g,""),null,null,{responseType:"arraybuffer"}).then(function(response){console.log(response);var blob=new Blob([response.data],{type:'application/pdf'});var link=document.createElement('a');link.href=window.URL.createObjectURL(blob);link.download=displayName+'_report.pdf';link.click();}).finally(function(){return _this2.setState({downloading:false});});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-printer icon-left'}),'Pdf Report')),this.props.permissions.manage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-accent2',disabled:disableEditMode,title:disableEditMode?"Submit your application changes before editing recipient.":"",onClick:toggleEditMode},'Edit')))),incompleteFields&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_shared_IncompleteApplicationWarning__["a" /* default */],{viewOnly:true,fields:incompleteFields}),reportName&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'accent-text'},'Report Name: '),reportName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'application-details-personal-info flex-center'},addressDisplay&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-home-outline accent-text2'}),addressDisplay),previousAddressDisplay&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-home-outline accent-text2'}),previousAddressDisplay),email&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-email-outline accent-text2'}),email),phoneNumber&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-telephone-outline accent-text2'}),phoneNumber),secondPhoneNumber&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-telephone-outline accent-text2'}),secondPhoneNumber),campaignList&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-briefcase-outline accent-text2'}),campaignList),tags.map(function(tag){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:tag.key,className:'chip reverse-chip'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,tag.value));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),orgEmployment&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Position:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'application-details-personal-info flex-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-person-outline accent-text2'}),orgEmployment))),bankAccounts.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bold-text'},'Account Information:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'application-details-account-info flex-center'},bankRoutingNumber&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons icon-wallet accent-text2'}),'Bank Routing #: ',bankRoutingNumber),bankBranchNumber&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons icon-pie-chart accent-text2'}),'Branch #: ',bankBranchNumber),bankAccountNumber&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons icon-calculator accent-text2'}),'Account #: ',bankAccountNumber),bankAccountHolder&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons accent-text2'},'person_outline'),'Account Holder: ',bankAccountHolder),achRoutingNumber&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons icon-wallet accent-text2'}),'ACH Routing #: ',achRoutingNumber),achAccountNumber&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons icon-calculator accent-text2'}),'ACH Account #: ',achAccountNumber),achAccountType&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-information-outline accent-text2'}),'Account Type: ',achAccountType),inactiveBankAccounts.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link-text small-text',onClick:function onClick(){return _this2.setState({showInactiveBankAccounts:true});}},'See Inactive Accounts')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),this.state.showInactiveBankAccounts&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inactive-accounts-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons',onClick:function onClick(){return _this2.setState({showInactiveBankAccounts:false});}},'close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'table-header table-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Bank Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Bank Branch'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Account Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Account Holder'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ACH Routing #'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'ACH Account #'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Account Type'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,inactiveBankAccounts.map(function(acct){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:acct.bankAccountId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,acct.bankRoutingNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,acct.bankBranchNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,acct.bankAccountNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,acct.bankAccountHolder),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,acct.achRoutingNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,acct.achAccountNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,acct.achAccountType));})))),references.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'References:'),references.map(function(reference){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:reference.referenceId,className:'application-details-personal-info flex-center'},reference.displayName&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-person-outline accent-text2'}),reference.displayName),reference.relationship&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-information-outline accent-text2'}),reference.relationship),(reference.phoneNumber||reference.secondPhoneNumber)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-telephone-outline accent-text2'}),[reference.phoneNumber,reference.secondPhoneNumber].filter(function(p){return p;}).join(' | ')),reference.email&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-email-outline accent-text2'}),reference.email),reference.addressDisplay&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-location-outline accent-text2'}),reference.addressDisplay));})),trustedPayee&&trustedPayee.referenceId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Trusted Payee:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},trustedPayee.displayName,' - ',trustedPayee.isIsraeli?Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["i" /* formatBankInfoDisplay */])(trustedPayee.bankRoutingNumber,trustedPayee.bankBranchNumber,trustedPayee.bankAccountNumber,trustedPayee.bankAccountHolder):trustedPayee.addressDisplay)),solicitors.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-16'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bold-text'},'Solicitors:')),solicitors.map(function(reference){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:reference.referenceId,className:'application-details-personal-info flex-center'},reference.displayName&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-person-outline accent-text2'}),reference.displayName),reference.relationship&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-information-outline accent-text2'}),reference.relationship),(reference.phoneNumber||reference.secondPhoneNumber)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-telephone-outline accent-text2'}),[reference.phoneNumber,reference.secondPhoneNumber].filter(function(p){return p;}).join(' | ')),reference.email&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-email-outline accent-text2'}),reference.email),reference.addressDisplay&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-location-outline accent-text2'}),reference.addressDisplay));})),roshYeshivas.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-16'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bold-text'},'Rosh Yeshivas:')),roshYeshivas.map(function(reference){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:reference.referenceId,className:'application-details-personal-info flex-center'},reference.displayName&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-person-outline accent-text2'}),reference.displayName),reference.relationship&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-information-outline accent-text2'}),reference.relationship),(reference.phoneNumber||reference.secondPhoneNumber)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-telephone-outline accent-text2'}),[reference.phoneNumber,reference.secondPhoneNumber].filter(function(p){return p;}).join(' | ')),reference.email&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-email-outline accent-text2'}),reference.email),reference.addressDisplay&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-location-outline accent-text2'}),reference.addressDisplay));})),applicantPledges.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-16 pledges-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bold-text'},'Pledges:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pledges-table-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table pledges-table pledges-table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'table-header table-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-right'},'#'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-right'},'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-right'},'Amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-right'},'Paid'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-right'},'Outstanding'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-left'},'Payout Schedule'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,applicantPledges.map(function(ap,index){var pledgeKey=ap.applicantPledgeId||'row-'+index;var outstandingAmount=(ap.pledgeAmount||0)-(ap.amountPaid||0);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:pledgeKey},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right','data-label':'#'},ap.applicantPledgeId?'#'+ap.applicantPledgeId:"-"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right','data-label':'Date'},_this2.displayLocalDate(ap.pledgeDate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right','data-label':'Amount'},Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["j" /* formatCurrency */])(ap.pledgeAmount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right','data-label':'Paid'},Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["j" /* formatCurrency */])(ap.amountPaid)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right','data-label':'Outstanding'},Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["j" /* formatCurrency */])(outstandingAmount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'pledge-schedule-cell text-left','data-label':'Payout Schedule'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pledge-schedule-text'},ap.payOutSchedule),ap.payOutSchedule&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tooltip pledge-schedule-tooltip'},ap.payOutSchedule)));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-card-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-justify'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bold-text'},'NOTES:')),this.props.permissions.manage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'xs-text link-text',onClick:this.toggleModal.bind(this,"recipientNoteModal")},'Add New')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-card-rows details-card-notes'},notes.map(function(note){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:note.noteId,className:'details-card-note'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'medium-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-notebook accent-text2'}),' ',note.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'accent-text small-text'},note.writtenBy,' on ',Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["k" /* formatDate */])(note.writtenOn)),(note.userId===_this2.props.userId||_this2.props.isAdmin||_this2.props.isApprover)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-card-note-actions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-pencil primary-hover icon-right accent-text input',onClick:function onClick(){_this2.setState({note:note});_this2.toggleModal("recipientNoteModal");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-trash trash-hover icon-right accent-text input',onClick:function onClick(){_this2.setState({note:note});_this2.toggleModal("deleteNoteConfirmationModal");}})));}))),this.props.applicationHistory.length>1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recipient-details-summary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RecipientSummaryPanel__["a" /* default */],{recipientId:applicantId}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__NoteModal__["a" /* default */],{show:this.state.showModals.recipientNoteModal,close:function close(){_this2.setState({note:{}});_this2.toggleModal("recipientNoteModal");},note:this.state.note,save:function save(text){return _this2.state.note.noteId?_this2.props.updateNote(applicantId,_this2.state.note.noteId,text):_this2.props.addNote(applicantId,text);},loading:this.props.updatingNote.loading,success:this.props.updatingNote.success}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_ConfirmationModal__["a" /* default */],{show:this.state.showModals.deleteNoteConfirmationModal,close:function close(){_this2.setState({note:{}});_this2.toggleModal('deleteNoteConfirmationModal');},message:'Are you sure you want to permanently delete this note?',confirm:this.props.deleteNote.bind(this,applicantId,this.state.note.noteId),loading:this.props.updatingNote.loading,success:this.props.updatingNote.success}));}}]);return RecipientDetailsCard;}(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (RecipientDetailsCard);

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RecipientSummaryPanel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_apiUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_shared_AiIcon__ = __webpack_require__(172);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Inline AI summary of the recipient's application history, shown above the
 * applications list on the recipient account page. Fetches the cached summary
 * and, when none is available yet, triggers generation. Renders nothing when
 * the AI summary is not configured or there is nothing to show.
 */var RecipientSummaryPanel=function(_React$Component){_inherits(RecipientSummaryPanel,_React$Component);function RecipientSummaryPanel(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,RecipientSummaryPanel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RecipientSummaryPanel.__proto__||Object.getPrototypeOf(RecipientSummaryPanel)).call.apply(_ref,[this].concat(args))),_this),_this.state={summary:null,loading:false,error:false,aiLoading:false},_this.requestId=0,_this.load=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var recipientId,requestId,result,pending;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:recipientId=_this.props.recipientId;if(!(!recipientId||!_this.props.showAiSummaries)){_context.next=3;break;}return _context.abrupt('return');case 3:_this.setState({loading:true,error:false,summary:null,aiLoading:false});requestId=++_this.requestId;_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_3__lib_apiUtils__["b" /* getRequest */])('/applications/recipients/'+recipientId+'/summary');case 7:result=_context.sent;if(!(requestId!==_this.requestId||!_this.props.showAiSummaries)){_context.next=10;break;}return _context.abrupt('return');case 10:if(result.success){_context.next=13;break;}_this.setState({loading:false,error:true});return _context.abrupt('return');case 13:pending=!!(result.data.aiSummaryPending&&!result.data.aiSummary);_this.setState({summary:result.data,loading:false,aiLoading:pending});if(pending)_this.generate();case 16:case'end':return _context.stop();}}},_callee,_this2);})),_this.generate=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var recipientId,requestId,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:recipientId=_this.props.recipientId;if(_this.props.showAiSummaries){_context2.next=3;break;}return _context2.abrupt('return');case 3:requestId=_this.requestId;_context2.next=6;return Object(__WEBPACK_IMPORTED_MODULE_3__lib_apiUtils__["d" /* postRequest */])('/applications/recipients/'+recipientId+'/summary/generate');case 6:result=_context2.sent;if(!(requestId!==_this.requestId||!_this.props.showAiSummaries)){_context2.next=9;break;}return _context2.abrupt('return');case 9:_this.setState(function(prev){return{aiLoading:false,summary:Object.assign({},prev.summary||{},{aiSummary:result.success?result.data.aiSummary:null,aiSummaryGeneratedDate:result.success?result.data.generatedDate:null,aiSummaryPending:!result.success})};});case 10:case'end':return _context2.stop();}}},_callee2,_this2);})),_this.renderShimmer=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{'aria-busy':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'shimmer-line'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'shimmer-line',style:{width:'80%'}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'shimmer-line',style:{width:'55%'}}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RecipientSummaryPanel,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.showAiSummaries)this.load();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(!prevProps.showAiSummaries&&this.props.showAiSummaries){this.load();}else if(prevProps.showAiSummaries&&!this.props.showAiSummaries){this.requestId++;this.setState({loading:false,aiLoading:false});}else if(this.props.showAiSummaries&&prevProps.recipientId!==this.props.recipientId){this.load();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.requestId++;}},{key:'render',value:function render(){var _state=this.state,summary=_state.summary,loading=_state.loading,error=_state.error,aiLoading=_state.aiLoading;if(!this.props.showAiSummaries||error)return null;var hasSummary=summary&&summary.aiSummary;// Nothing to show: AI not configured, no visible applications, or no summary.
if(!loading&&!aiLoading&&!hasSummary)return null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'recipient-ai-summary-panel'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'panel-label'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_shared_AiIcon__["a" /* default */],{className:'ai-icon',size:15}),'AI Summary'),loading||aiLoading?this.renderShimmer():__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'summary-text'},summary.aiSummary));}}]);return RecipientSummaryPanel;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);function mapStateToProps(state){return{showAiSummaries:state.userProfile.profile.data.showAiSummaries!==false};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(RecipientSummaryPanel));

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_number_format__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_number_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_RadioGroup__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedPhoneInput__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_shared_AddressAutocomplete__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_util_AutocompleteMultiInput__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__applicationsComponents_applicationsCommon_RecipientReferencesTable__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__applicationsComponents_applicationsCommon_ApplicantPledgesTable__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commonComponents_shared_IncompleteApplicationWarning__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RecipientBankAccountsTable__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AchAccountsTable__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_clonedeep__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_clonedeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_clonedeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RecipientDetailsEditCard=function(_React$Component){_inherits(RecipientDetailsEditCard,_React$Component);function RecipientDetailsEditCard(props){_classCallCheck(this,RecipientDetailsEditCard);var _this=_possibleConstructorReturn(this,(RecipientDetailsEditCard.__proto__||Object.getPrototypeOf(RecipientDetailsEditCard)).call(this,props));_initialiseProps.call(_this);var recipient=_this.props.recipient;var hasPrevAddress=recipient.previousAddress.streetNumber||recipient.previousAddress.street||recipient.previousAddress.city||recipient.previousAddress.state||recipient.previousAddress.zip||recipient.previousAddress.country||recipient.previousAddress.unitType||recipient.previousAddress.apartment;_this.initialState={recipient:props.getInitialFormattedRecipient(recipient),submitAttempted:recipient.incomplete,showEmail:!!(recipient.email||recipient.applicantType===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["l" /* RecipientTypes */].Organization),showSecondPhone:!!recipient.secondPhoneNumber,showPrevAddress:hasPrevAddress,setTrustedPayee:!!recipient.trustedPayee,error:false,dataErrors:{phoneNumber:false,email:false,secondPhoneNumber:false,taxId:false}};_this.state=__WEBPACK_IMPORTED_MODULE_17_lodash_clonedeep___default()(_this.initialState);_this.updateRecipient=_this.updateRecipient.bind(_this);_this.updateOrganization=_this.updateOrganization.bind(_this);_this.onChange=_this.onChange.bind(_this);_this.updateDataErrors=_this.updateDataErrors.bind(_this);_this.save=_this.save.bind(_this);return _this;}_createClass(RecipientDetailsEditCard,[{key:'updateRecipient',value:function updateRecipient(name,value){if(name==="firstName"||name==="lastName"||name==="reportName")value=Object(__WEBPACK_IMPORTED_MODULE_18__lib_utils__["C" /* toTitleCase */])(value);this.setState({recipient:Object.assign({},this.state.recipient,_defineProperty({},name,value))});}},{key:'updateOrganization',value:function updateOrganization(name,value){if(name==='registered'){value?this.setState({recipient:Object.assign({},this.state.recipient,{organization:Object.assign({},this.state.recipient.organization,_defineProperty({taxId:''},name,!value))})}):this.setState({recipient:Object.assign({},this.state.recipient,{organization:Object.assign({},this.state.recipient.organization,_defineProperty({},name,!value))})});return;}if(name==="name")value=Object(__WEBPACK_IMPORTED_MODULE_18__lib_utils__["C" /* toTitleCase */])(value);this.setState({recipient:Object.assign({},this.state.recipient,{organization:Object.assign({},this.state.recipient.organization,_defineProperty({},name,value))})});}},{key:'onChange',value:function onChange(name,value){this.setState(_defineProperty({},name,value));}},{key:'validateEmail',value:function validateEmail(name,value){var isValid=Object(__WEBPACK_IMPORTED_MODULE_18__lib_utils__["x" /* isValidEmail */])(value);this.updateDataErrors(name,!isValid);return isValid;}},{key:'validateLength',value:function validateLength(name,length,value){var isValid=Object(__WEBPACK_IMPORTED_MODULE_18__lib_utils__["E" /* validateFieldLength */])(length,value);this.updateDataErrors(name,!isValid);return isValid;}},{key:'updateDataErrors',value:function updateDataErrors(name,value){this.setState({dataErrors:Object.assign({},this.state.dataErrors,_defineProperty({},name,value))});}},{key:'save',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var incompleteFields,recipient;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(this.state.error)this.setState({error:false});//remove prev error
incompleteFields=this.props.getIncompleteFields(this.state.recipient,this.state.setTrustedPayee);if(!(this.state.submitAttempted||!incompleteFields)){_context.next=9;break;}recipient=Object.assign({},this.state.recipient,{references:this.state.recipient.references.map(function(ref){return{referenceId:ref.referenceId,relationship:ref.relationship};}),solicitors:this.state.recipient.solicitors.map(function(ref){return{referenceId:ref.referenceId,relationship:ref.relationship};}),roshYeshivas:this.state.recipient.roshYeshivas.map(function(ref){return{referenceId:ref.referenceId,relationship:ref.relationship};}),trustedPayeeId:this.state.recipient.trustedPayee?this.state.recipient.trustedPayee.referenceId:null});_context.next=6;return this.props.updateRecipient(this.props.recipient.applicantId,recipient);case 6:if(this.props.updateRecipientDetails.success){if(this.props.recipient.incomplete&&(!incompleteFields||incompleteFields.recipientInfo.every(function(field){return field.indexOf('Bank Account')>=0;})))this.props.getApplicationHistory();//reload applications to refelect recipient status change (if recip is complete, or just missing bank info for applications not paid to recipient)
this.props.getRecipientAccountDetails(this.props.recipient.applicantId,true);this.props.toggleEditMode();if(this.state.recipient.address&&(this.state.recipient.address.country&&this.props.tags.nationalities.indexOf(this.state.recipient.address.country)<0||this.state.recipient.address.city&&this.props.tags.cities.indexOf(this.state.recipient.address.city)<0)){this.props.getSystemSettings();//get updated nationalities/cities
}}else{this.setState({error:true});}_context.next=10;break;case 9:if(!this.state.submitAttempted)this.setState({submitAttempted:true});case 10:case'end':return _context.stop();}}},_callee,this);}));function save(){return _ref.apply(this,arguments);}return save;}()},{key:'render',value:function render(){var _this2=this;var _state=this.state,dataErrors=_state.dataErrors,recipient=_state.recipient,showPrevAddress=_state.showPrevAddress,submitAttempted=_state.submitAttempted;var incompleteFields=this.props.getIncompleteFields(recipient,this.state.setTrustedPayee);var allowIncomplete=incompleteFields?this.allowIncompleteUpdate(incompleteFields):false;// previous allowIncomplete logic:
//  (this.props.recipient.incomplete //recipient is incomplete
//     && (this.props.applicationHistory.every(app => app.status === ApplicationStatuses.Incomplete) //AND all recipient applications are incomplete
//         || (incompleteFields && incompleteFields.recipientInfo.every(field => field.indexOf('Bank Account') >= 0))) //OR only missing payment info - to accomodate for the fact that recipeints can be missing payment info and thus be incomplete but have complete applications because they alernate complete payment info
// );
var isDisabled=this.state.submitAttempted&&incompleteFields&&!allowIncomplete||Object(__WEBPACK_IMPORTED_MODULE_18__lib_utils__["e" /* deepEquals */])(this.initialState.recipient,this.state.recipient)||this.props.recipient.incomplete&&!recipient.address.street&&this.props.recipient.addressUsedForThirdParty||recipient.applicantType===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["l" /* RecipientTypes */].Individual&&(!recipient.firstName||!recipient.lastName)||recipient.applicantType===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["l" /* RecipientTypes */].Organization&&!recipient.organization.name;var disabledMessage=void 0;if(isDisabled&&(recipient.applicantType===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["l" /* RecipientTypes */].Individual&&(!recipient.firstName||!recipient.lastName)||recipient.applicantType===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["l" /* RecipientTypes */].Organization&&!recipient.organization.name))disabledMessage="Recipient name must be complete.";return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card application-details-info'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'application-details-info-edit'},recipient.applicantType===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["l" /* RecipientTypes */].Individual&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row flex-justify'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-select'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Title'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__["a" /* default */],{clearable:true,options:recipient.isIsraeli?this.props.tags.israelPersonTitles:this.props.tags.usPersonTitles,label:'Title',name:'personTitleId',value:recipient.personTitleId,onChange:function onChange(e){return _this2.updateRecipient(e.target.name,e.target.value);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'First Name',name:'firstName',value:recipient.firstName,onChange:this.updateRecipient,required:recipient.applicantType==="Individual",showRequiredError:submitAttempted}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'Last Name',name:'lastName',value:recipient.lastName,onChange:this.updateRecipient,required:recipient.applicantType===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["l" /* RecipientTypes */].Individual,showRequiredError:submitAttempted}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Report Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',value:recipient.reportName,onChange:function onChange(e){return _this2.updateRecipient('reportName',e.target.value);}}))),recipient.applicantType===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["l" /* RecipientTypes */].Organization&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Institution Title'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__["a" /* default */],{clearable:true,options:recipient.isIsraeli?this.props.tags.israelInstitutionTitles:this.props.tags.usInstitutionTitles,label:'Institution Title',name:'institutionTitleId',value:recipient.organization.institutionTitleId,onChange:function onChange(e){return _this2.updateOrganization(e.target.name,e.target.value);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'Name',name:'name',value:recipient.organization.name,onChange:this.updateOrganization,required:recipient.applicantType===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["l" /* RecipientTypes */].Organization,showRequiredError:submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Report Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',value:recipient.reportName,onChange:function onChange(e){return _this2.updateRecipient('reportName',e.target.value);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format___default.a,{placeholder:'#########',format:'#########',onValueChange:function onValueChange(values){return _this2.updateOrganization('taxId',values.value);},disabled:!recipient.organization.registered}),label:'Tax ID',name:'taxId',value:recipient.organization.taxId,errorMessage:'Invalid Tax ID',validated:true,showValidationError:true,validate:this.validateLength.bind(this,'taxId',9),required:true,showRequiredError:recipient.applicantType===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["l" /* RecipientTypes */].Organization&&recipient.organization.registered&&submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'check',className:'custom-check',name:'registered',checked:!recipient.organization.registered,onChange:function onChange(e){return _this2.updateOrganization(e.target.name,e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'check'},'Not Registered')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedPhoneInput__["a" /* default */],{span1:!this.state.showSecondPhone&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:this.onChange.bind(this,'showSecondPhone',true),className:'link-text small-text'},'Add Phone'),span2:!this.state.showEmail&&recipient.applicantType===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["l" /* RecipientTypes */].Individual&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:this.onChange.bind(this,'showEmail',true),className:'link-text small-text'},'Add Email'),phoneNumber:recipient.phoneNumber,phoneType:recipient.phoneType,phoneNumberName:'phoneNumber',phoneTypeName:'phoneType',onChange:this.updateRecipient,error:dataErrors.phoneNumber,updateError:this.updateDataErrors,errorName:'phoneNumber'})),this.state.showSecondPhone&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedPhoneInput__["a" /* default */],{label:'Second Phone',phoneNumber:recipient.secondPhoneNumber,phoneType:recipient.secondPhoneType,phoneNumberName:'secondPhoneNumber',phoneTypeName:'secondPhoneType',onChange:this.updateRecipient,error:dataErrors.secondPhoneNumber,updateError:this.props.updateDataErrors,errorName:'secondPhoneNumber'})),this.state.showEmail&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'Email',name:'email',value:recipient.email,onChange:this.updateRecipient,required:false,showRequiredError:false,validated:true,showValidationError:true,validate:this.validateEmail.bind(this,'email'),errorMessage:'Invalid Email Address'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row flex-justify address-error-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_shared_AddressAutocomplete__["a" /* default */],{isIsraeli:recipient.isIsraeli,required:true,showRequiredError:submitAttempted||this.props.recipient.incomplete&&this.props.recipient.addressUsedForThirdParty&&!recipient.address.street,address:recipient.address,updateAddress:function updateAddress(address){return _this2.updateRecipient('address',address);},updateError:this.updateDataErrors.bind(this,'recipAddressError'),addAddressLabel:(recipient.address.city||recipient.address.country||recipient.address.state||recipient.address.street||recipient.address.streetNumber||recipient.address.zip)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'link-text small-text',onClick:function onClick(){_this2.onChange('recipient',Object.assign({},recipient,{address:{},previousAddress:Object.assign({},recipient.address)}));if(!showPrevAddress){_this2.onChange('showPrevAddress',true);}},title:'Set current address to previous'},'Add New Address')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.props.recipient.incomplete&&this.props.recipient.addressUsedForThirdParty&&!recipient.address.street,message:'Address is used for associated application payments and is therefore required.'})),showPrevAddress&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row flex-justify'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_shared_AddressAutocomplete__["a" /* default */],{title:'Previous Address',isIsraeli:recipient.isIsraeli,showRequiredError:submitAttempted,required:false,address:recipient.previousAddress,updateAddress:function updateAddress(address){return _this2.updateRecipient('previousAddress',address);},updateError:this.updateDataErrors.bind(this,'recipPreviousAddressError')})),recipient.isIsraeli&&recipient.applicantType===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["l" /* RecipientTypes */].Individual&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_number_format___default.a,{placeholder:'#########',format:'#########',onValueChange:function onValueChange(values){return _this2.updateRecipient('teudatZahut',values.value);}}),label:'Teudat Zehut',name:'teudatZahut',value:recipient.teudatZahut,required:recipient.isIsraeli,showRequiredError:submitAttempted})),recipient.isIsraeli&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__RecipientBankAccountsTable__["a" /* default */],{bankAccounts:recipient.bankAccounts,submitAttempted:submitAttempted,validateLength:this.validateLength.bind(this),updateBankAccounts:function updateBankAccounts(accounts){return _this2.updateRecipient('bankAccounts',accounts);}})),!recipient.isIsraeli&&recipient.applicantType===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["l" /* RecipientTypes */].Organization&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__AchAccountsTable__["a" /* default */],{bankAccounts:recipient.bankAccounts,submitAttempted:submitAttempted,validateLength:this.validateLength.bind(this),updateBankAccounts:function updateBankAccounts(accounts){return _this2.updateRecipient('bankAccounts',accounts);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third categories-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_util_AutocompleteMultiInput__["a" /* default */],{showList:true,options:recipient.applicantType===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["l" /* RecipientTypes */].Individual?this.props.tags.categories.individualTags:this.props.tags.categories.organizationTags,selection:recipient.tags,update:this.updateRecipient}),label:'Categories',name:'tags',value:recipient.tags.length,required:true,showRequiredError:submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),recipient.applicantType===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["l" /* RecipientTypes */].Individual&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_RadioGroup__["a" /* default */],{title:'Current Position',name:'orgEmploymentType',value:recipient.orgEmploymentType,options:this.props.tags.orgEmploymentTypes,onChange:this.onChangeParticipant})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},recipient.orgEmploymentType===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["i" /* OrgEmploymentTypes */].Other&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'no-margin-bottom-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'Specify',name:'orgEmploymentPosition',value:recipient.orgEmploymentPosition,required:true,showRequiredError:submitAttempted&&recipient.orgEmploymentPosition==="",onChange:this.onChangeParticipant})),recipient.orgEmploymentType===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["i" /* OrgEmploymentTypes */].Rebbi&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'no-margin-bottom-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'',className:'input-label'},'Grade'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__["a" /* default */],{options:[{key:0,value:"Pre-K"},{key:1,value:"1"},{key:2,value:"2"},{key:3,value:"3"},{key:4,value:"4"},{key:5,value:"5"},{key:6,value:"6"},{key:7,value:"7"},{key:8,value:"8"},{key:9,value:"9"},{key:10,value:"10"},{key:11,value:"11"},{key:12,value:"12"}],allowZero:true}),name:'orgEmploymentGrade',value:recipient.orgEmploymentGrade,onChange:this.onChangeParticipant,required:true,showRequiredError:submitAttempted&&recipient.orgEmploymentGrade===""})),recipient.orgEmploymentGrade>=9&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ml-16'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_RadioGroup__["a" /* default */],{title:'Seder',error:submitAttempted&&!recipient.orgEmploymentSeder,name:'orgEmploymentSeder',value:recipient.orgEmploymentSeder,options:[{key:1,value:"1st"},{key:2,value:"2nd"}],onChange:this.onChangeParticipant}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row references-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__applicationsComponents_applicationsCommon_RecipientReferencesTable__["a" /* default */],{references:recipient.references,solicitors:recipient.solicitors,roshYeshivas:recipient.roshYeshivas,trustedPayee:recipient.trustedPayee,updateRecipient:this.updateRecipient,updateRecipientProps:function updateRecipientProps(props){return _this2.onChange('recipient',Object.assign({},recipient,props));},setTrustedPayee:this.state.setTrustedPayee,toggleSetTrustedPayee:this.onChange,submitAttempted:submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row pledges-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__applicationsComponents_applicationsCommon_ApplicantPledgesTable__["a" /* default */],{applicantPledges:recipient.applicantPledges,updateRecipient:this.updateRecipient,updateRecipientProps:function updateRecipientProps(props){return _this2.props.onChange('recipient',Object.assign({},recipient,props));},submitAttempted:submitAttempted})),submitAttempted&&incompleteFields&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonComponents_shared_IncompleteApplicationWarning__["a" /* default */],{fields:incompleteFields,allowIncomplete:allowIncomplete}),this.props.updateRecipientDetails.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details-card-footer clearfix text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.props.toggleEditMode},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent2',onClick:this.save,disabled:Object.keys(dataErrors).some(function(k){return dataErrors[k];})||isDisabled},'Update'),isDisabled&&disabledMessage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'info-label'},disabledMessage),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error&&!(this.props.updateRecipientDetails.message&&this.props.updateRecipientDetails.message.indexOf('\n')>0),message:this.props.updateRecipientDetails.message||'Something went wrong and the recipient could not be updated. Please try again.'})),this.state.error&&this.props.updateRecipientDetails.message&&this.props.updateRecipientDetails.message.indexOf('\n')>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-right'},this.props.updateRecipientDetails.message.split('\n').map(function(text,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'error-label',key:index},text);}))));}}]);return RecipientDetailsEditCard;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this3=this;this.allowIncompleteUpdate=function(incompleteFields){if(_this3.props.recipient.incomplete){//original recipient was incomplete
var origIncompleteFields=_this3.props.getIncompleteFields(_this3.initialState.recipient);var noNewIncompleteFields=incompleteFields.recipientInfo.every(function(field){return origIncompleteFields.recipientInfo.indexOf(field)>=0;});//all incomplete required fields in updated recipient were originally incomplete as well - making it 'more / = complete', not less           
if(noNewIncompleteFields)return true;var isTotallyIncomplete=_this3.props.recipient.incomplete//recipient is incomplete
//AND all recipient applications are incomplete
&&(_this3.props.applicationHistory.every(function(app){return app.status===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["a" /* ApplicationStatuses */].Incomplete;})//OR only missing payment info - to accomodate for the fact that recipeints can be missing payment info and thus be incomplete but have complete applications because they alernate complete payment info
||incompleteFields&&incompleteFields.recipientInfo.every(function(field){return field.indexOf('Bank Account')>=0;}));//this logic is currently live but not technically 100% accurate.
//if only missing bank info allow to update even if has complete applications - truth is applications may NOT have their own payment info...  
//solution would be to get flag from backend to determine if 'applicationsRelyOnPaymentInfo'...
return isTotallyIncomplete;//TODO:
//shud allow update if only removed bank info and NO apps paid to recipient...
}return false;};this.onChangeParticipant=function(name,value){var recipient=Object.assign({},_this3.state.recipient,_defineProperty({},name,value));if(name==='orgEmploymentType'){if(value!==__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["i" /* OrgEmploymentTypes */].Other){recipient.orgEmploymentPosition="";}else if(value!==__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["i" /* OrgEmploymentTypes */].Rebbi){recipient.orgEmploymentGrade="";recipient.orgEmploymentSeder="";}}if(name==='orgEmploymentGrade'&&value<9&&recipient.orgEmploymentSeder){recipient.orgEmploymentSeder="";}_this3.setState({recipient:recipient});};};/* harmony default export */ __webpack_exports__["a"] = (RecipientDetailsEditCard);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_number_format__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_number_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Toggle__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RecipientBankAccountsTable=function(_React$Component){_inherits(RecipientBankAccountsTable,_React$Component);function RecipientBankAccountsTable(props){_classCallCheck(this,RecipientBankAccountsTable);var _this=_possibleConstructorReturn(this,(RecipientBankAccountsTable.__proto__||Object.getPrototypeOf(RecipientBankAccountsTable)).call(this,props));_this.initialState={accountUpdate:{bankRoutingNumber:'',bankBranchNumber:'',bankAccountNumber:'',bankAccountHolder:'',active:false},editAccountIndex:null,newAccount:false,dataErrors:[]};_this.addNewAccount=function(){_this.setState({newAccount:true,accountUpdate:Object.assign({},_this.state.accountUpdate,{active:true})});};_this.updateNewAccount=function(name,value){_this.setState({accountUpdate:Object.assign({},_this.state.accountUpdate,_defineProperty({},name,value))});};_this.submitAccountUpdates=function(){if(_this.disableSubmit())return;var bankAccounts=[].concat(_toConsumableArray(_this.props.bankAccounts));if(_this.state.accountUpdate.active){bankAccounts=_this.getBankAccountsOnSetAccountActive(_this.state.editAccountIndex);}bankAccounts[_this.state.editAccountIndex]=_this.state.accountUpdate;_this.props.updateBankAccounts(bankAccounts);_this.setState(_this.initialState);};_this.submitNewAccount=function(){if(_this.disableSubmit())return;var bankAccounts=[].concat(_toConsumableArray(_this.props.bankAccounts));if(_this.state.accountUpdate.active){bankAccounts=_this.getBankAccountsOnSetAccountActive();}bankAccounts.push(_this.state.accountUpdate);_this.props.updateBankAccounts(bankAccounts);_this.setState(_this.initialState);};_this.toggleAccountActive=function(accountIndex,active){var bankAccounts=[].concat(_toConsumableArray(_this.props.bankAccounts));if(active){bankAccounts=_this.getBankAccountsOnSetAccountActive(accountIndex);}bankAccounts[accountIndex].active=active;_this.props.updateBankAccounts(bankAccounts);};_this.getBankAccountsOnSetAccountActive=function(){var accountIndex=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var bankAccounts=[].concat(_toConsumableArray(_this.props.bankAccounts));var otherActiveAccount=bankAccounts.find(function(act,index){return index!==accountIndex&&act.active===true;});if(otherActiveAccount){otherActiveAccount.active=false;}else if(accountIndex!==null&&_this.state.accountUpdate.active){_this.setState({accountUpdate:Object.assign({},_this.state.accountUpdate,{active:false})});}return bankAccounts;};_this.validateFieldLength=function(name,length,value){var isValid=Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils__["E" /* validateFieldLength */])(length,value);var dataErrors=[].concat(_toConsumableArray(_this.state.dataErrors));if(isValid)dataErrors=dataErrors.filter(function(e){return e!==name;});else dataErrors.push(name);_this.setState({dataErrors:dataErrors});return isValid;};_this.disableSubmit=function(){var _this$state=_this.state,accountUpdate=_this$state.accountUpdate,dataErrors=_this$state.dataErrors;return dataErrors.length||!accountUpdate.bankRoutingNumber&&!accountUpdate.bankBranchNumber&&!accountUpdate.bankAccountNumber&&!accountUpdate.bankAccountHolder;};_this.state=_this.initialState;return _this;}_createClass(RecipientBankAccountsTable,[{key:'render',value:function render(){var _this2=this;var _props=this.props,bankAccounts=_props.bankAccounts,submitAttempted=_props.submitAttempted;var _state=this.state,accountUpdate=_state.accountUpdate,newAccount=_state.newAccount,editAccountIndex=_state.editAccountIndex;var disableSubmit=this.disableSubmit();var addingOrEditing=newAccount||editAccountIndex!==null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-width bank-accounts-edit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Bank Accounts'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link-text small-text '+(addingOrEditing?"disabled":""),style:{fontSize:"11px",marginLeft:"8px"},onClick:!addingOrEditing?this.addNewAccount:null},'Add New'),(bankAccounts.length>0||newAccount)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'table-header table-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Bank Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Bank Branch'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Account Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Account Holder'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Active'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,bankAccounts.map(function(acct,index){return editAccountIndex===index?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_number_format___default.a,{placeholder:'##',format:'##',onValueChange:function onValueChange(values){return _this2.updateNewAccount('bankRoutingNumber',values.value);}}),label:'Bank Number',name:'bankRoutingNumber',value:accountUpdate.bankRoutingNumber||'',errorMessage:'Invalid Bank Number',validated:true,showValidationError:true,validate:function validate(val){return _this2.validateFieldLength('bankRoutingNumber',2,val);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_number_format___default.a,{placeholder:'###',format:'###',onValueChange:function onValueChange(values){return _this2.updateNewAccount('bankBranchNumber',values.value);}}),label:'Branch Number',name:'bankBranchNumber',value:accountUpdate.bankBranchNumber||'',errorMessage:'Invalid Branch Number',validated:true,showValidationError:true,validate:function validate(val){return _this2.validateFieldLength('bankBranchNumber',3,val);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_number_format___default.a,{placeholder:'###############',format:'###############',onValueChange:function onValueChange(values){return _this2.updateNewAccount('bankAccountNumber',values.value);}}),label:'Account Number',name:'bankAccountNumber',value:accountUpdate.bankAccountNumber||''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Account Holder'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'bankAccountHolder',value:accountUpdate.bankAccountHolder||'',onChange:function onChange(e){return _this2.updateNewAccount(e.target.name,e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Toggle__["a" /* default */],{id:'active-'+index,name:'active',value:accountUpdate.active,onChange:_this2.updateNewAccount})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link-text small-text '+(disableSubmit?"disabled":""),onClick:!disableSubmit?_this2.submitAccountUpdates:null},'Submit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link-text small-text',onClick:function onClick(){return _this2.setState(_this2.initialState);},style:{marginLeft:"16px"}},'Cancel'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:''+(acct.active&&submitAttempted&&!acct.bankRoutingNumber?"required-err-cell":"")},acct.bankRoutingNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:''+(acct.active&&submitAttempted&&!acct.bankBranchNumber?"required-err-cell":"")},acct.bankBranchNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:''+(acct.active&&submitAttempted&&!acct.bankAccountNumber?"required-err-cell":"")},acct.bankAccountNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,acct.bankAccountHolder),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Toggle__["a" /* default */],{name:'active',id:'edit-active-'+index,disabled:addingOrEditing,onChange:function onChange(name,value){return _this2.toggleAccountActive(index,value);},value:addingOrEditing&&accountUpdate.active?false:acct.active})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-pencil primary-hover input '+(newAccount?"disabled":""),onClick:!newAccount?function(){return _this2.setState({editAccountIndex:index,accountUpdate:acct});}:null})));}),newAccount&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'new-acct'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_number_format___default.a,{placeholder:'##',format:'##',onValueChange:function onValueChange(values){return _this2.updateNewAccount('bankRoutingNumber',values.value);}}),label:'Bank Number',name:'bankRoutingNumber',value:accountUpdate.bankRoutingNumber,errorMessage:'Invalid Bank Number',validated:true,showValidationError:true,validate:function validate(val){return _this2.validateFieldLength('bankRoutingNumber',2,val);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_number_format___default.a,{placeholder:'###',format:'###',onValueChange:function onValueChange(values){return _this2.updateNewAccount('bankBranchNumber',values.value);}}),label:'Branch Number',name:'bankBranchNumber',value:accountUpdate.bankBranchNumber,errorMessage:'Invalid Branch Number',validated:true,showValidationError:true,validate:function validate(val){return _this2.validateFieldLength('bankBranchNumber',3,val);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_number_format___default.a,{placeholder:'###############',format:'###############',onValueChange:function onValueChange(values){return _this2.updateNewAccount('bankAccountNumber',values.value);}}),label:'Account Number',name:'bankAccountNumber',value:accountUpdate.bankAccountNumber})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Account Holder'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'bankAccountHolder',value:accountUpdate.bankAccountHolder,onChange:function onChange(e){return _this2.updateNewAccount(e.target.name,e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Toggle__["a" /* default */],{id:'new-active',name:'active',value:accountUpdate.active,onChange:this.updateNewAccount})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link-text small-text '+(disableSubmit?"disabled":""),onClick:!disableSubmit?this.submitNewAccount:null},'Submit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link-text small-text',onClick:function onClick(){return _this2.setState(_this2.initialState);},style:{marginLeft:"16px"}},'Cancel'))))));}}]);return RecipientBankAccountsTable;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (RecipientBankAccountsTable);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_number_format__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_number_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Toggle__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Select__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AchAccountsTable=function(_React$Component){_inherits(AchAccountsTable,_React$Component);function AchAccountsTable(props){_classCallCheck(this,AchAccountsTable);var _this=_possibleConstructorReturn(this,(AchAccountsTable.__proto__||Object.getPrototypeOf(AchAccountsTable)).call(this,props));_this.initialState={accountUpdate:{achRoutingNumber:'',achAccountNumber:'',achAccountType:'',active:false},editAccountIndex:null,newAccount:false,dataErrors:[]};_this.addNewAccount=function(){_this.setState({newAccount:true,accountUpdate:Object.assign({},_this.state.accountUpdate,{active:true})});};_this.updateNewAccount=function(name,value){_this.setState({accountUpdate:Object.assign({},_this.state.accountUpdate,_defineProperty({},name,value))});};_this.submitAccountUpdates=function(){if(_this.disableSubmit())return;var bankAccounts=[].concat(_toConsumableArray(_this.props.bankAccounts));if(_this.state.accountUpdate.active){bankAccounts=_this.getBankAccountsOnSetAccountActive(_this.state.editAccountIndex);}bankAccounts[_this.state.editAccountIndex]=_this.state.accountUpdate;_this.props.updateBankAccounts(bankAccounts);_this.setState(_this.initialState);};_this.submitNewAccount=function(){if(_this.disableSubmit())return;var bankAccounts=[].concat(_toConsumableArray(_this.props.bankAccounts));if(_this.state.accountUpdate.active){bankAccounts=_this.getBankAccountsOnSetAccountActive();}bankAccounts.push(_this.state.accountUpdate);_this.props.updateBankAccounts(bankAccounts);_this.setState(_this.initialState);};_this.toggleAccountActive=function(accountIndex,active){var bankAccounts=[].concat(_toConsumableArray(_this.props.bankAccounts));if(active){bankAccounts=_this.getBankAccountsOnSetAccountActive(accountIndex);}bankAccounts[accountIndex].active=active;_this.props.updateBankAccounts(bankAccounts);};_this.getBankAccountsOnSetAccountActive=function(){var accountIndex=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var bankAccounts=[].concat(_toConsumableArray(_this.props.bankAccounts));var otherActiveAccount=bankAccounts.find(function(act,index){return index!==accountIndex&&act.active===true;});if(otherActiveAccount){otherActiveAccount.active=false;}else if(accountIndex!==null&&_this.state.accountUpdate.active){_this.setState({accountUpdate:Object.assign({},_this.state.accountUpdate,{active:false})});}return bankAccounts;};_this.validateFieldLength=function(name,length,value){var isValid=Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils__["E" /* validateFieldLength */])(length,value);var dataErrors=[].concat(_toConsumableArray(_this.state.dataErrors));if(isValid)dataErrors=dataErrors.filter(function(e){return e!==name;});else dataErrors.push(name);_this.setState({dataErrors:dataErrors});return isValid;};_this.disableSubmit=function(){var _this$state=_this.state,accountUpdate=_this$state.accountUpdate,dataErrors=_this$state.dataErrors;if(dataErrors.length>0)return true;var requiredFieldsMissing=!accountUpdate.achRoutingNumber||accountUpdate.achRoutingNumber===''||!accountUpdate.achAccountNumber||accountUpdate.achAccountNumber===''||!accountUpdate.achAccountType||accountUpdate.achAccountType==='';return requiredFieldsMissing;};_this.state=_this.initialState;return _this;}_createClass(AchAccountsTable,[{key:'render',value:function render(){var _this2=this;var _props=this.props,bankAccounts=_props.bankAccounts,submitAttempted=_props.submitAttempted;var _state=this.state,accountUpdate=_state.accountUpdate,newAccount=_state.newAccount,editAccountIndex=_state.editAccountIndex;var disableSubmit=this.disableSubmit();var addingOrEditing=newAccount||editAccountIndex!==null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'full-width bank-accounts-edit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'ACH Bank Accounts'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link-text small-text '+(addingOrEditing?"disabled":""),style:{fontSize:"11px",marginLeft:"8px"},onClick:!addingOrEditing?this.addNewAccount:null},'Add New'),(bankAccounts.length>0||newAccount)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'table-header table-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Routing Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Account Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Account Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Active'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,bankAccounts.map(function(acct,index){return editAccountIndex===index?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_number_format___default.a,{placeholder:'#########',format:'#########',onValueChange:function onValueChange(values){return _this2.updateNewAccount('achRoutingNumber',values.value);}}),label:'ACH Routing Number',name:'achRoutingNumber',value:accountUpdate.achRoutingNumber||'',errorMessage:'Invalid ACH Routing Number',validated:true,showValidationError:true,validate:function validate(val){return _this2.validateFieldLength('achRoutingNumber',9,val);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_number_format___default.a,{placeholder:'###############',format:'###############',onValueChange:function onValueChange(values){return _this2.updateNewAccount('achAccountNumber',values.value);}}),label:'ACH Account Number',name:'achAccountNumber',value:accountUpdate.achAccountNumber||''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Select__["a" /* default */],{tabIndex:430,options:[{key:'checking',value:'checking'},{key:'savings',value:'savings'}]}),label:'Account Type',name:'achAccountType',value:accountUpdate.achAccountType||'',onChange:_this2.updateNewAccount})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Toggle__["a" /* default */],{id:'active-'+index,name:'active',value:accountUpdate.active,onChange:_this2.updateNewAccount})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link-text small-text '+(disableSubmit?"disabled":""),onClick:!disableSubmit?_this2.submitAccountUpdates:null},'Submit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link-text small-text',onClick:function onClick(){return _this2.setState(_this2.initialState);},style:{marginLeft:"16px"}},'Cancel'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:''+(acct.active&&submitAttempted&&!acct.achRoutingNumber?"required-err-cell":"")},acct.achRoutingNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:''+(acct.active&&submitAttempted&&!acct.achAccountNumber?"required-err-cell":"")},acct.achAccountNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,acct.achAccountType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Toggle__["a" /* default */],{name:'active',id:'edit-active-'+index,disabled:addingOrEditing,onChange:function onChange(name,value){return _this2.toggleAccountActive(index,value);},value:addingOrEditing&&accountUpdate.active?false:acct.active})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-pencil primary-hover input '+(newAccount?"disabled":""),onClick:!newAccount?function(){return _this2.setState({editAccountIndex:index,accountUpdate:acct});}:null})));}),newAccount&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:'new-acct'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_number_format___default.a,{placeholder:'#########',format:'#########',onValueChange:function onValueChange(values){return _this2.updateNewAccount('achRoutingNumber',values.value);}}),label:'ACH Routing Number',name:'achRoutingNumber',value:accountUpdate.achRoutingNumber,errorMessage:'Invalid ACH Routing Number',validated:true,showValidationError:true,validate:function validate(val){return _this2.validateFieldLength('achRoutingNumber',9,val);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_number_format___default.a,{placeholder:'###############',format:'###############',onValueChange:function onValueChange(values){return _this2.updateNewAccount('achAccountNumber',values.value);}}),label:'ACH Account Number',name:'achAccountNumber',value:accountUpdate.achAccountNumber})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Select__["a" /* default */],{tabIndex:430,options:[{key:'checking',value:'checking'},{key:'savings',value:'savings'}]}),label:'Account Type',name:'achAccountType',value:accountUpdate.achAccountType,onChange:this.updateNewAccount})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Toggle__["a" /* default */],{id:'new-active',name:'active',value:accountUpdate.active,onChange:this.updateNewAccount})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link-text small-text '+(disableSubmit?"disabled":""),onClick:!disableSubmit?this.submitNewAccount:null},'Submit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link-text small-text',onClick:function onClick(){return _this2.setState(_this2.initialState);},style:{marginLeft:"16px"}},'Cancel'))))));}}]);return AchAccountsTable;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AchAccountsTable);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RecipientAccountCampaignsTable=function(_React$Component){_inherits(RecipientAccountCampaignsTable,_React$Component);function RecipientAccountCampaignsTable(props){_classCallCheck(this,RecipientAccountCampaignsTable);var _this=_possibleConstructorReturn(this,(RecipientAccountCampaignsTable.__proto__||Object.getPrototypeOf(RecipientAccountCampaignsTable)).call(this,props));_this.state={campaigns:props.campaigns?props.campaigns.sort(function(c1,c2){return c1.campaignName>c2.campaignName;}):[],sortBy:'campaignName',sortAsc:true,showTable:false};return _this;}_createClass(RecipientAccountCampaignsTable,[{key:'sortTable',value:function sortTable(sortBy){var sortAsc=this.state.sortBy===sortBy?!this.state.sortAsc:true;var campaigns=this.state.campaigns.sort(function(c1,c2){return sortAsc?c1[sortBy]>c2[sortBy]:c1[sortBy]<c2[sortBy];});this.setState({sortBy:sortBy,sortAsc:sortAsc,campaigns:campaigns});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'campaigns-card-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'campaigns-card card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'campaigns-card-header flex-justify flex-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Campaigns'),this.props.campaignListId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{className:'btn btn-primary',to:'/campaigns/lists/'+this.props.campaignListId},'Campaign List'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-flat-accent',onClick:function onClick(){return _this2.setState({showTable:!_this2.state.showTable});}},this.state.showTable?"Hide":"Show")),this.state.showTable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-container'},this.state.campaigns&&this.state.campaigns.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'table-header table-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'sort '+(this.state.sortBy==='campaignName'?'active':'')},'Campaign',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sort-arrows relative',onClick:this.sortTable.bind(this,'campaignName')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-android-arrow-dropup'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-android-arrow-dropdown'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'sort '+(this.state.sortBy==='count'?'active':'')},'Count',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sort-arrows relative',onClick:this.sortTable.bind(this,'count')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-android-arrow-dropup'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-android-arrow-dropdown'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'sort '+(this.state.sortBy==='defaultAmount'?'active':'')},'Amount Per Person',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sort-arrows relative',onClick:this.sortTable.bind(this,'defaultAmount')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-android-arrow-dropup'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-android-arrow-dropdown'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'sort '+(this.state.sortBy==='total'?'active':'')},'Total',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sort-arrows relative',onClick:this.sortTable.bind(this,'total')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-android-arrow-dropup'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-android-arrow-dropdown'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.state.campaigns.map(function(campaign){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:campaign.campaignId,className:'table-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Campaign'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,campaign.campaignName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Count'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["m" /* formatNumber */])(campaign.count))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Amount Per Person'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["j" /* formatCurrency */])(campaign.defaultAmount,campaign.isIsraeli))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Total'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["j" /* formatCurrency */])(campaign.total,campaign.isIsraeli))));}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'accent-text no-results'},'No Campaigns'))));}}]);return RecipientAccountCampaignsTable;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (RecipientAccountCampaignsTable);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ApplicationsHistoryTable__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ApplicationDetailsCard__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ApplicationDetailsEditCard__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_constants__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RecipientAccountApplications=function(_React$Component){_inherits(RecipientAccountApplications,_React$Component);function RecipientAccountApplications(props){_classCallCheck(this,RecipientAccountApplications);var _this=_possibleConstructorReturn(this,(RecipientAccountApplications.__proto__||Object.getPrototypeOf(RecipientAccountApplications)).call(this,props));_this.getInitialFormattedApplication=function(applicationDetails){return{paymentInfo:{manualPayment:{blankCheckId:applicationDetails.paymentInfo.manualPayment?applicationDetails.paymentInfo.manualPayment.blankCheckId||null:null,manualPaymentType:applicationDetails.paymentInfo.manualPayment?applicationDetails.paymentInfo.manualPayment.manualPaymentType||null:null,manualPaymentNumber:applicationDetails.paymentInfo.manualPayment?applicationDetails.paymentInfo.manualPayment.manualPaymentNumber||null:null,manualPaymentDate:applicationDetails.paymentInfo.manualPayment?applicationDetails.paymentInfo.manualPayment.manualPaymentDate||null:null,manualPaymentAmount:applicationDetails.paymentInfo.manualPayment?applicationDetails.paymentInfo.manualPayment.manualPaymentAmount||null:null},fundId:applicationDetails.paymentInfo.fundId,payTo:applicationDetails.paymentInfo.payTo,thirdParty:{referenceId:applicationDetails.paymentInfo.thirdParty?applicationDetails.paymentInfo.thirdParty.referenceId:'',useRecipientAddress:applicationDetails.paymentInfo.thirdParty?applicationDetails.paymentInfo.thirdParty.useRecipientAddress:false,isIsraeli:applicationDetails.paymentInfo.thirdParty?applicationDetails.paymentInfo.thirdParty.isIsraeli:_this.props.recipientDetails.isIsraeli,firstName:applicationDetails.paymentInfo.thirdParty?applicationDetails.paymentInfo.thirdParty.firstName||'':'',lastName:applicationDetails.paymentInfo.thirdParty?applicationDetails.paymentInfo.thirdParty.lastName||'':'',orgName:applicationDetails.paymentInfo.thirdParty?applicationDetails.paymentInfo.thirdParty.orgName||'':'',address:applicationDetails.paymentInfo.thirdParty&&applicationDetails.paymentInfo.thirdParty.address?applicationDetails.paymentInfo.thirdParty.address:{},bankNumber:applicationDetails.paymentInfo.thirdParty?applicationDetails.paymentInfo.thirdParty.bankNumber||'':'',branchNumber:applicationDetails.paymentInfo.thirdParty?applicationDetails.paymentInfo.thirdParty.branchNumber||'':'',accountNumber:applicationDetails.paymentInfo.thirdParty?applicationDetails.paymentInfo.thirdParty.accountNumber||'':'',accountHolder:applicationDetails.paymentInfo.thirdParty?applicationDetails.paymentInfo.thirdParty.accountHolder||'':'',careOf:applicationDetails.paymentInfo.thirdParty?applicationDetails.paymentInfo.thirdParty.careOf||'':''},checkMemo:applicationDetails.paymentInfo.checkMemo||'',reportMemo:applicationDetails.paymentInfo.reportMemo||''},isPrivate:applicationDetails.isPrivate,reasonId:applicationDetails.reason?applicationDetails.reason.applicationReasonId:'',amount:applicationDetails.amount||'',requestAmount:applicationDetails.requestedAmount||'',approverId:applicationDetails.approverId||'',sourceId:applicationDetails.source?applicationDetails.source.referenceId:'',individualCategoryId:applicationDetails.campaignIndividualCategoryId||'',newAttachments:[],deletedAttachments:[],cardTypeId:applicationDetails.cardId||'',printInstructions:applicationDetails.printInstructions||'',inquire:applicationDetails.inquire,inquireNote:applicationDetails.inquireNote||'',applicantPledgeId:applicationDetails.applicantPledgeId||'',reasonDate:applicationDetails.reasonDate||'',weddingHall:applicationDetails.weddingHall||'',weddingSide:applicationDetails.weddingSide||''};};_this.getIncompleteFields=function(applicationDetails,thirdPartyPayeeType){var application=applicationDetails||_this.getInitialFormattedApplication(_this.props.currentApplicationDetails.data);var recipient=_this.props.recipientDetails;var initialApplicationDetails=_this.props.currentApplicationDetails.data;var incompleteFields={applicationInfo:[],paymentInfo:[]};var incompleteRecipientInfo=[];//if manual payment only require manual payment fields and last name
if(application.paymentInfo.manualPayment&&application.paymentInfo.manualPayment.manualPaymentType){if(!application.paymentInfo.manualPayment.manualPaymentAmount||!application.paymentInfo.manualPayment.manualPaymentDate||!application.paymentInfo.manualPayment.manualPaymentNumber){incompleteFields.paymentInfo.push('Incomplete Manual Payment Information');}if(recipient.applicantType===__WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__["l" /* RecipientTypes */].Individual){if(!recipient.lastName)incompleteRecipientInfo.push('Last Name');}else{if(!recipient.organization.name)incompleteRecipientInfo.push('Name');}}else{//recipient info
if(recipient.incomplete){if(recipient.applicantType===__WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__["l" /* RecipientTypes */].Individual){if(!recipient.firstName)incompleteRecipientInfo.push('First Name');if(!recipient.lastName)incompleteRecipientInfo.push('Last Name');}else{if(!recipient.organization.name)incompleteRecipientInfo.push('Name');if(recipient.organization.registered&&!recipient.organization.taxId)incompleteRecipientInfo.push('Tax ID');}if(recipient.isIsraeli){if(recipient.applicantType===__WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__["l" /* RecipientTypes */].Individual&&!recipient.teudatZahut)incompleteRecipientInfo.push('Teudat Zehut');if(!recipient.trustedPayee){var activeBankAcct=recipient.bankAccounts.filter(function(acct){return acct.active;})[0];if(!activeBankAcct){incompleteRecipientInfo.push('Active Bank Account');}else{if(!activeBankAcct.bankRoutingNumber)incompleteRecipientInfo.push('Active Bank Account - Bank Number');if(!activeBankAcct.bankBranchNumber)incompleteRecipientInfo.push('Active Bank Account - Branch Number');if(!activeBankAcct.bankAccountNumber)incompleteRecipientInfo.push('Active Bank Account - Account Number');}}}if(!recipient.tags.length)incompleteRecipientInfo.push('Categories');if(!recipient.address.streetNumber||!recipient.address.street||!recipient.address.city||!recipient.address.country)incompleteRecipientInfo.push('Address is Incomplete');}//applicationInfo:
if(!initialApplicationDetails.campaign&&!application.reasonId)incompleteFields.applicationInfo.push('Reason');if(!application.approverId)incompleteFields.applicationInfo.push('Approver');if(initialApplicationDetails.status===__WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__["a" /* ApplicationStatuses */].Approved&&!application.amount)incompleteFields.applicationInfo.push('Amount');//paymentInfo:
if(!application.paymentInfo.fundId)incompleteFields.paymentInfo.push('Fund');var thirdParty=application.paymentInfo.thirdParty;if(application.paymentInfo.payTo===__WEBPACK_IMPORTED_MODULE_5__lib_constants__["e" /* PayeeTypes */].ThirdParty){if(thirdPartyPayeeType===__WEBPACK_IMPORTED_MODULE_5__lib_constants__["i" /* SourceTypes */].Reference){if(!thirdParty.referenceId)incompleteFields.paymentInfo.push('Third Party Payee');}else{if(!thirdParty.orgName&&(!thirdParty.firstName||!thirdParty.lastName))incompleteFields.paymentInfo.push('Third Party Payee Name');if(thirdParty.isIsraeli&&(!application.paymentInfo.manualPayment||!application.paymentInfo.manualPayment.manualPaymentType)&&(!thirdParty.bankNumber||!thirdParty.branchNumber||!thirdParty.accountNumber))incompleteFields.paymentInfo.push('Third Party Payee Bank Information');else if(!thirdParty.isIsraeli&&(!application.paymentInfo.manualPayment||!application.paymentInfo.manualPayment.manualPaymentType)&&!thirdParty.useRecipientAddress&&(!thirdParty.address.streetNumber||!thirdParty.address.street||!thirdParty.address.city||!thirdParty.address.country))incompleteFields.paymentInfo.push('Third Party Payee Address');}}}if(!incompleteFields.applicationInfo.length&&!incompleteFields.paymentInfo.length&&incompleteRecipientInfo.length){//only recipient is incomplete
var missingOnlyRecipientPaymentInfo=incompleteRecipientInfo.every(function(field){return field.indexOf('Active Bank Account')>=0;});//missing only pymt info
var notUsingRecipientPaymentInfo=application.paymentInfo.payTo!==__WEBPACK_IMPORTED_MODULE_5__lib_constants__["e" /* PayeeTypes */].Recipient||application.paymentInfo.manualPayment&&application.paymentInfo.manualPayment.manualPaymentType;//AND not pay to recipient, or manual check pymt (so don't need recipient pymt info)
incompleteFields.incompleteApplicationDueToRecipient=!missingOnlyRecipientPaymentInfo||!notUsingRecipientPaymentInfo;incompleteFields.recipientInfo=incompleteRecipientInfo;//add incomplete recipient info only if affecting application
}return incompleteFields.applicationInfo.length||incompleteFields.paymentInfo.length||incompleteFields.incompleteApplicationDueToRecipient?incompleteFields:null;};_this.state={selectedApplicationId:null};return _this;}_createClass(RecipientAccountApplications,[{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.props.editMode)this.props.toggleEditMode();}},{key:'render',value:function render(){var applications=this.props.applicationHistory.data;var selectedApplicationIndex=applications.map(function(app){return app.applicationId;}).indexOf(this.props.currentApplicationId);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'application-details flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ApplicationsHistoryTable__["a" /* default */],{currentApplicationId:this.props.currentApplicationId,applications:applications,'export':this.props.export,editMode:this.props.editMode,loading:this.props.applicationHistory.loading,recipientId:this.props.recipientDetails.applicantId,recipientName:this.props.recipientDetails.applicantType===__WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__["l" /* RecipientTypes */].Organization?this.props.recipientDetails.organization.name:this.props.recipientDetails.lastName+' '+this.props.recipientDetails.firstName,totalPaid:this.props.recipientDetails.totalPaid,recipientIsIsraeli:this.props.recipientDetails.isIsraeli,selectApplication:this.props.selectApplication.bind(this),allowCreate:this.props.permissions.applications.manage,getRecipientApplicationsForExport:this.props.getRecipientApplicationsForExport}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details-card-container'},this.props.currentApplicationId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.editMode?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ApplicationDetailsEditCard__["a" /* default */],{recipientDetails:this.props.recipientDetails,applicationDetails:this.props.currentApplicationDetails.data,updateApplication:this.props.updateApplication,updateApplicationDetails:this.props.updateApplicationDetails,getApplicationDetails:this.props.getApplicationDetails,getApplicationHistory:this.props.getApplicationHistory,permissions:this.props.permissions,toggleEditMode:this.props.toggleEditMode,getBlankChecks:this.props.getBlankChecks,blankChecks:this.props.blankChecks,manualPaymentTypes:this.props.manualPaymentTypes,tags:this.props.tags,userId:this.props.userId,getInitialFormattedApplication:this.getInitialFormattedApplication,getIncompleteFields:this.getIncompleteFields}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ApplicationDetailsCard__["a" /* default */],{recipientDetails:this.props.recipientDetails,applicationDetails:this.props.currentApplicationDetails.data,loading:this.props.currentApplicationDetails.loading,totalApplications:applications.length,applicationIndex:selectedApplicationIndex+1,prevApplicationId:selectedApplicationIndex<=0?null:applications[selectedApplicationIndex-1].applicationId,nextApplicationId:selectedApplicationIndex<0||selectedApplicationIndex===applications.length-1?null:applications[selectedApplicationIndex+1].applicationId,selectApplication:this.props.selectApplication.bind(this),toggleEditMode:this.props.toggleEditMode,disableEditMode:this.props.disableEditMode,updateApplicationStatus:this.props.updateApplicationStatus,revertApplicationStatus:this.props.revertApplicationStatus,applicationStatusUpdate:this.props.applicationStatusUpdate,getApplicationDetails:this.props.getApplicationDetails,printCheck:this.props.printCheck,printing:this.props.printing,confirmPrinting:this.props.confirmPrinting,confirmingPrinting:this.props.confirmingPrinting,wireApplication:this.props.wireApplication,sendACH:this.props.sendACH,sendingACH:this.props.sendingACH,voidPayment:this.props.voidPayment,voidingPayment:this.props.voidingPayment,addNote:this.props.addNote,updateNote:this.props.updateNote,deleteNote:this.props.deleteNote,updatingNote:this.props.updatingNote,updateAttachments:this.props.updateAttachments,updatingAttachments:this.props.updatingAttachments,updateReceipts:this.props.updateReceipts,deleteReceipt:this.props.deleteReceipt,updatingReceipts:this.props.updatingReceipts,userId:this.props.userId,permissions:this.props.permissions.applications,admin:this.props.permissions.admin,funds:this.props.funds,getIncompleteFields:this.getIncompleteFields}))));}}]);return RecipientAccountApplications;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (RecipientAccountApplications);

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_ApplicationStatusTag__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RecipientApplicationsReportModal__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ApplicationsTable=function(_NavigationComponent){_inherits(ApplicationsTable,_NavigationComponent);function ApplicationsTable(props){_classCallCheck(this,ApplicationsTable);var _this=_possibleConstructorReturn(this,(ApplicationsTable.__proto__||Object.getPrototypeOf(ApplicationsTable)).call(this,props));_this.state={showModals:{reportModal:false}};return _this;}_createClass(ApplicationsTable,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'applications-card-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'applications-card card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'applications-card-header flex-justify flex-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Applications'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-flat btn-small',onClick:function onClick(){return _this2.toggleModal("reportModal");},disabled:!this.props.applications.length},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/export-icon.png',className:'icon-left',alt:'export-icon'}),'Export'),this.props.allowCreate&&this.props.recipientId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{className:'btn btn-primary primary',to:'/applications/create-application/'+this.props.recipientId},'Create')),this.props.loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20'}):!this.props.applications.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'no-applications'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-layers'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'There are no applications.')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'applications-list'},this.props.applications.map(function(application){var selected=_this2.props.currentApplicationId===application.applicationId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:application.applicationId,className:'application '+(selected?"application-selected":_this2.props.editMode?"application-disabled":""),onClick:!selected&&!_this2.props.editMode?_this2.props.selectApplication.bind(_this2,application.applicationId):null},application.isBlocked?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'application-grid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},'Private application by ',application.createdBy),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text accent-text text-right'},Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["k" /* formatDate */])(application.date))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'application-grid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},application.reason||application.campaign),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text text-right'},application.campaignIndividualCategory||application.campaignList),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text'},Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["j" /* formatCurrency */])(application.amount,application.currency===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["f" /* CurrencyTypes */].Shekel)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'history-table-application-tag'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_ApplicationStatusTag__["a" /* default */],{status:application.status})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'small-text accent-text text-right'},Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["k" /* formatDate */])(application.date),application.checkOrWireDate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tooltip application-list-tooltip'},'Check/Wire Date: ',Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["k" /* formatDate */])(application.checkOrWireDate)))));})),this.props.applications.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'application-total'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-right bold-text'},'Total Paid: ',this.props.totalPaid||(this.props.recipientIsIsraeli?__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["f" /* CurrencyTypes */].Shekel:__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["f" /* CurrencyTypes */].Dollar)+'0')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RecipientApplicationsReportModal__["a" /* default */],{getDataForExport:this.props.getRecipientApplicationsForExport.bind(this),recipientId:this.props.recipientId,recipientName:this.props.recipientName,'export':this.props.export,show:this.state.showModals.reportModal,close:function close(){return _this2.toggleModal("reportModal");}}));}}]);return ApplicationsTable;}(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ApplicationsTable);

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function getReportFields(){return{Recipient:[{label:"Name",value:"DisplayName",default:""},{label:"Report Name",value:"ReportName",default:""},{label:"Phone Number(s)",value:"PhoneNumber",default:""},{label:"Email Address",value:"Email",default:""},{label:"Address",value:"DisplayAddress",default:""},{label:"Applicant Type",value:"ApplicantType",default:""},{label:"Reference(s)",value:"References",default:""},{label:"Solicitor(s)",value:"Solicitors",default:""},{label:"Rosh Yeshiva(s)",value:"RoshYeshivas",default:""},{label:"Campaign List(s)",value:"CampaignLists",default:""},{label:"Notes",value:"RecipientNotes",default:""},{label:"Total Paid",value:"TotalPaid",default:""}],Application:[{label:"Created By",value:"CreatedBy",default:""},{label:"Creation Date",value:"CreationDate",default:""},{label:"Status",value:"Status",default:""},{label:"Amount",value:"Amount",default:""},{label:"Currency",value:"Currency",default:""},{label:"Reason",value:"Reason",default:""},{label:"Fund",value:"Fund",default:""},{label:"Check Date",value:"CheckOrWireDate",default:""},{label:"Check #",value:"CheckOrWireNumber",default:""},{label:"Check Memo",value:"CheckMemo",default:""},{label:"Report Memo",value:"ReportMemo",default:""},{label:"Approved By",value:"ApprovedBy",default:""},{label:"Review Date",value:"ReviewDate",default:""},{label:"Notes",value:"ApplicationNotes",default:""}]};}var initialState={fields:[],startDate:"",endDate:"",error:false,noData:false,downloading:false,submitAttempted:false};var RecipientApplicationsReportModal=function(_React$Component){_inherits(RecipientApplicationsReportModal,_React$Component);function RecipientApplicationsReportModal(props){_classCallCheck(this,RecipientApplicationsReportModal);var _this=_possibleConstructorReturn(this,(RecipientApplicationsReportModal.__proto__||Object.getPrototypeOf(RecipientApplicationsReportModal)).call(this,props));_this.onChange=function(name,value){_this.setState(_defineProperty({},name,value));};_this.onToggleReportFields=function(event){var fieldName=event.target.name;var checked=event.target.checked;var fields=[].concat(_toConsumableArray(_this.state.fields));if(checked){fields.push(fieldName);}else{fields=fields.filter(function(f){return f!==fieldName;});}_this.setState({fields:fields});};_this.state=initialState;return _this;}_createClass(RecipientApplicationsReportModal,[{key:"close",value:function close(){this.setState(initialState);this.props.close();}},{key:"exportData",value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _state,fields,startDate,endDate,recipientId,dateNow,reportFields,params,exportRecipientHeaders,exportApplicationHeaders,reportName,response,records,recipientHeadersCSV,csv;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({error:false,noData:false,submitAttempted:true});_state=this.state,fields=_state.fields,startDate=_state.startDate,endDate=_state.endDate;recipientId=this.props.recipientId;if(fields.length){_context.next=5;break;}return _context.abrupt("return");case 5:this.setState({downloading:true});_context.prev=6;dateNow=""+new Date().toLocaleDateString().replace(/\//g,"_");reportFields=getReportFields();params={fields:fields,recipientId:recipientId,startDate:startDate,endDate:endDate};exportRecipientHeaders=reportFields.Recipient.filter(function(field){return fields.indexOf(field.value)>=0;});exportApplicationHeaders=reportFields.Application.filter(function(field){return fields.indexOf(field.value)>=0;});reportName=(this.props.recipientName+" "+dateNow).replace(' ','_');_context.next=15;return this.props.getDataForExport(params);case 15:response=this.props.export;if(response.success){_context.next=18;break;}throw Error("error");case 18:records=response.data.values;if(records.length){_context.next=21;break;}throw Error("noData");case 21:recipientHeadersCSV=Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["d" /* convertToCSV */])([{label:" ",value:"rowName",default:""},{label:" ",value:"rowValue",default:""}],[{rowName:"Report Dates:",rowValue:startDate||endDate?Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["k" /* formatDate */])(startDate+" 00:00:0000")+" - "+Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["k" /* formatDate */])(endDate+" 00:00:0000"):''}].concat(_toConsumableArray(exportRecipientHeaders.map(function(field){return{rowName:field.label,rowValue:records[0][field.value]};}))));csv=recipientHeadersCSV+"\r\n\r\n"+Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["d" /* convertToCSV */])(exportApplicationHeaders,records);Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["f" /* downloadCSV */])(csv,reportName+".xls");this.setState({downloading:false},this.close);_context.next=30;break;case 27:_context.prev=27;_context.t0=_context["catch"](6);this.setState(_defineProperty({downloading:false},_context.t0.message||"error",true));case 30:case"end":return _context.stop();}}},_callee,this,[[6,27]]);}));function exportData(){return _ref.apply(this,arguments);}return exportData;}()},{key:"render",value:function render(){var _this2=this;var _state2=this.state,error=_state2.error,fields=_state2.fields,startDate=_state2.startDate,endDate=_state2.endDate,downloading=_state2.downloading,noData=_state2.noData,submitAttempted=_state2.submitAttempted;var show=this.props.show;var reportFields=getReportFields();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal new-fund-modal large-modal"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"bordered-modal-header"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",{className:"modal-page-header"},"Recipient Applications Report"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon ion-ios-close-empty",onClick:this.close.bind(this)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"mb-16"},submitAttempted&&!fields.length&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"xs-text error-text ml-8"},"* Please select report fields")),Object.keys(reportFields).map(function(key,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"mb-16",key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"mb-16 input-label "+(submitAttempted&&!fields.length?"error-label":"")},key," Fields"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row report-fields-grid"},reportFields[key].map(function(field){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-check-container",key:field.value},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",id:"report-field-"+field.value,className:"custom-check",name:field.value,onChange:_this2.onToggleReportFields,checked:fields.indexOf(field.value)>=0}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{htmlFor:"report-field-"+field.value,className:"secondary-text"},field.label));})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half column-half-left"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"input-label"},"Between Dates"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"date",max:endDate}),value:Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["l" /* formatDateForInput */])(startDate),name:"startDate",onChange:this.onChange})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"date",min:startDate}),value:Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["l" /* formatDateForInput */])(endDate),name:"endDate",onChange:this.onChange})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-btns text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-accent",onClick:this.close.bind(this)},"Cancel"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-primary",onClick:this.exportData.bind(this),disabled:downloading},downloading?"Downloading Report":"Download Report"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:error}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:noData,message:"No data was found.",timeOut:5000})))));}}]);return RecipientApplicationsReportModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (RecipientApplicationsReportModal);

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_apiUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_shared_ApplicationActionsDropdown__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_shared_ExportButton__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__printingComponents_PrintModal__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CompletePrintingModal__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ApplicationAttachmentModal__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ApplicationAttachmentsUploadModal__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ApplyToPledgeModal__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__NoteModal__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__commonComponents_shared_ConfirmationModal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__commonComponents_shared_IncompleteApplicationWarning__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__applicationsComponents_applicationsCommon_MarkInquiryWarning__ = __webpack_require__(187);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ApplicationDetailsCard=function(_NavigationComponent){_inherits(ApplicationDetailsCard,_NavigationComponent);function ApplicationDetailsCard(props){var _this2=this;_classCallCheck(this,ApplicationDetailsCard);var _this=_possibleConstructorReturn(this,(ApplicationDetailsCard.__proto__||Object.getPrototypeOf(ApplicationDetailsCard)).call(this,props));_this.handleReceiptFileSelect=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var files,file;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:files=event.target.files;if(!(files&&files.length>0)){_context.next=14;break;}// Only take the first file (only one receipt allowed)
file=files[0];_this.setState({uploadingReceipt:true});_context.next=6;return _this.props.updateReceipts(_this.props.applicationDetails.applicationId,{newReceipts:[file],deletedReceipts:[]});case 6:// Reset the file input
if(_this.receiptFileInputRef){_this.receiptFileInputRef.value='';}_this.setState({uploadingReceipt:false});// Check for errors and refresh application details
if(!_this.props.updatingReceipts.success){_context.next=13;break;}_context.next=11;return _this.props.getApplicationDetails(_this.props.applicationDetails.applicationId,true);case 11:_context.next=14;break;case 13:__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].error('Upload failed',_this.props.updatingReceipts.message||'We were unable to upload the receipt. Please try again.');case 14:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.handleAddReceiptClick=function(){if(_this.receiptFileInputRef){_this.receiptFileInputRef.click();}};_this.handleDeleteReceipt=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event,receipt){var receiptId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(event){event.stopPropagation();// Prevent triggering the view receipt click
event.preventDefault();}receiptId=receipt.documentId||receipt.fileId||receipt.fileid;if(receiptId){_context2.next=5;break;}console.error('No receipt ID found:',receipt);return _context2.abrupt('return');case 5:_this.setState({deletingReceipt:true});_context2.prev=6;_context2.next=9;return _this.props.deleteReceipt(_this.props.applicationDetails.applicationId,receiptId);case 9:if(!_this.props.updatingReceipts.success){_context2.next=14;break;}_context2.next=12;return _this.props.getApplicationDetails(_this.props.applicationDetails.applicationId,true);case 12:_context2.next=15;break;case 14:__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].error('Delete failed',_this.props.updatingReceipts.message||'We were unable to delete the receipt. Please try again.');case 15:_context2.next=21;break;case 17:_context2.prev=17;_context2.t0=_context2['catch'](6);console.error('Error deleting receipt:',_context2.t0);__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].error('Something went wrong','We were unable to delete the receipt. Please try again.');case 21:_context2.prev=21;_this.setState({deletingReceipt:false});return _context2.finish(21);case 24:case'end':return _context2.stop();}}},_callee2,_this2,[[6,17,21,24]]);}));return function(_x2,_x3){return _ref2.apply(this,arguments);};}();_this.handleReceiptDragEnter=function(event){event.preventDefault();event.stopPropagation();_this.setState({isDraggingReceipt:true});};_this.handleReceiptDragLeave=function(event){event.preventDefault();event.stopPropagation();// Only set to false if leaving the drop zone entirely
if(event.currentTarget&&!event.currentTarget.contains(event.relatedTarget)){_this.setState({isDraggingReceipt:false});}};_this.handleReceiptDragOver=function(event){event.preventDefault();event.stopPropagation();};_this.handleReceiptDrop=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var files,file,acceptedTypes;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:event.preventDefault();event.stopPropagation();_this.setState({isDraggingReceipt:false});files=event.dataTransfer.files;if(!(files&&files.length>0)){_context3.next=20;break;}file=files[0];// Validate file type
acceptedTypes=['application/pdf','text/html','image/png','image/jpeg','image/tiff','image/gif','image/bmp'];if(acceptedTypes.includes(file.type)){_context3.next=10;break;}__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].error('Invalid file type','Please upload a PDF, HTML, or image file.');return _context3.abrupt('return');case 10:_this.setState({uploadingReceipt:true});_context3.next=13;return _this.props.updateReceipts(_this.props.applicationDetails.applicationId,{newReceipts:[file],deletedReceipts:[]});case 13:_this.setState({uploadingReceipt:false});// Check for errors and refresh application details
if(!_this.props.updatingReceipts.success){_context3.next=19;break;}_context3.next=17;return _this.props.getApplicationDetails(_this.props.applicationDetails.applicationId,true);case 17:_context3.next=20;break;case 19:__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].error('Upload failed',_this.props.updatingReceipts.message||'We were unable to upload the receipt. Please try again.');case 20:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x4){return _ref3.apply(this,arguments);};}();_this.closeApplyToPledgeModal=function(){_this.setState(function(prevState){return{selectedPledgeId:'',applyingPledge:false,showModals:Object.assign({},prevState.showModals,{applyToPledgeModal:false})};});};_this.applyPledgeToApplication=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var selectedPledgeId,applicationDetails,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:selectedPledgeId=_this.state.selectedPledgeId;applicationDetails=_this.props.applicationDetails;if(selectedPledgeId){_context4.next=5;break;}__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].error('Pledge required','Please select a pledge to apply.');return _context4.abrupt('return');case 5:_this.setState({applyingPledge:true});_context4.prev=6;_context4.next=9;return Object(__WEBPACK_IMPORTED_MODULE_4__lib_apiUtils__["e" /* putRequest */])('/applications/'+applicationDetails.applicationId+'/pledge/'+selectedPledgeId);case 9:response=_context4.sent;if(!response.success){_context4.next=17;break;}_context4.next=13;return _this.props.getApplicationDetails(applicationDetails.applicationId,true,applicationDetails.recipientId);case 13:_this.closeApplyToPledgeModal();__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].success('Pledge Applied','The selected pledge was applied to the application.');_context4.next=18;break;case 17:__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].error('Unable to apply pledge',response.message||'Please try again.');case 18:_context4.next=23;break;case 20:_context4.prev=20;_context4.t0=_context4['catch'](6);__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].error('Unable to apply pledge',_context4.t0.message||'Please try again.');case 23:_context4.prev=23;_this.setState({applyingPledge:false});return _context4.finish(23);case 26:case'end':return _context4.stop();}}},_callee4,_this2,[[6,20,23,26]]);}));_this.initialState={showHistory:false,sendingACH:false,showModals:{printApplicationsModal:false,completePrintingModal:false,confirmPrintingModal:false,applicationAttachmentModal:false,applicationAttachmentsUploadModal:false,applicationNoteModal:false,deleteNoteConfirmationModal:false,revertStatusConfirmationModal:false,sendACHConfirmationModal:false,applyToPledgeModal:false},achSendSuccess:false,uploadingReceipt:false,deletingReceipt:false,isDraggingReceipt:false,selectedPledgeId:'',applyingPledge:false,attachment:{loading:false,success:true,document:{}},receipt:{loading:false,success:true,document:{}},viewingDocumentType:null,// 'attachment' or 'receipt'
note:{}};_this.state=_this.initialState;_this.detailsRef=null;_this.setDetailsRef=function(element){_this.detailsRef=element;};_this.receiptFileInputRef=null;_this.setReceiptFileInputRef=function(element){_this.receiptFileInputRef=element;};return _this;}_createClass(ApplicationDetailsCard,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.applicationDetails.applicationId&&nextProps.applicationDetails.applicationId!==this.props.applicationDetails.applicationId)this.setState(this.initialState);}},{key:'getWireApplicationForExport',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(applicationId){var application;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return this.props.wireApplication([applicationId]);case 2:application=_context5.sent;if(application.data.length){application.data[0].teudatZahut=Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["n" /* formatNumberStringForExcel */])(application.data[0].teudatZahut);}return _context5.abrupt('return',application);case 5:case'end':return _context5.stop();}}},_callee5,this);}));function getWireApplicationForExport(_x5){return _ref5.apply(this,arguments);}return getWireApplicationForExport;}()},{key:'validForACH',value:function validForACH(){var _props=this.props,recipientDetails=_props.recipientDetails,applicationDetails=_props.applicationDetails;var paymentInfo=applicationDetails.paymentInfo;var bankAccounts=recipientDetails.bankAccounts||[];// Validate ACH eligibility
if(!paymentInfo.fundAllowsACH||paymentInfo.payTo!==__WEBPACK_IMPORTED_MODULE_18__lib_constants__["e" /* PayeeTypes */].Recipient){return false;}// Check for at least one valid ACH-enabled account
return bankAccounts.some(function(_ref6){var active=_ref6.active,achRoutingNumber=_ref6.achRoutingNumber,achAccountNumber=_ref6.achAccountNumber,achAccountType=_ref6.achAccountType;return active&&achRoutingNumber&&achAccountNumber&&achAccountType;});}},{key:'isOrg',value:function isOrg(){return this.props.applicationDetails.recipient.applicantType===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["l" /* RecipientTypes */].Organization;}},{key:'confirmSendACH',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){var _props$applicationDet,applicationId,recipientId,response,applicationResult,errorMessage,_errorMessage,_errorMessage2;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_props$applicationDet=this.props.applicationDetails,applicationId=_props$applicationDet.applicationId,recipientId=_props$applicationDet.recipientId;this.setState({sendingACH:true,achSendSuccess:false});_context6.prev=2;_context6.next=5;return this.props.sendACH([applicationId]);case 5:response=_context6.sent;if(!response.success){_context6.next=20;break;}applicationResult=response.data?response.data.find(function(result){return result.transactionId===applicationId;}):null;if(!(applicationResult&&applicationResult.isSuccess)){_context6.next=15;break;}__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].success("ACH Transfer Successful","The ACH transfer has been initiated successfully.");this.setState({achSendSuccess:true});this.props.getApplicationDetails(applicationId,true,recipientId);return _context6.abrupt('return',true);case 15:errorMessage=applicationResult?applicationResult.message:"No response received from server";__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].error("ACH Transfer Failed",errorMessage);return _context6.abrupt('return',false);case 18:_context6.next=23;break;case 20:_errorMessage=response.message||"ACH transfer could not be initiated. Please try again.";__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].error("ACH Transfer Failed",_errorMessage);return _context6.abrupt('return',false);case 23:_context6.next=31;break;case 25:_context6.prev=25;_context6.t0=_context6['catch'](2);console.error('ACH Error:',_context6.t0);_errorMessage2=_context6.t0.message||"ACH transfer could not be initiated. Please try again.";__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].error("Something went wrong",_errorMessage2);return _context6.abrupt('return',false);case 31:_context6.prev=31;this.setState({sendingACH:false});return _context6.finish(31);case 34:case'end':return _context6.stop();}}},_callee6,this,[[2,25,31,34]]);}));function confirmSendACH(){return _ref7.apply(this,arguments);}return confirmSendACH;}()},{key:'getApplicationActions',value:function getApplicationActions(status){var _this3=this;var application=this.props.applicationDetails;var fund=application.paymentInfo?this.props.funds.find(function(f){return f.key===application.paymentInfo.fundId;}).value:{};var applicationActionsDropdown=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_shared_ApplicationActionsDropdown__["a" /* default */],{status:status,applicationId:application.applicationId,userId:this.props.userId,approverId:application.approverId,admin:this.props.admin,amount:application.amount,currency:application.currency,inquire:application.inquire,inquireNote:application.inquireNote,update:this.props.applicationStatusUpdate,updateApplicationStatus:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(action,app){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return _this3.props.updateApplicationStatus(action,app);case 2:if(_this3.props.applicationStatusUpdate.success)_this3.props.getApplicationDetails(application.applicationId,true);case 3:case'end':return _context7.stop();}}},_callee7,_this3);}));return function(_x6,_x7){return _ref8.apply(this,arguments);};}(),maxAmount:application.maxApprovalAmount});switch(status){case __WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].New:return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.props.permissions.manage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-flat-primary',disabled:this.props.disableEditMode,title:this.props.disableEditMode?"Submit your recipient changes before editing this application.":"",onClick:this.props.toggleEditMode},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-edit icon-left'}),'Edit'),(this.props.permissions.approveFull||this.props.permissions.approveLimited)&&applicationActionsDropdown);case __WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].Incomplete:return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.props.permissions.manage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-flat-primary',onClick:this.props.toggleEditMode.bind(this)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-edit icon-left'}),'Edit'),this.props.admin||this.props.userId===application.approverId?applicationActionsDropdown:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-xs btn-flat-status-incomplete'},'Incomplete'));case __WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].Approved:return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex'},this.props.permissions.manage&&application.approverId===this.props.userId&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-flat-primary',onClick:this.props.toggleEditMode.bind(this)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-edit icon-left'}),'Edit'),application.currency===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["f" /* CurrencyTypes */].Shekel?this.props.permissions.wire&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_shared_ExportButton__["a" /* default */],{text:'Wire Payment',busyText:'Exporting Wire Info...',disabled:application.amount>fund.wiringMax,title:application.amount>fund.wiringMax?"Application amount exceeds wiring max":"",exportHeaders:[{label:"First Name",value:"firstName",default:""},{label:"Last Name",value:"lastName",default:""},{label:"Teudat",value:"teudatZahut",default:""},{label:"Wire Info",value:"wireInfo",default:""},{label:"Address",value:"address",default:""},{label:"City",value:"city",default:""},{label:"Amount",value:"amount",default:""},{label:"Pay To",value:"payTo",default:""},{label:"Currency Symbol",value:"currencySymbol",default:""}],fileName:'Approved-wires',getDataForExport:this.getWireApplicationForExport.bind(this,application.applicationId),onGetDataSuccess:this.props.getApplicationDetails.bind(this,application.applicationId,true,application.recipientId)}):this.props.permissions.print&&(application.printJobId?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat',onClick:this.toggleModal.bind(this,'confirmPrintingModal')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-printer icon-left'}),'Confirm Printing'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat',disabled:application.amount>fund.checkCuttingMax,title:application.amount>fund.checkCuttingMax?"Application amount exceeds check cutting max":"",onClick:this.toggleModal.bind(this,'printApplicationsModal')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-printer icon-left'}),'Print'),this.validForACH()&&this.isOrg()&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat',disabled:application.amount>fund.checkCuttingMax||this.state.sendingACH,title:application.amount>fund.checkCuttingMax?"Application amount exceeds check cutting max":"",onClick:this.toggleModal.bind(this,'sendACHConfirmationModal')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-credit-card icon-left'}),this.state.sendingACH?'Sending...':'Send ACH'))),(this.props.permissions.approveFull||this.props.permissions.approveLimited)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-flat-accent',onClick:function onClick(){return _this3.toggleModal('revertStatusConfirmationModal');}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-action-undo icon-left'}),'Undo Approval'),this.props.admin||this.props.userId===application.approverId?applicationActionsDropdown:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-xs btn-flat-status-approved'},'Approved'));case __WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].InReview:return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,(this.props.permissions.approveFull||this.props.permissions.approveLimited)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-flat-accent',onClick:function onClick(){return _this3.toggleModal('revertStatusConfirmationModal');}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-action-undo icon-left'}),'Undo Review'),this.props.permissions.approveFull||this.props.permissions.approveLimited?applicationActionsDropdown:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-xs btn-flat-status-inreview'},'In Review'));case __WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].Paid:return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,application.clearedMonth?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-flat-cleared'},'Cleared ',application.clearedMonth):this.props.permissions.void&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-void',onClick:_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return _this3.props.voidPayment([application.applicationId]);case 2:if(_this3.props.voidingPayment.success)_this3.props.getApplicationDetails(application.applicationId,true,application.recipientId);case 3:case'end':return _context8.stop();}}},_callee8,_this3);}))},this.props.voidingPayment.loading?'Voiding...':'Void'),this.props.admin||this.props.userId===application.approverId?applicationActionsDropdown:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-xs btn-flat-status-paid'},'Paid'));case __WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].Rejected:return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,(this.props.permissions.approveFull||this.props.permissions.approveLimited)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-flat-accent',onClick:function onClick(){return _this3.toggleModal('revertStatusConfirmationModal');}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-action-undo icon-left'}),'Undo Rejection'),this.props.admin||this.props.userId===application.approverId?applicationActionsDropdown:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-xs btn-flat-status-rejected'},'Rejected'));default:return null;}}},{key:'navigateToApplication',value:function navigateToApplication(applicationId){if(!applicationId)return;this.props.selectApplication(applicationId);var detailsNode=this.detailsRef;if(detailsNode){var position=detailsNode.getBoundingClientRect();window.scrollTo({behavior:'smooth',left:position.left,top:position.top});}}},{key:'viewAttachment',value:function viewAttachment(document){var _this4=this;this.setState({attachment:{success:true,loading:true,document:Object.assign({},document,{source:''})},receipt:{loading:false,success:true,document:{}},viewingDocumentType:'attachment'},_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(){var res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_this4.toggleModal('applicationAttachmentModal');_context9.next=3;return Object(__WEBPACK_IMPORTED_MODULE_4__lib_apiUtils__["b" /* getRequest */])('/applications/'+_this4.props.applicationDetails.applicationId+'/attachments/'+document.documentId,null,null,{responseType:'arraybuffer'});case 3:res=_context9.sent;_this4.setState({attachment:{success:res.success,loading:false,document:Object.assign({},_this4.state.attachment.document,{source:res.data})}});case 5:case'end':return _context9.stop();}}},_callee9,_this4);})));}},{key:'viewReceipt',value:function viewReceipt(document){var _this5=this;this.setState({receipt:{success:true,loading:true,document:Object.assign({},document,{source:''})},attachment:{loading:false,success:true,document:{}},viewingDocumentType:'receipt'},_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(){var res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_this5.toggleModal('applicationAttachmentModal');_context10.next=3;return Object(__WEBPACK_IMPORTED_MODULE_4__lib_apiUtils__["b" /* getRequest */])('/applications/'+_this5.props.applicationDetails.applicationId+'/receipts/'+document.documentId,null,null,{responseType:'arraybuffer'});case 3:res=_context10.sent;_this5.setState({receipt:{success:res.success,loading:false,document:Object.assign({},_this5.state.receipt.document,{source:res.data})}});case 5:case'end':return _context10.stop();}}},_callee10,_this5);})));}},{key:'showApplicationReasonDate',value:function showApplicationReasonDate(reason,reasonDate){//Only shows Application Reason Date(wedding date) in case of wedding (Wedding Date)
if(this.isWedding(reason.reason)&&reasonDate){var rDate=new Date(Date.parse(reasonDate));var localeFormattedDate=this.props.recipientDetails.isIsraeli?rDate.toLocaleDateString('he-IL'):rDate.toLocaleDateString('en-us');return' ('+localeFormattedDate+')';}return'';}},{key:'isWedding',value:function isWedding(reason){return reason.toLowerCase().includes('wedding');}},{key:'render',value:function render(){var _this6=this;var _props$applicationDet2=this.props.applicationDetails,amount=_props$applicationDet2.amount,applicationId=_props$applicationDet2.applicationId,approvalNote=_props$applicationDet2.approvalNote,approverName=_props$applicationDet2.approverName,_props$applicationDet3=_props$applicationDet2.attachments,attachments=_props$applicationDet3===undefined?[]:_props$applicationDet3,_props$applicationDet4=_props$applicationDet2.receipts,receipts=_props$applicationDet4===undefined?[]:_props$applicationDet4,campaign=_props$applicationDet2.campaign,campaignIndividualCategory=_props$applicationDet2.campaignIndividualCategory,card=_props$applicationDet2.card,checkOrWireNumber=_props$applicationDet2.checkOrWireNumber,checkOrWireDate=_props$applicationDet2.checkOrWireDate,createdBy=_props$applicationDet2.createdBy,currency=_props$applicationDet2.currency,_props$applicationDet5=_props$applicationDet2.history,history=_props$applicationDet5===undefined?[]:_props$applicationDet5,isBlocked=_props$applicationDet2.isBlocked,isPrivate=_props$applicationDet2.isPrivate,_props$applicationDet6=_props$applicationDet2.notes,notes=_props$applicationDet6===undefined?[]:_props$applicationDet6,_props$applicationDet7=_props$applicationDet2.paymentInfo,paymentInfo=_props$applicationDet7===undefined?{}:_props$applicationDet7,printInstructions=_props$applicationDet2.printInstructions,printJobId=_props$applicationDet2.printJobId,_props$applicationDet8=_props$applicationDet2.reason,reason=_props$applicationDet8===undefined?{}:_props$applicationDet8,_props$applicationDet9=_props$applicationDet2.reasonDate,reasonDate=_props$applicationDet9===undefined?{}:_props$applicationDet9,recipientId=_props$applicationDet2.recipientId,_props$applicationDet10=_props$applicationDet2.source,source=_props$applicationDet10===undefined?{}:_props$applicationDet10,rejectReason=_props$applicationDet2.rejectReason,requestedAmount=_props$applicationDet2.requestedAmount,reviewDate=_props$applicationDet2.reviewDate,signatureNeeded=_props$applicationDet2.signatureNeeded,status=_props$applicationDet2.status,inquire=_props$applicationDet2.inquire,inquireNote=_props$applicationDet2.inquireNote,approverId=_props$applicationDet2.approverId,applicantPledge=_props$applicationDet2.applicantPledge,applicantPledgeId=_props$applicationDet2.applicantPledgeId,weddingHall=_props$applicationDet2.weddingHall,weddingSide=_props$applicationDet2.weddingSide,createdDate=_props$applicationDet2.createdDate;var applicationHistory=history.slice().sort(function(r1,r2){return r2.applicationHistoryId-r1.applicationHistoryId;});var payeeIsIsraeli=Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["p" /* getApplicationPayee */])(this.props.applicationDetails.paymentInfo,this.props.recipientDetails).isIsraeli;//Need to get payee to set currency type for request amount display and input - because that reflects nationlity of payee, and does not necessarily match the currency type of the application - if the application is paid with manual check.
var incompleteFields=applicationId&&status===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].Incomplete?this.props.getIncompleteFields():null;var applicantPledgeOptions=(this.props.recipientDetails.applicantPledges||[]).map(function(p){return{key:p.applicantPledgeId,value:'#'+p.applicantPledgeId+' - '+Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["k" /* formatDate */])(p.pledgeDate)+' - '+Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["j" /* formatCurrency */])(p.pledgeAmount)};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details-card card'},isBlocked?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{ref:this.setDetailsRef,className:'details-card-header flex-justify flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Private Application by ',createdBy)):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{ref:this.setDetailsRef,className:'details-card-header flex-justify flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Details'),this.getApplicationActions(status)),!isBlocked&&(applicationId||this.props.loading)&&(this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details-card-subheader flex-justify'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,inquire&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__applicationsComponents_applicationsCommon_MarkInquiryWarning__["a" /* default */],{inquireNote:inquireNote}),incompleteFields&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__commonComponents_shared_IncompleteApplicationWarning__["a" /* default */],{viewOnly:true,fields:incompleteFields}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,!!(status===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].Approved||status===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].Paid||campaign&&amount)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["j" /* formatCurrency */])(amount,currency===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["f" /* CurrencyTypes */].Shekel)),status===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].Paid&&(paymentInfo.manualPayment&&paymentInfo.manualPayment.manualPaymentType||checkOrWireNumber||checkOrWireDate)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text accent-text'},paymentInfo.manualPayment&&paymentInfo.manualPayment.manualPaymentType===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["h" /* ManualPaymentTypes */].ManualWire?'Wire':'Check',' ','#',checkOrWireNumber,' ',checkOrWireDate?'| '+Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["k" /* formatDate */])(checkOrWireDate):'')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,campaign?campaign:reason&&reason.reason?reason.reason+' '+(this.showApplicationReasonDate(reason,reasonDate)||''):'',reason&&reason.reason&&this.isWedding(reason.reason)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text',style:{marginRight:'8px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text'},'Wedding Hall: '),weddingHall),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text'},'Side: '),weddingSide))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center'},campaignIndividualCategory&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'accent-text bold-text',style:{marginRight:'8px'}},campaignIndividualCategory),paymentInfo.fundName&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'accent-text3 uppercase-text small-text bold-text'},paymentInfo.fundName))),isPrivate&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'accent-text medium-text private light-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-locked-outline'}),'Private')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details-card-section details-card-section-icons'},requestedAmount>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-wallet accent-text2'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text'},'Requested Amount:'),' ',Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["j" /* formatCurrency */])(requestedAmount,payeeIsIsraeli)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-credit-card accent-text2'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text'},'Payable to: '),paymentInfo.payTo===__WEBPACK_IMPORTED_MODULE_18__lib_constants__["e" /* PayeeTypes */].Recipient?'Recipient':paymentInfo.payTo===__WEBPACK_IMPORTED_MODULE_18__lib_constants__["e" /* PayeeTypes */].TrustedPayee?' Trusted Payee: '+paymentInfo.trustedPayeePayment.paidToName+' -\n                                        '+Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["i" /* formatBankInfoDisplay */])(paymentInfo.trustedPayeePayment.bankNumber,paymentInfo.trustedPayeePayment.branchNumber,paymentInfo.trustedPayeePayment.accountNumber,paymentInfo.trustedPayeePayment.accountHolder):paymentInfo.thirdParty?(paymentInfo.thirdParty.orgName||(paymentInfo.thirdParty.firstName||'')+' '+(paymentInfo.thirdParty.lastName||''))+'\n                                                '+(paymentInfo.thirdParty.bankNumber||paymentInfo.thirdParty.branchNumber||paymentInfo.thirdParty.accountNumber||paymentInfo.thirdParty.accountHolder?' - '+Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["i" /* formatBankInfoDisplay */])(paymentInfo.thirdParty.bankNumber,paymentInfo.thirdParty.branchNumber,paymentInfo.thirdParty.accountNumber,paymentInfo.thirdParty.accountHolder):'')+'\n                                                '+(paymentInfo.thirdParty.useRecipientAddress?" at recipient's address":paymentInfo.thirdParty.addressDisplay?' - '+paymentInfo.thirdParty.addressDisplay:'')+'\n                                                '+(paymentInfo.thirdParty.careOf?' | Care Of: '+paymentInfo.thirdParty.careOf:''):''),status===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].Incomplete&&paymentInfo.manualPayment&&paymentInfo.manualPayment.manualPaymentType&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text'},'Manual Payment: '),paymentInfo.manualPayment.manualPaymentNumber?'#'+paymentInfo.manualPayment.manualPaymentNumber:'',' ',paymentInfo.manualPayment.manualPaymentDate?Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["k" /* formatDate */])(paymentInfo.manualPayment.manualPaymentDate):'',' ',paymentInfo.manualPayment.manualPaymentAmount?Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["j" /* formatCurrency */])(paymentInfo.manualPayment.manualPaymentAmount,currency===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["f" /* CurrencyTypes */].Shekel):'')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details-card-section details-card-section-icons'},approverName&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-user accent-text2'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text'},'Approver:'),' ',approverName),source&&source.referenceId&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-people-outline accent-text2'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text'},'Source: '),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,source.name),(source.address||source.email||source.phoneNumber)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,' ','-',' ',[source.address,source.email,source.phoneNumber].filter(function(i){return i;}).join(' - ')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details-card-section details-card-section-icons'},paymentInfo.checkMemo&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-doc accent-text2'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text'},'Check Memo: '),' ',paymentInfo.checkMemo),paymentInfo.reportMemo&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-doc accent-text2'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text'},'Report Memo: '),' ',paymentInfo.reportMemo),(card||printInstructions||signatureNeeded)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-printer accent-text2 left'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text'},'Printing Instructions: '),card?'Card - '+card:'',card&&printInstructions?'.  ':'',printInstructions||'',signatureNeeded&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'icon-right error-text small-text'},'Signature Needed')),approvalNote&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-close accent-text2'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text'},'Approval Note: '),' ',approvalNote),rejectReason&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-close accent-text2'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text'},'Rejection Reason: '),' ',rejectReason),reviewDate&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-calendar accent-text2'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text'},'Review Date: '),' ',Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["k" /* formatDate */])(reviewDate)),(this.props.recipientDetails.applicantPledges||[]).length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-wallet accent-text2'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text'},'Applied to Pledge:'),' ',applicantPledgeId?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'bold-text'},'#',applicantPledgeId):this.props.permissions.manage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-flat-primary btn-xs',onClick:this.toggleModal.bind(this,'applyToPledgeModal')},'Apply to Pledge'),applicantPledgeId&&' ',applicantPledge)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details-card-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-justify'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-paper-clip accent-text2'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text'},'Attachments: ')),this.props.permissions.manage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'xs-text link-text',onClick:this.toggleModal.bind(this,'applicationAttachmentsUploadModal')},'Add',attachments.length>0?'/Manage':'',' Attachments')),attachments.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details-card-rows details-card-attachments'},attachments.map(function(a){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:a.documentId,className:'small-text details-card-attachment primary-hover',onClick:_this6.viewAttachment.bind(_this6,a)},a.extension&&a.extension.toLowerCase()==='.docx'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons docx-attachment-icon',title:'Word document'},'description'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-paper-clip'}),a.name);}))),(status===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].Paid||receipts.length>0)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details-card-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-justify'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-doc accent-text2'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text'},'Receipt: ')),this.props.permissions.manage&&this.state.deletingReceipt&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'xs-text accent-text'},'Deleting...')),receipts.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details-card-rows details-card-attachments'},receipts.map(function(r){var receiptId=r.documentId||r.fileId||r.fileid;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:receiptId,className:'small-text details-card-attachment primary-hover'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-doc'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:_this6.viewReceipt.bind(_this6,Object.assign({},r,{documentId:receiptId}))},r.name),_this6.props.permissions.manage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:function onClick(e){return _this6.handleDeleteReceipt(e,Object.assign({},r,{documentId:receiptId}));},style:{marginLeft:'8px',cursor:'pointer',display:'inline-block'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-outline trash-hover icon-right'})));})):this.props.permissions.manage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'upload-box',onDragEnter:!this.state.uploadingReceipt?this.handleReceiptDragEnter:undefined,onDragLeave:!this.state.uploadingReceipt?this.handleReceiptDragLeave:undefined,onDragOver:!this.state.uploadingReceipt?this.handleReceiptDragOver:undefined,onDrop:!this.state.uploadingReceipt?this.handleReceiptDrop:undefined,onClick:!this.state.uploadingReceipt?this.handleAddReceiptClick:undefined,style:{marginTop:'8px',cursor:this.state.uploadingReceipt?'default':'pointer'}},this.state.uploadingReceipt?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center',justifyContent:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'16'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text',style:{marginLeft:'8px'}},'Uploading receipt...')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'accent-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-cloud-upload-outline'}),'Drop files here or ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),' click to ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text2 block'},'Upload Receipt'))),this.props.permissions.manage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{ref:this.setReceiptFileInputRef,type:'file',style:{display:'none'},accept:'application/pdf,text/html,image/png,image/jpeg,image/tiff,image/gif,image/bmp',onChange:this.handleReceiptFileSelect})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details-card-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-justify'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-notebook accent-text2'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text'},'Notes: ')),this.props.permissions.manage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'xs-text link-text',onClick:this.toggleModal.bind(this,'applicationNoteModal')},'Add New')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details-card-rows details-card-notes'},notes.map(function(note){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:note.noteId,className:'details-card-note'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},note.text),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'accent-text small-text'},note.writtenBy,' on ',Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["k" /* formatDate */])(note.writtenOn)),(note.userId===_this6.props.userId||approverId===_this6.props.userId)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details-card-note-actions'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-pencil primary-hover icon-right accent-text input',onClick:function onClick(){_this6.setState({note:note});_this6.toggleModal('applicationNoteModal');}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-trash trash-hover icon-right accent-text input',onClick:function onClick(){_this6.setState({note:note});_this6.toggleModal('deleteNoteConfirmationModal');}})));}))),applicationHistory.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details-card-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-justify'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-clock accent-text2'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text'},'History: ')),applicationHistory.length>1&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'xs-text link-text',onClick:function onClick(){return _this6.setState({showHistory:!_this6.state.showHistory});}},this.state.showHistory?'Show Less':'Show More')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details-card-rows'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'column-quarter small-text'},applicationHistory[0].action,' By:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'column-quarter small-text'},applicationHistory[0].usersName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'column-quarter small-text'},Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["k" /* formatDate */])(applicationHistory[0].date)),applicationHistory[0].action==='Voided'&&applicationHistory[0].checkOrWireNumber&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'column-quarter small-text'},(applicationHistory[0].transactionSource.includes('Wire')?'Wire':'Check')+'# '+applicationHistory[0].checkOrWireNumber)),applicationHistory.length>1&&this.state.showHistory&&applicationHistory.slice(1,applicationHistory.length).map(function(record){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:record.applicationHistoryId,className:'flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'column-quarter small-text'},record.action,' By:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'column-quarter small-text'},record.usersName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'column-quarter small-text'},Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["k" /* formatDate */])(record.date)),record.action==='Voided'&&record.checkOrWireNumber&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'column-quarter small-text'},(record.transactionSource.includes('Wire')?'Wire':'Check')+'# '+record.checkOrWireNumber));}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details-card-footer clearfix text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center previous-next-arrows'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'previous',onClick:this.navigateToApplication.bind(this,this.props.prevApplicationId)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-arrow-back accent-text2 '+(!this.props.prevApplicationId?'disabled':'')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'link-text '+(!this.props.prevApplicationId?'disabled':'')},'Previous')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'accent-text medium-text'},this.props.applicationIndex,' of ',this.props.totalApplications),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'next',onClick:this.navigateToApplication.bind(this,this.props.nextApplicationId)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'link-text '+(!this.props.nextApplicationId?'disabled':'')},'Next'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-arrow-forward accent-text2 '+(!this.props.nextApplicationId?'disabled':'')})))))),this.state.showModals.printApplicationsModal&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__printingComponents_PrintModal__["a" /* default */],{close:this.toggleModal.bind(this,'printApplicationsModal'),onPrintSuccess:this.toggleModal.bind(this,'completePrintingModal'),count:1,print:function print(printerId){return _this6.props.printCheck('applications',printerId,{applicationIds:[_this6.props.applicationDetails.applicationId]});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CompletePrintingModal__["a" /* default */],{show:this.state.showModals.completePrintingModal||this.state.showModals.confirmPrintingModal,close:this.toggleModal.bind(this,this.state.showModals.completePrintingModal?'completePrintingModal':'confirmPrintingModal'),printInfo:this.state.showModals.completePrintingModal?this.props.printing.data:[{printJobId:printJobId,checkOrWireNumber:checkOrWireNumber,card:card}],allowReprint:this.state.showModals.completePrintingModal,reprint:function reprint(){return _this6.props.printCheck('reprints',_this6.props.printing.printerId,{printJobIds:[_this6.props.printing.data[0].printJobId]});},reprinting:this.props.printing,confirmPrint:function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(isCancel){var printInfo;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:printInfo=_this6.state.showModals.completePrintingModal?_this6.props.printing.data[0]:{printJobId:printJobId};_context11.next=3;return _this6.props.confirmPrinting([printInfo.printJobId],isCancel);case 3:if(_this6.props.confirmingPrinting.success)_this6.props.getApplicationDetails(applicationId,true,recipientId);case 4:case'end':return _context11.stop();}}},_callee11,_this6);}));return function(_x8){return _ref12.apply(this,arguments);};}(),confirming:this.props.confirmingPrinting}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ApplicationAttachmentModal__["a" /* default */],Object.assign({show:this.state.showModals.applicationAttachmentModal,close:function close(){_this6.setState({attachment:{loading:false,success:true,document:{}},receipt:{loading:false,success:true,document:{}},viewingDocumentType:null});_this6.toggleModal('applicationAttachmentModal');}},this.state.viewingDocumentType==='receipt'?this.state.receipt:this.state.attachment,{recipient:this.props.recipientDetails,documentType:this.state.viewingDocumentType})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ApplicationAttachmentsUploadModal__["a" /* default */],Object.assign({show:this.state.showModals.applicationAttachmentsUploadModal,close:this.toggleModal.bind(this,'applicationAttachmentsUploadModal'),attachments:attachments,applicationId:applicationId,updateAttachments:this.props.updateAttachments},this.props.updatingAttachments)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__NoteModal__["a" /* default */],{show:this.state.showModals.applicationNoteModal,close:function close(){_this6.setState({note:{}});_this6.toggleModal('applicationNoteModal');},note:this.state.note,save:function save(text){return _this6.state.note.noteId?_this6.props.updateNote(applicationId,_this6.state.note.noteId,text):_this6.props.addNote(applicationId,text);},loading:this.props.updatingNote.loading,success:this.props.updatingNote.success}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__commonComponents_shared_ConfirmationModal__["a" /* default */],{show:this.state.showModals.deleteNoteConfirmationModal,close:function close(){_this6.setState({note:{}});_this6.toggleModal('deleteNoteConfirmationModal');},message:'Are you sure you want to permanently delete this note?',confirm:this.props.deleteNote.bind(this,applicationId,this.state.note.noteId),loading:this.props.updatingNote.loading,success:this.props.updatingNote.success}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__commonComponents_shared_ConfirmationModal__["a" /* default */],{show:this.state.showModals.revertStatusConfirmationModal,close:function close(){return _this6.toggleModal('revertStatusConfirmationModal');},message:'Are you sure you want to revert the status of this application to new?',confirm:_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return _this6.props.revertApplicationStatus(applicationId);case 2:if(_this6.props.applicationStatusUpdate.success)_this6.props.getApplicationDetails(applicationId,true);case 3:case'end':return _context12.stop();}}},_callee12,_this6);})),loading:this.props.applicationStatusUpdate.loading,success:this.props.applicationStatusUpdate.success}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__commonComponents_shared_ConfirmationModal__["a" /* default */],{show:this.state.showModals.sendACHConfirmationModal,title:'Send ACH',message:'Are you sure you want to send ACH to '+(this.props.recipientDetails&&this.props.recipientDetails.displayName?this.props.recipientDetails.displayName:"this recipient")+'?',close:function close(){return _this6.toggleModal('sendACHConfirmationModal');},confirm:this.confirmSendACH.bind(this),loading:this.state.sendingACH,success:this.state.achSendSuccess,errorMessage:'ACH transfer could not be initiated. Please try again.'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ApplyToPledgeModal__["a" /* default */],{show:this.state.showModals.applyToPledgeModal,close:this.closeApplyToPledgeModal,applicantPledgeOptions:applicantPledgeOptions,selectedPledgeId:this.state.selectedPledgeId,onPledgeChange:function onPledgeChange(e){return _this6.setState({selectedPledgeId:e.target.value});},applyingPledge:this.state.applyingPledge,onApply:this.applyPledgeToApplication}));}}]);return ApplicationDetailsCard;}(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ApplicationDetailsCard);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CompletePrintingModal=function(_React$Component){_inherits(CompletePrintingModal,_React$Component);function CompletePrintingModal(props){_classCallCheck(this,CompletePrintingModal);var _this=_possibleConstructorReturn(this,(CompletePrintingModal.__proto__||Object.getPrototypeOf(CompletePrintingModal)).call(this,props));_this.state={printing:false,error:false,awaitConfirm:true};return _this;}_createClass(CompletePrintingModal,[{key:"confirmPrintJob",value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(isCancel){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({error:false});_context.next=3;return this.props.confirmPrint(isCancel);case 3:if(this.props.confirming.success){this.close();}else{this.setState({error:true});}case 4:case"end":return _context.stop();}}},_callee,this);}));function confirmPrintJob(_x){return _ref.apply(this,arguments);}return confirmPrintJob;}()},{key:"reprint",value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:this.setState({error:false,awaitConfirm:false});_context2.next=3;return this.props.reprint();case 3:if(this.props.reprinting.success){this.setState({awaitConfirm:true});}else{this.setState({error:true});}case 4:case"end":return _context2.stop();}}},_callee2,this);}));function reprint(){return _ref2.apply(this,arguments);}return reprint;}()},{key:"close",value:function close(){this.props.close();this.setState({error:false,awaitConfirm:false});}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Prompt */],{when:this.props.show,message:"Are you sure you'd like to leave this page before confirming printing?  You will not be able to confirm printing at a later point."}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal print-modal small-modal"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",{className:"page-header text-center"},"Printing"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{className:"modal-img",src:"/images/Print.png",alt:"print"}),this.props.printInfo.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"printing-options"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"medium-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon ion-ios-checkmark-outline accent-text icon-left"}),"Check #",this.props.printInfo[0].checkNumber),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"medium-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon ion-ios-"+(this.props.printInfo[0].card?"checkmark":"close")+"-outline accent-text icon-left"}),"Card")),this.state.awaitConfirm&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"print-confirmation"},"Print job has completed. ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null)," Click Finish to confirm printing. ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null)," Click Cancel if printing was unsuccessful."),this.props.confirming.loading||this.props.allowReprint&&this.props.reprinting.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_LoadingSpinner__["a" /* default */],{height:"20"}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-primary btn-fullWidth",onClick:this.confirmPrintJob.bind(this)},"Finish"),this.props.allowReprint&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-accent btn-fullWidth mb-16",onClick:this.reprint.bind(this)},"Reprint"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-danger btn-fullWidth",onClick:this.confirmPrintJob.bind(this,true)},"Cancel")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error}))));}}]);return CompletePrintingModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CompletePrintingModal);

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mammoth_mammoth_browser__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mammoth_mammoth_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mammoth_mammoth_browser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dompurify__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dompurify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_dompurify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DOCX_MIME="application/vnd.openxmlformats-officedocument.wordprocessingml.document";var ApplicationAttachmentModal=function(_React$Component){_inherits(ApplicationAttachmentModal,_React$Component);function ApplicationAttachmentModal(props){var _this2=this;_classCallCheck(this,ApplicationAttachmentModal);var _this=_possibleConstructorReturn(this,(ApplicationAttachmentModal.__proto__||Object.getPrototypeOf(ApplicationAttachmentModal)).call(this,props));_this.revokeAttachmentSource=function(){if(_this.state.attachmentSource){URL.revokeObjectURL(_this.state.attachmentSource);}};_this.renderDocx=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(source){var arrayBuffer,result,safeHtml;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;if(source){_context.next=4;break;}_this.setState({docxLoading:false});return _context.abrupt('return');case 4:// mammoth expects an ArrayBuffer; the attachment is fetched as arraybuffer.
arrayBuffer=source instanceof ArrayBuffer?source:new Uint8Array(source).buffer;_context.next=7;return __WEBPACK_IMPORTED_MODULE_2_mammoth_mammoth_browser___default.a.convertToHtml({arrayBuffer:arrayBuffer});case 7:result=_context.sent;// Sanitize the generated markup before rendering to guard against any
// malicious content embedded in the uploaded document.
safeHtml=__WEBPACK_IMPORTED_MODULE_3_dompurify___default.a.sanitize(result.value,{USE_PROFILES:{html:true}});_this.setState({docxHtml:safeHtml,docxLoading:false,docxError:false});_context.next=15;break;case 12:_context.prev=12;_context.t0=_context['catch'](0);_this.setState({docxLoading:false,docxError:true});case 15:case'end':return _context.stop();}}},_callee,_this2,[[0,12]]);}));return function(_x){return _ref.apply(this,arguments);};}();_this.toggleZoom=function(){_this.setState({zoom:!_this.state.zoom});};_this.state={attachmentSource:'',attachmentType:'',docxHtml:'',docxLoading:false,docxError:false,zoom:true};return _this;}_createClass(ApplicationAttachmentModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.document.source!==this.props.document.source){var attachmentType=void 0;switch((nextProps.document.extension||'').toLowerCase()){case".pdf":attachmentType="application/pdf";break;case".html":attachmentType="text/html";break;case".png":attachmentType="image/png";break;case".jpeg":case".jpg":attachmentType="image/jpeg";break;case".tif":case".tiff":attachmentType="image/tiff";break;case".gif":attachmentType="image/gif";break;case".bmp":attachmentType="image/bmp";break;case".docx":attachmentType=DOCX_MIME;break;default:attachmentType="";break;}this.revokeAttachmentSource();if(attachmentType===DOCX_MIME){this.setState({attachmentSource:'',attachmentType:attachmentType,docxHtml:'',docxError:false,docxLoading:true,zoom:true});this.renderDocx(nextProps.document.source);}else{var hasValidSource=nextProps.document.source&&attachmentType;this.setState({attachmentSource:hasValidSource?URL.createObjectURL(new Blob([nextProps.document.source],{type:attachmentType})):'',attachmentType:attachmentType,docxHtml:'',docxError:false,docxLoading:false,zoom:true});}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.revokeAttachmentSource();}},{key:'renderDocxPreview',value:function renderDocxPreview(){if(this.state.docxLoading){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'30'});}if(this.state.docxError){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'small-text text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-paperclip icon-left xl-text middle'}),'Preview is not available for this document.',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'View the file in your downloads.');}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'docx-preview-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'docx-preview-page',dangerouslySetInnerHTML:{__html:this.state.docxHtml}}));}},{key:'render',value:function render(){//TODO - Chrome Warning - Resource interpreted as Document but transferred with MIME type image/tiff...  
//Ignoring for now.  If this becomes an issue may need to return documents with specific headers from backend.  
var recipient=this.props.recipient;var primaryBankAccount=recipient&&recipient.bankAccounts?recipient.bankAccounts.filter(function(acct){return acct.active;})[0]:null;var isReceipt=this.props.documentType==='receipt';var documentLabel=isReceipt?'Receipt':'Attachment';var isDocx=this.state.attachmentType===DOCX_MIME;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal attachment-modal'+(this.state.zoom?"-lg":"")},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},!this.props.success?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},documentLabel):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},this.props.document.name,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{onClick:this.toggleZoom,className:'material-icons input',style:{marginLeft:'16px'}},this.state.zoom?'zoom_out':'zoom_in')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.props.close})),!!recipient&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,recipient.displayName&&'Recipient '+recipient.displayName,recipient.teudatZahut&&' | Teudat Zehut '+recipient.teudatZahut,primaryBankAccount&&' | Bank Account '+Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["i" /* formatBankInfoDisplay */])(primaryBankAccount.bankRoutingNumber,primaryBankAccount.bankBranchNumber,primaryBankAccount.bankAccountNumber,primaryBankAccount.bankAccountHolder)),this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'30'}):!this.props.success?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'small-text text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-paperclip icon-left xl-text middle'}),'Could Not Load ',documentLabel):isDocx?this.renderDocxPreview():this.state.attachmentSource&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.state.attachmentType==="image/tiff"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'small-text text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-paperclip icon-left xl-text middle'}),'Preview is not compatible with the file format of this attachment.',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'View the file in your downloads.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('iframe',{title:'app-attachment',style:{height:1000,width:1000},src:this.state.attachmentSource+'#zoom=135'})))));}}]);return ApplicationAttachmentModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ApplicationAttachmentModal);

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, setImmediate) {var require;var require;// Module: @xmldom/xmldom@0.8.6
// License: MIT
//
// Module: base64-js@1.5.1
// License: MIT
//
// Module: bluebird@3.4.7
// License: MIT
//
// Module: buffer@4.9.1
// License: MIT
//
// Module: dingbat-to-unicode@1.0.1
// License: BSD-2-Clause
//
// Module: ieee754@1.1.8
// License: BSD-3-Clause
//
// Module: isarray@1.0.0
// License: MIT
//
// Module: jszip@3.7.1
// License: (MIT OR GPL-3.0-or-later)
//
// Module: lop@0.4.2
// License: BSD-2-Clause
//
// Module: mammoth@1.12.0
// License: BSD-2-Clause
//
// Module: option@0.2.4
// License: BSD-2-Clause
//
// Module: process@0.11.9
// License: MIT
//
// Module: underscore@1.13.1
// License: MIT
//
// Module: xmlbuilder@10.0.0
// License: MIT
//
(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.mammoth = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var promises = require("../../lib/promises");

exports.Files = Files;


function Files() {
    function read(uri) {
        return promises.reject(new Error("could not open external image: '" + uri + "'\ncannot open linked files from a web browser"));
    }
    
    return {
        read: read
    };
}

},{"../../lib/promises":23}],2:[function(require,module,exports){
var promises = require("../lib/promises");
var zipfile = require("../lib/zipfile");

exports.openZip = openZip;

function openZip(options) {
    if (options.arrayBuffer) {
        return promises.resolve(zipfile.openArrayBuffer(options.arrayBuffer));
    } else {
        return promises.reject(new Error("Could not find file in options"));
    }
}

},{"../lib/promises":23,"../lib/zipfile":40}],3:[function(require,module,exports){
var _ = require("underscore");

var promises = require("./promises");
var documents = require("./documents");
var htmlPaths = require("./styles/html-paths");
var results = require("./results");
var images = require("./images");
var Html = require("./html");
var writers = require("./writers");

exports.DocumentConverter = DocumentConverter;


function DocumentConverter(options) {
    return {
        convertToHtml: function(element) {
            var comments = _.indexBy(
                element.type === documents.types.document ? element.comments : [],
                "commentId"
            );
            var conversion = new DocumentConversion(options, comments);
            return conversion.convertToHtml(element);
        }
    };
}

function DocumentConversion(options, comments) {
    var noteNumber = 1;

    var noteReferences = [];

    var referencedComments = [];

    options = _.extend({ignoreEmptyParagraphs: true}, options);
    var idPrefix = options.idPrefix === undefined ? "" : options.idPrefix;
    var ignoreEmptyParagraphs = options.ignoreEmptyParagraphs;

    var defaultParagraphStyle = htmlPaths.topLevelElement("p");

    var styleMap = options.styleMap || [];

    function convertToHtml(document) {
        var messages = [];

        var html = elementToHtml(document, messages, {});

        var deferredNodes = [];
        walkHtml(html, function(node) {
            if (node.type === "deferred") {
                deferredNodes.push(node);
            }
        });
        var deferredValues = {};
        return promises.mapSeries(deferredNodes, function(deferred) {
            return deferred.value().then(function(value) {
                deferredValues[deferred.id] = value;
            });
        }).then(function() {
            function replaceDeferred(nodes) {
                return flatMap(nodes, function(node) {
                    if (node.type === "deferred") {
                        return deferredValues[node.id];
                    } else if (node.children) {
                        return [
                            _.extend({}, node, {
                                children: replaceDeferred(node.children)
                            })
                        ];
                    } else {
                        return [node];
                    }
                });
            }
            var writer = writers.writer({
                prettyPrint: options.prettyPrint,
                outputFormat: options.outputFormat
            });
            Html.write(writer, Html.simplify(replaceDeferred(html)));
            return new results.Result(writer.asString(), messages);
        });
    }

    function convertElements(elements, messages, options) {
        return flatMap(elements, function(element) {
            return elementToHtml(element, messages, options);
        });
    }

    function elementToHtml(element, messages, options) {
        if (!options) {
            throw new Error("options not set");
        }
        var handler = elementConverters[element.type];
        if (handler) {
            return handler(element, messages, options);
        } else {
            return [];
        }
    }

    function convertParagraph(element, messages, options) {
        return htmlPathForParagraph(element, messages).wrap(function() {
            var content = convertElements(element.children, messages, options);
            if (ignoreEmptyParagraphs) {
                return content;
            } else {
                return [Html.forceWrite].concat(content);
            }
        });
    }

    function htmlPathForParagraph(element, messages) {
        var style = findStyle(element);

        if (style) {
            return style.to;
        } else {
            if (element.styleId) {
                messages.push(unrecognisedStyleWarning("paragraph", element));
            }
            return defaultParagraphStyle;
        }
    }

    function convertRun(run, messages, options) {
        var nodes = function() {
            return convertElements(run.children, messages, options);
        };
        var paths = [];
        if (run.highlight !== null) {
            var path = findHtmlPath({type: "highlight", color: run.highlight});
            if (path) {
                paths.push(path);
            }
        }
        if (run.isSmallCaps) {
            paths.push(findHtmlPathForRunProperty("smallCaps"));
        }
        if (run.isAllCaps) {
            paths.push(findHtmlPathForRunProperty("allCaps"));
        }
        if (run.isStrikethrough) {
            paths.push(findHtmlPathForRunProperty("strikethrough", "s"));
        }
        if (run.isUnderline) {
            paths.push(findHtmlPathForRunProperty("underline"));
        }
        if (run.verticalAlignment === documents.verticalAlignment.subscript) {
            paths.push(htmlPaths.element("sub", {}, {fresh: false}));
        }
        if (run.verticalAlignment === documents.verticalAlignment.superscript) {
            paths.push(htmlPaths.element("sup", {}, {fresh: false}));
        }
        if (run.isItalic) {
            paths.push(findHtmlPathForRunProperty("italic", "em"));
        }
        if (run.isBold) {
            paths.push(findHtmlPathForRunProperty("bold", "strong"));
        }
        var stylePath = htmlPaths.empty;
        var style = findStyle(run);
        if (style) {
            stylePath = style.to;
        } else if (run.styleId) {
            messages.push(unrecognisedStyleWarning("run", run));
        }
        paths.push(stylePath);

        paths.forEach(function(path) {
            nodes = path.wrap.bind(path, nodes);
        });

        return nodes();
    }

    function findHtmlPathForRunProperty(elementType, defaultTagName) {
        var path = findHtmlPath({type: elementType});
        if (path) {
            return path;
        } else if (defaultTagName) {
            return htmlPaths.element(defaultTagName, {}, {fresh: false});
        } else {
            return htmlPaths.empty;
        }
    }

    function findHtmlPath(element, defaultPath) {
        var style = findStyle(element);
        return style ? style.to : defaultPath;
    }

    function findStyle(element) {
        for (var i = 0; i < styleMap.length; i++) {
            if (styleMap[i].from.matches(element)) {
                return styleMap[i];
            }
        }
    }

    function recoveringConvertImage(convertImage) {
        return function(image, messages) {
            return promises.attempt(function() {
                return convertImage(image, messages);
            }).caught(function(error) {
                messages.push(results.error(error));
                return [];
            });
        };
    }

    function noteHtmlId(note) {
        return referentHtmlId(note.noteType, note.noteId);
    }

    function noteRefHtmlId(note) {
        return referenceHtmlId(note.noteType, note.noteId);
    }

    function referentHtmlId(referenceType, referenceId) {
        return htmlId(referenceType + "-" + referenceId);
    }

    function referenceHtmlId(referenceType, referenceId) {
        return htmlId(referenceType + "-ref-" + referenceId);
    }

    function htmlId(suffix) {
        return idPrefix + suffix;
    }

    var defaultTablePath = htmlPaths.elements([
        htmlPaths.element("table", {}, {fresh: true})
    ]);

    function convertTable(element, messages, options) {
        return findHtmlPath(element, defaultTablePath).wrap(function() {
            return convertTableChildren(element, messages, options);
        });
    }

    function convertTableChildren(element, messages, options) {
        var bodyIndex = _.findIndex(element.children, function(child) {
            return !child.type === documents.types.tableRow || !child.isHeader;
        });
        if (bodyIndex === -1) {
            bodyIndex = element.children.length;
        }
        var children;
        if (bodyIndex === 0) {
            children = convertElements(
                element.children,
                messages,
                _.extend({}, options, {isTableHeader: false})
            );
        } else {
            var headRows = convertElements(
                element.children.slice(0, bodyIndex),
                messages,
                _.extend({}, options, {isTableHeader: true})
            );
            var bodyRows = convertElements(
                element.children.slice(bodyIndex),
                messages,
                _.extend({}, options, {isTableHeader: false})
            );
            children = [
                Html.freshElement("thead", {}, headRows),
                Html.freshElement("tbody", {}, bodyRows)
            ];
        }
        return [Html.forceWrite].concat(children);
    }

    function convertTableRow(element, messages, options) {
        var children = convertElements(element.children, messages, options);
        return [
            Html.freshElement("tr", {}, [Html.forceWrite].concat(children))
        ];
    }

    function convertTableCell(element, messages, options) {
        var tagName = options.isTableHeader ? "th" : "td";
        var children = convertElements(element.children, messages, options);
        var attributes = {};
        if (element.colSpan !== 1) {
            attributes.colspan = element.colSpan.toString();
        }
        if (element.rowSpan !== 1) {
            attributes.rowspan = element.rowSpan.toString();
        }

        return [
            Html.freshElement(tagName, attributes, [Html.forceWrite].concat(children))
        ];
    }

    function convertCommentReference(reference, messages, options) {
        return findHtmlPath(reference, htmlPaths.ignore).wrap(function() {
            var comment = comments[reference.commentId];
            var count = referencedComments.length + 1;
            var label = "[" + commentAuthorLabel(comment) + count + "]";
            referencedComments.push({label: label, comment: comment});
            // TODO: remove duplication with note references
            return [
                Html.freshElement("a", {
                    href: "#" + referentHtmlId("comment", reference.commentId),
                    id: referenceHtmlId("comment", reference.commentId)
                }, [Html.text(label)])
            ];
        });
    }

    function convertComment(referencedComment, messages, options) {
        // TODO: remove duplication with note references

        var label = referencedComment.label;
        var comment = referencedComment.comment;
        var body = convertElements(comment.body, messages, options).concat([
            Html.nonFreshElement("p", {}, [
                Html.text(" "),
                Html.freshElement("a", {"href": "#" + referenceHtmlId("comment", comment.commentId)}, [
                    Html.text("↑")
                ])
            ])
        ]);

        return [
            Html.freshElement(
                "dt",
                {"id": referentHtmlId("comment", comment.commentId)},
                [Html.text("Comment " + label)]
            ),
            Html.freshElement("dd", {}, body)
        ];
    }

    function convertBreak(element, messages, options) {
        return htmlPathForBreak(element).wrap(function() {
            return [];
        });
    }

    function htmlPathForBreak(element) {
        var style = findStyle(element);
        if (style) {
            return style.to;
        } else if (element.breakType === "line") {
            return htmlPaths.topLevelElement("br");
        } else {
            return htmlPaths.empty;
        }
    }

    var elementConverters = {
        "document": function(document, messages, options) {
            var children = convertElements(document.children, messages, options);
            var notes = noteReferences.map(function(noteReference) {
                return document.notes.resolve(noteReference);
            });
            var notesNodes = convertElements(notes, messages, options);
            return children.concat([
                Html.freshElement("ol", {}, notesNodes),
                Html.freshElement("dl", {}, flatMap(referencedComments, function(referencedComment) {
                    return convertComment(referencedComment, messages, options);
                }))
            ]);
        },
        "paragraph": convertParagraph,
        "run": convertRun,
        "text": function(element, messages, options) {
            return [Html.text(element.value)];
        },
        "tab": function(element, messages, options) {
            return [Html.text("\t")];
        },
        "hyperlink": function(element, messages, options) {
            var href = element.anchor ? "#" + htmlId(element.anchor) : element.href;
            var attributes = {href: href};
            if (element.targetFrame != null) {
                attributes.target = element.targetFrame;
            }

            var children = convertElements(element.children, messages, options);
            return [Html.nonFreshElement("a", attributes, children)];
        },
        "checkbox": function(element) {
            var attributes = {type: "checkbox"};
            if (element.checked) {
                attributes["checked"] = "checked";
            }
            return [Html.freshElement("input", attributes)];
        },
        "bookmarkStart": function(element, messages, options) {
            var anchor = Html.freshElement("a", {
                id: htmlId(element.name)
            }, [Html.forceWrite]);
            return [anchor];
        },
        "noteReference": function(element, messages, options) {
            noteReferences.push(element);
            var anchor = Html.freshElement("a", {
                href: "#" + noteHtmlId(element),
                id: noteRefHtmlId(element)
            }, [Html.text("[" + (noteNumber++) + "]")]);

            return [Html.freshElement("sup", {}, [anchor])];
        },
        "note": function(element, messages, options) {
            var children = convertElements(element.body, messages, options);
            var backLink = Html.elementWithTag(htmlPaths.element("p", {}, {fresh: false}), [
                Html.text(" "),
                Html.freshElement("a", {href: "#" + noteRefHtmlId(element)}, [Html.text("↑")])
            ]);
            var body = children.concat([backLink]);

            return Html.freshElement("li", {id: noteHtmlId(element)}, body);
        },
        "commentReference": convertCommentReference,
        "comment": convertComment,
        "image": deferredConversion(recoveringConvertImage(options.convertImage || images.dataUri)),
        "table": convertTable,
        "tableRow": convertTableRow,
        "tableCell": convertTableCell,
        "break": convertBreak
    };
    return {
        convertToHtml: convertToHtml
    };
}

var deferredId = 1;

function deferredConversion(func) {
    return function(element, messages, options) {
        return [
            {
                type: "deferred",
                id: deferredId++,
                value: function() {
                    return func(element, messages, options);
                }
            }
        ];
    };
}

function unrecognisedStyleWarning(type, element) {
    return results.warning(
        "Unrecognised " + type + " style: '" + element.styleName + "'" +
        " (Style ID: " + element.styleId + ")"
    );
}

function flatMap(values, func) {
    return _.flatten(values.map(func), true);
}

function walkHtml(nodes, callback) {
    nodes.forEach(function(node) {
        callback(node);
        if (node.children) {
            walkHtml(node.children, callback);
        }
    });
}

var commentAuthorLabel = exports.commentAuthorLabel = function commentAuthorLabel(comment) {
    return comment.authorInitials || "";
};

},{"./documents":4,"./html":18,"./images":20,"./promises":23,"./results":25,"./styles/html-paths":28,"./writers":33,"underscore":102}],4:[function(require,module,exports){
(function (Buffer){
var _ = require("underscore");

var types = exports.types = {
    document: "document",
    paragraph: "paragraph",
    run: "run",
    text: "text",
    tab: "tab",
    checkbox: "checkbox",
    hyperlink: "hyperlink",
    noteReference: "noteReference",
    image: "image",
    note: "note",
    commentReference: "commentReference",
    comment: "comment",
    table: "table",
    tableRow: "tableRow",
    tableCell: "tableCell",
    "break": "break",
    bookmarkStart: "bookmarkStart"
};

function Document(children, options) {
    options = options || {};
    return {
        type: types.document,
        children: children,
        notes: options.notes || new Notes({}),
        comments: options.comments || []
    };
}

function Paragraph(children, properties) {
    properties = properties || {};
    var indent = properties.indent || {};
    return {
        type: types.paragraph,
        children: children,
        styleId: properties.styleId || null,
        styleName: properties.styleName || null,
        numbering: properties.numbering || null,
        alignment: properties.alignment || null,
        indent: {
            start: indent.start || null,
            end: indent.end || null,
            firstLine: indent.firstLine || null,
            hanging: indent.hanging || null
        }
    };
}

function Run(children, properties) {
    properties = properties || {};
    return {
        type: types.run,
        children: children,
        styleId: properties.styleId || null,
        styleName: properties.styleName || null,
        isBold: !!properties.isBold,
        isUnderline: !!properties.isUnderline,
        isItalic: !!properties.isItalic,
        isStrikethrough: !!properties.isStrikethrough,
        isAllCaps: !!properties.isAllCaps,
        isSmallCaps: !!properties.isSmallCaps,
        verticalAlignment: properties.verticalAlignment || verticalAlignment.baseline,
        font: properties.font || null,
        fontSize: properties.fontSize || null,
        highlight: properties.highlight || null
    };
}

var verticalAlignment = {
    baseline: "baseline",
    superscript: "superscript",
    subscript: "subscript"
};

function Text(value) {
    return {
        type: types.text,
        value: value
    };
}

function Tab() {
    return {
        type: types.tab
    };
}

function Checkbox(options) {
    return {
        type: types.checkbox,
        checked: options.checked
    };
}

function Hyperlink(children, options) {
    return {
        type: types.hyperlink,
        children: children,
        href: options.href,
        anchor: options.anchor,
        targetFrame: options.targetFrame
    };
}

function NoteReference(options) {
    return {
        type: types.noteReference,
        noteType: options.noteType,
        noteId: options.noteId
    };
}

function Notes(notes) {
    this._notes = _.indexBy(notes, function(note) {
        return noteKey(note.noteType, note.noteId);
    });
}

Notes.prototype.resolve = function(reference) {
    return this.findNoteByKey(noteKey(reference.noteType, reference.noteId));
};

Notes.prototype.findNoteByKey = function(key) {
    return this._notes[key] || null;
};

function Note(options) {
    return {
        type: types.note,
        noteType: options.noteType,
        noteId: options.noteId,
        body: options.body
    };
}

function commentReference(options) {
    return {
        type: types.commentReference,
        commentId: options.commentId
    };
}

function comment(options) {
    return {
        type: types.comment,
        commentId: options.commentId,
        body: options.body,
        authorName: options.authorName,
        authorInitials: options.authorInitials
    };
}

function noteKey(noteType, id) {
    return noteType + "-" + id;
}

function Image(options) {
    return {
        type: types.image,
        // `read` is retained for backwards compatibility, but other read
        // methods should be preferred.
        read: function(encoding) {
            if (encoding) {
                return options.readImage(encoding);
            } else {
                return options.readImage().then(function(arrayBuffer) {
                    return Buffer.from(arrayBuffer);
                });
            }
        },
        readAsArrayBuffer: function() {
            return options.readImage();
        },
        readAsBase64String: function() {
            return options.readImage("base64");
        },
        readAsBuffer: function() {
            return options.readImage().then(function(arrayBuffer) {
                return Buffer.from(arrayBuffer);
            });
        },
        altText: options.altText,
        contentType: options.contentType
    };
}

function Table(children, properties) {
    properties = properties || {};
    return {
        type: types.table,
        children: children,
        styleId: properties.styleId || null,
        styleName: properties.styleName || null
    };
}

function TableRow(children, options) {
    options = options || {};
    return {
        type: types.tableRow,
        children: children,
        isHeader: options.isHeader || false
    };
}

function TableCell(children, options) {
    options = options || {};
    return {
        type: types.tableCell,
        children: children,
        colSpan: options.colSpan == null ? 1 : options.colSpan,
        rowSpan: options.rowSpan == null ? 1 : options.rowSpan
    };
}

function Break(breakType) {
    return {
        type: types["break"],
        breakType: breakType
    };
}

function BookmarkStart(options) {
    return {
        type: types.bookmarkStart,
        name: options.name
    };
}

exports.document = exports.Document = Document;
exports.paragraph = exports.Paragraph = Paragraph;
exports.run = exports.Run = Run;
exports.text = exports.Text = Text;
exports.tab = exports.Tab = Tab;
exports.checkbox = exports.Checkbox = Checkbox;
exports.Hyperlink = Hyperlink;
exports.noteReference = exports.NoteReference = NoteReference;
exports.Notes = Notes;
exports.Note = Note;
exports.commentReference = commentReference;
exports.comment = comment;
exports.Image = Image;
exports.Table = Table;
exports.TableRow = TableRow;
exports.TableCell = TableCell;
exports.lineBreak = Break("line");
exports.pageBreak = Break("page");
exports.columnBreak = Break("column");
exports.BookmarkStart = BookmarkStart;

exports.verticalAlignment = verticalAlignment;

}).call(this,require("buffer").Buffer)
},{"buffer":83,"underscore":102}],5:[function(require,module,exports){
exports.createBodyReader = createBodyReader;
exports._readNumberingProperties = readNumberingProperties;

var dingbatToUnicode = require("dingbat-to-unicode");
var _ = require("underscore");

var documents = require("../documents");
var Result = require("../results").Result;
var warning = require("../results").warning;
var xml = require("../xml");
var transforms = require("../transforms");
var uris = require("./uris");

function createBodyReader(options) {
    return {
        readXmlElement: function(element) {
            return new BodyReader(options).readXmlElement(element);
        },
        readXmlElements: function(elements) {
            return new BodyReader(options).readXmlElements(elements);
        }
    };
}

function BodyReader(options) {
    var complexFieldStack = [];
    var currentInstrText = [];

    // When a paragraph is marked as deleted, its contents should be combined
    // with the following paragraph. See 17.13.5.15 del (Deleted Paragraph) of
    // ECMA-376 4th edition Part 1.
    var deletedParagraphContents = [];

    var relationships = options.relationships;
    var contentTypes = options.contentTypes;
    var docxFile = options.docxFile;
    var files = options.files;
    var numbering = options.numbering;
    var styles = options.styles;

    function readXmlElements(elements) {
        var results = elements.map(readXmlElement);
        return combineResults(results);
    }

    function readXmlElement(element) {
        if (element.type === "element") {
            var handler = xmlElementReaders[element.name];
            if (handler) {
                return handler(element);
            } else if (!Object.prototype.hasOwnProperty.call(ignoreElements, element.name)) {
                var message = warning("An unrecognised element was ignored: " + element.name);
                return emptyResultWithMessages([message]);
            }
        }
        return emptyResult();
    }

    function readParagraphProperties(element) {
        return readParagraphStyle(element).map(function(style) {
            return {
                type: "paragraphProperties",
                styleId: style.styleId,
                styleName: style.name,
                alignment: element.firstOrEmpty("w:jc").attributes["w:val"],
                numbering: readNumberingProperties(style.styleId, element.firstOrEmpty("w:numPr"), numbering),
                indent: readParagraphIndent(element.firstOrEmpty("w:ind"))
            };
        });
    }

    function readParagraphIndent(element) {
        return {
            start: element.attributes["w:start"] || element.attributes["w:left"],
            end: element.attributes["w:end"] || element.attributes["w:right"],
            firstLine: element.attributes["w:firstLine"],
            hanging: element.attributes["w:hanging"]
        };
    }

    function readRunProperties(element) {
        return readRunStyle(element).map(function(style) {
            var fontSizeString = element.firstOrEmpty("w:sz").attributes["w:val"];
            // w:sz gives the font size in half points, so halve the value to get the size in points
            var fontSize = /^[0-9]+$/.test(fontSizeString) ? parseInt(fontSizeString, 10) / 2 : null;

            return {
                type: "runProperties",
                styleId: style.styleId,
                styleName: style.name,
                verticalAlignment: element.firstOrEmpty("w:vertAlign").attributes["w:val"],
                font: element.firstOrEmpty("w:rFonts").attributes["w:ascii"],
                fontSize: fontSize,
                isBold: readBooleanElement(element.first("w:b")),
                isUnderline: readUnderline(element.first("w:u")),
                isItalic: readBooleanElement(element.first("w:i")),
                isStrikethrough: readBooleanElement(element.first("w:strike")),
                isAllCaps: readBooleanElement(element.first("w:caps")),
                isSmallCaps: readBooleanElement(element.first("w:smallCaps")),
                highlight: readHighlightValue(element.firstOrEmpty("w:highlight").attributes["w:val"])
            };
        });
    }

    function readUnderline(element) {
        if (element) {
            var value = element.attributes["w:val"];
            return value !== undefined && value !== "false" && value !== "0" && value !== "none";
        } else {
            return false;
        }
    }

    function readBooleanElement(element) {
        if (element) {
            var value = element.attributes["w:val"];
            return value !== "false" && value !== "0";
        } else {
            return false;
        }
    }

    function readBooleanAttributeValue(value) {
        return value !== "false" && value !== "0";
    }

    function readHighlightValue(value) {
        if (!value || value === "none") {
            return null;
        } else {
            return value;
        }
    }

    function readParagraphStyle(element) {
        return readStyle(element, "w:pStyle", "Paragraph", styles.findParagraphStyleById);
    }

    function readRunStyle(element) {
        return readStyle(element, "w:rStyle", "Run", styles.findCharacterStyleById);
    }

    function readTableStyle(element) {
        return readStyle(element, "w:tblStyle", "Table", styles.findTableStyleById);
    }

    function readStyle(element, styleTagName, styleType, findStyleById) {
        var messages = [];
        var styleElement = element.first(styleTagName);
        var styleId = null;
        var name = null;
        if (styleElement) {
            styleId = styleElement.attributes["w:val"];
            if (styleId) {
                var style = findStyleById(styleId);
                if (style) {
                    name = style.name;
                } else {
                    messages.push(undefinedStyleWarning(styleType, styleId));
                }
            }
        }
        return elementResultWithMessages({styleId: styleId, name: name}, messages);
    }

    function readFldChar(element) {
        var type = element.attributes["w:fldCharType"];
        if (type === "begin") {
            complexFieldStack.push({type: "begin", fldChar: element});
            currentInstrText = [];
        } else if (type === "end") {
            var complexFieldEnd = complexFieldStack.pop();
            if (complexFieldEnd.type === "begin") {
                complexFieldEnd = parseCurrentInstrText(complexFieldEnd);
            }
            if (complexFieldEnd.type === "checkbox") {
                return elementResult(documents.checkbox({
                    checked: complexFieldEnd.checked
                }));
            }
        } else if (type === "separate") {
            var complexFieldSeparate = complexFieldStack.pop();
            var complexField = parseCurrentInstrText(complexFieldSeparate);
            complexFieldStack.push(complexField);
        }
        return emptyResult();
    }

    function currentHyperlinkOptions() {
        var topHyperlink = _.last(complexFieldStack.filter(function(complexField) {
            return complexField.type === "hyperlink";
        }));
        return topHyperlink ? topHyperlink.options : null;
    }

    function parseCurrentInstrText(complexField) {
        return parseInstrText(
            currentInstrText.join(''),
            complexField.type === "begin"
                ? complexField.fldChar
                : xml.emptyElement
        );
    }

    function parseInstrText(instrText, fldChar) {
        var linkResult = /^\s*HYPERLINK\s+(\\l\s+)?(?:"(.*)"|([^\\]\S*))/.exec(instrText);
        if (linkResult) {
            var location = linkResult[2] === undefined ? linkResult[3] : linkResult[2];
            var options = linkResult[1] === undefined ? {href: location} : {anchor: location};
            return {type: "hyperlink", options: options};
        }

        var checkboxResult = /\s*FORMCHECKBOX\s*/.exec(instrText);
        if (checkboxResult) {
            var checkboxElement = fldChar
                .firstOrEmpty("w:ffData")
                .firstOrEmpty("w:checkBox");
            var checkedElement = checkboxElement.first("w:checked");
            var checked = checkedElement == null
                ? readBooleanElement(checkboxElement.first("w:default"))
                : readBooleanElement(checkedElement);
            return {type: "checkbox", checked: checked};
        }

        return {type: "unknown"};
    }

    function readInstrText(element) {
        currentInstrText.push(element.text());
        return emptyResult();
    }

    function readSymbol(element) {
        // See 17.3.3.30 sym (Symbol Character) of ECMA-376 4th edition Part 1
        var font = element.attributes["w:font"];
        var char = element.attributes["w:char"];
        var unicodeCharacter = dingbatToUnicode.hex(font, char);
        if (unicodeCharacter == null && /^F0..$/.test(char)) {
            unicodeCharacter = dingbatToUnicode.hex(font, char.substring(2));
        }

        if (unicodeCharacter == null) {
            return emptyResultWithMessages([warning(
                "A w:sym element with an unsupported character was ignored: char " +  char + " in font " + font
            )]);
        } else {
            return elementResult(new documents.Text(unicodeCharacter.string));
        }
    }

    function noteReferenceReader(noteType) {
        return function(element) {
            var noteId = element.attributes["w:id"];
            return elementResult(new documents.NoteReference({
                noteType: noteType,
                noteId: noteId
            }));
        };
    }

    function readCommentReference(element) {
        return elementResult(documents.commentReference({
            commentId: element.attributes["w:id"]
        }));
    }

    function readChildElements(element) {
        return readXmlElements(element.children);
    }

    var xmlElementReaders = {
        "w:p": function(element) {
            var paragraphPropertiesElement = element.firstOrEmpty("w:pPr");

            var isDeleted = !!paragraphPropertiesElement
                .firstOrEmpty("w:rPr")
                .first("w:del");

            if (isDeleted) {
                element.children.forEach(function(child) {
                    deletedParagraphContents.push(child);
                });
                return emptyResult();
            } else {
                var childrenXml = element.children;
                if (deletedParagraphContents.length > 0) {
                    childrenXml = deletedParagraphContents.concat(childrenXml);
                    deletedParagraphContents = [];
                }
                return ReadResult.map(
                    readParagraphProperties(paragraphPropertiesElement),
                    readXmlElements(childrenXml),
                    function(properties, children) {
                        return new documents.Paragraph(children, properties);
                    }
                ).insertExtra();
            }
        },
        "w:r": function(element) {
            return ReadResult.map(
                readRunProperties(element.firstOrEmpty("w:rPr")),
                readXmlElements(element.children),
                function(properties, children) {
                    var hyperlinkOptions = currentHyperlinkOptions();
                    if (hyperlinkOptions !== null) {
                        children = [new documents.Hyperlink(children, hyperlinkOptions)];
                    }

                    return new documents.Run(children, properties);
                }
            );
        },
        "w:fldChar": readFldChar,
        "w:instrText": readInstrText,
        "w:t": function(element) {
            return elementResult(new documents.Text(element.text()));
        },
        "w:tab": function(element) {
            return elementResult(new documents.Tab());
        },
        "w:noBreakHyphen": function() {
            return elementResult(new documents.Text("\u2011"));
        },
        "w:softHyphen": function(element) {
            return elementResult(new documents.Text("\u00AD"));
        },
        "w:sym": readSymbol,
        "w:hyperlink": function(element) {
            var relationshipId = element.attributes["r:id"];
            var anchor = element.attributes["w:anchor"];
            return readXmlElements(element.children).map(function(children) {
                function create(options) {
                    var targetFrame = element.attributes["w:tgtFrame"] || null;

                    return new documents.Hyperlink(
                        children,
                        _.extend({targetFrame: targetFrame}, options)
                    );
                }

                if (relationshipId) {
                    var href = relationships.findTargetByRelationshipId(relationshipId);
                    if (anchor) {
                        href = uris.replaceFragment(href, anchor);
                    }
                    return create({href: href});
                } else if (anchor) {
                    return create({anchor: anchor});
                } else {
                    return children;
                }
            });
        },
        "w:tbl": readTable,
        "w:tr": readTableRow,
        "w:tc": readTableCell,
        "w:footnoteReference": noteReferenceReader("footnote"),
        "w:endnoteReference": noteReferenceReader("endnote"),
        "w:commentReference": readCommentReference,
        "w:br": function(element) {
            var breakType = element.attributes["w:type"];
            if (breakType == null || breakType === "textWrapping") {
                return elementResult(documents.lineBreak);
            } else if (breakType === "page") {
                return elementResult(documents.pageBreak);
            } else if (breakType === "column") {
                return elementResult(documents.columnBreak);
            } else {
                return emptyResultWithMessages([warning("Unsupported break type: " + breakType)]);
            }
        },
        "w:bookmarkStart": function(element){
            var name = element.attributes["w:name"];
            if (name === "_GoBack") {
                return emptyResult();
            } else {
                return elementResult(new documents.BookmarkStart({name: name}));
            }
        },

        "mc:AlternateContent": function(element) {
            return readChildElements(element.firstOrEmpty("mc:Fallback"));
        },

        "w:sdt": function(element) {
            var contentResult = readXmlElements(element.firstOrEmpty("w:sdtContent").children);
            return contentResult.map(function(content) {
                // From the WordML standard: https://learn.microsoft.com/en-us/openspecs/office_standards/ms-docx/3350cb64-931f-41f7-8824-f18b2568ce66
                //
                // > A CT_SdtCheckbox element that specifies that the parent
                // > structured document tag is a checkbox when displayed in the
                // > document. The parent structured document tag contents MUST
                // > contain a single character and optionally an additional
                // > character in a deleted run.

                var checkbox = element
                    .firstOrEmpty("w:sdtPr")
                    .first("wordml:checkbox");

                if (checkbox) {
                    var checkedElement = checkbox.first("wordml:checked");
                    var isChecked = !!checkedElement && readBooleanAttributeValue(
                        checkedElement.attributes["wordml:val"]
                    );
                    var documentCheckbox = documents.checkbox({
                        checked: isChecked
                    });

                    var hasCheckbox = false;
                    var replacedContent = content.map(transforms._elementsOfType(
                        documents.types.text,
                        function(text) {
                            if (text.value.length > 0 && !hasCheckbox) {
                                hasCheckbox = true;
                                return documentCheckbox;
                            } else {
                                return text;
                            }
                        }
                    ));

                    if (hasCheckbox) {
                        return replacedContent;
                    } else {
                        return documentCheckbox;
                    }

                } else {
                    return content;
                }
            });
        },

        "w:ins": readChildElements,
        "w:object": readChildElements,
        "w:smartTag": readChildElements,
        "w:drawing": readChildElements,
        "w:pict": function(element) {
            return readChildElements(element).toExtra();
        },
        "v:roundrect": readChildElements,
        "v:shape": readChildElements,
        "v:textbox": readChildElements,
        "w:txbxContent": readChildElements,
        "wp:inline": readDrawingElement,
        "wp:anchor": readDrawingElement,
        "v:imagedata": readImageData,
        "v:group": readChildElements,
        "v:rect": readChildElements
    };

    return {
        readXmlElement: readXmlElement,
        readXmlElements: readXmlElements
    };


    function readTable(element) {
        var propertiesResult = readTableProperties(element.firstOrEmpty("w:tblPr"));
        return readXmlElements(element.children)
            .flatMap(calculateRowSpans)
            .flatMap(function(children) {
                return propertiesResult.map(function(properties) {
                    return documents.Table(children, properties);
                });
            });
    }

    function readTableProperties(element) {
        return readTableStyle(element).map(function(style) {
            return {
                styleId: style.styleId,
                styleName: style.name
            };
        });
    }

    function readTableRow(element) {
        var properties = element.firstOrEmpty("w:trPr");

        // See 17.13.5.12 del (Deleted Table Row) of ECMA-376 4th edition Part 1
        var isDeleted = !!properties.first("w:del");
        if (isDeleted) {
            return emptyResult();
        }

        var isHeader = !!properties.first("w:tblHeader");
        return readXmlElements(element.children).map(function(children) {
            return documents.TableRow(children, {isHeader: isHeader});
        });
    }

    function readTableCell(element) {
        return readXmlElements(element.children).map(function(children) {
            var properties = element.firstOrEmpty("w:tcPr");

            var gridSpan = properties.firstOrEmpty("w:gridSpan").attributes["w:val"];
            var colSpan = gridSpan ? parseInt(gridSpan, 10) : 1;

            var cell = documents.TableCell(children, {colSpan: colSpan});
            cell._vMerge = readVMerge(properties);
            return cell;
        });
    }

    function readVMerge(properties) {
        var element = properties.first("w:vMerge");
        if (element) {
            var val = element.attributes["w:val"];
            return val === "continue" || !val;
        } else {
            return null;
        }
    }

    function calculateRowSpans(rows) {
        var unexpectedNonRows = _.any(rows, function(row) {
            return row.type !== documents.types.tableRow;
        });
        if (unexpectedNonRows) {
            removeVMergeProperties(rows);
            return elementResultWithMessages(rows, [warning(
                "unexpected non-row element in table, cell merging may be incorrect"
            )]);
        }
        var unexpectedNonCells = _.any(rows, function(row) {
            return _.any(row.children, function(cell) {
                return cell.type !== documents.types.tableCell;
            });
        });
        if (unexpectedNonCells) {
            removeVMergeProperties(rows);
            return elementResultWithMessages(rows, [warning(
                "unexpected non-cell element in table row, cell merging may be incorrect"
            )]);
        }

        var columns = {};

        rows.forEach(function(row) {
            var cellIndex = 0;
            row.children.forEach(function(cell) {
                if (cell._vMerge && columns[cellIndex]) {
                    columns[cellIndex].rowSpan++;
                } else {
                    columns[cellIndex] = cell;
                    cell._vMerge = false;
                }
                cellIndex += cell.colSpan;
            });
        });

        rows.forEach(function(row) {
            row.children = row.children.filter(function(cell) {
                return !cell._vMerge;
            });
            row.children.forEach(function(cell) {
                delete cell._vMerge;
            });
        });

        return elementResult(rows);
    }

    function removeVMergeProperties(rows) {
        rows.forEach(function(row) {
            var cells = transforms.getDescendantsOfType(row, documents.types.tableCell);
            cells.forEach(function(cell) {
                delete cell._vMerge;
            });
        });
    }

    function readDrawingElement(element) {
        var blips = element
            .getElementsByTagName("a:graphic")
            .getElementsByTagName("a:graphicData")
            .getElementsByTagName("pic:pic")
            .getElementsByTagName("pic:blipFill")
            .getElementsByTagName("a:blip");

        return combineResults(blips.map(readBlip.bind(null, element)));
    }

    function readBlip(element, blip) {
        var propertiesElement = element.firstOrEmpty("wp:docPr");
        var properties = propertiesElement.attributes;

        var altText = isBlank(properties.descr) ? properties.title : properties.descr;

        var blipImageFile = findBlipImageFile(blip);
        if (blipImageFile === null) {
            return emptyResultWithMessages([warning("Could not find image file for a:blip element")]);
        }

        return readImage(blipImageFile, altText).map(function(imageElement) {
            var hlinkClickElement = propertiesElement.firstOrEmpty("a:hlinkClick");
            var relationshipId = hlinkClickElement.attributes["r:id"];
            if (relationshipId) {
                var href = relationships.findTargetByRelationshipId(relationshipId);
                return new documents.Hyperlink([imageElement], {href: href});
            } else {
                return imageElement;
            }
        });
    }

    function isBlank(value) {
        return value == null || /^\s*$/.test(value);
    }

    function findBlipImageFile(blip) {
        var embedRelationshipId = blip.attributes["r:embed"];
        var linkRelationshipId = blip.attributes["r:link"];
        if (embedRelationshipId) {
            return findEmbeddedImageFile(embedRelationshipId);
        } else if (linkRelationshipId) {
            var imagePath = relationships.findTargetByRelationshipId(linkRelationshipId);
            return {
                path: imagePath,
                read: files.read.bind(files, imagePath)
            };
        } else {
            return null;
        }
    }

    function readImageData(element) {
        var relationshipId = element.attributes['r:id'];

        if (relationshipId) {
            return readImage(
                findEmbeddedImageFile(relationshipId),
                element.attributes["o:title"]);
        } else {
            return emptyResultWithMessages([warning("A v:imagedata element without a relationship ID was ignored")]);
        }
    }

    function findEmbeddedImageFile(relationshipId) {
        var path = uris.uriToZipEntryName("word", relationships.findTargetByRelationshipId(relationshipId));
        return {
            path: path,
            read: docxFile.read.bind(docxFile, path)
        };
    }

    function readImage(imageFile, altText) {
        var contentType = contentTypes.findContentType(imageFile.path);

        var image = documents.Image({
            readImage: imageFile.read,
            altText: altText,
            contentType: contentType
        });
        var warnings = supportedImageTypes[contentType] ?
            [] : warning("Image of type " + contentType + " is unlikely to display in web browsers");
        return elementResultWithMessages(image, warnings);
    }

    function undefinedStyleWarning(type, styleId) {
        return warning(
            type + " style with ID " + styleId + " was referenced but not defined in the document");
    }
}


function readNumberingProperties(styleId, element, numbering) {
    var level = element.firstOrEmpty("w:ilvl").attributes["w:val"];
    var numId = element.firstOrEmpty("w:numId").attributes["w:val"];
    if (level !== undefined && numId !== undefined) {
        return numbering.findLevel(numId, level);
    }

    if (styleId != null) {
        var levelByStyleId = numbering.findLevelByParagraphStyleId(styleId);
        if (levelByStyleId != null) {
            return levelByStyleId;
        }
    }

    // Some malformed documents define numbering levels without an index, and
    // reference the numbering using a w:numPr element without a w:ilvl child.
    // To handle such cases, we assume a level of 0 as a fallback.
    if (numId !== undefined) {
        return numbering.findLevel(numId, "0");
    }

    return null;
}

var supportedImageTypes = {
    "image/png": true,
    "image/gif": true,
    "image/jpeg": true,
    "image/svg+xml": true,
    "image/tiff": true
};

var ignoreElements = {
    "office-word:wrap": true,
    "v:shadow": true,
    "v:shapetype": true,
    "w:annotationRef": true,
    "w:bookmarkEnd": true,
    "w:sectPr": true,
    "w:proofErr": true,
    "w:lastRenderedPageBreak": true,
    "w:commentRangeStart": true,
    "w:commentRangeEnd": true,
    "w:del": true,
    "w:footnoteRef": true,
    "w:endnoteRef": true,
    "w:pPr": true,
    "w:rPr": true,
    "w:tblPr": true,
    "w:tblGrid": true,
    "w:trPr": true,
    "w:tcPr": true
};

function emptyResultWithMessages(messages) {
    return new ReadResult(null, null, messages);
}

function emptyResult() {
    return new ReadResult(null);
}

function elementResult(element) {
    return new ReadResult(element);
}

function elementResultWithMessages(element, messages) {
    return new ReadResult(element, null, messages);
}

function ReadResult(element, extra, messages) {
    this.value = element || [];
    this.extra = extra || [];
    this._result = new Result({
        element: this.value,
        extra: extra
    }, messages);
    this.messages = this._result.messages;
}

ReadResult.prototype.toExtra = function() {
    return new ReadResult(null, joinElements(this.extra, this.value), this.messages);
};

ReadResult.prototype.insertExtra = function() {
    var extra = this.extra;
    if (extra && extra.length) {
        return new ReadResult(joinElements(this.value, extra), null, this.messages);
    } else {
        return this;
    }
};

ReadResult.prototype.map = function(func) {
    var result = this._result.map(function(value) {
        return func(value.element);
    });
    return new ReadResult(result.value, this.extra, result.messages);
};

ReadResult.prototype.flatMap = function(func) {
    var result = this._result.flatMap(function(value) {
        return func(value.element)._result;
    });
    return new ReadResult(result.value.element, joinElements(this.extra, result.value.extra), result.messages);
};

ReadResult.map = function(first, second, func) {
    return new ReadResult(
        func(first.value, second.value),
        joinElements(first.extra, second.extra),
        first.messages.concat(second.messages)
    );
};

function combineResults(results) {
    var result = Result.combine(_.pluck(results, "_result"));
    return new ReadResult(
        _.flatten(_.pluck(result.value, "element")),
        _.filter(_.flatten(_.pluck(result.value, "extra")), identity),
        result.messages
    );
}

function joinElements(first, second) {
    return _.flatten([first, second]);
}

function identity(value) {
    return value;
}

},{"../documents":4,"../results":25,"../transforms":30,"../xml":35,"./uris":16,"dingbat-to-unicode":85,"underscore":102}],6:[function(require,module,exports){
var documents = require("../documents");
var Result = require("../results").Result;

function createCommentsReader(bodyReader) {
    function readCommentsXml(element) {
        return Result.combine(element.getElementsByTagName("w:comment")
            .map(readCommentElement));
    }

    function readCommentElement(element) {
        var id = element.attributes["w:id"];

        function readOptionalAttribute(name) {
            return (element.attributes[name] || "").trim() || null;
        }

        return bodyReader.readXmlElements(element.children)
            .map(function(body) {
                return documents.comment({
                    commentId: id,
                    body: body,
                    authorName: readOptionalAttribute("w:author"),
                    authorInitials: readOptionalAttribute("w:initials")
                });
            });
    }
    
    return readCommentsXml;
}

exports.createCommentsReader = createCommentsReader;

},{"../documents":4,"../results":25}],7:[function(require,module,exports){
exports.readContentTypesFromXml = readContentTypesFromXml;

var fallbackContentTypes = {
    "png": "png",
    "gif": "gif",
    "jpeg": "jpeg",
    "jpg": "jpeg",
    "tif": "tiff",
    "tiff": "tiff",
    "bmp": "bmp"
};

exports.defaultContentTypes = contentTypes({}, {});


function readContentTypesFromXml(element) {
    var extensionDefaults = {};
    var overrides = {};
    
    element.children.forEach(function(child) {
        if (child.name === "content-types:Default") {
            extensionDefaults[child.attributes.Extension] = child.attributes.ContentType;
        }
        if (child.name === "content-types:Override") {
            var name = child.attributes.PartName;
            if (name.charAt(0) === "/") {
                name = name.substring(1);
            }
            overrides[name] = child.attributes.ContentType;
        }
    });
    return contentTypes(overrides, extensionDefaults);
}

function contentTypes(overrides, extensionDefaults) {
    return {
        findContentType: function(path) {
            var overrideContentType = overrides[path];
            if (overrideContentType) {
                return overrideContentType;
            } else {
                var pathParts = path.split(".");
                var extension = pathParts[pathParts.length - 1];
                if (extensionDefaults.hasOwnProperty(extension)) {
                    return extensionDefaults[extension];
                } else {
                    var fallback = fallbackContentTypes[extension.toLowerCase()];
                    if (fallback) {
                        return "image/" + fallback;
                    } else {
                        return null;
                    }
                }
            }
        }
    };
    
}

},{}],8:[function(require,module,exports){
exports.DocumentXmlReader = DocumentXmlReader;

var documents = require("../documents");
var Result = require("../results").Result;


function DocumentXmlReader(options) {
    var bodyReader = options.bodyReader;

    function convertXmlToDocument(element) {
        var body = element.first("w:body");

        if (body == null) {
            throw new Error("Could not find the body element: are you sure this is a docx file?");
        }

        var result = bodyReader.readXmlElements(body.children)
            .map(function(children) {
                return new documents.Document(children, {
                    notes: options.notes,
                    comments: options.comments
                });
            });
        return new Result(result.value, result.messages);
    }

    return {
        convertXmlToDocument: convertXmlToDocument
    };
}

},{"../documents":4,"../results":25}],9:[function(require,module,exports){
exports.read = read;
exports._findPartPaths = findPartPaths;

var promises = require("../promises");
var documents = require("../documents");
var Result = require("../results").Result;
var zipfile = require("../zipfile");

var readXmlFromZipFile = require("./office-xml-reader").readXmlFromZipFile;
var createBodyReader = require("./body-reader").createBodyReader;
var DocumentXmlReader = require("./document-xml-reader").DocumentXmlReader;
var relationshipsReader = require("./relationships-reader");
var contentTypesReader = require("./content-types-reader");
var numberingXml = require("./numbering-xml");
var stylesReader = require("./styles-reader");
var notesReader = require("./notes-reader");
var commentsReader = require("./comments-reader");
var Files = require("./files").Files;


function read(docxFile, input, options) {
    input = input || {};
    options = options || {};

    var files = new Files({
        externalFileAccess: options.externalFileAccess,
        relativeToFile: input.path
    });

    return promises.props({
        contentTypes: readContentTypesFromZipFile(docxFile),
        partPaths: findPartPaths(docxFile),
        docxFile: docxFile,
        files: files
    }).also(function(result) {
        return {
            styles: readStylesFromZipFile(docxFile, result.partPaths.styles)
        };
    }).also(function(result) {
        return {
            numbering: readNumberingFromZipFile(docxFile, result.partPaths.numbering, result.styles)
        };
    }).also(function(result) {
        return {
            footnotes: readXmlFileWithBody(result.partPaths.footnotes, result, function(bodyReader, xml) {
                if (xml) {
                    return notesReader.createFootnotesReader(bodyReader)(xml);
                } else {
                    return new Result([]);
                }
            }),
            endnotes: readXmlFileWithBody(result.partPaths.endnotes, result, function(bodyReader, xml) {
                if (xml) {
                    return notesReader.createEndnotesReader(bodyReader)(xml);
                } else {
                    return new Result([]);
                }
            }),
            comments: readXmlFileWithBody(result.partPaths.comments, result, function(bodyReader, xml) {
                if (xml) {
                    return commentsReader.createCommentsReader(bodyReader)(xml);
                } else {
                    return new Result([]);
                }
            })
        };
    }).also(function(result) {
        return {
            notes: result.footnotes.flatMap(function(footnotes) {
                return result.endnotes.map(function(endnotes) {
                    return new documents.Notes(footnotes.concat(endnotes));
                });
            })
        };
    }).then(function(result) {
        return readXmlFileWithBody(result.partPaths.mainDocument, result, function(bodyReader, xml) {
            return result.notes.flatMap(function(notes) {
                return result.comments.flatMap(function(comments) {
                    var reader = new DocumentXmlReader({
                        bodyReader: bodyReader,
                        notes: notes,
                        comments: comments
                    });
                    return reader.convertXmlToDocument(xml);
                });
            });
        });
    });
}

function findPartPaths(docxFile) {
    return readPackageRelationships(docxFile).then(function(packageRelationships) {
        var mainDocumentPath = findPartPath({
            docxFile: docxFile,
            relationships: packageRelationships,
            relationshipType: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
            basePath: "",
            fallbackPath: "word/document.xml"
        });

        if (!docxFile.exists(mainDocumentPath)) {
            throw new Error("Could not find main document part. Are you sure this is a valid .docx file?");
        }

        return xmlFileReader({
            filename: relationshipsFilename(mainDocumentPath),
            readElement: relationshipsReader.readRelationships,
            defaultValue: relationshipsReader.defaultValue
        })(docxFile).then(function(documentRelationships) {
            function findPartRelatedToMainDocument(name) {
                return findPartPath({
                    docxFile: docxFile,
                    relationships: documentRelationships,
                    relationshipType: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/" + name,
                    basePath: zipfile.splitPath(mainDocumentPath).dirname,
                    fallbackPath: "word/" + name + ".xml"
                });
            }

            return {
                mainDocument: mainDocumentPath,
                comments: findPartRelatedToMainDocument("comments"),
                endnotes: findPartRelatedToMainDocument("endnotes"),
                footnotes: findPartRelatedToMainDocument("footnotes"),
                numbering: findPartRelatedToMainDocument("numbering"),
                styles: findPartRelatedToMainDocument("styles")
            };
        });
    });
}

function findPartPath(options) {
    var docxFile = options.docxFile;
    var relationships = options.relationships;
    var relationshipType = options.relationshipType;
    var basePath = options.basePath;
    var fallbackPath = options.fallbackPath;

    var targets = relationships.findTargetsByType(relationshipType);
    var normalisedTargets = targets.map(function(target) {
        return stripPrefix(zipfile.joinPath(basePath, target), "/");
    });
    var validTargets = normalisedTargets.filter(function(target) {
        return docxFile.exists(target);
    });
    if (validTargets.length === 0) {
        return fallbackPath;
    } else {
        return validTargets[0];
    }
}

function stripPrefix(value, prefix) {
    if (value.substring(0, prefix.length) === prefix) {
        return value.substring(prefix.length);
    } else {
        return value;
    }
}

function xmlFileReader(options) {
    return function(zipFile) {
        return readXmlFromZipFile(zipFile, options.filename)
            .then(function(element) {
                return element ? options.readElement(element) : options.defaultValue;
            });
    };
}

function readXmlFileWithBody(filename, options, func) {
    var readRelationshipsFromZipFile = xmlFileReader({
        filename: relationshipsFilename(filename),
        readElement: relationshipsReader.readRelationships,
        defaultValue: relationshipsReader.defaultValue
    });

    return readRelationshipsFromZipFile(options.docxFile).then(function(relationships) {
        var bodyReader = new createBodyReader({
            relationships: relationships,
            contentTypes: options.contentTypes,
            docxFile: options.docxFile,
            numbering: options.numbering,
            styles: options.styles,
            files: options.files
        });
        return readXmlFromZipFile(options.docxFile, filename)
            .then(function(xml) {
                return func(bodyReader, xml);
            });
    });
}

function relationshipsFilename(filename) {
    var split = zipfile.splitPath(filename);
    return zipfile.joinPath(split.dirname, "_rels", split.basename + ".rels");
}

var readContentTypesFromZipFile = xmlFileReader({
    filename: "[Content_Types].xml",
    readElement: contentTypesReader.readContentTypesFromXml,
    defaultValue: contentTypesReader.defaultContentTypes
});

function readNumberingFromZipFile(zipFile, path, styles) {
    return xmlFileReader({
        filename: path,
        readElement: function(element) {
            return numberingXml.readNumberingXml(element, {styles: styles});
        },
        defaultValue: numberingXml.defaultNumbering
    })(zipFile);
}

function readStylesFromZipFile(zipFile, path) {
    return xmlFileReader({
        filename: path,
        readElement: stylesReader.readStylesXml,
        defaultValue: stylesReader.defaultStyles
    })(zipFile);
}

var readPackageRelationships = xmlFileReader({
    filename: "_rels/.rels",
    readElement: relationshipsReader.readRelationships,
    defaultValue: relationshipsReader.defaultValue
});

},{"../documents":4,"../promises":23,"../results":25,"../zipfile":40,"./body-reader":5,"./comments-reader":6,"./content-types-reader":7,"./document-xml-reader":8,"./files":1,"./notes-reader":10,"./numbering-xml":11,"./office-xml-reader":12,"./relationships-reader":13,"./styles-reader":15}],10:[function(require,module,exports){
var documents = require("../documents");
var Result = require("../results").Result;

exports.createFootnotesReader = createReader.bind(this, "footnote");
exports.createEndnotesReader = createReader.bind(this, "endnote");

function createReader(noteType, bodyReader) {
    function readNotesXml(element) {
        return Result.combine(element.getElementsByTagName("w:" + noteType)
            .filter(isFootnoteElement)
            .map(readFootnoteElement));
    }

    function isFootnoteElement(element) {
        var type = element.attributes["w:type"];
        return type !== "continuationSeparator" && type !== "separator";
    }

    function readFootnoteElement(footnoteElement) {
        var id = footnoteElement.attributes["w:id"];
        return bodyReader.readXmlElements(footnoteElement.children)
            .map(function(body) {
                return documents.Note({noteType: noteType, noteId: id, body: body});
            });
    }
    
    return readNotesXml;
}

},{"../documents":4,"../results":25}],11:[function(require,module,exports){
var _ = require("underscore");

exports.readNumberingXml = readNumberingXml;
exports.Numbering = Numbering;
exports.defaultNumbering = new Numbering({}, {});

function Numbering(nums, abstractNums, styles) {
    var allLevels = _.flatten(_.values(abstractNums).map(function(abstractNum) {
        return _.values(abstractNum.levels);
    }));

    var levelsByParagraphStyleId = _.indexBy(
        allLevels.filter(function(level) {
            return level.paragraphStyleId != null;
        }),
        "paragraphStyleId"
    );

    function findLevel(numId, level) {
        var num = nums[numId];
        if (num) {
            var abstractNum = abstractNums[num.abstractNumId];
            if (!abstractNum) {
                return null;
            } else if (abstractNum.numStyleLink == null) {
                return abstractNums[num.abstractNumId].levels[level];
            } else {
                var style = styles.findNumberingStyleById(abstractNum.numStyleLink);
                return findLevel(style.numId, level);
            }
        } else {
            return null;
        }
    }

    function findLevelByParagraphStyleId(styleId) {
        return levelsByParagraphStyleId[styleId] || null;
    }

    return {
        findLevel: findLevel,
        findLevelByParagraphStyleId: findLevelByParagraphStyleId
    };
}

function readNumberingXml(root, options) {
    if (!options || !options.styles) {
        throw new Error("styles is missing");
    }

    var abstractNums = readAbstractNums(root);
    var nums = readNums(root, abstractNums);
    return new Numbering(nums, abstractNums, options.styles);
}

function readAbstractNums(root) {
    var abstractNums = {};
    root.getElementsByTagName("w:abstractNum").forEach(function(element) {
        var id = element.attributes["w:abstractNumId"];
        abstractNums[id] = readAbstractNum(element);
    });
    return abstractNums;
}

function readAbstractNum(element) {
    var levels = {};

    // Some malformed documents define numbering levels without an index, and
    // reference the numbering using a w:numPr element without a w:ilvl child.
    // To handle such cases, we assume a level of 0 as a fallback.
    var levelWithoutIndex = null;

    element.getElementsByTagName("w:lvl").forEach(function(levelElement) {
        var levelIndex = levelElement.attributes["w:ilvl"];
        var numFmt = levelElement.firstOrEmpty("w:numFmt").attributes["w:val"];
        var isOrdered = numFmt !== "bullet";
        var paragraphStyleId = levelElement.firstOrEmpty("w:pStyle").attributes["w:val"];

        if (levelIndex === undefined) {
            levelWithoutIndex = {
                isOrdered: isOrdered,
                level: "0",
                paragraphStyleId: paragraphStyleId
            };
        } else {
            levels[levelIndex] = {
                isOrdered: isOrdered,
                level: levelIndex,
                paragraphStyleId: paragraphStyleId
            };
        }
    });

    if (levelWithoutIndex !== null && levels[levelWithoutIndex.level] === undefined) {
        levels[levelWithoutIndex.level] = levelWithoutIndex;
    }

    var numStyleLink = element.firstOrEmpty("w:numStyleLink").attributes["w:val"];

    return {levels: levels, numStyleLink: numStyleLink};
}

function readNums(root) {
    var nums = {};
    root.getElementsByTagName("w:num").forEach(function(element) {
        var numId = element.attributes["w:numId"];
        var abstractNumId = element.first("w:abstractNumId").attributes["w:val"];
        nums[numId] = {abstractNumId: abstractNumId};
    });
    return nums;
}

},{"underscore":102}],12:[function(require,module,exports){
var _ = require("underscore");

var promises = require("../promises");
var xml = require("../xml");


exports.read = read;
exports.readXmlFromZipFile = readXmlFromZipFile;

var xmlNamespaceMap = {
    // Transitional format
    "http://schemas.openxmlformats.org/wordprocessingml/2006/main": "w",
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships": "r",
    "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing": "wp",
    "http://schemas.openxmlformats.org/drawingml/2006/main": "a",
    "http://schemas.openxmlformats.org/drawingml/2006/picture": "pic",

    // Strict format
    "http://purl.oclc.org/ooxml/wordprocessingml/main": "w",
    "http://purl.oclc.org/ooxml/officeDocument/relationships": "r",
    "http://purl.oclc.org/ooxml/drawingml/wordprocessingDrawing": "wp",
    "http://purl.oclc.org/ooxml/drawingml/main": "a",
    "http://purl.oclc.org/ooxml/drawingml/picture": "pic",

    // Common
    "http://schemas.openxmlformats.org/package/2006/content-types": "content-types",
    "http://schemas.openxmlformats.org/package/2006/relationships": "relationships",
    "http://schemas.openxmlformats.org/markup-compatibility/2006": "mc",
    "urn:schemas-microsoft-com:vml": "v",
    "urn:schemas-microsoft-com:office:word": "office-word",

    // [MS-DOCX]: Word Extensions to the Office Open XML (.docx) File Format
    // https://learn.microsoft.com/en-us/openspecs/office_standards/ms-docx/b839fe1f-e1ca-4fa6-8c26-5954d0abbccd
    "http://schemas.microsoft.com/office/word/2010/wordml": "wordml"
};


function read(xmlString) {
    return xml.readString(xmlString, xmlNamespaceMap)
        .then(function(document) {
            return collapseAlternateContent(document)[0];
        });
}


function readXmlFromZipFile(docxFile, path) {
    if (docxFile.exists(path)) {
        return docxFile.read(path, "utf-8")
            .then(stripUtf8Bom)
            .then(read);
    } else {
        return promises.resolve(null);
    }
}


function stripUtf8Bom(xmlString) {
    return xmlString.replace(/^\uFEFF/g, '');
}


function collapseAlternateContent(node) {
    if (node.type === "element") {
        if (node.name === "mc:AlternateContent") {
            return node.firstOrEmpty("mc:Fallback").children;
        } else {
            node.children = _.flatten(node.children.map(collapseAlternateContent, true));
            return [node];
        }
    } else {
        return [node];
    }
}

},{"../promises":23,"../xml":35,"underscore":102}],13:[function(require,module,exports){
exports.readRelationships = readRelationships;
exports.defaultValue = new Relationships([]);
exports.Relationships = Relationships;


function readRelationships(element) {
    var relationships = [];
    element.children.forEach(function(child) {
        if (child.name === "relationships:Relationship") {
            var relationship = {
                relationshipId: child.attributes.Id,
                target: child.attributes.Target,
                type: child.attributes.Type
            };
            relationships.push(relationship);
        }
    });
    return new Relationships(relationships);
}

function Relationships(relationships) {
    var targetsByRelationshipId = {};
    relationships.forEach(function(relationship) {
        targetsByRelationshipId[relationship.relationshipId] = relationship.target;
    });

    var targetsByType = {};
    relationships.forEach(function(relationship) {
        if (!targetsByType[relationship.type]) {
            targetsByType[relationship.type] = [];
        }
        targetsByType[relationship.type].push(relationship.target);
    });

    return {
        findTargetByRelationshipId: function(relationshipId) {
            return targetsByRelationshipId[relationshipId];
        },
        findTargetsByType: function(type) {
            return targetsByType[type] || [];
        }
    };
}

},{}],14:[function(require,module,exports){
var _ = require("underscore");

var promises = require("../promises");
var xml = require("../xml");

exports.writeStyleMap = writeStyleMap;
exports.readStyleMap = readStyleMap;


var schema = "http://schemas.zwobble.org/mammoth/style-map";
var styleMapPath = "mammoth/style-map";
var styleMapAbsolutePath = "/" + styleMapPath;

function writeStyleMap(docxFile, styleMap) {
    docxFile.write(styleMapPath, styleMap);
    return updateRelationships(docxFile).then(function() {
        return updateContentTypes(docxFile);
    });
}

function updateRelationships(docxFile) {
    var path = "word/_rels/document.xml.rels";
    var relationshipsUri = "http://schemas.openxmlformats.org/package/2006/relationships";
    var relationshipElementName = "{" + relationshipsUri + "}Relationship";
    return docxFile.read(path, "utf8")
        .then(xml.readString)
        .then(function(relationshipsContainer) {
            var relationships = relationshipsContainer.children;
            addOrUpdateElement(relationships, relationshipElementName, "Id", {
                "Id": "rMammothStyleMap",
                "Type": schema,
                "Target": styleMapAbsolutePath
            });
            
            var namespaces = {"": relationshipsUri};
            return docxFile.write(path, xml.writeString(relationshipsContainer, namespaces));
        });
}

function updateContentTypes(docxFile) {
    var path = "[Content_Types].xml";
    var contentTypesUri = "http://schemas.openxmlformats.org/package/2006/content-types";
    var overrideName = "{" + contentTypesUri + "}Override";
    return docxFile.read(path, "utf8")
        .then(xml.readString)
        .then(function(typesElement) {
            var children = typesElement.children;
            addOrUpdateElement(children, overrideName, "PartName", {
                "PartName": styleMapAbsolutePath,
                "ContentType": "text/prs.mammoth.style-map"
            });
            var namespaces = {"": contentTypesUri};
            return docxFile.write(path, xml.writeString(typesElement, namespaces));
        });
}

function addOrUpdateElement(elements, name, identifyingAttribute, attributes) {
    var existingElement = _.find(elements, function(element) {
        return element.name === name &&
            element.attributes[identifyingAttribute] === attributes[identifyingAttribute];
    });
    if (existingElement) {
        existingElement.attributes = attributes;
    } else {
        elements.push(xml.element(name, attributes));
    }
}

function readStyleMap(docxFile) {
    if (docxFile.exists(styleMapPath)) {
        return docxFile.read(styleMapPath, "utf8");
    } else {
        return promises.resolve(null);
    }
}

},{"../promises":23,"../xml":35,"underscore":102}],15:[function(require,module,exports){
exports.readStylesXml = readStylesXml;
exports.Styles = Styles;
exports.defaultStyles = new Styles({}, {});

function Styles(paragraphStyles, characterStyles, tableStyles, numberingStyles) {
    return {
        findParagraphStyleById: function(styleId) {
            return paragraphStyles[styleId];
        },
        findCharacterStyleById: function(styleId) {
            return characterStyles[styleId];
        },
        findTableStyleById: function(styleId) {
            return tableStyles[styleId];
        },
        findNumberingStyleById: function(styleId) {
            return numberingStyles[styleId];
        }
    };
}

Styles.EMPTY = new Styles({}, {}, {}, {});

function readStylesXml(root) {
    var paragraphStyles = {};
    var characterStyles = {};
    var tableStyles = {};
    var numberingStyles = {};

    var styles = {
        "paragraph": paragraphStyles,
        "character": characterStyles,
        "table": tableStyles,
        "numbering": numberingStyles
    };

    root.getElementsByTagName("w:style").forEach(function(styleElement) {
        var style = readStyleElement(styleElement);
        var styleSet = styles[style.type];

        // Per 17.7.4.17 style (Style Definition) of ECMA-376 4th edition Part 1:
        //
        // > If multiple style definitions each declare the same value for their
        // > styleId, then the first such instance shall keep its current
        // > identifier with all other instances being reassigned in any manner
        // > desired.
        //
        // For the purpose of conversion, there's no point holding onto styles
        // with reassigned style IDs, so we ignore such style definitions.

        if (styleSet && styleSet[style.styleId] === undefined) {
            styleSet[style.styleId] = style;
        }
    });

    return new Styles(paragraphStyles, characterStyles, tableStyles, numberingStyles);
}

function readStyleElement(styleElement) {
    var type = styleElement.attributes["w:type"];

    if (type === "numbering") {
        return readNumberingStyleElement(type, styleElement);
    } else {
        var styleId = readStyleId(styleElement);
        var name = styleName(styleElement);
        return {type: type, styleId: styleId, name: name};
    }
}

function styleName(styleElement) {
    var nameElement = styleElement.first("w:name");
    return nameElement ? nameElement.attributes["w:val"] : null;
}

function readNumberingStyleElement(type, styleElement) {
    var styleId = readStyleId(styleElement);

    var numId = styleElement
        .firstOrEmpty("w:pPr")
        .firstOrEmpty("w:numPr")
        .firstOrEmpty("w:numId")
        .attributes["w:val"];

    return {type: type, numId: numId, styleId: styleId};
}

function readStyleId(styleElement) {
    return styleElement.attributes["w:styleId"];
}

},{}],16:[function(require,module,exports){
exports.uriToZipEntryName = uriToZipEntryName;
exports.replaceFragment = replaceFragment;

function uriToZipEntryName(base, uri) {
    if (uri.charAt(0) === "/") {
        return uri.substr(1);
    } else {
        // In general, we should check first and second for trailing and leading slashes,
        // but in our specific case this seems to be sufficient
        return base + "/" + uri;
    }
}


function replaceFragment(uri, fragment) {
    var hashIndex = uri.indexOf("#");
    if (hashIndex !== -1) {
        uri = uri.substring(0, hashIndex);
    }
    return uri + "#" + fragment;
}

},{}],17:[function(require,module,exports){
var htmlPaths = require("../styles/html-paths");


function nonFreshElement(tagName, attributes, children) {
    return elementWithTag(
        htmlPaths.element(tagName, attributes, {fresh: false}),
        children);
}

function freshElement(tagName, attributes, children) {
    var tag = htmlPaths.element(tagName, attributes, {fresh: true});
    return elementWithTag(tag, children);
}

function elementWithTag(tag, children) {
    return {
        type: "element",
        tag: tag,
        children: children || []
    };
}

function text(value) {
    return {
        type: "text",
        value: value
    };
}

var forceWrite = {
    type: "forceWrite"
};

exports.freshElement = freshElement;
exports.nonFreshElement = nonFreshElement;
exports.elementWithTag = elementWithTag;
exports.text = text;
exports.forceWrite = forceWrite;

var voidTagNames = {
    "br": true,
    "hr": true,
    "img": true,
    "input": true
};

function isVoidElement(node) {
    return (node.children.length === 0) && voidTagNames[node.tag.tagName];
}

exports.isVoidElement = isVoidElement;

},{"../styles/html-paths":28}],18:[function(require,module,exports){
var ast = require("./ast");

exports.freshElement = ast.freshElement;
exports.nonFreshElement = ast.nonFreshElement;
exports.elementWithTag = ast.elementWithTag;
exports.text = ast.text;
exports.forceWrite = ast.forceWrite;

exports.simplify = require("./simplify");

function write(writer, nodes) {
    nodes.forEach(function(node) {
        writeNode(writer, node);
    });
}

function writeNode(writer, node) {
    toStrings[node.type](writer, node);
}

var toStrings = {
    element: generateElementString,
    text: generateTextString,
    forceWrite: function() { }
};

function generateElementString(writer, node) {
    if (ast.isVoidElement(node)) {
        writer.selfClosing(node.tag.tagName, node.tag.attributes);
    } else {
        writer.open(node.tag.tagName, node.tag.attributes);
        write(writer, node.children);
        writer.close(node.tag.tagName);
    }
}

function generateTextString(writer, node) {
    writer.text(node.value);
}

exports.write = write;

},{"./ast":17,"./simplify":19}],19:[function(require,module,exports){
var _ = require("underscore");

var ast = require("./ast");

function simplify(nodes) {
    return collapse(removeEmpty(nodes));
}

function collapse(nodes) {
    var children = [];
    
    nodes.map(collapseNode).forEach(function(child) {
        appendChild(children, child);
    });
    return children;
}

function collapseNode(node) {
    return collapsers[node.type](node);
}

var collapsers = {
    element: collapseElement,
    text: identity,
    forceWrite: identity
};

function collapseElement(node) {
    return ast.elementWithTag(node.tag, collapse(node.children));
}

function identity(value) {
    return value;
}

function appendChild(children, child) {
    var lastChild = children[children.length - 1];
    if (child.type === "element" && !child.tag.fresh && lastChild && lastChild.type === "element" && child.tag.matchesElement(lastChild.tag)) {
        if (child.tag.separator) {
            appendChild(lastChild.children, ast.text(child.tag.separator));
        }
        child.children.forEach(function(grandChild) {
            // Mutation is fine since simplifying elements create a copy of the children.
            appendChild(lastChild.children, grandChild);
        });
    } else {
        children.push(child);
    }
}

function removeEmpty(nodes) {
    return flatMap(nodes, function(node) {
        return emptiers[node.type](node);
    });
}

function flatMap(values, func) {
    return _.flatten(_.map(values, func), true);
}

var emptiers = {
    element: elementEmptier,
    text: textEmptier,
    forceWrite: neverEmpty
};

function neverEmpty(node) {
    return [node];
}

function elementEmptier(element) {
    var children = removeEmpty(element.children);
    if (children.length === 0 && !ast.isVoidElement(element)) {
        return [];
    } else {
        return [ast.elementWithTag(element.tag, children)];
    }
}

function textEmptier(node) {
    if (node.value.length === 0) {
        return [];
    } else {
        return [node];
    }
}

module.exports = simplify;

},{"./ast":17,"underscore":102}],20:[function(require,module,exports){
var _ = require("underscore");

var promises = require("./promises");
var Html = require("./html");

exports.imgElement = imgElement;

function imgElement(func) {
    return function(element, messages) {
        return promises.when(func(element)).then(function(result) {
            var attributes = {};
            if (element.altText) {
                attributes.alt = element.altText;
            }
            _.extend(attributes, result);

            return [Html.freshElement("img", attributes)];
        });
    };
}

// Undocumented, but retained for backwards-compatibility with 0.3.x
exports.inline = exports.imgElement;

exports.dataUri = imgElement(function(element) {
    return element.readAsBase64String().then(function(imageBuffer) {
        return {
            src: "data:" + element.contentType + ";base64," + imageBuffer
        };
    });
});

},{"./html":18,"./promises":23,"underscore":102}],21:[function(require,module,exports){
(function (Buffer){
var _ = require("underscore");

var docxReader = require("./docx/docx-reader");
var docxStyleMap = require("./docx/style-map");
var DocumentConverter = require("./document-to-html").DocumentConverter;
var convertElementToRawText = require("./raw-text").convertElementToRawText;
var readStyle = require("./style-reader").readStyle;
var readOptions = require("./options-reader").readOptions;
var unzip = require("./unzip");
var Result = require("./results").Result;

exports.convertToHtml = convertToHtml;
exports.convertToMarkdown = convertToMarkdown;
exports.convert = convert;
exports.extractRawText = extractRawText;
exports.images = require("./images");
exports.transforms = require("./transforms");
exports.underline = require("./underline");
exports.embedStyleMap = embedStyleMap;
exports.readEmbeddedStyleMap = readEmbeddedStyleMap;

function convertToHtml(input, options) {
    return convert(input, options);
}

function convertToMarkdown(input, options) {
    var markdownOptions = Object.create(options || {});
    markdownOptions.outputFormat = "markdown";
    return convert(input, markdownOptions);
}

function convert(input, options) {
    options = readOptions(options);

    return unzip.openZip(input)
        .tap(function(docxFile) {
            return docxStyleMap.readStyleMap(docxFile).then(function(styleMap) {
                options.embeddedStyleMap = styleMap;
            });
        })
        .then(function(docxFile) {
            return docxReader.read(docxFile, input, options)
                .then(function(documentResult) {
                    return documentResult.map(options.transformDocument);
                })
                .then(function(documentResult) {
                    return convertDocumentToHtml(documentResult, options);
                });
        });
}

function readEmbeddedStyleMap(input) {
    return unzip.openZip(input)
        .then(docxStyleMap.readStyleMap);
}

function convertDocumentToHtml(documentResult, options) {
    var styleMapResult = parseStyleMap(options.readStyleMap());
    var parsedOptions = _.extend({}, options, {
        styleMap: styleMapResult.value
    });
    var documentConverter = new DocumentConverter(parsedOptions);

    return documentResult.flatMapThen(function(document) {
        return styleMapResult.flatMapThen(function(styleMap) {
            return documentConverter.convertToHtml(document);
        });
    });
}

function parseStyleMap(styleMap) {
    return Result.combine((styleMap || []).map(readStyle))
        .map(function(styleMap) {
            return styleMap.filter(function(styleMapping) {
                return !!styleMapping;
            });
        });
}


function extractRawText(input) {
    return unzip.openZip(input)
        .then(docxReader.read)
        .then(function(documentResult) {
            return documentResult.map(convertElementToRawText);
        });
}

function embedStyleMap(input, styleMap) {
    return unzip.openZip(input)
        .tap(function(docxFile) {
            return docxStyleMap.writeStyleMap(docxFile, styleMap);
        })
        .then(function(docxFile) {
            return docxFile.toArrayBuffer();
        })
        .then(function(arrayBuffer) {
            return {
                toArrayBuffer: function() {
                    return arrayBuffer;
                },
                toBuffer: function() {
                    return Buffer.from(arrayBuffer);
                }
            };
        });
}

exports.styleMapping = function() {
    throw new Error('Use a raw string instead of mammoth.styleMapping e.g. "p[style-name=\'Title\'] => h1" instead of mammoth.styleMapping("p[style-name=\'Title\'] => h1")');
};

}).call(this,require("buffer").Buffer)
},{"./document-to-html":3,"./docx/docx-reader":9,"./docx/style-map":14,"./images":20,"./options-reader":22,"./raw-text":24,"./results":25,"./style-reader":26,"./transforms":30,"./underline":31,"./unzip":2,"buffer":83,"underscore":102}],22:[function(require,module,exports){
exports.readOptions = readOptions;


var _ = require("underscore");

var defaultStyleMap = exports._defaultStyleMap = [
    "p.Heading1 => h1:fresh",
    "p.Heading2 => h2:fresh",
    "p.Heading3 => h3:fresh",
    "p.Heading4 => h4:fresh",
    "p.Heading5 => h5:fresh",
    "p.Heading6 => h6:fresh",
    "p[style-name='Heading 1'] => h1:fresh",
    "p[style-name='Heading 2'] => h2:fresh",
    "p[style-name='Heading 3'] => h3:fresh",
    "p[style-name='Heading 4'] => h4:fresh",
    "p[style-name='Heading 5'] => h5:fresh",
    "p[style-name='Heading 6'] => h6:fresh",
    "p[style-name='heading 1'] => h1:fresh",
    "p[style-name='heading 2'] => h2:fresh",
    "p[style-name='heading 3'] => h3:fresh",
    "p[style-name='heading 4'] => h4:fresh",
    "p[style-name='heading 5'] => h5:fresh",
    "p[style-name='heading 6'] => h6:fresh",

    // Apple Pages
    "p.Heading => h1:fresh",
    "p[style-name='Heading'] => h1:fresh",

    "r[style-name='Strong'] => strong",

    "p[style-name='footnote text'] => p:fresh",
    "r[style-name='footnote reference'] =>",
    "p[style-name='endnote text'] => p:fresh",
    "r[style-name='endnote reference'] =>",
    "p[style-name='annotation text'] => p:fresh",
    "r[style-name='annotation reference'] =>",

    // LibreOffice
    "p[style-name='Footnote'] => p:fresh",
    "r[style-name='Footnote anchor'] =>",
    "p[style-name='Endnote'] => p:fresh",
    "r[style-name='Endnote anchor'] =>",

    "p:unordered-list(1) => ul > li:fresh",
    "p:unordered-list(2) => ul|ol > li > ul > li:fresh",
    "p:unordered-list(3) => ul|ol > li > ul|ol > li > ul > li:fresh",
    "p:unordered-list(4) => ul|ol > li > ul|ol > li > ul|ol > li > ul > li:fresh",
    "p:unordered-list(5) => ul|ol > li > ul|ol > li > ul|ol > li > ul|ol > li > ul > li:fresh",
    "p:ordered-list(1) => ol > li:fresh",
    "p:ordered-list(2) => ul|ol > li > ol > li:fresh",
    "p:ordered-list(3) => ul|ol > li > ul|ol > li > ol > li:fresh",
    "p:ordered-list(4) => ul|ol > li > ul|ol > li > ul|ol > li > ol > li:fresh",
    "p:ordered-list(5) => ul|ol > li > ul|ol > li > ul|ol > li > ul|ol > li > ol > li:fresh",

    "r[style-name='Hyperlink'] =>",

    "p[style-name='Normal'] => p:fresh",

    // Apple Pages
    "p.Body => p:fresh",
    "p[style-name='Body'] => p:fresh"
];

var standardOptions = exports._standardOptions = {
    externalFileAccess: false,
    transformDocument: identity,
    includeDefaultStyleMap: true,
    includeEmbeddedStyleMap: true
};

function readOptions(options) {
    options = options || {};
    return _.extend({}, standardOptions, options, {
        customStyleMap: readStyleMap(options.styleMap),
        readStyleMap: function() {
            var styleMap = this.customStyleMap;
            if (this.includeEmbeddedStyleMap) {
                styleMap = styleMap.concat(readStyleMap(this.embeddedStyleMap));
            }
            if (this.includeDefaultStyleMap) {
                styleMap = styleMap.concat(defaultStyleMap);
            }
            return styleMap;
        }
    });
}

function readStyleMap(styleMap) {
    if (!styleMap) {
        return [];
    } else if (_.isString(styleMap)) {
        return styleMap.split("\n")
            .map(function(line) {
                return line.trim();
            })
            .filter(function(line) {
                return line !== "" && line.charAt(0) !== "#";
            });
    } else {
        return styleMap;
    }
}

function identity(value) {
    return value;
}

},{"underscore":102}],23:[function(require,module,exports){
var _ = require("underscore");
var bluebird = require("bluebird/js/release/promise")();

exports.defer = defer;
exports.when = bluebird.resolve;
exports.resolve = bluebird.resolve;
exports.all = bluebird.all;
exports.props = bluebird.props;
exports.reject = bluebird.reject;
exports.promisify = bluebird.promisify;
exports.mapSeries = bluebird.mapSeries;
exports.attempt = bluebird.attempt;

exports.nfcall = function(func) {
    var args = Array.prototype.slice.call(arguments, 1);
    var promisedFunc = bluebird.promisify(func);
    return promisedFunc.apply(null, args);
};

bluebird.prototype.fail = bluebird.prototype.caught;

bluebird.prototype.also = function(func) {
    return this.then(function(value) {
        var returnValue = _.extend({}, value, func(value));
        return bluebird.props(returnValue);
    });
};

function defer() {
    var resolve;
    var reject;
    var promise = new bluebird.Promise(function(resolveArg, rejectArg) {
        resolve = resolveArg;
        reject = rejectArg;
    });

    return {
        resolve: resolve,
        reject: reject,
        promise: promise
    };
}

},{"bluebird/js/release/promise":68,"underscore":102}],24:[function(require,module,exports){
var documents = require("./documents");

function convertElementToRawText(element) {
    if (element.type === "text") {
        return element.value;
    } else if (element.type === documents.types.tab) {
        return "\t";
    } else {
        var tail = element.type === "paragraph" ? "\n\n" : "";
        return (element.children || []).map(convertElementToRawText).join("") + tail;
    }
}

exports.convertElementToRawText = convertElementToRawText;

},{"./documents":4}],25:[function(require,module,exports){
var _ = require("underscore");


exports.Result = Result;
exports.success = success;
exports.warning = warning;
exports.error = error;


function Result(value, messages) {
    this.value = value;
    this.messages = messages || [];
}

Result.prototype.map = function(func) {
    return new Result(func(this.value), this.messages);
};

Result.prototype.flatMap = function(func) {
    var funcResult = func(this.value);
    return new Result(funcResult.value, combineMessages([this, funcResult]));
};

Result.prototype.flatMapThen = function(func) {
    var that = this;
    return func(this.value).then(function(otherResult) {
        return new Result(otherResult.value, combineMessages([that, otherResult]));
    });
};

Result.combine = function(results) {
    var values = _.flatten(_.pluck(results, "value"));
    var messages = combineMessages(results);
    return new Result(values, messages);
};

function success(value) {
    return new Result(value, []);
}

function warning(message) {
    return {
        type: "warning",
        message: message
    };
}

function error(exception) {
    return {
        type: "error",
        message: exception.message,
        error: exception
    };
}

function combineMessages(results) {
    var messages = [];
    _.flatten(_.pluck(results, "messages"), true).forEach(function(message) {
        if (!containsMessage(messages, message)) {
            messages.push(message);
        }
    });
    return messages;
}

function containsMessage(messages, message) {
    return _.find(messages, isSameMessage.bind(null, message)) !== undefined;
}

function isSameMessage(first, second) {
    return first.type === second.type && first.message === second.message;
}

},{"underscore":102}],26:[function(require,module,exports){
var _ = require("underscore");
var lop = require("lop");

var documentMatchers = require("./styles/document-matchers");
var htmlPaths = require("./styles/html-paths");
var tokenise = require("./styles/parser/tokeniser").tokenise;
var results = require("./results");

exports.readHtmlPath = readHtmlPath;
exports.readDocumentMatcher = readDocumentMatcher;
exports.readStyle = readStyle;


function readStyle(string) {
    return parseString(styleRule, string);
}

function createStyleRule() {
    return lop.rules.sequence(
        lop.rules.sequence.capture(documentMatcherRule()),
        lop.rules.tokenOfType("whitespace"),
        lop.rules.tokenOfType("arrow"),
        lop.rules.sequence.capture(lop.rules.optional(lop.rules.sequence(
            lop.rules.tokenOfType("whitespace"),
            lop.rules.sequence.capture(htmlPathRule())
        ).head())),
        lop.rules.tokenOfType("end")
    ).map(function(documentMatcher, htmlPath) {
        return {
            from: documentMatcher,
            to: htmlPath.valueOrElse(htmlPaths.empty)
        };
    });
}

function readDocumentMatcher(string) {
    return parseString(documentMatcherRule(), string);
}

function documentMatcherRule() {
    var sequence = lop.rules.sequence;

    var identifierToConstant = function(identifier, constant) {
        return lop.rules.then(
            lop.rules.token("identifier", identifier),
            function() {
                return constant;
            }
        );
    };

    var paragraphRule = identifierToConstant("p", documentMatchers.paragraph);
    var runRule = identifierToConstant("r", documentMatchers.run);

    var elementTypeRule = lop.rules.firstOf("p or r or table",
        paragraphRule,
        runRule
    );

    var styleIdRule = lop.rules.sequence(
        lop.rules.tokenOfType("dot"),
        lop.rules.sequence.cut(),
        lop.rules.sequence.capture(identifierRule)
    ).map(function(styleId) {
        return {styleId: styleId};
    });

    var styleNameMatcherRule = lop.rules.firstOf("style name matcher",
        lop.rules.then(
            lop.rules.sequence(
                lop.rules.tokenOfType("equals"),
                lop.rules.sequence.cut(),
                lop.rules.sequence.capture(stringRule)
            ).head(),
            function(styleName) {
                return {styleName: documentMatchers.equalTo(styleName)};
            }
        ),
        lop.rules.then(
            lop.rules.sequence(
                lop.rules.tokenOfType("startsWith"),
                lop.rules.sequence.cut(),
                lop.rules.sequence.capture(stringRule)
            ).head(),
            function(styleName) {
                return {styleName: documentMatchers.startsWith(styleName)};
            }
        )
    );

    var styleNameRule = lop.rules.sequence(
        lop.rules.tokenOfType("open-square-bracket"),
        lop.rules.sequence.cut(),
        lop.rules.token("identifier", "style-name"),
        lop.rules.sequence.capture(styleNameMatcherRule),
        lop.rules.tokenOfType("close-square-bracket")
    ).head();


    var listTypeRule = lop.rules.firstOf("list type",
        identifierToConstant("ordered-list", {isOrdered: true}),
        identifierToConstant("unordered-list", {isOrdered: false})
    );
    var listRule = sequence(
        lop.rules.tokenOfType("colon"),
        sequence.capture(listTypeRule),
        sequence.cut(),
        lop.rules.tokenOfType("open-paren"),
        sequence.capture(integerRule),
        lop.rules.tokenOfType("close-paren")
    ).map(function(listType, levelNumber) {
        return {
            list: {
                isOrdered: listType.isOrdered,
                levelIndex: levelNumber - 1
            }
        };
    });

    function createMatcherSuffixesRule(rules) {
        var matcherSuffix = lop.rules.firstOf.apply(
            lop.rules.firstOf,
            ["matcher suffix"].concat(rules)
        );
        var matcherSuffixes = lop.rules.zeroOrMore(matcherSuffix);
        return lop.rules.then(matcherSuffixes, function(suffixes) {
            var matcherOptions = {};
            suffixes.forEach(function(suffix) {
                _.extend(matcherOptions, suffix);
            });
            return matcherOptions;
        });
    }

    var paragraphOrRun = sequence(
        sequence.capture(elementTypeRule),
        sequence.capture(createMatcherSuffixesRule([
            styleIdRule,
            styleNameRule,
            listRule
        ]))
    ).map(function(createMatcher, matcherOptions) {
        return createMatcher(matcherOptions);
    });

    var table = sequence(
        lop.rules.token("identifier", "table"),
        sequence.capture(createMatcherSuffixesRule([
            styleIdRule,
            styleNameRule
        ]))
    ).map(function(options) {
        return documentMatchers.table(options);
    });

    var bold = identifierToConstant("b", documentMatchers.bold);
    var italic = identifierToConstant("i", documentMatchers.italic);
    var underline = identifierToConstant("u", documentMatchers.underline);
    var strikethrough = identifierToConstant("strike", documentMatchers.strikethrough);
    var allCaps = identifierToConstant("all-caps", documentMatchers.allCaps);
    var smallCaps = identifierToConstant("small-caps", documentMatchers.smallCaps);

    var highlight = sequence(
        lop.rules.token("identifier", "highlight"),
        lop.rules.sequence.capture(lop.rules.optional(lop.rules.sequence(
            lop.rules.tokenOfType("open-square-bracket"),
            lop.rules.sequence.cut(),
            lop.rules.token("identifier", "color"),
            lop.rules.tokenOfType("equals"),
            lop.rules.sequence.capture(stringRule),
            lop.rules.tokenOfType("close-square-bracket")
        ).head()))
    ).map(function(color) {
        return documentMatchers.highlight({
            color: color.valueOrElse(undefined)
        });
    });

    var commentReference = identifierToConstant("comment-reference", documentMatchers.commentReference);

    var breakMatcher = sequence(
        lop.rules.token("identifier", "br"),
        sequence.cut(),
        lop.rules.tokenOfType("open-square-bracket"),
        lop.rules.token("identifier", "type"),
        lop.rules.tokenOfType("equals"),
        sequence.capture(stringRule),
        lop.rules.tokenOfType("close-square-bracket")
    ).map(function(breakType) {
        switch (breakType) {
        case "line":
            return documentMatchers.lineBreak;
        case "page":
            return documentMatchers.pageBreak;
        case "column":
            return documentMatchers.columnBreak;
        default:
            // TODO: handle unknown document matchers
        }
    });

    return lop.rules.firstOf("element type",
        paragraphOrRun,
        table,
        bold,
        italic,
        underline,
        strikethrough,
        allCaps,
        smallCaps,
        highlight,
        commentReference,
        breakMatcher
    );
}

function readHtmlPath(string) {
    return parseString(htmlPathRule(), string);
}

function htmlPathRule() {
    var capture = lop.rules.sequence.capture;
    var whitespaceRule = lop.rules.tokenOfType("whitespace");
    var freshRule = lop.rules.then(
        lop.rules.optional(lop.rules.sequence(
            lop.rules.tokenOfType("colon"),
            lop.rules.token("identifier", "fresh")
        )),
        function(option) {
            return option.map(function() {
                return true;
            }).valueOrElse(false);
        }
    );

    var separatorRule = lop.rules.then(
        lop.rules.optional(lop.rules.sequence(
            lop.rules.tokenOfType("colon"),
            lop.rules.token("identifier", "separator"),
            lop.rules.tokenOfType("open-paren"),
            capture(stringRule),
            lop.rules.tokenOfType("close-paren")
        ).head()),
        function(option) {
            return option.valueOrElse("");
        }
    );

    var tagNamesRule = lop.rules.oneOrMoreWithSeparator(
        identifierRule,
        lop.rules.tokenOfType("choice")
    );

    var styleElementRule = lop.rules.sequence(
        capture(tagNamesRule),
        capture(lop.rules.zeroOrMore(attributeOrClassRule)),
        capture(freshRule),
        capture(separatorRule)
    ).map(function(tagName, attributesList, fresh, separator) {
        var attributes = {};
        var options = {};
        attributesList.forEach(function(attribute) {
            if (attribute.append && attributes[attribute.name]) {
                attributes[attribute.name] += " " + attribute.value;
            } else {
                attributes[attribute.name] = attribute.value;
            }
        });
        if (fresh) {
            options.fresh = true;
        }
        if (separator) {
            options.separator = separator;
        }
        return htmlPaths.element(tagName, attributes, options);
    });

    return lop.rules.firstOf("html path",
        lop.rules.then(lop.rules.tokenOfType("bang"), function() {
            return htmlPaths.ignore;
        }),
        lop.rules.then(
            lop.rules.zeroOrMoreWithSeparator(
                styleElementRule,
                lop.rules.sequence(
                    whitespaceRule,
                    lop.rules.tokenOfType("gt"),
                    whitespaceRule
                )
            ),
            htmlPaths.elements
        )
    );
}

var identifierRule = lop.rules.then(
    lop.rules.tokenOfType("identifier"),
    decodeEscapeSequences
);
var integerRule = lop.rules.tokenOfType("integer");

var stringRule = lop.rules.then(
    lop.rules.tokenOfType("string"),
    decodeEscapeSequences
);

var escapeSequences = {
    "n": "\n",
    "r": "\r",
    "t": "\t"
};

function decodeEscapeSequences(value) {
    return value.replace(/\\(.)/g, function(match, code) {
        return escapeSequences[code] || code;
    });
}

var attributeRule = lop.rules.sequence(
    lop.rules.tokenOfType("open-square-bracket"),
    lop.rules.sequence.cut(),
    lop.rules.sequence.capture(identifierRule),
    lop.rules.tokenOfType("equals"),
    lop.rules.sequence.capture(stringRule),
    lop.rules.tokenOfType("close-square-bracket")
).map(function(name, value) {
    return {name: name, value: value, append: false};
});

var classRule = lop.rules.sequence(
    lop.rules.tokenOfType("dot"),
    lop.rules.sequence.cut(),
    lop.rules.sequence.capture(identifierRule)
).map(function(className) {
    return {name: "class", value: className, append: true};
});

var attributeOrClassRule = lop.rules.firstOf(
    "attribute or class",
    attributeRule,
    classRule
);

function parseString(rule, string) {
    var tokens = tokenise(string);
    var parser = lop.Parser();
    var parseResult = parser.parseTokens(rule, tokens);
    if (parseResult.isSuccess()) {
        return results.success(parseResult.value());
    } else {
        return new results.Result(null, [results.warning(describeFailure(string, parseResult))]);
    }
}

function describeFailure(input, parseResult) {
    return "Did not understand this style mapping, so ignored it: " + input + "\n" +
        parseResult.errors().map(describeError).join("\n");
}

function describeError(error) {
    return "Error was at character number " + error.characterNumber() + ": " +
        "Expected " + error.expected + " but got " + error.actual;
}

var styleRule = createStyleRule();

},{"./results":25,"./styles/document-matchers":27,"./styles/html-paths":28,"./styles/parser/tokeniser":29,"lop":89,"underscore":102}],27:[function(require,module,exports){
exports.paragraph = paragraph;
exports.run = run;
exports.table = table;
exports.bold = new Matcher("bold");
exports.italic = new Matcher("italic");
exports.underline = new Matcher("underline");
exports.strikethrough = new Matcher("strikethrough");
exports.allCaps = new Matcher("allCaps");
exports.smallCaps = new Matcher("smallCaps");
exports.highlight = highlight;
exports.commentReference = new Matcher("commentReference");
exports.lineBreak = new BreakMatcher({breakType: "line"});
exports.pageBreak = new BreakMatcher({breakType: "page"});
exports.columnBreak = new BreakMatcher({breakType: "column"});
exports.equalTo = equalTo;
exports.startsWith = startsWith;


function paragraph(options) {
    return new Matcher("paragraph", options);
}

function run(options) {
    return new Matcher("run", options);
}

function table(options) {
    return new Matcher("table", options);
}

function highlight(options) {
    return new HighlightMatcher(options);
}

function Matcher(elementType, options) {
    options = options || {};
    this._elementType = elementType;
    this._styleId = options.styleId;
    this._styleName = options.styleName;
    if (options.list) {
        this._listIndex = options.list.levelIndex;
        this._listIsOrdered = options.list.isOrdered;
    }
}

Matcher.prototype.matches = function(element) {
    return element.type === this._elementType &&
        (this._styleId === undefined || element.styleId === this._styleId) &&
        (this._styleName === undefined || (element.styleName && this._styleName.operator(this._styleName.operand, element.styleName))) &&
        (this._listIndex === undefined || isList(element, this._listIndex, this._listIsOrdered)) &&
        (this._breakType === undefined || this._breakType === element.breakType);
};

function HighlightMatcher(options) {
    options = options || {};
    this._color = options.color;
}

HighlightMatcher.prototype.matches = function(element) {
    return element.type === "highlight" &&
        (this._color === undefined || element.color === this._color);
};

function BreakMatcher(options) {
    options = options || {};
    this._breakType = options.breakType;
}

BreakMatcher.prototype.matches = function(element) {
    return element.type === "break" &&
        (this._breakType === undefined || element.breakType === this._breakType);
};

function isList(element, levelIndex, isOrdered) {
    return element.numbering &&
        element.numbering.level == levelIndex &&
        element.numbering.isOrdered == isOrdered;
}

function equalTo(value) {
    return {
        operator: operatorEqualTo,
        operand: value
    };
}

function startsWith(value) {
    return {
        operator: operatorStartsWith,
        operand: value
    };
}

function operatorEqualTo(first, second) {
    return first.toUpperCase() === second.toUpperCase();
}

function operatorStartsWith(first, second) {
    return second.toUpperCase().indexOf(first.toUpperCase()) === 0;
}

},{}],28:[function(require,module,exports){
var _ = require("underscore");

var html = require("../html");

exports.topLevelElement = topLevelElement;
exports.elements = elements;
exports.element = element;

function topLevelElement(tagName, attributes) {
    return elements([element(tagName, attributes, {fresh: true})]);
}

function elements(elementStyles) {
    return new HtmlPath(elementStyles.map(function(elementStyle) {
        if (_.isString(elementStyle)) {
            return element(elementStyle);
        } else {
            return elementStyle;
        }
    }));
}

function HtmlPath(elements) {
    this._elements = elements;
}

HtmlPath.prototype.wrap = function wrap(children) {
    var result = children();
    for (var index = this._elements.length - 1; index >= 0; index--) {
        result = this._elements[index].wrapNodes(result);
    }
    return result;
};

function element(tagName, attributes, options) {
    options = options || {};
    return new Element(tagName, attributes, options);
}

function Element(tagName, attributes, options) {
    var tagNames = {};
    if (_.isArray(tagName)) {
        tagName.forEach(function(tagName) {
            tagNames[tagName] = true;
        });
        tagName = tagName[0];
    } else {
        tagNames[tagName] = true;
    }
    
    this.tagName = tagName;
    this.tagNames = tagNames;
    this.attributes = attributes || {};
    this.fresh = options.fresh;
    this.separator = options.separator;
}

Element.prototype.matchesElement = function(element) {
    return this.tagNames[element.tagName] && _.isEqual(this.attributes || {}, element.attributes || {});
};

Element.prototype.wrap = function wrap(generateNodes) {
    return this.wrapNodes(generateNodes());
};

Element.prototype.wrapNodes = function wrapNodes(nodes) {
    return [html.elementWithTag(this, nodes)];
};

exports.empty = elements([]);
exports.ignore = {
    wrap: function() {
        return [];
    }
};

},{"../html":18,"underscore":102}],29:[function(require,module,exports){
var lop = require("lop");
var RegexTokeniser = lop.RegexTokeniser;

exports.tokenise = tokenise;

var stringPrefix = "'((?:\\\\.|[^'])*)";

function tokenise(string) {
    var identifierCharacter = "(?:[a-zA-Z\\-_]|\\\\.)";
    var tokeniser = new RegexTokeniser([
        {name: "identifier", regex: new RegExp("(" + identifierCharacter + "(?:" + identifierCharacter + "|[0-9])*)")},
        {name: "dot", regex: /\./},
        {name: "colon", regex: /:/},
        {name: "gt", regex: />/},
        {name: "whitespace", regex: /\s+/},
        {name: "arrow", regex: /=>/},
        {name: "equals", regex: /=/},
        {name: "startsWith", regex: /\^=/},
        {name: "open-paren", regex: /\(/},
        {name: "close-paren", regex: /\)/},
        {name: "open-square-bracket", regex: /\[/},
        {name: "close-square-bracket", regex: /\]/},
        {name: "string", regex: new RegExp(stringPrefix + "'")},
        {name: "unterminated-string", regex: new RegExp(stringPrefix)},
        {name: "integer", regex: /([0-9]+)/},
        {name: "choice", regex: /\|/},
        {name: "bang", regex: /(!)/}
    ]);
    return tokeniser.tokenise(string);
}

},{"lop":89}],30:[function(require,module,exports){
var _ = require("underscore");

exports.paragraph = paragraph;
exports.run = run;
exports._elements = elements;
exports._elementsOfType = elementsOfType;
exports.getDescendantsOfType = getDescendantsOfType;
exports.getDescendants = getDescendants;

function paragraph(transform) {
    return elementsOfType("paragraph", transform);
}

function run(transform) {
    return elementsOfType("run", transform);
}

function elementsOfType(elementType, transform) {
    return elements(function(element) {
        if (element.type === elementType) {
            return transform(element);
        } else {
            return element;
        }
    });
}

function elements(transform) {
    return function transformElement(element) {
        if (element.children) {
            var children = _.map(element.children, transformElement);
            element = _.extend(element, {children: children});
        }
        return transform(element);
    };
}


function getDescendantsOfType(element, type) {
    return getDescendants(element).filter(function(descendant) {
        return descendant.type === type;
    });
}

function getDescendants(element) {
    var descendants = [];

    visitDescendants(element, function(descendant) {
        descendants.push(descendant);
    });

    return descendants;
}

function visitDescendants(element, visit) {
    if (element.children) {
        element.children.forEach(function(child) {
            visitDescendants(child, visit);
            visit(child);
        });
    }
}

},{"underscore":102}],31:[function(require,module,exports){
var htmlPaths = require("./styles/html-paths");
var Html = require("./html");


exports.element = element;

function element(name) {
    return function(html) {
        return Html.elementWithTag(htmlPaths.element(name), [html]);
    };
}

},{"./html":18,"./styles/html-paths":28}],32:[function(require,module,exports){
var _ = require("underscore");

exports.writer = writer;

function writer(options) {
    options = options || {};
    if (options.prettyPrint) {
        return prettyWriter();
    } else {
        return simpleWriter();
    }
}


var indentedElements = {
    div: true,
    p: true,
    ul: true,
    li: true
};


function prettyWriter() {
    var indentationLevel = 0;
    var indentation = "  ";
    var stack = [];
    var start = true;
    var inText = false;

    var writer = simpleWriter();

    function open(tagName, attributes) {
        if (indentedElements[tagName]) {
            indent();
        }
        stack.push(tagName);
        writer.open(tagName, attributes);
        if (indentedElements[tagName]) {
            indentationLevel++;
        }
        start = false;
    }

    function close(tagName) {
        if (indentedElements[tagName]) {
            indentationLevel--;
            indent();
        }
        stack.pop();
        writer.close(tagName);
    }

    function text(value) {
        startText();
        var text = isInPre() ? value : value.replace("\n", "\n" + indentation);
        writer.text(text);
    }

    function selfClosing(tagName, attributes) {
        indent();
        writer.selfClosing(tagName, attributes);
    }

    function insideIndentedElement() {
        return stack.length === 0 || indentedElements[stack[stack.length - 1]];
    }

    function startText() {
        if (!inText) {
            indent();
            inText = true;
        }
    }

    function indent() {
        inText = false;
        if (!start && insideIndentedElement() && !isInPre()) {
            writer._append("\n");
            for (var i = 0; i < indentationLevel; i++) {
                writer._append(indentation);
            }
        }
    }

    function isInPre() {
        return _.some(stack, function(tagName) {
            return tagName === "pre";
        });
    }

    return {
        asString: writer.asString,
        open: open,
        close: close,
        text: text,
        selfClosing: selfClosing
    };
}


function simpleWriter() {
    var fragments = [];

    function open(tagName, attributes) {
        var attributeString = generateAttributeString(attributes);
        fragments.push("<" + tagName + attributeString + ">");
    }

    function close(tagName) {
        fragments.push("</" + tagName + ">");
    }

    function selfClosing(tagName, attributes) {
        var attributeString = generateAttributeString(attributes);
        fragments.push("<" + tagName + attributeString + " />");
    }

    function generateAttributeString(attributes) {
        return _.map(attributes, function(value, key) {
            return " " + key + '="' + escapeHtmlAttribute(value) + '"';
        }).join("");
    }

    function text(value) {
        fragments.push(escapeHtmlText(value));
    }

    function append(html) {
        fragments.push(html);
    }

    function asString() {
        return fragments.join("");
    }

    return {
        asString: asString,
        open: open,
        close: close,
        text: text,
        selfClosing: selfClosing,
        _append: append
    };
}

function escapeHtmlText(value) {
    return value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

function escapeHtmlAttribute(value) {
    return value
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

},{"underscore":102}],33:[function(require,module,exports){
var htmlWriter = require("./html-writer");
var markdownWriter = require("./markdown-writer");

exports.writer = writer;


function writer(options) {
    options = options || {};
    if (options.outputFormat === "markdown") {
        return markdownWriter.writer();
    } else {
        return htmlWriter.writer(options);
    }
}

},{"./html-writer":32,"./markdown-writer":34}],34:[function(require,module,exports){
var _ = require("underscore");


function symmetricMarkdownElement(end) {
    return markdownElement(end, end);
}

function markdownElement(start, end) {
    return function() {
        return {start: start, end: end};
    };
}

function markdownLink(attributes) {
    var href = attributes.href || "";
    if (href) {
        return {
            start: "[",
            end: "](" + href + ")",
            anchorPosition: "before"
        };
    } else {
        return {};
    }
}

function markdownImage(attributes) {
    var src = attributes.src || "";
    var altText = attributes.alt || "";
    if (src || altText) {
        return {start: "![" + altText + "](" + src + ")"};
    } else {
        return {};
    }
}

function markdownList(options) {
    return function(attributes, list) {
        return {
            start: list ? "\n" : "",
            end: list ? "" : "\n",
            list: {
                isOrdered: options.isOrdered,
                indent: list ? list.indent + 1 : 0,
                count: 0
            }
        };
    };
}

function markdownListItem(attributes, list, listItem) {
    list = list || {indent: 0, isOrdered: false, count: 0};
    list.count++;
    listItem.hasClosed = false;
    
    var bullet = list.isOrdered ? list.count + "." : "-";
    var start = repeatString("\t", list.indent) + bullet + " ";
        
    return {
        start: start,
        end: function() {
            if (!listItem.hasClosed) {
                listItem.hasClosed = true;
                return "\n";
            }
        }
    };
}

var htmlToMarkdown = {
    "p": markdownElement("", "\n\n"),
    "br": markdownElement("", "  \n"),
    "ul": markdownList({isOrdered: false}),
    "ol": markdownList({isOrdered: true}),
    "li": markdownListItem,
    "strong": symmetricMarkdownElement("__"),
    "em": symmetricMarkdownElement("*"),
    "a": markdownLink,
    "img": markdownImage
};

(function() {
    for (var i = 1; i <= 6; i++) {
        htmlToMarkdown["h" + i] = markdownElement(repeatString("#", i) + " ", "\n\n");
    }
})();

function repeatString(value, count) {
    return new Array(count + 1).join(value);
}

function markdownWriter() {
    var fragments = [];
    var elementStack = [];
    var list = null;
    var listItem = {};
    
    function open(tagName, attributes) {
        attributes = attributes || {};
        
        var createElement = htmlToMarkdown[tagName] || function() {
            return {};
        };
        var element = createElement(attributes, list, listItem);
        elementStack.push({end: element.end, list: list});
        
        if (element.list) {
            list = element.list;
        }
        
        var anchorBeforeStart = element.anchorPosition === "before";
        if (anchorBeforeStart) {
            writeAnchor(attributes);
        }

        fragments.push(element.start || "");
        if (!anchorBeforeStart) {
            writeAnchor(attributes);
        }
    }
    
    function writeAnchor(attributes) {
        if (attributes.id) {
            fragments.push('<a id="' + attributes.id + '"></a>');
        }
    }
    
    function close(tagName) {
        var element = elementStack.pop();
        list = element.list;
        var end = _.isFunction(element.end) ? element.end() : element.end;
        fragments.push(end || "");
    }
    
    function selfClosing(tagName, attributes) {
        open(tagName, attributes);
        close(tagName);
    }
    
    function text(value) {
        fragments.push(escapeMarkdown(value));
    }
    
    function asString() {
        return fragments.join("");
    }

    return {
        asString: asString,
        open: open,
        close: close,
        text: text,
        selfClosing: selfClosing
    };
}

exports.writer = markdownWriter;

function escapeMarkdown(value) {
    return value
        .replace(/\\/g, '\\\\')
        .replace(/([\`\*_\{\}\[\]\(\)\#\+\-\.\!])/g, '\\$1');
}

},{"underscore":102}],35:[function(require,module,exports){
var nodes = require("./nodes");

exports.Element = nodes.Element;
exports.element = nodes.element;
exports.emptyElement = nodes.emptyElement;
exports.text = nodes.text;
exports.readString = require("./reader").readString;
exports.writeString = require("./writer").writeString;

},{"./nodes":36,"./reader":37,"./writer":38}],36:[function(require,module,exports){
var _ = require("underscore");


exports.Element = Element;
exports.element = function(name, attributes, children) {
    return new Element(name, attributes, children);
};
exports.text = function(value) {
    return {
        type: "text",
        value: value
    };
};


var emptyElement = exports.emptyElement = {
    first: function() {
        return null;
    },
    firstOrEmpty: function() {
        return emptyElement;
    },
    attributes: {},
    children: []
};

function Element(name, attributes, children) {
    this.type = "element";
    this.name = name;
    this.attributes = attributes || {};
    this.children = children || [];
}

Element.prototype.first = function(name) {
    return _.find(this.children, function(child) {
        return child.name === name;
    });
};

Element.prototype.firstOrEmpty = function(name) {
    return this.first(name) || emptyElement;
};

Element.prototype.getElementsByTagName = function(name) {
    var elements = _.filter(this.children, function(child) {
        return child.name === name;
    });
    return toElementList(elements);
};

Element.prototype.text = function() {
    if (this.children.length === 0) {
        return "";
    } else if (this.children.length !== 1 || this.children[0].type !== "text") {
        throw new Error("Not implemented");
    }
    return this.children[0].value;
};

var elementListPrototype = {
    getElementsByTagName: function(name) {
        return toElementList(_.flatten(this.map(function(element) {
            return element.getElementsByTagName(name);
        }, true)));
    }
};

function toElementList(array) {
    return _.extend(array, elementListPrototype);
}

},{"underscore":102}],37:[function(require,module,exports){
var promises = require("../promises");
var _ = require("underscore");

var xmldom = require("./xmldom");
var nodes = require("./nodes");
var Element = nodes.Element;

exports.readString = readString;

var Node = xmldom.Node;

function readString(xmlString, namespaceMap) {
    namespaceMap = namespaceMap || {};

    try {
        var document = xmldom.parseFromString(xmlString, "text/xml");
    } catch (error) {
        return promises.reject(error);
    }

    if (document.documentElement.tagName === "parsererror") {
        return promises.resolve(new Error(document.documentElement.textContent));
    }

    function convertNode(node) {
        switch (node.nodeType) {
        case Node.ELEMENT_NODE:
            return convertElement(node);
        case Node.TEXT_NODE:
            return nodes.text(node.nodeValue);
        }
    }

    function convertElement(element) {
        var convertedName = convertName(element);

        var convertedChildren = [];
        _.forEach(element.childNodes, function(childNode) {
            var convertedNode = convertNode(childNode);
            if (convertedNode) {
                convertedChildren.push(convertedNode);
            }
        });

        var convertedAttributes = {};
        _.forEach(element.attributes, function(attribute) {
            convertedAttributes[convertName(attribute)] = attribute.value;
        });

        return new Element(convertedName, convertedAttributes, convertedChildren);
    }

    function convertName(node) {
        if (node.namespaceURI) {
            var mappedPrefix = namespaceMap[node.namespaceURI];
            var prefix;
            if (mappedPrefix) {
                prefix = mappedPrefix + ":";
            } else {
                prefix = "{" + node.namespaceURI + "}";
            }
            return prefix + node.localName;
        } else {
            return node.localName;
        }
    }

    return promises.resolve(convertNode(document.documentElement));
}

},{"../promises":23,"./nodes":36,"./xmldom":39,"underscore":102}],38:[function(require,module,exports){
var _ = require("underscore");
var xmlbuilder = require("xmlbuilder");


exports.writeString = writeString;


function writeString(root, namespaces) {
    var uriToPrefix = _.invert(namespaces);
    
    var nodeWriters = {
        element: writeElement,
        text: writeTextNode
    };

    function writeNode(builder, node) {
        return nodeWriters[node.type](builder, node);
    }

    function writeElement(builder, element) {
        var elementBuilder = builder.element(mapElementName(element.name), element.attributes);
        element.children.forEach(function(child) {
            writeNode(elementBuilder, child);
        });
    }
    
    function mapElementName(name) {
        var longFormMatch = /^\{(.*)\}(.*)$/.exec(name);
        if (longFormMatch) {
            var prefix = uriToPrefix[longFormMatch[1]];
            return prefix + (prefix === "" ? "" : ":") + longFormMatch[2];
        } else {
            return name;
        }
    }
    
    function writeDocument(root) {
        var builder = xmlbuilder
            .create(mapElementName(root.name), {
                version: '1.0',
                encoding: 'UTF-8',
                standalone: true
            });
        
        _.forEach(namespaces, function(uri, prefix) {
            var key = "xmlns" + (prefix === "" ? "" : ":" + prefix);
            builder.attribute(key, uri);
        });
        
        root.children.forEach(function(child) {
            writeNode(builder, child);
        });
        return builder.end();
    }

    return writeDocument(root);
}

function writeTextNode(builder, node) {
    builder.text(node.value);
}

},{"underscore":102,"xmlbuilder":124}],39:[function(require,module,exports){
var xmldom = require("@xmldom/xmldom");
var dom = require("@xmldom/xmldom/lib/dom");

function parseFromString(string) {
    var error = null;

    var domParser = new xmldom.DOMParser({
        errorHandler: function(level, message) {
            error = {level: level, message: message};
        }
    });

    var document = domParser.parseFromString(string);

    if (error === null) {
        return document;
    } else {
        throw new Error(error.level + ": " + error.message);
    }
}

exports.parseFromString = parseFromString;
exports.Node = dom.Node;

},{"@xmldom/xmldom":45,"@xmldom/xmldom/lib/dom":43}],40:[function(require,module,exports){
var base64js = require("base64-js");
var JSZip = require("jszip");

exports.openArrayBuffer = openArrayBuffer;
exports.splitPath = splitPath;
exports.joinPath = joinPath;

function openArrayBuffer(arrayBuffer) {
    return JSZip.loadAsync(arrayBuffer).then(function(zipFile) {
        function exists(name) {
            return zipFile.file(name) !== null;
        }

        function read(name, encoding) {
            return zipFile.file(name).async("uint8array").then(function(array) {
                if (encoding === "base64") {
                    return base64js.fromByteArray(array);
                } else if (encoding) {
                    var decoder = new TextDecoder(encoding);
                    return decoder.decode(array);
                } else {
                    return array;
                }
            });
        }

        function write(name, contents) {
            zipFile.file(name, contents);
        }

        function toArrayBuffer() {
            return zipFile.generateAsync({type: "arraybuffer"});
        }

        return {
            exists: exists,
            read: read,
            write: write,
            toArrayBuffer: toArrayBuffer
        };
    });
}

function splitPath(path) {
    var lastIndex = path.lastIndexOf("/");
    if (lastIndex === -1) {
        return {dirname: "", basename: path};
    } else {
        return {
            dirname: path.substring(0, lastIndex),
            basename: path.substring(lastIndex + 1)
        };
    }
}

function joinPath() {
    var nonEmptyPaths = Array.prototype.filter.call(arguments, function(path) {
        return path;
    });

    var relevantPaths = [];

    nonEmptyPaths.forEach(function(path) {
        if (/^\//.test(path)) {
            relevantPaths = [path];
        } else {
            relevantPaths.push(path);
        }
    });

    return relevantPaths.join("/");
}

},{"base64-js":47,"jszip":88}],41:[function(require,module,exports){
'use strict'

/**
 * Ponyfill for `Array.prototype.find` which is only available in ES6 runtimes.
 *
 * Works with anything that has a `length` property and index access properties, including NodeList.
 *
 * @template {unknown} T
 * @param {Array<T> | ({length:number, [number]: T})} list
 * @param {function (item: T, index: number, list:Array<T> | ({length:number, [number]: T})):boolean} predicate
 * @param {Partial<Pick<ArrayConstructor['prototype'], 'find'>>?} ac `Array.prototype` by default,
 * 				allows injecting a custom implementation in tests
 * @returns {T | undefined}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
 * @see https://tc39.es/ecma262/multipage/indexed-collections.html#sec-array.prototype.find
 */
function find(list, predicate, ac) {
	if (ac === undefined) {
		ac = Array.prototype;
	}
	if (list && typeof ac.find === 'function') {
		return ac.find.call(list, predicate);
	}
	for (var i = 0; i < list.length; i++) {
		if (Object.prototype.hasOwnProperty.call(list, i)) {
			var item = list[i];
			if (predicate.call(undefined, item, i, list)) {
				return item;
			}
		}
	}
}

/**
 * "Shallow freezes" an object to render it immutable.
 * Uses `Object.freeze` if available,
 * otherwise the immutability is only in the type.
 *
 * Is used to create "enum like" objects.
 *
 * @template T
 * @param {T} object the object to freeze
 * @param {Pick<ObjectConstructor, 'freeze'> = Object} oc `Object` by default,
 * 				allows to inject custom object constructor for tests
 * @returns {Readonly<T>}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
 */
function freeze(object, oc) {
	if (oc === undefined) {
		oc = Object
	}
	return oc && typeof oc.freeze === 'function' ? oc.freeze(object) : object
}

/**
 * Since we can not rely on `Object.assign` we provide a simplified version
 * that is sufficient for our needs.
 *
 * @param {Object} target
 * @param {Object | null | undefined} source
 *
 * @returns {Object} target
 * @throws TypeError if target is not an object
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 * @see https://tc39.es/ecma262/multipage/fundamental-objects.html#sec-object.assign
 */
function assign(target, source) {
	if (target === null || typeof target !== 'object') {
		throw new TypeError('target is not an object')
	}
	for (var key in source) {
		if (Object.prototype.hasOwnProperty.call(source, key)) {
			target[key] = source[key]
		}
	}
	return target
}

/**
 * All mime types that are allowed as input to `DOMParser.parseFromString`
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString#Argument02 MDN
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#domparsersupportedtype WHATWG HTML Spec
 * @see DOMParser.prototype.parseFromString
 */
var MIME_TYPE = freeze({
	/**
	 * `text/html`, the only mime type that triggers treating an XML document as HTML.
	 *
	 * @see DOMParser.SupportedType.isHTML
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
	 */
	HTML: 'text/html',

	/**
	 * Helper method to check a mime type if it indicates an HTML document
	 *
	 * @param {string} [value]
	 * @returns {boolean}
	 *
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */
	isHTML: function (value) {
		return value === MIME_TYPE.HTML
	},

	/**
	 * `application/xml`, the standard mime type for XML documents.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
	 * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */
	XML_APPLICATION: 'application/xml',

	/**
	 * `text/html`, an alias for `application/xml`.
	 *
	 * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
	 * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */
	XML_TEXT: 'text/xml',

	/**
	 * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
	 * but is parsed as an XML document.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
	 * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
	 */
	XML_XHTML_APPLICATION: 'application/xhtml+xml',

	/**
	 * `image/svg+xml`,
	 *
	 * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
	 * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
	 * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
	 */
	XML_SVG_IMAGE: 'image/svg+xml',
})

/**
 * Namespaces that are used in this code base.
 *
 * @see http://www.w3.org/TR/REC-xml-names
 */
var NAMESPACE = freeze({
	/**
	 * The XHTML namespace.
	 *
	 * @see http://www.w3.org/1999/xhtml
	 */
	HTML: 'http://www.w3.org/1999/xhtml',

	/**
	 * Checks if `uri` equals `NAMESPACE.HTML`.
	 *
	 * @param {string} [uri]
	 *
	 * @see NAMESPACE.HTML
	 */
	isHTML: function (uri) {
		return uri === NAMESPACE.HTML
	},

	/**
	 * The SVG namespace.
	 *
	 * @see http://www.w3.org/2000/svg
	 */
	SVG: 'http://www.w3.org/2000/svg',

	/**
	 * The `xml:` namespace.
	 *
	 * @see http://www.w3.org/XML/1998/namespace
	 */
	XML: 'http://www.w3.org/XML/1998/namespace',

	/**
	 * The `xmlns:` namespace
	 *
	 * @see https://www.w3.org/2000/xmlns/
	 */
	XMLNS: 'http://www.w3.org/2000/xmlns/',
})

exports.assign = assign;
exports.find = find;
exports.freeze = freeze;
exports.MIME_TYPE = MIME_TYPE;
exports.NAMESPACE = NAMESPACE;

},{}],42:[function(require,module,exports){
var conventions = require("./conventions");
var dom = require('./dom')
var entities = require('./entities');
var sax = require('./sax');

var DOMImplementation = dom.DOMImplementation;

var NAMESPACE = conventions.NAMESPACE;

var ParseError = sax.ParseError;
var XMLReader = sax.XMLReader;

/**
 * Normalizes line ending according to https://www.w3.org/TR/xml11/#sec-line-ends:
 *
 * > XML parsed entities are often stored in computer files which,
 * > for editing convenience, are organized into lines.
 * > These lines are typically separated by some combination
 * > of the characters CARRIAGE RETURN (#xD) and LINE FEED (#xA).
 * >
 * > To simplify the tasks of applications, the XML processor must behave
 * > as if it normalized all line breaks in external parsed entities (including the document entity)
 * > on input, before parsing, by translating all of the following to a single #xA character:
 * >
 * > 1. the two-character sequence #xD #xA
 * > 2. the two-character sequence #xD #x85
 * > 3. the single character #x85
 * > 4. the single character #x2028
 * > 5. any #xD character that is not immediately followed by #xA or #x85.
 *
 * @param {string} input
 * @returns {string}
 */
function normalizeLineEndings(input) {
	return input
		.replace(/\r[\n\u0085]/g, '\n')
		.replace(/[\r\u0085\u2028]/g, '\n')
}

/**
 * @typedef Locator
 * @property {number} [columnNumber]
 * @property {number} [lineNumber]
 */

/**
 * @typedef DOMParserOptions
 * @property {DOMHandler} [domBuilder]
 * @property {Function} [errorHandler]
 * @property {(string) => string} [normalizeLineEndings] used to replace line endings before parsing
 * 						defaults to `normalizeLineEndings`
 * @property {Locator} [locator]
 * @property {Record<string, string>} [xmlns]
 *
 * @see normalizeLineEndings
 */

/**
 * The DOMParser interface provides the ability to parse XML or HTML source code
 * from a string into a DOM `Document`.
 *
 * _xmldom is different from the spec in that it allows an `options` parameter,
 * to override the default behavior._
 *
 * @param {DOMParserOptions} [options]
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-parsing-and-serialization
 */
function DOMParser(options){
	this.options = options ||{locator:{}};
}

DOMParser.prototype.parseFromString = function(source,mimeType){
	var options = this.options;
	var sax =  new XMLReader();
	var domBuilder = options.domBuilder || new DOMHandler();//contentHandler and LexicalHandler
	var errorHandler = options.errorHandler;
	var locator = options.locator;
	var defaultNSMap = options.xmlns||{};
	var isHTML = /\/x?html?$/.test(mimeType);//mimeType.toLowerCase().indexOf('html') > -1;
  	var entityMap = isHTML ? entities.HTML_ENTITIES : entities.XML_ENTITIES;
	if(locator){
		domBuilder.setDocumentLocator(locator)
	}

	sax.errorHandler = buildErrorHandler(errorHandler,domBuilder,locator);
	sax.domBuilder = options.domBuilder || domBuilder;
	if(isHTML){
		defaultNSMap[''] = NAMESPACE.HTML;
	}
	defaultNSMap.xml = defaultNSMap.xml || NAMESPACE.XML;
	var normalize = options.normalizeLineEndings || normalizeLineEndings;
	if (source && typeof source === 'string') {
		sax.parse(
			normalize(source),
			defaultNSMap,
			entityMap
		)
	} else {
		sax.errorHandler.error('invalid doc source')
	}
	return domBuilder.doc;
}
function buildErrorHandler(errorImpl,domBuilder,locator){
	if(!errorImpl){
		if(domBuilder instanceof DOMHandler){
			return domBuilder;
		}
		errorImpl = domBuilder ;
	}
	var errorHandler = {}
	var isCallback = errorImpl instanceof Function;
	locator = locator||{}
	function build(key){
		var fn = errorImpl[key];
		if(!fn && isCallback){
			fn = errorImpl.length == 2?function(msg){errorImpl(key,msg)}:errorImpl;
		}
		errorHandler[key] = fn && function(msg){
			fn('[xmldom '+key+']\t'+msg+_locator(locator));
		}||function(){};
	}
	build('warning');
	build('error');
	build('fatalError');
	return errorHandler;
}

//console.log('#\n\n\n\n\n\n\n####')
/**
 * +ContentHandler+ErrorHandler
 * +LexicalHandler+EntityResolver2
 * -DeclHandler-DTDHandler
 *
 * DefaultHandler:EntityResolver, DTDHandler, ContentHandler, ErrorHandler
 * DefaultHandler2:DefaultHandler,LexicalHandler, DeclHandler, EntityResolver2
 * @link http://www.saxproject.org/apidoc/org/xml/sax/helpers/DefaultHandler.html
 */
function DOMHandler() {
    this.cdata = false;
}
function position(locator,node){
	node.lineNumber = locator.lineNumber;
	node.columnNumber = locator.columnNumber;
}
/**
 * @see org.xml.sax.ContentHandler#startDocument
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
 */
DOMHandler.prototype = {
	startDocument : function() {
    	this.doc = new DOMImplementation().createDocument(null, null, null);
    	if (this.locator) {
        	this.doc.documentURI = this.locator.systemId;
    	}
	},
	startElement:function(namespaceURI, localName, qName, attrs) {
		var doc = this.doc;
	    var el = doc.createElementNS(namespaceURI, qName||localName);
	    var len = attrs.length;
	    appendElement(this, el);
	    this.currentElement = el;

		this.locator && position(this.locator,el)
	    for (var i = 0 ; i < len; i++) {
	        var namespaceURI = attrs.getURI(i);
	        var value = attrs.getValue(i);
	        var qName = attrs.getQName(i);
			var attr = doc.createAttributeNS(namespaceURI, qName);
			this.locator &&position(attrs.getLocator(i),attr);
			attr.value = attr.nodeValue = value;
			el.setAttributeNode(attr)
	    }
	},
	endElement:function(namespaceURI, localName, qName) {
		var current = this.currentElement
		var tagName = current.tagName;
		this.currentElement = current.parentNode;
	},
	startPrefixMapping:function(prefix, uri) {
	},
	endPrefixMapping:function(prefix) {
	},
	processingInstruction:function(target, data) {
	    var ins = this.doc.createProcessingInstruction(target, data);
	    this.locator && position(this.locator,ins)
	    appendElement(this, ins);
	},
	ignorableWhitespace:function(ch, start, length) {
	},
	characters:function(chars, start, length) {
		chars = _toString.apply(this,arguments)
		//console.log(chars)
		if(chars){
			if (this.cdata) {
				var charNode = this.doc.createCDATASection(chars);
			} else {
				var charNode = this.doc.createTextNode(chars);
			}
			if(this.currentElement){
				this.currentElement.appendChild(charNode);
			}else if(/^\s*$/.test(chars)){
				this.doc.appendChild(charNode);
				//process xml
			}
			this.locator && position(this.locator,charNode)
		}
	},
	skippedEntity:function(name) {
	},
	endDocument:function() {
		this.doc.normalize();
	},
	setDocumentLocator:function (locator) {
	    if(this.locator = locator){// && !('lineNumber' in locator)){
	    	locator.lineNumber = 0;
	    }
	},
	//LexicalHandler
	comment:function(chars, start, length) {
		chars = _toString.apply(this,arguments)
	    var comm = this.doc.createComment(chars);
	    this.locator && position(this.locator,comm)
	    appendElement(this, comm);
	},

	startCDATA:function() {
	    //used in characters() methods
	    this.cdata = true;
	},
	endCDATA:function() {
	    this.cdata = false;
	},

	startDTD:function(name, publicId, systemId) {
		var impl = this.doc.implementation;
	    if (impl && impl.createDocumentType) {
	        var dt = impl.createDocumentType(name, publicId, systemId);
	        this.locator && position(this.locator,dt)
	        appendElement(this, dt);
					this.doc.doctype = dt;
	    }
	},
	/**
	 * @see org.xml.sax.ErrorHandler
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
	 */
	warning:function(error) {
		console.warn('[xmldom warning]\t'+error,_locator(this.locator));
	},
	error:function(error) {
		console.error('[xmldom error]\t'+error,_locator(this.locator));
	},
	fatalError:function(error) {
		throw new ParseError(error, this.locator);
	}
}
function _locator(l){
	if(l){
		return '\n@'+(l.systemId ||'')+'#[line:'+l.lineNumber+',col:'+l.columnNumber+']'
	}
}
function _toString(chars,start,length){
	if(typeof chars == 'string'){
		return chars.substr(start,length)
	}else{//java sax connect width xmldom on rhino(what about: "? && !(chars instanceof String)")
		if(chars.length >= start+length || start){
			return new java.lang.String(chars,start,length)+'';
		}
		return chars;
	}
}

/*
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/LexicalHandler.html
 * used method of org.xml.sax.ext.LexicalHandler:
 *  #comment(chars, start, length)
 *  #startCDATA()
 *  #endCDATA()
 *  #startDTD(name, publicId, systemId)
 *
 *
 * IGNORED method of org.xml.sax.ext.LexicalHandler:
 *  #endDTD()
 *  #startEntity(name)
 *  #endEntity(name)
 *
 *
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/DeclHandler.html
 * IGNORED method of org.xml.sax.ext.DeclHandler
 * 	#attributeDecl(eName, aName, type, mode, value)
 *  #elementDecl(name, model)
 *  #externalEntityDecl(name, publicId, systemId)
 *  #internalEntityDecl(name, value)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/EntityResolver2.html
 * IGNORED method of org.xml.sax.EntityResolver2
 *  #resolveEntity(String name,String publicId,String baseURI,String systemId)
 *  #resolveEntity(publicId, systemId)
 *  #getExternalSubset(name, baseURI)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/DTDHandler.html
 * IGNORED method of org.xml.sax.DTDHandler
 *  #notationDecl(name, publicId, systemId) {};
 *  #unparsedEntityDecl(name, publicId, systemId, notationName) {};
 */
"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g,function(key){
	DOMHandler.prototype[key] = function(){return null}
})

/* Private static helpers treated below as private instance methods, so don't need to add these to the public API; we might use a Relator to also get rid of non-standard public properties */
function appendElement (hander,node) {
    if (!hander.currentElement) {
        hander.doc.appendChild(node);
    } else {
        hander.currentElement.appendChild(node);
    }
}//appendChild and setAttributeNS are preformance key

exports.__DOMHandler = DOMHandler;
exports.normalizeLineEndings = normalizeLineEndings;
exports.DOMParser = DOMParser;

},{"./conventions":41,"./dom":43,"./entities":44,"./sax":46}],43:[function(require,module,exports){
var conventions = require("./conventions");

var find = conventions.find;
var NAMESPACE = conventions.NAMESPACE;

/**
 * A prerequisite for `[].filter`, to drop elements that are empty
 * @param {string} input
 * @returns {boolean}
 */
function notEmptyString (input) {
	return input !== ''
}
/**
 * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
 * @see https://infra.spec.whatwg.org/#ascii-whitespace
 *
 * @param {string} input
 * @returns {string[]} (can be empty)
 */
function splitOnASCIIWhitespace(input) {
	// U+0009 TAB, U+000A LF, U+000C FF, U+000D CR, U+0020 SPACE
	return input ? input.split(/[\t\n\f\r ]+/).filter(notEmptyString) : []
}

/**
 * Adds element as a key to current if it is not already present.
 *
 * @param {Record<string, boolean | undefined>} current
 * @param {string} element
 * @returns {Record<string, boolean | undefined>}
 */
function orderedSetReducer (current, element) {
	if (!current.hasOwnProperty(element)) {
		current[element] = true;
	}
	return current;
}

/**
 * @see https://infra.spec.whatwg.org/#ordered-set
 * @param {string} input
 * @returns {string[]}
 */
function toOrderedSet(input) {
	if (!input) return [];
	var list = splitOnASCIIWhitespace(input);
	return Object.keys(list.reduce(orderedSetReducer, {}))
}

/**
 * Uses `list.indexOf` to implement something like `Array.prototype.includes`,
 * which we can not rely on being available.
 *
 * @param {any[]} list
 * @returns {function(any): boolean}
 */
function arrayIncludes (list) {
	return function(element) {
		return list && list.indexOf(element) !== -1;
	}
}

function copy(src,dest){
	for(var p in src){
		if (Object.prototype.hasOwnProperty.call(src, p)) {
			dest[p] = src[p];
		}
	}
}

/**
^\w+\.prototype\.([_\w]+)\s*=\s*((?:.*\{\s*?[\r\n][\s\S]*?^})|\S.*?(?=[;\r\n]));?
^\w+\.prototype\.([_\w]+)\s*=\s*(\S.*?(?=[;\r\n]));?
 */
function _extends(Class,Super){
	var pt = Class.prototype;
	if(!(pt instanceof Super)){
		function t(){};
		t.prototype = Super.prototype;
		t = new t();
		copy(pt,t);
		Class.prototype = pt = t;
	}
	if(pt.constructor != Class){
		if(typeof Class != 'function'){
			console.error("unknown Class:"+Class)
		}
		pt.constructor = Class
	}
}

// Node Types
var NodeType = {}
var ELEMENT_NODE                = NodeType.ELEMENT_NODE                = 1;
var ATTRIBUTE_NODE              = NodeType.ATTRIBUTE_NODE              = 2;
var TEXT_NODE                   = NodeType.TEXT_NODE                   = 3;
var CDATA_SECTION_NODE          = NodeType.CDATA_SECTION_NODE          = 4;
var ENTITY_REFERENCE_NODE       = NodeType.ENTITY_REFERENCE_NODE       = 5;
var ENTITY_NODE                 = NodeType.ENTITY_NODE                 = 6;
var PROCESSING_INSTRUCTION_NODE = NodeType.PROCESSING_INSTRUCTION_NODE = 7;
var COMMENT_NODE                = NodeType.COMMENT_NODE                = 8;
var DOCUMENT_NODE               = NodeType.DOCUMENT_NODE               = 9;
var DOCUMENT_TYPE_NODE          = NodeType.DOCUMENT_TYPE_NODE          = 10;
var DOCUMENT_FRAGMENT_NODE      = NodeType.DOCUMENT_FRAGMENT_NODE      = 11;
var NOTATION_NODE               = NodeType.NOTATION_NODE               = 12;

// ExceptionCode
var ExceptionCode = {}
var ExceptionMessage = {};
var INDEX_SIZE_ERR              = ExceptionCode.INDEX_SIZE_ERR              = ((ExceptionMessage[1]="Index size error"),1);
var DOMSTRING_SIZE_ERR          = ExceptionCode.DOMSTRING_SIZE_ERR          = ((ExceptionMessage[2]="DOMString size error"),2);
var HIERARCHY_REQUEST_ERR       = ExceptionCode.HIERARCHY_REQUEST_ERR       = ((ExceptionMessage[3]="Hierarchy request error"),3);
var WRONG_DOCUMENT_ERR          = ExceptionCode.WRONG_DOCUMENT_ERR          = ((ExceptionMessage[4]="Wrong document"),4);
var INVALID_CHARACTER_ERR       = ExceptionCode.INVALID_CHARACTER_ERR       = ((ExceptionMessage[5]="Invalid character"),5);
var NO_DATA_ALLOWED_ERR         = ExceptionCode.NO_DATA_ALLOWED_ERR         = ((ExceptionMessage[6]="No data allowed"),6);
var NO_MODIFICATION_ALLOWED_ERR = ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = ((ExceptionMessage[7]="No modification allowed"),7);
var NOT_FOUND_ERR               = ExceptionCode.NOT_FOUND_ERR               = ((ExceptionMessage[8]="Not found"),8);
var NOT_SUPPORTED_ERR           = ExceptionCode.NOT_SUPPORTED_ERR           = ((ExceptionMessage[9]="Not supported"),9);
var INUSE_ATTRIBUTE_ERR         = ExceptionCode.INUSE_ATTRIBUTE_ERR         = ((ExceptionMessage[10]="Attribute in use"),10);
//level2
var INVALID_STATE_ERR        	= ExceptionCode.INVALID_STATE_ERR        	= ((ExceptionMessage[11]="Invalid state"),11);
var SYNTAX_ERR               	= ExceptionCode.SYNTAX_ERR               	= ((ExceptionMessage[12]="Syntax error"),12);
var INVALID_MODIFICATION_ERR 	= ExceptionCode.INVALID_MODIFICATION_ERR 	= ((ExceptionMessage[13]="Invalid modification"),13);
var NAMESPACE_ERR            	= ExceptionCode.NAMESPACE_ERR           	= ((ExceptionMessage[14]="Invalid namespace"),14);
var INVALID_ACCESS_ERR       	= ExceptionCode.INVALID_ACCESS_ERR      	= ((ExceptionMessage[15]="Invalid access"),15);

/**
 * DOM Level 2
 * Object DOMException
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/ecma-script-binding.html
 * @see http://www.w3.org/TR/REC-DOM-Level-1/ecma-script-language-binding.html
 */
function DOMException(code, message) {
	if(message instanceof Error){
		var error = message;
	}else{
		error = this;
		Error.call(this, ExceptionMessage[code]);
		this.message = ExceptionMessage[code];
		if(Error.captureStackTrace) Error.captureStackTrace(this, DOMException);
	}
	error.code = code;
	if(message) this.message = this.message + ": " + message;
	return error;
};
DOMException.prototype = Error.prototype;
copy(ExceptionCode,DOMException)

/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
 * The NodeList interface provides the abstraction of an ordered collection of nodes, without defining or constraining how this collection is implemented. NodeList objects in the DOM are live.
 * The items in the NodeList are accessible via an integral index, starting from 0.
 */
function NodeList() {
};
NodeList.prototype = {
	/**
	 * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
	 * @standard level1
	 */
	length:0,
	/**
	 * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
	 * @standard level1
	 * @param index  unsigned long
	 *   Index into the collection.
	 * @return Node
	 * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
	 */
	item: function(index) {
		return this[index] || null;
	},
	toString:function(isHTML,nodeFilter){
		for(var buf = [], i = 0;i<this.length;i++){
			serializeToString(this[i],buf,isHTML,nodeFilter);
		}
		return buf.join('');
	},
	/**
	 * @private
	 * @param {function (Node):boolean} predicate
	 * @returns {Node[]}
	 */
	filter: function (predicate) {
		return Array.prototype.filter.call(this, predicate);
	},
	/**
	 * @private
	 * @param {Node} item
	 * @returns {number}
	 */
	indexOf: function (item) {
		return Array.prototype.indexOf.call(this, item);
	},
};

function LiveNodeList(node,refresh){
	this._node = node;
	this._refresh = refresh
	_updateLiveList(this);
}
function _updateLiveList(list){
	var inc = list._node._inc || list._node.ownerDocument._inc;
	if(list._inc != inc){
		var ls = list._refresh(list._node);
		//console.log(ls.length)
		__set__(list,'length',ls.length);
		copy(ls,list);
		list._inc = inc;
	}
}
LiveNodeList.prototype.item = function(i){
	_updateLiveList(this);
	return this[i];
}

_extends(LiveNodeList,NodeList);

/**
 * Objects implementing the NamedNodeMap interface are used
 * to represent collections of nodes that can be accessed by name.
 * Note that NamedNodeMap does not inherit from NodeList;
 * NamedNodeMaps are not maintained in any particular order.
 * Objects contained in an object implementing NamedNodeMap may also be accessed by an ordinal index,
 * but this is simply to allow convenient enumeration of the contents of a NamedNodeMap,
 * and does not imply that the DOM specifies an order to these Nodes.
 * NamedNodeMap objects in the DOM are live.
 * used for attributes or DocumentType entities
 */
function NamedNodeMap() {
};

function _findNodeIndex(list,node){
	var i = list.length;
	while(i--){
		if(list[i] === node){return i}
	}
}

function _addNamedNode(el,list,newAttr,oldAttr){
	if(oldAttr){
		list[_findNodeIndex(list,oldAttr)] = newAttr;
	}else{
		list[list.length++] = newAttr;
	}
	if(el){
		newAttr.ownerElement = el;
		var doc = el.ownerDocument;
		if(doc){
			oldAttr && _onRemoveAttribute(doc,el,oldAttr);
			_onAddAttribute(doc,el,newAttr);
		}
	}
}
function _removeNamedNode(el,list,attr){
	//console.log('remove attr:'+attr)
	var i = _findNodeIndex(list,attr);
	if(i>=0){
		var lastIndex = list.length-1
		while(i<lastIndex){
			list[i] = list[++i]
		}
		list.length = lastIndex;
		if(el){
			var doc = el.ownerDocument;
			if(doc){
				_onRemoveAttribute(doc,el,attr);
				attr.ownerElement = null;
			}
		}
	}else{
		throw new DOMException(NOT_FOUND_ERR,new Error(el.tagName+'@'+attr))
	}
}
NamedNodeMap.prototype = {
	length:0,
	item:NodeList.prototype.item,
	getNamedItem: function(key) {
//		if(key.indexOf(':')>0 || key == 'xmlns'){
//			return null;
//		}
		//console.log()
		var i = this.length;
		while(i--){
			var attr = this[i];
			//console.log(attr.nodeName,key)
			if(attr.nodeName == key){
				return attr;
			}
		}
	},
	setNamedItem: function(attr) {
		var el = attr.ownerElement;
		if(el && el!=this._ownerElement){
			throw new DOMException(INUSE_ATTRIBUTE_ERR);
		}
		var oldAttr = this.getNamedItem(attr.nodeName);
		_addNamedNode(this._ownerElement,this,attr,oldAttr);
		return oldAttr;
	},
	/* returns Node */
	setNamedItemNS: function(attr) {// raises: WRONG_DOCUMENT_ERR,NO_MODIFICATION_ALLOWED_ERR,INUSE_ATTRIBUTE_ERR
		var el = attr.ownerElement, oldAttr;
		if(el && el!=this._ownerElement){
			throw new DOMException(INUSE_ATTRIBUTE_ERR);
		}
		oldAttr = this.getNamedItemNS(attr.namespaceURI,attr.localName);
		_addNamedNode(this._ownerElement,this,attr,oldAttr);
		return oldAttr;
	},

	/* returns Node */
	removeNamedItem: function(key) {
		var attr = this.getNamedItem(key);
		_removeNamedNode(this._ownerElement,this,attr);
		return attr;


	},// raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR

	//for level2
	removeNamedItemNS:function(namespaceURI,localName){
		var attr = this.getNamedItemNS(namespaceURI,localName);
		_removeNamedNode(this._ownerElement,this,attr);
		return attr;
	},
	getNamedItemNS: function(namespaceURI, localName) {
		var i = this.length;
		while(i--){
			var node = this[i];
			if(node.localName == localName && node.namespaceURI == namespaceURI){
				return node;
			}
		}
		return null;
	}
};

/**
 * The DOMImplementation interface represents an object providing methods
 * which are not dependent on any particular document.
 * Such an object is returned by the `Document.implementation` property.
 *
 * __The individual methods describe the differences compared to the specs.__
 *
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation MDN
 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-102161490 DOM Level 1 Core (Initial)
 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#ID-102161490 DOM Level 2 Core
 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-102161490 DOM Level 3 Core
 * @see https://dom.spec.whatwg.org/#domimplementation DOM Living Standard
 */
function DOMImplementation() {
}

DOMImplementation.prototype = {
	/**
	 * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
	 * The different implementations fairly diverged in what kind of features were reported.
	 * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
	 *
	 * @deprecated It is deprecated and modern browsers return true in all cases.
	 *
	 * @param {string} feature
	 * @param {string} [version]
	 * @returns {boolean} always true
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
	 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
	 */
	hasFeature: function(feature, version) {
			return true;
	},
	/**
	 * Creates an XML Document object of the specified type with its document element.
	 *
	 * __It behaves slightly different from the description in the living standard__:
	 * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
	 * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * @param {string|null} namespaceURI
	 * @param {string} qualifiedName
	 * @param {DocumentType=null} doctype
	 * @returns {Document}
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */
	createDocument: function(namespaceURI,  qualifiedName, doctype){
		var doc = new Document();
		doc.implementation = this;
		doc.childNodes = new NodeList();
		doc.doctype = doctype || null;
		if (doctype){
			doc.appendChild(doctype);
		}
		if (qualifiedName){
			var root = doc.createElementNS(namespaceURI, qualifiedName);
			doc.appendChild(root);
		}
		return doc;
	},
	/**
	 * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
	 *
	 * __This behavior is slightly different from the in the specs__:
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * @param {string} qualifiedName
	 * @param {string} [publicId]
	 * @param {string} [systemId]
	 * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
	 * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */
	createDocumentType: function(qualifiedName, publicId, systemId){
		var node = new DocumentType();
		node.name = qualifiedName;
		node.nodeName = qualifiedName;
		node.publicId = publicId || '';
		node.systemId = systemId || '';

		return node;
	}
};


/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-1950641247
 */

function Node() {
};

Node.prototype = {
	firstChild : null,
	lastChild : null,
	previousSibling : null,
	nextSibling : null,
	attributes : null,
	parentNode : null,
	childNodes : null,
	ownerDocument : null,
	nodeValue : null,
	namespaceURI : null,
	prefix : null,
	localName : null,
	// Modified in DOM Level 2:
	insertBefore:function(newChild, refChild){//raises
		return _insertBefore(this,newChild,refChild);
	},
	replaceChild:function(newChild, oldChild){//raises
		_insertBefore(this, newChild,oldChild, assertPreReplacementValidityInDocument);
		if(oldChild){
			this.removeChild(oldChild);
		}
	},
	removeChild:function(oldChild){
		return _removeChild(this,oldChild);
	},
	appendChild:function(newChild){
		return this.insertBefore(newChild,null);
	},
	hasChildNodes:function(){
		return this.firstChild != null;
	},
	cloneNode:function(deep){
		return cloneNode(this.ownerDocument||this,this,deep);
	},
	// Modified in DOM Level 2:
	normalize:function(){
		var child = this.firstChild;
		while(child){
			var next = child.nextSibling;
			if(next && next.nodeType == TEXT_NODE && child.nodeType == TEXT_NODE){
				this.removeChild(next);
				child.appendData(next.data);
			}else{
				child.normalize();
				child = next;
			}
		}
	},
  	// Introduced in DOM Level 2:
	isSupported:function(feature, version){
		return this.ownerDocument.implementation.hasFeature(feature,version);
	},
    // Introduced in DOM Level 2:
    hasAttributes:function(){
    	return this.attributes.length>0;
    },
	/**
	 * Look up the prefix associated to the given namespace URI, starting from this node.
	 * **The default namespace declarations are ignored by this method.**
	 * See Namespace Prefix Lookup for details on the algorithm used by this method.
	 *
	 * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
	 *
	 * @param {string | null} namespaceURI
	 * @returns {string | null}
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
	 * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
	 * @see https://github.com/xmldom/xmldom/issues/322
	 */
    lookupPrefix:function(namespaceURI){
    	var el = this;
    	while(el){
    		var map = el._nsMap;
    		//console.dir(map)
    		if(map){
    			for(var n in map){
						if (Object.prototype.hasOwnProperty.call(map, n) && map[n] === namespaceURI) {
							return n;
						}
    			}
    		}
    		el = el.nodeType == ATTRIBUTE_NODE?el.ownerDocument : el.parentNode;
    	}
    	return null;
    },
    // Introduced in DOM Level 3:
    lookupNamespaceURI:function(prefix){
    	var el = this;
    	while(el){
    		var map = el._nsMap;
    		//console.dir(map)
    		if(map){
    			if(Object.prototype.hasOwnProperty.call(map, prefix)){
    				return map[prefix] ;
    			}
    		}
    		el = el.nodeType == ATTRIBUTE_NODE?el.ownerDocument : el.parentNode;
    	}
    	return null;
    },
    // Introduced in DOM Level 3:
    isDefaultNamespace:function(namespaceURI){
    	var prefix = this.lookupPrefix(namespaceURI);
    	return prefix == null;
    }
};


function _xmlEncoder(c){
	return c == '<' && '&lt;' ||
         c == '>' && '&gt;' ||
         c == '&' && '&amp;' ||
         c == '"' && '&quot;' ||
         '&#'+c.charCodeAt()+';'
}


copy(NodeType,Node);
copy(NodeType,Node.prototype);

/**
 * @param callback return true for continue,false for break
 * @return boolean true: break visit;
 */
function _visitNode(node,callback){
	if(callback(node)){
		return true;
	}
	if(node = node.firstChild){
		do{
			if(_visitNode(node,callback)){return true}
        }while(node=node.nextSibling)
    }
}



function Document(){
	this.ownerDocument = this;
}

function _onAddAttribute(doc,el,newAttr){
	doc && doc._inc++;
	var ns = newAttr.namespaceURI ;
	if(ns === NAMESPACE.XMLNS){
		//update namespace
		el._nsMap[newAttr.prefix?newAttr.localName:''] = newAttr.value
	}
}

function _onRemoveAttribute(doc,el,newAttr,remove){
	doc && doc._inc++;
	var ns = newAttr.namespaceURI ;
	if(ns === NAMESPACE.XMLNS){
		//update namespace
		delete el._nsMap[newAttr.prefix?newAttr.localName:'']
	}
}

/**
 * Updates `el.childNodes`, updating the indexed items and it's `length`.
 * Passing `newChild` means it will be appended.
 * Otherwise it's assumed that an item has been removed,
 * and `el.firstNode` and it's `.nextSibling` are used
 * to walk the current list of child nodes.
 *
 * @param {Document} doc
 * @param {Node} el
 * @param {Node} [newChild]
 * @private
 */
function _onUpdateChild (doc, el, newChild) {
	if(doc && doc._inc){
		doc._inc++;
		//update childNodes
		var cs = el.childNodes;
		if (newChild) {
			cs[cs.length++] = newChild;
		} else {
			var child = el.firstChild;
			var i = 0;
			while (child) {
				cs[i++] = child;
				child = child.nextSibling;
			}
			cs.length = i;
			delete cs[cs.length];
		}
	}
}

/**
 * Removes the connections between `parentNode` and `child`
 * and any existing `child.previousSibling` or `child.nextSibling`.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 *
 * @param {Node} parentNode
 * @param {Node} child
 * @returns {Node} the child that was removed.
 * @private
 */
function _removeChild (parentNode, child) {
	var previous = child.previousSibling;
	var next = child.nextSibling;
	if (previous) {
		previous.nextSibling = next;
	} else {
		parentNode.firstChild = next;
	}
	if (next) {
		next.previousSibling = previous;
	} else {
		parentNode.lastChild = previous;
	}
	child.parentNode = null;
	child.previousSibling = null;
	child.nextSibling = null;
	_onUpdateChild(parentNode.ownerDocument, parentNode);
	return child;
}

/**
 * Returns `true` if `node` can be a parent for insertion.
 * @param {Node} node
 * @returns {boolean}
 */
function hasValidParentNodeType(node) {
	return (
		node &&
		(node.nodeType === Node.DOCUMENT_NODE || node.nodeType === Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === Node.ELEMENT_NODE)
	);
}

/**
 * Returns `true` if `node` can be inserted according to it's `nodeType`.
 * @param {Node} node
 * @returns {boolean}
 */
function hasInsertableNodeType(node) {
	return (
		node &&
		(isElementNode(node) ||
			isTextNode(node) ||
			isDocTypeNode(node) ||
			node.nodeType === Node.DOCUMENT_FRAGMENT_NODE ||
			node.nodeType === Node.COMMENT_NODE ||
			node.nodeType === Node.PROCESSING_INSTRUCTION_NODE)
	);
}

/**
 * Returns true if `node` is a DOCTYPE node
 * @param {Node} node
 * @returns {boolean}
 */
function isDocTypeNode(node) {
	return node && node.nodeType === Node.DOCUMENT_TYPE_NODE;
}

/**
 * Returns true if the node is an element
 * @param {Node} node
 * @returns {boolean}
 */
function isElementNode(node) {
	return node && node.nodeType === Node.ELEMENT_NODE;
}
/**
 * Returns true if `node` is a text node
 * @param {Node} node
 * @returns {boolean}
 */
function isTextNode(node) {
	return node && node.nodeType === Node.TEXT_NODE;
}

/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Document} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */
function isElementInsertionPossible(doc, child) {
	var parentChildNodes = doc.childNodes || [];
	if (find(parentChildNodes, isElementNode) || isDocTypeNode(child)) {
		return false;
	}
	var docTypeNode = find(parentChildNodes, isDocTypeNode);
	return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}

/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Node} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */
function isElementReplacementPossible(doc, child) {
	var parentChildNodes = doc.childNodes || [];

	function hasElementChildThatIsNotChild(node) {
		return isElementNode(node) && node !== child;
	}

	if (find(parentChildNodes, hasElementChildThatIsNotChild)) {
		return false;
	}
	var docTypeNode = find(parentChildNodes, isDocTypeNode);
	return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}

/**
 * @private
 * Steps 1-5 of the checks before inserting and before replacing a child are the same.
 *
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */
function assertPreInsertionValidity1to5(parent, node, child) {
	// 1. If `parent` is not a Document, DocumentFragment, or Element node, then throw a "HierarchyRequestError" DOMException.
	if (!hasValidParentNodeType(parent)) {
		throw new DOMException(HIERARCHY_REQUEST_ERR, 'Unexpected parent node type ' + parent.nodeType);
	}
	// 2. If `node` is a host-including inclusive ancestor of `parent`, then throw a "HierarchyRequestError" DOMException.
	// not implemented!
	// 3. If `child` is non-null and its parent is not `parent`, then throw a "NotFoundError" DOMException.
	if (child && child.parentNode !== parent) {
		throw new DOMException(NOT_FOUND_ERR, 'child not in parent');
	}
	if (
		// 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
		!hasInsertableNodeType(node) ||
		// 5. If either `node` is a Text node and `parent` is a document,
		// the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
		// || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
		// or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
		(isDocTypeNode(node) && parent.nodeType !== Node.DOCUMENT_NODE)
	) {
		throw new DOMException(
			HIERARCHY_REQUEST_ERR,
			'Unexpected node type ' + node.nodeType + ' for parent node type ' + parent.nodeType
		);
	}
}

/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */
function assertPreInsertionValidityInDocument(parent, node, child) {
	var parentChildNodes = parent.childNodes || [];
	var nodeChildNodes = node.childNodes || [];

	// DocumentFragment
	if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
		var nodeChildElements = nodeChildNodes.filter(isElementNode);
		// If node has more than one element child or has a Text node child.
		if (nodeChildElements.length > 1 || find(nodeChildNodes, isTextNode)) {
			throw new DOMException(HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
		}
		// Otherwise, if `node` has one element child and either `parent` has an element child,
		// `child` is a doctype, or `child` is non-null and a doctype is following `child`.
		if (nodeChildElements.length === 1 && !isElementInsertionPossible(parent, child)) {
			throw new DOMException(HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
		}
	}
	// Element
	if (isElementNode(node)) {
		// `parent` has an element child, `child` is a doctype,
		// or `child` is non-null and a doctype is following `child`.
		if (!isElementInsertionPossible(parent, child)) {
			throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
		}
	}
	// DocumentType
	if (isDocTypeNode(node)) {
		// `parent` has a doctype child,
		if (find(parentChildNodes, isDocTypeNode)) {
			throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
		}
		var parentElementChild = find(parentChildNodes, isElementNode);
		// `child` is non-null and an element is preceding `child`,
		if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) {
			throw new DOMException(HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
		}
		// or `child` is null and `parent` has an element child.
		if (!child && parentElementChild) {
			throw new DOMException(HIERARCHY_REQUEST_ERR, 'Doctype can not be appended since element is present');
		}
	}
}

/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */
function assertPreReplacementValidityInDocument(parent, node, child) {
	var parentChildNodes = parent.childNodes || [];
	var nodeChildNodes = node.childNodes || [];

	// DocumentFragment
	if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
		var nodeChildElements = nodeChildNodes.filter(isElementNode);
		// If `node` has more than one element child or has a Text node child.
		if (nodeChildElements.length > 1 || find(nodeChildNodes, isTextNode)) {
			throw new DOMException(HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
		}
		// Otherwise, if `node` has one element child and either `parent` has an element child that is not `child` or a doctype is following `child`.
		if (nodeChildElements.length === 1 && !isElementReplacementPossible(parent, child)) {
			throw new DOMException(HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
		}
	}
	// Element
	if (isElementNode(node)) {
		// `parent` has an element child that is not `child` or a doctype is following `child`.
		if (!isElementReplacementPossible(parent, child)) {
			throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
		}
	}
	// DocumentType
	if (isDocTypeNode(node)) {
		function hasDoctypeChildThatIsNotChild(node) {
			return isDocTypeNode(node) && node !== child;
		}

		// `parent` has a doctype child that is not `child`,
		if (find(parentChildNodes, hasDoctypeChildThatIsNotChild)) {
			throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
		}
		var parentElementChild = find(parentChildNodes, isElementNode);
		// or an element is preceding `child`.
		if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) {
			throw new DOMException(HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
		}
	}
}

/**
 * @private
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */
function _insertBefore(parent, node, child, _inDocumentAssertion) {
	// To ensure pre-insertion validity of a node into a parent before a child, run these steps:
	assertPreInsertionValidity1to5(parent, node, child);

	// If parent is a document, and any of the statements below, switched on the interface node implements,
	// are true, then throw a "HierarchyRequestError" DOMException.
	if (parent.nodeType === Node.DOCUMENT_NODE) {
		(_inDocumentAssertion || assertPreInsertionValidityInDocument)(parent, node, child);
	}

	var cp = node.parentNode;
	if(cp){
		cp.removeChild(node);//remove and update
	}
	if(node.nodeType === DOCUMENT_FRAGMENT_NODE){
		var newFirst = node.firstChild;
		if (newFirst == null) {
			return node;
		}
		var newLast = node.lastChild;
	}else{
		newFirst = newLast = node;
	}
	var pre = child ? child.previousSibling : parent.lastChild;

	newFirst.previousSibling = pre;
	newLast.nextSibling = child;


	if(pre){
		pre.nextSibling = newFirst;
	}else{
		parent.firstChild = newFirst;
	}
	if(child == null){
		parent.lastChild = newLast;
	}else{
		child.previousSibling = newLast;
	}
	do{
		newFirst.parentNode = parent;
	}while(newFirst !== newLast && (newFirst= newFirst.nextSibling))
	_onUpdateChild(parent.ownerDocument||parent, parent);
	//console.log(parent.lastChild.nextSibling == null)
	if (node.nodeType == DOCUMENT_FRAGMENT_NODE) {
		node.firstChild = node.lastChild = null;
	}
	return node;
}

/**
 * Appends `newChild` to `parentNode`.
 * If `newChild` is already connected to a `parentNode` it is first removed from it.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 * @param {Node} parentNode
 * @param {Node} newChild
 * @returns {Node}
 * @private
 */
function _appendSingleChild (parentNode, newChild) {
	if (newChild.parentNode) {
		newChild.parentNode.removeChild(newChild);
	}
	newChild.parentNode = parentNode;
	newChild.previousSibling = parentNode.lastChild;
	newChild.nextSibling = null;
	if (newChild.previousSibling) {
		newChild.previousSibling.nextSibling = newChild;
	} else {
		parentNode.firstChild = newChild;
	}
	parentNode.lastChild = newChild;
	_onUpdateChild(parentNode.ownerDocument, parentNode, newChild);
	return newChild;
}

Document.prototype = {
	//implementation : null,
	nodeName :  '#document',
	nodeType :  DOCUMENT_NODE,
	/**
	 * The DocumentType node of the document.
	 *
	 * @readonly
	 * @type DocumentType
	 */
	doctype :  null,
	documentElement :  null,
	_inc : 1,

	insertBefore :  function(newChild, refChild){//raises
		if(newChild.nodeType == DOCUMENT_FRAGMENT_NODE){
			var child = newChild.firstChild;
			while(child){
				var next = child.nextSibling;
				this.insertBefore(child,refChild);
				child = next;
			}
			return newChild;
		}
		_insertBefore(this, newChild, refChild);
		newChild.ownerDocument = this;
		if (this.documentElement === null && newChild.nodeType === ELEMENT_NODE) {
			this.documentElement = newChild;
		}

		return newChild;
	},
	removeChild :  function(oldChild){
		if(this.documentElement == oldChild){
			this.documentElement = null;
		}
		return _removeChild(this,oldChild);
	},
	replaceChild: function (newChild, oldChild) {
		//raises
		_insertBefore(this, newChild, oldChild, assertPreReplacementValidityInDocument);
		newChild.ownerDocument = this;
		if (oldChild) {
			this.removeChild(oldChild);
		}
		if (isElementNode(newChild)) {
			this.documentElement = newChild;
		}
	},
	// Introduced in DOM Level 2:
	importNode : function(importedNode,deep){
		return importNode(this,importedNode,deep);
	},
	// Introduced in DOM Level 2:
	getElementById :	function(id){
		var rtv = null;
		_visitNode(this.documentElement,function(node){
			if(node.nodeType == ELEMENT_NODE){
				if(node.getAttribute('id') == id){
					rtv = node;
					return true;
				}
			}
		})
		return rtv;
	},

	/**
	 * The `getElementsByClassName` method of `Document` interface returns an array-like object
	 * of all child elements which have **all** of the given class name(s).
	 *
	 * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
	 *
	 *
	 * Warning: This is a live LiveNodeList.
	 * Changes in the DOM will reflect in the array as the changes occur.
	 * If an element selected by this array no longer qualifies for the selector,
	 * it will automatically be removed. Be aware of this for iteration purposes.
	 *
	 * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
	 * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
	 */
	getElementsByClassName: function(classNames) {
		var classNamesSet = toOrderedSet(classNames)
		return new LiveNodeList(this, function(base) {
			var ls = [];
			if (classNamesSet.length > 0) {
				_visitNode(base.documentElement, function(node) {
					if(node !== base && node.nodeType === ELEMENT_NODE) {
						var nodeClassNames = node.getAttribute('class')
						// can be null if the attribute does not exist
						if (nodeClassNames) {
							// before splitting and iterating just compare them for the most common case
							var matches = classNames === nodeClassNames;
							if (!matches) {
								var nodeClassNamesSet = toOrderedSet(nodeClassNames)
								matches = classNamesSet.every(arrayIncludes(nodeClassNamesSet))
							}
							if(matches) {
								ls.push(node);
							}
						}
					}
				});
			}
			return ls;
		});
	},

	//document factory method:
	createElement :	function(tagName){
		var node = new Element();
		node.ownerDocument = this;
		node.nodeName = tagName;
		node.tagName = tagName;
		node.localName = tagName;
		node.childNodes = new NodeList();
		var attrs	= node.attributes = new NamedNodeMap();
		attrs._ownerElement = node;
		return node;
	},
	createDocumentFragment :	function(){
		var node = new DocumentFragment();
		node.ownerDocument = this;
		node.childNodes = new NodeList();
		return node;
	},
	createTextNode :	function(data){
		var node = new Text();
		node.ownerDocument = this;
		node.appendData(data)
		return node;
	},
	createComment :	function(data){
		var node = new Comment();
		node.ownerDocument = this;
		node.appendData(data)
		return node;
	},
	createCDATASection :	function(data){
		var node = new CDATASection();
		node.ownerDocument = this;
		node.appendData(data)
		return node;
	},
	createProcessingInstruction :	function(target,data){
		var node = new ProcessingInstruction();
		node.ownerDocument = this;
		node.tagName = node.target = target;
		node.nodeValue= node.data = data;
		return node;
	},
	createAttribute :	function(name){
		var node = new Attr();
		node.ownerDocument	= this;
		node.name = name;
		node.nodeName	= name;
		node.localName = name;
		node.specified = true;
		return node;
	},
	createEntityReference :	function(name){
		var node = new EntityReference();
		node.ownerDocument	= this;
		node.nodeName	= name;
		return node;
	},
	// Introduced in DOM Level 2:
	createElementNS :	function(namespaceURI,qualifiedName){
		var node = new Element();
		var pl = qualifiedName.split(':');
		var attrs	= node.attributes = new NamedNodeMap();
		node.childNodes = new NodeList();
		node.ownerDocument = this;
		node.nodeName = qualifiedName;
		node.tagName = qualifiedName;
		node.namespaceURI = namespaceURI;
		if(pl.length == 2){
			node.prefix = pl[0];
			node.localName = pl[1];
		}else{
			//el.prefix = null;
			node.localName = qualifiedName;
		}
		attrs._ownerElement = node;
		return node;
	},
	// Introduced in DOM Level 2:
	createAttributeNS :	function(namespaceURI,qualifiedName){
		var node = new Attr();
		var pl = qualifiedName.split(':');
		node.ownerDocument = this;
		node.nodeName = qualifiedName;
		node.name = qualifiedName;
		node.namespaceURI = namespaceURI;
		node.specified = true;
		if(pl.length == 2){
			node.prefix = pl[0];
			node.localName = pl[1];
		}else{
			//el.prefix = null;
			node.localName = qualifiedName;
		}
		return node;
	}
};
_extends(Document,Node);


function Element() {
	this._nsMap = {};
};
Element.prototype = {
	nodeType : ELEMENT_NODE,
	hasAttribute : function(name){
		return this.getAttributeNode(name)!=null;
	},
	getAttribute : function(name){
		var attr = this.getAttributeNode(name);
		return attr && attr.value || '';
	},
	getAttributeNode : function(name){
		return this.attributes.getNamedItem(name);
	},
	setAttribute : function(name, value){
		var attr = this.ownerDocument.createAttribute(name);
		attr.value = attr.nodeValue = "" + value;
		this.setAttributeNode(attr)
	},
	removeAttribute : function(name){
		var attr = this.getAttributeNode(name)
		attr && this.removeAttributeNode(attr);
	},

	//four real opeartion method
	appendChild:function(newChild){
		if(newChild.nodeType === DOCUMENT_FRAGMENT_NODE){
			return this.insertBefore(newChild,null);
		}else{
			return _appendSingleChild(this,newChild);
		}
	},
	setAttributeNode : function(newAttr){
		return this.attributes.setNamedItem(newAttr);
	},
	setAttributeNodeNS : function(newAttr){
		return this.attributes.setNamedItemNS(newAttr);
	},
	removeAttributeNode : function(oldAttr){
		//console.log(this == oldAttr.ownerElement)
		return this.attributes.removeNamedItem(oldAttr.nodeName);
	},
	//get real attribute name,and remove it by removeAttributeNode
	removeAttributeNS : function(namespaceURI, localName){
		var old = this.getAttributeNodeNS(namespaceURI, localName);
		old && this.removeAttributeNode(old);
	},

	hasAttributeNS : function(namespaceURI, localName){
		return this.getAttributeNodeNS(namespaceURI, localName)!=null;
	},
	getAttributeNS : function(namespaceURI, localName){
		var attr = this.getAttributeNodeNS(namespaceURI, localName);
		return attr && attr.value || '';
	},
	setAttributeNS : function(namespaceURI, qualifiedName, value){
		var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
		attr.value = attr.nodeValue = "" + value;
		this.setAttributeNode(attr)
	},
	getAttributeNodeNS : function(namespaceURI, localName){
		return this.attributes.getNamedItemNS(namespaceURI, localName);
	},

	getElementsByTagName : function(tagName){
		return new LiveNodeList(this,function(base){
			var ls = [];
			_visitNode(base,function(node){
				if(node !== base && node.nodeType == ELEMENT_NODE && (tagName === '*' || node.tagName == tagName)){
					ls.push(node);
				}
			});
			return ls;
		});
	},
	getElementsByTagNameNS : function(namespaceURI, localName){
		return new LiveNodeList(this,function(base){
			var ls = [];
			_visitNode(base,function(node){
				if(node !== base && node.nodeType === ELEMENT_NODE && (namespaceURI === '*' || node.namespaceURI === namespaceURI) && (localName === '*' || node.localName == localName)){
					ls.push(node);
				}
			});
			return ls;

		});
	}
};
Document.prototype.getElementsByTagName = Element.prototype.getElementsByTagName;
Document.prototype.getElementsByTagNameNS = Element.prototype.getElementsByTagNameNS;


_extends(Element,Node);
function Attr() {
};
Attr.prototype.nodeType = ATTRIBUTE_NODE;
_extends(Attr,Node);


function CharacterData() {
};
CharacterData.prototype = {
	data : '',
	substringData : function(offset, count) {
		return this.data.substring(offset, offset+count);
	},
	appendData: function(text) {
		text = this.data+text;
		this.nodeValue = this.data = text;
		this.length = text.length;
	},
	insertData: function(offset,text) {
		this.replaceData(offset,0,text);

	},
	appendChild:function(newChild){
		throw new Error(ExceptionMessage[HIERARCHY_REQUEST_ERR])
	},
	deleteData: function(offset, count) {
		this.replaceData(offset,count,"");
	},
	replaceData: function(offset, count, text) {
		var start = this.data.substring(0,offset);
		var end = this.data.substring(offset+count);
		text = start + text + end;
		this.nodeValue = this.data = text;
		this.length = text.length;
	}
}
_extends(CharacterData,Node);
function Text() {
};
Text.prototype = {
	nodeName : "#text",
	nodeType : TEXT_NODE,
	splitText : function(offset) {
		var text = this.data;
		var newText = text.substring(offset);
		text = text.substring(0, offset);
		this.data = this.nodeValue = text;
		this.length = text.length;
		var newNode = this.ownerDocument.createTextNode(newText);
		if(this.parentNode){
			this.parentNode.insertBefore(newNode, this.nextSibling);
		}
		return newNode;
	}
}
_extends(Text,CharacterData);
function Comment() {
};
Comment.prototype = {
	nodeName : "#comment",
	nodeType : COMMENT_NODE
}
_extends(Comment,CharacterData);

function CDATASection() {
};
CDATASection.prototype = {
	nodeName : "#cdata-section",
	nodeType : CDATA_SECTION_NODE
}
_extends(CDATASection,CharacterData);


function DocumentType() {
};
DocumentType.prototype.nodeType = DOCUMENT_TYPE_NODE;
_extends(DocumentType,Node);

function Notation() {
};
Notation.prototype.nodeType = NOTATION_NODE;
_extends(Notation,Node);

function Entity() {
};
Entity.prototype.nodeType = ENTITY_NODE;
_extends(Entity,Node);

function EntityReference() {
};
EntityReference.prototype.nodeType = ENTITY_REFERENCE_NODE;
_extends(EntityReference,Node);

function DocumentFragment() {
};
DocumentFragment.prototype.nodeName =	"#document-fragment";
DocumentFragment.prototype.nodeType =	DOCUMENT_FRAGMENT_NODE;
_extends(DocumentFragment,Node);


function ProcessingInstruction() {
}
ProcessingInstruction.prototype.nodeType = PROCESSING_INSTRUCTION_NODE;
_extends(ProcessingInstruction,Node);
function XMLSerializer(){}
XMLSerializer.prototype.serializeToString = function(node,isHtml,nodeFilter){
	return nodeSerializeToString.call(node,isHtml,nodeFilter);
}
Node.prototype.toString = nodeSerializeToString;
function nodeSerializeToString(isHtml,nodeFilter){
	var buf = [];
	var refNode = this.nodeType == 9 && this.documentElement || this;
	var prefix = refNode.prefix;
	var uri = refNode.namespaceURI;

	if(uri && prefix == null){
		//console.log(prefix)
		var prefix = refNode.lookupPrefix(uri);
		if(prefix == null){
			//isHTML = true;
			var visibleNamespaces=[
			{namespace:uri,prefix:null}
			//{namespace:uri,prefix:''}
			]
		}
	}
	serializeToString(this,buf,isHtml,nodeFilter,visibleNamespaces);
	//console.log('###',this.nodeType,uri,prefix,buf.join(''))
	return buf.join('');
}

function needNamespaceDefine(node, isHTML, visibleNamespaces) {
	var prefix = node.prefix || '';
	var uri = node.namespaceURI;
	// According to [Namespaces in XML 1.0](https://www.w3.org/TR/REC-xml-names/#ns-using) ,
	// and more specifically https://www.w3.org/TR/REC-xml-names/#nsc-NoPrefixUndecl :
	// > In a namespace declaration for a prefix [...], the attribute value MUST NOT be empty.
	// in a similar manner [Namespaces in XML 1.1](https://www.w3.org/TR/xml-names11/#ns-using)
	// and more specifically https://www.w3.org/TR/xml-names11/#nsc-NSDeclared :
	// > [...] Furthermore, the attribute value [...] must not be an empty string.
	// so serializing empty namespace value like xmlns:ds="" would produce an invalid XML document.
	if (!uri) {
		return false;
	}
	if (prefix === "xml" && uri === NAMESPACE.XML || uri === NAMESPACE.XMLNS) {
		return false;
	}

	var i = visibleNamespaces.length
	while (i--) {
		var ns = visibleNamespaces[i];
		// get namespace prefix
		if (ns.prefix === prefix) {
			return ns.namespace !== uri;
		}
	}
	return true;
}
/**
 * Well-formed constraint: No < in Attribute Values
 * > The replacement text of any entity referred to directly or indirectly
 * > in an attribute value must not contain a <.
 * @see https://www.w3.org/TR/xml11/#CleanAttrVals
 * @see https://www.w3.org/TR/xml11/#NT-AttValue
 *
 * Literal whitespace other than space that appear in attribute values
 * are serialized as their entity references, so they will be preserved.
 * (In contrast to whitespace literals in the input which are normalized to spaces)
 * @see https://www.w3.org/TR/xml11/#AVNormalize
 * @see https://w3c.github.io/DOM-Parsing/#serializing-an-element-s-attributes
 */
function addSerializedAttribute(buf, qualifiedName, value) {
	buf.push(' ', qualifiedName, '="', value.replace(/[<>&"\t\n\r]/g, _xmlEncoder), '"')
}

function serializeToString(node,buf,isHTML,nodeFilter,visibleNamespaces){
	if (!visibleNamespaces) {
		visibleNamespaces = [];
	}

	if(nodeFilter){
		node = nodeFilter(node);
		if(node){
			if(typeof node == 'string'){
				buf.push(node);
				return;
			}
		}else{
			return;
		}
		//buf.sort.apply(attrs, attributeSorter);
	}

	switch(node.nodeType){
	case ELEMENT_NODE:
		var attrs = node.attributes;
		var len = attrs.length;
		var child = node.firstChild;
		var nodeName = node.tagName;

		isHTML = NAMESPACE.isHTML(node.namespaceURI) || isHTML

		var prefixedNodeName = nodeName
		if (!isHTML && !node.prefix && node.namespaceURI) {
			var defaultNS
			// lookup current default ns from `xmlns` attribute
			for (var ai = 0; ai < attrs.length; ai++) {
				if (attrs.item(ai).name === 'xmlns') {
					defaultNS = attrs.item(ai).value
					break
				}
			}
			if (!defaultNS) {
				// lookup current default ns in visibleNamespaces
				for (var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--) {
					var namespace = visibleNamespaces[nsi]
					if (namespace.prefix === '' && namespace.namespace === node.namespaceURI) {
						defaultNS = namespace.namespace
						break
					}
				}
			}
			if (defaultNS !== node.namespaceURI) {
				for (var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--) {
					var namespace = visibleNamespaces[nsi]
					if (namespace.namespace === node.namespaceURI) {
						if (namespace.prefix) {
							prefixedNodeName = namespace.prefix + ':' + nodeName
						}
						break
					}
				}
			}
		}

		buf.push('<', prefixedNodeName);

		for(var i=0;i<len;i++){
			// add namespaces for attributes
			var attr = attrs.item(i);
			if (attr.prefix == 'xmlns') {
				visibleNamespaces.push({ prefix: attr.localName, namespace: attr.value });
			}else if(attr.nodeName == 'xmlns'){
				visibleNamespaces.push({ prefix: '', namespace: attr.value });
			}
		}

		for(var i=0;i<len;i++){
			var attr = attrs.item(i);
			if (needNamespaceDefine(attr,isHTML, visibleNamespaces)) {
				var prefix = attr.prefix||'';
				var uri = attr.namespaceURI;
				addSerializedAttribute(buf, prefix ? 'xmlns:' + prefix : "xmlns", uri);
				visibleNamespaces.push({ prefix: prefix, namespace:uri });
			}
			serializeToString(attr,buf,isHTML,nodeFilter,visibleNamespaces);
		}

		// add namespace for current node
		if (nodeName === prefixedNodeName && needNamespaceDefine(node, isHTML, visibleNamespaces)) {
			var prefix = node.prefix||'';
			var uri = node.namespaceURI;
			addSerializedAttribute(buf, prefix ? 'xmlns:' + prefix : "xmlns", uri);
			visibleNamespaces.push({ prefix: prefix, namespace:uri });
		}

		if(child || isHTML && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)){
			buf.push('>');
			//if is cdata child node
			if(isHTML && /^script$/i.test(nodeName)){
				while(child){
					if(child.data){
						buf.push(child.data);
					}else{
						serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
					}
					child = child.nextSibling;
				}
			}else
			{
				while(child){
					serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
					child = child.nextSibling;
				}
			}
			buf.push('</',prefixedNodeName,'>');
		}else{
			buf.push('/>');
		}
		// remove added visible namespaces
		//visibleNamespaces.length = startVisibleNamespaces;
		return;
	case DOCUMENT_NODE:
	case DOCUMENT_FRAGMENT_NODE:
		var child = node.firstChild;
		while(child){
			serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
			child = child.nextSibling;
		}
		return;
	case ATTRIBUTE_NODE:
		return addSerializedAttribute(buf, node.name, node.value);
	case TEXT_NODE:
		/**
		 * The ampersand character (&) and the left angle bracket (<) must not appear in their literal form,
		 * except when used as markup delimiters, or within a comment, a processing instruction, or a CDATA section.
		 * If they are needed elsewhere, they must be escaped using either numeric character references or the strings
		 * `&amp;` and `&lt;` respectively.
		 * The right angle bracket (>) may be represented using the string " &gt; ", and must, for compatibility,
		 * be escaped using either `&gt;` or a character reference when it appears in the string `]]>` in content,
		 * when that string is not marking the end of a CDATA section.
		 *
		 * In the content of elements, character data is any string of characters
		 * which does not contain the start-delimiter of any markup
		 * and does not include the CDATA-section-close delimiter, `]]>`.
		 *
		 * @see https://www.w3.org/TR/xml/#NT-CharData
		 * @see https://w3c.github.io/DOM-Parsing/#xml-serializing-a-text-node
		 */
		return buf.push(node.data
			.replace(/[<&>]/g,_xmlEncoder)
		);
	case CDATA_SECTION_NODE:
		return buf.push( '<![CDATA[',node.data,']]>');
	case COMMENT_NODE:
		return buf.push( "<!--",node.data,"-->");
	case DOCUMENT_TYPE_NODE:
		var pubid = node.publicId;
		var sysid = node.systemId;
		buf.push('<!DOCTYPE ',node.name);
		if(pubid){
			buf.push(' PUBLIC ', pubid);
			if (sysid && sysid!='.') {
				buf.push(' ', sysid);
			}
			buf.push('>');
		}else if(sysid && sysid!='.'){
			buf.push(' SYSTEM ', sysid, '>');
		}else{
			var sub = node.internalSubset;
			if(sub){
				buf.push(" [",sub,"]");
			}
			buf.push(">");
		}
		return;
	case PROCESSING_INSTRUCTION_NODE:
		return buf.push( "<?",node.target," ",node.data,"?>");
	case ENTITY_REFERENCE_NODE:
		return buf.push( '&',node.nodeName,';');
	//case ENTITY_NODE:
	//case NOTATION_NODE:
	default:
		buf.push('??',node.nodeName);
	}
}
function importNode(doc,node,deep){
	var node2;
	switch (node.nodeType) {
	case ELEMENT_NODE:
		node2 = node.cloneNode(false);
		node2.ownerDocument = doc;
		//var attrs = node2.attributes;
		//var len = attrs.length;
		//for(var i=0;i<len;i++){
			//node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
		//}
	case DOCUMENT_FRAGMENT_NODE:
		break;
	case ATTRIBUTE_NODE:
		deep = true;
		break;
	//case ENTITY_REFERENCE_NODE:
	//case PROCESSING_INSTRUCTION_NODE:
	////case TEXT_NODE:
	//case CDATA_SECTION_NODE:
	//case COMMENT_NODE:
	//	deep = false;
	//	break;
	//case DOCUMENT_NODE:
	//case DOCUMENT_TYPE_NODE:
	//cannot be imported.
	//case ENTITY_NODE:
	//case NOTATION_NODE：
	//can not hit in level3
	//default:throw e;
	}
	if(!node2){
		node2 = node.cloneNode(false);//false
	}
	node2.ownerDocument = doc;
	node2.parentNode = null;
	if(deep){
		var child = node.firstChild;
		while(child){
			node2.appendChild(importNode(doc,child,deep));
			child = child.nextSibling;
		}
	}
	return node2;
}
//
//var _relationMap = {firstChild:1,lastChild:1,previousSibling:1,nextSibling:1,
//					attributes:1,childNodes:1,parentNode:1,documentElement:1,doctype,};
function cloneNode(doc,node,deep){
	var node2 = new node.constructor();
	for (var n in node) {
		if (Object.prototype.hasOwnProperty.call(node, n)) {
			var v = node[n];
			if (typeof v != "object") {
				if (v != node2[n]) {
					node2[n] = v;
				}
			}
		}
	}
	if(node.childNodes){
		node2.childNodes = new NodeList();
	}
	node2.ownerDocument = doc;
	switch (node2.nodeType) {
	case ELEMENT_NODE:
		var attrs	= node.attributes;
		var attrs2	= node2.attributes = new NamedNodeMap();
		var len = attrs.length
		attrs2._ownerElement = node2;
		for(var i=0;i<len;i++){
			node2.setAttributeNode(cloneNode(doc,attrs.item(i),true));
		}
		break;;
	case ATTRIBUTE_NODE:
		deep = true;
	}
	if(deep){
		var child = node.firstChild;
		while(child){
			node2.appendChild(cloneNode(doc,child,deep));
			child = child.nextSibling;
		}
	}
	return node2;
}

function __set__(object,key,value){
	object[key] = value
}
//do dynamic
try{
	if(Object.defineProperty){
		Object.defineProperty(LiveNodeList.prototype,'length',{
			get:function(){
				_updateLiveList(this);
				return this.$$length;
			}
		});

		Object.defineProperty(Node.prototype,'textContent',{
			get:function(){
				return getTextContent(this);
			},

			set:function(data){
				switch(this.nodeType){
				case ELEMENT_NODE:
				case DOCUMENT_FRAGMENT_NODE:
					while(this.firstChild){
						this.removeChild(this.firstChild);
					}
					if(data || String(data)){
						this.appendChild(this.ownerDocument.createTextNode(data));
					}
					break;

				default:
					this.data = data;
					this.value = data;
					this.nodeValue = data;
				}
			}
		})

		function getTextContent(node){
			switch(node.nodeType){
			case ELEMENT_NODE:
			case DOCUMENT_FRAGMENT_NODE:
				var buf = [];
				node = node.firstChild;
				while(node){
					if(node.nodeType!==7 && node.nodeType !==8){
						buf.push(getTextContent(node));
					}
					node = node.nextSibling;
				}
				return buf.join('');
			default:
				return node.nodeValue;
			}
		}

		__set__ = function(object,key,value){
			//console.log(value)
			object['$$'+key] = value
		}
	}
}catch(e){//ie8
}

//if(typeof require == 'function'){
	exports.DocumentType = DocumentType;
	exports.DOMException = DOMException;
	exports.DOMImplementation = DOMImplementation;
	exports.Element = Element;
	exports.Node = Node;
	exports.NodeList = NodeList;
	exports.XMLSerializer = XMLSerializer;
//}

},{"./conventions":41}],44:[function(require,module,exports){
var freeze = require('./conventions').freeze;

/**
 * The entities that are predefined in every XML document.
 *
 * @see https://www.w3.org/TR/2006/REC-xml11-20060816/#sec-predefined-ent W3C XML 1.1
 * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-predefined-ent W3C XML 1.0
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Predefined_entities_in_XML Wikipedia
 */
exports.XML_ENTITIES = freeze({amp:'&', apos:"'", gt:'>', lt:'<', quot:'"'})

/**
 * A map of currently 241 entities that are detected in an HTML document.
 * They contain all entries from `XML_ENTITIES`.
 *
 * @see XML_ENTITIES
 * @see DOMParser.parseFromString
 * @see DOMImplementation.prototype.createHTMLDocument
 * @see https://html.spec.whatwg.org/#named-character-references WHATWG HTML(5) Spec
 * @see https://www.w3.org/TR/xml-entity-names/ W3C XML Entity Names
 * @see https://www.w3.org/TR/html4/sgml/entities.html W3C HTML4/SGML
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Character_entity_references_in_HTML Wikipedia (HTML)
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Entities_representing_special_characters_in_XHTML Wikpedia (XHTML)
 */
exports.HTML_ENTITIES = freeze({
       lt: '<',
       gt: '>',
       amp: '&',
       quot: '"',
       apos: "'",
       Agrave: "À",
       Aacute: "Á",
       Acirc: "Â",
       Atilde: "Ã",
       Auml: "Ä",
       Aring: "Å",
       AElig: "Æ",
       Ccedil: "Ç",
       Egrave: "È",
       Eacute: "É",
       Ecirc: "Ê",
       Euml: "Ë",
       Igrave: "Ì",
       Iacute: "Í",
       Icirc: "Î",
       Iuml: "Ï",
       ETH: "Ð",
       Ntilde: "Ñ",
       Ograve: "Ò",
       Oacute: "Ó",
       Ocirc: "Ô",
       Otilde: "Õ",
       Ouml: "Ö",
       Oslash: "Ø",
       Ugrave: "Ù",
       Uacute: "Ú",
       Ucirc: "Û",
       Uuml: "Ü",
       Yacute: "Ý",
       THORN: "Þ",
       szlig: "ß",
       agrave: "à",
       aacute: "á",
       acirc: "â",
       atilde: "ã",
       auml: "ä",
       aring: "å",
       aelig: "æ",
       ccedil: "ç",
       egrave: "è",
       eacute: "é",
       ecirc: "ê",
       euml: "ë",
       igrave: "ì",
       iacute: "í",
       icirc: "î",
       iuml: "ï",
       eth: "ð",
       ntilde: "ñ",
       ograve: "ò",
       oacute: "ó",
       ocirc: "ô",
       otilde: "õ",
       ouml: "ö",
       oslash: "ø",
       ugrave: "ù",
       uacute: "ú",
       ucirc: "û",
       uuml: "ü",
       yacute: "ý",
       thorn: "þ",
       yuml: "ÿ",
       nbsp: "\u00a0",
       iexcl: "¡",
       cent: "¢",
       pound: "£",
       curren: "¤",
       yen: "¥",
       brvbar: "¦",
       sect: "§",
       uml: "¨",
       copy: "©",
       ordf: "ª",
       laquo: "«",
       not: "¬",
       shy: "­­",
       reg: "®",
       macr: "¯",
       deg: "°",
       plusmn: "±",
       sup2: "²",
       sup3: "³",
       acute: "´",
       micro: "µ",
       para: "¶",
       middot: "·",
       cedil: "¸",
       sup1: "¹",
       ordm: "º",
       raquo: "»",
       frac14: "¼",
       frac12: "½",
       frac34: "¾",
       iquest: "¿",
       times: "×",
       divide: "÷",
       forall: "∀",
       part: "∂",
       exist: "∃",
       empty: "∅",
       nabla: "∇",
       isin: "∈",
       notin: "∉",
       ni: "∋",
       prod: "∏",
       sum: "∑",
       minus: "−",
       lowast: "∗",
       radic: "√",
       prop: "∝",
       infin: "∞",
       ang: "∠",
       and: "∧",
       or: "∨",
       cap: "∩",
       cup: "∪",
       'int': "∫",
       there4: "∴",
       sim: "∼",
       cong: "≅",
       asymp: "≈",
       ne: "≠",
       equiv: "≡",
       le: "≤",
       ge: "≥",
       sub: "⊂",
       sup: "⊃",
       nsub: "⊄",
       sube: "⊆",
       supe: "⊇",
       oplus: "⊕",
       otimes: "⊗",
       perp: "⊥",
       sdot: "⋅",
       Alpha: "Α",
       Beta: "Β",
       Gamma: "Γ",
       Delta: "Δ",
       Epsilon: "Ε",
       Zeta: "Ζ",
       Eta: "Η",
       Theta: "Θ",
       Iota: "Ι",
       Kappa: "Κ",
       Lambda: "Λ",
       Mu: "Μ",
       Nu: "Ν",
       Xi: "Ξ",
       Omicron: "Ο",
       Pi: "Π",
       Rho: "Ρ",
       Sigma: "Σ",
       Tau: "Τ",
       Upsilon: "Υ",
       Phi: "Φ",
       Chi: "Χ",
       Psi: "Ψ",
       Omega: "Ω",
       alpha: "α",
       beta: "β",
       gamma: "γ",
       delta: "δ",
       epsilon: "ε",
       zeta: "ζ",
       eta: "η",
       theta: "θ",
       iota: "ι",
       kappa: "κ",
       lambda: "λ",
       mu: "μ",
       nu: "ν",
       xi: "ξ",
       omicron: "ο",
       pi: "π",
       rho: "ρ",
       sigmaf: "ς",
       sigma: "σ",
       tau: "τ",
       upsilon: "υ",
       phi: "φ",
       chi: "χ",
       psi: "ψ",
       omega: "ω",
       thetasym: "ϑ",
       upsih: "ϒ",
       piv: "ϖ",
       OElig: "Œ",
       oelig: "œ",
       Scaron: "Š",
       scaron: "š",
       Yuml: "Ÿ",
       fnof: "ƒ",
       circ: "ˆ",
       tilde: "˜",
       ensp: " ",
       emsp: " ",
       thinsp: " ",
       zwnj: "‌",
       zwj: "‍",
       lrm: "‎",
       rlm: "‏",
       ndash: "–",
       mdash: "—",
       lsquo: "‘",
       rsquo: "’",
       sbquo: "‚",
       ldquo: "“",
       rdquo: "”",
       bdquo: "„",
       dagger: "†",
       Dagger: "‡",
       bull: "•",
       hellip: "…",
       permil: "‰",
       prime: "′",
       Prime: "″",
       lsaquo: "‹",
       rsaquo: "›",
       oline: "‾",
       euro: "€",
       trade: "™",
       larr: "←",
       uarr: "↑",
       rarr: "→",
       darr: "↓",
       harr: "↔",
       crarr: "↵",
       lceil: "⌈",
       rceil: "⌉",
       lfloor: "⌊",
       rfloor: "⌋",
       loz: "◊",
       spades: "♠",
       clubs: "♣",
       hearts: "♥",
       diams: "♦"
});

/**
 * @deprecated use `HTML_ENTITIES` instead
 * @see HTML_ENTITIES
 */
exports.entityMap = exports.HTML_ENTITIES

},{"./conventions":41}],45:[function(require,module,exports){
var dom = require('./dom')
exports.DOMImplementation = dom.DOMImplementation
exports.XMLSerializer = dom.XMLSerializer
exports.DOMParser = require('./dom-parser').DOMParser

},{"./dom":43,"./dom-parser":42}],46:[function(require,module,exports){
var NAMESPACE = require("./conventions").NAMESPACE;

//[4]   	NameStartChar	   ::=   	":" | [A-Z] | "_" | [a-z] | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x2FF] | [#x370-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
//[4a]   	NameChar	   ::=   	NameStartChar | "-" | "." | [0-9] | #xB7 | [#x0300-#x036F] | [#x203F-#x2040]
//[5]   	Name	   ::=   	NameStartChar (NameChar)*
var nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]///\u10000-\uEFFFF
var nameChar = new RegExp("[\\-\\.0-9"+nameStartChar.source.slice(1,-1)+"\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
var tagNamePattern = new RegExp('^'+nameStartChar.source+nameChar.source+'*(?:\:'+nameStartChar.source+nameChar.source+'*)?$');
//var tagNamePattern = /^[a-zA-Z_][\w\-\.]*(?:\:[a-zA-Z_][\w\-\.]*)?$/
//var handlers = 'resolveEntity,getExternalSubset,characters,endDocument,endElement,endPrefixMapping,ignorableWhitespace,processingInstruction,setDocumentLocator,skippedEntity,startDocument,startElement,startPrefixMapping,notationDecl,unparsedEntityDecl,error,fatalError,warning,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,comment,endCDATA,endDTD,endEntity,startCDATA,startDTD,startEntity'.split(',')

//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
var S_TAG = 0;//tag name offerring
var S_ATTR = 1;//attr name offerring
var S_ATTR_SPACE=2;//attr name end and space offer
var S_EQ = 3;//=space?
var S_ATTR_NOQUOT_VALUE = 4;//attr value(no quot value only)
var S_ATTR_END = 5;//attr value end and no space(quot end)
var S_TAG_SPACE = 6;//(attr value end || tag end ) && (space offer)
var S_TAG_CLOSE = 7;//closed el<el />

/**
 * Creates an error that will not be caught by XMLReader aka the SAX parser.
 *
 * @param {string} message
 * @param {any?} locator Optional, can provide details about the location in the source
 * @constructor
 */
function ParseError(message, locator) {
	this.message = message
	this.locator = locator
	if(Error.captureStackTrace) Error.captureStackTrace(this, ParseError);
}
ParseError.prototype = new Error();
ParseError.prototype.name = ParseError.name

function XMLReader(){

}

XMLReader.prototype = {
	parse:function(source,defaultNSMap,entityMap){
		var domBuilder = this.domBuilder;
		domBuilder.startDocument();
		_copy(defaultNSMap ,defaultNSMap = {})
		parse(source,defaultNSMap,entityMap,
				domBuilder,this.errorHandler);
		domBuilder.endDocument();
	}
}
function parse(source,defaultNSMapCopy,entityMap,domBuilder,errorHandler){
	function fixedFromCharCode(code) {
		// String.prototype.fromCharCode does not supports
		// > 2 bytes unicode chars directly
		if (code > 0xffff) {
			code -= 0x10000;
			var surrogate1 = 0xd800 + (code >> 10)
				, surrogate2 = 0xdc00 + (code & 0x3ff);

			return String.fromCharCode(surrogate1, surrogate2);
		} else {
			return String.fromCharCode(code);
		}
	}
	function entityReplacer(a){
		var k = a.slice(1,-1);
		if (Object.hasOwnProperty.call(entityMap, k)) {
			return entityMap[k];
		}else if(k.charAt(0) === '#'){
			return fixedFromCharCode(parseInt(k.substr(1).replace('x','0x')))
		}else{
			errorHandler.error('entity not found:'+a);
			return a;
		}
	}
	function appendText(end){//has some bugs
		if(end>start){
			var xt = source.substring(start,end).replace(/&#?\w+;/g,entityReplacer);
			locator&&position(start);
			domBuilder.characters(xt,0,end-start);
			start = end
		}
	}
	function position(p,m){
		while(p>=lineEnd && (m = linePattern.exec(source))){
			lineStart = m.index;
			lineEnd = lineStart + m[0].length;
			locator.lineNumber++;
			//console.log('line++:',locator,startPos,endPos)
		}
		locator.columnNumber = p-lineStart+1;
	}
	var lineStart = 0;
	var lineEnd = 0;
	var linePattern = /.*(?:\r\n?|\n)|.*$/g
	var locator = domBuilder.locator;

	var parseStack = [{currentNSMap:defaultNSMapCopy}]
	var closeMap = {};
	var start = 0;
	while(true){
		try{
			var tagStart = source.indexOf('<',start);
			if(tagStart<0){
				if(!source.substr(start).match(/^\s*$/)){
					var doc = domBuilder.doc;
	    			var text = doc.createTextNode(source.substr(start));
	    			doc.appendChild(text);
	    			domBuilder.currentElement = text;
				}
				return;
			}
			if(tagStart>start){
				appendText(tagStart);
			}
			switch(source.charAt(tagStart+1)){
			case '/':
				var end = source.indexOf('>',tagStart+3);
				var tagName = source.substring(tagStart + 2, end).replace(/[ \t\n\r]+$/g, '');
				var config = parseStack.pop();
				if(end<0){

	        		tagName = source.substring(tagStart+2).replace(/[\s<].*/,'');
	        		errorHandler.error("end tag name: "+tagName+' is not complete:'+config.tagName);
	        		end = tagStart+1+tagName.length;
	        	}else if(tagName.match(/\s</)){
	        		tagName = tagName.replace(/[\s<].*/,'');
	        		errorHandler.error("end tag name: "+tagName+' maybe not complete');
	        		end = tagStart+1+tagName.length;
				}
				var localNSMap = config.localNSMap;
				var endMatch = config.tagName == tagName;
				var endIgnoreCaseMach = endMatch || config.tagName&&config.tagName.toLowerCase() == tagName.toLowerCase()
		        if(endIgnoreCaseMach){
		        	domBuilder.endElement(config.uri,config.localName,tagName);
					if(localNSMap){
						for (var prefix in localNSMap) {
							if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) {
								domBuilder.endPrefixMapping(prefix);
							}
						}
					}
					if(!endMatch){
		            	errorHandler.fatalError("end tag name: "+tagName+' is not match the current start tagName:'+config.tagName ); // No known test case
					}
		        }else{
		        	parseStack.push(config)
		        }

				end++;
				break;
				// end elment
			case '?':// <?...?>
				locator&&position(tagStart);
				end = parseInstruction(source,tagStart,domBuilder);
				break;
			case '!':// <!doctype,<![CDATA,<!--
				locator&&position(tagStart);
				end = parseDCC(source,tagStart,domBuilder,errorHandler);
				break;
			default:
				locator&&position(tagStart);
				var el = new ElementAttributes();
				var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
				//elStartEnd
				var end = parseElementStartPart(source,tagStart,el,currentNSMap,entityReplacer,errorHandler);
				var len = el.length;


				if(!el.closed && fixSelfClosed(source,end,el.tagName,closeMap)){
					el.closed = true;
					if(!entityMap.nbsp){
						errorHandler.warning('unclosed xml attribute');
					}
				}
				if(locator && len){
					var locator2 = copyLocator(locator,{});
					//try{//attribute position fixed
					for(var i = 0;i<len;i++){
						var a = el[i];
						position(a.offset);
						a.locator = copyLocator(locator,{});
					}
					domBuilder.locator = locator2
					if(appendElement(el,domBuilder,currentNSMap)){
						parseStack.push(el)
					}
					domBuilder.locator = locator;
				}else{
					if(appendElement(el,domBuilder,currentNSMap)){
						parseStack.push(el)
					}
				}

				if (NAMESPACE.isHTML(el.uri) && !el.closed) {
					end = parseHtmlSpecialContent(source,end,el.tagName,entityReplacer,domBuilder)
				} else {
					end++;
				}
			}
		}catch(e){
			if (e instanceof ParseError) {
				throw e;
			}
			errorHandler.error('element parse error: '+e)
			end = -1;
		}
		if(end>start){
			start = end;
		}else{
			//TODO: 这里有可能sax回退，有位置错误风险
			appendText(Math.max(tagStart,start)+1);
		}
	}
}
function copyLocator(f,t){
	t.lineNumber = f.lineNumber;
	t.columnNumber = f.columnNumber;
	return t;
}

/**
 * @see #appendElement(source,elStartEnd,el,selfClosed,entityReplacer,domBuilder,parseStack);
 * @return end of the elementStartPart(end of elementEndPart for selfClosed el)
 */
function parseElementStartPart(source,start,el,currentNSMap,entityReplacer,errorHandler){

	/**
	 * @param {string} qname
	 * @param {string} value
	 * @param {number} startIndex
	 */
	function addAttribute(qname, value, startIndex) {
		if (el.attributeNames.hasOwnProperty(qname)) {
			errorHandler.fatalError('Attribute ' + qname + ' redefined')
		}
		el.addValue(
			qname,
			// @see https://www.w3.org/TR/xml/#AVNormalize
			// since the xmldom sax parser does not "interpret" DTD the following is not implemented:
			// - recursive replacement of (DTD) entity references
			// - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
			value.replace(/[\t\n\r]/g, ' ').replace(/&#?\w+;/g, entityReplacer),
			startIndex
		)
	}
	var attrName;
	var value;
	var p = ++start;
	var s = S_TAG;//status
	while(true){
		var c = source.charAt(p);
		switch(c){
		case '=':
			if(s === S_ATTR){//attrName
				attrName = source.slice(start,p);
				s = S_EQ;
			}else if(s === S_ATTR_SPACE){
				s = S_EQ;
			}else{
				//fatalError: equal must after attrName or space after attrName
				throw new Error('attribute equal must after attrName'); // No known test case
			}
			break;
		case '\'':
		case '"':
			if(s === S_EQ || s === S_ATTR //|| s == S_ATTR_SPACE
				){//equal
				if(s === S_ATTR){
					errorHandler.warning('attribute value must after "="')
					attrName = source.slice(start,p)
				}
				start = p+1;
				p = source.indexOf(c,start)
				if(p>0){
					value = source.slice(start, p);
					addAttribute(attrName, value, start-1);
					s = S_ATTR_END;
				}else{
					//fatalError: no end quot match
					throw new Error('attribute value no end \''+c+'\' match');
				}
			}else if(s == S_ATTR_NOQUOT_VALUE){
				value = source.slice(start, p);
				addAttribute(attrName, value, start);
				errorHandler.warning('attribute "'+attrName+'" missed start quot('+c+')!!');
				start = p+1;
				s = S_ATTR_END
			}else{
				//fatalError: no equal before
				throw new Error('attribute value must after "="'); // No known test case
			}
			break;
		case '/':
			switch(s){
			case S_TAG:
				el.setTagName(source.slice(start,p));
			case S_ATTR_END:
			case S_TAG_SPACE:
			case S_TAG_CLOSE:
				s =S_TAG_CLOSE;
				el.closed = true;
			case S_ATTR_NOQUOT_VALUE:
			case S_ATTR:
			case S_ATTR_SPACE:
				break;
			//case S_EQ:
			default:
				throw new Error("attribute invalid close char('/')") // No known test case
			}
			break;
		case ''://end document
			errorHandler.error('unexpected end of input');
			if(s == S_TAG){
				el.setTagName(source.slice(start,p));
			}
			return p;
		case '>':
			switch(s){
			case S_TAG:
				el.setTagName(source.slice(start,p));
			case S_ATTR_END:
			case S_TAG_SPACE:
			case S_TAG_CLOSE:
				break;//normal
			case S_ATTR_NOQUOT_VALUE://Compatible state
			case S_ATTR:
				value = source.slice(start,p);
				if(value.slice(-1) === '/'){
					el.closed  = true;
					value = value.slice(0,-1)
				}
			case S_ATTR_SPACE:
				if(s === S_ATTR_SPACE){
					value = attrName;
				}
				if(s == S_ATTR_NOQUOT_VALUE){
					errorHandler.warning('attribute "'+value+'" missed quot(")!');
					addAttribute(attrName, value, start)
				}else{
					if(!NAMESPACE.isHTML(currentNSMap['']) || !value.match(/^(?:disabled|checked|selected)$/i)){
						errorHandler.warning('attribute "'+value+'" missed value!! "'+value+'" instead!!')
					}
					addAttribute(value, value, start)
				}
				break;
			case S_EQ:
				throw new Error('attribute value missed!!');
			}
//			console.log(tagName,tagNamePattern,tagNamePattern.test(tagName))
			return p;
		/*xml space '\x20' | #x9 | #xD | #xA; */
		case '\u0080':
			c = ' ';
		default:
			if(c<= ' '){//space
				switch(s){
				case S_TAG:
					el.setTagName(source.slice(start,p));//tagName
					s = S_TAG_SPACE;
					break;
				case S_ATTR:
					attrName = source.slice(start,p)
					s = S_ATTR_SPACE;
					break;
				case S_ATTR_NOQUOT_VALUE:
					var value = source.slice(start, p);
					errorHandler.warning('attribute "'+value+'" missed quot(")!!');
					addAttribute(attrName, value, start)
				case S_ATTR_END:
					s = S_TAG_SPACE;
					break;
				//case S_TAG_SPACE:
				//case S_EQ:
				//case S_ATTR_SPACE:
				//	void();break;
				//case S_TAG_CLOSE:
					//ignore warning
				}
			}else{//not space
//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
				switch(s){
				//case S_TAG:void();break;
				//case S_ATTR:void();break;
				//case S_ATTR_NOQUOT_VALUE:void();break;
				case S_ATTR_SPACE:
					var tagName =  el.tagName;
					if (!NAMESPACE.isHTML(currentNSMap['']) || !attrName.match(/^(?:disabled|checked|selected)$/i)) {
						errorHandler.warning('attribute "'+attrName+'" missed value!! "'+attrName+'" instead2!!')
					}
					addAttribute(attrName, attrName, start);
					start = p;
					s = S_ATTR;
					break;
				case S_ATTR_END:
					errorHandler.warning('attribute space is required"'+attrName+'"!!')
				case S_TAG_SPACE:
					s = S_ATTR;
					start = p;
					break;
				case S_EQ:
					s = S_ATTR_NOQUOT_VALUE;
					start = p;
					break;
				case S_TAG_CLOSE:
					throw new Error("elements closed character '/' and '>' must be connected to");
				}
			}
		}//end outer switch
		//console.log('p++',p)
		p++;
	}
}
/**
 * @return true if has new namespace define
 */
function appendElement(el,domBuilder,currentNSMap){
	var tagName = el.tagName;
	var localNSMap = null;
	//var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
	var i = el.length;
	while(i--){
		var a = el[i];
		var qName = a.qName;
		var value = a.value;
		var nsp = qName.indexOf(':');
		if(nsp>0){
			var prefix = a.prefix = qName.slice(0,nsp);
			var localName = qName.slice(nsp+1);
			var nsPrefix = prefix === 'xmlns' && localName
		}else{
			localName = qName;
			prefix = null
			nsPrefix = qName === 'xmlns' && ''
		}
		//can not set prefix,because prefix !== ''
		a.localName = localName ;
		//prefix == null for no ns prefix attribute
		if(nsPrefix !== false){//hack!!
			if(localNSMap == null){
				localNSMap = {}
				//console.log(currentNSMap,0)
				_copy(currentNSMap,currentNSMap={})
				//console.log(currentNSMap,1)
			}
			currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
			a.uri = NAMESPACE.XMLNS
			domBuilder.startPrefixMapping(nsPrefix, value)
		}
	}
	var i = el.length;
	while(i--){
		a = el[i];
		var prefix = a.prefix;
		if(prefix){//no prefix attribute has no namespace
			if(prefix === 'xml'){
				a.uri = NAMESPACE.XML;
			}if(prefix !== 'xmlns'){
				a.uri = currentNSMap[prefix || '']

				//{console.log('###'+a.qName,domBuilder.locator.systemId+'',currentNSMap,a.uri)}
			}
		}
	}
	var nsp = tagName.indexOf(':');
	if(nsp>0){
		prefix = el.prefix = tagName.slice(0,nsp);
		localName = el.localName = tagName.slice(nsp+1);
	}else{
		prefix = null;//important!!
		localName = el.localName = tagName;
	}
	//no prefix element has default namespace
	var ns = el.uri = currentNSMap[prefix || ''];
	domBuilder.startElement(ns,localName,tagName,el);
	//endPrefixMapping and startPrefixMapping have not any help for dom builder
	//localNSMap = null
	if(el.closed){
		domBuilder.endElement(ns,localName,tagName);
		if(localNSMap){
			for (prefix in localNSMap) {
				if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) {
					domBuilder.endPrefixMapping(prefix);
				}
			}
		}
	}else{
		el.currentNSMap = currentNSMap;
		el.localNSMap = localNSMap;
		//parseStack.push(el);
		return true;
	}
}
function parseHtmlSpecialContent(source,elStartEnd,tagName,entityReplacer,domBuilder){
	if(/^(?:script|textarea)$/i.test(tagName)){
		var elEndStart =  source.indexOf('</'+tagName+'>',elStartEnd);
		var text = source.substring(elStartEnd+1,elEndStart);
		if(/[&<]/.test(text)){
			if(/^script$/i.test(tagName)){
				//if(!/\]\]>/.test(text)){
					//lexHandler.startCDATA();
					domBuilder.characters(text,0,text.length);
					//lexHandler.endCDATA();
					return elEndStart;
				//}
			}//}else{//text area
				text = text.replace(/&#?\w+;/g,entityReplacer);
				domBuilder.characters(text,0,text.length);
				return elEndStart;
			//}

		}
	}
	return elStartEnd+1;
}
function fixSelfClosed(source,elStartEnd,tagName,closeMap){
	//if(tagName in closeMap){
	var pos = closeMap[tagName];
	if(pos == null){
		//console.log(tagName)
		pos =  source.lastIndexOf('</'+tagName+'>')
		if(pos<elStartEnd){//忘记闭合
			pos = source.lastIndexOf('</'+tagName)
		}
		closeMap[tagName] =pos
	}
	return pos<elStartEnd;
	//}
}

function _copy (source, target) {
	for (var n in source) {
		if (Object.prototype.hasOwnProperty.call(source, n)) {
			target[n] = source[n];
		}
	}
}

function parseDCC(source,start,domBuilder,errorHandler){//sure start with '<!'
	var next= source.charAt(start+2)
	switch(next){
	case '-':
		if(source.charAt(start + 3) === '-'){
			var end = source.indexOf('-->',start+4);
			//append comment source.substring(4,end)//<!--
			if(end>start){
				domBuilder.comment(source,start+4,end-start-4);
				return end+3;
			}else{
				errorHandler.error("Unclosed comment");
				return -1;
			}
		}else{
			//error
			return -1;
		}
	default:
		if(source.substr(start+3,6) == 'CDATA['){
			var end = source.indexOf(']]>',start+9);
			domBuilder.startCDATA();
			domBuilder.characters(source,start+9,end-start-9);
			domBuilder.endCDATA()
			return end+3;
		}
		//<!DOCTYPE
		//startDTD(java.lang.String name, java.lang.String publicId, java.lang.String systemId)
		var matchs = split(source,start);
		var len = matchs.length;
		if(len>1 && /!doctype/i.test(matchs[0][0])){
			var name = matchs[1][0];
			var pubid = false;
			var sysid = false;
			if(len>3){
				if(/^public$/i.test(matchs[2][0])){
					pubid = matchs[3][0];
					sysid = len>4 && matchs[4][0];
				}else if(/^system$/i.test(matchs[2][0])){
					sysid = matchs[3][0];
				}
			}
			var lastMatch = matchs[len-1]
			domBuilder.startDTD(name, pubid, sysid);
			domBuilder.endDTD();

			return lastMatch.index+lastMatch[0].length
		}
	}
	return -1;
}



function parseInstruction(source,start,domBuilder){
	var end = source.indexOf('?>',start);
	if(end){
		var match = source.substring(start,end).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
		if(match){
			var len = match[0].length;
			domBuilder.processingInstruction(match[1], match[2]) ;
			return end+2;
		}else{//error
			return -1;
		}
	}
	return -1;
}

function ElementAttributes(){
	this.attributeNames = {}
}
ElementAttributes.prototype = {
	setTagName:function(tagName){
		if(!tagNamePattern.test(tagName)){
			throw new Error('invalid tagName:'+tagName)
		}
		this.tagName = tagName
	},
	addValue:function(qName, value, offset) {
		if(!tagNamePattern.test(qName)){
			throw new Error('invalid attribute:'+qName)
		}
		this.attributeNames[qName] = this.length;
		this[this.length++] = {qName:qName,value:value,offset:offset}
	},
	length:0,
	getLocalName:function(i){return this[i].localName},
	getLocator:function(i){return this[i].locator},
	getQName:function(i){return this[i].qName},
	getURI:function(i){return this[i].uri},
	getValue:function(i){return this[i].value}
//	,getIndex:function(uri, localName)){
//		if(localName){
//
//		}else{
//			var qName = uri
//		}
//	},
//	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
//	getType:function(uri,localName){}
//	getType:function(i){},
}



function split(source,start){
	var match;
	var buf = [];
	var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
	reg.lastIndex = start;
	reg.exec(source);//skip <
	while(match = reg.exec(source)){
		buf.push(match);
		if(match[1])return buf;
	}
}

exports.XMLReader = XMLReader;
exports.ParseError = ParseError;

},{"./conventions":41}],47:[function(require,module,exports){
'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}

},{}],48:[function(require,module,exports){
"use strict";
module.exports = function(Promise) {
var SomePromiseArray = Promise._SomePromiseArray;
function any(promises) {
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(1);
    ret.setUnwrap();
    ret.init();
    return promise;
}

Promise.any = function (promises) {
    return any(promises);
};

Promise.prototype.any = function () {
    return any(this);
};

};

},{}],49:[function(require,module,exports){
(function (process){
"use strict";
var firstLineError;
try {throw new Error(); } catch (e) {firstLineError = e;}
var schedule = require("./schedule");
var Queue = require("./queue");
var util = require("./util");

function Async() {
    this._customScheduler = false;
    this._isTickUsed = false;
    this._lateQueue = new Queue(16);
    this._normalQueue = new Queue(16);
    this._haveDrainedQueues = false;
    this._trampolineEnabled = true;
    var self = this;
    this.drainQueues = function () {
        self._drainQueues();
    };
    this._schedule = schedule;
}

Async.prototype.setScheduler = function(fn) {
    var prev = this._schedule;
    this._schedule = fn;
    this._customScheduler = true;
    return prev;
};

Async.prototype.hasCustomScheduler = function() {
    return this._customScheduler;
};

Async.prototype.enableTrampoline = function() {
    this._trampolineEnabled = true;
};

Async.prototype.disableTrampolineIfNecessary = function() {
    if (util.hasDevTools) {
        this._trampolineEnabled = false;
    }
};

Async.prototype.haveItemsQueued = function () {
    return this._isTickUsed || this._haveDrainedQueues;
};


Async.prototype.fatalError = function(e, isNode) {
    if (isNode) {
        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
            "\n");
        process.exit(2);
    } else {
        this.throwLater(e);
    }
};

Async.prototype.throwLater = function(fn, arg) {
    if (arguments.length === 1) {
        arg = fn;
        fn = function () { throw arg; };
    }
    if (typeof setTimeout !== "undefined") {
        setTimeout(function() {
            fn(arg);
        }, 0);
    } else try {
        this._schedule(function() {
            fn(arg);
        });
    } catch (e) {
        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
};

function AsyncInvokeLater(fn, receiver, arg) {
    this._lateQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncInvoke(fn, receiver, arg) {
    this._normalQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncSettlePromises(promise) {
    this._normalQueue._pushOne(promise);
    this._queueTick();
}

if (!util.hasDevTools) {
    Async.prototype.invokeLater = AsyncInvokeLater;
    Async.prototype.invoke = AsyncInvoke;
    Async.prototype.settlePromises = AsyncSettlePromises;
} else {
    Async.prototype.invokeLater = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvokeLater.call(this, fn, receiver, arg);
        } else {
            this._schedule(function() {
                setTimeout(function() {
                    fn.call(receiver, arg);
                }, 100);
            });
        }
    };

    Async.prototype.invoke = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvoke.call(this, fn, receiver, arg);
        } else {
            this._schedule(function() {
                fn.call(receiver, arg);
            });
        }
    };

    Async.prototype.settlePromises = function(promise) {
        if (this._trampolineEnabled) {
            AsyncSettlePromises.call(this, promise);
        } else {
            this._schedule(function() {
                promise._settlePromises();
            });
        }
    };
}

Async.prototype._drainQueue = function(queue) {
    while (queue.length() > 0) {
        var fn = queue.shift();
        if (typeof fn !== "function") {
            fn._settlePromises();
            continue;
        }
        var receiver = queue.shift();
        var arg = queue.shift();
        fn.call(receiver, arg);
    }
};

Async.prototype._drainQueues = function () {
    this._drainQueue(this._normalQueue);
    this._reset();
    this._haveDrainedQueues = true;
    this._drainQueue(this._lateQueue);
};

Async.prototype._queueTick = function () {
    if (!this._isTickUsed) {
        this._isTickUsed = true;
        this._schedule(this.drainQueues);
    }
};

Async.prototype._reset = function () {
    this._isTickUsed = false;
};

module.exports = Async;
module.exports.firstLineError = firstLineError;

}).call(this,require('_process'))
},{"./queue":72,"./schedule":75,"./util":82,"_process":101}],50:[function(require,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
var calledBind = false;
var rejectThis = function(_, e) {
    this._reject(e);
};

var targetRejected = function(e, context) {
    context.promiseRejectionQueued = true;
    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
};

var bindingResolved = function(thisArg, context) {
    if (((this._bitField & 50397184) === 0)) {
        this._resolveCallback(context.target);
    }
};

var bindingRejected = function(e, context) {
    if (!context.promiseRejectionQueued) this._reject(e);
};

Promise.prototype.bind = function (thisArg) {
    if (!calledBind) {
        calledBind = true;
        Promise.prototype._propagateFrom = debug.propagateFromFunction();
        Promise.prototype._boundValue = debug.boundValueFunction();
    }
    var maybePromise = tryConvertToPromise(thisArg);
    var ret = new Promise(INTERNAL);
    ret._propagateFrom(this, 1);
    var target = this._target();
    ret._setBoundTo(maybePromise);
    if (maybePromise instanceof Promise) {
        var context = {
            promiseRejectionQueued: false,
            promise: ret,
            target: target,
            bindingPromise: maybePromise
        };
        target._then(INTERNAL, targetRejected, undefined, ret, context);
        maybePromise._then(
            bindingResolved, bindingRejected, undefined, ret, context);
        ret._setOnCancel(maybePromise);
    } else {
        ret._resolveCallback(target);
    }
    return ret;
};

Promise.prototype._setBoundTo = function (obj) {
    if (obj !== undefined) {
        this._bitField = this._bitField | 2097152;
        this._boundTo = obj;
    } else {
        this._bitField = this._bitField & (~2097152);
    }
};

Promise.prototype._isBound = function () {
    return (this._bitField & 2097152) === 2097152;
};

Promise.bind = function (thisArg, value) {
    return Promise.resolve(value).bind(thisArg);
};
};

},{}],51:[function(require,module,exports){
"use strict";
var cr = Object.create;
if (cr) {
    var callerCache = cr(null);
    var getterCache = cr(null);
    callerCache[" size"] = getterCache[" size"] = 0;
}

module.exports = function(Promise) {
var util = require("./util");
var canEvaluate = util.canEvaluate;
var isIdentifier = util.isIdentifier;

var getMethodCaller;
var getGetter;
if (true) {
var makeMethodCaller = function (methodName) {
    return new Function("ensureMethod", "                                    \n\
        return function(obj) {                                               \n\
            'use strict'                                                     \n\
            var len = this.length;                                           \n\
            ensureMethod(obj, 'methodName');                                 \n\
            switch(len) {                                                    \n\
                case 1: return obj.methodName(this[0]);                      \n\
                case 2: return obj.methodName(this[0], this[1]);             \n\
                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
                case 0: return obj.methodName();                             \n\
                default:                                                     \n\
                    return obj.methodName.apply(obj, this);                  \n\
            }                                                                \n\
        };                                                                   \n\
        ".replace(/methodName/g, methodName))(ensureMethod);
};

var makeGetter = function (propertyName) {
    return new Function("obj", "                                             \n\
        'use strict';                                                        \n\
        return obj.propertyName;                                             \n\
        ".replace("propertyName", propertyName));
};

var getCompiled = function(name, compiler, cache) {
    var ret = cache[name];
    if (typeof ret !== "function") {
        if (!isIdentifier(name)) {
            return null;
        }
        ret = compiler(name);
        cache[name] = ret;
        cache[" size"]++;
        if (cache[" size"] > 512) {
            var keys = Object.keys(cache);
            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
            cache[" size"] = keys.length - 256;
        }
    }
    return ret;
};

getMethodCaller = function(name) {
    return getCompiled(name, makeMethodCaller, callerCache);
};

getGetter = function(name) {
    return getCompiled(name, makeGetter, getterCache);
};
}

function ensureMethod(obj, methodName) {
    var fn;
    if (obj != null) fn = obj[methodName];
    if (typeof fn !== "function") {
        var message = "Object " + util.classString(obj) + " has no method '" +
            util.toString(methodName) + "'";
        throw new Promise.TypeError(message);
    }
    return fn;
}

function caller(obj) {
    var methodName = this.pop();
    var fn = ensureMethod(obj, methodName);
    return fn.apply(obj, this);
}
Promise.prototype.call = function (methodName) {
    var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
    if (true) {
        if (canEvaluate) {
            var maybeCaller = getMethodCaller(methodName);
            if (maybeCaller !== null) {
                return this._then(
                    maybeCaller, undefined, undefined, args, undefined);
            }
        }
    }
    args.push(methodName);
    return this._then(caller, undefined, undefined, args, undefined);
};

function namedGetter(obj) {
    return obj[this];
}
function indexedGetter(obj) {
    var index = +this;
    if (index < 0) index = Math.max(0, index + obj.length);
    return obj[index];
}
Promise.prototype.get = function (propertyName) {
    var isIndex = (typeof propertyName === "number");
    var getter;
    if (!isIndex) {
        if (canEvaluate) {
            var maybeGetter = getGetter(propertyName);
            getter = maybeGetter !== null ? maybeGetter : namedGetter;
        } else {
            getter = namedGetter;
        }
    } else {
        getter = indexedGetter;
    }
    return this._then(getter, undefined, undefined, propertyName, undefined);
};
};

},{"./util":82}],52:[function(require,module,exports){
"use strict";
module.exports = function(Promise, PromiseArray, apiRejection, debug) {
var util = require("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

Promise.prototype["break"] = Promise.prototype.cancel = function() {
    if (!debug.cancellation()) return this._warn("cancellation is disabled");

    var promise = this;
    var child = promise;
    while (promise._isCancellable()) {
        if (!promise._cancelBy(child)) {
            if (child._isFollowing()) {
                child._followee().cancel();
            } else {
                child._cancelBranched();
            }
            break;
        }

        var parent = promise._cancellationParent;
        if (parent == null || !parent._isCancellable()) {
            if (promise._isFollowing()) {
                promise._followee().cancel();
            } else {
                promise._cancelBranched();
            }
            break;
        } else {
            if (promise._isFollowing()) promise._followee().cancel();
            promise._setWillBeCancelled();
            child = promise;
            promise = parent;
        }
    }
};

Promise.prototype._branchHasCancelled = function() {
    this._branchesRemainingToCancel--;
};

Promise.prototype._enoughBranchesHaveCancelled = function() {
    return this._branchesRemainingToCancel === undefined ||
           this._branchesRemainingToCancel <= 0;
};

Promise.prototype._cancelBy = function(canceller) {
    if (canceller === this) {
        this._branchesRemainingToCancel = 0;
        this._invokeOnCancel();
        return true;
    } else {
        this._branchHasCancelled();
        if (this._enoughBranchesHaveCancelled()) {
            this._invokeOnCancel();
            return true;
        }
    }
    return false;
};

Promise.prototype._cancelBranched = function() {
    if (this._enoughBranchesHaveCancelled()) {
        this._cancel();
    }
};

Promise.prototype._cancel = function() {
    if (!this._isCancellable()) return;
    this._setCancelled();
    async.invoke(this._cancelPromises, this, undefined);
};

Promise.prototype._cancelPromises = function() {
    if (this._length() > 0) this._settlePromises();
};

Promise.prototype._unsetOnCancel = function() {
    this._onCancelField = undefined;
};

Promise.prototype._isCancellable = function() {
    return this.isPending() && !this._isCancelled();
};

Promise.prototype.isCancellable = function() {
    return this.isPending() && !this.isCancelled();
};

Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
    if (util.isArray(onCancelCallback)) {
        for (var i = 0; i < onCancelCallback.length; ++i) {
            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
        }
    } else if (onCancelCallback !== undefined) {
        if (typeof onCancelCallback === "function") {
            if (!internalOnly) {
                var e = tryCatch(onCancelCallback).call(this._boundValue());
                if (e === errorObj) {
                    this._attachExtraTrace(e.e);
                    async.throwLater(e.e);
                }
            }
        } else {
            onCancelCallback._resultCancelled(this);
        }
    }
};

Promise.prototype._invokeOnCancel = function() {
    var onCancelCallback = this._onCancel();
    this._unsetOnCancel();
    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
};

Promise.prototype._invokeInternalOnCancel = function() {
    if (this._isCancellable()) {
        this._doInvokeOnCancel(this._onCancel(), true);
        this._unsetOnCancel();
    }
};

Promise.prototype._resultCancelled = function() {
    this.cancel();
};

};

},{"./util":82}],53:[function(require,module,exports){
"use strict";
module.exports = function(NEXT_FILTER) {
var util = require("./util");
var getKeys = require("./es5").keys;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function catchFilter(instances, cb, promise) {
    return function(e) {
        var boundTo = promise._boundValue();
        predicateLoop: for (var i = 0; i < instances.length; ++i) {
            var item = instances[i];

            if (item === Error ||
                (item != null && item.prototype instanceof Error)) {
                if (e instanceof item) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (typeof item === "function") {
                var matchesPredicate = tryCatch(item).call(boundTo, e);
                if (matchesPredicate === errorObj) {
                    return matchesPredicate;
                } else if (matchesPredicate) {
                    return tryCatch(cb).call(boundTo, e);
                }
            } else if (util.isObject(e)) {
                var keys = getKeys(item);
                for (var j = 0; j < keys.length; ++j) {
                    var key = keys[j];
                    if (item[key] != e[key]) {
                        continue predicateLoop;
                    }
                }
                return tryCatch(cb).call(boundTo, e);
            }
        }
        return NEXT_FILTER;
    };
}

return catchFilter;
};

},{"./es5":59,"./util":82}],54:[function(require,module,exports){
"use strict";
module.exports = function(Promise) {
var longStackTraces = false;
var contextStack = [];

Promise.prototype._promiseCreated = function() {};
Promise.prototype._pushContext = function() {};
Promise.prototype._popContext = function() {return null;};
Promise._peekContext = Promise.prototype._peekContext = function() {};

function Context() {
    this._trace = new Context.CapturedTrace(peekContext());
}
Context.prototype._pushContext = function () {
    if (this._trace !== undefined) {
        this._trace._promiseCreated = null;
        contextStack.push(this._trace);
    }
};

Context.prototype._popContext = function () {
    if (this._trace !== undefined) {
        var trace = contextStack.pop();
        var ret = trace._promiseCreated;
        trace._promiseCreated = null;
        return ret;
    }
    return null;
};

function createContext() {
    if (longStackTraces) return new Context();
}

function peekContext() {
    var lastIndex = contextStack.length - 1;
    if (lastIndex >= 0) {
        return contextStack[lastIndex];
    }
    return undefined;
}
Context.CapturedTrace = null;
Context.create = createContext;
Context.deactivateLongStackTraces = function() {};
Context.activateLongStackTraces = function() {
    var Promise_pushContext = Promise.prototype._pushContext;
    var Promise_popContext = Promise.prototype._popContext;
    var Promise_PeekContext = Promise._peekContext;
    var Promise_peekContext = Promise.prototype._peekContext;
    var Promise_promiseCreated = Promise.prototype._promiseCreated;
    Context.deactivateLongStackTraces = function() {
        Promise.prototype._pushContext = Promise_pushContext;
        Promise.prototype._popContext = Promise_popContext;
        Promise._peekContext = Promise_PeekContext;
        Promise.prototype._peekContext = Promise_peekContext;
        Promise.prototype._promiseCreated = Promise_promiseCreated;
        longStackTraces = false;
    };
    longStackTraces = true;
    Promise.prototype._pushContext = Context.prototype._pushContext;
    Promise.prototype._popContext = Context.prototype._popContext;
    Promise._peekContext = Promise.prototype._peekContext = peekContext;
    Promise.prototype._promiseCreated = function() {
        var ctx = this._peekContext();
        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
    };
};
return Context;
};

},{}],55:[function(require,module,exports){
(function (process){
"use strict";
module.exports = function(Promise, Context) {
var getDomain = Promise._getDomain;
var async = Promise._async;
var Warning = require("./errors").Warning;
var util = require("./util");
var canAttachTrace = util.canAttachTrace;
var unhandledRejectionHandled;
var possiblyUnhandledRejection;
var bluebirdFramePattern =
    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
var stackFramePattern = null;
var formatStack = null;
var indentStackFrames = false;
var printWarning;
var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
                        (false ||
                         util.env("BLUEBIRD_DEBUG") ||
                         util.env("NODE_ENV") === "development"));

var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
    (debugging || util.env("BLUEBIRD_WARNINGS")));

var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));

var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));

Promise.prototype.suppressUnhandledRejections = function() {
    var target = this._target();
    target._bitField = ((target._bitField & (~1048576)) |
                      524288);
};

Promise.prototype._ensurePossibleRejectionHandled = function () {
    if ((this._bitField & 524288) !== 0) return;
    this._setRejectionIsUnhandled();
    async.invokeLater(this._notifyUnhandledRejection, this, undefined);
};

Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
    fireRejectionEvent("rejectionHandled",
                                  unhandledRejectionHandled, undefined, this);
};

Promise.prototype._setReturnedNonUndefined = function() {
    this._bitField = this._bitField | 268435456;
};

Promise.prototype._returnedNonUndefined = function() {
    return (this._bitField & 268435456) !== 0;
};

Promise.prototype._notifyUnhandledRejection = function () {
    if (this._isRejectionUnhandled()) {
        var reason = this._settledValue();
        this._setUnhandledRejectionIsNotified();
        fireRejectionEvent("unhandledRejection",
                                      possiblyUnhandledRejection, reason, this);
    }
};

Promise.prototype._setUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField | 262144;
};

Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField & (~262144);
};

Promise.prototype._isUnhandledRejectionNotified = function () {
    return (this._bitField & 262144) > 0;
};

Promise.prototype._setRejectionIsUnhandled = function () {
    this._bitField = this._bitField | 1048576;
};

Promise.prototype._unsetRejectionIsUnhandled = function () {
    this._bitField = this._bitField & (~1048576);
    if (this._isUnhandledRejectionNotified()) {
        this._unsetUnhandledRejectionIsNotified();
        this._notifyUnhandledRejectionIsHandled();
    }
};

Promise.prototype._isRejectionUnhandled = function () {
    return (this._bitField & 1048576) > 0;
};

Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
    return warn(message, shouldUseOwnTrace, promise || this);
};

Promise.onPossiblyUnhandledRejection = function (fn) {
    var domain = getDomain();
    possiblyUnhandledRejection =
        typeof fn === "function" ? (domain === null ?
                                            fn : util.domainBind(domain, fn))
                                 : undefined;
};

Promise.onUnhandledRejectionHandled = function (fn) {
    var domain = getDomain();
    unhandledRejectionHandled =
        typeof fn === "function" ? (domain === null ?
                                            fn : util.domainBind(domain, fn))
                                 : undefined;
};

var disableLongStackTraces = function() {};
Promise.longStackTraces = function () {
    if (async.haveItemsQueued() && !config.longStackTraces) {
        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    if (!config.longStackTraces && longStackTracesIsSupported()) {
        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
        config.longStackTraces = true;
        disableLongStackTraces = function() {
            if (async.haveItemsQueued() && !config.longStackTraces) {
                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
            }
            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
            Context.deactivateLongStackTraces();
            async.enableTrampoline();
            config.longStackTraces = false;
        };
        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
        Context.activateLongStackTraces();
        async.disableTrampolineIfNecessary();
    }
};

Promise.hasLongStackTraces = function () {
    return config.longStackTraces && longStackTracesIsSupported();
};

var fireDomEvent = (function() {
    try {
        if (typeof CustomEvent === "function") {
            var event = new CustomEvent("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = new CustomEvent(name.toLowerCase(), {
                    detail: event,
                    cancelable: true
                });
                return !util.global.dispatchEvent(domEvent);
            };
        } else if (typeof Event === "function") {
            var event = new Event("CustomEvent");
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = new Event(name.toLowerCase(), {
                    cancelable: true
                });
                domEvent.detail = event;
                return !util.global.dispatchEvent(domEvent);
            };
        } else {
            var event = document.createEvent("CustomEvent");
            event.initCustomEvent("testingtheevent", false, true, {});
            util.global.dispatchEvent(event);
            return function(name, event) {
                var domEvent = document.createEvent("CustomEvent");
                domEvent.initCustomEvent(name.toLowerCase(), false, true,
                    event);
                return !util.global.dispatchEvent(domEvent);
            };
        }
    } catch (e) {}
    return function() {
        return false;
    };
})();

var fireGlobalEvent = (function() {
    if (util.isNode) {
        return function() {
            return process.emit.apply(process, arguments);
        };
    } else {
        if (!util.global) {
            return function() {
                return false;
            };
        }
        return function(name) {
            var methodName = "on" + name.toLowerCase();
            var method = util.global[methodName];
            if (!method) return false;
            method.apply(util.global, [].slice.call(arguments, 1));
            return true;
        };
    }
})();

function generatePromiseLifecycleEventObject(name, promise) {
    return {promise: promise};
}

var eventToObjectGenerator = {
    promiseCreated: generatePromiseLifecycleEventObject,
    promiseFulfilled: generatePromiseLifecycleEventObject,
    promiseRejected: generatePromiseLifecycleEventObject,
    promiseResolved: generatePromiseLifecycleEventObject,
    promiseCancelled: generatePromiseLifecycleEventObject,
    promiseChained: function(name, promise, child) {
        return {promise: promise, child: child};
    },
    warning: function(name, warning) {
        return {warning: warning};
    },
    unhandledRejection: function (name, reason, promise) {
        return {reason: reason, promise: promise};
    },
    rejectionHandled: generatePromiseLifecycleEventObject
};

var activeFireEvent = function (name) {
    var globalEventFired = false;
    try {
        globalEventFired = fireGlobalEvent.apply(null, arguments);
    } catch (e) {
        async.throwLater(e);
        globalEventFired = true;
    }

    var domEventFired = false;
    try {
        domEventFired = fireDomEvent(name,
                    eventToObjectGenerator[name].apply(null, arguments));
    } catch (e) {
        async.throwLater(e);
        domEventFired = true;
    }

    return domEventFired || globalEventFired;
};

Promise.config = function(opts) {
    opts = Object(opts);
    if ("longStackTraces" in opts) {
        if (opts.longStackTraces) {
            Promise.longStackTraces();
        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
            disableLongStackTraces();
        }
    }
    if ("warnings" in opts) {
        var warningsOption = opts.warnings;
        config.warnings = !!warningsOption;
        wForgottenReturn = config.warnings;

        if (util.isObject(warningsOption)) {
            if ("wForgottenReturn" in warningsOption) {
                wForgottenReturn = !!warningsOption.wForgottenReturn;
            }
        }
    }
    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
        if (async.haveItemsQueued()) {
            throw new Error(
                "cannot enable cancellation after promises are in use");
        }
        Promise.prototype._clearCancellationData =
            cancellationClearCancellationData;
        Promise.prototype._propagateFrom = cancellationPropagateFrom;
        Promise.prototype._onCancel = cancellationOnCancel;
        Promise.prototype._setOnCancel = cancellationSetOnCancel;
        Promise.prototype._attachCancellationCallback =
            cancellationAttachCancellationCallback;
        Promise.prototype._execute = cancellationExecute;
        propagateFromFunction = cancellationPropagateFrom;
        config.cancellation = true;
    }
    if ("monitoring" in opts) {
        if (opts.monitoring && !config.monitoring) {
            config.monitoring = true;
            Promise.prototype._fireEvent = activeFireEvent;
        } else if (!opts.monitoring && config.monitoring) {
            config.monitoring = false;
            Promise.prototype._fireEvent = defaultFireEvent;
        }
    }
    return Promise;
};

function defaultFireEvent() { return false; }

Promise.prototype._fireEvent = defaultFireEvent;
Promise.prototype._execute = function(executor, resolve, reject) {
    try {
        executor(resolve, reject);
    } catch (e) {
        return e;
    }
};
Promise.prototype._onCancel = function () {};
Promise.prototype._setOnCancel = function (handler) { ; };
Promise.prototype._attachCancellationCallback = function(onCancel) {
    ;
};
Promise.prototype._captureStackTrace = function () {};
Promise.prototype._attachExtraTrace = function () {};
Promise.prototype._clearCancellationData = function() {};
Promise.prototype._propagateFrom = function (parent, flags) {
    ;
    ;
};

function cancellationExecute(executor, resolve, reject) {
    var promise = this;
    try {
        executor(resolve, reject, function(onCancel) {
            if (typeof onCancel !== "function") {
                throw new TypeError("onCancel must be a function, got: " +
                                    util.toString(onCancel));
            }
            promise._attachCancellationCallback(onCancel);
        });
    } catch (e) {
        return e;
    }
}

function cancellationAttachCancellationCallback(onCancel) {
    if (!this._isCancellable()) return this;

    var previousOnCancel = this._onCancel();
    if (previousOnCancel !== undefined) {
        if (util.isArray(previousOnCancel)) {
            previousOnCancel.push(onCancel);
        } else {
            this._setOnCancel([previousOnCancel, onCancel]);
        }
    } else {
        this._setOnCancel(onCancel);
    }
}

function cancellationOnCancel() {
    return this._onCancelField;
}

function cancellationSetOnCancel(onCancel) {
    this._onCancelField = onCancel;
}

function cancellationClearCancellationData() {
    this._cancellationParent = undefined;
    this._onCancelField = undefined;
}

function cancellationPropagateFrom(parent, flags) {
    if ((flags & 1) !== 0) {
        this._cancellationParent = parent;
        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
        if (branchesRemainingToCancel === undefined) {
            branchesRemainingToCancel = 0;
        }
        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
    }
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}

function bindingPropagateFrom(parent, flags) {
    if ((flags & 2) !== 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
}
var propagateFromFunction = bindingPropagateFrom;

function boundValueFunction() {
    var ret = this._boundTo;
    if (ret !== undefined) {
        if (ret instanceof Promise) {
            if (ret.isFulfilled()) {
                return ret.value();
            } else {
                return undefined;
            }
        }
    }
    return ret;
}

function longStackTracesCaptureStackTrace() {
    this._trace = new CapturedTrace(this._peekContext());
}

function longStackTracesAttachExtraTrace(error, ignoreSelf) {
    if (canAttachTrace(error)) {
        var trace = this._trace;
        if (trace !== undefined) {
            if (ignoreSelf) trace = trace._parent;
        }
        if (trace !== undefined) {
            trace.attachExtraTrace(error);
        } else if (!error.__stackCleaned__) {
            var parsed = parseStackAndMessage(error);
            util.notEnumerableProp(error, "stack",
                parsed.message + "\n" + parsed.stack.join("\n"));
            util.notEnumerableProp(error, "__stackCleaned__", true);
        }
    }
}

function checkForgottenReturns(returnValue, promiseCreated, name, promise,
                               parent) {
    if (returnValue === undefined && promiseCreated !== null &&
        wForgottenReturn) {
        if (parent !== undefined && parent._returnedNonUndefined()) return;
        if ((promise._bitField & 65535) === 0) return;

        if (name) name = name + " ";
        var handlerLine = "";
        var creatorLine = "";
        if (promiseCreated._trace) {
            var traceLines = promiseCreated._trace.stack.split("\n");
            var stack = cleanStack(traceLines);
            for (var i = stack.length - 1; i >= 0; --i) {
                var line = stack[i];
                if (!nodeFramePattern.test(line)) {
                    var lineMatches = line.match(parseLinePattern);
                    if (lineMatches) {
                        handlerLine  = "at " + lineMatches[1] +
                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                    }
                    break;
                }
            }

            if (stack.length > 0) {
                var firstUserLine = stack[0];
                for (var i = 0; i < traceLines.length; ++i) {

                    if (traceLines[i] === firstUserLine) {
                        if (i > 0) {
                            creatorLine = "\n" + traceLines[i - 1];
                        }
                        break;
                    }
                }

            }
        }
        var msg = "a promise was created in a " + name +
            "handler " + handlerLine + "but was not returned from it, " +
            "see http://goo.gl/rRqMUw" +
            creatorLine;
        promise._warn(msg, true, promiseCreated);
    }
}

function deprecated(name, replacement) {
    var message = name +
        " is deprecated and will be removed in a future version.";
    if (replacement) message += " Use " + replacement + " instead.";
    return warn(message);
}

function warn(message, shouldUseOwnTrace, promise) {
    if (!config.warnings) return;
    var warning = new Warning(message);
    var ctx;
    if (shouldUseOwnTrace) {
        promise._attachExtraTrace(warning);
    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
        ctx.attachExtraTrace(warning);
    } else {
        var parsed = parseStackAndMessage(warning);
        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
    }

    if (!activeFireEvent("warning", warning)) {
        formatAndLogError(warning, "", true);
    }
}

function reconstructStack(message, stacks) {
    for (var i = 0; i < stacks.length - 1; ++i) {
        stacks[i].push("From previous event:");
        stacks[i] = stacks[i].join("\n");
    }
    if (i < stacks.length) {
        stacks[i] = stacks[i].join("\n");
    }
    return message + "\n" + stacks.join("\n");
}

function removeDuplicateOrEmptyJumps(stacks) {
    for (var i = 0; i < stacks.length; ++i) {
        if (stacks[i].length === 0 ||
            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
            stacks.splice(i, 1);
            i--;
        }
    }
}

function removeCommonRoots(stacks) {
    var current = stacks[0];
    for (var i = 1; i < stacks.length; ++i) {
        var prev = stacks[i];
        var currentLastIndex = current.length - 1;
        var currentLastLine = current[currentLastIndex];
        var commonRootMeetPoint = -1;

        for (var j = prev.length - 1; j >= 0; --j) {
            if (prev[j] === currentLastLine) {
                commonRootMeetPoint = j;
                break;
            }
        }

        for (var j = commonRootMeetPoint; j >= 0; --j) {
            var line = prev[j];
            if (current[currentLastIndex] === line) {
                current.pop();
                currentLastIndex--;
            } else {
                break;
            }
        }
        current = prev;
    }
}

function cleanStack(stack) {
    var ret = [];
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        var isTraceLine = "    (No stack trace)" === line ||
            stackFramePattern.test(line);
        var isInternalFrame = isTraceLine && shouldIgnore(line);
        if (isTraceLine && !isInternalFrame) {
            if (indentStackFrames && line.charAt(0) !== " ") {
                line = "    " + line;
            }
            ret.push(line);
        }
    }
    return ret;
}

function stackFramesAsArray(error) {
    var stack = error.stack.replace(/\s+$/g, "").split("\n");
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
            break;
        }
    }
    if (i > 0 && error.name != "SyntaxError") {
        stack = stack.slice(i);
    }
    return stack;
}

function parseStackAndMessage(error) {
    var stack = error.stack;
    var message = error.toString();
    stack = typeof stack === "string" && stack.length > 0
                ? stackFramesAsArray(error) : ["    (No stack trace)"];
    return {
        message: message,
        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
    };
}

function formatAndLogError(error, title, isSoft) {
    if (typeof console !== "undefined") {
        var message;
        if (util.isObject(error)) {
            var stack = error.stack;
            message = title + formatStack(stack, error);
        } else {
            message = title + String(error);
        }
        if (typeof printWarning === "function") {
            printWarning(message, isSoft);
        } else if (typeof console.log === "function" ||
            typeof console.log === "object") {
            console.log(message);
        }
    }
}

function fireRejectionEvent(name, localHandler, reason, promise) {
    var localEventFired = false;
    try {
        if (typeof localHandler === "function") {
            localEventFired = true;
            if (name === "rejectionHandled") {
                localHandler(promise);
            } else {
                localHandler(reason, promise);
            }
        }
    } catch (e) {
        async.throwLater(e);
    }

    if (name === "unhandledRejection") {
        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
            formatAndLogError(reason, "Unhandled rejection ");
        }
    } else {
        activeFireEvent(name, promise);
    }
}

function formatNonError(obj) {
    var str;
    if (typeof obj === "function") {
        str = "[function " +
            (obj.name || "anonymous") +
            "]";
    } else {
        str = obj && typeof obj.toString === "function"
            ? obj.toString() : util.toString(obj);
        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
        if (ruselessToString.test(str)) {
            try {
                var newStr = JSON.stringify(obj);
                str = newStr;
            }
            catch(e) {

            }
        }
        if (str.length === 0) {
            str = "(empty array)";
        }
    }
    return ("(<" + snip(str) + ">, no stack trace)");
}

function snip(str) {
    var maxChars = 41;
    if (str.length < maxChars) {
        return str;
    }
    return str.substr(0, maxChars - 3) + "...";
}

function longStackTracesIsSupported() {
    return typeof captureStackTrace === "function";
}

var shouldIgnore = function() { return false; };
var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
function parseLineInfo(line) {
    var matches = line.match(parseLineInfoRegex);
    if (matches) {
        return {
            fileName: matches[1],
            line: parseInt(matches[2], 10)
        };
    }
}

function setBounds(firstLineError, lastLineError) {
    if (!longStackTracesIsSupported()) return;
    var firstStackLines = firstLineError.stack.split("\n");
    var lastStackLines = lastLineError.stack.split("\n");
    var firstIndex = -1;
    var lastIndex = -1;
    var firstFileName;
    var lastFileName;
    for (var i = 0; i < firstStackLines.length; ++i) {
        var result = parseLineInfo(firstStackLines[i]);
        if (result) {
            firstFileName = result.fileName;
            firstIndex = result.line;
            break;
        }
    }
    for (var i = 0; i < lastStackLines.length; ++i) {
        var result = parseLineInfo(lastStackLines[i]);
        if (result) {
            lastFileName = result.fileName;
            lastIndex = result.line;
            break;
        }
    }
    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
        firstFileName !== lastFileName || firstIndex >= lastIndex) {
        return;
    }

    shouldIgnore = function(line) {
        if (bluebirdFramePattern.test(line)) return true;
        var info = parseLineInfo(line);
        if (info) {
            if (info.fileName === firstFileName &&
                (firstIndex <= info.line && info.line <= lastIndex)) {
                return true;
            }
        }
        return false;
    };
}

function CapturedTrace(parent) {
    this._parent = parent;
    this._promisesCreated = 0;
    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
    captureStackTrace(this, CapturedTrace);
    if (length > 32) this.uncycle();
}
util.inherits(CapturedTrace, Error);
Context.CapturedTrace = CapturedTrace;

CapturedTrace.prototype.uncycle = function() {
    var length = this._length;
    if (length < 2) return;
    var nodes = [];
    var stackToIndex = {};

    for (var i = 0, node = this; node !== undefined; ++i) {
        nodes.push(node);
        node = node._parent;
    }
    length = this._length = i;
    for (var i = length - 1; i >= 0; --i) {
        var stack = nodes[i].stack;
        if (stackToIndex[stack] === undefined) {
            stackToIndex[stack] = i;
        }
    }
    for (var i = 0; i < length; ++i) {
        var currentStack = nodes[i].stack;
        var index = stackToIndex[currentStack];
        if (index !== undefined && index !== i) {
            if (index > 0) {
                nodes[index - 1]._parent = undefined;
                nodes[index - 1]._length = 1;
            }
            nodes[i]._parent = undefined;
            nodes[i]._length = 1;
            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;

            if (index < length - 1) {
                cycleEdgeNode._parent = nodes[index + 1];
                cycleEdgeNode._parent.uncycle();
                cycleEdgeNode._length =
                    cycleEdgeNode._parent._length + 1;
            } else {
                cycleEdgeNode._parent = undefined;
                cycleEdgeNode._length = 1;
            }
            var currentChildLength = cycleEdgeNode._length + 1;
            for (var j = i - 2; j >= 0; --j) {
                nodes[j]._length = currentChildLength;
                currentChildLength++;
            }
            return;
        }
    }
};

CapturedTrace.prototype.attachExtraTrace = function(error) {
    if (error.__stackCleaned__) return;
    this.uncycle();
    var parsed = parseStackAndMessage(error);
    var message = parsed.message;
    var stacks = [parsed.stack];

    var trace = this;
    while (trace !== undefined) {
        stacks.push(cleanStack(trace.stack.split("\n")));
        trace = trace._parent;
    }
    removeCommonRoots(stacks);
    removeDuplicateOrEmptyJumps(stacks);
    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
    util.notEnumerableProp(error, "__stackCleaned__", true);
};

var captureStackTrace = (function stackDetection() {
    var v8stackFramePattern = /^\s*at\s*/;
    var v8stackFormatter = function(stack, error) {
        if (typeof stack === "string") return stack;

        if (error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    if (typeof Error.stackTraceLimit === "number" &&
        typeof Error.captureStackTrace === "function") {
        Error.stackTraceLimit += 6;
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        var captureStackTrace = Error.captureStackTrace;

        shouldIgnore = function(line) {
            return bluebirdFramePattern.test(line);
        };
        return function(receiver, ignoreUntil) {
            Error.stackTraceLimit += 6;
            captureStackTrace(receiver, ignoreUntil);
            Error.stackTraceLimit -= 6;
        };
    }
    var err = new Error();

    if (typeof err.stack === "string" &&
        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
        stackFramePattern = /@/;
        formatStack = v8stackFormatter;
        indentStackFrames = true;
        return function captureStackTrace(o) {
            o.stack = new Error().stack;
        };
    }

    var hasStackAfterThrow;
    try { throw new Error(); }
    catch(e) {
        hasStackAfterThrow = ("stack" in e);
    }
    if (!("stack" in err) && hasStackAfterThrow &&
        typeof Error.stackTraceLimit === "number") {
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        return function captureStackTrace(o) {
            Error.stackTraceLimit += 6;
            try { throw new Error(); }
            catch(e) { o.stack = e.stack; }
            Error.stackTraceLimit -= 6;
        };
    }

    formatStack = function(stack, error) {
        if (typeof stack === "string") return stack;

        if ((typeof error === "object" ||
            typeof error === "function") &&
            error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    return null;

})([]);

if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
    printWarning = function (message) {
        console.warn(message);
    };
    if (util.isNode && process.stderr.isTTY) {
        printWarning = function(message, isSoft) {
            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
            console.warn(color + message + "\u001b[0m\n");
        };
    } else if (!util.isNode && typeof (new Error().stack) === "string") {
        printWarning = function(message, isSoft) {
            console.warn("%c" + message,
                        isSoft ? "color: darkorange" : "color: red");
        };
    }
}

var config = {
    warnings: warnings,
    longStackTraces: false,
    cancellation: false,
    monitoring: false
};

if (longStackTraces) Promise.longStackTraces();

return {
    longStackTraces: function() {
        return config.longStackTraces;
    },
    warnings: function() {
        return config.warnings;
    },
    cancellation: function() {
        return config.cancellation;
    },
    monitoring: function() {
        return config.monitoring;
    },
    propagateFromFunction: function() {
        return propagateFromFunction;
    },
    boundValueFunction: function() {
        return boundValueFunction;
    },
    checkForgottenReturns: checkForgottenReturns,
    setBounds: setBounds,
    warn: warn,
    deprecated: deprecated,
    CapturedTrace: CapturedTrace,
    fireDomEvent: fireDomEvent,
    fireGlobalEvent: fireGlobalEvent
};
};

}).call(this,require('_process'))
},{"./errors":58,"./util":82,"_process":101}],56:[function(require,module,exports){
"use strict";
module.exports = function(Promise) {
function returner() {
    return this.value;
}
function thrower() {
    throw this.reason;
}

Promise.prototype["return"] =
Promise.prototype.thenReturn = function (value) {
    if (value instanceof Promise) value.suppressUnhandledRejections();
    return this._then(
        returner, undefined, undefined, {value: value}, undefined);
};

Promise.prototype["throw"] =
Promise.prototype.thenThrow = function (reason) {
    return this._then(
        thrower, undefined, undefined, {reason: reason}, undefined);
};

Promise.prototype.catchThrow = function (reason) {
    if (arguments.length <= 1) {
        return this._then(
            undefined, thrower, undefined, {reason: reason}, undefined);
    } else {
        var _reason = arguments[1];
        var handler = function() {throw _reason;};
        return this.caught(reason, handler);
    }
};

Promise.prototype.catchReturn = function (value) {
    if (arguments.length <= 1) {
        if (value instanceof Promise) value.suppressUnhandledRejections();
        return this._then(
            undefined, returner, undefined, {value: value}, undefined);
    } else {
        var _value = arguments[1];
        if (_value instanceof Promise) _value.suppressUnhandledRejections();
        var handler = function() {return _value;};
        return this.caught(value, handler);
    }
};
};

},{}],57:[function(require,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseReduce = Promise.reduce;
var PromiseAll = Promise.all;

function promiseAllThis() {
    return PromiseAll(this);
}

function PromiseMapSeries(promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
}

Promise.prototype.each = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, this, undefined);
};

Promise.prototype.mapSeries = function (fn) {
    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
};

Promise.each = function (promises, fn) {
    return PromiseReduce(promises, fn, INTERNAL, 0)
              ._then(promiseAllThis, undefined, undefined, promises, undefined);
};

Promise.mapSeries = PromiseMapSeries;
};


},{}],58:[function(require,module,exports){
"use strict";
var es5 = require("./es5");
var Objectfreeze = es5.freeze;
var util = require("./util");
var inherits = util.inherits;
var notEnumerableProp = util.notEnumerableProp;

function subError(nameProperty, defaultMessage) {
    function SubError(message) {
        if (!(this instanceof SubError)) return new SubError(message);
        notEnumerableProp(this, "message",
            typeof message === "string" ? message : defaultMessage);
        notEnumerableProp(this, "name", nameProperty);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        } else {
            Error.call(this);
        }
    }
    inherits(SubError, Error);
    return SubError;
}

var _TypeError, _RangeError;
var Warning = subError("Warning", "warning");
var CancellationError = subError("CancellationError", "cancellation error");
var TimeoutError = subError("TimeoutError", "timeout error");
var AggregateError = subError("AggregateError", "aggregate error");
try {
    _TypeError = TypeError;
    _RangeError = RangeError;
} catch(e) {
    _TypeError = subError("TypeError", "type error");
    _RangeError = subError("RangeError", "range error");
}

var methods = ("join pop push shift unshift slice filter forEach some " +
    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");

for (var i = 0; i < methods.length; ++i) {
    if (typeof Array.prototype[methods[i]] === "function") {
        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
    }
}

es5.defineProperty(AggregateError.prototype, "length", {
    value: 0,
    configurable: false,
    writable: true,
    enumerable: true
});
AggregateError.prototype["isOperational"] = true;
var level = 0;
AggregateError.prototype.toString = function() {
    var indent = Array(level * 4 + 1).join(" ");
    var ret = "\n" + indent + "AggregateError of:" + "\n";
    level++;
    indent = Array(level * 4 + 1).join(" ");
    for (var i = 0; i < this.length; ++i) {
        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
        var lines = str.split("\n");
        for (var j = 0; j < lines.length; ++j) {
            lines[j] = indent + lines[j];
        }
        str = lines.join("\n");
        ret += str + "\n";
    }
    level--;
    return ret;
};

function OperationalError(message) {
    if (!(this instanceof OperationalError))
        return new OperationalError(message);
    notEnumerableProp(this, "name", "OperationalError");
    notEnumerableProp(this, "message", message);
    this.cause = message;
    this["isOperational"] = true;

    if (message instanceof Error) {
        notEnumerableProp(this, "message", message.message);
        notEnumerableProp(this, "stack", message.stack);
    } else if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
    }

}
inherits(OperationalError, Error);

var errorTypes = Error["__BluebirdErrorTypes__"];
if (!errorTypes) {
    errorTypes = Objectfreeze({
        CancellationError: CancellationError,
        TimeoutError: TimeoutError,
        OperationalError: OperationalError,
        RejectionError: OperationalError,
        AggregateError: AggregateError
    });
    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
        value: errorTypes,
        writable: false,
        enumerable: false,
        configurable: false
    });
}

module.exports = {
    Error: Error,
    TypeError: _TypeError,
    RangeError: _RangeError,
    CancellationError: errorTypes.CancellationError,
    OperationalError: errorTypes.OperationalError,
    TimeoutError: errorTypes.TimeoutError,
    AggregateError: errorTypes.AggregateError,
    Warning: Warning
};

},{"./es5":59,"./util":82}],59:[function(require,module,exports){
var isES5 = (function(){
    "use strict";
    return this === undefined;
})();

if (isES5) {
    module.exports = {
        freeze: Object.freeze,
        defineProperty: Object.defineProperty,
        getDescriptor: Object.getOwnPropertyDescriptor,
        keys: Object.keys,
        names: Object.getOwnPropertyNames,
        getPrototypeOf: Object.getPrototypeOf,
        isArray: Array.isArray,
        isES5: isES5,
        propertyIsWritable: function(obj, prop) {
            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
            return !!(!descriptor || descriptor.writable || descriptor.set);
        }
    };
} else {
    var has = {}.hasOwnProperty;
    var str = {}.toString;
    var proto = {}.constructor.prototype;

    var ObjectKeys = function (o) {
        var ret = [];
        for (var key in o) {
            if (has.call(o, key)) {
                ret.push(key);
            }
        }
        return ret;
    };

    var ObjectGetDescriptor = function(o, key) {
        return {value: o[key]};
    };

    var ObjectDefineProperty = function (o, key, desc) {
        o[key] = desc.value;
        return o;
    };

    var ObjectFreeze = function (obj) {
        return obj;
    };

    var ObjectGetPrototypeOf = function (obj) {
        try {
            return Object(obj).constructor.prototype;
        }
        catch (e) {
            return proto;
        }
    };

    var ArrayIsArray = function (obj) {
        try {
            return str.call(obj) === "[object Array]";
        }
        catch(e) {
            return false;
        }
    };

    module.exports = {
        isArray: ArrayIsArray,
        keys: ObjectKeys,
        names: ObjectKeys,
        defineProperty: ObjectDefineProperty,
        getDescriptor: ObjectGetDescriptor,
        freeze: ObjectFreeze,
        getPrototypeOf: ObjectGetPrototypeOf,
        isES5: isES5,
        propertyIsWritable: function() {
            return true;
        }
    };
}

},{}],60:[function(require,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseMap = Promise.map;

Promise.prototype.filter = function (fn, options) {
    return PromiseMap(this, fn, options, INTERNAL);
};

Promise.filter = function (promises, fn, options) {
    return PromiseMap(promises, fn, options, INTERNAL);
};
};

},{}],61:[function(require,module,exports){
"use strict";
module.exports = function(Promise, tryConvertToPromise) {
var util = require("./util");
var CancellationError = Promise.CancellationError;
var errorObj = util.errorObj;

function PassThroughHandlerContext(promise, type, handler) {
    this.promise = promise;
    this.type = type;
    this.handler = handler;
    this.called = false;
    this.cancelPromise = null;
}

PassThroughHandlerContext.prototype.isFinallyHandler = function() {
    return this.type === 0;
};

function FinallyHandlerCancelReaction(finallyHandler) {
    this.finallyHandler = finallyHandler;
}

FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
    checkCancel(this.finallyHandler);
};

function checkCancel(ctx, reason) {
    if (ctx.cancelPromise != null) {
        if (arguments.length > 1) {
            ctx.cancelPromise._reject(reason);
        } else {
            ctx.cancelPromise._cancel();
        }
        ctx.cancelPromise = null;
        return true;
    }
    return false;
}

function succeed() {
    return finallyHandler.call(this, this.promise._target()._settledValue());
}
function fail(reason) {
    if (checkCancel(this, reason)) return;
    errorObj.e = reason;
    return errorObj;
}
function finallyHandler(reasonOrValue) {
    var promise = this.promise;
    var handler = this.handler;

    if (!this.called) {
        this.called = true;
        var ret = this.isFinallyHandler()
            ? handler.call(promise._boundValue())
            : handler.call(promise._boundValue(), reasonOrValue);
        if (ret !== undefined) {
            promise._setReturnedNonUndefined();
            var maybePromise = tryConvertToPromise(ret, promise);
            if (maybePromise instanceof Promise) {
                if (this.cancelPromise != null) {
                    if (maybePromise._isCancelled()) {
                        var reason =
                            new CancellationError("late cancellation observer");
                        promise._attachExtraTrace(reason);
                        errorObj.e = reason;
                        return errorObj;
                    } else if (maybePromise.isPending()) {
                        maybePromise._attachCancellationCallback(
                            new FinallyHandlerCancelReaction(this));
                    }
                }
                return maybePromise._then(
                    succeed, fail, undefined, this, undefined);
            }
        }
    }

    if (promise.isRejected()) {
        checkCancel(this);
        errorObj.e = reasonOrValue;
        return errorObj;
    } else {
        checkCancel(this);
        return reasonOrValue;
    }
}

Promise.prototype._passThrough = function(handler, type, success, fail) {
    if (typeof handler !== "function") return this.then();
    return this._then(success,
                      fail,
                      undefined,
                      new PassThroughHandlerContext(this, type, handler),
                      undefined);
};

Promise.prototype.lastly =
Promise.prototype["finally"] = function (handler) {
    return this._passThrough(handler,
                             0,
                             finallyHandler,
                             finallyHandler);
};

Promise.prototype.tap = function (handler) {
    return this._passThrough(handler, 1, finallyHandler);
};

return PassThroughHandlerContext;
};

},{"./util":82}],62:[function(require,module,exports){
"use strict";
module.exports = function(Promise,
                          apiRejection,
                          INTERNAL,
                          tryConvertToPromise,
                          Proxyable,
                          debug) {
var errors = require("./errors");
var TypeError = errors.TypeError;
var util = require("./util");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
var yieldHandlers = [];

function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
    for (var i = 0; i < yieldHandlers.length; ++i) {
        traceParent._pushContext();
        var result = tryCatch(yieldHandlers[i])(value);
        traceParent._popContext();
        if (result === errorObj) {
            traceParent._pushContext();
            var ret = Promise.reject(errorObj.e);
            traceParent._popContext();
            return ret;
        }
        var maybePromise = tryConvertToPromise(result, traceParent);
        if (maybePromise instanceof Promise) return maybePromise;
    }
    return null;
}

function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
    if (debug.cancellation()) {
        var internal = new Promise(INTERNAL);
        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
        this._promise = internal.lastly(function() {
            return _finallyPromise;
        });
        internal._captureStackTrace();
        internal._setOnCancel(this);
    } else {
        var promise = this._promise = new Promise(INTERNAL);
        promise._captureStackTrace();
    }
    this._stack = stack;
    this._generatorFunction = generatorFunction;
    this._receiver = receiver;
    this._generator = undefined;
    this._yieldHandlers = typeof yieldHandler === "function"
        ? [yieldHandler].concat(yieldHandlers)
        : yieldHandlers;
    this._yieldedPromise = null;
    this._cancellationPhase = false;
}
util.inherits(PromiseSpawn, Proxyable);

PromiseSpawn.prototype._isResolved = function() {
    return this._promise === null;
};

PromiseSpawn.prototype._cleanup = function() {
    this._promise = this._generator = null;
    if (debug.cancellation() && this._finallyPromise !== null) {
        this._finallyPromise._fulfill();
        this._finallyPromise = null;
    }
};

PromiseSpawn.prototype._promiseCancelled = function() {
    if (this._isResolved()) return;
    var implementsReturn = typeof this._generator["return"] !== "undefined";

    var result;
    if (!implementsReturn) {
        var reason = new Promise.CancellationError(
            "generator .return() sentinel");
        Promise.coroutine.returnSentinel = reason;
        this._promise._attachExtraTrace(reason);
        this._promise._pushContext();
        result = tryCatch(this._generator["throw"]).call(this._generator,
                                                         reason);
        this._promise._popContext();
    } else {
        this._promise._pushContext();
        result = tryCatch(this._generator["return"]).call(this._generator,
                                                          undefined);
        this._promise._popContext();
    }
    this._cancellationPhase = true;
    this._yieldedPromise = null;
    this._continue(result);
};

PromiseSpawn.prototype._promiseFulfilled = function(value) {
    this._yieldedPromise = null;
    this._promise._pushContext();
    var result = tryCatch(this._generator.next).call(this._generator, value);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._promiseRejected = function(reason) {
    this._yieldedPromise = null;
    this._promise._attachExtraTrace(reason);
    this._promise._pushContext();
    var result = tryCatch(this._generator["throw"])
        .call(this._generator, reason);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._resultCancelled = function() {
    if (this._yieldedPromise instanceof Promise) {
        var promise = this._yieldedPromise;
        this._yieldedPromise = null;
        promise.cancel();
    }
};

PromiseSpawn.prototype.promise = function () {
    return this._promise;
};

PromiseSpawn.prototype._run = function () {
    this._generator = this._generatorFunction.call(this._receiver);
    this._receiver =
        this._generatorFunction = undefined;
    this._promiseFulfilled(undefined);
};

PromiseSpawn.prototype._continue = function (result) {
    var promise = this._promise;
    if (result === errorObj) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._rejectCallback(result.e, false);
        }
    }

    var value = result.value;
    if (result.done === true) {
        this._cleanup();
        if (this._cancellationPhase) {
            return promise.cancel();
        } else {
            return promise._resolveCallback(value);
        }
    } else {
        var maybePromise = tryConvertToPromise(value, this._promise);
        if (!(maybePromise instanceof Promise)) {
            maybePromise =
                promiseFromYieldHandler(maybePromise,
                                        this._yieldHandlers,
                                        this._promise);
            if (maybePromise === null) {
                this._promiseRejected(
                    new TypeError(
                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", value) +
                        "From coroutine:\u000a" +
                        this._stack.split("\n").slice(1, -7).join("\n")
                    )
                );
                return;
            }
        }
        maybePromise = maybePromise._target();
        var bitField = maybePromise._bitField;
        ;
        if (((bitField & 50397184) === 0)) {
            this._yieldedPromise = maybePromise;
            maybePromise._proxy(this, null);
        } else if (((bitField & 33554432) !== 0)) {
            Promise._async.invoke(
                this._promiseFulfilled, this, maybePromise._value()
            );
        } else if (((bitField & 16777216) !== 0)) {
            Promise._async.invoke(
                this._promiseRejected, this, maybePromise._reason()
            );
        } else {
            this._promiseCancelled();
        }
    }
};

Promise.coroutine = function (generatorFunction, options) {
    if (typeof generatorFunction !== "function") {
        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var yieldHandler = Object(options).yieldHandler;
    var PromiseSpawn$ = PromiseSpawn;
    var stack = new Error().stack;
    return function () {
        var generator = generatorFunction.apply(this, arguments);
        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
                                      stack);
        var ret = spawn.promise();
        spawn._generator = generator;
        spawn._promiseFulfilled(undefined);
        return ret;
    };
};

Promise.coroutine.addYieldHandler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    yieldHandlers.push(fn);
};

Promise.spawn = function (generatorFunction) {
    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
    if (typeof generatorFunction !== "function") {
        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var spawn = new PromiseSpawn(generatorFunction, this);
    var ret = spawn.promise();
    spawn._run(Promise.spawn);
    return ret;
};
};

},{"./errors":58,"./util":82}],63:[function(require,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async,
         getDomain) {
var util = require("./util");
var canEvaluate = util.canEvaluate;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var reject;

if (true) {
if (canEvaluate) {
    var thenCallback = function(i) {
        return new Function("value", "holder", "                             \n\
            'use strict';                                                    \n\
            holder.pIndex = value;                                           \n\
            holder.checkFulfillment(this);                                   \n\
            ".replace(/Index/g, i));
    };

    var promiseSetter = function(i) {
        return new Function("promise", "holder", "                           \n\
            'use strict';                                                    \n\
            holder.pIndex = promise;                                         \n\
            ".replace(/Index/g, i));
    };

    var generateHolderClass = function(total) {
        var props = new Array(total);
        for (var i = 0; i < props.length; ++i) {
            props[i] = "this.p" + (i+1);
        }
        var assignment = props.join(" = ") + " = null;";
        var cancellationCode= "var promise;\n" + props.map(function(prop) {
            return "                                                         \n\
                promise = " + prop + ";                                      \n\
                if (promise instanceof Promise) {                            \n\
                    promise.cancel();                                        \n\
                }                                                            \n\
            ";
        }).join("\n");
        var passedArguments = props.join(", ");
        var name = "Holder$" + total;


        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
            'use strict';                                                    \n\
            function [TheName](fn) {                                         \n\
                [TheProperties]                                              \n\
                this.fn = fn;                                                \n\
                this.asyncNeeded = true;                                     \n\
                this.now = 0;                                                \n\
            }                                                                \n\
                                                                             \n\
            [TheName].prototype._callFunction = function(promise) {          \n\
                promise._pushContext();                                      \n\
                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
                promise._popContext();                                       \n\
                if (ret === errorObj) {                                      \n\
                    promise._rejectCallback(ret.e, false);                   \n\
                } else {                                                     \n\
                    promise._resolveCallback(ret);                           \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype.checkFulfillment = function(promise) {       \n\
                var now = ++this.now;                                        \n\
                if (now === [TheTotal]) {                                    \n\
                    if (this.asyncNeeded) {                                  \n\
                        async.invoke(this._callFunction, this, promise);     \n\
                    } else {                                                 \n\
                        this._callFunction(promise);                         \n\
                    }                                                        \n\
                                                                             \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype._resultCancelled = function() {              \n\
                [CancellationCode]                                           \n\
            };                                                               \n\
                                                                             \n\
            return [TheName];                                                \n\
        }(tryCatch, errorObj, Promise, async);                               \n\
        ";

        code = code.replace(/\[TheName\]/g, name)
            .replace(/\[TheTotal\]/g, total)
            .replace(/\[ThePassedArguments\]/g, passedArguments)
            .replace(/\[TheProperties\]/g, assignment)
            .replace(/\[CancellationCode\]/g, cancellationCode);

        return new Function("tryCatch", "errorObj", "Promise", "async", code)
                           (tryCatch, errorObj, Promise, async);
    };

    var holderClasses = [];
    var thenCallbacks = [];
    var promiseSetters = [];

    for (var i = 0; i < 8; ++i) {
        holderClasses.push(generateHolderClass(i + 1));
        thenCallbacks.push(thenCallback(i + 1));
        promiseSetters.push(promiseSetter(i + 1));
    }

    reject = function (reason) {
        this._reject(reason);
    };
}}

Promise.join = function () {
    var last = arguments.length - 1;
    var fn;
    if (last > 0 && typeof arguments[last] === "function") {
        fn = arguments[last];
        if (true) {
            if (last <= 8 && canEvaluate) {
                var ret = new Promise(INTERNAL);
                ret._captureStackTrace();
                var HolderClass = holderClasses[last - 1];
                var holder = new HolderClass(fn);
                var callbacks = thenCallbacks;

                for (var i = 0; i < last; ++i) {
                    var maybePromise = tryConvertToPromise(arguments[i], ret);
                    if (maybePromise instanceof Promise) {
                        maybePromise = maybePromise._target();
                        var bitField = maybePromise._bitField;
                        ;
                        if (((bitField & 50397184) === 0)) {
                            maybePromise._then(callbacks[i], reject,
                                               undefined, ret, holder);
                            promiseSetters[i](maybePromise, holder);
                            holder.asyncNeeded = false;
                        } else if (((bitField & 33554432) !== 0)) {
                            callbacks[i].call(ret,
                                              maybePromise._value(), holder);
                        } else if (((bitField & 16777216) !== 0)) {
                            ret._reject(maybePromise._reason());
                        } else {
                            ret._cancel();
                        }
                    } else {
                        callbacks[i].call(ret, maybePromise, holder);
                    }
                }

                if (!ret._isFateSealed()) {
                    if (holder.asyncNeeded) {
                        var domain = getDomain();
                        if (domain !== null) {
                            holder.fn = util.domainBind(domain, holder.fn);
                        }
                    }
                    ret._setAsyncGuaranteed();
                    ret._setOnCancel(holder);
                }
                return ret;
            }
        }
    }
    var $_len = arguments.length;var args = new Array($_len); for(var $_i = 0; $_i < $_len; ++$_i) {args[$_i] = arguments[$_i];};
    if (fn) args.pop();
    var ret = new PromiseArray(args).promise();
    return fn !== undefined ? ret.spread(fn) : ret;
};

};

},{"./util":82}],64:[function(require,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var getDomain = Promise._getDomain;
var util = require("./util");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var async = Promise._async;

function MappingPromiseArray(promises, fn, limit, _filter) {
    this.constructor$(promises);
    this._promise._captureStackTrace();
    var domain = getDomain();
    this._callback = domain === null ? fn : util.domainBind(domain, fn);
    this._preservedValues = _filter === INTERNAL
        ? new Array(this.length())
        : null;
    this._limit = limit;
    this._inFlight = 0;
    this._queue = [];
    async.invoke(this._asyncInit, this, undefined);
}
util.inherits(MappingPromiseArray, PromiseArray);

MappingPromiseArray.prototype._asyncInit = function() {
    this._init$(undefined, -2);
};

MappingPromiseArray.prototype._init = function () {};

MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var values = this._values;
    var length = this.length();
    var preservedValues = this._preservedValues;
    var limit = this._limit;

    if (index < 0) {
        index = (index * -1) - 1;
        values[index] = value;
        if (limit >= 1) {
            this._inFlight--;
            this._drainQueue();
            if (this._isResolved()) return true;
        }
    } else {
        if (limit >= 1 && this._inFlight >= limit) {
            values[index] = value;
            this._queue.push(index);
            return false;
        }
        if (preservedValues !== null) preservedValues[index] = value;

        var promise = this._promise;
        var callback = this._callback;
        var receiver = promise._boundValue();
        promise._pushContext();
        var ret = tryCatch(callback).call(receiver, value, index, length);
        var promiseCreated = promise._popContext();
        debug.checkForgottenReturns(
            ret,
            promiseCreated,
            preservedValues !== null ? "Promise.filter" : "Promise.map",
            promise
        );
        if (ret === errorObj) {
            this._reject(ret.e);
            return true;
        }

        var maybePromise = tryConvertToPromise(ret, this._promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            var bitField = maybePromise._bitField;
            ;
            if (((bitField & 50397184) === 0)) {
                if (limit >= 1) this._inFlight++;
                values[index] = maybePromise;
                maybePromise._proxy(this, (index + 1) * -1);
                return false;
            } else if (((bitField & 33554432) !== 0)) {
                ret = maybePromise._value();
            } else if (((bitField & 16777216) !== 0)) {
                this._reject(maybePromise._reason());
                return true;
            } else {
                this._cancel();
                return true;
            }
        }
        values[index] = ret;
    }
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= length) {
        if (preservedValues !== null) {
            this._filter(values, preservedValues);
        } else {
            this._resolve(values);
        }
        return true;
    }
    return false;
};

MappingPromiseArray.prototype._drainQueue = function () {
    var queue = this._queue;
    var limit = this._limit;
    var values = this._values;
    while (queue.length > 0 && this._inFlight < limit) {
        if (this._isResolved()) return;
        var index = queue.pop();
        this._promiseFulfilled(values[index], index);
    }
};

MappingPromiseArray.prototype._filter = function (booleans, values) {
    var len = values.length;
    var ret = new Array(len);
    var j = 0;
    for (var i = 0; i < len; ++i) {
        if (booleans[i]) ret[j++] = values[i];
    }
    ret.length = j;
    this._resolve(ret);
};

MappingPromiseArray.prototype.preservedValues = function () {
    return this._preservedValues;
};

function map(promises, fn, options, _filter) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }

    var limit = 0;
    if (options !== undefined) {
        if (typeof options === "object" && options !== null) {
            if (typeof options.concurrency !== "number") {
                return Promise.reject(
                    new TypeError("'concurrency' must be a number but it is " +
                                    util.classString(options.concurrency)));
            }
            limit = options.concurrency;
        } else {
            return Promise.reject(new TypeError(
                            "options argument must be an object but it is " +
                             util.classString(options)));
        }
    }
    limit = typeof limit === "number" &&
        isFinite(limit) && limit >= 1 ? limit : 0;
    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
}

Promise.prototype.map = function (fn, options) {
    return map(this, fn, options, null);
};

Promise.map = function (promises, fn, options, _filter) {
    return map(promises, fn, options, _filter);
};


};

},{"./util":82}],65:[function(require,module,exports){
"use strict";
module.exports =
function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
var util = require("./util");
var tryCatch = util.tryCatch;

Promise.method = function (fn) {
    if (typeof fn !== "function") {
        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
    }
    return function () {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._pushContext();
        var value = tryCatch(fn).apply(this, arguments);
        var promiseCreated = ret._popContext();
        debug.checkForgottenReturns(
            value, promiseCreated, "Promise.method", ret);
        ret._resolveFromSyncValue(value);
        return ret;
    };
};

Promise.attempt = Promise["try"] = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._pushContext();
    var value;
    if (arguments.length > 1) {
        debug.deprecated("calling Promise.try with more than 1 argument");
        var arg = arguments[1];
        var ctx = arguments[2];
        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
                                  : tryCatch(fn).call(ctx, arg);
    } else {
        value = tryCatch(fn)();
    }
    var promiseCreated = ret._popContext();
    debug.checkForgottenReturns(
        value, promiseCreated, "Promise.try", ret);
    ret._resolveFromSyncValue(value);
    return ret;
};

Promise.prototype._resolveFromSyncValue = function (value) {
    if (value === util.errorObj) {
        this._rejectCallback(value.e, false);
    } else {
        this._resolveCallback(value, true);
    }
};
};

},{"./util":82}],66:[function(require,module,exports){
"use strict";
var util = require("./util");
var maybeWrapAsError = util.maybeWrapAsError;
var errors = require("./errors");
var OperationalError = errors.OperationalError;
var es5 = require("./es5");

function isUntypedError(obj) {
    return obj instanceof Error &&
        es5.getPrototypeOf(obj) === Error.prototype;
}

var rErrorKey = /^(?:name|message|stack|cause)$/;
function wrapAsOperationalError(obj) {
    var ret;
    if (isUntypedError(obj)) {
        ret = new OperationalError(obj);
        ret.name = obj.name;
        ret.message = obj.message;
        ret.stack = obj.stack;
        var keys = es5.keys(obj);
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!rErrorKey.test(key)) {
                ret[key] = obj[key];
            }
        }
        return ret;
    }
    util.markAsOriginatingFromRejection(obj);
    return obj;
}

function nodebackForPromise(promise, multiArgs) {
    return function(err, value) {
        if (promise === null) return;
        if (err) {
            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
            promise._attachExtraTrace(wrapped);
            promise._reject(wrapped);
        } else if (!multiArgs) {
            promise._fulfill(value);
        } else {
            var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
            promise._fulfill(args);
        }
        promise = null;
    };
}

module.exports = nodebackForPromise;

},{"./errors":58,"./es5":59,"./util":82}],67:[function(require,module,exports){
"use strict";
module.exports = function(Promise) {
var util = require("./util");
var async = Promise._async;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function spreadAdapter(val, nodeback) {
    var promise = this;
    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
    var ret =
        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

function successAdapter(val, nodeback) {
    var promise = this;
    var receiver = promise._boundValue();
    var ret = val === undefined
        ? tryCatch(nodeback).call(receiver, null)
        : tryCatch(nodeback).call(receiver, null, val);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}
function errorAdapter(reason, nodeback) {
    var promise = this;
    if (!reason) {
        var newReason = new Error(reason + "");
        newReason.cause = reason;
        reason = newReason;
    }
    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
                                                                     options) {
    if (typeof nodeback == "function") {
        var adapter = successAdapter;
        if (options !== undefined && Object(options).spread) {
            adapter = spreadAdapter;
        }
        this._then(
            adapter,
            errorAdapter,
            undefined,
            this,
            nodeback
        );
    }
    return this;
};
};

},{"./util":82}],68:[function(require,module,exports){
(function (process){
"use strict";
module.exports = function() {
var makeSelfResolutionError = function () {
    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var reflectHandler = function() {
    return new Promise.PromiseInspection(this._target());
};
var apiRejection = function(msg) {
    return Promise.reject(new TypeError(msg));
};
function Proxyable() {}
var UNDEFINED_BINDING = {};
var util = require("./util");

var getDomain;
if (util.isNode) {
    getDomain = function() {
        var ret = process.domain;
        if (ret === undefined) ret = null;
        return ret;
    };
} else {
    getDomain = function() {
        return null;
    };
}
util.notEnumerableProp(Promise, "_getDomain", getDomain);

var es5 = require("./es5");
var Async = require("./async");
var async = new Async();
es5.defineProperty(Promise, "_async", {value: async});
var errors = require("./errors");
var TypeError = Promise.TypeError = errors.TypeError;
Promise.RangeError = errors.RangeError;
var CancellationError = Promise.CancellationError = errors.CancellationError;
Promise.TimeoutError = errors.TimeoutError;
Promise.OperationalError = errors.OperationalError;
Promise.RejectionError = errors.OperationalError;
Promise.AggregateError = errors.AggregateError;
var INTERNAL = function(){};
var APPLY = {};
var NEXT_FILTER = {};
var tryConvertToPromise = require("./thenables")(Promise, INTERNAL);
var PromiseArray =
    require("./promise_array")(Promise, INTERNAL,
                               tryConvertToPromise, apiRejection, Proxyable);
var Context = require("./context")(Promise);
 /*jshint unused:false*/
var createContext = Context.create;
var debug = require("./debuggability")(Promise, Context);
var CapturedTrace = debug.CapturedTrace;
var PassThroughHandlerContext =
    require("./finally")(Promise, tryConvertToPromise);
var catchFilter = require("./catch_filter")(NEXT_FILTER);
var nodebackForPromise = require("./nodeback");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
function check(self, executor) {
    if (typeof executor !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(executor));
    }
    if (self.constructor !== Promise) {
        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
}

function Promise(executor) {
    this._bitField = 0;
    this._fulfillmentHandler0 = undefined;
    this._rejectionHandler0 = undefined;
    this._promise0 = undefined;
    this._receiver0 = undefined;
    if (executor !== INTERNAL) {
        check(this, executor);
        this._resolveFromExecutor(executor);
    }
    this._promiseCreated();
    this._fireEvent("promiseCreated", this);
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
    var len = arguments.length;
    if (len > 1) {
        var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (util.isObject(item)) {
                catchInstances[j++] = item;
            } else {
                return apiRejection("expecting an object but got " +
                    "A catch statement predicate " + util.classString(item));
            }
        }
        catchInstances.length = j;
        fn = arguments[i];
        return this.then(undefined, catchFilter(catchInstances, fn, this));
    }
    return this.then(undefined, fn);
};

Promise.prototype.reflect = function () {
    return this._then(reflectHandler,
        reflectHandler, undefined, this, undefined);
};

Promise.prototype.then = function (didFulfill, didReject) {
    if (debug.warnings() && arguments.length > 0 &&
        typeof didFulfill !== "function" &&
        typeof didReject !== "function") {
        var msg = ".then() only accepts functions but was passed: " +
                util.classString(didFulfill);
        if (arguments.length > 1) {
            msg += ", " + util.classString(didReject);
        }
        this._warn(msg);
    }
    return this._then(didFulfill, didReject, undefined, undefined, undefined);
};

Promise.prototype.done = function (didFulfill, didReject) {
    var promise =
        this._then(didFulfill, didReject, undefined, undefined, undefined);
    promise._setIsFinal();
};

Promise.prototype.spread = function (fn) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
};

Promise.prototype.toJSON = function () {
    var ret = {
        isFulfilled: false,
        isRejected: false,
        fulfillmentValue: undefined,
        rejectionReason: undefined
    };
    if (this.isFulfilled()) {
        ret.fulfillmentValue = this.value();
        ret.isFulfilled = true;
    } else if (this.isRejected()) {
        ret.rejectionReason = this.reason();
        ret.isRejected = true;
    }
    return ret;
};

Promise.prototype.all = function () {
    if (arguments.length > 0) {
        this._warn(".all() was passed arguments but it does not take any");
    }
    return new PromiseArray(this).promise();
};

Promise.prototype.error = function (fn) {
    return this.caught(util.originatesFromRejection, fn);
};

Promise.getNewLibraryCopy = module.exports;

Promise.is = function (val) {
    return val instanceof Promise;
};

Promise.fromNode = Promise.fromCallback = function(fn) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
                                         : false;
    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
    if (result === errorObj) {
        ret._rejectCallback(result.e, true);
    }
    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
    return ret;
};

Promise.all = function (promises) {
    return new PromiseArray(promises).promise();
};

Promise.cast = function (obj) {
    var ret = tryConvertToPromise(obj);
    if (!(ret instanceof Promise)) {
        ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._setFulfilled();
        ret._rejectionHandler0 = obj;
    }
    return ret;
};

Promise.resolve = Promise.fulfilled = Promise.cast;

Promise.reject = Promise.rejected = function (reason) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._rejectCallback(reason, true);
    return ret;
};

Promise.setScheduler = function(fn) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    return async.setScheduler(fn);
};

Promise.prototype._then = function (
    didFulfill,
    didReject,
    _,    receiver,
    internalData
) {
    var haveInternalData = internalData !== undefined;
    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
    var target = this._target();
    var bitField = target._bitField;

    if (!haveInternalData) {
        promise._propagateFrom(this, 3);
        promise._captureStackTrace();
        if (receiver === undefined &&
            ((this._bitField & 2097152) !== 0)) {
            if (!((bitField & 50397184) === 0)) {
                receiver = this._boundValue();
            } else {
                receiver = target === this ? undefined : this._boundTo;
            }
        }
        this._fireEvent("promiseChained", this, promise);
    }

    var domain = getDomain();
    if (!((bitField & 50397184) === 0)) {
        var handler, value, settler = target._settlePromiseCtx;
        if (((bitField & 33554432) !== 0)) {
            value = target._rejectionHandler0;
            handler = didFulfill;
        } else if (((bitField & 16777216) !== 0)) {
            value = target._fulfillmentHandler0;
            handler = didReject;
            target._unsetRejectionIsUnhandled();
        } else {
            settler = target._settlePromiseLateCancellationObserver;
            value = new CancellationError("late cancellation observer");
            target._attachExtraTrace(value);
            handler = didReject;
        }

        async.invoke(settler, target, {
            handler: domain === null ? handler
                : (typeof handler === "function" &&
                    util.domainBind(domain, handler)),
            promise: promise,
            receiver: receiver,
            value: value
        });
    } else {
        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
    }

    return promise;
};

Promise.prototype._length = function () {
    return this._bitField & 65535;
};

Promise.prototype._isFateSealed = function () {
    return (this._bitField & 117506048) !== 0;
};

Promise.prototype._isFollowing = function () {
    return (this._bitField & 67108864) === 67108864;
};

Promise.prototype._setLength = function (len) {
    this._bitField = (this._bitField & -65536) |
        (len & 65535);
};

Promise.prototype._setFulfilled = function () {
    this._bitField = this._bitField | 33554432;
    this._fireEvent("promiseFulfilled", this);
};

Promise.prototype._setRejected = function () {
    this._bitField = this._bitField | 16777216;
    this._fireEvent("promiseRejected", this);
};

Promise.prototype._setFollowing = function () {
    this._bitField = this._bitField | 67108864;
    this._fireEvent("promiseResolved", this);
};

Promise.prototype._setIsFinal = function () {
    this._bitField = this._bitField | 4194304;
};

Promise.prototype._isFinal = function () {
    return (this._bitField & 4194304) > 0;
};

Promise.prototype._unsetCancelled = function() {
    this._bitField = this._bitField & (~65536);
};

Promise.prototype._setCancelled = function() {
    this._bitField = this._bitField | 65536;
    this._fireEvent("promiseCancelled", this);
};

Promise.prototype._setWillBeCancelled = function() {
    this._bitField = this._bitField | 8388608;
};

Promise.prototype._setAsyncGuaranteed = function() {
    if (async.hasCustomScheduler()) return;
    this._bitField = this._bitField | 134217728;
};

Promise.prototype._receiverAt = function (index) {
    var ret = index === 0 ? this._receiver0 : this[
            index * 4 - 4 + 3];
    if (ret === UNDEFINED_BINDING) {
        return undefined;
    } else if (ret === undefined && this._isBound()) {
        return this._boundValue();
    }
    return ret;
};

Promise.prototype._promiseAt = function (index) {
    return this[
            index * 4 - 4 + 2];
};

Promise.prototype._fulfillmentHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 0];
};

Promise.prototype._rejectionHandlerAt = function (index) {
    return this[
            index * 4 - 4 + 1];
};

Promise.prototype._boundValue = function() {};

Promise.prototype._migrateCallback0 = function (follower) {
    var bitField = follower._bitField;
    var fulfill = follower._fulfillmentHandler0;
    var reject = follower._rejectionHandler0;
    var promise = follower._promise0;
    var receiver = follower._receiverAt(0);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._migrateCallbackAt = function (follower, index) {
    var fulfill = follower._fulfillmentHandlerAt(index);
    var reject = follower._rejectionHandlerAt(index);
    var promise = follower._promiseAt(index);
    var receiver = follower._receiverAt(index);
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, promise, receiver, null);
};

Promise.prototype._addCallbacks = function (
    fulfill,
    reject,
    promise,
    receiver,
    domain
) {
    var index = this._length();

    if (index >= 65535 - 4) {
        index = 0;
        this._setLength(0);
    }

    if (index === 0) {
        this._promise0 = promise;
        this._receiver0 = receiver;
        if (typeof fulfill === "function") {
            this._fulfillmentHandler0 =
                domain === null ? fulfill : util.domainBind(domain, fulfill);
        }
        if (typeof reject === "function") {
            this._rejectionHandler0 =
                domain === null ? reject : util.domainBind(domain, reject);
        }
    } else {
        var base = index * 4 - 4;
        this[base + 2] = promise;
        this[base + 3] = receiver;
        if (typeof fulfill === "function") {
            this[base + 0] =
                domain === null ? fulfill : util.domainBind(domain, fulfill);
        }
        if (typeof reject === "function") {
            this[base + 1] =
                domain === null ? reject : util.domainBind(domain, reject);
        }
    }
    this._setLength(index + 1);
    return index;
};

Promise.prototype._proxy = function (proxyable, arg) {
    this._addCallbacks(undefined, undefined, arg, proxyable, null);
};

Promise.prototype._resolveCallback = function(value, shouldBind) {
    if (((this._bitField & 117506048) !== 0)) return;
    if (value === this)
        return this._rejectCallback(makeSelfResolutionError(), false);
    var maybePromise = tryConvertToPromise(value, this);
    if (!(maybePromise instanceof Promise)) return this._fulfill(value);

    if (shouldBind) this._propagateFrom(maybePromise, 2);

    var promise = maybePromise._target();

    if (promise === this) {
        this._reject(makeSelfResolutionError());
        return;
    }

    var bitField = promise._bitField;
    if (((bitField & 50397184) === 0)) {
        var len = this._length();
        if (len > 0) promise._migrateCallback0(this);
        for (var i = 1; i < len; ++i) {
            promise._migrateCallbackAt(this, i);
        }
        this._setFollowing();
        this._setLength(0);
        this._setFollowee(promise);
    } else if (((bitField & 33554432) !== 0)) {
        this._fulfill(promise._value());
    } else if (((bitField & 16777216) !== 0)) {
        this._reject(promise._reason());
    } else {
        var reason = new CancellationError("late cancellation observer");
        promise._attachExtraTrace(reason);
        this._reject(reason);
    }
};

Promise.prototype._rejectCallback =
function(reason, synchronous, ignoreNonErrorWarnings) {
    var trace = util.ensureErrorObject(reason);
    var hasStack = trace === reason;
    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
        var message = "a promise was rejected with a non-error: " +
            util.classString(reason);
        this._warn(message, true);
    }
    this._attachExtraTrace(trace, synchronous ? hasStack : false);
    this._reject(reason);
};

Promise.prototype._resolveFromExecutor = function (executor) {
    var promise = this;
    this._captureStackTrace();
    this._pushContext();
    var synchronous = true;
    var r = this._execute(executor, function(value) {
        promise._resolveCallback(value);
    }, function (reason) {
        promise._rejectCallback(reason, synchronous);
    });
    synchronous = false;
    this._popContext();

    if (r !== undefined) {
        promise._rejectCallback(r, true);
    }
};

Promise.prototype._settlePromiseFromHandler = function (
    handler, receiver, value, promise
) {
    var bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;
    promise._pushContext();
    var x;
    if (receiver === APPLY) {
        if (!value || typeof value.length !== "number") {
            x = errorObj;
            x.e = new TypeError("cannot .spread() a non-array: " +
                                    util.classString(value));
        } else {
            x = tryCatch(handler).apply(this._boundValue(), value);
        }
    } else {
        x = tryCatch(handler).call(receiver, value);
    }
    var promiseCreated = promise._popContext();
    bitField = promise._bitField;
    if (((bitField & 65536) !== 0)) return;

    if (x === NEXT_FILTER) {
        promise._reject(value);
    } else if (x === errorObj) {
        promise._rejectCallback(x.e, false);
    } else {
        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
        promise._resolveCallback(x);
    }
};

Promise.prototype._target = function() {
    var ret = this;
    while (ret._isFollowing()) ret = ret._followee();
    return ret;
};

Promise.prototype._followee = function() {
    return this._rejectionHandler0;
};

Promise.prototype._setFollowee = function(promise) {
    this._rejectionHandler0 = promise;
};

Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
    var isPromise = promise instanceof Promise;
    var bitField = this._bitField;
    var asyncGuaranteed = ((bitField & 134217728) !== 0);
    if (((bitField & 65536) !== 0)) {
        if (isPromise) promise._invokeInternalOnCancel();

        if (receiver instanceof PassThroughHandlerContext &&
            receiver.isFinallyHandler()) {
            receiver.cancelPromise = promise;
            if (tryCatch(handler).call(receiver, value) === errorObj) {
                promise._reject(errorObj.e);
            }
        } else if (handler === reflectHandler) {
            promise._fulfill(reflectHandler.call(receiver));
        } else if (receiver instanceof Proxyable) {
            receiver._promiseCancelled(promise);
        } else if (isPromise || promise instanceof PromiseArray) {
            promise._cancel();
        } else {
            receiver.cancel();
        }
    } else if (typeof handler === "function") {
        if (!isPromise) {
            handler.call(receiver, value, promise);
        } else {
            if (asyncGuaranteed) promise._setAsyncGuaranteed();
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (receiver instanceof Proxyable) {
        if (!receiver._isResolved()) {
            if (((bitField & 33554432) !== 0)) {
                receiver._promiseFulfilled(value, promise);
            } else {
                receiver._promiseRejected(value, promise);
            }
        }
    } else if (isPromise) {
        if (asyncGuaranteed) promise._setAsyncGuaranteed();
        if (((bitField & 33554432) !== 0)) {
            promise._fulfill(value);
        } else {
            promise._reject(value);
        }
    }
};

Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
    var handler = ctx.handler;
    var promise = ctx.promise;
    var receiver = ctx.receiver;
    var value = ctx.value;
    if (typeof handler === "function") {
        if (!(promise instanceof Promise)) {
            handler.call(receiver, value, promise);
        } else {
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (promise instanceof Promise) {
        promise._reject(value);
    }
};

Promise.prototype._settlePromiseCtx = function(ctx) {
    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
};

Promise.prototype._settlePromise0 = function(handler, value, bitField) {
    var promise = this._promise0;
    var receiver = this._receiverAt(0);
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._settlePromise(promise, handler, receiver, value);
};

Promise.prototype._clearCallbackDataAtIndex = function(index) {
    var base = index * 4 - 4;
    this[base + 2] =
    this[base + 3] =
    this[base + 0] =
    this[base + 1] = undefined;
};

Promise.prototype._fulfill = function (value) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    if (value === this) {
        var err = makeSelfResolutionError();
        this._attachExtraTrace(err);
        return this._reject(err);
    }
    this._setFulfilled();
    this._rejectionHandler0 = value;

    if ((bitField & 65535) > 0) {
        if (((bitField & 134217728) !== 0)) {
            this._settlePromises();
        } else {
            async.settlePromises(this);
        }
    }
};

Promise.prototype._reject = function (reason) {
    var bitField = this._bitField;
    if (((bitField & 117506048) >>> 16)) return;
    this._setRejected();
    this._fulfillmentHandler0 = reason;

    if (this._isFinal()) {
        return async.fatalError(reason, util.isNode);
    }

    if ((bitField & 65535) > 0) {
        async.settlePromises(this);
    } else {
        this._ensurePossibleRejectionHandled();
    }
};

Promise.prototype._fulfillPromises = function (len, value) {
    for (var i = 1; i < len; i++) {
        var handler = this._fulfillmentHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, value);
    }
};

Promise.prototype._rejectPromises = function (len, reason) {
    for (var i = 1; i < len; i++) {
        var handler = this._rejectionHandlerAt(i);
        var promise = this._promiseAt(i);
        var receiver = this._receiverAt(i);
        this._clearCallbackDataAtIndex(i);
        this._settlePromise(promise, handler, receiver, reason);
    }
};

Promise.prototype._settlePromises = function () {
    var bitField = this._bitField;
    var len = (bitField & 65535);

    if (len > 0) {
        if (((bitField & 16842752) !== 0)) {
            var reason = this._fulfillmentHandler0;
            this._settlePromise0(this._rejectionHandler0, reason, bitField);
            this._rejectPromises(len, reason);
        } else {
            var value = this._rejectionHandler0;
            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
            this._fulfillPromises(len, value);
        }
        this._setLength(0);
    }
    this._clearCancellationData();
};

Promise.prototype._settledValue = function() {
    var bitField = this._bitField;
    if (((bitField & 33554432) !== 0)) {
        return this._rejectionHandler0;
    } else if (((bitField & 16777216) !== 0)) {
        return this._fulfillmentHandler0;
    }
};

function deferResolve(v) {this.promise._resolveCallback(v);}
function deferReject(v) {this.promise._rejectCallback(v, false);}

Promise.defer = Promise.pending = function() {
    debug.deprecated("Promise.defer", "new Promise");
    var promise = new Promise(INTERNAL);
    return {
        promise: promise,
        resolve: deferResolve,
        reject: deferReject
    };
};

util.notEnumerableProp(Promise,
                       "_makeSelfResolutionError",
                       makeSelfResolutionError);

require("./method")(Promise, INTERNAL, tryConvertToPromise, apiRejection,
    debug);
require("./bind")(Promise, INTERNAL, tryConvertToPromise, debug);
require("./cancel")(Promise, PromiseArray, apiRejection, debug);
require("./direct_resolve")(Promise);
require("./synchronous_inspection")(Promise);
require("./join")(
    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
Promise.Promise = Promise;
Promise.version = "3.4.7";
require('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
require('./call_get.js')(Promise);
require('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
require('./timers.js')(Promise, INTERNAL, debug);
require('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
require('./nodeify.js')(Promise);
require('./promisify.js')(Promise, INTERNAL);
require('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
require('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
require('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
require('./settle.js')(Promise, PromiseArray, debug);
require('./some.js')(Promise, PromiseArray, apiRejection);
require('./filter.js')(Promise, INTERNAL);
require('./each.js')(Promise, INTERNAL);
require('./any.js')(Promise);
                                                         
    util.toFastProperties(Promise);                                          
    util.toFastProperties(Promise.prototype);                                
    function fillTypes(value) {                                              
        var p = new Promise(INTERNAL);                                       
        p._fulfillmentHandler0 = value;                                      
        p._rejectionHandler0 = value;                                        
        p._promise0 = value;                                                 
        p._receiver0 = value;                                                
    }                                                                        
    // Complete slack tracking, opt out of field-type tracking and           
    // stabilize map                                                         
    fillTypes({a: 1});                                                       
    fillTypes({b: 2});                                                       
    fillTypes({c: 3});                                                       
    fillTypes(1);                                                            
    fillTypes(function(){});                                                 
    fillTypes(undefined);                                                    
    fillTypes(false);                                                        
    fillTypes(new Promise(INTERNAL));                                        
    debug.setBounds(Async.firstLineError, util.lastLineError);               
    return Promise;                                                          

};

}).call(this,require('_process'))
},{"./any.js":48,"./async":49,"./bind":50,"./call_get.js":51,"./cancel":52,"./catch_filter":53,"./context":54,"./debuggability":55,"./direct_resolve":56,"./each.js":57,"./errors":58,"./es5":59,"./filter.js":60,"./finally":61,"./generators.js":62,"./join":63,"./map.js":64,"./method":65,"./nodeback":66,"./nodeify.js":67,"./promise_array":69,"./promisify.js":70,"./props.js":71,"./race.js":73,"./reduce.js":74,"./settle.js":76,"./some.js":77,"./synchronous_inspection":78,"./thenables":79,"./timers.js":80,"./using.js":81,"./util":82,"_process":101}],69:[function(require,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise,
    apiRejection, Proxyable) {
var util = require("./util");
var isArray = util.isArray;

function toResolutionValue(val) {
    switch(val) {
    case -2: return [];
    case -3: return {};
    }
}

function PromiseArray(values) {
    var promise = this._promise = new Promise(INTERNAL);
    if (values instanceof Promise) {
        promise._propagateFrom(values, 3);
    }
    promise._setOnCancel(this);
    this._values = values;
    this._length = 0;
    this._totalResolved = 0;
    this._init(undefined, -2);
}
util.inherits(PromiseArray, Proxyable);

PromiseArray.prototype.length = function () {
    return this._length;
};

PromiseArray.prototype.promise = function () {
    return this._promise;
};

PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
    var values = tryConvertToPromise(this._values, this._promise);
    if (values instanceof Promise) {
        values = values._target();
        var bitField = values._bitField;
        ;
        this._values = values;

        if (((bitField & 50397184) === 0)) {
            this._promise._setAsyncGuaranteed();
            return values._then(
                init,
                this._reject,
                undefined,
                this,
                resolveValueIfEmpty
           );
        } else if (((bitField & 33554432) !== 0)) {
            values = values._value();
        } else if (((bitField & 16777216) !== 0)) {
            return this._reject(values._reason());
        } else {
            return this._cancel();
        }
    }
    values = util.asArray(values);
    if (values === null) {
        var err = apiRejection(
            "expecting an array or an iterable object but got " + util.classString(values)).reason();
        this._promise._rejectCallback(err, false);
        return;
    }

    if (values.length === 0) {
        if (resolveValueIfEmpty === -5) {
            this._resolveEmptyArray();
        }
        else {
            this._resolve(toResolutionValue(resolveValueIfEmpty));
        }
        return;
    }
    this._iterate(values);
};

PromiseArray.prototype._iterate = function(values) {
    var len = this.getActualLength(values.length);
    this._length = len;
    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
    var result = this._promise;
    var isResolved = false;
    var bitField = null;
    for (var i = 0; i < len; ++i) {
        var maybePromise = tryConvertToPromise(values[i], result);

        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            bitField = maybePromise._bitField;
        } else {
            bitField = null;
        }

        if (isResolved) {
            if (bitField !== null) {
                maybePromise.suppressUnhandledRejections();
            }
        } else if (bitField !== null) {
            if (((bitField & 50397184) === 0)) {
                maybePromise._proxy(this, i);
                this._values[i] = maybePromise;
            } else if (((bitField & 33554432) !== 0)) {
                isResolved = this._promiseFulfilled(maybePromise._value(), i);
            } else if (((bitField & 16777216) !== 0)) {
                isResolved = this._promiseRejected(maybePromise._reason(), i);
            } else {
                isResolved = this._promiseCancelled(i);
            }
        } else {
            isResolved = this._promiseFulfilled(maybePromise, i);
        }
    }
    if (!isResolved) result._setAsyncGuaranteed();
};

PromiseArray.prototype._isResolved = function () {
    return this._values === null;
};

PromiseArray.prototype._resolve = function (value) {
    this._values = null;
    this._promise._fulfill(value);
};

PromiseArray.prototype._cancel = function() {
    if (this._isResolved() || !this._promise._isCancellable()) return;
    this._values = null;
    this._promise._cancel();
};

PromiseArray.prototype._reject = function (reason) {
    this._values = null;
    this._promise._rejectCallback(reason, false);
};

PromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

PromiseArray.prototype._promiseCancelled = function() {
    this._cancel();
    return true;
};

PromiseArray.prototype._promiseRejected = function (reason) {
    this._totalResolved++;
    this._reject(reason);
    return true;
};

PromiseArray.prototype._resultCancelled = function() {
    if (this._isResolved()) return;
    var values = this._values;
    this._cancel();
    if (values instanceof Promise) {
        values.cancel();
    } else {
        for (var i = 0; i < values.length; ++i) {
            if (values[i] instanceof Promise) {
                values[i].cancel();
            }
        }
    }
};

PromiseArray.prototype.shouldCopyValues = function () {
    return true;
};

PromiseArray.prototype.getActualLength = function (len) {
    return len;
};

return PromiseArray;
};

},{"./util":82}],70:[function(require,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var THIS = {};
var util = require("./util");
var nodebackForPromise = require("./nodeback");
var withAppended = util.withAppended;
var maybeWrapAsError = util.maybeWrapAsError;
var canEvaluate = util.canEvaluate;
var TypeError = require("./errors").TypeError;
var defaultSuffix = "Async";
var defaultPromisified = {__isPromisified__: true};
var noCopyProps = [
    "arity",    "length",
    "name",
    "arguments",
    "caller",
    "callee",
    "prototype",
    "__isPromisified__"
];
var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");

var defaultFilter = function(name) {
    return util.isIdentifier(name) &&
        name.charAt(0) !== "_" &&
        name !== "constructor";
};

function propsFilter(key) {
    return !noCopyPropsPattern.test(key);
}

function isPromisified(fn) {
    try {
        return fn.__isPromisified__ === true;
    }
    catch (e) {
        return false;
    }
}

function hasPromisified(obj, key, suffix) {
    var val = util.getDataPropertyOrDefault(obj, key + suffix,
                                            defaultPromisified);
    return val ? isPromisified(val) : false;
}
function checkValid(ret, suffix, suffixRegexp) {
    for (var i = 0; i < ret.length; i += 2) {
        var key = ret[i];
        if (suffixRegexp.test(key)) {
            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
            for (var j = 0; j < ret.length; j += 2) {
                if (ret[j] === keyWithoutAsyncSuffix) {
                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
                        .replace("%s", suffix));
                }
            }
        }
    }
}

function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
    var keys = util.inheritedDataKeys(obj);
    var ret = [];
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var value = obj[key];
        var passesDefaultFilter = filter === defaultFilter
            ? true : defaultFilter(key, value, obj);
        if (typeof value === "function" &&
            !isPromisified(value) &&
            !hasPromisified(obj, key, suffix) &&
            filter(key, value, obj, passesDefaultFilter)) {
            ret.push(key, value);
        }
    }
    checkValid(ret, suffix, suffixRegexp);
    return ret;
}

var escapeIdentRegex = function(str) {
    return str.replace(/([$])/, "\\$");
};

var makeNodePromisifiedEval;
if (true) {
var switchCaseArgumentOrder = function(likelyArgumentCount) {
    var ret = [likelyArgumentCount];
    var min = Math.max(0, likelyArgumentCount - 1 - 3);
    for(var i = likelyArgumentCount - 1; i >= min; --i) {
        ret.push(i);
    }
    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
        ret.push(i);
    }
    return ret;
};

var argumentSequence = function(argumentCount) {
    return util.filledRange(argumentCount, "_arg", "");
};

var parameterDeclaration = function(parameterCount) {
    return util.filledRange(
        Math.max(parameterCount, 3), "_arg", "");
};

var parameterCount = function(fn) {
    if (typeof fn.length === "number") {
        return Math.max(Math.min(fn.length, 1023 + 1), 0);
    }
    return 0;
};

makeNodePromisifiedEval =
function(callback, receiver, originalName, fn, _, multiArgs) {
    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
    var shouldProxyThis = typeof callback === "string" || receiver === THIS;

    function generateCallForArgumentCount(count) {
        var args = argumentSequence(count).join(", ");
        var comma = count > 0 ? ", " : "";
        var ret;
        if (shouldProxyThis) {
            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
        } else {
            ret = receiver === undefined
                ? "ret = callback({{args}}, nodeback); break;\n"
                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
        }
        return ret.replace("{{args}}", args).replace(", ", comma);
    }

    function generateArgumentSwitchCase() {
        var ret = "";
        for (var i = 0; i < argumentOrder.length; ++i) {
            ret += "case " + argumentOrder[i] +":" +
                generateCallForArgumentCount(argumentOrder[i]);
        }

        ret += "                                                             \n\
        default:                                                             \n\
            var args = new Array(len + 1);                                   \n\
            var i = 0;                                                       \n\
            for (var i = 0; i < len; ++i) {                                  \n\
               args[i] = arguments[i];                                       \n\
            }                                                                \n\
            args[i] = nodeback;                                              \n\
            [CodeForCall]                                                    \n\
            break;                                                           \n\
        ".replace("[CodeForCall]", (shouldProxyThis
                                ? "ret = callback.apply(this, args);\n"
                                : "ret = callback.apply(receiver, args);\n"));
        return ret;
    }

    var getFunctionCode = typeof callback === "string"
                                ? ("this != null ? this['"+callback+"'] : fn")
                                : "fn";
    var body = "'use strict';                                                \n\
        var ret = function (Parameters) {                                    \n\
            'use strict';                                                    \n\
            var len = arguments.length;                                      \n\
            var promise = new Promise(INTERNAL);                             \n\
            promise._captureStackTrace();                                    \n\
            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
            var ret;                                                         \n\
            var callback = tryCatch([GetFunctionCode]);                      \n\
            switch(len) {                                                    \n\
                [CodeForSwitchCase]                                          \n\
            }                                                                \n\
            if (ret === errorObj) {                                          \n\
                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
            }                                                                \n\
            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
            return promise;                                                  \n\
        };                                                                   \n\
        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
        return ret;                                                          \n\
    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
        .replace("[GetFunctionCode]", getFunctionCode);
    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
    return new Function("Promise",
                        "fn",
                        "receiver",
                        "withAppended",
                        "maybeWrapAsError",
                        "nodebackForPromise",
                        "tryCatch",
                        "errorObj",
                        "notEnumerableProp",
                        "INTERNAL",
                        body)(
                    Promise,
                    fn,
                    receiver,
                    withAppended,
                    maybeWrapAsError,
                    nodebackForPromise,
                    util.tryCatch,
                    util.errorObj,
                    util.notEnumerableProp,
                    INTERNAL);
};
}

function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
    var defaultThis = (function() {return this;})();
    var method = callback;
    if (typeof method === "string") {
        callback = fn;
    }
    function promisified() {
        var _receiver = receiver;
        if (receiver === THIS) _receiver = this;
        var promise = new Promise(INTERNAL);
        promise._captureStackTrace();
        var cb = typeof method === "string" && this !== defaultThis
            ? this[method] : callback;
        var fn = nodebackForPromise(promise, multiArgs);
        try {
            cb.apply(_receiver, withAppended(arguments, fn));
        } catch(e) {
            promise._rejectCallback(maybeWrapAsError(e), true, true);
        }
        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
        return promise;
    }
    util.notEnumerableProp(promisified, "__isPromisified__", true);
    return promisified;
}

var makeNodePromisified = canEvaluate
    ? makeNodePromisifiedEval
    : makeNodePromisifiedClosure;

function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
    var methods =
        promisifiableMethods(obj, suffix, suffixRegexp, filter);

    for (var i = 0, len = methods.length; i < len; i+= 2) {
        var key = methods[i];
        var fn = methods[i+1];
        var promisifiedKey = key + suffix;
        if (promisifier === makeNodePromisified) {
            obj[promisifiedKey] =
                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
        } else {
            var promisified = promisifier(fn, function() {
                return makeNodePromisified(key, THIS, key,
                                           fn, suffix, multiArgs);
            });
            util.notEnumerableProp(promisified, "__isPromisified__", true);
            obj[promisifiedKey] = promisified;
        }
    }
    util.toFastProperties(obj);
    return obj;
}

function promisify(callback, receiver, multiArgs) {
    return makeNodePromisified(callback, receiver, undefined,
                                callback, null, multiArgs);
}

Promise.promisify = function (fn, options) {
    if (typeof fn !== "function") {
        throw new TypeError("expecting a function but got " + util.classString(fn));
    }
    if (isPromisified(fn)) {
        return fn;
    }
    options = Object(options);
    var receiver = options.context === undefined ? THIS : options.context;
    var multiArgs = !!options.multiArgs;
    var ret = promisify(fn, receiver, multiArgs);
    util.copyDescriptors(fn, ret, propsFilter);
    return ret;
};

Promise.promisifyAll = function (target, options) {
    if (typeof target !== "function" && typeof target !== "object") {
        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    options = Object(options);
    var multiArgs = !!options.multiArgs;
    var suffix = options.suffix;
    if (typeof suffix !== "string") suffix = defaultSuffix;
    var filter = options.filter;
    if (typeof filter !== "function") filter = defaultFilter;
    var promisifier = options.promisifier;
    if (typeof promisifier !== "function") promisifier = makeNodePromisified;

    if (!util.isIdentifier(suffix)) {
        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }

    var keys = util.inheritedDataKeys(target);
    for (var i = 0; i < keys.length; ++i) {
        var value = target[keys[i]];
        if (keys[i] !== "constructor" &&
            util.isClass(value)) {
            promisifyAll(value.prototype, suffix, filter, promisifier,
                multiArgs);
            promisifyAll(value, suffix, filter, promisifier, multiArgs);
        }
    }

    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
};
};


},{"./errors":58,"./nodeback":66,"./util":82}],71:[function(require,module,exports){
"use strict";
module.exports = function(
    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
var util = require("./util");
var isObject = util.isObject;
var es5 = require("./es5");
var Es6Map;
if (typeof Map === "function") Es6Map = Map;

var mapToEntries = (function() {
    var index = 0;
    var size = 0;

    function extractEntry(value, key) {
        this[index] = value;
        this[index + size] = key;
        index++;
    }

    return function mapToEntries(map) {
        size = map.size;
        index = 0;
        var ret = new Array(map.size * 2);
        map.forEach(extractEntry, ret);
        return ret;
    };
})();

var entriesToMap = function(entries) {
    var ret = new Es6Map();
    var length = entries.length / 2 | 0;
    for (var i = 0; i < length; ++i) {
        var key = entries[length + i];
        var value = entries[i];
        ret.set(key, value);
    }
    return ret;
};

function PropertiesPromiseArray(obj) {
    var isMap = false;
    var entries;
    if (Es6Map !== undefined && obj instanceof Es6Map) {
        entries = mapToEntries(obj);
        isMap = true;
    } else {
        var keys = es5.keys(obj);
        var len = keys.length;
        entries = new Array(len * 2);
        for (var i = 0; i < len; ++i) {
            var key = keys[i];
            entries[i] = obj[key];
            entries[i + len] = key;
        }
    }
    this.constructor$(entries);
    this._isMap = isMap;
    this._init$(undefined, -3);
}
util.inherits(PropertiesPromiseArray, PromiseArray);

PropertiesPromiseArray.prototype._init = function () {};

PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        var val;
        if (this._isMap) {
            val = entriesToMap(this._values);
        } else {
            val = {};
            var keyOffset = this.length();
            for (var i = 0, len = this.length(); i < len; ++i) {
                val[this._values[i + keyOffset]] = this._values[i];
            }
        }
        this._resolve(val);
        return true;
    }
    return false;
};

PropertiesPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

PropertiesPromiseArray.prototype.getActualLength = function (len) {
    return len >> 1;
};

function props(promises) {
    var ret;
    var castValue = tryConvertToPromise(promises);

    if (!isObject(castValue)) {
        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    } else if (castValue instanceof Promise) {
        ret = castValue._then(
            Promise.props, undefined, undefined, undefined, undefined);
    } else {
        ret = new PropertiesPromiseArray(castValue).promise();
    }

    if (castValue instanceof Promise) {
        ret._propagateFrom(castValue, 2);
    }
    return ret;
}

Promise.prototype.props = function () {
    return props(this);
};

Promise.props = function (promises) {
    return props(promises);
};
};

},{"./es5":59,"./util":82}],72:[function(require,module,exports){
"use strict";
function arrayMove(src, srcIndex, dst, dstIndex, len) {
    for (var j = 0; j < len; ++j) {
        dst[j + dstIndex] = src[j + srcIndex];
        src[j + srcIndex] = void 0;
    }
}

function Queue(capacity) {
    this._capacity = capacity;
    this._length = 0;
    this._front = 0;
}

Queue.prototype._willBeOverCapacity = function (size) {
    return this._capacity < size;
};

Queue.prototype._pushOne = function (arg) {
    var length = this.length();
    this._checkCapacity(length + 1);
    var i = (this._front + length) & (this._capacity - 1);
    this[i] = arg;
    this._length = length + 1;
};

Queue.prototype.push = function (fn, receiver, arg) {
    var length = this.length() + 3;
    if (this._willBeOverCapacity(length)) {
        this._pushOne(fn);
        this._pushOne(receiver);
        this._pushOne(arg);
        return;
    }
    var j = this._front + length - 3;
    this._checkCapacity(length);
    var wrapMask = this._capacity - 1;
    this[(j + 0) & wrapMask] = fn;
    this[(j + 1) & wrapMask] = receiver;
    this[(j + 2) & wrapMask] = arg;
    this._length = length;
};

Queue.prototype.shift = function () {
    var front = this._front,
        ret = this[front];

    this[front] = undefined;
    this._front = (front + 1) & (this._capacity - 1);
    this._length--;
    return ret;
};

Queue.prototype.length = function () {
    return this._length;
};

Queue.prototype._checkCapacity = function (size) {
    if (this._capacity < size) {
        this._resizeTo(this._capacity << 1);
    }
};

Queue.prototype._resizeTo = function (capacity) {
    var oldCapacity = this._capacity;
    this._capacity = capacity;
    var front = this._front;
    var length = this._length;
    var moveItemsCount = (front + length) & (oldCapacity - 1);
    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
};

module.exports = Queue;

},{}],73:[function(require,module,exports){
"use strict";
module.exports = function(
    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
var util = require("./util");

var raceLater = function (promise) {
    return promise.then(function(array) {
        return race(array, promise);
    });
};

function race(promises, parent) {
    var maybePromise = tryConvertToPromise(promises);

    if (maybePromise instanceof Promise) {
        return raceLater(maybePromise);
    } else {
        promises = util.asArray(promises);
        if (promises === null)
            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
    }

    var ret = new Promise(INTERNAL);
    if (parent !== undefined) {
        ret._propagateFrom(parent, 3);
    }
    var fulfill = ret._fulfill;
    var reject = ret._reject;
    for (var i = 0, len = promises.length; i < len; ++i) {
        var val = promises[i];

        if (val === undefined && !(i in promises)) {
            continue;
        }

        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
    }
    return ret;
}

Promise.race = function (promises) {
    return race(promises, undefined);
};

Promise.prototype.race = function () {
    return race(this, undefined);
};

};

},{"./util":82}],74:[function(require,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL,
                          debug) {
var getDomain = Promise._getDomain;
var util = require("./util");
var tryCatch = util.tryCatch;

function ReductionPromiseArray(promises, fn, initialValue, _each) {
    this.constructor$(promises);
    var domain = getDomain();
    this._fn = domain === null ? fn : util.domainBind(domain, fn);
    if (initialValue !== undefined) {
        initialValue = Promise.resolve(initialValue);
        initialValue._attachCancellationCallback(this);
    }
    this._initialValue = initialValue;
    this._currentCancellable = null;
    if(_each === INTERNAL) {
        this._eachValues = Array(this._length);
    } else if (_each === 0) {
        this._eachValues = null;
    } else {
        this._eachValues = undefined;
    }
    this._promise._captureStackTrace();
    this._init$(undefined, -5);
}
util.inherits(ReductionPromiseArray, PromiseArray);

ReductionPromiseArray.prototype._gotAccum = function(accum) {
    if (this._eachValues !== undefined && 
        this._eachValues !== null && 
        accum !== INTERNAL) {
        this._eachValues.push(accum);
    }
};

ReductionPromiseArray.prototype._eachComplete = function(value) {
    if (this._eachValues !== null) {
        this._eachValues.push(value);
    }
    return this._eachValues;
};

ReductionPromiseArray.prototype._init = function() {};

ReductionPromiseArray.prototype._resolveEmptyArray = function() {
    this._resolve(this._eachValues !== undefined ? this._eachValues
                                                 : this._initialValue);
};

ReductionPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

ReductionPromiseArray.prototype._resolve = function(value) {
    this._promise._resolveCallback(value);
    this._values = null;
};

ReductionPromiseArray.prototype._resultCancelled = function(sender) {
    if (sender === this._initialValue) return this._cancel();
    if (this._isResolved()) return;
    this._resultCancelled$();
    if (this._currentCancellable instanceof Promise) {
        this._currentCancellable.cancel();
    }
    if (this._initialValue instanceof Promise) {
        this._initialValue.cancel();
    }
};

ReductionPromiseArray.prototype._iterate = function (values) {
    this._values = values;
    var value;
    var i;
    var length = values.length;
    if (this._initialValue !== undefined) {
        value = this._initialValue;
        i = 0;
    } else {
        value = Promise.resolve(values[0]);
        i = 1;
    }

    this._currentCancellable = value;

    if (!value.isRejected()) {
        for (; i < length; ++i) {
            var ctx = {
                accum: null,
                value: values[i],
                index: i,
                length: length,
                array: this
            };
            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
        }
    }

    if (this._eachValues !== undefined) {
        value = value
            ._then(this._eachComplete, undefined, undefined, this, undefined);
    }
    value._then(completed, completed, undefined, value, this);
};

Promise.prototype.reduce = function (fn, initialValue) {
    return reduce(this, fn, initialValue, null);
};

Promise.reduce = function (promises, fn, initialValue, _each) {
    return reduce(promises, fn, initialValue, _each);
};

function completed(valueOrReason, array) {
    if (this.isFulfilled()) {
        array._resolve(valueOrReason);
    } else {
        array._reject(valueOrReason);
    }
}

function reduce(promises, fn, initialValue, _each) {
    if (typeof fn !== "function") {
        return apiRejection("expecting a function but got " + util.classString(fn));
    }
    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
    return array.promise();
}

function gotAccum(accum) {
    this.accum = accum;
    this.array._gotAccum(accum);
    var value = tryConvertToPromise(this.value, this.array._promise);
    if (value instanceof Promise) {
        this.array._currentCancellable = value;
        return value._then(gotValue, undefined, undefined, this, undefined);
    } else {
        return gotValue.call(this, value);
    }
}

function gotValue(value) {
    var array = this.array;
    var promise = array._promise;
    var fn = tryCatch(array._fn);
    promise._pushContext();
    var ret;
    if (array._eachValues !== undefined) {
        ret = fn.call(promise._boundValue(), value, this.index, this.length);
    } else {
        ret = fn.call(promise._boundValue(),
                              this.accum, value, this.index, this.length);
    }
    if (ret instanceof Promise) {
        array._currentCancellable = ret;
    }
    var promiseCreated = promise._popContext();
    debug.checkForgottenReturns(
        ret,
        promiseCreated,
        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
        promise
    );
    return ret;
}
};

},{"./util":82}],75:[function(require,module,exports){
(function (process,global){
"use strict";
var util = require("./util");
var schedule;
var noAsyncScheduler = function() {
    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var NativePromise = util.getNativePromise();
if (util.isNode && typeof MutationObserver === "undefined") {
    var GlobalSetImmediate = global.setImmediate;
    var ProcessNextTick = process.nextTick;
    schedule = util.isRecentNode
                ? function(fn) { GlobalSetImmediate.call(global, fn); }
                : function(fn) { ProcessNextTick.call(process, fn); };
} else if (typeof NativePromise === "function" &&
           typeof NativePromise.resolve === "function") {
    var nativePromise = NativePromise.resolve();
    schedule = function(fn) {
        nativePromise.then(fn);
    };
} else if ((typeof MutationObserver !== "undefined") &&
          !(typeof window !== "undefined" &&
            window.navigator &&
            (window.navigator.standalone || window.cordova))) {
    schedule = (function() {
        var div = document.createElement("div");
        var opts = {attributes: true};
        var toggleScheduled = false;
        var div2 = document.createElement("div");
        var o2 = new MutationObserver(function() {
            div.classList.toggle("foo");
            toggleScheduled = false;
        });
        o2.observe(div2, opts);

        var scheduleToggle = function() {
            if (toggleScheduled) return;
                toggleScheduled = true;
                div2.classList.toggle("foo");
            };

            return function schedule(fn) {
            var o = new MutationObserver(function() {
                o.disconnect();
                fn();
            });
            o.observe(div, opts);
            scheduleToggle();
        };
    })();
} else if (typeof setImmediate !== "undefined") {
    schedule = function (fn) {
        setImmediate(fn);
    };
} else if (typeof setTimeout !== "undefined") {
    schedule = function (fn) {
        setTimeout(fn, 0);
    };
} else {
    schedule = noAsyncScheduler;
}
module.exports = schedule;

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./util":82,"_process":101}],76:[function(require,module,exports){
"use strict";
module.exports =
    function(Promise, PromiseArray, debug) {
var PromiseInspection = Promise.PromiseInspection;
var util = require("./util");

function SettledPromiseArray(values) {
    this.constructor$(values);
}
util.inherits(SettledPromiseArray, PromiseArray);

SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
    this._values[index] = inspection;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
        return true;
    }
    return false;
};

SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var ret = new PromiseInspection();
    ret._bitField = 33554432;
    ret._settledValueField = value;
    return this._promiseResolved(index, ret);
};
SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
    var ret = new PromiseInspection();
    ret._bitField = 16777216;
    ret._settledValueField = reason;
    return this._promiseResolved(index, ret);
};

Promise.settle = function (promises) {
    debug.deprecated(".settle()", ".reflect()");
    return new SettledPromiseArray(promises).promise();
};

Promise.prototype.settle = function () {
    return Promise.settle(this);
};
};

},{"./util":82}],77:[function(require,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, apiRejection) {
var util = require("./util");
var RangeError = require("./errors").RangeError;
var AggregateError = require("./errors").AggregateError;
var isArray = util.isArray;
var CANCELLATION = {};


function SomePromiseArray(values) {
    this.constructor$(values);
    this._howMany = 0;
    this._unwrap = false;
    this._initialized = false;
}
util.inherits(SomePromiseArray, PromiseArray);

SomePromiseArray.prototype._init = function () {
    if (!this._initialized) {
        return;
    }
    if (this._howMany === 0) {
        this._resolve([]);
        return;
    }
    this._init$(undefined, -5);
    var isArrayResolved = isArray(this._values);
    if (!this._isResolved() &&
        isArrayResolved &&
        this._howMany > this._canPossiblyFulfill()) {
        this._reject(this._getRangeError(this.length()));
    }
};

SomePromiseArray.prototype.init = function () {
    this._initialized = true;
    this._init();
};

SomePromiseArray.prototype.setUnwrap = function () {
    this._unwrap = true;
};

SomePromiseArray.prototype.howMany = function () {
    return this._howMany;
};

SomePromiseArray.prototype.setHowMany = function (count) {
    this._howMany = count;
};

SomePromiseArray.prototype._promiseFulfilled = function (value) {
    this._addFulfilled(value);
    if (this._fulfilled() === this.howMany()) {
        this._values.length = this.howMany();
        if (this.howMany() === 1 && this._unwrap) {
            this._resolve(this._values[0]);
        } else {
            this._resolve(this._values);
        }
        return true;
    }
    return false;

};
SomePromiseArray.prototype._promiseRejected = function (reason) {
    this._addRejected(reason);
    return this._checkOutcome();
};

SomePromiseArray.prototype._promiseCancelled = function () {
    if (this._values instanceof Promise || this._values == null) {
        return this._cancel();
    }
    this._addRejected(CANCELLATION);
    return this._checkOutcome();
};

SomePromiseArray.prototype._checkOutcome = function() {
    if (this.howMany() > this._canPossiblyFulfill()) {
        var e = new AggregateError();
        for (var i = this.length(); i < this._values.length; ++i) {
            if (this._values[i] !== CANCELLATION) {
                e.push(this._values[i]);
            }
        }
        if (e.length > 0) {
            this._reject(e);
        } else {
            this._cancel();
        }
        return true;
    }
    return false;
};

SomePromiseArray.prototype._fulfilled = function () {
    return this._totalResolved;
};

SomePromiseArray.prototype._rejected = function () {
    return this._values.length - this.length();
};

SomePromiseArray.prototype._addRejected = function (reason) {
    this._values.push(reason);
};

SomePromiseArray.prototype._addFulfilled = function (value) {
    this._values[this._totalResolved++] = value;
};

SomePromiseArray.prototype._canPossiblyFulfill = function () {
    return this.length() - this._rejected();
};

SomePromiseArray.prototype._getRangeError = function (count) {
    var message = "Input array must contain at least " +
            this._howMany + " items but contains only " + count + " items";
    return new RangeError(message);
};

SomePromiseArray.prototype._resolveEmptyArray = function () {
    this._reject(this._getRangeError(0));
};

function some(promises, howMany) {
    if ((howMany | 0) !== howMany || howMany < 0) {
        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(howMany);
    ret.init();
    return promise;
}

Promise.some = function (promises, howMany) {
    return some(promises, howMany);
};

Promise.prototype.some = function (howMany) {
    return some(this, howMany);
};

Promise._SomePromiseArray = SomePromiseArray;
};

},{"./errors":58,"./util":82}],78:[function(require,module,exports){
"use strict";
module.exports = function(Promise) {
function PromiseInspection(promise) {
    if (promise !== undefined) {
        promise = promise._target();
        this._bitField = promise._bitField;
        this._settledValueField = promise._isFateSealed()
            ? promise._settledValue() : undefined;
    }
    else {
        this._bitField = 0;
        this._settledValueField = undefined;
    }
}

PromiseInspection.prototype._settledValue = function() {
    return this._settledValueField;
};

var value = PromiseInspection.prototype.value = function () {
    if (!this.isFulfilled()) {
        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var reason = PromiseInspection.prototype.error =
PromiseInspection.prototype.reason = function () {
    if (!this.isRejected()) {
        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    return this._settledValue();
};

var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
    return (this._bitField & 33554432) !== 0;
};

var isRejected = PromiseInspection.prototype.isRejected = function () {
    return (this._bitField & 16777216) !== 0;
};

var isPending = PromiseInspection.prototype.isPending = function () {
    return (this._bitField & 50397184) === 0;
};

var isResolved = PromiseInspection.prototype.isResolved = function () {
    return (this._bitField & 50331648) !== 0;
};

PromiseInspection.prototype.isCancelled = function() {
    return (this._bitField & 8454144) !== 0;
};

Promise.prototype.__isCancelled = function() {
    return (this._bitField & 65536) === 65536;
};

Promise.prototype._isCancelled = function() {
    return this._target().__isCancelled();
};

Promise.prototype.isCancelled = function() {
    return (this._target()._bitField & 8454144) !== 0;
};

Promise.prototype.isPending = function() {
    return isPending.call(this._target());
};

Promise.prototype.isRejected = function() {
    return isRejected.call(this._target());
};

Promise.prototype.isFulfilled = function() {
    return isFulfilled.call(this._target());
};

Promise.prototype.isResolved = function() {
    return isResolved.call(this._target());
};

Promise.prototype.value = function() {
    return value.call(this._target());
};

Promise.prototype.reason = function() {
    var target = this._target();
    target._unsetRejectionIsUnhandled();
    return reason.call(target);
};

Promise.prototype._value = function() {
    return this._settledValue();
};

Promise.prototype._reason = function() {
    this._unsetRejectionIsUnhandled();
    return this._settledValue();
};

Promise.PromiseInspection = PromiseInspection;
};

},{}],79:[function(require,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var util = require("./util");
var errorObj = util.errorObj;
var isObject = util.isObject;

function tryConvertToPromise(obj, context) {
    if (isObject(obj)) {
        if (obj instanceof Promise) return obj;
        var then = getThen(obj);
        if (then === errorObj) {
            if (context) context._pushContext();
            var ret = Promise.reject(then.e);
            if (context) context._popContext();
            return ret;
        } else if (typeof then === "function") {
            if (isAnyBluebirdPromise(obj)) {
                var ret = new Promise(INTERNAL);
                obj._then(
                    ret._fulfill,
                    ret._reject,
                    undefined,
                    ret,
                    null
                );
                return ret;
            }
            return doThenable(obj, then, context);
        }
    }
    return obj;
}

function doGetThen(obj) {
    return obj.then;
}

function getThen(obj) {
    try {
        return doGetThen(obj);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}

var hasProp = {}.hasOwnProperty;
function isAnyBluebirdPromise(obj) {
    try {
        return hasProp.call(obj, "_promise0");
    } catch (e) {
        return false;
    }
}

function doThenable(x, then, context) {
    var promise = new Promise(INTERNAL);
    var ret = promise;
    if (context) context._pushContext();
    promise._captureStackTrace();
    if (context) context._popContext();
    var synchronous = true;
    var result = util.tryCatch(then).call(x, resolve, reject);
    synchronous = false;

    if (promise && result === errorObj) {
        promise._rejectCallback(result.e, true, true);
        promise = null;
    }

    function resolve(value) {
        if (!promise) return;
        promise._resolveCallback(value);
        promise = null;
    }

    function reject(reason) {
        if (!promise) return;
        promise._rejectCallback(reason, synchronous, true);
        promise = null;
    }
    return ret;
}

return tryConvertToPromise;
};

},{"./util":82}],80:[function(require,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, debug) {
var util = require("./util");
var TimeoutError = Promise.TimeoutError;

function HandleWrapper(handle)  {
    this.handle = handle;
}

HandleWrapper.prototype._resultCancelled = function() {
    clearTimeout(this.handle);
};

var afterValue = function(value) { return delay(+this).thenReturn(value); };
var delay = Promise.delay = function (ms, value) {
    var ret;
    var handle;
    if (value !== undefined) {
        ret = Promise.resolve(value)
                ._then(afterValue, null, null, ms, undefined);
        if (debug.cancellation() && value instanceof Promise) {
            ret._setOnCancel(value);
        }
    } else {
        ret = new Promise(INTERNAL);
        handle = setTimeout(function() { ret._fulfill(); }, +ms);
        if (debug.cancellation()) {
            ret._setOnCancel(new HandleWrapper(handle));
        }
        ret._captureStackTrace();
    }
    ret._setAsyncGuaranteed();
    return ret;
};

Promise.prototype.delay = function (ms) {
    return delay(ms, this);
};

var afterTimeout = function (promise, message, parent) {
    var err;
    if (typeof message !== "string") {
        if (message instanceof Error) {
            err = message;
        } else {
            err = new TimeoutError("operation timed out");
        }
    } else {
        err = new TimeoutError(message);
    }
    util.markAsOriginatingFromRejection(err);
    promise._attachExtraTrace(err);
    promise._reject(err);

    if (parent != null) {
        parent.cancel();
    }
};

function successClear(value) {
    clearTimeout(this.handle);
    return value;
}

function failureClear(reason) {
    clearTimeout(this.handle);
    throw reason;
}

Promise.prototype.timeout = function (ms, message) {
    ms = +ms;
    var ret, parent;

    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
        if (ret.isPending()) {
            afterTimeout(ret, message, parent);
        }
    }, ms));

    if (debug.cancellation()) {
        parent = this.then();
        ret = parent._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
        ret._setOnCancel(handleWrapper);
    } else {
        ret = this._then(successClear, failureClear,
                            undefined, handleWrapper, undefined);
    }

    return ret;
};

};

},{"./util":82}],81:[function(require,module,exports){
"use strict";
module.exports = function (Promise, apiRejection, tryConvertToPromise,
    createContext, INTERNAL, debug) {
    var util = require("./util");
    var TypeError = require("./errors").TypeError;
    var inherits = require("./util").inherits;
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    var NULL = {};

    function thrower(e) {
        setTimeout(function(){throw e;}, 0);
    }

    function castPreservingDisposable(thenable) {
        var maybePromise = tryConvertToPromise(thenable);
        if (maybePromise !== thenable &&
            typeof thenable._isDisposable === "function" &&
            typeof thenable._getDisposer === "function" &&
            thenable._isDisposable()) {
            maybePromise._setDisposable(thenable._getDisposer());
        }
        return maybePromise;
    }
    function dispose(resources, inspection) {
        var i = 0;
        var len = resources.length;
        var ret = new Promise(INTERNAL);
        function iterator() {
            if (i >= len) return ret._fulfill();
            var maybePromise = castPreservingDisposable(resources[i++]);
            if (maybePromise instanceof Promise &&
                maybePromise._isDisposable()) {
                try {
                    maybePromise = tryConvertToPromise(
                        maybePromise._getDisposer().tryDispose(inspection),
                        resources.promise);
                } catch (e) {
                    return thrower(e);
                }
                if (maybePromise instanceof Promise) {
                    return maybePromise._then(iterator, thrower,
                                              null, null, null);
                }
            }
            iterator();
        }
        iterator();
        return ret;
    }

    function Disposer(data, promise, context) {
        this._data = data;
        this._promise = promise;
        this._context = context;
    }

    Disposer.prototype.data = function () {
        return this._data;
    };

    Disposer.prototype.promise = function () {
        return this._promise;
    };

    Disposer.prototype.resource = function () {
        if (this.promise().isFulfilled()) {
            return this.promise().value();
        }
        return NULL;
    };

    Disposer.prototype.tryDispose = function(inspection) {
        var resource = this.resource();
        var context = this._context;
        if (context !== undefined) context._pushContext();
        var ret = resource !== NULL
            ? this.doDispose(resource, inspection) : null;
        if (context !== undefined) context._popContext();
        this._promise._unsetDisposable();
        this._data = null;
        return ret;
    };

    Disposer.isDisposer = function (d) {
        return (d != null &&
                typeof d.resource === "function" &&
                typeof d.tryDispose === "function");
    };

    function FunctionDisposer(fn, promise, context) {
        this.constructor$(fn, promise, context);
    }
    inherits(FunctionDisposer, Disposer);

    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
        var fn = this.data();
        return fn.call(resource, resource, inspection);
    };

    function maybeUnwrapDisposer(value) {
        if (Disposer.isDisposer(value)) {
            this.resources[this.index]._setDisposable(value);
            return value.promise();
        }
        return value;
    }

    function ResourceList(length) {
        this.length = length;
        this.promise = null;
        this[length-1] = null;
    }

    ResourceList.prototype._resultCancelled = function() {
        var len = this.length;
        for (var i = 0; i < len; ++i) {
            var item = this[i];
            if (item instanceof Promise) {
                item.cancel();
            }
        }
    };

    Promise.using = function () {
        var len = arguments.length;
        if (len < 2) return apiRejection(
                        "you must pass at least 2 arguments to Promise.using");
        var fn = arguments[len - 1];
        if (typeof fn !== "function") {
            return apiRejection("expecting a function but got " + util.classString(fn));
        }
        var input;
        var spreadArgs = true;
        if (len === 2 && Array.isArray(arguments[0])) {
            input = arguments[0];
            len = input.length;
            spreadArgs = false;
        } else {
            input = arguments;
            len--;
        }
        var resources = new ResourceList(len);
        for (var i = 0; i < len; ++i) {
            var resource = input[i];
            if (Disposer.isDisposer(resource)) {
                var disposer = resource;
                resource = resource.promise();
                resource._setDisposable(disposer);
            } else {
                var maybePromise = tryConvertToPromise(resource);
                if (maybePromise instanceof Promise) {
                    resource =
                        maybePromise._then(maybeUnwrapDisposer, null, null, {
                            resources: resources,
                            index: i
                    }, undefined);
                }
            }
            resources[i] = resource;
        }

        var reflectedResources = new Array(resources.length);
        for (var i = 0; i < reflectedResources.length; ++i) {
            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
        }

        var resultPromise = Promise.all(reflectedResources)
            .then(function(inspections) {
                for (var i = 0; i < inspections.length; ++i) {
                    var inspection = inspections[i];
                    if (inspection.isRejected()) {
                        errorObj.e = inspection.error();
                        return errorObj;
                    } else if (!inspection.isFulfilled()) {
                        resultPromise.cancel();
                        return;
                    }
                    inspections[i] = inspection.value();
                }
                promise._pushContext();

                fn = tryCatch(fn);
                var ret = spreadArgs
                    ? fn.apply(undefined, inspections) : fn(inspections);
                var promiseCreated = promise._popContext();
                debug.checkForgottenReturns(
                    ret, promiseCreated, "Promise.using", promise);
                return ret;
            });

        var promise = resultPromise.lastly(function() {
            var inspection = new Promise.PromiseInspection(resultPromise);
            return dispose(resources, inspection);
        });
        resources.promise = promise;
        promise._setOnCancel(resources);
        return promise;
    };

    Promise.prototype._setDisposable = function (disposer) {
        this._bitField = this._bitField | 131072;
        this._disposer = disposer;
    };

    Promise.prototype._isDisposable = function () {
        return (this._bitField & 131072) > 0;
    };

    Promise.prototype._getDisposer = function () {
        return this._disposer;
    };

    Promise.prototype._unsetDisposable = function () {
        this._bitField = this._bitField & (~131072);
        this._disposer = undefined;
    };

    Promise.prototype.disposer = function (fn) {
        if (typeof fn === "function") {
            return new FunctionDisposer(fn, this, createContext());
        }
        throw new TypeError();
    };

};

},{"./errors":58,"./util":82}],82:[function(require,module,exports){
(function (process,global){
"use strict";
var es5 = require("./es5");
var canEvaluate = typeof navigator == "undefined";

var errorObj = {e: {}};
var tryCatchTarget;
var globalObject = typeof self !== "undefined" ? self :
    typeof window !== "undefined" ? window :
    typeof global !== "undefined" ? global :
    this !== undefined ? this : null;

function tryCatcher() {
    try {
        var target = tryCatchTarget;
        tryCatchTarget = null;
        return target.apply(this, arguments);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}

var inherits = function(Child, Parent) {
    var hasProp = {}.hasOwnProperty;

    function T() {
        this.constructor = Child;
        this.constructor$ = Parent;
        for (var propertyName in Parent.prototype) {
            if (hasProp.call(Parent.prototype, propertyName) &&
                propertyName.charAt(propertyName.length-1) !== "$"
           ) {
                this[propertyName + "$"] = Parent.prototype[propertyName];
            }
        }
    }
    T.prototype = Parent.prototype;
    Child.prototype = new T();
    return Child.prototype;
};


function isPrimitive(val) {
    return val == null || val === true || val === false ||
        typeof val === "string" || typeof val === "number";

}

function isObject(value) {
    return typeof value === "function" ||
           typeof value === "object" && value !== null;
}

function maybeWrapAsError(maybeError) {
    if (!isPrimitive(maybeError)) return maybeError;

    return new Error(safeToString(maybeError));
}

function withAppended(target, appendee) {
    var len = target.length;
    var ret = new Array(len + 1);
    var i;
    for (i = 0; i < len; ++i) {
        ret[i] = target[i];
    }
    ret[i] = appendee;
    return ret;
}

function getDataPropertyOrDefault(obj, key, defaultValue) {
    if (es5.isES5) {
        var desc = Object.getOwnPropertyDescriptor(obj, key);

        if (desc != null) {
            return desc.get == null && desc.set == null
                    ? desc.value
                    : defaultValue;
        }
    } else {
        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
    }
}

function notEnumerableProp(obj, name, value) {
    if (isPrimitive(obj)) return obj;
    var descriptor = {
        value: value,
        configurable: true,
        enumerable: false,
        writable: true
    };
    es5.defineProperty(obj, name, descriptor);
    return obj;
}

function thrower(r) {
    throw r;
}

var inheritedDataKeys = (function() {
    var excludedPrototypes = [
        Array.prototype,
        Object.prototype,
        Function.prototype
    ];

    var isExcludedProto = function(val) {
        for (var i = 0; i < excludedPrototypes.length; ++i) {
            if (excludedPrototypes[i] === val) {
                return true;
            }
        }
        return false;
    };

    if (es5.isES5) {
        var getKeys = Object.getOwnPropertyNames;
        return function(obj) {
            var ret = [];
            var visitedKeys = Object.create(null);
            while (obj != null && !isExcludedProto(obj)) {
                var keys;
                try {
                    keys = getKeys(obj);
                } catch (e) {
                    return ret;
                }
                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    if (visitedKeys[key]) continue;
                    visitedKeys[key] = true;
                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                    if (desc != null && desc.get == null && desc.set == null) {
                        ret.push(key);
                    }
                }
                obj = es5.getPrototypeOf(obj);
            }
            return ret;
        };
    } else {
        var hasProp = {}.hasOwnProperty;
        return function(obj) {
            if (isExcludedProto(obj)) return [];
            var ret = [];

            /*jshint forin:false */
            enumeration: for (var key in obj) {
                if (hasProp.call(obj, key)) {
                    ret.push(key);
                } else {
                    for (var i = 0; i < excludedPrototypes.length; ++i) {
                        if (hasProp.call(excludedPrototypes[i], key)) {
                            continue enumeration;
                        }
                    }
                    ret.push(key);
                }
            }
            return ret;
        };
    }

})();

var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
function isClass(fn) {
    try {
        if (typeof fn === "function") {
            var keys = es5.names(fn.prototype);

            var hasMethods = es5.isES5 && keys.length > 1;
            var hasMethodsOtherThanConstructor = keys.length > 0 &&
                !(keys.length === 1 && keys[0] === "constructor");
            var hasThisAssignmentAndStaticMethods =
                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;

            if (hasMethods || hasMethodsOtherThanConstructor ||
                hasThisAssignmentAndStaticMethods) {
                return true;
            }
        }
        return false;
    } catch (e) {
        return false;
    }
}

function toFastProperties(obj) {
    /*jshint -W027,-W055,-W031*/
    function FakeConstructor() {}
    FakeConstructor.prototype = obj;
    var l = 8;
    while (l--) new FakeConstructor();
    return obj;
    eval(obj);
}

var rident = /^[a-z$_][a-z$_0-9]*$/i;
function isIdentifier(str) {
    return rident.test(str);
}

function filledRange(count, prefix, suffix) {
    var ret = new Array(count);
    for(var i = 0; i < count; ++i) {
        ret[i] = prefix + i + suffix;
    }
    return ret;
}

function safeToString(obj) {
    try {
        return obj + "";
    } catch (e) {
        return "[no string representation]";
    }
}

function isError(obj) {
    return obj !== null &&
           typeof obj === "object" &&
           typeof obj.message === "string" &&
           typeof obj.name === "string";
}

function markAsOriginatingFromRejection(e) {
    try {
        notEnumerableProp(e, "isOperational", true);
    }
    catch(ignore) {}
}

function originatesFromRejection(e) {
    if (e == null) return false;
    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
        e["isOperational"] === true);
}

function canAttachTrace(obj) {
    return isError(obj) && es5.propertyIsWritable(obj, "stack");
}

var ensureErrorObject = (function() {
    if (!("stack" in new Error())) {
        return function(value) {
            if (canAttachTrace(value)) return value;
            try {throw new Error(safeToString(value));}
            catch(err) {return err;}
        };
    } else {
        return function(value) {
            if (canAttachTrace(value)) return value;
            return new Error(safeToString(value));
        };
    }
})();

function classString(obj) {
    return {}.toString.call(obj);
}

function copyDescriptors(from, to, filter) {
    var keys = es5.names(from);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (filter(key)) {
            try {
                es5.defineProperty(to, key, es5.getDescriptor(from, key));
            } catch (ignore) {}
        }
    }
}

var asArray = function(v) {
    if (es5.isArray(v)) {
        return v;
    }
    return null;
};

if (typeof Symbol !== "undefined" && Symbol.iterator) {
    var ArrayFrom = typeof Array.from === "function" ? function(v) {
        return Array.from(v);
    } : function(v) {
        var ret = [];
        var it = v[Symbol.iterator]();
        var itResult;
        while (!((itResult = it.next()).done)) {
            ret.push(itResult.value);
        }
        return ret;
    };

    asArray = function(v) {
        if (es5.isArray(v)) {
            return v;
        } else if (v != null && typeof v[Symbol.iterator] === "function") {
            return ArrayFrom(v);
        }
        return null;
    };
}

var isNode = typeof process !== "undefined" &&
        classString(process).toLowerCase() === "[object process]";

var hasEnvVariables = typeof process !== "undefined" &&
    typeof process.env !== "undefined";

function env(key) {
    return hasEnvVariables ? process.env[key] : undefined;
}

function getNativePromise() {
    if (typeof Promise === "function") {
        try {
            var promise = new Promise(function(){});
            if ({}.toString.call(promise) === "[object Promise]") {
                return Promise;
            }
        } catch (e) {}
    }
}

function domainBind(self, cb) {
    return self.bind(cb);
}

var ret = {
    isClass: isClass,
    isIdentifier: isIdentifier,
    inheritedDataKeys: inheritedDataKeys,
    getDataPropertyOrDefault: getDataPropertyOrDefault,
    thrower: thrower,
    isArray: es5.isArray,
    asArray: asArray,
    notEnumerableProp: notEnumerableProp,
    isPrimitive: isPrimitive,
    isObject: isObject,
    isError: isError,
    canEvaluate: canEvaluate,
    errorObj: errorObj,
    tryCatch: tryCatch,
    inherits: inherits,
    withAppended: withAppended,
    maybeWrapAsError: maybeWrapAsError,
    toFastProperties: toFastProperties,
    filledRange: filledRange,
    toString: safeToString,
    canAttachTrace: canAttachTrace,
    ensureErrorObject: ensureErrorObject,
    originatesFromRejection: originatesFromRejection,
    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
    classString: classString,
    copyDescriptors: copyDescriptors,
    hasDevTools: typeof chrome !== "undefined" && chrome &&
                 typeof chrome.loadTimes === "function",
    isNode: isNode,
    hasEnvVariables: hasEnvVariables,
    env: env,
    global: globalObject,
    getNativePromise: getNativePromise,
    domainBind: domainBind
};
ret.isRecentNode = ret.isNode && (function() {
    var version = process.versions.node.split(".").map(Number);
    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
})();

if (ret.isNode) ret.toFastProperties(process);

try {throw new Error(); } catch (e) {ret.lastLineError = e;}
module.exports = ret;

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./es5":59,"_process":101}],83:[function(require,module,exports){
(function (global){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = require('base64-js')
var ieee754 = require('ieee754')
var isArray = require('isarray')

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"base64-js":47,"ieee754":86,"isarray":87}],84:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dingbats = [
    { "Typeface name": "Symbol", "Dingbat dec": "32", "Dingbat hex": "20", "Unicode dec": "32", "Unicode hex": "20" },
    { "Typeface name": "Symbol", "Dingbat dec": "33", "Dingbat hex": "21", "Unicode dec": "33", "Unicode hex": "21" },
    { "Typeface name": "Symbol", "Dingbat dec": "34", "Dingbat hex": "22", "Unicode dec": "8704", "Unicode hex": "2200" },
    { "Typeface name": "Symbol", "Dingbat dec": "35", "Dingbat hex": "23", "Unicode dec": "35", "Unicode hex": "23" },
    { "Typeface name": "Symbol", "Dingbat dec": "36", "Dingbat hex": "24", "Unicode dec": "8707", "Unicode hex": "2203" },
    { "Typeface name": "Symbol", "Dingbat dec": "37", "Dingbat hex": "25", "Unicode dec": "37", "Unicode hex": "25" },
    { "Typeface name": "Symbol", "Dingbat dec": "38", "Dingbat hex": "26", "Unicode dec": "38", "Unicode hex": "26" },
    { "Typeface name": "Symbol", "Dingbat dec": "39", "Dingbat hex": "27", "Unicode dec": "8717", "Unicode hex": "220D" },
    { "Typeface name": "Symbol", "Dingbat dec": "40", "Dingbat hex": "28", "Unicode dec": "40", "Unicode hex": "28" },
    { "Typeface name": "Symbol", "Dingbat dec": "41", "Dingbat hex": "29", "Unicode dec": "41", "Unicode hex": "29" },
    { "Typeface name": "Symbol", "Dingbat dec": "42", "Dingbat hex": "2A", "Unicode dec": "42", "Unicode hex": "2A" },
    { "Typeface name": "Symbol", "Dingbat dec": "43", "Dingbat hex": "2B", "Unicode dec": "43", "Unicode hex": "2B" },
    { "Typeface name": "Symbol", "Dingbat dec": "44", "Dingbat hex": "2C", "Unicode dec": "44", "Unicode hex": "2C" },
    { "Typeface name": "Symbol", "Dingbat dec": "45", "Dingbat hex": "2D", "Unicode dec": "8722", "Unicode hex": "2212" },
    { "Typeface name": "Symbol", "Dingbat dec": "46", "Dingbat hex": "2E", "Unicode dec": "46", "Unicode hex": "2E" },
    { "Typeface name": "Symbol", "Dingbat dec": "47", "Dingbat hex": "2F", "Unicode dec": "47", "Unicode hex": "2F" },
    { "Typeface name": "Symbol", "Dingbat dec": "48", "Dingbat hex": "30", "Unicode dec": "48", "Unicode hex": "30" },
    { "Typeface name": "Symbol", "Dingbat dec": "49", "Dingbat hex": "31", "Unicode dec": "49", "Unicode hex": "31" },
    { "Typeface name": "Symbol", "Dingbat dec": "50", "Dingbat hex": "32", "Unicode dec": "50", "Unicode hex": "32" },
    { "Typeface name": "Symbol", "Dingbat dec": "51", "Dingbat hex": "33", "Unicode dec": "51", "Unicode hex": "33" },
    { "Typeface name": "Symbol", "Dingbat dec": "52", "Dingbat hex": "34", "Unicode dec": "52", "Unicode hex": "34" },
    { "Typeface name": "Symbol", "Dingbat dec": "53", "Dingbat hex": "35", "Unicode dec": "53", "Unicode hex": "35" },
    { "Typeface name": "Symbol", "Dingbat dec": "54", "Dingbat hex": "36", "Unicode dec": "54", "Unicode hex": "36" },
    { "Typeface name": "Symbol", "Dingbat dec": "55", "Dingbat hex": "37", "Unicode dec": "55", "Unicode hex": "37" },
    { "Typeface name": "Symbol", "Dingbat dec": "56", "Dingbat hex": "38", "Unicode dec": "56", "Unicode hex": "38" },
    { "Typeface name": "Symbol", "Dingbat dec": "57", "Dingbat hex": "39", "Unicode dec": "57", "Unicode hex": "39" },
    { "Typeface name": "Symbol", "Dingbat dec": "58", "Dingbat hex": "3A", "Unicode dec": "58", "Unicode hex": "3A" },
    { "Typeface name": "Symbol", "Dingbat dec": "59", "Dingbat hex": "3B", "Unicode dec": "59", "Unicode hex": "3B" },
    { "Typeface name": "Symbol", "Dingbat dec": "60", "Dingbat hex": "3C", "Unicode dec": "60", "Unicode hex": "3C" },
    { "Typeface name": "Symbol", "Dingbat dec": "61", "Dingbat hex": "3D", "Unicode dec": "61", "Unicode hex": "3D" },
    { "Typeface name": "Symbol", "Dingbat dec": "62", "Dingbat hex": "3E", "Unicode dec": "62", "Unicode hex": "3E" },
    { "Typeface name": "Symbol", "Dingbat dec": "63", "Dingbat hex": "3F", "Unicode dec": "63", "Unicode hex": "3F" },
    { "Typeface name": "Symbol", "Dingbat dec": "64", "Dingbat hex": "40", "Unicode dec": "8773", "Unicode hex": "2245" },
    { "Typeface name": "Symbol", "Dingbat dec": "65", "Dingbat hex": "41", "Unicode dec": "913", "Unicode hex": "391" },
    { "Typeface name": "Symbol", "Dingbat dec": "66", "Dingbat hex": "42", "Unicode dec": "914", "Unicode hex": "392" },
    { "Typeface name": "Symbol", "Dingbat dec": "67", "Dingbat hex": "43", "Unicode dec": "935", "Unicode hex": "3A7" },
    { "Typeface name": "Symbol", "Dingbat dec": "68", "Dingbat hex": "44", "Unicode dec": "916", "Unicode hex": "394" },
    { "Typeface name": "Symbol", "Dingbat dec": "69", "Dingbat hex": "45", "Unicode dec": "917", "Unicode hex": "395" },
    { "Typeface name": "Symbol", "Dingbat dec": "70", "Dingbat hex": "46", "Unicode dec": "934", "Unicode hex": "3A6" },
    { "Typeface name": "Symbol", "Dingbat dec": "71", "Dingbat hex": "47", "Unicode dec": "915", "Unicode hex": "393" },
    { "Typeface name": "Symbol", "Dingbat dec": "72", "Dingbat hex": "48", "Unicode dec": "919", "Unicode hex": "397" },
    { "Typeface name": "Symbol", "Dingbat dec": "73", "Dingbat hex": "49", "Unicode dec": "921", "Unicode hex": "399" },
    { "Typeface name": "Symbol", "Dingbat dec": "74", "Dingbat hex": "4A", "Unicode dec": "977", "Unicode hex": "3D1" },
    { "Typeface name": "Symbol", "Dingbat dec": "75", "Dingbat hex": "4B", "Unicode dec": "922", "Unicode hex": "39A" },
    { "Typeface name": "Symbol", "Dingbat dec": "76", "Dingbat hex": "4C", "Unicode dec": "923", "Unicode hex": "39B" },
    { "Typeface name": "Symbol", "Dingbat dec": "77", "Dingbat hex": "4D", "Unicode dec": "924", "Unicode hex": "39C" },
    { "Typeface name": "Symbol", "Dingbat dec": "78", "Dingbat hex": "4E", "Unicode dec": "925", "Unicode hex": "39D" },
    { "Typeface name": "Symbol", "Dingbat dec": "79", "Dingbat hex": "4F", "Unicode dec": "927", "Unicode hex": "39F" },
    { "Typeface name": "Symbol", "Dingbat dec": "80", "Dingbat hex": "50", "Unicode dec": "928", "Unicode hex": "3A0" },
    { "Typeface name": "Symbol", "Dingbat dec": "81", "Dingbat hex": "51", "Unicode dec": "920", "Unicode hex": "398" },
    { "Typeface name": "Symbol", "Dingbat dec": "82", "Dingbat hex": "52", "Unicode dec": "929", "Unicode hex": "3A1" },
    { "Typeface name": "Symbol", "Dingbat dec": "83", "Dingbat hex": "53", "Unicode dec": "931", "Unicode hex": "3A3" },
    { "Typeface name": "Symbol", "Dingbat dec": "84", "Dingbat hex": "54", "Unicode dec": "932", "Unicode hex": "3A4" },
    { "Typeface name": "Symbol", "Dingbat dec": "85", "Dingbat hex": "55", "Unicode dec": "933", "Unicode hex": "3A5" },
    { "Typeface name": "Symbol", "Dingbat dec": "86", "Dingbat hex": "56", "Unicode dec": "962", "Unicode hex": "3C2" },
    { "Typeface name": "Symbol", "Dingbat dec": "87", "Dingbat hex": "57", "Unicode dec": "937", "Unicode hex": "3A9" },
    { "Typeface name": "Symbol", "Dingbat dec": "88", "Dingbat hex": "58", "Unicode dec": "926", "Unicode hex": "39E" },
    { "Typeface name": "Symbol", "Dingbat dec": "89", "Dingbat hex": "59", "Unicode dec": "936", "Unicode hex": "3A8" },
    { "Typeface name": "Symbol", "Dingbat dec": "90", "Dingbat hex": "5A", "Unicode dec": "918", "Unicode hex": "396" },
    { "Typeface name": "Symbol", "Dingbat dec": "91", "Dingbat hex": "5B", "Unicode dec": "91", "Unicode hex": "5B" },
    { "Typeface name": "Symbol", "Dingbat dec": "92", "Dingbat hex": "5C", "Unicode dec": "8756", "Unicode hex": "2234" },
    { "Typeface name": "Symbol", "Dingbat dec": "93", "Dingbat hex": "5D", "Unicode dec": "93", "Unicode hex": "5D" },
    { "Typeface name": "Symbol", "Dingbat dec": "94", "Dingbat hex": "5E", "Unicode dec": "8869", "Unicode hex": "22A5" },
    { "Typeface name": "Symbol", "Dingbat dec": "95", "Dingbat hex": "5F", "Unicode dec": "95", "Unicode hex": "5F" },
    { "Typeface name": "Symbol", "Dingbat dec": "96", "Dingbat hex": "60", "Unicode dec": "8254", "Unicode hex": "203E" },
    { "Typeface name": "Symbol", "Dingbat dec": "97", "Dingbat hex": "61", "Unicode dec": "945", "Unicode hex": "3B1" },
    { "Typeface name": "Symbol", "Dingbat dec": "98", "Dingbat hex": "62", "Unicode dec": "946", "Unicode hex": "3B2" },
    { "Typeface name": "Symbol", "Dingbat dec": "99", "Dingbat hex": "63", "Unicode dec": "967", "Unicode hex": "3C7" },
    { "Typeface name": "Symbol", "Dingbat dec": "100", "Dingbat hex": "64", "Unicode dec": "948", "Unicode hex": "3B4" },
    { "Typeface name": "Symbol", "Dingbat dec": "101", "Dingbat hex": "65", "Unicode dec": "949", "Unicode hex": "3B5" },
    { "Typeface name": "Symbol", "Dingbat dec": "102", "Dingbat hex": "66", "Unicode dec": "966", "Unicode hex": "3C6" },
    { "Typeface name": "Symbol", "Dingbat dec": "103", "Dingbat hex": "67", "Unicode dec": "947", "Unicode hex": "3B3" },
    { "Typeface name": "Symbol", "Dingbat dec": "104", "Dingbat hex": "68", "Unicode dec": "951", "Unicode hex": "3B7" },
    { "Typeface name": "Symbol", "Dingbat dec": "105", "Dingbat hex": "69", "Unicode dec": "953", "Unicode hex": "3B9" },
    { "Typeface name": "Symbol", "Dingbat dec": "106", "Dingbat hex": "6A", "Unicode dec": "981", "Unicode hex": "3D5" },
    { "Typeface name": "Symbol", "Dingbat dec": "107", "Dingbat hex": "6B", "Unicode dec": "954", "Unicode hex": "3BA" },
    { "Typeface name": "Symbol", "Dingbat dec": "108", "Dingbat hex": "6C", "Unicode dec": "955", "Unicode hex": "3BB" },
    { "Typeface name": "Symbol", "Dingbat dec": "109", "Dingbat hex": "6D", "Unicode dec": "956", "Unicode hex": "3BC" },
    { "Typeface name": "Symbol", "Dingbat dec": "110", "Dingbat hex": "6E", "Unicode dec": "957", "Unicode hex": "3BD" },
    { "Typeface name": "Symbol", "Dingbat dec": "111", "Dingbat hex": "6F", "Unicode dec": "959", "Unicode hex": "3BF" },
    { "Typeface name": "Symbol", "Dingbat dec": "112", "Dingbat hex": "70", "Unicode dec": "960", "Unicode hex": "3C0" },
    { "Typeface name": "Symbol", "Dingbat dec": "113", "Dingbat hex": "71", "Unicode dec": "952", "Unicode hex": "3B8" },
    { "Typeface name": "Symbol", "Dingbat dec": "114", "Dingbat hex": "72", "Unicode dec": "961", "Unicode hex": "3C1" },
    { "Typeface name": "Symbol", "Dingbat dec": "115", "Dingbat hex": "73", "Unicode dec": "963", "Unicode hex": "3C3" },
    { "Typeface name": "Symbol", "Dingbat dec": "116", "Dingbat hex": "74", "Unicode dec": "964", "Unicode hex": "3C4" },
    { "Typeface name": "Symbol", "Dingbat dec": "117", "Dingbat hex": "75", "Unicode dec": "965", "Unicode hex": "3C5" },
    { "Typeface name": "Symbol", "Dingbat dec": "118", "Dingbat hex": "76", "Unicode dec": "982", "Unicode hex": "3D6" },
    { "Typeface name": "Symbol", "Dingbat dec": "119", "Dingbat hex": "77", "Unicode dec": "969", "Unicode hex": "3C9" },
    { "Typeface name": "Symbol", "Dingbat dec": "120", "Dingbat hex": "78", "Unicode dec": "958", "Unicode hex": "3BE" },
    { "Typeface name": "Symbol", "Dingbat dec": "121", "Dingbat hex": "79", "Unicode dec": "968", "Unicode hex": "3C8" },
    { "Typeface name": "Symbol", "Dingbat dec": "122", "Dingbat hex": "7A", "Unicode dec": "950", "Unicode hex": "3B6" },
    { "Typeface name": "Symbol", "Dingbat dec": "123", "Dingbat hex": "7B", "Unicode dec": "123", "Unicode hex": "7B" },
    { "Typeface name": "Symbol", "Dingbat dec": "124", "Dingbat hex": "7C", "Unicode dec": "124", "Unicode hex": "7C" },
    { "Typeface name": "Symbol", "Dingbat dec": "125", "Dingbat hex": "7D", "Unicode dec": "125", "Unicode hex": "7D" },
    { "Typeface name": "Symbol", "Dingbat dec": "126", "Dingbat hex": "7E", "Unicode dec": "126", "Unicode hex": "7E" },
    { "Typeface name": "Symbol", "Dingbat dec": "160", "Dingbat hex": "A0", "Unicode dec": "8364", "Unicode hex": "20AC" },
    { "Typeface name": "Symbol", "Dingbat dec": "161", "Dingbat hex": "A1", "Unicode dec": "978", "Unicode hex": "3D2" },
    { "Typeface name": "Symbol", "Dingbat dec": "162", "Dingbat hex": "A2", "Unicode dec": "8242", "Unicode hex": "2032" },
    { "Typeface name": "Symbol", "Dingbat dec": "163", "Dingbat hex": "A3", "Unicode dec": "8804", "Unicode hex": "2264" },
    { "Typeface name": "Symbol", "Dingbat dec": "164", "Dingbat hex": "A4", "Unicode dec": "8260", "Unicode hex": "2044" },
    { "Typeface name": "Symbol", "Dingbat dec": "165", "Dingbat hex": "A5", "Unicode dec": "8734", "Unicode hex": "221E" },
    { "Typeface name": "Symbol", "Dingbat dec": "166", "Dingbat hex": "A6", "Unicode dec": "402", "Unicode hex": "192" },
    { "Typeface name": "Symbol", "Dingbat dec": "167", "Dingbat hex": "A7", "Unicode dec": "9827", "Unicode hex": "2663" },
    { "Typeface name": "Symbol", "Dingbat dec": "168", "Dingbat hex": "A8", "Unicode dec": "9830", "Unicode hex": "2666" },
    { "Typeface name": "Symbol", "Dingbat dec": "169", "Dingbat hex": "A9", "Unicode dec": "9829", "Unicode hex": "2665" },
    { "Typeface name": "Symbol", "Dingbat dec": "170", "Dingbat hex": "AA", "Unicode dec": "9824", "Unicode hex": "2660" },
    { "Typeface name": "Symbol", "Dingbat dec": "171", "Dingbat hex": "AB", "Unicode dec": "8596", "Unicode hex": "2194" },
    { "Typeface name": "Symbol", "Dingbat dec": "172", "Dingbat hex": "AC", "Unicode dec": "8592", "Unicode hex": "2190" },
    { "Typeface name": "Symbol", "Dingbat dec": "173", "Dingbat hex": "AD", "Unicode dec": "8593", "Unicode hex": "2191" },
    { "Typeface name": "Symbol", "Dingbat dec": "174", "Dingbat hex": "AE", "Unicode dec": "8594", "Unicode hex": "2192" },
    { "Typeface name": "Symbol", "Dingbat dec": "175", "Dingbat hex": "AF", "Unicode dec": "8595", "Unicode hex": "2193" },
    { "Typeface name": "Symbol", "Dingbat dec": "176", "Dingbat hex": "B0", "Unicode dec": "176", "Unicode hex": "B0" },
    { "Typeface name": "Symbol", "Dingbat dec": "177", "Dingbat hex": "B1", "Unicode dec": "177", "Unicode hex": "B1" },
    { "Typeface name": "Symbol", "Dingbat dec": "178", "Dingbat hex": "B2", "Unicode dec": "8243", "Unicode hex": "2033" },
    { "Typeface name": "Symbol", "Dingbat dec": "179", "Dingbat hex": "B3", "Unicode dec": "8805", "Unicode hex": "2265" },
    { "Typeface name": "Symbol", "Dingbat dec": "180", "Dingbat hex": "B4", "Unicode dec": "215", "Unicode hex": "D7" },
    { "Typeface name": "Symbol", "Dingbat dec": "181", "Dingbat hex": "B5", "Unicode dec": "8733", "Unicode hex": "221D" },
    { "Typeface name": "Symbol", "Dingbat dec": "182", "Dingbat hex": "B6", "Unicode dec": "8706", "Unicode hex": "2202" },
    { "Typeface name": "Symbol", "Dingbat dec": "183", "Dingbat hex": "B7", "Unicode dec": "8226", "Unicode hex": "2022" },
    { "Typeface name": "Symbol", "Dingbat dec": "184", "Dingbat hex": "B8", "Unicode dec": "247", "Unicode hex": "F7" },
    { "Typeface name": "Symbol", "Dingbat dec": "185", "Dingbat hex": "B9", "Unicode dec": "8800", "Unicode hex": "2260" },
    { "Typeface name": "Symbol", "Dingbat dec": "186", "Dingbat hex": "BA", "Unicode dec": "8801", "Unicode hex": "2261" },
    { "Typeface name": "Symbol", "Dingbat dec": "187", "Dingbat hex": "BB", "Unicode dec": "8776", "Unicode hex": "2248" },
    { "Typeface name": "Symbol", "Dingbat dec": "188", "Dingbat hex": "BC", "Unicode dec": "8230", "Unicode hex": "2026" },
    { "Typeface name": "Symbol", "Dingbat dec": "189", "Dingbat hex": "BD", "Unicode dec": "9168", "Unicode hex": "23D0" },
    { "Typeface name": "Symbol", "Dingbat dec": "190", "Dingbat hex": "BE", "Unicode dec": "9135", "Unicode hex": "23AF" },
    { "Typeface name": "Symbol", "Dingbat dec": "191", "Dingbat hex": "BF", "Unicode dec": "8629", "Unicode hex": "21B5" },
    { "Typeface name": "Symbol", "Dingbat dec": "192", "Dingbat hex": "C0", "Unicode dec": "8501", "Unicode hex": "2135" },
    { "Typeface name": "Symbol", "Dingbat dec": "193", "Dingbat hex": "C1", "Unicode dec": "8465", "Unicode hex": "2111" },
    { "Typeface name": "Symbol", "Dingbat dec": "194", "Dingbat hex": "C2", "Unicode dec": "8476", "Unicode hex": "211C" },
    { "Typeface name": "Symbol", "Dingbat dec": "195", "Dingbat hex": "C3", "Unicode dec": "8472", "Unicode hex": "2118" },
    { "Typeface name": "Symbol", "Dingbat dec": "196", "Dingbat hex": "C4", "Unicode dec": "8855", "Unicode hex": "2297" },
    { "Typeface name": "Symbol", "Dingbat dec": "197", "Dingbat hex": "C5", "Unicode dec": "8853", "Unicode hex": "2295" },
    { "Typeface name": "Symbol", "Dingbat dec": "198", "Dingbat hex": "C6", "Unicode dec": "8709", "Unicode hex": "2205" },
    { "Typeface name": "Symbol", "Dingbat dec": "199", "Dingbat hex": "C7", "Unicode dec": "8745", "Unicode hex": "2229" },
    { "Typeface name": "Symbol", "Dingbat dec": "200", "Dingbat hex": "C8", "Unicode dec": "8746", "Unicode hex": "222A" },
    { "Typeface name": "Symbol", "Dingbat dec": "201", "Dingbat hex": "C9", "Unicode dec": "8835", "Unicode hex": "2283" },
    { "Typeface name": "Symbol", "Dingbat dec": "202", "Dingbat hex": "CA", "Unicode dec": "8839", "Unicode hex": "2287" },
    { "Typeface name": "Symbol", "Dingbat dec": "203", "Dingbat hex": "CB", "Unicode dec": "8836", "Unicode hex": "2284" },
    { "Typeface name": "Symbol", "Dingbat dec": "204", "Dingbat hex": "CC", "Unicode dec": "8834", "Unicode hex": "2282" },
    { "Typeface name": "Symbol", "Dingbat dec": "205", "Dingbat hex": "CD", "Unicode dec": "8838", "Unicode hex": "2286" },
    { "Typeface name": "Symbol", "Dingbat dec": "206", "Dingbat hex": "CE", "Unicode dec": "8712", "Unicode hex": "2208" },
    { "Typeface name": "Symbol", "Dingbat dec": "207", "Dingbat hex": "CF", "Unicode dec": "8713", "Unicode hex": "2209" },
    { "Typeface name": "Symbol", "Dingbat dec": "208", "Dingbat hex": "D0", "Unicode dec": "8736", "Unicode hex": "2220" },
    { "Typeface name": "Symbol", "Dingbat dec": "209", "Dingbat hex": "D1", "Unicode dec": "8711", "Unicode hex": "2207" },
    { "Typeface name": "Symbol", "Dingbat dec": "210", "Dingbat hex": "D2", "Unicode dec": "174", "Unicode hex": "AE" },
    { "Typeface name": "Symbol", "Dingbat dec": "211", "Dingbat hex": "D3", "Unicode dec": "169", "Unicode hex": "A9" },
    { "Typeface name": "Symbol", "Dingbat dec": "212", "Dingbat hex": "D4", "Unicode dec": "8482", "Unicode hex": "2122" },
    { "Typeface name": "Symbol", "Dingbat dec": "213", "Dingbat hex": "D5", "Unicode dec": "8719", "Unicode hex": "220F" },
    { "Typeface name": "Symbol", "Dingbat dec": "214", "Dingbat hex": "D6", "Unicode dec": "8730", "Unicode hex": "221A" },
    { "Typeface name": "Symbol", "Dingbat dec": "215", "Dingbat hex": "D7", "Unicode dec": "8901", "Unicode hex": "22C5" },
    { "Typeface name": "Symbol", "Dingbat dec": "216", "Dingbat hex": "D8", "Unicode dec": "172", "Unicode hex": "AC" },
    { "Typeface name": "Symbol", "Dingbat dec": "217", "Dingbat hex": "D9", "Unicode dec": "8743", "Unicode hex": "2227" },
    { "Typeface name": "Symbol", "Dingbat dec": "218", "Dingbat hex": "DA", "Unicode dec": "8744", "Unicode hex": "2228" },
    { "Typeface name": "Symbol", "Dingbat dec": "219", "Dingbat hex": "DB", "Unicode dec": "8660", "Unicode hex": "21D4" },
    { "Typeface name": "Symbol", "Dingbat dec": "220", "Dingbat hex": "DC", "Unicode dec": "8656", "Unicode hex": "21D0" },
    { "Typeface name": "Symbol", "Dingbat dec": "221", "Dingbat hex": "DD", "Unicode dec": "8657", "Unicode hex": "21D1" },
    { "Typeface name": "Symbol", "Dingbat dec": "222", "Dingbat hex": "DE", "Unicode dec": "8658", "Unicode hex": "21D2" },
    { "Typeface name": "Symbol", "Dingbat dec": "223", "Dingbat hex": "DF", "Unicode dec": "8659", "Unicode hex": "21D3" },
    { "Typeface name": "Symbol", "Dingbat dec": "224", "Dingbat hex": "E0", "Unicode dec": "9674", "Unicode hex": "25CA" },
    { "Typeface name": "Symbol", "Dingbat dec": "225", "Dingbat hex": "E1", "Unicode dec": "12296", "Unicode hex": "3008" },
    { "Typeface name": "Symbol", "Dingbat dec": "226", "Dingbat hex": "E2", "Unicode dec": "174", "Unicode hex": "AE" },
    { "Typeface name": "Symbol", "Dingbat dec": "227", "Dingbat hex": "E3", "Unicode dec": "169", "Unicode hex": "A9" },
    { "Typeface name": "Symbol", "Dingbat dec": "228", "Dingbat hex": "E4", "Unicode dec": "8482", "Unicode hex": "2122" },
    { "Typeface name": "Symbol", "Dingbat dec": "229", "Dingbat hex": "E5", "Unicode dec": "8721", "Unicode hex": "2211" },
    { "Typeface name": "Symbol", "Dingbat dec": "230", "Dingbat hex": "E6", "Unicode dec": "9115", "Unicode hex": "239B" },
    { "Typeface name": "Symbol", "Dingbat dec": "231", "Dingbat hex": "E7", "Unicode dec": "9116", "Unicode hex": "239C" },
    { "Typeface name": "Symbol", "Dingbat dec": "232", "Dingbat hex": "E8", "Unicode dec": "9117", "Unicode hex": "239D" },
    { "Typeface name": "Symbol", "Dingbat dec": "233", "Dingbat hex": "E9", "Unicode dec": "9121", "Unicode hex": "23A1" },
    { "Typeface name": "Symbol", "Dingbat dec": "234", "Dingbat hex": "EA", "Unicode dec": "9122", "Unicode hex": "23A2" },
    { "Typeface name": "Symbol", "Dingbat dec": "235", "Dingbat hex": "EB", "Unicode dec": "9123", "Unicode hex": "23A3" },
    { "Typeface name": "Symbol", "Dingbat dec": "236", "Dingbat hex": "EC", "Unicode dec": "9127", "Unicode hex": "23A7" },
    { "Typeface name": "Symbol", "Dingbat dec": "237", "Dingbat hex": "ED", "Unicode dec": "9128", "Unicode hex": "23A8" },
    { "Typeface name": "Symbol", "Dingbat dec": "238", "Dingbat hex": "EE", "Unicode dec": "9129", "Unicode hex": "23A9" },
    { "Typeface name": "Symbol", "Dingbat dec": "239", "Dingbat hex": "EF", "Unicode dec": "9130", "Unicode hex": "23AA" },
    { "Typeface name": "Symbol", "Dingbat dec": "240", "Dingbat hex": "F0", "Unicode dec": "63743", "Unicode hex": "F8FF" },
    { "Typeface name": "Symbol", "Dingbat dec": "241", "Dingbat hex": "F1", "Unicode dec": "12297", "Unicode hex": "3009" },
    { "Typeface name": "Symbol", "Dingbat dec": "242", "Dingbat hex": "F2", "Unicode dec": "8747", "Unicode hex": "222B" },
    { "Typeface name": "Symbol", "Dingbat dec": "243", "Dingbat hex": "F3", "Unicode dec": "8992", "Unicode hex": "2320" },
    { "Typeface name": "Symbol", "Dingbat dec": "244", "Dingbat hex": "F4", "Unicode dec": "9134", "Unicode hex": "23AE" },
    { "Typeface name": "Symbol", "Dingbat dec": "245", "Dingbat hex": "F5", "Unicode dec": "8993", "Unicode hex": "2321" },
    { "Typeface name": "Symbol", "Dingbat dec": "246", "Dingbat hex": "F6", "Unicode dec": "9118", "Unicode hex": "239E" },
    { "Typeface name": "Symbol", "Dingbat dec": "247", "Dingbat hex": "F7", "Unicode dec": "9119", "Unicode hex": "239F" },
    { "Typeface name": "Symbol", "Dingbat dec": "248", "Dingbat hex": "F8", "Unicode dec": "9120", "Unicode hex": "23A0" },
    { "Typeface name": "Symbol", "Dingbat dec": "249", "Dingbat hex": "F9", "Unicode dec": "9124", "Unicode hex": "23A4" },
    { "Typeface name": "Symbol", "Dingbat dec": "250", "Dingbat hex": "FA", "Unicode dec": "9125", "Unicode hex": "23A5" },
    { "Typeface name": "Symbol", "Dingbat dec": "251", "Dingbat hex": "FB", "Unicode dec": "9126", "Unicode hex": "23A6" },
    { "Typeface name": "Symbol", "Dingbat dec": "252", "Dingbat hex": "FC", "Unicode dec": "9131", "Unicode hex": "23AB" },
    { "Typeface name": "Symbol", "Dingbat dec": "253", "Dingbat hex": "FD", "Unicode dec": "9132", "Unicode hex": "23AC" },
    { "Typeface name": "Symbol", "Dingbat dec": "254", "Dingbat hex": "FE", "Unicode dec": "9133", "Unicode hex": "23AD" },
    { "Typeface name": "Webdings", "Dingbat dec": "32", "Dingbat hex": "20", "Unicode dec": "32", "Unicode hex": "20" },
    { "Typeface name": "Webdings", "Dingbat dec": "33", "Dingbat hex": "21", "Unicode dec": "128375", "Unicode hex": "1F577" },
    { "Typeface name": "Webdings", "Dingbat dec": "34", "Dingbat hex": "22", "Unicode dec": "128376", "Unicode hex": "1F578" },
    { "Typeface name": "Webdings", "Dingbat dec": "35", "Dingbat hex": "23", "Unicode dec": "128370", "Unicode hex": "1F572" },
    { "Typeface name": "Webdings", "Dingbat dec": "36", "Dingbat hex": "24", "Unicode dec": "128374", "Unicode hex": "1F576" },
    { "Typeface name": "Webdings", "Dingbat dec": "37", "Dingbat hex": "25", "Unicode dec": "127942", "Unicode hex": "1F3C6" },
    { "Typeface name": "Webdings", "Dingbat dec": "38", "Dingbat hex": "26", "Unicode dec": "127894", "Unicode hex": "1F396" },
    { "Typeface name": "Webdings", "Dingbat dec": "39", "Dingbat hex": "27", "Unicode dec": "128391", "Unicode hex": "1F587" },
    { "Typeface name": "Webdings", "Dingbat dec": "40", "Dingbat hex": "28", "Unicode dec": "128488", "Unicode hex": "1F5E8" },
    { "Typeface name": "Webdings", "Dingbat dec": "41", "Dingbat hex": "29", "Unicode dec": "128489", "Unicode hex": "1F5E9" },
    { "Typeface name": "Webdings", "Dingbat dec": "42", "Dingbat hex": "2A", "Unicode dec": "128496", "Unicode hex": "1F5F0" },
    { "Typeface name": "Webdings", "Dingbat dec": "43", "Dingbat hex": "2B", "Unicode dec": "128497", "Unicode hex": "1F5F1" },
    { "Typeface name": "Webdings", "Dingbat dec": "44", "Dingbat hex": "2C", "Unicode dec": "127798", "Unicode hex": "1F336" },
    { "Typeface name": "Webdings", "Dingbat dec": "45", "Dingbat hex": "2D", "Unicode dec": "127895", "Unicode hex": "1F397" },
    { "Typeface name": "Webdings", "Dingbat dec": "46", "Dingbat hex": "2E", "Unicode dec": "128638", "Unicode hex": "1F67E" },
    { "Typeface name": "Webdings", "Dingbat dec": "47", "Dingbat hex": "2F", "Unicode dec": "128636", "Unicode hex": "1F67C" },
    { "Typeface name": "Webdings", "Dingbat dec": "48", "Dingbat hex": "30", "Unicode dec": "128469", "Unicode hex": "1F5D5" },
    { "Typeface name": "Webdings", "Dingbat dec": "49", "Dingbat hex": "31", "Unicode dec": "128470", "Unicode hex": "1F5D6" },
    { "Typeface name": "Webdings", "Dingbat dec": "50", "Dingbat hex": "32", "Unicode dec": "128471", "Unicode hex": "1F5D7" },
    { "Typeface name": "Webdings", "Dingbat dec": "51", "Dingbat hex": "33", "Unicode dec": "9204", "Unicode hex": "23F4" },
    { "Typeface name": "Webdings", "Dingbat dec": "52", "Dingbat hex": "34", "Unicode dec": "9205", "Unicode hex": "23F5" },
    { "Typeface name": "Webdings", "Dingbat dec": "53", "Dingbat hex": "35", "Unicode dec": "9206", "Unicode hex": "23F6" },
    { "Typeface name": "Webdings", "Dingbat dec": "54", "Dingbat hex": "36", "Unicode dec": "9207", "Unicode hex": "23F7" },
    { "Typeface name": "Webdings", "Dingbat dec": "55", "Dingbat hex": "37", "Unicode dec": "9194", "Unicode hex": "23EA" },
    { "Typeface name": "Webdings", "Dingbat dec": "56", "Dingbat hex": "38", "Unicode dec": "9193", "Unicode hex": "23E9" },
    { "Typeface name": "Webdings", "Dingbat dec": "57", "Dingbat hex": "39", "Unicode dec": "9198", "Unicode hex": "23EE" },
    { "Typeface name": "Webdings", "Dingbat dec": "58", "Dingbat hex": "3A", "Unicode dec": "9197", "Unicode hex": "23ED" },
    { "Typeface name": "Webdings", "Dingbat dec": "59", "Dingbat hex": "3B", "Unicode dec": "9208", "Unicode hex": "23F8" },
    { "Typeface name": "Webdings", "Dingbat dec": "60", "Dingbat hex": "3C", "Unicode dec": "9209", "Unicode hex": "23F9" },
    { "Typeface name": "Webdings", "Dingbat dec": "61", "Dingbat hex": "3D", "Unicode dec": "9210", "Unicode hex": "23FA" },
    { "Typeface name": "Webdings", "Dingbat dec": "62", "Dingbat hex": "3E", "Unicode dec": "128474", "Unicode hex": "1F5DA" },
    { "Typeface name": "Webdings", "Dingbat dec": "63", "Dingbat hex": "3F", "Unicode dec": "128499", "Unicode hex": "1F5F3" },
    { "Typeface name": "Webdings", "Dingbat dec": "64", "Dingbat hex": "40", "Unicode dec": "128736", "Unicode hex": "1F6E0" },
    { "Typeface name": "Webdings", "Dingbat dec": "65", "Dingbat hex": "41", "Unicode dec": "127959", "Unicode hex": "1F3D7" },
    { "Typeface name": "Webdings", "Dingbat dec": "66", "Dingbat hex": "42", "Unicode dec": "127960", "Unicode hex": "1F3D8" },
    { "Typeface name": "Webdings", "Dingbat dec": "67", "Dingbat hex": "43", "Unicode dec": "127961", "Unicode hex": "1F3D9" },
    { "Typeface name": "Webdings", "Dingbat dec": "68", "Dingbat hex": "44", "Unicode dec": "127962", "Unicode hex": "1F3DA" },
    { "Typeface name": "Webdings", "Dingbat dec": "69", "Dingbat hex": "45", "Unicode dec": "127964", "Unicode hex": "1F3DC" },
    { "Typeface name": "Webdings", "Dingbat dec": "70", "Dingbat hex": "46", "Unicode dec": "127981", "Unicode hex": "1F3ED" },
    { "Typeface name": "Webdings", "Dingbat dec": "71", "Dingbat hex": "47", "Unicode dec": "127963", "Unicode hex": "1F3DB" },
    { "Typeface name": "Webdings", "Dingbat dec": "72", "Dingbat hex": "48", "Unicode dec": "127968", "Unicode hex": "1F3E0" },
    { "Typeface name": "Webdings", "Dingbat dec": "73", "Dingbat hex": "49", "Unicode dec": "127958", "Unicode hex": "1F3D6" },
    { "Typeface name": "Webdings", "Dingbat dec": "74", "Dingbat hex": "4A", "Unicode dec": "127965", "Unicode hex": "1F3DD" },
    { "Typeface name": "Webdings", "Dingbat dec": "75", "Dingbat hex": "4B", "Unicode dec": "128739", "Unicode hex": "1F6E3" },
    { "Typeface name": "Webdings", "Dingbat dec": "76", "Dingbat hex": "4C", "Unicode dec": "128269", "Unicode hex": "1F50D" },
    { "Typeface name": "Webdings", "Dingbat dec": "77", "Dingbat hex": "4D", "Unicode dec": "127956", "Unicode hex": "1F3D4" },
    { "Typeface name": "Webdings", "Dingbat dec": "78", "Dingbat hex": "4E", "Unicode dec": "128065", "Unicode hex": "1F441" },
    { "Typeface name": "Webdings", "Dingbat dec": "79", "Dingbat hex": "4F", "Unicode dec": "128066", "Unicode hex": "1F442" },
    { "Typeface name": "Webdings", "Dingbat dec": "80", "Dingbat hex": "50", "Unicode dec": "127966", "Unicode hex": "1F3DE" },
    { "Typeface name": "Webdings", "Dingbat dec": "81", "Dingbat hex": "51", "Unicode dec": "127957", "Unicode hex": "1F3D5" },
    { "Typeface name": "Webdings", "Dingbat dec": "82", "Dingbat hex": "52", "Unicode dec": "128740", "Unicode hex": "1F6E4" },
    { "Typeface name": "Webdings", "Dingbat dec": "83", "Dingbat hex": "53", "Unicode dec": "127967", "Unicode hex": "1F3DF" },
    { "Typeface name": "Webdings", "Dingbat dec": "84", "Dingbat hex": "54", "Unicode dec": "128755", "Unicode hex": "1F6F3" },
    { "Typeface name": "Webdings", "Dingbat dec": "85", "Dingbat hex": "55", "Unicode dec": "128364", "Unicode hex": "1F56C" },
    { "Typeface name": "Webdings", "Dingbat dec": "86", "Dingbat hex": "56", "Unicode dec": "128363", "Unicode hex": "1F56B" },
    { "Typeface name": "Webdings", "Dingbat dec": "87", "Dingbat hex": "57", "Unicode dec": "128360", "Unicode hex": "1F568" },
    { "Typeface name": "Webdings", "Dingbat dec": "88", "Dingbat hex": "58", "Unicode dec": "128264", "Unicode hex": "1F508" },
    { "Typeface name": "Webdings", "Dingbat dec": "89", "Dingbat hex": "59", "Unicode dec": "127892", "Unicode hex": "1F394" },
    { "Typeface name": "Webdings", "Dingbat dec": "90", "Dingbat hex": "5A", "Unicode dec": "127893", "Unicode hex": "1F395" },
    { "Typeface name": "Webdings", "Dingbat dec": "91", "Dingbat hex": "5B", "Unicode dec": "128492", "Unicode hex": "1F5EC" },
    { "Typeface name": "Webdings", "Dingbat dec": "92", "Dingbat hex": "5C", "Unicode dec": "128637", "Unicode hex": "1F67D" },
    { "Typeface name": "Webdings", "Dingbat dec": "93", "Dingbat hex": "5D", "Unicode dec": "128493", "Unicode hex": "1F5ED" },
    { "Typeface name": "Webdings", "Dingbat dec": "94", "Dingbat hex": "5E", "Unicode dec": "128490", "Unicode hex": "1F5EA" },
    { "Typeface name": "Webdings", "Dingbat dec": "95", "Dingbat hex": "5F", "Unicode dec": "128491", "Unicode hex": "1F5EB" },
    { "Typeface name": "Webdings", "Dingbat dec": "96", "Dingbat hex": "60", "Unicode dec": "11156", "Unicode hex": "2B94" },
    { "Typeface name": "Webdings", "Dingbat dec": "97", "Dingbat hex": "61", "Unicode dec": "10004", "Unicode hex": "2714" },
    { "Typeface name": "Webdings", "Dingbat dec": "98", "Dingbat hex": "62", "Unicode dec": "128690", "Unicode hex": "1F6B2" },
    { "Typeface name": "Webdings", "Dingbat dec": "99", "Dingbat hex": "63", "Unicode dec": "11036", "Unicode hex": "2B1C" },
    { "Typeface name": "Webdings", "Dingbat dec": "100", "Dingbat hex": "64", "Unicode dec": "128737", "Unicode hex": "1F6E1" },
    { "Typeface name": "Webdings", "Dingbat dec": "101", "Dingbat hex": "65", "Unicode dec": "128230", "Unicode hex": "1F4E6" },
    { "Typeface name": "Webdings", "Dingbat dec": "102", "Dingbat hex": "66", "Unicode dec": "128753", "Unicode hex": "1F6F1" },
    { "Typeface name": "Webdings", "Dingbat dec": "103", "Dingbat hex": "67", "Unicode dec": "11035", "Unicode hex": "2B1B" },
    { "Typeface name": "Webdings", "Dingbat dec": "104", "Dingbat hex": "68", "Unicode dec": "128657", "Unicode hex": "1F691" },
    { "Typeface name": "Webdings", "Dingbat dec": "105", "Dingbat hex": "69", "Unicode dec": "128712", "Unicode hex": "1F6C8" },
    { "Typeface name": "Webdings", "Dingbat dec": "106", "Dingbat hex": "6A", "Unicode dec": "128745", "Unicode hex": "1F6E9" },
    { "Typeface name": "Webdings", "Dingbat dec": "107", "Dingbat hex": "6B", "Unicode dec": "128752", "Unicode hex": "1F6F0" },
    { "Typeface name": "Webdings", "Dingbat dec": "108", "Dingbat hex": "6C", "Unicode dec": "128968", "Unicode hex": "1F7C8" },
    { "Typeface name": "Webdings", "Dingbat dec": "109", "Dingbat hex": "6D", "Unicode dec": "128372", "Unicode hex": "1F574" },
    { "Typeface name": "Webdings", "Dingbat dec": "110", "Dingbat hex": "6E", "Unicode dec": "11044", "Unicode hex": "2B24" },
    { "Typeface name": "Webdings", "Dingbat dec": "111", "Dingbat hex": "6F", "Unicode dec": "128741", "Unicode hex": "1F6E5" },
    { "Typeface name": "Webdings", "Dingbat dec": "112", "Dingbat hex": "70", "Unicode dec": "128660", "Unicode hex": "1F694" },
    { "Typeface name": "Webdings", "Dingbat dec": "113", "Dingbat hex": "71", "Unicode dec": "128472", "Unicode hex": "1F5D8" },
    { "Typeface name": "Webdings", "Dingbat dec": "114", "Dingbat hex": "72", "Unicode dec": "128473", "Unicode hex": "1F5D9" },
    { "Typeface name": "Webdings", "Dingbat dec": "115", "Dingbat hex": "73", "Unicode dec": "10067", "Unicode hex": "2753" },
    { "Typeface name": "Webdings", "Dingbat dec": "116", "Dingbat hex": "74", "Unicode dec": "128754", "Unicode hex": "1F6F2" },
    { "Typeface name": "Webdings", "Dingbat dec": "117", "Dingbat hex": "75", "Unicode dec": "128647", "Unicode hex": "1F687" },
    { "Typeface name": "Webdings", "Dingbat dec": "118", "Dingbat hex": "76", "Unicode dec": "128653", "Unicode hex": "1F68D" },
    { "Typeface name": "Webdings", "Dingbat dec": "119", "Dingbat hex": "77", "Unicode dec": "9971", "Unicode hex": "26F3" },
    { "Typeface name": "Webdings", "Dingbat dec": "120", "Dingbat hex": "78", "Unicode dec": "10680", "Unicode hex": "29B8" },
    { "Typeface name": "Webdings", "Dingbat dec": "121", "Dingbat hex": "79", "Unicode dec": "8854", "Unicode hex": "2296" },
    { "Typeface name": "Webdings", "Dingbat dec": "122", "Dingbat hex": "7A", "Unicode dec": "128685", "Unicode hex": "1F6AD" },
    { "Typeface name": "Webdings", "Dingbat dec": "123", "Dingbat hex": "7B", "Unicode dec": "128494", "Unicode hex": "1F5EE" },
    { "Typeface name": "Webdings", "Dingbat dec": "124", "Dingbat hex": "7C", "Unicode dec": "9168", "Unicode hex": "23D0" },
    { "Typeface name": "Webdings", "Dingbat dec": "125", "Dingbat hex": "7D", "Unicode dec": "128495", "Unicode hex": "1F5EF" },
    { "Typeface name": "Webdings", "Dingbat dec": "126", "Dingbat hex": "7E", "Unicode dec": "128498", "Unicode hex": "1F5F2" },
    { "Typeface name": "Webdings", "Dingbat dec": "128", "Dingbat hex": "80", "Unicode dec": "128697", "Unicode hex": "1F6B9" },
    { "Typeface name": "Webdings", "Dingbat dec": "129", "Dingbat hex": "81", "Unicode dec": "128698", "Unicode hex": "1F6BA" },
    { "Typeface name": "Webdings", "Dingbat dec": "130", "Dingbat hex": "82", "Unicode dec": "128713", "Unicode hex": "1F6C9" },
    { "Typeface name": "Webdings", "Dingbat dec": "131", "Dingbat hex": "83", "Unicode dec": "128714", "Unicode hex": "1F6CA" },
    { "Typeface name": "Webdings", "Dingbat dec": "132", "Dingbat hex": "84", "Unicode dec": "128700", "Unicode hex": "1F6BC" },
    { "Typeface name": "Webdings", "Dingbat dec": "133", "Dingbat hex": "85", "Unicode dec": "128125", "Unicode hex": "1F47D" },
    { "Typeface name": "Webdings", "Dingbat dec": "134", "Dingbat hex": "86", "Unicode dec": "127947", "Unicode hex": "1F3CB" },
    { "Typeface name": "Webdings", "Dingbat dec": "135", "Dingbat hex": "87", "Unicode dec": "9975", "Unicode hex": "26F7" },
    { "Typeface name": "Webdings", "Dingbat dec": "136", "Dingbat hex": "88", "Unicode dec": "127938", "Unicode hex": "1F3C2" },
    { "Typeface name": "Webdings", "Dingbat dec": "137", "Dingbat hex": "89", "Unicode dec": "127948", "Unicode hex": "1F3CC" },
    { "Typeface name": "Webdings", "Dingbat dec": "138", "Dingbat hex": "8A", "Unicode dec": "127946", "Unicode hex": "1F3CA" },
    { "Typeface name": "Webdings", "Dingbat dec": "139", "Dingbat hex": "8B", "Unicode dec": "127940", "Unicode hex": "1F3C4" },
    { "Typeface name": "Webdings", "Dingbat dec": "140", "Dingbat hex": "8C", "Unicode dec": "127949", "Unicode hex": "1F3CD" },
    { "Typeface name": "Webdings", "Dingbat dec": "141", "Dingbat hex": "8D", "Unicode dec": "127950", "Unicode hex": "1F3CE" },
    { "Typeface name": "Webdings", "Dingbat dec": "142", "Dingbat hex": "8E", "Unicode dec": "128664", "Unicode hex": "1F698" },
    { "Typeface name": "Webdings", "Dingbat dec": "143", "Dingbat hex": "8F", "Unicode dec": "128480", "Unicode hex": "1F5E0" },
    { "Typeface name": "Webdings", "Dingbat dec": "144", "Dingbat hex": "90", "Unicode dec": "128738", "Unicode hex": "1F6E2" },
    { "Typeface name": "Webdings", "Dingbat dec": "145", "Dingbat hex": "91", "Unicode dec": "128176", "Unicode hex": "1F4B0" },
    { "Typeface name": "Webdings", "Dingbat dec": "146", "Dingbat hex": "92", "Unicode dec": "127991", "Unicode hex": "1F3F7" },
    { "Typeface name": "Webdings", "Dingbat dec": "147", "Dingbat hex": "93", "Unicode dec": "128179", "Unicode hex": "1F4B3" },
    { "Typeface name": "Webdings", "Dingbat dec": "148", "Dingbat hex": "94", "Unicode dec": "128106", "Unicode hex": "1F46A" },
    { "Typeface name": "Webdings", "Dingbat dec": "149", "Dingbat hex": "95", "Unicode dec": "128481", "Unicode hex": "1F5E1" },
    { "Typeface name": "Webdings", "Dingbat dec": "150", "Dingbat hex": "96", "Unicode dec": "128482", "Unicode hex": "1F5E2" },
    { "Typeface name": "Webdings", "Dingbat dec": "151", "Dingbat hex": "97", "Unicode dec": "128483", "Unicode hex": "1F5E3" },
    { "Typeface name": "Webdings", "Dingbat dec": "152", "Dingbat hex": "98", "Unicode dec": "10031", "Unicode hex": "272F" },
    { "Typeface name": "Webdings", "Dingbat dec": "153", "Dingbat hex": "99", "Unicode dec": "128388", "Unicode hex": "1F584" },
    { "Typeface name": "Webdings", "Dingbat dec": "154", "Dingbat hex": "9A", "Unicode dec": "128389", "Unicode hex": "1F585" },
    { "Typeface name": "Webdings", "Dingbat dec": "155", "Dingbat hex": "9B", "Unicode dec": "128387", "Unicode hex": "1F583" },
    { "Typeface name": "Webdings", "Dingbat dec": "156", "Dingbat hex": "9C", "Unicode dec": "128390", "Unicode hex": "1F586" },
    { "Typeface name": "Webdings", "Dingbat dec": "157", "Dingbat hex": "9D", "Unicode dec": "128441", "Unicode hex": "1F5B9" },
    { "Typeface name": "Webdings", "Dingbat dec": "158", "Dingbat hex": "9E", "Unicode dec": "128442", "Unicode hex": "1F5BA" },
    { "Typeface name": "Webdings", "Dingbat dec": "159", "Dingbat hex": "9F", "Unicode dec": "128443", "Unicode hex": "1F5BB" },
    { "Typeface name": "Webdings", "Dingbat dec": "160", "Dingbat hex": "A0", "Unicode dec": "128373", "Unicode hex": "1F575" },
    { "Typeface name": "Webdings", "Dingbat dec": "161", "Dingbat hex": "A1", "Unicode dec": "128368", "Unicode hex": "1F570" },
    { "Typeface name": "Webdings", "Dingbat dec": "162", "Dingbat hex": "A2", "Unicode dec": "128445", "Unicode hex": "1F5BD" },
    { "Typeface name": "Webdings", "Dingbat dec": "163", "Dingbat hex": "A3", "Unicode dec": "128446", "Unicode hex": "1F5BE" },
    { "Typeface name": "Webdings", "Dingbat dec": "164", "Dingbat hex": "A4", "Unicode dec": "128203", "Unicode hex": "1F4CB" },
    { "Typeface name": "Webdings", "Dingbat dec": "165", "Dingbat hex": "A5", "Unicode dec": "128466", "Unicode hex": "1F5D2" },
    { "Typeface name": "Webdings", "Dingbat dec": "166", "Dingbat hex": "A6", "Unicode dec": "128467", "Unicode hex": "1F5D3" },
    { "Typeface name": "Webdings", "Dingbat dec": "167", "Dingbat hex": "A7", "Unicode dec": "128366", "Unicode hex": "1F56E" },
    { "Typeface name": "Webdings", "Dingbat dec": "168", "Dingbat hex": "A8", "Unicode dec": "128218", "Unicode hex": "1F4DA" },
    { "Typeface name": "Webdings", "Dingbat dec": "169", "Dingbat hex": "A9", "Unicode dec": "128478", "Unicode hex": "1F5DE" },
    { "Typeface name": "Webdings", "Dingbat dec": "170", "Dingbat hex": "AA", "Unicode dec": "128479", "Unicode hex": "1F5DF" },
    { "Typeface name": "Webdings", "Dingbat dec": "171", "Dingbat hex": "AB", "Unicode dec": "128451", "Unicode hex": "1F5C3" },
    { "Typeface name": "Webdings", "Dingbat dec": "172", "Dingbat hex": "AC", "Unicode dec": "128450", "Unicode hex": "1F5C2" },
    { "Typeface name": "Webdings", "Dingbat dec": "173", "Dingbat hex": "AD", "Unicode dec": "128444", "Unicode hex": "1F5BC" },
    { "Typeface name": "Webdings", "Dingbat dec": "174", "Dingbat hex": "AE", "Unicode dec": "127917", "Unicode hex": "1F3AD" },
    { "Typeface name": "Webdings", "Dingbat dec": "175", "Dingbat hex": "AF", "Unicode dec": "127900", "Unicode hex": "1F39C" },
    { "Typeface name": "Webdings", "Dingbat dec": "176", "Dingbat hex": "B0", "Unicode dec": "127896", "Unicode hex": "1F398" },
    { "Typeface name": "Webdings", "Dingbat dec": "177", "Dingbat hex": "B1", "Unicode dec": "127897", "Unicode hex": "1F399" },
    { "Typeface name": "Webdings", "Dingbat dec": "178", "Dingbat hex": "B2", "Unicode dec": "127911", "Unicode hex": "1F3A7" },
    { "Typeface name": "Webdings", "Dingbat dec": "179", "Dingbat hex": "B3", "Unicode dec": "128191", "Unicode hex": "1F4BF" },
    { "Typeface name": "Webdings", "Dingbat dec": "180", "Dingbat hex": "B4", "Unicode dec": "127902", "Unicode hex": "1F39E" },
    { "Typeface name": "Webdings", "Dingbat dec": "181", "Dingbat hex": "B5", "Unicode dec": "128247", "Unicode hex": "1F4F7" },
    { "Typeface name": "Webdings", "Dingbat dec": "182", "Dingbat hex": "B6", "Unicode dec": "127903", "Unicode hex": "1F39F" },
    { "Typeface name": "Webdings", "Dingbat dec": "183", "Dingbat hex": "B7", "Unicode dec": "127916", "Unicode hex": "1F3AC" },
    { "Typeface name": "Webdings", "Dingbat dec": "184", "Dingbat hex": "B8", "Unicode dec": "128253", "Unicode hex": "1F4FD" },
    { "Typeface name": "Webdings", "Dingbat dec": "185", "Dingbat hex": "B9", "Unicode dec": "128249", "Unicode hex": "1F4F9" },
    { "Typeface name": "Webdings", "Dingbat dec": "186", "Dingbat hex": "BA", "Unicode dec": "128254", "Unicode hex": "1F4FE" },
    { "Typeface name": "Webdings", "Dingbat dec": "187", "Dingbat hex": "BB", "Unicode dec": "128251", "Unicode hex": "1F4FB" },
    { "Typeface name": "Webdings", "Dingbat dec": "188", "Dingbat hex": "BC", "Unicode dec": "127898", "Unicode hex": "1F39A" },
    { "Typeface name": "Webdings", "Dingbat dec": "189", "Dingbat hex": "BD", "Unicode dec": "127899", "Unicode hex": "1F39B" },
    { "Typeface name": "Webdings", "Dingbat dec": "190", "Dingbat hex": "BE", "Unicode dec": "128250", "Unicode hex": "1F4FA" },
    { "Typeface name": "Webdings", "Dingbat dec": "191", "Dingbat hex": "BF", "Unicode dec": "128187", "Unicode hex": "1F4BB" },
    { "Typeface name": "Webdings", "Dingbat dec": "192", "Dingbat hex": "C0", "Unicode dec": "128421", "Unicode hex": "1F5A5" },
    { "Typeface name": "Webdings", "Dingbat dec": "193", "Dingbat hex": "C1", "Unicode dec": "128422", "Unicode hex": "1F5A6" },
    { "Typeface name": "Webdings", "Dingbat dec": "194", "Dingbat hex": "C2", "Unicode dec": "128423", "Unicode hex": "1F5A7" },
    { "Typeface name": "Webdings", "Dingbat dec": "195", "Dingbat hex": "C3", "Unicode dec": "128377", "Unicode hex": "1F579" },
    { "Typeface name": "Webdings", "Dingbat dec": "196", "Dingbat hex": "C4", "Unicode dec": "127918", "Unicode hex": "1F3AE" },
    { "Typeface name": "Webdings", "Dingbat dec": "197", "Dingbat hex": "C5", "Unicode dec": "128379", "Unicode hex": "1F57B" },
    { "Typeface name": "Webdings", "Dingbat dec": "198", "Dingbat hex": "C6", "Unicode dec": "128380", "Unicode hex": "1F57C" },
    { "Typeface name": "Webdings", "Dingbat dec": "199", "Dingbat hex": "C7", "Unicode dec": "128223", "Unicode hex": "1F4DF" },
    { "Typeface name": "Webdings", "Dingbat dec": "200", "Dingbat hex": "C8", "Unicode dec": "128385", "Unicode hex": "1F581" },
    { "Typeface name": "Webdings", "Dingbat dec": "201", "Dingbat hex": "C9", "Unicode dec": "128384", "Unicode hex": "1F580" },
    { "Typeface name": "Webdings", "Dingbat dec": "202", "Dingbat hex": "CA", "Unicode dec": "128424", "Unicode hex": "1F5A8" },
    { "Typeface name": "Webdings", "Dingbat dec": "203", "Dingbat hex": "CB", "Unicode dec": "128425", "Unicode hex": "1F5A9" },
    { "Typeface name": "Webdings", "Dingbat dec": "204", "Dingbat hex": "CC", "Unicode dec": "128447", "Unicode hex": "1F5BF" },
    { "Typeface name": "Webdings", "Dingbat dec": "205", "Dingbat hex": "CD", "Unicode dec": "128426", "Unicode hex": "1F5AA" },
    { "Typeface name": "Webdings", "Dingbat dec": "206", "Dingbat hex": "CE", "Unicode dec": "128476", "Unicode hex": "1F5DC" },
    { "Typeface name": "Webdings", "Dingbat dec": "207", "Dingbat hex": "CF", "Unicode dec": "128274", "Unicode hex": "1F512" },
    { "Typeface name": "Webdings", "Dingbat dec": "208", "Dingbat hex": "D0", "Unicode dec": "128275", "Unicode hex": "1F513" },
    { "Typeface name": "Webdings", "Dingbat dec": "209", "Dingbat hex": "D1", "Unicode dec": "128477", "Unicode hex": "1F5DD" },
    { "Typeface name": "Webdings", "Dingbat dec": "210", "Dingbat hex": "D2", "Unicode dec": "128229", "Unicode hex": "1F4E5" },
    { "Typeface name": "Webdings", "Dingbat dec": "211", "Dingbat hex": "D3", "Unicode dec": "128228", "Unicode hex": "1F4E4" },
    { "Typeface name": "Webdings", "Dingbat dec": "212", "Dingbat hex": "D4", "Unicode dec": "128371", "Unicode hex": "1F573" },
    { "Typeface name": "Webdings", "Dingbat dec": "213", "Dingbat hex": "D5", "Unicode dec": "127779", "Unicode hex": "1F323" },
    { "Typeface name": "Webdings", "Dingbat dec": "214", "Dingbat hex": "D6", "Unicode dec": "127780", "Unicode hex": "1F324" },
    { "Typeface name": "Webdings", "Dingbat dec": "215", "Dingbat hex": "D7", "Unicode dec": "127781", "Unicode hex": "1F325" },
    { "Typeface name": "Webdings", "Dingbat dec": "216", "Dingbat hex": "D8", "Unicode dec": "127782", "Unicode hex": "1F326" },
    { "Typeface name": "Webdings", "Dingbat dec": "217", "Dingbat hex": "D9", "Unicode dec": "9729", "Unicode hex": "2601" },
    { "Typeface name": "Webdings", "Dingbat dec": "218", "Dingbat hex": "DA", "Unicode dec": "127784", "Unicode hex": "1F328" },
    { "Typeface name": "Webdings", "Dingbat dec": "219", "Dingbat hex": "DB", "Unicode dec": "127783", "Unicode hex": "1F327" },
    { "Typeface name": "Webdings", "Dingbat dec": "220", "Dingbat hex": "DC", "Unicode dec": "127785", "Unicode hex": "1F329" },
    { "Typeface name": "Webdings", "Dingbat dec": "221", "Dingbat hex": "DD", "Unicode dec": "127786", "Unicode hex": "1F32A" },
    { "Typeface name": "Webdings", "Dingbat dec": "222", "Dingbat hex": "DE", "Unicode dec": "127788", "Unicode hex": "1F32C" },
    { "Typeface name": "Webdings", "Dingbat dec": "223", "Dingbat hex": "DF", "Unicode dec": "127787", "Unicode hex": "1F32B" },
    { "Typeface name": "Webdings", "Dingbat dec": "224", "Dingbat hex": "E0", "Unicode dec": "127772", "Unicode hex": "1F31C" },
    { "Typeface name": "Webdings", "Dingbat dec": "225", "Dingbat hex": "E1", "Unicode dec": "127777", "Unicode hex": "1F321" },
    { "Typeface name": "Webdings", "Dingbat dec": "226", "Dingbat hex": "E2", "Unicode dec": "128715", "Unicode hex": "1F6CB" },
    { "Typeface name": "Webdings", "Dingbat dec": "227", "Dingbat hex": "E3", "Unicode dec": "128719", "Unicode hex": "1F6CF" },
    { "Typeface name": "Webdings", "Dingbat dec": "228", "Dingbat hex": "E4", "Unicode dec": "127869", "Unicode hex": "1F37D" },
    { "Typeface name": "Webdings", "Dingbat dec": "229", "Dingbat hex": "E5", "Unicode dec": "127864", "Unicode hex": "1F378" },
    { "Typeface name": "Webdings", "Dingbat dec": "230", "Dingbat hex": "E6", "Unicode dec": "128718", "Unicode hex": "1F6CE" },
    { "Typeface name": "Webdings", "Dingbat dec": "231", "Dingbat hex": "E7", "Unicode dec": "128717", "Unicode hex": "1F6CD" },
    { "Typeface name": "Webdings", "Dingbat dec": "232", "Dingbat hex": "E8", "Unicode dec": "9413", "Unicode hex": "24C5" },
    { "Typeface name": "Webdings", "Dingbat dec": "233", "Dingbat hex": "E9", "Unicode dec": "9855", "Unicode hex": "267F" },
    { "Typeface name": "Webdings", "Dingbat dec": "234", "Dingbat hex": "EA", "Unicode dec": "128710", "Unicode hex": "1F6C6" },
    { "Typeface name": "Webdings", "Dingbat dec": "235", "Dingbat hex": "EB", "Unicode dec": "128392", "Unicode hex": "1F588" },
    { "Typeface name": "Webdings", "Dingbat dec": "236", "Dingbat hex": "EC", "Unicode dec": "127891", "Unicode hex": "1F393" },
    { "Typeface name": "Webdings", "Dingbat dec": "237", "Dingbat hex": "ED", "Unicode dec": "128484", "Unicode hex": "1F5E4" },
    { "Typeface name": "Webdings", "Dingbat dec": "238", "Dingbat hex": "EE", "Unicode dec": "128485", "Unicode hex": "1F5E5" },
    { "Typeface name": "Webdings", "Dingbat dec": "239", "Dingbat hex": "EF", "Unicode dec": "128486", "Unicode hex": "1F5E6" },
    { "Typeface name": "Webdings", "Dingbat dec": "240", "Dingbat hex": "F0", "Unicode dec": "128487", "Unicode hex": "1F5E7" },
    { "Typeface name": "Webdings", "Dingbat dec": "241", "Dingbat hex": "F1", "Unicode dec": "128746", "Unicode hex": "1F6EA" },
    { "Typeface name": "Webdings", "Dingbat dec": "242", "Dingbat hex": "F2", "Unicode dec": "128063", "Unicode hex": "1F43F" },
    { "Typeface name": "Webdings", "Dingbat dec": "243", "Dingbat hex": "F3", "Unicode dec": "128038", "Unicode hex": "1F426" },
    { "Typeface name": "Webdings", "Dingbat dec": "244", "Dingbat hex": "F4", "Unicode dec": "128031", "Unicode hex": "1F41F" },
    { "Typeface name": "Webdings", "Dingbat dec": "245", "Dingbat hex": "F5", "Unicode dec": "128021", "Unicode hex": "1F415" },
    { "Typeface name": "Webdings", "Dingbat dec": "246", "Dingbat hex": "F6", "Unicode dec": "128008", "Unicode hex": "1F408" },
    { "Typeface name": "Webdings", "Dingbat dec": "247", "Dingbat hex": "F7", "Unicode dec": "128620", "Unicode hex": "1F66C" },
    { "Typeface name": "Webdings", "Dingbat dec": "248", "Dingbat hex": "F8", "Unicode dec": "128622", "Unicode hex": "1F66E" },
    { "Typeface name": "Webdings", "Dingbat dec": "249", "Dingbat hex": "F9", "Unicode dec": "128621", "Unicode hex": "1F66D" },
    { "Typeface name": "Webdings", "Dingbat dec": "250", "Dingbat hex": "FA", "Unicode dec": "128623", "Unicode hex": "1F66F" },
    { "Typeface name": "Webdings", "Dingbat dec": "251", "Dingbat hex": "FB", "Unicode dec": "128506", "Unicode hex": "1F5FA" },
    { "Typeface name": "Webdings", "Dingbat dec": "252", "Dingbat hex": "FC", "Unicode dec": "127757", "Unicode hex": "1F30D" },
    { "Typeface name": "Webdings", "Dingbat dec": "253", "Dingbat hex": "FD", "Unicode dec": "127759", "Unicode hex": "1F30F" },
    { "Typeface name": "Webdings", "Dingbat dec": "254", "Dingbat hex": "FE", "Unicode dec": "127758", "Unicode hex": "1F30E" },
    { "Typeface name": "Webdings", "Dingbat dec": "255", "Dingbat hex": "FF", "Unicode dec": "128330", "Unicode hex": "1F54A" },
    { "Typeface name": "Wingdings", "Dingbat dec": "32", "Dingbat hex": "20", "Unicode dec": "32", "Unicode hex": "20" },
    { "Typeface name": "Wingdings", "Dingbat dec": "33", "Dingbat hex": "21", "Unicode dec": "128393", "Unicode hex": "1F589" },
    { "Typeface name": "Wingdings", "Dingbat dec": "34", "Dingbat hex": "22", "Unicode dec": "9986", "Unicode hex": "2702" },
    { "Typeface name": "Wingdings", "Dingbat dec": "35", "Dingbat hex": "23", "Unicode dec": "9985", "Unicode hex": "2701" },
    { "Typeface name": "Wingdings", "Dingbat dec": "36", "Dingbat hex": "24", "Unicode dec": "128083", "Unicode hex": "1F453" },
    { "Typeface name": "Wingdings", "Dingbat dec": "37", "Dingbat hex": "25", "Unicode dec": "128365", "Unicode hex": "1F56D" },
    { "Typeface name": "Wingdings", "Dingbat dec": "38", "Dingbat hex": "26", "Unicode dec": "128366", "Unicode hex": "1F56E" },
    { "Typeface name": "Wingdings", "Dingbat dec": "39", "Dingbat hex": "27", "Unicode dec": "128367", "Unicode hex": "1F56F" },
    { "Typeface name": "Wingdings", "Dingbat dec": "40", "Dingbat hex": "28", "Unicode dec": "128383", "Unicode hex": "1F57F" },
    { "Typeface name": "Wingdings", "Dingbat dec": "41", "Dingbat hex": "29", "Unicode dec": "9990", "Unicode hex": "2706" },
    { "Typeface name": "Wingdings", "Dingbat dec": "42", "Dingbat hex": "2A", "Unicode dec": "128386", "Unicode hex": "1F582" },
    { "Typeface name": "Wingdings", "Dingbat dec": "43", "Dingbat hex": "2B", "Unicode dec": "128387", "Unicode hex": "1F583" },
    { "Typeface name": "Wingdings", "Dingbat dec": "44", "Dingbat hex": "2C", "Unicode dec": "128234", "Unicode hex": "1F4EA" },
    { "Typeface name": "Wingdings", "Dingbat dec": "45", "Dingbat hex": "2D", "Unicode dec": "128235", "Unicode hex": "1F4EB" },
    { "Typeface name": "Wingdings", "Dingbat dec": "46", "Dingbat hex": "2E", "Unicode dec": "128236", "Unicode hex": "1F4EC" },
    { "Typeface name": "Wingdings", "Dingbat dec": "47", "Dingbat hex": "2F", "Unicode dec": "128237", "Unicode hex": "1F4ED" },
    { "Typeface name": "Wingdings", "Dingbat dec": "48", "Dingbat hex": "30", "Unicode dec": "128448", "Unicode hex": "1F5C0" },
    { "Typeface name": "Wingdings", "Dingbat dec": "49", "Dingbat hex": "31", "Unicode dec": "128449", "Unicode hex": "1F5C1" },
    { "Typeface name": "Wingdings", "Dingbat dec": "50", "Dingbat hex": "32", "Unicode dec": "128462", "Unicode hex": "1F5CE" },
    { "Typeface name": "Wingdings", "Dingbat dec": "51", "Dingbat hex": "33", "Unicode dec": "128463", "Unicode hex": "1F5CF" },
    { "Typeface name": "Wingdings", "Dingbat dec": "52", "Dingbat hex": "34", "Unicode dec": "128464", "Unicode hex": "1F5D0" },
    { "Typeface name": "Wingdings", "Dingbat dec": "53", "Dingbat hex": "35", "Unicode dec": "128452", "Unicode hex": "1F5C4" },
    { "Typeface name": "Wingdings", "Dingbat dec": "54", "Dingbat hex": "36", "Unicode dec": "8987", "Unicode hex": "231B" },
    { "Typeface name": "Wingdings", "Dingbat dec": "55", "Dingbat hex": "37", "Unicode dec": "128430", "Unicode hex": "1F5AE" },
    { "Typeface name": "Wingdings", "Dingbat dec": "56", "Dingbat hex": "38", "Unicode dec": "128432", "Unicode hex": "1F5B0" },
    { "Typeface name": "Wingdings", "Dingbat dec": "57", "Dingbat hex": "39", "Unicode dec": "128434", "Unicode hex": "1F5B2" },
    { "Typeface name": "Wingdings", "Dingbat dec": "58", "Dingbat hex": "3A", "Unicode dec": "128435", "Unicode hex": "1F5B3" },
    { "Typeface name": "Wingdings", "Dingbat dec": "59", "Dingbat hex": "3B", "Unicode dec": "128436", "Unicode hex": "1F5B4" },
    { "Typeface name": "Wingdings", "Dingbat dec": "60", "Dingbat hex": "3C", "Unicode dec": "128427", "Unicode hex": "1F5AB" },
    { "Typeface name": "Wingdings", "Dingbat dec": "61", "Dingbat hex": "3D", "Unicode dec": "128428", "Unicode hex": "1F5AC" },
    { "Typeface name": "Wingdings", "Dingbat dec": "62", "Dingbat hex": "3E", "Unicode dec": "9991", "Unicode hex": "2707" },
    { "Typeface name": "Wingdings", "Dingbat dec": "63", "Dingbat hex": "3F", "Unicode dec": "9997", "Unicode hex": "270D" },
    { "Typeface name": "Wingdings", "Dingbat dec": "64", "Dingbat hex": "40", "Unicode dec": "128398", "Unicode hex": "1F58E" },
    { "Typeface name": "Wingdings", "Dingbat dec": "65", "Dingbat hex": "41", "Unicode dec": "9996", "Unicode hex": "270C" },
    { "Typeface name": "Wingdings", "Dingbat dec": "66", "Dingbat hex": "42", "Unicode dec": "128399", "Unicode hex": "1F58F" },
    { "Typeface name": "Wingdings", "Dingbat dec": "67", "Dingbat hex": "43", "Unicode dec": "128077", "Unicode hex": "1F44D" },
    { "Typeface name": "Wingdings", "Dingbat dec": "68", "Dingbat hex": "44", "Unicode dec": "128078", "Unicode hex": "1F44E" },
    { "Typeface name": "Wingdings", "Dingbat dec": "69", "Dingbat hex": "45", "Unicode dec": "9756", "Unicode hex": "261C" },
    { "Typeface name": "Wingdings", "Dingbat dec": "70", "Dingbat hex": "46", "Unicode dec": "9758", "Unicode hex": "261E" },
    { "Typeface name": "Wingdings", "Dingbat dec": "71", "Dingbat hex": "47", "Unicode dec": "9757", "Unicode hex": "261D" },
    { "Typeface name": "Wingdings", "Dingbat dec": "72", "Dingbat hex": "48", "Unicode dec": "9759", "Unicode hex": "261F" },
    { "Typeface name": "Wingdings", "Dingbat dec": "73", "Dingbat hex": "49", "Unicode dec": "128400", "Unicode hex": "1F590" },
    { "Typeface name": "Wingdings", "Dingbat dec": "74", "Dingbat hex": "4A", "Unicode dec": "9786", "Unicode hex": "263A" },
    { "Typeface name": "Wingdings", "Dingbat dec": "75", "Dingbat hex": "4B", "Unicode dec": "128528", "Unicode hex": "1F610" },
    { "Typeface name": "Wingdings", "Dingbat dec": "76", "Dingbat hex": "4C", "Unicode dec": "9785", "Unicode hex": "2639" },
    { "Typeface name": "Wingdings", "Dingbat dec": "77", "Dingbat hex": "4D", "Unicode dec": "128163", "Unicode hex": "1F4A3" },
    { "Typeface name": "Wingdings", "Dingbat dec": "78", "Dingbat hex": "4E", "Unicode dec": "128369", "Unicode hex": "1F571" },
    { "Typeface name": "Wingdings", "Dingbat dec": "79", "Dingbat hex": "4F", "Unicode dec": "127987", "Unicode hex": "1F3F3" },
    { "Typeface name": "Wingdings", "Dingbat dec": "80", "Dingbat hex": "50", "Unicode dec": "127985", "Unicode hex": "1F3F1" },
    { "Typeface name": "Wingdings", "Dingbat dec": "81", "Dingbat hex": "51", "Unicode dec": "9992", "Unicode hex": "2708" },
    { "Typeface name": "Wingdings", "Dingbat dec": "82", "Dingbat hex": "52", "Unicode dec": "9788", "Unicode hex": "263C" },
    { "Typeface name": "Wingdings", "Dingbat dec": "83", "Dingbat hex": "53", "Unicode dec": "127778", "Unicode hex": "1F322" },
    { "Typeface name": "Wingdings", "Dingbat dec": "84", "Dingbat hex": "54", "Unicode dec": "10052", "Unicode hex": "2744" },
    { "Typeface name": "Wingdings", "Dingbat dec": "85", "Dingbat hex": "55", "Unicode dec": "128326", "Unicode hex": "1F546" },
    { "Typeface name": "Wingdings", "Dingbat dec": "86", "Dingbat hex": "56", "Unicode dec": "10014", "Unicode hex": "271E" },
    { "Typeface name": "Wingdings", "Dingbat dec": "87", "Dingbat hex": "57", "Unicode dec": "128328", "Unicode hex": "1F548" },
    { "Typeface name": "Wingdings", "Dingbat dec": "88", "Dingbat hex": "58", "Unicode dec": "10016", "Unicode hex": "2720" },
    { "Typeface name": "Wingdings", "Dingbat dec": "89", "Dingbat hex": "59", "Unicode dec": "10017", "Unicode hex": "2721" },
    { "Typeface name": "Wingdings", "Dingbat dec": "90", "Dingbat hex": "5A", "Unicode dec": "9770", "Unicode hex": "262A" },
    { "Typeface name": "Wingdings", "Dingbat dec": "91", "Dingbat hex": "5B", "Unicode dec": "9775", "Unicode hex": "262F" },
    { "Typeface name": "Wingdings", "Dingbat dec": "92", "Dingbat hex": "5C", "Unicode dec": "128329", "Unicode hex": "1F549" },
    { "Typeface name": "Wingdings", "Dingbat dec": "93", "Dingbat hex": "5D", "Unicode dec": "9784", "Unicode hex": "2638" },
    { "Typeface name": "Wingdings", "Dingbat dec": "94", "Dingbat hex": "5E", "Unicode dec": "9800", "Unicode hex": "2648" },
    { "Typeface name": "Wingdings", "Dingbat dec": "95", "Dingbat hex": "5F", "Unicode dec": "9801", "Unicode hex": "2649" },
    { "Typeface name": "Wingdings", "Dingbat dec": "96", "Dingbat hex": "60", "Unicode dec": "9802", "Unicode hex": "264A" },
    { "Typeface name": "Wingdings", "Dingbat dec": "97", "Dingbat hex": "61", "Unicode dec": "9803", "Unicode hex": "264B" },
    { "Typeface name": "Wingdings", "Dingbat dec": "98", "Dingbat hex": "62", "Unicode dec": "9804", "Unicode hex": "264C" },
    { "Typeface name": "Wingdings", "Dingbat dec": "99", "Dingbat hex": "63", "Unicode dec": "9805", "Unicode hex": "264D" },
    { "Typeface name": "Wingdings", "Dingbat dec": "100", "Dingbat hex": "64", "Unicode dec": "9806", "Unicode hex": "264E" },
    { "Typeface name": "Wingdings", "Dingbat dec": "101", "Dingbat hex": "65", "Unicode dec": "9807", "Unicode hex": "264F" },
    { "Typeface name": "Wingdings", "Dingbat dec": "102", "Dingbat hex": "66", "Unicode dec": "9808", "Unicode hex": "2650" },
    { "Typeface name": "Wingdings", "Dingbat dec": "103", "Dingbat hex": "67", "Unicode dec": "9809", "Unicode hex": "2651" },
    { "Typeface name": "Wingdings", "Dingbat dec": "104", "Dingbat hex": "68", "Unicode dec": "9810", "Unicode hex": "2652" },
    { "Typeface name": "Wingdings", "Dingbat dec": "105", "Dingbat hex": "69", "Unicode dec": "9811", "Unicode hex": "2653" },
    { "Typeface name": "Wingdings", "Dingbat dec": "106", "Dingbat hex": "6A", "Unicode dec": "128624", "Unicode hex": "1F670" },
    { "Typeface name": "Wingdings", "Dingbat dec": "107", "Dingbat hex": "6B", "Unicode dec": "128629", "Unicode hex": "1F675" },
    { "Typeface name": "Wingdings", "Dingbat dec": "108", "Dingbat hex": "6C", "Unicode dec": "9899", "Unicode hex": "26AB" },
    { "Typeface name": "Wingdings", "Dingbat dec": "109", "Dingbat hex": "6D", "Unicode dec": "128318", "Unicode hex": "1F53E" },
    { "Typeface name": "Wingdings", "Dingbat dec": "110", "Dingbat hex": "6E", "Unicode dec": "9724", "Unicode hex": "25FC" },
    { "Typeface name": "Wingdings", "Dingbat dec": "111", "Dingbat hex": "6F", "Unicode dec": "128911", "Unicode hex": "1F78F" },
    { "Typeface name": "Wingdings", "Dingbat dec": "112", "Dingbat hex": "70", "Unicode dec": "128912", "Unicode hex": "1F790" },
    { "Typeface name": "Wingdings", "Dingbat dec": "113", "Dingbat hex": "71", "Unicode dec": "10065", "Unicode hex": "2751" },
    { "Typeface name": "Wingdings", "Dingbat dec": "114", "Dingbat hex": "72", "Unicode dec": "10066", "Unicode hex": "2752" },
    { "Typeface name": "Wingdings", "Dingbat dec": "115", "Dingbat hex": "73", "Unicode dec": "128927", "Unicode hex": "1F79F" },
    { "Typeface name": "Wingdings", "Dingbat dec": "116", "Dingbat hex": "74", "Unicode dec": "10731", "Unicode hex": "29EB" },
    { "Typeface name": "Wingdings", "Dingbat dec": "117", "Dingbat hex": "75", "Unicode dec": "9670", "Unicode hex": "25C6" },
    { "Typeface name": "Wingdings", "Dingbat dec": "118", "Dingbat hex": "76", "Unicode dec": "10070", "Unicode hex": "2756" },
    { "Typeface name": "Wingdings", "Dingbat dec": "119", "Dingbat hex": "77", "Unicode dec": "11049", "Unicode hex": "2B29" },
    { "Typeface name": "Wingdings", "Dingbat dec": "120", "Dingbat hex": "78", "Unicode dec": "8999", "Unicode hex": "2327" },
    { "Typeface name": "Wingdings", "Dingbat dec": "121", "Dingbat hex": "79", "Unicode dec": "11193", "Unicode hex": "2BB9" },
    { "Typeface name": "Wingdings", "Dingbat dec": "122", "Dingbat hex": "7A", "Unicode dec": "8984", "Unicode hex": "2318" },
    { "Typeface name": "Wingdings", "Dingbat dec": "123", "Dingbat hex": "7B", "Unicode dec": "127989", "Unicode hex": "1F3F5" },
    { "Typeface name": "Wingdings", "Dingbat dec": "124", "Dingbat hex": "7C", "Unicode dec": "127990", "Unicode hex": "1F3F6" },
    { "Typeface name": "Wingdings", "Dingbat dec": "125", "Dingbat hex": "7D", "Unicode dec": "128630", "Unicode hex": "1F676" },
    { "Typeface name": "Wingdings", "Dingbat dec": "126", "Dingbat hex": "7E", "Unicode dec": "128631", "Unicode hex": "1F677" },
    { "Typeface name": "Wingdings", "Dingbat dec": "127", "Dingbat hex": "7F", "Unicode dec": "9647", "Unicode hex": "25AF" },
    { "Typeface name": "Wingdings", "Dingbat dec": "128", "Dingbat hex": "80", "Unicode dec": "127243", "Unicode hex": "1F10B" },
    { "Typeface name": "Wingdings", "Dingbat dec": "129", "Dingbat hex": "81", "Unicode dec": "10112", "Unicode hex": "2780" },
    { "Typeface name": "Wingdings", "Dingbat dec": "130", "Dingbat hex": "82", "Unicode dec": "10113", "Unicode hex": "2781" },
    { "Typeface name": "Wingdings", "Dingbat dec": "131", "Dingbat hex": "83", "Unicode dec": "10114", "Unicode hex": "2782" },
    { "Typeface name": "Wingdings", "Dingbat dec": "132", "Dingbat hex": "84", "Unicode dec": "10115", "Unicode hex": "2783" },
    { "Typeface name": "Wingdings", "Dingbat dec": "133", "Dingbat hex": "85", "Unicode dec": "10116", "Unicode hex": "2784" },
    { "Typeface name": "Wingdings", "Dingbat dec": "134", "Dingbat hex": "86", "Unicode dec": "10117", "Unicode hex": "2785" },
    { "Typeface name": "Wingdings", "Dingbat dec": "135", "Dingbat hex": "87", "Unicode dec": "10118", "Unicode hex": "2786" },
    { "Typeface name": "Wingdings", "Dingbat dec": "136", "Dingbat hex": "88", "Unicode dec": "10119", "Unicode hex": "2787" },
    { "Typeface name": "Wingdings", "Dingbat dec": "137", "Dingbat hex": "89", "Unicode dec": "10120", "Unicode hex": "2788" },
    { "Typeface name": "Wingdings", "Dingbat dec": "138", "Dingbat hex": "8A", "Unicode dec": "10121", "Unicode hex": "2789" },
    { "Typeface name": "Wingdings", "Dingbat dec": "139", "Dingbat hex": "8B", "Unicode dec": "127244", "Unicode hex": "1F10C" },
    { "Typeface name": "Wingdings", "Dingbat dec": "140", "Dingbat hex": "8C", "Unicode dec": "10122", "Unicode hex": "278A" },
    { "Typeface name": "Wingdings", "Dingbat dec": "141", "Dingbat hex": "8D", "Unicode dec": "10123", "Unicode hex": "278B" },
    { "Typeface name": "Wingdings", "Dingbat dec": "142", "Dingbat hex": "8E", "Unicode dec": "10124", "Unicode hex": "278C" },
    { "Typeface name": "Wingdings", "Dingbat dec": "143", "Dingbat hex": "8F", "Unicode dec": "10125", "Unicode hex": "278D" },
    { "Typeface name": "Wingdings", "Dingbat dec": "144", "Dingbat hex": "90", "Unicode dec": "10126", "Unicode hex": "278E" },
    { "Typeface name": "Wingdings", "Dingbat dec": "145", "Dingbat hex": "91", "Unicode dec": "10127", "Unicode hex": "278F" },
    { "Typeface name": "Wingdings", "Dingbat dec": "146", "Dingbat hex": "92", "Unicode dec": "10128", "Unicode hex": "2790" },
    { "Typeface name": "Wingdings", "Dingbat dec": "147", "Dingbat hex": "93", "Unicode dec": "10129", "Unicode hex": "2791" },
    { "Typeface name": "Wingdings", "Dingbat dec": "148", "Dingbat hex": "94", "Unicode dec": "10130", "Unicode hex": "2792" },
    { "Typeface name": "Wingdings", "Dingbat dec": "149", "Dingbat hex": "95", "Unicode dec": "10131", "Unicode hex": "2793" },
    { "Typeface name": "Wingdings", "Dingbat dec": "150", "Dingbat hex": "96", "Unicode dec": "128610", "Unicode hex": "1F662" },
    { "Typeface name": "Wingdings", "Dingbat dec": "151", "Dingbat hex": "97", "Unicode dec": "128608", "Unicode hex": "1F660" },
    { "Typeface name": "Wingdings", "Dingbat dec": "152", "Dingbat hex": "98", "Unicode dec": "128609", "Unicode hex": "1F661" },
    { "Typeface name": "Wingdings", "Dingbat dec": "153", "Dingbat hex": "99", "Unicode dec": "128611", "Unicode hex": "1F663" },
    { "Typeface name": "Wingdings", "Dingbat dec": "154", "Dingbat hex": "9A", "Unicode dec": "128606", "Unicode hex": "1F65E" },
    { "Typeface name": "Wingdings", "Dingbat dec": "155", "Dingbat hex": "9B", "Unicode dec": "128604", "Unicode hex": "1F65C" },
    { "Typeface name": "Wingdings", "Dingbat dec": "156", "Dingbat hex": "9C", "Unicode dec": "128605", "Unicode hex": "1F65D" },
    { "Typeface name": "Wingdings", "Dingbat dec": "157", "Dingbat hex": "9D", "Unicode dec": "128607", "Unicode hex": "1F65F" },
    { "Typeface name": "Wingdings", "Dingbat dec": "158", "Dingbat hex": "9E", "Unicode dec": "8729", "Unicode hex": "2219" },
    { "Typeface name": "Wingdings", "Dingbat dec": "159", "Dingbat hex": "9F", "Unicode dec": "8226", "Unicode hex": "2022" },
    { "Typeface name": "Wingdings", "Dingbat dec": "160", "Dingbat hex": "A0", "Unicode dec": "11037", "Unicode hex": "2B1D" },
    { "Typeface name": "Wingdings", "Dingbat dec": "161", "Dingbat hex": "A1", "Unicode dec": "11096", "Unicode hex": "2B58" },
    { "Typeface name": "Wingdings", "Dingbat dec": "162", "Dingbat hex": "A2", "Unicode dec": "128902", "Unicode hex": "1F786" },
    { "Typeface name": "Wingdings", "Dingbat dec": "163", "Dingbat hex": "A3", "Unicode dec": "128904", "Unicode hex": "1F788" },
    { "Typeface name": "Wingdings", "Dingbat dec": "164", "Dingbat hex": "A4", "Unicode dec": "128906", "Unicode hex": "1F78A" },
    { "Typeface name": "Wingdings", "Dingbat dec": "165", "Dingbat hex": "A5", "Unicode dec": "128907", "Unicode hex": "1F78B" },
    { "Typeface name": "Wingdings", "Dingbat dec": "166", "Dingbat hex": "A6", "Unicode dec": "128319", "Unicode hex": "1F53F" },
    { "Typeface name": "Wingdings", "Dingbat dec": "167", "Dingbat hex": "A7", "Unicode dec": "9642", "Unicode hex": "25AA" },
    { "Typeface name": "Wingdings", "Dingbat dec": "168", "Dingbat hex": "A8", "Unicode dec": "128910", "Unicode hex": "1F78E" },
    { "Typeface name": "Wingdings", "Dingbat dec": "169", "Dingbat hex": "A9", "Unicode dec": "128961", "Unicode hex": "1F7C1" },
    { "Typeface name": "Wingdings", "Dingbat dec": "170", "Dingbat hex": "AA", "Unicode dec": "128965", "Unicode hex": "1F7C5" },
    { "Typeface name": "Wingdings", "Dingbat dec": "171", "Dingbat hex": "AB", "Unicode dec": "9733", "Unicode hex": "2605" },
    { "Typeface name": "Wingdings", "Dingbat dec": "172", "Dingbat hex": "AC", "Unicode dec": "128971", "Unicode hex": "1F7CB" },
    { "Typeface name": "Wingdings", "Dingbat dec": "173", "Dingbat hex": "AD", "Unicode dec": "128975", "Unicode hex": "1F7CF" },
    { "Typeface name": "Wingdings", "Dingbat dec": "174", "Dingbat hex": "AE", "Unicode dec": "128979", "Unicode hex": "1F7D3" },
    { "Typeface name": "Wingdings", "Dingbat dec": "175", "Dingbat hex": "AF", "Unicode dec": "128977", "Unicode hex": "1F7D1" },
    { "Typeface name": "Wingdings", "Dingbat dec": "176", "Dingbat hex": "B0", "Unicode dec": "11216", "Unicode hex": "2BD0" },
    { "Typeface name": "Wingdings", "Dingbat dec": "177", "Dingbat hex": "B1", "Unicode dec": "8982", "Unicode hex": "2316" },
    { "Typeface name": "Wingdings", "Dingbat dec": "178", "Dingbat hex": "B2", "Unicode dec": "11214", "Unicode hex": "2BCE" },
    { "Typeface name": "Wingdings", "Dingbat dec": "179", "Dingbat hex": "B3", "Unicode dec": "11215", "Unicode hex": "2BCF" },
    { "Typeface name": "Wingdings", "Dingbat dec": "180", "Dingbat hex": "B4", "Unicode dec": "11217", "Unicode hex": "2BD1" },
    { "Typeface name": "Wingdings", "Dingbat dec": "181", "Dingbat hex": "B5", "Unicode dec": "10026", "Unicode hex": "272A" },
    { "Typeface name": "Wingdings", "Dingbat dec": "182", "Dingbat hex": "B6", "Unicode dec": "10032", "Unicode hex": "2730" },
    { "Typeface name": "Wingdings", "Dingbat dec": "183", "Dingbat hex": "B7", "Unicode dec": "128336", "Unicode hex": "1F550" },
    { "Typeface name": "Wingdings", "Dingbat dec": "184", "Dingbat hex": "B8", "Unicode dec": "128337", "Unicode hex": "1F551" },
    { "Typeface name": "Wingdings", "Dingbat dec": "185", "Dingbat hex": "B9", "Unicode dec": "128338", "Unicode hex": "1F552" },
    { "Typeface name": "Wingdings", "Dingbat dec": "186", "Dingbat hex": "BA", "Unicode dec": "128339", "Unicode hex": "1F553" },
    { "Typeface name": "Wingdings", "Dingbat dec": "187", "Dingbat hex": "BB", "Unicode dec": "128340", "Unicode hex": "1F554" },
    { "Typeface name": "Wingdings", "Dingbat dec": "188", "Dingbat hex": "BC", "Unicode dec": "128341", "Unicode hex": "1F555" },
    { "Typeface name": "Wingdings", "Dingbat dec": "189", "Dingbat hex": "BD", "Unicode dec": "128342", "Unicode hex": "1F556" },
    { "Typeface name": "Wingdings", "Dingbat dec": "190", "Dingbat hex": "BE", "Unicode dec": "128343", "Unicode hex": "1F557" },
    { "Typeface name": "Wingdings", "Dingbat dec": "191", "Dingbat hex": "BF", "Unicode dec": "128344", "Unicode hex": "1F558" },
    { "Typeface name": "Wingdings", "Dingbat dec": "192", "Dingbat hex": "C0", "Unicode dec": "128345", "Unicode hex": "1F559" },
    { "Typeface name": "Wingdings", "Dingbat dec": "193", "Dingbat hex": "C1", "Unicode dec": "128346", "Unicode hex": "1F55A" },
    { "Typeface name": "Wingdings", "Dingbat dec": "194", "Dingbat hex": "C2", "Unicode dec": "128347", "Unicode hex": "1F55B" },
    { "Typeface name": "Wingdings", "Dingbat dec": "195", "Dingbat hex": "C3", "Unicode dec": "11184", "Unicode hex": "2BB0" },
    { "Typeface name": "Wingdings", "Dingbat dec": "196", "Dingbat hex": "C4", "Unicode dec": "11185", "Unicode hex": "2BB1" },
    { "Typeface name": "Wingdings", "Dingbat dec": "197", "Dingbat hex": "C5", "Unicode dec": "11186", "Unicode hex": "2BB2" },
    { "Typeface name": "Wingdings", "Dingbat dec": "198", "Dingbat hex": "C6", "Unicode dec": "11187", "Unicode hex": "2BB3" },
    { "Typeface name": "Wingdings", "Dingbat dec": "199", "Dingbat hex": "C7", "Unicode dec": "11188", "Unicode hex": "2BB4" },
    { "Typeface name": "Wingdings", "Dingbat dec": "200", "Dingbat hex": "C8", "Unicode dec": "11189", "Unicode hex": "2BB5" },
    { "Typeface name": "Wingdings", "Dingbat dec": "201", "Dingbat hex": "C9", "Unicode dec": "11190", "Unicode hex": "2BB6" },
    { "Typeface name": "Wingdings", "Dingbat dec": "202", "Dingbat hex": "CA", "Unicode dec": "11191", "Unicode hex": "2BB7" },
    { "Typeface name": "Wingdings", "Dingbat dec": "203", "Dingbat hex": "CB", "Unicode dec": "128618", "Unicode hex": "1F66A" },
    { "Typeface name": "Wingdings", "Dingbat dec": "204", "Dingbat hex": "CC", "Unicode dec": "128619", "Unicode hex": "1F66B" },
    { "Typeface name": "Wingdings", "Dingbat dec": "205", "Dingbat hex": "CD", "Unicode dec": "128597", "Unicode hex": "1F655" },
    { "Typeface name": "Wingdings", "Dingbat dec": "206", "Dingbat hex": "CE", "Unicode dec": "128596", "Unicode hex": "1F654" },
    { "Typeface name": "Wingdings", "Dingbat dec": "207", "Dingbat hex": "CF", "Unicode dec": "128599", "Unicode hex": "1F657" },
    { "Typeface name": "Wingdings", "Dingbat dec": "208", "Dingbat hex": "D0", "Unicode dec": "128598", "Unicode hex": "1F656" },
    { "Typeface name": "Wingdings", "Dingbat dec": "209", "Dingbat hex": "D1", "Unicode dec": "128592", "Unicode hex": "1F650" },
    { "Typeface name": "Wingdings", "Dingbat dec": "210", "Dingbat hex": "D2", "Unicode dec": "128593", "Unicode hex": "1F651" },
    { "Typeface name": "Wingdings", "Dingbat dec": "211", "Dingbat hex": "D3", "Unicode dec": "128594", "Unicode hex": "1F652" },
    { "Typeface name": "Wingdings", "Dingbat dec": "212", "Dingbat hex": "D4", "Unicode dec": "128595", "Unicode hex": "1F653" },
    { "Typeface name": "Wingdings", "Dingbat dec": "213", "Dingbat hex": "D5", "Unicode dec": "9003", "Unicode hex": "232B" },
    { "Typeface name": "Wingdings", "Dingbat dec": "214", "Dingbat hex": "D6", "Unicode dec": "8998", "Unicode hex": "2326" },
    { "Typeface name": "Wingdings", "Dingbat dec": "215", "Dingbat hex": "D7", "Unicode dec": "11160", "Unicode hex": "2B98" },
    { "Typeface name": "Wingdings", "Dingbat dec": "216", "Dingbat hex": "D8", "Unicode dec": "11162", "Unicode hex": "2B9A" },
    { "Typeface name": "Wingdings", "Dingbat dec": "217", "Dingbat hex": "D9", "Unicode dec": "11161", "Unicode hex": "2B99" },
    { "Typeface name": "Wingdings", "Dingbat dec": "218", "Dingbat hex": "DA", "Unicode dec": "11163", "Unicode hex": "2B9B" },
    { "Typeface name": "Wingdings", "Dingbat dec": "219", "Dingbat hex": "DB", "Unicode dec": "11144", "Unicode hex": "2B88" },
    { "Typeface name": "Wingdings", "Dingbat dec": "220", "Dingbat hex": "DC", "Unicode dec": "11146", "Unicode hex": "2B8A" },
    { "Typeface name": "Wingdings", "Dingbat dec": "221", "Dingbat hex": "DD", "Unicode dec": "11145", "Unicode hex": "2B89" },
    { "Typeface name": "Wingdings", "Dingbat dec": "222", "Dingbat hex": "DE", "Unicode dec": "11147", "Unicode hex": "2B8B" },
    { "Typeface name": "Wingdings", "Dingbat dec": "223", "Dingbat hex": "DF", "Unicode dec": "129128", "Unicode hex": "1F868" },
    { "Typeface name": "Wingdings", "Dingbat dec": "224", "Dingbat hex": "E0", "Unicode dec": "129130", "Unicode hex": "1F86A" },
    { "Typeface name": "Wingdings", "Dingbat dec": "225", "Dingbat hex": "E1", "Unicode dec": "129129", "Unicode hex": "1F869" },
    { "Typeface name": "Wingdings", "Dingbat dec": "226", "Dingbat hex": "E2", "Unicode dec": "129131", "Unicode hex": "1F86B" },
    { "Typeface name": "Wingdings", "Dingbat dec": "227", "Dingbat hex": "E3", "Unicode dec": "129132", "Unicode hex": "1F86C" },
    { "Typeface name": "Wingdings", "Dingbat dec": "228", "Dingbat hex": "E4", "Unicode dec": "129133", "Unicode hex": "1F86D" },
    { "Typeface name": "Wingdings", "Dingbat dec": "229", "Dingbat hex": "E5", "Unicode dec": "129135", "Unicode hex": "1F86F" },
    { "Typeface name": "Wingdings", "Dingbat dec": "230", "Dingbat hex": "E6", "Unicode dec": "129134", "Unicode hex": "1F86E" },
    { "Typeface name": "Wingdings", "Dingbat dec": "231", "Dingbat hex": "E7", "Unicode dec": "129144", "Unicode hex": "1F878" },
    { "Typeface name": "Wingdings", "Dingbat dec": "232", "Dingbat hex": "E8", "Unicode dec": "129146", "Unicode hex": "1F87A" },
    { "Typeface name": "Wingdings", "Dingbat dec": "233", "Dingbat hex": "E9", "Unicode dec": "129145", "Unicode hex": "1F879" },
    { "Typeface name": "Wingdings", "Dingbat dec": "234", "Dingbat hex": "EA", "Unicode dec": "129147", "Unicode hex": "1F87B" },
    { "Typeface name": "Wingdings", "Dingbat dec": "235", "Dingbat hex": "EB", "Unicode dec": "129148", "Unicode hex": "1F87C" },
    { "Typeface name": "Wingdings", "Dingbat dec": "236", "Dingbat hex": "EC", "Unicode dec": "129149", "Unicode hex": "1F87D" },
    { "Typeface name": "Wingdings", "Dingbat dec": "237", "Dingbat hex": "ED", "Unicode dec": "129151", "Unicode hex": "1F87F" },
    { "Typeface name": "Wingdings", "Dingbat dec": "238", "Dingbat hex": "EE", "Unicode dec": "129150", "Unicode hex": "1F87E" },
    { "Typeface name": "Wingdings", "Dingbat dec": "239", "Dingbat hex": "EF", "Unicode dec": "8678", "Unicode hex": "21E6" },
    { "Typeface name": "Wingdings", "Dingbat dec": "240", "Dingbat hex": "F0", "Unicode dec": "8680", "Unicode hex": "21E8" },
    { "Typeface name": "Wingdings", "Dingbat dec": "241", "Dingbat hex": "F1", "Unicode dec": "8679", "Unicode hex": "21E7" },
    { "Typeface name": "Wingdings", "Dingbat dec": "242", "Dingbat hex": "F2", "Unicode dec": "8681", "Unicode hex": "21E9" },
    { "Typeface name": "Wingdings", "Dingbat dec": "243", "Dingbat hex": "F3", "Unicode dec": "11012", "Unicode hex": "2B04" },
    { "Typeface name": "Wingdings", "Dingbat dec": "244", "Dingbat hex": "F4", "Unicode dec": "8691", "Unicode hex": "21F3" },
    { "Typeface name": "Wingdings", "Dingbat dec": "245", "Dingbat hex": "F5", "Unicode dec": "11009", "Unicode hex": "2B01" },
    { "Typeface name": "Wingdings", "Dingbat dec": "246", "Dingbat hex": "F6", "Unicode dec": "11008", "Unicode hex": "2B00" },
    { "Typeface name": "Wingdings", "Dingbat dec": "247", "Dingbat hex": "F7", "Unicode dec": "11011", "Unicode hex": "2B03" },
    { "Typeface name": "Wingdings", "Dingbat dec": "248", "Dingbat hex": "F8", "Unicode dec": "11010", "Unicode hex": "2B02" },
    { "Typeface name": "Wingdings", "Dingbat dec": "249", "Dingbat hex": "F9", "Unicode dec": "129196", "Unicode hex": "1F8AC" },
    { "Typeface name": "Wingdings", "Dingbat dec": "250", "Dingbat hex": "FA", "Unicode dec": "129197", "Unicode hex": "1F8AD" },
    { "Typeface name": "Wingdings", "Dingbat dec": "251", "Dingbat hex": "FB", "Unicode dec": "128502", "Unicode hex": "1F5F6" },
    { "Typeface name": "Wingdings", "Dingbat dec": "252", "Dingbat hex": "FC", "Unicode dec": "10003", "Unicode hex": "2713" },
    { "Typeface name": "Wingdings", "Dingbat dec": "253", "Dingbat hex": "FD", "Unicode dec": "128503", "Unicode hex": "1F5F7" },
    { "Typeface name": "Wingdings", "Dingbat dec": "254", "Dingbat hex": "FE", "Unicode dec": "128505", "Unicode hex": "1F5F9" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "32", "Dingbat hex": "20", "Unicode dec": "32", "Unicode hex": "20" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "33", "Dingbat hex": "21", "Unicode dec": "128394", "Unicode hex": "1F58A" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "34", "Dingbat hex": "22", "Unicode dec": "128395", "Unicode hex": "1F58B" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "35", "Dingbat hex": "23", "Unicode dec": "128396", "Unicode hex": "1F58C" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "36", "Dingbat hex": "24", "Unicode dec": "128397", "Unicode hex": "1F58D" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "37", "Dingbat hex": "25", "Unicode dec": "9988", "Unicode hex": "2704" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "38", "Dingbat hex": "26", "Unicode dec": "9984", "Unicode hex": "2700" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "39", "Dingbat hex": "27", "Unicode dec": "128382", "Unicode hex": "1F57E" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "40", "Dingbat hex": "28", "Unicode dec": "128381", "Unicode hex": "1F57D" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "41", "Dingbat hex": "29", "Unicode dec": "128453", "Unicode hex": "1F5C5" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "42", "Dingbat hex": "2A", "Unicode dec": "128454", "Unicode hex": "1F5C6" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "43", "Dingbat hex": "2B", "Unicode dec": "128455", "Unicode hex": "1F5C7" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "44", "Dingbat hex": "2C", "Unicode dec": "128456", "Unicode hex": "1F5C8" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "45", "Dingbat hex": "2D", "Unicode dec": "128457", "Unicode hex": "1F5C9" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "46", "Dingbat hex": "2E", "Unicode dec": "128458", "Unicode hex": "1F5CA" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "47", "Dingbat hex": "2F", "Unicode dec": "128459", "Unicode hex": "1F5CB" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "48", "Dingbat hex": "30", "Unicode dec": "128460", "Unicode hex": "1F5CC" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "49", "Dingbat hex": "31", "Unicode dec": "128461", "Unicode hex": "1F5CD" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "50", "Dingbat hex": "32", "Unicode dec": "128203", "Unicode hex": "1F4CB" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "51", "Dingbat hex": "33", "Unicode dec": "128465", "Unicode hex": "1F5D1" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "52", "Dingbat hex": "34", "Unicode dec": "128468", "Unicode hex": "1F5D4" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "53", "Dingbat hex": "35", "Unicode dec": "128437", "Unicode hex": "1F5B5" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "54", "Dingbat hex": "36", "Unicode dec": "128438", "Unicode hex": "1F5B6" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "55", "Dingbat hex": "37", "Unicode dec": "128439", "Unicode hex": "1F5B7" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "56", "Dingbat hex": "38", "Unicode dec": "128440", "Unicode hex": "1F5B8" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "57", "Dingbat hex": "39", "Unicode dec": "128429", "Unicode hex": "1F5AD" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "58", "Dingbat hex": "3A", "Unicode dec": "128431", "Unicode hex": "1F5AF" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "59", "Dingbat hex": "3B", "Unicode dec": "128433", "Unicode hex": "1F5B1" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "60", "Dingbat hex": "3C", "Unicode dec": "128402", "Unicode hex": "1F592" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "61", "Dingbat hex": "3D", "Unicode dec": "128403", "Unicode hex": "1F593" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "62", "Dingbat hex": "3E", "Unicode dec": "128408", "Unicode hex": "1F598" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "63", "Dingbat hex": "3F", "Unicode dec": "128409", "Unicode hex": "1F599" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "64", "Dingbat hex": "40", "Unicode dec": "128410", "Unicode hex": "1F59A" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "65", "Dingbat hex": "41", "Unicode dec": "128411", "Unicode hex": "1F59B" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "66", "Dingbat hex": "42", "Unicode dec": "128072", "Unicode hex": "1F448" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "67", "Dingbat hex": "43", "Unicode dec": "128073", "Unicode hex": "1F449" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "68", "Dingbat hex": "44", "Unicode dec": "128412", "Unicode hex": "1F59C" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "69", "Dingbat hex": "45", "Unicode dec": "128413", "Unicode hex": "1F59D" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "70", "Dingbat hex": "46", "Unicode dec": "128414", "Unicode hex": "1F59E" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "71", "Dingbat hex": "47", "Unicode dec": "128415", "Unicode hex": "1F59F" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "72", "Dingbat hex": "48", "Unicode dec": "128416", "Unicode hex": "1F5A0" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "73", "Dingbat hex": "49", "Unicode dec": "128417", "Unicode hex": "1F5A1" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "74", "Dingbat hex": "4A", "Unicode dec": "128070", "Unicode hex": "1F446" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "75", "Dingbat hex": "4B", "Unicode dec": "128071", "Unicode hex": "1F447" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "76", "Dingbat hex": "4C", "Unicode dec": "128418", "Unicode hex": "1F5A2" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "77", "Dingbat hex": "4D", "Unicode dec": "128419", "Unicode hex": "1F5A3" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "78", "Dingbat hex": "4E", "Unicode dec": "128401", "Unicode hex": "1F591" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "79", "Dingbat hex": "4F", "Unicode dec": "128500", "Unicode hex": "1F5F4" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "80", "Dingbat hex": "50", "Unicode dec": "128504", "Unicode hex": "1F5F8" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "81", "Dingbat hex": "51", "Unicode dec": "128501", "Unicode hex": "1F5F5" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "82", "Dingbat hex": "52", "Unicode dec": "9745", "Unicode hex": "2611" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "83", "Dingbat hex": "53", "Unicode dec": "11197", "Unicode hex": "2BBD" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "84", "Dingbat hex": "54", "Unicode dec": "9746", "Unicode hex": "2612" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "85", "Dingbat hex": "55", "Unicode dec": "11198", "Unicode hex": "2BBE" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "86", "Dingbat hex": "56", "Unicode dec": "11199", "Unicode hex": "2BBF" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "87", "Dingbat hex": "57", "Unicode dec": "128711", "Unicode hex": "1F6C7" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "88", "Dingbat hex": "58", "Unicode dec": "10680", "Unicode hex": "29B8" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "89", "Dingbat hex": "59", "Unicode dec": "128625", "Unicode hex": "1F671" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "90", "Dingbat hex": "5A", "Unicode dec": "128628", "Unicode hex": "1F674" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "91", "Dingbat hex": "5B", "Unicode dec": "128626", "Unicode hex": "1F672" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "92", "Dingbat hex": "5C", "Unicode dec": "128627", "Unicode hex": "1F673" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "93", "Dingbat hex": "5D", "Unicode dec": "8253", "Unicode hex": "203D" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "94", "Dingbat hex": "5E", "Unicode dec": "128633", "Unicode hex": "1F679" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "95", "Dingbat hex": "5F", "Unicode dec": "128634", "Unicode hex": "1F67A" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "96", "Dingbat hex": "60", "Unicode dec": "128635", "Unicode hex": "1F67B" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "97", "Dingbat hex": "61", "Unicode dec": "128614", "Unicode hex": "1F666" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "98", "Dingbat hex": "62", "Unicode dec": "128612", "Unicode hex": "1F664" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "99", "Dingbat hex": "63", "Unicode dec": "128613", "Unicode hex": "1F665" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "100", "Dingbat hex": "64", "Unicode dec": "128615", "Unicode hex": "1F667" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "101", "Dingbat hex": "65", "Unicode dec": "128602", "Unicode hex": "1F65A" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "102", "Dingbat hex": "66", "Unicode dec": "128600", "Unicode hex": "1F658" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "103", "Dingbat hex": "67", "Unicode dec": "128601", "Unicode hex": "1F659" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "104", "Dingbat hex": "68", "Unicode dec": "128603", "Unicode hex": "1F65B" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "105", "Dingbat hex": "69", "Unicode dec": "9450", "Unicode hex": "24EA" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "106", "Dingbat hex": "6A", "Unicode dec": "9312", "Unicode hex": "2460" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "107", "Dingbat hex": "6B", "Unicode dec": "9313", "Unicode hex": "2461" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "108", "Dingbat hex": "6C", "Unicode dec": "9314", "Unicode hex": "2462" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "109", "Dingbat hex": "6D", "Unicode dec": "9315", "Unicode hex": "2463" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "110", "Dingbat hex": "6E", "Unicode dec": "9316", "Unicode hex": "2464" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "111", "Dingbat hex": "6F", "Unicode dec": "9317", "Unicode hex": "2465" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "112", "Dingbat hex": "70", "Unicode dec": "9318", "Unicode hex": "2466" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "113", "Dingbat hex": "71", "Unicode dec": "9319", "Unicode hex": "2467" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "114", "Dingbat hex": "72", "Unicode dec": "9320", "Unicode hex": "2468" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "115", "Dingbat hex": "73", "Unicode dec": "9321", "Unicode hex": "2469" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "116", "Dingbat hex": "74", "Unicode dec": "9471", "Unicode hex": "24FF" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "117", "Dingbat hex": "75", "Unicode dec": "10102", "Unicode hex": "2776" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "118", "Dingbat hex": "76", "Unicode dec": "10103", "Unicode hex": "2777" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "119", "Dingbat hex": "77", "Unicode dec": "10104", "Unicode hex": "2778" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "120", "Dingbat hex": "78", "Unicode dec": "10105", "Unicode hex": "2779" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "121", "Dingbat hex": "79", "Unicode dec": "10106", "Unicode hex": "277A" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "122", "Dingbat hex": "7A", "Unicode dec": "10107", "Unicode hex": "277B" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "123", "Dingbat hex": "7B", "Unicode dec": "10108", "Unicode hex": "277C" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "124", "Dingbat hex": "7C", "Unicode dec": "10109", "Unicode hex": "277D" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "125", "Dingbat hex": "7D", "Unicode dec": "10110", "Unicode hex": "277E" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "126", "Dingbat hex": "7E", "Unicode dec": "10111", "Unicode hex": "277F" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "128", "Dingbat hex": "80", "Unicode dec": "9737", "Unicode hex": "2609" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "129", "Dingbat hex": "81", "Unicode dec": "127765", "Unicode hex": "1F315" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "130", "Dingbat hex": "82", "Unicode dec": "9789", "Unicode hex": "263D" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "131", "Dingbat hex": "83", "Unicode dec": "9790", "Unicode hex": "263E" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "132", "Dingbat hex": "84", "Unicode dec": "11839", "Unicode hex": "2E3F" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "133", "Dingbat hex": "85", "Unicode dec": "10013", "Unicode hex": "271D" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "134", "Dingbat hex": "86", "Unicode dec": "128327", "Unicode hex": "1F547" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "135", "Dingbat hex": "87", "Unicode dec": "128348", "Unicode hex": "1F55C" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "136", "Dingbat hex": "88", "Unicode dec": "128349", "Unicode hex": "1F55D" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "137", "Dingbat hex": "89", "Unicode dec": "128350", "Unicode hex": "1F55E" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "138", "Dingbat hex": "8A", "Unicode dec": "128351", "Unicode hex": "1F55F" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "139", "Dingbat hex": "8B", "Unicode dec": "128352", "Unicode hex": "1F560" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "140", "Dingbat hex": "8C", "Unicode dec": "128353", "Unicode hex": "1F561" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "141", "Dingbat hex": "8D", "Unicode dec": "128354", "Unicode hex": "1F562" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "142", "Dingbat hex": "8E", "Unicode dec": "128355", "Unicode hex": "1F563" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "143", "Dingbat hex": "8F", "Unicode dec": "128356", "Unicode hex": "1F564" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "144", "Dingbat hex": "90", "Unicode dec": "128357", "Unicode hex": "1F565" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "145", "Dingbat hex": "91", "Unicode dec": "128358", "Unicode hex": "1F566" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "146", "Dingbat hex": "92", "Unicode dec": "128359", "Unicode hex": "1F567" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "147", "Dingbat hex": "93", "Unicode dec": "128616", "Unicode hex": "1F668" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "148", "Dingbat hex": "94", "Unicode dec": "128617", "Unicode hex": "1F669" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "149", "Dingbat hex": "95", "Unicode dec": "8901", "Unicode hex": "22C5" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "150", "Dingbat hex": "96", "Unicode dec": "128900", "Unicode hex": "1F784" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "151", "Dingbat hex": "97", "Unicode dec": "10625", "Unicode hex": "2981" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "152", "Dingbat hex": "98", "Unicode dec": "9679", "Unicode hex": "25CF" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "153", "Dingbat hex": "99", "Unicode dec": "9675", "Unicode hex": "25CB" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "154", "Dingbat hex": "9A", "Unicode dec": "128901", "Unicode hex": "1F785" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "155", "Dingbat hex": "9B", "Unicode dec": "128903", "Unicode hex": "1F787" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "156", "Dingbat hex": "9C", "Unicode dec": "128905", "Unicode hex": "1F789" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "157", "Dingbat hex": "9D", "Unicode dec": "8857", "Unicode hex": "2299" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "158", "Dingbat hex": "9E", "Unicode dec": "10687", "Unicode hex": "29BF" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "159", "Dingbat hex": "9F", "Unicode dec": "128908", "Unicode hex": "1F78C" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "160", "Dingbat hex": "A0", "Unicode dec": "128909", "Unicode hex": "1F78D" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "161", "Dingbat hex": "A1", "Unicode dec": "9726", "Unicode hex": "25FE" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "162", "Dingbat hex": "A2", "Unicode dec": "9632", "Unicode hex": "25A0" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "163", "Dingbat hex": "A3", "Unicode dec": "9633", "Unicode hex": "25A1" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "164", "Dingbat hex": "A4", "Unicode dec": "128913", "Unicode hex": "1F791" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "165", "Dingbat hex": "A5", "Unicode dec": "128914", "Unicode hex": "1F792" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "166", "Dingbat hex": "A6", "Unicode dec": "128915", "Unicode hex": "1F793" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "167", "Dingbat hex": "A7", "Unicode dec": "128916", "Unicode hex": "1F794" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "168", "Dingbat hex": "A8", "Unicode dec": "9635", "Unicode hex": "25A3" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "169", "Dingbat hex": "A9", "Unicode dec": "128917", "Unicode hex": "1F795" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "170", "Dingbat hex": "AA", "Unicode dec": "128918", "Unicode hex": "1F796" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "171", "Dingbat hex": "AB", "Unicode dec": "128919", "Unicode hex": "1F797" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "172", "Dingbat hex": "AC", "Unicode dec": "128920", "Unicode hex": "1F798" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "173", "Dingbat hex": "AD", "Unicode dec": "11049", "Unicode hex": "2B29" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "174", "Dingbat hex": "AE", "Unicode dec": "11045", "Unicode hex": "2B25" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "175", "Dingbat hex": "AF", "Unicode dec": "9671", "Unicode hex": "25C7" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "176", "Dingbat hex": "B0", "Unicode dec": "128922", "Unicode hex": "1F79A" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "177", "Dingbat hex": "B1", "Unicode dec": "9672", "Unicode hex": "25C8" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "178", "Dingbat hex": "B2", "Unicode dec": "128923", "Unicode hex": "1F79B" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "179", "Dingbat hex": "B3", "Unicode dec": "128924", "Unicode hex": "1F79C" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "180", "Dingbat hex": "B4", "Unicode dec": "128925", "Unicode hex": "1F79D" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "181", "Dingbat hex": "B5", "Unicode dec": "128926", "Unicode hex": "1F79E" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "182", "Dingbat hex": "B6", "Unicode dec": "11050", "Unicode hex": "2B2A" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "183", "Dingbat hex": "B7", "Unicode dec": "11047", "Unicode hex": "2B27" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "184", "Dingbat hex": "B8", "Unicode dec": "9674", "Unicode hex": "25CA" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "185", "Dingbat hex": "B9", "Unicode dec": "128928", "Unicode hex": "1F7A0" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "186", "Dingbat hex": "BA", "Unicode dec": "9686", "Unicode hex": "25D6" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "187", "Dingbat hex": "BB", "Unicode dec": "9687", "Unicode hex": "25D7" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "188", "Dingbat hex": "BC", "Unicode dec": "11210", "Unicode hex": "2BCA" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "189", "Dingbat hex": "BD", "Unicode dec": "11211", "Unicode hex": "2BCB" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "190", "Dingbat hex": "BE", "Unicode dec": "11200", "Unicode hex": "2BC0" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "191", "Dingbat hex": "BF", "Unicode dec": "11201", "Unicode hex": "2BC1" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "192", "Dingbat hex": "C0", "Unicode dec": "11039", "Unicode hex": "2B1F" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "193", "Dingbat hex": "C1", "Unicode dec": "11202", "Unicode hex": "2BC2" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "194", "Dingbat hex": "C2", "Unicode dec": "11043", "Unicode hex": "2B23" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "195", "Dingbat hex": "C3", "Unicode dec": "11042", "Unicode hex": "2B22" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "196", "Dingbat hex": "C4", "Unicode dec": "11203", "Unicode hex": "2BC3" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "197", "Dingbat hex": "C5", "Unicode dec": "11204", "Unicode hex": "2BC4" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "198", "Dingbat hex": "C6", "Unicode dec": "128929", "Unicode hex": "1F7A1" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "199", "Dingbat hex": "C7", "Unicode dec": "128930", "Unicode hex": "1F7A2" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "200", "Dingbat hex": "C8", "Unicode dec": "128931", "Unicode hex": "1F7A3" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "201", "Dingbat hex": "C9", "Unicode dec": "128932", "Unicode hex": "1F7A4" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "202", "Dingbat hex": "CA", "Unicode dec": "128933", "Unicode hex": "1F7A5" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "203", "Dingbat hex": "CB", "Unicode dec": "128934", "Unicode hex": "1F7A6" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "204", "Dingbat hex": "CC", "Unicode dec": "128935", "Unicode hex": "1F7A7" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "205", "Dingbat hex": "CD", "Unicode dec": "128936", "Unicode hex": "1F7A8" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "206", "Dingbat hex": "CE", "Unicode dec": "128937", "Unicode hex": "1F7A9" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "207", "Dingbat hex": "CF", "Unicode dec": "128938", "Unicode hex": "1F7AA" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "208", "Dingbat hex": "D0", "Unicode dec": "128939", "Unicode hex": "1F7AB" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "209", "Dingbat hex": "D1", "Unicode dec": "128940", "Unicode hex": "1F7AC" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "210", "Dingbat hex": "D2", "Unicode dec": "128941", "Unicode hex": "1F7AD" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "211", "Dingbat hex": "D3", "Unicode dec": "128942", "Unicode hex": "1F7AE" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "212", "Dingbat hex": "D4", "Unicode dec": "128943", "Unicode hex": "1F7AF" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "213", "Dingbat hex": "D5", "Unicode dec": "128944", "Unicode hex": "1F7B0" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "214", "Dingbat hex": "D6", "Unicode dec": "128945", "Unicode hex": "1F7B1" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "215", "Dingbat hex": "D7", "Unicode dec": "128946", "Unicode hex": "1F7B2" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "216", "Dingbat hex": "D8", "Unicode dec": "128947", "Unicode hex": "1F7B3" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "217", "Dingbat hex": "D9", "Unicode dec": "128948", "Unicode hex": "1F7B4" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "218", "Dingbat hex": "DA", "Unicode dec": "128949", "Unicode hex": "1F7B5" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "219", "Dingbat hex": "DB", "Unicode dec": "128950", "Unicode hex": "1F7B6" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "220", "Dingbat hex": "DC", "Unicode dec": "128951", "Unicode hex": "1F7B7" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "221", "Dingbat hex": "DD", "Unicode dec": "128952", "Unicode hex": "1F7B8" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "222", "Dingbat hex": "DE", "Unicode dec": "128953", "Unicode hex": "1F7B9" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "223", "Dingbat hex": "DF", "Unicode dec": "128954", "Unicode hex": "1F7BA" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "224", "Dingbat hex": "E0", "Unicode dec": "128955", "Unicode hex": "1F7BB" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "225", "Dingbat hex": "E1", "Unicode dec": "128956", "Unicode hex": "1F7BC" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "226", "Dingbat hex": "E2", "Unicode dec": "128957", "Unicode hex": "1F7BD" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "227", "Dingbat hex": "E3", "Unicode dec": "128958", "Unicode hex": "1F7BE" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "228", "Dingbat hex": "E4", "Unicode dec": "128959", "Unicode hex": "1F7BF" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "229", "Dingbat hex": "E5", "Unicode dec": "128960", "Unicode hex": "1F7C0" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "230", "Dingbat hex": "E6", "Unicode dec": "128962", "Unicode hex": "1F7C2" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "231", "Dingbat hex": "E7", "Unicode dec": "128964", "Unicode hex": "1F7C4" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "232", "Dingbat hex": "E8", "Unicode dec": "128966", "Unicode hex": "1F7C6" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "233", "Dingbat hex": "E9", "Unicode dec": "128969", "Unicode hex": "1F7C9" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "234", "Dingbat hex": "EA", "Unicode dec": "128970", "Unicode hex": "1F7CA" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "235", "Dingbat hex": "EB", "Unicode dec": "10038", "Unicode hex": "2736" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "236", "Dingbat hex": "EC", "Unicode dec": "128972", "Unicode hex": "1F7CC" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "237", "Dingbat hex": "ED", "Unicode dec": "128974", "Unicode hex": "1F7CE" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "238", "Dingbat hex": "EE", "Unicode dec": "128976", "Unicode hex": "1F7D0" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "239", "Dingbat hex": "EF", "Unicode dec": "128978", "Unicode hex": "1F7D2" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "240", "Dingbat hex": "F0", "Unicode dec": "10041", "Unicode hex": "2739" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "241", "Dingbat hex": "F1", "Unicode dec": "128963", "Unicode hex": "1F7C3" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "242", "Dingbat hex": "F2", "Unicode dec": "128967", "Unicode hex": "1F7C7" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "243", "Dingbat hex": "F3", "Unicode dec": "10031", "Unicode hex": "272F" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "244", "Dingbat hex": "F4", "Unicode dec": "128973", "Unicode hex": "1F7CD" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "245", "Dingbat hex": "F5", "Unicode dec": "128980", "Unicode hex": "1F7D4" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "246", "Dingbat hex": "F6", "Unicode dec": "11212", "Unicode hex": "2BCC" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "247", "Dingbat hex": "F7", "Unicode dec": "11213", "Unicode hex": "2BCD" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "248", "Dingbat hex": "F8", "Unicode dec": "8251", "Unicode hex": "203B" },
    { "Typeface name": "Wingdings 2", "Dingbat dec": "249", "Dingbat hex": "F9", "Unicode dec": "8258", "Unicode hex": "2042" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "32", "Dingbat hex": "20", "Unicode dec": "32", "Unicode hex": "20" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "33", "Dingbat hex": "21", "Unicode dec": "11104", "Unicode hex": "2B60" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "34", "Dingbat hex": "22", "Unicode dec": "11106", "Unicode hex": "2B62" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "35", "Dingbat hex": "23", "Unicode dec": "11105", "Unicode hex": "2B61" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "36", "Dingbat hex": "24", "Unicode dec": "11107", "Unicode hex": "2B63" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "37", "Dingbat hex": "25", "Unicode dec": "11110", "Unicode hex": "2B66" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "38", "Dingbat hex": "26", "Unicode dec": "11111", "Unicode hex": "2B67" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "39", "Dingbat hex": "27", "Unicode dec": "11113", "Unicode hex": "2B69" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "40", "Dingbat hex": "28", "Unicode dec": "11112", "Unicode hex": "2B68" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "41", "Dingbat hex": "29", "Unicode dec": "11120", "Unicode hex": "2B70" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "42", "Dingbat hex": "2A", "Unicode dec": "11122", "Unicode hex": "2B72" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "43", "Dingbat hex": "2B", "Unicode dec": "11121", "Unicode hex": "2B71" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "44", "Dingbat hex": "2C", "Unicode dec": "11123", "Unicode hex": "2B73" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "45", "Dingbat hex": "2D", "Unicode dec": "11126", "Unicode hex": "2B76" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "46", "Dingbat hex": "2E", "Unicode dec": "11128", "Unicode hex": "2B78" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "47", "Dingbat hex": "2F", "Unicode dec": "11131", "Unicode hex": "2B7B" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "48", "Dingbat hex": "30", "Unicode dec": "11133", "Unicode hex": "2B7D" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "49", "Dingbat hex": "31", "Unicode dec": "11108", "Unicode hex": "2B64" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "50", "Dingbat hex": "32", "Unicode dec": "11109", "Unicode hex": "2B65" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "51", "Dingbat hex": "33", "Unicode dec": "11114", "Unicode hex": "2B6A" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "52", "Dingbat hex": "34", "Unicode dec": "11116", "Unicode hex": "2B6C" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "53", "Dingbat hex": "35", "Unicode dec": "11115", "Unicode hex": "2B6B" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "54", "Dingbat hex": "36", "Unicode dec": "11117", "Unicode hex": "2B6D" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "55", "Dingbat hex": "37", "Unicode dec": "11085", "Unicode hex": "2B4D" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "56", "Dingbat hex": "38", "Unicode dec": "11168", "Unicode hex": "2BA0" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "57", "Dingbat hex": "39", "Unicode dec": "11169", "Unicode hex": "2BA1" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "58", "Dingbat hex": "3A", "Unicode dec": "11170", "Unicode hex": "2BA2" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "59", "Dingbat hex": "3B", "Unicode dec": "11171", "Unicode hex": "2BA3" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "60", "Dingbat hex": "3C", "Unicode dec": "11172", "Unicode hex": "2BA4" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "61", "Dingbat hex": "3D", "Unicode dec": "11173", "Unicode hex": "2BA5" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "62", "Dingbat hex": "3E", "Unicode dec": "11174", "Unicode hex": "2BA6" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "63", "Dingbat hex": "3F", "Unicode dec": "11175", "Unicode hex": "2BA7" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "64", "Dingbat hex": "40", "Unicode dec": "11152", "Unicode hex": "2B90" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "65", "Dingbat hex": "41", "Unicode dec": "11153", "Unicode hex": "2B91" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "66", "Dingbat hex": "42", "Unicode dec": "11154", "Unicode hex": "2B92" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "67", "Dingbat hex": "43", "Unicode dec": "11155", "Unicode hex": "2B93" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "68", "Dingbat hex": "44", "Unicode dec": "11136", "Unicode hex": "2B80" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "69", "Dingbat hex": "45", "Unicode dec": "11139", "Unicode hex": "2B83" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "70", "Dingbat hex": "46", "Unicode dec": "11134", "Unicode hex": "2B7E" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "71", "Dingbat hex": "47", "Unicode dec": "11135", "Unicode hex": "2B7F" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "72", "Dingbat hex": "48", "Unicode dec": "11140", "Unicode hex": "2B84" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "73", "Dingbat hex": "49", "Unicode dec": "11142", "Unicode hex": "2B86" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "74", "Dingbat hex": "4A", "Unicode dec": "11141", "Unicode hex": "2B85" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "75", "Dingbat hex": "4B", "Unicode dec": "11143", "Unicode hex": "2B87" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "76", "Dingbat hex": "4C", "Unicode dec": "11151", "Unicode hex": "2B8F" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "77", "Dingbat hex": "4D", "Unicode dec": "11149", "Unicode hex": "2B8D" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "78", "Dingbat hex": "4E", "Unicode dec": "11150", "Unicode hex": "2B8E" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "79", "Dingbat hex": "4F", "Unicode dec": "11148", "Unicode hex": "2B8C" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "80", "Dingbat hex": "50", "Unicode dec": "11118", "Unicode hex": "2B6E" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "81", "Dingbat hex": "51", "Unicode dec": "11119", "Unicode hex": "2B6F" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "82", "Dingbat hex": "52", "Unicode dec": "9099", "Unicode hex": "238B" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "83", "Dingbat hex": "53", "Unicode dec": "8996", "Unicode hex": "2324" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "84", "Dingbat hex": "54", "Unicode dec": "8963", "Unicode hex": "2303" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "85", "Dingbat hex": "55", "Unicode dec": "8997", "Unicode hex": "2325" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "86", "Dingbat hex": "56", "Unicode dec": "9251", "Unicode hex": "2423" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "87", "Dingbat hex": "57", "Unicode dec": "9085", "Unicode hex": "237D" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "88", "Dingbat hex": "58", "Unicode dec": "8682", "Unicode hex": "21EA" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "89", "Dingbat hex": "59", "Unicode dec": "11192", "Unicode hex": "2BB8" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "90", "Dingbat hex": "5A", "Unicode dec": "129184", "Unicode hex": "1F8A0" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "91", "Dingbat hex": "5B", "Unicode dec": "129185", "Unicode hex": "1F8A1" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "92", "Dingbat hex": "5C", "Unicode dec": "129186", "Unicode hex": "1F8A2" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "93", "Dingbat hex": "5D", "Unicode dec": "129187", "Unicode hex": "1F8A3" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "94", "Dingbat hex": "5E", "Unicode dec": "129188", "Unicode hex": "1F8A4" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "95", "Dingbat hex": "5F", "Unicode dec": "129189", "Unicode hex": "1F8A5" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "96", "Dingbat hex": "60", "Unicode dec": "129190", "Unicode hex": "1F8A6" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "97", "Dingbat hex": "61", "Unicode dec": "129191", "Unicode hex": "1F8A7" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "98", "Dingbat hex": "62", "Unicode dec": "129192", "Unicode hex": "1F8A8" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "99", "Dingbat hex": "63", "Unicode dec": "129193", "Unicode hex": "1F8A9" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "100", "Dingbat hex": "64", "Unicode dec": "129194", "Unicode hex": "1F8AA" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "101", "Dingbat hex": "65", "Unicode dec": "129195", "Unicode hex": "1F8AB" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "102", "Dingbat hex": "66", "Unicode dec": "129104", "Unicode hex": "1F850" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "103", "Dingbat hex": "67", "Unicode dec": "129106", "Unicode hex": "1F852" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "104", "Dingbat hex": "68", "Unicode dec": "129105", "Unicode hex": "1F851" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "105", "Dingbat hex": "69", "Unicode dec": "129107", "Unicode hex": "1F853" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "106", "Dingbat hex": "6A", "Unicode dec": "129108", "Unicode hex": "1F854" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "107", "Dingbat hex": "6B", "Unicode dec": "129109", "Unicode hex": "1F855" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "108", "Dingbat hex": "6C", "Unicode dec": "129111", "Unicode hex": "1F857" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "109", "Dingbat hex": "6D", "Unicode dec": "129110", "Unicode hex": "1F856" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "110", "Dingbat hex": "6E", "Unicode dec": "129112", "Unicode hex": "1F858" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "111", "Dingbat hex": "6F", "Unicode dec": "129113", "Unicode hex": "1F859" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "112", "Dingbat hex": "70", "Unicode dec": "9650", "Unicode hex": "25B2" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "113", "Dingbat hex": "71", "Unicode dec": "9660", "Unicode hex": "25BC" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "114", "Dingbat hex": "72", "Unicode dec": "9651", "Unicode hex": "25B3" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "115", "Dingbat hex": "73", "Unicode dec": "9661", "Unicode hex": "25BD" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "116", "Dingbat hex": "74", "Unicode dec": "9664", "Unicode hex": "25C0" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "117", "Dingbat hex": "75", "Unicode dec": "9654", "Unicode hex": "25B6" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "118", "Dingbat hex": "76", "Unicode dec": "9665", "Unicode hex": "25C1" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "119", "Dingbat hex": "77", "Unicode dec": "9655", "Unicode hex": "25B7" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "120", "Dingbat hex": "78", "Unicode dec": "9699", "Unicode hex": "25E3" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "121", "Dingbat hex": "79", "Unicode dec": "9698", "Unicode hex": "25E2" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "122", "Dingbat hex": "7A", "Unicode dec": "9700", "Unicode hex": "25E4" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "123", "Dingbat hex": "7B", "Unicode dec": "9701", "Unicode hex": "25E5" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "124", "Dingbat hex": "7C", "Unicode dec": "128896", "Unicode hex": "1F780" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "125", "Dingbat hex": "7D", "Unicode dec": "128898", "Unicode hex": "1F782" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "126", "Dingbat hex": "7E", "Unicode dec": "128897", "Unicode hex": "1F781" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "128", "Dingbat hex": "80", "Unicode dec": "128899", "Unicode hex": "1F783" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "129", "Dingbat hex": "81", "Unicode dec": "11205", "Unicode hex": "2BC5" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "130", "Dingbat hex": "82", "Unicode dec": "11206", "Unicode hex": "2BC6" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "131", "Dingbat hex": "83", "Unicode dec": "11207", "Unicode hex": "2BC7" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "132", "Dingbat hex": "84", "Unicode dec": "11208", "Unicode hex": "2BC8" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "133", "Dingbat hex": "85", "Unicode dec": "11164", "Unicode hex": "2B9C" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "134", "Dingbat hex": "86", "Unicode dec": "11166", "Unicode hex": "2B9E" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "135", "Dingbat hex": "87", "Unicode dec": "11165", "Unicode hex": "2B9D" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "136", "Dingbat hex": "88", "Unicode dec": "11167", "Unicode hex": "2B9F" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "137", "Dingbat hex": "89", "Unicode dec": "129040", "Unicode hex": "1F810" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "138", "Dingbat hex": "8A", "Unicode dec": "129042", "Unicode hex": "1F812" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "139", "Dingbat hex": "8B", "Unicode dec": "129041", "Unicode hex": "1F811" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "140", "Dingbat hex": "8C", "Unicode dec": "129043", "Unicode hex": "1F813" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "141", "Dingbat hex": "8D", "Unicode dec": "129044", "Unicode hex": "1F814" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "142", "Dingbat hex": "8E", "Unicode dec": "129046", "Unicode hex": "1F816" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "143", "Dingbat hex": "8F", "Unicode dec": "129045", "Unicode hex": "1F815" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "144", "Dingbat hex": "90", "Unicode dec": "129047", "Unicode hex": "1F817" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "145", "Dingbat hex": "91", "Unicode dec": "129048", "Unicode hex": "1F818" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "146", "Dingbat hex": "92", "Unicode dec": "129050", "Unicode hex": "1F81A" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "147", "Dingbat hex": "93", "Unicode dec": "129049", "Unicode hex": "1F819" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "148", "Dingbat hex": "94", "Unicode dec": "129051", "Unicode hex": "1F81B" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "149", "Dingbat hex": "95", "Unicode dec": "129052", "Unicode hex": "1F81C" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "150", "Dingbat hex": "96", "Unicode dec": "129054", "Unicode hex": "1F81E" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "151", "Dingbat hex": "97", "Unicode dec": "129053", "Unicode hex": "1F81D" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "152", "Dingbat hex": "98", "Unicode dec": "129055", "Unicode hex": "1F81F" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "153", "Dingbat hex": "99", "Unicode dec": "129024", "Unicode hex": "1F800" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "154", "Dingbat hex": "9A", "Unicode dec": "129026", "Unicode hex": "1F802" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "155", "Dingbat hex": "9B", "Unicode dec": "129025", "Unicode hex": "1F801" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "156", "Dingbat hex": "9C", "Unicode dec": "129027", "Unicode hex": "1F803" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "157", "Dingbat hex": "9D", "Unicode dec": "129028", "Unicode hex": "1F804" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "158", "Dingbat hex": "9E", "Unicode dec": "129030", "Unicode hex": "1F806" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "159", "Dingbat hex": "9F", "Unicode dec": "129029", "Unicode hex": "1F805" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "160", "Dingbat hex": "A0", "Unicode dec": "129031", "Unicode hex": "1F807" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "161", "Dingbat hex": "A1", "Unicode dec": "129032", "Unicode hex": "1F808" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "162", "Dingbat hex": "A2", "Unicode dec": "129034", "Unicode hex": "1F80A" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "163", "Dingbat hex": "A3", "Unicode dec": "129033", "Unicode hex": "1F809" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "164", "Dingbat hex": "A4", "Unicode dec": "129035", "Unicode hex": "1F80B" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "165", "Dingbat hex": "A5", "Unicode dec": "129056", "Unicode hex": "1F820" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "166", "Dingbat hex": "A6", "Unicode dec": "129058", "Unicode hex": "1F822" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "167", "Dingbat hex": "A7", "Unicode dec": "129060", "Unicode hex": "1F824" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "168", "Dingbat hex": "A8", "Unicode dec": "129062", "Unicode hex": "1F826" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "169", "Dingbat hex": "A9", "Unicode dec": "129064", "Unicode hex": "1F828" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "170", "Dingbat hex": "AA", "Unicode dec": "129066", "Unicode hex": "1F82A" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "171", "Dingbat hex": "AB", "Unicode dec": "129068", "Unicode hex": "1F82C" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "172", "Dingbat hex": "AC", "Unicode dec": "129180", "Unicode hex": "1F89C" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "173", "Dingbat hex": "AD", "Unicode dec": "129181", "Unicode hex": "1F89D" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "174", "Dingbat hex": "AE", "Unicode dec": "129182", "Unicode hex": "1F89E" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "175", "Dingbat hex": "AF", "Unicode dec": "129183", "Unicode hex": "1F89F" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "176", "Dingbat hex": "B0", "Unicode dec": "129070", "Unicode hex": "1F82E" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "177", "Dingbat hex": "B1", "Unicode dec": "129072", "Unicode hex": "1F830" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "178", "Dingbat hex": "B2", "Unicode dec": "129074", "Unicode hex": "1F832" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "179", "Dingbat hex": "B3", "Unicode dec": "129076", "Unicode hex": "1F834" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "180", "Dingbat hex": "B4", "Unicode dec": "129078", "Unicode hex": "1F836" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "181", "Dingbat hex": "B5", "Unicode dec": "129080", "Unicode hex": "1F838" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "182", "Dingbat hex": "B6", "Unicode dec": "129082", "Unicode hex": "1F83A" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "183", "Dingbat hex": "B7", "Unicode dec": "129081", "Unicode hex": "1F839" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "184", "Dingbat hex": "B8", "Unicode dec": "129083", "Unicode hex": "1F83B" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "185", "Dingbat hex": "B9", "Unicode dec": "129176", "Unicode hex": "1F898" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "186", "Dingbat hex": "BA", "Unicode dec": "129178", "Unicode hex": "1F89A" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "187", "Dingbat hex": "BB", "Unicode dec": "129177", "Unicode hex": "1F899" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "188", "Dingbat hex": "BC", "Unicode dec": "129179", "Unicode hex": "1F89B" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "189", "Dingbat hex": "BD", "Unicode dec": "129084", "Unicode hex": "1F83C" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "190", "Dingbat hex": "BE", "Unicode dec": "129086", "Unicode hex": "1F83E" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "191", "Dingbat hex": "BF", "Unicode dec": "129085", "Unicode hex": "1F83D" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "192", "Dingbat hex": "C0", "Unicode dec": "129087", "Unicode hex": "1F83F" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "193", "Dingbat hex": "C1", "Unicode dec": "129088", "Unicode hex": "1F840" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "194", "Dingbat hex": "C2", "Unicode dec": "129090", "Unicode hex": "1F842" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "195", "Dingbat hex": "C3", "Unicode dec": "129089", "Unicode hex": "1F841" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "196", "Dingbat hex": "C4", "Unicode dec": "129091", "Unicode hex": "1F843" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "197", "Dingbat hex": "C5", "Unicode dec": "129092", "Unicode hex": "1F844" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "198", "Dingbat hex": "C6", "Unicode dec": "129094", "Unicode hex": "1F846" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "199", "Dingbat hex": "C7", "Unicode dec": "129093", "Unicode hex": "1F845" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "200", "Dingbat hex": "C8", "Unicode dec": "129095", "Unicode hex": "1F847" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "201", "Dingbat hex": "C9", "Unicode dec": "11176", "Unicode hex": "2BA8" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "202", "Dingbat hex": "CA", "Unicode dec": "11177", "Unicode hex": "2BA9" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "203", "Dingbat hex": "CB", "Unicode dec": "11178", "Unicode hex": "2BAA" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "204", "Dingbat hex": "CC", "Unicode dec": "11179", "Unicode hex": "2BAB" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "205", "Dingbat hex": "CD", "Unicode dec": "11180", "Unicode hex": "2BAC" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "206", "Dingbat hex": "CE", "Unicode dec": "11181", "Unicode hex": "2BAD" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "207", "Dingbat hex": "CF", "Unicode dec": "11182", "Unicode hex": "2BAE" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "208", "Dingbat hex": "D0", "Unicode dec": "11183", "Unicode hex": "2BAF" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "209", "Dingbat hex": "D1", "Unicode dec": "129120", "Unicode hex": "1F860" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "210", "Dingbat hex": "D2", "Unicode dec": "129122", "Unicode hex": "1F862" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "211", "Dingbat hex": "D3", "Unicode dec": "129121", "Unicode hex": "1F861" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "212", "Dingbat hex": "D4", "Unicode dec": "129123", "Unicode hex": "1F863" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "213", "Dingbat hex": "D5", "Unicode dec": "129124", "Unicode hex": "1F864" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "214", "Dingbat hex": "D6", "Unicode dec": "129125", "Unicode hex": "1F865" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "215", "Dingbat hex": "D7", "Unicode dec": "129127", "Unicode hex": "1F867" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "216", "Dingbat hex": "D8", "Unicode dec": "129126", "Unicode hex": "1F866" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "217", "Dingbat hex": "D9", "Unicode dec": "129136", "Unicode hex": "1F870" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "218", "Dingbat hex": "DA", "Unicode dec": "129138", "Unicode hex": "1F872" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "219", "Dingbat hex": "DB", "Unicode dec": "129137", "Unicode hex": "1F871" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "220", "Dingbat hex": "DC", "Unicode dec": "129139", "Unicode hex": "1F873" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "221", "Dingbat hex": "DD", "Unicode dec": "129140", "Unicode hex": "1F874" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "222", "Dingbat hex": "DE", "Unicode dec": "129141", "Unicode hex": "1F875" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "223", "Dingbat hex": "DF", "Unicode dec": "129143", "Unicode hex": "1F877" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "224", "Dingbat hex": "E0", "Unicode dec": "129142", "Unicode hex": "1F876" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "225", "Dingbat hex": "E1", "Unicode dec": "129152", "Unicode hex": "1F880" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "226", "Dingbat hex": "E2", "Unicode dec": "129154", "Unicode hex": "1F882" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "227", "Dingbat hex": "E3", "Unicode dec": "129153", "Unicode hex": "1F881" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "228", "Dingbat hex": "E4", "Unicode dec": "129155", "Unicode hex": "1F883" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "229", "Dingbat hex": "E5", "Unicode dec": "129156", "Unicode hex": "1F884" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "230", "Dingbat hex": "E6", "Unicode dec": "129157", "Unicode hex": "1F885" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "231", "Dingbat hex": "E7", "Unicode dec": "129159", "Unicode hex": "1F887" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "232", "Dingbat hex": "E8", "Unicode dec": "129158", "Unicode hex": "1F886" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "233", "Dingbat hex": "E9", "Unicode dec": "129168", "Unicode hex": "1F890" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "234", "Dingbat hex": "EA", "Unicode dec": "129170", "Unicode hex": "1F892" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "235", "Dingbat hex": "EB", "Unicode dec": "129169", "Unicode hex": "1F891" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "236", "Dingbat hex": "EC", "Unicode dec": "129171", "Unicode hex": "1F893" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "237", "Dingbat hex": "ED", "Unicode dec": "129172", "Unicode hex": "1F894" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "238", "Dingbat hex": "EE", "Unicode dec": "129174", "Unicode hex": "1F896" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "239", "Dingbat hex": "EF", "Unicode dec": "129173", "Unicode hex": "1F895" },
    { "Typeface name": "Wingdings 3", "Dingbat dec": "240", "Dingbat hex": "F0", "Unicode dec": "129175", "Unicode hex": "1F897" },
];
exports.default = dingbats;

},{}],85:[function(require,module,exports){
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hex = exports.dec = exports.codePoint = void 0;
var dingbats_1 = __importDefault(require("./dingbats"));
var dingbatsByCodePoint = {};
var fromCodePoint = String.fromCodePoint ? String.fromCodePoint : fromCodePointPolyfill;
for (var _i = 0, dingbats_2 = dingbats_1.default; _i < dingbats_2.length; _i++) {
    var dingbat = dingbats_2[_i];
    var codePoint_1 = parseInt(dingbat["Unicode dec"], 10);
    var scalarValue = {
        codePoint: codePoint_1,
        string: fromCodePoint(codePoint_1),
    };
    dingbatsByCodePoint[dingbat["Typeface name"].toUpperCase() + "_" + dingbat["Dingbat dec"]] = scalarValue;
}
function codePoint(typeface, codePoint) {
    return dingbatsByCodePoint[typeface.toUpperCase() + "_" + codePoint];
}
exports.codePoint = codePoint;
function dec(typeface, dec) {
    return codePoint(typeface, parseInt(dec, 10));
}
exports.dec = dec;
function hex(typeface, hex) {
    return codePoint(typeface, parseInt(hex, 16));
}
exports.hex = hex;
function fromCodePointPolyfill(codePoint) {
    if (codePoint <= 0xFFFF) {
        // BMP
        return String.fromCharCode(codePoint);
    }
    else {
        // Astral
        // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        var highSurrogate = Math.floor((codePoint - 0x10000) / 0x400) + 0xD800;
        var lowSurrogate = (codePoint - 0x10000) % 0x400 + 0xDC00;
        return String.fromCharCode(highSurrogate, lowSurrogate);
    }
}
;

},{"./dingbats":84}],86:[function(require,module,exports){
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],87:[function(require,module,exports){
var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

},{}],88:[function(require,module,exports){
(function (global,Buffer){
/*!

JSZip v3.7.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/master/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/master/LICENSE
*/

!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{("undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this).JSZip=t()}}(function(){return function s(a,o,h){function u(r,t){if(!o[r]){if(!a[r]){var e="function"==typeof require&&require;if(!t&&e)return e(r,!0);if(l)return l(r,!0);var i=new Error("Cannot find module '"+r+"'");throw i.code="MODULE_NOT_FOUND",i}var n=o[r]={exports:{}};a[r][0].call(n.exports,function(t){var e=a[r][1][t];return u(e||t)},n,n.exports,s,a,o,h)}return o[r].exports}for(var l="function"==typeof require&&require,t=0;t<h.length;t++)u(h[t]);return u}({1:[function(t,e,r){"use strict";var c=t("./utils"),d=t("./support"),p="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";r.encode=function(t){for(var e,r,i,n,s,a,o,h=[],u=0,l=t.length,f=l,d="string"!==c.getTypeOf(t);u<t.length;)f=l-u,i=d?(e=t[u++],r=u<l?t[u++]:0,u<l?t[u++]:0):(e=t.charCodeAt(u++),r=u<l?t.charCodeAt(u++):0,u<l?t.charCodeAt(u++):0),n=e>>2,s=(3&e)<<4|r>>4,a=1<f?(15&r)<<2|i>>6:64,o=2<f?63&i:64,h.push(p.charAt(n)+p.charAt(s)+p.charAt(a)+p.charAt(o));return h.join("")},r.decode=function(t){var e,r,i,n,s,a,o=0,h=0,u="data:";if(t.substr(0,u.length)===u)throw new Error("Invalid base64 input, it looks like a data url.");var l,f=3*(t=t.replace(/[^A-Za-z0-9\+\/\=]/g,"")).length/4;if(t.charAt(t.length-1)===p.charAt(64)&&f--,t.charAt(t.length-2)===p.charAt(64)&&f--,f%1!=0)throw new Error("Invalid base64 input, bad content length.");for(l=d.uint8array?new Uint8Array(0|f):new Array(0|f);o<t.length;)e=p.indexOf(t.charAt(o++))<<2|(n=p.indexOf(t.charAt(o++)))>>4,r=(15&n)<<4|(s=p.indexOf(t.charAt(o++)))>>2,i=(3&s)<<6|(a=p.indexOf(t.charAt(o++))),l[h++]=e,64!==s&&(l[h++]=r),64!==a&&(l[h++]=i);return l}},{"./support":30,"./utils":32}],2:[function(t,e,r){"use strict";var i=t("./external"),n=t("./stream/DataWorker"),s=t("./stream/Crc32Probe"),a=t("./stream/DataLengthProbe");function o(t,e,r,i,n){this.compressedSize=t,this.uncompressedSize=e,this.crc32=r,this.compression=i,this.compressedContent=n}o.prototype={getContentWorker:function(){var t=new n(i.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")),e=this;return t.on("end",function(){if(this.streamInfo.data_length!==e.uncompressedSize)throw new Error("Bug : uncompressed data size mismatch")}),t},getCompressedWorker:function(){return new n(i.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize",this.compressedSize).withStreamInfo("uncompressedSize",this.uncompressedSize).withStreamInfo("crc32",this.crc32).withStreamInfo("compression",this.compression)}},o.createWorkerFrom=function(t,e,r){return t.pipe(new s).pipe(new a("uncompressedSize")).pipe(e.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression",e)},e.exports=o},{"./external":6,"./stream/Crc32Probe":25,"./stream/DataLengthProbe":26,"./stream/DataWorker":27}],3:[function(t,e,r){"use strict";var i=t("./stream/GenericWorker");r.STORE={magic:"\0\0",compressWorker:function(t){return new i("STORE compression")},uncompressWorker:function(){return new i("STORE decompression")}},r.DEFLATE=t("./flate")},{"./flate":7,"./stream/GenericWorker":28}],4:[function(t,e,r){"use strict";var i=t("./utils");var o=function(){for(var t,e=[],r=0;r<256;r++){t=r;for(var i=0;i<8;i++)t=1&t?3988292384^t>>>1:t>>>1;e[r]=t}return e}();e.exports=function(t,e){return void 0!==t&&t.length?"string"!==i.getTypeOf(t)?function(t,e,r,i){var n=o,s=i+r;t^=-1;for(var a=i;a<s;a++)t=t>>>8^n[255&(t^e[a])];return-1^t}(0|e,t,t.length,0):function(t,e,r,i){var n=o,s=i+r;t^=-1;for(var a=i;a<s;a++)t=t>>>8^n[255&(t^e.charCodeAt(a))];return-1^t}(0|e,t,t.length,0):0}},{"./utils":32}],5:[function(t,e,r){"use strict";r.base64=!1,r.binary=!1,r.dir=!1,r.createFolders=!0,r.date=null,r.compression=null,r.compressionOptions=null,r.comment=null,r.unixPermissions=null,r.dosPermissions=null},{}],6:[function(t,e,r){"use strict";var i=null;i="undefined"!=typeof Promise?Promise:t("lie"),e.exports={Promise:i}},{lie:37}],7:[function(t,e,r){"use strict";var i="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Uint32Array,n=t("pako"),s=t("./utils"),a=t("./stream/GenericWorker"),o=i?"uint8array":"array";function h(t,e){a.call(this,"FlateWorker/"+t),this._pako=null,this._pakoAction=t,this._pakoOptions=e,this.meta={}}r.magic="\b\0",s.inherits(h,a),h.prototype.processChunk=function(t){this.meta=t.meta,null===this._pako&&this._createPako(),this._pako.push(s.transformTo(o,t.data),!1)},h.prototype.flush=function(){a.prototype.flush.call(this),null===this._pako&&this._createPako(),this._pako.push([],!0)},h.prototype.cleanUp=function(){a.prototype.cleanUp.call(this),this._pako=null},h.prototype._createPako=function(){this._pako=new n[this._pakoAction]({raw:!0,level:this._pakoOptions.level||-1});var e=this;this._pako.onData=function(t){e.push({data:t,meta:e.meta})}},r.compressWorker=function(t){return new h("Deflate",t)},r.uncompressWorker=function(){return new h("Inflate",{})}},{"./stream/GenericWorker":28,"./utils":32,pako:38}],8:[function(t,e,r){"use strict";function A(t,e){var r,i="";for(r=0;r<e;r++)i+=String.fromCharCode(255&t),t>>>=8;return i}function i(t,e,r,i,n,s){var a,o,h=t.file,u=t.compression,l=s!==O.utf8encode,f=I.transformTo("string",s(h.name)),d=I.transformTo("string",O.utf8encode(h.name)),c=h.comment,p=I.transformTo("string",s(c)),m=I.transformTo("string",O.utf8encode(c)),_=d.length!==h.name.length,g=m.length!==c.length,b="",v="",y="",w=h.dir,k=h.date,x={crc32:0,compressedSize:0,uncompressedSize:0};e&&!r||(x.crc32=t.crc32,x.compressedSize=t.compressedSize,x.uncompressedSize=t.uncompressedSize);var S=0;e&&(S|=8),l||!_&&!g||(S|=2048);var z=0,C=0;w&&(z|=16),"UNIX"===n?(C=798,z|=function(t,e){var r=t;return t||(r=e?16893:33204),(65535&r)<<16}(h.unixPermissions,w)):(C=20,z|=function(t){return 63&(t||0)}(h.dosPermissions)),a=k.getUTCHours(),a<<=6,a|=k.getUTCMinutes(),a<<=5,a|=k.getUTCSeconds()/2,o=k.getUTCFullYear()-1980,o<<=4,o|=k.getUTCMonth()+1,o<<=5,o|=k.getUTCDate(),_&&(v=A(1,1)+A(B(f),4)+d,b+="up"+A(v.length,2)+v),g&&(y=A(1,1)+A(B(p),4)+m,b+="uc"+A(y.length,2)+y);var E="";return E+="\n\0",E+=A(S,2),E+=u.magic,E+=A(a,2),E+=A(o,2),E+=A(x.crc32,4),E+=A(x.compressedSize,4),E+=A(x.uncompressedSize,4),E+=A(f.length,2),E+=A(b.length,2),{fileRecord:R.LOCAL_FILE_HEADER+E+f+b,dirRecord:R.CENTRAL_FILE_HEADER+A(C,2)+E+A(p.length,2)+"\0\0\0\0"+A(z,4)+A(i,4)+f+b+p}}var I=t("../utils"),n=t("../stream/GenericWorker"),O=t("../utf8"),B=t("../crc32"),R=t("../signature");function s(t,e,r,i){n.call(this,"ZipFileWorker"),this.bytesWritten=0,this.zipComment=e,this.zipPlatform=r,this.encodeFileName=i,this.streamFiles=t,this.accumulate=!1,this.contentBuffer=[],this.dirRecords=[],this.currentSourceOffset=0,this.entriesCount=0,this.currentFile=null,this._sources=[]}I.inherits(s,n),s.prototype.push=function(t){var e=t.meta.percent||0,r=this.entriesCount,i=this._sources.length;this.accumulate?this.contentBuffer.push(t):(this.bytesWritten+=t.data.length,n.prototype.push.call(this,{data:t.data,meta:{currentFile:this.currentFile,percent:r?(e+100*(r-i-1))/r:100}}))},s.prototype.openedSource=function(t){this.currentSourceOffset=this.bytesWritten,this.currentFile=t.file.name;var e=this.streamFiles&&!t.file.dir;if(e){var r=i(t,e,!1,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);this.push({data:r.fileRecord,meta:{percent:0}})}else this.accumulate=!0},s.prototype.closedSource=function(t){this.accumulate=!1;var e=this.streamFiles&&!t.file.dir,r=i(t,e,!0,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);if(this.dirRecords.push(r.dirRecord),e)this.push({data:function(t){return R.DATA_DESCRIPTOR+A(t.crc32,4)+A(t.compressedSize,4)+A(t.uncompressedSize,4)}(t),meta:{percent:100}});else for(this.push({data:r.fileRecord,meta:{percent:0}});this.contentBuffer.length;)this.push(this.contentBuffer.shift());this.currentFile=null},s.prototype.flush=function(){for(var t=this.bytesWritten,e=0;e<this.dirRecords.length;e++)this.push({data:this.dirRecords[e],meta:{percent:100}});var r=this.bytesWritten-t,i=function(t,e,r,i,n){var s=I.transformTo("string",n(i));return R.CENTRAL_DIRECTORY_END+"\0\0\0\0"+A(t,2)+A(t,2)+A(e,4)+A(r,4)+A(s.length,2)+s}(this.dirRecords.length,r,t,this.zipComment,this.encodeFileName);this.push({data:i,meta:{percent:100}})},s.prototype.prepareNextSource=function(){this.previous=this._sources.shift(),this.openedSource(this.previous.streamInfo),this.isPaused?this.previous.pause():this.previous.resume()},s.prototype.registerPrevious=function(t){this._sources.push(t);var e=this;return t.on("data",function(t){e.processChunk(t)}),t.on("end",function(){e.closedSource(e.previous.streamInfo),e._sources.length?e.prepareNextSource():e.end()}),t.on("error",function(t){e.error(t)}),this},s.prototype.resume=function(){return!!n.prototype.resume.call(this)&&(!this.previous&&this._sources.length?(this.prepareNextSource(),!0):this.previous||this._sources.length||this.generatedError?void 0:(this.end(),!0))},s.prototype.error=function(t){var e=this._sources;if(!n.prototype.error.call(this,t))return!1;for(var r=0;r<e.length;r++)try{e[r].error(t)}catch(t){}return!0},s.prototype.lock=function(){n.prototype.lock.call(this);for(var t=this._sources,e=0;e<t.length;e++)t[e].lock()},e.exports=s},{"../crc32":4,"../signature":23,"../stream/GenericWorker":28,"../utf8":31,"../utils":32}],9:[function(t,e,r){"use strict";var u=t("../compressions"),i=t("./ZipFileWorker");r.generateWorker=function(t,a,e){var o=new i(a.streamFiles,e,a.platform,a.encodeFileName),h=0;try{t.forEach(function(t,e){h++;var r=function(t,e){var r=t||e,i=u[r];if(!i)throw new Error(r+" is not a valid compression method !");return i}(e.options.compression,a.compression),i=e.options.compressionOptions||a.compressionOptions||{},n=e.dir,s=e.date;e._compressWorker(r,i).withStreamInfo("file",{name:t,dir:n,date:s,comment:e.comment||"",unixPermissions:e.unixPermissions,dosPermissions:e.dosPermissions}).pipe(o)}),o.entriesCount=h}catch(t){o.error(t)}return o}},{"../compressions":3,"./ZipFileWorker":8}],10:[function(t,e,r){"use strict";function i(){if(!(this instanceof i))return new i;if(arguments.length)throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");this.files=Object.create(null),this.comment=null,this.root="",this.clone=function(){var t=new i;for(var e in this)"function"!=typeof this[e]&&(t[e]=this[e]);return t}}(i.prototype=t("./object")).loadAsync=t("./load"),i.support=t("./support"),i.defaults=t("./defaults"),i.version="3.7.1",i.loadAsync=function(t,e){return(new i).loadAsync(t,e)},i.external=t("./external"),e.exports=i},{"./defaults":5,"./external":6,"./load":11,"./object":15,"./support":30}],11:[function(t,e,r){"use strict";var i=t("./utils"),n=t("./external"),o=t("./utf8"),h=t("./zipEntries"),s=t("./stream/Crc32Probe"),u=t("./nodejsUtils");function l(i){return new n.Promise(function(t,e){var r=i.decompressed.getContentWorker().pipe(new s);r.on("error",function(t){e(t)}).on("end",function(){r.streamInfo.crc32!==i.decompressed.crc32?e(new Error("Corrupted zip : CRC32 mismatch")):t()}).resume()})}e.exports=function(t,s){var a=this;return s=i.extend(s||{},{base64:!1,checkCRC32:!1,optimizedBinaryString:!1,createFolders:!1,decodeFileName:o.utf8decode}),u.isNode&&u.isStream(t)?n.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")):i.prepareContent("the loaded zip file",t,!0,s.optimizedBinaryString,s.base64).then(function(t){var e=new h(s);return e.load(t),e}).then(function(t){var e=[n.Promise.resolve(t)],r=t.files;if(s.checkCRC32)for(var i=0;i<r.length;i++)e.push(l(r[i]));return n.Promise.all(e)}).then(function(t){for(var e=t.shift(),r=e.files,i=0;i<r.length;i++){var n=r[i];a.file(n.fileNameStr,n.decompressed,{binary:!0,optimizedBinaryString:!0,date:n.date,dir:n.dir,comment:n.fileCommentStr.length?n.fileCommentStr:null,unixPermissions:n.unixPermissions,dosPermissions:n.dosPermissions,createFolders:s.createFolders})}return e.zipComment.length&&(a.comment=e.zipComment),a})}},{"./external":6,"./nodejsUtils":14,"./stream/Crc32Probe":25,"./utf8":31,"./utils":32,"./zipEntries":33}],12:[function(t,e,r){"use strict";var i=t("../utils"),n=t("../stream/GenericWorker");function s(t,e){n.call(this,"Nodejs stream input adapter for "+t),this._upstreamEnded=!1,this._bindStream(e)}i.inherits(s,n),s.prototype._bindStream=function(t){var e=this;(this._stream=t).pause(),t.on("data",function(t){e.push({data:t,meta:{percent:0}})}).on("error",function(t){e.isPaused?this.generatedError=t:e.error(t)}).on("end",function(){e.isPaused?e._upstreamEnded=!0:e.end()})},s.prototype.pause=function(){return!!n.prototype.pause.call(this)&&(this._stream.pause(),!0)},s.prototype.resume=function(){return!!n.prototype.resume.call(this)&&(this._upstreamEnded?this.end():this._stream.resume(),!0)},e.exports=s},{"../stream/GenericWorker":28,"../utils":32}],13:[function(t,e,r){"use strict";var n=t("readable-stream").Readable;function i(t,e,r){n.call(this,e),this._helper=t;var i=this;t.on("data",function(t,e){i.push(t)||i._helper.pause(),r&&r(e)}).on("error",function(t){i.emit("error",t)}).on("end",function(){i.push(null)})}t("../utils").inherits(i,n),i.prototype._read=function(){this._helper.resume()},e.exports=i},{"../utils":32,"readable-stream":16}],14:[function(t,e,r){"use strict";e.exports={isNode:"undefined"!=typeof Buffer,newBufferFrom:function(t,e){if(Buffer.from&&Buffer.from!==Uint8Array.from)return Buffer.from(t,e);if("number"==typeof t)throw new Error('The "data" argument must not be a number');return new Buffer(t,e)},allocBuffer:function(t){if(Buffer.alloc)return Buffer.alloc(t);var e=new Buffer(t);return e.fill(0),e},isBuffer:function(t){return Buffer.isBuffer(t)},isStream:function(t){return t&&"function"==typeof t.on&&"function"==typeof t.pause&&"function"==typeof t.resume}}},{}],15:[function(t,e,r){"use strict";function s(t,e,r){var i,n=u.getTypeOf(e),s=u.extend(r||{},f);s.date=s.date||new Date,null!==s.compression&&(s.compression=s.compression.toUpperCase()),"string"==typeof s.unixPermissions&&(s.unixPermissions=parseInt(s.unixPermissions,8)),s.unixPermissions&&16384&s.unixPermissions&&(s.dir=!0),s.dosPermissions&&16&s.dosPermissions&&(s.dir=!0),s.dir&&(t=g(t)),s.createFolders&&(i=_(t))&&b.call(this,i,!0);var a="string"===n&&!1===s.binary&&!1===s.base64;r&&void 0!==r.binary||(s.binary=!a),(e instanceof d&&0===e.uncompressedSize||s.dir||!e||0===e.length)&&(s.base64=!1,s.binary=!0,e="",s.compression="STORE",n="string");var o=null;o=e instanceof d||e instanceof l?e:p.isNode&&p.isStream(e)?new m(t,e):u.prepareContent(t,e,s.binary,s.optimizedBinaryString,s.base64);var h=new c(t,o,s);this.files[t]=h}var n=t("./utf8"),u=t("./utils"),l=t("./stream/GenericWorker"),a=t("./stream/StreamHelper"),f=t("./defaults"),d=t("./compressedObject"),c=t("./zipObject"),o=t("./generate"),p=t("./nodejsUtils"),m=t("./nodejs/NodejsStreamInputAdapter"),_=function(t){"/"===t.slice(-1)&&(t=t.substring(0,t.length-1));var e=t.lastIndexOf("/");return 0<e?t.substring(0,e):""},g=function(t){return"/"!==t.slice(-1)&&(t+="/"),t},b=function(t,e){return e=void 0!==e?e:f.createFolders,t=g(t),this.files[t]||s.call(this,t,null,{dir:!0,createFolders:e}),this.files[t]};function h(t){return"[object RegExp]"===Object.prototype.toString.call(t)}var i={load:function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},forEach:function(t){var e,r,i;for(e in this.files)i=this.files[e],(r=e.slice(this.root.length,e.length))&&e.slice(0,this.root.length)===this.root&&t(r,i)},filter:function(r){var i=[];return this.forEach(function(t,e){r(t,e)&&i.push(e)}),i},file:function(t,e,r){if(1!==arguments.length)return t=this.root+t,s.call(this,t,e,r),this;if(h(t)){var i=t;return this.filter(function(t,e){return!e.dir&&i.test(t)})}var n=this.files[this.root+t];return n&&!n.dir?n:null},folder:function(r){if(!r)return this;if(h(r))return this.filter(function(t,e){return e.dir&&r.test(t)});var t=this.root+r,e=b.call(this,t),i=this.clone();return i.root=e.name,i},remove:function(r){r=this.root+r;var t=this.files[r];if(t||("/"!==r.slice(-1)&&(r+="/"),t=this.files[r]),t&&!t.dir)delete this.files[r];else for(var e=this.filter(function(t,e){return e.name.slice(0,r.length)===r}),i=0;i<e.length;i++)delete this.files[e[i].name];return this},generate:function(t){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},generateInternalStream:function(t){var e,r={};try{if((r=u.extend(t||{},{streamFiles:!1,compression:"STORE",compressionOptions:null,type:"",platform:"DOS",comment:null,mimeType:"application/zip",encodeFileName:n.utf8encode})).type=r.type.toLowerCase(),r.compression=r.compression.toUpperCase(),"binarystring"===r.type&&(r.type="string"),!r.type)throw new Error("No output type specified.");u.checkSupport(r.type),"darwin"!==r.platform&&"freebsd"!==r.platform&&"linux"!==r.platform&&"sunos"!==r.platform||(r.platform="UNIX"),"win32"===r.platform&&(r.platform="DOS");var i=r.comment||this.comment||"";e=o.generateWorker(this,r,i)}catch(t){(e=new l("error")).error(t)}return new a(e,r.type||"string",r.mimeType)},generateAsync:function(t,e){return this.generateInternalStream(t).accumulate(e)},generateNodeStream:function(t,e){return(t=t||{}).type||(t.type="nodebuffer"),this.generateInternalStream(t).toNodejsStream(e)}};e.exports=i},{"./compressedObject":2,"./defaults":5,"./generate":9,"./nodejs/NodejsStreamInputAdapter":12,"./nodejsUtils":14,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31,"./utils":32,"./zipObject":35}],16:[function(t,e,r){e.exports=t("stream")},{stream:void 0}],17:[function(t,e,r){"use strict";var i=t("./DataReader");function n(t){i.call(this,t);for(var e=0;e<this.data.length;e++)t[e]=255&t[e]}t("../utils").inherits(n,i),n.prototype.byteAt=function(t){return this.data[this.zero+t]},n.prototype.lastIndexOfSignature=function(t){for(var e=t.charCodeAt(0),r=t.charCodeAt(1),i=t.charCodeAt(2),n=t.charCodeAt(3),s=this.length-4;0<=s;--s)if(this.data[s]===e&&this.data[s+1]===r&&this.data[s+2]===i&&this.data[s+3]===n)return s-this.zero;return-1},n.prototype.readAndCheckSignature=function(t){var e=t.charCodeAt(0),r=t.charCodeAt(1),i=t.charCodeAt(2),n=t.charCodeAt(3),s=this.readData(4);return e===s[0]&&r===s[1]&&i===s[2]&&n===s[3]},n.prototype.readData=function(t){if(this.checkOffset(t),0===t)return[];var e=this.data.slice(this.zero+this.index,this.zero+this.index+t);return this.index+=t,e},e.exports=n},{"../utils":32,"./DataReader":18}],18:[function(t,e,r){"use strict";var i=t("../utils");function n(t){this.data=t,this.length=t.length,this.index=0,this.zero=0}n.prototype={checkOffset:function(t){this.checkIndex(this.index+t)},checkIndex:function(t){if(this.length<this.zero+t||t<0)throw new Error("End of data reached (data length = "+this.length+", asked index = "+t+"). Corrupted zip ?")},setIndex:function(t){this.checkIndex(t),this.index=t},skip:function(t){this.setIndex(this.index+t)},byteAt:function(t){},readInt:function(t){var e,r=0;for(this.checkOffset(t),e=this.index+t-1;e>=this.index;e--)r=(r<<8)+this.byteAt(e);return this.index+=t,r},readString:function(t){return i.transformTo("string",this.readData(t))},readData:function(t){},lastIndexOfSignature:function(t){},readAndCheckSignature:function(t){},readDate:function(){var t=this.readInt(4);return new Date(Date.UTC(1980+(t>>25&127),(t>>21&15)-1,t>>16&31,t>>11&31,t>>5&63,(31&t)<<1))}},e.exports=n},{"../utils":32}],19:[function(t,e,r){"use strict";var i=t("./Uint8ArrayReader");function n(t){i.call(this,t)}t("../utils").inherits(n,i),n.prototype.readData=function(t){this.checkOffset(t);var e=this.data.slice(this.zero+this.index,this.zero+this.index+t);return this.index+=t,e},e.exports=n},{"../utils":32,"./Uint8ArrayReader":21}],20:[function(t,e,r){"use strict";var i=t("./DataReader");function n(t){i.call(this,t)}t("../utils").inherits(n,i),n.prototype.byteAt=function(t){return this.data.charCodeAt(this.zero+t)},n.prototype.lastIndexOfSignature=function(t){return this.data.lastIndexOf(t)-this.zero},n.prototype.readAndCheckSignature=function(t){return t===this.readData(4)},n.prototype.readData=function(t){this.checkOffset(t);var e=this.data.slice(this.zero+this.index,this.zero+this.index+t);return this.index+=t,e},e.exports=n},{"../utils":32,"./DataReader":18}],21:[function(t,e,r){"use strict";var i=t("./ArrayReader");function n(t){i.call(this,t)}t("../utils").inherits(n,i),n.prototype.readData=function(t){if(this.checkOffset(t),0===t)return new Uint8Array(0);var e=this.data.subarray(this.zero+this.index,this.zero+this.index+t);return this.index+=t,e},e.exports=n},{"../utils":32,"./ArrayReader":17}],22:[function(t,e,r){"use strict";var i=t("../utils"),n=t("../support"),s=t("./ArrayReader"),a=t("./StringReader"),o=t("./NodeBufferReader"),h=t("./Uint8ArrayReader");e.exports=function(t){var e=i.getTypeOf(t);return i.checkSupport(e),"string"!==e||n.uint8array?"nodebuffer"===e?new o(t):n.uint8array?new h(i.transformTo("uint8array",t)):new s(i.transformTo("array",t)):new a(t)}},{"../support":30,"../utils":32,"./ArrayReader":17,"./NodeBufferReader":19,"./StringReader":20,"./Uint8ArrayReader":21}],23:[function(t,e,r){"use strict";r.LOCAL_FILE_HEADER="PK",r.CENTRAL_FILE_HEADER="PK",r.CENTRAL_DIRECTORY_END="PK",r.ZIP64_CENTRAL_DIRECTORY_LOCATOR="PK",r.ZIP64_CENTRAL_DIRECTORY_END="PK",r.DATA_DESCRIPTOR="PK\b"},{}],24:[function(t,e,r){"use strict";var i=t("./GenericWorker"),n=t("../utils");function s(t){i.call(this,"ConvertWorker to "+t),this.destType=t}n.inherits(s,i),s.prototype.processChunk=function(t){this.push({data:n.transformTo(this.destType,t.data),meta:t.meta})},e.exports=s},{"../utils":32,"./GenericWorker":28}],25:[function(t,e,r){"use strict";var i=t("./GenericWorker"),n=t("../crc32");function s(){i.call(this,"Crc32Probe"),this.withStreamInfo("crc32",0)}t("../utils").inherits(s,i),s.prototype.processChunk=function(t){this.streamInfo.crc32=n(t.data,this.streamInfo.crc32||0),this.push(t)},e.exports=s},{"../crc32":4,"../utils":32,"./GenericWorker":28}],26:[function(t,e,r){"use strict";var i=t("../utils"),n=t("./GenericWorker");function s(t){n.call(this,"DataLengthProbe for "+t),this.propName=t,this.withStreamInfo(t,0)}i.inherits(s,n),s.prototype.processChunk=function(t){if(t){var e=this.streamInfo[this.propName]||0;this.streamInfo[this.propName]=e+t.data.length}n.prototype.processChunk.call(this,t)},e.exports=s},{"../utils":32,"./GenericWorker":28}],27:[function(t,e,r){"use strict";var i=t("../utils"),n=t("./GenericWorker");function s(t){n.call(this,"DataWorker");var e=this;this.dataIsReady=!1,this.index=0,this.max=0,this.data=null,this.type="",this._tickScheduled=!1,t.then(function(t){e.dataIsReady=!0,e.data=t,e.max=t&&t.length||0,e.type=i.getTypeOf(t),e.isPaused||e._tickAndRepeat()},function(t){e.error(t)})}i.inherits(s,n),s.prototype.cleanUp=function(){n.prototype.cleanUp.call(this),this.data=null},s.prototype.resume=function(){return!!n.prototype.resume.call(this)&&(!this._tickScheduled&&this.dataIsReady&&(this._tickScheduled=!0,i.delay(this._tickAndRepeat,[],this)),!0)},s.prototype._tickAndRepeat=function(){this._tickScheduled=!1,this.isPaused||this.isFinished||(this._tick(),this.isFinished||(i.delay(this._tickAndRepeat,[],this),this._tickScheduled=!0))},s.prototype._tick=function(){if(this.isPaused||this.isFinished)return!1;var t=null,e=Math.min(this.max,this.index+16384);if(this.index>=this.max)return this.end();switch(this.type){case"string":t=this.data.substring(this.index,e);break;case"uint8array":t=this.data.subarray(this.index,e);break;case"array":case"nodebuffer":t=this.data.slice(this.index,e)}return this.index=e,this.push({data:t,meta:{percent:this.max?this.index/this.max*100:0}})},e.exports=s},{"../utils":32,"./GenericWorker":28}],28:[function(t,e,r){"use strict";function i(t){this.name=t||"default",this.streamInfo={},this.generatedError=null,this.extraStreamInfo={},this.isPaused=!0,this.isFinished=!1,this.isLocked=!1,this._listeners={data:[],end:[],error:[]},this.previous=null}i.prototype={push:function(t){this.emit("data",t)},end:function(){if(this.isFinished)return!1;this.flush();try{this.emit("end"),this.cleanUp(),this.isFinished=!0}catch(t){this.emit("error",t)}return!0},error:function(t){return!this.isFinished&&(this.isPaused?this.generatedError=t:(this.isFinished=!0,this.emit("error",t),this.previous&&this.previous.error(t),this.cleanUp()),!0)},on:function(t,e){return this._listeners[t].push(e),this},cleanUp:function(){this.streamInfo=this.generatedError=this.extraStreamInfo=null,this._listeners=[]},emit:function(t,e){if(this._listeners[t])for(var r=0;r<this._listeners[t].length;r++)this._listeners[t][r].call(this,e)},pipe:function(t){return t.registerPrevious(this)},registerPrevious:function(t){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.streamInfo=t.streamInfo,this.mergeStreamInfo(),this.previous=t;var e=this;return t.on("data",function(t){e.processChunk(t)}),t.on("end",function(){e.end()}),t.on("error",function(t){e.error(t)}),this},pause:function(){return!this.isPaused&&!this.isFinished&&(this.isPaused=!0,this.previous&&this.previous.pause(),!0)},resume:function(){if(!this.isPaused||this.isFinished)return!1;var t=this.isPaused=!1;return this.generatedError&&(this.error(this.generatedError),t=!0),this.previous&&this.previous.resume(),!t},flush:function(){},processChunk:function(t){this.push(t)},withStreamInfo:function(t,e){return this.extraStreamInfo[t]=e,this.mergeStreamInfo(),this},mergeStreamInfo:function(){for(var t in this.extraStreamInfo)this.extraStreamInfo.hasOwnProperty(t)&&(this.streamInfo[t]=this.extraStreamInfo[t])},lock:function(){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.isLocked=!0,this.previous&&this.previous.lock()},toString:function(){var t="Worker "+this.name;return this.previous?this.previous+" -> "+t:t}},e.exports=i},{}],29:[function(t,e,r){"use strict";var h=t("../utils"),n=t("./ConvertWorker"),s=t("./GenericWorker"),u=t("../base64"),i=t("../support"),a=t("../external"),o=null;if(i.nodestream)try{o=t("../nodejs/NodejsStreamOutputAdapter")}catch(t){}function l(t,o){return new a.Promise(function(e,r){var i=[],n=t._internalType,s=t._outputType,a=t._mimeType;t.on("data",function(t,e){i.push(t),o&&o(e)}).on("error",function(t){i=[],r(t)}).on("end",function(){try{var t=function(t,e,r){switch(t){case"blob":return h.newBlob(h.transformTo("arraybuffer",e),r);case"base64":return u.encode(e);default:return h.transformTo(t,e)}}(s,function(t,e){var r,i=0,n=null,s=0;for(r=0;r<e.length;r++)s+=e[r].length;switch(t){case"string":return e.join("");case"array":return Array.prototype.concat.apply([],e);case"uint8array":for(n=new Uint8Array(s),r=0;r<e.length;r++)n.set(e[r],i),i+=e[r].length;return n;case"nodebuffer":return Buffer.concat(e);default:throw new Error("concat : unsupported type '"+t+"'")}}(n,i),a);e(t)}catch(t){r(t)}i=[]}).resume()})}function f(t,e,r){var i=e;switch(e){case"blob":case"arraybuffer":i="uint8array";break;case"base64":i="string"}try{this._internalType=i,this._outputType=e,this._mimeType=r,h.checkSupport(i),this._worker=t.pipe(new n(i)),t.lock()}catch(t){this._worker=new s("error"),this._worker.error(t)}}f.prototype={accumulate:function(t){return l(this,t)},on:function(t,e){var r=this;return"data"===t?this._worker.on(t,function(t){e.call(r,t.data,t.meta)}):this._worker.on(t,function(){h.delay(e,arguments,r)}),this},resume:function(){return h.delay(this._worker.resume,[],this._worker),this},pause:function(){return this._worker.pause(),this},toNodejsStream:function(t){if(h.checkSupport("nodestream"),"nodebuffer"!==this._outputType)throw new Error(this._outputType+" is not supported by this method");return new o(this,{objectMode:"nodebuffer"!==this._outputType},t)}},e.exports=f},{"../base64":1,"../external":6,"../nodejs/NodejsStreamOutputAdapter":13,"../support":30,"../utils":32,"./ConvertWorker":24,"./GenericWorker":28}],30:[function(t,e,r){"use strict";if(r.base64=!0,r.array=!0,r.string=!0,r.arraybuffer="undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array,r.nodebuffer="undefined"!=typeof Buffer,r.uint8array="undefined"!=typeof Uint8Array,"undefined"==typeof ArrayBuffer)r.blob=!1;else{var i=new ArrayBuffer(0);try{r.blob=0===new Blob([i],{type:"application/zip"}).size}catch(t){try{var n=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);n.append(i),r.blob=0===n.getBlob("application/zip").size}catch(t){r.blob=!1}}}try{r.nodestream=!!t("readable-stream").Readable}catch(t){r.nodestream=!1}},{"readable-stream":16}],31:[function(t,e,s){"use strict";for(var o=t("./utils"),h=t("./support"),r=t("./nodejsUtils"),i=t("./stream/GenericWorker"),u=new Array(256),n=0;n<256;n++)u[n]=252<=n?6:248<=n?5:240<=n?4:224<=n?3:192<=n?2:1;u[254]=u[254]=1;function a(){i.call(this,"utf-8 decode"),this.leftOver=null}function l(){i.call(this,"utf-8 encode")}s.utf8encode=function(t){return h.nodebuffer?r.newBufferFrom(t,"utf-8"):function(t){var e,r,i,n,s,a=t.length,o=0;for(n=0;n<a;n++)55296==(64512&(r=t.charCodeAt(n)))&&n+1<a&&56320==(64512&(i=t.charCodeAt(n+1)))&&(r=65536+(r-55296<<10)+(i-56320),n++),o+=r<128?1:r<2048?2:r<65536?3:4;for(e=h.uint8array?new Uint8Array(o):new Array(o),n=s=0;s<o;n++)55296==(64512&(r=t.charCodeAt(n)))&&n+1<a&&56320==(64512&(i=t.charCodeAt(n+1)))&&(r=65536+(r-55296<<10)+(i-56320),n++),r<128?e[s++]=r:(r<2048?e[s++]=192|r>>>6:(r<65536?e[s++]=224|r>>>12:(e[s++]=240|r>>>18,e[s++]=128|r>>>12&63),e[s++]=128|r>>>6&63),e[s++]=128|63&r);return e}(t)},s.utf8decode=function(t){return h.nodebuffer?o.transformTo("nodebuffer",t).toString("utf-8"):function(t){var e,r,i,n,s=t.length,a=new Array(2*s);for(e=r=0;e<s;)if((i=t[e++])<128)a[r++]=i;else if(4<(n=u[i]))a[r++]=65533,e+=n-1;else{for(i&=2===n?31:3===n?15:7;1<n&&e<s;)i=i<<6|63&t[e++],n--;1<n?a[r++]=65533:i<65536?a[r++]=i:(i-=65536,a[r++]=55296|i>>10&1023,a[r++]=56320|1023&i)}return a.length!==r&&(a.subarray?a=a.subarray(0,r):a.length=r),o.applyFromCharCode(a)}(t=o.transformTo(h.uint8array?"uint8array":"array",t))},o.inherits(a,i),a.prototype.processChunk=function(t){var e=o.transformTo(h.uint8array?"uint8array":"array",t.data);if(this.leftOver&&this.leftOver.length){if(h.uint8array){var r=e;(e=new Uint8Array(r.length+this.leftOver.length)).set(this.leftOver,0),e.set(r,this.leftOver.length)}else e=this.leftOver.concat(e);this.leftOver=null}var i=function(t,e){var r;for((e=e||t.length)>t.length&&(e=t.length),r=e-1;0<=r&&128==(192&t[r]);)r--;return r<0?e:0===r?e:r+u[t[r]]>e?r:e}(e),n=e;i!==e.length&&(h.uint8array?(n=e.subarray(0,i),this.leftOver=e.subarray(i,e.length)):(n=e.slice(0,i),this.leftOver=e.slice(i,e.length))),this.push({data:s.utf8decode(n),meta:t.meta})},a.prototype.flush=function(){this.leftOver&&this.leftOver.length&&(this.push({data:s.utf8decode(this.leftOver),meta:{}}),this.leftOver=null)},s.Utf8DecodeWorker=a,o.inherits(l,i),l.prototype.processChunk=function(t){this.push({data:s.utf8encode(t.data),meta:t.meta})},s.Utf8EncodeWorker=l},{"./nodejsUtils":14,"./stream/GenericWorker":28,"./support":30,"./utils":32}],32:[function(t,e,a){"use strict";var o=t("./support"),h=t("./base64"),r=t("./nodejsUtils"),i=t("set-immediate-shim"),u=t("./external");function n(t){return t}function l(t,e){for(var r=0;r<t.length;++r)e[r]=255&t.charCodeAt(r);return e}a.newBlob=function(e,r){a.checkSupport("blob");try{return new Blob([e],{type:r})}catch(t){try{var i=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);return i.append(e),i.getBlob(r)}catch(t){throw new Error("Bug : can't construct the Blob.")}}};var s={stringifyByChunk:function(t,e,r){var i=[],n=0,s=t.length;if(s<=r)return String.fromCharCode.apply(null,t);for(;n<s;)"array"===e||"nodebuffer"===e?i.push(String.fromCharCode.apply(null,t.slice(n,Math.min(n+r,s)))):i.push(String.fromCharCode.apply(null,t.subarray(n,Math.min(n+r,s)))),n+=r;return i.join("")},stringifyByChar:function(t){for(var e="",r=0;r<t.length;r++)e+=String.fromCharCode(t[r]);return e},applyCanBeUsed:{uint8array:function(){try{return o.uint8array&&1===String.fromCharCode.apply(null,new Uint8Array(1)).length}catch(t){return!1}}(),nodebuffer:function(){try{return o.nodebuffer&&1===String.fromCharCode.apply(null,r.allocBuffer(1)).length}catch(t){return!1}}()}};function f(t){var e=65536,r=a.getTypeOf(t),i=!0;if("uint8array"===r?i=s.applyCanBeUsed.uint8array:"nodebuffer"===r&&(i=s.applyCanBeUsed.nodebuffer),i)for(;1<e;)try{return s.stringifyByChunk(t,r,e)}catch(t){e=Math.floor(e/2)}return s.stringifyByChar(t)}function d(t,e){for(var r=0;r<t.length;r++)e[r]=t[r];return e}a.applyFromCharCode=f;var c={};c.string={string:n,array:function(t){return l(t,new Array(t.length))},arraybuffer:function(t){return c.string.uint8array(t).buffer},uint8array:function(t){return l(t,new Uint8Array(t.length))},nodebuffer:function(t){return l(t,r.allocBuffer(t.length))}},c.array={string:f,array:n,arraybuffer:function(t){return new Uint8Array(t).buffer},uint8array:function(t){return new Uint8Array(t)},nodebuffer:function(t){return r.newBufferFrom(t)}},c.arraybuffer={string:function(t){return f(new Uint8Array(t))},array:function(t){return d(new Uint8Array(t),new Array(t.byteLength))},arraybuffer:n,uint8array:function(t){return new Uint8Array(t)},nodebuffer:function(t){return r.newBufferFrom(new Uint8Array(t))}},c.uint8array={string:f,array:function(t){return d(t,new Array(t.length))},arraybuffer:function(t){return t.buffer},uint8array:n,nodebuffer:function(t){return r.newBufferFrom(t)}},c.nodebuffer={string:f,array:function(t){return d(t,new Array(t.length))},arraybuffer:function(t){return c.nodebuffer.uint8array(t).buffer},uint8array:function(t){return d(t,new Uint8Array(t.length))},nodebuffer:n},a.transformTo=function(t,e){if(e=e||"",!t)return e;a.checkSupport(t);var r=a.getTypeOf(e);return c[r][t](e)},a.getTypeOf=function(t){return"string"==typeof t?"string":"[object Array]"===Object.prototype.toString.call(t)?"array":o.nodebuffer&&r.isBuffer(t)?"nodebuffer":o.uint8array&&t instanceof Uint8Array?"uint8array":o.arraybuffer&&t instanceof ArrayBuffer?"arraybuffer":void 0},a.checkSupport=function(t){if(!o[t.toLowerCase()])throw new Error(t+" is not supported by this platform")},a.MAX_VALUE_16BITS=65535,a.MAX_VALUE_32BITS=-1,a.pretty=function(t){var e,r,i="";for(r=0;r<(t||"").length;r++)i+="\\x"+((e=t.charCodeAt(r))<16?"0":"")+e.toString(16).toUpperCase();return i},a.delay=function(t,e,r){i(function(){t.apply(r||null,e||[])})},a.inherits=function(t,e){function r(){}r.prototype=e.prototype,t.prototype=new r},a.extend=function(){var t,e,r={};for(t=0;t<arguments.length;t++)for(e in arguments[t])arguments[t].hasOwnProperty(e)&&void 0===r[e]&&(r[e]=arguments[t][e]);return r},a.prepareContent=function(r,t,i,n,s){return u.Promise.resolve(t).then(function(i){return o.blob&&(i instanceof Blob||-1!==["[object File]","[object Blob]"].indexOf(Object.prototype.toString.call(i)))&&"undefined"!=typeof FileReader?new u.Promise(function(e,r){var t=new FileReader;t.onload=function(t){e(t.target.result)},t.onerror=function(t){r(t.target.error)},t.readAsArrayBuffer(i)}):i}).then(function(t){var e=a.getTypeOf(t);return e?("arraybuffer"===e?t=a.transformTo("uint8array",t):"string"===e&&(s?t=h.decode(t):i&&!0!==n&&(t=function(t){return l(t,o.uint8array?new Uint8Array(t.length):new Array(t.length))}(t))),t):u.Promise.reject(new Error("Can't read the data of '"+r+"'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"))})}},{"./base64":1,"./external":6,"./nodejsUtils":14,"./support":30,"set-immediate-shim":54}],33:[function(t,e,r){"use strict";var i=t("./reader/readerFor"),n=t("./utils"),s=t("./signature"),a=t("./zipEntry"),o=(t("./utf8"),t("./support"));function h(t){this.files=[],this.loadOptions=t}h.prototype={checkSignature:function(t){if(!this.reader.readAndCheckSignature(t)){this.reader.index-=4;var e=this.reader.readString(4);throw new Error("Corrupted zip or bug: unexpected signature ("+n.pretty(e)+", expected "+n.pretty(t)+")")}},isSignature:function(t,e){var r=this.reader.index;this.reader.setIndex(t);var i=this.reader.readString(4)===e;return this.reader.setIndex(r),i},readBlockEndOfCentral:function(){this.diskNumber=this.reader.readInt(2),this.diskWithCentralDirStart=this.reader.readInt(2),this.centralDirRecordsOnThisDisk=this.reader.readInt(2),this.centralDirRecords=this.reader.readInt(2),this.centralDirSize=this.reader.readInt(4),this.centralDirOffset=this.reader.readInt(4),this.zipCommentLength=this.reader.readInt(2);var t=this.reader.readData(this.zipCommentLength),e=o.uint8array?"uint8array":"array",r=n.transformTo(e,t);this.zipComment=this.loadOptions.decodeFileName(r)},readBlockZip64EndOfCentral:function(){this.zip64EndOfCentralSize=this.reader.readInt(8),this.reader.skip(4),this.diskNumber=this.reader.readInt(4),this.diskWithCentralDirStart=this.reader.readInt(4),this.centralDirRecordsOnThisDisk=this.reader.readInt(8),this.centralDirRecords=this.reader.readInt(8),this.centralDirSize=this.reader.readInt(8),this.centralDirOffset=this.reader.readInt(8),this.zip64ExtensibleData={};for(var t,e,r,i=this.zip64EndOfCentralSize-44;0<i;)t=this.reader.readInt(2),e=this.reader.readInt(4),r=this.reader.readData(e),this.zip64ExtensibleData[t]={id:t,length:e,value:r}},readBlockZip64EndOfCentralLocator:function(){if(this.diskWithZip64CentralDirStart=this.reader.readInt(4),this.relativeOffsetEndOfZip64CentralDir=this.reader.readInt(8),this.disksCount=this.reader.readInt(4),1<this.disksCount)throw new Error("Multi-volumes zip are not supported")},readLocalFiles:function(){var t,e;for(t=0;t<this.files.length;t++)e=this.files[t],this.reader.setIndex(e.localHeaderOffset),this.checkSignature(s.LOCAL_FILE_HEADER),e.readLocalPart(this.reader),e.handleUTF8(),e.processAttributes()},readCentralDir:function(){var t;for(this.reader.setIndex(this.centralDirOffset);this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(t=new a({zip64:this.zip64},this.loadOptions)).readCentralPart(this.reader),this.files.push(t);if(this.centralDirRecords!==this.files.length&&0!==this.centralDirRecords&&0===this.files.length)throw new Error("Corrupted zip or bug: expected "+this.centralDirRecords+" records in central dir, got "+this.files.length)},readEndOfCentral:function(){var t=this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);if(t<0)throw!this.isSignature(0,s.LOCAL_FILE_HEADER)?new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html"):new Error("Corrupted zip: can't find end of central directory");this.reader.setIndex(t);var e=t;if(this.checkSignature(s.CENTRAL_DIRECTORY_END),this.readBlockEndOfCentral(),this.diskNumber===n.MAX_VALUE_16BITS||this.diskWithCentralDirStart===n.MAX_VALUE_16BITS||this.centralDirRecordsOnThisDisk===n.MAX_VALUE_16BITS||this.centralDirRecords===n.MAX_VALUE_16BITS||this.centralDirSize===n.MAX_VALUE_32BITS||this.centralDirOffset===n.MAX_VALUE_32BITS){if(this.zip64=!0,(t=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR))<0)throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");if(this.reader.setIndex(t),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR),this.readBlockZip64EndOfCentralLocator(),!this.isSignature(this.relativeOffsetEndOfZip64CentralDir,s.ZIP64_CENTRAL_DIRECTORY_END)&&(this.relativeOffsetEndOfZip64CentralDir=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.relativeOffsetEndOfZip64CentralDir<0))throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.readBlockZip64EndOfCentral()}var r=this.centralDirOffset+this.centralDirSize;this.zip64&&(r+=20,r+=12+this.zip64EndOfCentralSize);var i=e-r;if(0<i)this.isSignature(e,s.CENTRAL_FILE_HEADER)||(this.reader.zero=i);else if(i<0)throw new Error("Corrupted zip: missing "+Math.abs(i)+" bytes.")},prepareReader:function(t){this.reader=i(t)},load:function(t){this.prepareReader(t),this.readEndOfCentral(),this.readCentralDir(),this.readLocalFiles()}},e.exports=h},{"./reader/readerFor":22,"./signature":23,"./support":30,"./utf8":31,"./utils":32,"./zipEntry":34}],34:[function(t,e,r){"use strict";var i=t("./reader/readerFor"),s=t("./utils"),n=t("./compressedObject"),a=t("./crc32"),o=t("./utf8"),h=t("./compressions"),u=t("./support");function l(t,e){this.options=t,this.loadOptions=e}l.prototype={isEncrypted:function(){return 1==(1&this.bitFlag)},useUTF8:function(){return 2048==(2048&this.bitFlag)},readLocalPart:function(t){var e,r;if(t.skip(22),this.fileNameLength=t.readInt(2),r=t.readInt(2),this.fileName=t.readData(this.fileNameLength),t.skip(r),-1===this.compressedSize||-1===this.uncompressedSize)throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");if(null===(e=function(t){for(var e in h)if(h.hasOwnProperty(e)&&h[e].magic===t)return h[e];return null}(this.compressionMethod)))throw new Error("Corrupted zip : compression "+s.pretty(this.compressionMethod)+" unknown (inner file : "+s.transformTo("string",this.fileName)+")");this.decompressed=new n(this.compressedSize,this.uncompressedSize,this.crc32,e,t.readData(this.compressedSize))},readCentralPart:function(t){this.versionMadeBy=t.readInt(2),t.skip(2),this.bitFlag=t.readInt(2),this.compressionMethod=t.readString(2),this.date=t.readDate(),this.crc32=t.readInt(4),this.compressedSize=t.readInt(4),this.uncompressedSize=t.readInt(4);var e=t.readInt(2);if(this.extraFieldsLength=t.readInt(2),this.fileCommentLength=t.readInt(2),this.diskNumberStart=t.readInt(2),this.internalFileAttributes=t.readInt(2),this.externalFileAttributes=t.readInt(4),this.localHeaderOffset=t.readInt(4),this.isEncrypted())throw new Error("Encrypted zip are not supported");t.skip(e),this.readExtraFields(t),this.parseZIP64ExtraField(t),this.fileComment=t.readData(this.fileCommentLength)},processAttributes:function(){this.unixPermissions=null,this.dosPermissions=null;var t=this.versionMadeBy>>8;this.dir=!!(16&this.externalFileAttributes),0==t&&(this.dosPermissions=63&this.externalFileAttributes),3==t&&(this.unixPermissions=this.externalFileAttributes>>16&65535),this.dir||"/"!==this.fileNameStr.slice(-1)||(this.dir=!0)},parseZIP64ExtraField:function(t){if(this.extraFields[1]){var e=i(this.extraFields[1].value);this.uncompressedSize===s.MAX_VALUE_32BITS&&(this.uncompressedSize=e.readInt(8)),this.compressedSize===s.MAX_VALUE_32BITS&&(this.compressedSize=e.readInt(8)),this.localHeaderOffset===s.MAX_VALUE_32BITS&&(this.localHeaderOffset=e.readInt(8)),this.diskNumberStart===s.MAX_VALUE_32BITS&&(this.diskNumberStart=e.readInt(4))}},readExtraFields:function(t){var e,r,i,n=t.index+this.extraFieldsLength;for(this.extraFields||(this.extraFields={});t.index+4<n;)e=t.readInt(2),r=t.readInt(2),i=t.readData(r),this.extraFields[e]={id:e,length:r,value:i};t.setIndex(n)},handleUTF8:function(){var t=u.uint8array?"uint8array":"array";if(this.useUTF8())this.fileNameStr=o.utf8decode(this.fileName),this.fileCommentStr=o.utf8decode(this.fileComment);else{var e=this.findExtraFieldUnicodePath();if(null!==e)this.fileNameStr=e;else{var r=s.transformTo(t,this.fileName);this.fileNameStr=this.loadOptions.decodeFileName(r)}var i=this.findExtraFieldUnicodeComment();if(null!==i)this.fileCommentStr=i;else{var n=s.transformTo(t,this.fileComment);this.fileCommentStr=this.loadOptions.decodeFileName(n)}}},findExtraFieldUnicodePath:function(){var t=this.extraFields[28789];if(t){var e=i(t.value);return 1!==e.readInt(1)?null:a(this.fileName)!==e.readInt(4)?null:o.utf8decode(e.readData(t.length-5))}return null},findExtraFieldUnicodeComment:function(){var t=this.extraFields[25461];if(t){var e=i(t.value);return 1!==e.readInt(1)?null:a(this.fileComment)!==e.readInt(4)?null:o.utf8decode(e.readData(t.length-5))}return null}},e.exports=l},{"./compressedObject":2,"./compressions":3,"./crc32":4,"./reader/readerFor":22,"./support":30,"./utf8":31,"./utils":32}],35:[function(t,e,r){"use strict";function i(t,e,r){this.name=t,this.dir=r.dir,this.date=r.date,this.comment=r.comment,this.unixPermissions=r.unixPermissions,this.dosPermissions=r.dosPermissions,this._data=e,this._dataBinary=r.binary,this.options={compression:r.compression,compressionOptions:r.compressionOptions}}var s=t("./stream/StreamHelper"),n=t("./stream/DataWorker"),a=t("./utf8"),o=t("./compressedObject"),h=t("./stream/GenericWorker");i.prototype={internalStream:function(t){var e=null,r="string";try{if(!t)throw new Error("No output type specified.");var i="string"===(r=t.toLowerCase())||"text"===r;"binarystring"!==r&&"text"!==r||(r="string"),e=this._decompressWorker();var n=!this._dataBinary;n&&!i&&(e=e.pipe(new a.Utf8EncodeWorker)),!n&&i&&(e=e.pipe(new a.Utf8DecodeWorker))}catch(t){(e=new h("error")).error(t)}return new s(e,r,"")},async:function(t,e){return this.internalStream(t).accumulate(e)},nodeStream:function(t,e){return this.internalStream(t||"nodebuffer").toNodejsStream(e)},_compressWorker:function(t,e){if(this._data instanceof o&&this._data.compression.magic===t.magic)return this._data.getCompressedWorker();var r=this._decompressWorker();return this._dataBinary||(r=r.pipe(new a.Utf8EncodeWorker)),o.createWorkerFrom(r,t,e)},_decompressWorker:function(){return this._data instanceof o?this._data.getContentWorker():this._data instanceof h?this._data:new n(this._data)}};for(var u=["asText","asBinary","asNodeBuffer","asUint8Array","asArrayBuffer"],l=function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},f=0;f<u.length;f++)i.prototype[u[f]]=l;e.exports=i},{"./compressedObject":2,"./stream/DataWorker":27,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31}],36:[function(t,l,e){(function(e){"use strict";var r,i,t=e.MutationObserver||e.WebKitMutationObserver;if(t){var n=0,s=new t(u),a=e.document.createTextNode("");s.observe(a,{characterData:!0}),r=function(){a.data=n=++n%2}}else if(e.setImmediate||void 0===e.MessageChannel)r="document"in e&&"onreadystatechange"in e.document.createElement("script")?function(){var t=e.document.createElement("script");t.onreadystatechange=function(){u(),t.onreadystatechange=null,t.parentNode.removeChild(t),t=null},e.document.documentElement.appendChild(t)}:function(){setTimeout(u,0)};else{var o=new e.MessageChannel;o.port1.onmessage=u,r=function(){o.port2.postMessage(0)}}var h=[];function u(){var t,e;i=!0;for(var r=h.length;r;){for(e=h,h=[],t=-1;++t<r;)e[t]();r=h.length}i=!1}l.exports=function(t){1!==h.push(t)||i||r()}}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],37:[function(t,e,r){"use strict";var n=t("immediate");function u(){}var l={},s=["REJECTED"],a=["FULFILLED"],i=["PENDING"];function o(t){if("function"!=typeof t)throw new TypeError("resolver must be a function");this.state=i,this.queue=[],this.outcome=void 0,t!==u&&c(this,t)}function h(t,e,r){this.promise=t,"function"==typeof e&&(this.onFulfilled=e,this.callFulfilled=this.otherCallFulfilled),"function"==typeof r&&(this.onRejected=r,this.callRejected=this.otherCallRejected)}function f(e,r,i){n(function(){var t;try{t=r(i)}catch(t){return l.reject(e,t)}t===e?l.reject(e,new TypeError("Cannot resolve promise with itself")):l.resolve(e,t)})}function d(t){var e=t&&t.then;if(t&&("object"==typeof t||"function"==typeof t)&&"function"==typeof e)return function(){e.apply(t,arguments)}}function c(e,t){var r=!1;function i(t){r||(r=!0,l.reject(e,t))}function n(t){r||(r=!0,l.resolve(e,t))}var s=p(function(){t(n,i)});"error"===s.status&&i(s.value)}function p(t,e){var r={};try{r.value=t(e),r.status="success"}catch(t){r.status="error",r.value=t}return r}(e.exports=o).prototype.finally=function(e){if("function"!=typeof e)return this;var r=this.constructor;return this.then(function(t){return r.resolve(e()).then(function(){return t})},function(t){return r.resolve(e()).then(function(){throw t})})},o.prototype.catch=function(t){return this.then(null,t)},o.prototype.then=function(t,e){if("function"!=typeof t&&this.state===a||"function"!=typeof e&&this.state===s)return this;var r=new this.constructor(u);this.state!==i?f(r,this.state===a?t:e,this.outcome):this.queue.push(new h(r,t,e));return r},h.prototype.callFulfilled=function(t){l.resolve(this.promise,t)},h.prototype.otherCallFulfilled=function(t){f(this.promise,this.onFulfilled,t)},h.prototype.callRejected=function(t){l.reject(this.promise,t)},h.prototype.otherCallRejected=function(t){f(this.promise,this.onRejected,t)},l.resolve=function(t,e){var r=p(d,e);if("error"===r.status)return l.reject(t,r.value);var i=r.value;if(i)c(t,i);else{t.state=a,t.outcome=e;for(var n=-1,s=t.queue.length;++n<s;)t.queue[n].callFulfilled(e)}return t},l.reject=function(t,e){t.state=s,t.outcome=e;for(var r=-1,i=t.queue.length;++r<i;)t.queue[r].callRejected(e);return t},o.resolve=function(t){if(t instanceof this)return t;return l.resolve(new this(u),t)},o.reject=function(t){var e=new this(u);return l.reject(e,t)},o.all=function(t){var r=this;if("[object Array]"!==Object.prototype.toString.call(t))return this.reject(new TypeError("must be an array"));var i=t.length,n=!1;if(!i)return this.resolve([]);var s=new Array(i),a=0,e=-1,o=new this(u);for(;++e<i;)h(t[e],e);return o;function h(t,e){r.resolve(t).then(function(t){s[e]=t,++a!==i||n||(n=!0,l.resolve(o,s))},function(t){n||(n=!0,l.reject(o,t))})}},o.race=function(t){var e=this;if("[object Array]"!==Object.prototype.toString.call(t))return this.reject(new TypeError("must be an array"));var r=t.length,i=!1;if(!r)return this.resolve([]);var n=-1,s=new this(u);for(;++n<r;)a=t[n],e.resolve(a).then(function(t){i||(i=!0,l.resolve(s,t))},function(t){i||(i=!0,l.reject(s,t))});var a;return s}},{immediate:36}],38:[function(t,e,r){"use strict";var i={};(0,t("./lib/utils/common").assign)(i,t("./lib/deflate"),t("./lib/inflate"),t("./lib/zlib/constants")),e.exports=i},{"./lib/deflate":39,"./lib/inflate":40,"./lib/utils/common":41,"./lib/zlib/constants":44}],39:[function(t,e,r){"use strict";var a=t("./zlib/deflate"),o=t("./utils/common"),h=t("./utils/strings"),n=t("./zlib/messages"),s=t("./zlib/zstream"),u=Object.prototype.toString,l=0,f=-1,d=0,c=8;function p(t){if(!(this instanceof p))return new p(t);this.options=o.assign({level:f,method:c,chunkSize:16384,windowBits:15,memLevel:8,strategy:d,to:""},t||{});var e=this.options;e.raw&&0<e.windowBits?e.windowBits=-e.windowBits:e.gzip&&0<e.windowBits&&e.windowBits<16&&(e.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new s,this.strm.avail_out=0;var r=a.deflateInit2(this.strm,e.level,e.method,e.windowBits,e.memLevel,e.strategy);if(r!==l)throw new Error(n[r]);if(e.header&&a.deflateSetHeader(this.strm,e.header),e.dictionary){var i;if(i="string"==typeof e.dictionary?h.string2buf(e.dictionary):"[object ArrayBuffer]"===u.call(e.dictionary)?new Uint8Array(e.dictionary):e.dictionary,(r=a.deflateSetDictionary(this.strm,i))!==l)throw new Error(n[r]);this._dict_set=!0}}function i(t,e){var r=new p(e);if(r.push(t,!0),r.err)throw r.msg||n[r.err];return r.result}p.prototype.push=function(t,e){var r,i,n=this.strm,s=this.options.chunkSize;if(this.ended)return!1;i=e===~~e?e:!0===e?4:0,"string"==typeof t?n.input=h.string2buf(t):"[object ArrayBuffer]"===u.call(t)?n.input=new Uint8Array(t):n.input=t,n.next_in=0,n.avail_in=n.input.length;do{if(0===n.avail_out&&(n.output=new o.Buf8(s),n.next_out=0,n.avail_out=s),1!==(r=a.deflate(n,i))&&r!==l)return this.onEnd(r),!(this.ended=!0);0!==n.avail_out&&(0!==n.avail_in||4!==i&&2!==i)||("string"===this.options.to?this.onData(h.buf2binstring(o.shrinkBuf(n.output,n.next_out))):this.onData(o.shrinkBuf(n.output,n.next_out)))}while((0<n.avail_in||0===n.avail_out)&&1!==r);return 4===i?(r=a.deflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===l):2!==i||(this.onEnd(l),!(n.avail_out=0))},p.prototype.onData=function(t){this.chunks.push(t)},p.prototype.onEnd=function(t){t===l&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=o.flattenChunks(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},r.Deflate=p,r.deflate=i,r.deflateRaw=function(t,e){return(e=e||{}).raw=!0,i(t,e)},r.gzip=function(t,e){return(e=e||{}).gzip=!0,i(t,e)}},{"./utils/common":41,"./utils/strings":42,"./zlib/deflate":46,"./zlib/messages":51,"./zlib/zstream":53}],40:[function(t,e,r){"use strict";var d=t("./zlib/inflate"),c=t("./utils/common"),p=t("./utils/strings"),m=t("./zlib/constants"),i=t("./zlib/messages"),n=t("./zlib/zstream"),s=t("./zlib/gzheader"),_=Object.prototype.toString;function a(t){if(!(this instanceof a))return new a(t);this.options=c.assign({chunkSize:16384,windowBits:0,to:""},t||{});var e=this.options;e.raw&&0<=e.windowBits&&e.windowBits<16&&(e.windowBits=-e.windowBits,0===e.windowBits&&(e.windowBits=-15)),!(0<=e.windowBits&&e.windowBits<16)||t&&t.windowBits||(e.windowBits+=32),15<e.windowBits&&e.windowBits<48&&0==(15&e.windowBits)&&(e.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new n,this.strm.avail_out=0;var r=d.inflateInit2(this.strm,e.windowBits);if(r!==m.Z_OK)throw new Error(i[r]);this.header=new s,d.inflateGetHeader(this.strm,this.header)}function o(t,e){var r=new a(e);if(r.push(t,!0),r.err)throw r.msg||i[r.err];return r.result}a.prototype.push=function(t,e){var r,i,n,s,a,o,h=this.strm,u=this.options.chunkSize,l=this.options.dictionary,f=!1;if(this.ended)return!1;i=e===~~e?e:!0===e?m.Z_FINISH:m.Z_NO_FLUSH,"string"==typeof t?h.input=p.binstring2buf(t):"[object ArrayBuffer]"===_.call(t)?h.input=new Uint8Array(t):h.input=t,h.next_in=0,h.avail_in=h.input.length;do{if(0===h.avail_out&&(h.output=new c.Buf8(u),h.next_out=0,h.avail_out=u),(r=d.inflate(h,m.Z_NO_FLUSH))===m.Z_NEED_DICT&&l&&(o="string"==typeof l?p.string2buf(l):"[object ArrayBuffer]"===_.call(l)?new Uint8Array(l):l,r=d.inflateSetDictionary(this.strm,o)),r===m.Z_BUF_ERROR&&!0===f&&(r=m.Z_OK,f=!1),r!==m.Z_STREAM_END&&r!==m.Z_OK)return this.onEnd(r),!(this.ended=!0);h.next_out&&(0!==h.avail_out&&r!==m.Z_STREAM_END&&(0!==h.avail_in||i!==m.Z_FINISH&&i!==m.Z_SYNC_FLUSH)||("string"===this.options.to?(n=p.utf8border(h.output,h.next_out),s=h.next_out-n,a=p.buf2string(h.output,n),h.next_out=s,h.avail_out=u-s,s&&c.arraySet(h.output,h.output,n,s,0),this.onData(a)):this.onData(c.shrinkBuf(h.output,h.next_out)))),0===h.avail_in&&0===h.avail_out&&(f=!0)}while((0<h.avail_in||0===h.avail_out)&&r!==m.Z_STREAM_END);return r===m.Z_STREAM_END&&(i=m.Z_FINISH),i===m.Z_FINISH?(r=d.inflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===m.Z_OK):i!==m.Z_SYNC_FLUSH||(this.onEnd(m.Z_OK),!(h.avail_out=0))},a.prototype.onData=function(t){this.chunks.push(t)},a.prototype.onEnd=function(t){t===m.Z_OK&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=c.flattenChunks(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},r.Inflate=a,r.inflate=o,r.inflateRaw=function(t,e){return(e=e||{}).raw=!0,o(t,e)},r.ungzip=o},{"./utils/common":41,"./utils/strings":42,"./zlib/constants":44,"./zlib/gzheader":47,"./zlib/inflate":49,"./zlib/messages":51,"./zlib/zstream":53}],41:[function(t,e,r){"use strict";var i="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Int32Array;r.assign=function(t){for(var e=Array.prototype.slice.call(arguments,1);e.length;){var r=e.shift();if(r){if("object"!=typeof r)throw new TypeError(r+"must be non-object");for(var i in r)r.hasOwnProperty(i)&&(t[i]=r[i])}}return t},r.shrinkBuf=function(t,e){return t.length===e?t:t.subarray?t.subarray(0,e):(t.length=e,t)};var n={arraySet:function(t,e,r,i,n){if(e.subarray&&t.subarray)t.set(e.subarray(r,r+i),n);else for(var s=0;s<i;s++)t[n+s]=e[r+s]},flattenChunks:function(t){var e,r,i,n,s,a;for(e=i=0,r=t.length;e<r;e++)i+=t[e].length;for(a=new Uint8Array(i),e=n=0,r=t.length;e<r;e++)s=t[e],a.set(s,n),n+=s.length;return a}},s={arraySet:function(t,e,r,i,n){for(var s=0;s<i;s++)t[n+s]=e[r+s]},flattenChunks:function(t){return[].concat.apply([],t)}};r.setTyped=function(t){t?(r.Buf8=Uint8Array,r.Buf16=Uint16Array,r.Buf32=Int32Array,r.assign(r,n)):(r.Buf8=Array,r.Buf16=Array,r.Buf32=Array,r.assign(r,s))},r.setTyped(i)},{}],42:[function(t,e,r){"use strict";var h=t("./common"),n=!0,s=!0;try{String.fromCharCode.apply(null,[0])}catch(t){n=!1}try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(t){s=!1}for(var u=new h.Buf8(256),i=0;i<256;i++)u[i]=252<=i?6:248<=i?5:240<=i?4:224<=i?3:192<=i?2:1;function l(t,e){if(e<65537&&(t.subarray&&s||!t.subarray&&n))return String.fromCharCode.apply(null,h.shrinkBuf(t,e));for(var r="",i=0;i<e;i++)r+=String.fromCharCode(t[i]);return r}u[254]=u[254]=1,r.string2buf=function(t){var e,r,i,n,s,a=t.length,o=0;for(n=0;n<a;n++)55296==(64512&(r=t.charCodeAt(n)))&&n+1<a&&56320==(64512&(i=t.charCodeAt(n+1)))&&(r=65536+(r-55296<<10)+(i-56320),n++),o+=r<128?1:r<2048?2:r<65536?3:4;for(e=new h.Buf8(o),n=s=0;s<o;n++)55296==(64512&(r=t.charCodeAt(n)))&&n+1<a&&56320==(64512&(i=t.charCodeAt(n+1)))&&(r=65536+(r-55296<<10)+(i-56320),n++),r<128?e[s++]=r:(r<2048?e[s++]=192|r>>>6:(r<65536?e[s++]=224|r>>>12:(e[s++]=240|r>>>18,e[s++]=128|r>>>12&63),e[s++]=128|r>>>6&63),e[s++]=128|63&r);return e},r.buf2binstring=function(t){return l(t,t.length)},r.binstring2buf=function(t){for(var e=new h.Buf8(t.length),r=0,i=e.length;r<i;r++)e[r]=t.charCodeAt(r);return e},r.buf2string=function(t,e){var r,i,n,s,a=e||t.length,o=new Array(2*a);for(r=i=0;r<a;)if((n=t[r++])<128)o[i++]=n;else if(4<(s=u[n]))o[i++]=65533,r+=s-1;else{for(n&=2===s?31:3===s?15:7;1<s&&r<a;)n=n<<6|63&t[r++],s--;1<s?o[i++]=65533:n<65536?o[i++]=n:(n-=65536,o[i++]=55296|n>>10&1023,o[i++]=56320|1023&n)}return l(o,i)},r.utf8border=function(t,e){var r;for((e=e||t.length)>t.length&&(e=t.length),r=e-1;0<=r&&128==(192&t[r]);)r--;return r<0?e:0===r?e:r+u[t[r]]>e?r:e}},{"./common":41}],43:[function(t,e,r){"use strict";e.exports=function(t,e,r,i){for(var n=65535&t|0,s=t>>>16&65535|0,a=0;0!==r;){for(r-=a=2e3<r?2e3:r;s=s+(n=n+e[i++]|0)|0,--a;);n%=65521,s%=65521}return n|s<<16|0}},{}],44:[function(t,e,r){"use strict";e.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},{}],45:[function(t,e,r){"use strict";var o=function(){for(var t,e=[],r=0;r<256;r++){t=r;for(var i=0;i<8;i++)t=1&t?3988292384^t>>>1:t>>>1;e[r]=t}return e}();e.exports=function(t,e,r,i){var n=o,s=i+r;t^=-1;for(var a=i;a<s;a++)t=t>>>8^n[255&(t^e[a])];return-1^t}},{}],46:[function(t,e,r){"use strict";var h,d=t("../utils/common"),u=t("./trees"),c=t("./adler32"),p=t("./crc32"),i=t("./messages"),l=0,f=4,m=0,_=-2,g=-1,b=4,n=2,v=8,y=9,s=286,a=30,o=19,w=2*s+1,k=15,x=3,S=258,z=S+x+1,C=42,E=113,A=1,I=2,O=3,B=4;function R(t,e){return t.msg=i[e],e}function T(t){return(t<<1)-(4<t?9:0)}function D(t){for(var e=t.length;0<=--e;)t[e]=0}function F(t){var e=t.state,r=e.pending;r>t.avail_out&&(r=t.avail_out),0!==r&&(d.arraySet(t.output,e.pending_buf,e.pending_out,r,t.next_out),t.next_out+=r,e.pending_out+=r,t.total_out+=r,t.avail_out-=r,e.pending-=r,0===e.pending&&(e.pending_out=0))}function N(t,e){u._tr_flush_block(t,0<=t.block_start?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,F(t.strm)}function U(t,e){t.pending_buf[t.pending++]=e}function P(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e}function L(t,e){var r,i,n=t.max_chain_length,s=t.strstart,a=t.prev_length,o=t.nice_match,h=t.strstart>t.w_size-z?t.strstart-(t.w_size-z):0,u=t.window,l=t.w_mask,f=t.prev,d=t.strstart+S,c=u[s+a-1],p=u[s+a];t.prev_length>=t.good_match&&(n>>=2),o>t.lookahead&&(o=t.lookahead);do{if(u[(r=e)+a]===p&&u[r+a-1]===c&&u[r]===u[s]&&u[++r]===u[s+1]){s+=2,r++;do{}while(u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&s<d);if(i=S-(d-s),s=d-S,a<i){if(t.match_start=e,o<=(a=i))break;c=u[s+a-1],p=u[s+a]}}}while((e=f[e&l])>h&&0!=--n);return a<=t.lookahead?a:t.lookahead}function j(t){var e,r,i,n,s,a,o,h,u,l,f=t.w_size;do{if(n=t.window_size-t.lookahead-t.strstart,t.strstart>=f+(f-z)){for(d.arraySet(t.window,t.window,f,f,0),t.match_start-=f,t.strstart-=f,t.block_start-=f,e=r=t.hash_size;i=t.head[--e],t.head[e]=f<=i?i-f:0,--r;);for(e=r=f;i=t.prev[--e],t.prev[e]=f<=i?i-f:0,--r;);n+=f}if(0===t.strm.avail_in)break;if(a=t.strm,o=t.window,h=t.strstart+t.lookahead,u=n,l=void 0,l=a.avail_in,u<l&&(l=u),r=0===l?0:(a.avail_in-=l,d.arraySet(o,a.input,a.next_in,l,h),1===a.state.wrap?a.adler=c(a.adler,o,l,h):2===a.state.wrap&&(a.adler=p(a.adler,o,l,h)),a.next_in+=l,a.total_in+=l,l),t.lookahead+=r,t.lookahead+t.insert>=x)for(s=t.strstart-t.insert,t.ins_h=t.window[s],t.ins_h=(t.ins_h<<t.hash_shift^t.window[s+1])&t.hash_mask;t.insert&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[s+x-1])&t.hash_mask,t.prev[s&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=s,s++,t.insert--,!(t.lookahead+t.insert<x)););}while(t.lookahead<z&&0!==t.strm.avail_in)}function Z(t,e){for(var r,i;;){if(t.lookahead<z){if(j(t),t.lookahead<z&&e===l)return A;if(0===t.lookahead)break}if(r=0,t.lookahead>=x&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+x-1])&t.hash_mask,r=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==r&&t.strstart-r<=t.w_size-z&&(t.match_length=L(t,r)),t.match_length>=x)if(i=u._tr_tally(t,t.strstart-t.match_start,t.match_length-x),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=x){for(t.match_length--;t.strstart++,t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+x-1])&t.hash_mask,r=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart,0!=--t.match_length;);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+1])&t.hash_mask;else i=u._tr_tally(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(i&&(N(t,!1),0===t.strm.avail_out))return A}return t.insert=t.strstart<x-1?t.strstart:x-1,e===f?(N(t,!0),0===t.strm.avail_out?O:B):t.last_lit&&(N(t,!1),0===t.strm.avail_out)?A:I}function W(t,e){for(var r,i,n;;){if(t.lookahead<z){if(j(t),t.lookahead<z&&e===l)return A;if(0===t.lookahead)break}if(r=0,t.lookahead>=x&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+x-1])&t.hash_mask,r=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=x-1,0!==r&&t.prev_length<t.max_lazy_match&&t.strstart-r<=t.w_size-z&&(t.match_length=L(t,r),t.match_length<=5&&(1===t.strategy||t.match_length===x&&4096<t.strstart-t.match_start)&&(t.match_length=x-1)),t.prev_length>=x&&t.match_length<=t.prev_length){for(n=t.strstart+t.lookahead-x,i=u._tr_tally(t,t.strstart-1-t.prev_match,t.prev_length-x),t.lookahead-=t.prev_length-1,t.prev_length-=2;++t.strstart<=n&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+x-1])&t.hash_mask,r=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!=--t.prev_length;);if(t.match_available=0,t.match_length=x-1,t.strstart++,i&&(N(t,!1),0===t.strm.avail_out))return A}else if(t.match_available){if((i=u._tr_tally(t,0,t.window[t.strstart-1]))&&N(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return A}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(i=u._tr_tally(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<x-1?t.strstart:x-1,e===f?(N(t,!0),0===t.strm.avail_out?O:B):t.last_lit&&(N(t,!1),0===t.strm.avail_out)?A:I}function M(t,e,r,i,n){this.good_length=t,this.max_lazy=e,this.nice_length=r,this.max_chain=i,this.func=n}function H(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=v,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new d.Buf16(2*w),this.dyn_dtree=new d.Buf16(2*(2*a+1)),this.bl_tree=new d.Buf16(2*(2*o+1)),D(this.dyn_ltree),D(this.dyn_dtree),D(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new d.Buf16(k+1),this.heap=new d.Buf16(2*s+1),D(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new d.Buf16(2*s+1),D(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}function G(t){var e;return t&&t.state?(t.total_in=t.total_out=0,t.data_type=n,(e=t.state).pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?C:E,t.adler=2===e.wrap?0:1,e.last_flush=l,u._tr_init(e),m):R(t,_)}function K(t){var e=G(t);return e===m&&function(t){t.window_size=2*t.w_size,D(t.head),t.max_lazy_match=h[t.level].max_lazy,t.good_match=h[t.level].good_length,t.nice_match=h[t.level].nice_length,t.max_chain_length=h[t.level].max_chain,t.strstart=0,t.block_start=0,t.lookahead=0,t.insert=0,t.match_length=t.prev_length=x-1,t.match_available=0,t.ins_h=0}(t.state),e}function Y(t,e,r,i,n,s){if(!t)return _;var a=1;if(e===g&&(e=6),i<0?(a=0,i=-i):15<i&&(a=2,i-=16),n<1||y<n||r!==v||i<8||15<i||e<0||9<e||s<0||b<s)return R(t,_);8===i&&(i=9);var o=new H;return(t.state=o).strm=t,o.wrap=a,o.gzhead=null,o.w_bits=i,o.w_size=1<<o.w_bits,o.w_mask=o.w_size-1,o.hash_bits=n+7,o.hash_size=1<<o.hash_bits,o.hash_mask=o.hash_size-1,o.hash_shift=~~((o.hash_bits+x-1)/x),o.window=new d.Buf8(2*o.w_size),o.head=new d.Buf16(o.hash_size),o.prev=new d.Buf16(o.w_size),o.lit_bufsize=1<<n+6,o.pending_buf_size=4*o.lit_bufsize,o.pending_buf=new d.Buf8(o.pending_buf_size),o.d_buf=1*o.lit_bufsize,o.l_buf=3*o.lit_bufsize,o.level=e,o.strategy=s,o.method=r,K(t)}h=[new M(0,0,0,0,function(t,e){var r=65535;for(r>t.pending_buf_size-5&&(r=t.pending_buf_size-5);;){if(t.lookahead<=1){if(j(t),0===t.lookahead&&e===l)return A;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var i=t.block_start+r;if((0===t.strstart||t.strstart>=i)&&(t.lookahead=t.strstart-i,t.strstart=i,N(t,!1),0===t.strm.avail_out))return A;if(t.strstart-t.block_start>=t.w_size-z&&(N(t,!1),0===t.strm.avail_out))return A}return t.insert=0,e===f?(N(t,!0),0===t.strm.avail_out?O:B):(t.strstart>t.block_start&&(N(t,!1),t.strm.avail_out),A)}),new M(4,4,8,4,Z),new M(4,5,16,8,Z),new M(4,6,32,32,Z),new M(4,4,16,16,W),new M(8,16,32,32,W),new M(8,16,128,128,W),new M(8,32,128,256,W),new M(32,128,258,1024,W),new M(32,258,258,4096,W)],r.deflateInit=function(t,e){return Y(t,e,v,15,8,0)},r.deflateInit2=Y,r.deflateReset=K,r.deflateResetKeep=G,r.deflateSetHeader=function(t,e){return t&&t.state?2!==t.state.wrap?_:(t.state.gzhead=e,m):_},r.deflate=function(t,e){var r,i,n,s;if(!t||!t.state||5<e||e<0)return t?R(t,_):_;if(i=t.state,!t.output||!t.input&&0!==t.avail_in||666===i.status&&e!==f)return R(t,0===t.avail_out?-5:_);if(i.strm=t,r=i.last_flush,i.last_flush=e,i.status===C)if(2===i.wrap)t.adler=0,U(i,31),U(i,139),U(i,8),i.gzhead?(U(i,(i.gzhead.text?1:0)+(i.gzhead.hcrc?2:0)+(i.gzhead.extra?4:0)+(i.gzhead.name?8:0)+(i.gzhead.comment?16:0)),U(i,255&i.gzhead.time),U(i,i.gzhead.time>>8&255),U(i,i.gzhead.time>>16&255),U(i,i.gzhead.time>>24&255),U(i,9===i.level?2:2<=i.strategy||i.level<2?4:0),U(i,255&i.gzhead.os),i.gzhead.extra&&i.gzhead.extra.length&&(U(i,255&i.gzhead.extra.length),U(i,i.gzhead.extra.length>>8&255)),i.gzhead.hcrc&&(t.adler=p(t.adler,i.pending_buf,i.pending,0)),i.gzindex=0,i.status=69):(U(i,0),U(i,0),U(i,0),U(i,0),U(i,0),U(i,9===i.level?2:2<=i.strategy||i.level<2?4:0),U(i,3),i.status=E);else{var a=v+(i.w_bits-8<<4)<<8;a|=(2<=i.strategy||i.level<2?0:i.level<6?1:6===i.level?2:3)<<6,0!==i.strstart&&(a|=32),a+=31-a%31,i.status=E,P(i,a),0!==i.strstart&&(P(i,t.adler>>>16),P(i,65535&t.adler)),t.adler=1}if(69===i.status)if(i.gzhead.extra){for(n=i.pending;i.gzindex<(65535&i.gzhead.extra.length)&&(i.pending!==i.pending_buf_size||(i.gzhead.hcrc&&i.pending>n&&(t.adler=p(t.adler,i.pending_buf,i.pending-n,n)),F(t),n=i.pending,i.pending!==i.pending_buf_size));)U(i,255&i.gzhead.extra[i.gzindex]),i.gzindex++;i.gzhead.hcrc&&i.pending>n&&(t.adler=p(t.adler,i.pending_buf,i.pending-n,n)),i.gzindex===i.gzhead.extra.length&&(i.gzindex=0,i.status=73)}else i.status=73;if(73===i.status)if(i.gzhead.name){n=i.pending;do{if(i.pending===i.pending_buf_size&&(i.gzhead.hcrc&&i.pending>n&&(t.adler=p(t.adler,i.pending_buf,i.pending-n,n)),F(t),n=i.pending,i.pending===i.pending_buf_size)){s=1;break}s=i.gzindex<i.gzhead.name.length?255&i.gzhead.name.charCodeAt(i.gzindex++):0,U(i,s)}while(0!==s);i.gzhead.hcrc&&i.pending>n&&(t.adler=p(t.adler,i.pending_buf,i.pending-n,n)),0===s&&(i.gzindex=0,i.status=91)}else i.status=91;if(91===i.status)if(i.gzhead.comment){n=i.pending;do{if(i.pending===i.pending_buf_size&&(i.gzhead.hcrc&&i.pending>n&&(t.adler=p(t.adler,i.pending_buf,i.pending-n,n)),F(t),n=i.pending,i.pending===i.pending_buf_size)){s=1;break}s=i.gzindex<i.gzhead.comment.length?255&i.gzhead.comment.charCodeAt(i.gzindex++):0,U(i,s)}while(0!==s);i.gzhead.hcrc&&i.pending>n&&(t.adler=p(t.adler,i.pending_buf,i.pending-n,n)),0===s&&(i.status=103)}else i.status=103;if(103===i.status&&(i.gzhead.hcrc?(i.pending+2>i.pending_buf_size&&F(t),i.pending+2<=i.pending_buf_size&&(U(i,255&t.adler),U(i,t.adler>>8&255),t.adler=0,i.status=E)):i.status=E),0!==i.pending){if(F(t),0===t.avail_out)return i.last_flush=-1,m}else if(0===t.avail_in&&T(e)<=T(r)&&e!==f)return R(t,-5);if(666===i.status&&0!==t.avail_in)return R(t,-5);if(0!==t.avail_in||0!==i.lookahead||e!==l&&666!==i.status){var o=2===i.strategy?function(t,e){for(var r;;){if(0===t.lookahead&&(j(t),0===t.lookahead)){if(e===l)return A;break}if(t.match_length=0,r=u._tr_tally(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,r&&(N(t,!1),0===t.strm.avail_out))return A}return t.insert=0,e===f?(N(t,!0),0===t.strm.avail_out?O:B):t.last_lit&&(N(t,!1),0===t.strm.avail_out)?A:I}(i,e):3===i.strategy?function(t,e){for(var r,i,n,s,a=t.window;;){if(t.lookahead<=S){if(j(t),t.lookahead<=S&&e===l)return A;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=x&&0<t.strstart&&(i=a[n=t.strstart-1])===a[++n]&&i===a[++n]&&i===a[++n]){s=t.strstart+S;do{}while(i===a[++n]&&i===a[++n]&&i===a[++n]&&i===a[++n]&&i===a[++n]&&i===a[++n]&&i===a[++n]&&i===a[++n]&&n<s);t.match_length=S-(s-n),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=x?(r=u._tr_tally(t,1,t.match_length-x),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(r=u._tr_tally(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),r&&(N(t,!1),0===t.strm.avail_out))return A}return t.insert=0,e===f?(N(t,!0),0===t.strm.avail_out?O:B):t.last_lit&&(N(t,!1),0===t.strm.avail_out)?A:I}(i,e):h[i.level].func(i,e);if(o!==O&&o!==B||(i.status=666),o===A||o===O)return 0===t.avail_out&&(i.last_flush=-1),m;if(o===I&&(1===e?u._tr_align(i):5!==e&&(u._tr_stored_block(i,0,0,!1),3===e&&(D(i.head),0===i.lookahead&&(i.strstart=0,i.block_start=0,i.insert=0))),F(t),0===t.avail_out))return i.last_flush=-1,m}return e!==f?m:i.wrap<=0?1:(2===i.wrap?(U(i,255&t.adler),U(i,t.adler>>8&255),U(i,t.adler>>16&255),U(i,t.adler>>24&255),U(i,255&t.total_in),U(i,t.total_in>>8&255),U(i,t.total_in>>16&255),U(i,t.total_in>>24&255)):(P(i,t.adler>>>16),P(i,65535&t.adler)),F(t),0<i.wrap&&(i.wrap=-i.wrap),0!==i.pending?m:1)},r.deflateEnd=function(t){var e;return t&&t.state?(e=t.state.status)!==C&&69!==e&&73!==e&&91!==e&&103!==e&&e!==E&&666!==e?R(t,_):(t.state=null,e===E?R(t,-3):m):_},r.deflateSetDictionary=function(t,e){var r,i,n,s,a,o,h,u,l=e.length;if(!t||!t.state)return _;if(2===(s=(r=t.state).wrap)||1===s&&r.status!==C||r.lookahead)return _;for(1===s&&(t.adler=c(t.adler,e,l,0)),r.wrap=0,l>=r.w_size&&(0===s&&(D(r.head),r.strstart=0,r.block_start=0,r.insert=0),u=new d.Buf8(r.w_size),d.arraySet(u,e,l-r.w_size,r.w_size,0),e=u,l=r.w_size),a=t.avail_in,o=t.next_in,h=t.input,t.avail_in=l,t.next_in=0,t.input=e,j(r);r.lookahead>=x;){for(i=r.strstart,n=r.lookahead-(x-1);r.ins_h=(r.ins_h<<r.hash_shift^r.window[i+x-1])&r.hash_mask,r.prev[i&r.w_mask]=r.head[r.ins_h],r.head[r.ins_h]=i,i++,--n;);r.strstart=i,r.lookahead=x-1,j(r)}return r.strstart+=r.lookahead,r.block_start=r.strstart,r.insert=r.lookahead,r.lookahead=0,r.match_length=r.prev_length=x-1,r.match_available=0,t.next_in=o,t.input=h,t.avail_in=a,r.wrap=s,m},r.deflateInfo="pako deflate (from Nodeca project)"},{"../utils/common":41,"./adler32":43,"./crc32":45,"./messages":51,"./trees":52}],47:[function(t,e,r){"use strict";e.exports=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1}},{}],48:[function(t,e,r){"use strict";e.exports=function(t,e){var r,i,n,s,a,o,h,u,l,f,d,c,p,m,_,g,b,v,y,w,k,x,S,z,C;r=t.state,i=t.next_in,z=t.input,n=i+(t.avail_in-5),s=t.next_out,C=t.output,a=s-(e-t.avail_out),o=s+(t.avail_out-257),h=r.dmax,u=r.wsize,l=r.whave,f=r.wnext,d=r.window,c=r.hold,p=r.bits,m=r.lencode,_=r.distcode,g=(1<<r.lenbits)-1,b=(1<<r.distbits)-1;t:do{p<15&&(c+=z[i++]<<p,p+=8,c+=z[i++]<<p,p+=8),v=m[c&g];e:for(;;){if(c>>>=y=v>>>24,p-=y,0===(y=v>>>16&255))C[s++]=65535&v;else{if(!(16&y)){if(0==(64&y)){v=m[(65535&v)+(c&(1<<y)-1)];continue e}if(32&y){r.mode=12;break t}t.msg="invalid literal/length code",r.mode=30;break t}w=65535&v,(y&=15)&&(p<y&&(c+=z[i++]<<p,p+=8),w+=c&(1<<y)-1,c>>>=y,p-=y),p<15&&(c+=z[i++]<<p,p+=8,c+=z[i++]<<p,p+=8),v=_[c&b];r:for(;;){if(c>>>=y=v>>>24,p-=y,!(16&(y=v>>>16&255))){if(0==(64&y)){v=_[(65535&v)+(c&(1<<y)-1)];continue r}t.msg="invalid distance code",r.mode=30;break t}if(k=65535&v,p<(y&=15)&&(c+=z[i++]<<p,(p+=8)<y&&(c+=z[i++]<<p,p+=8)),h<(k+=c&(1<<y)-1)){t.msg="invalid distance too far back",r.mode=30;break t}if(c>>>=y,p-=y,(y=s-a)<k){if(l<(y=k-y)&&r.sane){t.msg="invalid distance too far back",r.mode=30;break t}if(S=d,(x=0)===f){if(x+=u-y,y<w){for(w-=y;C[s++]=d[x++],--y;);x=s-k,S=C}}else if(f<y){if(x+=u+f-y,(y-=f)<w){for(w-=y;C[s++]=d[x++],--y;);if(x=0,f<w){for(w-=y=f;C[s++]=d[x++],--y;);x=s-k,S=C}}}else if(x+=f-y,y<w){for(w-=y;C[s++]=d[x++],--y;);x=s-k,S=C}for(;2<w;)C[s++]=S[x++],C[s++]=S[x++],C[s++]=S[x++],w-=3;w&&(C[s++]=S[x++],1<w&&(C[s++]=S[x++]))}else{for(x=s-k;C[s++]=C[x++],C[s++]=C[x++],C[s++]=C[x++],2<(w-=3););w&&(C[s++]=C[x++],1<w&&(C[s++]=C[x++]))}break}}break}}while(i<n&&s<o);i-=w=p>>3,c&=(1<<(p-=w<<3))-1,t.next_in=i,t.next_out=s,t.avail_in=i<n?n-i+5:5-(i-n),t.avail_out=s<o?o-s+257:257-(s-o),r.hold=c,r.bits=p}},{}],49:[function(t,e,r){"use strict";var I=t("../utils/common"),O=t("./adler32"),B=t("./crc32"),R=t("./inffast"),T=t("./inftrees"),D=1,F=2,N=0,U=-2,P=1,i=852,n=592;function L(t){return(t>>>24&255)+(t>>>8&65280)+((65280&t)<<8)+((255&t)<<24)}function s(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new I.Buf16(320),this.work=new I.Buf16(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}function a(t){var e;return t&&t.state?(e=t.state,t.total_in=t.total_out=e.total=0,t.msg="",e.wrap&&(t.adler=1&e.wrap),e.mode=P,e.last=0,e.havedict=0,e.dmax=32768,e.head=null,e.hold=0,e.bits=0,e.lencode=e.lendyn=new I.Buf32(i),e.distcode=e.distdyn=new I.Buf32(n),e.sane=1,e.back=-1,N):U}function o(t){var e;return t&&t.state?((e=t.state).wsize=0,e.whave=0,e.wnext=0,a(t)):U}function h(t,e){var r,i;return t&&t.state?(i=t.state,e<0?(r=0,e=-e):(r=1+(e>>4),e<48&&(e&=15)),e&&(e<8||15<e)?U:(null!==i.window&&i.wbits!==e&&(i.window=null),i.wrap=r,i.wbits=e,o(t))):U}function u(t,e){var r,i;return t?(i=new s,(t.state=i).window=null,(r=h(t,e))!==N&&(t.state=null),r):U}var l,f,d=!0;function j(t){if(d){var e;for(l=new I.Buf32(512),f=new I.Buf32(32),e=0;e<144;)t.lens[e++]=8;for(;e<256;)t.lens[e++]=9;for(;e<280;)t.lens[e++]=7;for(;e<288;)t.lens[e++]=8;for(T(D,t.lens,0,288,l,0,t.work,{bits:9}),e=0;e<32;)t.lens[e++]=5;T(F,t.lens,0,32,f,0,t.work,{bits:5}),d=!1}t.lencode=l,t.lenbits=9,t.distcode=f,t.distbits=5}function Z(t,e,r,i){var n,s=t.state;return null===s.window&&(s.wsize=1<<s.wbits,s.wnext=0,s.whave=0,s.window=new I.Buf8(s.wsize)),i>=s.wsize?(I.arraySet(s.window,e,r-s.wsize,s.wsize,0),s.wnext=0,s.whave=s.wsize):(i<(n=s.wsize-s.wnext)&&(n=i),I.arraySet(s.window,e,r-i,n,s.wnext),(i-=n)?(I.arraySet(s.window,e,r-i,i,0),s.wnext=i,s.whave=s.wsize):(s.wnext+=n,s.wnext===s.wsize&&(s.wnext=0),s.whave<s.wsize&&(s.whave+=n))),0}r.inflateReset=o,r.inflateReset2=h,r.inflateResetKeep=a,r.inflateInit=function(t){return u(t,15)},r.inflateInit2=u,r.inflate=function(t,e){var r,i,n,s,a,o,h,u,l,f,d,c,p,m,_,g,b,v,y,w,k,x,S,z,C=0,E=new I.Buf8(4),A=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!t||!t.state||!t.output||!t.input&&0!==t.avail_in)return U;12===(r=t.state).mode&&(r.mode=13),a=t.next_out,n=t.output,h=t.avail_out,s=t.next_in,i=t.input,o=t.avail_in,u=r.hold,l=r.bits,f=o,d=h,x=N;t:for(;;)switch(r.mode){case P:if(0===r.wrap){r.mode=13;break}for(;l<16;){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}if(2&r.wrap&&35615===u){E[r.check=0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0),l=u=0,r.mode=2;break}if(r.flags=0,r.head&&(r.head.done=!1),!(1&r.wrap)||(((255&u)<<8)+(u>>8))%31){t.msg="incorrect header check",r.mode=30;break}if(8!=(15&u)){t.msg="unknown compression method",r.mode=30;break}if(l-=4,k=8+(15&(u>>>=4)),0===r.wbits)r.wbits=k;else if(k>r.wbits){t.msg="invalid window size",r.mode=30;break}r.dmax=1<<k,t.adler=r.check=1,r.mode=512&u?10:12,l=u=0;break;case 2:for(;l<16;){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}if(r.flags=u,8!=(255&r.flags)){t.msg="unknown compression method",r.mode=30;break}if(57344&r.flags){t.msg="unknown header flags set",r.mode=30;break}r.head&&(r.head.text=u>>8&1),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0,r.mode=3;case 3:for(;l<32;){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}r.head&&(r.head.time=u),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,E[2]=u>>>16&255,E[3]=u>>>24&255,r.check=B(r.check,E,4,0)),l=u=0,r.mode=4;case 4:for(;l<16;){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}r.head&&(r.head.xflags=255&u,r.head.os=u>>8),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0,r.mode=5;case 5:if(1024&r.flags){for(;l<16;){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}r.length=u,r.head&&(r.head.extra_len=u),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0}else r.head&&(r.head.extra=null);r.mode=6;case 6:if(1024&r.flags&&(o<(c=r.length)&&(c=o),c&&(r.head&&(k=r.head.extra_len-r.length,r.head.extra||(r.head.extra=new Array(r.head.extra_len)),I.arraySet(r.head.extra,i,s,c,k)),512&r.flags&&(r.check=B(r.check,i,c,s)),o-=c,s+=c,r.length-=c),r.length))break t;r.length=0,r.mode=7;case 7:if(2048&r.flags){if(0===o)break t;for(c=0;k=i[s+c++],r.head&&k&&r.length<65536&&(r.head.name+=String.fromCharCode(k)),k&&c<o;);if(512&r.flags&&(r.check=B(r.check,i,c,s)),o-=c,s+=c,k)break t}else r.head&&(r.head.name=null);r.length=0,r.mode=8;case 8:if(4096&r.flags){if(0===o)break t;for(c=0;k=i[s+c++],r.head&&k&&r.length<65536&&(r.head.comment+=String.fromCharCode(k)),k&&c<o;);if(512&r.flags&&(r.check=B(r.check,i,c,s)),o-=c,s+=c,k)break t}else r.head&&(r.head.comment=null);r.mode=9;case 9:if(512&r.flags){for(;l<16;){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}if(u!==(65535&r.check)){t.msg="header crc mismatch",r.mode=30;break}l=u=0}r.head&&(r.head.hcrc=r.flags>>9&1,r.head.done=!0),t.adler=r.check=0,r.mode=12;break;case 10:for(;l<32;){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}t.adler=r.check=L(u),l=u=0,r.mode=11;case 11:if(0===r.havedict)return t.next_out=a,t.avail_out=h,t.next_in=s,t.avail_in=o,r.hold=u,r.bits=l,2;t.adler=r.check=1,r.mode=12;case 12:if(5===e||6===e)break t;case 13:if(r.last){u>>>=7&l,l-=7&l,r.mode=27;break}for(;l<3;){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}switch(r.last=1&u,l-=1,3&(u>>>=1)){case 0:r.mode=14;break;case 1:if(j(r),r.mode=20,6!==e)break;u>>>=2,l-=2;break t;case 2:r.mode=17;break;case 3:t.msg="invalid block type",r.mode=30}u>>>=2,l-=2;break;case 14:for(u>>>=7&l,l-=7&l;l<32;){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}if((65535&u)!=(u>>>16^65535)){t.msg="invalid stored block lengths",r.mode=30;break}if(r.length=65535&u,l=u=0,r.mode=15,6===e)break t;case 15:r.mode=16;case 16:if(c=r.length){if(o<c&&(c=o),h<c&&(c=h),0===c)break t;I.arraySet(n,i,s,c,a),o-=c,s+=c,h-=c,a+=c,r.length-=c;break}r.mode=12;break;case 17:for(;l<14;){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}if(r.nlen=257+(31&u),u>>>=5,l-=5,r.ndist=1+(31&u),u>>>=5,l-=5,r.ncode=4+(15&u),u>>>=4,l-=4,286<r.nlen||30<r.ndist){t.msg="too many length or distance symbols",r.mode=30;break}r.have=0,r.mode=18;case 18:for(;r.have<r.ncode;){for(;l<3;){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}r.lens[A[r.have++]]=7&u,u>>>=3,l-=3}for(;r.have<19;)r.lens[A[r.have++]]=0;if(r.lencode=r.lendyn,r.lenbits=7,S={bits:r.lenbits},x=T(0,r.lens,0,19,r.lencode,0,r.work,S),r.lenbits=S.bits,x){t.msg="invalid code lengths set",r.mode=30;break}r.have=0,r.mode=19;case 19:for(;r.have<r.nlen+r.ndist;){for(;g=(C=r.lencode[u&(1<<r.lenbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}if(b<16)u>>>=_,l-=_,r.lens[r.have++]=b;else{if(16===b){for(z=_+2;l<z;){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}if(u>>>=_,l-=_,0===r.have){t.msg="invalid bit length repeat",r.mode=30;break}k=r.lens[r.have-1],c=3+(3&u),u>>>=2,l-=2}else if(17===b){for(z=_+3;l<z;){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}l-=_,k=0,c=3+(7&(u>>>=_)),u>>>=3,l-=3}else{for(z=_+7;l<z;){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}l-=_,k=0,c=11+(127&(u>>>=_)),u>>>=7,l-=7}if(r.have+c>r.nlen+r.ndist){t.msg="invalid bit length repeat",r.mode=30;break}for(;c--;)r.lens[r.have++]=k}}if(30===r.mode)break;if(0===r.lens[256]){t.msg="invalid code -- missing end-of-block",r.mode=30;break}if(r.lenbits=9,S={bits:r.lenbits},x=T(D,r.lens,0,r.nlen,r.lencode,0,r.work,S),r.lenbits=S.bits,x){t.msg="invalid literal/lengths set",r.mode=30;break}if(r.distbits=6,r.distcode=r.distdyn,S={bits:r.distbits},x=T(F,r.lens,r.nlen,r.ndist,r.distcode,0,r.work,S),r.distbits=S.bits,x){t.msg="invalid distances set",r.mode=30;break}if(r.mode=20,6===e)break t;case 20:r.mode=21;case 21:if(6<=o&&258<=h){t.next_out=a,t.avail_out=h,t.next_in=s,t.avail_in=o,r.hold=u,r.bits=l,R(t,d),a=t.next_out,n=t.output,h=t.avail_out,s=t.next_in,i=t.input,o=t.avail_in,u=r.hold,l=r.bits,12===r.mode&&(r.back=-1);break}for(r.back=0;g=(C=r.lencode[u&(1<<r.lenbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}if(g&&0==(240&g)){for(v=_,y=g,w=b;g=(C=r.lencode[w+((u&(1<<v+y)-1)>>v)])>>>16&255,b=65535&C,!(v+(_=C>>>24)<=l);){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}u>>>=v,l-=v,r.back+=v}if(u>>>=_,l-=_,r.back+=_,r.length=b,0===g){r.mode=26;break}if(32&g){r.back=-1,r.mode=12;break}if(64&g){t.msg="invalid literal/length code",r.mode=30;break}r.extra=15&g,r.mode=22;case 22:if(r.extra){for(z=r.extra;l<z;){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}r.length+=u&(1<<r.extra)-1,u>>>=r.extra,l-=r.extra,r.back+=r.extra}r.was=r.length,r.mode=23;case 23:for(;g=(C=r.distcode[u&(1<<r.distbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}if(0==(240&g)){for(v=_,y=g,w=b;g=(C=r.distcode[w+((u&(1<<v+y)-1)>>v)])>>>16&255,b=65535&C,!(v+(_=C>>>24)<=l);){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}u>>>=v,l-=v,r.back+=v}if(u>>>=_,l-=_,r.back+=_,64&g){t.msg="invalid distance code",r.mode=30;break}r.offset=b,r.extra=15&g,r.mode=24;case 24:if(r.extra){for(z=r.extra;l<z;){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}r.offset+=u&(1<<r.extra)-1,u>>>=r.extra,l-=r.extra,r.back+=r.extra}if(r.offset>r.dmax){t.msg="invalid distance too far back",r.mode=30;break}r.mode=25;case 25:if(0===h)break t;if(c=d-h,r.offset>c){if((c=r.offset-c)>r.whave&&r.sane){t.msg="invalid distance too far back",r.mode=30;break}p=c>r.wnext?(c-=r.wnext,r.wsize-c):r.wnext-c,c>r.length&&(c=r.length),m=r.window}else m=n,p=a-r.offset,c=r.length;for(h<c&&(c=h),h-=c,r.length-=c;n[a++]=m[p++],--c;);0===r.length&&(r.mode=21);break;case 26:if(0===h)break t;n[a++]=r.length,h--,r.mode=21;break;case 27:if(r.wrap){for(;l<32;){if(0===o)break t;o--,u|=i[s++]<<l,l+=8}if(d-=h,t.total_out+=d,r.total+=d,d&&(t.adler=r.check=r.flags?B(r.check,n,d,a-d):O(r.check,n,d,a-d)),d=h,(r.flags?u:L(u))!==r.check){t.msg="incorrect data check",r.mode=30;break}l=u=0}r.mode=28;case 28:if(r.wrap&&r.flags){for(;l<32;){if(0===o)break t;o--,u+=i[s++]<<l,l+=8}if(u!==(4294967295&r.total)){t.msg="incorrect length check",r.mode=30;break}l=u=0}r.mode=29;case 29:x=1;break t;case 30:x=-3;break t;case 31:return-4;case 32:default:return U}return t.next_out=a,t.avail_out=h,t.next_in=s,t.avail_in=o,r.hold=u,r.bits=l,(r.wsize||d!==t.avail_out&&r.mode<30&&(r.mode<27||4!==e))&&Z(t,t.output,t.next_out,d-t.avail_out)?(r.mode=31,-4):(f-=t.avail_in,d-=t.avail_out,t.total_in+=f,t.total_out+=d,r.total+=d,r.wrap&&d&&(t.adler=r.check=r.flags?B(r.check,n,d,t.next_out-d):O(r.check,n,d,t.next_out-d)),t.data_type=r.bits+(r.last?64:0)+(12===r.mode?128:0)+(20===r.mode||15===r.mode?256:0),(0==f&&0===d||4===e)&&x===N&&(x=-5),x)},r.inflateEnd=function(t){if(!t||!t.state)return U;var e=t.state;return e.window&&(e.window=null),t.state=null,N},r.inflateGetHeader=function(t,e){var r;return t&&t.state?0==(2&(r=t.state).wrap)?U:((r.head=e).done=!1,N):U},r.inflateSetDictionary=function(t,e){var r,i=e.length;return t&&t.state?0!==(r=t.state).wrap&&11!==r.mode?U:11===r.mode&&O(1,e,i,0)!==r.check?-3:Z(t,e,i,i)?(r.mode=31,-4):(r.havedict=1,N):U},r.inflateInfo="pako inflate (from Nodeca project)"},{"../utils/common":41,"./adler32":43,"./crc32":45,"./inffast":48,"./inftrees":50}],50:[function(t,e,r){"use strict";var D=t("../utils/common"),F=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],N=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78],U=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0],P=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];e.exports=function(t,e,r,i,n,s,a,o){var h,u,l,f,d,c,p,m,_,g=o.bits,b=0,v=0,y=0,w=0,k=0,x=0,S=0,z=0,C=0,E=0,A=null,I=0,O=new D.Buf16(16),B=new D.Buf16(16),R=null,T=0;for(b=0;b<=15;b++)O[b]=0;for(v=0;v<i;v++)O[e[r+v]]++;for(k=g,w=15;1<=w&&0===O[w];w--);if(w<k&&(k=w),0===w)return n[s++]=20971520,n[s++]=20971520,o.bits=1,0;for(y=1;y<w&&0===O[y];y++);for(k<y&&(k=y),b=z=1;b<=15;b++)if(z<<=1,(z-=O[b])<0)return-1;if(0<z&&(0===t||1!==w))return-1;for(B[1]=0,b=1;b<15;b++)B[b+1]=B[b]+O[b];for(v=0;v<i;v++)0!==e[r+v]&&(a[B[e[r+v]]++]=v);if(c=0===t?(A=R=a,19):1===t?(A=F,I-=257,R=N,T-=257,256):(A=U,R=P,-1),b=y,d=s,S=v=E=0,l=-1,f=(C=1<<(x=k))-1,1===t&&852<C||2===t&&592<C)return 1;for(;;){for(p=b-S,_=a[v]<c?(m=0,a[v]):a[v]>c?(m=R[T+a[v]],A[I+a[v]]):(m=96,0),h=1<<b-S,y=u=1<<x;n[d+(E>>S)+(u-=h)]=p<<24|m<<16|_|0,0!==u;);for(h=1<<b-1;E&h;)h>>=1;if(0!==h?(E&=h-1,E+=h):E=0,v++,0==--O[b]){if(b===w)break;b=e[r+a[v]]}if(k<b&&(E&f)!==l){for(0===S&&(S=k),d+=y,z=1<<(x=b-S);x+S<w&&!((z-=O[x+S])<=0);)x++,z<<=1;if(C+=1<<x,1===t&&852<C||2===t&&592<C)return 1;n[l=E&f]=k<<24|x<<16|d-s|0}}return 0!==E&&(n[d+E]=b-S<<24|64<<16|0),o.bits=k,0}},{"../utils/common":41}],51:[function(t,e,r){"use strict";e.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}},{}],52:[function(t,e,r){"use strict";var n=t("../utils/common"),o=0,h=1;function i(t){for(var e=t.length;0<=--e;)t[e]=0}var s=0,a=29,u=256,l=u+1+a,f=30,d=19,_=2*l+1,g=15,c=16,p=7,m=256,b=16,v=17,y=18,w=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],k=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],x=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],S=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],z=new Array(2*(l+2));i(z);var C=new Array(2*f);i(C);var E=new Array(512);i(E);var A=new Array(256);i(A);var I=new Array(a);i(I);var O,B,R,T=new Array(f);function D(t,e,r,i,n){this.static_tree=t,this.extra_bits=e,this.extra_base=r,this.elems=i,this.max_length=n,this.has_stree=t&&t.length}function F(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}function N(t){return t<256?E[t]:E[256+(t>>>7)]}function U(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255}function P(t,e,r){t.bi_valid>c-r?(t.bi_buf|=e<<t.bi_valid&65535,U(t,t.bi_buf),t.bi_buf=e>>c-t.bi_valid,t.bi_valid+=r-c):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=r)}function L(t,e,r){P(t,r[2*e],r[2*e+1])}function j(t,e){for(var r=0;r|=1&t,t>>>=1,r<<=1,0<--e;);return r>>>1}function Z(t,e,r){var i,n,s=new Array(g+1),a=0;for(i=1;i<=g;i++)s[i]=a=a+r[i-1]<<1;for(n=0;n<=e;n++){var o=t[2*n+1];0!==o&&(t[2*n]=j(s[o]++,o))}}function W(t){var e;for(e=0;e<l;e++)t.dyn_ltree[2*e]=0;for(e=0;e<f;e++)t.dyn_dtree[2*e]=0;for(e=0;e<d;e++)t.bl_tree[2*e]=0;t.dyn_ltree[2*m]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0}function M(t){8<t.bi_valid?U(t,t.bi_buf):0<t.bi_valid&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0}function H(t,e,r,i){var n=2*e,s=2*r;return t[n]<t[s]||t[n]===t[s]&&i[e]<=i[r]}function G(t,e,r){for(var i=t.heap[r],n=r<<1;n<=t.heap_len&&(n<t.heap_len&&H(e,t.heap[n+1],t.heap[n],t.depth)&&n++,!H(e,i,t.heap[n],t.depth));)t.heap[r]=t.heap[n],r=n,n<<=1;t.heap[r]=i}function K(t,e,r){var i,n,s,a,o=0;if(0!==t.last_lit)for(;i=t.pending_buf[t.d_buf+2*o]<<8|t.pending_buf[t.d_buf+2*o+1],n=t.pending_buf[t.l_buf+o],o++,0===i?L(t,n,e):(L(t,(s=A[n])+u+1,e),0!==(a=w[s])&&P(t,n-=I[s],a),L(t,s=N(--i),r),0!==(a=k[s])&&P(t,i-=T[s],a)),o<t.last_lit;);L(t,m,e)}function Y(t,e){var r,i,n,s=e.dyn_tree,a=e.stat_desc.static_tree,o=e.stat_desc.has_stree,h=e.stat_desc.elems,u=-1;for(t.heap_len=0,t.heap_max=_,r=0;r<h;r++)0!==s[2*r]?(t.heap[++t.heap_len]=u=r,t.depth[r]=0):s[2*r+1]=0;for(;t.heap_len<2;)s[2*(n=t.heap[++t.heap_len]=u<2?++u:0)]=1,t.depth[n]=0,t.opt_len--,o&&(t.static_len-=a[2*n+1]);for(e.max_code=u,r=t.heap_len>>1;1<=r;r--)G(t,s,r);for(n=h;r=t.heap[1],t.heap[1]=t.heap[t.heap_len--],G(t,s,1),i=t.heap[1],t.heap[--t.heap_max]=r,t.heap[--t.heap_max]=i,s[2*n]=s[2*r]+s[2*i],t.depth[n]=(t.depth[r]>=t.depth[i]?t.depth[r]:t.depth[i])+1,s[2*r+1]=s[2*i+1]=n,t.heap[1]=n++,G(t,s,1),2<=t.heap_len;);t.heap[--t.heap_max]=t.heap[1],function(t,e){var r,i,n,s,a,o,h=e.dyn_tree,u=e.max_code,l=e.stat_desc.static_tree,f=e.stat_desc.has_stree,d=e.stat_desc.extra_bits,c=e.stat_desc.extra_base,p=e.stat_desc.max_length,m=0;for(s=0;s<=g;s++)t.bl_count[s]=0;for(h[2*t.heap[t.heap_max]+1]=0,r=t.heap_max+1;r<_;r++)p<(s=h[2*h[2*(i=t.heap[r])+1]+1]+1)&&(s=p,m++),h[2*i+1]=s,u<i||(t.bl_count[s]++,a=0,c<=i&&(a=d[i-c]),o=h[2*i],t.opt_len+=o*(s+a),f&&(t.static_len+=o*(l[2*i+1]+a)));if(0!==m){do{for(s=p-1;0===t.bl_count[s];)s--;t.bl_count[s]--,t.bl_count[s+1]+=2,t.bl_count[p]--,m-=2}while(0<m);for(s=p;0!==s;s--)for(i=t.bl_count[s];0!==i;)u<(n=t.heap[--r])||(h[2*n+1]!==s&&(t.opt_len+=(s-h[2*n+1])*h[2*n],h[2*n+1]=s),i--)}}(t,e),Z(s,u,t.bl_count)}function X(t,e,r){var i,n,s=-1,a=e[1],o=0,h=7,u=4;for(0===a&&(h=138,u=3),e[2*(r+1)+1]=65535,i=0;i<=r;i++)n=a,a=e[2*(i+1)+1],++o<h&&n===a||(o<u?t.bl_tree[2*n]+=o:0!==n?(n!==s&&t.bl_tree[2*n]++,t.bl_tree[2*b]++):o<=10?t.bl_tree[2*v]++:t.bl_tree[2*y]++,s=n,u=(o=0)===a?(h=138,3):n===a?(h=6,3):(h=7,4))}function V(t,e,r){var i,n,s=-1,a=e[1],o=0,h=7,u=4;for(0===a&&(h=138,u=3),i=0;i<=r;i++)if(n=a,a=e[2*(i+1)+1],!(++o<h&&n===a)){if(o<u)for(;L(t,n,t.bl_tree),0!=--o;);else 0!==n?(n!==s&&(L(t,n,t.bl_tree),o--),L(t,b,t.bl_tree),P(t,o-3,2)):o<=10?(L(t,v,t.bl_tree),P(t,o-3,3)):(L(t,y,t.bl_tree),P(t,o-11,7));s=n,u=(o=0)===a?(h=138,3):n===a?(h=6,3):(h=7,4)}}i(T);var q=!1;function J(t,e,r,i){P(t,(s<<1)+(i?1:0),3),function(t,e,r,i){M(t),i&&(U(t,r),U(t,~r)),n.arraySet(t.pending_buf,t.window,e,r,t.pending),t.pending+=r}(t,e,r,!0)}r._tr_init=function(t){q||(function(){var t,e,r,i,n,s=new Array(g+1);for(i=r=0;i<a-1;i++)for(I[i]=r,t=0;t<1<<w[i];t++)A[r++]=i;for(A[r-1]=i,i=n=0;i<16;i++)for(T[i]=n,t=0;t<1<<k[i];t++)E[n++]=i;for(n>>=7;i<f;i++)for(T[i]=n<<7,t=0;t<1<<k[i]-7;t++)E[256+n++]=i;for(e=0;e<=g;e++)s[e]=0;for(t=0;t<=143;)z[2*t+1]=8,t++,s[8]++;for(;t<=255;)z[2*t+1]=9,t++,s[9]++;for(;t<=279;)z[2*t+1]=7,t++,s[7]++;for(;t<=287;)z[2*t+1]=8,t++,s[8]++;for(Z(z,l+1,s),t=0;t<f;t++)C[2*t+1]=5,C[2*t]=j(t,5);O=new D(z,w,u+1,l,g),B=new D(C,k,0,f,g),R=new D(new Array(0),x,0,d,p)}(),q=!0),t.l_desc=new F(t.dyn_ltree,O),t.d_desc=new F(t.dyn_dtree,B),t.bl_desc=new F(t.bl_tree,R),t.bi_buf=0,t.bi_valid=0,W(t)},r._tr_stored_block=J,r._tr_flush_block=function(t,e,r,i){var n,s,a=0;0<t.level?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,r=4093624447;for(e=0;e<=31;e++,r>>>=1)if(1&r&&0!==t.dyn_ltree[2*e])return o;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return h;for(e=32;e<u;e++)if(0!==t.dyn_ltree[2*e])return h;return o}(t)),Y(t,t.l_desc),Y(t,t.d_desc),a=function(t){var e;for(X(t,t.dyn_ltree,t.l_desc.max_code),X(t,t.dyn_dtree,t.d_desc.max_code),Y(t,t.bl_desc),e=d-1;3<=e&&0===t.bl_tree[2*S[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),n=t.opt_len+3+7>>>3,(s=t.static_len+3+7>>>3)<=n&&(n=s)):n=s=r+5,r+4<=n&&-1!==e?J(t,e,r,i):4===t.strategy||s===n?(P(t,2+(i?1:0),3),K(t,z,C)):(P(t,4+(i?1:0),3),function(t,e,r,i){var n;for(P(t,e-257,5),P(t,r-1,5),P(t,i-4,4),n=0;n<i;n++)P(t,t.bl_tree[2*S[n]+1],3);V(t,t.dyn_ltree,e-1),V(t,t.dyn_dtree,r-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,a+1),K(t,t.dyn_ltree,t.dyn_dtree)),W(t),i&&M(t)},r._tr_tally=function(t,e,r){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&r,t.last_lit++,0===e?t.dyn_ltree[2*r]++:(t.matches++,e--,t.dyn_ltree[2*(A[r]+u+1)]++,t.dyn_dtree[2*N(e)]++),t.last_lit===t.lit_bufsize-1},r._tr_align=function(t){P(t,2,3),L(t,m,z),function(t){16===t.bi_valid?(U(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):8<=t.bi_valid&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}},{"../utils/common":41}],53:[function(t,e,r){"use strict";e.exports=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0}},{}],54:[function(t,e,r){"use strict";e.exports="function"==typeof setImmediate?setImmediate:function(){var t=[].slice.apply(arguments);t.splice(1,0,0),setTimeout.apply(null,t)}},{}]},{},[10])(10)});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer)
},{"buffer":83}],89:[function(require,module,exports){
exports.Parser = require("./lib/parser").Parser;
exports.rules = require("./lib/rules");
exports.errors = require("./lib/errors");
exports.results = require("./lib/parsing-results");
exports.StringSource = require("./lib/StringSource");
exports.Token = require("./lib/Token");
exports.bottomUp = require("./lib/bottom-up");
exports.RegexTokeniser = require("./lib/regex-tokeniser").RegexTokeniser;

exports.rule = function(ruleBuilder) {
    var rule;
    return function(input) {
        if (!rule) {
            rule = ruleBuilder();
        }
        return rule(input);
    };
};

},{"./lib/StringSource":90,"./lib/Token":91,"./lib/bottom-up":93,"./lib/errors":94,"./lib/parser":96,"./lib/parsing-results":97,"./lib/regex-tokeniser":98,"./lib/rules":99}],90:[function(require,module,exports){
var StringSource = module.exports = function(string, description) {
    var self = {
        asString: function() {
            return string;
        },
        range: function(startIndex, endIndex) {
            return new StringSourceRange(string, description, startIndex, endIndex);
        }
    };
    return self;
};

var StringSourceRange = function(string, description, startIndex, endIndex) {
    this._string = string;
    this._description = description;
    this._startIndex = startIndex;
    this._endIndex = endIndex;
};

StringSourceRange.prototype.to = function(otherRange) {
    // TODO: Assert that tokens are the same across both iterators
    return new StringSourceRange(this._string, this._description, this._startIndex, otherRange._endIndex);
};

StringSourceRange.prototype.describe = function() {
    var position = this._position();
    var description = this._description ? this._description + "\n" : "";
    return description + "Line number: " + position.lineNumber + "\nCharacter number: " + position.characterNumber;
};

StringSourceRange.prototype.lineNumber = function() {
    return this._position().lineNumber;
};

StringSourceRange.prototype.characterNumber = function() {
    return this._position().characterNumber;
};

StringSourceRange.prototype._position = function() {
    var self = this;
    var index = 0;
    var nextNewLine = function() {
        return self._string.indexOf("\n", index);
    };

    var lineNumber = 1;
    while (nextNewLine() !== -1 && nextNewLine() < this._startIndex) {
        index = nextNewLine() + 1;
        lineNumber += 1;
    }
    var characterNumber = this._startIndex - index + 1;
    return {lineNumber: lineNumber, characterNumber: characterNumber};
};

},{}],91:[function(require,module,exports){
module.exports = function(name, value, source) {
    this.name = name;
    this.value = value;
    if (source) {
        this.source = source;
    }
};

},{}],92:[function(require,module,exports){
var TokenIterator = module.exports = function(tokens, startIndex) {
    this._tokens = tokens;
    this._startIndex = startIndex || 0;
};

TokenIterator.prototype.head = function() {
    return this._tokens[this._startIndex];
};

TokenIterator.prototype.tail = function(startIndex) {
    return new TokenIterator(this._tokens, this._startIndex + 1);
};

TokenIterator.prototype.toArray = function() {
    return this._tokens.slice(this._startIndex);
};

TokenIterator.prototype.end = function() {
    return this._tokens[this._tokens.length - 1];
};

// TODO: doesn't need to be a method, can be a separate function,
// which simplifies implementation of the TokenIterator interface
TokenIterator.prototype.to = function(end) {
    var start = this.head().source;
    var endToken = end.head() || end.end();
    return start.to(endToken.source);
};

},{}],93:[function(require,module,exports){
var rules = require("./rules");
var results = require("./parsing-results");

exports.parser = function(name, prefixRules, infixRuleBuilders) {
    var self = {
        rule: rule,
        leftAssociative: leftAssociative,
        rightAssociative: rightAssociative
    };
    
    var infixRules = new InfixRules(infixRuleBuilders.map(createInfixRule));
    var prefixRule = rules.firstOf(name, prefixRules);
    
    function createInfixRule(infixRuleBuilder) {
        return {
            name: infixRuleBuilder.name,
            rule: lazyRule(infixRuleBuilder.ruleBuilder.bind(null, self))
        };
    }
    
    function rule() {
        return createRule(infixRules);
    }
    
    function leftAssociative(name) {
        return createRule(infixRules.untilExclusive(name));
    }
    
    function rightAssociative(name) {
        return createRule(infixRules.untilInclusive(name));
    }
    
    function createRule(infixRules) {
        return apply.bind(null, infixRules);
    }
    
    function apply(infixRules, tokens) {
        var leftResult = prefixRule(tokens);
        if (leftResult.isSuccess()) {
            return infixRules.apply(leftResult);
        } else {
            return leftResult;
        }
    }
    
    return self;
};

function InfixRules(infixRules) {
    function untilExclusive(name) {
        return new InfixRules(infixRules.slice(0, ruleNames().indexOf(name)));
    }
    
    function untilInclusive(name) {
        return new InfixRules(infixRules.slice(0, ruleNames().indexOf(name) + 1));
    }
    
    function ruleNames() {
        return infixRules.map(function(rule) {
            return rule.name;
        });
    }
    
    function apply(leftResult) {
        var currentResult;
        var source;
        while (true) {
            currentResult = applyToTokens(leftResult.remaining());
            if (currentResult.isSuccess()) {
                source = leftResult.source().to(currentResult.source());
                leftResult = results.success(
                    currentResult.value()(leftResult.value(), source),
                    currentResult.remaining(),
                    source
                )
            } else if (currentResult.isFailure()) {
                return leftResult;
            } else {
                return currentResult;
            }
        }
    }
    
    function applyToTokens(tokens) {
        return rules.firstOf("infix", infixRules.map(function(infix) {
            return infix.rule;
        }))(tokens);
    }
    
    return {
        apply: apply,
        untilExclusive: untilExclusive,
        untilInclusive: untilInclusive
    }
}

exports.infix = function(name, ruleBuilder) {
    function map(func) {
        return exports.infix(name, function(parser) {
            var rule = ruleBuilder(parser);
            return function(tokens) {
                var result = rule(tokens);
                return result.map(function(right) {
                    return function(left, source) {
                        return func(left, right, source);
                    };
                });
            };
        });
    }
    
    return {
        name: name,
        ruleBuilder: ruleBuilder,
        map: map
    };
}

// TODO: move into a sensible place and remove duplication
var lazyRule = function(ruleBuilder) {
    var rule;
    return function(input) {
        if (!rule) {
            rule = ruleBuilder();
        }
        return rule(input);
    };
};

},{"./parsing-results":97,"./rules":99}],94:[function(require,module,exports){
exports.error = function(options) {
    return new Error(options);
};

var Error = function(options) {
    this.expected = options.expected;
    this.actual = options.actual;
    this._location = options.location;
};

Error.prototype.describe = function() {
    var locationDescription = this._location ? this._location.describe() + ":\n" : "";
    return locationDescription + "Expected " + this.expected + "\nbut got " + this.actual;
};

Error.prototype.lineNumber = function() {
    return this._location.lineNumber();
};

Error.prototype.characterNumber = function() {
    return this._location.characterNumber();
};

},{}],95:[function(require,module,exports){
var fromArray = exports.fromArray = function(array) {
    var index = 0;
    var hasNext = function() {
        return index < array.length;
    };
    return new LazyIterator({
        hasNext: hasNext,
        next: function() {
            if (!hasNext()) {
                throw new Error("No more elements");
            } else {
                return array[index++];
            }
        }
    });
};

var LazyIterator = function(iterator) {
    this._iterator = iterator;
};

LazyIterator.prototype.map = function(func) {
    var iterator = this._iterator;
    return new LazyIterator({
        hasNext: function() {
            return iterator.hasNext();
        },
        next: function() {
            return func(iterator.next());
        }
    });
};

LazyIterator.prototype.filter = function(condition) {
    var iterator = this._iterator;
    
    var moved = false;
    var hasNext = false;
    var next;
    var moveIfNecessary = function() {
        if (moved) {
            return;
        }
        moved = true;
        hasNext = false;
        while (iterator.hasNext() && !hasNext) {
            next = iterator.next();
            hasNext = condition(next);
        }
    };
    
    return new LazyIterator({
        hasNext: function() {
            moveIfNecessary();
            return hasNext;
        },
        next: function() {
            moveIfNecessary();
            var toReturn = next;
            moved = false;
            return toReturn;
        }
    });
};

LazyIterator.prototype.first = function() {
    var iterator = this._iterator;
    if (this._iterator.hasNext()) {
        return iterator.next();
    } else {
        return null;
    }
};

LazyIterator.prototype.toArray = function() {
    var result = [];
    while (this._iterator.hasNext()) {
        result.push(this._iterator.next());
    }
    return result;
};

},{}],96:[function(require,module,exports){
var TokenIterator = require("./TokenIterator");

exports.Parser = function(options) {
    var parseTokens = function(parser, tokens) {
        return parser(new TokenIterator(tokens));
    };
    
    return {
        parseTokens: parseTokens
    };
};

},{"./TokenIterator":92}],97:[function(require,module,exports){
module.exports = {
    failure: function(errors, remaining) {
        if (errors.length < 1) {
            throw new Error("Failure must have errors");
        }
        return new Result({
            status: "failure",
            remaining: remaining,
            errors: errors
        });
    },
    error: function(errors, remaining) {
        if (errors.length < 1) {
            throw new Error("Failure must have errors");
        }
        return new Result({
            status: "error",
            remaining: remaining,
            errors: errors
        });
    },
    success: function(value, remaining, source) {
        return new Result({
            status: "success",
            value: value,
            source: source,
            remaining: remaining,
            errors: []
        });
    },
    cut: function(remaining) {
        return new Result({
            status: "cut",
            remaining: remaining,
            errors: []
        });
    }
};

var Result = function(options) {
    this._value = options.value;
    this._status = options.status;
    this._hasValue = options.value !== undefined;
    this._remaining = options.remaining;
    this._source = options.source;
    this._errors = options.errors;
};

Result.prototype.map = function(func) {
    if (this._hasValue) {
        return new Result({
            value: func(this._value, this._source),
            status: this._status,
            remaining: this._remaining,
            source: this._source,
            errors: this._errors
        });
    } else {
        return this;
    }
};

Result.prototype.changeRemaining = function(remaining) {
    return new Result({
        value: this._value,
        status: this._status,
        remaining: remaining,
        source: this._source,
        errors: this._errors
    });
};

Result.prototype.isSuccess = function() {
    return this._status === "success" || this._status === "cut";
};

Result.prototype.isFailure = function() {
    return this._status === "failure";
};

Result.prototype.isError = function() {
    return this._status === "error";
};

Result.prototype.isCut = function() {
    return this._status === "cut";
};

Result.prototype.value = function() {
    return this._value;
};

Result.prototype.remaining = function() {
    return this._remaining;
};

Result.prototype.source = function() {
    return this._source;
};

Result.prototype.errors = function() {
    return this._errors;
};

},{}],98:[function(require,module,exports){
var Token = require("./Token");
var StringSource = require("./StringSource");

exports.RegexTokeniser = RegexTokeniser;

function RegexTokeniser(rules) {
    rules = rules.map(function(rule) {
        return {
            name: rule.name,
            regex: new RegExp(rule.regex.source, "g")
        };
    });
    
    function tokenise(input, description) {
        var source = new StringSource(input, description);
        var index = 0;
        var tokens = [];
    
        while (index < input.length) {
            var result = readNextToken(input, index, source);
            index = result.endIndex;
            tokens.push(result.token);
        }
        
        tokens.push(endToken(input, source));
        return tokens;
    }

    function readNextToken(string, startIndex, source) {
        for (var i = 0; i < rules.length; i++) {
            var regex = rules[i].regex;
            regex.lastIndex = startIndex;
            var result = regex.exec(string);
            
            if (result) {
                var endIndex = startIndex + result[0].length;
                if (result.index === startIndex && endIndex > startIndex) {
                    var value = result[1];
                    var token = new Token(
                        rules[i].name,
                        value,
                        source.range(startIndex, endIndex)
                    );
                    return {token: token, endIndex: endIndex};
                }
            }
        }
        var endIndex = startIndex + 1;
        var token = new Token(
            "unrecognisedCharacter",
            string.substring(startIndex, endIndex),
            source.range(startIndex, endIndex)
        );
        return {token: token, endIndex: endIndex};
    }
    
    function endToken(input, source) {
        return new Token(
            "end",
            null,
            source.range(input.length, input.length)
        );
    }
    
    return {
        tokenise: tokenise
    }
}



},{"./StringSource":90,"./Token":91}],99:[function(require,module,exports){
var _ = require("underscore");
var options = require("option");
var results = require("./parsing-results");
var errors = require("./errors");
var lazyIterators = require("./lazy-iterators");

exports.token = function(tokenType, value) {
    var matchValue = value !== undefined;
    return function(input) {
        var token = input.head();
        if (token && token.name === tokenType && (!matchValue || token.value === value)) {
            return results.success(token.value, input.tail(), token.source);
        } else {
            var expected = describeToken({name: tokenType, value: value});
            return describeTokenMismatch(input, expected);
        }
    };
};

exports.tokenOfType = function(tokenType) {
    return exports.token(tokenType);
};

exports.firstOf = function(name, parsers) {
    if (!_.isArray(parsers)) {
        parsers = Array.prototype.slice.call(arguments, 1);
    }
    return function(input) {
        return lazyIterators
            .fromArray(parsers)
            .map(function(parser) {
                return parser(input);
            })
            .filter(function(result) {
                return result.isSuccess() || result.isError();
            })
            .first() || describeTokenMismatch(input, name);
    };
};

exports.then = function(parser, func) {
    return function(input) {
        var result = parser(input);
        if (!result.map) {
            console.log(result);
        }
        return result.map(func);
    };
};

exports.sequence = function() {
    var parsers = Array.prototype.slice.call(arguments, 0);
    var rule = function(input) {
        var result = _.foldl(parsers, function(memo, parser) {
            var result = memo.result;
            var hasCut = memo.hasCut;
            if (!result.isSuccess()) {
                return {result: result, hasCut: hasCut};
            }
            var subResult = parser(result.remaining());
            if (subResult.isCut()) {
                return {result: result, hasCut: true};
            } else if (subResult.isSuccess()) {
                var values;
                if (parser.isCaptured) {
                    values = result.value().withValue(parser, subResult.value());
                } else {
                    values = result.value();
                }
                var remaining = subResult.remaining();
                var source = input.to(remaining);
                return {
                    result: results.success(values, remaining, source),
                    hasCut: hasCut
                };
            } else if (hasCut) {
                return {result: results.error(subResult.errors(), subResult.remaining()), hasCut: hasCut};
            } else {
                return {result: subResult, hasCut: hasCut};
            }
        }, {result: results.success(new SequenceValues(), input), hasCut: false}).result;
        var source = input.to(result.remaining());
        return result.map(function(values) {
            return values.withValue(exports.sequence.source, source);
        });
    };
    rule.head = function() {
        var firstCapture = _.find(parsers, isCapturedRule);
        return exports.then(
            rule,
            exports.sequence.extract(firstCapture)
        );
    };
    rule.map = function(func) {
        return exports.then(
            rule,
            function(result) {
                return func.apply(this, result.toArray());
            }
        );
    };
    
    function isCapturedRule(subRule) {
        return subRule.isCaptured;
    }
    
    return rule;
};

var SequenceValues = function(values, valuesArray) {
    this._values = values || {};
    this._valuesArray = valuesArray || [];
};

SequenceValues.prototype.withValue = function(rule, value) {
    if (rule.captureName && rule.captureName in this._values) {
        throw new Error("Cannot add second value for capture \"" + rule.captureName + "\"");
    } else {
        var newValues = _.clone(this._values);
        newValues[rule.captureName] = value;
        var newValuesArray = this._valuesArray.concat([value]);
        return new SequenceValues(newValues, newValuesArray);
    }
};

SequenceValues.prototype.get = function(rule) {
    if (rule.captureName in this._values) {
        return this._values[rule.captureName];
    } else {
        throw new Error("No value for capture \"" + rule.captureName + "\"");
    }
};

SequenceValues.prototype.toArray = function() {
    return this._valuesArray;
};

exports.sequence.capture = function(rule, name) {
    var captureRule = function() {
        return rule.apply(this, arguments);
    };
    captureRule.captureName = name;
    captureRule.isCaptured = true;
    return captureRule;
};

exports.sequence.extract = function(rule) {
    return function(result) {
        return result.get(rule);
    };
};

exports.sequence.applyValues = function(func) {
    // TODO: check captureName doesn't conflict with source or other captures
    var rules = Array.prototype.slice.call(arguments, 1);
    return function(result) {
        var values = rules.map(function(rule) {
            return result.get(rule);
        });
        return func.apply(this, values);
    };
};

exports.sequence.source = {
    captureName: "☃source☃"
};

exports.sequence.cut = function() {
    return function(input) {
        return results.cut(input);
    };
};

exports.optional = function(rule) {
    return function(input) {
        var result = rule(input);
        if (result.isSuccess()) {
            return result.map(options.some);
        } else if (result.isFailure()) {
            return results.success(options.none, input);
        } else {
            return result;
        }
    };
};

exports.zeroOrMoreWithSeparator = function(rule, separator) {
    return repeatedWithSeparator(rule, separator, false);
};

exports.oneOrMoreWithSeparator = function(rule, separator) {
    return repeatedWithSeparator(rule, separator, true);
};

var zeroOrMore = exports.zeroOrMore = function(rule) {
    return function(input) {
        var values = [];
        var result;
        while ((result = rule(input)) && result.isSuccess()) {
            input = result.remaining();
            values.push(result.value());
        }
        if (result.isError()) {
            return result;
        } else {
            return results.success(values, input);
        }
    };
};

exports.oneOrMore = function(rule) {
    return exports.oneOrMoreWithSeparator(rule, noOpRule);
};

function noOpRule(input) {
    return results.success(null, input);
}

var repeatedWithSeparator = function(rule, separator, isOneOrMore) {
    return function(input) {
        var result = rule(input);
        if (result.isSuccess()) {
            var mainRule = exports.sequence.capture(rule, "main");
            var remainingRule = zeroOrMore(exports.then(
                exports.sequence(separator, mainRule),
                exports.sequence.extract(mainRule)
            ));
            var remainingResult = remainingRule(result.remaining());
            return results.success([result.value()].concat(remainingResult.value()), remainingResult.remaining());
        } else if (isOneOrMore || result.isError()) {
            return result;
        } else {
            return results.success([], input);
        }
    };
};

exports.leftAssociative = function(leftRule, rightRule, func) {
    var rights;
    if (func) {
        rights = [{func: func, rule: rightRule}];
    } else {
        rights = rightRule;
    }
    rights = rights.map(function(right) {
        return exports.then(right.rule, function(rightValue) {
            return function(leftValue, source) {
                return right.func(leftValue, rightValue, source);
            };
        });
    });
    var repeatedRule = exports.firstOf.apply(null, ["rules"].concat(rights));
    
    return function(input) {
        var start = input;
        var leftResult = leftRule(input);
        if (!leftResult.isSuccess()) {
            return leftResult;
        }
        var repeatedResult = repeatedRule(leftResult.remaining());
        while (repeatedResult.isSuccess()) {
            var remaining = repeatedResult.remaining();
            var source = start.to(repeatedResult.remaining());
            var right = repeatedResult.value();
            leftResult = results.success(
                right(leftResult.value(), source),
                remaining,
                source
            );
            repeatedResult = repeatedRule(leftResult.remaining());
        }
        if (repeatedResult.isError()) {
            return repeatedResult;
        }
        return leftResult;
    };
};

exports.leftAssociative.firstOf = function() {
    return Array.prototype.slice.call(arguments, 0);
};

exports.nonConsuming = function(rule) {
    return function(input) {
        return rule(input).changeRemaining(input);
    };
};

var describeToken = function(token) {
    if (token.value) {
        return token.name + " \"" + token.value + "\"";
    } else {
        return token.name;
    }
};

function describeTokenMismatch(input, expected) {
    var error;
    var token = input.head();
    if (token) {
        error = errors.error({
            expected: expected,
            actual: describeToken(token),
            location: token.source
        });
    } else {
        error = errors.error({
            expected: expected,
            actual: "end of tokens"
        });
    }
    return results.failure([error], input);
}

},{"./errors":94,"./lazy-iterators":95,"./parsing-results":97,"option":100,"underscore":102}],100:[function(require,module,exports){
exports.none = Object.create({
    value: function() {
        throw new Error('Called value on none');
    },
    isNone: function() {
        return true;
    },
    isSome: function() {
        return false;
    },
    map: function() {
        return exports.none;
    },
    flatMap: function() {
        return exports.none;
    },
    filter: function() {
        return exports.none;
    },
    toArray: function() {
        return [];
    },
    orElse: callOrReturn,
    valueOrElse: callOrReturn
});

function callOrReturn(value) {
    if (typeof(value) == "function") {
        return value();
    } else {
        return value;
    }
}

exports.some = function(value) {
    return new Some(value);
};

var Some = function(value) {
    this._value = value;
};

Some.prototype.value = function() {
    return this._value;
};

Some.prototype.isNone = function() {
    return false;
};

Some.prototype.isSome = function() {
    return true;
};

Some.prototype.map = function(func) {
    return new Some(func(this._value));
};

Some.prototype.flatMap = function(func) {
    return func(this._value);
};

Some.prototype.filter = function(predicate) {
    return predicate(this._value) ? this : exports.none;
};

Some.prototype.toArray = function() {
    return [this._value];
};

Some.prototype.orElse = function(value) {
    return this;
};

Some.prototype.valueOrElse = function(value) {
    return this._value;
};

exports.isOption = function(value) {
    return value === exports.none || value instanceof Some;
};

exports.fromNullable = function(value) {
    if (value == null) {
        return exports.none;
    }
    return new Some(value);
}

},{}],101:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],102:[function(require,module,exports){
(function (global){
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define('underscore', factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
    var current = global._;
    var exports = global._ = factory();
    exports.noConflict = function () { global._ = current; return exports; };
  }()));
}(this, (function () {
  //     Underscore.js 1.13.1
  //     https://underscorejs.org
  //     (c) 2009-2021 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
  //     Underscore may be freely distributed under the MIT license.

  // Current version.
  var VERSION = '1.13.1';

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
            typeof global == 'object' && global.global === global && global ||
            Function('return this')() ||
            {};

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // Modern feature detection.
  var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
      supportsDataView = typeof DataView !== 'undefined';

  // All **ECMAScript 5+** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create,
      nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;

  // Create references to these builtin functions because we override them.
  var _isNaN = isNaN,
      _isFinite = isFinite;

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  // The largest integer that can be represented exactly.
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  function restArguments(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  }

  // Is a given variable an object?
  function isObject(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  }

  // Is a given value equal to null?
  function isNull(obj) {
    return obj === null;
  }

  // Is a given variable undefined?
  function isUndefined(obj) {
    return obj === void 0;
  }

  // Is a given value a boolean?
  function isBoolean(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  }

  // Is a given value a DOM element?
  function isElement(obj) {
    return !!(obj && obj.nodeType === 1);
  }

  // Internal function for creating a `toString`-based type tester.
  function tagTester(name) {
    var tag = '[object ' + name + ']';
    return function(obj) {
      return toString.call(obj) === tag;
    };
  }

  var isString = tagTester('String');

  var isNumber = tagTester('Number');

  var isDate = tagTester('Date');

  var isRegExp = tagTester('RegExp');

  var isError = tagTester('Error');

  var isSymbol = tagTester('Symbol');

  var isArrayBuffer = tagTester('ArrayBuffer');

  var isFunction = tagTester('Function');

  // Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
  // v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  var isFunction$1 = isFunction;

  var hasObjectTag = tagTester('Object');

  // In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
  // In IE 11, the most common among them, this problem also applies to
  // `Map`, `WeakMap` and `Set`.
  var hasStringTagBug = (
        supportsDataView && hasObjectTag(new DataView(new ArrayBuffer(8)))
      ),
      isIE11 = (typeof Map !== 'undefined' && hasObjectTag(new Map));

  var isDataView = tagTester('DataView');

  // In IE 10 - Edge 13, we need a different heuristic
  // to determine whether an object is a `DataView`.
  function ie10IsDataView(obj) {
    return obj != null && isFunction$1(obj.getInt8) && isArrayBuffer(obj.buffer);
  }

  var isDataView$1 = (hasStringTagBug ? ie10IsDataView : isDataView);

  // Is a given value an array?
  // Delegates to ECMA5's native `Array.isArray`.
  var isArray = nativeIsArray || tagTester('Array');

  // Internal function to check whether `key` is an own property name of `obj`.
  function has$1(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  }

  var isArguments = tagTester('Arguments');

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  (function() {
    if (!isArguments(arguments)) {
      isArguments = function(obj) {
        return has$1(obj, 'callee');
      };
    }
  }());

  var isArguments$1 = isArguments;

  // Is a given object a finite number?
  function isFinite$1(obj) {
    return !isSymbol(obj) && _isFinite(obj) && !isNaN(parseFloat(obj));
  }

  // Is the given value `NaN`?
  function isNaN$1(obj) {
    return isNumber(obj) && _isNaN(obj);
  }

  // Predicate-generating function. Often useful outside of Underscore.
  function constant(value) {
    return function() {
      return value;
    };
  }

  // Common internal logic for `isArrayLike` and `isBufferLike`.
  function createSizePropertyCheck(getSizeProperty) {
    return function(collection) {
      var sizeProperty = getSizeProperty(collection);
      return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= MAX_ARRAY_INDEX;
    }
  }

  // Internal helper to generate a function to obtain property `key` from `obj`.
  function shallowProperty(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  }

  // Internal helper to obtain the `byteLength` property of an object.
  var getByteLength = shallowProperty('byteLength');

  // Internal helper to determine whether we should spend extensive checks against
  // `ArrayBuffer` et al.
  var isBufferLike = createSizePropertyCheck(getByteLength);

  // Is a given value a typed array?
  var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
  function isTypedArray(obj) {
    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
    // Otherwise, fall back on the above regular expression.
    return nativeIsView ? (nativeIsView(obj) && !isDataView$1(obj)) :
                  isBufferLike(obj) && typedArrayPattern.test(toString.call(obj));
  }

  var isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(false);

  // Internal helper to obtain the `length` property of an object.
  var getLength = shallowProperty('length');

  // Internal helper to create a simple lookup structure.
  // `collectNonEnumProps` used to depend on `_.contains`, but this led to
  // circular imports. `emulatedSet` is a one-off solution that only works for
  // arrays of strings.
  function emulatedSet(keys) {
    var hash = {};
    for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
    return {
      contains: function(key) { return hash[key]; },
      push: function(key) {
        hash[key] = true;
        return keys.push(key);
      }
    };
  }

  // Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
  // be iterated by `for key in ...` and thus missed. Extends `keys` in place if
  // needed.
  function collectNonEnumProps(obj, keys) {
    keys = emulatedSet(keys);
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = isFunction$1(constructor) && constructor.prototype || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (has$1(obj, prop) && !keys.contains(prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  function keys(obj) {
    if (!isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (has$1(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  }

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  function isEmpty(obj) {
    if (obj == null) return true;
    // Skip the more expensive `toString`-based type checks if `obj` has no
    // `.length`.
    var length = getLength(obj);
    if (typeof length == 'number' && (
      isArray(obj) || isString(obj) || isArguments$1(obj)
    )) return length === 0;
    return getLength(keys(obj)) === 0;
  }

  // Returns whether an object has a given set of `key:value` pairs.
  function isMatch(object, attrs) {
    var _keys = keys(attrs), length = _keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = _keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  }

  // If Underscore is called as a function, it returns a wrapped object that can
  // be used OO-style. This wrapper holds altered versions of all functions added
  // through `_.mixin`. Wrapped objects may be chained.
  function _$1(obj) {
    if (obj instanceof _$1) return obj;
    if (!(this instanceof _$1)) return new _$1(obj);
    this._wrapped = obj;
  }

  _$1.VERSION = VERSION;

  // Extracts the result from a wrapped and chained object.
  _$1.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxies for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _$1.prototype.valueOf = _$1.prototype.toJSON = _$1.prototype.value;

  _$1.prototype.toString = function() {
    return String(this._wrapped);
  };

  // Internal function to wrap or shallow-copy an ArrayBuffer,
  // typed array or DataView to a new view, reusing the buffer.
  function toBufferView(bufferSource) {
    return new Uint8Array(
      bufferSource.buffer || bufferSource,
      bufferSource.byteOffset || 0,
      getByteLength(bufferSource)
    );
  }

  // We use this string twice, so give it a name for minification.
  var tagDataView = '[object DataView]';

  // Internal recursive comparison function for `_.isEqual`.
  function eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  }

  // Internal recursive comparison function for `_.isEqual`.
  function deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _$1) a = a._wrapped;
    if (b instanceof _$1) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    // Work around a bug in IE 10 - Edge 13.
    if (hasStringTagBug && className == '[object Object]' && isDataView$1(a)) {
      if (!isDataView$1(b)) return false;
      className = tagDataView;
    }
    switch (className) {
      // These types are compared by value.
      case '[object RegExp]':
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
      case '[object ArrayBuffer]':
      case tagDataView:
        // Coerce to typed array so we can fall through.
        return deepEq(toBufferView(a), toBufferView(b), aStack, bStack);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays && isTypedArray$1(a)) {
        var byteLength = getByteLength(a);
        if (byteLength !== getByteLength(b)) return false;
        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
        areArrays = true;
    }
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(isFunction$1(aCtor) && aCtor instanceof aCtor &&
                               isFunction$1(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var _keys = keys(a), key;
      length = _keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = _keys[length];
        if (!(has$1(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  }

  // Perform a deep comparison to check if two objects are equal.
  function isEqual(a, b) {
    return eq(a, b);
  }

  // Retrieve all the enumerable property names of an object.
  function allKeys(obj) {
    if (!isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  }

  // Since the regular `Object.prototype.toString` type tests don't work for
  // some types in IE 11, we use a fingerprinting heuristic instead, based
  // on the methods. It's not great, but it's the best we got.
  // The fingerprint method lists are defined below.
  function ie11fingerprint(methods) {
    var length = getLength(methods);
    return function(obj) {
      if (obj == null) return false;
      // `Map`, `WeakMap` and `Set` have no enumerable keys.
      var keys = allKeys(obj);
      if (getLength(keys)) return false;
      for (var i = 0; i < length; i++) {
        if (!isFunction$1(obj[methods[i]])) return false;
      }
      // If we are testing against `WeakMap`, we need to ensure that
      // `obj` doesn't have a `forEach` method in order to distinguish
      // it from a regular `Map`.
      return methods !== weakMapMethods || !isFunction$1(obj[forEachName]);
    };
  }

  // In the interest of compact minification, we write
  // each string in the fingerprints only once.
  var forEachName = 'forEach',
      hasName = 'has',
      commonInit = ['clear', 'delete'],
      mapTail = ['get', hasName, 'set'];

  // `Map`, `WeakMap` and `Set` each have slightly different
  // combinations of the above sublists.
  var mapMethods = commonInit.concat(forEachName, mapTail),
      weakMapMethods = commonInit.concat(mapTail),
      setMethods = ['add'].concat(commonInit, forEachName, hasName);

  var isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map');

  var isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester('WeakMap');

  var isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester('Set');

  var isWeakSet = tagTester('WeakSet');

  // Retrieve the values of an object's properties.
  function values(obj) {
    var _keys = keys(obj);
    var length = _keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[_keys[i]];
    }
    return values;
  }

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of `_.object` with one argument.
  function pairs(obj) {
    var _keys = keys(obj);
    var length = _keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [_keys[i], obj[_keys[i]]];
    }
    return pairs;
  }

  // Invert the keys and values of an object. The values must be serializable.
  function invert(obj) {
    var result = {};
    var _keys = keys(obj);
    for (var i = 0, length = _keys.length; i < length; i++) {
      result[obj[_keys[i]]] = _keys[i];
    }
    return result;
  }

  // Return a sorted list of the function names available on the object.
  function functions(obj) {
    var names = [];
    for (var key in obj) {
      if (isFunction$1(obj[key])) names.push(key);
    }
    return names.sort();
  }

  // An internal function for creating assigner functions.
  function createAssigner(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  }

  // Extend a given object with all the properties in passed-in object(s).
  var extend = createAssigner(allKeys);

  // Assigns a given object with all the own properties in the passed-in
  // object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  var extendOwn = createAssigner(keys);

  // Fill in a given object with default properties.
  var defaults = createAssigner(allKeys, true);

  // Create a naked function reference for surrogate-prototype-swapping.
  function ctor() {
    return function(){};
  }

  // An internal function for creating a new object that inherits from another.
  function baseCreate(prototype) {
    if (!isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    var Ctor = ctor();
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  }

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  function create(prototype, props) {
    var result = baseCreate(prototype);
    if (props) extendOwn(result, props);
    return result;
  }

  // Create a (shallow-cloned) duplicate of an object.
  function clone(obj) {
    if (!isObject(obj)) return obj;
    return isArray(obj) ? obj.slice() : extend({}, obj);
  }

  // Invokes `interceptor` with the `obj` and then returns `obj`.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  function tap(obj, interceptor) {
    interceptor(obj);
    return obj;
  }

  // Normalize a (deep) property `path` to array.
  // Like `_.iteratee`, this function can be customized.
  function toPath$1(path) {
    return isArray(path) ? path : [path];
  }
  _$1.toPath = toPath$1;

  // Internal wrapper for `_.toPath` to enable minification.
  // Similar to `cb` for `_.iteratee`.
  function toPath(path) {
    return _$1.toPath(path);
  }

  // Internal function to obtain a nested property in `obj` along `path`.
  function deepGet(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  }

  // Get the value of the (deep) property on `path` from `object`.
  // If any property in `path` does not exist or if the value is
  // `undefined`, return `defaultValue` instead.
  // The `path` is normalized through `_.toPath`.
  function get(object, path, defaultValue) {
    var value = deepGet(object, toPath(path));
    return isUndefined(value) ? defaultValue : value;
  }

  // Shortcut function for checking if an object has a given property directly on
  // itself (in other words, not on a prototype). Unlike the internal `has`
  // function, this public version can also traverse nested properties.
  function has(obj, path) {
    path = toPath(path);
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (!has$1(obj, key)) return false;
      obj = obj[key];
    }
    return !!length;
  }

  // Keep the identity function around for default iteratees.
  function identity(value) {
    return value;
  }

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  function matcher(attrs) {
    attrs = extendOwn({}, attrs);
    return function(obj) {
      return isMatch(obj, attrs);
    };
  }

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indices.
  function property(path) {
    path = toPath(path);
    return function(obj) {
      return deepGet(obj, path);
    };
  }

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  function optimizeCb(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  }

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `_.identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  function baseIteratee(value, context, argCount) {
    if (value == null) return identity;
    if (isFunction$1(value)) return optimizeCb(value, context, argCount);
    if (isObject(value) && !isArray(value)) return matcher(value);
    return property(value);
  }

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only `argCount` argument.
  function iteratee(value, context) {
    return baseIteratee(value, context, Infinity);
  }
  _$1.iteratee = iteratee;

  // The function we call internally to generate a callback. It invokes
  // `_.iteratee` if overridden, otherwise `baseIteratee`.
  function cb(value, context, argCount) {
    if (_$1.iteratee !== iteratee) return _$1.iteratee(value, context);
    return baseIteratee(value, context, argCount);
  }

  // Returns the results of applying the `iteratee` to each element of `obj`.
  // In contrast to `_.map` it returns an object.
  function mapObject(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var _keys = keys(obj),
        length = _keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = _keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  }

  // Predicate-generating function. Often useful outside of Underscore.
  function noop(){}

  // Generates a function for a given object that returns a given property.
  function propertyOf(obj) {
    if (obj == null) return noop;
    return function(path) {
      return get(obj, path);
    };
  }

  // Run a function **n** times.
  function times(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  }

  // Return a random integer between `min` and `max` (inclusive).
  function random(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  }

  // A (possibly faster) way to get the current timestamp as an integer.
  var now = Date.now || function() {
    return new Date().getTime();
  };

  // Internal helper to generate functions for escaping and unescaping strings
  // to/from HTML interpolation.
  function createEscaper(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  }

  // Internal list of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };

  // Function for escaping strings to HTML interpolation.
  var _escape = createEscaper(escapeMap);

  // Internal list of HTML entities for unescaping.
  var unescapeMap = invert(escapeMap);

  // Function for unescaping strings from HTML interpolation.
  var _unescape = createEscaper(unescapeMap);

  // By default, Underscore uses ERB-style template delimiters. Change the
  // following template settings to use alternative delimiters.
  var templateSettings = _$1.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `_.templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  function escapeChar(match) {
    return '\\' + escapes[match];
  }

  // In order to prevent third-party code injection through
  // `_.templateSettings.variable`, we test it against the following regular
  // expression. It is intentionally a bit more liberal than just matching valid
  // identifiers, but still prevents possible loopholes through defaults or
  // destructuring assignment.
  var bareIdentifier = /^\s*(\w|\$)+\s*$/;

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  function template(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = defaults({}, settings, _$1.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    var argument = settings.variable;
    if (argument) {
      // Insure against third-party code injection. (CVE-2021-23358)
      if (!bareIdentifier.test(argument)) throw new Error(
        'variable is not a bare identifier: ' + argument
      );
    } else {
      // If a variable is not specified, place data values in local scope.
      source = 'with(obj||{}){\n' + source + '}\n';
      argument = 'obj';
    }

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(argument, '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _$1);
    };

    // Provide the compiled source as a convenience for precompilation.
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  }

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  function result(obj, path, fallback) {
    path = toPath(path);
    var length = path.length;
    if (!length) {
      return isFunction$1(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = isFunction$1(prop) ? prop.call(obj) : prop;
    }
    return obj;
  }

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  function uniqueId(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  }

  // Start chaining a wrapped Underscore object.
  function chain(obj) {
    var instance = _$1(obj);
    instance._chain = true;
    return instance;
  }

  // Internal function to execute `sourceFunc` bound to `context` with optional
  // `args`. Determines whether to execute a function as a constructor or as a
  // normal function.
  function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (isObject(result)) return result;
    return self;
  }

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. `_` acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  var partial = restArguments(function(func, boundArgs) {
    var placeholder = partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  partial.placeholder = _$1;

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally).
  var bind = restArguments(function(func, context, args) {
    if (!isFunction$1(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Internal helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var isArrayLike = createSizePropertyCheck(getLength);

  // Internal implementation of a recursive `flatten` function.
  function flatten$1(input, depth, strict, output) {
    output = output || [];
    if (!depth && depth !== 0) {
      depth = Infinity;
    } else if (depth <= 0) {
      return output.concat(input);
    }
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (isArray(value) || isArguments$1(value))) {
        // Flatten current level of array or arguments object.
        if (depth > 1) {
          flatten$1(value, depth - 1, strict, output);
          idx = output.length;
        } else {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  }

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  var bindAll = restArguments(function(obj, keys) {
    keys = flatten$1(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = bind(obj[key], obj);
    }
    return obj;
  });

  // Memoize an expensive function by storing its results.
  function memoize(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!has$1(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  }

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  var delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  var defer = partial(delay, _$1, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  function throttle(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var _now = now();
      if (!previous && options.leading === false) previous = _now;
      var remaining = wait - (_now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = _now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  }

  // When a sequence of calls of the returned function ends, the argument
  // function is triggered. The end of a sequence is defined by the `wait`
  // parameter. If `immediate` is passed, the argument function will be
  // triggered at the beginning of the sequence instead of at the end.
  function debounce(func, wait, immediate) {
    var timeout, previous, args, result, context;

    var later = function() {
      var passed = now() - previous;
      if (wait > passed) {
        timeout = setTimeout(later, wait - passed);
      } else {
        timeout = null;
        if (!immediate) result = func.apply(context, args);
        // This check is needed because `func` can recursively invoke `debounced`.
        if (!timeout) args = context = null;
      }
    };

    var debounced = restArguments(function(_args) {
      context = this;
      args = _args;
      previous = now();
      if (!timeout) {
        timeout = setTimeout(later, wait);
        if (immediate) result = func.apply(context, args);
      }
      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = args = context = null;
    };

    return debounced;
  }

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  function wrap(func, wrapper) {
    return partial(wrapper, func);
  }

  // Returns a negated version of the passed-in predicate.
  function negate(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  }

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  function compose() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  }

  // Returns a function that will only be executed on and after the Nth call.
  function after(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  }

  // Returns a function that will only be executed up to (but not including) the
  // Nth call.
  function before(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  }

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  var once = partial(before, 2);

  // Returns the first key on an object that passes a truth test.
  function findKey(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = keys(obj), key;
    for (var i = 0, length = _keys.length; i < length; i++) {
      key = _keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  }

  // Internal function to generate `_.findIndex` and `_.findLastIndex`.
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a truth test.
  var findIndex = createPredicateIndexFinder(1);

  // Returns the last index on an array-like that passes a truth test.
  var findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  function sortedIndex(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  }

  // Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), isNaN$1);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  var indexOf = createIndexFinder(1, findIndex, sortedIndex);

  // Return the position of the last occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  var lastIndexOf = createIndexFinder(-1, findLastIndex);

  // Return the first value which passes a truth test.
  function find(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? findIndex : findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  }

  // Convenience version of a common use case of `_.find`: getting the first
  // object containing specific `key:value` pairs.
  function findWhere(obj, attrs) {
    return find(obj, matcher(attrs));
  }

  // The cornerstone for collection functions, an `each`
  // implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  function each(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var _keys = keys(obj);
      for (i = 0, length = _keys.length; i < length; i++) {
        iteratee(obj[_keys[i]], _keys[i], obj);
      }
    }
    return obj;
  }

  // Return the results of applying the iteratee to each element.
  function map(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  }

  // Internal helper to create a reducing function, iterating left or right.
  function createReduce(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var _keys = !isArrayLike(obj) && keys(obj),
          length = (_keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[_keys ? _keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = _keys ? _keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  var reduce = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  var reduceRight = createReduce(-1);

  // Return all the elements that pass a truth test.
  function filter(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  }

  // Return all the elements for which a truth test fails.
  function reject(obj, predicate, context) {
    return filter(obj, negate(cb(predicate)), context);
  }

  // Determine whether all of the elements pass a truth test.
  function every(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  }

  // Determine if at least one element in the object passes a truth test.
  function some(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  }

  // Determine if the array or object contains a given item (using `===`).
  function contains(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return indexOf(obj, item, fromIndex) >= 0;
  }

  // Invoke a method (with arguments) on every item in a collection.
  var invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (isFunction$1(path)) {
      func = path;
    } else {
      path = toPath(path);
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `_.map`: fetching a property.
  function pluck(obj, key) {
    return map(obj, property(key));
  }

  // Convenience version of a common use case of `_.filter`: selecting only
  // objects containing specific `key:value` pairs.
  function where(obj, attrs) {
    return filter(obj, matcher(attrs));
  }

  // Return the maximum element (or element-based computation).
  function max(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  }

  // Return the minimum element (or element-based computation).
  function min(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  }

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `_.map`.
  function sample(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = values(obj);
      return obj[random(obj.length - 1)];
    }
    var sample = isArrayLike(obj) ? clone(obj) : values(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  }

  // Shuffle a collection.
  function shuffle(obj) {
    return sample(obj, Infinity);
  }

  // Sort the object's values by a criterion produced by an iteratee.
  function sortBy(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return pluck(map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  }

  // An internal function used for aggregate "group by" operations.
  function group(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  }

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  var groupBy = group(function(result, value, key) {
    if (has$1(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
  // when you know that your index values will be unique.
  var indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  var countBy = group(function(result, value, key) {
    if (has$1(result, key)) result[key]++; else result[key] = 1;
  });

  // Split a collection into two arrays: one whose elements all pass the given
  // truth test, and one whose elements all do not pass the truth test.
  var partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Safely create a real, live array from anything iterable.
  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  function toArray(obj) {
    if (!obj) return [];
    if (isArray(obj)) return slice.call(obj);
    if (isString(obj)) {
      // Keep surrogate pair characters together.
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return map(obj, identity);
    return values(obj);
  }

  // Return the number of elements in a collection.
  function size(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : keys(obj).length;
  }

  // Internal `_.pick` helper function to determine whether `key` is an enumerable
  // property name of `obj`.
  function keyInObj(value, key, obj) {
    return key in obj;
  }

  // Return a copy of the object only containing the allowed properties.
  var pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (isFunction$1(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten$1(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the disallowed properties.
  var omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (isFunction$1(iteratee)) {
      iteratee = negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = map(flatten$1(keys, false, false), String);
      iteratee = function(value, key) {
        return !contains(keys, key);
      };
    }
    return pick(obj, iteratee, context);
  });

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  function initial(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  }

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. The **guard** check allows it to work with `_.map`.
  function first(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[0];
    return initial(array, array.length - n);
  }

  // Returns everything but the first entry of the `array`. Especially useful on
  // the `arguments` object. Passing an **n** will return the rest N values in the
  // `array`.
  function rest(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  }

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  function last(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return rest(array, Math.max(0, array.length - n));
  }

  // Trim out all falsy values from an array.
  function compact(array) {
    return filter(array, Boolean);
  }

  // Flatten out an array, either recursively (by default), or up to `depth`.
  // Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
  function flatten(array, depth) {
    return flatten$1(array, depth, false);
  }

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  var difference = restArguments(function(array, rest) {
    rest = flatten$1(rest, true, true);
    return filter(array, function(value){
      return !contains(rest, value);
    });
  });

  // Return a version of the array that does not contain the specified value(s).
  var without = restArguments(function(array, otherArrays) {
    return difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  function uniq(array, isSorted, iteratee, context) {
    if (!isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  }

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  var union = restArguments(function(arrays) {
    return uniq(flatten$1(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  function intersection(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  }

  // Complement of zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  function unzip(array) {
    var length = array && max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = pluck(array, index);
    }
    return result;
  }

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  var zip = restArguments(unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of `_.pairs`.
  function object(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  }

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](https://docs.python.org/library/functions.html#range).
  function range(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  }

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  function chunk(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  }

  // Helper function to continue chaining intermediate results.
  function chainResult(instance, obj) {
    return instance._chain ? _$1(obj).chain() : obj;
  }

  // Add your own custom functions to the Underscore object.
  function mixin(obj) {
    each(functions(obj), function(name) {
      var func = _$1[name] = obj[name];
      _$1.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_$1, args));
      };
    });
    return _$1;
  }

  // Add all mutator `Array` functions to the wrapper.
  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _$1.prototype[name] = function() {
      var obj = this._wrapped;
      if (obj != null) {
        method.apply(obj, arguments);
        if ((name === 'shift' || name === 'splice') && obj.length === 0) {
          delete obj[0];
        }
      }
      return chainResult(this, obj);
    };
  });

  // Add all accessor `Array` functions to the wrapper.
  each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _$1.prototype[name] = function() {
      var obj = this._wrapped;
      if (obj != null) obj = method.apply(obj, arguments);
      return chainResult(this, obj);
    };
  });

  // Named Exports

  var allExports = {
    __proto__: null,
    VERSION: VERSION,
    restArguments: restArguments,
    isObject: isObject,
    isNull: isNull,
    isUndefined: isUndefined,
    isBoolean: isBoolean,
    isElement: isElement,
    isString: isString,
    isNumber: isNumber,
    isDate: isDate,
    isRegExp: isRegExp,
    isError: isError,
    isSymbol: isSymbol,
    isArrayBuffer: isArrayBuffer,
    isDataView: isDataView$1,
    isArray: isArray,
    isFunction: isFunction$1,
    isArguments: isArguments$1,
    isFinite: isFinite$1,
    isNaN: isNaN$1,
    isTypedArray: isTypedArray$1,
    isEmpty: isEmpty,
    isMatch: isMatch,
    isEqual: isEqual,
    isMap: isMap,
    isWeakMap: isWeakMap,
    isSet: isSet,
    isWeakSet: isWeakSet,
    keys: keys,
    allKeys: allKeys,
    values: values,
    pairs: pairs,
    invert: invert,
    functions: functions,
    methods: functions,
    extend: extend,
    extendOwn: extendOwn,
    assign: extendOwn,
    defaults: defaults,
    create: create,
    clone: clone,
    tap: tap,
    get: get,
    has: has,
    mapObject: mapObject,
    identity: identity,
    constant: constant,
    noop: noop,
    toPath: toPath$1,
    property: property,
    propertyOf: propertyOf,
    matcher: matcher,
    matches: matcher,
    times: times,
    random: random,
    now: now,
    escape: _escape,
    unescape: _unescape,
    templateSettings: templateSettings,
    template: template,
    result: result,
    uniqueId: uniqueId,
    chain: chain,
    iteratee: iteratee,
    partial: partial,
    bind: bind,
    bindAll: bindAll,
    memoize: memoize,
    delay: delay,
    defer: defer,
    throttle: throttle,
    debounce: debounce,
    wrap: wrap,
    negate: negate,
    compose: compose,
    after: after,
    before: before,
    once: once,
    findKey: findKey,
    findIndex: findIndex,
    findLastIndex: findLastIndex,
    sortedIndex: sortedIndex,
    indexOf: indexOf,
    lastIndexOf: lastIndexOf,
    find: find,
    detect: find,
    findWhere: findWhere,
    each: each,
    forEach: each,
    map: map,
    collect: map,
    reduce: reduce,
    foldl: reduce,
    inject: reduce,
    reduceRight: reduceRight,
    foldr: reduceRight,
    filter: filter,
    select: filter,
    reject: reject,
    every: every,
    all: every,
    some: some,
    any: some,
    contains: contains,
    includes: contains,
    include: contains,
    invoke: invoke,
    pluck: pluck,
    where: where,
    max: max,
    min: min,
    shuffle: shuffle,
    sample: sample,
    sortBy: sortBy,
    groupBy: groupBy,
    indexBy: indexBy,
    countBy: countBy,
    partition: partition,
    toArray: toArray,
    size: size,
    pick: pick,
    omit: omit,
    first: first,
    head: first,
    take: first,
    initial: initial,
    last: last,
    rest: rest,
    tail: rest,
    drop: rest,
    compact: compact,
    flatten: flatten,
    without: without,
    uniq: uniq,
    unique: uniq,
    union: union,
    intersection: intersection,
    difference: difference,
    unzip: unzip,
    transpose: unzip,
    zip: zip,
    object: object,
    range: range,
    chunk: chunk,
    mixin: mixin,
    'default': _$1
  };

  // Default Export

  // Add all of the Underscore functions to the wrapper object.
  var _ = mixin(allExports);
  // Legacy Node.js API.
  _._ = _;

  return _;

})));


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],103:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var assign, getValue, isArray, isEmpty, isFunction, isObject, isPlainObject,
    slice = [].slice,
    hasProp = {}.hasOwnProperty;

  assign = function() {
    var i, key, len, source, sources, target;
    target = arguments[0], sources = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    if (isFunction(Object.assign)) {
      Object.assign.apply(null, arguments);
    } else {
      for (i = 0, len = sources.length; i < len; i++) {
        source = sources[i];
        if (source != null) {
          for (key in source) {
            if (!hasProp.call(source, key)) continue;
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };

  isFunction = function(val) {
    return !!val && Object.prototype.toString.call(val) === '[object Function]';
  };

  isObject = function(val) {
    var ref;
    return !!val && ((ref = typeof val) === 'function' || ref === 'object');
  };

  isArray = function(val) {
    if (isFunction(Array.isArray)) {
      return Array.isArray(val);
    } else {
      return Object.prototype.toString.call(val) === '[object Array]';
    }
  };

  isEmpty = function(val) {
    var key;
    if (isArray(val)) {
      return !val.length;
    } else {
      for (key in val) {
        if (!hasProp.call(val, key)) continue;
        return false;
      }
      return true;
    }
  };

  isPlainObject = function(val) {
    var ctor, proto;
    return isObject(val) && (proto = Object.getPrototypeOf(val)) && (ctor = proto.constructor) && (typeof ctor === 'function') && (ctor instanceof ctor) && (Function.prototype.toString.call(ctor) === Function.prototype.toString.call(Object));
  };

  getValue = function(obj) {
    if (isFunction(obj.valueOf)) {
      return obj.valueOf();
    } else {
      return obj;
    }
  };

  module.exports.assign = assign;

  module.exports.isFunction = isFunction;

  module.exports.isObject = isObject;

  module.exports.isArray = isArray;

  module.exports.isEmpty = isEmpty;

  module.exports.isPlainObject = isPlainObject;

  module.exports.getValue = getValue;

}).call(this);

},{}],104:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var XMLAttribute;

  module.exports = XMLAttribute = (function() {
    function XMLAttribute(parent, name, value) {
      this.options = parent.options;
      this.stringify = parent.stringify;
      this.parent = parent;
      if (name == null) {
        throw new Error("Missing attribute name. " + this.debugInfo(name));
      }
      if (value == null) {
        throw new Error("Missing attribute value. " + this.debugInfo(name));
      }
      this.name = this.stringify.attName(name);
      this.value = this.stringify.attValue(value);
    }

    XMLAttribute.prototype.clone = function() {
      return Object.create(this);
    };

    XMLAttribute.prototype.toString = function(options) {
      return this.options.writer.set(options).attribute(this);
    };

    XMLAttribute.prototype.debugInfo = function(name) {
      var ref, ref1;
      name = name || this.name;
      if ((name == null) && !((ref = this.parent) != null ? ref.name : void 0)) {
        return "";
      } else if (name == null) {
        return "parent: <" + this.parent.name + ">";
      } else if (!((ref1 = this.parent) != null ? ref1.name : void 0)) {
        return "attribute: {" + name + "}";
      } else {
        return "attribute: {" + name + "}, parent: <" + this.parent.name + ">";
      }
    };

    return XMLAttribute;

  })();

}).call(this);

},{}],105:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var XMLCData, XMLNode,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = require('./XMLNode');

  module.exports = XMLCData = (function(superClass) {
    extend(XMLCData, superClass);

    function XMLCData(parent, text) {
      XMLCData.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing CDATA text. " + this.debugInfo());
      }
      this.text = this.stringify.cdata(text);
    }

    XMLCData.prototype.clone = function() {
      return Object.create(this);
    };

    XMLCData.prototype.toString = function(options) {
      return this.options.writer.set(options).cdata(this);
    };

    return XMLCData;

  })(XMLNode);

}).call(this);

},{"./XMLNode":116}],106:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var XMLComment, XMLNode,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = require('./XMLNode');

  module.exports = XMLComment = (function(superClass) {
    extend(XMLComment, superClass);

    function XMLComment(parent, text) {
      XMLComment.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing comment text. " + this.debugInfo());
      }
      this.text = this.stringify.comment(text);
    }

    XMLComment.prototype.clone = function() {
      return Object.create(this);
    };

    XMLComment.prototype.toString = function(options) {
      return this.options.writer.set(options).comment(this);
    };

    return XMLComment;

  })(XMLNode);

}).call(this);

},{"./XMLNode":116}],107:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var XMLDTDAttList, XMLNode,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = require('./XMLNode');

  module.exports = XMLDTDAttList = (function(superClass) {
    extend(XMLDTDAttList, superClass);

    function XMLDTDAttList(parent, elementName, attributeName, attributeType, defaultValueType, defaultValue) {
      XMLDTDAttList.__super__.constructor.call(this, parent);
      if (elementName == null) {
        throw new Error("Missing DTD element name. " + this.debugInfo());
      }
      if (attributeName == null) {
        throw new Error("Missing DTD attribute name. " + this.debugInfo(elementName));
      }
      if (!attributeType) {
        throw new Error("Missing DTD attribute type. " + this.debugInfo(elementName));
      }
      if (!defaultValueType) {
        throw new Error("Missing DTD attribute default. " + this.debugInfo(elementName));
      }
      if (defaultValueType.indexOf('#') !== 0) {
        defaultValueType = '#' + defaultValueType;
      }
      if (!defaultValueType.match(/^(#REQUIRED|#IMPLIED|#FIXED|#DEFAULT)$/)) {
        throw new Error("Invalid default value type; expected: #REQUIRED, #IMPLIED, #FIXED or #DEFAULT. " + this.debugInfo(elementName));
      }
      if (defaultValue && !defaultValueType.match(/^(#FIXED|#DEFAULT)$/)) {
        throw new Error("Default value only applies to #FIXED or #DEFAULT. " + this.debugInfo(elementName));
      }
      this.elementName = this.stringify.eleName(elementName);
      this.attributeName = this.stringify.attName(attributeName);
      this.attributeType = this.stringify.dtdAttType(attributeType);
      this.defaultValue = this.stringify.dtdAttDefault(defaultValue);
      this.defaultValueType = defaultValueType;
    }

    XMLDTDAttList.prototype.toString = function(options) {
      return this.options.writer.set(options).dtdAttList(this);
    };

    return XMLDTDAttList;

  })(XMLNode);

}).call(this);

},{"./XMLNode":116}],108:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var XMLDTDElement, XMLNode,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = require('./XMLNode');

  module.exports = XMLDTDElement = (function(superClass) {
    extend(XMLDTDElement, superClass);

    function XMLDTDElement(parent, name, value) {
      XMLDTDElement.__super__.constructor.call(this, parent);
      if (name == null) {
        throw new Error("Missing DTD element name. " + this.debugInfo());
      }
      if (!value) {
        value = '(#PCDATA)';
      }
      if (Array.isArray(value)) {
        value = '(' + value.join(',') + ')';
      }
      this.name = this.stringify.eleName(name);
      this.value = this.stringify.dtdElementValue(value);
    }

    XMLDTDElement.prototype.toString = function(options) {
      return this.options.writer.set(options).dtdElement(this);
    };

    return XMLDTDElement;

  })(XMLNode);

}).call(this);

},{"./XMLNode":116}],109:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var XMLDTDEntity, XMLNode, isObject,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  isObject = require('./Utility').isObject;

  XMLNode = require('./XMLNode');

  module.exports = XMLDTDEntity = (function(superClass) {
    extend(XMLDTDEntity, superClass);

    function XMLDTDEntity(parent, pe, name, value) {
      XMLDTDEntity.__super__.constructor.call(this, parent);
      if (name == null) {
        throw new Error("Missing DTD entity name. " + this.debugInfo(name));
      }
      if (value == null) {
        throw new Error("Missing DTD entity value. " + this.debugInfo(name));
      }
      this.pe = !!pe;
      this.name = this.stringify.eleName(name);
      if (!isObject(value)) {
        this.value = this.stringify.dtdEntityValue(value);
      } else {
        if (!value.pubID && !value.sysID) {
          throw new Error("Public and/or system identifiers are required for an external entity. " + this.debugInfo(name));
        }
        if (value.pubID && !value.sysID) {
          throw new Error("System identifier is required for a public external entity. " + this.debugInfo(name));
        }
        if (value.pubID != null) {
          this.pubID = this.stringify.dtdPubID(value.pubID);
        }
        if (value.sysID != null) {
          this.sysID = this.stringify.dtdSysID(value.sysID);
        }
        if (value.nData != null) {
          this.nData = this.stringify.dtdNData(value.nData);
        }
        if (this.pe && this.nData) {
          throw new Error("Notation declaration is not allowed in a parameter entity. " + this.debugInfo(name));
        }
      }
    }

    XMLDTDEntity.prototype.toString = function(options) {
      return this.options.writer.set(options).dtdEntity(this);
    };

    return XMLDTDEntity;

  })(XMLNode);

}).call(this);

},{"./Utility":103,"./XMLNode":116}],110:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var XMLDTDNotation, XMLNode,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = require('./XMLNode');

  module.exports = XMLDTDNotation = (function(superClass) {
    extend(XMLDTDNotation, superClass);

    function XMLDTDNotation(parent, name, value) {
      XMLDTDNotation.__super__.constructor.call(this, parent);
      if (name == null) {
        throw new Error("Missing DTD notation name. " + this.debugInfo(name));
      }
      if (!value.pubID && !value.sysID) {
        throw new Error("Public or system identifiers are required for an external entity. " + this.debugInfo(name));
      }
      this.name = this.stringify.eleName(name);
      if (value.pubID != null) {
        this.pubID = this.stringify.dtdPubID(value.pubID);
      }
      if (value.sysID != null) {
        this.sysID = this.stringify.dtdSysID(value.sysID);
      }
    }

    XMLDTDNotation.prototype.toString = function(options) {
      return this.options.writer.set(options).dtdNotation(this);
    };

    return XMLDTDNotation;

  })(XMLNode);

}).call(this);

},{"./XMLNode":116}],111:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var XMLDeclaration, XMLNode, isObject,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  isObject = require('./Utility').isObject;

  XMLNode = require('./XMLNode');

  module.exports = XMLDeclaration = (function(superClass) {
    extend(XMLDeclaration, superClass);

    function XMLDeclaration(parent, version, encoding, standalone) {
      var ref;
      XMLDeclaration.__super__.constructor.call(this, parent);
      if (isObject(version)) {
        ref = version, version = ref.version, encoding = ref.encoding, standalone = ref.standalone;
      }
      if (!version) {
        version = '1.0';
      }
      this.version = this.stringify.xmlVersion(version);
      if (encoding != null) {
        this.encoding = this.stringify.xmlEncoding(encoding);
      }
      if (standalone != null) {
        this.standalone = this.stringify.xmlStandalone(standalone);
      }
    }

    XMLDeclaration.prototype.toString = function(options) {
      return this.options.writer.set(options).declaration(this);
    };

    return XMLDeclaration;

  })(XMLNode);

}).call(this);

},{"./Utility":103,"./XMLNode":116}],112:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDocType, XMLNode, isObject,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  isObject = require('./Utility').isObject;

  XMLNode = require('./XMLNode');

  XMLDTDAttList = require('./XMLDTDAttList');

  XMLDTDEntity = require('./XMLDTDEntity');

  XMLDTDElement = require('./XMLDTDElement');

  XMLDTDNotation = require('./XMLDTDNotation');

  module.exports = XMLDocType = (function(superClass) {
    extend(XMLDocType, superClass);

    function XMLDocType(parent, pubID, sysID) {
      var ref, ref1;
      XMLDocType.__super__.constructor.call(this, parent);
      this.name = "!DOCTYPE";
      this.documentObject = parent;
      if (isObject(pubID)) {
        ref = pubID, pubID = ref.pubID, sysID = ref.sysID;
      }
      if (sysID == null) {
        ref1 = [pubID, sysID], sysID = ref1[0], pubID = ref1[1];
      }
      if (pubID != null) {
        this.pubID = this.stringify.dtdPubID(pubID);
      }
      if (sysID != null) {
        this.sysID = this.stringify.dtdSysID(sysID);
      }
    }

    XMLDocType.prototype.element = function(name, value) {
      var child;
      child = new XMLDTDElement(this, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
      var child;
      child = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.entity = function(name, value) {
      var child;
      child = new XMLDTDEntity(this, false, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.pEntity = function(name, value) {
      var child;
      child = new XMLDTDEntity(this, true, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.notation = function(name, value) {
      var child;
      child = new XMLDTDNotation(this, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.toString = function(options) {
      return this.options.writer.set(options).docType(this);
    };

    XMLDocType.prototype.ele = function(name, value) {
      return this.element(name, value);
    };

    XMLDocType.prototype.att = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
      return this.attList(elementName, attributeName, attributeType, defaultValueType, defaultValue);
    };

    XMLDocType.prototype.ent = function(name, value) {
      return this.entity(name, value);
    };

    XMLDocType.prototype.pent = function(name, value) {
      return this.pEntity(name, value);
    };

    XMLDocType.prototype.not = function(name, value) {
      return this.notation(name, value);
    };

    XMLDocType.prototype.up = function() {
      return this.root() || this.documentObject;
    };

    return XMLDocType;

  })(XMLNode);

}).call(this);

},{"./Utility":103,"./XMLDTDAttList":107,"./XMLDTDElement":108,"./XMLDTDEntity":109,"./XMLDTDNotation":110,"./XMLNode":116}],113:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var XMLDocument, XMLNode, XMLStringWriter, XMLStringifier, isPlainObject,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  isPlainObject = require('./Utility').isPlainObject;

  XMLNode = require('./XMLNode');

  XMLStringifier = require('./XMLStringifier');

  XMLStringWriter = require('./XMLStringWriter');

  module.exports = XMLDocument = (function(superClass) {
    extend(XMLDocument, superClass);

    function XMLDocument(options) {
      XMLDocument.__super__.constructor.call(this, null);
      this.name = "?xml";
      options || (options = {});
      if (!options.writer) {
        options.writer = new XMLStringWriter();
      }
      this.options = options;
      this.stringify = new XMLStringifier(options);
      this.isDocument = true;
    }

    XMLDocument.prototype.end = function(writer) {
      var writerOptions;
      if (!writer) {
        writer = this.options.writer;
      } else if (isPlainObject(writer)) {
        writerOptions = writer;
        writer = this.options.writer.set(writerOptions);
      }
      return writer.document(this);
    };

    XMLDocument.prototype.toString = function(options) {
      return this.options.writer.set(options).document(this);
    };

    return XMLDocument;

  })(XMLNode);

}).call(this);

},{"./Utility":103,"./XMLNode":116,"./XMLStringWriter":120,"./XMLStringifier":121}],114:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var XMLAttribute, XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLDocumentCB, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStringWriter, XMLStringifier, XMLText, getValue, isFunction, isObject, isPlainObject, ref,
    hasProp = {}.hasOwnProperty;

  ref = require('./Utility'), isObject = ref.isObject, isFunction = ref.isFunction, isPlainObject = ref.isPlainObject, getValue = ref.getValue;

  XMLElement = require('./XMLElement');

  XMLCData = require('./XMLCData');

  XMLComment = require('./XMLComment');

  XMLRaw = require('./XMLRaw');

  XMLText = require('./XMLText');

  XMLProcessingInstruction = require('./XMLProcessingInstruction');

  XMLDeclaration = require('./XMLDeclaration');

  XMLDocType = require('./XMLDocType');

  XMLDTDAttList = require('./XMLDTDAttList');

  XMLDTDEntity = require('./XMLDTDEntity');

  XMLDTDElement = require('./XMLDTDElement');

  XMLDTDNotation = require('./XMLDTDNotation');

  XMLAttribute = require('./XMLAttribute');

  XMLStringifier = require('./XMLStringifier');

  XMLStringWriter = require('./XMLStringWriter');

  module.exports = XMLDocumentCB = (function() {
    function XMLDocumentCB(options, onData, onEnd) {
      var writerOptions;
      this.name = "?xml";
      options || (options = {});
      if (!options.writer) {
        options.writer = new XMLStringWriter(options);
      } else if (isPlainObject(options.writer)) {
        writerOptions = options.writer;
        options.writer = new XMLStringWriter(writerOptions);
      }
      this.options = options;
      this.writer = options.writer;
      this.stringify = new XMLStringifier(options);
      this.onDataCallback = onData || function() {};
      this.onEndCallback = onEnd || function() {};
      this.currentNode = null;
      this.currentLevel = -1;
      this.openTags = {};
      this.documentStarted = false;
      this.documentCompleted = false;
      this.root = null;
    }

    XMLDocumentCB.prototype.node = function(name, attributes, text) {
      var ref1;
      if (name == null) {
        throw new Error("Missing node name.");
      }
      if (this.root && this.currentLevel === -1) {
        throw new Error("Document can only have one root node. " + this.debugInfo(name));
      }
      this.openCurrent();
      name = getValue(name);
      if (attributes == null) {
        attributes = {};
      }
      attributes = getValue(attributes);
      if (!isObject(attributes)) {
        ref1 = [attributes, text], text = ref1[0], attributes = ref1[1];
      }
      this.currentNode = new XMLElement(this, name, attributes);
      this.currentNode.children = false;
      this.currentLevel++;
      this.openTags[this.currentLevel] = this.currentNode;
      if (text != null) {
        this.text(text);
      }
      return this;
    };

    XMLDocumentCB.prototype.element = function(name, attributes, text) {
      if (this.currentNode && this.currentNode instanceof XMLDocType) {
        return this.dtdElement.apply(this, arguments);
      } else {
        return this.node(name, attributes, text);
      }
    };

    XMLDocumentCB.prototype.attribute = function(name, value) {
      var attName, attValue;
      if (!this.currentNode || this.currentNode.children) {
        throw new Error("att() can only be used immediately after an ele() call in callback mode. " + this.debugInfo(name));
      }
      if (name != null) {
        name = getValue(name);
      }
      if (isObject(name)) {
        for (attName in name) {
          if (!hasProp.call(name, attName)) continue;
          attValue = name[attName];
          this.attribute(attName, attValue);
        }
      } else {
        if (isFunction(value)) {
          value = value.apply();
        }
        if (!this.options.skipNullAttributes || (value != null)) {
          this.currentNode.attributes[name] = new XMLAttribute(this, name, value);
        }
      }
      return this;
    };

    XMLDocumentCB.prototype.text = function(value) {
      var node;
      this.openCurrent();
      node = new XMLText(this, value);
      this.onData(this.writer.text(node, this.currentLevel + 1), this.currentLevel + 1);
      return this;
    };

    XMLDocumentCB.prototype.cdata = function(value) {
      var node;
      this.openCurrent();
      node = new XMLCData(this, value);
      this.onData(this.writer.cdata(node, this.currentLevel + 1), this.currentLevel + 1);
      return this;
    };

    XMLDocumentCB.prototype.comment = function(value) {
      var node;
      this.openCurrent();
      node = new XMLComment(this, value);
      this.onData(this.writer.comment(node, this.currentLevel + 1), this.currentLevel + 1);
      return this;
    };

    XMLDocumentCB.prototype.raw = function(value) {
      var node;
      this.openCurrent();
      node = new XMLRaw(this, value);
      this.onData(this.writer.raw(node, this.currentLevel + 1), this.currentLevel + 1);
      return this;
    };

    XMLDocumentCB.prototype.instruction = function(target, value) {
      var i, insTarget, insValue, len, node;
      this.openCurrent();
      if (target != null) {
        target = getValue(target);
      }
      if (value != null) {
        value = getValue(value);
      }
      if (Array.isArray(target)) {
        for (i = 0, len = target.length; i < len; i++) {
          insTarget = target[i];
          this.instruction(insTarget);
        }
      } else if (isObject(target)) {
        for (insTarget in target) {
          if (!hasProp.call(target, insTarget)) continue;
          insValue = target[insTarget];
          this.instruction(insTarget, insValue);
        }
      } else {
        if (isFunction(value)) {
          value = value.apply();
        }
        node = new XMLProcessingInstruction(this, target, value);
        this.onData(this.writer.processingInstruction(node, this.currentLevel + 1), this.currentLevel + 1);
      }
      return this;
    };

    XMLDocumentCB.prototype.declaration = function(version, encoding, standalone) {
      var node;
      this.openCurrent();
      if (this.documentStarted) {
        throw new Error("declaration() must be the first node.");
      }
      node = new XMLDeclaration(this, version, encoding, standalone);
      this.onData(this.writer.declaration(node, this.currentLevel + 1), this.currentLevel + 1);
      return this;
    };

    XMLDocumentCB.prototype.doctype = function(root, pubID, sysID) {
      this.openCurrent();
      if (root == null) {
        throw new Error("Missing root node name.");
      }
      if (this.root) {
        throw new Error("dtd() must come before the root node.");
      }
      this.currentNode = new XMLDocType(this, pubID, sysID);
      this.currentNode.rootNodeName = root;
      this.currentNode.children = false;
      this.currentLevel++;
      this.openTags[this.currentLevel] = this.currentNode;
      return this;
    };

    XMLDocumentCB.prototype.dtdElement = function(name, value) {
      var node;
      this.openCurrent();
      node = new XMLDTDElement(this, name, value);
      this.onData(this.writer.dtdElement(node, this.currentLevel + 1), this.currentLevel + 1);
      return this;
    };

    XMLDocumentCB.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
      var node;
      this.openCurrent();
      node = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
      this.onData(this.writer.dtdAttList(node, this.currentLevel + 1), this.currentLevel + 1);
      return this;
    };

    XMLDocumentCB.prototype.entity = function(name, value) {
      var node;
      this.openCurrent();
      node = new XMLDTDEntity(this, false, name, value);
      this.onData(this.writer.dtdEntity(node, this.currentLevel + 1), this.currentLevel + 1);
      return this;
    };

    XMLDocumentCB.prototype.pEntity = function(name, value) {
      var node;
      this.openCurrent();
      node = new XMLDTDEntity(this, true, name, value);
      this.onData(this.writer.dtdEntity(node, this.currentLevel + 1), this.currentLevel + 1);
      return this;
    };

    XMLDocumentCB.prototype.notation = function(name, value) {
      var node;
      this.openCurrent();
      node = new XMLDTDNotation(this, name, value);
      this.onData(this.writer.dtdNotation(node, this.currentLevel + 1), this.currentLevel + 1);
      return this;
    };

    XMLDocumentCB.prototype.up = function() {
      if (this.currentLevel < 0) {
        throw new Error("The document node has no parent.");
      }
      if (this.currentNode) {
        if (this.currentNode.children) {
          this.closeNode(this.currentNode);
        } else {
          this.openNode(this.currentNode);
        }
        this.currentNode = null;
      } else {
        this.closeNode(this.openTags[this.currentLevel]);
      }
      delete this.openTags[this.currentLevel];
      this.currentLevel--;
      return this;
    };

    XMLDocumentCB.prototype.end = function() {
      while (this.currentLevel >= 0) {
        this.up();
      }
      return this.onEnd();
    };

    XMLDocumentCB.prototype.openCurrent = function() {
      if (this.currentNode) {
        this.currentNode.children = true;
        return this.openNode(this.currentNode);
      }
    };

    XMLDocumentCB.prototype.openNode = function(node) {
      if (!node.isOpen) {
        if (!this.root && this.currentLevel === 0 && node instanceof XMLElement) {
          this.root = node;
        }
        this.onData(this.writer.openNode(node, this.currentLevel), this.currentLevel);
        return node.isOpen = true;
      }
    };

    XMLDocumentCB.prototype.closeNode = function(node) {
      if (!node.isClosed) {
        this.onData(this.writer.closeNode(node, this.currentLevel), this.currentLevel);
        return node.isClosed = true;
      }
    };

    XMLDocumentCB.prototype.onData = function(chunk, level) {
      this.documentStarted = true;
      return this.onDataCallback(chunk, level + 1);
    };

    XMLDocumentCB.prototype.onEnd = function() {
      this.documentCompleted = true;
      return this.onEndCallback();
    };

    XMLDocumentCB.prototype.debugInfo = function(name) {
      if (name == null) {
        return "";
      } else {
        return "node: <" + name + ">";
      }
    };

    XMLDocumentCB.prototype.ele = function() {
      return this.element.apply(this, arguments);
    };

    XMLDocumentCB.prototype.nod = function(name, attributes, text) {
      return this.node(name, attributes, text);
    };

    XMLDocumentCB.prototype.txt = function(value) {
      return this.text(value);
    };

    XMLDocumentCB.prototype.dat = function(value) {
      return this.cdata(value);
    };

    XMLDocumentCB.prototype.com = function(value) {
      return this.comment(value);
    };

    XMLDocumentCB.prototype.ins = function(target, value) {
      return this.instruction(target, value);
    };

    XMLDocumentCB.prototype.dec = function(version, encoding, standalone) {
      return this.declaration(version, encoding, standalone);
    };

    XMLDocumentCB.prototype.dtd = function(root, pubID, sysID) {
      return this.doctype(root, pubID, sysID);
    };

    XMLDocumentCB.prototype.e = function(name, attributes, text) {
      return this.element(name, attributes, text);
    };

    XMLDocumentCB.prototype.n = function(name, attributes, text) {
      return this.node(name, attributes, text);
    };

    XMLDocumentCB.prototype.t = function(value) {
      return this.text(value);
    };

    XMLDocumentCB.prototype.d = function(value) {
      return this.cdata(value);
    };

    XMLDocumentCB.prototype.c = function(value) {
      return this.comment(value);
    };

    XMLDocumentCB.prototype.r = function(value) {
      return this.raw(value);
    };

    XMLDocumentCB.prototype.i = function(target, value) {
      return this.instruction(target, value);
    };

    XMLDocumentCB.prototype.att = function() {
      if (this.currentNode && this.currentNode instanceof XMLDocType) {
        return this.attList.apply(this, arguments);
      } else {
        return this.attribute.apply(this, arguments);
      }
    };

    XMLDocumentCB.prototype.a = function() {
      if (this.currentNode && this.currentNode instanceof XMLDocType) {
        return this.attList.apply(this, arguments);
      } else {
        return this.attribute.apply(this, arguments);
      }
    };

    XMLDocumentCB.prototype.ent = function(name, value) {
      return this.entity(name, value);
    };

    XMLDocumentCB.prototype.pent = function(name, value) {
      return this.pEntity(name, value);
    };

    XMLDocumentCB.prototype.not = function(name, value) {
      return this.notation(name, value);
    };

    return XMLDocumentCB;

  })();

}).call(this);

},{"./Utility":103,"./XMLAttribute":104,"./XMLCData":105,"./XMLComment":106,"./XMLDTDAttList":107,"./XMLDTDElement":108,"./XMLDTDEntity":109,"./XMLDTDNotation":110,"./XMLDeclaration":111,"./XMLDocType":112,"./XMLElement":115,"./XMLProcessingInstruction":117,"./XMLRaw":118,"./XMLStringWriter":120,"./XMLStringifier":121,"./XMLText":122}],115:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var XMLAttribute, XMLElement, XMLNode, getValue, isFunction, isObject, ref,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ref = require('./Utility'), isObject = ref.isObject, isFunction = ref.isFunction, getValue = ref.getValue;

  XMLNode = require('./XMLNode');

  XMLAttribute = require('./XMLAttribute');

  module.exports = XMLElement = (function(superClass) {
    extend(XMLElement, superClass);

    function XMLElement(parent, name, attributes) {
      XMLElement.__super__.constructor.call(this, parent);
      if (name == null) {
        throw new Error("Missing element name. " + this.debugInfo());
      }
      this.name = this.stringify.eleName(name);
      this.attributes = {};
      if (attributes != null) {
        this.attribute(attributes);
      }
      if (parent.isDocument) {
        this.isRoot = true;
        this.documentObject = parent;
        parent.rootObject = this;
      }
    }

    XMLElement.prototype.clone = function() {
      var att, attName, clonedSelf, ref1;
      clonedSelf = Object.create(this);
      if (clonedSelf.isRoot) {
        clonedSelf.documentObject = null;
      }
      clonedSelf.attributes = {};
      ref1 = this.attributes;
      for (attName in ref1) {
        if (!hasProp.call(ref1, attName)) continue;
        att = ref1[attName];
        clonedSelf.attributes[attName] = att.clone();
      }
      clonedSelf.children = [];
      this.children.forEach(function(child) {
        var clonedChild;
        clonedChild = child.clone();
        clonedChild.parent = clonedSelf;
        return clonedSelf.children.push(clonedChild);
      });
      return clonedSelf;
    };

    XMLElement.prototype.attribute = function(name, value) {
      var attName, attValue;
      if (name != null) {
        name = getValue(name);
      }
      if (isObject(name)) {
        for (attName in name) {
          if (!hasProp.call(name, attName)) continue;
          attValue = name[attName];
          this.attribute(attName, attValue);
        }
      } else {
        if (isFunction(value)) {
          value = value.apply();
        }
        if (!this.options.skipNullAttributes || (value != null)) {
          this.attributes[name] = new XMLAttribute(this, name, value);
        }
      }
      return this;
    };

    XMLElement.prototype.removeAttribute = function(name) {
      var attName, i, len;
      if (name == null) {
        throw new Error("Missing attribute name. " + this.debugInfo());
      }
      name = getValue(name);
      if (Array.isArray(name)) {
        for (i = 0, len = name.length; i < len; i++) {
          attName = name[i];
          delete this.attributes[attName];
        }
      } else {
        delete this.attributes[name];
      }
      return this;
    };

    XMLElement.prototype.toString = function(options) {
      return this.options.writer.set(options).element(this);
    };

    XMLElement.prototype.att = function(name, value) {
      return this.attribute(name, value);
    };

    XMLElement.prototype.a = function(name, value) {
      return this.attribute(name, value);
    };

    return XMLElement;

  })(XMLNode);

}).call(this);

},{"./Utility":103,"./XMLAttribute":104,"./XMLNode":116}],116:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var XMLCData, XMLComment, XMLDeclaration, XMLDocType, XMLElement, XMLNode, XMLProcessingInstruction, XMLRaw, XMLText, getValue, isEmpty, isFunction, isObject, ref,
    hasProp = {}.hasOwnProperty;

  ref = require('./Utility'), isObject = ref.isObject, isFunction = ref.isFunction, isEmpty = ref.isEmpty, getValue = ref.getValue;

  XMLElement = null;

  XMLCData = null;

  XMLComment = null;

  XMLDeclaration = null;

  XMLDocType = null;

  XMLRaw = null;

  XMLText = null;

  XMLProcessingInstruction = null;

  module.exports = XMLNode = (function() {
    function XMLNode(parent) {
      this.parent = parent;
      if (this.parent) {
        this.options = this.parent.options;
        this.stringify = this.parent.stringify;
      }
      this.children = [];
      if (!XMLElement) {
        XMLElement = require('./XMLElement');
        XMLCData = require('./XMLCData');
        XMLComment = require('./XMLComment');
        XMLDeclaration = require('./XMLDeclaration');
        XMLDocType = require('./XMLDocType');
        XMLRaw = require('./XMLRaw');
        XMLText = require('./XMLText');
        XMLProcessingInstruction = require('./XMLProcessingInstruction');
      }
    }

    XMLNode.prototype.element = function(name, attributes, text) {
      var childNode, item, j, k, key, lastChild, len, len1, ref1, val;
      lastChild = null;
      if (attributes == null) {
        attributes = {};
      }
      attributes = getValue(attributes);
      if (!isObject(attributes)) {
        ref1 = [attributes, text], text = ref1[0], attributes = ref1[1];
      }
      if (name != null) {
        name = getValue(name);
      }
      if (Array.isArray(name)) {
        for (j = 0, len = name.length; j < len; j++) {
          item = name[j];
          lastChild = this.element(item);
        }
      } else if (isFunction(name)) {
        lastChild = this.element(name.apply());
      } else if (isObject(name)) {
        for (key in name) {
          if (!hasProp.call(name, key)) continue;
          val = name[key];
          if (isFunction(val)) {
            val = val.apply();
          }
          if ((isObject(val)) && (isEmpty(val))) {
            val = null;
          }
          if (!this.options.ignoreDecorators && this.stringify.convertAttKey && key.indexOf(this.stringify.convertAttKey) === 0) {
            lastChild = this.attribute(key.substr(this.stringify.convertAttKey.length), val);
          } else if (!this.options.separateArrayItems && Array.isArray(val)) {
            for (k = 0, len1 = val.length; k < len1; k++) {
              item = val[k];
              childNode = {};
              childNode[key] = item;
              lastChild = this.element(childNode);
            }
          } else if (isObject(val)) {
            lastChild = this.element(key);
            lastChild.element(val);
          } else {
            lastChild = this.element(key, val);
          }
        }
      } else {
        if (!this.options.ignoreDecorators && this.stringify.convertTextKey && name.indexOf(this.stringify.convertTextKey) === 0) {
          lastChild = this.text(text);
        } else if (!this.options.ignoreDecorators && this.stringify.convertCDataKey && name.indexOf(this.stringify.convertCDataKey) === 0) {
          lastChild = this.cdata(text);
        } else if (!this.options.ignoreDecorators && this.stringify.convertCommentKey && name.indexOf(this.stringify.convertCommentKey) === 0) {
          lastChild = this.comment(text);
        } else if (!this.options.ignoreDecorators && this.stringify.convertRawKey && name.indexOf(this.stringify.convertRawKey) === 0) {
          lastChild = this.raw(text);
        } else if (!this.options.ignoreDecorators && this.stringify.convertPIKey && name.indexOf(this.stringify.convertPIKey) === 0) {
          lastChild = this.instruction(name.substr(this.stringify.convertPIKey.length), text);
        } else {
          lastChild = this.node(name, attributes, text);
        }
      }
      if (lastChild == null) {
        throw new Error("Could not create any elements with: " + name + ". " + this.debugInfo());
      }
      return lastChild;
    };

    XMLNode.prototype.insertBefore = function(name, attributes, text) {
      var child, i, removed;
      if (this.isRoot) {
        throw new Error("Cannot insert elements at root level. " + this.debugInfo(name));
      }
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i);
      child = this.parent.element(name, attributes, text);
      Array.prototype.push.apply(this.parent.children, removed);
      return child;
    };

    XMLNode.prototype.insertAfter = function(name, attributes, text) {
      var child, i, removed;
      if (this.isRoot) {
        throw new Error("Cannot insert elements at root level. " + this.debugInfo(name));
      }
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i + 1);
      child = this.parent.element(name, attributes, text);
      Array.prototype.push.apply(this.parent.children, removed);
      return child;
    };

    XMLNode.prototype.remove = function() {
      var i, ref1;
      if (this.isRoot) {
        throw new Error("Cannot remove the root element. " + this.debugInfo());
      }
      i = this.parent.children.indexOf(this);
      [].splice.apply(this.parent.children, [i, i - i + 1].concat(ref1 = [])), ref1;
      return this.parent;
    };

    XMLNode.prototype.node = function(name, attributes, text) {
      var child, ref1;
      if (name != null) {
        name = getValue(name);
      }
      attributes || (attributes = {});
      attributes = getValue(attributes);
      if (!isObject(attributes)) {
        ref1 = [attributes, text], text = ref1[0], attributes = ref1[1];
      }
      child = new XMLElement(this, name, attributes);
      if (text != null) {
        child.text(text);
      }
      this.children.push(child);
      return child;
    };

    XMLNode.prototype.text = function(value) {
      var child;
      child = new XMLText(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.cdata = function(value) {
      var child;
      child = new XMLCData(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.comment = function(value) {
      var child;
      child = new XMLComment(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.commentBefore = function(value) {
      var child, i, removed;
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i);
      child = this.parent.comment(value);
      Array.prototype.push.apply(this.parent.children, removed);
      return this;
    };

    XMLNode.prototype.commentAfter = function(value) {
      var child, i, removed;
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i + 1);
      child = this.parent.comment(value);
      Array.prototype.push.apply(this.parent.children, removed);
      return this;
    };

    XMLNode.prototype.raw = function(value) {
      var child;
      child = new XMLRaw(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.instruction = function(target, value) {
      var insTarget, insValue, instruction, j, len;
      if (target != null) {
        target = getValue(target);
      }
      if (value != null) {
        value = getValue(value);
      }
      if (Array.isArray(target)) {
        for (j = 0, len = target.length; j < len; j++) {
          insTarget = target[j];
          this.instruction(insTarget);
        }
      } else if (isObject(target)) {
        for (insTarget in target) {
          if (!hasProp.call(target, insTarget)) continue;
          insValue = target[insTarget];
          this.instruction(insTarget, insValue);
        }
      } else {
        if (isFunction(value)) {
          value = value.apply();
        }
        instruction = new XMLProcessingInstruction(this, target, value);
        this.children.push(instruction);
      }
      return this;
    };

    XMLNode.prototype.instructionBefore = function(target, value) {
      var child, i, removed;
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i);
      child = this.parent.instruction(target, value);
      Array.prototype.push.apply(this.parent.children, removed);
      return this;
    };

    XMLNode.prototype.instructionAfter = function(target, value) {
      var child, i, removed;
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i + 1);
      child = this.parent.instruction(target, value);
      Array.prototype.push.apply(this.parent.children, removed);
      return this;
    };

    XMLNode.prototype.declaration = function(version, encoding, standalone) {
      var doc, xmldec;
      doc = this.document();
      xmldec = new XMLDeclaration(doc, version, encoding, standalone);
      if (doc.children[0] instanceof XMLDeclaration) {
        doc.children[0] = xmldec;
      } else {
        doc.children.unshift(xmldec);
      }
      return doc.root() || doc;
    };

    XMLNode.prototype.doctype = function(pubID, sysID) {
      var child, doc, doctype, i, j, k, len, len1, ref1, ref2;
      doc = this.document();
      doctype = new XMLDocType(doc, pubID, sysID);
      ref1 = doc.children;
      for (i = j = 0, len = ref1.length; j < len; i = ++j) {
        child = ref1[i];
        if (child instanceof XMLDocType) {
          doc.children[i] = doctype;
          return doctype;
        }
      }
      ref2 = doc.children;
      for (i = k = 0, len1 = ref2.length; k < len1; i = ++k) {
        child = ref2[i];
        if (child.isRoot) {
          doc.children.splice(i, 0, doctype);
          return doctype;
        }
      }
      doc.children.push(doctype);
      return doctype;
    };

    XMLNode.prototype.up = function() {
      if (this.isRoot) {
        throw new Error("The root node has no parent. Use doc() if you need to get the document object.");
      }
      return this.parent;
    };

    XMLNode.prototype.root = function() {
      var node;
      node = this;
      while (node) {
        if (node.isDocument) {
          return node.rootObject;
        } else if (node.isRoot) {
          return node;
        } else {
          node = node.parent;
        }
      }
    };

    XMLNode.prototype.document = function() {
      var node;
      node = this;
      while (node) {
        if (node.isDocument) {
          return node;
        } else {
          node = node.parent;
        }
      }
    };

    XMLNode.prototype.end = function(options) {
      return this.document().end(options);
    };

    XMLNode.prototype.prev = function() {
      var i;
      i = this.parent.children.indexOf(this);
      if (i < 1) {
        throw new Error("Already at the first node. " + this.debugInfo());
      }
      return this.parent.children[i - 1];
    };

    XMLNode.prototype.next = function() {
      var i;
      i = this.parent.children.indexOf(this);
      if (i === -1 || i === this.parent.children.length - 1) {
        throw new Error("Already at the last node. " + this.debugInfo());
      }
      return this.parent.children[i + 1];
    };

    XMLNode.prototype.importDocument = function(doc) {
      var clonedRoot;
      clonedRoot = doc.root().clone();
      clonedRoot.parent = this;
      clonedRoot.isRoot = false;
      this.children.push(clonedRoot);
      return this;
    };

    XMLNode.prototype.debugInfo = function(name) {
      var ref1, ref2;
      name = name || this.name;
      if ((name == null) && !((ref1 = this.parent) != null ? ref1.name : void 0)) {
        return "";
      } else if (name == null) {
        return "parent: <" + this.parent.name + ">";
      } else if (!((ref2 = this.parent) != null ? ref2.name : void 0)) {
        return "node: <" + name + ">";
      } else {
        return "node: <" + name + ">, parent: <" + this.parent.name + ">";
      }
    };

    XMLNode.prototype.ele = function(name, attributes, text) {
      return this.element(name, attributes, text);
    };

    XMLNode.prototype.nod = function(name, attributes, text) {
      return this.node(name, attributes, text);
    };

    XMLNode.prototype.txt = function(value) {
      return this.text(value);
    };

    XMLNode.prototype.dat = function(value) {
      return this.cdata(value);
    };

    XMLNode.prototype.com = function(value) {
      return this.comment(value);
    };

    XMLNode.prototype.ins = function(target, value) {
      return this.instruction(target, value);
    };

    XMLNode.prototype.doc = function() {
      return this.document();
    };

    XMLNode.prototype.dec = function(version, encoding, standalone) {
      return this.declaration(version, encoding, standalone);
    };

    XMLNode.prototype.dtd = function(pubID, sysID) {
      return this.doctype(pubID, sysID);
    };

    XMLNode.prototype.e = function(name, attributes, text) {
      return this.element(name, attributes, text);
    };

    XMLNode.prototype.n = function(name, attributes, text) {
      return this.node(name, attributes, text);
    };

    XMLNode.prototype.t = function(value) {
      return this.text(value);
    };

    XMLNode.prototype.d = function(value) {
      return this.cdata(value);
    };

    XMLNode.prototype.c = function(value) {
      return this.comment(value);
    };

    XMLNode.prototype.r = function(value) {
      return this.raw(value);
    };

    XMLNode.prototype.i = function(target, value) {
      return this.instruction(target, value);
    };

    XMLNode.prototype.u = function() {
      return this.up();
    };

    XMLNode.prototype.importXMLBuilder = function(doc) {
      return this.importDocument(doc);
    };

    return XMLNode;

  })();

}).call(this);

},{"./Utility":103,"./XMLCData":105,"./XMLComment":106,"./XMLDeclaration":111,"./XMLDocType":112,"./XMLElement":115,"./XMLProcessingInstruction":117,"./XMLRaw":118,"./XMLText":122}],117:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var XMLNode, XMLProcessingInstruction,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = require('./XMLNode');

  module.exports = XMLProcessingInstruction = (function(superClass) {
    extend(XMLProcessingInstruction, superClass);

    function XMLProcessingInstruction(parent, target, value) {
      XMLProcessingInstruction.__super__.constructor.call(this, parent);
      if (target == null) {
        throw new Error("Missing instruction target. " + this.debugInfo());
      }
      this.target = this.stringify.insTarget(target);
      if (value) {
        this.value = this.stringify.insValue(value);
      }
    }

    XMLProcessingInstruction.prototype.clone = function() {
      return Object.create(this);
    };

    XMLProcessingInstruction.prototype.toString = function(options) {
      return this.options.writer.set(options).processingInstruction(this);
    };

    return XMLProcessingInstruction;

  })(XMLNode);

}).call(this);

},{"./XMLNode":116}],118:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var XMLNode, XMLRaw,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = require('./XMLNode');

  module.exports = XMLRaw = (function(superClass) {
    extend(XMLRaw, superClass);

    function XMLRaw(parent, text) {
      XMLRaw.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing raw text. " + this.debugInfo());
      }
      this.value = this.stringify.raw(text);
    }

    XMLRaw.prototype.clone = function() {
      return Object.create(this);
    };

    XMLRaw.prototype.toString = function(options) {
      return this.options.writer.set(options).raw(this);
    };

    return XMLRaw;

  })(XMLNode);

}).call(this);

},{"./XMLNode":116}],119:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStreamWriter, XMLText, XMLWriterBase,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLDeclaration = require('./XMLDeclaration');

  XMLDocType = require('./XMLDocType');

  XMLCData = require('./XMLCData');

  XMLComment = require('./XMLComment');

  XMLElement = require('./XMLElement');

  XMLRaw = require('./XMLRaw');

  XMLText = require('./XMLText');

  XMLProcessingInstruction = require('./XMLProcessingInstruction');

  XMLDTDAttList = require('./XMLDTDAttList');

  XMLDTDElement = require('./XMLDTDElement');

  XMLDTDEntity = require('./XMLDTDEntity');

  XMLDTDNotation = require('./XMLDTDNotation');

  XMLWriterBase = require('./XMLWriterBase');

  module.exports = XMLStreamWriter = (function(superClass) {
    extend(XMLStreamWriter, superClass);

    function XMLStreamWriter(stream, options) {
      XMLStreamWriter.__super__.constructor.call(this, options);
      this.stream = stream;
    }

    XMLStreamWriter.prototype.document = function(doc) {
      var child, i, j, len, len1, ref, ref1, results;
      ref = doc.children;
      for (i = 0, len = ref.length; i < len; i++) {
        child = ref[i];
        child.isLastRootNode = false;
      }
      doc.children[doc.children.length - 1].isLastRootNode = true;
      ref1 = doc.children;
      results = [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        child = ref1[j];
        switch (false) {
          case !(child instanceof XMLDeclaration):
            results.push(this.declaration(child));
            break;
          case !(child instanceof XMLDocType):
            results.push(this.docType(child));
            break;
          case !(child instanceof XMLComment):
            results.push(this.comment(child));
            break;
          case !(child instanceof XMLProcessingInstruction):
            results.push(this.processingInstruction(child));
            break;
          default:
            results.push(this.element(child));
        }
      }
      return results;
    };

    XMLStreamWriter.prototype.attribute = function(att) {
      return this.stream.write(' ' + att.name + '="' + att.value + '"');
    };

    XMLStreamWriter.prototype.cdata = function(node, level) {
      return this.stream.write(this.space(level) + '<![CDATA[' + node.text + ']]>' + this.endline(node));
    };

    XMLStreamWriter.prototype.comment = function(node, level) {
      return this.stream.write(this.space(level) + '<!-- ' + node.text + ' -->' + this.endline(node));
    };

    XMLStreamWriter.prototype.declaration = function(node, level) {
      this.stream.write(this.space(level));
      this.stream.write('<?xml version="' + node.version + '"');
      if (node.encoding != null) {
        this.stream.write(' encoding="' + node.encoding + '"');
      }
      if (node.standalone != null) {
        this.stream.write(' standalone="' + node.standalone + '"');
      }
      this.stream.write(this.spacebeforeslash + '?>');
      return this.stream.write(this.endline(node));
    };

    XMLStreamWriter.prototype.docType = function(node, level) {
      var child, i, len, ref;
      level || (level = 0);
      this.stream.write(this.space(level));
      this.stream.write('<!DOCTYPE ' + node.root().name);
      if (node.pubID && node.sysID) {
        this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
      } else if (node.sysID) {
        this.stream.write(' SYSTEM "' + node.sysID + '"');
      }
      if (node.children.length > 0) {
        this.stream.write(' [');
        this.stream.write(this.endline(node));
        ref = node.children;
        for (i = 0, len = ref.length; i < len; i++) {
          child = ref[i];
          switch (false) {
            case !(child instanceof XMLDTDAttList):
              this.dtdAttList(child, level + 1);
              break;
            case !(child instanceof XMLDTDElement):
              this.dtdElement(child, level + 1);
              break;
            case !(child instanceof XMLDTDEntity):
              this.dtdEntity(child, level + 1);
              break;
            case !(child instanceof XMLDTDNotation):
              this.dtdNotation(child, level + 1);
              break;
            case !(child instanceof XMLCData):
              this.cdata(child, level + 1);
              break;
            case !(child instanceof XMLComment):
              this.comment(child, level + 1);
              break;
            case !(child instanceof XMLProcessingInstruction):
              this.processingInstruction(child, level + 1);
              break;
            default:
              throw new Error("Unknown DTD node type: " + child.constructor.name);
          }
        }
        this.stream.write(']');
      }
      this.stream.write(this.spacebeforeslash + '>');
      return this.stream.write(this.endline(node));
    };

    XMLStreamWriter.prototype.element = function(node, level) {
      var att, child, i, len, name, ref, ref1, space;
      level || (level = 0);
      space = this.space(level);
      this.stream.write(space + '<' + node.name);
      ref = node.attributes;
      for (name in ref) {
        if (!hasProp.call(ref, name)) continue;
        att = ref[name];
        this.attribute(att);
      }
      if (node.children.length === 0 || node.children.every(function(e) {
        return e.value === '';
      })) {
        if (this.allowEmpty) {
          this.stream.write('></' + node.name + '>');
        } else {
          this.stream.write(this.spacebeforeslash + '/>');
        }
      } else if (this.pretty && node.children.length === 1 && (node.children[0].value != null)) {
        this.stream.write('>');
        this.stream.write(node.children[0].value);
        this.stream.write('</' + node.name + '>');
      } else {
        this.stream.write('>' + this.newline);
        ref1 = node.children;
        for (i = 0, len = ref1.length; i < len; i++) {
          child = ref1[i];
          switch (false) {
            case !(child instanceof XMLCData):
              this.cdata(child, level + 1);
              break;
            case !(child instanceof XMLComment):
              this.comment(child, level + 1);
              break;
            case !(child instanceof XMLElement):
              this.element(child, level + 1);
              break;
            case !(child instanceof XMLRaw):
              this.raw(child, level + 1);
              break;
            case !(child instanceof XMLText):
              this.text(child, level + 1);
              break;
            case !(child instanceof XMLProcessingInstruction):
              this.processingInstruction(child, level + 1);
              break;
            default:
              throw new Error("Unknown XML node type: " + child.constructor.name);
          }
        }
        this.stream.write(space + '</' + node.name + '>');
      }
      return this.stream.write(this.endline(node));
    };

    XMLStreamWriter.prototype.processingInstruction = function(node, level) {
      this.stream.write(this.space(level) + '<?' + node.target);
      if (node.value) {
        this.stream.write(' ' + node.value);
      }
      return this.stream.write(this.spacebeforeslash + '?>' + this.endline(node));
    };

    XMLStreamWriter.prototype.raw = function(node, level) {
      return this.stream.write(this.space(level) + node.value + this.endline(node));
    };

    XMLStreamWriter.prototype.text = function(node, level) {
      return this.stream.write(this.space(level) + node.value + this.endline(node));
    };

    XMLStreamWriter.prototype.dtdAttList = function(node, level) {
      this.stream.write(this.space(level) + '<!ATTLIST ' + node.elementName + ' ' + node.attributeName + ' ' + node.attributeType);
      if (node.defaultValueType !== '#DEFAULT') {
        this.stream.write(' ' + node.defaultValueType);
      }
      if (node.defaultValue) {
        this.stream.write(' "' + node.defaultValue + '"');
      }
      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
    };

    XMLStreamWriter.prototype.dtdElement = function(node, level) {
      this.stream.write(this.space(level) + '<!ELEMENT ' + node.name + ' ' + node.value);
      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
    };

    XMLStreamWriter.prototype.dtdEntity = function(node, level) {
      this.stream.write(this.space(level) + '<!ENTITY');
      if (node.pe) {
        this.stream.write(' %');
      }
      this.stream.write(' ' + node.name);
      if (node.value) {
        this.stream.write(' "' + node.value + '"');
      } else {
        if (node.pubID && node.sysID) {
          this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
        } else if (node.sysID) {
          this.stream.write(' SYSTEM "' + node.sysID + '"');
        }
        if (node.nData) {
          this.stream.write(' NDATA ' + node.nData);
        }
      }
      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
    };

    XMLStreamWriter.prototype.dtdNotation = function(node, level) {
      this.stream.write(this.space(level) + '<!NOTATION ' + node.name);
      if (node.pubID && node.sysID) {
        this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
      } else if (node.pubID) {
        this.stream.write(' PUBLIC "' + node.pubID + '"');
      } else if (node.sysID) {
        this.stream.write(' SYSTEM "' + node.sysID + '"');
      }
      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
    };

    XMLStreamWriter.prototype.endline = function(node) {
      if (!node.isLastRootNode) {
        return this.newline;
      } else {
        return '';
      }
    };

    return XMLStreamWriter;

  })(XMLWriterBase);

}).call(this);

},{"./XMLCData":105,"./XMLComment":106,"./XMLDTDAttList":107,"./XMLDTDElement":108,"./XMLDTDEntity":109,"./XMLDTDNotation":110,"./XMLDeclaration":111,"./XMLDocType":112,"./XMLElement":115,"./XMLProcessingInstruction":117,"./XMLRaw":118,"./XMLText":122,"./XMLWriterBase":123}],120:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStringWriter, XMLText, XMLWriterBase,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLDeclaration = require('./XMLDeclaration');

  XMLDocType = require('./XMLDocType');

  XMLCData = require('./XMLCData');

  XMLComment = require('./XMLComment');

  XMLElement = require('./XMLElement');

  XMLRaw = require('./XMLRaw');

  XMLText = require('./XMLText');

  XMLProcessingInstruction = require('./XMLProcessingInstruction');

  XMLDTDAttList = require('./XMLDTDAttList');

  XMLDTDElement = require('./XMLDTDElement');

  XMLDTDEntity = require('./XMLDTDEntity');

  XMLDTDNotation = require('./XMLDTDNotation');

  XMLWriterBase = require('./XMLWriterBase');

  module.exports = XMLStringWriter = (function(superClass) {
    extend(XMLStringWriter, superClass);

    function XMLStringWriter(options) {
      XMLStringWriter.__super__.constructor.call(this, options);
    }

    XMLStringWriter.prototype.document = function(doc) {
      var child, i, len, r, ref;
      this.textispresent = false;
      r = '';
      ref = doc.children;
      for (i = 0, len = ref.length; i < len; i++) {
        child = ref[i];
        r += (function() {
          switch (false) {
            case !(child instanceof XMLDeclaration):
              return this.declaration(child);
            case !(child instanceof XMLDocType):
              return this.docType(child);
            case !(child instanceof XMLComment):
              return this.comment(child);
            case !(child instanceof XMLProcessingInstruction):
              return this.processingInstruction(child);
            default:
              return this.element(child, 0);
          }
        }).call(this);
      }
      if (this.pretty && r.slice(-this.newline.length) === this.newline) {
        r = r.slice(0, -this.newline.length);
      }
      return r;
    };

    XMLStringWriter.prototype.attribute = function(att) {
      return ' ' + att.name + '="' + att.value + '"';
    };

    XMLStringWriter.prototype.cdata = function(node, level) {
      return this.space(level) + '<![CDATA[' + node.text + ']]>' + this.newline;
    };

    XMLStringWriter.prototype.comment = function(node, level) {
      return this.space(level) + '<!-- ' + node.text + ' -->' + this.newline;
    };

    XMLStringWriter.prototype.declaration = function(node, level) {
      var r;
      r = this.space(level);
      r += '<?xml version="' + node.version + '"';
      if (node.encoding != null) {
        r += ' encoding="' + node.encoding + '"';
      }
      if (node.standalone != null) {
        r += ' standalone="' + node.standalone + '"';
      }
      r += this.spacebeforeslash + '?>';
      r += this.newline;
      return r;
    };

    XMLStringWriter.prototype.docType = function(node, level) {
      var child, i, len, r, ref;
      level || (level = 0);
      r = this.space(level);
      r += '<!DOCTYPE ' + node.root().name;
      if (node.pubID && node.sysID) {
        r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
      } else if (node.sysID) {
        r += ' SYSTEM "' + node.sysID + '"';
      }
      if (node.children.length > 0) {
        r += ' [';
        r += this.newline;
        ref = node.children;
        for (i = 0, len = ref.length; i < len; i++) {
          child = ref[i];
          r += (function() {
            switch (false) {
              case !(child instanceof XMLDTDAttList):
                return this.dtdAttList(child, level + 1);
              case !(child instanceof XMLDTDElement):
                return this.dtdElement(child, level + 1);
              case !(child instanceof XMLDTDEntity):
                return this.dtdEntity(child, level + 1);
              case !(child instanceof XMLDTDNotation):
                return this.dtdNotation(child, level + 1);
              case !(child instanceof XMLCData):
                return this.cdata(child, level + 1);
              case !(child instanceof XMLComment):
                return this.comment(child, level + 1);
              case !(child instanceof XMLProcessingInstruction):
                return this.processingInstruction(child, level + 1);
              default:
                throw new Error("Unknown DTD node type: " + child.constructor.name);
            }
          }).call(this);
        }
        r += ']';
      }
      r += this.spacebeforeslash + '>';
      r += this.newline;
      return r;
    };

    XMLStringWriter.prototype.element = function(node, level) {
      var att, child, i, j, len, len1, name, r, ref, ref1, ref2, space, textispresentwasset;
      level || (level = 0);
      textispresentwasset = false;
      if (this.textispresent) {
        this.newline = '';
        this.pretty = false;
      } else {
        this.newline = this.newlinedefault;
        this.pretty = this.prettydefault;
      }
      space = this.space(level);
      r = '';
      r += space + '<' + node.name;
      ref = node.attributes;
      for (name in ref) {
        if (!hasProp.call(ref, name)) continue;
        att = ref[name];
        r += this.attribute(att);
      }
      if (node.children.length === 0 || node.children.every(function(e) {
        return e.value === '';
      })) {
        if (this.allowEmpty) {
          r += '></' + node.name + '>' + this.newline;
        } else {
          r += this.spacebeforeslash + '/>' + this.newline;
        }
      } else if (this.pretty && node.children.length === 1 && (node.children[0].value != null)) {
        r += '>';
        r += node.children[0].value;
        r += '</' + node.name + '>' + this.newline;
      } else {
        if (this.dontprettytextnodes) {
          ref1 = node.children;
          for (i = 0, len = ref1.length; i < len; i++) {
            child = ref1[i];
            if (child.value != null) {
              this.textispresent++;
              textispresentwasset = true;
              break;
            }
          }
        }
        if (this.textispresent) {
          this.newline = '';
          this.pretty = false;
          space = this.space(level);
        }
        r += '>' + this.newline;
        ref2 = node.children;
        for (j = 0, len1 = ref2.length; j < len1; j++) {
          child = ref2[j];
          r += (function() {
            switch (false) {
              case !(child instanceof XMLCData):
                return this.cdata(child, level + 1);
              case !(child instanceof XMLComment):
                return this.comment(child, level + 1);
              case !(child instanceof XMLElement):
                return this.element(child, level + 1);
              case !(child instanceof XMLRaw):
                return this.raw(child, level + 1);
              case !(child instanceof XMLText):
                return this.text(child, level + 1);
              case !(child instanceof XMLProcessingInstruction):
                return this.processingInstruction(child, level + 1);
              default:
                throw new Error("Unknown XML node type: " + child.constructor.name);
            }
          }).call(this);
        }
        if (textispresentwasset) {
          this.textispresent--;
        }
        if (!this.textispresent) {
          this.newline = this.newlinedefault;
          this.pretty = this.prettydefault;
        }
        r += space + '</' + node.name + '>' + this.newline;
      }
      return r;
    };

    XMLStringWriter.prototype.processingInstruction = function(node, level) {
      var r;
      r = this.space(level) + '<?' + node.target;
      if (node.value) {
        r += ' ' + node.value;
      }
      r += this.spacebeforeslash + '?>' + this.newline;
      return r;
    };

    XMLStringWriter.prototype.raw = function(node, level) {
      return this.space(level) + node.value + this.newline;
    };

    XMLStringWriter.prototype.text = function(node, level) {
      return this.space(level) + node.value + this.newline;
    };

    XMLStringWriter.prototype.dtdAttList = function(node, level) {
      var r;
      r = this.space(level) + '<!ATTLIST ' + node.elementName + ' ' + node.attributeName + ' ' + node.attributeType;
      if (node.defaultValueType !== '#DEFAULT') {
        r += ' ' + node.defaultValueType;
      }
      if (node.defaultValue) {
        r += ' "' + node.defaultValue + '"';
      }
      r += this.spacebeforeslash + '>' + this.newline;
      return r;
    };

    XMLStringWriter.prototype.dtdElement = function(node, level) {
      return this.space(level) + '<!ELEMENT ' + node.name + ' ' + node.value + this.spacebeforeslash + '>' + this.newline;
    };

    XMLStringWriter.prototype.dtdEntity = function(node, level) {
      var r;
      r = this.space(level) + '<!ENTITY';
      if (node.pe) {
        r += ' %';
      }
      r += ' ' + node.name;
      if (node.value) {
        r += ' "' + node.value + '"';
      } else {
        if (node.pubID && node.sysID) {
          r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
        } else if (node.sysID) {
          r += ' SYSTEM "' + node.sysID + '"';
        }
        if (node.nData) {
          r += ' NDATA ' + node.nData;
        }
      }
      r += this.spacebeforeslash + '>' + this.newline;
      return r;
    };

    XMLStringWriter.prototype.dtdNotation = function(node, level) {
      var r;
      r = this.space(level) + '<!NOTATION ' + node.name;
      if (node.pubID && node.sysID) {
        r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
      } else if (node.pubID) {
        r += ' PUBLIC "' + node.pubID + '"';
      } else if (node.sysID) {
        r += ' SYSTEM "' + node.sysID + '"';
      }
      r += this.spacebeforeslash + '>' + this.newline;
      return r;
    };

    XMLStringWriter.prototype.openNode = function(node, level) {
      var att, name, r, ref;
      level || (level = 0);
      if (node instanceof XMLElement) {
        r = this.space(level) + '<' + node.name;
        ref = node.attributes;
        for (name in ref) {
          if (!hasProp.call(ref, name)) continue;
          att = ref[name];
          r += this.attribute(att);
        }
        r += (node.children ? '>' : '/>') + this.newline;
        return r;
      } else {
        r = this.space(level) + '<!DOCTYPE ' + node.rootNodeName;
        if (node.pubID && node.sysID) {
          r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
        } else if (node.sysID) {
          r += ' SYSTEM "' + node.sysID + '"';
        }
        r += (node.children ? ' [' : '>') + this.newline;
        return r;
      }
    };

    XMLStringWriter.prototype.closeNode = function(node, level) {
      level || (level = 0);
      switch (false) {
        case !(node instanceof XMLElement):
          return this.space(level) + '</' + node.name + '>' + this.newline;
        case !(node instanceof XMLDocType):
          return this.space(level) + ']>' + this.newline;
      }
    };

    return XMLStringWriter;

  })(XMLWriterBase);

}).call(this);

},{"./XMLCData":105,"./XMLComment":106,"./XMLDTDAttList":107,"./XMLDTDElement":108,"./XMLDTDEntity":109,"./XMLDTDNotation":110,"./XMLDeclaration":111,"./XMLDocType":112,"./XMLElement":115,"./XMLProcessingInstruction":117,"./XMLRaw":118,"./XMLText":122,"./XMLWriterBase":123}],121:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var XMLStringifier,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    hasProp = {}.hasOwnProperty;

  module.exports = XMLStringifier = (function() {
    function XMLStringifier(options) {
      this.assertLegalChar = bind(this.assertLegalChar, this);
      var key, ref, value;
      options || (options = {});
      this.noDoubleEncoding = options.noDoubleEncoding;
      ref = options.stringify || {};
      for (key in ref) {
        if (!hasProp.call(ref, key)) continue;
        value = ref[key];
        this[key] = value;
      }
    }

    XMLStringifier.prototype.eleName = function(val) {
      val = '' + val || '';
      return this.assertLegalChar(val);
    };

    XMLStringifier.prototype.eleText = function(val) {
      val = '' + val || '';
      return this.assertLegalChar(this.elEscape(val));
    };

    XMLStringifier.prototype.cdata = function(val) {
      val = '' + val || '';
      val = val.replace(']]>', ']]]]><![CDATA[>');
      return this.assertLegalChar(val);
    };

    XMLStringifier.prototype.comment = function(val) {
      val = '' + val || '';
      if (val.match(/--/)) {
        throw new Error("Comment text cannot contain double-hypen: " + val);
      }
      return this.assertLegalChar(val);
    };

    XMLStringifier.prototype.raw = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.attName = function(val) {
      return val = '' + val || '';
    };

    XMLStringifier.prototype.attValue = function(val) {
      val = '' + val || '';
      return this.attEscape(val);
    };

    XMLStringifier.prototype.insTarget = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.insValue = function(val) {
      val = '' + val || '';
      if (val.match(/\?>/)) {
        throw new Error("Invalid processing instruction value: " + val);
      }
      return val;
    };

    XMLStringifier.prototype.xmlVersion = function(val) {
      val = '' + val || '';
      if (!val.match(/1\.[0-9]+/)) {
        throw new Error("Invalid version number: " + val);
      }
      return val;
    };

    XMLStringifier.prototype.xmlEncoding = function(val) {
      val = '' + val || '';
      if (!val.match(/^[A-Za-z](?:[A-Za-z0-9._-])*$/)) {
        throw new Error("Invalid encoding: " + val);
      }
      return val;
    };

    XMLStringifier.prototype.xmlStandalone = function(val) {
      if (val) {
        return "yes";
      } else {
        return "no";
      }
    };

    XMLStringifier.prototype.dtdPubID = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdSysID = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdElementValue = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdAttType = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdAttDefault = function(val) {
      if (val != null) {
        return '' + val || '';
      } else {
        return val;
      }
    };

    XMLStringifier.prototype.dtdEntityValue = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdNData = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.convertAttKey = '@';

    XMLStringifier.prototype.convertPIKey = '?';

    XMLStringifier.prototype.convertTextKey = '#text';

    XMLStringifier.prototype.convertCDataKey = '#cdata';

    XMLStringifier.prototype.convertCommentKey = '#comment';

    XMLStringifier.prototype.convertRawKey = '#raw';

    XMLStringifier.prototype.assertLegalChar = function(str) {
      var res;
      res = str.match(/[\0\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/);
      if (res) {
        throw new Error("Invalid character in string: " + str + " at index " + res.index);
      }
      return str;
    };

    XMLStringifier.prototype.elEscape = function(str) {
      var ampregex;
      ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
      return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\r/g, '&#xD;');
    };

    XMLStringifier.prototype.attEscape = function(str) {
      var ampregex;
      ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
      return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/\t/g, '&#x9;').replace(/\n/g, '&#xA;').replace(/\r/g, '&#xD;');
    };

    return XMLStringifier;

  })();

}).call(this);

},{}],122:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var XMLNode, XMLText,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = require('./XMLNode');

  module.exports = XMLText = (function(superClass) {
    extend(XMLText, superClass);

    function XMLText(parent, text) {
      XMLText.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing element text. " + this.debugInfo());
      }
      this.value = this.stringify.eleText(text);
    }

    XMLText.prototype.clone = function() {
      return Object.create(this);
    };

    XMLText.prototype.toString = function(options) {
      return this.options.writer.set(options).text(this);
    };

    return XMLText;

  })(XMLNode);

}).call(this);

},{"./XMLNode":116}],123:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var XMLWriterBase,
    hasProp = {}.hasOwnProperty;

  module.exports = XMLWriterBase = (function() {
    function XMLWriterBase(options) {
      var key, ref, ref1, ref2, ref3, ref4, ref5, ref6, value;
      options || (options = {});
      this.pretty = options.pretty || false;
      this.allowEmpty = (ref = options.allowEmpty) != null ? ref : false;
      if (this.pretty) {
        this.indent = (ref1 = options.indent) != null ? ref1 : '  ';
        this.newline = (ref2 = options.newline) != null ? ref2 : '\n';
        this.offset = (ref3 = options.offset) != null ? ref3 : 0;
        this.dontprettytextnodes = (ref4 = options.dontprettytextnodes) != null ? ref4 : 0;
      } else {
        this.indent = '';
        this.newline = '';
        this.offset = 0;
        this.dontprettytextnodes = 0;
      }
      this.spacebeforeslash = (ref5 = options.spacebeforeslash) != null ? ref5 : '';
      if (this.spacebeforeslash === true) {
        this.spacebeforeslash = ' ';
      }
      this.newlinedefault = this.newline;
      this.prettydefault = this.pretty;
      ref6 = options.writer || {};
      for (key in ref6) {
        if (!hasProp.call(ref6, key)) continue;
        value = ref6[key];
        this[key] = value;
      }
    }

    XMLWriterBase.prototype.set = function(options) {
      var key, ref, value;
      options || (options = {});
      if ("pretty" in options) {
        this.pretty = options.pretty;
      }
      if ("allowEmpty" in options) {
        this.allowEmpty = options.allowEmpty;
      }
      if (this.pretty) {
        this.indent = "indent" in options ? options.indent : '  ';
        this.newline = "newline" in options ? options.newline : '\n';
        this.offset = "offset" in options ? options.offset : 0;
        this.dontprettytextnodes = "dontprettytextnodes" in options ? options.dontprettytextnodes : 0;
      } else {
        this.indent = '';
        this.newline = '';
        this.offset = 0;
        this.dontprettytextnodes = 0;
      }
      this.spacebeforeslash = "spacebeforeslash" in options ? options.spacebeforeslash : '';
      if (this.spacebeforeslash === true) {
        this.spacebeforeslash = ' ';
      }
      this.newlinedefault = this.newline;
      this.prettydefault = this.pretty;
      ref = options.writer || {};
      for (key in ref) {
        if (!hasProp.call(ref, key)) continue;
        value = ref[key];
        this[key] = value;
      }
      return this;
    };

    XMLWriterBase.prototype.space = function(level) {
      var indent;
      if (this.pretty) {
        indent = (level || 0) + this.offset + 1;
        if (indent > 0) {
          return new Array(indent).join(this.indent);
        } else {
          return '';
        }
      } else {
        return '';
      }
    };

    return XMLWriterBase;

  })();

}).call(this);

},{}],124:[function(require,module,exports){
// Generated by CoffeeScript 1.12.7
(function() {
  var XMLDocument, XMLDocumentCB, XMLStreamWriter, XMLStringWriter, assign, isFunction, ref;

  ref = require('./Utility'), assign = ref.assign, isFunction = ref.isFunction;

  XMLDocument = require('./XMLDocument');

  XMLDocumentCB = require('./XMLDocumentCB');

  XMLStringWriter = require('./XMLStringWriter');

  XMLStreamWriter = require('./XMLStreamWriter');

  module.exports.create = function(name, xmldec, doctype, options) {
    var doc, root;
    if (name == null) {
      throw new Error("Root element needs a name.");
    }
    options = assign({}, xmldec, doctype, options);
    doc = new XMLDocument(options);
    root = doc.element(name);
    if (!options.headless) {
      doc.declaration(options);
      if ((options.pubID != null) || (options.sysID != null)) {
        doc.doctype(options);
      }
    }
    return root;
  };

  module.exports.begin = function(options, onData, onEnd) {
    var ref1;
    if (isFunction(options)) {
      ref1 = [options, onData], onData = ref1[0], onEnd = ref1[1];
      options = {};
    }
    if (onData) {
      return new XMLDocumentCB(options, onData, onEnd);
    } else {
      return new XMLDocument(options);
    }
  };

  module.exports.stringWriter = function(options) {
    return new XMLStringWriter(options);
  };

  module.exports.streamWriter = function(stream, options) {
    return new XMLStreamWriter(stream, options);
  };

}).call(this);

},{"./Utility":103,"./XMLDocument":113,"./XMLDocumentCB":114,"./XMLStreamWriter":119,"./XMLStringWriter":120}]},{},[21])(21)
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18), __webpack_require__(524).setImmediate))

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(525);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18), __webpack_require__(62)))

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

/*! @license DOMPurify 2.5.8 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.8/LICENSE */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.DOMPurify = factory());
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }
    return _construct.apply(null, arguments);
  }
  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }
  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var hasOwnProperty = Object.hasOwnProperty,
    setPrototypeOf = Object.setPrototypeOf,
    isFrozen = Object.isFrozen,
    getPrototypeOf = Object.getPrototypeOf,
    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
    seal = Object.seal,
    create = Object.create; // eslint-disable-line import/no-mutable-exports
  var _ref = typeof Reflect !== 'undefined' && Reflect,
    apply = _ref.apply,
    construct = _ref.construct;
  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }
  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }
  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }
  if (!construct) {
    construct = function construct(Func, args) {
      return _construct(Func, _toConsumableArray(args));
    };
  }
  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);
  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringToString = unapply(String.prototype.toString);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);
  var regExpTest = unapply(RegExp.prototype.test);
  var typeErrorCreate = unconstruct(TypeError);
  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return apply(func, thisArg, args);
    };
  }
  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return construct(func, args);
    };
  }

  /* Add properties to a lookup table */
  function addToSet(set, array, transformCaseFunc) {
    var _transformCaseFunc;
    transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }
    var l = array.length;
    while (l--) {
      var element = array[l];
      if (typeof element === 'string') {
        var lcElement = transformCaseFunc(element);
        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }
          element = lcElement;
        }
      }
      set[element] = true;
    }
    return set;
  }

  /* Shallow clone an object */
  function clone(object) {
    var newObject = create(null);
    var property;
    for (property in object) {
      if (apply(hasOwnProperty, object, [property]) === true) {
        newObject[property] = object[property];
      }
    }
    return newObject;
  }

  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */
  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);
      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }
        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }
      object = getPrototypeOf(object);
    }
    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }
    return fallbackValue;
  }

  var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);

  // SVG
  var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);

  // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.
  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
  var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']);

  // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.
  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
  var text = freeze(['#text']);

  var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
  var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
  var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  // eslint-disable-next-line unicorn/better-regex
  var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
  var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
  var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );
  var DOCTYPE_NAME = seal(/^html$/i);
  var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };

  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */
  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    }

    // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';
    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }
    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html) {
          return html;
        },
        createScriptURL: function createScriptURL(scriptUrl) {
          return scriptUrl;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };
  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };

    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */
    DOMPurify.version = '2.5.8';

    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */
    DOMPurify.removed = [];
    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;
      return DOMPurify;
    }
    var originalDocument = window.document;
    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
      HTMLTemplateElement = window.HTMLTemplateElement,
      Node = window.Node,
      Element = window.Element,
      NodeFilter = window.NodeFilter,
      _window$NamedNodeMap = window.NamedNodeMap,
      NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
      HTMLFormElement = window.HTMLFormElement,
      DOMParser = window.DOMParser,
      trustedTypes = window.trustedTypes;
    var ElementPrototype = Element.prototype;
    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode');

    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');
      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }
    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
    var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
    var _document = document,
      implementation = _document.implementation,
      createNodeIterator = _document.createNodeIterator,
      createDocumentFragment = _document.createDocumentFragment,
      getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;
    var documentMode = {};
    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}
    var hooks = {};

    /**
     * Expose whether this browser supports running the full DOMPurify.
     */
    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
    var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
      ERB_EXPR$1 = ERB_EXPR,
      TMPLIT_EXPR$1 = TMPLIT_EXPR,
      DATA_ATTR$1 = DATA_ATTR,
      ARIA_ATTR$1 = ARIA_ATTR,
      IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
      ATTR_WHITESPACE$1 = ATTR_WHITESPACE,
      CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
    var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;

    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */
    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));

    /* Allowed attribute names */
    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));

    /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */
    var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
      tagNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      attributeNameCheck: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: true,
        configurable: false,
        enumerable: true,
        value: false
      }
    }));

    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
    var FORBID_TAGS = null;

    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
    var FORBID_ATTR = null;

    /* Decide if ARIA attributes are okay */
    var ALLOW_ARIA_ATTR = true;

    /* Decide if custom data attributes are okay */
    var ALLOW_DATA_ATTR = true;

    /* Decide if unknown protocols are okay */
    var ALLOW_UNKNOWN_PROTOCOLS = false;

    /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */
    var ALLOW_SELF_CLOSE_IN_ATTR = true;

    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */
    var SAFE_FOR_TEMPLATES = false;

    /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */
    var SAFE_FOR_XML = true;

    /* Decide if document with <html>... should be returned */
    var WHOLE_DOCUMENT = false;

    /* Track whether config is already set on this instance of DOMPurify. */
    var SET_CONFIG = false;

    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */
    var FORCE_BODY = false;

    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */
    var RETURN_DOM = false;

    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */
    var RETURN_DOM_FRAGMENT = false;

    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */
    var RETURN_TRUSTED_TYPE = false;

    /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */
    var SANITIZE_DOM = true;

    /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */
    var SANITIZE_NAMED_PROPS = false;
    var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';

    /* Keep element content when removing element? */
    var KEEP_CONTENT = true;

    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */
    var IN_PLACE = false;

    /* Allow usage of profiles like html, svg and mathMl */
    var USE_PROFILES = {};

    /* Tags to ignore content of when KEEP_CONTENT is true */
    var FORBID_CONTENTS = null;
    var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);

    /* Tags that are safe for data: URIs */
    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);

    /* Attributes safe for values like "javascript:" */
    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */
    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;

    /* Allowed XHTML+XML namespaces */
    var ALLOWED_NAMESPACES = null;
    var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);

    /* Parsing of strict XHTML documents */
    var PARSER_MEDIA_TYPE;
    var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    var transformCaseFunc;

    /* Keep a reference to config to pass to hooks */
    var CONFIG = null;

    /* Ideally, do not touch anything below this line */
    /* ______________________________________________ */

    var formElement = document.createElement('form');
    var isRegexOrFunction = function isRegexOrFunction(testValue) {
      return testValue instanceof RegExp || testValue instanceof Function;
    };

    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity
    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }

      /* Shield configuration object from tampering */
      if (!cfg || _typeof(cfg) !== 'object') {
        cfg = {};
      }

      /* Shield configuration object from prototype pollution */
      cfg = clone(cfg);
      PARSER_MEDIA_TYPE =
      // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;

      // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;

      /* Set configuration parameters */
      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
      ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES),
      // eslint-disable-line indent
      cfg.ADD_URI_SAFE_ATTR,
      // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS),
      // eslint-disable-line indent
      cfg.ADD_DATA_URI_TAGS,
      // eslint-disable-line indent
      transformCaseFunc // eslint-disable-line indent
      ) // eslint-disable-line indent
      : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
      ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
      SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
      RETURN_DOM = cfg.RETURN_DOM || false; // Default false
      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
      FORCE_BODY = cfg.FORCE_BODY || false; // Default false
      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
      SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
      IN_PLACE = cfg.IN_PLACE || false; // Default false
      IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
      CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
      }
      if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
        CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
      }
      if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
        CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
      }
      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }
      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }

      /* Parse profile info */
      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
        ALLOWED_ATTR = [];
        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html$1);
          addToSet(ALLOWED_ATTR, html);
        }
        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg$1);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }
        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg);
          addToSet(ALLOWED_ATTR, xml);
        }
        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl$1);
          addToSet(ALLOWED_ATTR, mathMl);
          addToSet(ALLOWED_ATTR, xml);
        }
      }

      /* Merge configuration parameters */
      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }
        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }
      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }
        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }
      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
      }
      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }
        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
      }

      /* Add #text in case KEEP_CONTENT is set to true */
      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }

      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }

      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      }

      // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.
      if (freeze) {
        freeze(cfg);
      }
      CONFIG = cfg;
    };
    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
    var HTML_INTEGRATION_POINTS = addToSet({}, ['annotation-xml']);

    // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.
    var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);

    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */
    var ALL_SVG_TAGS = addToSet({}, svg$1);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);
    var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);

    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */
    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element);

      // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.
      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: NAMESPACE,
          tagName: 'template'
        };
      }
      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);
      if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
        return false;
      }
      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        }

        // The only way to switch from MathML to SVG is via`
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.
        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        }

        // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.
        return Boolean(ALL_SVG_TAGS[tagName]);
      }
      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        }

        // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points
        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        }

        // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.
        return Boolean(ALL_MATHML_TAGS[tagName]);
      }
      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }
        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace
        return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
      }

      // For XHTML and XML documents that support custom namespaces
      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
        return true;
      }

      // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
      // Return false just in case.
      return false;
    };

    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */
    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, {
        element: node
      });
      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };

    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */
    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }
      node.removeAttribute(name);

      // We void attribute values for unremovable "is"" attributes
      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };

    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */
    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc;
      var leadingWhitespace;
      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }
      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }
      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */
      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }

      /* Use createHTMLDocument in case DOMParser is not available */
      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);
        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
        } catch (_) {
          // Syntax error if dirtyPayload is invalid xml
        }
      }
      var body = doc.body || doc.documentElement;
      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }

      /* Work on whole document or just its body */
      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }
      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };

    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */
    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root,
      // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
    };

    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */
    var _isClobbered = function _isClobbered(elm) {
      return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
    };

    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */
    var _isNode = function _isNode(object) {
      return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };

    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */
    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }
      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };

    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */
    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content;

      /* Execute a hook if present */
      _executeHook('beforeSanitizeElements', currentNode, null);

      /* Check if element is clobbered or can clobber */
      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Check if tagname contains Unicode */
      if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Now let's check the element's type and name */
      var tagName = transformCaseFunc(currentNode.nodeName);

      /* Execute a hook if present */
      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });

      /* Detect mXSS attempts abusing namespace confusion */
      if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Mitigate a problem with templates inside select */
      if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove any ocurrence of processing instructions */
      if (currentNode.nodeType === 7) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove any kind of possibly harmful comments */
      if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove element if anything forbids its presence */
      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Check if we have a custom element to handle */
        if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
          if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
        }

        /* Keep content except for bad-listed elements */
        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
          if (childNodes && parentNode) {
            var childCount = childNodes.length;
            for (var i = childCount - 1; i >= 0; --i) {
              var childClone = cloneNode(childNodes[i], true);
              childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
              parentNode.insertBefore(childClone, getNextSibling(currentNode));
            }
          }
        }
        _forceRemove(currentNode);
        return true;
      }

      /* Check whether element has a valid namespace */
      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Make sure that older browsers don't get fallback-tag mXSS */
      if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Sanitize element content to be template-safe */
      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
        content = stringReplace(content, ERB_EXPR$1, ' ');
        content = stringReplace(content, TMPLIT_EXPR$1, ' ');
        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, {
            element: currentNode.cloneNode()
          });
          currentNode.textContent = content;
        }
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeElements', currentNode, null);
      return false;
    };

    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity
    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }

      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */
      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        if (
        // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) ||
        // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ; else {
          return false;
        }
        /* Check value is safe. First, is attr inert? If so, is safe */
      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ; else if (value) {
        return false;
      } else ;
      return true;
    };

    /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */
    var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
      return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
    };

    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */
    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr;
      var value;
      var lcName;
      var l;
      /* Execute a hook if present */
      _executeHook('beforeSanitizeAttributes', currentNode, null);
      var attributes = currentNode.attributes;

      /* Check if we have attributes; if not we might have a text node */
      if (!attributes || _isClobbered(currentNode)) {
        return;
      }
      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;

      /* Go backwards over all attributes; safely remove bad ones */
      while (l--) {
        attr = attributes[l];
        var _attr = attr,
          name = _attr.name,
          namespaceURI = _attr.namespaceURI;
        value = name === 'value' ? attr.value : stringTrim(attr.value);
        lcName = transformCaseFunc(name);

        /* Execute a hook if present */
        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
        value = hookEvent.attrValue;

        /* Did the hooks approve of the attribute? */
        if (hookEvent.forceKeepAttr) {
          continue;
        }

        /* Remove attribute */
        _removeAttribute(name, currentNode);

        /* Did the hooks approve of the attribute? */
        if (!hookEvent.keepAttr) {
          continue;
        }

        /* Work around a security issue in jQuery 3.0 */
        if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);
          continue;
        }

        /* Sanitize attribute content to be template-safe */
        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
          value = stringReplace(value, ERB_EXPR$1, ' ');
          value = stringReplace(value, TMPLIT_EXPR$1, ' ');
        }

        /* Is `value` valid for this attribute? */
        var lcTag = transformCaseFunc(currentNode.nodeName);
        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }

        /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */
        if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
          // Remove the attribute with this value
          _removeAttribute(name, currentNode);

          // Prefix the value and later re-create the attribute with the sanitized value
          value = SANITIZE_NAMED_PROPS_PREFIX + value;
        }

        /* Work around a security issue with comments inside attributes */
        if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
          _removeAttribute(name, currentNode);
          continue;
        }

        /* Handle attributes that require Trusted Types */
        if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
          if (namespaceURI) ; else {
            switch (trustedTypes.getAttributeType(lcTag, lcName)) {
              case 'TrustedHTML':
                {
                  value = trustedTypesPolicy.createHTML(value);
                  break;
                }
              case 'TrustedScriptURL':
                {
                  value = trustedTypesPolicy.createScriptURL(value);
                  break;
                }
            }
          }
        }

        /* Handle invalid data-* attribute set by try-catching it */
        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }
          if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
          } else {
            arrayPop(DOMPurify.removed);
          }
        } catch (_) {}
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeAttributes', currentNode, null);
    };

    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */
    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode;
      var shadowIterator = _createIterator(fragment);

      /* Execute a hook if present */
      _executeHook('beforeSanitizeShadowDOM', fragment, null);
      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);
        /* Sanitize tags and elements */
        _sanitizeElements(shadowNode);

        /* Check attributes next */
        _sanitizeAttributes(shadowNode);

        /* Deep shadow DOM detected */
        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };

    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity
    DOMPurify.sanitize = function (dirty) {
      var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var body;
      var importedNode;
      var currentNode;
      var oldNode;
      var returnNode;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */
      IS_EMPTY_INPUT = !dirty;
      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }

      /* Stringify, in case dirty is an object */
      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        if (typeof dirty.toString === 'function') {
          dirty = dirty.toString();
          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        } else {
          throw typeErrorCreate('toString is not a function');
        }
      }

      /* Check we can run. Otherwise fall back or ignore */
      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }
          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }
        return dirty;
      }

      /* Assign config vars */
      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }

      /* Clean up removed elements */
      DOMPurify.removed = [];

      /* Check if dirty is correctly typed for IN_PLACE */
      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }
      if (IN_PLACE) {
        /* Do some early pre-sanitization to avoid unsafe root nodes */
        if (dirty.nodeName) {
          var tagName = transformCaseFunc(dirty.nodeName);
          if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
          }
        }
      } else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);
        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
        // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }

        /* Initialize the document to work on */
        body = _initDocument(dirty);

        /* Check we have a DOM node from the data */
        if (!body) {
          return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
      }

      /* Remove first element node (ours) if FORCE_BODY is set */
      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }

      /* Get node iterator */
      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);

      /* Now start iterating over the created document */
      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }

        /* Sanitize tags and elements */
        _sanitizeElements(currentNode);

        /* Check attributes next */
        _sanitizeAttributes(currentNode);

        /* Shadow DOM detected, sanitize it */
        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }
        oldNode = currentNode;
      }
      oldNode = null;

      /* If we sanitized `dirty` in-place, return it. */
      if (IN_PLACE) {
        return dirty;
      }

      /* Return sanitized string or DOM */
      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);
          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }
        if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }
        return returnNode;
      }
      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;

      /* Serialize doctype if allowed */
      if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
        serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
      }

      /* Sanitize final string template-safe */
      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
        serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
      }
      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };

    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */
    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);
      SET_CONFIG = true;
    };

    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */
    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };

    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */
    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }
      var lcTag = transformCaseFunc(tag);
      var lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };

    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */
    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }
      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };

    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */
    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        return arrayPop(hooks[entryPoint]);
      }
    };

    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */
    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };

    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */
    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };
    return DOMPurify;
  }
  var purify = createDOMPurify();

  return purify;

}));
//# sourceMappingURL=purify.js.map


/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_shared_UploadAttachments__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ApplicationAttachmentsUploadModal=function(_React$Component){_inherits(ApplicationAttachmentsUploadModal,_React$Component);function ApplicationAttachmentsUploadModal(props){var _this2=this;_classCallCheck(this,ApplicationAttachmentsUploadModal);var _this=_possibleConstructorReturn(this,(ApplicationAttachmentsUploadModal.__proto__||Object.getPrototypeOf(ApplicationAttachmentsUploadModal)).call(this,props));_this.updateAttachments=function(newAttachments){_this.setState({newAttachments:newAttachments});};_this.deleteAttachment=function(attachment){if(_this.props.attachments.indexOf(attachment)>=0){_this.setState({deletedAttachments:[].concat(_toConsumableArray(_this.state.deletedAttachments),[attachment.documentId])});}};_this.onClose=function(){_this.setState(_this.initialState);_this.props.close();};_this.onSubmit=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.updateAttachments(_this.props.applicationId,{newAttachments:_this.state.newAttachments,deletedAttachments:_this.state.deletedAttachments});case 2:if(_this.props.success){_this.onClose();}else{_this.setState({error:true});}case 3:case'end':return _context.stop();}}},_callee,_this2);}));_this.initialState={deletedAttachments:[],newAttachments:[],error:false};_this.state=_this.initialState;return _this;}_createClass(ApplicationAttachmentsUploadModal,[{key:'render',value:function render(){var _this3=this;var _props=this.props,attachments=_props.attachments,loading=_props.loading,message=_props.message;var _state=this.state,deletedAttachments=_state.deletedAttachments,newAttachments=_state.newAttachments,error=_state.error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal large-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bordered-modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},'Manage Attachments'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.onClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-paperclip icon-left xl-text middle'}),'Attachment(s):'),attachments&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',null,attachments.map(function(attachment,index){if(deletedAttachments.indexOf(attachment.documentId)<0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:attachment.name},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-document icon-left middle'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'small-text'},attachment.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-outline trash-hover icon-right middle',onClick:function onClick(){return _this3.deleteAttachment(attachment);}}));}return null;})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_shared_UploadAttachments__["a" /* default */],{files:newAttachments,name:'newAttachments',onChange:function onChange(name,val){return _this3.updateAttachments(val);}}))),loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.onClose},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',onClick:this.onSubmit,disabled:!newAttachments.length&&!deletedAttachments.length},'Submit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:error,message:message})))));}}]);return ApplicationAttachmentsUploadModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ApplicationAttachmentsUploadModal);

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Select__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ApplyToPledgeModal=function(_React$Component){_inherits(ApplyToPledgeModal,_React$Component);function ApplyToPledgeModal(){_classCallCheck(this,ApplyToPledgeModal);return _possibleConstructorReturn(this,(ApplyToPledgeModal.__proto__||Object.getPrototypeOf(ApplyToPledgeModal)).apply(this,arguments));}_createClass(ApplyToPledgeModal,[{key:'render',value:function render(){var _props=this.props,show=_props.show,close=_props.close,applicantPledgeOptions=_props.applicantPledgeOptions,selectedPledgeId=_props.selectedPledgeId,onPledgeChange=_props.onPledgeChange,applyingPledge=_props.applyingPledge,onApply=_props.onApply;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_Modal__["a" /* default */],{modalShowing:show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal warning-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'modal-page-header'},'Apply to Pledge')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-row modal-row-full-width'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Pledge'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Select__["a" /* default */],{clearable:false,options:applicantPledgeOptions,name:'selectedPledgeId',value:selectedPledgeId,onChange:onPledgeChange})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-accent',onClick:close},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-accent2',disabled:!selectedPledgeId||applyingPledge,onClick:onApply},applyingPledge?'Applying...':'Apply')))));}}]);return ApplyToPledgeModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ApplyToPledgeModal);

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_CurrencyFormatInput__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_RadioGroup__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_UploadAttachments__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_shared_IncompleteApplicationWarning__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_util_AutocompleteInput__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__applicationsComponents_newApplication_PaymentInfo__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__applicationsComponents_newApplication_CheckExistsWarningModal__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_clonedeep__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_clonedeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_clonedeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__applicationsComponents_applicationsCommon_MarkInquiry__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__applicationsComponents_applicationsCommon_MarkInquiryWarning__ = __webpack_require__(187);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ApplicationDetailsEditCard=function(_NavigationComponent){_inherits(ApplicationDetailsEditCard,_NavigationComponent);function ApplicationDetailsEditCard(props){var _this2=this;_classCallCheck(this,ApplicationDetailsEditCard);var _this=_possibleConstructorReturn(this,(ApplicationDetailsEditCard.__proto__||Object.getPrototypeOf(ApplicationDetailsEditCard)).call(this,props));_this.save=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var bypass=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var missingFields,application,getUpdatedRecipient;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(_this.state.error||_this.state.manualCheckError)_this.setState({error:false,manualCheckError:false});missingFields=_this.props.getIncompleteFields(_this.state.application,_this.state.thirdPartyPayeeType);if(!(_this.state.submitAttempted||!missingFields)){_context.next=10;break;}application=Object.assign({},_this.state.application);if(application.paymentInfo.manualPayment.manualPaymentType&&application.amount){application.amount='';//clear out amount if paid by manual check
}else if(!application.paymentInfo.manualPayment.manualPaymentType){application.paymentInfo.manualPayment=null;}_context.next=7;return _this.props.updateApplication(_this.props.applicationDetails.applicationId,application,bypass);case 7:if(_this.props.updateApplicationDetails.success){getUpdatedRecipient=!missingFields&&application.paymentInfo.manualPayment&&application.paymentInfo.manualPayment.manualPaymentType||//need updated recipient total
application.sourceId!==_this.initialState.application.sourceId//need updated recipient references / trusted payee isUsedAsPayee
||!Object(__WEBPACK_IMPORTED_MODULE_17__lib_utils__["e" /* deepEquals */])(application.paymentInfo,_this.initialState.application.paymentInfo);_this.props.getApplicationDetails(_this.props.applicationDetails.applicationId,true,getUpdatedRecipient?_this.props.applicationDetails.recipientId:null);_this.props.getApplicationHistory();_this.props.toggleEditMode();}else{if(_this.props.updateApplicationDetails.message){if(_this.props.updateApplicationDetails.message.toLowerCase().indexOf('check number assigned')>=0){_this.toggleModal("checkExistsWarningModal");}else if(_this.props.updateApplicationDetails.message.toLowerCase().indexOf("available")>=0){_this.setState({manualCheckError:true,manualCheckLabel:'',application:Object.assign({},application,{paymentInfo:Object.assign({},application.paymentInfo,{manualPayment:Object.assign({},application.paymentInfo.manualPayment,{blankCheckId:''})})})});}}else{_this.setState({error:true});}}_context.next=11;break;case 10:if(!_this.state.submitAttempted)_this.setState({submitAttempted:true});case 11:case'end':return _context.stop();}}},_callee,_this2);}));var applicationDetails=_this.props.applicationDetails;_this.initialState={application:props.getInitialFormattedApplication(applicationDetails),applicationSourceType:!applicationDetails.source?__WEBPACK_IMPORTED_MODULE_16__lib_constants__["i" /* SourceTypes */].New:props.recipientDetails.references.map(function(r){return r.referenceId;}).indexOf(applicationDetails.source.referenceId)>=0?__WEBPACK_IMPORTED_MODULE_16__lib_constants__["i" /* SourceTypes */].Reference:__WEBPACK_IMPORTED_MODULE_16__lib_constants__["i" /* SourceTypes */].New,thirdPartyPayeeType:applicationDetails.paymentInfo.thirdParty&&applicationDetails.paymentInfo.thirdParty.referenceId?__WEBPACK_IMPORTED_MODULE_16__lib_constants__["i" /* SourceTypes */].Reference:__WEBPACK_IMPORTED_MODULE_16__lib_constants__["i" /* SourceTypes */].New,showCareOf:applicationDetails.paymentInfo.thirdParty&&applicationDetails.paymentInfo.thirdParty.careOf?true:false,incomplete:applicationDetails.status===__WEBPACK_IMPORTED_MODULE_15__lib_systemVariables__["a" /* ApplicationStatuses */].Incomplete,error:false,manualCheckError:false,manualCheckLabel:applicationDetails.paymentInfo.manualPayment&&applicationDetails.paymentInfo.manualPayment.manualPaymentType===__WEBPACK_IMPORTED_MODULE_15__lib_systemVariables__["h" /* ManualPaymentTypes */].BlankCheck?applicationDetails.paymentInfo.manualPayment.manualPaymentNumber||'':'',submitAttempted:applicationDetails.status===__WEBPACK_IMPORTED_MODULE_15__lib_systemVariables__["a" /* ApplicationStatuses */].Incomplete,showModals:{checkExistsWarningModal:false}};_this.state=__WEBPACK_IMPORTED_MODULE_14_lodash_clonedeep___default()(_this.initialState);_this.onChange=_this.onChange.bind(_this);_this.updateApplication=_this.updateApplication.bind(_this);_this.updatePaymentInfo=_this.updatePaymentInfo.bind(_this);return _this;}_createClass(ApplicationDetailsEditCard,[{key:'componentWillMount',value:function componentWillMount(){if(this.state.application.paymentInfo.fundId&&this.state.application.paymentInfo.manualPayment&&this.state.application.paymentInfo.manualPayment.manualPaymentType)this.props.getBlankChecks(this.state.application.paymentInfo.fundId);}},{key:'onChange',value:function onChange(name,value){this.setState(_defineProperty({},name,value));}},{key:'eventUpdate',value:function eventUpdate(func,event){func(event.target.name,event.target.type==="checkbox"?event.target.checked:event.target.value);}},{key:'updateApplication',value:function updateApplication(name,value){this.setState({application:Object.assign({},this.state.application,_defineProperty({},name,value))});}},{key:'updatePaymentInfo',value:function updatePaymentInfo(name,value){if(name==='fundId'&&this.state.application.paymentInfo.manualPayment&&this.state.application.paymentInfo.manualPayment.manualPaymentType){var _Object$assign2;this.props.getBlankChecks(value);this.setState({manualCheckLabel:'',application:Object.assign({},this.state.application,{paymentInfo:Object.assign({},this.state.application.paymentInfo,(_Object$assign2={},_defineProperty(_Object$assign2,name,value),_defineProperty(_Object$assign2,'manualPayment',Object.assign({},this.state.application.paymentInfo.manualPayment,{blankCheckId:''})),_Object$assign2))})});}else this.setState({application:Object.assign({},this.state.application,{paymentInfo:Object.assign({},this.state.application.paymentInfo,_defineProperty({},name,value))})});}},{key:'updateAttachments',value:function updateAttachments(name,value){this.setState({application:Object.assign({},this.state.application,_defineProperty({},name,value))});}},{key:'deleteAttachment',value:function deleteAttachment(attachment){var files=[].concat(_toConsumableArray(this.props.applicationDetails.attachments));var index=files.indexOf(attachment);if(index>=0){this.setState({application:Object.assign({},this.state.application,{deletedAttachments:[].concat(_toConsumableArray(this.state.application.deletedAttachments),[attachment.documentId])})});}}},{key:'isWedding',value:function isWedding(reasonId,applicationReasons){var s="wedding";for(var index=0;index<applicationReasons.length;index++){var element=applicationReasons[index];if(element.key==reasonId){var containsWedding=element.value.toLowerCase().includes(s);if(containsWedding)return true;}}return false;}},{key:'render',value:function render(){var _this3=this;var _state=this.state,application=_state.application,applicationSourceType=_state.applicationSourceType,manualCheckLabel=_state.manualCheckLabel,thirdPartyPayeeType=_state.thirdPartyPayeeType,submitAttempted=_state.submitAttempted,error=_state.error;var _props=this.props,userId=_props.userId,permissions=_props.permissions,blankChecks=_props.blankChecks,applicationDetails=_props.applicationDetails,updateApplicationDetails=_props.updateApplicationDetails,recipientDetails=_props.recipientDetails,tags=_props.tags,toggleEditMode=_props.toggleEditMode;var isManualPayment=application.paymentInfo.manualPayment&&application.paymentInfo.manualPayment.manualPaymentType;var payeeIsIsraeli=Object(__WEBPACK_IMPORTED_MODULE_17__lib_utils__["p" /* getApplicationPayee */])(application.paymentInfo,recipientDetails).isIsraeli;var incompleteFields=this.props.getIncompleteFields(this.state.application,this.state.thirdPartyPayeeType);var isDisabled=Object(__WEBPACK_IMPORTED_MODULE_17__lib_utils__["e" /* deepEquals */])(this.initialState.application,this.state.application)//no changes
||applicationDetails.status===__WEBPACK_IMPORTED_MODULE_15__lib_systemVariables__["a" /* ApplicationStatuses */].Approved&&application.amount>applicationDetails.maxApprovalAmount//when amount is editable check that amount does not exceed max amount
||this.state.submitAttempted&&!this.state.incomplete&&incompleteFields//cannot make complete app incomplete
||!application.paymentInfo.fundId||!application.approverId;//these 2 fields cannot be removed even for incomplete
var showMarkInquiry=application.approverId===userId||permissions.admin;var applicantPledgeOptions=recipientDetails.applicantPledges.map(function(x){return{key:x.applicantPledgeId,value:Object(__WEBPACK_IMPORTED_MODULE_17__lib_utils__["k" /* formatDate */])(x.pledgeDate)+" - "+Object(__WEBPACK_IMPORTED_MODULE_17__lib_utils__["j" /* formatCurrency */])(x.pledgeAmount)};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details-card card'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details-card-header flex-justify flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Edit Details')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details-card-edit'},applicationDetails.status===__WEBPACK_IMPORTED_MODULE_15__lib_systemVariables__["a" /* ApplicationStatuses */].Incomplete&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'error-label'},'This application was incomplete'),applicationDetails.inquire&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__applicationsComponents_applicationsCommon_MarkInquiryWarning__["a" /* default */],{inquireNote:application.inquireNote}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center info-row'},applicationDetails.status===__WEBPACK_IMPORTED_MODULE_15__lib_systemVariables__["a" /* ApplicationStatuses */].Approved&&!isManualPayment&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_CurrencyFormatInput__["a" /* default */],{tabIndex:500,isIsraeli:payeeIsIsraeli}),label:'Amount',name:'amount',value:application.amount,onChange:this.updateApplication,required:applicationDetails.status===__WEBPACK_IMPORTED_MODULE_15__lib_systemVariables__["a" /* ApplicationStatuses */].Approved,showRequiredError:submitAttempted,validated:true,showValidationError:true,validate:function validate(val){return applicationDetails.maxApprovalAmount?Object(__WEBPACK_IMPORTED_MODULE_17__lib_utils__["B" /* stripCurrencyFormat */])(val)<=applicationDetails.maxApprovalAmount:true;},errorMessage:'Amount cannot exceed '+Object(__WEBPACK_IMPORTED_MODULE_17__lib_utils__["j" /* formatCurrency */])(applicationDetails.maxApprovalAmount,payeeIsIsraeli)+'.'})),!applicationDetails.campaign&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:applicationDetails.status===__WEBPACK_IMPORTED_MODULE_15__lib_systemVariables__["a" /* ApplicationStatuses */].Approved?"column-third":"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Request Amount'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_CurrencyFormatInput__["a" /* default */],{tabIndex:505,name:'requestAmount',value:application.requestAmount,onChange:this.eventUpdate.bind(this,this.updateApplication),isIsraeli:payeeIsIsraeli})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:applicationDetails.status===__WEBPACK_IMPORTED_MODULE_15__lib_systemVariables__["a" /* ApplicationStatuses */].Approved?"column-third":"column-half"},!applicationDetails.campaign&&permissions.applications.private&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'check-private',className:'custom-check',name:'isPrivate',checked:application.isPrivate,onChange:this.eventUpdate.bind(this,this.updateApplication)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'check-private'},'Private')))),!applicationDetails.campaign&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half column-half-left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_Select__["a" /* default */],{tabIndex:510,clearable:true,options:tags.applicationReasons}),onChange:this.updateApplication,required:!isManualPayment,showRequiredError:submitAttempted,label:'Reason',name:'reasonId',value:application.reasonId})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half column-half-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_Select__["a" /* default */],{tabIndex:520,options:tags.approvers}),name:'approverId',value:application.approverId,onChange:this.updateApplication,label:'Approver',required:true,showRequiredError:submitAttempted}))),this.isWedding(application.reasonId,tags.applicationReasons)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'date',format:'mm/dd/yyyy',min:Object(__WEBPACK_IMPORTED_MODULE_17__lib_utils__["l" /* formatDateForInput */])(application.reasonDate),max:'9999-12-31'}),label:'Wedding Date',name:'reasonDate',value:Object(__WEBPACK_IMPORTED_MODULE_17__lib_utils__["l" /* formatDateForInput */])(application.reasonDate),tabIndex:432,onChange:this.updateApplication,required:false,showRequiredError:this.submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'Wedding Hall',name:'weddingHall',value:application.weddingHall,onChange:this.updateApplication})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_Select__["a" /* default */],{tabIndex:430,options:[{key:'Boy',value:'Boy'},{key:'Girl',value:'Girl'}]}),label:'Side',name:'weddingSide',value:application.weddingSide,onChange:this.updateApplication}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_RadioGroup__["a" /* default */],{title:'Source',options:[{key:'new',value:'Enter New'},{key:'reference',value:'Choose Reference',disabled:!recipientDetails.references.length}],name:'applicationSourceType',value:this.state.applicationSourceType,onChange:this.onChange}),applicationSourceType==="reference"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_Select__["a" /* default */],{tabIndex:530,options:recipientDetails.references.map(function(ref){return{key:ref.referenceId,value:ref.displayName};}),name:'sourceId',value:application.sourceId,onChange:function onChange(e){return _this3.updateApplication(e.target.name,e.target.value);}}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_util_AutocompleteInput__["a" /* default */],{tabIndex:530,showList:true,placeholder:'Search references',name:'sourceId',value:application.sourceId,options:Object(__WEBPACK_IMPORTED_MODULE_17__lib_utils__["o" /* formatReferenceOptions */])(tags.references.filter(function(r){return recipientDetails.references.map(function(ref){return ref.referenceId;}).indexOf(r.referenceId)<0;})),update:this.updateApplication})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Campaign Individual Category'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_Select__["a" /* default */],{tabIndex:450,clearable:true,options:tags.campaignIndivCategories,name:'individualCategoryId',value:application.individualCategoryId,onChange:function onChange(e){return _this3.updateApplication(e.target.name,e.target.value);}})),recipientDetails.applicantPledges.length>=1&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Pledge'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_Select__["a" /* default */],{tabIndex:455,clearable:true,options:applicantPledgeOptions,name:'applicantPledgeId',value:application.applicantPledgeId,onChange:function onChange(e){return _this3.updateApplication(e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__applicationsComponents_newApplication_PaymentInfo__["a" /* default */],{applicationId:applicationDetails.applicationId,campaignApplication:applicationDetails.campaign,submitAttempted:submitAttempted,paymentInfo:application.paymentInfo,manageAccounting:permissions.accounting.manage,payeeIsIsraeli:payeeIsIsraeli,initialThirdParty:{referenceId:'',useRecipientAddress:false,isIsraeli:recipientDetails.isIsraeli,firstName:'',lastName:'',orgName:'',address:{},bankNumber:'',branchNumber:'',accountNumber:'',accountHolder:'',careOf:''},preEditThirdParty:this.initialState.application.paymentInfo.thirdParty,trustedPayee:recipientDetails.trustedPayee,onChange:this.onChange,updateApplication:this.updateApplication,updatePaymentInfo:this.updatePaymentInfo,funds:payeeIsIsraeli&&!isManualPayment?tags.israeliFunds:tags.usFunds,defaultUSFund:tags.defaultUSFund,defaultIsraeliFund:tags.defaultIsraelFund,blankChecks:Object.assign({},blankChecks,{data:[].concat(_toConsumableArray(applicationDetails.paymentInfo&&applicationDetails.paymentInfo.manualPayment&&applicationDetails.paymentInfo.manualPayment.manualPaymentType&&applicationDetails.paymentInfo.manualPayment.blankCheckId&&applicationDetails.paymentInfo.fundId.toString()===application.paymentInfo.fundId.toString()?[{blankCheckId:applicationDetails.paymentInfo.manualPayment.blackCheckId,checkNumber:applicationDetails.paymentInfo.manualPayment.manualPaymentNumber}]:[]),_toConsumableArray(blankChecks.data))}),getBlankChecks:this.props.getBlankChecks,manualCheckLabel:manualCheckLabel,manualPaymentTypes:this.props.manualPaymentTypes,thirdPartyPayeeType:thirdPartyPayeeType,showCareOf:this.state.showCareOf,recipientReferences:recipientDetails.references.filter(function(ref){return ref.isPayable;}),recipientAddress:!recipientDetails.isIsraeli&&recipientDetails.address?Object(__WEBPACK_IMPORTED_MODULE_17__lib_utils__["b" /* concatenateAddressLabel */])(recipientDetails.address):'',recipientTypes:tags.recipientTypes})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-paperclip icon-left xl-text middle'}),'Attachment(s):'),applicationDetails.attachments&&applicationDetails.attachments.map(function(attachment,index){if(_this3.state.application.deletedAttachments.indexOf(attachment.documentId)<0)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text',key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-document icon-left middle'}),attachment.name,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{onClick:_this3.deleteAttachment.bind(_this3,attachment),className:'icon ion-trash-b trash-hover accent-text icon-right'}));return null;})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_UploadAttachments__["a" /* default */],{files:application.newAttachments,name:'newAttachments',onChange:this.updateAttachments.bind(this)})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:"24px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},'Print Instructions'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Card Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_Select__["a" /* default */],{tabIndex:800,clearable:true,name:'cardTypeId',value:application.cardTypeId,options:tags.cardTypes,onChange:this.eventUpdate.bind(this,this.updateApplication)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-two-thirds'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'empty-label'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{tabIndex:810,type:'text',placeholder:'Enter any other instructions',name:'printInstructions',value:application.printInstructions,onChange:this.eventUpdate.bind(this,this.updateApplication)})))),showMarkInquiry&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__applicationsComponents_applicationsCommon_MarkInquiry__["a" /* default */],{inquire:application.inquire,inquireNote:application.inquireNote,updateApplication:this.updateApplication}),submitAttempted&&incompleteFields&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_shared_IncompleteApplicationWarning__["a" /* default */],{fields:incompleteFields,allowIncomplete:applicationDetails.status===__WEBPACK_IMPORTED_MODULE_15__lib_systemVariables__["a" /* ApplicationStatuses */].Incomplete}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__applicationsComponents_newApplication_CheckExistsWarningModal__["a" /* default */],{transactions:this.props.updateApplicationDetails.data,message:this.props.updateApplicationDetails.message,show:this.state.showModals.checkExistsWarningModal,close:function close(){return _this3.toggleModal("checkExistsWarningModal");},'continue':function _continue(){return _this3.save(true);}}),updateApplicationDetails.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'details-card-footer clearfix text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:toggleEditMode},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-flat-primary',onClick:this.save.bind(this),disabled:isDisabled},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons icon-left'},'save'),'Update'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:error||this.state.manualCheckError,message:this.state.manualCheckError?'Manual Check Number is not available. Please select a different check number.':'Something went wrong and the application could not be updated. Please try again.'}))));}}]);return ApplicationDetailsEditCard;}(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ApplicationDetailsEditCard);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_ReferencesActions__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ReferencesTable__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReferenceModal__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_throttle_debounce__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_throttle_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_throttle_debounce__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReferencesPage=function(_NavigationComponent){_inherits(ReferencesPage,_NavigationComponent);function ReferencesPage(props){var _this2=this;_classCallCheck(this,ReferencesPage);var _this=_possibleConstructorReturn(this,(ReferencesPage.__proto__||Object.getPrototypeOf(ReferencesPage)).call(this,props));_this.searchReferences=function(keyword){_this.props.actions.updateReferencesSearch(keyword);_this.searchDebounce();};_this.searchDebounce=Object(__WEBPACK_IMPORTED_MODULE_9_throttle_debounce__["debounce"])(500,function(){_this.props.actions.getReferences(1,_this.props.referencesTable.resultView,_this.props.referencesTable.sort);});_this.createReference=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(reference){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.actions.createReference(reference);case 2:if(_this.props.createReference.success){_this.props.actions.getReferences(1,_this.props.referencesTable.resultView,_this.props.referencesTable.sort);}case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.updateReference=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(referenceId,reference){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.actions.updateReference(referenceId,reference);case 2:if(_this.props.updateReference.success){_this.props.actions.getReferences(_this.props.referencesTable.page,_this.props.referencesTable.resultView,_this.props.referencesTable.sort);}case 3:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2,_x3){return _ref2.apply(this,arguments);};}();_this.state={showModals:{newReferenceModal:false}};return _this;}_createClass(ReferencesPage,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.searchReferences('');}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page references-page'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'subheader'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container flex-justify flex-center',style:{marginBottom:"32px"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'page-header'},'References'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'search-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'search'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',placeholder:'Search',value:this.props.keyword||'',disabled:!this.props.keyword&&!this.props.referencesTable.data.records.length,onChange:function onChange(e){return _this3.searchReferences(e.target.value);}}))),this.props.userPermissions.manage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this3.toggleModal("newReferenceModal");}},'New Reference')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ReferencesTable__["a" /* default */],Object.assign({canManage:this.props.userPermissions.manage},this.props.referencesTable,{updateTable:this.props.actions.updateTable,getReferences:this.props.actions.getReferences,updatingReference:this.props.updateReference,updateReference:this.updateReference,deleteReference:this.props.actions.deleteReference,usPersonTitles:this.props.usPersonTitles,israelPersonTitles:this.props.israelPersonTitles,usInstitutionTitles:this.props.usInstitutionTitles,israelInstitutionTitles:this.props.israelInstitutionTitles,recipientTypes:this.props.recipientTypes})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ReferenceModal__["a" /* default */],Object.assign({show:this.state.showModals.newReferenceModal,close:this.toggleModal.bind(this,"newReferenceModal")},this.props.createReference,{submitReference:this.createReference,usPersonTitles:this.props.usPersonTitles,israelPersonTitles:this.props.israelPersonTitles,usInstitutionTitles:this.props.usInstitutionTitles,israelInstitutionTitles:this.props.israelInstitutionTitles,recipientTypes:this.props.recipientTypes})));}}]);return ReferencesPage;}(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_NavigationComponent__["a" /* default */]);function mapStateToProps(state){return Object.assign({},state.references,{referencesTable:state.referencesTable,usPersonTitles:state.settings.systemSettings.data.recipientSettings.usPersonTitles,israelPersonTitles:state.settings.systemSettings.data.recipientSettings.israelPersonTitles,usInstitutionTitles:state.settings.systemSettings.data.recipientSettings.usInstitutionTitles,israelInstitutionTitles:state.settings.systemSettings.data.recipientSettings.israelInstitutionTitles,recipientTypes:state.settings.systemSettings.data.otherSettings.recipientTypes,userPermissions:{manage:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["j" /* PermissionTypes */].RecipientAccntsManage)>=0}});}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_4__redux_actions_ReferencesActions__,dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(ReferencesPage));

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_PaginatedTable__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ReferencesTableRow__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReferenceModal__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_ConfirmationModal__ = __webpack_require__(22);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReferencesTable=function(_NavigationComponent){_inherits(ReferencesTable,_NavigationComponent);function ReferencesTable(props){_classCallCheck(this,ReferencesTable);var _this=_possibleConstructorReturn(this,(ReferencesTable.__proto__||Object.getPrototypeOf(ReferencesTable)).call(this,props));_this.initialState={selectedRecord:{},showModals:{editReferenceModal:false,confirmationModal:false}};_this.state=_this.initialState;_this.getTableRow=_this.getTableRow.bind(_this);return _this;}_createClass(ReferencesTable,[{key:'getTableRow',value:function getTableRow(reference){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ReferencesTableRow__["a" /* default */],{key:reference.referenceId,reference:reference,canManage:this.props.canManage,edit:function edit(){return _this2.setState({selectedRecord:reference},_this2.toggleModal.bind(_this2,"editReferenceModal"));},'delete':function _delete(){return _this2.setState({selectedRecord:reference},_this2.toggleModal.bind(_this2,"confirmationModal"));}});}},{key:'render',value:function render(){var _this3=this;var columns=[{title:'Name',sortable:true,id:'name'},{title:'Position',sortable:true,id:'position'},{title:'Phone',sortable:true,id:'phone'},{title:'Email',sortable:true,id:'email'},{title:'Address',sortable:true,id:'address'},{title:'Used As Payee',sortable:true,id:'isPayee'},{title:'Bank Account',sortable:true,id:'bankAccount'}];if(this.props.canManage)columns.push({title:'Action',sortable:false,id:'action'});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_PaginatedTable__["a" /* default */],{name:'references',page:this.props.page,totalCount:this.props.data.totalCount,resultsView:this.props.resultsView,sort:this.props.sort,loading:this.props.loading,success:this.props.success,renderRow:this.getTableRow,columns:columns,records:this.props.data.records||[],sortData:this.props.updateTable,changeDataView:this.props.updateTable,loadData:this.props.getReferences}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ReferenceModal__["a" /* default */],Object.assign({show:this.state.showModals.editReferenceModal,close:this.toggleModal.bind(this,"editReferenceModal"),reference:this.state.selectedRecord},this.props.updatingReference,{submitReference:function submitReference(reference){return _this3.props.updateReference(_this3.state.selectedRecord.referenceId,reference);},usPersonTitles:this.props.usPersonTitles,israelPersonTitles:this.props.israelPersonTitles,usInstitutionTitles:this.props.usInstitutionTitles,israelInstitutionTitles:this.props.israelInstitutionTitles,recipientTypes:this.props.recipientTypes})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_ConfirmationModal__["a" /* default */],{show:this.state.showModals.confirmationModal,message:this.state.selectedRecord.referenceId?'Are you sure you want to permanently delete '+(this.state.selectedRecord.displayName||'this reference')+' from your references?':'',close:function close(){_this3.setState({selectedRecord:_this3.initialState.selectedRecord});_this3.toggleModal("confirmationModal");},confirm:function confirm(){return _this3.props.deleteReference(_this3.state.selectedRecord.referenceId);},loading:this.props.removing.loading,success:this.props.removing.success,errorMessage:this.props.removing.message}));}}]);return ReferencesTable;}(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ReferencesTable);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReferencesTableRow=function(_NavigationComponent){_inherits(ReferencesTableRow,_NavigationComponent);function ReferencesTableRow(){_classCallCheck(this,ReferencesTableRow);return _possibleConstructorReturn(this,(ReferencesTableRow.__proto__||Object.getPrototypeOf(ReferencesTableRow)).apply(this,arguments));}_createClass(ReferencesTableRow,[{key:'render',value:function render(){var _props$reference=this.props.reference,displayName=_props$reference.displayName,position=_props$reference.position,phoneNumber=_props$reference.phoneNumber,secondPhoneNumber=_props$reference.secondPhoneNumber,email=_props$reference.email,addressDisplay=_props$reference.addressDisplay,isPayee=_props$reference.isPayee,bankRoutingNumber=_props$reference.bankRoutingNumber,bankBranchNumber=_props$reference.bankBranchNumber,bankAccountNumber=_props$reference.bankAccountNumber,canBeDeleted=_props$reference.canBeDeleted;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'bold-text'},displayName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Position'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,position)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Phone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,[phoneNumber,secondPhoneNumber].filter(function(p){return p;}).join(' | '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Email'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,email)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Address'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,addressDisplay)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Payee'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,isPayee&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-check icon-left'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'BankAccount'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["i" /* formatBankInfoDisplay */])(bankRoutingNumber,bankBranchNumber,bankAccountNumber)||'N/A',' ')),this.props.canManage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Action'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-pencil primary-hover input',onClick:this.props.edit,style:{marginRight:"16px"}}),canBeDeleted&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-trash trash-hover input',onClick:this.props.delete})));}}]);return ReferencesTableRow;}(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ReferencesTableRow);

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_DuplicateRecipientsActions__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DuplicatesTable__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MergeDuplicatesModal__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DuplicateRecipientsPage=function(_NavigationComponent){_inherits(DuplicateRecipientsPage,_NavigationComponent);//will pagination complicate things???  what happens once they merge and they disappear???  
//all duplicates stay until they request 'findDuplicates' - which happens on page refresh and if click 'refresh duplicates'
//when merge it, all it does is marks it 'merged', doesn't remove it - otherwise pagination will get messed up
//we need to keep in state whether it was merged bec need to keep track until it's re-requested
//disable once merged, but leave there
//OR shud we re-request the page each time they merge?  maybe let's  do that!
//separate request to find and get!!!!!!!!!  IMPT TO KNOW THIS!  DON'T SHOW TABLE TILL FOUND RETURNS SUCCESS!!!! THEN GET...
//PLAN
//if merge, clears it out on backend (does not run refind!), and re-request the page we're on!
//find -finds them!  get does NOT find them!
function DuplicateRecipientsPage(props){_classCallCheck(this,DuplicateRecipientsPage);var _this=_possibleConstructorReturn(this,(DuplicateRecipientsPage.__proto__||Object.getPrototypeOf(DuplicateRecipientsPage)).call(this,props));_this.viewDuplicatesDetails=function(recipientIds){_this.props.actions.getDuplicateRecipientsDetails(recipientIds[0],recipientIds[1]);_this.toggleModal("mergeDuplicatesModal");};_this.state={showModals:{mergeDuplicatesModal:false}};return _this;}_createClass(DuplicateRecipientsPage,[{key:'componentWillMount',value:function componentWillMount(){this.props.actions.findDuplicateRecipients();//handle failure!!! (loading)
}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page manage-duplicates'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subheader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container flex-justify'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'page-header'},'Manage Duplicates',this.props.duplicateRecipientsTable.data.totalCount>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'duplicate-tag'},Object(__WEBPACK_IMPORTED_MODULE_9__lib_utils__["m" /* formatNumber */])(this.props.duplicateRecipientsTable.data.totalCount))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'back-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-android-arrow-back middle medium-text'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{to:'/recipient-accounts',className:'link-text small-text'},'Back to Recipients')))),this.props.findingDuplicates.loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'30'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DuplicatesTable__["a" /* default */],Object.assign({},this.props.duplicateRecipientsTable,{updateTable:this.props.actions.updateTable,getDuplicates:this.props.actions.getDuplicateRecipients,viewDuplicatesDetails:this.viewDuplicatesDetails})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__MergeDuplicatesModal__["a" /* default */],{show:this.state.showModals.mergeDuplicatesModal,close:function close(){return _this2.toggleModal("mergeDuplicatesModal");},duplicatesDetails:this.props.duplicatesDetails,mergeDuplicates:this.props.actions.resolveDuplicateRecipients,mergingDuplicates:this.props.resolvingDuplicates}));}}]);return DuplicateRecipientsPage;}(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_NavigationComponent__["a" /* default */]);function mapStateToProps(state){return Object.assign({},state.duplicateRecipients,{duplicateRecipientsTable:state.duplicateRecipientsTable});}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_4__redux_actions_DuplicateRecipientsActions__,dispatch)};}/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(DuplicateRecipientsPage));

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_PaginatedTable__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DuplicatesTableRow__ = __webpack_require__(535);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DuplicatesTable=function(_React$Component){_inherits(DuplicatesTable,_React$Component);function DuplicatesTable(props){_classCallCheck(this,DuplicatesTable);var _this=_possibleConstructorReturn(this,(DuplicatesTable.__proto__||Object.getPrototypeOf(DuplicatesTable)).call(this,props));_this.getTableRow=_this.getTableRow.bind(_this);return _this;}_createClass(DuplicatesTable,[{key:'getTableRow',value:function getTableRow(duplicate){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DuplicatesTableRow__["a" /* default */],{key:duplicate.map(function(r){return r.applicantId;}).join('-'),recipients:duplicate,viewDuplicatesDetails:this.props.viewDuplicatesDetails});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_PaginatedTable__["a" /* default */],{name:'duplicate recipients',page:this.props.page,totalCount:this.props.data.totalCount,resultsView:this.props.resultsView,loading:this.props.loading,success:this.props.success,renderRow:this.getTableRow,columns:[{title:'Name',sortable:false,id:'name'},{title:'Address',sortable:false,id:'address'},{title:'Phone',sortable:false,id:'phone'}],records:this.props.data.records||[]// sortData={this.props.updateTable}
,changeDataView:this.props.updateTable,loadData:this.props.getDuplicates});}}]);return DuplicatesTable;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (DuplicatesTable);

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DuplicatesTableRow=function(_React$Component){_inherits(DuplicatesTableRow,_React$Component);function DuplicatesTableRow(props){_classCallCheck(this,DuplicatesTableRow);var _this=_possibleConstructorReturn(this,(DuplicatesTableRow.__proto__||Object.getPrototypeOf(DuplicatesTableRow)).call(this,props));_this.toggleSelection=function(applicantId){var selection=[].concat(_toConsumableArray(_this.state.selection));selection=selection.indexOf(applicantId)>=0?selection.filter(function(i){return i!==applicantId;}):[].concat(_toConsumableArray(selection),[applicantId]);_this.setState({selection:selection});};_this.state={selection:[]};return _this;}_createClass(DuplicatesTableRow,[{key:'render',value:function render(){var _this2=this;var _props=this.props,recipients=_props.recipients,resolving=_props.resolving,error=_props.error;var selection=this.state.selection;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'table-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Name'},recipients.map(function(recipient){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:recipient.applicantId,style:{display:"flex",alignItems:"center",marginBottom:"8px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-check-container\n                            '+(selection.indexOf(recipient.applicantId)<0&&selection.length===2?"disabled":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'select-'+recipient.applicantId,className:'custom-check',checked:selection.indexOf(recipient.applicantId)>=0,onChange:function onChange(){return _this2.toggleSelection(recipient.applicantId);},disabled:selection.indexOf(recipient.applicantId)<0&&selection.length===2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'select-'+recipient.applicantId,className:'secondary-text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'bold-text relative',style:{marginTop:"0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-person-outline',style:{fontSize:"20px",verticalAlign:"middle",marginRight:"8px"}}),recipient.name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{className:'btn btn-primary btn-xs',target:"_blank",to:'/recipient-accounts/'+recipient.applicantId,style:{height:"20px",lineHeight:"20px",marginLeft:"8px",minWidth:"auto"}},'View')));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Address'},recipients.map(function(recipient){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{key:recipient.applicantId,className:'relative icon-left-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-home-outline'}),recipient.address);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Phone'},recipients.map(function(recipient){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{key:recipient.applicantId,className:'relative icon-left-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons ion-ios-telephone-outline'}),recipient.phoneNumber);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},resolving?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'32',alignRight:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-small',disabled:selection.length!==2,onClick:function onClick(){return _this2.props.viewDuplicatesDetails(selection);}},'Merge')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:error})));}}]);return DuplicatesTableRow;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (DuplicatesTableRow);

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_CampaignsActions__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CampaignsFilters__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CampaignsTable__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CreateCampaignModal__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignsPage=function(_NavigationComponent){_inherits(CampaignsPage,_NavigationComponent);function CampaignsPage(props){_classCallCheck(this,CampaignsPage);var _this=_possibleConstructorReturn(this,(CampaignsPage.__proto__||Object.getPrototypeOf(CampaignsPage)).call(this,props));_this.state={showModals:{createCampaignModal:false}};return _this;}_createClass(CampaignsPage,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subheader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container flex-justify'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'page-header'},'Campaigns'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'action-buttons'},this.props.userPermissions.individuals&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{className:'btn btn-accent2 btn-small icon-left',to:'/campaigns/lists'},'Manage Campaign Lists'),this.props.userPermissions.manage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-small',onClick:this.toggleModal.bind(this,"createCampaignModal")},'Create New')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CampaignsFilters__["a" /* default */],Object.assign({},this.props.filters,{campaignSettings:Object.assign({},this.props.campaignSettings,{locationGroups:this.props.locationGroups}),update:function update(name,value){_this2.props.actions.updateFilters(name,value);_this2.props.actions.getCampaignRecords(1,_this2.props.resultsView,_this2.props.sort);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CampaignsTable__["a" /* default */],Object.assign({},this.props.campaignsTable,{updateTable:this.props.actions.updateTable,getCampaigns:this.props.actions.getCampaignRecords,locations:this.props.locationGroups})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CreateCampaignModal__["a" /* default */],Object.assign({show:this.state.showModals.createCampaignModal,close:this.toggleModal.bind(this,"createCampaignModal")},this.props.newCampaign,{categories:this.props.campaignSettings.categories,months:this.props.campaignSettings.months,locations:this.props.locationGroups,approvers:this.props.approvers,createCampaign:this.props.actions.createCampaign})));}}]);return CampaignsPage;}(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_NavigationComponent__["a" /* default */]);function mapStateToProps(state,ownProps){return Object.assign({},state.campaigns,{campaignsTable:state.campaignsTable,campaignSettings:state.settings.systemSettings.data.campaignSettings,locationGroups:state.settings.systemSettings.data.campaignSettings.locationGroups.filter(function(lg){return state.userProfile.profile.data.departments.indexOf(lg.department)>=0;}),approvers:state.users.approvers.data,userPermissions:{manage:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__["j" /* PermissionTypes */].CampaignAndListsManage)>=0,individuals:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__["j" /* PermissionTypes */].IndividualsManage)>=0}});}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_4__redux_actions_CampaignsActions__,dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CampaignsPage));

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_Select__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignsFilters=function(_React$Component){_inherits(CampaignsFilters,_React$Component);function CampaignsFilters(props){_classCallCheck(this,CampaignsFilters);var _this=_possibleConstructorReturn(this,(CampaignsFilters.__proto__||Object.getPrototypeOf(CampaignsFilters)).call(this,props));_this.onChange=_this.onChange.bind(_this);return _this;}_createClass(CampaignsFilters,[{key:'onChange',value:function onChange(event){this.props.update(_defineProperty({},event.target.name,event.target.value));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'campaigns-filters'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container flex-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_Select__["a" /* default */],{clearable:true,name:'categoryId',value:this.props.categoryId,placeholder:'Category',options:this.props.campaignSettings.categories.map(function(cat){return{key:cat.campaignCategoryId,value:cat.name};}),onChange:this.onChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_Select__["a" /* default */],{clearable:true,name:'locationId',value:this.props.locationId,placeholder:'Location',options:this.props.campaignSettings.locationGroups.map(function(locationGroup){return{key:locationGroup.groupId,value:locationGroup.groupName,details:locationGroup.members.map(function(member){return member.city+', '+member.state;}).join('\n')};}),onChange:this.onChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_Select__["a" /* default */],{clearable:true,name:'year',value:this.props.year,placeholder:'Year',options:this.props.campaignSettings.years.sort(function(y1,y2){return y2-y1;}).map(function(yr){return{key:yr,value:yr};}),onChange:this.onChange})));}}]);return CampaignsFilters;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CampaignsFilters);

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_PaginatedTable__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CampaignsTableRow__ = __webpack_require__(539);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignsTable=function(_React$Component){_inherits(CampaignsTable,_React$Component);function CampaignsTable(){_classCallCheck(this,CampaignsTable);return _possibleConstructorReturn(this,(CampaignsTable.__proto__||Object.getPrototypeOf(CampaignsTable)).apply(this,arguments));}_createClass(CampaignsTable,[{key:'getTableRow',value:function getTableRow(campaign){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CampaignsTableRow__["a" /* default */],{key:campaign.campaignId,campaign:campaign,locations:this.props.locations});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_PaginatedTable__["a" /* default */],{name:'campaigns',page:this.props.page,totalCount:this.props.data.totalCount,resultsView:this.props.resultsView,sort:this.props.sort,loading:this.props.loading,success:this.props.success,renderRow:this.getTableRow.bind(this),columns:[{id:'status',title:'Status',sortable:true},{id:'campaignName',title:'Campaign Name',sortable:false},{id:'date',title:'Date',sortable:false},{id:'recipients',title:'Recipients',sortable:false},{id:'allocatedFunds',title:'Campaign Total (to date)',sortable:false}],records:this.props.data.records||[],sortData:this.props.updateTable,changeDataView:this.props.updateTable,loadData:this.props.getCampaigns});}}]);return CampaignsTable;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CampaignsTable);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_HoverTableRow__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_shared_CampaignStatusTag__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignsTableRow=function(_NavigationComponent){_inherits(CampaignsTableRow,_NavigationComponent);function CampaignsTableRow(){_classCallCheck(this,CampaignsTableRow);return _possibleConstructorReturn(this,(CampaignsTableRow.__proto__||Object.getPrototypeOf(CampaignsTableRow)).apply(this,arguments));}_createClass(CampaignsTableRow,[{key:'render',value:function render(){var _props$campaign=this.props.campaign,campaignId=_props$campaign.campaignId,status=_props$campaign.status,name=_props$campaign.name,dateCreated=_props$campaign.dateCreated,endDate=_props$campaign.endDate,totalRecipients=_props$campaign.totalRecipients,totalFunds=_props$campaign.totalFunds;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_HoverTableRow__["a" /* default */],{onClick:this.pushRoute.bind(this,'/campaigns/'+campaignId)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Status'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_shared_CampaignStatusTag__["a" /* default */],{status:status})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Campaign'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{className:'bold-text',to:'/campaigns/'+campaignId},name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Date'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'accent-text'},'Created: '),Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["k" /* formatDate */])(dateCreated),' \xA0 \xA0 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'accent-text'},'Ending: '),Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["k" /* formatDate */])(endDate))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Recipients'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,totalRecipients)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Campaign Total'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,totalFunds)));}}]);return CampaignsTableRow;}(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (CampaignsTableRow);

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_CurrencyFormatInput__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={campaign:{categoryId:'',locationId:'',month:'',year:new Date().getFullYear(),approverId:'',maxAmount:'',endDate:''},campaignCategoryType:'',invalidMaxAmount:false,error:false,submitAttempted:false};var CreateCampaignModal=function(_NavigationComponent){_inherits(CreateCampaignModal,_NavigationComponent);function CreateCampaignModal(props){_classCallCheck(this,CreateCampaignModal);var _this=_possibleConstructorReturn(this,(CreateCampaignModal.__proto__||Object.getPrototypeOf(CreateCampaignModal)).call(this,props));_this.state=initialState;_this.onChange=_this.onChange.bind(_this);return _this;}_createClass(CreateCampaignModal,[{key:'onChange',value:function onChange(name,value){var _this2=this;this.setState({campaign:Object.assign({},this.state.campaign,_defineProperty({},name,value))},function(){if(name==="categoryId"){var campaignCategoryType='';if(value){var categories=[].concat(_toConsumableArray(_this2.props.categories));var index=categories.map(function(c){return c.campaignCategoryId.toString();}).indexOf(value.toString());if(categories[index])campaignCategoryType=categories[index].campaignType;}_this2.setState({campaignCategoryType:campaignCategoryType,campaign:Object.assign({},_this2.state.campaign,{month:!campaignCategoryType||campaignCategoryType===__WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__["b" /* CampaignCategoryTypes */].Yearly?'':_this2.state.month})});}});}},{key:'onSubmit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var campaign;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({error:false,submitAttempted:true});campaign=this.state.campaign;if(!(!campaign.categoryId||!campaign.approverId||!campaign.year||!campaign.maxAmount||!campaign.endDate||!campaign.locationId||this.state.campaignCategoryType===__WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__["b" /* CampaignCategoryTypes */].Monthly&&!campaign.month||this.state.invalidMaxAmount)){_context.next=4;break;}return _context.abrupt('return');case 4:_context.next=6;return this.props.createCampaign(this.state.campaign);case 6:if(this.props.success){this.onClose();this.pushRoute('/campaigns/'+this.props.campaignId);}else{this.setState({error:true});}case 7:case'end':return _context.stop();}}},_callee,this);}));function onSubmit(){return _ref.apply(this,arguments);}return onSubmit;}()},{key:'onClose',value:function onClose(){this.props.close();this.setState(initialState);}},{key:'render',value:function render(){var campaign=this.state.campaign;var isIsraeli=Object(__WEBPACK_IMPORTED_MODULE_9__lib_utils__["z" /* locationIsIsraeli */])(this.props.locations,campaign.locationId);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal new-transaction-modal large-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},'Create Campaign'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.onClose.bind(this)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Select__["a" /* default */],{options:this.props.categories.map(function(c){return{key:c.campaignCategoryId,value:c.name};})}),label:'Category',name:'categoryId',value:campaign.categoryId,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},campaign.categoryId&&this.state.campaignCategoryType===__WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__["b" /* CampaignCategoryTypes */].Monthly&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Select__["a" /* default */],{options:this.props.months}),label:'Month',name:'month',value:campaign.month,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Select__["a" /* default */],{options:this.props.locations.map(function(locationGroup){return{key:locationGroup.groupId,value:locationGroup.groupName,details:locationGroup.members.map(function(member){return member.city+', '+member.state;}).join('\n')};})}),label:'Location',name:'locationId',value:campaign.locationId,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'Year',name:'year',value:campaign.year,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Select__["a" /* default */],{options:this.props.approvers}),label:'Approver',name:'approverId',value:campaign.approverId,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'date',min:Object(__WEBPACK_IMPORTED_MODULE_9__lib_utils__["l" /* formatDateForInput */])(new Date())}),label:'End Date',name:'endDate',value:campaign.endDate,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_CurrencyFormatInput__["a" /* default */],{isIsraeli:isIsraeli}),label:'Max Amount',name:'maxAmount',value:campaign.maxAmount,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'}))),this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.onClose.bind(this)},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',disabled:this.state.invalidMaxAmount,onClick:this.onSubmit.bind(this)},'Submit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error,message:this.props.message})))));}}]);return CreateCampaignModal;}(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (CreateCampaignModal);

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_CampaignsActions__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_SuggestionsActions__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_CampaignListsActions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions_ExternalCampaignListsActions__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_actions_ApplicationsActions__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_shared_CampaignStatusTag__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CampaignDetailsTable__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__EditCampaignModal__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_query_string__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__commonComponents_shared_ConfirmationModal__ = __webpack_require__(22);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignDetailsPage=function(_NavigationComponent){_inherits(CampaignDetailsPage,_NavigationComponent);function CampaignDetailsPage(props){_classCallCheck(this,CampaignDetailsPage);var _this=_possibleConstructorReturn(this,(CampaignDetailsPage.__proto__||Object.getPrototypeOf(CampaignDetailsPage)).call(this,props));_this.state={campaignId:_this.props.match.params.id,showModals:{editCampaignModal:false,deleteCampaignModal:false},deleting:{loading:false,success:false,message:'We were unable to delete the campaign. It may have paid or accepted applications. Please try again.'}};return _this;}_createClass(CampaignDetailsPage,[{key:'componentWillMount',value:function componentWillMount(){if(this.state.campaignId){this.getDetails();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.actions.clearCampaignDetails();}},{key:'deleteCampaign',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.actions.deleteCampaign(this.state.campaignId);case 2:if(this.props.campaignDelete.success){this.pushRoute('/campaigns/');}case 3:case'end':return _context.stop();}}},_callee,this);}));function deleteCampaign(){return _ref.apply(this,arguments);}return deleteCampaign;}()},{key:'getDetails',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return this.props.actions.getCampaignDetails(this.state.campaignId);case 2:if(!this.props.details.success){__WEBPACK_IMPORTED_MODULE_14_react_redux_toastr__["toastr"].error('Something went wrong','We were unable to retrieve campaign list details.  Please try again.');}case 3:case'end':return _context2.stop();}}},_callee2,this);}));function getDetails(){return _ref2.apply(this,arguments);}return getDetails;}()},{key:'render',value:function render(){var _this2=this;var campaign=Object.assign({},this.props.details.data);campaign.isIsraeli=Object(__WEBPACK_IMPORTED_MODULE_15__lib_utils__["z" /* locationIsIsraeli */])(this.props.locationGroups,campaign.locationId);var locationGroup=campaign.locationId?this.props.locationGroups[this.props.locationGroups.map(function(loc){return loc.groupId.toString();}).indexOf(campaign.locationId.toString())]:null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page campaign'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'subheader campaign-header campaign-details-header'},this.props.details.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'30'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container flex-justify'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'page-header'},campaign.name,' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_shared_CampaignStatusTag__["a" /* default */],{status:campaign.status})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex campaign-header-icons'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-calendar icon-left accent-text2'}),Object(__WEBPACK_IMPORTED_MODULE_15__lib_utils__["k" /* formatDate */])(campaign.dateCreated),' - ',Object(__WEBPACK_IMPORTED_MODULE_15__lib_utils__["k" /* formatDate */])(campaign.endDate)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},campaign.isIsraeli?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons shekel-icon icon icon-left accent-text2'},'\u20AA'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-social-usd icon-left accent-text2'}),Object(__WEBPACK_IMPORTED_MODULE_15__lib_utils__["j" /* formatCurrency */])(campaign.isIsraeli?campaign.maxAmountShekel:campaign.maxAmountDollar,campaign.isIsraeli),' limit')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,campaign.fundNames&&campaign.fundNames.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-home icon-left accent-text2'}),campaign.fundNames.join(', ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-user icon-left accent-text2'}),'Approver: ',campaign.approverName)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-credit-card icon-left accent-text2'}),'Campaign Total (to date): ',campaign.totalFunds),locationGroup&&locationGroup.members.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-location-pin icon-left accent-text2'}),locationGroup.members.map(function(loc){return loc.city;}).join(', ')||locationGroup.members[0].country,' ')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'campaign-header-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'campaign-header-right-left'},campaign.canDelete//flag sent from API - determines if campaign can be deleted based if user has appropriate institution/individuals permission and if campaign has approved/paid applications
&&!this.props.campaignListsTable.loading&&!this.props.campaignIndividualsTable.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-danger',onClick:this.toggleModal.bind(this,"deleteCampaignModal")},'Delete'):'',this.props.userPermissions.manage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',onClick:this.toggleModal.bind(this,"editCampaignModal")},campaign.status===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["e" /* CampaignStatuses */].Open?"Edit":"Extend")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'campaign-header-right-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text accent-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-clock icon-left'}),'Updated by ',campaign.lastUpdatedBy))))),campaign.campaignId&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__CampaignDetailsTable__["a" /* default */],{isAdmin:this.props.userPermissions.admin,view:__WEBPACK_IMPORTED_MODULE_17_query_string___default.a.parse(this.props.history.location.search).view||(this.props.userPermissions.individuals?'lists':'individuals'),toggleView:function toggleView(view){return _this2.props.history.replace({search:view!=='lists'?'?view='+view:''});},canUpdate:this.props.userPermissions.manage&&campaign.status===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["e" /* CampaignStatuses */].Open,canApproveApplications:this.props.userPermissions.approveApplications&&campaign.status===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["e" /* CampaignStatuses */].Open,canUpdateRecipients:this.props.userPermissions.manageApplications&&campaign.status===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["e" /* CampaignStatuses */].Open,campaignId:this.state.campaignId,campaign:campaign,actions:this.props.actions,listsTable:this.props.campaignListsTable,individualsTable:this.props.campaignIndividualsTable,lists:this.props.lists,receivingParticipants:this.props.receivingParticipantsTable,individuals:this.props.individuals,approvingIndividuals:this.props.approvingCampaignIndividuals,campaignLists:this.props.campaignLists,campaignListStatuses:this.props.campaignListStatuses||[],creatingCampaignList:this.props.campaignListCreate,externalCampaignListRecipients:this.props.externalCampaignListRecipients,recipientSuggestions:this.props.recipientSuggestions,systemSettings:this.props.systemSettings,locationGroups:this.props.locationGroups,funds:this.props.funds,organizations:this.props.organizations,references:this.props.references,userPermissions:this.props.userPermissions}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__EditCampaignModal__["a" /* default */],Object.assign({show:this.state.showModals.editCampaignModal,close:this.toggleModal.bind(this,"editCampaignModal")},this.props.updateCampaignDetails,{campaign:campaign,approvers:this.props.approvers||[],updateCampaign:this.props.actions.updateCampaign})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__commonComponents_shared_ConfirmationModal__["a" /* default */],{show:this.state.showModals.deleteCampaignModal,message:this.state.campaignId?'Are you sure you want to permanently delete '+campaign.name+' campaign?':'',close:function close(){_this2.toggleModal("deleteCampaignModal");},confirm:function confirm(){return _this2.deleteCampaign(_this2.state.campaignId);},loading:this.state.deleting.loading,success:this.state.deleting.success,errorMessage:this.state.deleting.message}));}}]);return CampaignDetailsPage;}(__WEBPACK_IMPORTED_MODULE_9__commonComponents_util_NavigationComponent__["a" /* default */]);function mapStateToProps(state,ownProps){return Object.assign({},state.campaignDetails,{campaignListsTable:state.campaignDetailsListsTable,campaignIndividualsTable:state.campaignDetailsIndividualsTable,receivingParticipantsTable:state.receivingParticipantsTable,approvingCampaignIndividuals:state.applications.updating,campaignLists:state.campaignLists.allCampaignLists,campaignListCreate:state.campaignLists.newCampaignList,campaignListStatuses:state.settings.systemSettings.data.otherSettings.campaignListStatuses,externalCampaignListRecipients:state.externalCampaignList.listRecipients,recipientSuggestions:state.suggestions.recipientSuggestions,systemSettings:state.settings.systemSettings.data,locationGroups:state.settings.systemSettings.data.campaignSettings.locationGroups.filter(function(lg){return state.userProfile.profile.data.departments.indexOf(lg.department)>=0;}),approvers:state.users.approvers.data,references:state.references.references,organizations:state.recipientAccounts.organizations.data,funds:state.funds.fundsByDept,userPermissions:{admin:state.userProfile.profile.data.roleId===1,manage:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["j" /* PermissionTypes */].CampaignAndListsManage)>=0,approveApplications:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsApproveFull)>=0||state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsApproveLimited)>=0,manageApplications:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsManage)>=0,individuals:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["j" /* PermissionTypes */].IndividualsManage)>=0,institutions:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["j" /* PermissionTypes */].InstitutionsManage)>=0},campaignDelete:Object.assign({},state.campaigns.campaignDelete)});}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(Object.assign({},__WEBPACK_IMPORTED_MODULE_4__redux_actions_CampaignsActions__,{createCampaignList:__WEBPACK_IMPORTED_MODULE_6__redux_actions_CampaignListsActions__["createCampaignList"],getAllCampaignLists:__WEBPACK_IMPORTED_MODULE_6__redux_actions_CampaignListsActions__["getAllCampaignLists"],getExternalCampaignListRecipients:__WEBPACK_IMPORTED_MODULE_7__redux_actions_ExternalCampaignListsActions__["getExternalCampaignListRecipients"]},__WEBPACK_IMPORTED_MODULE_5__redux_actions_SuggestionsActions__,{updateApplicationsStatus:__WEBPACK_IMPORTED_MODULE_8__redux_actions_ApplicationsActions__["updateApplicationsStatus"]}),dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CampaignDetailsPage));

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CampaignDetailsListsTable__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CampaignDetailsIndividualsTable__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddCampaignListModal__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__campaignsCommon_AddCampaignRecipientModal__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_throttle_debounce__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_throttle_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_throttle_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignDetailsTable=function(_NavigationComponent){_inherits(CampaignDetailsTable,_NavigationComponent);function CampaignDetailsTable(props){_classCallCheck(this,CampaignDetailsTable);var _this=_possibleConstructorReturn(this,(CampaignDetailsTable.__proto__||Object.getPrototypeOf(CampaignDetailsTable)).call(this,props));_this.state={showModals:{addCampaignListModal:false,createCampaignListModal:false,addCampaignRecipientModal:false,createRecipientModal:false}};_this.searchDebounce=Object(__WEBPACK_IMPORTED_MODULE_7_throttle_debounce__["debounce"])(500,_this.searchDebounce);_this.searchListsDebounce=Object(__WEBPACK_IMPORTED_MODULE_7_throttle_debounce__["debounce"])(500,_this.searchListsDebounce);return _this;}_createClass(CampaignDetailsTable,[{key:'componentWillMount',value:function componentWillMount(){this.props.actions.getCampaignAllLists(this.props.campaignId);this.props.actions.getCampaignAllIndividuals(this.props.campaignId);this.props.actions.getIndividuals(this.props.campaignId);}},{key:'toggleTable',value:function toggleTable(view){if(this.props.view!==view){this.props.toggleView(view);}}},{key:'filterLists',value:function filterLists(event){if(event.target.name==="search"){this.props.actions.updateListsTable({keyword:event.target.value});this.searchListsDebounce();}else{this.props.actions.updateListsTable({statusFilter:event.target.value});this.props.actions.getLists(this.props.campaignId,1,this.props.listsTable.resultView,this.props.listsTable.sort);}}},{key:'searchIndividuals',value:function searchIndividuals(event){this.props.actions.updateIndividualsTable({search:event.target.value});this.searchDebounce();}},{key:'searchDebounce',value:function searchDebounce(){this.props.actions.getIndividuals(this.props.campaignId,1,this.props.individualsTable.resultView,this.props.individualsTable.sort);}},{key:'searchListsDebounce',value:function searchListsDebounce(){this.props.actions.getLists(this.props.campaignId,1,this.props.listsTable.resultView,this.props.listsTable.sort);}},{key:'addList',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(campaignListId,emailMessage,defaultAmount,bypassError){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.actions.addList(this.props.campaignId,campaignListId,emailMessage,defaultAmount,bypassError);case 2:if(this.props.lists.newList.success){this.props.actions.getLists(this.props.campaignId,1,this.props.listsTable.resultsView,this.props.listsTable.sort);this.props.actions.getCampaignAllLists(this.props.campaignId);}case 3:case'end':return _context.stop();}}},_callee,this);}));function addList(_x,_x2,_x3,_x4){return _ref.apply(this,arguments);}return addList;}()},{key:'verifyExternalUpdates',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(campaignId,campaignListId,newParticipants,rejectedParticipants,defaultAmount,bypassError){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return this.props.actions.verifyCampaignListExternalUpdates(campaignId,campaignListId,newParticipants,rejectedParticipants,defaultAmount,bypassError);case 2:if(this.props.lists.verifyUpdates.success){this.props.actions.getLists(this.props.campaignId,1,this.props.listsTable.resultsView,this.props.listsTable.sort);this.props.actions.getCampaignAllLists(this.props.campaignId);}case 3:case'end':return _context2.stop();}}},_callee2,this);}));function verifyExternalUpdates(_x5,_x6,_x7,_x8,_x9,_x10){return _ref2.apply(this,arguments);}return verifyExternalUpdates;}()},{key:'addIndividual',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(bypassError,recipientId,campaignApplication){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return this.props.actions.addIndividual(this.props.campaignId,recipientId,bypassError,campaignApplication);case 2:if(this.props.individuals.newIndividual.success){this.props.actions.getIndividuals(this.props.campaignId,1,this.props.individualsTable.resultsView,this.props.individualsTable.sort);this.props.actions.getCampaignAllIndividuals(this.props.campaignId);}case 3:case'end':return _context3.stop();}}},_callee3,this);}));function addIndividual(_x11,_x12,_x13){return _ref3.apply(this,arguments);}return addIndividual;}()},{key:'removeList',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(campaignId,campaignListId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return this.props.actions.removeList(campaignId,campaignListId);case 2:if(this.props.listsTable.removing.success){this.props.actions.getCampaignAllLists(this.props.campaignId);}case 3:case'end':return _context4.stop();}}},_callee4,this);}));function removeList(_x14,_x15){return _ref4.apply(this,arguments);}return removeList;}()},{key:'removeIndividual',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(campaignId,recipientId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return this.props.actions.removeIndividual(campaignId,recipientId);case 2:if(this.props.individualsTable.removing.success){this.props.actions.getCampaignAllIndividuals(this.props.campaignId);}case 3:case'end':return _context5.stop();}}},_callee5,this);}));function removeIndividual(_x16,_x17){return _ref5.apply(this,arguments);}return removeIndividual;}()},{key:'approveIndividualsApplications',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return this.props.actions.updateApplicationsStatus('approve',this.props.individualsTable.selected.map(function(indiv){return{applicationId:indiv.applicationId,amount:indiv.amount,currency:Object(__WEBPACK_IMPORTED_MODULE_9__lib_utils__["s" /* getObjectKeyByValue */])(__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["f" /* CurrencyTypes */],_this2.props.campaign.isIsraeli?'₪':'$')};}));case 2:if(this.props.approvingIndividuals.success){__WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__["toastr"].success(this.props.individualsTable.selected.length+' '+(this.props.individualsTable.selected.length>1?"Applications have":"Application has")+' been approved.');this.props.actions.getIndividuals(this.props.campaignId,this.props.individualsTable.page,this.props.individualsTable.resultsView,this.props.individualsTable.sort);}else{__WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__["toastr"].error('Something went wrong','Application'+(this.props.individualsTable.selected.length>1?"s":"")+' could not be approved.  Please try again.');}case 3:case'end':return _context6.stop();}}},_callee6,this);}));function approveIndividualsApplications(){return _ref6.apply(this,arguments);}return approveIndividualsApplications;}()},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'campaigns-filters'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container flex-center flex-justify'},this.props.userPermissions.individuals?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'campaign-options flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:(this.props.view==="lists"?"active":"")+' accent-text medium-text',onClick:this.toggleTable.bind(this,"lists")},'Lists')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:(this.props.view==="individuals"?"active":"")+' accent-text medium-text',onClick:this.toggleTable.bind(this,"individuals")},'Individuals'))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex'},this.props.view==="lists"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'search-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'search'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',placeholder:'Search List Names',name:'search',value:this.props.listsTable.keyword,disabled:!this.props.listsTable.keyword&&!this.props.listsTable.data.records.length,onChange:function onChange(e){return _this3.filterLists(e);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-select'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('select',{value:this.props.listsTable.statusFilter,disabled:!this.props.listsTable.statusFilter&&!this.props.listsTable.data.records.length,onChange:function onChange(e){return _this3.filterLists(e);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{defaultValue:true},'All'),this.props.campaignListStatuses.map(function(status){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:status.key,value:status.key},status.value);})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-arrow-down'})),this.props.canUpdate&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent2',disabled:this.props.lists.allLists.loading,onClick:this.toggleModal.bind(this,"addCampaignListModal")},'Add List')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex'},this.props.individualsTable.selected.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-small approve',disabled:this.props.approvingIndividuals.loading,onClick:function onClick(){return _this3.approveIndividualsApplications();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-checkmark approved-text icon-left large-text middle'}),this.props.approvingIndividuals.loading?"Approving Selected...":"Approve Selected"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'search-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'search'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',placeholder:'Search',value:this.props.individualsTable.search||'',disabled:!this.props.individualsTable.search&&!this.props.individualsTable.data.records.length,onChange:this.searchIndividuals.bind(this)})),this.props.canUpdate&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent2',disabled:this.props.individuals.allIndividuals.loading,onClick:this.toggleModal.bind(this,"addCampaignRecipientModal")},'Add Recipient'))))),this.props.userPermissions.individuals&&this.props.view==="lists"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CampaignDetailsListsTable__["a" /* default */],Object.assign({},this.props.listsTable,{canUpdate:this.props.canUpdate,updateTable:this.props.actions.updateListsTable,campaign:this.props.campaign,getCampaignLists:function getCampaignLists(){var _props$actions;for(var _len=arguments.length,tableProps=Array(_len),_key=0;_key<_len;_key++){tableProps[_key]=arguments[_key];}return(_props$actions=_this3.props.actions).getLists.apply(_props$actions,[_this3.props.campaignId].concat(_toConsumableArray(tableProps||{})));},update:this.props.actions.updateList,updating:this.props.listsTable.updating,remove:this.removeList.bind(this),removing:this.props.listsTable.removing,canApprove:this.props.canApproveApplications,approve:this.props.actions.approveCampaignList,approving:this.props.lists.approve,resendMessage:this.props.actions.resendExternalCampaignListMessage,resendingMessage:this.props.lists.resendMessage//wizard:
,getExternalUpdates:this.props.actions.getCampaignListExternalUpdates,externalUpdates:this.props.lists.externalUpdates,getReceivingParticipants:this.props.actions.getReceivingParticipants,receivingParticipants:this.props.receivingParticipants,getExternalListRecipients:this.props.actions.getExternalCampaignListRecipients,externalListRecipients:this.props.externalCampaignListRecipients,recipientSuggestions:this.props.recipientSuggestions,getRecipientSuggestions:this.props.actions.getRecipientSuggestions,clearRecipientSuggestions:this.props.actions.clearRecipientSuggestions,clearReceivingParticipants:this.props.actions.clearReceivingParticipants,verifyExternalUpdates:this.verifyExternalUpdates.bind(this),verifyingUpdates:this.props.lists.verifyUpdates,addList:this.addList.bind(this),addingList:this.props.lists.newList})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CampaignDetailsIndividualsTable__["a" /* default */],Object.assign({},this.props.individualsTable,{canUpdate:this.props.canUpdate,canUpdateIndividual:this.props.canUpdateRecipients,canUpdateAmount:this.props.canApproveApplications,updateTable:this.props.actions.updateIndividualsTable,campaign:this.props.campaign,getCampaignIndividuals:function getCampaignIndividuals(){var _props$actions2;for(var _len2=arguments.length,tableProps=Array(_len2),_key2=0;_key2<_len2;_key2++){tableProps[_key2]=arguments[_key2];}return(_props$actions2=_this3.props.actions).getIndividuals.apply(_props$actions2,[_this3.props.campaignId].concat(_toConsumableArray(tableProps||{})));},update:this.props.actions.updateIndividual,updating:this.props.individualsTable.updating,remove:this.removeIndividual.bind(this),removing:this.props.individualsTable.removing,toggleSelect:this.props.actions.toggleSelectIndividual,funds:this.props.funds,campaignIndivCategories:this.props.systemSettings.campaignSettings.campaignIndivCategories})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AddCampaignListModal__["a" /* default */],Object.assign({show:this.state.showModals.addCampaignListModal,close:this.toggleModal.bind(this,"addCampaignListModal")},this.props.lists.newList,{isAdmin:this.props.isAdmin,addList:this.addList.bind(this),campaign:this.props.campaign,getCampaignLists:this.props.actions.getAllCampaignLists,campaignLists:Object.assign({},this.props.campaignLists,{data:this.props.campaignLists.data.filter(function(list){return _this3.props.lists.allLists.data.map(function(l){return l.campaignListId;}).indexOf(list.campaignListId)<0;}).filter(function(list){return!_this3.props.campaign.locationId||list.locationId===_this3.props.campaign.locationId;})}),hasLists:this.props.listsTable.data.records&&this.props.listsTable.data.records.length>0//create list:
,createList:this.props.actions.createCampaignList,creatingList:this.props.creatingCampaignList,individualCategories:this.props.systemSettings.recipientSettings.individualTags.map(function(indivTag){return{key:indivTag.key,value:indivTag.value};}),organizationCategories:this.props.userPermissions.institutions?this.props.systemSettings.recipientSettings.organizationTags.map(function(orgTag){return{key:orgTag.key,value:orgTag.value};}):[],locations:this.props.locationGroups,organizations:this.props.organizations,ILFunds:this.props.funds.IL,USFunds:this.props.funds.US})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__campaignsCommon_AddCampaignRecipientModal__["a" /* default */],Object.assign({campaign:this.props.campaign,show:this.state.showModals.addCampaignRecipientModal,close:this.toggleModal.bind(this,"addCampaignRecipientModal")},this.props.individuals.newIndividual,{addRecipient:this.addIndividual.bind(this),funds:this.props.funds,defaultUSFund:this.props.systemSettings.fundSettings.defaultUSFund,defaultIsraelFund:this.props.systemSettings.fundSettings.defaultIsraelFund,recipientType:this.props.userPermissions.individuals&&!this.props.userPermissions.institutions?__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["l" /* RecipientTypes */].Individual:this.props.userPermissions.institutions&&!this.props.userPermissions.individuals?__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["l" /* RecipientTypes */].Organization:null,recipientTypes:this.props.systemSettings.otherSettings.recipientTypes,references:this.props.references,campaignIndivCategories:this.props.systemSettings.campaignSettings.campaignIndivCategories,recipientSuggestions:this.props.recipientSuggestions,getRecipientSuggestions:function getRecipientSuggestions(name,otherInput){return _this3.props.actions.getRecipientSuggestions(name,Object.assign({},otherInput,{applicantType:_this3.props.userPermissions.individuals&&!_this3.props.userPermissions.institutions?__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["l" /* RecipientTypes */].Individual:_this3.props.userPermissions.institutions&&!_this3.props.userPermissions.individuals?__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["l" /* RecipientTypes */].Organization:otherInput?otherInput.applicantType:undefined,locationId:_this3.props.campaign.locationId,departments:[_this3.props.campaign.isIsraeli?__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["g" /* Departments */].IL:__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["g" /* Departments */].US]}),_this3.props.individuals.allIndividuals.data.map(function(i){return i.recipientId;}));},clearRecipientSuggestions:this.props.actions.clearRecipientSuggestions})));}}]);return CampaignDetailsTable;}(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (CampaignDetailsTable);

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_PaginatedTable__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CampaignDetailsListsTableRow__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VerifyCampaignListWizard_VerifyListWizardModal__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_ConfirmationModal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_shared_WarningModal__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={showModals:{confirmationModal:false,verifyWizardModal:false,warningModal:false},selectedRecord:{},recordAction:{actionType:'',action:function action(){},actionPayload:{},confirmationMessage:''}};var CampaignDetailsListsTable=function(_NavigationComponent){_inherits(CampaignDetailsListsTable,_NavigationComponent);function CampaignDetailsListsTable(props){_classCallCheck(this,CampaignDetailsListsTable);var _this=_possibleConstructorReturn(this,(CampaignDetailsListsTable.__proto__||Object.getPrototypeOf(CampaignDetailsListsTable)).call(this,props));_this.state=initialState;_this.getTableRow=_this.getTableRow.bind(_this);return _this;}_createClass(CampaignDetailsListsTable,[{key:'selectRecord',value:function selectRecord(modal,campaignList){var actionType=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var action=arguments.length>3&&arguments[3]!==undefined?arguments[3]:function(){};var confirmationMessage=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'';var actionPayload=arguments.length>5&&arguments[5]!==undefined?arguments[5]:{};this.setState({selectedRecord:campaignList,recordAction:{actionType:actionType,action:action,actionPayload:actionPayload,confirmationMessage:confirmationMessage}},this.toggleModal.bind(this,modal));}},{key:'getTableRow',value:function getTableRow(campaignList){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CampaignDetailsListsTableRow__["a" /* default */],{key:campaignList.campaignListId,canUpdate:this.props.canUpdate,canApprove:this.props.canApprove,campaignId:this.props.campaign.campaignId,campaignList:campaignList,maxAmount:this.props.campaign.isIsraeli?this.props.campaign.maxAmountShekel:this.props.campaign.maxAmountDollar,isIsraeli:this.props.campaign.isIsraeli,update:function update(_update){return _this2.selectRecord("warningModal",campaignList,'updating',_this2.props.update,'Updating the default amount will update the amount on applications associated with this list and campaign that have not yet been approved.',_update);},updating:this.props.updating[campaignList.campaignListId]===true,updateError:this.props.updating.hasOwnProperty(campaignList.campaignListId)&&this.props.updating[campaignList.campaignListId]!==true,remove:this.selectRecord.bind(this,"confirmationModal",campaignList,'removing',this.props.remove,'Are you sure you want to remove the '+campaignList.name+' list from the '+this.props.campaign.name+' campaign?  This will cause all applications associated with this list and campaign to be deleted.'),approve:this.selectRecord.bind(this,"confirmationModal",campaignList,'approving',this.props.approve,'Approve '+campaignList.name+' list?'),resendMessage:this.selectRecord.bind(this,"confirmationModal",campaignList,'resendingMessage',this.props.resendMessage,'Resend message to '+campaignList.manager+'?'),verify:function verify(){_this2.props.getExternalUpdates(campaignList.campaignListId);_this2.selectRecord("verifyWizardModal",campaignList);}});}},{key:'render',value:function render(){var _this3=this;var columns=[{id:'status',title:'Status',sortable:true},{id:'name',title:'Name',sortable:true},{id:'count',title:'Count',sortable:false},{id:'manager',title:'Manager',sortable:false},{id:'fund',title:'Default Fund',sortable:false},{id:'defaultAmount',title:'Default Amount',sortable:false},{id:'totalCreated',title:'Total Created',sortable:false},{id:'totalPaid',title:'Total Paid',sortable:false}];if(this.props.canUpdate)columns.concat([{id:'action',title:'',sortable:false},{id:'delete',title:'',sortable:false}]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_PaginatedTable__["a" /* default */],{name:'campaign lists',page:this.props.page,totalCount:this.props.data.totalCount,resultsView:this.props.resultsView,sort:this.props.sort,loading:this.props.loading,success:this.props.success,renderRow:this.getTableRow,columns:columns,records:this.props.data.records||[],sortData:this.props.updateTable,changeDataView:this.props.updateTable,loadData:this.props.getCampaignLists,clearData:this.props.clearCampaignLists}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__VerifyCampaignListWizard_VerifyListWizardModal__["a" /* default */],{show:this.state.showModals.verifyWizardModal,close:function close(){_this3.toggleModal("verifyWizardModal");_this3.setState({selectedRecord:initialState.selectedRecord,recordAction:initialState.recordAction});_this3.props.clearReceivingParticipants();},campaign:this.props.campaign,campaignList:this.state.selectedRecord,externalUpdates:this.props.externalUpdates,receivingParticipants:this.props.receivingParticipants,listRecipients:this.props.externalListRecipients,getListRecipients:this.props.getExternalListRecipients,getReceivingParticipants:function getReceivingParticipants(campaignListId,newParticipants){for(var _len=arguments.length,tableProps=Array(_len>2?_len-2:0),_key=2;_key<_len;_key++){tableProps[_key-2]=arguments[_key];}var _props;return(_props=_this3.props).getReceivingParticipants.apply(_props,[campaignListId,newParticipants].concat(_toConsumableArray(tableProps||{})));},recipientSuggestions:this.props.recipientSuggestions,getRecipientSuggestions:this.props.getRecipientSuggestions,clearRecipientSuggestions:this.props.clearRecipientSuggestions,clearReceivingParticipants:this.props.clearReceivingParticipants,verifyUpdates:this.props.verifyExternalUpdates,verifyingUpdates:this.props.verifyingUpdates}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_ConfirmationModal__["a" /* default */],{show:this.state.showModals.confirmationModal,message:this.state.recordAction.confirmationMessage,close:function close(){_this3.toggleModal("confirmationModal");_this3.setState({selectedRecord:initialState.selectedRecord,recordAction:initialState.recordAction});},confirm:this.state.recordAction.action.bind(this,this.props.campaign.campaignId,this.state.selectedRecord.campaignListId),loading:this.props[this.state.recordAction.actionType]&&this.props[this.state.recordAction.actionType].loading,success:this.props[this.state.recordAction.actionType]&&this.props[this.state.recordAction.actionType].success,errorMessage:this.props[this.state.recordAction.actionType]&&this.props[this.state.recordAction.actionType].message}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_shared_WarningModal__["a" /* default */],{show:this.state.showModals.warningModal,message:this.state.recordAction.confirmationMessage,close:this.toggleModal.bind(this,"warningModal"),cancel:function cancel(){return _this3.setState({selectedRecord:initialState.selectedRecord,recordAction:initialState.recordAction});},'continue':this.state.recordAction.action.bind(this,this.props.campaign.campaignId,this.state.selectedRecord.campaignListId,this.state.recordAction.actionPayload)}));}}]);return CampaignDetailsListsTable;}(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (CampaignDetailsListsTable);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_HoverTableRow__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_CurrencyFormatInput__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={editMode:false,updatedAmount:null,updateAttempted:false,updateError:false};var CampaignDetailsListsTableRow=function(_NavigationComponent){_inherits(CampaignDetailsListsTableRow,_NavigationComponent);function CampaignDetailsListsTableRow(props){_classCallCheck(this,CampaignDetailsListsTableRow);var _this=_possibleConstructorReturn(this,(CampaignDetailsListsTableRow.__proto__||Object.getPrototypeOf(CampaignDetailsListsTableRow)).call(this,props));_this.state=initialState;return _this;}_createClass(CampaignDetailsListsTableRow,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.updating&&!nextProps.updating){if(nextProps.updateError){this.setState({updateError:true});}else{this.cancelUpdate();}}}},{key:'onChangeAmount',value:function onChangeAmount(name,value){var updatedAmount=parseFloat(value||0)!==parseFloat(this.props.campaignList.defaultAmount||0)?value:null;this.setState({updatedAmount:updatedAmount});}},{key:'updateListAmount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({updateAttempted:true,updateError:false});if(!(this.state.updatedAmount>this.props.maxAmount)){_context.next=3;break;}return _context.abrupt('return');case 3:this.props.update({defaultAmount:this.state.updatedAmount});case 4:case'end':return _context.stop();}}},_callee,this);}));function updateListAmount(){return _ref.apply(this,arguments);}return updateListAmount;}()},{key:'cancelUpdate',value:function cancelUpdate(){this.setState(initialState);}},{key:'render',value:function render(){var _this2=this;var _props$campaignList=this.props.campaignList,name=_props$campaignList.name,status=_props$campaignList.status,statusDisplay=_props$campaignList.statusDisplay,count=_props$campaignList.count,manager=_props$campaignList.manager,fund=_props$campaignList.fund,defaultAmount=_props$campaignList.defaultAmount,totalCreated=_props$campaignList.totalCreated,totalPaid=_props$campaignList.totalPaid,canApprove=_props$campaignList.canApprove,canRemove=_props$campaignList.canRemove;var statusTag=void 0;var actionButton=void 0;switch(status){case __WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__["c" /* CampaignListStatuses */].Added:statusTag=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-xs btn-flat-status-approved'},statusDisplay);if(canApprove)actionButton=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat-approved btn-xs btn-campaign-status input',disabled:!this.props.canApprove,onClick:function onClick(){if(_this2.props.canApprove)_this2.props.approve();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-check icon-left input'}),'Approve');break;case __WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__["c" /* CampaignListStatuses */].Approved:statusTag=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-xs btn-flat-status-approved'},statusDisplay);actionButton=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-check icon-left'}),'Approved');break;case __WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__["c" /* CampaignListStatuses */].Sent:statusTag=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-xs btn-flat-status-new'},statusDisplay);actionButton=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent2 btn-xs btn-campaign-status input',onClick:this.props.resendMessage},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-arrow-right-circle icon-left input'}),'Resend');break;case __WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__["c" /* CampaignListStatuses */].Submitted:statusTag=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-xs btn-flat-primary btn-flat-primary-background btn-flat-status-submitted'},statusDisplay);actionButton=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary btn-flat-primary-hover btn-xs btn-campaign-status input',onClick:this.props.verify},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-check icon-left input'}),'Verify');break;default:statusTag=null;actionButton=null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_HoverTableRow__["a" /* default */],{onClick:this.pushRouteWithProps.bind(this,'/campaigns/'+this.props.campaignId+'/lists/'+this.props.campaignList.campaignListId+'/applications')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Status'},statusTag),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Name'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'bold-text'},name)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Count'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_8__lib_utils__["m" /* formatNumber */])(count))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Manager'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,manager)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Fund'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,fund)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Default Amount'},this.state.editMode?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dollar-input-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dollar-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_CurrencyFormatInput__["a" /* default */],{className:'input',isIsraeli:this.props.isIsraeli}),value:this.state.updatedAmount!==null?this.state.updatedAmount:defaultAmount||'',onChange:this.onChangeAmount.bind(this),onKeyDown:function onKeyDown(e){if(e.key==='Enter'&&_this2.state.updatedAmount!==null)_this2.updateListAmount();},validated:true,showValidationError:this.state.updateAttempted,validate:function validate(val){return!val||Object(__WEBPACK_IMPORTED_MODULE_8__lib_utils__["B" /* stripCurrencyFormat */])(val)<=_this2.props.maxAmount;},errorMessage:'Default amount cannot exceed '+Object(__WEBPACK_IMPORTED_MODULE_8__lib_utils__["j" /* formatCurrency */])(this.props.maxAmount,this.props.isIsraeli)+'.'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dollar-input-edit input'},this.props.updating?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'12'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons input '+(this.state.updatedAmount===null?"disabled":""),onClick:this.updateListAmount.bind(this)},'check'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons input',onClick:this.cancelUpdate.bind(this)},'close'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.updateError,timeOut:5000})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'inline-block'},Object(__WEBPACK_IMPORTED_MODULE_8__lib_utils__["j" /* formatCurrency */])(defaultAmount,this.props.isIsraeli)||(this.props.isIsraeli?'₪':'$')+' -',this.props.canUpdate&&status!==__WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__["c" /* CampaignListStatuses */].Approved&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-pencil primary-hover icon-right accent-text input',onClick:function onClick(){return _this2.setState({editMode:!_this2.state.editMode});}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Total Created'},totalCreated),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Total Paid'},totalPaid),this.props.canUpdate&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,actionButton),this.props.canUpdate&&canRemove&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Remove'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-trash trash-hover input',onClick:this.props.remove})));}}]);return CampaignDetailsListsTableRow;}(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (CampaignDetailsListsTableRow);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WizardStep1__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WizardStep2__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WizardStep3__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_clonedeep__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_clonedeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_clonedeep__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VerifyListWizardModal=function(_React$Component){_inherits(VerifyListWizardModal,_React$Component);function VerifyListWizardModal(props){_classCallCheck(this,VerifyListWizardModal);var _this=_possibleConstructorReturn(this,(VerifyListWizardModal.__proto__||Object.getPrototypeOf(VerifyListWizardModal)).call(this,props));_this.updateRejectedParticipants=function(rejectedParticipants){_this.setState({rejectedParticipants:rejectedParticipants});};_this.initialState={wizardStep:1,newParticipants:[],rejectedParticipants:[],defaultAmount:''};_this.state=__WEBPACK_IMPORTED_MODULE_8_lodash_clonedeep___default()(_this.initialState);return _this;}_createClass(VerifyListWizardModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.campaignList.defaultAmount&&!this.state.defaultAmount){this.setState({defaultAmount:nextProps.campaignList.defaultAmount});}}},{key:'onNext',value:function onNext(){if(this.state.wizardStep<3){this.setState({wizardStep:this.state.wizardStep+1});}}},{key:'onPrevious',value:function onPrevious(){if(this.state.wizardStep>1){this.setState({wizardStep:this.state.wizardStep-1});}}},{key:'onClose',value:function onClose(){this.setState(Object.assign({},this.initialState,{newParticipants:[],rejectedParticipants:[]}),this.props.close);}},{key:'onSubmit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(bypassListError){var newParticipants;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(this.state.newParticipants.length<this.props.externalUpdates.data.addedParticipants.length)){_context.next=2;break;}return _context.abrupt('return');case 2:newParticipants=this.state.newParticipants;_context.next=5;return this.props.verifyUpdates(this.props.campaign.campaignId,this.props.campaignList.campaignListId,newParticipants.map(function(_ref2){var key=_ref2.key,value=_ref2.value;return{key:key,value:value};}),//dont send in name,
this.state.rejectedParticipants,this.state.defaultAmount,bypassListError);case 5:if(this.props.verifyingUpdates.success)this.onClose();case 6:case'end':return _context.stop();}}},_callee,this);}));function onSubmit(_x){return _ref.apply(this,arguments);}return onSubmit;}()},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal verify-modal xl-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},'Verify Updated List and Create Applications'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.onClose.bind(this)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-subheader'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center verify-campaign-details-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,this.props.campaignList.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'xs-text accent-text'},'Submitted by ',this.props.campaignList.manager,' on ',Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils__["k" /* formatDate */])(this.props.campaignList.submittedDate))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'verify-modal-steps flex-center'},['Review Update','Verify New Participants','Confirm And Add List To Campaign'].map(function(step,index){var active=_this2.state.wizardStep===index+1;var completed=_this2.state.wizardStep>index+1;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'step-circle '+(active?"active":"")+' '+(completed?"completed":"")},completed?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-checkmark'}):index+1),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,step),index<2&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-arrow-right accent-text icon-right'})));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null)),this.props.externalUpdates.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'30'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'verify-modal-body'},this.state.wizardStep===1&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__WizardStep1__["a" /* default */],{close:this.onClose.bind(this),next:this.onNext.bind(this),removedParticipants:this.props.externalUpdates.data.removedParticipants||[],updatedParticipants:this.props.externalUpdates.data.updatedParticipants||[],isIsraeli:this.props.campaign.isIsraeli,isOrgList:this.props.campaignList.isOrgList}),this.state.wizardStep===2&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__WizardStep2__["a" /* default */],{close:this.onClose.bind(this),next:this.onNext.bind(this),previous:this.onPrevious.bind(this),newParticipants:this.state.newParticipants||[],rejectedParticipants:this.state.rejectedParticipants||[],addedParticipants:this.props.externalUpdates.data.addedParticipants||[],getRecipientSuggestions:this.props.getRecipientSuggestions,recipientSuggestions:this.props.recipientSuggestions,getListRecipients:function getListRecipients(){return _this2.props.getListRecipients(_this2.props.campaignList.campaignListId);},listRecipients:this.props.listRecipients,updateNewParticipants:function updateNewParticipants(newParticipants){return _this2.setState({newParticipants:newParticipants});},updateRejectedParticipants:this.updateRejectedParticipants,locationId:this.props.campaign.locationId,isIsraeli:this.props.campaign.isIsraeli,isOrgList:this.props.campaignList.isOrgList}),this.state.wizardStep===3&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__WizardStep3__["a" /* default */],{close:this.onClose.bind(this),previous:this.onPrevious.bind(this),submit:this.onSubmit.bind(this),newParticipants:this.state.newParticipants,updateNewParticipants:function updateNewParticipants(newParticipants){return _this2.setState({newParticipants:newParticipants});},updateRejectedParticipants:this.updateRejectedParticipants,rejectedParticipants:this.state.rejectedParticipants,getReceivingParticipants:function getReceivingParticipants(){var _props;for(var _len=arguments.length,tableProps=Array(_len),_key=0;_key<_len;_key++){tableProps[_key]=arguments[_key];}return(_props=_this2.props).getReceivingParticipants.apply(_props,[_this2.props.campaignList.campaignListId,_this2.state.newParticipants].concat(tableProps));},receivingParticipants:this.props.receivingParticipants||[],clearReceivingParticipants:this.props.clearReceivingParticipants,campaignName:this.props.campaign.name,defaultAmount:this.state.defaultAmount,maxAmount:this.props.campaign.isIsraeli?this.props.campaign.maxAmountShekel:this.props.campaign.maxAmountDollar,isIsraeli:this.props.campaign.isIsraeli,updateDefaultAmount:function updateDefaultAmount(defaultAmount){return _this2.setState({defaultAmount:defaultAmount});},submitting:this.props.verifyingUpdates.loading,message:this.props.verifyingUpdates.message,error:!this.props.verifyingUpdates.loading&&!this.props.verifyingUpdates.success})),!this.props.externalUpdates.loading&&!this.props.externalUpdates.success&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'error-label text-right'},'Something went wrong and we were unable to retrieve external updates for the ',this.props.campaignList.name,' campaign list.  Please try again.'))));}}]);return VerifyListWizardModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (VerifyListWizardModal);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WizardParticipantsTable__ = __webpack_require__(547);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WizardStep1=function(_React$Component){_inherits(WizardStep1,_React$Component);function WizardStep1(){_classCallCheck(this,WizardStep1);return _possibleConstructorReturn(this,(WizardStep1.__proto__||Object.getPrototypeOf(WizardStep1)).apply(this,arguments));}_createClass(WizardStep1,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wizard-step-1'},!this.props.removedParticipants.length&&!this.props.updatedParticipants.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'double-line-height'},'No participants have been updated or removed.  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' Click Next to continue.'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.removedParticipants.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'error-text medium-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-close icon-left'}),'The following recipients were removed from this list'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__WizardParticipantsTable__["a" /* default */],{isOrgList:this.props.isOrgList,isIsraeli:this.props.isIsraeli,participants:this.props.removedParticipants})),this.props.updatedParticipants.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'approved-text medium-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-check icon-left'}),'The following recipients have been updated'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__WizardParticipantsTable__["a" /* default */],{isOrgList:this.props.isOrgList,isIsraeli:this.props.isIsraeli,participants:this.props.updatedParticipants}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.props.close},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:this.props.next},'Next')));}}]);return WizardStep1;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (WizardStep1);

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var isOrgList=_ref.isOrgList,isIsraeli=_ref.isIsraeli,participants=_ref.participants;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"table-container modal-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,isIsraeli?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"table-header table-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Phone"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Address"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Previous Address"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Email"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Teudat Zehut"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Bank No."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Branch No."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Account No."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Account Holder"),isOrgList&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Position")):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"table-header table-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Phone"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Address"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Previous Address"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Email"),isOrgList&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Position"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,participants.map(function(participant){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:participant.externalListMemberId,className:"table-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"data-label":"Name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,participant.displayName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"data-label":"Phone"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,participant.phoneNumber.join(' | '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"data-label":"Address"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,participant.address)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"data-label":"Previous Address"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,participant.previousAddress)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"data-label":"Email"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{"wordBreak":"break-all"}},participant.email)),isIsraeli&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"data-label":"TeudatZehut"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,participant.teudatZahut)),isIsraeli&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"data-label":"RoutingNum"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,participant.bankRoutingNumber)),isIsraeli&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"data-label":"BranchNum"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,participant.bankBranchNumber)),isIsraeli&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"data-label":"AccountNum"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,participant.bankAccountNumber)),isIsraeli&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"data-label":"AccountHolder"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,participant.bankAccountHolder)),isOrgList&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"data-label":"Position"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,participant.orgEmployment)));}))));});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={currentParticipantIndex:0,currentParticipantId:null,newParticipants:{}};var WizardStep2=function(_React$Component){_inherits(WizardStep2,_React$Component);function WizardStep2(props){var _this2=this;_classCallCheck(this,WizardStep2);var _this=_possibleConstructorReturn(this,(WizardStep2.__proto__||Object.getPrototypeOf(WizardStep2)).call(this,props));_this.getRecipientSuggestionsBlacklist=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!_this.props.addedParticipants.length){_context.next=4;break;}_context.next=3;return _this.props.getListRecipients();case 3:if(_this.props.listRecipients.success){_this.getRecipientSuggestions();}case 4:case'end':return _context.stop();}}},_callee,_this2);}));_this.setParticipants=function(){var updatedNewParticipants=[];var rejectedParticipants=[];for(var participantId in _this.state.newParticipants){updatedNewParticipants.push({key:participantId,value:_this.state.newParticipants[participantId].suggestionId,name:_this.state.newParticipants[participantId].suggestionName,lastName:_this.state.newParticipants[participantId].suggestionLastName,orgEmployment:_this.state.newParticipants[participantId].suggestionPosition});if(_this.state.newParticipants[participantId].reject===true){rejectedParticipants.push({key:participantId,value:_this.state.newParticipants[participantId].rejectedReason});}}_this.props.updateNewParticipants(updatedNewParticipants);_this.props.updateRejectedParticipants(rejectedParticipants);};_this.getRecipientSuggestions=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var currentParticipant;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:currentParticipant=_this.props.addedParticipants[_this.state.currentParticipantIndex];_context2.next=3;return _this.props.getRecipientSuggestions(currentParticipant.firstName+' '+currentParticipant.lastName,Object.assign({address:currentParticipant.address,applicantType:__WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__["l" /* RecipientTypes */].Individual,departments:[_this.props.isIsraeli?__WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__["g" /* Departments */].IL:__WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__["g" /* Departments */].US],includeCampaignLists:true,//include campaign list field with results
phoneNumber:currentParticipant.phoneNumber},!_this.props.isOrgList?{locationId:_this.props.locationId}:{}),[].concat(_toConsumableArray(_this.props.listRecipients.data),_toConsumableArray(Object.keys(_this.state.newParticipants).map(function(participantId){return _this.state.newParticipants[participantId].suggestionId&&currentParticipant!=participantId;}).filter(function(id){return id;}))));case 3:if(!_this.props.recipientSuggestions.data.filter(function(r){return!r.incomplete;}).length)_this.updateNewParticipant(_this.state.currentParticipantId,{createNew:true,suggestionId:null,reject:false});case 4:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.state=Object.assign({},initialState,{currentParticipantId:props.addedParticipants[0]?props.addedParticipants[0].externalListMemberId:initialState.currentParticipantId,newParticipants:_this.getNewParticipants(props.newParticipants||[],props.rejectedParticipants||[])});return _this;}_createClass(WizardStep2,[{key:'componentDidMount',value:function componentDidMount(){this.getRecipientSuggestionsBlacklist();}},{key:'getNewParticipants',value:function getNewParticipants(newParticipants,rejectedParticipants){if(newParticipants.length===0)return{};var p={};var particiapnts=newParticipants.map(function(item){var rejectedParticipant=rejectedParticipants.find(function(r){return r.key.toString()===item.key.toString();});p[item.key]={};p[item.key]["createNew"]=item.value?false:true;p[item.key]["suggestionId"]=item.value?item.value:null;p[item.key]["suggestionName"]=item.name?item.name:null;p[item.key]["suggestionLastName"]=item.lastName?item.lastName:null;p[item.key]["suggestionPosition"]=item.orgEmployment?item.orgEmployment:null;p[item.key]["reject"]=!!rejectedParticipant?true:false;p[item.key]["rejectedReason"]=!!rejectedParticipant?rejectedParticipant.value:"";return p;});return p;}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.setState(initialState);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.addedParticipants[0]&&nextProps.addedParticipants[0]!==this.props.addedParticipants[0]){this.setState({currentParticipantId:nextProps.addedParticipants[0].externalListMemberId},this.getRecipientSuggestions);}}},{key:'onNext',value:function onNext(){this.setParticipants();this.props.next();}},{key:'onPrevious',value:function onPrevious(){this.setParticipants();this.props.previous();}},{key:'updateNewParticipant',value:function updateNewParticipant(participantId,state){this.setState({newParticipants:Object.assign({},this.state.newParticipants,_defineProperty({},participantId,state))});}},{key:'toggleUseSuggestion',value:function toggleUseSuggestion(event){this.updateNewParticipant(this.state.currentParticipantId,Object.assign({},this.state.newParticipants[this.state.currentParticipantId],{createNew:event.target.name==="create"?true:false,suggestionId:null}));}},{key:'selectSuggestion',value:function selectSuggestion(suggestionId,suggestionName,suggestionLastName,suggestionPosition){this.updateNewParticipant(this.state.currentParticipantId,Object.assign({},this.state.newParticipants[this.state.currentParticipantId],{createNew:false,suggestionId:suggestionId,suggestionName:suggestionName,suggestionLastName:suggestionLastName,suggestionPosition:suggestionPosition}));}},{key:'updateRejectParticipant',value:function updateRejectParticipant(event){this.updateNewParticipant(this.state.currentParticipantId,Object.assign({},this.state.newParticipants[this.state.currentParticipantId],{reject:event.target.checked}));}},{key:'updateRejectedReason',value:function updateRejectedReason(event){this.updateNewParticipant(this.state.currentParticipantId,Object.assign({},this.state.newParticipants[this.state.currentParticipantId],{rejectedReason:event.target.value}));}},{key:'navigateParticipants',value:function navigateParticipants(next){if(next&&(!this.state.newParticipants[this.state.currentParticipantId]||!this.state.newParticipants[this.state.currentParticipantId].createNew&&!this.state.newParticipants[this.state.currentParticipantId].suggestionId))return;var updatedIndex=next?this.state.currentParticipantIndex+1:this.state.currentParticipantIndex-1;if(this.props.addedParticipants[updatedIndex]){this.setState({currentParticipantIndex:updatedIndex,currentParticipantId:this.props.addedParticipants[updatedIndex].externalListMemberId},this.getRecipientSuggestions);}}},{key:'render',value:function render(){var _this3=this;var currentParticipant=this.props.addedParticipants[this.state.currentParticipantIndex]||{};var currentParticipantState=this.state.newParticipants[this.state.currentParticipantId]||{createNew:false,suggestionId:null,reject:false};var canChooseRecipientSuggestion=!!this.props.recipientSuggestions.data.filter(function(r){return!r.incomplete;}).length;var reject=currentParticipantState.reject,rejectedReason=currentParticipantState.rejectedReason;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'wizard-step-2'},this.props.addedParticipants.length===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'double-line-height'},'No participants have been added to this campaign list.  ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),' Click Next to continue.'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex new-staff'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Reported New Staff'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},currentParticipant.displayName)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Previous Employment'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},currentParticipant.previousEmployment)),this.props.isOrgList&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Current Employment'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},currentParticipant.orgEmployment||'---')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Phone'),currentParticipant.phoneNumber&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},currentParticipant.phoneNumber.join(' | ')||'---')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Address'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},currentParticipant.addressDisplay)),currentParticipant.previousAddressDisplay&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Previous Address'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},currentParticipant.previousAddressDisplay)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Email'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},currentParticipant.email||'---'))),this.props.isIsraeli&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex new-staff'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Teudat Zehut'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},currentParticipant.teudatZahut)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Bank Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},currentParticipant.bankRoutingNumber)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Branch Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},currentParticipant.bankBranchNumber)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Account Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},currentParticipant.bankAccountNumber)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Account Holder'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},currentParticipant.bankAccountHolder||'---'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null)),this.props.listRecipients.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_LoadingSpinner__["a" /* default */],{height:20}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'small-text accent-text2'},'Retreiving recipient suggestion information...')):!this.props.listRecipients.success?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'small-text error-text'},'Something went wrong when attempting to retrieve recipient suggestion information for this list. Please try refreshing the page.')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section relative suggestions-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'radio',id:'suggestion',name:'suggestion',disabled:!this.props.recipientSuggestions.loading&&!canChooseRecipientSuggestion,checked:!currentParticipantState.createNew,onChange:this.toggleUseSuggestion.bind(this)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'suggestion',className:!this.props.recipientSuggestions.loading&&!canChooseRecipientSuggestion?"disabled":""},'Choose a suggestion'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'btn btn-xs btn-reset',onClick:this.getRecipientSuggestions},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-refresh'}),' Refresh'),this.props.recipientSuggestions.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'25'}):this.props.recipientSuggestions.data.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'table-container modal-table'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'table'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'table-header table-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Address'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Phone'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Campaign Lists'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,this.props.recipientSuggestions.data.map(function(recipient){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'table-row',key:recipient.applicantId},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Name'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:'/recipient-accounts/'+recipient.applicantId},recipient.name),recipient.incomplete&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'tag incomplete'},'Incomplete')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Address'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,recipient.address)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Phone'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,recipient.phoneNumber)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Campaign-Lists'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,recipient.campaignLists?recipient.campaignLists.join(', '):'')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{className:'use-btn-container'},!currentParticipantState.createNew&&!recipient.incomplete&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-flat btn-flat-open '+(!currentParticipantState.createNew&&currentParticipantState.suggestionId===recipient.applicantId?"":"btn-flat-open-hover"),onClick:_this3.selectSuggestion.bind(_this3,recipient.applicantId,recipient.name,recipient.lastName,recipient.orgEmployment)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-check icon-left'}),'Use')));})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'radio-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'radio',id:'create',name:'create',checked:currentParticipantState.createNew,onChange:this.toggleUseSuggestion.bind(this)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'create'},this.props.recipientSuggestions.data.length?"None of the above recipients match, c":"C",'reate new recipient with info provided.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'reject',name:'reject',className:'custom-check',checked:currentParticipantState.reject,onChange:this.updateRejectParticipant.bind(this)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'reject'},'Reject Application')),reject&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',placeholder:'Reject Reason',value:rejectedReason,onChange:this.updateRejectedReason.bind(this)}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-arrow-left icon-left primary-hover \n                            '+(this.state.currentParticipantIndex===0?"disabled":""),onClick:this.navigateParticipants.bind(this,false)}),this.state.currentParticipantIndex+1,' of ',this.props.addedParticipants.length,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-arrow-right icon-right primary-hover\n                            '+(this.state.currentParticipantIndex>=this.props.addedParticipants.length-1||!currentParticipantState.createNew&&!currentParticipantState.suggestionId?"disabled":""),onClick:this.navigateParticipants.bind(this,true)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',onClick:this.onPrevious.bind(this)},'Previous'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.props.close},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',onClick:this.onNext.bind(this),disabled:this.props.addedParticipants.length&&(!currentParticipantState.createNew&&!currentParticipantState.suggestionId||Object.keys(this.state.newParticipants).length<this.props.addedParticipants.length)},'Next')));}}]);return WizardStep2;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (WizardStep2);

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_CurrencyFormatInput__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_shared_WarningModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReceivingParticipantsTable__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={submitAttempted:false,checkAddListRule:true,promptReceivedPast60days:false,promptDuplicateApplications:false,error:false,showModals:{campaign60DayRuleAlertModal:false,duplicateApplicationsAlertModal:false}};var WizardStep3=function(_NavigationComponent){_inherits(WizardStep3,_NavigationComponent);function WizardStep3(props){_classCallCheck(this,WizardStep3);var _this=_possibleConstructorReturn(this,(WizardStep3.__proto__||Object.getPrototypeOf(WizardStep3)).call(this,props));_this.state=initialState;return _this;}_createClass(WizardStep3,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.setState(initialState);}},{key:'onSubmit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var promptDuplicateApplications,promptReceivedPast60days;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({submitAttempted:true,error:false});//submit attempted was used to show required indication when default amount was required.  did not remove this property - waiting to see if implementation will be reverted to original way.
if(!(this.props.defaultAmount>this.props.maxAmount)){_context.next=3;break;}return _context.abrupt('return');case 3:_context.next=5;return this.props.submit(!this.state.checkAddListRule);case 5:if(this.props.error){if(this.state.checkAddListRule&&this.props.message&&(this.props.message.indexOf("60 days")>=0||this.props.message.indexOf("another application")>=0)){promptDuplicateApplications=this.props.message.indexOf("another application")>=0;promptReceivedPast60days=!promptDuplicateApplications||this.props.message.indexOf("|")>=0;this.setState({promptReceivedPast60days:promptReceivedPast60days,promptDuplicateApplications:promptDuplicateApplications},this.toggleModal.bind(this,promptReceivedPast60days?'campaign60DayRuleAlertModal':'duplicateApplicationsAlertModal'));}else{this.setState({error:true});}}case 6:case'end':return _context.stop();}}},_callee,this);}));function onSubmit(){return _ref.apply(this,arguments);}return onSubmit;}()},{key:'onPrevious',value:function onPrevious(){this.props.clearReceivingParticipants();this.props.previous();}},{key:'render',value:function render(){var _this2=this;var totalCount=this.props.receivingParticipants.data.totalCount;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'wizard-step-3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_CurrencyFormatInput__["a" /* default */],{isIsraeli:this.props.isIsraeli}),label:'Enter the default amount for this list',name:'defaultAmount',value:this.props.defaultAmount,onChange:function onChange(name,val){return _this2.props.updateDefaultAmount(val);},validated:true,showValidationError:true,validate:function validate(val){return!val||Object(__WEBPACK_IMPORTED_MODULE_9__lib_utils__["B" /* stripCurrencyFormat */])(val)<=_this2.props.maxAmount;},errorMessage:'Default amount cannot exceed '+Object(__WEBPACK_IMPORTED_MODULE_9__lib_utils__["j" /* formatCurrency */])(this.props.maxAmount,this.props.isIsraeli)+'.'}))),totalCount>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'applicant-amount accent-text2'},totalCount,' Application',totalCount===1?'':'s'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},'will be added to ',this.props.campaignName?'the '+this.props.campaignName:'this',' Campaign')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-table'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ReceivingParticipantsTable__["a" /* default */],Object.assign({},this.props.receivingParticipants,{rejectedParticipants:this.props.rejectedParticipants,updateRejectedParticipants:this.props.updateRejectedParticipants,newParticipants:this.props.newParticipants,getReceivingParticipants:this.props.getReceivingParticipants}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),this.props.submitting?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-error-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'warning-modal-btns modal-btns text-right relative'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',onClick:this.onPrevious.bind(this)},'Previous'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.props.close},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',onClick:this.onSubmit.bind(this)},'Submit')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error,message:this.props.message||"Something went wrong and the verification process could not be completed.  Please try again."})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_shared_WarningModal__["a" /* default */],{show:this.state.showModals.campaign60DayRuleAlertModal,close:this.toggleModal.bind(this,"campaign60DayRuleAlertModal"),message:(this.props.message||"").split('|')[0],'continue':function _continue(){_this2.setState({checkAddListRule:false},_this2.state.promptDuplicateApplications?_this2.toggleModal.bind(_this2,'duplicateApplicationsAlertModal'):_this2.onSubmit);},cancel:function cancel(){_this2.setState({checkAddListRule:true});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_shared_WarningModal__["a" /* default */],{show:this.state.showModals.duplicateApplicationsAlertModal,close:this.toggleModal.bind(this,"duplicateApplicationsAlertModal"),message:(this.props.message||"").split('|')[(this.props.message||"").split('|').length-1],'continue':function _continue(){_this2.setState({checkAddListRule:false},_this2.onSubmit);},cancel:function cancel(){_this2.setState({checkAddListRule:true});}}));}}]);return WizardStep3;}(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (WizardStep3);

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_InfiniteScrollList__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ReceivingParticipantsTableRow__ = __webpack_require__(551);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReceivingParticipantsTable=function(_React$Component){_inherits(ReceivingParticipantsTable,_React$Component);function ReceivingParticipantsTable(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,ReceivingParticipantsTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ReceivingParticipantsTable.__proto__||Object.getPrototypeOf(ReceivingParticipantsTable)).call.apply(_ref,[this].concat(args))),_this),_this.getReceivingParticipants=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(page,sort){var reset=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:return _context.abrupt("return",_this.props.getReceivingParticipants(reset,page,_this.props.results,sort));case 1:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x2,_x3){return _ref2.apply(this,arguments);};}(),_this.getTableRow=function(participant){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ReceivingParticipantsTableRow__["a" /* default */],{key:participant.externalListMemberId,participant:participant,rejectedParticipants:_this.props.rejectedParticipants,updateRejectedParticipants:_this.props.updateRejectedParticipants});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ReceivingParticipantsTable,[{key:"render",value:function render(){var _props=this.props,_props$data=_props.data,records=_props$data.records,totalCount=_props$data.totalCount,hasMore=_props.hasMore,loading=_props.loading,page=_props.page,results=_props.results,sort=_props.sort,success=_props.success;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_InfiniteScrollList__["a" /* default */],{name:"receiving participants",page:page,totalCount:totalCount,resultsView:results,sort:sort,loading:loading,success:success,renderRecord:this.getTableRow,columns:[{title:"Reject",id:null},{title:"Name",sortable:true,id:"name"},{title:"Position",sortable:true,id:"position"},{title:"Rejected Reason",sortable:false,id:"reason"}],records:records||[],hasMore:hasMore,showFooter:false,getRecords:this.getReceivingParticipants,hideScrollToTopButton:true});}}]);return ReceivingParticipantsTable;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ReceivingParticipantsTable);

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={updatedRejectedReason:null};var ReceivingParticipantsTableRow=function(_React$Component){_inherits(ReceivingParticipantsTableRow,_React$Component);function ReceivingParticipantsTableRow(props){_classCallCheck(this,ReceivingParticipantsTableRow);var _this=_possibleConstructorReturn(this,(ReceivingParticipantsTableRow.__proto__||Object.getPrototypeOf(ReceivingParticipantsTableRow)).call(this,props));_this.onToggleReject=function(event,participant){var checked=event.target.checked;var id=participant.externalListMemberId.toString();if(checked){_this.props.updateRejectedParticipants([].concat(_toConsumableArray(_this.props.rejectedParticipants),[{key:id}]));}else{_this.props.updateRejectedParticipants(_this.props.rejectedParticipants.filter(function(p){return p.key.toString()!==id;}));_this.setState({updatedRejectedReason:null});}};_this.onChangeRejectedReason=function(e){_this.setState({updatedRejectedReason:e.target.value});};_this.updateRejectedReason=function(participant,reason){var id=participant.externalListMemberId.toString();_this.props.updateRejectedParticipants([].concat(_toConsumableArray(_this.props.rejectedParticipants.filter(function(p){return p.key.toString()!==id;})),[{key:id,value:reason}]));_this.setState({updatedRejectedReason:null});};_this.state=initialState;return _this;}_createClass(ReceivingParticipantsTableRow,[{key:"render",value:function render(){var _this2=this;var participant=this.props.participant;var id=participant.externalListMemberId.toString();var rejectedParticipant=this.props.rejectedParticipants.find(function(member){return member.key.toString()===id;});var isRejected=rejectedParticipant?true:false;var rejectedReason=isRejected===true?rejectedParticipant.value:"";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"table-row",key:participant.externalListMemberId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"custom-check-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",id:"reject-"+participant.externalListMemberId,onChange:function onChange(e){return _this2.onToggleReject(e,participant);},className:"custom-check",checked:isRejected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"reject-"+participant.externalListMemberId,className:"secondary-text"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"data-label":"Name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,participant.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"data-label":"Position"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,participant.orgEmployment)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{"data-label":"Rejected Reason"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",value:this.state.updatedRejectedReason!==null?this.state.updatedRejectedReason:rejectedReason||'',disabled:!isRejected,onChange:this.onChangeRejectedReason,onKeyDown:function onKeyDown(e){if(e.key==='Enter')_this2.updateRejectedReason(participant,e.target.value);},onBlur:function onBlur(e){return _this2.updateRejectedReason(participant,e.target.value);}})));}}]);return ReceivingParticipantsTableRow;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ReceivingParticipantsTableRow);

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_PaginatedTable__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CampaignDetailsIndividualsTableRow__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_shared_ConfirmationModal__ = __webpack_require__(22);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignDetailsIndividualsTable=function(_NavigationComponent){_inherits(CampaignDetailsIndividualsTable,_NavigationComponent);function CampaignDetailsIndividualsTable(props){_classCallCheck(this,CampaignDetailsIndividualsTable);var _this=_possibleConstructorReturn(this,(CampaignDetailsIndividualsTable.__proto__||Object.getPrototypeOf(CampaignDetailsIndividualsTable)).call(this,props));_this.state={showModals:{confirmationModal:false},selectedRecord:{}};_this.getTableRow=_this.getTableRow.bind(_this);return _this;}_createClass(CampaignDetailsIndividualsTable,[{key:'getTableRow',value:function getTableRow(recipient){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CampaignDetailsIndividualsTableRow__["a" /* default */],{key:recipient.recipientId,canUpdate:this.props.canUpdate,canUpdateIndividual:this.props.canUpdateIndividual,canUpdateAmount:this.props.canUpdateAmount,recipient:recipient,campaignId:this.props.campaign.campaignId,campaignName:this.props.campaign.name,maxAmount:recipient.payeeIsIsraeli?this.props.campaign.maxAmountShekel:this.props.campaign.maxAmountDollar,isIsraeli:recipient.payeeIsIsraeli,funds:recipient.payeeIsIsraeli?this.props.funds.IL:this.props.funds.US,campaignIndivCategories:this.props.campaignIndivCategories,toggleSelect:this.props.toggleSelect,selected:this.props.selected.map(function(r){return r.recipientId;}).indexOf(recipient.recipientId)>=0,update:function update(){var _props;for(var _len=arguments.length,updateProps=Array(_len),_key=0;_key<_len;_key++){updateProps[_key]=arguments[_key];}return(_props=_this2.props).update.apply(_props,[_this2.props.campaign.campaignId].concat(updateProps));},updating:this.props.updating[recipient.recipientId]===true,updateError:this.props.updating.hasOwnProperty(recipient.recipientId)&&this.props.updating[recipient.recipientId]!==true,updateErrorMessage:(this.props.updating.hasOwnProperty(recipient.recipientId)&&this.props.updating[recipient.recipientId])!==true?this.props.updating[recipient.recipientId]:'',remove:function remove(selectedRecord){_this2.setState({selectedRecord:selectedRecord});_this2.toggleModal("confirmationModal");}});}},{key:'render',value:function render(){var _this3=this;var columns=[{id:'name',title:'Name',sortable:true},{id:'amount',title:'Amount',sortable:true},{id:'fund',title:'Fund',sortable:true},{id:'category',title:'Category',sortable:true}];if(this.props.canUpdateIndividual)columns.concat([{id:'edit',title:'Edit',sortable:false}]);if(this.props.canUpdate)columns.concat([{id:'remove',title:'Remove',sortable:false}]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_PaginatedTable__["a" /* default */],{name:'campaign recipients',page:this.props.page,totalCount:this.props.data.totalCount,resultsView:this.props.resultsView,sort:this.props.sort,loading:this.props.loading,success:this.props.success,renderRow:this.getTableRow,columns:columns,records:this.props.data.records||[],sortData:this.props.updateTable,changeDataView:this.props.updateTable,loadData:this.props.getCampaignIndividuals}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_shared_ConfirmationModal__["a" /* default */],{show:this.state.showModals.confirmationModal,message:this.props.campaign.campaignId?'Are you sure you want to remove '+(this.state.selectedRecord.name||'this individual')+' from the '+(this.props.campaign.name||'')+' campaign?':'',close:function close(){_this3.toggleModal("confirmationModal");_this3.setState({selectedRecord:{}});},confirm:this.props.remove.bind(this,this.props.campaign.campaignId,this.state.selectedRecord.recipientId),loading:this.props.removing.loading,success:this.props.removing.success,errorMessage:this.props.removing.message}));}}]);return CampaignDetailsIndividualsTable;}(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (CampaignDetailsIndividualsTable);

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_HoverTableRow__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_CurrencyFormatInput__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={editMode:false,update:{},updateAttempted:false,updateError:false};var CampaignDetailsIndividualsTableRow=function(_NavigationComponent){_inherits(CampaignDetailsIndividualsTableRow,_NavigationComponent);function CampaignDetailsIndividualsTableRow(props){_classCallCheck(this,CampaignDetailsIndividualsTableRow);var _this=_possibleConstructorReturn(this,(CampaignDetailsIndividualsTableRow.__proto__||Object.getPrototypeOf(CampaignDetailsIndividualsTableRow)).call(this,props));_this.state=initialState;_this.onChange=_this.onChange.bind(_this);return _this;}_createClass(CampaignDetailsIndividualsTableRow,[{key:'onChange',value:function onChange(name,value){var update=Object.assign({},this.state.update);if(value.toString()===this.props.recipient[name].toString()){delete update[name];}else{update[name]=value;}this.setState({update:update});}},{key:'updateIndividual',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var update,_props,campaignIndivCategories,funds,maxAmount,recipient,updateError;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({updateAttempted:true,updateError:false});update=this.state.update;_props=this.props,campaignIndivCategories=_props.campaignIndivCategories,funds=_props.funds,maxAmount=_props.maxAmount,recipient=_props.recipient,updateError=_props.updateError;if(!(!Object.keys(update).length//no update
||(update.hasOwnProperty('fundId')?!update.fundId:!recipient.fundId)//no fund
||(update.amount||recipient.amount)>maxAmount)){_context.next=5;break;}return _context.abrupt('return');case 5://set updates name fields for display purposes
if(update.fundId)update.fundName=funds[funds.map(function(f){return f.key.toString();}).indexOf(update.fundId.toString())].value;if(update.individualCategoryId)update.individualCategoryName=campaignIndivCategories[campaignIndivCategories.map(function(c){return c.key.toString();}).indexOf(update.individualCategoryId.toString())].value;_context.next=9;return this.props.update(recipient.recipientId,recipient.applicationId,update);case 9:if(updateError){this.setState({updateError:true});}else{this.cancelUpdate();}case 10:case'end':return _context.stop();}}},_callee,this);}));function updateIndividual(){return _ref.apply(this,arguments);}return updateIndividual;}()},{key:'cancelUpdate',value:function cancelUpdate(){this.setState(initialState);}},{key:'render',value:function render(){var _this2=this;var _props$recipient=this.props.recipient,applicationId=_props$recipient.applicationId,recipientId=_props$recipient.recipientId,name=_props$recipient.name,amount=_props$recipient.amount,fundName=_props$recipient.fundName,fundId=_props$recipient.fundId,individualCategoryName=_props$recipient.individualCategoryName,individualCategoryId=_props$recipient.individualCategoryId,status=_props$recipient.status;var canApprove=status===__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["a" /* ApplicationStatuses */].New&&amount>0;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_HoverTableRow__["a" /* default */],{onClick:this.pushRouteWithProps.bind(this,'/recipient-accounts/'+recipientId+'?applicationId='+applicationId,{prevPage:this.props.campaignName+' Campaign',campaignId:this.props.campaignId,applicationId:applicationId})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Name'},this.props.canUpdate&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-check-container name-check-container '+(!canApprove?"disabled":"")},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'name-'+applicationId,className:'custom-check input',checked:this.props.selected,onChange:function onChange(){return _this2.props.toggleSelect(_this2.props.recipient);},disabled:!canApprove}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'name-'+applicationId,className:'secondary-text input'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{className:'bold-text',to:'/recipient-accounts/'+recipientId+'?applicationId='+applicationId},name)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Amount'},this.state.editMode&&this.props.canUpdateAmount?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dollar-input-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dollar-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_CurrencyFormatInput__["a" /* default */],{className:'input',isIsraeli:this.props.isIsraeli}),name:'amount',value:this.state.update.hasOwnProperty("amount")?this.state.update.amount:amount||'',onChange:this.onChange.bind(this),onKeyDown:function onKeyDown(e){if(e.key==='Enter'&&Object.keys(_this2.state.update).length)_this2.updateIndividual();},validated:true,showValidationError:this.state.updateAttempted,validate:function validate(val){return!val||Object(__WEBPACK_IMPORTED_MODULE_10__lib_utils__["B" /* stripCurrencyFormat */])(val)<=_this2.props.maxAmount;},errorMessage:'Amount cannot exceed '+Object(__WEBPACK_IMPORTED_MODULE_10__lib_utils__["j" /* formatCurrency */])(this.props.maxAmount,this.props.isIsraeli)+'.'}))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_10__lib_utils__["j" /* formatCurrency */])(amount,this.props.isIsraeli))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Fund'},this.state.editMode?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_Select__["a" /* default */],{className:'input',options:this.props.funds}),name:'fundId',value:this.state.update.hasOwnProperty("fundId")?this.state.update.fundId:fundId,onChange:this.onChange.bind(this),required:true,showRequiredError:this.state.updateAttempted}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,fundName)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Category'},this.state.editMode?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_Select__["a" /* default */],{className:'input',clearable:true,options:this.props.campaignIndivCategories}),name:'individualCategoryId',value:this.state.update.hasOwnProperty("individualCategoryId")?this.state.update.individualCategoryId:individualCategoryId,onChange:this.onChange.bind(this),required:false,showRequiredError:this.state.updateAttempted}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,individualCategoryName)),this.props.canUpdateIndividual&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Edit'},status===__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["a" /* ApplicationStatuses */].New&&(!this.state.editMode?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-pencil primary-hover input',onClick:function onClick(){return _this2.setState({editMode:true});}}):this.props.updating?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'12'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons primary-hover input '+(!Object.keys(this.state.update).length?"disabled":""),onClick:this.updateIndividual.bind(this),style:{fontSize:"15px"}},'check'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons primary-hover input',onClick:this.cancelUpdate.bind(this),style:{fontSize:"15px",marginLeft:"8px"}},'close'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.updateError,timeOut:5000,message:this.props.updateErrorMessage})),this.props.canUpdate&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Remove'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-trash trash-hover input',onClick:this.props.remove.bind(this,this.props.recipient)})));}}]);return CampaignDetailsIndividualsTableRow;}(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (CampaignDetailsIndividualsTableRow);

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_CurrencyFormatInput__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__campaignsCommon_CreateCampaignListModal__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_shared_WarningModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={campaignList:{},emailMessage:'',defaultAmount:'',submitAttempted:false,checkAddListRule:true,promptReceivedPast60days:false,promptDuplicateApplications:false,showModals:{createCampaignListModal:false,campaign60DayRuleAlertModal:false,duplicateApplicationsAlertModal:false}};var AddCampaignListModal=function(_NavigationComponent){_inherits(AddCampaignListModal,_NavigationComponent);function AddCampaignListModal(props){_classCallCheck(this,AddCampaignListModal);var _this=_possibleConstructorReturn(this,(AddCampaignListModal.__proto__||Object.getPrototypeOf(AddCampaignListModal)).call(this,props));_this.state=initialState;return _this;}_createClass(AddCampaignListModal,[{key:'onClose',value:function onClose(){this.props.close();this.setState(initialState);}},{key:'onSelectList',value:function onSelectList(name,value){var campaignList=this.props.campaignLists.data.filter(function(list){return list.campaignListId.toString()===value.toString();})[0];if(campaignList){this.setState({campaignList:campaignList});}}},{key:'onChange',value:function onChange(name,value){this.setState(_defineProperty({},name,value));}},{key:'onSubmit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var promptDuplicateApplications,promptReceivedPast60days;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({submitAttempted:true,error:false});if(!(!this.state.campaignList.campaignListId||this.state.campaignList.campaignListType===__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["d" /* CampaignListTypes */].Internal&&this.state.defaultAmount>(this.props.campaign.isIsraeli?this.props.campaign.maxAmountShekel:this.props.campaign.maxAmountDollar))){_context.next=3;break;}return _context.abrupt('return');case 3:_context.next=5;return this.props.addList(this.state.campaignList.campaignListId,this.state.emailMessage,this.state.defaultAmount,!this.state.checkAddListRule);case 5:if(this.props.success){this.onClose();}else{if(this.state.checkAddListRule&&this.props.message&&(this.props.message.indexOf("60 days")>=0||this.props.message.indexOf("another application")>=0)){promptDuplicateApplications=this.props.message.indexOf("another application")>=0;promptReceivedPast60days=!promptDuplicateApplications||this.props.message.indexOf("|")>=0;this.setState({promptReceivedPast60days:promptReceivedPast60days,promptDuplicateApplications:promptDuplicateApplications},this.toggleModal.bind(this,promptReceivedPast60days?'campaign60DayRuleAlertModal':'duplicateApplicationsAlertModal'));}else{this.setState({error:true});}}case 6:case'end':return _context.stop();}}},_callee,this);}));function onSubmit(){return _ref.apply(this,arguments);}return onSubmit;}()},{key:'createCampaignList',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(list){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return this.props.createList(list);case 2:if(!this.props.creatingList.success){_context2.next=6;break;}_context2.next=5;return this.props.getCampaignLists();case 5:this.onSelectList('campaignListId',this.props.creatingList.campaignListId);case 6:case'end':return _context2.stop();}}},_callee2,this);}));function createCampaignList(_x){return _ref2.apply(this,arguments);}return createCampaignList;}()},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show&&!this.state.showModals.createCampaignListModal},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal add-list-modal large-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},'Add List'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.onClose.bind(this)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section choose-list-container'},!this.props.campaignLists.loading&&(this.props.campaignLists.data.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-select'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_Select__["a" /* default */],{options:this.props.campaignLists.data,loading:this.props.campaignLists.loading}),label:'Choose List',name:'campaignList',value:this.state.campaignList.campaignListId,onChange:this.onSelectList.bind(this),required:true,showRequiredError:this.state.submitAttempted})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'empty-state text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'not_interested'),'There are no ',this.props.hasLists?'more ':'','campaign lists that match the campaign location group.  ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),' Click below to create a new list.')),this.state.campaignList.campaignListId>0&&(this.state.campaignList.campaignListType===__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["d" /* CampaignListTypes */].External?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'add-list-margin-top'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Add Message'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{name:'emailMessage',value:this.state.emailMessage,onChange:function onChange(e){return _this2.onChange(e.target.name,e.target.value);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text info-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-info icon-left middle'}),'List will be sent to ',this.state.campaignList.managerName&&this.state.campaignList.managerName+' at ',this.state.campaignList.managerEmail,' for review and update.')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'add-list-margin-top'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_CurrencyFormatInput__["a" /* default */],{isIsraeli:this.props.campaign.isIsraeli}),label:'Default Amount',name:'defaultAmount',value:this.state.defaultAmount,onChange:this.onChange.bind(this),validated:true,showValidationError:true,validate:function validate(val){return!val||Object(__WEBPACK_IMPORTED_MODULE_12__lib_utils__["B" /* stripCurrencyFormat */])(val)<=(_this2.props.campaign.isIsraeli?_this2.props.campaign.maxAmountShekel:_this2.props.campaign.maxAmountDollar);},errorMessage:'Default amount cannot exceed '+Object(__WEBPACK_IMPORTED_MODULE_12__lib_utils__["j" /* formatCurrency */])(this.props.campaign.isIsraeli?this.props.campaign.maxAmountShekel:this.props.campaign.maxAmountDollar,this.props.campaign.isIsraeli)})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-footer flex-justify'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent2',onClick:this.toggleModal.bind(this,"createCampaignListModal")},'Create List'),this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-btns text-right no-wrap-error'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.onClose.bind(this)},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',disabled:!this.state.campaignList.campaignListId,onClick:this.onSubmit.bind(this)},this.state.campaignList.campaignListType===__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["d" /* CampaignListTypes */].External?"Send":"Add"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error,message:this.props.message})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__campaignsCommon_CreateCampaignListModal__["a" /* default */],Object.assign({show:this.state.showModals.createCampaignListModal,close:this.toggleModal.bind(this,"createCampaignListModal")},this.props.creatingList,{isAdmin:this.props.isAdmin,loading:this.props.creatingList.loading||this.props.campaignLists.loading,locationId:this.props.campaign.locationId,locations:this.props.locations,individualCategories:this.props.individualCategories,organizationCategories:this.props.organizationCategories,organizations:this.props.organizations,ILFunds:this.props.ILFunds,USFunds:this.props.USFunds,createCampaignList:this.createCampaignList.bind(this)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_shared_WarningModal__["a" /* default */],{show:this.state.showModals.campaign60DayRuleAlertModal,close:this.toggleModal.bind(this,"campaign60DayRuleAlertModal"),message:(this.props.message||"").split('|')[0],'continue':function _continue(){_this2.setState({checkAddListRule:false},_this2.state.promptDuplicateApplications?_this2.toggleModal.bind(_this2,'duplicateApplicationsAlertModal'):_this2.onSubmit);},cancel:function cancel(){_this2.setState({checkAddListRule:true});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_shared_WarningModal__["a" /* default */],{show:this.state.showModals.duplicateApplicationsAlertModal,close:this.toggleModal.bind(this,"duplicateApplicationsAlertModal"),message:(this.props.message||"").split('|')[(this.props.message||"").split('|').length-1],'continue':function _continue(){_this2.setState({checkAddListRule:false},_this2.onSubmit);},cancel:function cancel(){_this2.setState({checkAddListRule:true});}}));}}]);return AddCampaignListModal;}(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (AddCampaignListModal);

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_CurrencyFormatInput__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_RadioGroup__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_AutocompleteInput__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_shared_UploadAttachments__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__applicationsComponents_newApplication_PaymentInfo__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_constants__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignRecipientApplication=function(_React$Component){_inherits(CampaignRecipientApplication,_React$Component);function CampaignRecipientApplication(props){_classCallCheck(this,CampaignRecipientApplication);var _this=_possibleConstructorReturn(this,(CampaignRecipientApplication.__proto__||Object.getPrototypeOf(CampaignRecipientApplication)).call(this,props));_this.onChange=function(name,value){_this.setState(_defineProperty({},name,value));};_this.updateApplication=function(name,value){_this.setState({application:Object.assign({},_this.state.application,_defineProperty({},name,value))},function(){return _this.props.onChange("application",_this.state.application);});};_this.updatePaymentInfo=function(name,value){var application=_this.state.application;_this.setState({application:Object.assign({},application,{paymentInfo:Object.assign({},application.paymentInfo,_defineProperty({},name,value))})},function(){return _this.props.onChange("application",_this.state.application);});};_this.updateDataErrors=function(name,err){var dataErrors=[].concat(_toConsumableArray(_this.props.dataErrors));if(!err)dataErrors=dataErrors.filter(function(err){return err!==name;});else if(err&&!dataErrors[name])dataErrors.push(name);_this.props.onChange("dataErrors",dataErrors);};var state={application:{amount:"",note:"",attachments:[],sourceId:"",individualCategoryId:"",paymentInfo:{fundId:(props.recipient.isIsraeli?props.defaultIsraelFund:props.defaultUSFund)||"",payTo:props.recipient.trustedPayee?__WEBPACK_IMPORTED_MODULE_9__lib_constants__["e" /* PayeeTypes */].TrustedPayee:__WEBPACK_IMPORTED_MODULE_9__lib_constants__["e" /* PayeeTypes */].Recipient,thirdParty:{referenceId:"",useRecipientAddress:false,isIsraeli:props.recipient.isIsraeli,firstName:"",lastName:"",address:{},bankNumber:"",branchNumber:"",accountNumber:"",accountHolder:"",careOf:""},checkMemo:"",reportMemo:""}},applicationSourceType:__WEBPACK_IMPORTED_MODULE_9__lib_constants__["i" /* SourceTypes */].New,thirdPartyPayeeType:__WEBPACK_IMPORTED_MODULE_9__lib_constants__["i" /* SourceTypes */].New,showCareOf:false,setTrustedPayee:false};state.initialState=state;_this.state=state;return _this;}_createClass(CampaignRecipientApplication,[{key:"componentDidMount",value:function componentDidMount(){this.props.onChange("application",this.state.application);//Set application properties in parent
}},{key:"render",value:function render(){var _this2=this;var _state=this.state,application=_state.application,applicationSourceType=_state.applicationSourceType,initialState=_state.initialState,thirdPartyPayeeType=_state.thirdPartyPayeeType,showCareOf=_state.showCareOf;var _props=this.props,campaign=_props.campaign,campaignIndivCategories=_props.campaignIndivCategories,recipient=_props.recipient,recipientTypes=_props.recipientTypes,references=_props.references,israelFunds=_props.israelFunds,usFunds=_props.usFunds,defaultIsraelFund=_props.defaultIsraelFund,defaultUSFund=_props.defaultUSFund,submitAttempted=_props.submitAttempted;var payee=Object(__WEBPACK_IMPORTED_MODULE_8__lib_utils__["p" /* getApplicationPayee */])(application.paymentInfo,recipient);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"overflow-auto"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column-half column-half-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_CurrencyFormatInput__["a" /* default */],{isIsraeli:payee.isIsraeli}),label:"Amount",name:"amount",value:application.amount,onChange:this.updateApplication,validated:true,showValidationError:true,validate:function validate(val){var isValid=!val||Object(__WEBPACK_IMPORTED_MODULE_8__lib_utils__["B" /* stripCurrencyFormat */])(val)<=(payee.isIsraeli?campaign.maxAmountShekel:campaign.maxAmountDollar);_this2.updateDataErrors("applicationAmount",!isValid);return isValid;},errorMessage:"Amount cannot exceed "+Object(__WEBPACK_IMPORTED_MODULE_8__lib_utils__["j" /* formatCurrency */])(payee.isIsraeli?campaign.maxAmountShekel:campaign.maxAmountDollar,payee.isIsraeli)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column-half column-half-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"input-label"},"Category"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__["a" /* default */],{clearable:true,name:"individualCategoryId",value:application.individualCategoryId,options:campaignIndivCategories.filter(function(c){return c.active!==false;}),onChange:function onChange(e){return _this2.updateApplication(e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"input-label"},"Note"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{name:"note",value:application.note,tabIndex:450,onChange:function onChange(e){return _this2.updateApplication(e.target.name,e.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_shared_UploadAttachments__["a" /* default */],{files:application.attachments,name:"attachments",onChange:this.updateApplication})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-row flex-center",style:{marginTop:"24px",marginBottom:"24px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column-half column-half-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_RadioGroup__["a" /* default */],{title:"Source",options:[{key:__WEBPACK_IMPORTED_MODULE_9__lib_constants__["i" /* SourceTypes */].New,value:"Enter New"},{key:__WEBPACK_IMPORTED_MODULE_9__lib_constants__["i" /* SourceTypes */].Reference,value:"Choose Reference",disabled:!recipient.references.length}],name:"applicationSourceType",value:applicationSourceType,onChange:function onChange(name,val){_this2.onChange(name,val);_this2.updateApplication("sourceId","");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column-half column-half-right"},applicationSourceType===__WEBPACK_IMPORTED_MODULE_9__lib_constants__["i" /* SourceTypes */].Reference?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__["a" /* default */],{options:(recipient.references||[]).map(function(ref){return{key:ref.referenceId,value:ref.displayName};}),name:"sourceId",value:application.sourceId,onChange:function onChange(e){return _this2.updateApplication(e.target.name,e.target.value);}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_AutocompleteInput__["a" /* default */],{showList:true,placeholder:"Search references",name:"sourceId",value:application.sourceId,options:Object(__WEBPACK_IMPORTED_MODULE_8__lib_utils__["o" /* formatReferenceOptions */])(references.data.filter(function(r){return(recipient.references||[]).map(function(ref){return ref.referenceId;}).indexOf(r.referenceId)<0;})),update:this.updateApplication}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__applicationsComponents_newApplication_PaymentInfo__["a" /* default */],{campaignApplication:true,submitAttempted:submitAttempted,paymentInfo:application.paymentInfo,payeeIsIsraeli:payee.isIsraeli,initialThirdParty:Object.assign({},initialState.application.paymentInfo.thirdParty,{isIsraeli:recipient.isIsraeli}),trustedPayee:recipient.trustedPayee,onChange:this.onChange,updateApplication:this.updateApplication,updatePaymentInfo:this.updatePaymentInfo,funds:payee.isIsraeli?israelFunds:usFunds,defaultUSFund:defaultUSFund,defaultIsraeliFund:defaultIsraelFund,thirdPartyPayeeType:thirdPartyPayeeType,showCareOf:showCareOf,recipientReferences:recipient.references.filter(function(ref){return ref.isPayable;}),recipientAddress:!recipient.isIsraeli&&recipient.address&&recipient.address.street?Object(__WEBPACK_IMPORTED_MODULE_8__lib_utils__["b" /* concatenateAddressLabel */])(recipient.address):"",recipientTypes:recipientTypes})))));}}]);return CampaignRecipientApplication;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CampaignRecipientApplication);

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_CurrencyFormatInput__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={campaign:{},error:false,submitAttempted:false};var EditCampaignModal=function(_React$Component){_inherits(EditCampaignModal,_React$Component);function EditCampaignModal(props){_classCallCheck(this,EditCampaignModal);var _this=_possibleConstructorReturn(this,(EditCampaignModal.__proto__||Object.getPrototypeOf(EditCampaignModal)).call(this,props));_this.state=initialState;_this.onChange=_this.onChange.bind(_this);_this.onUpdate=_this.onUpdate.bind(_this);_this.onClose=_this.onClose.bind(_this);return _this;}_createClass(EditCampaignModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.campaign&&nextProps.campaign.campaignId!==this.state.campaign.campaignId){this.setState({campaign:nextProps.campaign});}}},{key:'onChange',value:function onChange(name,value){this.setState({campaign:Object.assign({},this.state.campaign,_defineProperty({},name,value))});}},{key:'onUpdate',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _state$campaign,isIsraeli,maxAmountDollar,maxAmountShekel,campaign;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({error:false,submitAttempted:true});_state$campaign=this.state.campaign,isIsraeli=_state$campaign.isIsraeli,maxAmountDollar=_state$campaign.maxAmountDollar,maxAmountShekel=_state$campaign.maxAmountShekel,campaign=_objectWithoutProperties(_state$campaign,['isIsraeli','maxAmountDollar','maxAmountShekel']);campaign.maxAmount=isIsraeli?maxAmountShekel:maxAmountDollar;if(!(!campaign.endDate||!campaign.approverId||!campaign.maxAmount)){_context.next=5;break;}return _context.abrupt('return');case 5:_context.next=7;return this.props.updateCampaign(campaign);case 7:if(this.props.success){this.onClose();}else{this.setState({error:true});}case 8:case'end':return _context.stop();}}},_callee,this);}));function onUpdate(){return _ref.apply(this,arguments);}return onUpdate;}()},{key:'onClose',value:function onClose(){this.props.close();this.setState(initialState);}},{key:'render',value:function render(){var campaign=this.state.campaign;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal large-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},campaign.status===__WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__["e" /* CampaignStatuses */].Open?"Edit":"Extend",' ',campaign.name,' Campaign'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.onClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'date',format:'mm/dd/yyyy',min:Object(__WEBPACK_IMPORTED_MODULE_8__lib_utils__["l" /* formatDateForInput */])(campaign.dateCreated),max:'9999-12-31'}),label:'End Date',name:'endDate',value:Object(__WEBPACK_IMPORTED_MODULE_8__lib_utils__["l" /* formatDateForInput */])(campaign.endDate),onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},campaign.status===__WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__["e" /* CampaignStatuses */].Open&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Select__["a" /* default */],{options:this.props.approvers}),label:'Approver',name:'approverId',value:campaign.approverId,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})))),campaign.status===__WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__["e" /* CampaignStatuses */].Open&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_CurrencyFormatInput__["a" /* default */],{isIsraeli:campaign.isIsraeli}),label:'Max Amount',name:campaign.isIsraeli?"maxAmountShekel":"maxAmountDollar",value:campaign.isIsraeli?campaign.maxAmountShekel:campaign.maxAmountDollar,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'}))),this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.onClose},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',onClick:this.onUpdate,disabled:Object(__WEBPACK_IMPORTED_MODULE_8__lib_utils__["e" /* deepEquals */])(this.props.campaign,this.state.campaign)},'Update'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error,message:this.props.message})))));}}]);return EditCampaignModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (EditCampaignModal);

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_CampaignListsActions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CampaignListsTable__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__campaignsCommon_CreateCampaignListModal__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_throttle_debounce__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_throttle_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_throttle_debounce__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignListsPage=function(_NavigationComponent){_inherits(CampaignListsPage,_NavigationComponent);function CampaignListsPage(props){_classCallCheck(this,CampaignListsPage);var _this=_possibleConstructorReturn(this,(CampaignListsPage.__proto__||Object.getPrototypeOf(CampaignListsPage)).call(this,props));_this.searchLists=function(keyword){_this.props.actions.updateCampaignListsSearch(keyword);_this.searchDebounce();};_this.searchDebounce=Object(__WEBPACK_IMPORTED_MODULE_9_throttle_debounce__["debounce"])(500,function(){_this.props.actions.getCampaignLists(1,_this.props.campaignListsTable.resultView,_this.props.campaignListsTable.sort);});_this.state={showModals:{createCampaignListModal:false}};return _this;}_createClass(CampaignListsPage,[{key:'componentDidMount',value:function componentDidMount(){if(!this.props.history.location.state||!this.props.history.location.state.preserveData){//manually reset and reload data, only if not nav from campaign list details page
this.props.actions.updateCampaignListsSearch("");//reset search keyword
this.props.actions.getCampaignLists();//reload data with default table settings
}else{this.props.actions.getCampaignLists(this.props.campaignListsTable.page,this.props.campaignListsTable.resultView,this.props.campaignListsTable.sort);delete this.props.history.location.state.preserveData;}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page campaign-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subheader campaign-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container flex-justify'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'page-header campaign-lists-header'},'Campaign Lists ',this.props.userPermissions.manage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn btn-primary btn-small icon-right',onClick:this.toggleModal.bind(this,"createCampaignListModal")},'Add list'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'back-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-android-arrow-back middle medium-text'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{to:'/campaigns',className:'link-text small-text'},'Back to Campaigns')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'campaigns-filters'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container flex-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'search-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'search'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Search List Names',value:this.props.keyword,disabled:!this.props.keyword&&!this.props.campaignListsTable.data.records.length,onChange:function onChange(e){return _this2.searchLists(e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CampaignListsTable__["a" /* default */],Object.assign({},this.props.campaignListsTable,{updateTable:this.props.actions.updateTable,getCampaignLists:this.props.actions.getCampaignLists})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__campaignsCommon_CreateCampaignListModal__["a" /* default */],Object.assign({show:this.state.showModals.createCampaignListModal,close:this.toggleModal.bind(this,"createCampaignListModal")},this.props.newCampaignList,{isAdmin:this.props.userPermissions.admin,individualCategories:this.props.systemSettings.recipientSettings.individualTags.map(function(indivTag){return{key:indivTag.key,value:indivTag.value};}),organizationCategories:this.props.userPermissions.institutions?this.props.systemSettings.recipientSettings.organizationTags.map(function(orgTag){return{key:orgTag.key,value:orgTag.value};}):[],locations:this.props.locationGroups||[],organizations:this.props.organizations||[],ILFunds:this.props.funds.IL||[],USFunds:this.props.funds.US||[],createCampaignList:this.props.actions.createCampaignList,onSuccess:this.pushRoute.bind(this,'/campaigns/lists/'+this.props.newCampaignList.campaignListId)})));}}]);return CampaignListsPage;}(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_NavigationComponent__["a" /* default */]);function mapStateToProps(state,ownProps){return Object.assign({},state.campaignLists,{campaignListsTable:state.campaignListsTable,systemSettings:state.settings.systemSettings.data,locationGroups:state.settings.systemSettings.data.campaignSettings.locationGroups.filter(function(lg){return state.userProfile.profile.data.departments.indexOf(lg.department)>=0;}),organizations:state.recipientAccounts.organizations.data,funds:state.funds.fundsByDept,userPermissions:{admin:state.userProfile.profile.data.roleId===1,manage:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["j" /* PermissionTypes */].CampaignAndListsManage)>=0,institutions:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["j" /* PermissionTypes */].InstitutionsManage)>=0}});}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_4__redux_actions_CampaignListsActions__,dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CampaignListsPage));

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_PaginatedTable__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CampaignListsTableRow__ = __webpack_require__(559);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignListsTable=function(_React$Component){_inherits(CampaignListsTable,_React$Component);function CampaignListsTable(){_classCallCheck(this,CampaignListsTable);return _possibleConstructorReturn(this,(CampaignListsTable.__proto__||Object.getPrototypeOf(CampaignListsTable)).apply(this,arguments));}_createClass(CampaignListsTable,[{key:'getTableRow',value:function getTableRow(campaignList){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CampaignListsTableRow__["a" /* default */],{key:campaignList.campaignListId,campaignList:campaignList});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_PaginatedTable__["a" /* default */],{name:'campaign lists',page:this.props.page,totalCount:this.props.data.totalCount,resultsView:this.props.resultsView,sort:this.props.sort,loading:this.props.loading,success:this.props.success,renderRow:this.getTableRow,columns:[{id:'name',title:'Name',sortable:true},{id:'city',title:'Location',sortable:true},{id:'count',title:'People in list',sortable:true},{id:'fund',title:'Fund',sortable:true}],records:this.props.data.records||[],sortData:this.props.updateTable,changeDataView:this.props.updateTable,loadData:this.props.getCampaignLists,noReload:true});}}]);return CampaignListsTable;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CampaignListsTable);

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_HoverTableRow__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignListsTableRow=function(_NavigationComponent){_inherits(CampaignListsTableRow,_NavigationComponent);function CampaignListsTableRow(){_classCallCheck(this,CampaignListsTableRow);return _possibleConstructorReturn(this,(CampaignListsTableRow.__proto__||Object.getPrototypeOf(CampaignListsTableRow)).apply(this,arguments));}_createClass(CampaignListsTableRow,[{key:'render',value:function render(){var _props$campaignList=this.props.campaignList,campaignListId=_props$campaignList.campaignListId,name=_props$campaignList.name,locationName=_props$campaignList.locationName,count=_props$campaignList.count,fundName=_props$campaignList.fundName,batch=_props$campaignList.batch;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_HoverTableRow__["a" /* default */],{onClick:this.pushRoute.bind(this,'/campaigns/lists/'+campaignListId)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{className:'bold-text flex flex-center',to:'/campaigns/lists/'+campaignListId},name,batch&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons ml-16 medium-text'},'filter_none'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'City'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,locationName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'People'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils__["m" /* formatNumber */])(count))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Fund'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,fundName)));}}]);return CampaignListsTableRow;}(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (CampaignListsTableRow);

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_CampaignListsActions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_SuggestionsActions__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CampaignListParticipantsTable__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CampaignListInfo__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CampaignListReportModal__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__campaignsCommon_AddCampaignRecipientModal__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PendingParticipantsModal__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_apiUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignListDetailsPage=function(_NavigationComponent){_inherits(CampaignListDetailsPage,_NavigationComponent);function CampaignListDetailsPage(props){_classCallCheck(this,CampaignListDetailsPage);var _this=_possibleConstructorReturn(this,(CampaignListDetailsPage.__proto__||Object.getPrototypeOf(CampaignListDetailsPage)).call(this,props));_this.state={campaignListId:_this.props.match.params.id,showModals:{editCampaignListModal:false,addRecipientModal:false,pendingParticipantsModal:false,reportModal:false}};return _this;}_createClass(CampaignListDetailsPage,[{key:'componentWillMount',value:function componentWillMount(){if(this.state.campaignListId){this.getDetails();this.props.actions.getCampaignListAllParticipants(this.state.campaignListId);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.actions.clearCampaignListDetails();var navHistory=this.props.history;if(navHistory.action==='POP'&&navHistory.location.pathname==="/campaigns/lists"){navHistory.replace({state:Object.assign({},navHistory.location.state,{preserveData:true})});}else{navHistory.replace({state:Object.assign({},navHistory.location.state,{preserveData:false})});}}},{key:'getDetails',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.actions.getCampaignListDetails(this.state.campaignListId);case 2:if(!this.props.details.success){__WEBPACK_IMPORTED_MODULE_13_react_redux_toastr__["toastr"].error("Something went wrong!",'We were unable to retrieve campaign list details.  Please try again.');}case 3:case'end':return _context.stop();}}},_callee,this);}));function getDetails(){return _ref.apply(this,arguments);}return getDetails;}()},{key:'getParticipantsForExport',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(params){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_14__lib_apiUtils__["b" /* getRequest */])('/campaignLists/'+this.state.campaignListId+'/participants/report',params,[]);case 2:return _context2.abrupt('return',_context2.sent);case 3:case'end':return _context2.stop();}}},_callee2,this);}));function getParticipantsForExport(_x){return _ref2.apply(this,arguments);}return getParticipantsForExport;}()},{key:'addListParticipants',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(bypassError,recipientIds,addToActiveCampaign,reloadListDetails){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return this.props.actions.addCampaignListParticipants(this.state.campaignListId,recipientIds.length?recipientIds:[recipientIds],bypassError,addToActiveCampaign,reloadListDetails);case 2:if(this.props.newParticipant.success){this.props.actions.getCampaignListParticipants(this.state.campaignListId,1,this.props.participantsTable.resultsView,this.props.participantsTable.sort);this.props.actions.getCampaignListAllParticipants(this.state.campaignListId);}case 3:case'end':return _context3.stop();}}},_callee3,this);}));function addListParticipants(_x2,_x3,_x4,_x5){return _ref3.apply(this,arguments);}return addListParticipants;}()},{key:'removeListParticipant',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(recipientId,bypassError,removeFromActiveCampaign){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return this.props.actions.removeCampaignListParticipant(this.state.campaignListId,recipientId,bypassError,removeFromActiveCampaign);case 2:if(this.props.participantsTable.removing.success){this.props.actions.getCampaignListAllParticipants(this.state.campaignListId);}case 3:case'end':return _context4.stop();}}},_callee4,this);}));function removeListParticipant(_x6,_x7,_x8){return _ref4.apply(this,arguments);}return removeListParticipant;}()},{key:'render',value:function render(){var _this2=this;var campaignList=this.props.details.data;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page campaign-list'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'subheader campaign-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container flex-justify'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'full-width'},this.props.details.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20'}):campaignList.campaignListId&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CampaignListInfo__["a" /* default */],{campaignList:campaignList}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'back-link'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-android-arrow-back middle medium-text'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'link-text small-text',onClick:this.props.history.goBack},'Back to Campaign Lists')))),campaignList.campaignListId&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'campaigns-filters'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container flex-center flex-justify'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},'Participants ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'total-tag'},Object(__WEBPACK_IMPORTED_MODULE_15__lib_utils__["m" /* formatNumber */])(this.props.participantsTable.data.totalCount))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex'},this.props.userPermissions.report&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent2 icon-right btn-small',onClick:this.toggleModal.bind(this,"reportModal")},'New Report'),this.props.userPermissions.manage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent2 icon-right btn-small',onClick:this.toggleModal.bind(this,"addRecipientModal")},'Add Participant'),this.props.userPermissions.manage&&campaignList.pendingMembersCount>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent2 icon-right btn-small',onClick:function onClick(){_this2.props.actions.getCampaignListPendingParticipants(campaignList.campaignListId);_this2.toggleModal("pendingParticipantsModal");}},'Add Pending Participants (',Object(__WEBPACK_IMPORTED_MODULE_15__lib_utils__["m" /* formatNumber */])(campaignList.pendingMembersCount),')')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CampaignListParticipantsTable__["a" /* default */],Object.assign({},this.props.participantsTable,{campaignListName:campaignList.name,campaignListId:campaignList.campaignListId,isExternalOrgCampaignList:campaignList.campaignListType===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["d" /* CampaignListTypes */].External&&campaignList.organizationName,updateTable:this.props.actions.updateParticipantsTable,getCampaignListParticipants:function getCampaignListParticipants(){var _props$actions;for(var _len=arguments.length,tableProps=Array(_len),_key=0;_key<_len;_key++){tableProps[_key]=arguments[_key];}return(_props$actions=_this2.props.actions).getCampaignListParticipants.apply(_props$actions,[_this2.state.campaignListId].concat(_toConsumableArray(tableProps||{})));},managePermission:this.props.userPermissions.manage,removeParticipant:this.removeListParticipant.bind(this)}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__campaignsCommon_AddCampaignRecipientModal__["a" /* default */],Object.assign({campaignList:campaignList,show:this.state.showModals.addRecipientModal,close:this.toggleModal.bind(this,"addRecipientModal")},this.props.newParticipant,{recipientType:!this.props.userPermissions.institutions?__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["l" /* RecipientTypes */].Individual:null,recipientTypes:this.props.systemSettings.otherSettings.recipientTypes,recipientSuggestions:this.props.recipientSuggestions,getRecipientSuggestions:function getRecipientSuggestions(name){var otherInfo=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return _this2.props.actions.getRecipientSuggestions(name,Object.assign({departments:[Object(__WEBPACK_IMPORTED_MODULE_15__lib_utils__["r" /* getLocationDepartment */])(_this2.props.locationGroups,campaignList.locationId)]},!campaignList.organizationName?{locationId:campaignList.locationId}:{},campaignList.campaignListType===__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["d" /* CampaignListTypes */].External||!_this2.props.userPermissions.institutions?{applicantType:__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["l" /* RecipientTypes */].Individual}:{},otherInfo),_this2.props.allParticipants.data.map(function(p){return p.applicantId;}));},locationId:campaignList.locationId,clearRecipientSuggestions:this.props.actions.clearRecipientSuggestions,addRecipient:this.addListParticipants.bind(this)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__PendingParticipantsModal__["a" /* default */],Object.assign({show:this.state.showModals.pendingParticipantsModal,close:this.toggleModal.bind(this,"pendingParticipantsModal"),campaignListName:campaignList.name,pendingParticipants:this.props.pendingParticipants},this.props.newParticipant,{addParticipants:function addParticipants(){for(var _len2=arguments.length,props=Array(_len2),_key2=0;_key2<_len2;_key2++){props[_key2]=arguments[_key2];}return _this2.addListParticipants.apply(_this2,props.concat([true]));}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CampaignListReportModal__["a" /* default */],{campaignListName:campaignList.name,getDataForExport:this.getParticipantsForExport.bind(this),show:this.state.showModals.reportModal,close:function close(){return _this2.toggleModal("reportModal");}}));}}]);return CampaignListDetailsPage;}(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_NavigationComponent__["a" /* default */]);function mapStateToProps(state,ownProps){return Object.assign({},state.campaignListDetails,{participantsTable:state.campaignListParticipantsTable,recipientSuggestions:state.suggestions.recipientSuggestions,systemSettings:state.settings.systemSettings.data,userPermissions:{admin:state.userProfile.profile.data.roleId===1,manage:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["j" /* PermissionTypes */].CampaignAndListsManage)>=0,report:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["j" /* PermissionTypes */].Reporting)>=0,institutions:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_16__lib_systemVariables__["j" /* PermissionTypes */].InstitutionsManage)>=0}});}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(Object.assign({},__WEBPACK_IMPORTED_MODULE_5__redux_actions_SuggestionsActions__,__WEBPACK_IMPORTED_MODULE_4__redux_actions_CampaignListsActions__),dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CampaignListDetailsPage));

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_PaginatedTable__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CampaignListParticipantsTableRow__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_ConfirmationModal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_shared_WarningModal__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignListParticipantsTable=function(_NavigationComponent){_inherits(CampaignListParticipantsTable,_NavigationComponent);function CampaignListParticipantsTable(props){_classCallCheck(this,CampaignListParticipantsTable);var _this=_possibleConstructorReturn(this,(CampaignListParticipantsTable.__proto__||Object.getPrototypeOf(CampaignListParticipantsTable)).call(this,props));_this.state={selectedRecord:{},bypassError:false,removeFromActiveCampaign:false,showModals:{confirmationModal:false,removeFromActiveCampaignsAlertModal:false}};_this.getTableRow=_this.getTableRow.bind(_this);return _this;}_createClass(CampaignListParticipantsTable,[{key:'getTableRow',value:function getTableRow(participant){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CampaignListParticipantsTableRow__["a" /* default */],{key:participant.applicantId,campaignListName:this.props.campaignListName,campaignListId:this.props.campaignListId,isExternalOrgCampaignList:this.props.isExternalOrgCampaignList,managePermission:this.props.managePermission,participant:participant,removeParticipant:function removeParticipant(participant){_this2.setState({selectedRecord:participant,bypassError:false,removeFromActiveCampaign:false},_this2.toggleModal.bind(_this2,"confirmationModal"));}});}},{key:'removeParticipant',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(recipientId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.removeParticipant(recipientId,this.state.bypassError,this.state.removeFromActiveCampaign);case 2:if(!this.props.removing.success&&this.props.removing.message&&this.props.removing.message.indexOf("active campaign")>=0){this.toggleModal("removeFromActiveCampaignsAlertModal");}case 3:case'end':return _context.stop();}}},_callee,this);}));function removeParticipant(_x){return _ref.apply(this,arguments);}return removeParticipant;}()},{key:'render',value:function render(){var _this3=this;var columns=[{id:'name',title:'Name',sortable:true},{id:'phone',title:'Phone',sortable:false},{id:'address',title:'Address',sortable:false}];if(this.props.isExternalOrgCampaignList)columns.push({id:'position',title:'Position',sortable:false});if(this.props.managePermission)columns.push({id:'delete',title:'Delete',sortable:false});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_PaginatedTable__["a" /* default */],{name:'campaign list participants',page:this.props.page,totalCount:this.props.data.totalCount,resultsView:this.props.resultsView,sort:this.props.sort,loading:this.props.loading,success:this.props.success,renderRow:this.getTableRow,columns:columns,records:this.props.data.records||[],sortData:this.props.updateTable,changeDataView:this.props.updateTable,loadData:this.props.getCampaignListParticipants}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_ConfirmationModal__["a" /* default */],{show:this.state.showModals.confirmationModal,message:this.state.selectedRecord.applicantId?'Are you sure you want to remove '+(this.state.selectedRecord.displayName||'this participant')+' from '+(this.props.campaignListName||'this campaign')+' list?\n                     \nThis participant will be permanently removed and will need to manually added in order to be included again.':'',close:this.toggleModal.bind(this,"confirmationModal"),confirm:this.removeParticipant.bind(this,this.state.selectedRecord.applicantId,null),loading:this.props.removing.loading,success:this.props.removing.success||this.props.removing.message&&this.props.removing.message.indexOf("active campaign")>=0}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_shared_WarningModal__["a" /* default */],{show:this.state.showModals.removeFromActiveCampaignsAlertModal,close:this.toggleModal.bind(this,"removeFromActiveCampaignsAlertModal"),message:this.props.removing.message,confirmationMessage:"Do you want to remove this participant from these campaign(s)?",cancelText:"No",continueText:"Yes",cancel:function cancel(){_this3.setState({bypassError:true,removeFromActiveCampaign:false},_this3.removeParticipant.bind(_this3,_this3.state.selectedRecord.applicantId));},'continue':function _continue(){_this3.setState({bypassError:true,removeFromActiveCampaign:true},_this3.removeParticipant.bind(_this3,_this3.state.selectedRecord.applicantId));}}));}}]);return CampaignListParticipantsTable;}(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (CampaignListParticipantsTable);

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_HoverTableRow__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignListParticipantsTableRow=function(_NavigationComponent){_inherits(CampaignListParticipantsTableRow,_NavigationComponent);function CampaignListParticipantsTableRow(){_classCallCheck(this,CampaignListParticipantsTableRow);return _possibleConstructorReturn(this,(CampaignListParticipantsTableRow.__proto__||Object.getPrototypeOf(CampaignListParticipantsTableRow)).apply(this,arguments));}_createClass(CampaignListParticipantsTableRow,[{key:'render',value:function render(){var _props$participant=this.props.participant,applicantId=_props$participant.applicantId,addressDisplay=_props$participant.addressDisplay,displayName=_props$participant.displayName,orgEmployment=_props$participant.orgEmployment,_props$participant$ph=_props$participant.phoneNumber,phoneNumber=_props$participant$ph===undefined?[]:_props$participant$ph;var campaignListId=this.props.campaignListId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_HoverTableRow__["a" /* default */],{onClick:this.pushRouteWithProps.bind(this,'/recipient-accounts/'+applicantId,{prevPage:this.props.campaignListName+' Campaign List',campaignListId:campaignListId,recipientId:applicantId})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{className:'bold-text',to:'/recipient-accounts/'+applicantId},displayName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Phone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,phoneNumber.join(' | '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Address'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,addressDisplay)),this.props.isExternalOrgCampaignList&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Position'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,orgEmployment)),this.props.managePermission&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Delete',className:'delete-table-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-trash trash-hover input',onClick:this.props.removeParticipant.bind(this,this.props.participant)})));}}]);return CampaignListParticipantsTableRow;}(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (CampaignListParticipantsTableRow);

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_RadioGroup__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_shared_WarningModal__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={campaignList:{},invalidData:false,error:false,submitAttempted:false,checkAssocs:true,showModals:{assocsAlertModal:false}};var EditCampaignListModal=function(_NavigationComponent){_inherits(EditCampaignListModal,_NavigationComponent);function EditCampaignListModal(props){_classCallCheck(this,EditCampaignListModal);var _this=_possibleConstructorReturn(this,(EditCampaignListModal.__proto__||Object.getPrototypeOf(EditCampaignListModal)).call(this,props));_this.state=initialState;_this.onChange=_this.onChange.bind(_this);_this.onUpdate=_this.onUpdate.bind(_this);_this.onClose=_this.onClose.bind(_this);return _this;}_createClass(EditCampaignListModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!this.props.show&&nextProps.campaignList){this.setState({campaignList:nextProps.campaignList});}}},{key:'onChange',value:function onChange(name,value){this.setState({campaignList:Object.assign({},this.state.campaignList,_defineProperty({},name,value))});}},{key:'onUpdate',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var campaignList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({error:false,submitAttempted:true});campaignList=this.state.campaignList;if(!(this.state.invalidData||!campaignList.fundId||campaignList.campaignListType===__WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__["d" /* CampaignListTypes */].External&&(!campaignList.managerName||!campaignList.managerEmail))){_context.next=4;break;}return _context.abrupt('return');case 4:if(!(this.props.campaignList.campaignListType===__WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__["d" /* CampaignListTypes */].External&&campaignList.campaignListType===__WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__["d" /* CampaignListTypes */].Internal&&this.state.checkAssocs&&campaignList.assocsSent!==null)){_context.next=7;break;}this.toggleModal('assocsAlertModal');return _context.abrupt('return');case 7:_context.next=9;return this.props.updateCampaignList(this.state.campaignList);case 9:if(this.props.success){this.onClose();}else{this.setState({error:true});}case 10:case'end':return _context.stop();}}},_callee,this);}));function onUpdate(){return _ref.apply(this,arguments);}return onUpdate;}()},{key:'onClose',value:function onClose(){this.props.close();this.setState(initialState);}},{key:'validateEmail',value:function validateEmail(email){var isValid=Object(__WEBPACK_IMPORTED_MODULE_9__lib_utils__["x" /* isValidEmail */])(email);this.setState({invalidData:!isValid});return isValid;}},{key:'render',value:function render(){var _this2=this;var campaignList=this.state.campaignList;var hasSubmittedAssocs=campaignList.hasSubmittedAssocs;var assocsSent=campaignList.assocsSent;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal large-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},'Edit ',campaignList.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.onClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_RadioGroup__["a" /* default */],{title:'Type',name:'campaignListType',options:[{key:'Internal',value:'Internal',disabled:hasSubmittedAssocs},{key:'External',value:'External',disabled:hasSubmittedAssocs}],value:campaignList.campaignListType,onChange:this.onChange})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},this.props.isAdmin&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'empty-label',style:{marginBottom:"6px"}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'allow-duplicates',className:'custom-check',name:'allowDuplicates',onChange:function onChange(event){return _this2.onChange(event.target.name,event.target.checked);},checked:campaignList.allowDuplicates}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'allow-duplicates',className:'secondary-text'},'Allow Duplicates')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_Select__["a" /* default */],{options:Object(__WEBPACK_IMPORTED_MODULE_9__lib_utils__["z" /* locationIsIsraeli */])(this.props.locations,campaignList.locationId)?this.props.ILFunds:this.props.USFunds}),label:'Fund',name:'fundId',value:campaignList.fundId,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},campaignList.campaignListType===__WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__["d" /* CampaignListTypes */].External&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'empty-label',style:{marginBottom:"6px"}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{disabled:true//TODO - for now disabling update to batch always.  potentially would want to enable if no participants yet added of the list. 
,type:'checkbox',id:'batch-list',className:'custom-check',name:'batch',onChange:function onChange(event){return _this2.onChange(event.target.name,event.target.checked);},checked:campaignList.batch}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'batch-list',className:'secondary-text'},'Batch')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_shared_WarningModal__["a" /* default */],{show:this.state.showModals.assocsAlertModal,close:function close(){return _this2.toggleModal("assocsAlertModal");},message:'You modified this list from an external to internal list. \n This campaign list has external associations to the following campaigns: \n '+assocsSent+'\n \n                            You will have to add this campaign list to the campaign(s) again.','continue':function _continue(){_this2.setState({checkAssocs:false},_this2.onUpdate);}}),campaignList.campaignListType===__WEBPACK_IMPORTED_MODULE_10__lib_systemVariables__["d" /* CampaignListTypes */].External&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'Manager Name',name:'managerName',value:campaignList.managerName||'',onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'Manager Email',name:'managerEmail',value:campaignList.managerEmail||'',onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted,validated:true,showValidationError:true,validate:this.validateEmail.bind(this),errorMessage:'Invalid Email Address'})))),this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.onClose},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',onClick:this.onUpdate,disabled:this.state.invalidData||Object(__WEBPACK_IMPORTED_MODULE_9__lib_utils__["e" /* deepEquals */])(this.props.campaignList,this.state.campaignList)},'Update'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error})))));}}]);return EditCampaignListModal;}(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (EditCampaignListModal);

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function getReportFields(){return[{label:"Last Name/Org Name",value:"LastOrOrgName",default:""},{label:"First Name",value:"FirstName",default:""},{label:"Title",value:"Title",default:""},{label:"Report Name",value:"ReportName",default:""},{label:"Address",value:"Address",default:""},{label:"City",value:"City",default:""},{label:"State",value:"State",default:""},{label:"Zip",value:"Zip",default:""},{label:"Country",value:"Country",default:""},{label:"Phone Number(s)",value:"PhoneNumbers",default:""},{label:"Campaign List(s)",value:"CampaignLists",default:""},{label:"Categories",value:"Categories",default:""},{label:"Position",value:"Position",default:""},{label:"Reference(s)",value:"References",default:""},{label:"Solicitor(s)",value:"Solicitors",default:""},{label:"Rosh Yeshiva(s)",value:"RoshYeshivas",default:""},{label:"Teudat Zehut",value:"TeudatZehut",default:""},{label:"Bank Info",value:"BankAccountInfo",default:""},{label:"Bank Account Holder",value:"BankAccountHolder",default:""}];}var initialState={fields:[],groupBy:"",error:false,noData:false,downloading:false,submitAttempted:false};var ReportModal=function(_React$Component){_inherits(ReportModal,_React$Component);function ReportModal(props){_classCallCheck(this,ReportModal);var _this=_possibleConstructorReturn(this,(ReportModal.__proto__||Object.getPrototypeOf(ReportModal)).call(this,props));_this.onChange=function(name,value){_this.setState(_defineProperty({},name,value));};_this.onToggleReportFields=function(event){var fieldName=event.target.name;var checked=event.target.checked;var fields=[].concat(_toConsumableArray(_this.state.fields));if(checked){fields.push(fieldName);}else{fields=fields.filter(function(f){return f!==fieldName;});if(_this.state.groupBy===fieldName){_this.setState({groupBy:""});}}_this.setState({fields:fields});};_this.state=initialState;return _this;}_createClass(ReportModal,[{key:"close",value:function close(){this.setState(initialState);this.props.close();}},{key:"exportData",value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _state,fields,groupBy,dateNow,reportFields,params,exportHeaders,reportName,response,records;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({error:false,noData:false,submitAttempted:true});_state=this.state,fields=_state.fields,groupBy=_state.groupBy;if(fields.length){_context.next=4;break;}return _context.abrupt("return");case 4:this.setState({downloading:true});_context.prev=5;dateNow=""+new Date().toLocaleDateString().replace(/\//g,"_");reportFields=getReportFields();params={fields:fields,groupBy:groupBy};exportHeaders=reportFields.filter(function(field){return fields.indexOf(field.value)>=0;});reportName=this.props.reportName||this.props.campaignListName+"_"+dateNow;_context.next=13;return this.props.getDataForExport(params);case 13:response=_context.sent;if(response.success){_context.next=16;break;}throw Error("error");case 16:records=response.data.values;if(records.length){_context.next=19;break;}throw Error("noData");case 19:exportHeaders=exportHeaders.map(function(_ref2){var getValue=_ref2.getValue,header=_objectWithoutProperties(_ref2,["getValue"]);return Object.assign({},header,{value:getValue||header.value});});Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["g" /* exportCSVFile */])(exportHeaders,records,reportName);this.setState({downloading:false},this.close);_context.next=27;break;case 24:_context.prev=24;_context.t0=_context["catch"](5);this.setState(_defineProperty({downloading:false},_context.t0.message||"error",true));case 27:case"end":return _context.stop();}}},_callee,this,[[5,24]]);}));function exportData(){return _ref.apply(this,arguments);}return exportData;}()},{key:"render",value:function render(){var _this2=this;var _state2=this.state,error=_state2.error,fields=_state2.fields,groupBy=_state2.groupBy,downloading=_state2.downloading,noData=_state2.noData,submitAttempted=_state2.submitAttempted;var show=this.props.show;var reportFields=getReportFields();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal new-fund-modal large-modal"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"bordered-modal-header"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",{className:"modal-page-header"},"Campaign List Report"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon ion-ios-close-empty",onClick:this.close.bind(this)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"mb-16"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"flex"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"input-label "+(submitAttempted&&!fields.length?"error-label":"")},"Report Fields"),submitAttempted&&!fields.length&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"xs-text error-text ml-8"},"* Please select report fields")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row report-fields-grid"},reportFields.map(function(field){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-check-container",key:field.value},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",id:"report-field-"+field.value,className:"custom-check",name:field.value,onChange:_this2.onToggleReportFields,checked:fields.indexOf(field.value)>=0}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{htmlFor:"report-field-"+field.value,className:"secondary-text"},field.label));}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half column-half-left"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"input-label"},"Remove Duplicates Of"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__["a" /* default */],{clearable:true,options:reportFields.filter(function(field){return fields.indexOf(field.value)>=0;}).map(function(field){return{key:field.value,value:field.label};}),value:groupBy,name:"groupBy",onChange:function onChange(e){return _this2.onChange(e.target.name,e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-btns text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-accent",onClick:this.close.bind(this)},"Cancel"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-primary",onClick:this.exportData.bind(this),disabled:downloading},downloading?"Downloading Report":"Download Report"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:error}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:noData,message:"No data was found.",timeOut:5000})))));}}]);return ReportModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ReportModal);

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_HoverTableRow__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_shared_WarningModal__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={selectedParticipantsIds:[],error:false,checkCampaignRules:true,showModals:{campaign60DayRuleAlertModal:false,campaignAddToActiveRuleAlertModal:false}};var PendingParticipantsModal=function(_NavigationComponent){_inherits(PendingParticipantsModal,_NavigationComponent);function PendingParticipantsModal(props){_classCallCheck(this,PendingParticipantsModal);var _this=_possibleConstructorReturn(this,(PendingParticipantsModal.__proto__||Object.getPrototypeOf(PendingParticipantsModal)).call(this,props));_this.state=initialState;_this.onClose=_this.onClose.bind(_this);return _this;}_createClass(PendingParticipantsModal,[{key:'onSubmit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(addToActiveCampaign){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({error:false});_context.next=3;return this.props.addParticipants(!this.state.checkCampaignRules,this.state.selectedParticipantsIds,addToActiveCampaign);case 3:if(this.props.success){this.onClose();}else{if(this.state.checkCampaignRules&&this.props.message&&(this.props.message.indexOf("60 days")>=0||this.props.message.indexOf("active campaigns")>=0)){this.toggleModal(this.props.message.indexOf("active campaigns")>=0?'campaignAddToActiveRuleAlertModal':'campaign60DayRuleAlertModal');}else{this.setState({error:true});}}case 4:case'end':return _context.stop();}}},_callee,this);}));function onSubmit(_x){return _ref.apply(this,arguments);}return onSubmit;}()},{key:'onClose',value:function onClose(){this.props.close();this.setState(initialState);}},{key:'toggleSelection',value:function toggleSelection(id,event){var selection=id==='all'?event.target.checked?this.props.pendingParticipants.data.filter(function(p){return!p.incomplete;}).map(function(p){return p.applicantId;}):[]:event.target.checked?[].concat(_toConsumableArray(this.state.selectedParticipantsIds),[id]):this.state.selectedParticipantsIds.filter(function(i){return i!==id;});this.setState({selectedParticipantsIds:selection});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal add-pending-participants-modal xl-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},this.props.campaignListName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},this.props.pendingParticipantsCount,' Add Pending Participants')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.onClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section table-container'},this.props.pendingParticipants.success?this.props.pendingParticipants.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'table'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'table-header table-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,this.props.pendingParticipants.data.filter(function(p){return!p.incomplete;}).length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'pending-select-all',className:'custom-check',onChange:this.toggleSelection.bind(this,'all'),checked:this.state.selectedParticipantsIds.length===this.props.pendingParticipants.data.filter(function(p){return!p.incomplete;}).length}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'pending-select-all',className:'secondary-text',title:'Select All'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Address'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Phone'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,this.props.pendingParticipants.data.map(function(participant){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_HoverTableRow__["a" /* default */],{key:participant.applicantId,onClick:function onClick(){return _this2.pushRoute('/recipient-accounts/'+participant.applicantId);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'participant-'+participant.applicantId,className:'custom-check input',onChange:_this2.toggleSelection.bind(_this2,participant.applicantId),checked:_this2.state.selectedParticipantsIds.indexOf(participant.applicantId)>=0,disabled:participant.incomplete}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'participant-'+participant.applicantId,className:'secondary-text input',title:'Cannot add incomplete recipient'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:'/recipient-accounts/'+participant.applicantId},participant.name),participant.incomplete&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'tag incomplete'},'Incomplete')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,participant.address),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,participant.phoneNumber.join(", ")));}))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'error-message'},'Something went wrong and we could not retreive the pending participants for ',this.props.campaignListName,' list. Please try again.')),this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.onClose},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',disabled:!this.state.selectedParticipantsIds.length,onClick:function onClick(){return _this2.onSubmit(false);}},'Submit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error,message:this.props.message}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_shared_WarningModal__["a" /* default */],{show:this.state.showModals.campaign60DayRuleAlertModal,close:this.toggleModal.bind(this,"campaign60DayRuleAlertModal"),message:this.props.message,'continue':function _continue(){_this2.setState({checkCampaignRules:false},function(){return _this2.onSubmit(false);});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_shared_WarningModal__["a" /* default */],{show:this.state.showModals.campaignAddToActiveRuleAlertModal,close:this.toggleModal.bind(this,"campaignAddToActiveRuleAlertModal"),message:this.props.message,confirmationMessage:"Do you want to add these participant(s) to these campaign(s)?",cancelText:"No",continueText:"Yes",cancel:function cancel(){_this2.setState({checkCampaignRules:false},function(){return _this2.onSubmit(false);});},'continue':function _continue(){_this2.setState({checkCampaignRules:false},function(){return _this2.onSubmit(true);});}}));}}]);return PendingParticipantsModal;}(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (PendingParticipantsModal);

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_CampaignsActions__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions_CampaignListsActions__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CampaignListInfo__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CampaignListApplicationsTable__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_systemVariables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignListApplicationsPage=function(_NavigationComponent){_inherits(CampaignListApplicationsPage,_NavigationComponent);function CampaignListApplicationsPage(props){_classCallCheck(this,CampaignListApplicationsPage);var _this=_possibleConstructorReturn(this,(CampaignListApplicationsPage.__proto__||Object.getPrototypeOf(CampaignListApplicationsPage)).call(this,props));_this.state={campaignListId:_this.props.match.params.listId,campaignId:_this.props.match.params.campaignId};return _this;}_createClass(CampaignListApplicationsPage,[{key:'componentWillMount',value:function componentWillMount(){if(this.state.campaignId&&this.state.campaignListId){this.getDetails();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.actions.clearCampaignListApplications();}},{key:'getDetails',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.actions.getCampaignDetails(this.state.campaignId);case 2:if(!this.props.campaignDetails.details.success){__WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__["toastr"].error('Something went wrong','We were unable to retrieve campaign details.  Please try again.');}_context.next=5;return this.props.actions.getCampaignListDetails(this.state.campaignListId);case 5:if(!this.props.details.success){__WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__["toastr"].error("Something went wrong!",'We were unable to retrieve campaign list details.  Please try again.');}case 6:case'end':return _context.stop();}}},_callee,this);}));function getDetails(){return _ref.apply(this,arguments);}return getDetails;}()},{key:'updateStatus',value:function updateStatus(status){if(status!==this.props.campaignListApplications.applicationStatus){var sort=this.props.clApplicationsTable.sort;var resultsView=this.props.clApplicationsTable.resultsView;this.props.actions.updateCampaignListApplicationsStatus(status);this.props.actions.getCampaignListApplications(this.state.campaignId,this.state.campaignListId,1,resultsView,sort);}}},{key:'render',value:function render(){var _this2=this;var campaignList=this.props.details.data;var campaign=this.props.campaignDetails.details.data;campaign.isIsraeli=Object(__WEBPACK_IMPORTED_MODULE_11__lib_utils__["z" /* locationIsIsraeli */])(this.props.locationGroups,campaign.locationId);var _props$clApplications=this.props.clApplicationsTable.data,totalCreated=_props$clApplications.totalCreated,totalPaid=_props$clApplications.totalPaid;var applicationStatus=this.props.campaignListApplications.applicationStatus;var maxAmount=campaign.isIsraeli?campaign.maxAmountShekel:campaign.maxAmountDollar;var table=this.props.clApplicationsTable;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page campaign-list'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'subheader campaign-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container flex-justify'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'full-width'},this.props.campaignDetails.details.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20'}):campaign.campaignId&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center campaign-list-details-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,' ',campaign.name,' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-calendar icon-left accent-text2'}),Object(__WEBPACK_IMPORTED_MODULE_11__lib_utils__["k" /* formatDate */])(campaign.dateCreated),' - ',Object(__WEBPACK_IMPORTED_MODULE_11__lib_utils__["k" /* formatDate */])(campaign.endDate)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text'},campaign.isIsraeli?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons shekel-icon icon icon-left accent-text2'},'\u20AA'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-social-usd icon-left accent-text2'}),Object(__WEBPACK_IMPORTED_MODULE_11__lib_utils__["j" /* formatCurrency */])(maxAmount,campaign.isIsraeli),' limit'))),this.props.details.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20'}):campaignList.campaignListId&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CampaignListInfo__["a" /* default */],{campaignList:campaignList}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'back-link'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-android-arrow-back middle medium-text'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'link-text small-text',onClick:this.props.history.goBack},'Back to Campaigns')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'campaign-applications'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container flex-center flex-justify'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'info-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'application-options'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'application-option status-option-all '+(!applicationStatus?"active":""),onClick:this.updateStatus.bind(this,null)},'All Statuses'),Object.keys(__WEBPACK_IMPORTED_MODULE_12__lib_systemVariables__["a" /* ApplicationStatuses */]).map(function(statusKey){var status=__WEBPACK_IMPORTED_MODULE_12__lib_systemVariables__["a" /* ApplicationStatuses */][statusKey];var count=Object(__WEBPACK_IMPORTED_MODULE_11__lib_utils__["m" /* formatNumber */])(_this2.props.clApplicationsTable.data[statusKey.charAt(0).toLowerCase()+statusKey.slice(1)]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{key:statusKey,className:'application-option status-option-'+statusKey.toLowerCase()+' '+(applicationStatus===statusKey?"active":""),onClick:_this2.updateStatus.bind(_this2,statusKey)},status,' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'status-option-count'},count));}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},'Total Created ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'total-tag'},totalCreated)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},'Total Paid ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'total-tag'},totalPaid))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CampaignListApplicationsTable__["a" /* default */],Object.assign({},this.props.clApplicationsTable,{applicationStatus:applicationStatus,maxAmount:maxAmount,userPermissions:this.props.userPermissions,userId:this.props.userId,admin:this.props.admin,campaignId:campaign.campaignId,campaignListId:campaignList.campaignListId,campaignListName:campaignList.name,updateTable:this.props.actions.updateCampaignListApplicationsTable,updateApplication:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(app,update){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this2.props.actions.updateCampaignListApplication(app,update);case 2:if(table.success){_this2.props.actions.getCampaignListApplications(_this2.state.campaignId,_this2.state.campaignListId,table.page,table.resultsView,{by:table.sort.by,direction:table.sort.direction});}case 3:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x,_x2){return _ref2.apply(this,arguments);};}(),updateApplicationStatus:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(action,app){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this2.props.actions.updateApplicationStatus(action,app);case 2:if(table.success){_this2.props.actions.getCampaignListApplications(_this2.state.campaignId,_this2.state.campaignListId,table.page,table.resultsView,{by:table.sort.by,direction:table.sort.direction});}case 3:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3,_x4){return _ref3.apply(this,arguments);};}(),getCampaignListApplications:function getCampaignListApplications(){var _props$actions;for(var _len=arguments.length,tableProps=Array(_len),_key=0;_key<_len;_key++){tableProps[_key]=arguments[_key];}return(_props$actions=_this2.props.actions).getCampaignListApplications.apply(_props$actions,[_this2.state.campaignId,_this2.state.campaignListId].concat(_toConsumableArray(tableProps||{})));}})));}}]);return CampaignListApplicationsPage;}(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_NavigationComponent__["a" /* default */]);function mapStateToProps(state,ownProps){return Object.assign({},state.campaignListDetails,{campaignListApplications:state.campaignListApplications,campaignDetails:state.campaignDetails,locationGroups:state.settings.systemSettings.data.campaignSettings.locationGroups.filter(function(lg){return state.userProfile.profile.data.departments.indexOf(lg.department)>=0;}),clApplicationsTable:state.campaignListApplicationsTable,userPermissions:{manage:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_12__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsManage)>=0,approveFull:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_12__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsApproveFull)>=0,approveLimited:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_12__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsApproveLimited)>=0},userId:state.userProfile.profile.data.userId,admin:state.userProfile.profile.data.roleId===1});}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(Object.assign({},__WEBPACK_IMPORTED_MODULE_6__redux_actions_CampaignsActions__,{getCampaignListDetails:__WEBPACK_IMPORTED_MODULE_7__redux_actions_CampaignListsActions__["getCampaignListDetails"]}),dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CampaignListApplicationsPage));

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_PaginatedTable__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CampaignListApplicationsTableRow__ = __webpack_require__(568);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignListApplicationsTable=function(_React$Component){_inherits(CampaignListApplicationsTable,_React$Component);function CampaignListApplicationsTable(props){_classCallCheck(this,CampaignListApplicationsTable);var _this=_possibleConstructorReturn(this,(CampaignListApplicationsTable.__proto__||Object.getPrototypeOf(CampaignListApplicationsTable)).call(this,props));_this.getTableRow=_this.getTableRow.bind(_this);return _this;}_createClass(CampaignListApplicationsTable,[{key:'getTableRow',value:function getTableRow(applicationData){var update={success:this.props.success===true};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CampaignListApplicationsTableRow__["a" /* default */],{key:applicationData.applicationId,tableStatus:this.props.applicationStatus,permissions:this.props.userPermissions,userId:this.props.userId,admin:this.props.admin,maxAmount:this.props.maxAmount,applicationData:applicationData,updating:this.props.updating[applicationData.applicationId]===true,updateError:this.props.updating.hasOwnProperty(applicationData.applicationId)&&this.props.updating[applicationData.applicationId]!==true,update:update,updateApplication:this.props.updateApplication,updateApplicationStatus:this.props.updateApplicationStatus,campaignId:this.props.campaignId,campaignListId:this.props.campaignListId,campaignListName:this.props.campaignListName});}},{key:'render',value:function render(){var columns=[{id:'firstName',title:'First Name',sortable:true},{id:'lastName',title:'Last Name',sortable:true},{id:'creationDate',title:'Created Date',sortable:true},{id:'status',title:'Status',sortable:true},{id:'amount',title:'Amount',sortable:true},{id:'orgEmployment',title:'Position',sortable:false},{id:'checkDate',title:'Check Date',sortable:true},{id:'checkNumber',title:'Check Number',sortable:true}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'campaign-list-applications-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_PaginatedTable__["a" /* default */],{name:'campaign list applications',page:this.props.page,totalCount:this.props.data.totalCount,resultsView:this.props.resultsView,sort:this.props.sort,loading:this.props.loading,success:this.props.success,renderRow:this.getTableRow,columns:columns,records:this.props.data.records||[],sortData:this.props.updateTable,changeDataView:this.props.updateTable,loadData:this.props.getCampaignListApplications}));}}]);return CampaignListApplicationsTable;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CampaignListApplicationsTable);

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_HoverTableRow__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_shared_UpdateApplicationAmtInput__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_shared_ApplicationActionsDropdown__ = __webpack_require__(186);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignListApplicationsTableRow=function(_NavigationComponent){_inherits(CampaignListApplicationsTableRow,_NavigationComponent);function CampaignListApplicationsTableRow(){_classCallCheck(this,CampaignListApplicationsTableRow);return _possibleConstructorReturn(this,(CampaignListApplicationsTableRow.__proto__||Object.getPrototypeOf(CampaignListApplicationsTableRow)).apply(this,arguments));}_createClass(CampaignListApplicationsTableRow,[{key:'render',value:function render(){var _this2=this;var _props$applicationDat=this.props.applicationData,applicationId=_props$applicationDat.applicationId,recipientId=_props$applicationDat.recipientId,firstName=_props$applicationDat.firstName,lastName=_props$applicationDat.lastName,orgName=_props$applicationDat.orgName,creationDate=_props$applicationDat.creationDate,status=_props$applicationDat.status,amount=_props$applicationDat.amount,orgEmployment=_props$applicationDat.orgEmployment,currency=_props$applicationDat.currency,checkDate=_props$applicationDat.checkDate,checkNumber=_props$applicationDat.checkNumber,approverId=_props$applicationDat.approverId,inquire=_props$applicationDat.inquire,inquireNote=_props$applicationDat.inquireNote,isFirstTime=_props$applicationDat.isFirstTime;var _props=this.props,userId=_props.userId,admin=_props.admin;var canApprove=this.props.permissions.approveFull||this.props.permissions.approveLimited;var canManage=this.props.permissions.manage;var showStatusDropDown=canManage&&(status!==__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].Review&&status!==__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].New&&(admin||userId===approverId)||(status===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].Review||status===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].New)&&canApprove);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_HoverTableRow__["a" /* default */],{onDoubleClick:this.pushRouteWithProps.bind(this,'/recipient-accounts/'+recipientId+'?applicationId='+applicationId,{prevPage:this.props.campaignListName+' Campaign List Applications',campaignId:this.props.campaignId,campaignListId:this.props.campaignListId,applicationId:applicationId})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'First Name'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,firstName)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Last Name',className:'application-name'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'bold-text'},!lastName&&orgName?orgName:lastName,isFirstTime&&status===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].New&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'tag first-time'},'First Time'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Creation Date'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["k" /* formatDate */])(creationDate))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Status'},showStatusDropDown?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_shared_ApplicationActionsDropdown__["a" /* default */],{status:status,locked:this.props.updating,applicationId:applicationId,userId:userId,approverId:approverId,admin:admin,amount:amount,currency:currency,inquire:inquire,inquireNote:inquireNote,update:Object.assign({},this.props.update,{loading:this.props.updating}),updateApplicationStatus:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(action,app){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this2.props.updateApplicationStatus(action,app);case 1:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x,_x2){return _ref.apply(this,arguments);};}(),maxAmount:this.props.maxAmount}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,status)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Amount'},this.props.tableStatus===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["a" /* ApplicationStatuses */].New&&canApprove&&canManage?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_shared_UpdateApplicationAmtInput__["a" /* default */],{application:this.props.applicationData,updating:this.props.updating,updateError:this.props.updateError,update:this.props.updateApplication,maxAmount:this.props.maxAmount}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["j" /* formatCurrency */])(amount,currency===__WEBPACK_IMPORTED_MODULE_3__lib_systemVariables__["f" /* CurrencyTypes */].Shekel))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Position'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,orgEmployment)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Check Date'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["k" /* formatDate */])(checkDate))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{'data-label':'Check Number'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,checkNumber)));}}]);return CampaignListApplicationsTableRow;}(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (CampaignListApplicationsTableRow);

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_FundsActions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fundsCommon_FundModal__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_util_Toggle__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_redux_toastr__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FundsPage=function(_NavigationComponent){_inherits(FundsPage,_NavigationComponent);function FundsPage(props){_classCallCheck(this,FundsPage);var _this=_possibleConstructorReturn(this,(FundsPage.__proto__||Object.getPrototypeOf(FundsPage)).call(this,props));_this.onToggleChange=function(name,value){_this.setState(_defineProperty({},name,value));};_this.state={showModals:{fundModal:false},showInactiveFunds:false};return _this;}_createClass(FundsPage,[{key:'componentWillMount',value:function componentWillMount(){this.getFunds();}},{key:'getFunds',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.actions.getFundsVerbose();case 2:if(!this.props.funds.success)__WEBPACK_IMPORTED_MODULE_12_react_redux_toastr__["toastr"].error('Something went wrong','We were unable to retrieve funds.  Please try again.');case 3:case'end':return _context.stop();}}},_callee,this);}));function getFunds(){return _ref.apply(this,arguments);}return getFunds;}()},{key:'render',value:function render(){var allFunds=this.props.funds.data||[];var filteredFunds=this.state.showInactiveFunds?allFunds:allFunds.filter(function(fund){return fund.active!==false;});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'subheader funds-subheader'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container flex-justify'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'page-header'},'SFTF Funds'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'action-buttons'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'funds-filter-toggle flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_util_Toggle__["a" /* default */],{id:'inactive-funds',name:'showInactiveFunds',value:this.state.showInactiveFunds,onChange:this.onToggleChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'small-text'},'Show Inactive')),this.props.userPermissions.manageAccounting&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary btn-small',onClick:this.toggleModal.bind(null,'fundModal')},'Add Fund')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container funds-page'},this.props.funds.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_LoadingSpinner__["a" /* default */],{height:40}):filteredFunds.length?filteredFunds.map(function(fund){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{key:fund.fundId,to:'/accounting/'+fund.fundId},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card fund'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fund-card-content flex-justify'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fund-card-left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fund-name'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,fund.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'fund-status '+(fund.active?'fund-status-active':'fund-status-inactive')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'fund-status-dot'}),fund.active?'Active':'Inactive')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-home icon-left accent-text2 middle'}),fund.bankName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-user icon-left accent-text2 middle'}),'Account #',fund.accountNumber),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text accent-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-clock icon-left middle'}),'Last Activity on ',Object(__WEBPACK_IMPORTED_MODULE_10__lib_utils__["k" /* formatDate */])(fund.lastUpdated),' by ',fund.lastUpdatedBy)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fund-card-right flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-notebook icon-left gradient-icon'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'xs-text accent-text uppercase-text'},'Book Balance'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'xl-text'},Object(__WEBPACK_IMPORTED_MODULE_10__lib_utils__["j" /* formatCurrency */])(fund.bookBalance,fund.department===__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["g" /* Departments */].IL)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-check icon-left gradient-icon'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'xs-text accent-text uppercase-text'},'Approved Applications'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'xl-text accent-text3'},Object(__WEBPACK_IMPORTED_MODULE_10__lib_utils__["j" /* formatCurrency */])(fund.totalApproved,fund.department===__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["g" /* Departments */].IL)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-wallet icon-left gradient-icon'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'xs-text accent-text uppercase-text'},'Available Balance'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'xl-text '+(fund.availableBalance<0?'error-text':'approved-text')},Object(__WEBPACK_IMPORTED_MODULE_10__lib_utils__["j" /* formatCurrency */])(fund.availableBalance,fund.department===__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["g" /* Departments */].IL))))))));}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'empty-state'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'not_interested'),'No Funds Available')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__fundsCommon_FundModal__["a" /* default */],{show:this.state.showModals.fundModal,close:this.toggleModal.bind(null,'fundModal'),utils:this.props.utils,loading:this.props.newFund.loading,success:this.props.newFund.success,userPermissions:this.props.userPermissions,createFund:this.props.actions.createFund}));}}]);return FundsPage;}(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_NavigationComponent__["a" /* default */]);function mapStateToProps(state){return Object.assign({},state.funds,{utils:{banks:state.settings.systemSettings.data.fundSettings.banks,departments:state.settings.systemSettings.data.otherSettings.departments,unitTypes:state.settings.systemSettings.data.otherSettings.unitTypes},userPermissions:{manageAccounting:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_11__lib_systemVariables__["j" /* PermissionTypes */].AccountingManage)>=0,admin:state.userProfile.profile.data.roleId===1}});}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_5__redux_actions_FundsActions__,dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(FundsPage));

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_geosuggest__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_geosuggest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_geosuggest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_shared_GeoSuggestWrapper__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BankAddress=function(_React$Component){_inherits(BankAddress,_React$Component);function BankAddress(props){_classCallCheck(this,BankAddress);var _this=_possibleConstructorReturn(this,(BankAddress.__proto__||Object.getPrototypeOf(BankAddress)).call(this,props));_this.noSuggestionsError='noSuggestionsError';_this.invalidAddressError='invalidAddressError';_this.state={noSuggestionsError:false,invalidAddressError:false,addressLabel:_this.props.addressLabel||'',error:false};_this.clearNoSuggestions=_this.clearNoSuggestions.bind(_this);_this.updateSuggestions=_this.updateSuggestions.bind(_this);_this.noSuggestions=_this.noSuggestions.bind(_this);_this.onSuggestSelect=_this.onSuggestSelect.bind(_this);_this.updateErrors=_this.updateErrors.bind(_this);return _this;}_createClass(BankAddress,[{key:'clearNoSuggestions',value:function clearNoSuggestions(){if(this.state.noSuggestionsError)this.updateErrors(this.noSuggestionsError,false);if(this.state.invalidAddressError){this.updateErrors(this.invalidAddressError,false);}}},{key:'updateSuggestions',value:function updateSuggestions(suggestions){if(suggestions.length&&this.state.addressLabel)this.clearNoSuggestions();}},{key:'noSuggestions',value:function noSuggestions(){if(this._geoSuggest.props.value!==''){this.updateErrors(this.noSuggestionsError,true);}}},{key:'onBlur',value:function onBlur(){if((!this.props.address.streetNumber||!this.props.address.street||!this.props.address.city||!this.props.address.country)&&this.state.addressLabel&&!this.state.noSuggestionsError){this.updateErrors(this.invalidAddressError,true);}else if(this.state.invalidAddressError){this.updateErrors(this.invalidAddressError,false);}}},{key:'updateAddressLabel',value:function updateAddressLabel(e){this.setState({addressLabel:e});this.props.updateAddress(Object.assign({},this.state.address,{streetNumber:'',street:'',city:'',state:'',zip:'',country:''}));if(!e)this.clearNoSuggestions();}},{key:'onSuggestSelect',value:function onSuggestSelect(suggestion){if(suggestion&&suggestion.gmaps&&suggestion.gmaps.address_components){var address_components=suggestion.gmaps.address_components;var address=Object.assign({},this.state.address);address.streetNumber=address_components.find(function(obj){return obj.types.includes('street_number');})?address_components.find(function(obj){return obj.types.includes('street_number');}).long_name:'';address.street=address_components.find(function(obj){return obj.types.includes('route');})?address_components.find(function(obj){return obj.types.includes('route');}).long_name:'';address.city=address_components.find(function(obj){return obj.types.includes('locality');})?address_components.find(function(obj){return obj.types.includes('locality');}).long_name:''||address_components.find(function(obj){return obj.types.includes('sublocality');})?address_components.find(function(obj){return obj.types.includes('sublocality');}).long_name:'';address.state=address_components.find(function(obj){return obj.types.includes('administrative_area_level_1');})?address_components.find(function(obj){return obj.types.includes('administrative_area_level_1');}).long_name:'';address.country=address_components.find(function(obj){return obj.types.includes('country');})?address_components.find(function(obj){return obj.types.includes('country');}).long_name:'';address.zip=address_components.find(function(obj){return obj.types.includes('postal_code');})?address_components.find(function(obj){return obj.types.includes('postal_code');}).long_name:'';if(!address_components.find(function(obj){return obj.types.includes('street_number');})||!address_components.find(function(obj){return obj.types.includes('route');})){this.updateErrors(this.invalidAddressError,true);//set address to empty object and return
this.setState({addressLabel:Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils__["c" /* concatenateGeosuggestLabel */])(address,false)});this.props.updateAddress(Object.assign({},this.state.address,{streetNumber:'',street:'',city:'',state:'',zip:'',country:''}));this._geoSuggest.blur();return;}else if(this.state.invalidAddressError){this.updateErrors(this.invalidAddressError,false);}this.setState({addressLabel:Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils__["c" /* concatenateGeosuggestLabel */])(address,false)});this.props.updateAddress(address);this._geoSuggest.blur();}}},{key:'updateErrors',value:function updateErrors(errorName,value){if(errorName===this.invalidAddressError&&!this.state.noSuggestionsError||errorName===this.noSuggestionsError){this.setState(_defineProperty({},errorName,value));}}},{key:'render',value:function render(){var _this2=this;var validationErr=this.state.noSuggestionsError||this.state.invalidAddressError;var requiredErr=this.props.showRequiredError&&(!this.props.address.streetNumber||!this.props.address.street||!this.props.address.city||!this.props.address.country);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_shared_GeoSuggestWrapper__["a" /* default */],{isIsraeli:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address-autocomplete'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label '+(validationErr||requiredErr?"error-label":"")},'Bank Address'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_geosuggest___default.a,{inputClassName:validationErr||requiredErr?"error-input":"",placeholder:'Enter Address',queryDelay:0,autoComplete:'on',ref:function ref(el){return _this2._geoSuggest=el;},value:this.state.addressLabel,onUpdateSuggests:this.updateSuggestions,onChange:this.updateAddressLabel.bind(this),onBlur:this.onBlur.bind(this),initialValue:this.state.addressLabel,onFocus:this.clearNoSuggestions,onSuggestSelect:this.onSuggestSelect,types:['address'],onSuggestNoResults:this.noSuggestions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.noSuggestionsError,message:'No suggestions, address cannot be found.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.invalidAddressError,message:'Invalid Address'}))));}}]);return BankAddress;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BankAddress);

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_number_format__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_number_format__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StartingAmountInput=function(_React$Component){_inherits(StartingAmountInput,_React$Component);function StartingAmountInput(){_classCallCheck(this,StartingAmountInput);return _possibleConstructorReturn(this,(StartingAmountInput.__proto__||Object.getPrototypeOf(StartingAmountInput)).apply(this,arguments));}_createClass(StartingAmountInput,[{key:'rejectValue',value:function rejectValue(values){return!(values.value.length>1&&values.value[0]==='0');}},{key:'onChange',value:function onChange(e){var event=Object.assign({},e);event.target.value=event.target.value.replace(/[^0-9\.]/g,'');this.props.onChange(event);}},{key:'render',value:function render(){var _props=this.props,isIsraeli=_props.isIsraeli,passProps=_objectWithoutProperties(_props,['isIsraeli']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dollar-input'},isIsraeli?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons shekel-icon'},'\u20AA'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'attach_money'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_number_format___default.a,Object.assign({},passProps,{thousandSeparator:true,decimalScale:2,onChange:this.onChange.bind(this),isAllowed:this.rejectValue.bind(this)})));}}]);return StartingAmountInput;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (StartingAmountInput);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_geosuggest__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_geosuggest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_geosuggest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_shared_GeoSuggestWrapper__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FundReturnAddress=function(_React$Component){_inherits(FundReturnAddress,_React$Component);function FundReturnAddress(props){_classCallCheck(this,FundReturnAddress);var _this=_possibleConstructorReturn(this,(FundReturnAddress.__proto__||Object.getPrototypeOf(FundReturnAddress)).call(this,props));_this.noSuggestionsError='noSuggestionsError';_this.invalidAddressError='invalidAddressError';_this.state={noSuggestionsError:false,invalidAddressError:false,addressLabel:_this.props.addressLabel||''};_this.clearNoSuggestions=_this.clearNoSuggestions.bind(_this);_this.updateSuggestions=_this.updateSuggestions.bind(_this);_this.noSuggestions=_this.noSuggestions.bind(_this);_this.onSuggestSelect=_this.onSuggestSelect.bind(_this);_this.updateErrors=_this.updateErrors.bind(_this);return _this;}_createClass(FundReturnAddress,[{key:'clearNoSuggestions',value:function clearNoSuggestions(){if(this.state.noSuggestionsError)this.updateErrors(this.noSuggestionsError,false);if(this.state.invalidAddressError){this.updateErrors(this.invalidAddressError,false);}}},{key:'updateSuggestions',value:function updateSuggestions(suggestions){if(suggestions.length&&this.state.addressLabel)this.clearNoSuggestions();}},{key:'noSuggestions',value:function noSuggestions(){if(this._geoSuggest.props.value!==''){this.updateErrors(this.noSuggestionsError,true);}}},{key:'onBlur',value:function onBlur(){if((!this.props.address.streetNumber||!this.props.address.street||!this.props.address.city||!this.props.address.country)&&this.state.addressLabel&&!this.state.noSuggestionsError){this.updateErrors(this.invalidAddressError,true);}else if(this.state.invalidAddressError){this.updateErrors(this.invalidAddressError,false);}}},{key:'updateAddressLabel',value:function updateAddressLabel(label){this.setState({addressLabel:label||''});if(!label){// When input is cleared, also clear the address in parent
this.props.updateAddress({streetNumber:'',street:'',city:'',state:'',zip:'',country:'',unitType:'',apartment:''});this.clearNoSuggestions();}}},{key:'onUnitTypeChange',value:function onUnitTypeChange(e){var unitType=e&&e.target?e.target.value:'';this.props.updateAddress(Object.assign({},this.props.address,{unitType:unitType}));}},{key:'onApartmentChange',value:function onApartmentChange(e){var apartment=e&&e.target?e.target.value:e||'';this.props.updateAddress(Object.assign({},this.props.address,{apartment:apartment}));}},{key:'onSuggestSelect',value:function onSuggestSelect(suggestion){if(suggestion&&suggestion.gmaps&&suggestion.gmaps.address_components){var address_components=suggestion.gmaps.address_components;var address=Object.assign({},this.props.address);address.streetNumber=address_components.find(function(obj){return obj.types.includes('street_number');})?address_components.find(function(obj){return obj.types.includes('street_number');}).long_name:'';address.street=address_components.find(function(obj){return obj.types.includes('route');})?address_components.find(function(obj){return obj.types.includes('route');}).long_name:'';address.city=(address_components.find(function(obj){return obj.types.includes('locality');})?address_components.find(function(obj){return obj.types.includes('locality');}).long_name:'')||(address_components.find(function(obj){return obj.types.includes('sublocality');})?address_components.find(function(obj){return obj.types.includes('sublocality');}).long_name:'');address.state=address_components.find(function(obj){return obj.types.includes('administrative_area_level_1');})?address_components.find(function(obj){return obj.types.includes('administrative_area_level_1');}).long_name:'';address.country=address_components.find(function(obj){return obj.types.includes('country');})?address_components.find(function(obj){return obj.types.includes('country');}).long_name:'';address.zip=address_components.find(function(obj){return obj.types.includes('postal_code');})?address_components.find(function(obj){return obj.types.includes('postal_code');}).long_name:'';if(!address_components.find(function(obj){return obj.types.includes('street_number');})||!address_components.find(function(obj){return obj.types.includes('route');})){this.updateErrors(this.invalidAddressError,true);this.setState({addressLabel:Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["c" /* concatenateGeosuggestLabel */])(address,false)});this.props.updateAddress(Object.assign({},this.props.address,{streetNumber:'',street:'',city:'',state:'',zip:'',country:'',unitType:'',apartment:''}));this._geoSuggest.blur();return;}else if(this.state.invalidAddressError){this.updateErrors(this.invalidAddressError,false);}this.setState({addressLabel:Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["c" /* concatenateGeosuggestLabel */])(address,false)});this.props.updateAddress(address);this._geoSuggest.blur();}}},{key:'updateErrors',value:function updateErrors(errorName,value){if(errorName===this.invalidAddressError&&!this.state.noSuggestionsError||errorName===this.noSuggestionsError){this.setState(_defineProperty({},errorName,value));}}},{key:'render',value:function render(){var _this2=this;var validationErr=this.state.noSuggestionsError||this.state.invalidAddressError;var addr=this.props.address||{};var hasAnyAddressInput=!!(this.state.addressLabel||addr.streetNumber||addr.street||addr.city||addr.country||addr.state||addr.zip||addr.unitType||addr.apartment);var requiredErr=this.props.showRequiredError&&hasAnyAddressInput&&(!addr.streetNumber||!addr.street||!addr.city||!addr.country);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_shared_GeoSuggestWrapper__["a" /* default */],{isIsraeli:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address-autocomplete'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label '+(validationErr||requiredErr?"error-label":"")},'Return Address'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_geosuggest___default.a,{inputClassName:validationErr||requiredErr?"error-input":"",placeholder:'Enter Address',queryDelay:0,autoComplete:'on',ref:function ref(el){return _this2._geoSuggest=el;},value:this.state.addressLabel,onUpdateSuggests:this.updateSuggestions,onChange:this.updateAddressLabel.bind(this),onBlur:this.onBlur.bind(this),initialValue:this.state.addressLabel,onFocus:this.clearNoSuggestions,onSuggestSelect:this.onSuggestSelect,types:['address'],onSuggestNoResults:this.noSuggestions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.noSuggestionsError,message:'No suggestions, address cannot be found.'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.invalidAddressError,message:'Invalid Address'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-quarter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label input-label-small'},'Unit Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Select__["a" /* default */],{clearable:true,options:this.props.unitTypes,name:'unitType',value:this.props.address.unitType?this.props.address.unitType:'',onChange:this.onUnitTypeChange.bind(this)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-quarter',style:{paddingLeft:8}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label input-label-small'},'Unit #'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:this.props.address.apartment||'',onChange:this.onApartmentChange.bind(this),name:'apartment'}))));}}]);return FundReturnAddress;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (FundReturnAddress);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_FundsActions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fundsCommon_FundModal__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FundDetailsCard__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReconciliationReports__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AllTransactionsTable__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OutsideTransactionsTable__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ReportModal__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fundsCommon_OutsideTransactionModal__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NewBankReconciliation_BankReconciliationModal__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DateRangePicker__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__commonComponents_shared_ConfirmationModal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__TransactionNoteModal__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lib_apiUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_throttle_debounce__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_throttle_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_throttle_debounce__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var views={AllTransactions:"allTrans",OutsideTransactions:"outsideTrans",BankReconciliation:"bankRecon"};var FundDetailsPage=function(_NavigationComponent){_inherits(FundDetailsPage,_NavigationComponent);function FundDetailsPage(props){_classCallCheck(this,FundDetailsPage);var _this=_possibleConstructorReturn(this,(FundDetailsPage.__proto__||Object.getPrototypeOf(FundDetailsPage)).call(this,props));_this.reloadTransactionsTable=function(){var isOutsideTrans=_this.state.view===views.OutsideTransactions;if(isOutsideTrans){_this.props.actions.getOutsideTransactions(_this.state.fundId,_this.props.outsideTransactionsTable.page,_this.props.outsideTransactionsTable.resultsView,_this.props.outsideTransactionsTable.sort);}else{_this.props.actions.getTransactions(_this.state.fundId,_this.props.transactionsTable.page,_this.props.transactionsTable.resultsView,_this.props.transactionsTable.sort);}};_this.state={view:views.AllTransactions,fundId:_this.props.match.params.id,showModals:{fundModal:false,reportModal:false,outsideTransactionModal:false,newBankReconiliationModal:false,transactionNoteModal:false,confirmRevertReconciliationStatusModal:false},selectedTrans:[],selectedReport:null,selectedTransForUpdate:null};_this.getFundDetails=_this.getFundDetails.bind(_this);_this.getTransactionsForExport=_this.getTransactionsForExport.bind(_this);_this.searchTransactions=Object(__WEBPACK_IMPORTED_MODULE_23_throttle_debounce__["debounce"])(500,_this.searchTransactions).bind(_this);return _this;}_createClass(FundDetailsPage,[{key:"componentWillMount",value:function componentWillMount(){if(this.state.fundId){this.getFundDetails();}}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.props.actions.clearFundDetails();}},{key:"getFundDetails",value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.actions.getFundDetails(this.state.fundId);case 2:if(!this.props.fundDetails.success)__WEBPACK_IMPORTED_MODULE_22_react_redux_toastr__["toastr"].error("Something went wrong","We were unable to retrieve fund information.  Please try again.");case 3:case"end":return _context.stop();}}},_callee,this);}));function getFundDetails(){return _ref.apply(this,arguments);}return getFundDetails;}()},{key:"toggleTable",value:function toggleTable(view){if(this.state.view!==view)this.setState({view:view});}},{key:"updateTransFilters",value:function updateTransFilters(name,value,transTable,getTransactions){var _props$actions,_props$actions2;var params=[this.state.fundId,_defineProperty({},name,value),getTransactions,this.props[transTable].sort,this.props[transTable].results];transTable==="transactionsTable"?(_props$actions=this.props.actions).updateTransactionsFilters.apply(_props$actions,params):(_props$actions2=this.props.actions).updateOutsideTransactionsFilters.apply(_props$actions2,params);if(name==="search")this.searchTransactions(transTable);}},{key:"searchTransactions",value:function searchTransactions(transTable){var _props$actions3,_props$actions4;var params=[this.state.fundId,1,this.props[transTable].results,this.props[transTable].sort];transTable==="transactionsTable"?(_props$actions3=this.props.actions).getTransactions.apply(_props$actions3,params):(_props$actions4=this.props.actions).getOutsideTransactions.apply(_props$actions4,params);}},{key:"searchTransactionsAllTime",value:function searchTransactionsAllTime(transTable){var _props$actions5,_props$actions6;var params=[this.state.fundId,{startDate:"",endDate:""},true,this.props[transTable].sort,this.props[transTable].results];transTable==="transactionsTable"?(_props$actions5=this.props.actions).updateTransactionsFilters.apply(_props$actions5,params):(_props$actions6=this.props.actions).updateOutsideTransactionsFilters.apply(_props$actions6,params);}},{key:"selectTransaction",value:function selectTransaction(checked,transactionId){if(checked){this.setState({selectedTrans:[].concat(_toConsumableArray(this.state.selectedTrans),[transactionId])});}else{this.setState({selectedTrans:this.state.selectedTrans.filter(function(t){return t!==transactionId;})});}}},{key:"voidTransactions",value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return this.props.actions.voidTransactions(this.state.fundId,this.state.selectedTrans);case 2:if(this.props.voidTransactions.success)this.setState({selectedTrans:[]});case 3:case"end":return _context2.stop();}}},_callee2,this);}));function voidTransactions(){return _ref3.apply(this,arguments);}return voidTransactions;}()},{key:"renderActions",value:function renderActions(){var _this2=this;switch(this.state.view){case views.AllTransactions:return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"flex-center transaction-filters"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"search-input-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"search-input"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"material-icons"},"search"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",name:"search",placeholder:"Search Transactions",value:this.props.transactionsFilters.search,onChange:function onChange(e){return _this2.updateTransFilters(e.target.name,e.target.value,"transactionsTable",false);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__DateRangePicker__["a" /* default */],{startDate:this.props.transactionsFilters.startDate,endDate:this.props.transactionsFilters.endDate,update:function update(name,val){return _this2.updateTransFilters(name,val,"transactionsTable",true);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-primary",onClick:function onClick(){return _this2.searchTransactionsAllTime("transactionsTable");}},"All Time"),this.props.userPermissions.report&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-primary",onClick:this.toggleModal.bind(this,"reportModal"),disabled:!(this.props.transactionsTable.data.records&&this.props.transactionsTable.data.records.length)},"New Report"));case views.OutsideTransactions:return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"flex-center transaction-filters"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"search-input-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"search-input"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"material-icons"},"search"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",name:"search",placeholder:"Search Transactions",value:this.props.outsideTransactionsFilters.search,onChange:function onChange(e){return _this2.updateTransFilters(e.target.name,e.target.value,"outsideTransactionsTable",false);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__DateRangePicker__["a" /* default */],{startDate:this.props.outsideTransactionsFilters.startDate,endDate:this.props.outsideTransactionsFilters.endDate,update:function update(name,val){return _this2.updateTransFilters(name,val,"outsideTransactionsTable",true);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-primary",onClick:function onClick(){return _this2.searchTransactionsAllTime("outsideTransactionsTable");}},"All Time"),this.props.userPermissions.manageAccounting&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-primary",onClick:this.toggleModal.bind(this,"outsideTransactionModal")},"Add"),this.state.selectedTrans.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"flex-center void"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,this.state.selectedTrans.length," item",this.state.selectedTrans.length>1&&"s"," selected"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-flat btn-small",disabled:this.props.voidTransactions.loading,onClick:this.toggleModal.bind(this,"confirmVoidModal")},"Void Selected")),this.props.userPermissions.report&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-primary",disabled:!(this.props.outsideTransactionsTable.data.records&&this.props.outsideTransactionsTable.data.records.length),onClick:this.toggleModal.bind(this,"reportModal")},"New Report"));case views.BankReconciliation:return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"flex-center flex-justify transaction-filters"},this.props.reconciliationReports.reconciliationReports.data.lastReconciliation&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"small-text accent-text icon-left"},"Last Reconciliation: "+Object(__WEBPACK_IMPORTED_MODULE_19__lib_utils__["k" /* formatDate */])(this.props.reconciliationReports.reconciliationReports.data.lastReconciliation)),this.props.reconciliationReports.reconciliationReports.data.years&&this.props.reconciliationReports.reconciliationReports.data.years.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__commonComponents_util_Select__["a" /* default */],{placeholder:"Year",options:this.props.reconciliationReports.reconciliationReports.data.years.map(function(year){return{key:year,value:year};}),value:this.props.reconciliationReports.filters.year,name:"year",onChange:function onChange(e){return _this2.props.actions.updateReconciliationReportsFilters({year:e.target.value},_this2.state.fundId);}}),this.props.userPermissions.manageAccounting&&!this.props.reconciliationReports.reconciliationReports.loading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-primary btn-small",onClick:this.toggleModal.bind(this,"newBankReconiliationModal")},this.props.reconciliationReports.reconciliationReports.data.reconciliationInProgressReportId?"Continue Reconciliation":"Reconcile Now"));default:return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null);}}},{key:"getTransactionsForExport",value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(params){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(!(this.state.view===views.BankReconciliation)){_context3.next=6;break;}_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_20__lib_apiUtils__["b" /* getRequest */])("/funds/"+this.state.fundId+"/reconciliationReports/"+this.state.selectedReport.id,params);case 3:return _context3.abrupt("return",_context3.sent);case 6:_context3.next=8;return Object(__WEBPACK_IMPORTED_MODULE_20__lib_apiUtils__["b" /* getRequest */])("/funds/"+this.state.fundId+"/transactions/report",params);case 8:return _context3.abrupt("return",_context3.sent);case 9:case"end":return _context3.stop();}}},_callee3,this);}));function getTransactionsForExport(_x){return _ref4.apply(this,arguments);}return getTransactionsForExport;}()},{key:"render",value:function render(){var _this3=this,_Object$assign;var _props=this.props,fundDetails=_props.fundDetails,userPermissions=_props.userPermissions;var fund=fundDetails.data;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"page"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"subheader funds-subheader fund-details-subheader"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"container"},fundDetails.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__commonComponents_util_LoadingSpinner__["a" /* default */],{height:20}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FundDetailsCard__["a" /* default */],{fund:fund,isIsraeli:fund.department===__WEBPACK_IMPORTED_MODULE_21__lib_systemVariables__["g" /* Departments */].IL,toggleModal:this.toggleModal.bind(this,"fundModal"),permissions:userPermissions}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"transactions-tabs"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"container flex-justify flex-center"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",{className:"transaction-options flex"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{className:(this.state.view===views.AllTransactions?"active":"")+" accent-text medium-text",onClick:this.toggleTable.bind(this,views.AllTransactions)},"All Transactions")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{className:(this.state.view===views.OutsideTransactions?"active":"")+" accent-text medium-text",onClick:this.toggleTable.bind(this,views.OutsideTransactions)},"Outside Transactions")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{className:(this.state.view===views.BankReconciliation?"active":"")+" accent-text medium-text",onClick:this.toggleTable.bind(this,views.BankReconciliation)},"Bank Reconciliation"))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"container transactions-page"},this.renderActions(),this.state.view===views.AllTransactions&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__AllTransactionsTable__["a" /* default */],Object.assign({isIsraeli:fund.department===__WEBPACK_IMPORTED_MODULE_21__lib_systemVariables__["g" /* Departments */].IL},this.props.transactionsTable,{updateTable:this.props.actions.updateTransactionsTable,getTransactions:this.props.actions.getTransactions.bind(this,this.state.fundId),canUpdate:this.props.userPermissions.manageAccounting,onClickReconciliationNote:function onClickReconciliationNote(trans){_this3.setState({selectedTransForUpdate:trans},_this3.toggleModal.bind(_this3,"transactionNoteModal"));},onUpdateReconciliationStatus:function onUpdateReconciliationStatus(trans){_this3.setState({selectedTransForUpdate:trans},_this3.toggleModal.bind(_this3,"confirmRevertReconciliationStatusModal"));}})),this.state.view===views.OutsideTransactions&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__OutsideTransactionsTable__["a" /* default */],Object.assign({selectedTrans:this.state.selectedTrans,isIsraeli:fund.department===__WEBPACK_IMPORTED_MODULE_21__lib_systemVariables__["g" /* Departments */].IL},this.props.outsideTransactionsTable,{updateTable:this.props.actions.updateOutsideTransactionsTable,getTransactions:this.props.actions.getOutsideTransactions.bind(this,this.state.fundId),selectTransaction:this.selectTransaction.bind(this),canUpdate:this.props.userPermissions.manageAccounting,onUpdateTransaction:function onUpdateTransaction(trans){_this3.setState({selectedTransForUpdate:trans},_this3.toggleModal.bind(_this3,"outsideTransactionModal"));},onClickReconciliationNote:function onClickReconciliationNote(trans){_this3.setState({selectedTransForUpdate:trans},_this3.toggleModal.bind(_this3,"transactionNoteModal"));},onUpdateReconciliationStatus:function onUpdateReconciliationStatus(trans){_this3.setState({selectedTransForUpdate:trans},_this3.toggleModal.bind(_this3,"confirmRevertReconciliationStatusModal"));},userId:this.props.userId})),this.state.view===views.BankReconciliation&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ReconciliationReports__["a" /* default */],Object.assign({permissions:userPermissions},this.props.reconciliationReports,{fundId:this.state.fundId,deleteReport:this.props.actions.deleteReconciliationReport,getReports:this.props.actions.getReconciliationReports,downloadReport:function downloadReport(reportId,reportName){_this3.setState({selectedReport:{id:reportId,name:reportName}},_this3.toggleModal.bind(_this3,"reportModal"));}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ReportModal__["a" /* default */],{allowGroupedResults:this.state.view===views.AllTransactions,close:function close(){_this3.toggleModal("reportModal");if(_this3.state.selectedReport){_this3.setState({selectedReport:null});}},fundName:fund.name,getTransactionsForExport:this.getTransactionsForExport,reportName:this.state.view===views.BankReconciliation&&this.state.selectedReport?this.state.selectedReport.name:null,reportType:this.state.view===views.OutsideTransactions?"OutsideTransactionsReport":this.state.view===views.BankReconciliation?"BankReconciliationReport":null,show:this.state.showModals.reportModal,tableSettings:this.state.view===views.OutsideTransactions?this.props.outsideTransactionsTable:this.props.transactionsTable,filterSettings:this.state.view===views.OutsideTransactions?this.props.outsideTransactionsFilters:this.props.transactionsFilters}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__fundsCommon_OutsideTransactionModal__["a" /* default */],{isIsraeli:fund.department===__WEBPACK_IMPORTED_MODULE_21__lib_systemVariables__["g" /* Departments */].IL,fundId:this.state.fundId,onSuccess:this.props.actions.getOutsideTransactions.bind(this,this.state.fundId,1,this.props.outsideTransactionsTable.resultsView,this.props.outsideTransactionsTable.sort),onUpdateTransactionType:function onUpdateTransactionType(){if(_this3.props.outsideTransactionsTable.data.records&&_this3.props.outsideTransactionsTable.data.records.length){_this3.props.actions.getOutsideTransactions(_this3.state.fundId,_this3.props.outsideTransactionsTable.page,_this3.props.outsideTransactionsTable.resultsView,_this3.props.outsideTransactionsTable.sort);}},show:this.state.showModals.outsideTransactionModal,close:function close(){_this3.setState({selectedTransForUpdate:null},_this3.toggleModal.bind(_this3,"outsideTransactionModal"));},transactionForUpdate:this.state.selectedTransForUpdate}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__NewBankReconciliation_BankReconciliationModal__["a" /* default */],Object.assign({},this.props.reconciliationReports,(_Object$assign={fund:this.props.fundDetails.data,getReconciliationReport:this.props.actions.getReconciliationReport,createReconciliationReport:this.props.actions.createReconciliationReport,createAndCompleteReconciliationReport:this.props.actions.createAndCompleteReconciliationReport,updateReconciliationReport:this.props.actions.updateReconciliationReport,completeReconciliationReport:this.props.actions.completeReconciliationReport,clearReconciliationDetails:this.props.actions.clearReconciliationDetails//payments table:
,selectPayment:this.props.actions.toggleSelectReconciliationPayments,selectCredit:this.props.actions.toggleSelectReconciliationCredits,reconciliationPayments:this.props.reconciliationPaymentsTable,getPayments:this.props.actions.getReconciliationPayments.bind(this,this.state.fundId)//credits table:
,reconciliationCredits:this.props.reconciliationCreditsTable,getCredits:this.props.actions.getReconciliationCredits.bind(this,this.state.fundId)},_defineProperty(_Object$assign,"selectCredit",this.props.actions.toggleSelectReconciliationCredits),_defineProperty(_Object$assign,"updateAdjustments",this.props.actions.updateReconciliationAdjustments),_defineProperty(_Object$assign,"show",this.state.showModals.newBankReconiliationModal),_defineProperty(_Object$assign,"close",function close(){_this3.toggleModal("newBankReconiliationModal");_this3.props.actions.clearReconciliationDetails();}),_Object$assign))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__fundsCommon_FundModal__["a" /* default */],Object.assign({show:this.state.showModals.fundModal,fund:fund,utils:this.props.utils,userPermissions:this.props.userPermissions,close:this.toggleModal.bind(null,"fundModal")},this.props.updateFund,{createFund:this.props.actions.updateFundDetails.bind(this,fund.fundId),reloadFunds:this.props.actions.getFundDetails.bind(this,fund.fundId)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__commonComponents_shared_ConfirmationModal__["a" /* default */],{show:this.state.showModals.confirmVoidModal,close:function close(){_this3.toggleModal("confirmVoidModal");},message:"Are you sure you want to void these transactions?",confirm:this.voidTransactions.bind(this),loading:this.props.voidTransactions.loading,success:this.props.voidTransactions.success}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__commonComponents_shared_ConfirmationModal__["a" /* default */],{close:function close(){_this3.toggleModal("confirmRevertReconciliationStatusModal");_this3.setState({selectedTransForUpdate:null});},confirm:_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return _this3.props.actions.updateTransactionDetails(_this3.state.fundId,_this3.state.selectedTransForUpdate.transactionId,{reconciliationId:null,reconciliationNote:null});case 2:if(_this3.props.updateTransaction.success){_this3.reloadTransactionsTable();}case 3:case"end":return _context4.stop();}}},_callee4,_this3);})),loading:this.props.updateTransaction.loading,message:"Are you sure want to change the reconciliation status of this transaction to uncleared?",show:this.state.showModals.confirmRevertReconciliationStatusModal,success:this.props.updateTransaction.success}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__TransactionNoteModal__["a" /* default */],{close:function close(){_this3.toggleModal("transactionNoteModal");_this3.setState({selectedTransForUpdate:null});},loading:this.props.updateTransaction.loading,saveAsync:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(text){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return _this3.props.actions.updateTransactionDetails(_this3.state.fundId,_this3.state.selectedTransForUpdate.transactionId,{reconciliationNote:text});case 2:if(_this3.props.updateTransaction.success){_this3.reloadTransactionsTable();}case 3:case"end":return _context5.stop();}}},_callee5,_this3);}));return function(_x2){return _ref6.apply(this,arguments);};}(),show:this.state.showModals.transactionNoteModal,success:this.props.updateTransaction.success,text:this.state.selectedTransForUpdate?this.state.selectedTransForUpdate.reconciliationNote:""}));}}]);return FundDetailsPage;}(__WEBPACK_IMPORTED_MODULE_14__commonComponents_util_NavigationComponent__["a" /* default */]);function mapStateToProps(state){return Object.assign({},state.fundDetails,{transactionsTable:state.accountingTransactionsTable,outsideTransactionsTable:state.accountingOutsideTransactionsTable,reconciliationPaymentsTable:state.reconciliationPaymentsTable,reconciliationCreditsTable:state.reconciliationCreditsTable,reconciliationReports:state.reconciliationReports,utils:{banks:state.settings.systemSettings.data.fundSettings.banks,departments:state.settings.systemSettings.data.otherSettings.departments,unitTypes:state.settings.systemSettings.data.otherSettings.unitTypes},userId:state.userProfile.profile.data.userId,userPermissions:{manageAccounting:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_21__lib_systemVariables__["j" /* PermissionTypes */].AccountingManage)>=0,report:state.userProfile.permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_21__lib_systemVariables__["j" /* PermissionTypes */].Reporting)>=0,admin:state.userProfile.profile.data.roleId===1}});}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_4__redux_actions_FundsActions__,dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(FundDetailsPage));

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils__ = __webpack_require__(2);
var FundDetailsCard=function FundDetailsCard(_ref){var fund=_ref.fund,toggleModal=_ref.toggleModal,isIsraeli=_ref.isIsraeli,permissions=_ref.permissions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fund fund-card-content flex-justify'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fund-card-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fund-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,fund.name),permissions.manageAccounting&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-small icon-right',onClick:toggleModal},'View/Edit Fund Info')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'medium-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-home icon-left accent-text2 middle'}),fund.bankName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'medium-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-user icon-left accent-text2 middle'}),'Account #',fund.accountNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'medium-text accent-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-clock icon-left middle'}),'Last Activity on ',Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["k" /* formatDate */])(fund.lastUpdated),' by ',fund.lastUpdatedBy)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fund-card-right flex-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-notebook icon-left gradient-icon'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'xs-text accent-text uppercase-text'},'Book Balance'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'xl-text'},Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["j" /* formatCurrency */])(fund.bookBalance,isIsraeli)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-check icon-left gradient-icon'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'xs-text accent-text uppercase-text'},'Approved Applications'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'xl-text accent-text3'},Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["j" /* formatCurrency */])(fund.totalApproved,isIsraeli)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-wallet icon-left gradient-icon'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'xs-text accent-text uppercase-text'},'Available Balance'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'xl-text '+(fund.availableBalance<0?'error-text':'approved-text')},Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["j" /* formatCurrency */])(fund.availableBalance,isIsraeli))))));};/* harmony default export */ __webpack_exports__["a"] = (FundDetailsCard);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_shared_ConfirmationModal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReconciliationReports=function(_NavigationComponent){_inherits(ReconciliationReports,_NavigationComponent);function ReconciliationReports(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,ReconciliationReports);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ReconciliationReports.__proto__||Object.getPrototypeOf(ReconciliationReports)).call.apply(_ref,[this].concat(args))),_this),_this.state={selectedReportId:null,showModals:{confirmUndoReconciliationReportModal:false}},_this.onClickUndoReport=function(reportId){_this.setState({selectedReportId:reportId},function(){return _this.toggleModal("confirmUndoReconciliationReportModal");});},_this.undoReconciliationReport=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.deleteReport(_this.props.fundId,_this.state.selectedReportId);case 2:if(_this.props.deleteReconciliationReport.success){_this.setState({selectedReportId:null});}case 3:case"end":return _context.stop();}}},_callee,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ReconciliationReports,[{key:"componentWillMount",value:function componentWillMount(){this.getReports();}},{key:"getReports",value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return this.props.getReports(this.props.fundId);case 2:case"end":return _context2.stop();}}},_callee2,this);}));function getReports(){return _ref3.apply(this,arguments);}return getReports;}()},{key:"render",value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,this.props.reconciliationReports.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_LoadingSpinner__["a" /* default */],{height:32}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"bank-reconciliation"},this.props.reconciliationReports.data.reports&&this.props.reconciliationReports.data.reports.length?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",{className:"large-text"},"Previous Bank Reconciliation Reports"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("table",{className:"table bank-reconciliation-reports"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"Report Name"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"Bank Statement Balance"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"Statement Dates"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null,"Undo"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("th",null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody",null,this.props.reconciliationReports.data.reports.map(function(report){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{key:report.reportId},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold-text medium-text"},report.reportName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bold-text medium-text"},Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["j" /* formatCurrency */])(report.bankStatementBalance)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"medium-text"},Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["k" /* formatDate */])(report.dateFrom)+" - "+Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["k" /* formatDate */])(report.dateTo)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"bank-reconciliation-right-column text-center"},report.canBeDeleted&&_this3.props.permissions.manageAccounting&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon-action-undo icon-left accent-text",onClick:function onClick(){return _this3.onClickUndoReport(report.reportId);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{className:"text-center"},_this3.props.permissions.report&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-flat btn-flat-accent2",onClick:function onClick(){return _this3.props.downloadReport(report.reportId,report.reportName);}},"New Report")));})))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"empty-state"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"material-icons"},"not_interested"),"No Reports Available")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_shared_ConfirmationModal__["a" /* default */],{close:function close(){_this3.toggleModal("confirmUndoReconciliationReportModal");_this3.setState({selectedReportId:null});},confirm:this.undoReconciliationReport,loading:this.props.deleteReconciliationReport.loading,message:"Are you sure you want to delete this reconciliation report?",show:this.state.showModals.confirmUndoReconciliationReportModal,success:this.props.deleteReconciliationReport.success}));}}]);return ReconciliationReports;}(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ReconciliationReports);

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_PaginatedTable__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_HoverTableRow__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_constants__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AllTransactionsTable=function(_NavigationComponent){_inherits(AllTransactionsTable,_NavigationComponent);function AllTransactionsTable(props){_classCallCheck(this,AllTransactionsTable);var _this=_possibleConstructorReturn(this,(AllTransactionsTable.__proto__||Object.getPrototypeOf(AllTransactionsTable)).call(this,props));_this.formatAmount=_this.formatAmount.bind(_this);return _this;}_createClass(AllTransactionsTable,[{key:'getTableRow',value:function getTableRow(transaction){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_HoverTableRow__["a" /* default */],{key:transaction.transactionId,className:'table-row',onDoubleClick:function onDoubleClick(){return transaction.recipientId&&transaction.applicationId&&window.open('/recipient-accounts/'+transaction.recipientId+'?applicationId='+transaction.applicationId,"_blank");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'ReferenceNum',key:'ReferenceNum'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,transaction.referenceNumber)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Status',key:'Status'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,transaction.status)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Date',key:'Date'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils__["k" /* formatDate */])(transaction.date))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Amount',key:'Amount'},this.formatAmount(transaction.type,transaction.amount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Details',key:'Details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,transaction.details)),this.props.canUpdate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Action',style:{maxWidth:"150px"},key:'Action'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transactions-table-actions flex flex-justify'},!!transaction.reconciliationId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link-text small-text text-center input ml-8',onClick:function onClick(){return _this2.props.onUpdateReconciliationStatus(transaction);}},'Change Reconciliation Status'),!!transaction.reconciliationNote&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link-text small-text text-center input ml-8',onClick:function onClick(){return _this2.props.onClickReconciliationNote(transaction);}},'Note'))));}},{key:'formatAmount',value:function formatAmount(type,amount){return type===__WEBPACK_IMPORTED_MODULE_5__lib_constants__["m" /* TransactionTypes */].Withdrawal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'error-text'},'-',Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils__["j" /* formatCurrency */])(amount,this.props.isIsraeli)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'approved-text'},'+',Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils__["j" /* formatCurrency */])(amount,this.props.isIsraeli));}},{key:'render',value:function render(){var columns=[{title:'Reference #',sortable:true,id:'reference'},{title:'Status',sortable:true,id:'status'},{title:'Date',sortable:true,id:'date',defaultDirection:'Descending'},{title:'Amount',sortable:true,id:'amount'},{title:'Details',sortable:false,id:'details'}];if(this.props.canUpdate){columns.push({title:'Action',sortable:false,id:'action'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_PaginatedTable__["a" /* default */],{name:'transactions',page:this.props.page,totalCount:this.props.data.totalCount,resultsView:this.props.resultsView,sort:this.props.sort,loading:this.props.loading,success:this.props.success,renderRow:this.getTableRow.bind(this),columns:columns,records:this.props.data.records||[],sortData:this.props.updateTable,changeDataView:this.props.updateTable,loadData:this.props.getTransactions});}}]);return AllTransactionsTable;}(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (AllTransactionsTable);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_PaginatedTable__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_constants__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OutsideTransactionTable=function(_React$Component){_inherits(OutsideTransactionTable,_React$Component);function OutsideTransactionTable(){_classCallCheck(this,OutsideTransactionTable);return _possibleConstructorReturn(this,(OutsideTransactionTable.__proto__||Object.getPrototypeOf(OutsideTransactionTable)).apply(this,arguments));}_createClass(OutsideTransactionTable,[{key:'getTableRow',value:function getTableRow(transaction){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'table-row',key:transaction.transactionId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-check-container name-check-container '+(!transaction.canVoid?"disabled":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'name-'+transaction.transactionId,className:'custom-check input',checked:this.props.selectedTrans.includes(transaction.transactionId),onChange:function onChange(e){return _this2.props.selectTransaction(e.target.checked,transaction.transactionId);},disabled:!transaction.canVoid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name-'+transaction.transactionId,className:'secondary-text input'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'ReferenceNum',key:'ReferenceNum'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,transaction.referenceNumber)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Amount',key:'Amount'},this.formatAmount(transaction.type,transaction.amount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Date',key:'Date'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["k" /* formatDate */])(transaction.date))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Description',key:'Description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,transaction.description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Source',key:'Source'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,transaction.source)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Status',key:'Status'},this.formatStatus(transaction.status)),this.props.canUpdate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Action',style:{maxWidth:"200px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'transactions-table-actions flex flex-justify'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link-text small-text text-center input mr-8',onClick:function onClick(){return _this2.props.onUpdateTransaction(transaction);}},'Edit Transaction'),!!transaction.reconciliationId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link-text small-text text-center input mr-8',onClick:function onClick(){return _this2.props.onUpdateReconciliationStatus(transaction);}},'Change Reconciliation Status'),!!transaction.reconciliationNote&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'link-text small-text text-center input',onClick:function onClick(){return _this2.props.onClickReconciliationNote(transaction);}},'Note'))));}},{key:'formatAmount',value:function formatAmount(type,amount){return type===__WEBPACK_IMPORTED_MODULE_3__lib_constants__["m" /* TransactionTypes */].Withdrawal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'bold-text error-text'},'-',Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["j" /* formatCurrency */])(amount,this.props.isIsraeli)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'bold-text approved-text'},'+',Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils__["j" /* formatCurrency */])(amount,this.props.isIsraeli));}},{key:'formatStatus',value:function formatStatus(status){switch(status){case"Cleared":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-left icon-check approved-text'}),'Cleared');case"Outstanding":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-left icon-refresh approved-text'}),'Outstanding');case"Void":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-left icon-close approved-text'}),'Void');default:break;}}},{key:'render',value:function render(){var columns=[{title:'',sortable:false,id:'select'},{title:'Reference #',sortable:true,id:'reference'},{title:'Amount',sortable:true,id:'amount',defaultDirection:'Descending'},{title:'Date',sortable:true,id:'date'},{title:'Description',sortable:false,id:'description'},{title:'Source',sortable:false,id:'details'},{title:'Status',sortable:true,id:'status'}];if(this.props.canUpdate){columns.push({title:'Action',sortable:false,id:'action'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_PaginatedTable__["a" /* default */],{name:'outside transactions',page:this.props.page,totalCount:this.props.data.totalCount,resultsView:this.props.resultsView,sort:this.props.sort,loading:this.props.loading,success:this.props.success,renderRow:this.getTableRow.bind(this),columns:columns,records:this.props.data.records||[],sortData:this.props.updateTable,changeDataView:this.props.updateTable,loadData:this.props.getTransactions});}}]);return OutsideTransactionTable;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (OutsideTransactionTable);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_RadioGroup__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bignumber_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bignumber_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bignumber_js__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var ReportTypes={CashReport:"Cash Report",CheckRegisterReport:"Check Register Report",ClearedCheckReport:"Cleared Check Report",OutstandingTransactionsReport:"Outstanding Transactions Report",OutsideTransactionsReport:"Outside Transactions Report",BankReconciliationReport:"Bank Reconciliation Report"};var DefaultFields={CheckRegisterReport:["TransDate","RefNumber","LastOrOrgName","FirstName","ReportName","ReportMemo","TransAmount","Status"],OutstandingTransactionsReport:["TransAmount"]};function getReportFields(reportType){return[{label:"Date",value:"TransDate",default:""},{label:"Reference Number",value:"RefNumber",default:""},{label:"Last Name/Org Name",value:"LastOrOrgName",default:""},{label:"First Name",value:"FirstName",default:""},{label:"Title",value:"Title",default:""},{label:"Report Name",value:"ReportName",default:""},{label:"Bank Info",value:"BankAccountInfo",default:""},{label:"Bank Account Holder",value:"BankAccountHolder",default:""},{label:"Paid To",value:"PaidTo",default:""},{label:"Type",value:"Type",default:""},{label:"Deposit Source / Withdrawal Type",value:"Source",default:""},{label:"Description",value:"Description",default:""},{label:"Check Memo",value:"CheckMemo",default:""},{label:"Report Memo",value:"ReportMemo",default:""},{label:"Address",value:"Address",default:""},{label:"City",value:"City",default:""},{label:"State",value:"State",default:""},{label:"Zip",value:"Zip",default:""},{label:"Country",value:"Country",default:""},{label:"Teudat Zehut",value:"TeudatZehut",default:""},{label:"Tax Id",value:"TaxId",default:""},{label:"Approver",value:"Approver",default:""}].concat(_toConsumableArray(reportType===ReportTypes.CashReport?[{label:"Debit",value:"Debit",getValue:function getValue(_ref){var Debit=_ref.Debit;return Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["j" /* formatCurrency */])(Debit,null,true);},default:""},{label:"Credit",value:"Credit",getValue:function getValue(_ref2){var Credit=_ref2.Credit;return Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["j" /* formatCurrency */])(Credit,null,true);},default:""},{label:"Book Balance",value:"Balance",getValue:function getValue(_ref3){var Balance=_ref3.Balance;return Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["j" /* formatCurrency */])(Balance,null,true);},default:""}]:[{label:"Amount",value:"TransAmount",getValue:function getValue(_ref4){var TransAmount=_ref4.TransAmount;return reportType===ReportTypes.CheckRegisterReport?Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["j" /* formatCurrency */])(TransAmount,null,true,true):Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["j" /* formatCurrency */])(TransAmount,null,true);},default:"",disabled:reportType===ReportTypes.OutstandingTransactionsReport}]),[{label:"Currency",value:"Currency",default:""},{label:"Status",value:"Status",default:""}],_toConsumableArray(reportType!==ReportTypes.OutsideTransactionsReport&&[{label:"Reference(s)",value:"References",default:""},{label:"Solicitor(s)",value:"Solicitors",default:""},{label:"Rosh Yeshiva(s)",value:"RoshYeshivas",default:""}]));}var initialState={fields:[],groupBy:"",type:ReportTypes.CashReport,error:false,noData:false,downloading:false,submitAttempted:false,excludeVoidedChecks:false};var ReportModal=function(_React$Component){_inherits(ReportModal,_React$Component);function ReportModal(props){_classCallCheck(this,ReportModal);var _this=_possibleConstructorReturn(this,(ReportModal.__proto__||Object.getPrototypeOf(ReportModal)).call(this,props));_this.onChange=function(name,value){_this.setState(_defineProperty({},name,value));};_this.onToggleReportType=function(reportType){var reportTypeKey=Object.keys(ReportTypes).find(function(key){return ReportTypes[key]===reportType;});_this.setState({error:false,fields:DefaultFields[reportTypeKey]?DefaultFields[reportTypeKey]:[],groupBy:"",submitAttempted:false,type:reportType});};_this.onToggleReportFields=function(event){var fieldName=event.target.name;var checked=event.target.checked;var fields=[].concat(_toConsumableArray(_this.state.fields));if(checked){fields.push(fieldName);}else{fields=fields.filter(function(f){return f!==fieldName;});if(_this.state.groupBy===fieldName){_this.setState({groupBy:""});}}if(_this.state.type===ReportTypes.CashReport){//if balance is checked: cannot group results & credit, debit, and date must be checked
if(fieldName==="Balance"&&checked){if(_this.state.groupBy){_this.setState({groupBy:""});}if(fields.indexOf("Credit")<0){fields.push("Credit");}if(fields.indexOf("Debit")<0){fields.push("Debit");}if(fields.indexOf("TransDate")<0){fields.push("TransDate");}}else if((fieldName==="Credit"||fieldName==="Debit"||fieldName==="TransDate")&&!checked){if(fields.indexOf("Balance")>=0){fields=fields.filter(function(f){return f!=="Balance";});}}}_this.setState({fields:fields});};_this.excludeVoidedChecks=function(event){_this.setState({excludeVoidedChecks:event.target.checked});};_this.state=initialState;return _this;}_createClass(ReportModal,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.show&&!this.props.show&&nextProps.reportType){var type=ReportTypes[nextProps.reportType];this.setState({type:type});//default selected fields for reconciliation reports
if(type===ReportTypes.BankReconciliationReport){this.setState({fields:["TransDate","RefNumber","PaidTo","Type","Source","TransAmount","Status"]});}}}},{key:"close",value:function close(){this.setState(initialState);this.props.close();}},{key:"exportData",value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _state,fields,groupBy,type,_props,tableSettings,filterSettings,exportHeaders,reportName,dateNow,reportFields,params,response,records,data,totalAmnt,availBalance,csvPre,csv;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({error:false,noData:false,submitAttempted:true});_state=this.state,fields=_state.fields,groupBy=_state.groupBy,type=_state.type;_props=this.props,tableSettings=_props.tableSettings,filterSettings=_props.filterSettings;if(fields.length){_context.next=5;break;}return _context.abrupt("return");case 5:this.setState({downloading:true});_context.prev=6;exportHeaders=void 0;reportName=void 0;dateNow=""+new Date().toLocaleDateString().replace(/\//g,"_");reportFields=getReportFields(type);params=Object.assign({fields:fields,groupBy:groupBy,includeOpeningBalance:true},type!=ReportTypes.BankReconciliationReport&&type!=ReportTypes.OutstandingTransactionsReport&&{sortBy:tableSettings.sort.by,sortDirection:tableSettings.sort.direction,startDate:filterSettings.startDate,endDate:filterSettings.endDate});_context.t0=type;_context.next=_context.t0===ReportTypes.CashReport?15:_context.t0===ReportTypes.CheckRegisterReport?19:_context.t0===ReportTypes.ClearedCheckReport?23:_context.t0===ReportTypes.OutstandingTransactionsReport?27:_context.t0===ReportTypes.OutsideTransactionsReport?31:_context.t0===ReportTypes.BankReconciliationReport?35:39;break;case 15:params=Object.assign({},params,{statuses:["cleared","outstanding"]});exportHeaders=reportFields.filter(function(field){return fields.indexOf(field.value)>=0;});reportName="cash_"+dateNow;return _context.abrupt("break",42);case 19:params=Object.assign({},params,{sources:["systemCheck","manualCheck","systemWire","manualWire","systemACH"],statuses:this.state.excludeVoidedChecks?["Outstanding","Cleared"]:[]});exportHeaders=reportFields.filter(function(field){return fields.indexOf(field.value)>=0;});reportName="check_register_"+dateNow;return _context.abrupt("break",42);case 23:params=Object.assign({},params,{useClearedDate:true,sources:["systemCheck","manualCheck"],statuses:"cleared"});exportHeaders=reportFields.filter(function(field){return fields.indexOf(field.value)>=0;});reportName="cleared_check_"+dateNow;return _context.abrupt("break",42);case 27:params=Object.assign({},params,{statuses:"outstanding"});exportHeaders=reportFields.filter(function(field){return fields.indexOf(field.value)>=0;});reportName="outstanding_transactions_"+dateNow;return _context.abrupt("break",42);case 31:params=Object.assign({},params,{sources:["manual"]});exportHeaders=reportFields.filter(function(field){return fields.indexOf(field.value)>=0;});reportName="outside_transactions_"+dateNow;return _context.abrupt("break",42);case 35:params=Object.assign({},params,{report:true});exportHeaders=reportFields.filter(function(field){return fields.indexOf(field.value)>=0;});reportName=this.props.reportName||"bank_reconciliation_"+dateNow;return _context.abrupt("break",42);case 39:params={};exportHeaders=[];reportName="report_"+dateNow;case 42:_context.next=44;return this.props.getTransactionsForExport(params);case 44:response=_context.sent;if(response.success){_context.next=47;break;}throw Error("error");case 47:records=type===ReportTypes.BankReconciliationReport?response.data.clearedTransactions:response.data.values;if(!(!records.length&&type!==ReportTypes.BankReconciliationReport)){_context.next=50;break;}throw Error("noData");case 50:exportHeaders=exportHeaders.map(function(_ref6){var getValue=_ref6.getValue,header=_objectWithoutProperties(_ref6,["getValue"]);return Object.assign({},header,{value:getValue||header.value});});if(type){data=void 0;//custom csv 'header fields' for cash report and reconciliation reports
if(type===ReportTypes.BankReconciliationReport){data=[{rowName:"Beginning Balance:",rowValue:response.data.beginningBalance},{rowName:"Ending Balance:",rowValue:response.data.endingBalance},{rowName:"Report Dates:",rowValue:Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["k" /* formatDate */])(response.data.dateFrom)+" - "+Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["k" /* formatDate */])(response.data.dateTo)}];}else if(type===ReportTypes.OutstandingTransactionsReport){totalAmnt=records.reduce(function(total,trans){trans.TransAmount.split(',').map(function(t){return total=total.minus(t);});return total;},new __WEBPACK_IMPORTED_MODULE_8_bignumber_js__["BigNumber"](0));totalAmnt=parseFloat(totalAmnt);availBalance=new __WEBPACK_IMPORTED_MODULE_8_bignumber_js__["BigNumber"](response.data.openingBalance||0).plus(totalAmnt||0).toFixed(2);data=[{rowName:"Report Date:",rowValue:new Date().toLocaleString()},{rowName:"Book Balance:",rowValue:response.data.openingBalance},{rowName:"Total Outstanding Transactions Amount:",rowValue:totalAmnt},{rowName:"Bank Balance:",rowValue:parseFloat(availBalance)}];}else{data=[{rowName:"Report Dates:",rowValue:(filterSettings.startDate||filterSettings.endDate)&&Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["k" /* formatDate */])(filterSettings.startDate+" 00:00:0000")+" - "+Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["k" /* formatDate */])(filterSettings.endDate+" 00:00:0000")},{rowName:"Opening Balance:",rowValue:response.data.openingBalance}];}csvPre=Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["d" /* convertToCSV */])([{label:this.props.fundName,value:"rowName",default:""},{label:" ",value:"rowValue",default:""}],data);csv=csvPre+"\r\n\r\n"+Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["d" /* convertToCSV */])(exportHeaders,records);Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils__["f" /* downloadCSV */])(csv,reportName+".xls");}this.setState({downloading:false},this.close);_context.next=58;break;case 55:_context.prev=55;_context.t1=_context["catch"](6);this.setState(_defineProperty({downloading:false},_context.t1.message||"error",true));case 58:case"end":return _context.stop();}}},_callee,this,[[6,55]]);}));function exportData(){return _ref5.apply(this,arguments);}return exportData;}()},{key:"render",value:function render(){var _this2=this;var _state2=this.state,error=_state2.error,fields=_state2.fields,groupBy=_state2.groupBy,downloading=_state2.downloading,noData=_state2.noData,type=_state2.type,submitAttempted=_state2.submitAttempted;var _props2=this.props,allowGroupedResults=_props2.allowGroupedResults,reportType=_props2.reportType,show=_props2.show;var reportFields=getReportFields(type);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal new-fund-modal xl-modal"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"bordered-modal-header"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",{className:"modal-page-header"},"New ",reportType?ReportTypes[reportType]:"Accounting Report"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon ion-ios-close-empty",onClick:this.close.bind(this)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-section"},!reportType&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_RadioGroup__["a" /* default */],{name:"type",onChange:function onChange(name,value){return _this2.onToggleReportType(value);},options:Object.keys(ReportTypes).slice(0,4).map(function(type){return{key:ReportTypes[type],value:ReportTypes[type]};}),title:"Report Type",value:type}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"mb-16"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"flex"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"input-label "+(submitAttempted&&!fields.length?"error-label":"")},"Report Fields"),submitAttempted&&!fields.length&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"xs-text error-text ml-8"},"* Please select report fields")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row report-fields-grid"},reportFields.map(function(field){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-check-container",key:field.value},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",id:"report-field-"+field.value,className:"custom-check",name:field.value,onChange:_this2.onToggleReportFields,checked:fields.indexOf(field.value)>=0,disabled:field.disabled||false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{htmlFor:"report-field-"+field.value,className:"secondary-text"},field.label));}))),type==ReportTypes.CheckRegisterReport&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{className:"custom-check",type:"checkbox",id:"excludeVoidedChecks",name:"excludeVoidedChecks",onChange:this.excludeVoidedChecks}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{htmlFor:"excludeVoidedChecks"},"Exclude Voided Checks")),allowGroupedResults&&fields.indexOf("Balance")<0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half column-half-left"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{className:"input-label"},"Remove Duplicates Of"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Select__["a" /* default */],{clearable:true,options:reportFields.filter(function(field){return fields.indexOf(field.value)>=0;}).map(function(field){return{key:field.value,value:field.label};}),value:groupBy,name:"groupBy",onChange:function onChange(e){return _this2.onChange(e.target.name,e.target.value);}})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-btns text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-accent",onClick:this.close.bind(this)},"Cancel"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-primary",onClick:this.exportData.bind(this),disabled:downloading},downloading?"Downloading Report":"Download Report"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:error}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:noData,message:"No data was found matching the specified dates.",timeOut:5000})))));}}]);return ReportModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ReportModal);

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TransactionTypeModal=function(_React$Component){_inherits(TransactionTypeModal,_React$Component);function TransactionTypeModal(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,TransactionTypeModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TransactionTypeModal.__proto__||Object.getPrototypeOf(TransactionTypeModal)).call.apply(_ref,[this].concat(args))),_this),_this.state={error:false,submitAttempted:false,value:""},_this.onChange=function(name,value){_this.setState(_defineProperty({},name,value));},_this.onClose=function(){_this.setState({error:false,submitAttempted:false,value:""});_this.props.close();},_this.onSave=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({error:false,submitAttempted:true});if(_this.state.value){_context.next=3;break;}return _context.abrupt("return");case 3:_context.next=5;return _this.props.save(_this.props.transactionType?Object.assign({},_this.props.transactionType,{value:_this.state.value}):_this.state.value);case 5:if(_this.props.success){_this.onClose();}else{_this.setState({error:true});}case 6:case"end":return _context.stop();}}},_callee,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TransactionTypeModal,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.show&&!this.props.show&&nextProps.transactionType){this.setState({value:nextProps.transactionType.value});}}},{key:"render",value:function render(){var _props=this.props,show=_props.show,title=_props.title,transactionType=_props.transactionType;var _state=this.state,error=_state.error,value=_state.value,submitAttempted=_state.submitAttempted;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal new-fund-modal large-modal"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-header"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",{className:"page-header"},transactionType?"Edit":"New"," ",title),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon ion-ios-close-empty",onClick:this.onClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text"}),label:title,name:"value",onChange:this.onChange,required:true,showRequiredError:submitAttempted,value:value})),this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_LoadingSpinner__["a" /* default */],{alignRight:true,height:20}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-btns text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-accent",onClick:this.onClose},"Cancel"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-primary",onClick:this.onSave,disabled:!value||transactionType&&transactionType===value},"Save"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:error})))));}}]);return TransactionTypeModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (TransactionTypeModal);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BankReconciliationStep1__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BankReconiliationStep2__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BankReconciliationModal=function(_NavigationComponent){_inherits(BankReconciliationModal,_NavigationComponent);function BankReconciliationModal(props){var _this2=this;_classCallCheck(this,BankReconciliationModal);var _this=_possibleConstructorReturn(this,(BankReconciliationModal.__proto__||Object.getPrototypeOf(BankReconciliationModal)).call(this,props));_this.getInProgressReport=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(fundId,reportId){var reconciliationReportDetails,_reconciliationReport,pendingAdjustments,dateFrom,dateTo,endingBalance,pendingDeposits,pendingWithdrawals,beginningBalance,reportName,transactionNotes;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.getReconciliationReport(fundId,reportId);case 2:reconciliationReportDetails=_this.props.reconciliationReportDetails;if(reconciliationReportDetails.success){_reconciliationReport=reconciliationReportDetails.data,pendingAdjustments=_reconciliationReport.pendingAdjustments,dateFrom=_reconciliationReport.dateFrom,dateTo=_reconciliationReport.dateTo,endingBalance=_reconciliationReport.endingBalance,pendingDeposits=_reconciliationReport.pendingDeposits,pendingWithdrawals=_reconciliationReport.pendingWithdrawals,beginningBalance=_reconciliationReport.beginningBalance,reportName=_reconciliationReport.reportName;//select pending transactions for calc
pendingDeposits.forEach(function(crdt){return _this.props.selectCredit(crdt);});pendingWithdrawals.forEach(function(pymt){return _this.props.selectPayment(pymt);});//set pending adjustments for calc
_this.props.updateAdjustments(pendingAdjustments);transactionNotes={};[].concat(_toConsumableArray(pendingDeposits),_toConsumableArray(pendingWithdrawals)).forEach(function(_ref2){var transactionId=_ref2.transactionId,reconciliationNote=_ref2.reconciliationNote;if(reconciliationNote){transactionNotes[transactionId]=reconciliationNote;}});_this.setState({isReady:true,report:{dateFrom:dateFrom,dateTo:dateTo,id:reportId,reportName:reportName,statementBalance:endingBalance,beginningBalance:beginningBalance,transactionNotes:transactionNotes},step:2});}case 4:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x,_x2){return _ref.apply(this,arguments);};}();_this.getReportName=function(){var date=new Date();return __WEBPACK_IMPORTED_MODULE_7__lib_constants__["c" /* MonthNames */][date.getMonth()]+" "+date.getFullYear();};_this.onChange=function(name,value){_this.setState({report:Object.assign({},_this.state.report,_defineProperty({},name,value))});};_this.updateReport=function(report){_this.setState({report:report});};_this.continue=function(){_this.setState({step:2});};_this.cancel=function(){_this.setState({report:_this.report,submitAttempted:false,step:1},function(){_this.props.close();_this.props.clearReconciliationDetails();//TODO - why wouldnt we clear details here too?  [testing req]
});};_this.report={dateFrom:"",dateTo:"",reportName:_this.getReportName(),statementBalance:"",beginningBalance:"",transactionNotes:[]};_this.state={isReady:false,report:_this.report,step:1};return _this;}_createClass(BankReconciliationModal,[{key:"componentWillUpdate",value:function componentWillUpdate(nextProps){if(nextProps.show&&!this.props.show){var fundId=nextProps.fund.fundId,reconciliationInProgressReportId=nextProps.reconciliationReports.data.reconciliationInProgressReportId;if(reconciliationInProgressReportId){this.getInProgressReport(fundId,reconciliationInProgressReportId);}else{this.setState({isReady:true,report:Object.assign({},this.state.report,{dateFrom:nextProps.reconciliationReports.data.lastReconciliationEndDate||nextProps.fund.startingDate})});}}}},{key:"render",value:function render(){var _this3=this;var _state=this.state,isReady=_state.isReady,report=_state.report,step=_state.step;var _props=this.props,fund=_props.fund,newReconciliationReport=_props.newReconciliationReport,reconciliationAdjustments=_props.reconciliationAdjustments,reconciliationBalance=_props.reconciliationBalance,reconciliationCredits=_props.reconciliationCredits,reconciliationPayments=_props.reconciliationPayments,reconciliationReportDetails=_props.reconciliationReportDetails,reconciliationReports=_props.reconciliationReports,show=_props.show;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Modal__["a" /* default */],{modalShowing:show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal "+(step===1?"large-modal":"reconcile-modal")},!isReady?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"bordered-modal-header"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",{className:"page-header"},"Reconcile - "+fund.name)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon ion-ios-close-empty",onClick:this.cancel})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_LoadingSpinner__["a" /* default */],null)):reconciliationReportDetails.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_LoadingSpinner__["a" /* default */],null):!!report.id&&!reconciliationReportDetails.success?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"error-text"},"Sorry, something went wrong and we could not load your reconciliation report. Please try again."):step===1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__BankReconciliationStep1__["a" /* default */],{report:report,fundName:fund.name,onChange:this.onChange,"continue":this.continue,cancel:this.cancel,isIsraeli:fund.department===__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["g" /* Departments */].IL,wasPreviouslyReconciled:!!reconciliationReports.data.lastReconciliationEndDate}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__BankReconiliationStep2__["a" /* default */],Object.assign({},newReconciliationReport,{cancel:this.cancel,onChange:this.onChange,updateReport:this.updateReport,createReconciliationReport:this.props.createReconciliationReport,createAndCompleteReconciliationReport:this.props.createAndCompleteReconciliationReport,updateReconciliationReport:this.props.updateReconciliationReport,completeReconciliationReport:this.props.completeReconciliationReport,clearReconciliationDetails:this.props.clearReconciliationDetails,reconciliationBalance:reconciliationBalance,report:report,isIsraeli:fund.department===__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["g" /* Departments */].IL,fundId:fund.fundId,fundName:fund.name,selectPayment:this.props.selectPayment,reconciliationPayments:reconciliationPayments,getPayments:function getPayments(){var _props2;for(var _len=arguments.length,passProps=Array(_len),_key=0;_key<_len;_key++){passProps[_key]=arguments[_key];}return(_props2=_this3.props).getPayments.apply(_props2,[report.dateFrom,report.dateTo].concat(passProps));},selectCredit:this.props.selectCredit,reconciliationCredits:reconciliationCredits,getCredits:function getCredits(){var _props3;for(var _len2=arguments.length,passProps=Array(_len2),_key2=0;_key2<_len2;_key2++){passProps[_key2]=arguments[_key2];}return(_props3=_this3.props).getCredits.apply(_props3,[report.dateFrom,report.dateTo].concat(passProps));},reconciliationAdjustments:reconciliationAdjustments,updateAdjustments:this.props.updateAdjustments})))));}}]);return BankReconciliationModal;}(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (BankReconciliationModal);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_CurrencyFormatInput__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BankReconciliationStep1=function(_React$Component){_inherits(BankReconciliationStep1,_React$Component);function BankReconciliationStep1(props){_classCallCheck(this,BankReconciliationStep1);var _this=_possibleConstructorReturn(this,(BankReconciliationStep1.__proto__||Object.getPrototypeOf(BankReconciliationStep1)).call(this,props));_this.state={submitAttempted:false};return _this;}_createClass(BankReconciliationStep1,[{key:"continue",value:function _continue(){if(!this.state.submitAttempted)this.setState({submitAttempted:true});var report=this.props.report;if(report.reportName&&report.dateTo&&report.statementBalance){this.props.continue();}}},{key:"render",value:function render(){var _props=this.props,report=_props.report,isIsraeli=_props.isIsraeli,_onChange=_props.onChange,wasPreviouslyReconciled=_props.wasPreviouslyReconciled;var submitAttempted=this.state.submitAttempted;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bordered-modal-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"page-header"},"Reconcile - "+this.props.fundName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon ion-ios-close-empty",onClick:this.props.cancel})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text"}),required:true,showRequiredError:submitAttempted,value:report.reportName,onChange:function onChange(name,value){return _onChange(name,Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils__["C" /* toTitleCase */])(value));},name:"reportName",label:"Report Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{className:"input-label"},wasPreviouslyReconciled?"Date of Last Reconciliation":"Fund Start Date"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"mt-16"},Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils__["k" /* formatDate */])(report.dateFrom))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date",min:Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils__["l" /* formatDateForInput */])(report.dateFrom),max:"9999-12-31"}),value:Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils__["l" /* formatDateForInput */])(report.dateTo),name:"dateTo",onChange:_onChange,required:true,showRequiredError:submitAttempted,label:"To - Enter Bank Statement Date"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_CurrencyFormatInput__["a" /* default */],{allowNegative:true,allowZero:true,isIsraeli:isIsraeli}),label:"Bank Statement Balance",name:"statementBalance",onChange:_onChange,required:true,showRequiredError:submitAttempted,value:report.statementBalance,zeroAsValue:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-btns text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"btn btn-accent",onClick:this.props.cancel},"Cancel"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"btn btn-primary",onClick:this.continue.bind(this)},"Continue")));}}]);return BankReconciliationStep1;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BankReconciliationStep1);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReconciliationCreditsTable__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ReconciliationPaymentsTable__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReconciliationAdjustmentsList__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ReconciliationAdjustmentModal__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EditReconciliationInfoModal__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EditReconciliationBankBalanceModal__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_shared_ConfirmationModal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fundsCommon_OutsideTransactionModal__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TransactionNoteModal__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_bignumber_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_bignumber_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_bignumber_js__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BankReconciliationStep2=function(_NavigationComponent){_inherits(BankReconciliationStep2,_NavigationComponent);function BankReconciliationStep2(props){_classCallCheck(this,BankReconciliationStep2);var _this=_possibleConstructorReturn(this,(BankReconciliationStep2.__proto__||Object.getPrototypeOf(BankReconciliationStep2)).call(this,props));_this.reloadTables=function(type){var isCreditsTable=type===__WEBPACK_IMPORTED_MODULE_15__lib_constants__["m" /* TransactionTypes */].Deposit;var getData=isCreditsTable?_this.props.getCredits:_this.props.getPayments;var _ref=isCreditsTable?_this.props.reconciliationCredits:_this.props.reconciliationPayments,results=_ref.results,sort=_ref.sort;getData(true,1,results,sort);};_this.getClearedTransactionsWithNotes=function(){var clearedTransactions={};[].concat(_toConsumableArray(_this.props.reconciliationPayments.selected.map(function(trans){return trans.transactionId;})),_toConsumableArray(_this.props.reconciliationCredits.selected.map(function(trans){return trans.transactionId;}))).forEach(function(transactionId){clearedTransactions[transactionId]=_this.props.report.transactionNotes[transactionId]||null;});return clearedTransactions;};_this.state={error:false,showModals:{confirmCancellationModal:false,newAdjustmentModal:false,newOutsideTrans:false,transactionNoteModal:false,reconciliationInfo:false,reconciliationBankBalance:false},transactionIdForNote:null};return _this;}_createClass(BankReconciliationStep2,[{key:"cancel",value:function cancel(){this.props.clearReconciliationDetails();this.props.cancel();}},{key:"update",value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(report){var invalidSelectedPayments,invalidSelectedCredits;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(report.dateTo!==this.props.report.dateTo)){_context.next=16;break;}report.dateTo=Object(__WEBPACK_IMPORTED_MODULE_14__lib_utils__["k" /* formatDate */])(report.dateTo+" 00:00:0000");invalidSelectedPayments=this.props.reconciliationPayments.selected.some(function(r){return new Date(r.date)>new Date(report.dateTo);});invalidSelectedCredits=this.props.reconciliationCredits.selected.some(function(r){return new Date(r.date)>new Date(report.dateTo);});if(!(invalidSelectedPayments||invalidSelectedCredits)){_context.next=9;break;}this.setState({invalidReportDate:true});return _context.abrupt("return");case 9:this.setState({invalidReportDate:false});_context.next=12;return this.props.updateReport(report);case 12:this.props.getPayments();this.props.getCredits();case 14:_context.next=17;break;case 16:this.props.updateReport(report);case 17:this.setState({showModals:Object.assign({},this.state.showModals,{reconciliationInfo:false,reconciliationBankBalance:false})});case 18:case"end":return _context.stop();}}},_callee,this);}));function update(_x){return _ref2.apply(this,arguments);}return update;}()},{key:"save",value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(closeOnSave){var recId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:this.setState({error:false});recId=this.props.report.id||this.props.newReconciliationReportId;if(!recId){_context2.next=7;break;}_context2.next=5;return this.props.updateReconciliationReport(this.props.fundId,recId,this.getClearedTransactionsWithNotes(),this.props.reconciliationAdjustments,this.props.report,closeOnSave);case 5:_context2.next=9;break;case 7:_context2.next=9;return this.props.createReconciliationReport(this.props.fundId,Object.assign({},this.props.report,{inProgress:true,clearedTransactions:this.getClearedTransactionsWithNotes(),adjustments:this.props.reconciliationAdjustments}),closeOnSave);case 9:if(!this.props.success){this.setState({error:true});}else{if(closeOnSave){this.cancel();}}case 10:case"end":return _context2.stop();}}},_callee2,this);}));function save(_x2){return _ref3.apply(this,arguments);}return save;}()},{key:"reconcile",value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var recId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:this.setState({error:false});recId=this.props.report.id||this.props.newReconciliationReportId;if(!recId){_context3.next=7;break;}_context3.next=5;return this.props.completeReconciliationReport(this.props.fundId,recId,this.getClearedTransactionsWithNotes(),this.props.reconciliationAdjustments,this.props.report);case 5:_context3.next=9;break;case 7:_context3.next=9;return this.props.createAndCompleteReconciliationReport(this.props.fundId,Object.assign({},this.props.report,{inProgress:false,clearedTransactions:this.getClearedTransactionsWithNotes(),adjustments:this.props.reconciliationAdjustments}));case 9:if(!this.props.success){this.setState({error:true});}else{this.cancel();}case 10:case"end":return _context3.stop();}}},_callee3,this);}));function reconcile(){return _ref4.apply(this,arguments);}return reconcile;}()},{key:"render",value:function render(){var _this2=this;var difference=new __WEBPACK_IMPORTED_MODULE_16_bignumber_js__["BigNumber"](this.props.reconciliationBalance||0).minus(this.props.report.statementBalance||0);var enabled=difference.isEqualTo(new __WEBPACK_IMPORTED_MODULE_16_bignumber_js__["BigNumber"](0));difference=difference.toFixed(2);//can't chain this on above line since it calls .toFixed on the statement balance then...
var totalPayments=this.props.reconciliationPayments.selected.reduce(function(total,trans){return total.plus(trans.amount);},new __WEBPACK_IMPORTED_MODULE_16_bignumber_js__["BigNumber"](0));var totalCredits=this.props.reconciliationCredits.selected.reduce(function(total,trans){return total.plus(trans.amount);},new __WEBPACK_IMPORTED_MODULE_16_bignumber_js__["BigNumber"](0));return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"bordered-modal-header"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",{className:"page-header"},"Reconcile - "+this.props.fundName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"small-text"},this.props.report.reportName," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"accent-text"},"From")," ",Object(__WEBPACK_IMPORTED_MODULE_14__lib_utils__["k" /* formatDate */])(this.props.report.dateFrom)," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"accent-text"},"to")," ",Object(__WEBPACK_IMPORTED_MODULE_14__lib_utils__["k" /* formatDate */])(this.props.report.dateTo.length>10?this.props.report.dateTo:new Date(this.props.report.dateTo+" 00:00:0000")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon-pencil primary-hover input",onClick:this.toggleModal.bind(this,"reconciliationInfo"),style:{marginLeft:"10px"}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon ion-ios-close-empty",onClick:this.toggleModal.bind(this,"confirmCancellationModal")})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-row reconcile-modal-tables"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon-credit-card error-text icon-left middle xl-text"}),"Payments"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"table-container modal-table"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ReconciliationPaymentsTable__["a" /* default */],Object.assign({isIsraeli:this.props.isIsraeli,selectPayment:this.props.selectPayment},this.props.reconciliationPayments,{getPayments:this.props.getPayments,transactionNotes:this.props.report.transactionNotes,onClickTransactionNote:function onClickTransactionNote(transactionId){_this2.setState({transactionIdForNote:transactionId},function(){return _this2.toggleModal("transactionNoteModal");});}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ReconciliationAdjustmentsList__["a" /* default */],{adjustments:this.props.reconciliationAdjustments,isIsraeli:this.props.isIsraeli,type:__WEBPACK_IMPORTED_MODULE_15__lib_constants__["m" /* TransactionTypes */].Withdrawal,updateAdjustments:this.props.updateAdjustments}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"medium-text"},"Total:"," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"bold-text"},Object(__WEBPACK_IMPORTED_MODULE_14__lib_utils__["j" /* formatCurrency */])(totalPayments,this.props.isIsraeli)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon-credit-card approved-text icon-left middle xl-text"}),"Credits"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"table-container modal-table"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ReconciliationCreditsTable__["a" /* default */],Object.assign({isIsraeli:this.props.isIsraeli,selectCredit:this.props.selectCredit},this.props.reconciliationCredits,{getCredits:this.props.getCredits,transactionNotes:this.props.report.transactionNotes,onClickTransactionNote:function onClickTransactionNote(transactionId){_this2.setState({transactionIdForNote:transactionId},function(){return _this2.toggleModal("transactionNoteModal");});}})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ReconciliationAdjustmentsList__["a" /* default */],{adjustments:this.props.reconciliationAdjustments,isIsraeli:this.props.isIsraeli,type:__WEBPACK_IMPORTED_MODULE_15__lib_constants__["m" /* TransactionTypes */].Deposit,updateAdjustments:this.props.updateAdjustments}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"medium-text"},"Total:"," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"bold-text"},Object(__WEBPACK_IMPORTED_MODULE_14__lib_utils__["j" /* formatCurrency */])(totalCredits,this.props.isIsraeli)))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"text-right balances"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"medium-text"},"Beginning Balance:"," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"bold-text"},Object(__WEBPACK_IMPORTED_MODULE_14__lib_utils__["j" /* formatCurrency */])(this.props.report.beginningBalance,this.props.isIsraeli))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"medium-text"},"Current Reconciliation Ending Balance:"," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"bold-text"},Object(__WEBPACK_IMPORTED_MODULE_14__lib_utils__["j" /* formatCurrency */])(this.props.reconciliationBalance,this.props.isIsraeli))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"medium-text"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"icon-pencil primary-hover input",onClick:this.toggleModal.bind(this,"reconciliationBankBalance"),style:{marginRight:"10px"}}),"Bank Statement Balance:"," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"bold-text"},Object(__WEBPACK_IMPORTED_MODULE_14__lib_utils__["j" /* formatCurrency */])(this.props.report.statementBalance,this.props.isIsraeli))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:"medium-text error-text"},"Difference:"," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"bold-text"},Object(__WEBPACK_IMPORTED_MODULE_14__lib_utils__["j" /* formatCurrency */])(difference,this.props.isIsraeli)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-footer flex-justify"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-btns-left"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-accent2",onClick:this.toggleModal.bind(this,"newOutsideTrans")},"Add Transaction"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-accent2 ml-8",onClick:this.toggleModal.bind(this,"newAdjustmentModal")},"Add Reconciliation Adjustment")),this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonComponents_util_LoadingSpinner__["a" /* default */],{height:20,alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"modal-btns text-right"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-accent",onClick:this.toggleModal.bind(this,"confirmCancellationModal")},"Cancel"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-primary",onClick:function onClick(){return _this2.save(false);}},"Save"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-primary",onClick:function onClick(){return _this2.save(true);}},"Save & Close"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{className:"btn btn-primary",disabled:!enabled,onClick:this.reconcile.bind(this)},"Reconcile"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error}))),this.state.showModals.reconciliationInfo&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__EditReconciliationInfoModal__["a" /* default */],{report:this.props.report,invalidReportDate:this.state.invalidReportDate,"continue":this.update.bind(this),close:this.toggleModal.bind(this,"reconciliationInfo")}),this.state.showModals.reconciliationBankBalance&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__EditReconciliationBankBalanceModal__["a" /* default */],{report:this.props.report,isIsraeli:this.props.isIsraeli,"continue":this.update.bind(this),close:this.toggleModal.bind(this,"reconciliationBankBalance")}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__fundsCommon_OutsideTransactionModal__["a" /* default */],{isIsraeli:this.props.isIsraeli,fundId:this.props.fundId,onSuccess:this.reloadTables.bind(this),onUpdateTransactionType:function onUpdateTransactionType(){},show:this.state.showModals.newOutsideTrans,close:this.toggleModal.bind(this,"newOutsideTrans")}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TransactionNoteModal__["a" /* default */],{close:function close(){_this2.toggleModal("transactionNoteModal");_this2.setState({transactionIdForNote:null});},save:function save(text){var transactionNotes=Object.assign({},_this2.props.report.transactionNotes);transactionNotes[_this2.state.transactionIdForNote]=text||null;_this2.props.onChange("transactionNotes",transactionNotes);},show:this.state.showModals.transactionNoteModal,text:this.props.report.transactionNotes[this.state.transactionIdForNote]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ReconciliationAdjustmentModal__["a" /* default */],{close:function close(){return _this2.toggleModal("newAdjustmentModal");},isIsraeli:this.props.isIsraeli,show:this.state.showModals.newAdjustmentModal,submit:function submit(adjustment){_this2.props.updateAdjustments([].concat(_toConsumableArray(_this2.props.reconciliationAdjustments),[adjustment]));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_shared_ConfirmationModal__["a" /* default */],{close:this.toggleModal.bind(this,"confirmCancellationModal"),closeOnConfirm:false,confirm:function confirm(){return _this2.cancel();},message:"Are you sure you want to cancel this reconciliation?  You will lose your progress.",show:this.state.showModals.confirmCancellationModal,success:true,title:"Cancel Reconciliation"}));}}]);return BankReconciliationStep2;}(__WEBPACK_IMPORTED_MODULE_11__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (BankReconciliationStep2);

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_InfiniteScrollList__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReconciliationCreditsTable=function(_React$Component){_inherits(ReconciliationCreditsTable,_React$Component);function ReconciliationCreditsTable(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,ReconciliationCreditsTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ReconciliationCreditsTable.__proto__||Object.getPrototypeOf(ReconciliationCreditsTable)).call.apply(_ref,[this].concat(args))),_this),_this.getCreditsPaginated=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(page,sort){var reset=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:return _context.abrupt("return",_this.props.getCredits(reset,page,_this.props.results,sort));case 1:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x2,_x3){return _ref2.apply(this,arguments);};}(),_this.getTableRow=function(transaction){var selected=_this.props.selected.map(function(trans){return trans.transactionId;}).indexOf(transaction.transactionId)>=0;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"table-row",key:transaction.transactionId},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-check-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",id:"credit-"+transaction.transactionId,onChange:_this.props.selectCredit.bind(null,transaction),className:"custom-check",checked:selected}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{htmlFor:"credit-"+transaction.transactionId,className:"secondary-text"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"data-label":"Check"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,transaction.referenceNumber)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"data-label":"Date"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils__["k" /* formatDate */])(transaction.date))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"data-label":"Description"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,transaction.details)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"data-label":"Type"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,transaction.type)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"data-label":"Amount"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils__["j" /* formatCurrency */])(transaction.amount,_this.props.isIsraeli))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"data-label":"Note"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"material-icons "+(!selected?"disabled":""),onClick:function onClick(){if(selected){_this.props.onClickTransactionNote(transaction.transactionId);}}},_this.props.transactionNotes[transaction.transactionId]?"note":"note_add")));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ReconciliationCreditsTable,[{key:"render",value:function render(){var _props=this.props,_props$data=_props.data,records=_props$data.records,totalCount=_props$data.totalCount,hasMore=_props.hasMore,loading=_props.loading,page=_props.page,results=_props.results,sort=_props.sort,success=_props.success;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_InfiniteScrollList__["a" /* default */],{name:"reconciliation credits",page:page,totalCount:totalCount,resultsView:results,sort:sort,loading:loading,success:success,renderRecord:this.getTableRow,columns:[{id:null},{title:"Check Number",sortable:true,id:"name"},{title:"Date",sortable:true,id:"date",defaultDirection:"Ascending"},{title:"Description",sortable:true,id:"description"},{title:"Type",sortable:true,id:"type"},{title:"Amount",sortable:true,id:"amount"},{title:"Note",sortable:false,id:"note"}],records:records||[],hasMore:hasMore,showFooter:false,getRecords:this.getCreditsPaginated,hideScrollToTopButton:true});}}]);return ReconciliationCreditsTable;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ReconciliationCreditsTable);

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_InfiniteScrollList__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReconciliationPaymentsTable=function(_React$Component){_inherits(ReconciliationPaymentsTable,_React$Component);function ReconciliationPaymentsTable(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,ReconciliationPaymentsTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ReconciliationPaymentsTable.__proto__||Object.getPrototypeOf(ReconciliationPaymentsTable)).call.apply(_ref,[this].concat(args))),_this),_this.state={localSort:null},_this._isPrefetching=false,_this.prefetchMorePages=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var maxExtraPages=arguments.length>0&&arguments[0]!==undefined?arguments[0]:5;var nextPage,i;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!_this._isPrefetching){_context.next=2;break;}return _context.abrupt("return");case 2:_this._isPrefetching=true;_context.prev=3;nextPage=(_this.props.page||1)+1;i=0;case 6:if(!(i<maxExtraPages)){_context.next=13;break;}_context.next=9;return _this.props.getPayments(false,nextPage,_this.props.results,_this.props.sort);case 9:nextPage+=1;case 10:i++;_context.next=6;break;case 13:_context.prev=13;_this._isPrefetching=false;return _context.finish(13);case 16:case"end":return _context.stop();}}},_callee,_this2,[[3,,13,16]]);})),_this.getPaymentsPaginated=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(page,sort){var reset=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!(sort&&sort.by==="selected")){_context2.next=6;break;}if(!_this.state.localSort||_this.state.localSort.direction!==sort.direction){_this.setState({localSort:sort});}if(!reset){_context2.next=5;break;}// Start a small background prefetch so selected rows not yet loaded can appear
setTimeout(function(){return _this.prefetchMorePages();},0);return _context2.abrupt("return");case 5:return _context2.abrupt("return",_this.props.getPayments(false,page,_this.props.results,_this.props.sort));case 6:if(_this.state.localSort)_this.setState({localSort:null});return _context2.abrupt("return",_this.props.getPayments(reset,page,_this.props.results,sort));case 8:case"end":return _context2.stop();}}},_callee2,_this2);}));return function(_x3,_x4){return _ref3.apply(this,arguments);};}(),_this.getTableRow=function(transaction){var selected=(_this.props.selected||[]).some(function(trans){return trans.transactionId===transaction.transactionId;});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr",{className:"table-row",key:transaction.transactionId},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"custom-check-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"checkbox",id:"payment-"+transaction.transactionId,className:"custom-check",onChange:_this.props.selectPayment.bind(null,transaction),checked:selected}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label",{htmlFor:"payment-"+transaction.transactionId,className:"secondary-text"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"data-label":"Check Number"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,transaction.referenceNumber)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"data-label":"Date"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils__["k" /* formatDate */])(transaction.date))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"data-label":"Payee"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,transaction.details)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"data-label":"Amount"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils__["j" /* formatCurrency */])(transaction.amount,_this.props.isIsraeli))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("td",{"data-label":"Note"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i",{className:"material-icons "+(!selected?"disabled":""),onClick:function onClick(){if(selected){_this.props.onClickTransactionNote(transaction.transactionId);}}},_this.props.transactionNotes[transaction.transactionId]?"note":"note_add")));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ReconciliationPaymentsTable,[{key:"render",value:function render(){var _props=this.props,_props$data=_props.data,records=_props$data.records,totalCount=_props$data.totalCount,hasMore=_props.hasMore,loading=_props.loading,page=_props.page,results=_props.results,sort=_props.sort,success=_props.success;var effectiveSort=this.state.localSort||sort;var baseRecords=Array.isArray(records)?records:[];var selectedList=Array.isArray(this.props.selected)?this.props.selected:[];var selectedIds=new Set(selectedList.map(function(trans){return trans.transactionId;}));var displayRecords=baseRecords;if(effectiveSort&&effectiveSort.by==="selected"){var selectedFromBase=baseRecords.filter(function(r){return selectedIds.has(r.transactionId);});var unselectedFromBase=baseRecords.filter(function(r){return!selectedIds.has(r.transactionId);});var selectedNotInBase=selectedList.filter(function(s){return!baseRecords.some(function(r){return r.transactionId===s.transactionId;});});// De-duplicate selected: prefer base version when available
var selectedCombinedMap=new Map();selectedFromBase.forEach(function(r){return selectedCombinedMap.set(r.transactionId,r);});selectedNotInBase.forEach(function(s){if(!selectedCombinedMap.has(s.transactionId))selectedCombinedMap.set(s.transactionId,s);});var selectedCombined=Array.from(selectedCombinedMap.values());displayRecords=effectiveSort.direction==="Descending"?[].concat(_toConsumableArray(selectedCombined),_toConsumableArray(unselectedFromBase)):[].concat(_toConsumableArray(unselectedFromBase),_toConsumableArray(selectedCombined));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_InfiniteScrollList__["a" /* default */],{name:"reconciliation payments",page:page,totalCount:totalCount,resultsView:results,sort:effectiveSort,loading:loading,success:success,renderRecord:this.getTableRow,columns:[{title:"Cleared",sortable:true,id:"selected",defaultDirection:"Descending"},{title:"Check Number",sortable:true,id:"reference"},{title:"Date",sortable:true,id:"date",defaultDirection:"Ascending"},{title:"Payee",sortable:true,id:"details"},{title:"Amount",sortable:true,id:"amount"},{title:"Note",sortable:false,id:"note"}],records:displayRecords,hasMore:hasMore,showFooter:false,getRecords:this.getPaymentsPaginated,hideScrollToTopButton:true});}}]);return ReconciliationPaymentsTable;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ReconciliationPaymentsTable);

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReconciliationAdjustmentModal__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReconciliationAdjustmentsList=function(_NavigationComponent){_inherits(ReconciliationAdjustmentsList,_NavigationComponent);function ReconciliationAdjustmentsList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ReconciliationAdjustmentsList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ReconciliationAdjustmentsList.__proto__||Object.getPrototypeOf(ReconciliationAdjustmentsList)).call.apply(_ref,[this].concat(args))),_this),_this.state={editAdjustmentIndex:null,showModals:{editAdjustmentModal:false}},_this.onEditAdjustment=function(adjustment){var _this$props=_this.props,adjustments=_this$props.adjustments,updateAdjustments=_this$props.updateAdjustments;var editedAdjustments=[].concat(_toConsumableArray(adjustments));editedAdjustments[_this.state.editAdjustmentIndex]=adjustment;updateAdjustments(editedAdjustments);_this.setState({editAdjustmentIndex:null});},_this.onDeleteAdjustment=function(adjustmentIndex){var _this$props2=_this.props,adjustments=_this$props2.adjustments,updateAdjustments=_this$props2.updateAdjustments;updateAdjustments(adjustments.filter(function(adj,index){return index!==adjustmentIndex;}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ReconciliationAdjustmentsList,[{key:"render",value:function render(){var _this2=this;var _props=this.props,adjustments=_props.adjustments,isIsraeli=_props.isIsraeli,type=_props.type;var _state=this.state,editAdjustmentIndex=_state.editAdjustmentIndex,showModals=_state.showModals;return adjustments.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mb-16"},adjustments.map(function(adjustment,index){return{adjustment:adjustment,adjustmentIndex:index};}).filter(function(_ref2){var adjustment=_ref2.adjustment;return adjustment.transactionType===type;}).map(function(_ref3){var adjustment=_ref3.adjustment,adjustmentIndex=_ref3.adjustmentIndex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"flex flex-justify mb-8 mr-8 medium-text",key:adjustmentIndex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,adjustment.description||""," (Reconciliation Adjustment):"," ",Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils__["j" /* formatCurrency */])(adjustment.amount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"flex flex-justify"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon-pencil primary-hover input mr-8",onClick:function onClick(){_this2.setState({editAdjustmentIndex:adjustmentIndex},function(){return _this2.toggleModal("editAdjustmentModal");});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon-trash trash-hover input",onClick:function onClick(){return _this2.onDeleteAdjustment(adjustmentIndex);}})));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ReconciliationAdjustmentModal__["a" /* default */],{adjustment:adjustments[editAdjustmentIndex],close:function close(){return _this2.toggleModal("editAdjustmentModal");},isIsraeli:isIsraeli,show:showModals.editAdjustmentModal,submit:this.onEditAdjustment})):null;}}]);return ReconciliationAdjustmentsList;}(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ReconciliationAdjustmentsList);

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditReconciliationInfoModal=function(_React$Component){_inherits(EditReconciliationInfoModal,_React$Component);function EditReconciliationInfoModal(props){_classCallCheck(this,EditReconciliationInfoModal);var _this=_possibleConstructorReturn(this,(EditReconciliationInfoModal.__proto__||Object.getPrototypeOf(EditReconciliationInfoModal)).call(this,props));_this.onChange=function(name,value){_this.setState({report:Object.assign({},_this.state.report,_defineProperty({},name,value))});};_this.state={submitAttempted:false,report:props.report||{}};return _this;}_createClass(EditReconciliationInfoModal,[{key:"continue",value:function _continue(){if(!this.state.submitAttempted)this.setState({submitAttempted:true});var report=this.state.report;if(report.reportName&&report.dateTo){this.props.continue(report);}}},{key:"render",value:function render(){var _this2=this;// const { show } = this.props;
var _state=this.state,submitAttempted=_state.submitAttempted,report=_state.report;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal new-transaction-modal large-modal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bordered-modal-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"page-header"},"Edit Report Name and Date")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon ion-ios-close-empty",onClick:this.props.close})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text"}),required:true,showRequiredError:submitAttempted,value:report.reportName,onChange:function onChange(name,value){return _this2.onChange(name,Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils__["C" /* toTitleCase */])(value));},name:"reportName",label:"Report Name"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column-half"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"date",min:Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils__["l" /* formatDateForInput */])(report.dateFrom),max:"9999-12-31"}),value:Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils__["l" /* formatDateForInput */])(report.dateTo.length>10?report.dateTo:new Date(report.dateTo+" 00:00:0000")),name:"dateTo",onChange:this.onChange,required:true,showRequiredError:submitAttempted,label:"To - Enter Bank Statement Date"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.props.invalidReportDate,message:'You have selected a date range that excludes a transaction that is marked as reconciled. \n Please uncheck transaction before altering the date range'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-btns text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"btn btn-accent",onClick:this.props.close},"Cancel"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"btn btn-primary",onClick:this.continue.bind(this)},"Continue")))));}}]);return EditReconciliationInfoModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (EditReconciliationInfoModal);

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_CurrencyFormatInput__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Modal__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditReconciliationBankBalanceModal=function(_React$Component){_inherits(EditReconciliationBankBalanceModal,_React$Component);function EditReconciliationBankBalanceModal(props){_classCallCheck(this,EditReconciliationBankBalanceModal);var _this=_possibleConstructorReturn(this,(EditReconciliationBankBalanceModal.__proto__||Object.getPrototypeOf(EditReconciliationBankBalanceModal)).call(this,props));_this.onChange=function(name,value){_this.setState({report:Object.assign({},_this.state.report,_defineProperty({},name,value))});};_this.state={submitAttempted:false,report:props.report||{}};return _this;}_createClass(EditReconciliationBankBalanceModal,[{key:"continue",value:function _continue(){if(!this.state.submitAttempted)this.setState({submitAttempted:true});var report=this.state.report;if(report.statementBalance){this.props.continue(report);}}},{key:"render",value:function render(){var isIsraeli=this.props.isIsraeli;var _state=this.state,submitAttempted=_state.submitAttempted,report=_state.report;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Modal__["a" /* default */],{modalShowing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal new-transaction-modal large-modal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bordered-modal-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"page-header"},"Edit Bank Balance")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon ion-ios-close-empty",onClick:this.props.close})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_CurrencyFormatInput__["a" /* default */],{allowNegative:true,allowZero:true,isIsraeli:isIsraeli}),label:"Bank Statement Balance",name:"statementBalance",onChange:this.onChange,required:true,showRequiredError:submitAttempted,value:report.statementBalance,zeroAsValue:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-btns text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"btn btn-accent",onClick:this.props.close},"Cancel"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"btn btn-primary",onClick:this.continue.bind(this)},"Continue")))));}}]);return EditReconciliationBankBalanceModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (EditReconciliationBankBalanceModal);

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DateRangePicker=function(_React$Component){_inherits(DateRangePicker,_React$Component);function DateRangePicker(){_classCallCheck(this,DateRangePicker);return _possibleConstructorReturn(this,(DateRangePicker.__proto__||Object.getPrototypeOf(DateRangePicker)).apply(this,arguments));}_createClass(DateRangePicker,[{key:'onChange',value:function onChange(event){this.props.update(event.target.name,event.target.value);}},{key:'render',value:function render(){var _props=this.props,startDate=_props.startDate,endDate=_props.endDate;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-center transaction-date-range'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'medium-text'},'Date Range'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',name:'startDate',value:Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["l" /* formatDateForInput */])(startDate),max:endDate,onChange:this.onChange.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'medium-text'},'To'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',name:'endDate',value:Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["l" /* formatDateForInput */])(endDate),min:startDate,onChange:this.onChange.bind(this)}));}}]);return DateRangePicker;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (DateRangePicker);

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_UsersActions__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SettingsMenu__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UsersTable__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UserSettingsModal__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserSettingsPage=function(_NavigationComponent){_inherits(UserSettingsPage,_NavigationComponent);function UserSettingsPage(props){_classCallCheck(this,UserSettingsPage);var _this=_possibleConstructorReturn(this,(UserSettingsPage.__proto__||Object.getPrototypeOf(UserSettingsPage)).call(this,props));_this.state={showModals:{userDetailsModal:false},editUserId:''};return _this;}_createClass(UserSettingsPage,[{key:'viewUserDetails',value:function viewUserDetails(userId){this.setState({editUserId:userId},this.toggleModal.bind(this,'userDetailsModal'));}},{key:'reloadUsers',value:function reloadUsers(){this.props.actions.getUsers(this.props.usersTable.page,this.props.usersTable.resultsView,this.props.usersTable.sort);}},{key:'toggleUserActive',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(userId,active,replacementApproverId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.actions.updateUserDetail(userId,{active:active},replacementApproverId);case 2:case'end':return _context.stop();}}},_callee,this);}));function toggleUserActive(_x,_x2,_x3){return _ref.apply(this,arguments);}return toggleUserActive;}()},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'subheader'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container flex-justify flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SettingsMenu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-small btn-primary icon-left',onClick:this.toggleModal.bind(this,"userDetailsModal")},'New User'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__UsersTable__["a" /* default */],Object.assign({},this.props.usersTable,{updateTable:this.props.actions.updateTable,getUsers:this.props.actions.getUsers,viewUserDetails:this.viewUserDetails.bind(this),toggleUserActive:this.toggleUserActive.bind(this),updatingActive:this.props.updateUserDetail,approvers:this.props.approvers.data})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__UserSettingsModal__["a" /* default */],{show:this.state.showModals.userDetailsModal,close:function close(){if(_this2.state.editUserId){_this2.setState({editUserId:''});}_this2.props.actions.clearUserDetailsAndPermissions();_this2.toggleModal("userDetailsModal");},editUserId:this.state.editUserId,getUserDetails:this.props.actions.getUserDetails,getUserPermissions:this.props.actions.getUserPermissions,userDetails:this.props.userDetails,userPermissions:this.props.userPermissions,approvers:this.props.approvers.data,departments:this.props.departments,roles:this.props.roles,permissionTypes:this.props.permissionTypes,israelFunds:this.props.israelFunds,usFunds:this.props.usFunds,allowAllFundsAccess:this.props.thisUserProfile.departments.length===this.props.departments.length&&this.props.thisUserPermissions.indexOf(__WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__["j" /* PermissionTypes */].AllFundsAccess)>=0,getPermissionsForRole:this.props.actions.getPermissionsForRole,permissionsForRole:this.props.permissionsForRole,createUser:this.props.actions.createUser,updateUser:this.props.actions.updateUser,creatingUser:this.props.createUser,updatingUser:this.props.updateUser,reloadUsers:this.reloadUsers.bind(this)}));}}]);return UserSettingsPage;}(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_NavigationComponent__["a" /* default */]);function mapStateToProps(state,ownProps){return Object.assign({},state.users,{usersTable:state.usersTable,departments:state.settings.systemSettings.data.otherSettings.departments,permissionTypes:state.settings.systemSettings.data.otherSettings.permissionTypes,roles:state.settings.systemSettings.data.otherSettings.roles,israelFunds:state.funds.fundsByDept.IL,usFunds:state.funds.fundsByDept.US,thisUserProfile:state.userProfile.profile.data,thisUserPermissions:state.userProfile.permissions.data});}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_4__redux_actions_UsersActions__,dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(UserSettingsPage));

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_PaginatedTable__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UsersTableRow__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_ConfirmationModal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ApproverReplacementModal__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_apiUtils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UsersTable=function(_NavigationComponent){_inherits(UsersTable,_NavigationComponent);function UsersTable(props){_classCallCheck(this,UsersTable);var _this=_possibleConstructorReturn(this,(UsersTable.__proto__||Object.getPrototypeOf(UsersTable)).call(this,props));_this.initialState={showModals:{confirmationModal:false,approverReplacementModal:false},selectedRecord:{},loadingUserPermissions:false};_this.state=_this.initialState;_this.getTableRow=_this.getTableRow.bind(_this);return _this;}_createClass(UsersTable,[{key:'getTableRow',value:function getTableRow(user){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__UsersTableRow__["a" /* default */],{key:user.userId,user:user,viewUserDetails:this.props.viewUserDetails,toggleActive:this.toggleUserActive.bind(this)});}},{key:'toggleUserActive',value:function toggleUserActive(activate,user){var _this2=this;this.setState({selectedRecord:user},_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var deactivatingApprover,permissions;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:deactivatingApprover=false;if(activate){_context.next=8;break;}_this2.setState({loadingUserPermissions:true});_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_8__lib_apiUtils__["b" /* getRequest */])('/users/'+user.userId+'/permissions',null,{});case 5:permissions=_context.sent;deactivatingApprover=permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsApproveFull)>=0||permissions.data.indexOf(__WEBPACK_IMPORTED_MODULE_9__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsApproveLimited)>=0;_this2.setState({loadingUserPermissions:false});case 8:_this2.toggleModal(deactivatingApprover?"approverReplacementModal":"confirmationModal");case 9:case'end':return _context.stop();}}},_callee,_this2);})));}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.state.loadingUserPermissions&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'spinner-absolute user-settings-spinner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'32'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_PaginatedTable__["a" /* default */],{name:'users',page:this.props.page,totalCount:this.props.data.totalCount,resultsView:this.props.resultsView,sort:this.props.sort,loading:this.props.loading,success:this.props.success,renderRow:this.getTableRow,columns:[{id:'name',title:'Name',sortable:true},{id:'department',title:'Department',sortable:true},{id:'email',title:'Email',sortable:true},{id:'phone',title:'Phone',sortable:true},{id:'role',title:'Role',sortable:true},{id:'active',title:'Active',sortable:false}],records:this.props.data.records||[],sortData:this.props.updateTable,changeDataView:this.props.updateTable,loadData:this.props.getUsers}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ApproverReplacementModal__["a" /* default */],{show:this.state.showModals.approverReplacementModal,close:function close(approverId){if(approverId){_this3.setState({selectedRecord:Object.assign({},_this3.state.selectedRecord,{replacementApproverId:approverId})},_this3.toggleModals.bind(_this3,["approverReplacementModal","confirmationModal"]));}else{_this3.setState({selectedRecord:_this3.initialState.selectedRecord});_this3.toggleModal("approverReplacementModal");}},user:this.state.selectedRecord,approvers:this.props.approvers}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_ConfirmationModal__["a" /* default */],{show:this.state.showModals.confirmationModal,message:this.state.selectedRecord.userId?'Are you sure you want to '+(this.state.selectedRecord.active?"deactivate":"activate")+' '+this.state.selectedRecord.name+'?':'',close:function close(){_this3.setState({selectedRecord:_this3.initialState.selectedRecord});_this3.toggleModal("confirmationModal");},confirm:this.props.toggleUserActive.bind(this,this.state.selectedRecord.userId,!this.state.selectedRecord.active,this.state.selectedRecord.replacementApproverId),loading:this.props.updatingActive.loading,success:this.props.updatingActive.success,errorMessage:this.props.updatingActive.message}));}}]);return UsersTable;}(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (UsersTable);

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_HoverTableRow__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Toggle__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UsersTableRow=function(_React$Component){_inherits(UsersTableRow,_React$Component);function UsersTableRow(){_classCallCheck(this,UsersTableRow);return _possibleConstructorReturn(this,(UsersTableRow.__proto__||Object.getPrototypeOf(UsersTableRow)).apply(this,arguments));}_createClass(UsersTableRow,[{key:'render',value:function render(){var _this2=this;var user=this.props.user;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_HoverTableRow__["a" /* default */],{key:user.userId,onClick:this.props.viewUserDetails.bind(this,user.userId)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'bold-text'},user.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Department'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,user.departments.join(', '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Email'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,user.email)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Phone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,user.phone)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Role'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,user.role)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Active'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Toggle__["a" /* default */],{id:user.userId,name:'active',value:user.active,onChange:function onChange(name,val){return _this2.props.toggleActive(val,user);}})));}}]);return UsersTableRow;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (UsersTableRow);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ApproverReplacementModal__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_util_MultiSelect__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_util_RadioGroup__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_util_ValidatedPhoneInput__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_clonedeep__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_clonedeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_clonedeep__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UsersSettingsModal=function(_NavigationComponent){_inherits(UsersSettingsModal,_NavigationComponent);function UsersSettingsModal(props){_classCallCheck(this,UsersSettingsModal);var _this=_possibleConstructorReturn(this,(UsersSettingsModal.__proto__||Object.getPrototypeOf(UsersSettingsModal)).call(this,props));_this.recipientTypePermissions={Individuals:"IndividualsManage",Institutions:"InstitutionsManage"};_this.onResetPermissions=function(){_this.setState({additionalPermissions:_this.getDefaultAdditionalPermissions()});};_this.getDefaultAdditionalPermissions=function(){var noRole=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var userRole=noRole?null:_this.props.roles.find(function(role){return role.key.toString()===_this.state.userDetails.roleId.toString();});var defaultRecipientTypePermissions=userRole&&userRole.value==="Account Manager"?[_this.recipientTypePermissions.Individuals]:[_this.recipientTypePermissions.Individuals,_this.recipientTypePermissions.Institutions];return[__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["j" /* PermissionTypes */].AllFundsAccess].concat(defaultRecipientTypePermissions);};_this.onToggleRecipientTypePermission=function(permission){var recipientTypePermissions=Object.keys(_this.recipientTypePermissions).map(function(key){return _this.recipientTypePermissions[key];});var additionalPermissions=_this.state.additionalPermissions.filter(function(p){return recipientTypePermissions.indexOf(p)<0;});if(permission==="all"){additionalPermissions.push.apply(additionalPermissions,_toConsumableArray(recipientTypePermissions));}else{additionalPermissions.push(permission);}_this.setState({additionalPermissions:additionalPermissions});};_this.onToggleFundsPermission=function(fundPermission){var additionalPermissions=[].concat(_toConsumableArray(_this.state.additionalPermissions.filter(function(p){return p!==__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["j" /* PermissionTypes */].AllFundsAccess&&p!==__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["j" /* PermissionTypes */].LimitedFundsAccess;})),[fundPermission]);var limitedFunds=fundPermission===__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["j" /* PermissionTypes */].AllFundsAccess?[]:_this.state.userDetails.limitedFunds;_this.setState({additionalPermissions:additionalPermissions,userDetails:Object.assign({},_this.state.userDetails,{limitedFunds:limitedFunds})});};_this.onSelectLimitedFunds=function(selectedFunds,allAccessibleFunds){var limitedFunds=(selectedFunds.map(function(f){return f.value;}).indexOf("all")>=0?allAccessibleFunds:selectedFunds).map(function(f){return f.value;});_this.setState({userDetails:Object.assign({},_this.state.userDetails,{limitedFunds:limitedFunds})});};_this.initialState={userId:'',preEditUserDetails:{},userDetails:{firstName:'',lastName:'',phoneNumber:'',phoneType:__WEBPACK_IMPORTED_MODULE_14__lib_constants__["g" /* PhoneNumberTypes */].American,mobilePhone:'',mobilePhoneType:__WEBPACK_IMPORTED_MODULE_14__lib_constants__["g" /* PhoneNumberTypes */].American,email:'',userName:'',defaultApproverId:'',defaultPrinterId:'',departments:[__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["g" /* Departments */].US],roleId:'',limitedFunds:[]},preEditPermissionsForRole:[],preEditAdditionalPermissions:_this.getDefaultAdditionalPermissions(true),additionalPermissions:_this.getDefaultAdditionalPermissions(true),replacementApproverId:'',submitAttempted:false,invalidData:{},error:false,showModals:{"approverReplacementModal":false}};_this.state=__WEBPACK_IMPORTED_MODULE_15_lodash_clonedeep___default()(_this.initialState);_this.onChange=_this.onChange.bind(_this);_this.onTogglePermission=_this.onTogglePermission.bind(_this);return _this;}_createClass(UsersSettingsModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.editUserId&&nextProps.show&&!this.props.show){this.getUserDetails(nextProps.editUserId);}}},{key:'getUserDetails',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(editUserId){var _this2=this;var _props$userDetails$da,userId,userDetails,additionalPermissions;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Promise.all([this.props.getUserDetails(editUserId),this.props.getUserPermissions(editUserId)]);case 2:_props$userDetails$da=this.props.userDetails.data,userId=_props$userDetails$da.userId,userDetails=_objectWithoutProperties(_props$userDetails$da,['userId']);userDetails.mobilePhoneType=userDetails.departments&&userDetails.departments.includes(__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["g" /* Departments */].US)?__WEBPACK_IMPORTED_MODULE_14__lib_constants__["g" /* PhoneNumberTypes */].American:__WEBPACK_IMPORTED_MODULE_14__lib_constants__["g" /* PhoneNumberTypes */].Other;userDetails.phoneType=userDetails.departments&&userDetails.departments.includes(__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["g" /* Departments */].US)?__WEBPACK_IMPORTED_MODULE_14__lib_constants__["g" /* PhoneNumberTypes */].American:__WEBPACK_IMPORTED_MODULE_14__lib_constants__["g" /* PhoneNumberTypes */].Other;this.setState({userId:userId,preEditUserDetails:Object.assign({},this.state.userDetails,userDetails),userDetails:Object.assign({},this.state.userDetails,userDetails)});if(!userDetails.roleId){_context.next=11;break;}_context.next=9;return this.props.getPermissionsForRole(userDetails.roleId);case 9:additionalPermissions=this.props.userPermissions.data.filter(function(permission){return _this2.props.permissionsForRole.data.indexOf(permission)<0;});this.setState({preEditPermissionsForRole:this.props.userPermissions.data,preEditAdditionalPermissions:additionalPermissions,additionalPermissions:additionalPermissions});case 11:case'end':return _context.stop();}}},_callee,this);}));function getUserDetails(_x2){return _ref.apply(this,arguments);}return getUserDetails;}()},{key:'onChange',value:function onChange(name,value){var _this3=this;if(name==="firstName"||name==="lastName")value=Object(__WEBPACK_IMPORTED_MODULE_12__lib_utils__["C" /* toTitleCase */])(value);this.setState({userDetails:Object.assign({},this.state.userDetails,_defineProperty({},name,value))},function(){if(name==="email"){_this3.setState({userDetails:Object.assign({},_this3.state.userDetails,{userName:value})});}else if(name==="roleId"){_this3.props.getPermissionsForRole(value);_this3.setState({additionalPermissions:_this3.getDefaultAdditionalPermissions()});}else if(name==="departments"&&value.length===1){var updatedDefaultApproverId=_this3.state.userDetails.defaultApproverId;var updatedLimitedFunds=_this3.state.userDetails.limitedFunds;if(_this3.state.userDetails.defaultApproverId){var defaultApprover=_this3.props.approvers[_this3.props.approvers.map(function(a){return a.key.toString();}).indexOf(_this3.state.userDetails.defaultApproverId.toString())];if(defaultApprover&&defaultApprover.departments.indexOf(value[0])<0){updatedDefaultApproverId="";}}if(_this3.state.additionalPermissions.indexOf(__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["j" /* PermissionTypes */].LimitedFundsAccess)>=0&&_this3.state.userDetails.limitedFunds.length){var accessibleFundIds=[].concat(_toConsumableArray(_this3.state.userDetails.departments.indexOf(__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["g" /* Departments */].US)>=0?_this3.props.usFunds:[]),_toConsumableArray(_this3.state.userDetails.departments.indexOf(__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["g" /* Departments */].IL)>=0?_this3.props.israelFunds:[])).map(function(f){return f.key;});updatedLimitedFunds=_this3.state.userDetails.limitedFunds.filter(function(fundId){return accessibleFundIds.indexOf(fundId)>=0;});}_this3.setState({userDetails:Object.assign({},_this3.state.userDetails,{defaultApproverId:updatedDefaultApproverId,limitedFunds:updatedLimitedFunds})});}});}},{key:'onTogglePermission',value:function onTogglePermission(event){this.setState({additionalPermissions:event.target.checked?[].concat(_toConsumableArray(this.state.additionalPermissions),[event.target.name]):this.state.additionalPermissions.filter(function(p){return p!==event.target.name;})});}},{key:'onSave',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(ignoreApprover){var userDetails,isApprover,update;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:this.setState({error:false,submitAttempted:true});userDetails=this.state.userDetails;if(!(this.state.invalidData.phoneNumber||this.state.invalidData.mobilePhone||this.state.invalidData.email||!userDetails.firstName||!userDetails.lastName||!userDetails.phoneNumber||!userDetails.mobilePhone||!userDetails.email||!userDetails.userName||!userDetails.defaultApproverId||!userDetails.departments.length||!userDetails.roleId)){_context2.next=4;break;}return _context2.abrupt('return');case 4:if(!(this.props.editUserId&&!ignoreApprover)){_context2.next=10;break;}isApprover=this.state.preEditPermissionsForRole.indexOf(__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsApproveFull)>=0||this.state.preEditPermissionsForRole.indexOf(__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsApproveLimited)>=0||this.state.preEditAdditionalPermissions.indexOf(__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsApproveFull)>=0||this.state.preEditAdditionalPermissions.indexOf(__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsApproveLimited)>=0;if(!isApprover){_context2.next=10;break;}if(!(this.props.permissionsForRole.data.indexOf(__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsApproveFull)<0&&this.props.permissionsForRole.data.indexOf(__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsApproveLimited)<0&&this.state.additionalPermissions.indexOf(__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsApproveFull)<0&&this.state.additionalPermissions.indexOf(__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["j" /* PermissionTypes */].ApplicationsApproveLimited)<0)){_context2.next=10;break;}this.toggleModal("approverReplacementModal");return _context2.abrupt('return');case 10:update=Object.assign({},this.state.userDetails,{additionalPermissions:this.state.additionalPermissions});if(!this.props.editUserId){_context2.next=16;break;}_context2.next=14;return this.props.updateUser(this.state.userId,update,this.state.replacementApproverId);case 14:_context2.next=18;break;case 16:_context2.next=18;return this.props.createUser(update);case 18:if(this.props.editUserId?this.props.updatingUser.success:this.props.creatingUser.success){this.onClose();this.props.reloadUsers();}else{this.setState({error:true});}case 19:case'end':return _context2.stop();}}},_callee2,this);}));function onSave(_x3){return _ref2.apply(this,arguments);}return onSave;}()},{key:'onClose',value:function onClose(){this.props.close();this.setState(this.initialState);}},{key:'validatePhone',value:function validatePhone(name,value){this.setState({invalidData:Object.assign({},this.state.invalidData,_defineProperty({},name,value))});}},{key:'validateEmail',value:function validateEmail(email){var isValid=Object(__WEBPACK_IMPORTED_MODULE_12__lib_utils__["x" /* isValidEmail */])(email);this.setState({invalidData:Object.assign({},this.state.invalidData,{email:!isValid})});return isValid;}},{key:'render',value:function render(){var _this4=this;var permissionsByCategory={};var permissionCategories=[{key:"Applications",value:"Applications"},{key:"RecipientAccnts",value:"Recipients"},{key:"CampaignAndLists",value:"Campaigns and Lists"},{key:"Payments",value:"Payments"},{key:"Accounting",value:"Accounting"},{key:"Reporting",value:"Reporting"},{key:"UsersAndSettings",value:"Users and Settings"}];permissionCategories.forEach(function(category){permissionsByCategory[category.value]=[];_this4.props.permissionTypes.forEach(function(permission){if(permission.key.indexOf(category.key)===0){var permissionByCateg=Object.assign({},permission,{displayValue:permission.value.replace(category.value+' ','')});permissionsByCategory[category.value].push(permissionByCateg);}});});var accessibleFunds=[].concat(_toConsumableArray(this.state.userDetails.departments.indexOf(__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["g" /* Departments */].US)>=0?this.props.usFunds:[]),_toConsumableArray(this.state.userDetails.departments.indexOf(__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["g" /* Departments */].IL)>=0?this.props.israelFunds:[])).map(function(fund){return{label:fund.value,value:fund.key};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal settings-modal xl-modal'},!this.props.userDetails.loading&&!this.props.userPermissions.loading&&(!this.props.userDetails.success||!this.props.userPermissions.success)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'error-label'},'Something went wrong and we were unable to retrieve user account settings.  Please try again.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bordered-modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'modal-page-header'},this.props.editUserId?'User Account Settings':'New User Account'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.onClose.bind(this)})),this.props.editUserId&&(this.props.userDetails.loading||this.props.userPermissions.loading)?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20'})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.props.editUserId&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'user-name'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icons ion-ios-person-outline accent-text2'}),this.props.userDetails.data.firstName,' ',this.props.userDetails.data.lastName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label section-label'},'Profile Settings'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'First Name',name:'firstName',value:this.state.userDetails.firstName,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'Last Name',name:'lastName',value:this.state.userDetails.lastName,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_util_ValidatedPhoneInput__["a" /* default */],{phoneNumber:this.state.userDetails.phoneNumber||'',phoneType:this.state.userDetails.phoneType||__WEBPACK_IMPORTED_MODULE_14__lib_constants__["g" /* PhoneNumberTypes */].American,phoneNumberName:'phoneNumber',phoneTypeName:'phoneType',onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted,error:this.state.invalidData.phoneNumber,updateError:this.validatePhone.bind(this),errorName:'phoneNumber'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_util_ValidatedPhoneInput__["a" /* default */],{label:'Mobile Phone',phoneNumber:this.state.userDetails.mobilePhone||'',phoneType:this.state.userDetails.mobilePhoneType||__WEBPACK_IMPORTED_MODULE_14__lib_constants__["g" /* PhoneNumberTypes */].American,phoneNumberName:'mobilePhone',phoneTypeName:'mobilePhoneType',onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted,error:this.state.invalidData.mobilePhone,updateError:this.validatePhone.bind(this),errorName:'mobilePhone'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label section-label'},'Account Settings'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'Email',name:'email',value:this.state.userDetails.email,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted,validated:true,showValidationError:true,validate:this.validateEmail.bind(this),errorMessage:'Invalid Email Address'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_util_RadioGroup__["a" /* default */],{title:'Department',name:'departments',value:this.state.userDetails.departments.sort().join(','),options:[].concat(_toConsumableArray(this.props.departments),[{key:this.props.departments.map(function(d){return d.value;}).join(','),value:this.props.departments.map(function(d){return d.value;}).sort().join(' & ')}]),onChange:function onChange(name,val){return _this4.onChange(name,val.split(','));}})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_Select__["a" /* default */],{options:this.props.approvers.filter(function(a){return _this4.state.userDetails.departments.length>1||a.departments.length>1||a.departments.indexOf(_this4.state.userDetails.departments[0])===0;})}),label:'Default Approver',name:'defaultApproverId',value:this.state.userDetails.defaultApproverId,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half role-settings'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_Select__["a" /* default */],{options:this.props.roles}),label:'Role/Permissions',name:'roleId',value:this.state.userDetails.roleId,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:!this.props.permissionsForRole.loading&&!this.props.permissionsForRole.success,message:'Unable to retrieve role permissions.  Please try again.'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},this.props.permissionsForRole.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'spinner-left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'empty-label'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'16'})):this.state.userDetails.roleId&&this.props.permissionsForRole.success&&!Object(__WEBPACK_IMPORTED_MODULE_12__lib_utils__["e" /* deepEquals */])(this.state.additionalPermissions,this.getDefaultAdditionalPermissions(),true)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-reset',onClick:this.onResetPermissions},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-loop'}),' Reset')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section permissions'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_util_RadioGroup__["a" /* default */],{name:'recipientTypePermission',title:'Recipient Type',onChange:function onChange(name,value){return _this4.onToggleRecipientTypePermission(value);},options:[].concat(_toConsumableArray(Object.keys(this.recipientTypePermissions).map(function(typePermission){return{key:_this4.recipientTypePermissions[typePermission],value:typePermission};})),[{key:"all",value:Object.keys(this.recipientTypePermissions).join(" and ")}]),value:this.state.additionalPermissions.indexOf(this.recipientTypePermissions.Institutions)>=0&&this.state.additionalPermissions.indexOf(this.recipientTypePermissions.Individuals)>=0?"all":this.state.additionalPermissions.indexOf(this.recipientTypePermissions.Institutions)>=0?this.recipientTypePermissions.Institutions:this.state.additionalPermissions.indexOf(this.recipientTypePermissions.Individuals)>=0?this.recipientTypePermissions.Individuals:""}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_util_RadioGroup__["a" /* default */],{name:'limitedFunds',title:'Funds',onChange:function onChange(name,value){return _this4.onToggleFundsPermission(value);},options:[{key:__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["j" /* PermissionTypes */].AllFundsAccess,value:"All"},{key:__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["j" /* PermissionTypes */].LimitedFundsAccess,value:"Limited"}],value:this.state.additionalPermissions.indexOf(__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["j" /* PermissionTypes */].AllFundsAccess)>=0?__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["j" /* PermissionTypes */].AllFundsAccess:__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["j" /* PermissionTypes */].LimitedFundsAccess}),this.state.additionalPermissions.indexOf(__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["j" /* PermissionTypes */].LimitedFundsAccess)>=0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_MultiSelect__["a" /* default */],{name:'limitedFunds',onChange:function onChange(name,value){return _this4.onSelectLimitedFunds(value,accessibleFunds);},options:[].concat(_toConsumableArray(this.props.allowAllFundsAccess&&this.state.userDetails.limitedFunds.length<accessibleFunds.length?[{label:"Select All",value:"all"}]:[]),_toConsumableArray(accessibleFunds)),placeholder:'Select Funds...',value:this.props.allowAllFundsAccess?this.state.userDetails.limitedFunds:accessibleFunds.map(function(fund){return fund.value;}).filter(function(fundId){return _this4.state.userDetails.limitedFunds.indexOf(fundId)>=0;})}),!this.props.allowAllFundsAccess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'xs-text error-text mt-16'},'You do not have access to all funds. Please use caution when updating funds for other users as you may be blocking them from previously accessible funds that are hidden from you.')),Object.keys(permissionsByCategory).map(function(category){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:category,className:'flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'accent-text small-text'},category,':'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'permission-checks-container'},permissionsByCategory[category].map(function(permission){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:permission.key,className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:permission.key,className:'custom-check',name:permission.key,checked:_this4.props.permissionsForRole.data.indexOf(permission.key)>=0||_this4.state.additionalPermissions.indexOf(permission.key)>=0,disabled:_this4.props.permissionsForRole.data.indexOf(permission.key)>=0,onChange:_this4.onTogglePermission}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:permission.key},permission.displayValue," "));})));})),this.props.creatingUser.loading||this.props.updatingUser.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.onClose.bind(this)},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this4.onSave();},disabled:this.state.invalidData.email||this.state.invalidData.phoneNumber||this.state.invalidData.mobilePhone||Object(__WEBPACK_IMPORTED_MODULE_12__lib_utils__["e" /* deepEquals */])(this.state.userDetails,this.state.preEditUserDetails)&&Object(__WEBPACK_IMPORTED_MODULE_12__lib_utils__["e" /* deepEquals */])(this.state.additionalPermissions,this.state.preEditAdditionalPermissions)},'Save'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error,message:this.props.editUserId?this.props.updatingUser.message:this.props.creatingUser.message})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ApproverReplacementModal__["a" /* default */],{show:this.state.showModals.approverReplacementModal,close:function close(approverId){if(approverId)_this4.setState({replacementApproverId:approverId},_this4.onSave.bind(_this4,true));_this4.toggleModal("approverReplacementModal");},user:{name:this.state.preEditUserDetails.firstName+' '+this.state.preEditUserDetails.lastName,userId:this.props.editUserId},approvers:this.props.approvers}));}}]);return UsersSettingsModal;}(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (UsersSettingsModal);

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(594);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MultiSelect=function(_React$Component){_inherits(MultiSelect,_React$Component);function MultiSelect(){_classCallCheck(this,MultiSelect);return _possibleConstructorReturn(this,(MultiSelect.__proto__||Object.getPrototypeOf(MultiSelect)).apply(this,arguments));}_createClass(MultiSelect,[{key:"render",value:function render(){var _props=this.props,disabled=_props.disabled,isClearable=_props.isClearable,name=_props.name,_onChange=_props.onChange,options=_props.options,placeholder=_props.placeholder,value=_props.value;var selection=value?value.map(function(valId,index){return{label:(options.find(function(o){return o.value===valId;})||{label:""}).label,value:valId};}):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],{className:"multiselect",closeMenuOnSelect:false,disabled:disabled,isClearable:isClearable,isMulti:true,name:name,onChange:function onChange(option){return _onChange(name,option);},options:options,placeholder:placeholder,value:selection});}}]);return MultiSelect;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (MultiSelect);

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SelectBase */
/* unused harmony export Async */
/* unused harmony export makeAsyncSelect */
/* unused harmony export AsyncCreatable */
/* unused harmony export Creatable */
/* unused harmony export makeCreatableSelect */
/* unused harmony export createFilter */
/* unused harmony export makeAnimated */
/* unused harmony export components */
/* unused harmony export mergeStyles */
/* unused harmony export defaultTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_memoize_one__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emotion__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raf__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_autosize__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_transition_group__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__);









function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/

function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, cssKey, state, className) {
  var arr = [cssKey, className];

  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
} // ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (_typeof(value) === 'object' && value !== null) return [value];
  return [];
}; // ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var newValue = onInputChange(inputValue, actionMeta);
    if (typeof newValue === 'string') return newValue;
  }

  return inputValue;
} // ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }

  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  var docEl = document.documentElement; // suck it, flow...

  if (style.position === 'fixed') return docEl;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);

    if (excludeStaticParent && style.position === 'static') {
      continue;
    }

    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return docEl;
} // Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/

function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);

    if (currentTime < duration) {
      __WEBPACK_IMPORTED_MODULE_5_raf___default()(animateScroll);
    } else {
      callback(element);
    }
  }

  animateScroll();
} // Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect

function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
} // ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
}

function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition,
      theme = _ref.theme;
  var spacing = theme.spacing;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: maxHeight
  }; // something went wrong, return default state

  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        } // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.


        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      } // 4. Forked beviour when there isn't enough space below
      // AUTO: flip the menu, render above


      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;

        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll


      if (placement === 'bottom') {
        scrollTo(scrollParent, scrollDown);
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      }

      break;

    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }

        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      } // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below


      return {
        placement: 'bottom',
        maxHeight: maxHeight
      };

    default:
      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
  } // fulfil contract with flow: implicit return value of undefined


  return defaultState;
} // Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}

var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement,
      _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      spacing = _ref2$theme.spacing,
      colors = _ref2$theme.colors;
  return _ref3 = {
    label: 'menu'
  }, _defineProperty(_ref3, alignToControl(placement), '100%'), _defineProperty(_ref3, "backgroundColor", colors.neutral0), _defineProperty(_ref3, "borderRadius", borderRadius), _defineProperty(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), _defineProperty(_ref3, "marginBottom", spacing.menuGutter), _defineProperty(_ref3, "marginTop", spacing.menuGutter), _defineProperty(_ref3, "position", 'absolute'), _defineProperty(_ref3, "width", '100%'), _defineProperty(_ref3, "zIndex", 1), _ref3;
}; // NOTE: internal only

var MenuPlacer =
/*#__PURE__*/
function (_Component) {
  _inherits(MenuPlacer, _Component);

  function MenuPlacer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MenuPlacer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MenuPlacer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPlacement", function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
          theme = _this$props.theme;
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (!ref) return; // DO NOT scroll if position is fixed

      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition,
        theme: theme
      });
      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getUpdatedProps", function () {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return _objectSpread({}, _this.props, {
        placement: placement,
        maxHeight: _this.state.maxHeight
      });
    });

    return _this;
  }

  _createClass(MenuPlacer, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);

  return MenuPlacer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(MenuPlacer, "contextTypes", {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var Menu = function Menu(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  var cn = cx(
  /*#__PURE__*/
  Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('menu', props)), {
    menu: true
  }, className);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cn
  }, innerProps, {
    ref: innerRef
  }), children);
};
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4) {
  var maxHeight = _ref4.maxHeight,
      baseUnit = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isMulti = props.isMulti,
      innerRef = props.innerRef;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('menuList', props)), {
      'menu-list': true,
      'menu-list--is-multi': isMulti
    }, className),
    ref: innerRef
  }, children);
}; // ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5) {
  var _ref5$theme = _ref5.theme,
      baseUnit = _ref5$theme.spacing.baseUnit,
      colors = _ref5$theme.colors;
  return {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
    textAlign: 'center'
  };
};

var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('noOptionsMessage', props)), {
      'menu-notice': true,
      'menu-notice--no-options': true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};
var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('loadingMessage', props)), {
      'menu-notice': true,
      'menu-notice--loading': true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal =
/*#__PURE__*/
function (_Component2) {
  _inherits(MenuPortal, _Component2);

  function MenuPortal() {
    var _getPrototypeOf3;

    var _this2;

    _classCallCheck(this, MenuPortal);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(MenuPortal)).call.apply(_getPrototypeOf3, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "state", {
      placement: null
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "getPortalPlacement", function (_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

      if (placement !== initialPlacement) {
        _this2.setState({
          placement: placement
        });
      }
    });

    return _this2;
  }

  _createClass(MenuPortal, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        getPortalPlacement: this.getPortalPlacement
      };
    } // callback for occassions where the menu must "flip"

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          appendTo = _this$props2.appendTo,
          children = _this$props2.children,
          controlElement = _this$props2.controlElement,
          menuPlacement = _this$props2.menuPlacement,
          position = _this$props2.menuPosition,
          getStyles = _this$props2.getStyles;
      var isFixed = position === 'fixed'; // bail early if required elements aren't present

      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = {
        offset: offset,
        position: position,
        rect: rect
      }; // same wrapper element whether fixed or portalled

      var menuWrapper = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className:
        /*#__PURE__*/

        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('menuPortal', state))
      }, children);
      return appendTo ? Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["createPortal"])(menuWrapper, appendTo) : menuWrapper;
    }
  }]);

  return MenuPortal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(MenuPortal, "childContextTypes", {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && _typeof(a) == 'object' && _typeof(b) == 'object') {
    var arrA = isArray(a),
        arrB = isArray(b),
        i,
        length,
        key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }

      return true;
    }

    if (arrA != arrB) return false;
    var dateA = a instanceof Date,
        dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();
    var regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();
    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length) {
      return false;
    }

    for (i = length; i-- !== 0;) {
      if (!hasProp.call(b, keys[i])) return false;
    } // end fast-deep-equal
    // Custom handling for React


    for (i = length; i-- !== 0;) {
      key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    } // fast-deep-equal index.js 2.0.1


    return true;
  }

  return a !== a && b !== b;
} // end fast-deep-equal


function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    } // some other error. we should definitely know about these


    throw error;
  }
}

var diacritics = [{
  base: 'A',
  letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
}, {
  base: 'AA',
  letters: /[\uA732]/g
}, {
  base: 'AE',
  letters: /[\u00C6\u01FC\u01E2]/g
}, {
  base: 'AO',
  letters: /[\uA734]/g
}, {
  base: 'AU',
  letters: /[\uA736]/g
}, {
  base: 'AV',
  letters: /[\uA738\uA73A]/g
}, {
  base: 'AY',
  letters: /[\uA73C]/g
}, {
  base: 'B',
  letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
}, {
  base: 'C',
  letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
}, {
  base: 'D',
  letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
}, {
  base: 'DZ',
  letters: /[\u01F1\u01C4]/g
}, {
  base: 'Dz',
  letters: /[\u01F2\u01C5]/g
}, {
  base: 'E',
  letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
}, {
  base: 'F',
  letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
}, {
  base: 'G',
  letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
}, {
  base: 'H',
  letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
}, {
  base: 'I',
  letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
}, {
  base: 'J',
  letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
}, {
  base: 'K',
  letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
}, {
  base: 'L',
  letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
}, {
  base: 'LJ',
  letters: /[\u01C7]/g
}, {
  base: 'Lj',
  letters: /[\u01C8]/g
}, {
  base: 'M',
  letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
}, {
  base: 'N',
  letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
}, {
  base: 'NJ',
  letters: /[\u01CA]/g
}, {
  base: 'Nj',
  letters: /[\u01CB]/g
}, {
  base: 'O',
  letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
}, {
  base: 'OI',
  letters: /[\u01A2]/g
}, {
  base: 'OO',
  letters: /[\uA74E]/g
}, {
  base: 'OU',
  letters: /[\u0222]/g
}, {
  base: 'P',
  letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
}, {
  base: 'Q',
  letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
}, {
  base: 'R',
  letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
}, {
  base: 'S',
  letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
}, {
  base: 'T',
  letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
}, {
  base: 'TZ',
  letters: /[\uA728]/g
}, {
  base: 'U',
  letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
}, {
  base: 'V',
  letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
}, {
  base: 'VY',
  letters: /[\uA760]/g
}, {
  base: 'W',
  letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
}, {
  base: 'X',
  letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
}, {
  base: 'Y',
  letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
}, {
  base: 'Z',
  letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
}, {
  base: 'a',
  letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
}, {
  base: 'aa',
  letters: /[\uA733]/g
}, {
  base: 'ae',
  letters: /[\u00E6\u01FD\u01E3]/g
}, {
  base: 'ao',
  letters: /[\uA735]/g
}, {
  base: 'au',
  letters: /[\uA737]/g
}, {
  base: 'av',
  letters: /[\uA739\uA73B]/g
}, {
  base: 'ay',
  letters: /[\uA73D]/g
}, {
  base: 'b',
  letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
}, {
  base: 'c',
  letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
}, {
  base: 'd',
  letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
}, {
  base: 'dz',
  letters: /[\u01F3\u01C6]/g
}, {
  base: 'e',
  letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
}, {
  base: 'f',
  letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
}, {
  base: 'g',
  letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
}, {
  base: 'h',
  letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
}, {
  base: 'hv',
  letters: /[\u0195]/g
}, {
  base: 'i',
  letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
}, {
  base: 'j',
  letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
}, {
  base: 'k',
  letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
}, {
  base: 'l',
  letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
}, {
  base: 'lj',
  letters: /[\u01C9]/g
}, {
  base: 'm',
  letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
}, {
  base: 'n',
  letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
}, {
  base: 'nj',
  letters: /[\u01CC]/g
}, {
  base: 'o',
  letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
}, {
  base: 'oi',
  letters: /[\u01A3]/g
}, {
  base: 'ou',
  letters: /[\u0223]/g
}, {
  base: 'oo',
  letters: /[\uA74F]/g
}, {
  base: 'p',
  letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
}, {
  base: 'q',
  letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
}, {
  base: 'r',
  letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
}, {
  base: 's',
  letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
}, {
  base: 't',
  letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
}, {
  base: 'tz',
  letters: /[\uA729]/g
}, {
  base: 'u',
  letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
}, {
  base: 'v',
  letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
}, {
  base: 'vy',
  letters: /[\uA761]/g
}, {
  base: 'w',
  letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
}, {
  base: 'x',
  letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
}, {
  base: 'y',
  letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
}, {
  base: 'z',
  letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
}];
var stripDiacritics = function stripDiacritics(str) {
  for (var i = 0; i < diacritics.length; i++) {
    str = str.replace(diacritics[i].letters, diacritics[i].base);
  }

  return str;
};

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};

var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    var _ignoreCase$ignoreAcc = _objectSpread({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);

    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }

    if (ignoreAccents) {
      input = stripDiacritics(input);
      candidate = stripDiacritics(candidate);
    }

    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

var A11yText = function A11yText(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", _extends({
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])({
      label: 'a11yText',
      zIndex: 9999,
      border: 0,
      clip: 'rect(1px, 1px, 1px, 1px)',
      height: 1,
      width: 1,
      position: 'absolute',
      overflow: 'hidden',
      padding: 0,
      whiteSpace: 'nowrap',
      backgroundColor: 'red',
      color: 'blue'
    })
  }, props));
};

var DummyInput =
/*#__PURE__*/
function (_Component) {
  _inherits(DummyInput, _Component);

  function DummyInput() {
    _classCallCheck(this, DummyInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(DummyInput).apply(this, arguments));
  }

  _createClass(DummyInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          inProp = _this$props.in,
          out = _this$props.out,
          onExited = _this$props.onExited,
          appear = _this$props.appear,
          enter = _this$props.enter,
          exit = _this$props.exit,
          innerRef = _this$props.innerRef,
          emotion = _this$props.emotion,
          props = _objectWithoutProperties(_this$props, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", _extends({
        ref: innerRef
      }, props, {
        className:
        /*#__PURE__*/

        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])({
          label: 'dummyInput',
          // get rid of any default styles
          background: 0,
          border: 0,
          fontSize: 'inherit',
          outline: 0,
          padding: 0,
          // important! without `width` browsers won't allow focus
          width: 1,
          // remove cursor on desktop
          color: 'transparent',
          // remove cursor on mobile whilst maintaining "scroll into view" behaviour
          left: -100,
          opacity: 0,
          position: 'relative',
          transform: 'scale(0)'
        })
      }));
    }
  }]);

  return DummyInput;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var NodeResolver =
/*#__PURE__*/
function (_Component) {
  _inherits(NodeResolver, _Component);

  function NodeResolver() {
    _classCallCheck(this, NodeResolver);

    return _possibleConstructorReturn(this, _getPrototypeOf(NodeResolver).apply(this, arguments));
  }

  _createClass(NodeResolver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.innerRef(Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.innerRef(null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return NodeResolver;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

function preventTouchMove(e) {
  e.preventDefault();
}
function allowTouchMove(e) {
  e.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;

var ScrollLock =
/*#__PURE__*/
function (_Component) {
  _inherits(ScrollLock, _Component);

  function ScrollLock() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ScrollLock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollLock)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "originalStyles", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "listenerOptions", {
      capture: false,
      passive: false
    });

    return _this;
  }

  _createClass(ScrollLock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!canUseDOM) return;
      var _this$props = this.props,
          accountForScrollbars = _this$props.accountForScrollbars,
          touchScrollTarget = _this$props.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style;

      if (accountForScrollbars) {
        // store any styles already applied to the body
        STYLE_KEYS.forEach(function (key) {
          var val = targetStyle && targetStyle[key];
          _this2.originalStyles[key] = val;
        });
      } // apply the lock styles and padding if this is the first scroll lock


      if (accountForScrollbars && activeScrollLocks < 1) {
        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
        var clientWidth = document.body ? document.body.clientWidth : 0;
        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
        Object.keys(LOCK_STYLES).forEach(function (key) {
          var val = LOCK_STYLES[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });

        if (targetStyle) {
          targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
      } // account for touch devices


      if (target && isTouchDevice()) {
        // Mobile Safari ignores { overflow: hidden } declaration on the body.
        target.addEventListener('touchmove', preventTouchMove, this.listenerOptions); // Allow scroll on provided target

        if (touchScrollTarget) {
          touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      } // increment active scroll locks


      activeScrollLocks += 1;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (!canUseDOM) return;
      var _this$props2 = this.props,
          accountForScrollbars = _this$props2.accountForScrollbars,
          touchScrollTarget = _this$props2.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style; // safely decrement active scroll locks

      activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any

      if (accountForScrollbars && activeScrollLocks < 1) {
        STYLE_KEYS.forEach(function (key) {
          var val = _this3.originalStyles[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });
      } // remove touch listeners


      if (target && isTouchDevice()) {
        target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);

        if (touchScrollTarget) {
          touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return ScrollLock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(ScrollLock, "defaultProps", {
  accountForScrollbars: true
});

// NOTE:
// We shouldn't need this after updating to React v16.3.0, which introduces:
// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
var ScrollBlock =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ScrollBlock, _PureComponent);

  function ScrollBlock() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ScrollBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollBlock)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      touchScrollTarget: null
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getScrollTarget", function (ref) {
      if (ref === _this.state.touchScrollTarget) return;

      _this.setState({
        touchScrollTarget: ref
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blurSelectInput", function () {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    });

    return _this;
  }

  _createClass(ScrollBlock, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          isEnabled = _this$props.isEnabled;
      var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled

      if (!isEnabled) return children;
      /*
       * Div
       * ------------------------------
       * blocks scrolling on non-body elements behind the menu
        * NodeResolver
       * ------------------------------
       * we need a reference to the scrollable element to "unlock" scroll on
       * mobile devices
        * ScrollLock
       * ------------------------------
       * actually does the scroll locking
       */

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        onClick: this.blurSelectInput,
        className:
        /*#__PURE__*/

        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])({
          position: 'fixed',
          left: 0,
          bottom: 0,
          right: 0,
          top: 0
        })
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NodeResolver, {
        innerRef: this.getScrollTarget
      }, children), touchScrollTarget ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollLock, {
        touchScrollTarget: touchScrollTarget
      }) : null);
    }
  }]);

  return ScrollBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var ScrollCaptor =
/*#__PURE__*/
function (_Component) {
  _inherits(ScrollCaptor, _Component);

  function ScrollCaptor() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ScrollCaptor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollCaptor)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isBottom", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isTop", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollTarget", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "touchStart", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cancelScroll", function (event) {
      event.preventDefault();
      event.stopPropagation();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleEventDelta", function (event, delta) {
      var _this$props = _this.props,
          onBottomArrive = _this$props.onBottomArrive,
          onBottomLeave = _this$props.onBottomLeave,
          onTopArrive = _this$props.onTopArrive,
          onTopLeave = _this$props.onTopLeave;
      var _this$scrollTarget = _this.scrollTarget,
          scrollTop = _this$scrollTarget.scrollTop,
          scrollHeight = _this$scrollTarget.scrollHeight,
          clientHeight = _this$scrollTarget.clientHeight;
      var target = _this.scrollTarget;
      var isDeltaPositive = delta > 0;
      var availableScroll = scrollHeight - clientHeight - scrollTop;
      var shouldCancelScroll = false; // reset bottom/top flags

      if (availableScroll > delta && _this.isBottom) {
        if (onBottomLeave) onBottomLeave(event);
        _this.isBottom = false;
      }

      if (isDeltaPositive && _this.isTop) {
        if (onTopLeave) onTopLeave(event);
        _this.isTop = false;
      } // bottom limit


      if (isDeltaPositive && delta > availableScroll) {
        if (onBottomArrive && !_this.isBottom) {
          onBottomArrive(event);
        }

        target.scrollTop = scrollHeight;
        shouldCancelScroll = true;
        _this.isBottom = true; // top limit
      } else if (!isDeltaPositive && -delta > scrollTop) {
        if (onTopArrive && !_this.isTop) {
          onTopArrive(event);
        }

        target.scrollTop = 0;
        shouldCancelScroll = true;
        _this.isTop = true;
      } // cancel scroll


      if (shouldCancelScroll) {
        _this.cancelScroll(event);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onWheel", function (event) {
      _this.handleEventDelta(event, event.deltaY);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchStart", function (event) {
      // set touch start so we can calculate touchmove delta
      _this.touchStart = event.changedTouches[0].clientY;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchMove", function (event) {
      var deltaY = _this.touchStart - event.changedTouches[0].clientY;

      _this.handleEventDelta(event, deltaY);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getScrollTarget", function (ref) {
      _this.scrollTarget = ref;
    });

    return _this;
  }

  _createClass(ScrollCaptor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListening(this.scrollTarget);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListening(this.scrollTarget);
    }
  }, {
    key: "startListening",
    value: function startListening(el) {
      // bail early if no scroll available
      if (!el) return;
      if (el.scrollHeight <= el.clientHeight) return; // all the if statements are to appease Flow 😢

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: "stopListening",
    value: function stopListening(el) {
      // bail early if no scroll available
      if (el.scrollHeight <= el.clientHeight) return; // all the if statements are to appease Flow 😢

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NodeResolver, {
        innerRef: this.getScrollTarget
      }, this.props.children);
    }
  }]);

  return ScrollCaptor;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var ScrollCaptorSwitch =
/*#__PURE__*/
function (_Component2) {
  _inherits(ScrollCaptorSwitch, _Component2);

  function ScrollCaptorSwitch() {
    _classCallCheck(this, ScrollCaptorSwitch);

    return _possibleConstructorReturn(this, _getPrototypeOf(ScrollCaptorSwitch).apply(this, arguments));
  }

  _createClass(ScrollCaptorSwitch, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          isEnabled = _this$props2.isEnabled,
          props = _objectWithoutProperties(_this$props2, ["isEnabled"]);

      return isEnabled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollCaptor, props) : this.props.children;
    }
  }]);

  return ScrollCaptorSwitch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(ScrollCaptorSwitch, "defaultProps", {
  isEnabled: true
});

var instructionsAriaMessage = function instructionsAriaMessage(event) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isSearchable = context.isSearchable,
      isMulti = context.isMulti,
      label = context.label,
      isDisabled = context.isDisabled;

  switch (event) {
    case 'menu':
      return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu, press Tab to select the option and exit the menu.");

    case 'input':
      return "".concat(label ? label : 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');

    case 'value':
      return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
  }
};
var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
  var value = context.value,
      isDisabled = context.isDisabled;
  if (!value) return;

  switch (event) {
    case 'deselect-option':
    case 'pop-value':
    case 'remove-value':
      return "option ".concat(value, ", deselected.");

    case 'select-option':
      return isDisabled ? "option ".concat(value, " is disabled. Select another option.") : "option ".concat(value, ", selected.");
  }
};
var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
  var focusedValue = _ref.focusedValue,
      getOptionLabel = _ref.getOptionLabel,
      selectValue = _ref.selectValue;
  return "value ".concat(getOptionLabel(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
};
var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
  var focusedOption = _ref2.focusedOption,
      getOptionLabel = _ref2.getOptionLabel,
      options = _ref2.options;
  return "option ".concat(getOptionLabel(focusedOption), " focused").concat(focusedOption.isDisabled ? ' disabled' : '', ", ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
};
var resultsAriaMessage = function resultsAriaMessage(_ref3) {
  var inputValue = _ref3.inputValue,
      screenReaderMessage = _ref3.screenReaderMessage;
  return "".concat(screenReaderMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
};

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : null,
    pointerEvents: isDisabled ? 'none' : null,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('container', props)), {
      '--is-disabled': isDisabled,
      '--is-rtl': isRtl
    }, className)
  }, innerProps), children);
}; // ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};
var ValueContainer =
/*#__PURE__*/
function (_Component) {
  _inherits(ValueContainer, _Component);

  function ValueContainer() {
    _classCallCheck(this, ValueContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(ValueContainer).apply(this, arguments));
  }

  _createClass(ValueContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          cx = _this$props.cx,
          isMulti = _this$props.isMulti,
          getStyles = _this$props.getStyles,
          hasValue = _this$props.hasValue;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: cx(
        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('valueContainer', this.props)), {
          'value-container': true,
          'value-container--is-multi': isMulti,
          'value-container--has-value': hasValue
        }, className)
      }, children);
    }
  }]);

  return ValueContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]); // ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('indicatorsContainer', props)), {
      'indicators': true
    }, className)
  }, children);
};

// ==============================
// Dropdown & Clear Icons
// ==============================
var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])({
      display: 'inline-block',
      fill: 'currentColor',
      lineHeight: 1,
      stroke: 'currentColor',
      strokeWidth: 0
    })
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Svg, _extends({
    size: 20
  }, props), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Svg, _extends({
    size: 20
  }, props), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref2) {
  var isFocused = _ref2.isFocused,
      _ref2$theme = _ref2.theme,
      baseUnit = _ref2$theme.spacing.baseUnit,
      colors = _ref2$theme.colors;
  return {
    label: 'indicatorContainer',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({}, innerProps, {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('dropdownIndicator', props)), {
      'indicator': true,
      'dropdown-indicator': true
    }, className)
  }), children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({}, innerProps, {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('clearIndicator', props)), {
      'indicator': true,
      'clear-indicator': true
    }, className)
  }), children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CrossIcon, null));
}; // ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref3) {
  var isDisabled = _ref3.isDisabled,
      _ref3$theme = _ref3.theme,
      baseUnit = _ref3$theme.spacing.baseUnit,
      colors = _ref3$theme.colors;
  return {
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", _extends({}, innerProps, {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('indicatorSeparator', props)), {
      'indicator-separator': true
    }, className)
  }));
}; // ==============================
// Loading
// ==============================

var keyframesName = 'react-select-loading-indicator';
var keyframesInjected = false;
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref4) {
  var isFocused = _ref4.isFocused,
      size = _ref4.size,
      _ref4$theme = _ref4.theme,
      colors = _ref4$theme.colors,
      baseUnit = _ref4$theme.spacing.baseUnit;
  return {
    label: 'loadingIndicator',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref5) {
  var color = _ref5.color,
      delay = _ref5.delay,
      offset = _ref5.offset;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])({
      animationDuration: '1s',
      animationDelay: "".concat(delay, "ms"),
      animationIterationCount: 'infinite',
      animationName: keyframesName,
      animationTimingFunction: 'ease-in-out',
      backgroundColor: color,
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : null,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    })
  });
};

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isFocused = props.isFocused,
      isRtl = props.isRtl,
      colors = props.theme.colors;
  var color = isFocused ? colors.neutral80 : colors.neutral20;

  if (!keyframesInjected) {
    // eslint-disable-next-line no-unused-expressions
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["b" /* injectGlobal */])("@keyframes ", keyframesName, "{0%,80%,100%{opacity:0;}40%{opacity:1;}};");
    keyframesInjected = true;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({}, innerProps, {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('loadingIndicator', props)), {
      'indicator': true,
      'loading-indicator': true
    }, className)
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingDot, {
    color: color,
    delay: 0,
    offset: isRtl
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingDot, {
    color: color,
    delay: 160,
    offset: true
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingDot, {
    color: color,
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};

var css$1 = function css$$1(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      borderRadius = _ref$theme.borderRadius,
      spacing = _ref$theme.spacing;
  return {
    label: 'control',
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      menuIsOpen = props.menuIsOpen;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    ref: innerRef,
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('control', props)), {
      'control': true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }, className)
  }, innerProps), children);
};

var groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      headingProps = props.headingProps,
      label = props.label,
      theme = props.theme,
      selectProps = props.selectProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('group', props)), {
      'group': true
    }, className)
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Heading, _extends({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    cx: cx
  }), label), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, children));
};

var groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    label: 'group',
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: '500',
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};
var GroupHeading = function GroupHeading(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      theme = props.theme,
      selectProps = props.selectProps,
      cleanProps = _objectWithoutProperties(props, ["className", "cx", "getStyles", "theme", "selectProps"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('groupHeading', _objectSpread({
      theme: theme
    }, cleanProps))), {
      'group-heading': true
    }, className)
  }, cleanProps));
};

var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80
  };
};

var inputStyle = function inputStyle(isHidden) {
  return {
    label: 'input',
    background: 0,
    border: 0,
    fontSize: 'inherit',
    opacity: isHidden ? 0 : 1,
    outline: 0,
    padding: 0,
    color: 'inherit'
  };
};

var Input = function Input(_ref2) {
  var className = _ref2.className,
      cx = _ref2.cx,
      getStyles = _ref2.getStyles,
      innerRef = _ref2.innerRef,
      isHidden = _ref2.isHidden,
      isDisabled = _ref2.isDisabled,
      theme = _ref2.theme,
      selectProps = _ref2.selectProps,
      props = _objectWithoutProperties(_ref2, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('input', _objectSpread({
      theme: theme
    }, props)))
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_input_autosize___default.a, _extends({
    className: cx(null, {
      'input': true
    }, className),
    inputRef: innerRef,
    inputStyle: inputStyle(isHidden),
    disabled: isDisabled
  }, props)));
};

var multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      colors = _ref$theme.colors;
  return {
    label: 'multiValue',
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug

  };
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      colors = _ref2$theme.colors,
      cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      borderRadius = _ref3$theme.borderRadius,
      colors = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused && colors.dangerLight,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
      innerProps = _ref4.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
var MultiValueRemove =
/*#__PURE__*/
function (_Component) {
  _inherits(MultiValueRemove, _Component);

  function MultiValueRemove() {
    _classCallCheck(this, MultiValueRemove);

    return _possibleConstructorReturn(this, _getPrototypeOf(MultiValueRemove).apply(this, arguments));
  }

  _createClass(MultiValueRemove, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          innerProps = _this$props.innerProps;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", innerProps, children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CrossIcon, {
        size: 14
      }));
    }
  }]);

  return MultiValueRemove;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var MultiValue =
/*#__PURE__*/
function (_Component2) {
  _inherits(MultiValue, _Component2);

  function MultiValue() {
    _classCallCheck(this, MultiValue);

    return _possibleConstructorReturn(this, _getPrototypeOf(MultiValue).apply(this, arguments));
  }

  _createClass(MultiValue, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          components = _this$props2.components,
          cx = _this$props2.cx,
          data = _this$props2.data,
          getStyles = _this$props2.getStyles,
          innerProps = _this$props2.innerProps,
          isDisabled = _this$props2.isDisabled,
          removeProps = _this$props2.removeProps,
          selectProps = _this$props2.selectProps;
      var Container = components.Container,
          Label = components.Label,
          Remove = components.Remove;

      var containerInnerProps = _objectSpread({
        className: cx(
        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('multiValue', this.props)), {
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className)
      }, innerProps);

      var labelInnerProps = {
        className: cx(
        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('multiValueLabel', this.props)), {
          'multi-value__label': true
        }, className)
      };

      var removeInnerProps = _objectSpread({
        className: cx(
        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('multiValueRemove', this.props)), {
          'multi-value__remove': true
        }, className)
      }, removeProps);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container, {
        data: data,
        innerProps: containerInnerProps,
        selectProps: selectProps
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, {
        data: data,
        innerProps: labelInnerProps,
        selectProps: selectProps
      }, children), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Remove, {
        data: data,
        innerProps: removeInnerProps,
        selectProps: selectProps
      }));
    }
  }]);

  return MultiValue;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(MultiValue, "defaultProps", {
  cropWithEllipsis: true
});

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'option',
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    ref: innerRef,
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('option', props)), {
      'option': true,
      'option--is-disabled': isDisabled,
      'option--is-focused': isFocused,
      'option--is-selected': isSelected
    }, className)
  }, innerProps), children);
};

var placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'placeholder',
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('placeholder', props)), {
      'placeholder': true
    }, className)
  }, innerProps), children);
};

var css$2 = function css$$1(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'singleValue',
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('singleValue', props)), {
      'single-value': true,
      'single-value--is-disabled': isDisabled
    }, className)
  }, innerProps), children);
};

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return _objectSpread({}, components, props.components);
};

var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css$2,
  valueContainer: valueContainerCSS
}; // Merge Utility
// Allows consumers to extend a base Select with additional styles

function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // initialize with source styles
  var styles = _objectSpread({}, source); // massage in target styles


  Object.keys(target).forEach(function (key) {
    if (source[key]) {
      styles[key] = function (rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });
  return styles;
}

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4;
var baseUnit = 4;
/* Used to calculate consistent margin/padding on elements */

var controlHeight = 38;
/* The minimum height of the control */

var menuGutter = baseUnit * 2;
/* The amount of space between the control and menu */

var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

var defaultProps = {
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: '0',
  tabSelectsValue: true
};
var instanceId = 1;

var Select =
/*#__PURE__*/
function (_Component) {
  _inherits(Select, _Component);

  // Misc. Instance Properties
  // ------------------------------
  // TODO
  // Refs
  // ------------------------------
  // Lifecycle
  // ------------------------------
  function Select(_props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, _props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      ariaLiveSelection: '',
      ariaLiveContext: '',
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      menuOptions: {
        render: [],
        focusable: []
      },
      selectValue: []
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blockOptionHover", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isComposing", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearFocusValueOnUpdate", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "commonProps", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "components", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hasGroups", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initialTouchX", 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initialTouchY", 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputIsHiddenAfterUpdate", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "instancePrefix", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "openAfterFocus", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollToFocusedOptionOnUpdate", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "userIsDragging", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "controlRef", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getControlRef", function (ref) {
      _this.controlRef = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "focusedOptionRef", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getFocusedOptionRef", function (ref) {
      _this.focusedOptionRef = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "menuListRef", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getMenuListRef", function (ref) {
      _this.menuListRef = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputRef", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getInputRef", function (ref) {
      _this.inputRef = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cacheComponents", function (components$$1) {
      _this.components = defaultComponents({
        components: components$$1
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "focus", _this.focusInput);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blur", _this.blurInput);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (newValue, actionMeta) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name;
      onChange(newValue, _objectSpread({}, actionMeta, {
        name: name
      }));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setValue", function (newValue) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
      var option = arguments.length > 2 ? arguments[2] : undefined;
      var _this$props2 = _this.props,
          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
          isMulti = _this$props2.isMulti;

      _this.onInputChange('', {
        action: 'set-value'
      });

      if (closeMenuOnSelect) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } // when the select value should change, we should reset focusedValue


      _this.clearFocusValueOnUpdate = true;

      _this.onChange(newValue, {
        action: action,
        option: option
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectOption", function (newValue) {
      var _this$props3 = _this.props,
          blurInputOnSelect = _this$props3.blurInputOnSelect,
          isMulti = _this$props3.isMulti;
      var selectValue = _this.state.selectValue;

      if (isMulti) {
        if (_this.isOptionSelected(newValue, selectValue)) {
          var candidate = _this.getOptionValue(newValue);

          _this.setValue(selectValue.filter(function (i) {
            return _this.getOptionValue(i) !== candidate;
          }), 'deselect-option', newValue);

          _this.announceAriaLiveSelection({
            event: 'deselect-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          if (!_this.isOptionDisabled(newValue, selectValue)) {
            _this.setValue([].concat(_toConsumableArray(selectValue), [newValue]), 'select-option', newValue);

            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue)
              }
            });
          } else {
            // announce that option is disabled
            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue),
                isDisabled: true
              }
            });
          }
        }
      } else {
        if (!_this.isOptionDisabled(newValue, selectValue)) {
          _this.setValue(newValue, 'select-option');

          _this.announceAriaLiveSelection({
            event: 'select-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          // announce that option is disabled
          _this.announceAriaLiveSelection({
            event: 'select-option',
            context: {
              value: _this.getOptionLabel(newValue),
              isDisabled: true
            }
          });
        }
      }

      if (blurInputOnSelect) {
        _this.blurInput();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "removeValue", function (removedValue) {
      var selectValue = _this.state.selectValue;

      var candidate = _this.getOptionValue(removedValue);

      _this.onChange(selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      }), {
        action: 'remove-value',
        removedValue: removedValue
      });

      _this.announceAriaLiveSelection({
        event: 'remove-value',
        context: {
          value: removedValue ? _this.getOptionLabel(removedValue) : ''
        }
      });

      _this.focusInput();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearValue", function () {
      var isMulti = _this.props.isMulti;

      _this.onChange(isMulti ? [] : null, {
        action: 'clear'
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "popValue", function () {
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];

      _this.announceAriaLiveSelection({
        event: 'pop-value',
        context: {
          value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
        }
      });

      _this.onChange(selectValue.slice(0, selectValue.length - 1), {
        action: 'pop-value',
        removedValue: lastSelectedValue
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOptionLabel", function (data) {
      return _this.props.getOptionLabel(data);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOptionValue", function (data) {
      return _this.props.getOptionValue(data);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getStyles", function (key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getElementId", function (element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getActiveDescendentId", function () {
      var menuIsOpen = _this.props.menuIsOpen;
      var _this$state = _this.state,
          menuOptions = _this$state.menuOptions,
          focusedOption = _this$state.focusedOption;
      if (!focusedOption || !menuIsOpen) return undefined;
      var index = menuOptions.focusable.indexOf(focusedOption);
      var option = menuOptions.render[index];
      return option && option.key;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceAriaLiveSelection", function (_ref2) {
      var event = _ref2.event,
          context = _ref2.context;

      _this.setState({
        ariaLiveSelection: valueEventAriaMessage(event, context)
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceAriaLiveContext", function (_ref3) {
      var event = _ref3.event,
          context = _ref3.context;

      _this.setState({
        ariaLiveContext: instructionsAriaMessage(event, _objectSpread({}, context, {
          label: _this.props['aria-label']
        }))
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuMouseDown", function (event) {
      if (event.button !== 0) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();

      _this.focusInput();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuMouseMove", function (event) {
      _this.blockOptionHover = false;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onControlMouseDown", function (event) {
      var openMenuOnClick = _this.props.openMenuOnClick;

      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }

        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        //$FlowFixMe
        if (event.target.tagName !== 'INPUT') {
          _this.onMenuClose();
        }
      } //$FlowFixMe


      if (event.target.tagName !== 'INPUT') {
        event.preventDefault();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDropdownIndicatorMouseDown", function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
          isMulti = _this$props4.isMulti,
          menuIsOpen = _this$props4.menuIsOpen;

      _this.focusInput();

      if (menuIsOpen) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }

      event.preventDefault();
      event.stopPropagation();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClearIndicatorMouseDown", function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      _this.clearValue();

      event.stopPropagation();
      _this.openAfterFocus = false;
      setTimeout(function () {
        return _this.focusInput();
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onScroll", function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onCompositionStart", function () {
      _this.isComposing = true;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onCompositionEnd", function () {
      _this.isComposing = false;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchStart", function (_ref4) {
      var touches = _ref4.touches;
      var touch = touches.item(0);

      if (!touch) {
        return;
      }

      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchMove", function (_ref5) {
      var touches = _ref5.touches;
      var touch = touches.item(0);

      if (!touch) {
        return;
      }

      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchEnd", function (event) {
      if (_this.userIsDragging) return; // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).

      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      } // reset move vars


      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onControlTouchEnd", function (event) {
      if (_this.userIsDragging) return;

      _this.onControlMouseDown(event);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClearIndicatorTouchEnd", function (event) {
      if (_this.userIsDragging) return;

      _this.onClearIndicatorMouseDown(event);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDropdownIndicatorTouchEnd", function (event) {
      if (_this.userIsDragging) return;

      _this.onDropdownIndicatorMouseDown(event);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (event) {
      var inputValue = event.currentTarget.value;
      _this.inputIsHiddenAfterUpdate = false;

      _this.onInputChange(inputValue, {
        action: 'input-change'
      });

      _this.onMenuOpen();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputFocus", function (event) {
      var _this$props5 = _this.props,
          isSearchable = _this$props5.isSearchable,
          isMulti = _this$props5.isMulti;

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      _this.inputIsHiddenAfterUpdate = false;

      _this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });

      _this.setState({
        isFocused: true
      });

      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }

      _this.openAfterFocus = false;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputBlur", function (event) {
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();

        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      _this.onInputChange('', {
        action: 'input-blur'
      });

      _this.onMenuClose();

      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onOptionHover", function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }

      _this.setState({
        focusedOption: focusedOption
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "shouldHideSelectedOptions", function () {
      var _this$props6 = _this.props,
          hideSelectedOptions = _this$props6.hideSelectedOptions,
          isMulti = _this$props6.isMulti;
      if (hideSelectedOptions === undefined) return isMulti;
      return hideSelectedOptions;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onKeyDown", function (event) {
      var _this$props7 = _this.props,
          isMulti = _this$props7.isMulti,
          backspaceRemovesValue = _this$props7.backspaceRemovesValue,
          escapeClearsValue = _this$props7.escapeClearsValue,
          inputValue = _this$props7.inputValue,
          isClearable = _this$props7.isClearable,
          isDisabled = _this$props7.isDisabled,
          menuIsOpen = _this$props7.menuIsOpen,
          onKeyDown = _this$props7.onKeyDown,
          tabSelectsValue = _this$props7.tabSelectsValue,
          openMenuOnFocus = _this$props7.openMenuOnFocus;
      var _this$state2 = _this.state,
          focusedOption = _this$state2.focusedOption,
          focusedValue = _this$state2.focusedValue,
          selectValue = _this$state2.selectValue;
      if (isDisabled) return;

      if (typeof onKeyDown === 'function') {
        onKeyDown(event);

        if (event.defaultPrevented) {
          return;
        }
      } // Block option hover events when the user has just pressed a key


      _this.blockOptionHover = true;

      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;

          _this.focusValue('previous');

          break;

        case 'ArrowRight':
          if (!isMulti || inputValue) return;

          _this.focusValue('next');

          break;

        case 'Delete':
        case 'Backspace':
          if (inputValue) return;

          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;

            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }

          break;

        case 'Tab':
          if (_this.isComposing) return;

          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }

          _this.selectOption(focusedOption);

          break;

        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }

          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;

            _this.selectOption(focusedOption);

            break;
          }

          return;

        case 'Escape':
          if (menuIsOpen) {
            _this.inputIsHiddenAfterUpdate = false;

            _this.onInputChange('', {
              action: 'menu-close'
            });

            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }

          break;

        case ' ':
          // space
          if (inputValue) {
            return;
          }

          if (!menuIsOpen) {
            _this.openMenu('first');

            break;
          }

          if (!focusedOption) return;

          _this.selectOption(focusedOption);

          break;

        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }

          break;

        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }

          break;

        case 'PageUp':
          if (!menuIsOpen) return;

          _this.focusOption('pageup');

          break;

        case 'PageDown':
          if (!menuIsOpen) return;

          _this.focusOption('pagedown');

          break;

        case 'Home':
          if (!menuIsOpen) return;

          _this.focusOption('first');

          break;

        case 'End':
          if (!menuIsOpen) return;

          _this.focusOption('last');

          break;

        default:
          return;
      }

      event.preventDefault();
    });

    var value = _props.value;
    _this.cacheComponents = Object(__WEBPACK_IMPORTED_MODULE_1_memoize_one__["a" /* default */])(_this.cacheComponents, exportedEqual).bind(_assertThisInitialized(_assertThisInitialized(_this)));

    _this.cacheComponents(_props.components);

    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);

    var _selectValue = cleanValue(value);

    var _menuOptions = _this.buildMenuOptions(_props, _selectValue);

    _this.state.menuOptions = _menuOptions;
    _this.state.selectValue = _selectValue;
    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();

      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }

      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props8 = this.props,
          options = _this$props8.options,
          value = _this$props8.value,
          inputValue = _this$props8.inputValue; // re-cache custom components

      this.cacheComponents(nextProps.components); // rebuild the menu options

      if (nextProps.value !== value || nextProps.options !== options || nextProps.inputValue !== inputValue) {
        var selectValue = cleanValue(nextProps.value);
        var menuOptions = this.buildMenuOptions(nextProps, selectValue);
        var focusedValue = this.getNextFocusedValue(selectValue);
        var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
        this.setState({
          menuOptions: menuOptions,
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedValue: focusedValue
        });
      } // some updates should toggle the state of the input visibility


      if (this.inputIsHiddenAfterUpdate != null) {
        this.setState({
          inputIsHidden: this.inputIsHiddenAfterUpdate
        });
        delete this.inputIsHiddenAfterUpdate;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props9 = this.props,
          isDisabled = _this$props9.isDisabled,
          menuIsOpen = _this$props9.menuIsOpen;
      var isFocused = this.state.isFocused;

      if ( // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      } // scroll the focused option into view if necessary


      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
      }

      this.scrollToFocusedOptionOnUpdate = false;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: "onMenuOpen",
    // ==============================
    // Consumer Handlers
    // ==============================
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      var _this$props10 = this.props,
          isSearchable = _this$props10.isSearchable,
          isMulti = _this$props10.isMulti;
      this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });
      this.onInputChange('', {
        action: 'menu-close'
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    } // ==============================
    // Methods
    // ==============================

  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    } // aliased for consumers

  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this$state3 = this.state,
          menuOptions = _this$state3.menuOptions,
          selectValue = _this$state3.selectValue,
          isFocused = _this$state3.isFocused;
      var isMulti = this.props.isMulti;
      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;

      if (!isMulti) {
        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);

        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      } // only scroll if the menu isn't already open


      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.inputIsHiddenAfterUpdate = false;
      this.onMenuOpen();
      this.setState({
        focusedValue: null,
        focusedOption: menuOptions.focusable[openAtIndex]
      });
      this.announceAriaLiveContext({
        event: 'menu'
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$props11 = this.props,
          isMulti = _this$props11.isMulti,
          isSearchable = _this$props11.isSearchable;
      var _this$state4 = this.state,
          selectValue = _this$state4.selectValue,
          focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing

      if (!isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);

      if (!focusedValue) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'value'
        });
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }

          break;

        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }

          break;
      }

      if (nextFocus === -1) {
        this.announceAriaLiveContext({
          event: 'input',
          context: {
            isSearchable: isSearchable,
            isMulti: isMulti
          }
        });
      }

      this.setState({
        inputIsHidden: nextFocus === -1 ? false : true,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var _this$state5 = this.state,
          focusedOption = _this$state5.focusedOption,
          menuOptions = _this$state5.menuOptions;
      var options = menuOptions.focusable;
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'

      var focusedIndex = options.indexOf(focusedOption);

      if (!focusedOption) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'menu'
        });
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
      this.announceAriaLiveContext({
        event: 'menu',
        context: {
          isDisabled: isOptionDisabled(options[nextFocus])
        }
      });
    }
  }, {
    key: "getTheme",
    // ==============================
    // Getters
    // ==============================
    value: function getTheme() {
      // Use the default theme if there are no customizations.
      if (!this.props.theme) {
        return defaultTheme;
      } // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.


      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      } // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.


      return _objectSpread({}, defaultTheme, this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
          getStyles = this.getStyles,
          setValue = this.setValue,
          selectOption = this.selectOption,
          props = this.props;
      var classNamePrefix = props.classNamePrefix,
          isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var selectValue = this.state.selectValue;
      var hasValue = this.hasValue();

      var getValue = function getValue() {
        return selectValue;
      };

      var cx = classNames.bind(null, classNamePrefix);
      return {
        cx: cx,
        clearValue: clearValue,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        setValue: setValue,
        selectProps: props,
        theme: this.getTheme()
      };
    }
  }, {
    key: "getNextFocusedValue",
    value: function getNextFocusedValue(nextSelectValue) {
      if (this.clearFocusValueOnUpdate) {
        this.clearFocusValueOnUpdate = false;
        return null;
      }

      var _this$state6 = this.state,
          focusedValue = _this$state6.focusedValue,
          lastSelectValue = _this$state6.selectValue;
      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);

      if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);

        if (nextFocusedIndex > -1) {
          // the focused value is still in the selectValue, return it
          return focusedValue;
        } else if (lastFocusedIndex < nextSelectValue.length) {
          // the focusedValue is not present in the next selectValue array by
          // reference, so return the new value at the same index
          return nextSelectValue[lastFocusedIndex];
        }
      }

      return null;
    }
  }, {
    key: "getNextFocusedOption",
    value: function getNextFocusedOption(options) {
      var lastFocusedOption = this.state.focusedOption;
      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.state.menuOptions.render.length;
    }
  }, {
    key: "countOptions",
    value: function countOptions() {
      return this.state.menuOptions.focusable.length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props12 = this.props,
          isClearable = _this$props12.isClearable,
          isMulti = _this$props12.isMulti; // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled$$1(option, selectValue) {
      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      var _this2 = this;

      if (selectValue.indexOf(option) > -1) return true;

      if (typeof this.props.isOptionSelected === 'function') {
        return this.props.isOptionSelected(option, selectValue);
      }

      var candidate = this.getOptionValue(option);
      return selectValue.some(function (i) {
        return _this2.getOptionValue(i) === candidate;
      });
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var inputValue = this.props.inputValue;
        var selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: inputValue,
          selectValue: selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel$$1(data) {
      return this.props.formatGroupLabel(data);
    } // ==============================
    // Mouse Handlers
    // ==============================

  }, {
    key: "startListeningComposition",
    // ==============================
    // Composition Handlers
    // ==============================
    value: function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    // ==============================
    // Touch Handlers
    // ==============================
    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "buildMenuOptions",
    // ==============================
    // Menu Options
    // ==============================
    value: function buildMenuOptions(props, selectValue) {
      var _this3 = this;

      var _props$inputValue = props.inputValue,
          inputValue = _props$inputValue === void 0 ? '' : _props$inputValue,
          options = props.options;

      var toOption = function toOption(option, id) {
        var isDisabled = _this3.isOptionDisabled(option, selectValue);

        var isSelected = _this3.isOptionSelected(option, selectValue);

        var label = _this3.getOptionLabel(option);

        var value = _this3.getOptionValue(option);

        if (_this3.shouldHideSelectedOptions() && isSelected || !_this3.filterOption({
          label: label,
          value: value,
          data: option
        }, inputValue)) {
          return;
        }

        var onHover = isDisabled ? undefined : function () {
          return _this3.onOptionHover(option);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this3.selectOption(option);
        };
        var optionId = "".concat(_this3.getElementId('option'), "-").concat(id);
        return {
          innerProps: {
            id: optionId,
            onClick: onSelect,
            onMouseMove: onHover,
            onMouseOver: onHover,
            tabIndex: -1
          },
          data: option,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: 'option',
          value: value
        };
      };

      return options.reduce(function (acc, item, itemIndex) {
        if (item.options) {
          // TODO needs a tidier implementation
          if (!_this3.hasGroups) _this3.hasGroups = true;
          var items = item.options;
          var children = items.map(function (child, i) {
            var option = toOption(child, "".concat(itemIndex, "-").concat(i));
            if (option) acc.focusable.push(child);
            return option;
          }).filter(Boolean);

          if (children.length) {
            var groupId = "".concat(_this3.getElementId('group'), "-").concat(itemIndex);
            acc.render.push({
              type: 'group',
              key: groupId,
              data: item,
              options: children
            });
          }
        } else {
          var option = toOption(item, "".concat(itemIndex));

          if (option) {
            acc.render.push(option);
            acc.focusable.push(item);
          }
        }

        return acc;
      }, {
        render: [],
        focusable: []
      });
    } // ==============================
    // Renderers
    // ==============================

  }, {
    key: "constructAriaLiveMessage",
    value: function constructAriaLiveMessage() {
      var _this$state7 = this.state,
          ariaLiveContext = _this$state7.ariaLiveContext,
          selectValue = _this$state7.selectValue,
          focusedValue = _this$state7.focusedValue,
          focusedOption = _this$state7.focusedOption;
      var _this$props13 = this.props,
          options = _this$props13.options,
          menuIsOpen = _this$props13.menuIsOpen,
          inputValue = _this$props13.inputValue,
          screenReaderStatus = _this$props13.screenReaderStatus; // An aria live message representing the currently focused value in the select.

      var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
        focusedValue: focusedValue,
        getOptionLabel: this.getOptionLabel,
        selectValue: selectValue
      }) : ''; // An aria live message representing the currently focused option in the select.

      var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
        focusedOption: focusedOption,
        getOptionLabel: this.getOptionLabel,
        options: options
      }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.

      var resultsMsg = resultsAriaMessage({
        inputValue: inputValue,
        screenReaderMessage: screenReaderStatus({
          count: this.countOptions()
        })
      });
      return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props14 = this.props,
          isDisabled = _this$props14.isDisabled,
          isSearchable = _this$props14.isSearchable,
          inputId = _this$props14.inputId,
          inputValue = _this$props14.inputValue,
          tabIndex = _this$props14.tabIndex;
      var Input = this.components.Input;
      var inputIsHidden = this.state.inputIsHidden;
      var id = inputId || this.getElementId('input');

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DummyInput, {
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop,
          onFocus: this.onInputFocus,
          readOnly: true,
          disabled: isDisabled,
          tabIndex: tabIndex,
          value: ""
        });
      } // aria attributes makes the JSX "noisy", separated for clarity


      var ariaAttributes = {
        'aria-autocomplete': 'list',
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby']
      };
      var _this$commonProps = this.commonProps,
          cx = _this$commonProps.cx,
          theme = _this$commonProps.theme,
          selectProps = _this$commonProps.selectProps;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Input, _extends({
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        cx: cx,
        getStyles: this.getStyles,
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        selectProps: selectProps,
        spellCheck: "false",
        tabIndex: tabIndex,
        theme: theme,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this4 = this;

      var _this$components = this.components,
          MultiValue = _this$components.MultiValue,
          MultiValueContainer = _this$components.MultiValueContainer,
          MultiValueLabel = _this$components.MultiValueLabel,
          MultiValueRemove = _this$components.MultiValueRemove,
          SingleValue = _this$components.SingleValue,
          Placeholder = _this$components.Placeholder;
      var commonProps = this.commonProps;
      var _this$props15 = this.props,
          controlShouldRenderValue = _this$props15.controlShouldRenderValue,
          isDisabled = _this$props15.isDisabled,
          isMulti = _this$props15.isMulti,
          inputValue = _this$props15.inputValue,
          placeholder = _this$props15.placeholder;
      var _this$state8 = this.state,
          selectValue = _this$state8.selectValue,
          focusedValue = _this$state8.focusedValue,
          isFocused = _this$state8.isFocused;

      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Placeholder, _extends({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused
        }), placeholder);
      }

      if (isMulti) {
        var selectValues = selectValue.map(function (opt) {
          var isOptionFocused = opt === focusedValue;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MultiValue, _extends({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: _this4.getOptionValue(opt),
            removeProps: {
              onClick: function onClick() {
                return _this4.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this4.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
                e.stopPropagation();
              }
            },
            data: opt
          }), _this4.formatOptionLabel(opt, 'value'));
        });
        return selectValues;
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SingleValue, _extends({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var ClearIndicator = this.components.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props16 = this.props,
          isDisabled = _this$props16.isDisabled,
          isLoading = _this$props16.isLoading;
      var isFocused = this.state.isFocused;

      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClearIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var LoadingIndicator = this.components.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props17 = this.props,
          isDisabled = _this$props17.isDisabled,
          isLoading = _this$props17.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$components2 = this.components,
          DropdownIndicator = _this$components2.DropdownIndicator,
          IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator

      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndicatorSeparator, _extends({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var DropdownIndicator = this.components.DropdownIndicator;
      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DropdownIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this5 = this;

      var _this$components3 = this.components,
          Group = _this$components3.Group,
          GroupHeading = _this$components3.GroupHeading,
          Menu$$1 = _this$components3.Menu,
          MenuList$$1 = _this$components3.MenuList,
          MenuPortal$$1 = _this$components3.MenuPortal,
          LoadingMessage$$1 = _this$components3.LoadingMessage,
          NoOptionsMessage$$1 = _this$components3.NoOptionsMessage,
          Option = _this$components3.Option;
      var commonProps = this.commonProps;
      var _this$state9 = this.state,
          focusedOption = _this$state9.focusedOption,
          menuOptions = _this$state9.menuOptions;
      var _this$props18 = this.props,
          captureMenuScroll = _this$props18.captureMenuScroll,
          inputValue = _this$props18.inputValue,
          isLoading = _this$props18.isLoading,
          loadingMessage = _this$props18.loadingMessage,
          minMenuHeight = _this$props18.minMenuHeight,
          maxMenuHeight = _this$props18.maxMenuHeight,
          menuIsOpen = _this$props18.menuIsOpen,
          menuPlacement = _this$props18.menuPlacement,
          menuPosition = _this$props18.menuPosition,
          menuPortalTarget = _this$props18.menuPortalTarget,
          menuShouldBlockScroll = _this$props18.menuShouldBlockScroll,
          menuShouldScrollIntoView = _this$props18.menuShouldScrollIntoView,
          noOptionsMessage = _this$props18.noOptionsMessage,
          onMenuScrollToTop = _this$props18.onMenuScrollToTop,
          onMenuScrollToBottom = _this$props18.onMenuScrollToBottom;
      if (!menuIsOpen) return null; // TODO: Internal Option Type here

      var render = function render(props) {
        // for performance, the menu options in state aren't changed when the
        // focused option changes so we calculate additional props based on that
        var isFocused = focusedOption === props.data;
        props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Option, _extends({}, commonProps, props, {
          isFocused: isFocused
        }), _this5.formatOptionLabel(props.data, 'menu'));
      };

      var menuUI;

      if (this.hasOptions()) {
        menuUI = menuOptions.render.map(function (item) {
          if (item.type === 'group') {
            var type = item.type,
                group = _objectWithoutProperties(item, ["type"]);

            var headingId = "".concat(item.key, "-heading");
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Group, _extends({}, commonProps, group, {
              Heading: GroupHeading,
              headingProps: {
                id: headingId
              },
              label: _this5.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option);
            }));
          } else if (item.type === 'option') {
            return render(item);
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingMessage$$1, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });

        if (_message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NoOptionsMessage$$1, commonProps, _message);
      }

      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuPlacer, _extends({}, commonProps, menuPlacementProps), function (_ref6) {
        var ref = _ref6.ref,
            _ref6$placerProps = _ref6.placerProps,
            placement = _ref6$placerProps.placement,
            maxHeight = _ref6$placerProps.maxHeight;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Menu$$1, _extends({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this5.onMenuMouseDown,
            onMouseMove: _this5.onMenuMouseMove
          },
          isLoading: isLoading,
          placement: placement
        }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollCaptorSwitch, {
          isEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollBlock, {
          isEnabled: menuShouldBlockScroll
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuList$$1, _extends({}, commonProps, {
          innerRef: _this5.getMenuListRef,
          isLoading: isLoading,
          maxHeight: maxHeight
        }), menuUI))));
      }); // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`

      return menuPortalTarget || menuPosition === 'fixed' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuPortal$$1, _extends({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this6 = this;

      var _this$props19 = this.props,
          delimiter = _this$props19.delimiter,
          isDisabled = _this$props19.isDisabled,
          isMulti = _this$props19.isMulti,
          name = _this$props19.name;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this6.getOptionValue(opt);
          }).join(delimiter);
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this6.getOptionValue(opt)
            });
          }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            name: name,
            type: "hidden"
          });
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
          name: name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      if (!this.state.isFocused) return null;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(A11yText, {
        "aria-live": "assertive"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        id: "aria-selection-event"
      }, "\xA0", this.state.ariaLiveSelection), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        id: "aria-context"
      }, "\xA0", this.constructAriaLiveMessage()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$components4 = this.components,
          Control = _this$components4.Control,
          IndicatorsContainer = _this$components4.IndicatorsContainer,
          SelectContainer = _this$components4.SelectContainer,
          ValueContainer = _this$components4.ValueContainer;
      var _this$props20 = this.props,
          className = _this$props20.className,
          id = _this$props20.id,
          isDisabled = _this$props20.isDisabled,
          menuIsOpen = _this$props20.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectContainer, _extends({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Control, _extends({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValueContainer, _extends({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndicatorsContainer, _extends({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }]);

  return Select;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Select, "defaultProps", defaultProps);

var defaultProps$1 = {
  defaultInputValue: '',
  defaultMenuIsOpen: false,
  defaultValue: null
};

var manageState = function manageState(SelectComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(StateManager, _Component);

    function StateManager() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, StateManager);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(StateManager)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (value, actionMeta) {
        _this.callProp('onChange', value, actionMeta);

        _this.setState({
          value: value
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputChange", function (value, actionMeta) {
        // TODO: for backwards compatibility, we allow the prop to return a new
        // value, but now inputValue is a controllable prop we probably shouldn't
        var newValue = _this.callProp('onInputChange', value, actionMeta);

        _this.setState({
          inputValue: newValue !== undefined ? newValue : value
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuOpen", function () {
        _this.callProp('onMenuOpen');

        _this.setState({
          menuIsOpen: true
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuClose", function () {
        _this.callProp('onMenuClose');

        _this.setState({
          menuIsOpen: false
        });
      });

      return _this;
    }

    _createClass(StateManager, [{
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      } // FIXME: untyped flow code, return any

    }, {
      key: "getProp",
      value: function getProp(key) {
        return this.props[key] !== undefined ? this.props[key] : this.state[key];
      } // FIXME: untyped flow code, return any

    }, {
      key: "callProp",
      value: function callProp(name) {
        if (typeof this.props[name] === 'function') {
          var _this$props;

          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          return (_this$props = this.props)[name].apply(_this$props, args);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            defaultInputValue = _this$props2.defaultInputValue,
            defaultMenuIsOpen = _this$props2.defaultMenuIsOpen,
            defaultValue = _this$props2.defaultValue,
            props = _objectWithoutProperties(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectComponent, _extends({}, props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          inputValue: this.getProp('inputValue'),
          menuIsOpen: this.getProp('menuIsOpen'),
          onChange: this.onChange,
          onInputChange: this.onInputChange,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          value: this.getProp('value')
        }));
      }
    }]);

    return StateManager;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _defineProperty(_class, "defaultProps", defaultProps$1), _temp;
};

var defaultProps$2 = {
  cacheOptions: false,
  defaultOptions: false,
  filterOption: null
};
var makeAsyncSelect = function makeAsyncSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Async, _Component);

    function Async(props) {
      var _this;

      _classCallCheck(this, Async);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Async).call(this));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "lastRequest", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mounted", false);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "optionsCache", {});

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (newValue, actionMeta) {
        var _this$props = _this.props,
            cacheOptions = _this$props.cacheOptions,
            onInputChange = _this$props.onInputChange; // TODO

        var inputValue = handleInputChange(newValue, actionMeta, onInputChange);

        if (!inputValue) {
          delete _this.lastRequest;

          _this.setState({
            inputValue: '',
            loadedInputValue: '',
            loadedOptions: [],
            isLoading: false,
            passEmptyOptions: false
          });

          return;
        }

        if (cacheOptions && _this.optionsCache[inputValue]) {
          _this.setState({
            inputValue: inputValue,
            loadedInputValue: inputValue,
            loadedOptions: _this.optionsCache[inputValue],
            isLoading: false,
            passEmptyOptions: false
          });
        } else {
          var request = _this.lastRequest = {};

          _this.setState({
            inputValue: inputValue,
            isLoading: true,
            passEmptyOptions: !_this.state.loadedInputValue
          }, function () {
            _this.loadOptions(inputValue, function (options) {
              if (!_this.mounted) return;

              if (options) {
                _this.optionsCache[inputValue] = options;
              }

              if (request !== _this.lastRequest) return;
              delete _this.lastRequest;

              _this.setState({
                isLoading: false,
                loadedInputValue: inputValue,
                loadedOptions: options || [],
                passEmptyOptions: false
              });
            });
          });
        }

        return inputValue;
      });

      _this.state = {
        defaultOptions: Array.isArray(props.defaultOptions) ? props.defaultOptions : undefined,
        inputValue: typeof props.inputValue !== 'undefined' ? props.inputValue : '',
        isLoading: props.defaultOptions === true ? true : false,
        loadedOptions: [],
        passEmptyOptions: false
      };
      return _this;
    }

    _createClass(Async, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        this.mounted = true;
        var defaultOptions = this.props.defaultOptions;
        var inputValue = this.state.inputValue;

        if (defaultOptions === true) {
          this.loadOptions(inputValue, function (options) {
            if (!_this2.mounted) return;
            var isLoading = !!_this2.lastRequest;

            _this2.setState({
              defaultOptions: options || [],
              isLoading: isLoading
            });
          });
        }
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        // if the cacheOptions prop changes, clear the cache
        if (nextProps.cacheOptions !== this.props.cacheOptions) {
          this.optionsCache = {};
        }

        if (nextProps.defaultOptions !== this.props.defaultOptions) {
          this.setState({
            defaultOptions: Array.isArray(nextProps.defaultOptions) ? nextProps.defaultOptions : undefined
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.mounted = false;
      }
    }, {
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: "loadOptions",
      value: function loadOptions(inputValue, callback) {
        var loadOptions = this.props.loadOptions;
        if (!loadOptions) return callback();
        var loader = loadOptions(inputValue, callback);

        if (loader && typeof loader.then === 'function') {
          loader.then(callback, function () {
            return callback();
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;

        var _this$props2 = this.props,
            loadOptions = _this$props2.loadOptions,
            props = _objectWithoutProperties(_this$props2, ["loadOptions"]);

        var _this$state = this.state,
            defaultOptions = _this$state.defaultOptions,
            inputValue = _this$state.inputValue,
            isLoading = _this$state.isLoading,
            loadedInputValue = _this$state.loadedInputValue,
            loadedOptions = _this$state.loadedOptions,
            passEmptyOptions = _this$state.passEmptyOptions;
        var options = passEmptyOptions ? [] : inputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectComponent, _extends({}, props, {
          ref: function ref(_ref) {
            _this3.select = _ref;
          },
          options: options,
          isLoading: isLoading,
          onInputChange: this.handleInputChange
        }));
      }
    }]);

    return Async;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _defineProperty(_class, "defaultProps", defaultProps$2), _temp;
};
var SelectState = manageState(Select);
var Async = makeAsyncSelect(SelectState);

var compareOption = function compareOption() {
  var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var option = arguments.length > 1 ? arguments[1] : undefined;
  var candidate = String(inputValue).toLowerCase();
  var optionValue = String(option.value).toLowerCase();
  var optionLabel = String(option.label).toLowerCase();
  return optionValue === candidate || optionLabel === candidate;
};

var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return "Create \"".concat(inputValue, "\"");
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions) {
    return !(!inputValue || selectValue.some(function (option) {
      return compareOption(inputValue, option);
    }) || selectOptions.some(function (option) {
      return compareOption(inputValue, option);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};
var defaultProps$3 = _objectSpread({
  allowCreateWhileLoading: false,
  createOptionPosition: 'last'
}, builtins);
var makeCreatableSelect = function makeCreatableSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Creatable, _Component);

    function Creatable(props) {
      var _this;

      _classCallCheck(this, Creatable);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Creatable).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (newValue, actionMeta) {
        var _this$props = _this.props,
            getNewOptionData = _this$props.getNewOptionData,
            inputValue = _this$props.inputValue,
            isMulti = _this$props.isMulti,
            onChange = _this$props.onChange,
            onCreateOption = _this$props.onCreateOption,
            value = _this$props.value;

        if (actionMeta.action !== 'select-option') {
          return onChange(newValue, actionMeta);
        }

        var newOption = _this.state.newOption;
        var valueArray = Array.isArray(newValue) ? newValue : [newValue];

        if (valueArray[valueArray.length - 1] === newOption) {
          if (onCreateOption) onCreateOption(inputValue);else {
            var newOptionData = getNewOptionData(inputValue, inputValue);
            var newActionMeta = {
              action: 'create-option'
            };

            if (isMulti) {
              onChange([].concat(_toConsumableArray(cleanValue(value)), [newOptionData]), newActionMeta);
            } else {
              onChange(newOptionData, newActionMeta);
            }
          }
          return;
        }

        onChange(newValue, actionMeta);
      });

      var options = props.options || [];
      _this.state = {
        newOption: undefined,
        options: options
      };
      return _this;
    }

    _createClass(Creatable, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        var allowCreateWhileLoading = nextProps.allowCreateWhileLoading,
            createOptionPosition = nextProps.createOptionPosition,
            formatCreateLabel = nextProps.formatCreateLabel,
            getNewOptionData = nextProps.getNewOptionData,
            inputValue = nextProps.inputValue,
            isLoading = nextProps.isLoading,
            isValidNewOption = nextProps.isValidNewOption,
            value = nextProps.value;
        var options = nextProps.options || [];
        var newOption = this.state.newOption;

        if (isValidNewOption(inputValue, cleanValue(value), options)) {
          newOption = getNewOptionData(inputValue, formatCreateLabel(inputValue));
        } else {
          newOption = undefined;
        }

        this.setState({
          newOption: newOption,
          options: (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat(_toConsumableArray(options)) : [].concat(_toConsumableArray(options), [newOption]) : options
        });
      }
    }, {
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var props = _extends({}, this.props);

        var options = this.state.options;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectComponent, _extends({}, props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          options: options,
          onChange: this.onChange
        }));
      }
    }]);

    return Creatable;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _defineProperty(_class, "defaultProps", defaultProps$3), _temp;
}; // TODO: do this in package entrypoint

var SelectCreatable = makeCreatableSelect(Select);
var Creatable = manageState(SelectCreatable);

var SelectCreatable$1 = makeCreatableSelect(Select);
var SelectCreatableState = manageState(SelectCreatable$1);
var AsyncCreatable = makeAsyncSelect(SelectCreatableState);

// strip transition props off before spreading onto select component
// note we need to be explicit about innerRef for flow
var AnimatedInput = function AnimatedInput(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        appear = _ref.appear,
        enter = _ref.enter,
        exit = _ref.exit,
        props = _objectWithoutProperties(_ref, ["in", "onExited", "appear", "enter", "exit"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, props);
  };
};

var Fade = function Fade(_ref) {
  var Tag = _ref.component,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 1 : _ref$duration,
      inProp = _ref.in,
      onExited = _ref.onExited,
      props = _objectWithoutProperties(_ref, ["component", "duration", "in", "onExited"]);

  var transition = {
    entering: {
      opacity: 0
    },
    entered: {
      opacity: 1,
      transition: "opacity ".concat(duration, "ms")
    },
    exiting: {
      opacity: 0
    },
    exited: {
      opacity: 0
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__["Transition"], {
    mountOnEnter: true,
    unmountOnExit: true,
    in: inProp,
    timeout: duration
  }, function (state) {
    var innerProps = {
      style: _objectSpread({}, transition[state])
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
      innerProps: innerProps
    }, props));
  });
}; // ==============================
// Collapse Transition
// ==============================

var collapseDuration = 260;
// wrap each MultiValue with a collapse transition; decreases width until
// finally removing from DOM
var Collapse =
/*#__PURE__*/
function (_Component) {
  _inherits(Collapse, _Component);

  function Collapse() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Collapse);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Collapse)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "duration", collapseDuration);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "rafID", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      width: 'auto'
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "transition", {
      exiting: {
        width: 0,
        transition: "width ".concat(_this.duration, "ms ease-out")
      },
      exited: {
        width: 0
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getWidth", function (ref) {
      if (ref && isNaN(_this.state.width)) {
        /*
          Here we're invoking requestAnimationFrame with a callback invoking our
          call to getBoundingClientRect and setState in order to resolve an edge case
          around portalling. Certain portalling solutions briefly remove children from the DOM
          before appending them to the target node. This is to avoid us trying to call getBoundingClientrect
          while the Select component is in this state.
        */
        // cannot use `offsetWidth` because it is rounded
        _this.rafID = window.requestAnimationFrame(function () {
          var _ref$getBoundingClien = ref.getBoundingClientRect(),
              width = _ref$getBoundingClien.width;

          _this.setState({
            width: width
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getStyle", function (width) {
      return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: width
      };
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getTransition", function (state) {
      return _this.transition[state];
    });

    return _this;
  }

  _createClass(Collapse, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.rafID) {
        window.cancelAnimationFrame(this.rafID);
      }
    } // width must be calculated; cannot transition from `undefined` to `number`

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          inProp = _this$props.in;
      var width = this.state.width;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__["Transition"], {
        enter: false,
        mountOnEnter: true,
        unmountOnExit: true,
        in: inProp,
        timeout: this.duration
      }, function (state) {
        var style = _objectSpread({}, _this2.getStyle(width), _this2.getTransition(state));

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          ref: _this2.getWidth,
          style: style
        }, children);
      });
    }
  }]);

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var AnimatedMultiValue = function AnimatedMultiValue(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        props = _objectWithoutProperties(_ref, ["in", "onExited"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Collapse, {
      in: inProp,
      onExited: onExited
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
      cropWithEllipsis: inProp
    }, props)));
  };
};

var AnimatedPlaceholder = function AnimatedPlaceholder(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Fade, _extends({
      component: WrappedComponent,
      duration: props.isMulti ? collapseDuration : 1
    }, props));
  };
};

var AnimatedSingleValue = function AnimatedSingleValue(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Fade, _extends({
      component: WrappedComponent
    }, props));
  };
};

// make ValueContainer a transition group
var AnimatedValueContainer = function AnimatedValueContainer(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__["TransitionGroup"], _extends({
      component: WrappedComponent
    }, props));
  };
};

var makeAnimated = function makeAnimated() {
  var externalComponents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var components$$1 = defaultComponents({
    components: externalComponents
  });

  var Input = components$$1.Input,
      MultiValue = components$$1.MultiValue,
      Placeholder = components$$1.Placeholder,
      SingleValue = components$$1.SingleValue,
      ValueContainer = components$$1.ValueContainer,
      rest = _objectWithoutProperties(components$$1, ["Input", "MultiValue", "Placeholder", "SingleValue", "ValueContainer"]);

  return _objectSpread({
    Input: AnimatedInput(Input),
    MultiValue: AnimatedMultiValue(MultiValue),
    Placeholder: AnimatedPlaceholder(Placeholder),
    SingleValue: AnimatedSingleValue(SingleValue),
    ValueContainer: AnimatedValueContainer(ValueContainer)
  }, rest);
};

var AnimatedComponents = makeAnimated();
var Input$1 = AnimatedComponents.Input;
var MultiValue$1 = AnimatedComponents.MultiValue;
var Placeholder$1 = AnimatedComponents.Placeholder;
var SingleValue$1 = AnimatedComponents.SingleValue;
var ValueContainer$1 = AnimatedComponents.ValueContainer;
var index = Object(__WEBPACK_IMPORTED_MODULE_1_memoize_one__["a" /* default */])(makeAnimated, exportedEqual);

var index$1 = manageState(Select);

/* harmony default export */ __webpack_exports__["a"] = (index$1);



/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeOne);


/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export flush */
/* unused harmony export hydrate */
/* unused harmony export cx */
/* unused harmony export merge */
/* unused harmony export getRegisteredStyles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return injectGlobal; });
/* unused harmony export keyframes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return css; });
/* unused harmony export sheet */
/* unused harmony export caches */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_emotion__ = __webpack_require__(597);


var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = Object(__WEBPACK_IMPORTED_MODULE_0_create_emotion__["a" /* default */])(context),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    caches = _createEmotion.caches;



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(18)))

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_hash__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__);






var hyphenateRegex = /[A-Z]|^ms/g;
var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (styleName) {
  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
  !isNaN(value) && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    return oldProcessStyleValue(key, value);
  };
}

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'function':
        if (false) {
          console.error('Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\n' + 'Please call the function before passing it to cx.');
        }

        toAdd = classnames([arg()]);
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};
var isBrowser = typeof document !== 'undefined';

/*

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side

// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject()
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function makeStyleTag(opts) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', opts.key || '');

  if (opts.nonce !== undefined) {
    tag.setAttribute('nonce', opts.nonce);
  }

  tag.appendChild(document.createTextNode('')) // $FlowFixMe
  ;
  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = "production" === 'production'; // the big drawback here is that the css won't be editable in devtools

    this.tags = [];
    this.ctr = 0;
    this.opts = options;
  }

  var _proto = StyleSheet.prototype;

  _proto.inject = function inject() {
    if (this.injected) {
      throw new Error('already injected!');
    }

    this.tags[0] = makeStyleTag(this.opts);
    this.injected = true;
  };

  _proto.speedy = function speedy(bool) {
    if (this.ctr !== 0) {
      // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
      throw new Error("cannot change speedy now");
    }

    this.isSpeedy = !!bool;
  };

  _proto.insert = function insert(rule, sourceMap) {
    // this is the ultrafast version, works across browsers
    if (this.isSpeedy) {
      var tag = this.tags[this.tags.length - 1];
      var sheet = sheetForTag(tag);

      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.warn('illegal rule', rule); // eslint-disable-line no-console
        }
      }
    } else {
      var _tag = makeStyleTag(this.opts);

      this.tags.push(_tag);

      _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
    }

    this.ctr++;

    if (this.ctr % 65000 === 0) {
      this.tags.push(makeStyleTag(this.opts));
    }
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0; // todo - look for remnants in document.styleSheets

    this.injected = false;
  };

  return StyleSheet;
}();

function createEmotion(context, options) {
  if (context.__SECRET_EMOTION__ !== undefined) {
    return context.__SECRET_EMOTION__;
  }

  if (options === undefined) options = {};
  var key = options.key || 'css';

  if (false) {
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var current;

  function insertRule(rule) {
    current += rule;

    if (isBrowser) {
      sheet.insert(rule, currentSourceMap);
    }
  }

  var insertionPlugin = __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default()(insertRule);
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var caches = {
    registered: {},
    inserted: {},
    nonce: options.nonce,
    key: key
  };
  var sheet = new StyleSheet(options);

  if (isBrowser) {
    // 🚀
    sheet.inject();
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__["a" /* default */](stylisOptions);
  stylis.use(options.stylisPlugins)(insertionPlugin);
  var currentSourceMap = '';

  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) {
      return '';
    }

    switch (typeof interpolation) {
      case 'boolean':
        return '';

      case 'function':
        if (interpolation.__emotion_styles !== undefined) {
          var selector = interpolation.toString();

          if (selector === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          return selector;
        }

        if (this === undefined && "production" !== 'production') {
          console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);

      case 'object':
        return createStringFromObject.call(this, interpolation);

      default:
        var cached = caches.registered[interpolation];
        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
    }
  }

  var objectToStringCache = new WeakMap();

  function createStringFromObject(obj) {
    if (objectToStringCache.has(obj)) {
      // $FlowFixMe
      return objectToStringCache.get(obj);
    }

    var string = '';

    if (Array.isArray(obj)) {
      obj.forEach(function (interpolation) {
        string += handleInterpolation.call(this, interpolation, false);
      }, this);
    } else {
      Object.keys(obj).forEach(function (key) {
        if (typeof obj[key] !== 'object') {
          if (caches.registered[obj[key]] !== undefined) {
            string += key + "{" + caches.registered[obj[key]] + "}";
          } else {
            string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
          }
        } else {
          if (key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
            obj[key].forEach(function (value) {
              string += processStyleName(key) + ":" + processStyleValue(key, value) + ";";
            });
          } else {
            string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
          }
        }
      }, this);
    }

    objectToStringCache.set(obj, string);
    return string;
  }

  var name;
  var stylesWithLabel;
  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;

  var createClassName = function createClassName(styles, identifierName) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__emotion_hash__["a" /* default */])(styles + identifierName) + identifierName;
  };

  if (false) {
    var oldCreateClassName = createClassName;
    var sourceMappingUrlPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;

    createClassName = function createClassName(styles, identifierName) {
      return oldCreateClassName(styles.replace(sourceMappingUrlPattern, function (sourceMap) {
        currentSourceMap = sourceMap;
        return '';
      }), identifierName);
    };
  }

  var createStyles = function createStyles(strings) {
    var stringMode = true;
    var styles = '';
    var identifierName = '';

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation.call(this, strings, false);
    } else {
      styles += strings[0];
    }

    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    interpolations.forEach(function (interpolation, i) {
      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
      );

      if (stringMode === true && strings[i + 1] !== undefined) {
        styles += strings[i + 1];
      }
    }, this);
    stylesWithLabel = styles;
    styles = styles.replace(labelPattern, function (match, p1) {
      identifierName += "-" + p1;
      return '';
    });
    name = createClassName(styles, identifierName);
    return styles;
  };

  if (false) {
    var oldStylis = stylis;

    stylis = function stylis(selector, styles) {
      oldStylis(selector, styles);
      currentSourceMap = '';
    };
  }

  function insert(scope, styles) {
    if (caches.inserted[name] === undefined) {
      current = '';
      stylis(scope, styles);
      caches.inserted[name] = current;
    }
  }

  var css = function css() {
    var styles = createStyles.apply(this, arguments);
    var selector = key + "-" + name;

    if (caches.registered[selector] === undefined) {
      caches.registered[selector] = stylesWithLabel;
    }

    insert("." + selector, styles);
    return selector;
  };

  var keyframes = function keyframes() {
    var styles = createStyles.apply(this, arguments);
    var animation = "animation-" + name;
    insert('', "@keyframes " + animation + "{" + styles + "}");
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    var styles = createStyles.apply(this, arguments);
    insert('', styles);
  };

  function getRegisteredStyles(registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (caches.registered[className] !== undefined) {
        registeredStyles.push(className);
      } else {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }

  function merge(className, sourceMap) {
    var registeredStyles = [];
    var rawClassName = getRegisteredStyles(registeredStyles, className);

    if (registeredStyles.length < 2) {
      return className;
    }

    return rawClassName + css(registeredStyles, sourceMap);
  }

  function cx() {
    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      classNames[_key2] = arguments[_key2];
    }

    return merge(classnames(classNames));
  }

  function hydrateSingleId(id) {
    caches.inserted[id] = true;
  }

  function hydrate(ids) {
    ids.forEach(hydrateSingleId);
  }

  function flush() {
    if (isBrowser) {
      sheet.flush();
      sheet.inject();
    }

    caches.inserted = {};
    caches.registered = {};
  }

  if (isBrowser) {
    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
    Array.prototype.forEach.call(chunks, function (node) {
      // $FlowFixMe
      sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe

      node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
    });
  }

  var emotion = {
    flush: flush,
    hydrate: hydrate,
    cx: cx,
    merge: merge,
    getRegisteredStyles: getRegisteredStyles,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    css: css,
    sheet: sheet,
    caches: caches
  };
  context.__SECRET_EMOTION__ = emotion;
  return emotion;
}

/* harmony default export */ __webpack_exports__["a"] = (createEmotion);


/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash2_32_gc(str) {
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmurhash2_32_gc);


/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e, m).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e, m).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        switch (d.constructor) {
          case Array:
            for (var c = 0, e = d.length; c < e; ++c) {
              T(d[c]);
            }

            break;

          case Function:
            S[A++] = d;
            break;

          case Boolean:
            Y = !!d | 0;
        }

    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(604)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'UNSAFE_componentWillReceiveProps',
		value: function UNSAFE_componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(607));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(608));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(203));

var _Transition = _interopRequireDefault(__webpack_require__(200));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(7));

var _addClass = _interopRequireDefault(__webpack_require__(166));

var _removeClass = _interopRequireDefault(__webpack_require__(167));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(200));

var _PropTypes = __webpack_require__(202);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var appearClassName = _this.getClassNames('appear').doneClassName;

      var enterClassName = _this.getClassNames('enter').doneClassName;

      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames5.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var className = isStringClassNames ? prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames6 = this.getClassNames(type),
        className = _this$getClassNames6.className,
        activeClassName = _this$getClassNames6.activeClassName,
        doneClassName = _this$getClassNames6.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or
   * has finished the transition. A single name can be provided and it will be
   * suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(35);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(203));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_SettingsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_FundsActions__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_util_CurrencyFormatInput__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SettingsMenu__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TagInput__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__campaignSettings_CampaignSettings__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ApplyCancelInput__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__UpdateSelect__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__paymentSettings_ReturnAddress__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__paymentSettings_Signatures__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__CloudPrint__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__FlushAiSummaries__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__paymentSettings_CurrencyConversionInput__ = __webpack_require__(624);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SystemSettingsPage=function(_React$Component){_inherits(SystemSettingsPage,_React$Component);function SystemSettingsPage(){_classCallCheck(this,SystemSettingsPage);return _possibleConstructorReturn(this,(SystemSettingsPage.__proto__||Object.getPrototypeOf(SystemSettingsPage)).apply(this,arguments));}_createClass(SystemSettingsPage,[{key:'componentWillMount',value:function componentWillMount(){this.props.actions.getSystemSettings();this.props.actions.getFunds();}},{key:'validateEmail',value:function validateEmail(email){var isValid=Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["x" /* isValidEmail */])(email);this.setState({invalidData:!isValid});return isValid;}},{key:'render',value:function render(){var _props=this.props,settings=_props.settings,updatingSettings=_props.updatingSettings,tags=_props.tags,reloadingSettings=_props.reloadingSettings,loading=_props.loading;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-page relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subheader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container flex-justify flex-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SettingsMenu__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-loader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'section-header'},'Payment Settings'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-justify settings-section payment-settings'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half column-half-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ApplyCancelInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__paymentSettings_CurrencyConversionInput__["a" /* default */],null),title:'Shekel Conversion Rate',value:settings.paymentSettings.currencyConversionRate.value,loading:updatingSettings.currencyConversionRate.loading,success:updatingSettings.currencyConversionRate.success,update:this.props.actions.updateSetting.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["h" /* SettingNames */].CurrencyConversionRate,settings.paymentSettings.currencyConversionRate.id)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__paymentSettings_ReturnAddress__["a" /* default */],{address:settings.paymentSettings.returnAddress,addressLabel:Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils__["c" /* concatenateGeosuggestLabel */])(settings.paymentSettings.returnAddress,false),unitTypes:settings.otherSettings.unitTypes,update:this.props.actions.updateReturnAddress,loading:updatingSettings.returnAddress.loading,success:updatingSettings.returnAddress.success})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half column-half-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__paymentSettings_Signatures__["a" /* default */],{signatures:this.props.settings.paymentSettings.signatures,funds:tags.funds,addSignature:this.props.actions.saveSignature,adding:updatingSettings.signatures,reloadPaymentSettings:this.props.actions.getPartialSystemSettings.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["d" /* PartialSettings */].PaymentSettings),loading:reloadingSettings.paymentSettings.loading}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'section-header'},'Recipient Settings'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-justify settings-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half column-half-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TagInput__["a" /* default */],{title:'Individual Categories',values:settings.recipientSettings.individualTags,sort:true,add:this.props.actions.addTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].IndividualTags),name:'category',adding:updatingSettings.individualTags.add,deleting:updatingSettings.individualTags.delete,'delete':this.props.actions.deleteTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].IndividualTags)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TagInput__["a" /* default */],{title:'US Person Titles',values:settings.recipientSettings.usPersonTitles,sort:true,add:this.props.actions.addTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].USPersonTitles),name:'title',adding:updatingSettings.usPersonTitles.add,deleting:updatingSettings.usPersonTitles.delete,'delete':this.props.actions.deleteTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].USPersonTitles),allowUpdate:true,update:this.props.actions.updateTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].USPersonTitles),updating:updatingSettings.usPersonTitles.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TagInput__["a" /* default */],{title:'Israel Person Titles',values:settings.recipientSettings.israelPersonTitles,sort:true,add:this.props.actions.addTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].IsraelPersonTitles),name:'title',adding:updatingSettings.israelPersonTitles.add,deleting:updatingSettings.israelPersonTitles.delete,'delete':this.props.actions.deleteTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].IsraelPersonTitles),allowUpdate:true,update:this.props.actions.updateTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].IsraelPersonTitles),updating:updatingSettings.israelPersonTitles.update})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half column-half-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TagInput__["a" /* default */],{title:'Organization Categories',values:settings.recipientSettings.organizationTags,sort:true,add:this.props.actions.addTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].OrganizationTags),name:'category',adding:updatingSettings.organizationTags.add,deleting:updatingSettings.organizationTags.delete,'delete':this.props.actions.deleteTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].OrganizationTags)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TagInput__["a" /* default */],{title:'US Institution Titles',values:settings.recipientSettings.usInstitutionTitles,sort:true,add:this.props.actions.addTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].USInstitutionTitles),name:'title',adding:updatingSettings.usInstitutionTitles.add,deleting:updatingSettings.usInstitutionTitles.delete,'delete':this.props.actions.deleteTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].USInstitutionTitles),allowUpdate:true,update:this.props.actions.updateTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].USInstitutionTitles),updating:updatingSettings.usInstitutionTitles.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TagInput__["a" /* default */],{title:'Israel Institution Titles',values:settings.recipientSettings.israelInstitutionTitles,sort:true,add:this.props.actions.addTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].IsraelInstitutionTitles),name:'title',adding:updatingSettings.israelInstitutionTitles.add,deleting:updatingSettings.israelInstitutionTitles.delete,'delete':this.props.actions.deleteTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].IsraelInstitutionTitles),allowUpdate:true,update:this.props.actions.updateTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].IsraelInstitutionTitles),updating:updatingSettings.israelInstitutionTitles.update}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'section-header'},'Application Settings'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-justify settings-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half column-half-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TagInput__["a" /* default */],{title:'Individual Application Reasons',values:settings.applicationSettings.individualApplicationReasons,add:this.props.actions.addTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].IndividualApplicationReasons),name:'reason',adding:updatingSettings.individualApplicationReasons.add,deleting:updatingSettings.individualApplicationReasons.delete,'delete':this.props.actions.deleteTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].IndividualApplicationReasons)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half column-half-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TagInput__["a" /* default */],{title:'Organization Application Reasons',values:settings.applicationSettings.organizationApplicationReasons,add:this.props.actions.addTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].OrganizationApplicationReasons),name:'reason',adding:updatingSettings.organizationApplicationReasons.add,deleting:updatingSettings.organizationApplicationReasons.delete,'delete':this.props.actions.deleteTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].OrganizationApplicationReasons)}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'section-header'},'Campaign Settings'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half column-half-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ApplyCancelInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text'}),title:'Email From Address',value:settings.campaignSettings.fromEmailAddress.value,loading:updatingSettings.fromEmailAddress.loading,success:updatingSettings.fromEmailAddress.success,update:this.props.actions.updateSetting.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["h" /* SettingNames */].FromEmailAddress,settings.campaignSettings.fromEmailAddress.id),validate:this.validateEmail.bind(this),errorMessage:'Invalid Email Address'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__campaignSettings_CampaignSettings__["a" /* default */],{settings:settings.campaignSettings,categories:updatingSettings.campaignCategories,individualCategories:updatingSettings.campaignIndivCategories,locations:updatingSettings.campaignLocationGroups,addSetting:this.props.actions.addTag,deleteSetting:this.props.actions.deleteTag,updateLocationGroup:this.props.actions.updateLocationGroup,reloadCampaignSettings:this.props.actions.getPartialSystemSettings.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["d" /* PartialSettings */].CampaignSettings),loading:reloadingSettings.campaignSettings.loading,categoryTypes:settings.otherSettings.campaignCategories}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'section-header'},'Fund Settings'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-justify'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half column-half-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__UpdateSelect__["a" /* default */],{title:'Default US Fund',options:tags.usFunds,value:settings.fundSettings.defaultUSFund,update:this.props.actions.updateDefaultFund.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["h" /* SettingNames */].DefaultUSFund),loading:updatingSettings.defaultUSFund.loading,success:updatingSettings.defaultUSFund.success})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half column-half-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__UpdateSelect__["a" /* default */],{title:'Default IL Fund',options:tags.israelFunds,value:settings.fundSettings.defaultIsraelFund,update:this.props.actions.updateDefaultFund.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["h" /* SettingNames */].DefaultILFund),loading:updatingSettings.defaultIsraelFund.loading,success:updatingSettings.defaultIsraelFund.success}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-justify'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half column-half-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TagInput__["a" /* default */],{title:'Banks',values:settings.fundSettings.banks,add:this.props.actions.addTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].Banks),name:'bank',adding:updatingSettings.banks.add,deleting:updatingSettings.banks.delete,'delete':this.props.actions.deleteTag.bind(this,__WEBPACK_IMPORTED_MODULE_6__lib_constants__["l" /* TagNames */].Banks)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half column-half-right'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'section-header'},'Admin Tools'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'settings-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-justify'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half column-half-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__FlushAiSummaries__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half column-half-right'}))))));}}]);return SystemSettingsPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);function mapStateToProps(state,ownProps){return{loading:state.settings.systemSettings.loading||state.funds.fundsByDept.loading,settings:Object.assign({},state.settings.systemSettings.data),tags:{funds:state.funds.fundsByDept.all,israelFunds:state.funds.fundsByDept.IL,usFunds:state.funds.fundsByDept.US},updatingSettings:Object.assign({},state.systemSettings),reloadingSettings:Object.assign({},state.settings.systemSettings.reloading)};}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])(Object.assign({},__WEBPACK_IMPORTED_MODULE_3__redux_actions_SettingsActions__,{getFunds:__WEBPACK_IMPORTED_MODULE_4__redux_actions_FundsActions__["getFunds"]}),dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(SystemSettingsPage));

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CampaignCategoryInput__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CampaignCategoryModal__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationGroupModal__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LocationGroupInput__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TagInput__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_constants__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignSettings=function(_React$Component){_inherits(CampaignSettings,_React$Component);function CampaignSettings(props){_classCallCheck(this,CampaignSettings);var _this=_possibleConstructorReturn(this,(CampaignSettings.__proto__||Object.getPrototypeOf(CampaignSettings)).call(this,props));_this.state={modals:{campaignCategory:false,locationGroups:false},editLocationGroup:{groupName:'',members:[]}};return _this;}_createClass(CampaignSettings,[{key:'editLocationGroup',value:function editLocationGroup(groupId){var _this2=this;var index=this.props.settings.locationGroups.map(function(g){return g.groupId;}).indexOf(groupId);var group=this.props.settings.locationGroups[index];if(group){this.setState({editLocationGroup:group},function(){return _this2.toggleModal('locationGroups');});}}},{key:'closeLocationGroupModal',value:function closeLocationGroupModal(){var _this3=this;this.setState({editLocationGroup:{groupName:'',members:[]}},function(){return _this3.toggleModal('locationGroups');});}},{key:'toggleModal',value:function toggleModal(name){this.setState({modals:Object.assign({},this.state.modals,_defineProperty({},name,!this.state.modals[name]))});}},{key:'render',value:function render(){var _props$settings=this.props.settings,categories=_props$settings.categories,campaignIndivCategories=_props$settings.campaignIndivCategories,locationGroups=_props$settings.locationGroups;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-justify settings-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half column-half-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CampaignCategoryInput__["a" /* default */],{campaignCategories:categories,'delete':this.props.deleteSetting.bind(null,__WEBPACK_IMPORTED_MODULE_7__lib_constants__["l" /* TagNames */].CampaignCategories),showModal:this.toggleModal.bind(this,'campaignCategory'),deleting:this.props.categories.delete})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-half column-half-right relative'},this.props.loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'location-spinner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'32'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__LocationGroupInput__["a" /* default */],{locationGroups:locationGroups,showModal:this.toggleModal.bind(this,'locationGroups'),'delete':this.props.deleteSetting.bind(null,__WEBPACK_IMPORTED_MODULE_7__lib_constants__["l" /* TagNames */].LocationGroups),onClick:this.editLocationGroup.bind(this),deleting:this.props.locations.delete}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:"-16px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TagInput__["a" /* default */],{title:'Campaign Individual Categories',values:campaignIndivCategories,add:this.props.addSetting.bind(null,__WEBPACK_IMPORTED_MODULE_7__lib_constants__["l" /* TagNames */].CampaignIndivCategories),name:'campaign individual category',adding:this.props.individualCategories.add,deleting:this.props.individualCategories.delete,'delete':this.props.deleteSetting.bind(null,__WEBPACK_IMPORTED_MODULE_7__lib_constants__["l" /* TagNames */].CampaignIndivCategories)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CampaignCategoryModal__["a" /* default */],{loading:this.props.categories.add.loading,success:this.props.categories.add.success,show:this.state.modals.campaignCategory,close:this.toggleModal.bind(this,'campaignCategory'),campaignTypes:this.props.categoryTypes,addCategory:this.props.addSetting.bind(null,__WEBPACK_IMPORTED_MODULE_7__lib_constants__["l" /* TagNames */].CampaignCategories)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__LocationGroupModal__["a" /* default */],{loading:this.props.locations.add.loading||this.props.locations.update.loading,addingSuccess:this.props.locations.add.success,updatingSuccess:this.props.locations.update.success,show:this.state.modals.locationGroups,close:this.closeLocationGroupModal.bind(this),reloadCampaignSettings:this.props.reloadCampaignSettings,addLocationGroup:this.props.addSetting.bind(null,__WEBPACK_IMPORTED_MODULE_7__lib_constants__["l" /* TagNames */].LocationGroups),locationGroup:this.state.editLocationGroup,updateLocationGroup:this.props.updateLocationGroup.bind(null,this.state.editLocationGroup.groupId)}));}}]);return CampaignSettings;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CampaignSettings);

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignCategoryInput=function(_React$Component){_inherits(CampaignCategoryInput,_React$Component);function CampaignCategoryInput(props){_classCallCheck(this,CampaignCategoryInput);var _this=_possibleConstructorReturn(this,(CampaignCategoryInput.__proto__||Object.getPrototypeOf(CampaignCategoryInput)).call(this,props));_this.state={deletingError:false,errorMessage:''};return _this;}_createClass(CampaignCategoryInput,[{key:'showModal',value:function showModal(){if(this.state.deletingError||this.state.errorMessage)this.setState({deletingError:false,errorMessage:''});this.props.showModal();}},{key:'deleteSetting',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(this.state.deletingError||this.state.errorMessage)this.setState({deletingError:false,errorMessage:''});_context.next=3;return this.props.delete(id);case 3:if(this.props.deleting[id]&&!this.props.deleting[id].success){if(this.props.deleting[id]&&this.props.deleting[id].message)this.setState({errorMessage:this.props.deleting[id].message});else this.setState({deletingError:true});}case 4:case'end':return _context.stop();}}},_callee,this);}));function deleteSetting(_x){return _ref.apply(this,arguments);}return deleteSetting;}()},{key:'render',value:function render(){var _this2=this;var campaignCategories=this.props.campaignCategories;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-justify flex-center signature-label'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Campaign Categories'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'link-text xs-text',onClick:this.showModal.bind(this)},'Add New')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chip-container'},campaignCategories.map(function(category,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chip',key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,category.name,' - ',category.campaignType),_this2.props.deleting[category.campaignCategoryId]&&_this2.props.deleting[category.campaignCategoryId].loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_LoadingSpinner__["a" /* default */],{loading:_this2.props.deleting[category.campaignCategoryId]&&_this2.props.deleting[category.campaignCategoryId].success}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons delete-chip',onClick:_this2.deleteSetting.bind(_this2,category.campaignCategoryId)},'close'));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.deletingError||this.state.errorMessage,message:this.state.errorMessage||"Could not delete setting",timeOut:5000}));}}]);return CampaignCategoryInput;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);//campaignCategories, delete, showModal, deleting (adding is shown on modal)....
/* harmony default export */ __webpack_exports__["a"] = (CampaignCategoryInput);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignCategoryModal=function(_React$Component){_inherits(CampaignCategoryModal,_React$Component);function CampaignCategoryModal(props){_classCallCheck(this,CampaignCategoryModal);var _this=_possibleConstructorReturn(this,(CampaignCategoryModal.__proto__||Object.getPrototypeOf(CampaignCategoryModal)).call(this,props));_this.state={campaign:{name:'',campaignType:''},error:false,submitAttempted:false};_this.onChange=_this.onChange.bind(_this);_this.onSubmit=_this.onSubmit.bind(_this);_this.onClose=_this.onClose.bind(_this);return _this;}_createClass(CampaignCategoryModal,[{key:'onChange',value:function onChange(name,value){this.setState({campaign:Object.assign({},this.state.campaign,_defineProperty({},name,value))});}},{key:'onSubmit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var campaign;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({error:false,submitAttempted:true});campaign=this.state.campaign;if(!(!campaign.name||!campaign.campaignType)){_context.next=4;break;}return _context.abrupt('return');case 4:_context.next=6;return this.props.addCategory(this.state.campaign);case 6:if(this.props.success)this.onClose();else this.setState({error:true});case 7:case'end':return _context.stop();}}},_callee,this);}));function onSubmit(){return _ref.apply(this,arguments);}return onSubmit;}()},{key:'onClose',value:function onClose(){this.props.close();this.setState({campaign:{name:'',campaignType:''},error:false,submitAttempted:false});}},{key:'render',value:function render(){var campaign=this.state.campaign;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal new-transaction-modal large-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},'Create Campaign Category'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.onClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'Campaign Category Name',name:'name',value:campaign.name,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Select__["a" /* default */],{clearable:true,options:this.props.campaignTypes}),label:'Type',name:'campaignType',value:campaign.campaignType,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})))),this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.onClose},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',onClick:this.onSubmit},'Save'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error})))));}}]);return CampaignCategoryModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CampaignCategoryModal);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_RadioGroup__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CityInput__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LocationGroupModal=function(_React$Component){_inherits(LocationGroupModal,_React$Component);function LocationGroupModal(props){_classCallCheck(this,LocationGroupModal);var _this=_possibleConstructorReturn(this,(LocationGroupModal.__proto__||Object.getPrototypeOf(LocationGroupModal)).call(this,props));_this.state={locationGroup:{groupName:'',department:__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["g" /* Departments */].US,members:[]},groupId:'',error:false,submitAttempted:false};_this.onChange=_this.onChange.bind(_this);_this.onSubmit=_this.onSubmit.bind(_this);_this.onClose=_this.onClose.bind(_this);return _this;}_createClass(LocationGroupModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!Object(__WEBPACK_IMPORTED_MODULE_9__lib_utils__["e" /* deepEquals */])(nextProps.locationGroup,this.props.locationGroup)&&nextProps.locationGroup.groupId){var _nextProps$locationGr=nextProps.locationGroup,groupName=_nextProps$locationGr.groupName,members=_nextProps$locationGr.members,department=_nextProps$locationGr.department;this.setState({locationGroup:{groupName:groupName,members:members,department:department}});}}},{key:'onChange',value:function onChange(name,value){this.setState({locationGroup:Object.assign({},this.state.locationGroup,_defineProperty({},name,value))});}},{key:'updateDepartment',value:function updateDepartment(name,value){var _Object$assign2;this.setState({locationGroup:Object.assign({},this.state.locationGroup,(_Object$assign2={},_defineProperty(_Object$assign2,name,value),_defineProperty(_Object$assign2,'members',[]),_Object$assign2))});}},{key:'onSubmit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var locationGroup;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({error:false,submitAttempted:true});locationGroup=Object.assign({},{groupName:this.state.locationGroup.groupName,department:this.state.locationGroup.department,members:[].concat(_toConsumableArray(this.state.locationGroup.members))});if(!(!locationGroup.groupName||locationGroup.department===__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["g" /* Departments */].US&&!locationGroup.members.length)){_context.next=4;break;}return _context.abrupt('return');case 4:if(!this.props.locationGroup.members.length){_context.next=11;break;}delete locationGroup.department;_context.next=8;return this.props.updateLocationGroup(locationGroup);case 8:if(this.props.updatingSuccess){this.props.reloadCampaignSettings();this.onClose();}else this.setState({error:true});_context.next=15;break;case 11://This is in order for the backend to know that this location group is for any recipient with an address that has country of ישראל
if(!locationGroup.members.length&&locationGroup.department===__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["g" /* Departments */].IL)locationGroup.members.push({city:'',state:'',country:'ישראל'});_context.next=14;return this.props.addLocationGroup(locationGroup);case 14:if(this.props.addingSuccess){this.props.reloadCampaignSettings();this.onClose();}else this.setState({error:true});case 15:case'end':return _context.stop();}}},_callee,this);}));function onSubmit(){return _ref.apply(this,arguments);}return onSubmit;}()},{key:'onClose',value:function onClose(){this.props.close();this.setState({locationGroup:{groupName:'',members:[],department:__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["g" /* Departments */].US},error:false,submitAttempted:false});}},{key:'render',value:function render(){var _this2=this;var locationGroup=this.state.locationGroup;var disabled=false;var editMode=false;if(this.props.locationGroup.members.length){editMode=true;var _locationGroup=Object.assign({},this.props.locationGroup);delete _locationGroup.groupId;if(Object(__WEBPACK_IMPORTED_MODULE_9__lib_utils__["e" /* deepEquals */])(_locationGroup,this.state.locationGroup))disabled=true;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal new-transaction-modal large-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},editMode?'Edit':'Add New',' Location Group'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.onClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row modal-row-full-width'},editMode?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Department'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,locationGroup.department)):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_RadioGroup__["a" /* default */],{onChange:this.updateDepartment.bind(this),options:[{key:__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["g" /* Departments */].US,value:'US - $ - Check Printing'},{key:__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["g" /* Departments */].IL,value:'IL - ₪ - Wiring'}],title:'Which department is this location group for?',name:'department',value:locationGroup.department})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row modal-row-full-width'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'Location Group Name',name:'groupName',value:locationGroup.groupName,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row modal-row-full-width'},editMode&&locationGroup.department===__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["g" /* Departments */].IL&&locationGroup.members.length===1&&!locationGroup.members[0].city?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'This location group includes all cities in \u05D9\u05E9\u05E8\u05D0\u05DC.'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CityInput__["a" /* default */],{isIsraeli:locationGroup.department===__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["g" /* Departments */].IL,required:locationGroup.department===__WEBPACK_IMPORTED_MODULE_8__lib_systemVariables__["g" /* Departments */].US,showRequiredError:this.state.submitAttempted,values:locationGroup.members,updateValues:function updateValues(vals){return _this2.setState({locationGroup:Object.assign({},_this2.state.locationGroup,{members:vals})});}}))),this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.onClose},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',disabled:disabled,onClick:this.onSubmit},editMode?'Update':'Add'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error})))));}}]);return LocationGroupModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);//pass through departments....
/* harmony default export */ __webpack_exports__["a"] = (LocationGroupModal);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_geosuggest__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_geosuggest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_geosuggest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_shared_GeoSuggestWrapper__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CityInput=function(_React$Component){_inherits(CityInput,_React$Component);function CityInput(props){_classCallCheck(this,CityInput);var _this=_possibleConstructorReturn(this,(CityInput.__proto__||Object.getPrototypeOf(CityInput)).call(this,props));_this.skipSuggest=function(suggest){if(suggest.types.indexOf('locality')<0&&suggest.types.indexOf('sublocality')<0)return true;};_this.state={label:'',noSuggestionsError:false,duplicateError:false,invalidAddress:false};return _this;}_createClass(CityInput,[{key:'clearNoSuggestions',value:function clearNoSuggestions(){if(this.state.noSuggestionsError)this.setState({noSuggestionsError:false});}},{key:'updateSuggestions',value:function updateSuggestions(suggestions){if(this.state.duplicateError||this.state.invalidAddress)this.setState({duplicateError:false,invalidAddress:false});if(suggestions.length&&this.state.label)this.clearNoSuggestions();}},{key:'noSuggestions',value:function noSuggestions(){if(this._geoSuggest.props.value!=='')this.setState({noSuggestionsError:true});}},{key:'onSuggestSelect',value:function onSuggestSelect(suggestion){this.setState({duplicateError:false,invalidAddress:false});if(suggestion&&suggestion.gmaps&&suggestion.gmaps.address_components){var address_components=suggestion.gmaps.address_components;var city=address_components.find(function(obj){return obj.types.includes('locality');})?address_components.find(function(obj){return obj.types.includes('locality');}).long_name:''||address_components.find(function(obj){return obj.types.includes('sublocality');})?address_components.find(function(obj){return obj.types.includes('sublocality');}).long_name:'';var state=address_components.find(function(obj){return obj.types.includes('administrative_area_level_1');})?address_components.find(function(obj){return obj.types.includes('administrative_area_level_1');}).long_name:'';var country=address_components.find(function(obj){return obj.types.includes('country');})?address_components.find(function(obj){return obj.types.includes('country');}).long_name:'';if(this.props.isIsraeli?city&&country:city&&state&&country){if(Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils__["v" /* includesObj */])({city:city,state:state,country:country},[].concat(_toConsumableArray(this.props.values.map(function(value){return{city:value.city,state:value.state,country:value.country};}))))){this.setState({duplicateError:true});return;}this.props.updateValues([].concat(_toConsumableArray(this.props.values),[{city:city,state:state,country:country}]));this.setState({label:''});}else this.setState({invalidAddress:true});this._geoSuggest.blur();}}},{key:'remove',value:function remove(value){var index=this.props.values.indexOf(value);if(index>-1){var values=[].concat(_toConsumableArray(this.props.values));values.splice(index,1);this.props.updateValues(values);}}},{key:'render',value:function render(){var _this2=this;var requiredErr=this.props.showRequiredError&&this.props.required&&!this.props.values.length;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'input-label'},'Campaign Locations'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_shared_GeoSuggestWrapper__["a" /* default */],{isIsraeli:this.props.isIsraeli},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_geosuggest___default.a,{inputClassName:requiredErr||this.state.invalidAddress?"error-input":"",placeholder:'Enter City',queryDelay:0,autoComplete:'on',ref:function ref(el){return _this2._geoSuggest=el;},value:this.state.label,onChange:function onChange(val){return _this2.setState({label:val});},onUpdateSuggests:this.updateSuggestions.bind(this),initialValue:this.state.label,types:['(regions)'],country:this.props.isIsraeli?__WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__["g" /* Departments */].IL:null,skipSuggest:this.skipSuggest,onFocus:this.clearNoSuggestions.bind(this),onSuggestSelect:this.onSuggestSelect.bind(this),onSuggestNoResults:this.noSuggestions.bind(this)}),!!this.props.values.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chip-container'},this.props.values.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chip',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,value.city,', ',value.country==='United States'?value.state:value.country),!value.inUse&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons delete-chip',onClick:_this2.remove.bind(_this2,value)},'close'));}))),this.state.duplicateError&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'error-label'},'Can not add duplicate city'),this.state.invalidAddress&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'error-label'},'Invalid City'),this.state.noSuggestionsError&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'error-label'},'No suggestions'));}}]);return CityInput;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CityInput);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LocationGroupInput=function(_React$Component){_inherits(LocationGroupInput,_React$Component);function LocationGroupInput(props){_classCallCheck(this,LocationGroupInput);var _this=_possibleConstructorReturn(this,(LocationGroupInput.__proto__||Object.getPrototypeOf(LocationGroupInput)).call(this,props));_this.state={deletingError:false,errorMessage:''};return _this;}_createClass(LocationGroupInput,[{key:'showModal',value:function showModal(){if(this.state.deletingError||this.state.errorMessage)this.setState({deletingError:false,errorMessage:''});this.props.showModal();}},{key:'deleteSetting',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(this.state.deletingError||this.state.errorMessage)this.setState({deletingError:false,errorMessage:''});_context.next=3;return this.props.delete(id);case 3:if(this.props.deleting[id]&&!this.props.deleting[id].success){if(this.props.deleting[id]&&this.props.deleting[id].message)this.setState({errorMessage:this.props.deleting[id].message});else this.setState({deletingError:true});}case 4:case'end':return _context.stop();}}},_callee,this);}));function deleteSetting(_x){return _ref.apply(this,arguments);}return deleteSetting;}()},{key:'render',value:function render(){var _this2=this;var locationGroups=this.props.locationGroups;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-justify flex-center signature-label'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Location Groups'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'link-text xs-text',onClick:this.showModal.bind(this)},'Add New')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chip-container'},locationGroups.map(function(group){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'location-tooltip-container',key:group.groupId},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chip'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:_this2.props.onClick.bind(null,group.groupId)},group.groupName),_this2.props.deleting[group.groupId]&&_this2.props.deleting[group.groupId].loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_LoadingSpinner__["a" /* default */],{loading:_this2.props.deleting[group.groupId]&&_this2.props.deleting[group.groupId].success}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons delete-chip',onClick:_this2.deleteSetting.bind(_this2,group.groupId)},'close')),!(group.department===__WEBPACK_IMPORTED_MODULE_4__lib_systemVariables__["g" /* Departments */].IL&&group.members.length===1&&!group.members[0].city)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'location-tooltip'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'bold-text'},group.groupName),' Location Group'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'location-tooltip-chips'},group.members.map(function(member,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'chip',key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,member.city,', ',member.country==='United States'?member.state:member.country));}))));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.deletingError||this.state.errorMessage,message:this.state.errorMessage||"Could not delete setting",timeOut:5000}));}}]);return LocationGroupInput;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (LocationGroupInput);

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ApplyCancelInput=function(_React$Component){_inherits(ApplyCancelInput,_React$Component);function ApplyCancelInput(props){_classCallCheck(this,ApplyCancelInput);var _this=_possibleConstructorReturn(this,(ApplyCancelInput.__proto__||Object.getPrototypeOf(ApplyCancelInput)).call(this,props));_this.state={initialValue:_this.props.value,newValue:_this.props.value,error:false,validationError:_this.props.validate?!_this.props.validate(_this.props.value):false};_this.onChange=_this.onChange.bind(_this);_this.validate=_this.validate.bind(_this);return _this;}_createClass(ApplyCancelInput,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.value!==this.state.initialValue){this.setState({initialValue:nextProps.value,newValue:nextProps.value,validationError:this.props.validate?!this.props.validate(nextProps.value):false});}}},{key:'onChange',value:function onChange(e){var _this2=this;var newValue=e.target.value;this.setState({newValue:newValue},function(){_this2.validate(newValue);});}},{key:'hasValue',value:function hasValue(value){return value&&value.trim()!=='';}},{key:'validate',value:function validate(value){var requiredError=this.props.required&&!this.hasValue(value);var validationError=this.props.validate?!this.props.validate(value):false;this.setState({requiredError:requiredError,validationError:validationError});}},{key:'apply',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({error:false});_context.next=3;return this.props.update(this.state.newValue);case 3:if(!this.props.success){this.setState({error:true});}case 4:case'end':return _context.stop();}}},_callee,this);}));function apply(){return _ref.apply(this,arguments);}return apply;}()},{key:'cancel',value:function cancel(){this.setState({initialValue:this.props.value,newValue:this.props.value,error:false,validationError:this.props.validate?!this.props.validate(this.state.initialValue):false});}},{key:'render',value:function render(){var _this3=this;var _state=this.state,initialValue=_state.initialValue,newValue=_state.newValue,validationError=_state.validationError;var valuesUnequal=(newValue?newValue.toString():'')!==(initialValue?initialValue.toString():'');var isInvalid=validationError;var input=__WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(this.props.input,{name:'newValue',value:newValue||'',className:(this.props.input.props.className||"")+' '+(validationError?" error-input":""),onKeyDown:function onKeyDown(e){if(e.key==='Enter'&&valuesUnequal&&!isInvalid)_this3.apply();},onChange:this.onChange,onBlur:function onBlur(e){return _this3.validate(e.target.value);}});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},this.props.title),input,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:validationError,message:this.props.errorMessage||"Invalid entry"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'settings-btns'},valuesUnequal&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_LoadingSpinner__["a" /* default */],{height:20,loading:this.props.loading}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-small btn-primary icon-left',disabled:isInvalid||!newValue,onClick:this.apply.bind(this)},'Apply'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-small btn-accent',onClick:this.cancel.bind(this)},'Cancel')))));}}]);return ApplyCancelInput;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);//value, update, title, success, loading
/* harmony default export */ __webpack_exports__["a"] = (ApplyCancelInput);

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Select__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateSelect=function(_React$Component){_inherits(UpdateSelect,_React$Component);function UpdateSelect(props){_classCallCheck(this,UpdateSelect);var _this=_possibleConstructorReturn(this,(UpdateSelect.__proto__||Object.getPrototypeOf(UpdateSelect)).call(this,props));_this.state={initialValue:_this.props.value||'',newValue:_this.props.value||'',error:false,sucess:false};return _this;}_createClass(UpdateSelect,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.value!==this.state.initialValue){this.setState({initialValue:nextProps.value,newValue:nextProps.value});}}},{key:'onChange',value:function onChange(e){var _this2=this;this.setState({newValue:e.target.value,error:false,success:false},_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this2.props.update(_this2.state.newValue);case 2:if(!_this2.props.success){_this2.setState({error:true,newValue:_this2.props.value||''});}else{_this2.setState({success:true});}case 3:case'end':return _context.stop();}}},_callee,_this2);})));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'update-select relative'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},this.props.title),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Select__["a" /* default */],{options:this.props.options,value:this.state.newValue,onChange:this.onChange.bind(this)}),this.props.loading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text accent-text2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-reload icon-left'}),'Saving...'),this.state.success&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text approved-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon icon-left ion-checkmark-round'}),'Saved'),this.state.error&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'error-label'},'Oops, something went wrong. Please try again.'));}}]);return UpdateSelect;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);//options, value, title, update, loading, success
/* harmony default export */ __webpack_exports__["a"] = (UpdateSelect);

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SignatureAttachmentModal__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SignatureModal__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Signatures=function(_NavigationComponent){_inherits(Signatures,_NavigationComponent);function Signatures(props){_classCallCheck(this,Signatures);var _this=_possibleConstructorReturn(this,(Signatures.__proto__||Object.getPrototypeOf(Signatures)).call(this,props));_this.state={showModals:{signaturePreviewModal:false,signatureModal:false},attachment:{source:'',name:''},editSignature:{fundId:null,fundName:''}};return _this;}_createClass(Signatures,[{key:'viewAttachment',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(fileId,attachmentName){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({attachment:{source:'/api/settings/signatures/'+fileId,name:attachmentName}},function(){return _this2.toggleModal('signaturePreviewModal');});case 1:case'end':return _context.stop();}}},_callee,this);}));function viewAttachment(_x,_x2){return _ref.apply(this,arguments);}return viewAttachment;}()},{key:'editFundSignature',value:function editFundSignature(fundId,fundName){var _this3=this;this.setState({editSignature:{fundId:fundId,fundName:fundName}},function(){return _this3.toggleModal('signatureModal');});}},{key:'render',value:function render(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'relative'},this.props.loading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'signature-spinner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'32'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-justify flex-center signature-label'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Signature'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'link-text xs-text',onClick:this.toggleModal.bind(this,'signatureModal')},'Add New')),this.props.signatures.map(function(signature,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'signature',key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},signature.fundName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'accent-text small-text'},signature.fileName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'signature-actions'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-eye accent-text',onClick:_this4.viewAttachment.bind(_this4,signature.fileId,signature.fileName)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-upload accent-text',onClick:_this4.editFundSignature.bind(_this4,signature.fundId,signature.fundName)})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SignatureAttachmentModal__["a" /* default */],{show:this.state.showModals.signaturePreviewModal,source:this.state.url,close:this.toggleModal.bind(this,"signaturePreviewModal"),attachment:this.state.attachment}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SignatureModal__["a" /* default */],{show:this.state.showModals.signatureModal,fundId:this.state.editSignature.fundId,fundName:this.state.editSignature.fundName,close:function close(){_this4.setState({editSignature:{}},function(){return _this4.toggleModal('signatureModal');});},addSignature:this.props.addSignature,reloadPaymentSettings:this.props.reloadPaymentSettings,loading:this.props.adding.loading,success:this.props.adding.success,funds:this.props.funds.filter(function(f){return _this4.props.signatures.map(function(s){return s.fundId;}).indexOf(f.key)<0;})}));}}]);return Signatures;}(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_NavigationComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Signatures);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SignatureAttachmentModal=function(_React$Component){_inherits(SignatureAttachmentModal,_React$Component);function SignatureAttachmentModal(props){_classCallCheck(this,SignatureAttachmentModal);var _this=_possibleConstructorReturn(this,(SignatureAttachmentModal.__proto__||Object.getPrototypeOf(SignatureAttachmentModal)).call(this,props));_this.state={loading:true,error:false};return _this;}_createClass(SignatureAttachmentModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils__["e" /* deepEquals */])(nextProps.attachment,this.props.attachment)){this.setState({loading:true,error:false});}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal attachment-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'page-header'},this.props.attachment.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.props.close})),this.state.loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'30'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'signature-view',alt:'signature',src:this.props.attachment.source,onError:function onError(){return _this2.setState({error:true,loading:false});},onLoad:function onLoad(){return _this2.setState({loading:false});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{message:'Image preview could not be loaded, please try again.',show:this.state.error}))));}}]);return SignatureAttachmentModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SignatureAttachmentModal);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dropzone__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SignatureModal=function(_React$Component){_inherits(SignatureModal,_React$Component);function SignatureModal(props){_classCallCheck(this,SignatureModal);var _this=_possibleConstructorReturn(this,(SignatureModal.__proto__||Object.getPrototypeOf(SignatureModal)).call(this,props));_this.state={signature:{fundId:'',file:null},error:false,submitAttempted:false,rejectedFile:false};_this.onChange=_this.onChange.bind(_this);_this.onSubmit=_this.onSubmit.bind(_this);_this.onClose=_this.onClose.bind(_this);return _this;}_createClass(SignatureModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.fundId!==this.props.fundId){this.setState({signature:{file:null,fundId:nextProps.fundId||''}});}}},{key:'onChange',value:function onChange(name,value){this.setState({signature:Object.assign({},this.state.signature,_defineProperty({},name,value))});}},{key:'onSubmit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var signature;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({error:false,submitAttempted:true});signature=this.state.signature;if(!(!signature.fundId||!signature.file)){_context.next=4;break;}return _context.abrupt('return');case 4:_context.next=6;return this.props.addSignature(signature);case 6:if(this.props.success){this.onClose();this.props.reloadPaymentSettings();}else this.setState({error:true});case 7:case'end':return _context.stop();}}},_callee,this);}));function onSubmit(){return _ref.apply(this,arguments);}return onSubmit;}()},{key:'onClose',value:function onClose(){this.setState({signature:{fundId:'',file:null},error:false,submitAttempted:false,rejectedFile:false});this.props.close();}},{key:'onFileDrop',value:function onFileDrop(files){//to avoid memory leaks
var file=files[0];window.URL.revokeObjectURL(file.preview);this.onChange('file',file);}},{key:'dropRejected',value:function dropRejected(rejectedFile){var _this2=this;this.setState({rejectedFile:true},function(){setTimeout(function(){if(_this2.refs.dropzone){_this2.setState({rejectedFile:false});}},5000);});}},{key:'render',value:function render(){var signature=this.state.signature;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_Modal__["a" /* default */],{modalShowing:this.props.show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal new-signature-modal large-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},this.props.fundId?'Upload new signature for '+this.props.fundName:'Add New Signature'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.onClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},!this.props.fundId&&!this.props.fundName&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row modal-row-full-width'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_Select__["a" /* default */],{clearable:true,options:this.props.funds}),label:'Fund',name:'fundId',value:signature.fundId,onChange:this.onChange,required:true,showRequiredError:this.state.submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row modal-row-full-width'},signature.file?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-document icon-left middle'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'small-text'},signature.file.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-outline trash-hover icon-right middle',onClick:this.onChange.bind(this,'file',null)})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_dropzone__["a" /* default */],{ref:'dropzone',className:'upload-box '+(this.state.submitAttempted&&!this.state.signature.file?'error':''),accept:'image/png,image/jpeg,image/jpg',onDropRejected:this.dropRejected.bind(this),disablePreview:true,onDropAccepted:this.onFileDrop.bind(this),multiple:false,maxSize:4000000},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'accent-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-cloud-upload-outline'}),'Drop files here or ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),' click to ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text2 block'},'Upload Signature'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{message:'Incompatible file format or size, please make sure you are uploading an image up to 4MB',show:this.state.rejectedFile,timeOut:5000})))),this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.onClose},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',onClick:this.onSubmit},'Save'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error})))));}}]);return SignatureModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);//save, update, funds
/* harmony default export */ __webpack_exports__["a"] = (SignatureModal);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CloudPrint=function(_React$Component){_inherits(CloudPrint,_React$Component);function CloudPrint(props){_classCallCheck(this,CloudPrint);var _this=_possibleConstructorReturn(this,(CloudPrint.__proto__||Object.getPrototypeOf(CloudPrint)).call(this,props));_this.state={error:false};return _this;}_createClass(CloudPrint,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var params;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:params=__WEBPACK_IMPORTED_MODULE_2_query_string___default.a.parse(this.context.router.route.location.search);if(!params.code){_context.next=6;break;}_context.next=4;return this.props.authorize(params.code);case 4:if(!this.props.success){this.setState({error:true});}this.context.router.history.replace('/settings/system');case 6:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'authorizeCloudPrint',value:function authorizeCloudPrint(){this.setState({error:false});window.location='https://accounts.google.com/o/oauth2/v2/auth?scope=openid profile email https://www.googleapis.com/auth/cloudprint&access_type=offline&include_granted_scopes=true&state=state_parameter_passthrough_value&redirect_uri='+"https://sftfweb.com/settings/system"+'&response_type=code&client_id='+"166545524139-s1f1i50gbcjj4604qe2tebu9dnkargvv.apps.googleusercontent.com";}},{key:'render',value:function render(){var _props=this.props,cloudPrintIsAuthorized=_props.cloudPrintIsAuthorized,cloudPrintUserName=_props.cloudPrintUserName;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half column-half-left cloud-print'},cloudPrintIsAuthorized&&cloudPrintUserName&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'authorization'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'check_circle'),'Cloud Print is authorized with user ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'bold-text'},cloudPrintUserName)),this.props.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_LoadingSpinner__["a" /* default */],{height:20,loading:this.props.loading}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-large btn-primary icon-left',onClick:this.authorizeCloudPrint.bind(this)},cloudPrintIsAuthorized&&cloudPrintUserName?'Authorize with a Different Account':'Authorize Cloud Print',' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:this.state.error,message:'Something went wrong and the account could not be authorized. Please try again.'}));}}]);return CloudPrint;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);CloudPrint.contextTypes={router:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object};/* unused harmony default export */ var _unused_webpack_default_export = (CloudPrint);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_shared_ConfirmationModal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_apiUtils__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FlushAiSummaries=function(_React$Component){_inherits(FlushAiSummaries,_React$Component);function FlushAiSummaries(props){_classCallCheck(this,FlushAiSummaries);var _this=_possibleConstructorReturn(this,(FlushAiSummaries.__proto__||Object.getPrototypeOf(FlushAiSummaries)).call(this,props));_this.state={showModal:false,loading:false,error:''};return _this;}_createClass(FlushAiSummaries,[{key:'flushAiSummaries',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({loading:true});_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_4__lib_apiUtils__["a" /* deleteRequest */])('/applications/summaries/flush');case 3:response=_context.sent;if(response.success){this.setState({loading:false});__WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__["toastr"].success('AI summaries cleared',response.data.message);}else{this.setState({loading:false,error:response.message||'Something went wrong.  Please try again.'});}return _context.abrupt('return',response.success);case 6:case'end':return _context.stop();}}},_callee,this);}));function flushAiSummaries(){return _ref.apply(this,arguments);}return flushAiSummaries;}()},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'AI Summaries'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text'},'Clear all cached AI summaries so they regenerate with the latest agent instructions.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent2',onClick:function onClick(){return _this2.setState({showModal:true});}},'Clear AI Summary Cache'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_shared_ConfirmationModal__["a" /* default */],{show:this.state.showModal,title:'Clear AI Summaries',message:'This will delete all cached AI summaries. They will regenerate automatically as summaries are viewed. Continue?',close:function close(){return _this2.setState({showModal:false});},confirm:this.flushAiSummaries.bind(this),loading:this.state.loading,errorMessage:this.state.error}));}}]);return FlushAiSummaries;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (FlushAiSummaries);

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_number_format__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_number_format__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CurrencyConversionInput=function(_React$Component){_inherits(CurrencyConversionInput,_React$Component);function CurrencyConversionInput(){_classCallCheck(this,CurrencyConversionInput);return _possibleConstructorReturn(this,(CurrencyConversionInput.__proto__||Object.getPrototypeOf(CurrencyConversionInput)).apply(this,arguments));}_createClass(CurrencyConversionInput,[{key:'rejectValue',value:function rejectValue(values){return values.floatValue!==0;}},{key:'onChange',value:function onChange(e){var event=Object.assign({},e);event.target.value=event.target.value.replace(/[^0-9\.]/g,'');this.props.onChange(event);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_number_format___default.a,Object.assign({},this.props,{thousandSeparator:true,decimalScale:2,onChange:this.onChange.bind(this),isAllowed:this.rejectValue.bind(this)}));}}]);return CurrencyConversionInput;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CurrencyConversionInput);

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_CheckPrintingActions__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_util_CurrencyFormatInput__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SettingsMenu__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__printingComponents_PrintModal__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CheckPrintingPage=function(_NavigationComponent){_inherits(CheckPrintingPage,_NavigationComponent);function CheckPrintingPage(props){_classCallCheck(this,CheckPrintingPage);var _this=_possibleConstructorReturn(this,(CheckPrintingPage.__proto__||Object.getPrototypeOf(CheckPrintingPage)).call(this,props));_this.state={fundId:'',quantity:'',presetAmount:'',date:'',showModals:{printModal:false}};return _this;}_createClass(CheckPrintingPage,[{key:'onChange',value:function onChange(event){this.setState(_defineProperty({},event.target.name,event.target.value));}},{key:'printChecks',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(printerId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.actions.printChecks('blankChecks',printerId,{fundId:this.state.fundId,amountOfBlankChecks:this.state.quantity,presetAmount:this.state.presetAmount,date:this.state.date});case 2:if(this.props.printing.success){__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].success('Printing completed.');this.setState({fundId:'',quantity:'',presetAmount:''});}case 3:case'end':return _context.stop();}}},_callee,this);}));function printChecks(_x){return _ref.apply(this,arguments);}return printChecks;}()},{key:'render',value:function render(){var _this2=this;var fund=this.state.fundId?this.props.fundsWithLimits.find(function(f){return f.key.toString()===_this2.state.fundId.toString();}).value:{};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'subheader'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container flex-justify flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SettingsMenu__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'section-header'},'Print Blank Checks'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Fund'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_Select__["a" /* default */],{options:this.props.funds,label:'Fund',name:'fundId',value:this.state.fundId,onChange:this.onChange.bind(this)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'icon-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Quantity'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'number',min:'1',className:'filled-input',name:'quantity',value:this.state.quantity,onChange:this.onChange.bind(this)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'icon-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Preset Amount'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_util_CurrencyFormatInput__["a" /* default */],{className:'filled-input'}),name:'presetAmount',value:this.state.presetAmount,onChange:function onChange(name,val){return _this2.setState(_defineProperty({},name,val));},validated:true,showValidationError:true,validate:function validate(val){return!val||Object(__WEBPACK_IMPORTED_MODULE_12__lib_utils__["B" /* stripCurrencyFormat */])(val)<=fund.checkCuttingMax;},errorMessage:'Check amount cannot exceed '+Object(__WEBPACK_IMPORTED_MODULE_12__lib_utils__["j" /* formatCurrency */])(fund.checkCuttingMax)+'.'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'icon-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Date'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'date',max:'9999-12-31',value:this.state.date,name:'date',onChange:this.onChange.bind(this)}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',disabled:!this.state.fundId||!this.state.quantity||this.state.quantity<1,onClick:function onClick(){if(_this2.state.presetAmount<=fund.checkCuttingMax)_this2.toggleModal("printModal");}},'Print')),this.state.showModals.printModal&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__printingComponents_PrintModal__["a" /* default */],{close:this.toggleModal.bind(this,"printModal"),onPrintSuccess:this.pushRoute.bind(this,'/print'),count:this.state.quantity,print:this.printChecks.bind(this)}));}}]);return CheckPrintingPage;}(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_NavigationComponent__["a" /* default */]);function mapStateToProps(state,ownProps){return{funds:state.funds.fundsByDept.US,printing:state.checkPrinting.printing,fundsWithLimits:state.funds.fundsByDept.allWithLimits};}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({printChecks:__WEBPACK_IMPORTED_MODULE_4__redux_actions_CheckPrintingActions__["printChecks"]},dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(CheckPrintingPage));

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var ExecutionEnvironment = _interopDefault(__webpack_require__(627));
var shallowEqual = _interopDefault(__webpack_require__(628));

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;


    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if(ret !== void 0) {
        return !!ret;
    }

    if(objA === objB) {
        return true;
    }

    if(typeof objA !== 'object' || !objA ||
       typeof objB !== 'object' || !objB) {
        return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if(keysA.length !== keysB.length) {
        return false;
    }

    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++) {

        var key = keysA[idx];

        if(!bHasOwnProperty(key)) {
            return false;
        }

        var valueA = objA[key];
        var valueB = objB[key];

        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

        if(ret === false ||
           ret === void 0 && valueA !== valueB) {
            return false;
        }

    }

    return true;

};


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(630);
var isArguments = __webpack_require__(631);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 630 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 631 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(49);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(206);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_AuthenticationActions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_SettingsActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions_UtilsActions__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__IdleTimer__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_helmet__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__campaignComponents_externalLists_ExternalCampaignListPage__ = __webpack_require__(634);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ExternalUserContainer=function(_React$Component){_inherits(ExternalUserContainer,_React$Component);function ExternalUserContainer(props){_classCallCheck(this,ExternalUserContainer);var _this=_possibleConstructorReturn(this,(ExternalUserContainer.__proto__||Object.getPrototypeOf(ExternalUserContainer)).call(this,props));_this.state={ready:false,authenticated:false};return _this;}_createClass(ExternalUserContainer,[{key:'componentWillMount',value:function componentWillMount(){this.login();}},{key:'login',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.actions.externalLogin(__WEBPACK_IMPORTED_MODULE_2_query_string___default.a.parse(this.props.location.search).token);case 2:if(!this.props.login.success){_context.next=5;break;}_context.next=5;return this.props.actions.getSystemSettings();case 5:this.setState({ready:true,authenticated:this.props.login.success});case 6:case'end':return _context.stop();}}},_callee,this);}));function login(){return _ref.apply(this,arguments);}return login;}()},{key:'handleScriptInject',value:function handleScriptInject(_ref2){var scriptTags=_ref2.scriptTags;if(scriptTags){if(window.google)window.google=undefined;this.props.actions.updateGeosuggestLanguageSettings({loading:true});var scriptTag=scriptTags[0];scriptTag.onload=this.handleOnLoad.bind(this);}}},{key:'handleOnLoad',value:function handleOnLoad(script){this.props.actions.updateGeosuggestLanguageSettings({loading:false});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'secondary-page secretary-page'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_helmet__["Helmet"],{defer:false,onChangeClientState:function onChangeClientState(newState,addedTags){return _this2.handleScriptInject(addedTags);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('script',{async:false,type:'text/javascript',src:'https://maps.googleapis.com/maps/api/js?key='+"AIzaSyA5hyj_ZDrtl3AM67YAc9LiGCgqhvB_6i0"+'&libraries=places'+(this.props.utils.geosuggestLanguageSettings.language?'&language='+this.props.utils.geosuggestLanguageSettings.language:'')})),!this.state.ready?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'page'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'35'})):!this.state.authenticated?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'full-page-empty-state'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/logo.png',alt:'logo'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'This page is unavailable.  Please reach out to your SFTF contact to receive a new link to view your campaign list.')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__IdleTimer__["a" /* default */],{alwaysRefresh:true,logout:function logout(){return _this2.setState({authenticated:false});},refreshUrl:'/account/refreshExternalToken'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__campaignComponents_externalLists_ExternalCampaignListPage__["a" /* default */],{token:__WEBPACK_IMPORTED_MODULE_2_query_string___default.a.parse(this.props.location.search).token,campaignListId:this.props.match.params.id})));}}]);return ExternalUserContainer;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);function mapStateToProps(state,ownProps){return{login:state.authentication.login,utils:state.utils};}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])({externalLogin:__WEBPACK_IMPORTED_MODULE_5__redux_actions_AuthenticationActions__["externalLogin"],getSystemSettings:__WEBPACK_IMPORTED_MODULE_6__redux_actions_SettingsActions__["getSystemSettings"],updateGeosuggestLanguageSettings:__WEBPACK_IMPORTED_MODULE_7__redux_actions_UtilsActions__["a" /* updateGeosuggestLanguageSettings */]},dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(ExternalUserContainer));

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_ExternalCampaignListsActions__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_SuggestionsActions__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ExternalParticipantsInfiniteList__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SelectExternalParticipantModal__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ExternalParticipantModal__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_shared_ExportButton__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_util_NavigationComponent__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonComponents_shared_ConfirmationModal__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commonComponents_shared_WarningModal__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_throttle_debounce__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_throttle_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_throttle_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib_urlUtils__ = __webpack_require__(101);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var listTypes={New:'new',Received:'received',Rejected:'rejected'};var ExternalCampaignListPage=function(_NavigationComponent){_inherits(ExternalCampaignListPage,_NavigationComponent);function ExternalCampaignListPage(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,ExternalCampaignListPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ExternalCampaignListPage.__proto__||Object.getPrototypeOf(ExternalCampaignListPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={currentParticipant:{},listType:null,deselected:[],searchKeyword:'',selected:[],showModals:{removeRestoreConfirmationModal:false,externalParticipantModal:false,selectExternalParticipantModal:false,submitListConfirmationModal:false},submitted:false},_this.getListDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var campaignList,listType;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.actions.getExternalCampaignListDetails(_this.props.campaignListId);case 2:campaignList=_this.props.listDetails.data;if(!campaignList.batch){_context.next=9;break;}listType=Object(__WEBPACK_IMPORTED_MODULE_17__lib_urlUtils__["a" /* getQueryParams */])().list||listTypes.New;if(listType===listTypes.Received&&!campaignList.receivedParticipantsCount){listType=campaignList.newParticipantsCount?listTypes.New:listTypes.Rejected;}else if(listType===listTypes.New&&!campaignList.newParticipantsCount){listType=campaignList.receivedParticipantsCount?listTypes.Received:listTypes.Rejected;}else if(listType===listTypes.Rejected&&!campaignList.rejectedParticipantsCount){listType=campaignList.newParticipantsCount?listTypes.New:listTypes.Received;}_this.toggleListType(listType,false);//get existing recipients to blacklist from suggestions
_context.next=9;return _this.props.actions.getExternalCampaignListRecipients(_this.props.campaignListId);case 9:case'end':return _context.stop();}}},_callee,_this2);})),_this.getParticipants=function(reset,page,sort){_this.props.actions.getExternalCampaignListParticipants(_this.props.campaignListId,_this.state.listType,_this.state.searchKeyword,reset,page,sort);},_this.toggleListType=function(listType){var getParticipants=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;Object(__WEBPACK_IMPORTED_MODULE_17__lib_urlUtils__["b" /* setQueryParams */])({list:listType});_this.setState({listType:listType},function(){if(getParticipants)_this.getParticipants(true);});},_this.updateSearch=function(event){_this.setState({searchKeyword:event.target.value},_this.debounceSearchList);},_this.debounceSearchList=Object(__WEBPACK_IMPORTED_MODULE_16_throttle_debounce__["debounce"])(500,function(){_this.getParticipants(true,1,_this.props.participantsList.sort);}),_this.addParticipant=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(participant){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.actions.addExternalCampaignListParticipant(_this.props.campaignListId,participant);case 2:if(participant.recipientId){//reload recipients blacklist if chose suggestion...
_this.props.actions.getExternalCampaignListRecipients(_this.props.campaignListId);}if(_this.state.listType!==listTypes.New)_this.toggleListType(listTypes.New);case 4:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}(),_this.updateParticipant=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(participant){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.actions.updateExternalCampaignListParticipant(_this.props.campaignListId,participant);case 2:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref4.apply(this,arguments);};}(),_this.removeParticipant=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return _this.props.actions.removeExternalCampaignListParticipant(_this.props.campaignListId,_this.state.currentParticipant.externalListMemberId);case 2:case'end':return _context4.stop();}}},_callee4,_this2);})),_this.restoreParticipant=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return _this.props.actions.restoreExternalCampaignListParticipant(_this.props.campaignListId,_this.state.currentParticipant.externalListMemberId);case 2:case'end':return _context5.stop();}}},_callee5,_this2);})),_this.selectParticipant=function(participantId,select){var _this$state=_this.state,deselected=_this$state.deselected,selected=_this$state.selected;var restoreDefault=(select?deselected.indexOf(participantId):selected.indexOf(participantId))>=0;_this.setState({deselected:!select&&!restoreDefault?[].concat(_toConsumableArray(deselected),[participantId]):deselected.filter(function(id){return id!==participantId;}),selected:select&&!restoreDefault?[].concat(_toConsumableArray(selected),[participantId]):selected.filter(function(id){return id!==participantId;})},_this.debounceSaveSelectedParticipants);},_this.debounceSaveSelectedParticipants=Object(__WEBPACK_IMPORTED_MODULE_16_throttle_debounce__["debounce"])(2000,function(){_this.saveSelectedParticipants();}),_this.selectAllParticipantsToggle=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(toggleAll){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_this.saveSelectedParticipants(toggleAll);case 1:case'end':return _context6.stop();}}},_callee6,_this2);}));return function(_x4){return _ref7.apply(this,arguments);};}(),_this.saveSelectedParticipants=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(toggleAll){var _this$state2,deselected,selected,listSelection;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_this$state2=_this.state,deselected=_this$state2.deselected,selected=_this$state2.selected;listSelection=_this.props.listSelection;if(!(selected.length||deselected.length||toggleAll)){_context7.next=6;break;}_context7.next=5;return _this.props.actions.toggleExternalCampaignListParticipantsReceiving(_this.props.campaignListId,selected,deselected,toggleAll,_this.state.listType,_this.state.searchKeyword);case 5:if(listSelection.success){_this.setState({deselected:_this.state.deselected.filter(function(id){return deselected.indexOf(id)<0;}),selected:_this.state.selected.filter(function(id){return selected.indexOf(id)<0;})});}case 6:case'end':return _context7.stop();}}},_callee7,_this2);}));return function(_x5){return _ref8.apply(this,arguments);};}(),_this.exportList=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return _this.props.actions.exportExternalCampaignList(_this.props.campaignListId);case 2:return _context8.abrupt('return',_this.props.listExport);case 3:case'end':return _context8.stop();}}},_callee8,_this2);})),_this.submitList=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return _this.props.actions.submitExternalCampaignList(_this.props.campaignListId);case 2:if(_this.props.listSubmission.success){_this.setState({submitted:true});}case 3:case'end':return _context9.stop();}}},_callee9,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ExternalCampaignListPage,[{key:'componentWillMount',value:function componentWillMount(){this.getListDetails();}},{key:'render',value:function render(){var _this3=this;var _props=this.props,campaignList=_props.listDetails.data,listRecipients=_props.listRecipients,listDetails=_props.listDetails,listExport=_props.listExport,listUpdate=_props.listUpdate,listSelection=_props.listSelection,listSubmission=_props.listSubmission,_props$settings=_props.settings,usPersonTitles=_props$settings.usPersonTitles,israelPersonTitles=_props$settings.israelPersonTitles,locationGroups=_props$settings.locationGroups,orgEmploymentTypes=_props$settings.orgEmploymentTypes,previousEmploymentTypes=_props$settings.previousEmploymentTypes;var _state=this.state,currentParticipant=_state.currentParticipant,deselected=_state.deselected,listType=_state.listType,searchKeyword=_state.searchKeyword,selected=_state.selected,showModals=_state.showModals,submitted=_state.submitted;var isBatched=campaignList.batch;var isIsraeli=Object(__WEBPACK_IMPORTED_MODULE_15__lib_utils__["z" /* locationIsIsraeli */])(locationGroups,campaignList.locationId);var unsavedSelection=selected.length>0||deselected.length>0;var style='staff-list-table mt-16 '+(isIsraeli?'israeli-table':campaignList.isOrgList?'org-table':'')+' '+(isBatched&&listType===listTypes.Received?"received-table":"")+' '+(isBatched?"batched-list-table":"");return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'secondary-page external-page'},listDetails.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'full-page-empty-state'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'accent-text2'},'Retrieving campaign list information...')):!listDetails.success?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'full-page-empty-state'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/images/logo.png',alt:'logo'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Something went wrong and we were unable to retrieve your campaign list. Please try again.')):!!campaignList.campaignListId&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'external-page-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},campaignList.name,' Campaign List',campaignList.lastSubmitted&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'medium-text accent-text mt-8'},'Last Submitted: ',Object(__WEBPACK_IMPORTED_MODULE_15__lib_utils__["k" /* formatDate */])(campaignList.lastSubmitted))),!campaignList.awaitingVerification&&!submitted&&(!isBatched||listType)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'contents'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex flex-justify',style:{flex:'1',alignItems:'flex-start'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary flex flex-center ml-16',disabled:listSubmission.loading,onClick:function onClick(){return _this3.toggleModal(isBatched?'selectExternalParticipantModal':'externalParticipantModal');}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons mr-8',style:{fontSize:'18px'}},'add_circle_outline'),'Add New Participant'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex flex-center'},isBatched&&(listSelection.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex flex-center mr-16 accent-text2 small-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'12'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{marginLeft:'8px'}},'Saving selection...')):!listSelection.success?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text error-text mr-16'},'Attempt to save selection failed.',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'error-text small-text bold-text pointer',onClick:this.saveSelectedParticipants},'Try again.')):unsavedSelection?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'mr-16 accent-text2 small-text'},'Unsaved selection.',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text2 small-text bold-text pointer',onClick:this.saveSelectedParticipants},'Save now.')):campaignList.receivingParticipantsCount>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'accent-text2 medium-text mr-8'},campaignList.receivingParticipantsCount,' individual',campaignList.receivingParticipantsCount===1?'':'s',' selected for submission')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary-outline mr-8 flex flex-center',disabled:unsavedSelection||listSelection.loading||listSubmission.loading,onClick:function onClick(){return _this3.toggleModal('submitListConfirmationModal');}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons mr-8',style:{fontSize:'18px'}},'check_circle_outline'),'Submit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_shared_ExportButton__["a" /* default */],{disabled:unsavedSelection||listSelection.loading||listSubmission.loading,error:!listExport.loading&&!listExport.success,exporting:listExport.loading,exportHeaders:[{label:'Name',value:'displayName',default:''},{label:'Phone',value:'phoneNumber',default:''},{label:'Address',value:'addressDisplay',default:''}].concat(_toConsumableArray(isIsraeli?[{label:'Teudat Zehut',value:'teudatZahut',default:''},{label:'Bank Number',value:'bankRoutingNumber',default:''},{label:'Branch Number',value:'bankBranchNumber',default:''},{label:'Account Number',value:'bankAccountNumber',default:''},{label:'Account Holder',value:'bankAccountHolder',default:''}]:[]),_toConsumableArray(!isIsraeli&&campaignList.isOrgList?[{label:'Position',value:'orgEmployment',sortable:false}]:[]),_toConsumableArray(isBatched?[{label:'Is Receiving',value:function value(vals){return vals.isReceiving?'*':'';},default:''},{label:'Number of Times Received',value:function value(vals){return vals.numberOfTimesReceived||'';},default:''}]:[])),fileName:campaignList.name?campaignList.name.split(' ').join('-'):'Campaign-list',getDataForExport:this.exportList}))),isBatched&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'full-width'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'small-text',style:{color:'rgba(45,53,92,0.7)',lineHeight:'1.5'}},'Please check off individuals for submission. Unchecked individuals will remain on the list as stand-by. Please delete individuals that need to be removed entirely and edit any information about individuals that need updating. ',campaignList.receivedParticipantsCount>0&&'The “Received” tab shows all previously submitted individuals who can be checked off for an additional submission.',campaignList.rejectedParticipantsCount>0&&'The “Rejected” tab shows all previously submitted individuals who were rejected.'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'relative'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'thead-background'})),campaignList.awaitingVerification||submitted?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container relative mt-16'},'Your campaign list has been submitted and is awaiting verification by an SFTF staff member.'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container secondary-page-content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex flex-center flex-justify',style:{height:'56px'}},isBatched&&(campaignList.receivedParticipantsCount>0||campaignList.rejectedParticipantsCount>0)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'count'},Object.keys(listTypes).map(function(typeKey){var type=listTypes[typeKey];var typeCount=campaignList[type+'ParticipantsCount'];var active=listType===type;var disabled=!typeCount||unsavedSelection||listSelection.loading;return typeCount>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:active?'active':disabled?'disabled':'pointer',key:type,onClick:function onClick(){if(listType!==type&&!disabled)_this3.toggleListType(type);}},type.toUpperCase(),' (',typeCount||0,')'):"";})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'search-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'search'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',onChange:this.updateSearch,placeholder:'Search participants',value:searchKeyword,style:{maxWidth:'280px',marginBottom:'0'}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:style},(!isBatched||listType)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ExternalParticipantsInfiniteList__["a" /* default */],Object.assign({campaignListName:campaignList.name,isBatched:isBatched,isIsraeli:isIsraeli,isOrgList:campaignList.isOrgList,listType:listType,listTypes:listTypes,savingSelection:listSelection.loading},this.props.participantsList,{getParticipants:function getParticipants(page,sort){var reset=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return _this3.getParticipants(reset,page,sort);},deselected:deselected,selected:selected,toggleRemoveRestoreParticipant:function toggleRemoveRestoreParticipant(currentParticipant){_this3.setState({currentParticipant:currentParticipant},function(){return _this3.toggleModal('removeRestoreConfirmationModal');});},updateParticipant:function updateParticipant(currentParticipant){_this3.setState({currentParticipant:currentParticipant},function(){return _this3.toggleModal('externalParticipantModal');});},selectParticipant:this.selectParticipant,selectAllParticipantsToggle:this.selectAllParticipantsToggle}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_shared_ConfirmationModal__["a" /* default */],{show:showModals.removeRestoreConfirmationModal,message:!currentParticipant.externalListMemberId?'':currentParticipant.isRemoved?'Restore '+(currentParticipant.displayName||'this participant')+' to this list?':'Are you sure you want to remove '+(currentParticipant.displayName||'this participant')+' from this list?  \n                                                    \nThis participant will be permanently removed and will need to manually added in order to be included again.',close:function close(){_this3.setState({currentParticipant:{}},function(){return _this3.toggleModal('removeRestoreConfirmationModal');});},confirm:currentParticipant.isRemoved?this.restoreParticipant:this.removeParticipant,loading:listUpdate.loading,success:listUpdate.success}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ExternalParticipantModal__["a" /* default */],{show:showModals.externalParticipantModal,close:function close(){_this3.toggleModal('externalParticipantModal');_this3.setState({currentParticipant:{}});},isBatched:isBatched,isIsraeli:isIsraeli,isOrgList:campaignList.isOrgList,locationId:campaignList.locationId,participant:currentParticipant,submit:currentParticipant.externalListMemberId?this.updateParticipant:this.addParticipant,loading:listUpdate.loading,success:listUpdate.success,locationGroups:locationGroups,orgEmploymentTypes:orgEmploymentTypes,previousEmploymentTypes:previousEmploymentTypes,titles:isIsraeli?israelPersonTitles:usPersonTitles}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SelectExternalParticipantModal__["a" /* default */],{show:showModals.selectExternalParticipantModal,close:function close(){return _this3.toggleModal('selectExternalParticipantModal');},showCreate:function showCreate(){return _this3.toggleModals(['selectExternalParticipantModal','externalParticipantModal']);},listRecipients:listRecipients,clearRecipientSuggestions:this.props.actions.clearRecipientSuggestions,getRecipientSuggestions:function getRecipientSuggestions(recipientName){return _this3.props.actions.getRecipientSuggestions(recipientName,Object.assign({applicantType:__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["l" /* RecipientTypes */].Individual,departments:[isIsraeli?__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].IL:__WEBPACK_IMPORTED_MODULE_14__lib_systemVariables__["g" /* Departments */].US]},!campaignList.isOrgList?{locationId:campaignList.locationId}:{}),listRecipients.data);},recipientSuggestions:this.props.recipientSuggestions,submit:this.addParticipant,loading:listUpdate.loading,success:listUpdate.success}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__commonComponents_shared_ConfirmationModal__["a" /* default */],{show:showModals.submitListConfirmationModal,message:'Are you sure you would like to submit '+campaignList.name+' Campaign List?'+(!campaignList.hasUnsubmittedChanges?"\nYou have not made any updates to this list.":"")+(isBatched?"\n\nOnce submitted, your list will await review and verification by an SFTF staff member and will not be available for viewing or updating until the verification process is complete.":""),close:function close(){return _this3.toggleModal('submitListConfirmationModal');},confirm:this.submitList,loading:listSubmission.loading,success:listSubmission.success,errorMessage:listSubmission.message}))));}}]);return ExternalCampaignListPage;}(__WEBPACK_IMPORTED_MODULE_10__commonComponents_util_NavigationComponent__["a" /* default */]);function mapStateToProps(state){return{listDetails:state.externalCampaignList.listDetails,listRecipients:state.externalCampaignList.listRecipients,listExport:state.externalCampaignList.listExport,listUpdate:state.externalCampaignList.listUpdate,listSelection:state.externalCampaignList.listSelection,listSubmission:state.externalCampaignList.listSubmission,participantsList:state.externalCampaignListParticipantsList,recipientSuggestions:state.suggestions.recipientSuggestions,settings:Object.assign({},state.settings.systemSettings.data.recipientSettings,state.settings.systemSettings.data.otherSettings,state.settings.systemSettings.data.campaignSettings)};}function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(Object.assign({},__WEBPACK_IMPORTED_MODULE_4__redux_actions_ExternalCampaignListsActions__,__WEBPACK_IMPORTED_MODULE_5__redux_actions_SuggestionsActions__),dispatch)};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(ExternalCampaignListPage));

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_InfiniteScrollList__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ExternalParticipantsListRecord__ = __webpack_require__(636);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ExternalParticipantsInfiniteList=function(_React$Component){_inherits(ExternalParticipantsInfiniteList,_React$Component);function ExternalParticipantsInfiniteList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ExternalParticipantsInfiniteList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ExternalParticipantsInfiniteList.__proto__||Object.getPrototypeOf(ExternalParticipantsInfiniteList)).call.apply(_ref,[this].concat(args))),_this),_this.getListRecord=function(participant){var _this$props=_this.props,isBatched=_this$props.isBatched,isIsraeli=_this$props.isIsraeli,isOrgList=_this$props.isOrgList,listType=_this$props.listType,listTypes=_this$props.listTypes,deselected=_this$props.deselected,selected=_this$props.selected;var isReceiving=selected.indexOf(participant.externalListMemberId)>=0?true:deselected.indexOf(participant.externalListMemberId)>=0?false:participant.isReceiving;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ExternalParticipantsListRecord__["a" /* default */],{key:participant.externalListMemberId,isBatched:isBatched,isIsraeli:isIsraeli,isOrgList:isOrgList,isReceivedRecord:isBatched&&listType===listTypes.Received,participant:Object.assign({},participant,{isReceiving:isReceiving}),toggleRemoveRestore:_this.props.toggleRemoveRestoreParticipant,select:_this.props.selectParticipant,update:_this.props.updateParticipant});},_this.getColumns=function(){var _this$props2=_this.props,_this$props2$data=_this$props2.data,allSelected=_this$props2$data.allSelected,totalCount=_this$props2$data.totalCount,isBatched=_this$props2.isBatched,isIsraeli=_this$props2.isIsraeli,isOrgList=_this$props2.isOrgList,listType=_this$props2.listType,listTypes=_this$props2.listTypes,loading=_this$props2.loading,savingSelection=_this$props2.savingSelection;return[].concat(_toConsumableArray(isBatched?[{id:'isReceiving',title:'',sortable:true,defaultDirection:'Descending',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-check-container '+(loading||!totalCount?"disabled":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'external-participants-select-all',className:'custom-check',onChange:function onChange(e){return _this.props.selectAllParticipantsToggle(e.target.checked?"all":"none");},checked:totalCount&&allSelected,disabled:loading||!totalCount||savingSelection}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'external-participants-select-all',className:'secondary-text',title:'Select All'}))}]:[]),[{id:'name',title:'Name',sortable:true}],_toConsumableArray(isBatched&&listType===listTypes.Received?[{id:'numberOfTimesReceived',title:'Received Count',sortable:false}]:[]),[{id:'phone',title:'Phone',sortable:false},{id:'address',title:'Address',sortable:false}],_toConsumableArray(isIsraeli?[{id:'teudatZehut',title:'Teudat Zehut',sortable:false},{id:'bankNumber',title:'Bank Number',sortable:false},{id:'branchNumber',title:'Branch Number',sortable:false},{id:'accountNumber',title:'Account Number',sortable:false},{id:'accountHolder',title:'Account Holder',sortable:false}]:[]),_toConsumableArray(!isIsraeli&&isOrgList?[{id:'position',title:'Position',sortable:false}]:[]),[{id:'edit',title:'Edit',sortable:false},{id:'delete',title:'Delete',sortable:false}]);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ExternalParticipantsInfiniteList,[{key:'render',value:function render(){var _props=this.props,_props$data=_props.data,records=_props$data.records,totalCount=_props$data.totalCount,hasMore=_props.hasMore,listType=_props.listType,loading=_props.loading,page=_props.page,sort=_props.sort,success=_props.success;var columns=this.getColumns();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_InfiniteScrollList__["a" /* default */],{columns:columns,getRecords:this.props.getParticipants,hasMore:hasMore,loading:loading,name:(listType?listType+' ':"")+'campaign list participants',page:page,records:records,renderRecord:this.getListRecord,sort:sort,success:success,totalCount:totalCount}));}}]);return ExternalParticipantsInfiniteList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ExternalParticipantsInfiniteList);

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonComponents_util_HoverTableRow__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ExternalParticipantsListRecord=function(_React$Component){_inherits(ExternalParticipantsListRecord,_React$Component);function ExternalParticipantsListRecord(){_classCallCheck(this,ExternalParticipantsListRecord);return _possibleConstructorReturn(this,(ExternalParticipantsListRecord.__proto__||Object.getPrototypeOf(ExternalParticipantsListRecord)).apply(this,arguments));}_createClass(ExternalParticipantsListRecord,[{key:'render',value:function render(){var _this2=this;var _props=this.props,isBatched=_props.isBatched,isIsraeli=_props.isIsraeli,isOrgList=_props.isOrgList,isReceivedRecord=_props.isReceivedRecord,showEditDelete=_props.showEditDelete,participant=_props.participant,_props$participant=_props.participant,externalListMemberId=_props$participant.externalListMemberId,addressDisplay=_props$participant.addressDisplay,bankRoutingNumber=_props$participant.bankRoutingNumber,bankBranchNumber=_props$participant.bankBranchNumber,bankAccountNumber=_props$participant.bankAccountNumber,bankAccountHolder=_props$participant.bankAccountHolder,displayName=_props$participant.displayName,orgEmployment=_props$participant.orgEmployment,phoneNumber=_props$participant.phoneNumber,secondPhoneNumber=_props$participant.secondPhoneNumber,teudatZahut=_props$participant.teudatZahut,isReceiving=_props$participant.isReceiving,isRemoved=_props$participant.isRemoved,numberOfTimesReceived=_props$participant.numberOfTimesReceived;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__commonComponents_util_HoverTableRow__["a" /* default */],{className:'table-row '+(isRemoved?'deleted':'')},isBatched&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-check-container name-check-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'select-'+externalListMemberId,className:'custom-check input',disabled:isRemoved// || savingSelection - for now not disabling while saving
,checked:isReceiving,onChange:function onChange(e){return _this2.props.select(externalListMemberId,e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'select-'+externalListMemberId,className:'secondary-text input'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'bold-text'},displayName)),isReceivedRecord&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'ReceivedCount'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,numberOfTimesReceived)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Phone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,[phoneNumber,secondPhoneNumber].filter(function(n){return n;}).join(' | '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Address'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,addressDisplay)),isIsraeli&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'TeudatZahut'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,teudatZahut)),isIsraeli&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'BankNumber'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,bankRoutingNumber)),isIsraeli&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'BranchNumber'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,bankBranchNumber)),isIsraeli&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'AccountNumber'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,bankAccountNumber)),isIsraeli&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'AccountHolder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,bankAccountHolder)),!isIsraeli&&isOrgList&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Position'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,orgEmployment)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Edit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-pencil primary-hover '+(isRemoved?'disabled':''),onClick:function onClick(){if(!isRemoved)_this2.props.update(participant);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-label':'Delete',className:'delete-table-cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:isRemoved?'icon-refresh primary-hover':'icon-trash trash-hover',onClick:function onClick(){return _this2.props.toggleRemoveRestore(participant);}})));}}]);return ExternalParticipantsListRecord;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ExternalParticipantsListRecord);

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_AutoSuggestInput__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectExternalParticipantModal=function(_React$Component){_inherits(SelectExternalParticipantModal,_React$Component);function SelectExternalParticipantModal(props){var _this2=this;_classCallCheck(this,SelectExternalParticipantModal);var _this=_possibleConstructorReturn(this,(SelectExternalParticipantModal.__proto__||Object.getPrototypeOf(SelectExternalParticipantModal)).call(this,props));_this.onCreate=function(){_this.props.showCreate();_this.setState(_this.state.initialState);};_this.onChange=function(name,value){_this.setState(_defineProperty({},name,value));};_this.onClose=function(){_this.props.close();_this.setState(_this.state.initialState);};_this.onSubmit=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this$state,isReceiving,recipientId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({submitAttempted:true});_this$state=_this.state,isReceiving=_this$state.isReceiving,recipientId=_this$state.recipientId;if(recipientId){_context.next=4;break;}return _context.abrupt('return');case 4:_context.next=6;return _this.props.submit({recipientId:recipientId,isReceiving:isReceiving});case 6:if(_this.props.success){_this.onClose();}case 7:case'end':return _context.stop();}}},_callee,_this2);}));var state={isReceiving:true,recipientId:"",submitAttempted:false};_this.state=Object.assign({},state,{initialState:Object.assign({},state)});return _this;}_createClass(SelectExternalParticipantModal,[{key:'render',value:function render(){var _this3=this;var _state=this.state,recipientId=_state.recipientId,isReceiving=_state.isReceiving,submitAttempted=_state.submitAttempted;var _props=this.props,clearRecipientSuggestions=_props.clearRecipientSuggestions,getRecipientSuggestions=_props.getRecipientSuggestions,listRecipients=_props.listRecipients,loading=_props.loading,recipientSuggestions=_props.recipientSuggestions,show=_props.show,success=_props.success;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal external-participant-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},'Add Participant'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.onClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row flex-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'search-input-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_AutoSuggestInput__["a" /* default */],{allowIncomplete:false,disabled:listRecipients.loading||!listRecipients.success,suggestions:recipientSuggestions.data,suggestionKey:'applicantId',suggestionValue:'name',getSuggestions:getRecipientSuggestions,clearSuggestions:clearRecipientSuggestions,loadingSuggestions:recipientSuggestions.loading,update:function update(name,_ref2){var applicantId=_ref2.applicantId;return _this3.onChange(name,applicantId);}}),label:'Select Recipient',name:'recipientId',value:recipientId,required:true,showRequiredError:submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent2',disabled:loading,onClick:this.onCreate},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-plus-empty icon-left'}),'Create'))),!loading&&(listRecipients.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'small-text accent-text'},'Retrieving recipient suggestion information for your campaign list, please wait...'):!listRecipients.success&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'small-text error-text'},'Something went wrong when attempting to retrieve recipient suggestion information for your campaign list.  Please try refreshing the page.'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'isReceiving',className:'custom-check input',name:'isReceiving',checked:isReceiving,onChange:function onChange(e){return _this3.onChange(e.target.name,e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'isReceiving',className:'secondary-text input'},'Is Receiving'))),loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.onClose},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',onClick:this.onSubmit,disabled:!recipientId},'Submit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:!loading&&!success})))));}}]);return SelectExternalParticipantModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SelectExternalParticipantModal);

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedPhoneInput__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_AddressAutocomplete__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_number_format__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_number_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_number_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonComponents_util_Select__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonComponents_util_RadioGroup__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commonComponents_util_LoadingSpinner__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonComponents_util_FadeOutErrorMessage__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_constants__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_clonedeep__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_clonedeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_clonedeep__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ExternalParticipantModal=function(_React$Component){_inherits(ExternalParticipantModal,_React$Component);function ExternalParticipantModal(props){var _this2=this;_classCallCheck(this,ExternalParticipantModal);var _this=_possibleConstructorReturn(this,(ExternalParticipantModal.__proto__||Object.getPrototypeOf(ExternalParticipantModal)).call(this,props));_this.onChangeParticipant=function(name,value){if(name==="firstName"||name==="lastName"){value=Object(__WEBPACK_IMPORTED_MODULE_11__lib_utils__["C" /* toTitleCase */])(value);}var participant=Object.assign({},_this.state.participant,_defineProperty({},name,value));if(name==='previousEmploymentType'&&value!==__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["k" /* PreviousEmploymentTypes */].Other&&participant.otherPreviousEmployment){participant.otherPreviousEmployment="";}else if(name==='orgEmploymentType'){if(value!==__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["i" /* OrgEmploymentTypes */].Other&&participant.otherOrgEmployment){participant.otherOrgEmployment="";}else if(value!==__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["i" /* OrgEmploymentTypes */].Rebbi&&participant.orgEmploymentGrade){participant.orgEmploymentGrade="";participant.orgEmploymentSeder="";}}else if(name==='orgEmploymentGrade'&&value<9&&participant.orgEmploymentSeder){participant.orgEmploymentSeder="";}_this.setState({participant:participant});};_this.onClose=function(){_this.props.close();_this.setState(_this.state.initialState);};_this.onSubmit=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this$state,invalidData,participant;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({submitAttempted:true});_this$state=_this.state,invalidData=_this$state.invalidData,participant=_this$state.participant;if(!(Object.keys(invalidData).length||!participant.firstName||!participant.lastName||!participant.address||!participant.address.streetNumber||!participant.address.street||!participant.address.city||!participant.address.country||_this.props.isIsraeli&&(!participant.teudatZahut||!participant.bankRoutingNumber||!participant.bankBranchNumber||!participant.bankAccountNumber)||_this.props.isOrgList&&(!participant.orgEmploymentType||participant.orgEmploymentType===__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["i" /* OrgEmploymentTypes */].Other&&!participant.otherOrgEmployment||participant.orgEmploymentType===__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["i" /* OrgEmploymentTypes */].Rebbi&&participant.orgEmploymentGrade===""||participant.orgEmploymentType===__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["i" /* OrgEmploymentTypes */].Rebbi&&participant.orgEmploymentGrade>=9&&!participant.orgEmploymentSeder)||participant.previousEmploymentType===__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["k" /* PreviousEmploymentTypes */].Other&&!participant.otherPreviousEmployment)){_context.next=4;break;}return _context.abrupt('return');case 4:_context.next=6;return _this.props.submit(participant);case 6:if(_this.props.success){_this.onClose();}case 7:case'end':return _context.stop();}}},_callee,_this2);}));_this.setParticipantForEdit=function(participantForEdit){var formattedParticipant=Object.assign({},participantForEdit);Object(__WEBPACK_IMPORTED_MODULE_11__lib_utils__["A" /* replaceValuesInObject */])(formattedParticipant,function(prop){return prop===null;},"");var participant=Object.assign({},_this.state.participant,formattedParticipant);if(_this.props.isOrgList&&!participant.orgEmploymentType)participant.orgEmploymentType=__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["i" /* OrgEmploymentTypes */].Rebbi;if(!participant.previousEmploymentType)participant.previousEmploymentType=__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["k" /* PreviousEmploymentTypes */].NA;var hasPrevAddress=participant.previousAddress.streetNumber||participant.previousAddress.street||participant.previousAddress.city||participant.previousAddress.state||participant.previousAddress.zip||participant.previousAddress.country||participant.previousAddress.unitType||participant.previousAddress.apartment;_this.setState(Object.assign({},_this.state,{participant:participant,initialParticipant:participant,showPrevAddress:hasPrevAddress,showSecondPhone:participant.secondPhoneNumber,showEmail:participant.email}));};_this.updateValidation=function(name,value){var invalidData=Object.assign({},_this.state.invalidData);if(value)invalidData[name]=value;else delete invalidData[name];_this.setState({invalidData:invalidData});};_this.validateAddress=function(address){var _this$props=_this.props,locationId=_this$props.locationId,locationGroups=_this$props.locationGroups;return Object(__WEBPACK_IMPORTED_MODULE_11__lib_utils__["D" /* validateAddressLocation */])(locationGroups,locationId,address);};_this.validateEmail=function(name,value){var isValid=Object(__WEBPACK_IMPORTED_MODULE_11__lib_utils__["x" /* isValidEmail */])(value);_this.updateValidation(name,!isValid);return isValid;};_this.validateLength=function(name,length,val){var isValid=Object(__WEBPACK_IMPORTED_MODULE_11__lib_utils__["E" /* validateFieldLength */])(length,val);_this.updateValidation(name,!isValid);return isValid;};var state={participant:{id:0,personTitleId:'',firstName:'',lastName:'',address:{},previousAddress:{},teudatZehut:'',phoneNumber:'',phoneType:_this.props.isIsraeli?__WEBPACK_IMPORTED_MODULE_12__lib_constants__["g" /* PhoneNumberTypes */].Israeli:__WEBPACK_IMPORTED_MODULE_12__lib_constants__["g" /* PhoneNumberTypes */].American,secondPhoneNumber:'',secondPhoneType:_this.props.isIsraeli?__WEBPACK_IMPORTED_MODULE_12__lib_constants__["g" /* PhoneNumberTypes */].Israeli:__WEBPACK_IMPORTED_MODULE_12__lib_constants__["g" /* PhoneNumberTypes */].American,email:'',bankRoutingNumber:'',bankBranchNumber:'',bankAccountNumber:'',bankAccountHolder:'',orgEmploymentType:_this.props.isOrgList?__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["i" /* OrgEmploymentTypes */].Rebbi:null,otherOrgEmployment:"",orgEmploymentGrade:"",orgEmploymentSeder:"",previousEmploymentType:__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["k" /* PreviousEmploymentTypes */].NA,otherPreviousEmployment:'',isReceiving:true},showPrevAddress:false,showSecondPhone:false,showEmail:false,invalidData:{},submitAttempted:false};state.initialParticipant=__WEBPACK_IMPORTED_MODULE_14_lodash_clonedeep___default()(state.participant);state.initialState=__WEBPACK_IMPORTED_MODULE_14_lodash_clonedeep___default()(state);_this.state=state;return _this;}_createClass(ExternalParticipantModal,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!this.props.show&&nextProps.show&&nextProps.participant.externalListMemberId){//opening modal for edit
if(nextProps.participant){this.setParticipantForEdit(nextProps.participant);}}}},{key:'render',value:function render(){var _this3=this;var _state=this.state,invalidData=_state.invalidData,initialParticipant=_state.initialParticipant,participant=_state.participant,_state$participant=_state.participant,isReceiving=_state$participant.isReceiving,personTitleId=_state$participant.personTitleId,firstName=_state$participant.firstName,lastName=_state$participant.lastName,address=_state$participant.address,previousAddress=_state$participant.previousAddress,phoneNumber=_state$participant.phoneNumber,phoneType=_state$participant.phoneType,secondPhoneNumber=_state$participant.secondPhoneNumber,secondPhoneType=_state$participant.secondPhoneType,email=_state$participant.email,bankRoutingNumber=_state$participant.bankRoutingNumber,bankBranchNumber=_state$participant.bankBranchNumber,bankAccountNumber=_state$participant.bankAccountNumber,bankAccountHolder=_state$participant.bankAccountHolder,orgEmploymentType=_state$participant.orgEmploymentType,otherOrgEmployment=_state$participant.otherOrgEmployment,orgEmploymentGrade=_state$participant.orgEmploymentGrade,orgEmploymentSeder=_state$participant.orgEmploymentSeder,previousEmploymentType=_state$participant.previousEmploymentType,otherPreviousEmployment=_state$participant.otherPreviousEmployment,teudatZahut=_state$participant.teudatZahut,showPrevAddress=_state.showPrevAddress,showSecondPhone=_state.showSecondPhone,showEmail=_state.showEmail,submitAttempted=_state.submitAttempted;var _props=this.props,isBatched=_props.isBatched,isIsraeli=_props.isIsraeli,isOrgList=_props.isOrgList,loading=_props.loading,orgEmploymentTypes=_props.orgEmploymentTypes,previousEmploymentTypes=_props.previousEmploymentTypes,titles=_props.titles,show=_props.show,success=_props.success;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__commonComponents_util_Modal__["a" /* default */],{modalShowing:show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal external-participant-modal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'page-header'},initialParticipant.externalListMemberId?'Edit '+initialParticipant.displayName:"Add Participant"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon ion-ios-close-empty',onClick:this.onClose})),isBatched&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'custom-check-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',id:'isReceiving',className:'custom-check input',name:'isReceiving',checked:isReceiving,onChange:function onChange(e){return _this3.onChangeParticipant(e.target.name,e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'isReceiving',className:'secondary-text input'},'Is Receiving'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third mr-8'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Title'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_Select__["a" /* default */],{clearable:true,options:titles,name:'personTitleId',value:personTitleId,onChange:function onChange(e){return _this3.onChangeParticipant(e.target.name,e.target.value);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third mr-8'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'First Name',name:'firstName',value:firstName,onChange:this.onChangeParticipant,required:true,showRequiredError:this.state.submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'Last Name',name:'lastName',value:lastName,onChange:this.onChangeParticipant,required:true,showRequiredError:submitAttempted}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row info-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_AddressAutocomplete__["a" /* default */],{address:address,isIsraeli:isIsraeli,required:true,showRequiredError:submitAttempted,updateAddress:function updateAddress(ad){return _this3.onChangeParticipant('address',Object.assign({},address,ad));},updateError:function updateError(val){return _this3.updateValidation('address',val);},validateAddress:!isOrgList?this.validateAddress:null,addAddressLabel:initialParticipant.externalListMemberId?(address.city||address.country||address.state||address.street||address.streetNumber||address.zip)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'link-text small-text',onClick:function onClick(){_this3.setState({participant:Object.assign({},participant,{previousAddress:address,address:{}}),showPrevAddress:true});},title:'Set current address to previous'},'Add New Address'):!showPrevAddress&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:function onClick(){return _this3.setState({'showPrevAddress':true});},className:'link-text small-text'},'Add Previous Address')})),showPrevAddress&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row info-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__commonComponents_shared_AddressAutocomplete__["a" /* default */],{address:previousAddress,isIsraeli:isIsraeli,title:'Previous Address',updateAddress:function updateAddress(ad){return _this3.onChangeParticipant('previousAddress',Object.assign({},previousAddress,ad));},updateError:function updateError(val){return _this3.updateValidation('previousAddress',val);},validateAddress:!isOrgList?this.validateAddress:null})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedPhoneInput__["a" /* default */],{phoneNumber:phoneNumber||'',phoneType:phoneType,phoneNumberName:'phoneNumber',phoneTypeName:'phoneType',onChange:this.onChangeParticipant,error:invalidData.phone1,updateError:this.updateValidation,errorName:'phone1',span1:!showSecondPhone&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:function onClick(){return _this3.setState({showSecondPhone:true});},className:'link-text small-text'},'Add Phone'),span2:!showEmail&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:function onClick(){return _this3.setState({showEmail:true});},className:'link-text small-text'},'Add Email')})),showSecondPhone&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__commonComponents_util_ValidatedPhoneInput__["a" /* default */],{label:'Second Phone',phoneNumber:secondPhoneNumber||'',phoneType:secondPhoneType,phoneNumberName:'secondPhoneNumber',phoneTypeName:'secondPhoneType',onChange:this.onChangeParticipant,error:invalidData.phone2,updateError:this.updateValidation,errorName:'phone2'}))),showEmail&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row email-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text'}),label:'Email',name:'email',value:email,onChange:this.onChangeParticipant,validated:true,showValidationError:true,validate:function validate(val){return _this3.validateEmail("email",val);},errorMessage:'Invalid Email Address'})),isIsraeli&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_number_format___default.a,{placeholder:'##',format:'##'}),label:'Bank Number',name:'bankRoutingNumber',value:bankRoutingNumber||'',onChange:this.onChangeParticipant,required:true,showRequiredError:submitAttempted,validated:true,showValidationError:true,validate:function validate(val){return _this3.validateLength('bankRoutingNumber',2,val);},errorMessage:'Invalid Bank Number'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_number_format___default.a,{placeholder:'###',format:'###'}),label:'Branch Number',name:'bankBranchNumber',value:bankBranchNumber||'',onChange:this.onChangeParticipant,required:true,showRequiredError:submitAttempted,validated:true,showValidationError:true,validate:function validate(val){return _this3.validateLength('bankBranchNumber',3,val);},errorMessage:'Invalid Branch Number'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_number_format___default.a,{placeholder:'###############',format:'###############'}),label:'Account Number',name:'bankAccountNumber',value:bankAccountNumber||'',onChange:this.onChangeParticipant,required:true,showRequiredError:submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'input-label'},'Account Holder'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',name:'bankAccountHolder',value:bankAccountHolder||'',onChange:function onChange(e){return _this3.onChangeParticipant(e.target.name,e.target.value);}})))),isIsraeli&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_number_format___default.a,{placeholder:'#########',format:'#########'}),label:'Teudat Zehut',name:'teudatZahut',value:teudatZahut,onChange:this.onChangeParticipant,required:true,showRequiredError:submitAttempted})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'})),isOrgList&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_RadioGroup__["a" /* default */],{title:'Current Position',name:'orgEmploymentType',value:orgEmploymentType,options:orgEmploymentTypes,onChange:this.onChangeParticipant})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},orgEmploymentType===__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["i" /* OrgEmploymentTypes */].Other&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'no-margin-bottom-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',placeholder:'Specify'}),name:'otherOrgEmployment',value:otherOrgEmployment,onChange:this.onChangeParticipant,required:true,showRequiredError:submitAttempted&&!otherOrgEmployment})),orgEmploymentType===__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["i" /* OrgEmploymentTypes */].Rebbi&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'no-margin-bottom-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'',className:'input-label'},'Grade'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__commonComponents_util_Select__["a" /* default */],{options:[{key:0,value:"Pre-K"},{key:1,value:"1"},{key:2,value:"2"},{key:3,value:"3"},{key:4,value:"4"},{key:5,value:"5"},{key:6,value:"6"},{key:7,value:"7"},{key:8,value:"8"},{key:9,value:"9"},{key:10,value:"10"},{key:11,value:"11"},{key:12,value:"12"}],allowZero:true}),name:'orgEmploymentGrade',value:orgEmploymentGrade,onChange:this.onChangeParticipant,required:true,showRequiredError:submitAttempted&&orgEmploymentGrade===""})),orgEmploymentGrade>=9&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ml-16'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_RadioGroup__["a" /* default */],{title:'Seder',error:submitAttempted&&!orgEmploymentSeder,name:'orgEmploymentSeder',value:orgEmploymentSeder,options:[{key:1,value:"1st"},{key:2,value:"2nd"}],onChange:this.onChangeParticipant}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__commonComponents_util_RadioGroup__["a" /* default */],{title:'Prior Position of Employment',name:'previousEmploymentType',value:previousEmploymentType,options:previousEmploymentTypes,onChange:this.onChangeParticipant})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-half'},previousEmploymentType===__WEBPACK_IMPORTED_MODULE_13__lib_systemVariables__["k" /* PreviousEmploymentTypes */].Other&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'no-margin-bottom-input mt-8'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__commonComponents_util_ValidatedInput__["a" /* default */],{input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',placeholder:'Where?'}),name:'otherPreviousEmployment',value:otherPreviousEmployment,onChange:this.onChangeParticipant,required:true,showRequiredError:submitAttempted&&!otherPreviousEmployment}))))),loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__commonComponents_util_LoadingSpinner__["a" /* default */],{height:'20',alignRight:true}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-btns text-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-accent',onClick:this.onClose},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',onClick:this.onSubmit,disabled:Object.keys(invalidData).length||Object(__WEBPACK_IMPORTED_MODULE_11__lib_utils__["e" /* deepEquals */])(initialParticipant,participant)},initialParticipant.externalListMemberId?"Update":"Submit"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__commonComponents_util_FadeOutErrorMessage__["a" /* default */],{show:!loading&&!success})))));}}]);return ExternalParticipantModal;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ExternalParticipantModal);

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_raven_js__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ErrorBoundary=function(_React$Component){_inherits(ErrorBoundary,_React$Component);function ErrorBoundary(props){_classCallCheck(this,ErrorBoundary);var _this=_possibleConstructorReturn(this,(ErrorBoundary.__proto__||Object.getPrototypeOf(ErrorBoundary)).call(this,props));_this.state={error:false};return _this;}_createClass(ErrorBoundary,[{key:'componentDidCatch',value:function componentDidCatch(error,info){//catch and send error to sentry.io if prod environment
if(true){this.setState({error:true});__WEBPACK_IMPORTED_MODULE_1_raven_js___default.a.captureException(error,{extra:info});}}},{key:'render',value:function render(){if(this.state.error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Something\'s gone wrong'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Our team has been notified')));}else{return this.props.children;}}}]);return ErrorBoundary;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ErrorBoundary);

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false */

var TraceKit = __webpack_require__(641);
var stringify = __webpack_require__(208);
var md5 = __webpack_require__(642);
var RavenConfigError = __webpack_require__(643);

var utils = __webpack_require__(112);
var isError = utils.isError;
var isObject = utils.isObject;
var isPlainObject = utils.isPlainObject;
var isErrorEvent = utils.isErrorEvent;
var isUndefined = utils.isUndefined;
var isFunction = utils.isFunction;
var isString = utils.isString;
var isArray = utils.isArray;
var isEmptyObject = utils.isEmptyObject;
var each = utils.each;
var objectMerge = utils.objectMerge;
var truncate = utils.truncate;
var objectFrozen = utils.objectFrozen;
var hasKey = utils.hasKey;
var joinRegExp = utils.joinRegExp;
var urlencode = utils.urlencode;
var uuid4 = utils.uuid4;
var htmlTreeAsString = utils.htmlTreeAsString;
var isSameException = utils.isSameException;
var isSameStacktrace = utils.isSameStacktrace;
var parseUrl = utils.parseUrl;
var fill = utils.fill;
var supportsFetch = utils.supportsFetch;
var supportsReferrerPolicy = utils.supportsReferrerPolicy;
var serializeKeysForMessage = utils.serializeKeysForMessage;
var serializeException = utils.serializeException;
var sanitize = utils.sanitize;

var wrapConsoleMethod = __webpack_require__(644).wrapMethod;

var dsnKeys = 'source protocol user pass host port path'.split(' '),
  dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;

function now() {
  return +new Date();
}

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _document = _window.document;
var _navigator = _window.navigator;

function keepOriginalCallback(original, callback) {
  return isFunction(callback)
    ? function(data) {
        return callback(data, original);
      }
    : callback;
}

// First, check for JSON support
// If there is no JSON, we no-op the core features of Raven
// since JSON is required to encode the payload
function Raven() {
  this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
  // Raven can run in contexts where there's no document (react-native)
  this._hasDocument = !isUndefined(_document);
  this._hasNavigator = !isUndefined(_navigator);
  this._lastCapturedException = null;
  this._lastData = null;
  this._lastEventId = null;
  this._globalServer = null;
  this._globalKey = null;
  this._globalProject = null;
  this._globalContext = {};
  this._globalOptions = {
    // SENTRY_RELEASE can be injected by https://github.com/getsentry/sentry-webpack-plugin
    release: _window.SENTRY_RELEASE && _window.SENTRY_RELEASE.id,
    logger: 'javascript',
    ignoreErrors: [],
    ignoreUrls: [],
    whitelistUrls: [],
    includePaths: [],
    headers: null,
    collectWindowErrors: true,
    captureUnhandledRejections: true,
    maxMessageLength: 0,
    // By default, truncates URL values to 250 chars
    maxUrlLength: 250,
    stackTraceLimit: 50,
    autoBreadcrumbs: true,
    instrument: true,
    sampleRate: 1,
    sanitizeKeys: []
  };
  this._fetchDefaults = {
    method: 'POST',
    keepalive: true,
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    referrerPolicy: supportsReferrerPolicy() ? 'origin' : ''
  };
  this._ignoreOnError = 0;
  this._isRavenInstalled = false;
  this._originalErrorStackTraceLimit = Error.stackTraceLimit;
  // capture references to window.console *and* all its methods first
  // before the console plugin has a chance to monkey patch
  this._originalConsole = _window.console || {};
  this._originalConsoleMethods = {};
  this._plugins = [];
  this._startTime = now();
  this._wrappedBuiltIns = [];
  this._breadcrumbs = [];
  this._lastCapturedEvent = null;
  this._keypressTimeout;
  this._location = _window.location;
  this._lastHref = this._location && this._location.href;
  this._resetBackoff();

  // eslint-disable-next-line guard-for-in
  for (var method in this._originalConsole) {
    this._originalConsoleMethods[method] = this._originalConsole[method];
  }
}

/*
 * The core Raven singleton
 *
 * @this {Raven}
 */

Raven.prototype = {
  // Hardcode version string so that raven source can be loaded directly via
  // webpack (using a build step causes webpack #1617). Grunt verifies that
  // this value matches package.json during build.
  //   See: https://github.com/getsentry/raven-js/issues/465
  VERSION: '3.24.2',

  debug: false,

  TraceKit: TraceKit, // alias to TraceKit

  /*
     * Configure Raven with a DSN and extra options
     *
     * @param {string} dsn The public Sentry DSN
     * @param {object} options Set of global options [optional]
     * @return {Raven}
     */
  config: function(dsn, options) {
    var self = this;

    if (self._globalServer) {
      this._logDebug('error', 'Error: Raven has already been configured');
      return self;
    }
    if (!dsn) return self;

    var globalOptions = self._globalOptions;

    // merge in options
    if (options) {
      each(options, function(key, value) {
        // tags and extra are special and need to be put into context
        if (key === 'tags' || key === 'extra' || key === 'user') {
          self._globalContext[key] = value;
        } else {
          globalOptions[key] = value;
        }
      });
    }

    self.setDSN(dsn);

    // "Script error." is hard coded into browsers for errors that it can't read.
    // this is the result of a script being pulled in from an external domain and CORS.
    globalOptions.ignoreErrors.push(/^Script error\.?$/);
    globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);

    // join regexp rules into one big rule
    globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
    globalOptions.ignoreUrls = globalOptions.ignoreUrls.length
      ? joinRegExp(globalOptions.ignoreUrls)
      : false;
    globalOptions.whitelistUrls = globalOptions.whitelistUrls.length
      ? joinRegExp(globalOptions.whitelistUrls)
      : false;
    globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
    globalOptions.maxBreadcrumbs = Math.max(
      0,
      Math.min(globalOptions.maxBreadcrumbs || 100, 100)
    ); // default and hard limit is 100

    var autoBreadcrumbDefaults = {
      xhr: true,
      console: true,
      dom: true,
      location: true,
      sentry: true
    };

    var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
    if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
      autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
    } else if (autoBreadcrumbs !== false) {
      autoBreadcrumbs = autoBreadcrumbDefaults;
    }
    globalOptions.autoBreadcrumbs = autoBreadcrumbs;

    var instrumentDefaults = {
      tryCatch: true
    };

    var instrument = globalOptions.instrument;
    if ({}.toString.call(instrument) === '[object Object]') {
      instrument = objectMerge(instrumentDefaults, instrument);
    } else if (instrument !== false) {
      instrument = instrumentDefaults;
    }
    globalOptions.instrument = instrument;

    TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;

    // return for chaining
    return self;
  },

  /*
     * Installs a global window.onerror error handler
     * to capture and report uncaught exceptions.
     * At this point, install() is required to be called due
     * to the way TraceKit is set up.
     *
     * @return {Raven}
     */
  install: function() {
    var self = this;
    if (self.isSetup() && !self._isRavenInstalled) {
      TraceKit.report.subscribe(function() {
        self._handleOnErrorStackInfo.apply(self, arguments);
      });

      if (self._globalOptions.captureUnhandledRejections) {
        self._attachPromiseRejectionHandler();
      }

      self._patchFunctionToString();

      if (self._globalOptions.instrument && self._globalOptions.instrument.tryCatch) {
        self._instrumentTryCatch();
      }

      if (self._globalOptions.autoBreadcrumbs) self._instrumentBreadcrumbs();

      // Install all of the plugins
      self._drainPlugins();

      self._isRavenInstalled = true;
    }

    Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
    return this;
  },

  /*
     * Set the DSN (can be called multiple time unlike config)
     *
     * @param {string} dsn The public Sentry DSN
     */
  setDSN: function(dsn) {
    var self = this,
      uri = self._parseDSN(dsn),
      lastSlash = uri.path.lastIndexOf('/'),
      path = uri.path.substr(1, lastSlash);

    self._dsn = dsn;
    self._globalKey = uri.user;
    self._globalSecret = uri.pass && uri.pass.substr(1);
    self._globalProject = uri.path.substr(lastSlash + 1);

    self._globalServer = self._getGlobalServer(uri);

    self._globalEndpoint =
      self._globalServer + '/' + path + 'api/' + self._globalProject + '/store/';

    // Reset backoff state since we may be pointing at a
    // new project/server
    this._resetBackoff();
  },

  /*
     * Wrap code within a context so Raven can capture errors
     * reliably across domains that is executed immediately.
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The callback to be immediately executed within the context
     * @param {array} args An array of arguments to be called with the callback [optional]
     */
  context: function(options, func, args) {
    if (isFunction(options)) {
      args = func || [];
      func = options;
      options = undefined;
    }

    return this.wrap(options, func).apply(this, args);
  },

  /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} func A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */
  wrap: function(options, func, _before) {
    var self = this;
    // 1 argument has been passed, and it's not a function
    // so just return it
    if (isUndefined(func) && !isFunction(options)) {
      return options;
    }

    // options is optional
    if (isFunction(options)) {
      func = options;
      options = undefined;
    }

    // At this point, we've passed along 2 arguments, and the second one
    // is not a function either, so we'll just return the second argument.
    if (!isFunction(func)) {
      return func;
    }

    // We don't wanna wrap it twice!
    try {
      if (func.__raven__) {
        return func;
      }

      // If this has already been wrapped in the past, return that
      if (func.__raven_wrapper__) {
        return func.__raven_wrapper__;
      }
    } catch (e) {
      // Just accessing custom props in some Selenium environments
      // can cause a "Permission denied" exception (see raven-js#495).
      // Bail on wrapping and return the function as-is (defers to window.onerror).
      return func;
    }

    function wrapped() {
      var args = [],
        i = arguments.length,
        deep = !options || (options && options.deep !== false);

      if (_before && isFunction(_before)) {
        _before.apply(this, arguments);
      }

      // Recursively wrap all of a function's arguments that are
      // functions themselves.
      while (i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];

      try {
        // Attempt to invoke user-land function
        // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
        //       means Raven caught an error invoking your application code. This is
        //       expected behavior and NOT indicative of a bug with Raven.js.
        return func.apply(this, args);
      } catch (e) {
        self._ignoreNextOnError();
        self.captureException(e, options);
        throw e;
      }
    }

    // copy over properties of the old function
    for (var property in func) {
      if (hasKey(func, property)) {
        wrapped[property] = func[property];
      }
    }
    wrapped.prototype = func.prototype;

    func.__raven_wrapper__ = wrapped;
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    wrapped.__raven__ = true;
    wrapped.__orig__ = func;

    return wrapped;
  },

  /**
   * Uninstalls the global error handler.
   *
   * @return {Raven}
   */
  uninstall: function() {
    TraceKit.report.uninstall();

    this._detachPromiseRejectionHandler();
    this._unpatchFunctionToString();
    this._restoreBuiltIns();
    this._restoreConsole();

    Error.stackTraceLimit = this._originalErrorStackTraceLimit;
    this._isRavenInstalled = false;

    return this;
  },

  /**
   * Callback used for `unhandledrejection` event
   *
   * @param {PromiseRejectionEvent} event An object containing
   *   promise: the Promise that was rejected
   *   reason: the value with which the Promise was rejected
   * @return void
   */
  _promiseRejectionHandler: function(event) {
    this._logDebug('debug', 'Raven caught unhandled promise rejection:', event);
    this.captureException(event.reason, {
      extra: {
        unhandledPromiseRejection: true
      }
    });
  },

  /**
   * Installs the global promise rejection handler.
   *
   * @return {raven}
   */
  _attachPromiseRejectionHandler: function() {
    this._promiseRejectionHandler = this._promiseRejectionHandler.bind(this);
    _window.addEventListener &&
      _window.addEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Uninstalls the global promise rejection handler.
   *
   * @return {raven}
   */
  _detachPromiseRejectionHandler: function() {
    _window.removeEventListener &&
      _window.removeEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Manually capture an exception and send it over to Sentry
   *
   * @param {error} ex An exception to be logged
   * @param {object} options A specific set of options for this error [optional]
   * @return {Raven}
   */
  captureException: function(ex, options) {
    options = objectMerge({trimHeadFrames: 0}, options ? options : {});

    if (isErrorEvent(ex) && ex.error) {
      // If it is an ErrorEvent with `error` property, extract it to get actual Error
      ex = ex.error;
    } else if (isError(ex)) {
      // we have a real Error object
      ex = ex;
    } else if (isPlainObject(ex)) {
      // If it is plain Object, serialize it manually and extract options
      // This will allow us to group events based on top-level keys
      // which is much better than creating new group when any key/value change
      options = this._getCaptureExceptionOptionsFromPlainObject(options, ex);
      ex = new Error(options.message);
    } else {
      // If none of previous checks were valid, then it means that
      // it's not a plain Object
      // it's not a valid ErrorEvent (one with an error property)
      // it's not an Error
      // So bail out and capture it as a simple message:
      return this.captureMessage(
        ex,
        objectMerge(options, {
          stacktrace: true, // if we fall back to captureMessage, default to attempting a new trace
          trimHeadFrames: options.trimHeadFrames + 1
        })
      );
    }

    // Store the raw exception object for potential debugging and introspection
    this._lastCapturedException = ex;

    // TraceKit.report will re-raise any exception passed to it,
    // which means you have to wrap it in try/catch. Instead, we
    // can wrap it here and only re-raise if TraceKit.report
    // raises an exception different from the one we asked to
    // report on.
    try {
      var stack = TraceKit.computeStackTrace(ex);
      this._handleStackInfo(stack, options);
    } catch (ex1) {
      if (ex !== ex1) {
        throw ex1;
      }
    }

    return this;
  },

  _getCaptureExceptionOptionsFromPlainObject: function(currentOptions, ex) {
    var exKeys = Object.keys(ex).sort();
    var options = objectMerge(currentOptions, {
      message:
        'Non-Error exception captured with keys: ' + serializeKeysForMessage(exKeys),
      fingerprint: [md5(exKeys)],
      extra: currentOptions.extra || {}
    });
    options.extra.__serialized__ = serializeException(ex);

    return options;
  },

  /*
     * Manually send a message to Sentry
     *
     * @param {string} msg A plain message to be captured in Sentry
     * @param {object} options A specific set of options for this message [optional]
     * @return {Raven}
     */
  captureMessage: function(msg, options) {
    // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
    // early call; we'll error on the side of logging anything called before configuration since it's
    // probably something you should see:
    if (
      !!this._globalOptions.ignoreErrors.test &&
      this._globalOptions.ignoreErrors.test(msg)
    ) {
      return;
    }

    options = options || {};
    msg = msg + ''; // Make sure it's actually a string

    var data = objectMerge(
      {
        message: msg
      },
      options
    );

    var ex;
    // Generate a "synthetic" stack trace from this point.
    // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
    //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
    //       or if it catches a thrown object without a "stack" property.
    try {
      throw new Error(msg);
    } catch (ex1) {
      ex = ex1;
    }

    // null exception name so `Error` isn't prefixed to msg
    ex.name = null;
    var stack = TraceKit.computeStackTrace(ex);

    // stack[0] is `throw new Error(msg)` call itself, we are interested in the frame that was just before that, stack[1]
    var initialCall = isArray(stack.stack) && stack.stack[1];

    // if stack[1] is `Raven.captureException`, it means that someone passed a string to it and we redirected that call
    // to be handled by `captureMessage`, thus `initialCall` is the 3rd one, not 2nd
    // initialCall => captureException(string) => captureMessage(string)
    if (initialCall && initialCall.func === 'Raven.captureException') {
      initialCall = stack.stack[2];
    }

    var fileurl = (initialCall && initialCall.url) || '';

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    if (this._globalOptions.stacktrace || (options && options.stacktrace)) {
      // fingerprint on msg, not stack trace (legacy behavior, could be revisited)
      data.fingerprint = data.fingerprint == null ? msg : data.fingerprint;

      options = objectMerge(
        {
          trimHeadFrames: 0
        },
        options
      );
      // Since we know this is a synthetic trace, the top frame (this function call)
      // MUST be from Raven.js, so mark it for trimming
      // We add to the trim counter so that callers can choose to trim extra frames, such
      // as utility functions.
      options.trimHeadFrames += 1;

      var frames = this._prepareFrames(stack, options);
      data.stacktrace = {
        // Sentry expects frames oldest to newest
        frames: frames.reverse()
      };
    }

    // Make sure that fingerprint is always wrapped in an array
    if (data.fingerprint) {
      data.fingerprint = isArray(data.fingerprint)
        ? data.fingerprint
        : [data.fingerprint];
    }

    // Fire away!
    this._send(data);

    return this;
  },

  captureBreadcrumb: function(obj) {
    var crumb = objectMerge(
      {
        timestamp: now() / 1000
      },
      obj
    );

    if (isFunction(this._globalOptions.breadcrumbCallback)) {
      var result = this._globalOptions.breadcrumbCallback(crumb);

      if (isObject(result) && !isEmptyObject(result)) {
        crumb = result;
      } else if (result === false) {
        return this;
      }
    }

    this._breadcrumbs.push(crumb);
    if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
      this._breadcrumbs.shift();
    }
    return this;
  },

  addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
    var pluginArgs = [].slice.call(arguments, 1);

    this._plugins.push([plugin, pluginArgs]);
    if (this._isRavenInstalled) {
      this._drainPlugins();
    }

    return this;
  },

  /*
     * Set/clear a user to be sent along with the payload.
     *
     * @param {object} user An object representing user data [optional]
     * @return {Raven}
     */
  setUserContext: function(user) {
    // Intentionally do not merge here since that's an unexpected behavior.
    this._globalContext.user = user;

    return this;
  },

  /*
     * Merge extra attributes to be sent along with the payload.
     *
     * @param {object} extra An object representing extra data [optional]
     * @return {Raven}
     */
  setExtraContext: function(extra) {
    this._mergeContext('extra', extra);

    return this;
  },

  /*
     * Merge tags to be sent along with the payload.
     *
     * @param {object} tags An object representing tags [optional]
     * @return {Raven}
     */
  setTagsContext: function(tags) {
    this._mergeContext('tags', tags);

    return this;
  },

  /*
     * Clear all of the context.
     *
     * @return {Raven}
     */
  clearContext: function() {
    this._globalContext = {};

    return this;
  },

  /*
     * Get a copy of the current context. This cannot be mutated.
     *
     * @return {object} copy of context
     */
  getContext: function() {
    // lol javascript
    return JSON.parse(stringify(this._globalContext));
  },

  /*
     * Set environment of application
     *
     * @param {string} environment Typically something like 'production'.
     * @return {Raven}
     */
  setEnvironment: function(environment) {
    this._globalOptions.environment = environment;

    return this;
  },

  /*
     * Set release version of application
     *
     * @param {string} release Typically something like a git SHA to identify version
     * @return {Raven}
     */
  setRelease: function(release) {
    this._globalOptions.release = release;

    return this;
  },

  /*
     * Set the dataCallback option
     *
     * @param {function} callback The callback to run which allows the
     *                            data blob to be mutated before sending
     * @return {Raven}
     */
  setDataCallback: function(callback) {
    var original = this._globalOptions.dataCallback;
    this._globalOptions.dataCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the breadcrumbCallback option
     *
     * @param {function} callback The callback to run which allows filtering
     *                            or mutating breadcrumbs
     * @return {Raven}
     */
  setBreadcrumbCallback: function(callback) {
    var original = this._globalOptions.breadcrumbCallback;
    this._globalOptions.breadcrumbCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the shouldSendCallback option
     *
     * @param {function} callback The callback to run which allows
     *                            introspecting the blob before sending
     * @return {Raven}
     */
  setShouldSendCallback: function(callback) {
    var original = this._globalOptions.shouldSendCallback;
    this._globalOptions.shouldSendCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /**
   * Override the default HTTP transport mechanism that transmits data
   * to the Sentry server.
   *
   * @param {function} transport Function invoked instead of the default
   *                             `makeRequest` handler.
   *
   * @return {Raven}
   */
  setTransport: function(transport) {
    this._globalOptions.transport = transport;

    return this;
  },

  /*
     * Get the latest raw exception that was captured by Raven.
     *
     * @return {error}
     */
  lastException: function() {
    return this._lastCapturedException;
  },

  /*
     * Get the last event id
     *
     * @return {string}
     */
  lastEventId: function() {
    return this._lastEventId;
  },

  /*
     * Determine if Raven is setup and ready to go.
     *
     * @return {boolean}
     */
  isSetup: function() {
    if (!this._hasJSON) return false; // needs JSON support
    if (!this._globalServer) {
      if (!this.ravenNotConfiguredError) {
        this.ravenNotConfiguredError = true;
        this._logDebug('error', 'Error: Raven has not been configured.');
      }
      return false;
    }
    return true;
  },

  afterLoad: function() {
    // TODO: remove window dependence?

    // Attempt to initialize Raven on load
    var RavenConfig = _window.RavenConfig;
    if (RavenConfig) {
      this.config(RavenConfig.dsn, RavenConfig.config).install();
    }
  },

  showReportDialog: function(options) {
    if (
      !_document // doesn't work without a document (React native)
    )
      return;

    options = options || {};

    var lastEventId = options.eventId || this.lastEventId();
    if (!lastEventId) {
      throw new RavenConfigError('Missing eventId');
    }

    var dsn = options.dsn || this._dsn;
    if (!dsn) {
      throw new RavenConfigError('Missing DSN');
    }

    var encode = encodeURIComponent;
    var qs = '';
    qs += '?eventId=' + encode(lastEventId);
    qs += '&dsn=' + encode(dsn);

    var user = options.user || this._globalContext.user;
    if (user) {
      if (user.name) qs += '&name=' + encode(user.name);
      if (user.email) qs += '&email=' + encode(user.email);
    }

    var globalServer = this._getGlobalServer(this._parseDSN(dsn));

    var script = _document.createElement('script');
    script.async = true;
    script.src = globalServer + '/api/embed/error-page/' + qs;
    (_document.head || _document.body).appendChild(script);
  },

  /**** Private functions ****/
  _ignoreNextOnError: function() {
    var self = this;
    this._ignoreOnError += 1;
    setTimeout(function() {
      // onerror should trigger before setTimeout
      self._ignoreOnError -= 1;
    });
  },

  _triggerEvent: function(eventType, options) {
    // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
    var evt, key;

    if (!this._hasDocument) return;

    options = options || {};

    eventType = 'raven' + eventType.substr(0, 1).toUpperCase() + eventType.substr(1);

    if (_document.createEvent) {
      evt = _document.createEvent('HTMLEvents');
      evt.initEvent(eventType, true, true);
    } else {
      evt = _document.createEventObject();
      evt.eventType = eventType;
    }

    for (key in options)
      if (hasKey(options, key)) {
        evt[key] = options[key];
      }

    if (_document.createEvent) {
      // IE9 if standards
      _document.dispatchEvent(evt);
    } else {
      // IE8 regardless of Quirks or Standards
      // IE9 if quirks
      try {
        _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
      } catch (e) {
        // Do nothing
      }
    }
  },

  /**
   * Wraps addEventListener to capture UI breadcrumbs
   * @param evtName the event name (e.g. "click")
   * @returns {Function}
   * @private
   */
  _breadcrumbEventHandler: function(evtName) {
    var self = this;
    return function(evt) {
      // reset keypress timeout; e.g. triggering a 'click' after
      // a 'keypress' will reset the keypress debounce so that a new
      // set of keypresses can be recorded
      self._keypressTimeout = null;

      // It's possible this handler might trigger multiple times for the same
      // event (e.g. event propagation through node ancestors). Ignore if we've
      // already captured the event.
      if (self._lastCapturedEvent === evt) return;

      self._lastCapturedEvent = evt;

      // try/catch both:
      // - accessing evt.target (see getsentry/raven-js#838, #768)
      // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
      //   can throw an exception in some circumstances.
      var target;
      try {
        target = htmlTreeAsString(evt.target);
      } catch (e) {
        target = '<unknown>';
      }

      self.captureBreadcrumb({
        category: 'ui.' + evtName, // e.g. ui.click, ui.input
        message: target
      });
    };
  },

  /**
   * Wraps addEventListener to capture keypress UI events
   * @returns {Function}
   * @private
   */
  _keypressEventHandler: function() {
    var self = this,
      debounceDuration = 1000; // milliseconds

    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function(evt) {
      var target;
      try {
        target = evt.target;
      } catch (e) {
        // just accessing event properties can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/raven-js/issues/838
        return;
      }
      var tagName = target && target.tagName;

      // only consider keypress events on actual input elements
      // this will disregard keypresses targeting body (e.g. tabbing
      // through elements, hotkeys, etc)
      if (
        !tagName ||
        (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
      )
        return;

      // record first keypress in a series, but ignore subsequent
      // keypresses until debounce clears
      var timeout = self._keypressTimeout;
      if (!timeout) {
        self._breadcrumbEventHandler('input')(evt);
      }
      clearTimeout(timeout);
      self._keypressTimeout = setTimeout(function() {
        self._keypressTimeout = null;
      }, debounceDuration);
    };
  },

  /**
   * Captures a breadcrumb of type "navigation", normalizing input URLs
   * @param to the originating URL
   * @param from the target URL
   * @private
   */
  _captureUrlChange: function(from, to) {
    var parsedLoc = parseUrl(this._location.href);
    var parsedTo = parseUrl(to);
    var parsedFrom = parseUrl(from);

    // because onpopstate only tells you the "new" (to) value of location.href, and
    // not the previous (from) value, we need to track the value of the current URL
    // state ourselves
    this._lastHref = to;

    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
      to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
      from = parsedFrom.relative;

    this.captureBreadcrumb({
      category: 'navigation',
      data: {
        to: to,
        from: from
      }
    });
  },

  _patchFunctionToString: function() {
    var self = this;
    self._originalFunctionToString = Function.prototype.toString;
    // eslint-disable-next-line no-extend-native
    Function.prototype.toString = function() {
      if (typeof this === 'function' && this.__raven__) {
        return self._originalFunctionToString.apply(this.__orig__, arguments);
      }
      return self._originalFunctionToString.apply(this, arguments);
    };
  },

  _unpatchFunctionToString: function() {
    if (this._originalFunctionToString) {
      // eslint-disable-next-line no-extend-native
      Function.prototype.toString = this._originalFunctionToString;
    }
  },

  /**
   * Wrap timer functions and event targets to catch errors and provide
   * better metadata.
   */
  _instrumentTryCatch: function() {
    var self = this;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapTimeFn(orig) {
      return function(fn, t) {
        // preserve arity
        // Make a copy of the arguments to prevent deoptimization
        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i) {
          args[i] = arguments[i];
        }
        var originalCallback = args[0];
        if (isFunction(originalCallback)) {
          args[0] = self.wrap(originalCallback);
        }

        // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
        // also supports only two arguments and doesn't care what this is, so we
        // can just call the original function directly.
        if (orig.apply) {
          return orig.apply(this, args);
        } else {
          return orig(args[0], args[1]);
        }
      };
    }

    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    function wrapEventTarget(global) {
      var proto = _window[global] && _window[global].prototype;
      if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
        fill(
          proto,
          'addEventListener',
          function(orig) {
            return function(evtName, fn, capture, secure) {
              // preserve arity
              try {
                if (fn && fn.handleEvent) {
                  fn.handleEvent = self.wrap(fn.handleEvent);
                }
              } catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
              }

              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
              // so that we don't have more than one wrapper function
              var before, clickHandler, keypressHandler;

              if (
                autoBreadcrumbs &&
                autoBreadcrumbs.dom &&
                (global === 'EventTarget' || global === 'Node')
              ) {
                // NOTE: generating multiple handlers per addEventListener invocation, should
                //       revisit and verify we can just use one (almost certainly)
                clickHandler = self._breadcrumbEventHandler('click');
                keypressHandler = self._keypressEventHandler();
                before = function(evt) {
                  // need to intercept every DOM event in `before` argument, in case that
                  // same wrapped method is re-used for different events (e.g. mousemove THEN click)
                  // see #724
                  if (!evt) return;

                  var eventType;
                  try {
                    eventType = evt.type;
                  } catch (e) {
                    // just accessing event properties can throw an exception in some rare circumstances
                    // see: https://github.com/getsentry/raven-js/issues/838
                    return;
                  }
                  if (eventType === 'click') return clickHandler(evt);
                  else if (eventType === 'keypress') return keypressHandler(evt);
                };
              }
              return orig.call(
                this,
                evtName,
                self.wrap(fn, undefined, before),
                capture,
                secure
              );
            };
          },
          wrappedBuiltIns
        );
        fill(
          proto,
          'removeEventListener',
          function(orig) {
            return function(evt, fn, capture, secure) {
              try {
                fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__ : fn);
              } catch (e) {
                // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
              }
              return orig.call(this, evt, fn, capture, secure);
            };
          },
          wrappedBuiltIns
        );
      }
    }

    fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
    fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
    if (_window.requestAnimationFrame) {
      fill(
        _window,
        'requestAnimationFrame',
        function(orig) {
          return function(cb) {
            return orig(self.wrap(cb));
          };
        },
        wrappedBuiltIns
      );
    }

    // event targets borrowed from bugsnag-js:
    // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
    var eventTargets = [
      'EventTarget',
      'Window',
      'Node',
      'ApplicationCache',
      'AudioTrackList',
      'ChannelMergerNode',
      'CryptoOperation',
      'EventSource',
      'FileReader',
      'HTMLUnknownElement',
      'IDBDatabase',
      'IDBRequest',
      'IDBTransaction',
      'KeyOperation',
      'MediaController',
      'MessagePort',
      'ModalWindow',
      'Notification',
      'SVGElementInstance',
      'Screen',
      'TextTrack',
      'TextTrackCue',
      'TextTrackList',
      'WebSocket',
      'WebSocketWorker',
      'Worker',
      'XMLHttpRequest',
      'XMLHttpRequestEventTarget',
      'XMLHttpRequestUpload'
    ];
    for (var i = 0; i < eventTargets.length; i++) {
      wrapEventTarget(eventTargets[i]);
    }
  },

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - XMLHttpRequests
   *  - DOM interactions (click/typing)
   *  - window.location changes
   *  - console
   *
   * Can be disabled or individually configured via the `autoBreadcrumbs` config option
   */
  _instrumentBreadcrumbs: function() {
    var self = this;
    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapProp(prop, xhr) {
      if (prop in xhr && isFunction(xhr[prop])) {
        fill(xhr, prop, function(orig) {
          return self.wrap(orig);
        }); // intentionally don't track filled methods on XHR instances
      }
    }

    if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
      var xhrproto = _window.XMLHttpRequest && _window.XMLHttpRequest.prototype;
      fill(
        xhrproto,
        'open',
        function(origOpen) {
          return function(method, url) {
            // preserve arity

            // if Sentry key appears in URL, don't capture
            if (isString(url) && url.indexOf(self._globalKey) === -1) {
              this.__raven_xhr = {
                method: method,
                url: url,
                status_code: null
              };
            }

            return origOpen.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );

      fill(
        xhrproto,
        'send',
        function(origSend) {
          return function() {
            // preserve arity
            var xhr = this;

            function onreadystatechangeHandler() {
              if (xhr.__raven_xhr && xhr.readyState === 4) {
                try {
                  // touching statusCode in some platforms throws
                  // an exception
                  xhr.__raven_xhr.status_code = xhr.status;
                } catch (e) {
                  /* do nothing */
                }

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'xhr',
                  data: xhr.__raven_xhr
                });
              }
            }

            var props = ['onload', 'onerror', 'onprogress'];
            for (var j = 0; j < props.length; j++) {
              wrapProp(props[j], xhr);
            }

            if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
              fill(
                xhr,
                'onreadystatechange',
                function(orig) {
                  return self.wrap(orig, undefined, onreadystatechangeHandler);
                } /* intentionally don't track this instrumentation */
              );
            } else {
              // if onreadystatechange wasn't actually set by the page on this xhr, we
              // are free to set our own and capture the breadcrumb
              xhr.onreadystatechange = onreadystatechangeHandler;
            }

            return origSend.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );
    }

    if (autoBreadcrumbs.xhr && supportsFetch()) {
      fill(
        _window,
        'fetch',
        function(origFetch) {
          return function() {
            // preserve arity
            // Make a copy of the arguments to prevent deoptimization
            // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
            var args = new Array(arguments.length);
            for (var i = 0; i < args.length; ++i) {
              args[i] = arguments[i];
            }

            var fetchInput = args[0];
            var method = 'GET';
            var url;

            if (typeof fetchInput === 'string') {
              url = fetchInput;
            } else if ('Request' in _window && fetchInput instanceof _window.Request) {
              url = fetchInput.url;
              if (fetchInput.method) {
                method = fetchInput.method;
              }
            } else {
              url = '' + fetchInput;
            }

            // if Sentry key appears in URL, don't capture, as it's our own request
            if (url.indexOf(self._globalKey) !== -1) {
              return origFetch.apply(this, args);
            }

            if (args[1] && args[1].method) {
              method = args[1].method;
            }

            var fetchData = {
              method: method,
              url: url,
              status_code: null
            };

            return origFetch
              .apply(this, args)
              .then(function(response) {
                fetchData.status_code = response.status;

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'fetch',
                  data: fetchData
                });

                return response;
              })
              ['catch'](function(err) {
                // if there is an error performing the request
                self.captureBreadcrumb({
                  type: 'http',
                  category: 'fetch',
                  data: fetchData,
                  level: 'error'
                });

                throw err;
              });
          };
        },
        wrappedBuiltIns
      );
    }

    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    if (autoBreadcrumbs.dom && this._hasDocument) {
      if (_document.addEventListener) {
        _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
        _document.addEventListener('keypress', self._keypressEventHandler(), false);
      } else if (_document.attachEvent) {
        // IE8 Compatibility
        _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
        _document.attachEvent('onkeypress', self._keypressEventHandler());
      }
    }

    // record navigation (URL) changes
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var chrome = _window.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasPushAndReplaceState =
      !isChromePackagedApp &&
      _window.history &&
      history.pushState &&
      history.replaceState;
    if (autoBreadcrumbs.location && hasPushAndReplaceState) {
      // TODO: remove onpopstate handler on uninstall()
      var oldOnPopState = _window.onpopstate;
      _window.onpopstate = function() {
        var currentHref = self._location.href;
        self._captureUrlChange(self._lastHref, currentHref);

        if (oldOnPopState) {
          return oldOnPopState.apply(this, arguments);
        }
      };

      var historyReplacementFunction = function(origHistFunction) {
        // note history.pushState.length is 0; intentionally not declaring
        // params to preserve 0 arity
        return function(/* state, title, url */) {
          var url = arguments.length > 2 ? arguments[2] : undefined;

          // url argument is optional
          if (url) {
            // coerce to string (this is what pushState does)
            self._captureUrlChange(self._lastHref, url + '');
          }

          return origHistFunction.apply(this, arguments);
        };
      };

      fill(history, 'pushState', historyReplacementFunction, wrappedBuiltIns);
      fill(history, 'replaceState', historyReplacementFunction, wrappedBuiltIns);
    }

    if (autoBreadcrumbs.console && 'console' in _window && console.log) {
      // console
      var consoleMethodCallback = function(msg, data) {
        self.captureBreadcrumb({
          message: msg,
          level: data.level,
          category: 'console'
        });
      };

      each(['debug', 'info', 'warn', 'error', 'log'], function(_, level) {
        wrapConsoleMethod(console, level, consoleMethodCallback);
      });
    }
  },

  _restoreBuiltIns: function() {
    // restore any wrapped builtins
    var builtin;
    while (this._wrappedBuiltIns.length) {
      builtin = this._wrappedBuiltIns.shift();

      var obj = builtin[0],
        name = builtin[1],
        orig = builtin[2];

      obj[name] = orig;
    }
  },

  _restoreConsole: function() {
    // eslint-disable-next-line guard-for-in
    for (var method in this._originalConsoleMethods) {
      this._originalConsole[method] = this._originalConsoleMethods[method];
    }
  },

  _drainPlugins: function() {
    var self = this;

    // FIX ME TODO
    each(this._plugins, function(_, plugin) {
      var installer = plugin[0];
      var args = plugin[1];
      installer.apply(self, [self].concat(args));
    });
  },

  _parseDSN: function(str) {
    var m = dsnPattern.exec(str),
      dsn = {},
      i = 7;

    try {
      while (i--) dsn[dsnKeys[i]] = m[i] || '';
    } catch (e) {
      throw new RavenConfigError('Invalid DSN: ' + str);
    }

    if (dsn.pass && !this._globalOptions.allowSecretKey) {
      throw new RavenConfigError(
        'Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key'
      );
    }

    return dsn;
  },

  _getGlobalServer: function(uri) {
    // assemble the endpoint from the uri pieces
    var globalServer = '//' + uri.host + (uri.port ? ':' + uri.port : '');

    if (uri.protocol) {
      globalServer = uri.protocol + ':' + globalServer;
    }
    return globalServer;
  },

  _handleOnErrorStackInfo: function() {
    // if we are intentionally ignoring errors via onerror, bail out
    if (!this._ignoreOnError) {
      this._handleStackInfo.apply(this, arguments);
    }
  },

  _handleStackInfo: function(stackInfo, options) {
    var frames = this._prepareFrames(stackInfo, options);

    this._triggerEvent('handle', {
      stackInfo: stackInfo,
      options: options
    });

    this._processException(
      stackInfo.name,
      stackInfo.message,
      stackInfo.url,
      stackInfo.lineno,
      frames,
      options
    );
  },

  _prepareFrames: function(stackInfo, options) {
    var self = this;
    var frames = [];
    if (stackInfo.stack && stackInfo.stack.length) {
      each(stackInfo.stack, function(i, stack) {
        var frame = self._normalizeFrame(stack, stackInfo.url);
        if (frame) {
          frames.push(frame);
        }
      });

      // e.g. frames captured via captureMessage throw
      if (options && options.trimHeadFrames) {
        for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
          frames[j].in_app = false;
        }
      }
    }
    frames = frames.slice(0, this._globalOptions.stackTraceLimit);
    return frames;
  },

  _normalizeFrame: function(frame, stackInfoUrl) {
    // normalize the frames data
    var normalized = {
      filename: frame.url,
      lineno: frame.line,
      colno: frame.column,
      function: frame.func || '?'
    };

    // Case when we don't have any information about the error
    // E.g. throwing a string or raw object, instead of an `Error` in Firefox
    // Generating synthetic error doesn't add any value here
    //
    // We should probably somehow let a user know that they should fix their code
    if (!frame.url) {
      normalized.filename = stackInfoUrl; // fallback to whole stacks url from onerror handler
    }

    normalized.in_app = !// determine if an exception came from outside of our app
    // first we check the global includePaths list.
    (
      (!!this._globalOptions.includePaths.test &&
        !this._globalOptions.includePaths.test(normalized.filename)) ||
      // Now we check for fun, if the function name is Raven or TraceKit
      /(Raven|TraceKit)\./.test(normalized['function']) ||
      // finally, we do a last ditch effort and check for raven.min.js
      /raven\.(min\.)?js$/.test(normalized.filename)
    );

    return normalized;
  },

  _processException: function(type, message, fileurl, lineno, frames, options) {
    var prefixedMessage = (type ? type + ': ' : '') + (message || '');
    if (
      !!this._globalOptions.ignoreErrors.test &&
      (this._globalOptions.ignoreErrors.test(message) ||
        this._globalOptions.ignoreErrors.test(prefixedMessage))
    ) {
      return;
    }

    var stacktrace;

    if (frames && frames.length) {
      fileurl = frames[0].filename || fileurl;
      // Sentry expects frames oldest to newest
      // and JS sends them as newest to oldest
      frames.reverse();
      stacktrace = {frames: frames};
    } else if (fileurl) {
      stacktrace = {
        frames: [
          {
            filename: fileurl,
            lineno: lineno,
            in_app: true
          }
        ]
      };
    }

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    var data = objectMerge(
      {
        // sentry.interfaces.Exception
        exception: {
          values: [
            {
              type: type,
              value: message,
              stacktrace: stacktrace
            }
          ]
        },
        culprit: fileurl
      },
      options
    );

    // Fire away!
    this._send(data);
  },

  _trimPacket: function(data) {
    // For now, we only want to truncate the two different messages
    // but this could/should be expanded to just trim everything
    var max = this._globalOptions.maxMessageLength;
    if (data.message) {
      data.message = truncate(data.message, max);
    }
    if (data.exception) {
      var exception = data.exception.values[0];
      exception.value = truncate(exception.value, max);
    }

    var request = data.request;
    if (request) {
      if (request.url) {
        request.url = truncate(request.url, this._globalOptions.maxUrlLength);
      }
      if (request.Referer) {
        request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
      }
    }

    if (data.breadcrumbs && data.breadcrumbs.values)
      this._trimBreadcrumbs(data.breadcrumbs);

    return data;
  },

  /**
   * Truncate breadcrumb values (right now just URLs)
   */
  _trimBreadcrumbs: function(breadcrumbs) {
    // known breadcrumb properties with urls
    // TODO: also consider arbitrary prop values that start with (https?)?://
    var urlProps = ['to', 'from', 'url'],
      urlProp,
      crumb,
      data;

    for (var i = 0; i < breadcrumbs.values.length; ++i) {
      crumb = breadcrumbs.values[i];
      if (
        !crumb.hasOwnProperty('data') ||
        !isObject(crumb.data) ||
        objectFrozen(crumb.data)
      )
        continue;

      data = objectMerge({}, crumb.data);
      for (var j = 0; j < urlProps.length; ++j) {
        urlProp = urlProps[j];
        if (data.hasOwnProperty(urlProp) && data[urlProp]) {
          data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
        }
      }
      breadcrumbs.values[i].data = data;
    }
  },

  _getHttpData: function() {
    if (!this._hasNavigator && !this._hasDocument) return;
    var httpData = {};

    if (this._hasNavigator && _navigator.userAgent) {
      httpData.headers = {
        'User-Agent': navigator.userAgent
      };
    }

    // Check in `window` instead of `document`, as we may be in ServiceWorker environment
    if (_window.location && _window.location.href) {
      httpData.url = _window.location.href;
    }

    if (this._hasDocument && _document.referrer) {
      if (!httpData.headers) httpData.headers = {};
      httpData.headers.Referer = _document.referrer;
    }

    return httpData;
  },

  _resetBackoff: function() {
    this._backoffDuration = 0;
    this._backoffStart = null;
  },

  _shouldBackoff: function() {
    return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
  },

  /**
   * Returns true if the in-process data payload matches the signature
   * of the previously-sent data
   *
   * NOTE: This has to be done at this level because TraceKit can generate
   *       data from window.onerror WITHOUT an exception object (IE8, IE9,
   *       other old browsers). This can take the form of an "exception"
   *       data object with a single frame (derived from the onerror args).
   */
  _isRepeatData: function(current) {
    var last = this._lastData;

    if (
      !last ||
      current.message !== last.message || // defined for captureMessage
      current.culprit !== last.culprit // defined for captureException/onerror
    )
      return false;

    // Stacktrace interface (i.e. from captureMessage)
    if (current.stacktrace || last.stacktrace) {
      return isSameStacktrace(current.stacktrace, last.stacktrace);
    } else if (current.exception || last.exception) {
      // Exception interface (i.e. from captureException/onerror)
      return isSameException(current.exception, last.exception);
    }

    return true;
  },

  _setBackoffState: function(request) {
    // If we are already in a backoff state, don't change anything
    if (this._shouldBackoff()) {
      return;
    }

    var status = request.status;

    // 400 - project_id doesn't exist or some other fatal
    // 401 - invalid/revoked dsn
    // 429 - too many requests
    if (!(status === 400 || status === 401 || status === 429)) return;

    var retry;
    try {
      // If Retry-After is not in Access-Control-Expose-Headers, most
      // browsers will throw an exception trying to access it
      if (supportsFetch()) {
        retry = request.headers.get('Retry-After');
      } else {
        retry = request.getResponseHeader('Retry-After');
      }

      // Retry-After is returned in seconds
      retry = parseInt(retry, 10) * 1000;
    } catch (e) {
      /* eslint no-empty:0 */
    }

    this._backoffDuration = retry
      ? // If Sentry server returned a Retry-After value, use it
        retry
      : // Otherwise, double the last backoff duration (starts at 1 sec)
        this._backoffDuration * 2 || 1000;

    this._backoffStart = now();
  },

  _send: function(data) {
    var globalOptions = this._globalOptions;

    var baseData = {
        project: this._globalProject,
        logger: globalOptions.logger,
        platform: 'javascript'
      },
      httpData = this._getHttpData();

    if (httpData) {
      baseData.request = httpData;
    }

    // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
    if (data.trimHeadFrames) delete data.trimHeadFrames;

    data = objectMerge(baseData, data);

    // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
    data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
    data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);

    // Send along our own collected metadata with extra
    data.extra['session:duration'] = now() - this._startTime;

    if (this._breadcrumbs && this._breadcrumbs.length > 0) {
      // intentionally make shallow copy so that additions
      // to breadcrumbs aren't accidentally sent in this request
      data.breadcrumbs = {
        values: [].slice.call(this._breadcrumbs, 0)
      };
    }

    if (this._globalContext.user) {
      // sentry.interfaces.User
      data.user = this._globalContext.user;
    }

    // Include the environment if it's defined in globalOptions
    if (globalOptions.environment) data.environment = globalOptions.environment;

    // Include the release if it's defined in globalOptions
    if (globalOptions.release) data.release = globalOptions.release;

    // Include server_name if it's defined in globalOptions
    if (globalOptions.serverName) data.server_name = globalOptions.serverName;

    data = this._sanitizeData(data);

    // Cleanup empty properties before sending them to the server
    Object.keys(data).forEach(function(key) {
      if (data[key] == null || data[key] === '' || isEmptyObject(data[key])) {
        delete data[key];
      }
    });

    if (isFunction(globalOptions.dataCallback)) {
      data = globalOptions.dataCallback(data) || data;
    }

    // Why??????????
    if (!data || isEmptyObject(data)) {
      return;
    }

    // Check if the request should be filtered or not
    if (
      isFunction(globalOptions.shouldSendCallback) &&
      !globalOptions.shouldSendCallback(data)
    ) {
      return;
    }

    // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
    // so drop requests until "cool-off" period has elapsed.
    if (this._shouldBackoff()) {
      this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
      return;
    }

    if (typeof globalOptions.sampleRate === 'number') {
      if (Math.random() < globalOptions.sampleRate) {
        this._sendProcessedPayload(data);
      }
    } else {
      this._sendProcessedPayload(data);
    }
  },

  _sanitizeData: function(data) {
    return sanitize(data, this._globalOptions.sanitizeKeys);
  },

  _getUuid: function() {
    return uuid4();
  },

  _sendProcessedPayload: function(data, callback) {
    var self = this;
    var globalOptions = this._globalOptions;

    if (!this.isSetup()) return;

    // Try and clean up the packet before sending by truncating long values
    data = this._trimPacket(data);

    // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
    // but this would require copying an un-truncated copy of the data packet, which can be
    // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
    if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
      this._logDebug('warn', 'Raven dropped repeat event: ', data);
      return;
    }

    // Send along an event_id if not explicitly passed.
    // This event_id can be used to reference the error within Sentry itself.
    // Set lastEventId after we know the error should actually be sent
    this._lastEventId = data.event_id || (data.event_id = this._getUuid());

    // Store outbound payload after trim
    this._lastData = data;

    this._logDebug('debug', 'Raven about to send:', data);

    var auth = {
      sentry_version: '7',
      sentry_client: 'raven-js/' + this.VERSION,
      sentry_key: this._globalKey
    };

    if (this._globalSecret) {
      auth.sentry_secret = this._globalSecret;
    }

    var exception = data.exception && data.exception.values[0];

    // only capture 'sentry' breadcrumb is autoBreadcrumbs is truthy
    if (
      this._globalOptions.autoBreadcrumbs &&
      this._globalOptions.autoBreadcrumbs.sentry
    ) {
      this.captureBreadcrumb({
        category: 'sentry',
        message: exception
          ? (exception.type ? exception.type + ': ' : '') + exception.value
          : data.message,
        event_id: data.event_id,
        level: data.level || 'error' // presume error unless specified
      });
    }

    var url = this._globalEndpoint;
    (globalOptions.transport || this._makeRequest).call(this, {
      url: url,
      auth: auth,
      data: data,
      options: globalOptions,
      onSuccess: function success() {
        self._resetBackoff();

        self._triggerEvent('success', {
          data: data,
          src: url
        });
        callback && callback();
      },
      onError: function failure(error) {
        self._logDebug('error', 'Raven transport failed to send: ', error);

        if (error.request) {
          self._setBackoffState(error.request);
        }

        self._triggerEvent('failure', {
          data: data,
          src: url
        });
        error = error || new Error('Raven send failed (no additional details provided)');
        callback && callback(error);
      }
    });
  },

  _makeRequest: function(opts) {
    // Auth is intentionally sent as part of query string (NOT as custom HTTP header) to avoid preflight CORS requests
    var url = opts.url + '?' + urlencode(opts.auth);

    var evaluatedHeaders = null;
    var evaluatedFetchParameters = {};

    if (opts.options.headers) {
      evaluatedHeaders = this._evaluateHash(opts.options.headers);
    }

    if (opts.options.fetchParameters) {
      evaluatedFetchParameters = this._evaluateHash(opts.options.fetchParameters);
    }

    if (supportsFetch()) {
      evaluatedFetchParameters.body = stringify(opts.data);

      var defaultFetchOptions = objectMerge({}, this._fetchDefaults);
      var fetchOptions = objectMerge(defaultFetchOptions, evaluatedFetchParameters);

      if (evaluatedHeaders) {
        fetchOptions.headers = evaluatedHeaders;
      }

      return _window
        .fetch(url, fetchOptions)
        .then(function(response) {
          if (response.ok) {
            opts.onSuccess && opts.onSuccess();
          } else {
            var error = new Error('Sentry error code: ' + response.status);
            // It's called request only to keep compatibility with XHR interface
            // and not add more redundant checks in setBackoffState method
            error.request = response;
            opts.onError && opts.onError(error);
          }
        })
        ['catch'](function() {
          opts.onError &&
            opts.onError(new Error('Sentry error code: network unavailable'));
        });
    }

    var request = _window.XMLHttpRequest && new _window.XMLHttpRequest();
    if (!request) return;

    // if browser doesn't support CORS (e.g. IE7), we are out of luck
    var hasCORS = 'withCredentials' in request || typeof XDomainRequest !== 'undefined';

    if (!hasCORS) return;

    if ('withCredentials' in request) {
      request.onreadystatechange = function() {
        if (request.readyState !== 4) {
          return;
        } else if (request.status === 200) {
          opts.onSuccess && opts.onSuccess();
        } else if (opts.onError) {
          var err = new Error('Sentry error code: ' + request.status);
          err.request = request;
          opts.onError(err);
        }
      };
    } else {
      request = new XDomainRequest();
      // xdomainrequest cannot go http -> https (or vice versa),
      // so always use protocol relative
      url = url.replace(/^https?:/, '');

      // onreadystatechange not supported by XDomainRequest
      if (opts.onSuccess) {
        request.onload = opts.onSuccess;
      }
      if (opts.onError) {
        request.onerror = function() {
          var err = new Error('Sentry error code: XDomainRequest');
          err.request = request;
          opts.onError(err);
        };
      }
    }

    request.open('POST', url);

    if (evaluatedHeaders) {
      each(evaluatedHeaders, function(key, value) {
        request.setRequestHeader(key, value);
      });
    }

    request.send(stringify(opts.data));
  },

  _evaluateHash: function(hash) {
    var evaluated = {};

    for (var key in hash) {
      if (hash.hasOwnProperty(key)) {
        var value = hash[key];
        evaluated[key] = typeof value === 'function' ? value() : value;
      }
    }

    return evaluated;
  },

  _logDebug: function(level) {
    // We allow `Raven.debug` and `Raven.config(DSN, { debug: true })` to not make backward incompatible API change
    if (
      this._originalConsoleMethods[level] &&
      (this.debug || this._globalOptions.debug)
    ) {
      // In IE<10 console methods do not have their own 'apply' method
      Function.prototype.apply.call(
        this._originalConsoleMethods[level],
        this._originalConsole,
        [].slice.call(arguments, 1)
      );
    }
  },

  _mergeContext: function(key, context) {
    if (isUndefined(context)) {
      delete this._globalContext[key];
    } else {
      this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
    }
  }
};

// Deprecations
Raven.prototype.setUser = Raven.prototype.setUserContext;
Raven.prototype.setReleaseContext = Raven.prototype.setRelease;

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var utils = __webpack_require__(112);

/*
 TraceKit - Cross brower stack traces

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/

var TraceKit = {
  collectWindowErrors: true,
  debug: false
};

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;

function getLocationHref() {
  if (typeof document === 'undefined' || document.location == null) return '';

  return document.location.href;
}

/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = (function reportModuleWrapper() {
  var handlers = [],
    lastArgs = null,
    lastException = null,
    lastExceptionStack = null;

  /**
   * Add a crash handler.
   * @param {Function} handler
   */
  function subscribe(handler) {
    installGlobalHandler();
    handlers.push(handler);
  }

  /**
   * Remove a crash handler.
   * @param {Function} handler
   */
  function unsubscribe(handler) {
    for (var i = handlers.length - 1; i >= 0; --i) {
      if (handlers[i] === handler) {
        handlers.splice(i, 1);
      }
    }
  }

  /**
   * Remove all crash handlers.
   */
  function unsubscribeAll() {
    uninstallGlobalHandler();
    handlers = [];
  }

  /**
   * Dispatch stack information to all handlers.
   * @param {Object.<string, *>} stack
   */
  function notifyHandlers(stack, isWindowError) {
    var exception = null;
    if (isWindowError && !TraceKit.collectWindowErrors) {
      return;
    }
    for (var i in handlers) {
      if (handlers.hasOwnProperty(i)) {
        try {
          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
        } catch (inner) {
          exception = inner;
        }
      }
    }

    if (exception) {
      throw exception;
    }
  }

  var _oldOnerrorHandler, _onErrorHandlerInstalled;

  /**
   * Ensures all global unhandled exceptions are recorded.
   * Supported by Gecko and IE.
   * @param {string} msg Error message.
   * @param {string} url URL of script that generated the exception.
   * @param {(number|string)} lineNo The line number at which the error
   * occurred.
   * @param {?(number|string)} colNo The column number at which the error
   * occurred.
   * @param {?Error} ex The actual Error object.
   */
  function traceKitWindowOnError(msg, url, lineNo, colNo, ex) {
    var stack = null;
    // If 'ex' is ErrorEvent, get real Error from inside
    var exception = utils.isErrorEvent(ex) ? ex.error : ex;
    // If 'msg' is ErrorEvent, get real message from inside
    var message = utils.isErrorEvent(msg) ? msg.message : msg;

    if (lastExceptionStack) {
      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(
        lastExceptionStack,
        url,
        lineNo,
        message
      );
      processLastException();
    } else if (exception && utils.isError(exception)) {
      // non-string `exception` arg; attempt to extract stack trace

      // New chrome and blink send along a real error object
      // Let's just report that like a normal error.
      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
      stack = TraceKit.computeStackTrace(exception);
      notifyHandlers(stack, true);
    } else {
      var location = {
        url: url,
        line: lineNo,
        column: colNo
      };

      var name = undefined;
      var groups;

      if ({}.toString.call(message) === '[object String]') {
        var groups = message.match(ERROR_TYPES_RE);
        if (groups) {
          name = groups[1];
          message = groups[2];
        }
      }

      location.func = UNKNOWN_FUNCTION;

      stack = {
        name: name,
        message: message,
        url: getLocationHref(),
        stack: [location]
      };
      notifyHandlers(stack, true);
    }

    if (_oldOnerrorHandler) {
      return _oldOnerrorHandler.apply(this, arguments);
    }

    return false;
  }

  function installGlobalHandler() {
    if (_onErrorHandlerInstalled) {
      return;
    }
    _oldOnerrorHandler = _window.onerror;
    _window.onerror = traceKitWindowOnError;
    _onErrorHandlerInstalled = true;
  }

  function uninstallGlobalHandler() {
    if (!_onErrorHandlerInstalled) {
      return;
    }
    _window.onerror = _oldOnerrorHandler;
    _onErrorHandlerInstalled = false;
    _oldOnerrorHandler = undefined;
  }

  function processLastException() {
    var _lastExceptionStack = lastExceptionStack,
      _lastArgs = lastArgs;
    lastArgs = null;
    lastExceptionStack = null;
    lastException = null;
    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
  }

  /**
   * Reports an unhandled Error to TraceKit.
   * @param {Error} ex
   * @param {?boolean} rethrow If false, do not re-throw the exception.
   * Only used for window.onerror to not cause an infinite loop of
   * rethrowing.
   */
  function report(ex, rethrow) {
    var args = _slice.call(arguments, 1);
    if (lastExceptionStack) {
      if (lastException === ex) {
        return; // already caught by an inner catch block, ignore
      } else {
        processLastException();
      }
    }

    var stack = TraceKit.computeStackTrace(ex);
    lastExceptionStack = stack;
    lastException = ex;
    lastArgs = args;

    // If the stack trace is incomplete, wait for 2 seconds for
    // slow slow IE to see if onerror occurs or not before reporting
    // this exception; otherwise, we will end up with an incomplete
    // stack trace
    setTimeout(function() {
      if (lastException === ex) {
        processLastException();
      }
    }, stack.incomplete ? 2000 : 0);

    if (rethrow !== false) {
      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
  }

  report.subscribe = subscribe;
  report.unsubscribe = unsubscribe;
  report.uninstall = unsubscribeAll;
  return report;
})();

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */
TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
  // Contents of Exception in various browsers.
  //
  // SAFARI:
  // ex.message = Can't find variable: qq
  // ex.line = 59
  // ex.sourceId = 580238192
  // ex.sourceURL = http://...
  // ex.expressionBeginOffset = 96
  // ex.expressionCaretOffset = 98
  // ex.expressionEndOffset = 98
  // ex.name = ReferenceError
  //
  // FIREFOX:
  // ex.message = qq is not defined
  // ex.fileName = http://...
  // ex.lineNumber = 59
  // ex.columnNumber = 69
  // ex.stack = ...stack trace... (see the example below)
  // ex.name = ReferenceError
  //
  // CHROME:
  // ex.message = qq is not defined
  // ex.name = ReferenceError
  // ex.type = not_defined
  // ex.arguments = ['aa']
  // ex.stack = ...stack trace...
  //
  // INTERNET EXPLORER:
  // ex.message = ...
  // ex.name = ReferenceError
  //
  // OPERA:
  // ex.message = ...message... (see the example below)
  // ex.name = ReferenceError
  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

  /**
   * Computes stack trace information from the stack property.
   * Chrome and Gecko use this property.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceFromStackProp(ex) {
    if (typeof ex.stack === 'undefined' || !ex.stack) return;

    var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
    var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx(?:-web)|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
    // NOTE: blob urls are now supposed to always have an origin, therefore it's format
    // which is `blob:http://url/path/with-some-uuid`, is matched by `blob.*?:\/` as well
    var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
    // Used to additionally parse URL/line/column from eval frames
    var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
    var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
    var lines = ex.stack.split('\n');
    var stack = [];
    var submatch;
    var parts;
    var element;
    var reference = /^(.*) is undefined$/.exec(ex.message);

    for (var i = 0, j = lines.length; i < j; ++i) {
      if ((parts = chrome.exec(lines[i]))) {
        var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval && (submatch = chromeEval.exec(parts[2]))) {
          // throw out eval line/column and use top-most line/column number
          parts[2] = submatch[1]; // url
          parts[3] = submatch[2]; // line
          parts[4] = submatch[3]; // column
        }
        element = {
          url: !isNative ? parts[2] : null,
          func: parts[1] || UNKNOWN_FUNCTION,
          args: isNative ? [parts[2]] : [],
          line: parts[3] ? +parts[3] : null,
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = winjs.exec(lines[i]))) {
        element = {
          url: parts[2],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: [],
          line: +parts[3],
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = gecko.exec(lines[i]))) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval && (submatch = geckoEval.exec(parts[3]))) {
          // throw out eval line/column and use top-most line number
          parts[3] = submatch[1];
          parts[4] = submatch[2];
          parts[5] = null; // no column when eval
        } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
          // FireFox uses this awesome columnNumber property for its top frame
          // Also note, Firefox's column number is 0-based and everything else expects 1-based,
          // so adding 1
          // NOTE: this hack doesn't work if top-most frame is eval
          stack[0].column = ex.columnNumber + 1;
        }
        element = {
          url: parts[3],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: parts[2] ? parts[2].split(',') : [],
          line: parts[4] ? +parts[4] : null,
          column: parts[5] ? +parts[5] : null
        };
      } else {
        continue;
      }

      if (!element.func && element.line) {
        element.func = UNKNOWN_FUNCTION;
      }

      stack.push(element);
    }

    if (!stack.length) {
      return null;
    }

    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
  }

  /**
   * Adds information about the first frame to incomplete stack traces.
   * Safari and IE require this to get complete data on the first frame.
   * @param {Object.<string, *>} stackInfo Stack trace information from
   * one of the compute* methods.
   * @param {string} url The URL of the script that caused an error.
   * @param {(number|string)} lineNo The line number of the script that
   * caused an error.
   * @param {string=} message The error generated by the browser, which
   * hopefully contains the name of the object that caused the error.
   * @return {boolean} Whether or not the stack information was
   * augmented.
   */
  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
    var initial = {
      url: url,
      line: lineNo
    };

    if (initial.url && initial.line) {
      stackInfo.incomplete = false;

      if (!initial.func) {
        initial.func = UNKNOWN_FUNCTION;
      }

      if (stackInfo.stack.length > 0) {
        if (stackInfo.stack[0].url === initial.url) {
          if (stackInfo.stack[0].line === initial.line) {
            return false; // already in stack trace
          } else if (
            !stackInfo.stack[0].line &&
            stackInfo.stack[0].func === initial.func
          ) {
            stackInfo.stack[0].line = initial.line;
            return false;
          }
        }
      }

      stackInfo.stack.unshift(initial);
      stackInfo.partial = true;
      return true;
    } else {
      stackInfo.incomplete = true;
    }

    return false;
  }

  /**
   * Computes stack trace information by walking the arguments.caller
   * chain at the time the exception occurred. This will cause earlier
   * frames to be missed but is the only way to get any stack trace in
   * Safari and IE. The top frame is restored by
   * {@link augmentStackTraceWithInitialElement}.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceByWalkingCallerChain(ex, depth) {
    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
      stack = [],
      funcs = {},
      recursion = false,
      parts,
      item,
      source;

    for (
      var curr = computeStackTraceByWalkingCallerChain.caller;
      curr && !recursion;
      curr = curr.caller
    ) {
      if (curr === computeStackTrace || curr === TraceKit.report) {
        // console.log('skipping internal function');
        continue;
      }

      item = {
        url: null,
        func: UNKNOWN_FUNCTION,
        line: null,
        column: null
      };

      if (curr.name) {
        item.func = curr.name;
      } else if ((parts = functionName.exec(curr.toString()))) {
        item.func = parts[1];
      }

      if (typeof item.func === 'undefined') {
        try {
          item.func = parts.input.substring(0, parts.input.indexOf('{'));
        } catch (e) {}
      }

      if (funcs['' + curr]) {
        recursion = true;
      } else {
        funcs['' + curr] = true;
      }

      stack.push(item);
    }

    if (depth) {
      // console.log('depth is ' + depth);
      // console.log('stack is ' + stack.length);
      stack.splice(0, depth);
    }

    var result = {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
    augmentStackTraceWithInitialElement(
      result,
      ex.sourceURL || ex.fileName,
      ex.line || ex.lineNumber,
      ex.message || ex.description
    );
    return result;
  }

  /**
   * Computes a stack trace for an exception.
   * @param {Error} ex
   * @param {(string|number)=} depth
   */
  function computeStackTrace(ex, depth) {
    var stack = null;
    depth = depth == null ? 0 : +depth;

    try {
      stack = computeStackTraceFromStackProp(ex);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }

    try {
      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }
    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref()
    };
  }

  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;

  return computeStackTrace;
})();

module.exports = TraceKit;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 642 */
/***/ (function(module, exports) {

/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/*
* Add integers, wrapping at 2^32. This uses 16-bit operations internally
* to work around bugs in some JS interpreters.
*/
function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xffff);
}

/*
* Bitwise rotate a 32-bit number to the left.
*/
function bitRotateLeft(num, cnt) {
  return (num << cnt) | (num >>> (32 - cnt));
}

/*
* These functions implement the four basic operations the algorithm uses.
*/
function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
  return md5cmn((b & c) | (~b & d), a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
  return md5cmn((b & d) | (c & ~d), a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

/*
* Calculate the MD5 of an array of little-endian words, and a bit length.
*/
function binlMD5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << (len % 32);
  x[(((len + 64) >>> 9) << 4) + 14] = len;

  var i;
  var olda;
  var oldb;
  var oldc;
  var oldd;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (i = 0; i < x.length; i += 16) {
    olda = a;
    oldb = b;
    oldc = c;
    oldd = d;

    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);

    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);

    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);

    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);

    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }
  return [a, b, c, d];
}

/*
* Convert an array of little-endian words to a string
*/
function binl2rstr(input) {
  var i;
  var output = '';
  var length32 = input.length * 32;
  for (i = 0; i < length32; i += 8) {
    output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xff);
  }
  return output;
}

/*
* Convert a raw string to an array of little-endian words
* Characters >255 have their high-byte silently ignored.
*/
function rstr2binl(input) {
  var i;
  var output = [];
  output[(input.length >> 2) - 1] = undefined;
  for (i = 0; i < output.length; i += 1) {
    output[i] = 0;
  }
  var length8 = input.length * 8;
  for (i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << (i % 32);
  }
  return output;
}

/*
* Calculate the MD5 of a raw string
*/
function rstrMD5(s) {
  return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
}

/*
* Calculate the HMAC-MD5, of a key and some data (raw strings)
*/
function rstrHMACMD5(key, data) {
  var i;
  var bkey = rstr2binl(key);
  var ipad = [];
  var opad = [];
  var hash;
  ipad[15] = opad[15] = undefined;
  if (bkey.length > 16) {
    bkey = binlMD5(bkey, key.length * 8);
  }
  for (i = 0; i < 16; i += 1) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5c5c5c5c;
  }
  hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
  return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
}

/*
* Convert a raw string to a hex string
*/
function rstr2hex(input) {
  var hexTab = '0123456789abcdef';
  var output = '';
  var x;
  var i;
  for (i = 0; i < input.length; i += 1) {
    x = input.charCodeAt(i);
    output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f);
  }
  return output;
}

/*
* Encode a string as utf-8
*/
function str2rstrUTF8(input) {
  return unescape(encodeURIComponent(input));
}

/*
* Take string arguments and return either raw or hex encoded strings
*/
function rawMD5(s) {
  return rstrMD5(str2rstrUTF8(s));
}
function hexMD5(s) {
  return rstr2hex(rawMD5(s));
}
function rawHMACMD5(k, d) {
  return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
}
function hexHMACMD5(k, d) {
  return rstr2hex(rawHMACMD5(k, d));
}

function md5(string, key, raw) {
  if (!key) {
    if (!raw) {
      return hexMD5(string);
    }
    return rawMD5(string);
  }
  if (!raw) {
    return hexHMACMD5(key, string);
  }
  return rawHMACMD5(key, string);
}

module.exports = md5;


/***/ }),
/* 643 */
/***/ (function(module, exports) {

function RavenConfigError(message) {
  this.name = 'RavenConfigError';
  this.message = message;
}
RavenConfigError.prototype = new Error();
RavenConfigError.prototype.constructor = RavenConfigError;

module.exports = RavenConfigError;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var utils = __webpack_require__(112);

var wrapMethod = function(console, level, callback) {
  var originalConsoleLevel = console[level];
  var originalConsole = console;

  if (!(level in console)) {
    return;
  }

  var sentryLevel = level === 'warn' ? 'warning' : level;

  console[level] = function() {
    var args = [].slice.call(arguments);

    var msg = utils.safeJoin(args, ' ');
    var data = {level: sentryLevel, logger: 'console', extra: {arguments: args}};

    if (level === 'assert') {
      if (args[0] === false) {
        // Default browsers message
        msg =
          'Assertion failed: ' + (utils.safeJoin(args.slice(1), ' ') || 'console.assert');
        data.extra.arguments = args.slice(1);
        callback && callback(msg, data);
      }
    } else {
      callback && callback(msg, data);
    }

    // this fails for some browsers. :(
    if (originalConsoleLevel) {
      // IE9 doesn't allow calling apply on console functions directly
      // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
      Function.prototype.apply.call(originalConsoleLevel, originalConsole, args);
    }
  };
};

module.exports = {
  wrapMethod: wrapMethod
};


/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(!isLocalhost){// Is not local host. Just register service worker
registerValidSW(swUrl);}else{// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loadPolyfills;
function loadPolyfills(){//.closest() polyfill for IE9+:
if(!Element.prototype.matches)Element.prototype.matches=Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector;if(!Element.prototype.closest)Element.prototype.closest=function(s){var el=this;if(!document.documentElement.contains(el))return null;do{if(el.matches(s))return el;el=el.parentElement||el.parentNode;}while(el!==null&&el.nodeType===1);return null;};//.fill() polyfill for IE:
if(!Array.prototype.fill){Object.defineProperty(Array.prototype,'fill',{value:function value(_value){// Steps 1-2.
if(this==null){throw new TypeError('this is null or not defined');}var O=Object(this);// Steps 3-5.
var len=O.length>>>0;// Steps 6-7.
var start=arguments[1];var relativeStart=start>>0;// Step 8.
var k=relativeStart<0?Math.max(len+relativeStart,0):Math.min(relativeStart,len);// Steps 9-10.
var end=arguments[2];var relativeEnd=end===undefined?len:end>>0;// Step 11.
var final=relativeEnd<0?Math.max(len+relativeEnd,0):Math.min(relativeEnd,len);// Step 12.
while(k<final){O[k]=_value;k++;}// Step 13.
return O;}});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.f9566c52.js